var map = {
  "./sv-x-k12/calendar.header.json": [
    "329428",
    [
      920599
    ]
  ],
  "./fi/users.json": [
    "940611",
    [
      696097
    ]
  ],
  "./ja/content_migrations.json": [
    "664454",
    [
      706567
    ]
  ],
  "./nb/external_content_cancel.json": [
    "432018",
    [
      731262
    ]
  ],
  "./pl/AssignmentGroupListItemView.json": [
    "544268",
    [
      264320
    ]
  ],
  "./zh-Hant/group_submission_reminder.json": [
    "828739",
    [
      124301
    ]
  ],
  "./fr/gradebookOutcomeGradebookView.json": [
    "554495",
    [
      111262
    ]
  ],
  "./el/course_paces_footer.json": [
    "941371",
    [
      738685
    ]
  ],
  "./ga/assignment_grade_summary.json": [
    "878884",
    [
      950967
    ]
  ],
  "./ja/gradebook_history.json": [
    "709554",
    [
      551259
    ]
  ],
  "./en-GB-x-lbs/course_paces_pace_picker.json": [
    "831891",
    [
      811873
    ]
  ],
  "./sl/gradebook.json": [
    "411879",
    [
      969353
    ]
  ],
  "./zh-Hans/available_pronouns_list.json": [
    "867312",
    [
      148952
    ]
  ],
  "./nn/course_paces_settings.json": [
    "93464",
    [
      637356
    ]
  ],
  "./cy/account_calendar_settings_account_group.json": [
    "617000",
    [
      286552
    ]
  ],
  "./ar/peer_review_configuration_tray.json": [
    "235270",
    [
      68898
    ]
  ],
  "./ar/last_attended.json": [
    "808869",
    [
      396319
    ]
  ],
  "./nn/accessibility_checker.json": [
    "680818",
    [
      70294
    ]
  ],
  "./th/calculator_command.json": [
    "370420",
    [
      41840
    ]
  ],
  "./mi/courses.show.json": [
    "895109",
    [
      523560
    ]
  ],
  "./ms/course_statistics.json": [
    "983475",
    [
      536681
    ]
  ],
  "./ca/calendar_sidebar.json": [
    "180603",
    [
      181489
    ]
  ],
  "./fr-CA/assignments.no_assignments_search.json": [
    "179152",
    [
      785205
    ]
  ],
  "./ht/blueprint_settingsCourseFilter.json": [
    "145512",
    [
      158900
    ]
  ],
  "./tr/account_calendar_settings_account_group.json": [
    "171818",
    [
      360022
    ]
  ],
  "./th/course_paces_no_results.json": [
    "909691",
    [
      550477
    ]
  ],
  "./hu/MobileNavigation.json": [
    "447083",
    [
      538961
    ]
  ],
  "./he/course_paces_header.json": [
    "248175",
    [
      541005
    ]
  ],
  "./hi/quizzes_regrade_modal.json": [
    "281729",
    [
      389975
    ]
  ],
  "./th/LearningMasteryGradebook.json": [
    "761345",
    [
      287747
    ]
  ],
  "./es/CoursesTray.json": [
    "687844",
    [
      621777
    ]
  ],
  "./vi/blueprint_settingsMigrationSync.json": [
    "185655",
    [
      976381
    ]
  ],
  "./pt/peer-review-assignment-widget.json": [
    "657564",
    [
      229800
    ]
  ],
  "./hu/account_calendar_settings_confirmation_modal.json": [
    "863039",
    [
      421917
    ]
  ],
  "./ar/blueprint_coursesExpandableLockOptions.json": [
    "210010",
    [
      921806
    ]
  ],
  "./es/upload_button.json": [
    "803884",
    [
      914745
    ]
  ],
  "./sl/job_stats.json": [
    "508906",
    [
      550942
    ]
  ],
  "./pl/folder_tree.json": [
    "99699",
    [
      21269
    ]
  ],
  "./it/course_paces_blueprint_lock.json": [
    "194535",
    [
      873313
    ]
  ],
  "./cy/assignments_2_attempt_tab.json": [
    "241479",
    [
      86165
    ]
  ],
  "./ga/default_account_quotas.json": [
    "460121",
    [
      126559
    ]
  ],
  "./tr/blueprint_settingsCoursePicker.json": [
    "352030",
    [
      352514
    ]
  ],
  "./da-x-k12/empty_course.json": [
    "31654",
    [
      289298
    ]
  ],
  "./fr/AlignmentSummary.json": [
    "92141",
    [
      749008
    ]
  ],
  "./ja/self_unenrollment_modal.json": [
    "12349",
    [
      190868
    ]
  ],
  "./sv-x-k12/permissions.json": [
    "983517",
    [
      851931
    ]
  ],
  "./uk/outcome_management.json": [
    "650832",
    [
      606688
    ]
  ],
  "./es-ES/react_files.json": [
    "365340",
    [
      727724
    ]
  ],
  "./sv-x-k12/assignments_2_media_attempt.json": [
    "947099",
    [
      354457
    ]
  ],
  "./zh-Hant/widget_dashboard.json": [
    "736688",
    [
      278061
    ]
  ],
  "./da/blueprint_settingsSyncHistory.json": [
    "209343",
    [
      68013
    ]
  ],
  "./da-x-k12/edit_section_start_date.json": [
    "377683",
    [
      133917
    ]
  ],
  "./fr-CA/courses_show.json": [
    "794163",
    [
      36981
    ]
  ],
  "./th/knowledge_check_not_ready.json": [
    "650603",
    [
      48573
    ]
  ],
  "./id/course_paces_blackout_dates_table.json": [
    "758900",
    [
      50648
    ]
  ],
  "./it/entity_search_form.json": [
    "84794",
    [
      522374
    ]
  ],
  "./pt-BR/last_attended.json": [
    "373927",
    [
      141058
    ]
  ],
  "./el/account_settings_jsx_bundle.json": [
    "682363",
    [
      133549
    ]
  ],
  "./nl/unpublished_warning_modal.json": [
    "977522",
    [
      960342
    ]
  ],
  "./en-AU/suppress_notifications.json": [
    "812252",
    [
      739577
    ]
  ],
  "./en/assignments_bulk_edit.json": [
    "654753",
    [
      295027
    ]
  ],
  "./fr-CA/user_lists.json": [
    "916072",
    [
      139836
    ]
  ],
  "./es-ES/assignments_2_student_header_date_title.json": [
    "984252",
    [
      289484
    ]
  ],
  "./sv-x-k12/accessibility_checker.json": [
    "679481",
    [
      535167
    ]
  ],
  "./mi/grade_summary.json": [
    "790876",
    [
      86884
    ]
  ],
  "./fr-CA/assignments.json": [
    "15353",
    [
      905579
    ]
  ],
  "./pt-BR/outcome_detail.json": [
    "513233",
    [
      998856
    ]
  ],
  "./pl/ImportConfirmBox.json": [
    "154450",
    [
      37494
    ]
  ],
  "./zh-Hans/GroupDetailView.json": [
    "266286",
    [
      145558
    ]
  ],
  "./id/terms_of_service_modal.json": [
    "705914",
    [
      729390
    ]
  ],
  "./zh-Hans/webzip_export.json": [
    "374653",
    [
      483899
    ]
  ],
  "./da/quiz_statistics.json": [
    "29104",
    [
      694624
    ]
  ],
  "./sv-x-k12/assignments.no_assignments_search.json": [
    "699790",
    [
      288251
    ]
  ],
  "./el/notebook.json": [
    "829836",
    [
      614704
    ]
  ],
  "./ja/OutcomeDescriptionModal.json": [
    "823100",
    [
      868793
    ]
  ],
  "./nn/student_groups.json": [
    "659602",
    [
      355198
    ]
  ],
  "./da/blueprint_settingsMigrationOptions.json": [
    "670888",
    [
      24392
    ]
  ],
  "./ko/comm_messages.json": [
    "697761",
    [
      604175
    ]
  ],
  "./it/user_profile.json": [
    "972936",
    [
      198548
    ]
  ],
  "./fa/self_unenrollment_modal.json": [
    "438825",
    [
      404751
    ]
  ],
  "./ht/course_paces_actions.json": [
    "9512",
    [
      312828
    ]
  ],
  "./ru/conferences_alternatives.json": [
    "963837",
    [
      455883
    ]
  ],
  "./sv-x-k12/folder_tree.json": [
    "270140",
    [
      677132
    ]
  ],
  "./en-AU/permissions.json": [
    "606680",
    [
      644637
    ]
  ],
  "./cy/file_not_found.json": [
    "291265",
    [
      232991
    ]
  ],
  "./de/permissions_v2_add_tray.json": [
    "48099",
    [
      121846
    ]
  ],
  "./ms/account_calendar_settings_confirmation_modal.json": [
    "540510",
    [
      474222
    ]
  ],
  "./ru/SpeedGraderSettingsMenu.json": [
    "553814",
    [
      469967
    ]
  ],
  "./uk/appointment_groups.json": [
    "142952",
    [
      922344
    ]
  ],
  "./pt-BR/content_share_preview_overlay.json": [
    "571218",
    [
      271603
    ]
  ],
  "./it/account_calendar_settings_account_calendar_item.json": [
    "622490",
    [
      492614
    ]
  ],
  "./sl/react_developer_keys.json": [
    "78420",
    [
      39264
    ]
  ],
  "./ms/custom_emoji_deny_list.json": [
    "346519",
    [
      317084
    ]
  ],
  "./is/theme_collection_view.json": [
    "322452",
    [
      199396
    ]
  ],
  "./da/enhanced_individual_gradebook_submit_score.json": [
    "146544",
    [
      123232
    ]
  ],
  "./ca/account_calendar_settings_confirmation_modal.json": [
    "508894",
    [
      375038
    ]
  ],
  "./de/OutcomeMoveModal.json": [
    "731425",
    [
      625592
    ]
  ],
  "./id/user_profile.json": [
    "224664",
    [
      561444
    ]
  ],
  "./ca/react_collaborations.json": [
    "153440",
    [
      789424
    ]
  ],
  "./hi/assignments_2_student_header_date_title.json": [
    "255226",
    [
      147242
    ]
  ],
  "./hu/discussion_settings.json": [
    "888193",
    [
      201087
    ]
  ],
  "./es/assignments_2_student_header.json": [
    "403539",
    [
      310718
    ]
  ],
  "./fr/assignments_2_initial_query.json": [
    "446005",
    [
      585728
    ]
  ],
  "./sl/permissions_v2_add_tray.json": [
    "729843",
    [
      635949
    ]
  ],
  "./is/widget_dashboard.json": [
    "439973",
    [
      314723
    ]
  ],
  "./da-x-k12/terms_of_service_modal.json": [
    "529966",
    [
      196682
    ]
  ],
  "./es-ES/course_search_results.json": [
    "648872",
    [
      561792
    ]
  ],
  "./vi/quizzes_openModerateStudentDialog.json": [
    "806861",
    [
      668523
    ]
  ],
  "./fr/a2LatePolicyStatusDisplay.json": [
    "443042",
    [
      235024
    ]
  ],
  "./tr/ignite_agent.json": [
    "326144",
    [
      428484
    ]
  ],
  "./el/announcements_v2.json": [
    "915080",
    [
      482564
    ]
  ],
  "./ca/authentication_providers.json": [
    "585867",
    [
      677505
    ]
  ],
  "./da/assignments_2_submission_helpers.json": [
    "448609",
    [
      703503
    ]
  ],
  "./de/gradebook_history.json": [
    "257648",
    [
      726493
    ]
  ],
  "./de/new_nav.json": [
    "561801",
    [
      700320
    ]
  ],
  "./ar/use_switch_experience.json": [
    "299576",
    [
      71796
    ]
  ],
  "./fr/rubrics-export.json": [
    "465457",
    [
      696692
    ]
  ],
  "./hi/account_calendar_settings_utils.json": [
    "92429",
    [
      314091
    ]
  ],
  "./nn/unpublished_warning_modal.json": [
    "869372",
    [
      250688
    ]
  ],
  "./ca/gradingGradeSummary.json": [
    "649191",
    [
      955301
    ]
  ],
  "./es/submit_assignment.json": [
    "233130",
    [
      827523
    ]
  ],
  "./en-GB-x-ukhe/keyboardShortcutModal.json": [
    "929244",
    [
      153100
    ]
  ],
  "./th/assignments_2_student_content_rubric_self_assessment.json": [
    "494295",
    [
      975241
    ]
  ],
  "./en-GB-x-lbs/blueprint_settingsSyncChange.json": [
    "515638",
    [
      464622
    ]
  ],
  "./hu/CreateEditAssignmentModal.json": [
    "376687",
    [
      326861
    ]
  ],
  "./ms/EditMasteryScaleLink.json": [
    "566819",
    [
      621753
    ]
  ],
  "./th/account_calendar_settings_account_tree.json": [
    "487821",
    [
      543103
    ]
  ],
  "./nn/course_paces_modal.json": [
    "650218",
    [
      202934
    ]
  ],
  "./th/nav_tourpoints.json": [
    "807093",
    [
      905439
    ]
  ],
  "./sl/blueprint_coursesExpandableLockOptions.json": [
    "757234",
    [
      218062
    ]
  ],
  "./pt-BR/assignments_2_student_points_display.json": [
    "972779",
    [
      991950
    ]
  ],
  "./pl/permissions_role_tray.json": [
    "499012",
    [
      319680
    ]
  ],
  "./mi/widget_dashboard.json": [
    "591635",
    [
      916137
    ]
  ],
  "./da/discussion_posts.json": [
    "660579",
    [
      753993
    ]
  ],
  "./ko/gradingPeriodTemplate.json": [
    "183791",
    [
      619037
    ]
  ],
  "./fi/account_settings.json": [
    "376644",
    [
      330052
    ]
  ],
  "./mi/assignments.never_drop.json": [
    "738334",
    [
      739949
    ]
  ],
  "./hi/CreateEditAssignmentModalAdapter.json": [
    "956262",
    [
      822382
    ]
  ],
  "./fa/epub_exports.json": [
    "572255",
    [
      613
    ]
  ],
  "./zh-Hans/authentication_providers.json": [
    "315994",
    [
      60634
    ]
  ],
  "./es/assignmentsToggleShowByView.json": [
    "586461",
    [
      187780
    ]
  ],
  "./pt/outcome_reporting.json": [
    "780315",
    [
      935829
    ]
  ],
  "./ms/course_paces_modal.json": [
    "623518",
    [
      995758
    ]
  ],
  "./zh-Hant/SpeedGraderPostGradesMenu.json": [
    "932353",
    [
      271640
    ]
  ],
  "./nn/plugins.json": [
    "315682",
    [
      681654
    ]
  ],
  "./sv/group_submission_reminder.json": [
    "357319",
    [
      986128
    ]
  ],
  "./fi/widget_dashboard.json": [
    "353338",
    [
      289242
    ]
  ],
  "./nn/course_paces_actions.json": [
    "485108",
    [
      327000
    ]
  ],
  "./hy/files_v2.json": [
    "119655",
    [
      146957
    ]
  ],
  "./sv-x-k12/submissions_show_preview.json": [
    "179891",
    [
      299793
    ]
  ],
  "./zh-Hans/assignment_grade_summary.json": [
    "289233",
    [
      177319
    ]
  ],
  "./hy/quiz_show.json": [
    "35790",
    [
      36294
    ]
  ],
  "./is/registration.json": [
    "205367",
    [
      174237
    ]
  ],
  "./mi/assignment_show.json": [
    "802043",
    [
      184897
    ]
  ],
  "./de/use_switch_experience.json": [
    "851824",
    [
      265517
    ]
  ],
  "./he/OutcomeMoveModal.json": [
    "329333",
    [
      891771
    ]
  ],
  "./hi/edit_section_end_date.json": [
    "23586",
    [
      635218
    ]
  ],
  "./ms/media_player_iframe_content.json": [
    "829729",
    [
      78015
    ]
  ],
  "./pl/admin_split.json": [
    "415577",
    [
      52298
    ]
  ],
  "./nb-x-k12/course_search_results.json": [
    "834991",
    [
      800677
    ]
  ],
  "./ht/CourseAvailabilityOptions.json": [
    "906586",
    [
      797566
    ]
  ],
  "./fr/progressbar_view.json": [
    "962598",
    [
      786491
    ]
  ],
  "./ru/CreateEditAssignmentModal.json": [
    "433569",
    [
      709655
    ]
  ],
  "./ru/content_shares.json": [
    "503751",
    [
      397773
    ]
  ],
  "./da/assignments_2_student_annotation.json": [
    "505142",
    [
      766534
    ]
  ],
  "./ga/course_paces_footer.json": [
    "487782",
    [
      944062
    ]
  ],
  "./hy/notebook.json": [
    "90182",
    [
      872702
    ]
  ],
  "./fi/assignments_2_submission_histories_query.json": [
    "110849",
    [
      224727
    ]
  ],
  "./hy/gradebookActionMenu.json": [
    "482254",
    [
      109078
    ]
  ],
  "./sv-x-k12/react_collaborations.json": [
    "335405",
    [
      746923
    ]
  ],
  "./ga/AssignmentListItemView.json": [
    "966297",
    [
      734831
    ]
  ],
  "./is/account_settings_jsx_bundle.json": [
    "190954",
    [
      93482
    ]
  ],
  "./sv/announcements_v2.json": [
    "319064",
    [
      7380
    ]
  ],
  "./pl/courses_show.json": [
    "413608",
    [
      269796
    ]
  ],
  "./tr/calculator.json": [
    "952700",
    [
      943688
    ]
  ],
  "./cy/outcome_reporting.json": [
    "247299",
    [
      94297
    ]
  ],
  "./el/CoursesTray.json": [
    "131649",
    [
      831267
    ]
  ],
  "./es/k5_dashboard.json": [
    "603205",
    [
      775807
    ]
  ],
  "./it/eportfolio.json": [
    "165088",
    [
      814380
    ]
  ],
  "./ja/jobs_v2.json": [
    "478990",
    [
      913455
    ]
  ],
  "./uk/edit_section_view.json": [
    "506346",
    [
      334562
    ]
  ],
  "./da/peer_review_allocation_rules_tray.json": [
    "79960",
    [
      187000
    ]
  ],
  "./fa/blueprint_settingsCoursePicker.json": [
    "724111",
    [
      255381
    ]
  ],
  "./zh-Hant/blueprint_settingsCoursePicker.json": [
    "824382",
    [
      228658
    ]
  ],
  "./fr-CA/peer-review-assignment-widget.json": [
    "177057",
    [
      381219
    ]
  ],
  "./nb-x-k12/discussion_posts.json": [
    "218368",
    [
      985336
    ]
  ],
  "./hy/react_files.json": [
    "992282",
    [
      906762
    ]
  ],
  "./nl/react_collaborations.json": [
    "542278",
    [
      807498
    ]
  ],
  "./sv-x-k12/lti_registrations.json": [
    "104307",
    [
      716401
    ]
  ],
  "./pt-BR/gradebook.json": [
    "821253",
    [
      663508
    ]
  ],
  "./zh-Hant/job_stats.json": [
    "733555",
    [
      976797
    ]
  ],
  "./fr-CA/CreateEditAssignmentModal.json": [
    "376157",
    [
      292247
    ]
  ],
  "./ht/peer_review_allocation_rules_tray.json": [
    "165355",
    [
      254581
    ]
  ],
  "./ru/Navigation.json": [
    "50907",
    [
      675129
    ]
  ],
  "./nn/unpublished_changes_button_props.json": [
    "363425",
    [
      236051
    ]
  ],
  "./zh-Hant/learning_mastery_gradebook.json": [
    "838349",
    [
      823239
    ]
  ],
  "./sl/course_paces_assignment_row.json": [
    "425740",
    [
      437800
    ]
  ],
  "./ar/dashboard.json": [
    "933397",
    [
      772135
    ]
  ],
  "./ko/assignments_bulk_edit.json": [
    "649536",
    [
      178480
    ]
  ],
  "./en-GB-x-lbs/media_player_iframe_content.json": [
    "263983",
    [
      129813
    ]
  ],
  "./es/canvascareer.json": [
    "174932",
    [
      246529
    ]
  ],
  "./fa/assignments_2_login_action_prompt.json": [
    "707828",
    [
      804996
    ]
  ],
  "./ht/peer_review_allocation_rule_card.json": [
    "645388",
    [
      470944
    ]
  ],
  "./nl/course_paces_no_results.json": [
    "166817",
    [
      314115
    ]
  ],
  "./nn/comm_messages.json": [
    "521003",
    [
      528189
    ]
  ],
  "./ca/blueprint_settingsMigrationSync.json": [
    "513886",
    [
      383230
    ]
  ],
  "./ga/ai_experiences_ai_conversations.json": [
    "556794",
    [
      419098
    ]
  ],
  "./es/dashboard_grading_period_select.json": [
    "320976",
    [
      335781
    ]
  ],
  "./pt/outcome_detail.json": [
    "290174",
    [
      750434
    ]
  ],
  "./vi/outcomes_user_outcome_results.json": [
    "735452",
    [
      94668
    ]
  ],
  "./tr/new_nav.json": [
    "328128",
    [
      444996
    ]
  ],
  "./nb/grades_empty_page.json": [
    "942622",
    [
      117570
    ]
  ],
  "./th/plugins.json": [
    "193774",
    [
      770562
    ]
  ],
  "./uk/account_calendars_modal.json": [
    "59043",
    [
      276457
    ]
  ],
  "./fr/ldap_cert_upload.json": [
    "666754",
    [
      887239
    ]
  ],
  "./de/CreateEditAssignmentModalAdapter.json": [
    "850670",
    [
      650215
    ]
  ],
  "./vi/user_restore.json": [
    "198439",
    [
      757325
    ]
  ],
  "./ga/peer_review_allocation_rules_tray.json": [
    "255127",
    [
      216573
    ]
  ],
  "./fr/paginated_list.json": [
    "804918",
    [
      479699
    ]
  ],
  "./hi/calendar_sidebar.json": [
    "882926",
    [
      72966
    ]
  ],
  "./nn/copy_course.json": [
    "248277",
    [
      398543
    ]
  ],
  "./el/courses_show.json": [
    "367731",
    [
      34229
    ]
  ],
  "./es-ES/OutcomeDescriptionModal.json": [
    "353096",
    [
      436080
    ]
  ],
  "./fa/module_sequence_footer.json": [
    "710987",
    [
      573833
    ]
  ],
  "./ms/account_calendar_settings_filter_controls.json": [
    "692638",
    [
      317998
    ]
  ],
  "./fr/course_paces_blackout_date_row.json": [
    "168430",
    [
      212179
    ]
  ],
  "./th/rubrics-export.json": [
    "14033",
    [
      381619
    ]
  ],
  "./fa/AlignmentSummary.json": [
    "881534",
    [
      280710
    ]
  ],
  "./hy/AssignmentListItemView.json": [
    "434724",
    [
      720724
    ]
  ],
  "./hi/assignments_2_media_attempt.json": [
    "974843",
    [
      120089
    ]
  ],
  "./it/editGroup.json": [
    "995368",
    [
      502468
    ]
  ],
  "./it/peer_review_student_select.json": [
    "612475",
    [
      776941
    ]
  ],
  "./ms/content_shares.json": [
    "352604",
    [
      946276
    ]
  ],
  "./nb/widget_dashboard.json": [
    "988529",
    [
      997939
    ]
  ],
  "./nl/context_roster_user_services.json": [
    "665732",
    [
      22672
    ]
  ],
  "./en-GB/course_paces_empty_state.json": [
    "543111",
    [
      371342
    ]
  ],
  "./id/grade_summary.json": [
    "908975",
    [
      469697
    ]
  ],
  "./ar/course_paces_change_tracking.json": [
    "1058",
    [
      955934
    ]
  ],
  "./id/folder_tree.json": [
    "891318",
    [
      490906
    ]
  ],
  "./el/permission_button.json": [
    "631723",
    [
      644597
    ]
  ],
  "./hu/course_paces_flaggable_number_input.json": [
    "465256",
    [
      980472
    ]
  ],
  "./zh-Hant/grades_summary.json": [
    "185963",
    [
      306805
    ]
  ],
  "./ca/ldap_cert_upload.json": [
    "233266",
    [
      740250
    ]
  ],
  "./he/CommentLibrary.json": [
    "137287",
    [
      620405
    ]
  ],
  "./de/progressbar_view.json": [
    "15983",
    [
      536378
    ]
  ],
  "./ja/terms_of_use.json": [
    "664972",
    [
      278409
    ]
  ],
  "./ru/lti_registration.wizard.json": [
    "667973",
    [
      676767
    ]
  ],
  "./es-ES/outcome_alignment_v2.json": [
    "683718",
    [
      21486
    ]
  ],
  "./fi/jobs_v2.json": [
    "662154",
    [
      604330
    ]
  ],
  "./ko/CreateEditAssignmentModalAdapter.json": [
    "213237",
    [
      470347
    ]
  ],
  "./ar/course_paces_projected_dates.json": [
    "972544",
    [
      735876
    ]
  ],
  "./ko/bounced_emails.json": [
    "380488",
    [
      814248
    ]
  ],
  "./ms/blueprint_settingsCoursePickerTable.json": [
    "648440",
    [
      360968
    ]
  ],
  "./el/question_banks.json": [
    "817041",
    [
      520099
    ]
  ],
  "./he/assignments_2_attempt_tab.json": [
    "315304",
    [
      538712
    ]
  ],
  "./vi/k5_dashboard.json": [
    "93154",
    [
      333938
    ]
  ],
  "./hi/enhanced_individual_gradebook_submit_score.json": [
    "527564",
    [
      987708
    ]
  ],
  "./zh-Hans/roster_section_selector.json": [
    "370676",
    [
      274724
    ]
  ],
  "./el/assignmentsIndexView.json": [
    "462154",
    [
      690702
    ]
  ],
  "./it/discussion_topics_edit.json": [
    "473971",
    [
      65061
    ]
  ],
  "./da/grade_summaryGroupView.json": [
    "331433",
    [
      992903
    ]
  ],
  "./hi/sis_import.json": [
    "590296",
    [
      437216
    ]
  ],
  "./vi/SpeedGraderDiscussionsNavigation.json": [
    "901070",
    [
      293734
    ]
  ],
  "./es-ES/blueprint_settingsCourseFilter.json": [
    "969399",
    [
      639293
    ]
  ],
  "./hi/quizzes.take_quiz.json": [
    "478507",
    [
      402268
    ]
  ],
  "./sl/blueprint_course_sidebar.json": [
    "85237",
    [
      154671
    ]
  ],
  "./vi/sections_tooltip.json": [
    "651169",
    [
      914871
    ]
  ],
  "./fr/ai_experiences_edit.json": [
    "244015",
    [
      774742
    ]
  ],
  "./en-GB/course_paces_projected_dates.json": [
    "114358",
    [
      507707
    ]
  ],
  "./ht/assignments_bulk_edit.json": [
    "111098",
    [
      196158
    ]
  ],
  "./de/assignments_2_MoreOptions_CanvasFiles.json": [
    "855132",
    [
      37953
    ]
  ],
  "./sl/authentication_providers.json": [
    "335370",
    [
      820929
    ]
  ],
  "./en/blueprint_settingsUnsyncedChanges.json": [
    "739696",
    [
      678068
    ]
  ],
  "./is/discussion_create.json": [
    "190283",
    [
      590569
    ]
  ],
  "./cy/todos_page.json": [
    "180095",
    [
      841885
    ]
  ],
  "./sv/courses_show.json": [
    "668003",
    [
      348517
    ]
  ],
  "./sl/ImportConfirmBox.json": [
    "222475",
    [
      615461
    ]
  ],
  "./en-AU/filter_calendars_modal.json": [
    "675668",
    [
      557873
    ]
  ],
  "./zh-Hant/top_navigation_tools.json": [
    "528090",
    [
      180222
    ]
  ],
  "./uk/outcome_detail.json": [
    "514542",
    [
      502094
    ]
  ],
  "./en-GB-x-ukhe/content_migrations_redesign.json": [
    "938235",
    [
      484745
    ]
  ],
  "./ga/enhanced_individual_gradebook_submit_score.json": [
    "545873",
    [
      444455
    ]
  ],
  "./hy/blueprint_settingsCoursePicker.json": [
    "664785",
    [
      551847
    ]
  ],
  "./ja/epub_exports.json": [
    "162379",
    [
      551686
    ]
  ],
  "./en-AU-x-unimelb/GroupDetailView.json": [
    "15097",
    [
      402323
    ]
  ],
  "./hu/a2_AccessibleTipContent.json": [
    "795565",
    [
      490563
    ]
  ],
  "./zh-Hans/user_search_results.json": [
    "754836",
    [
      388420
    ]
  ],
  "./ca/conversations_2.json": [
    "934267",
    [
      298033
    ]
  ],
  "./id/OutcomeDescriptionModal.json": [
    "874216",
    [
      62236
    ]
  ],
  "./da-x-k12/copy_course.json": [
    "728360",
    [
      755996
    ]
  ],
  "./fi/files_v2.json": [
    "84781",
    [
      52363
    ]
  ],
  "./zh-Hant/permissions_v2_add_tray.json": [
    "353842",
    [
      790646
    ]
  ],
  "./fr/filter_calendars_modal.json": [
    "560730",
    [
      386639
    ]
  ],
  "./nb-x-k12/horizon_toggle.json": [
    "844356",
    [
      976548
    ]
  ],
  "./es-ES/quizzes_public.json": [
    "617326",
    [
      592550
    ]
  ],
  "./en-GB/account_calendars_modal.json": [
    "349422",
    [
      559027
    ]
  ],
  "./sl/account_calendar_settings_footer.json": [
    "259167",
    [
      103718
    ]
  ],
  "./ca/calendar_custom_recurring_event_natural_language.json": [
    "379254",
    [
      574374
    ]
  ],
  "./hi/account_settings.json": [
    "698430",
    [
      130438
    ]
  ],
  "./zh-Hans/student_entries.json": [
    "569373",
    [
      238219
    ]
  ],
  "./de/add_edit_pseudonym.json": [
    "360002",
    [
      735571
    ]
  ],
  "./ht/calendar_sidebar.json": [
    "466547",
    [
      703149
    ]
  ],
  "./nb-x-k12/user.json": [
    "422887",
    [
      392557
    ]
  ],
  "./da/LearningMasteryGradebook.json": [
    "278376",
    [
      803656
    ]
  ],
  "./ru/assignments.json": [
    "631549",
    [
      119019
    ]
  ],
  "./hy/canvascareer.json": [
    "965489",
    [
      68231
    ]
  ],
  "./cy/course_paces_change_tracking.json": [
    "833911",
    [
      267013
    ]
  ],
  "./nn/course_paces_app.json": [
    "84772",
    [
      519248
    ]
  ],
  "./hy/outcome_management.json": [
    "927825",
    [
      654967
    ]
  ],
  "./da/terms_index.json": [
    "785309",
    [
      53187
    ]
  ],
  "./it/blueprint_course_sidebar.json": [
    "387743",
    [
      143809
    ]
  ],
  "./en-AU/ai_experiences.json": [
    "189364",
    [
      941118
    ]
  ],
  "./is/canvascareer.json": [
    "493552",
    [
      551832
    ]
  ],
  "./pt-BR/grade_details.json": [
    "383485",
    [
      714188
    ]
  ],
  "./pt-BR/assignments_2_media_attempt.json": [
    "883881",
    [
      515248
    ]
  ],
  "./hi/peer-review-assignment-widget.json": [
    "648747",
    [
      812217
    ]
  ],
  "./it/context_modules_v2.json": [
    "990463",
    [
      311265
    ]
  ],
  "./sv-x-k12/MobileGlobalMenu.json": [
    "105137",
    [
      37543
    ]
  ],
  "./fa/outcome_reporting.json": [
    "36534",
    [
      52238
    ]
  ],
  "./en-AU-x-unimelb/authentication_providers.json": [
    "961963",
    [
      376941
    ]
  ],
  "./mi/permissions_role_tray_table_row.json": [
    "602454",
    [
      574870
    ]
  ],
  "./cy/moderate_quiz.json": [
    "898825",
    [
      481015
    ]
  ],
  "./tr/permissions.json": [
    "468048",
    [
      587684
    ]
  ],
  "./da-x-k12/account_calendar_settings.json": [
    "873633",
    [
      11811
    ]
  ],
  "./zh-Hant/calendar_custom_recurring_event_natural_language.json": [
    "564252",
    [
      148672
    ]
  ],
  "./nn/copy_warnings_modal.json": [
    "248579",
    [
      223293
    ]
  ],
  "./it/MoveOutcomesModal.json": [
    "614734",
    [
      871370
    ]
  ],
  "./fr/pseudonyms_mobile_login.json": [
    "580614",
    [
      365131
    ]
  ],
  "./mi/account_calendar_settings_account_tree.json": [
    "297059",
    [
      337081
    ]
  ],
  "./ht/custom_emoji_deny_list.json": [
    "563180",
    [
      279320
    ]
  ],
  "./zh-Hans/CreateEditAssignmentModal.json": [
    "548067",
    [
      761041
    ]
  ],
  "./en/course_paces_header.json": [
    "152611",
    [
      834269
    ]
  ],
  "./nn/todos_page.json": [
    "13579",
    [
      143997
    ]
  ],
  "./fr-CA/collaborations.json": [
    "9555",
    [
      991981
    ]
  ],
  "./is/discussion_insights.json": [
    "770274",
    [
      919314
    ]
  ],
  "./sv-x-k12/calendar_custom_recurring_event_repeat_picker.json": [
    "759547",
    [
      437177
    ]
  ],
  "./it/react_collaborations.json": [
    "971075",
    [
      716509
    ]
  ],
  "./nl/context_prior_users.json": [
    "877779",
    [
      23909
    ]
  ],
  "./nb/calendar_custom_recurring_event_natural_language.json": [
    "955214",
    [
      22586
    ]
  ],
  "./fa/assignments_2_student_annotation.json": [
    "300072",
    [
      472144
    ]
  ],
  "./is/link_to_students.json": [
    "989203",
    [
      242209
    ]
  ],
  "./nl/notebook_index.json": [
    "254426",
    [
      788998
    ]
  ],
  "./sv-x-k12/blueprint_settingsMigrationOptions.json": [
    "320172",
    [
      705260
    ]
  ],
  "./cy/course_paces_search.json": [
    "525545",
    [
      174327
    ]
  ],
  "./uk/OutcomeDescriptionModal.json": [
    "640093",
    [
      629731
    ]
  ],
  "./ar/assignments_2_student_header.json": [
    "724186",
    [
      80062
    ]
  ],
  "./da-x-k12/assignment_show.json": [
    "426384",
    [
      366580
    ]
  ],
  "./is/MobileGlobalMenu.json": [
    "110864",
    [
      267128
    ]
  ],
  "./uk/ProfileTray.json": [
    "111915",
    [
      19041
    ]
  ],
  "./hu/quiz_migration_notifications.json": [
    "407222",
    [
      810710
    ]
  ],
  "./nn/assignments_2_MoreOptions.json": [
    "780171",
    [
      3989
    ]
  ],
  "./sv-x-k12/SpeedGraderCheckpoints.json": [
    "403276",
    [
      830988
    ]
  ],
  "./vi/account_calendar_settings_account_list.json": [
    "281110",
    [
      603438
    ]
  ],
  "./da-x-k12/permissions.json": [
    "833255",
    [
      814033
    ]
  ],
  "./zh-Hant/assignment_index_deep_linking_handlers.json": [
    "471590",
    [
      309074
    ]
  ],
  "./da-x-k12/blueprint_settingsCoursePicker.json": [
    "240763",
    [
      333293
    ]
  ],
  "./de/ldap_cert_upload.json": [
    "871159",
    [
      735170
    ]
  ],
  "./el/change_password.json": [
    "786919",
    [
      867105
    ]
  ],
  "./hu/edit_section_view.json": [
    "291181",
    [
      318371
    ]
  ],
  "./ca/submit_online_url_assignment.json": [
    "21374",
    [
      318750
    ]
  ],
  "./mi/assignments_2_attempt_tab.json": [
    "231789",
    [
      808675
    ]
  ],
  "./sl/bounced_emails.json": [
    "591255",
    [
      155825
    ]
  ],
  "./sl/webcam_modal.json": [
    "788932",
    [
      266768
    ]
  ],
  "./vi/quantitative_data_options.json": [
    "370890",
    [
      281885
    ]
  ],
  "./ms/calendar_appointment_group_edit.json": [
    "829339",
    [
      189377
    ]
  ],
  "./en-CA/moderate_quiz.json": [
    "310481",
    [
      522343
    ]
  ],
  "./hi/SpeedGraderCheckpoints.json": [
    "989932",
    [
      691148
    ]
  ],
  "./nl/account_calendar_settings_filter_controls.json": [
    "532216",
    [
      294148
    ]
  ],
  "./en-GB/authentication_providers.json": [
    "376624",
    [
      605801
    ]
  ],
  "./es/assignments_2_file_upload.json": [
    "611120",
    [
      123013
    ]
  ],
  "./hi/LearningMasteryGradebook.json": [
    "412196",
    [
      237012
    ]
  ],
  "./it/media_immersive_view.json": [
    "194557",
    [
      731631
    ]
  ],
  "./ms/gradinggradingPeriodCollection.json": [
    "36595",
    [
      938473
    ]
  ],
  "./uk/change_password.json": [
    "722822",
    [
      494070
    ]
  ],
  "./zh-Hans/widget_dashboard.json": [
    "539164",
    [
      561196
    ]
  ],
  "./fa/password_complexity_configuration.json": [
    "124408",
    [
      118528
    ]
  ],
  "./hi/bulk_edit_students_table.json": [
    "304374",
    [
      201982
    ]
  ],
  "./id/remove_pace_warning_modal.json": [
    "917148",
    [
      227656
    ]
  ],
  "./cy/account_calendar_settings_utils.json": [
    "225290",
    [
      548562
    ]
  ],
  "./ga/student_annotation_preview.json": [
    "504212",
    [
      921956
    ]
  ],
  "./nn/user.json": [
    "980181",
    [
      577535
    ]
  ],
  "./fi/sis_import.json": [
    "930670",
    [
      266598
    ]
  ],
  "./es/jobs_v2.json": [
    "549491",
    [
      93022
    ]
  ],
  "./nl/auth_logging.json": [
    "815660",
    [
      668896
    ]
  ],
  "./da-x-k12/FindOutcomesModal.json": [
    "493204",
    [
      332496
    ]
  ],
  "./hi/use_switch_experience.json": [
    "165000",
    [
      619360
    ]
  ],
  "./ar/webcam_modal.json": [
    "748044",
    [
      504912
    ]
  ],
  "./ga/user.json": [
    "585173",
    [
      523699
    ]
  ],
  "./ms/custom_help_link.json": [
    "100058",
    [
      39522
    ]
  ],
  "./nb/dashboard.json": [
    "441574",
    [
      600530
    ]
  ],
  "./nl/account_calendar_settings_account_list.json": [
    "705683",
    [
      443941
    ]
  ],
  "./fi/gradebookActionMenu.json": [
    "421268",
    [
      389172
    ]
  ],
  "./nn/jobs_v2.json": [
    "181639",
    [
      707737
    ]
  ],
  "./sl/account_calendars_modal.json": [
    "2992",
    [
      956060
    ]
  ],
  "./sv/assignments_2_shared_Steps.json": [
    "405116",
    [
      730760
    ]
  ],
  "./sv/student_groups.json": [
    "8701",
    [
      439039
    ]
  ],
  "./th/blueprint_settingsCourseFilter.json": [
    "553584",
    [
      820380
    ]
  ],
  "./de/outcome_alignment_v2.json": [
    "34788",
    [
      977497
    ]
  ],
  "./en-GB-x-ukhe/edit_section_dates.json": [
    "953898",
    [
      889162
    ]
  ],
  "./ga/wiki_page_index.json": [
    "505271",
    [
      138733
    ]
  ],
  "./he/user_grades.json": [
    "810294",
    [
      960279
    ]
  ],
  "./nl/assignments_2_submission_helpers.json": [
    "734030",
    [
      956930
    ]
  ],
  "./sv/content_copy_redesign.json": [
    "179200",
    [
      317012
    ]
  ],
  "./sv/course_stats.json": [
    "467712",
    [
      620156
    ]
  ],
  "./tr/jobs.json": [
    "670588",
    [
      199720
    ]
  ],
  "./en-AU-x-unimelb/course_search_results.json": [
    "986165",
    [
      444679
    ]
  ],
  "./vi/assignments_2_student_content.json": [
    "70910",
    [
      386886
    ]
  ],
  "./fi/account_calendar_settings_account_calendar_item_dropdown.json": [
    "978518",
    [
      435358
    ]
  ],
  "./de/assignments_2_student_annotation.json": [
    "607602",
    [
      590323
    ]
  ],
  "./ms/quiz_log_auditing.json": [
    "968422",
    [
      534054
    ]
  ],
  "./fr/ai_experiences_show.json": [
    "219186",
    [
      590407
    ]
  ],
  "./mi/terms_of_service_modal.json": [
    "367779",
    [
      201465
    ]
  ],
  "./en.manifest.json": [
    "2669",
    []
  ],
  "./sv-x-k12/new_nav.json": [
    "825857",
    [
      690663
    ]
  ],
  "./th/bounced_emails.json": [
    "853238",
    [
      152906
    ]
  ],
  "./nb-x-k12/quizzes.take_quiz.json": [
    "186234",
    [
      729995
    ]
  ],
  "./en-AU/assignments_2_student_content.json": [
    "70149",
    [
      592540
    ]
  ],
  "./vi/course_paces_pace_picker.json": [
    "728634",
    [
      626010
    ]
  ],
  "./tr/default_account_quotas.json": [
    "357735",
    [
      490361
    ]
  ],
  "./fr-CA/react_collaborations.json": [
    "125895",
    [
      593761
    ]
  ],
  "./ko/dashboard.json": [
    "101388",
    [
      581540
    ]
  ],
  "./fi/rubrics-export.json": [
    "336186",
    [
      758874
    ]
  ],
  "./sl/collaborations.json": [
    "818245",
    [
      744983
    ]
  ],
  "./da/direct_share_course_import_panel.json": [
    "875831",
    [
      910357
    ]
  ],
  "./ga/password_complexity_configuration.json": [
    "41089",
    [
      833559
    ]
  ],
  "./sv/course_logging_details.json": [
    "949215",
    [
      188993
    ]
  ],
  "./nb-x-k12/paginated_list.json": [
    "959284",
    [
      598484
    ]
  ],
  "./fi/a2LatePolicyStatusDisplay.json": [
    "551312",
    [
      526232
    ]
  ],
  "./nn/syllabus_revisions.json": [
    "952900",
    [
      727776
    ]
  ],
  "./fa/ldap_cert_upload.json": [
    "845517",
    [
      106059
    ]
  ],
  "./en-GB/ProfileTray.json": [
    "452338",
    [
      815079
    ]
  ],
  "./nl/assignments_bulk_edit_use_save_assignment.json": [
    "723652",
    [
      874536
    ]
  ],
  "./ms/discussion_posts.json": [
    "524610",
    [
      473626
    ]
  ],
  "./pt-BR/content_shares.json": [
    "675575",
    [
      444962
    ]
  ],
  "./zh-Hant/appt_calendar_event_dialog.json": [
    "160428",
    [
      57384
    ]
  ],
  "./sv/terms_index.json": [
    "667971",
    [
      580181
    ]
  ],
  "./mi/restore_content_pane.json": [
    "413503",
    [
      934941
    ]
  ],
  "./ru/overview_page.json": [
    "733556",
    [
      769940
    ]
  ],
  "./el/context_modules_v2.json": [
    "713219",
    [
      550149
    ]
  ],
  "./hu/notebook.json": [
    "641762",
    [
      938330
    ]
  ],
  "./nb/account_course_user_search.json": [
    "301500",
    [
      491912
    ]
  ],
  "./ko/grade_summaryGroupView.json": [
    "725834",
    [
      2850
    ]
  ],
  "./en/wiki_page_index.json": [
    "838196",
    [
      898984
    ]
  ],
  "./es/course_template_details.json": [
    "431775",
    [
      136562
    ]
  ],
  "./id/admin_split.json": [
    "740735",
    [
      18502
    ]
  ],
  "./ko/edit_section_dates.json": [
    "173346",
    [
      883562
    ]
  ],
  "./ko/license_help.json": [
    "249447",
    [
      433669
    ]
  ],
  "./pl/gradebook.json": [
    "362664",
    [
      707204
    ]
  ],
  "./nl/courses.show.json": [
    "753177",
    [
      215256
    ]
  ],
  "./nb/accessibility_checker.json": [
    "55254",
    [
      179258
    ]
  ],
  "./nb-x-k12/terms_of_use.json": [
    "853809",
    [
      341767
    ]
  ],
  "./el/courses.json": [
    "617169",
    [
      943131
    ]
  ],
  "./da/youtube_migration.json": [
    "32731",
    [
      338545
    ]
  ],
  "./vi/assignments.json": [
    "169389",
    [
      829451
    ]
  ],
  "./ca/account_calendar_settings_account_list.json": [
    "632705",
    [
      797967
    ]
  ],
  "./ht/course_paces_blackout_dates_modal.json": [
    "505448",
    [
      897428
    ]
  ],
  "./ar/assignments_2_shared_Steps.json": [
    "540678",
    [
      377338
    ]
  ],
  "./th/blueprint_course_child.json": [
    "134510",
    [
      249738
    ]
  ],
  "./da/authentication_providers.json": [
    "906502",
    [
      857558
    ]
  ],
  "./da/canvascareer.json": [
    "575677",
    [
      988579
    ]
  ],
  "./en-GB-x-lbs/LearningMasteryGradebook.json": [
    "53243",
    [
      376553
    ]
  ],
  "./fr/course_paces_modal.json": [
    "174574",
    [
      968587
    ]
  ],
  "./hu/edit_section_dates.json": [
    "530129",
    [
      165871
    ]
  ],
  "./de/course_pace_date_input.json": [
    "245730",
    [
      213763
    ]
  ],
  "./nb/bounced_emails.json": [
    "949182",
    [
      169138
    ]
  ],
  "./vi/announcements_on_home_page.json": [
    "686733",
    [
      242363
    ]
  ],
  "./nb-x-k12/account_calendar_settings_account_group.json": [
    "230866",
    [
      626210
    ]
  ],
  "./ko/submissions_show_preview.json": [
    "259200",
    [
      206960
    ]
  ],
  "./sv/grade_details.json": [
    "826969",
    [
      152475
    ]
  ],
  "./id/quizzes_regrade_modal.json": [
    "644043",
    [
      345661
    ]
  ],
  "./zh-Hans/dashboard_grading_period_select.json": [
    "95959",
    [
      937565
    ]
  ],
  "./nb-x-k12/gradebook_uploads.json": [
    "545231",
    [
      541589
    ]
  ],
  "./th/EditMasteryScaleLink.json": [
    "384051",
    [
      847285
    ]
  ],
  "./en-AU-x-unimelb/ai_experiences.json": [
    "434026",
    [
      171382
    ]
  ],
  "./nb-x-k12/sharedSetDefaultGradeDialog.json": [
    "329819",
    [
      883449
    ]
  ],
  "./it/users.json": [
    "930211",
    [
      806197
    ]
  ],
  "./pt/appt_calendar_event_dialog.json": [
    "18070",
    [
      2797
    ]
  ],
  "./sv/MobileNavigation.json": [
    "470041",
    [
      787059
    ]
  ],
  "./ht/account_settings.json": [
    "636931",
    [
      813989
    ]
  ],
  "./hu/course_pace_date_input.json": [
    "70286",
    [
      906494
    ]
  ],
  "./es/FindOutcomesModal.json": [
    "599517",
    [
      721380
    ]
  ],
  "./pl/custom_help_link.json": [
    "457346",
    [
      720326
    ]
  ],
  "./nl/dashboard_grades_page.json": [
    "735013",
    [
      454503
    ]
  ],
  "./pt/remove_pace_warning_modal.json": [
    "456857",
    [
      240099
    ]
  ],
  "./sv/pseudonyms_mobile_login.json": [
    "401311",
    [
      500145
    ]
  ],
  "./it/course_paces_pace_picker.json": [
    "871018",
    [
      22318
    ]
  ],
  "./cy/permissions.json": [
    "835854",
    [
      13182
    ]
  ],
  "./el/MasteryScale.json": [
    "690528",
    [
      125396
    ]
  ],
  "./nl/course_paces_footer.json": [
    "211720",
    [
      121564
    ]
  ],
  "./pt-BR/peer_review_allocation_rule_card.json": [
    "509171",
    [
      668134
    ]
  ],
  "./zh-Hant/courses.show.json": [
    "237205",
    [
      977188
    ]
  ],
  "./es-ES/job_stats.json": [
    "440232",
    [
      35840
    ]
  ],
  "./en-GB-x-ukhe/react_scheduler.json": [
    "34377",
    [
      724463
    ]
  ],
  "./nn/assignments_2_submission_helpers.json": [
    "921000",
    [
      490636
    ]
  ],
  "./tr/folder_tree.json": [
    "502889",
    [
      462627
    ]
  ],
  "./mi/submissions_show_preview.json": [
    "224892",
    [
      824964
    ]
  ],
  "./en-GB-x-ukhe/ai_experiences_ai_conversations.json": [
    "855172",
    [
      891284
    ]
  ],
  "./en-GB/question_bank.json": [
    "790244",
    [
      130429
    ]
  ],
  "./hi/unpublished_warning_modal.json": [
    "904459",
    [
      785833
    ]
  ],
  "./id/course_template_details.json": [
    "328118",
    [
      470890
    ]
  ],
  "./hu/grade_details.json": [
    "308579",
    [
      158713
    ]
  ],
  "./th/files_v2.json": [
    "140858",
    [
      778166
    ]
  ],
  "./ko/courses.json": [
    "682150",
    [
      347702
    ]
  ],
  "./sv/assignments_bulk_edit.json": [
    "181771",
    [
      546637
    ]
  ],
  "./ca/section.json": [
    "709433",
    [
      514743
    ]
  ],
  "./tr/gradingGradeSummary.json": [
    "120001",
    [
      944211
    ]
  ],
  "./sl/course_paces_search.json": [
    "237022",
    [
      673058
    ]
  ],
  "./zh-Hant/content_migrations.json": [
    "695115",
    [
      733805
    ]
  ],
  "./sv/react_developer_keys.json": [
    "971822",
    [
      554170
    ]
  ],
  "./en-GB-x-lbs/announcements_v2.json": [
    "518537",
    [
      34431
    ]
  ],
  "./es/course_paces_actions.json": [
    "386808",
    [
      131693
    ]
  ],
  "./pl/assignments_2_student_annotation.json": [
    "499203",
    [
      807122
    ]
  ],
  "./el/assignments_2_media_attempt.json": [
    "606045",
    [
      808543
    ]
  ],
  "./da-x-k12/course_default_due_time.json": [
    "302993",
    [
      759163
    ]
  ],
  "./it/grades_empty_page.json": [
    "216279",
    [
      251281
    ]
  ],
  "./ja/SpeedGraderCheckpoints.json": [
    "189530",
    [
      668931
    ]
  ],
  "./ja/bounced_emails.json": [
    "891341",
    [
      860708
    ]
  ],
  "./tr/authentication_providers.json": [
    "189857",
    [
      534323
    ]
  ],
  "./vi/todo.json": [
    "865409",
    [
      537463
    ]
  ],
  "./ko/react_developer_keys.json": [
    "540175",
    [
      603069
    ]
  ],
  "./ru/plugins.json": [
    "920859",
    [
      348009
    ]
  ],
  "./hu/entity_search_form.json": [
    "234432",
    [
      42304
    ]
  ],
  "./sl/nav_tourpoints.json": [
    "591736",
    [
      340932
    ]
  ],
  "./ko/suppress_notifications.json": [
    "620168",
    [
      71144
    ]
  ],
  "./es/quizzes.take_quiz.json": [
    "316772",
    [
      188657
    ]
  ],
  "./fi/blueprint_settingsCoursePicker.json": [
    "860327",
    [
      540413
    ]
  ],
  "./ja/user_date_range_search.json": [
    "185706",
    [
      188819
    ]
  ],
  "./pt-BR/section.json": [
    "811476",
    [
      218217
    ]
  ],
  "./ms/gradebook_history.json": [
    "525207",
    [
      967749
    ]
  ],
  "./ca/login.json": [
    "723135",
    [
      268365
    ]
  ],
  "./sv-x-k12/announcements_v2.json": [
    "884874",
    [
      560490
    ]
  ],
  "./he/password_complexity_configuration.json": [
    "344330",
    [
      61458
    ]
  ],
  "./nb/horizon_toggle.json": [
    "168290",
    [
      150470
    ]
  ],
  "./zh-Hant/account_calendars.json": [
    "924451",
    [
      107989
    ]
  ],
  "./hu/error_form.json": [
    "405702",
    [
      671046
    ]
  ],
  "./is/course_paces_search.json": [
    "116997",
    [
      623315
    ]
  ],
  "./sl/gradebook_history.json": [
    "601952",
    [
      668604
    ]
  ],
  "./he/course_navigation_settings.json": [
    "995835",
    [
      500929
    ]
  ],
  "./nl/dashboard_grading_period_select.json": [
    "952210",
    [
      43598
    ]
  ],
  "./ru/license_help.json": [
    "462002",
    [
      596690
    ]
  ],
  "./uk/assignmentsIndexView.json": [
    "672701",
    [
      73859
    ]
  ],
  "./el/account_settings.json": [
    "437032",
    [
      111668
    ]
  ],
  "./es-ES/assignments_2_student_points_display.json": [
    "236811",
    [
      668105
    ]
  ],
  "./hy/appointment_groups.json": [
    "713637",
    [
      971875
    ]
  ],
  "./de/lti_registrations.json": [
    "637211",
    [
      630638
    ]
  ],
  "./fr-CA/content_migrations.json": [
    "661366",
    [
      198482
    ]
  ],
  "./mi/modelsQuiz.json": [
    "945011",
    [
      548265
    ]
  ],
  "./he/outcome_reporting.json": [
    "210216",
    [
      773144
    ]
  ],
  "./ar/discussion_topics_edit.json": [
    "452885",
    [
      209743
    ]
  ],
  "./ht/canvascareer.json": [
    "566308",
    [
      884744
    ]
  ],
  "./zh-Hant/calculator.json": [
    "483356",
    [
      450904
    ]
  ],
  "./ht/account_calendar_settings.json": [
    "614136",
    [
      583844
    ]
  ],
  "./nb-x-k12/react_collaborations.json": [
    "634650",
    [
      428058
    ]
  ],
  "./en-CA/a2LatePolicyStatusDisplay.json": [
    "324933",
    [
      90995
    ]
  ],
  "./ga/course_paces_blackout_date_row.json": [
    "310242",
    [
      536642
    ]
  ],
  "./en-GB/GroupsTray.json": [
    "569997",
    [
      786128
    ]
  ],
  "./it/a2LatePolicyToolTipContent.json": [
    "333604",
    [
      907152
    ]
  ],
  "./it/reset_pace_warning_modal.json": [
    "497539",
    [
      852389
    ]
  ],
  "./nn/gradingPeriodTemplate.json": [
    "915621",
    [
      403935
    ]
  ],
  "./es-ES/discussion_pinned_post.json": [
    "403099",
    [
      498121
    ]
  ],
  "./en-GB-x-lbs/gradinggradingPeriodCollection.json": [
    "819761",
    [
      328615
    ]
  ],
  "./es-ES/AddGroup.json": [
    "479647",
    [
      119029
    ]
  ],
  "./ar/assignments_2_login_action_prompt.json": [
    "699858",
    [
      160702
    ]
  ],
  "./en-GB-x-ukhe/grade_details.json": [
    "536666",
    [
      912538
    ]
  ],
  "./de/gradebook_uploads.json": [
    "998010",
    [
      522123
    ]
  ],
  "./ms/account_calendar_settings_account_tree.json": [
    "775517",
    [
      120211
    ]
  ],
  "./nb-x-k12/dashboard_grading_period_select.json": [
    "832950",
    [
      690302
    ]
  ],
  "./mi.eager.json": [
    "779317",
    [
      261152
    ]
  ],
  "./fi/assignment_index_menu.json": [
    "25843",
    [
      158433
    ]
  ],
  "./hu/blueprint_course_sidebar.json": [
    "342121",
    [
      710967
    ]
  ],
  "./pt/gradingGradeSummary.json": [
    "58647",
    [
      338681
    ]
  ],
  "./es-ES/video_conference.json": [
    "985359",
    [
      707637
    ]
  ],
  "./da-x-k12/comm_messages.json": [
    "248638",
    [
      932586
    ]
  ],
  "./it/course_stats.json": [
    "606940",
    [
      966904
    ]
  ],
  "./sv/content_exports.json": [
    "973106",
    [
      950574
    ]
  ],
  "./cy/assignments_2_MoreOptions_CanvasFiles.json": [
    "501451",
    [
      938385
    ]
  ],
  "./en-GB-x-ukhe/CoursesTray.json": [
    "174154",
    [
      912890
    ]
  ],
  "./en-AU/content_migrations.json": [
    "841315",
    [
      390494
    ]
  ],
  "./sl/react_scheduler.json": [
    "393487",
    [
      43600
    ]
  ],
  "./ht/quiz_migration_notifications.json": [
    "908587",
    [
      436069
    ]
  ],
  "./it/quizzes_public.json": [
    "328958",
    [
      489610
    ]
  ],
  "./ht/learning_mastery_gradebook.json": [
    "345103",
    [
      774705
    ]
  ],
  "./es/account_settings.json": [
    "788179",
    [
      188286
    ]
  ],
  "./el/peer_review_allocation_rule_card.json": [
    "666199",
    [
      714305
    ]
  ],
  "./nb/student_groups.json": [
    "838030",
    [
      581338
    ]
  ],
  "./nn/SpeedGraderCheckpoints.json": [
    "500357",
    [
      377087
    ]
  ],
  "./sv-x-k12/ai_experiences_show.json": [
    "863969",
    [
      749847
    ]
  ],
  "./nn/assignment_index_deep_linking_handlers.json": [
    "936112",
    [
      927060
    ]
  ],
  "./da-x-k12/account_calendar_settings_confirmation_modal.json": [
    "87661",
    [
      496807
    ]
  ],
  "./fr-CA/modules_page_icon_legend.json": [
    "983604",
    [
      159616
    ]
  ],
  "./ht/permissions_role_tray.json": [
    "228916",
    [
      908240
    ]
  ],
  "./id/ai_experiences_show.json": [
    "874947",
    [
      294733
    ]
  ],
  "./fa/account_course_user_search.json": [
    "952515",
    [
      393537
    ]
  ],
  "./it/context_roster_user_services.json": [
    "745681",
    [
      543603
    ]
  ],
  "./nb/assignments_peer_reviews.json": [
    "643415",
    [
      327201
    ]
  ],
  "./nb/quizzes_quiz_submission.json": [
    "773538",
    [
      753942
    ]
  ],
  "./de/AddGroup.json": [
    "937297",
    [
      399608
    ]
  ],
  "./ru/user_name.json": [
    "838028",
    [
      159900
    ]
  ],
  "./de/calendar.header.json": [
    "542060",
    [
      253681
    ]
  ],
  "./he/security_panel.json": [
    "914276",
    [
      575964
    ]
  ],
  "./sv-x-k12/important_dates.json": [
    "227089",
    [
      940951
    ]
  ],
  "./th/course_paces_blackout_date_row.json": [
    "330510",
    [
      404082
    ]
  ],
  "./zh-Hant/speed_grader_helpers.json": [
    "827045",
    [
      532591
    ]
  ],
  "./fr-CA/AssignmentGroupListItemView.json": [
    "403213",
    [
      716895
    ]
  ],
  "./is/horizon_toggle.json": [
    "654878",
    [
      249942
    ]
  ],
  "./ar/DueDateOverrideView.json": [
    "867934",
    [
      503186
    ]
  ],
  "./pt/keyboardShortcutModal.json": [
    "42866",
    [
      736198
    ]
  ],
  "./ht/dashboard_grades_page.json": [
    "916031",
    [
      624529
    ]
  ],
  "./sl/GroupsTray.json": [
    "56595",
    [
      702989
    ]
  ],
  "./nb-x-k12/quantitative_data_options.json": [
    "724293",
    [
      162563
    ]
  ],
  "./nl/course_navigation_settings.json": [
    "995332",
    [
      509728
    ]
  ],
  "./hy/suppress_notifications.json": [
    "519055",
    [
      859381
    ]
  ],
  "./sv/media_immersive_view.json": [
    "923833",
    [
      379451
    ]
  ],
  "./th/course_color_selector.json": [
    "348593",
    [
      913179
    ]
  ],
  "./ru/dashboard_grading_period_select.json": [
    "297889",
    [
      878647
    ]
  ],
  "./el/gradebookActionMenu.json": [
    "216432",
    [
      328196
    ]
  ],
  "./ar/files_v2.json": [
    "841895",
    [
      685785
    ]
  ],
  "./sv-x-k12/course_statistics.json": [
    "484204",
    [
      45228
    ]
  ],
  "./is/rate_limiting_settings.json": [
    "840808",
    [
      124176
    ]
  ],
  "./en-GB-x-ukhe/unpublished_warning_modal.json": [
    "643498",
    [
      63034
    ]
  ],
  "./da/FindOutcomesModal.json": [
    "549298",
    [
      969722
    ]
  ],
  "./cy/OutcomeDescriptionModal.json": [
    "32965",
    [
      939627
    ]
  ],
  "./ga/files_v2.json": [
    "378990",
    [
      139782
    ]
  ],
  "./ms/assignments_2_student_content_rubric_self_assessment.json": [
    "661063",
    [
      785813
    ]
  ],
  "./en-GB-x-lbs/roster_section_input.json": [
    "842072",
    [
      263392
    ]
  ],
  "./he/pseudonyms_mobile_login.json": [
    "96109",
    [
      124003
    ]
  ],
  "./es/assignment_index.json": [
    "124164",
    [
      310353
    ]
  ],
  "./cy/course_paces_no_results.json": [
    "964131",
    [
      450489
    ]
  ],
  "./en-GB-x-lbs/collaborations.json": [
    "811934",
    [
      567158
    ]
  ],
  "./fr/k5_dashboard.json": [
    "420717",
    [
      292072
    ]
  ],
  "./uk/dashboard_grading_period_select.json": [
    "716312",
    [
      416216
    ]
  ],
  "./hy/course_paces_change_tracking.json": [
    "682978",
    [
      821906
    ]
  ],
  "./ja/quizzes.take_quiz.json": [
    "442241",
    [
      849664
    ]
  ],
  "./da/editGroup.json": [
    "428402",
    [
      802362
    ]
  ],
  "./de/course_paces_change_tracking.json": [
    "780074",
    [
      5435
    ]
  ],
  "./pl/modules_page_icon_legend.json": [
    "532951",
    [
      347001
    ]
  ],
  "./sv-x-k12/sharedSetDefaultGradeDialog.json": [
    "63202",
    [
      695650
    ]
  ],
  "./fr-CA/CreateEditAssignmentModalAdapter.json": [
    "958920",
    [
      54780
    ]
  ],
  "./cy/blueprint_settingsAssociationsTable.json": [
    "414037",
    [
      656571
    ]
  ],
  "./ru/use_switch_experience.json": [
    "437186",
    [
      46530
    ]
  ],
  "./cy/gradingGradeSummary.json": [
    "755807",
    [
      495773
    ]
  ],
  "./da/assignments_bulk_edit.json": [
    "21037",
    [
      150099
    ]
  ],
  "./en-CA/LearningMasteryGradebook.json": [
    "496593",
    [
      32631
    ]
  ],
  "./he/suppress_notifications.json": [
    "643179",
    [
      108465
    ]
  ],
  "./is/section.json": [
    "893605",
    [
      756195
    ]
  ],
  "./tr/courses.show.json": [
    "867317",
    [
      551860
    ]
  ],
  "./tr/quiz_show.json": [
    "230243",
    [
      289021
    ]
  ],
  "./fi/ignite_agent.json": [
    "870277",
    [
      473939
    ]
  ],
  "./tr/course_template_details.json": [
    "10690",
    [
      212839
    ]
  ],
  "./he/upload_button.json": [
    "889427",
    [
      27241
    ]
  ],
  "./it/blueprint_settingsCourseFilter.json": [
    "334215",
    [
      347993
    ]
  ],
  "./sl/conferences.json": [
    "145266",
    [
      401374
    ]
  ],
  "./fa/assignment_index.json": [
    "625027",
    [
      867889
    ]
  ],
  "./zh-Hant/react_developer_keys.json": [
    "121995",
    [
      339261
    ]
  ],
  "./en-GB/external_content_cancel.json": [
    "739687",
    [
      645406
    ]
  ],
  "./id/courses_show.json": [
    "255423",
    [
      2849
    ]
  ],
  "./es/youtube_migration.json": [
    "597636",
    [
      1777
    ]
  ],
  "./en-GB-x-lbs/GroupsTray.json": [
    "384216",
    [
      443520
    ]
  ],
  "./en-AU-x-unimelb/gradingGradeSummary.json": [
    "429319",
    [
      199617
    ]
  ],
  "./it/assignments.no_assignments_search.json": [
    "291156",
    [
      846409
    ]
  ],
  "./ca/use_switch_experience.json": [
    "402803",
    [
      19257
    ]
  ],
  "./th/user_name.json": [
    "672473",
    [
      774363
    ]
  ],
  "./fr-CA/progress_pill.json": [
    "592364",
    [
      923656
    ]
  ],
  "./ms/outcome_detail.json": [
    "386158",
    [
      616222
    ]
  ],
  "./nb/course_paces_settings.json": [
    "810068",
    [
      383800
    ]
  ],
  "./da/course_paces_settings.json": [
    "453523",
    [
      634489
    ]
  ],
  "./sl/module_sequence_footer.json": [
    "407513",
    [
      30923
    ]
  ],
  "./fa/keyboardShortcutModal.json": [
    "363775",
    [
      724901
    ]
  ],
  "./ru/permission_button.json": [
    "249055",
    [
      430261
    ]
  ],
  "./el/calculator.json": [
    "184981",
    [
      12079
    ]
  ],
  "./el/gradinggradingPeriodCollection.json": [
    "130372",
    [
      729256
    ]
  ],
  "./nl/peer_review_allocation_rule_card.json": [
    "327514",
    [
      599766
    ]
  ],
  "./fr-CA/user_search_results.json": [
    "123470",
    [
      341034
    ]
  ],
  "./is/gradebook_history.json": [
    "141091",
    [
      573473
    ]
  ],
  "./nb-x-k12/restore_content_pane.json": [
    "561639",
    [
      997149
    ]
  ],
  "./hy/content_shares.json": [
    "820045",
    [
      485019
    ]
  ],
  "./zh-Hant/account_course_user_search.json": [
    "174866",
    [
      484222
    ]
  ],
  "./pl/assignments_2_media_attempt.json": [
    "11164",
    [
      156192
    ]
  ],
  "./ko/peer_reviews_student.json": [
    "642578",
    [
      270490
    ]
  ],
  "./pt-BR/AccountsTray.json": [
    "421889",
    [
      213832
    ]
  ],
  "./ru/account_calendar_settings_confirmation_modal.json": [
    "429601",
    [
      768199
    ]
  ],
  "./is/context_prior_users.json": [
    "346261",
    [
      968051
    ]
  ],
  "./de/AssignmentGroupListItemView.json": [
    "726031",
    [
      523130
    ]
  ],
  "./tr/rubrics-export.json": [
    "550467",
    [
      229613
    ]
  ],
  "./ru/account_calendar_settings_account_calendar_item_dropdown.json": [
    "288662",
    [
      577646
    ]
  ],
  "./el/SpeedGraderCheckpoints.json": [
    "401450",
    [
      32190
    ]
  ],
  "./zh-Hans/course_paces_flaggable_number_input.json": [
    "839812",
    [
      160420
    ]
  ],
  "./zh-Hans/roster_publicjs.json": [
    "232219",
    [
      343337
    ]
  ],
  "./ht/knowledge_check_not_ready.json": [
    "338307",
    [
      57493
    ]
  ],
  "./fr/restore_content_pane.json": [
    "307045",
    [
      375864
    ]
  ],
  "./da/conversations_2.json": [
    "657796",
    [
      43724
    ]
  ],
  "./sl/assignments_peer_reviews_student.json": [
    "1370",
    [
      47230
    ]
  ],
  "./vi/assignments_2_initial_query.json": [
    "282472",
    [
      970384
    ]
  ],
  "./mi/NewTabIndicator.json": [
    "358878",
    [
      587278
    ]
  ],
  "./ca/permissions_role_tray.json": [
    "3212",
    [
      894724
    ]
  ],
  "./mi/assignments_2_submission_helpers.json": [
    "911722",
    [
      388914
    ]
  ],
  "./uk/gradebook.json": [
    "967520",
    [
      158576
    ]
  ],
  "./da-x-k12/grades_empty_page.json": [
    "889579",
    [
      362365
    ]
  ],
  "./fa/edit_section_dates.json": [
    "932379",
    [
      383321
    ]
  ],
  "./ar/context_prior_users.json": [
    "501946",
    [
      958454
    ]
  ],
  "./en-GB-x-lbs/assignments_2_student_points_display.json": [
    "320034",
    [
      833506
    ]
  ],
  "./vi/assignment_index_menu.json": [
    "12035",
    [
      366033
    ]
  ],
  "./nn/progressbar_view.json": [
    "193450",
    [
      953358
    ]
  ],
  "./hi/user_name.json": [
    "34694",
    [
      61838
    ]
  ],
  "./sl/FindOutcomesModal.json": [
    "840142",
    [
      36530
    ]
  ],
  "./hi/not_found_page_slide_puzzle.json": [
    "448042",
    [
      872442
    ]
  ],
  "./zh-Hans/custom_help_link.json": [
    "773663",
    [
      537701
    ]
  ],
  "./en-GB/sidenav.json": [
    "484931",
    [
      535346
    ]
  ],
  "./hu/lti_registrations.json": [
    "722847",
    [
      457917
    ]
  ],
  "./ru/media_player_iframe_content.json": [
    "4520",
    [
      832752
    ]
  ],
  "./nl/blueprint_settingsUnsyncedChanges.json": [
    "558889",
    [
      687803
    ]
  ],
  "./en-GB-x-lbs/calendar_sidebar.json": [
    "456073",
    [
      401807
    ]
  ],
  "./es-ES/restore_content_pane.json": [
    "521638",
    [
      159998
    ]
  ],
  "./en-GB.json": [
    "256628",
    [
      928126
    ]
  ],
  "./hy/unpublished_changes_button_props.json": [
    "613608",
    [
      514944
    ]
  ],
  "./sv/student_study_drawer.json": [
    "830258",
    [
      623238
    ]
  ],
  "./ht/grade_summary.json": [
    "934910",
    [
      783722
    ]
  ],
  "./mi/discussion_settings.json": [
    "345916",
    [
      642084
    ]
  ],
  "./hi/course_logging_details.json": [
    "866297",
    [
      607679
    ]
  ],
  "./pl/assignments_bulk_edit_use_save_assignment.json": [
    "155842",
    [
      929454
    ]
  ],
  "./es/user_date_range_search.json": [
    "158569",
    [
      319640
    ]
  ],
  "./pl/calendar_edit.json": [
    "936201",
    [
      382011
    ]
  ],
  "./en-AU/outcome_management.json": [
    "378010",
    [
      141859
    ]
  ],
  "./fa/permission_button.json": [
    "830055",
    [
      73021
    ]
  ],
  "./zh-Hans/OutcomeMoveModal.json": [
    "240769",
    [
      849159
    ]
  ],
  "./nb-x-k12/manage_avatars.json": [
    "148806",
    [
      391854
    ]
  ],
  "./ht/blueprint_settingsMigrationSync.json": [
    "643926",
    [
      629890
    ]
  ],
  "./da-x-k12/assignment_2_assignment_toggle_details.json": [
    "90157",
    [
      273127
    ]
  ],
  "./sl/section.json": [
    "731366",
    [
      521922
    ]
  ],
  "./nn/quizzes_public.json": [
    "468585",
    [
      121859
    ]
  ],
  "./zh-Hant/course_statistics.json": [
    "311753",
    [
      399507
    ]
  ],
  "./fr-CA.json": [
    "54196",
    [
      745422
    ]
  ],
  "./fi/discussion_topics_edit.json": [
    "298067",
    [
      282353
    ]
  ],
  "./pt/modelsQuiz.json": [
    "547697",
    [
      204779
    ]
  ],
  "./sv/not_found_page_slide_puzzle.json": [
    "717640",
    [
      411820
    ]
  ],
  "./ca/password_complexity_configuration.json": [
    "768941",
    [
      646771
    ]
  ],
  "./nn/CoursesTray.json": [
    "545360",
    [
      614764
    ]
  ],
  "./ca/AssignmentListItemView.json": [
    "69117",
    [
      341571
    ]
  ],
  "./en-AU/content_shares.json": [
    "690314",
    [
      320275
    ]
  ],
  "./hy/blueprint_settingsCoursePickerTable.json": [
    "437431",
    [
      123965
    ]
  ],
  "./sl/SpeedGraderPostGradesMenu.json": [
    "551732",
    [
      551232
    ]
  ],
  "./nb-x-k12/submissions_show_preview.json": [
    "698228",
    [
      526916
    ]
  ],
  "./th/youtube_migration.json": [
    "876156",
    [
      583648
    ]
  ],
  "./en-GB/assignments_peer_reviews.json": [
    "309272",
    [
      909129
    ]
  ],
  "./tr/webzip_export.json": [
    "895464",
    [
      416444
    ]
  ],
  "./fi/pairing_code_user_observees.json": [
    "73730",
    [
      560930
    ]
  ],
  "./ms/user_restore.json": [
    "617012",
    [
      197612
    ]
  ],
  "./da-x-k12/bulk_edit_students_actions.json": [
    "64351",
    [
      775865
    ]
  ],
  "./pl/comm_messages.json": [
    "989551",
    [
      238353
    ]
  ],
  "./hi/account_calendar_settings_account_tree.json": [
    "734972",
    [
      942156
    ]
  ],
  "./sv-x-k12/user_grades.json": [
    "629333",
    [
      966755
    ]
  ],
  "./zh-Hans/new_nav.json": [
    "883305",
    [
      446047
    ]
  ],
  "./ca/assignments_2_peer_review.json": [
    "256095",
    [
      217965
    ]
  ],
  "./el/progressbar_view.json": [
    "935537",
    [
      999795
    ]
  ],
  "./is/MobileNavigation.json": [
    "312798",
    [
      957302
    ]
  ],
  "./en-GB/announcements_on_home_page.json": [
    "917761",
    [
      906828
    ]
  ],
  "./mi/peer-review-assignment-widget.json": [
    "97330",
    [
      964010
    ]
  ],
  "./nb/course_color_selector.json": [
    "824585",
    [
      315219
    ]
  ],
  "./ga/assignments_2_file_upload.json": [
    "660044",
    [
      529004
    ]
  ],
  "./nl/outcome_detail.json": [
    "164296",
    [
      55252
    ]
  ],
  "./pt/ldap_cert_upload.json": [
    "590370",
    [
      433238
    ]
  ],
  "./zh-Hans/peer_review_configuration_tray.json": [
    "45518",
    [
      898134
    ]
  ],
  "./sv/restore_content_pane.json": [
    "156954",
    [
      365246
    ]
  ],
  "./uk/assignment_2_assignment_toggle_details.json": [
    "457766",
    [
      928342
    ]
  ],
  "./ga/course_paces_no_results.json": [
    "560567",
    [
      233309
    ]
  ],
  "./es/IndividualStudentMasteryOutcome.json": [
    "792603",
    [
      831782
    ]
  ],
  "./is/assignments_2_student_header_date_title.json": [
    "270993",
    [
      191207
    ]
  ],
  "./ms/gradingPeriodTemplate.json": [
    "460793",
    [
      400871
    ]
  ],
  "./nl/course_paces_change_tracking.json": [
    "404885",
    [
      483031
    ]
  ],
  "./da-x-k12/learning_mastery_gradebook.json": [
    "752268",
    [
      776576
    ]
  ],
  "./ko/gradebook.json": [
    "769206",
    [
      397958
    ]
  ],
  "./hu/modelsQuiz.json": [
    "938392",
    [
      769928
    ]
  ],
  "./th/registration.json": [
    "887939",
    [
      752965
    ]
  ],
  "./ca/discussion_posts.json": [
    "383938",
    [
      753194
    ]
  ],
  "./cy/permissions_role_tray_table_row.json": [
    "478072",
    [
      202152
    ]
  ],
  "./id/peer_review_student_select.json": [
    "338891",
    [
      938621
    ]
  ],
  "./ms/discussionTopicKeyboradShortcutModal.json": [
    "608305",
    [
      55535
    ]
  ],
  "./fa/assignments.never_drop.json": [
    "321487",
    [
      50374
    ]
  ],
  "./nb/student_study_drawer.json": [
    "306857",
    [
      798339
    ]
  ],
  "./ar/content_migrations.json": [
    "896864",
    [
      620108
    ]
  ],
  "./ko/account_notification_settings.json": [
    "430961",
    [
      705996
    ]
  ],
  "./fr/dashboard_grades_page.json": [
    "313031",
    [
      331646
    ]
  ],
  "./en-AU-x-unimelb.eager.json": [
    "844627",
    [
      105354
    ]
  ],
  "./pl/discussion_row.json": [
    "520705",
    [
      406627
    ]
  ],
  "./cy/link_to_students.json": [
    "532711",
    [
      205685
    ]
  ],
  "./cy/a2_AccessibleTipContent.json": [
    "434874",
    [
      793314
    ]
  ],
  "./en-GB-x-ukhe/peer_reviews_student.json": [
    "50330",
    [
      769722
    ]
  ],
  "./ko/grade_change_logging_content.json": [
    "266012",
    [
      247284
    ]
  ],
  "./th/discussion_pinned_post.json": [
    "987476",
    [
      193544
    ]
  ],
  "./vi/gradinggradingPeriodCollection.json": [
    "575120",
    [
      130248
    ]
  ],
  "./mi/link_to_students.json": [
    "506597",
    [
      715083
    ]
  ],
  "./is/gradebook.json": [
    "293268",
    [
      99684
    ]
  ],
  "./da-x-k12/assignments_2_initial_query.json": [
    "133404",
    [
      6352
    ]
  ],
  "./ar/progressbar_view.json": [
    "166247",
    [
      791897
    ]
  ],
  "./th/rootFoldersFinder.json": [
    "556211",
    [
      615085
    ]
  ],
  "./ms/course_paces_time_selection.json": [
    "86833",
    [
      223119
    ]
  ],
  "./nb-x-k12/course_logging_details.json": [
    "113038",
    [
      281958
    ]
  ],
  "./ht/courses_show.json": [
    "547000",
    [
      339860
    ]
  ],
  "./fa/calendar.header.json": [
    "306110",
    [
      440093
    ]
  ],
  "./nb/user_restore.json": [
    "285772",
    [
      441992
    ]
  ],
  "./nl/epub_exports.json": [
    "67898",
    [
      957318
    ]
  ],
  "./pt/course_paces_modal.json": [
    "100814",
    [
      208938
    ]
  ],
  "./nn/question_bank.json": [
    "689069",
    [
      520775
    ]
  ],
  "./pl/assignments.no_assignments_search.json": [
    "218701",
    [
      464850
    ]
  ],
  "./en-AU/blueprint_settingsSyncChange.json": [
    "595330",
    [
      249227
    ]
  ],
  "./nb-x-k12/keyboardShortcutModal.json": [
    "639160",
    [
      204816
    ]
  ],
  "./uk/assignment_grade_summary.json": [
    "246248",
    [
      242619
    ]
  ],
  "./id/widget_dashboard.json": [
    "393738",
    [
      729310
    ]
  ],
  "./nb/discussion_pinned_post.json": [
    "627260",
    [
      997872
    ]
  ],
  "./pt-BR/group_submission_reminder.json": [
    "580696",
    [
      199573
    ]
  ],
  "./en-GB-x-lbs/courses_show.json": [
    "889054",
    [
      169606
    ]
  ],
  "./zh-Hans/edit_section_dates.json": [
    "598237",
    [
      945595
    ]
  ],
  "./ca/assignments_2_MoreOptions.json": [
    "389183",
    [
      341901
    ]
  ],
  "./ar/grades_empty_page.json": [
    "66297",
    [
      921531
    ]
  ],
  "./nb/bulk_edit_students_actions.json": [
    "609748",
    [
      675264
    ]
  ],
  "./pt/blueprint_settingsAssociationsTable.json": [
    "639197",
    [
      995879
    ]
  ],
  "./hi/assignments_2_file_upload.json": [
    "425379",
    [
      310369
    ]
  ],
  "./he/sis_import.json": [
    "712276",
    [
      340204
    ]
  ],
  "./ja/assignments_peer_reviews_student.json": [
    "632760",
    [
      17117
    ]
  ],
  "./cy/progress_pill.json": [
    "739197",
    [
      239635
    ]
  ],
  "./fr/grades_empty_page.json": [
    "657030",
    [
      888603
    ]
  ],
  "./en/widget_dashboard.json": [
    "535332",
    [
      270792
    ]
  ],
  "./pt/blueprint_settingsMigrationSync.json": [
    "910382",
    [
      751562
    ]
  ],
  "./cy/canvas_file_upload.json": [
    "748523",
    [
      206257
    ]
  ],
  "./zh-Hant/course_paces_no_results.json": [
    "280429",
    [
      974895
    ]
  ],
  "./it/todo.json": [
    "716785",
    [
      898131
    ]
  ],
  "./el/terms_index.json": [
    "239155",
    [
      939589
    ]
  ],
  "./ja/blueprint_settingsAssociationsTable.json": [
    "495700",
    [
      193105
    ]
  ],
  "./pt/permissions_role_tray_table_row.json": [
    "451808",
    [
      243324
    ]
  ],
  "./tr/SpeedGraderDiscussionsNavigation.json": [
    "610327",
    [
      375937
    ]
  ],
  "./nn/assignments_2_initial_query.json": [
    "513161",
    [
      919283
    ]
  ],
  "./th/assignments_2_shared_Steps.json": [
    "94091",
    [
      674629
    ]
  ],
  "./it/quiz_show.json": [
    "475304",
    [
      886884
    ]
  ],
  "./zh-Hans/discussion_row.json": [
    "730104",
    [
      276784
    ]
  ],
  "./th/blueprint_coursesExpandableLockOptions.json": [
    "123675",
    [
      945373
    ]
  ],
  "./pt-BR/rate_limiting_settings.json": [
    "404795",
    [
      653742
    ]
  ],
  "./vi/CommentLibrary.json": [
    "275493",
    [
      433523
    ]
  ],
  "./id/grade_details.json": [
    "605245",
    [
      518191
    ]
  ],
  "./en-GB-x-lbs/account_calendars.json": [
    "881703",
    [
      868077
    ]
  ],
  "./sl/gradebook_default_gradebook_components_content_filters_module_filter.json": [
    "610827",
    [
      258997
    ]
  ],
  "./ca/terms_of_service_modal.json": [
    "687597",
    [
      136563
    ]
  ],
  "./fi/permissions.json": [
    "15251",
    [
      234529
    ]
  ],
  "./ru/CreateEditAssignmentModalAdapter.json": [
    "844460",
    [
      253820
    ]
  ],
  "./hi/keyboardShortcutModal.json": [
    "877002",
    [
      161131
    ]
  ],
  "./sl/roster_section_input.json": [
    "754435",
    [
      883693
    ]
  ],
  "./sv/discussion_settings.json": [
    "194451",
    [
      557869
    ]
  ],
  "./es/permissions_role_tray.json": [
    "433252",
    [
      466833
    ]
  ],
  "./pt-BR/student_groups.json": [
    "379257",
    [
      697120
    ]
  ],
  "./nl/AlignmentSummary.json": [
    "161379",
    [
      783677
    ]
  ],
  "./id/NewTabIndicator.json": [
    "61773",
    [
      367935
    ]
  ],
  "./da-x-k12/course_paces_app.json": [
    "8715",
    [
      378885
    ]
  ],
  "./de/GroupsTray.json": [
    "900131",
    [
      955926
    ]
  ],
  "./id/blueprint_settingsCourseFilter.json": [
    "542295",
    [
      796841
    ]
  ],
  "./sv-x-k12/widget_dashboard.json": [
    "67604",
    [
      380628
    ]
  ],
  "./ko/course_paces_blueprint_lock.json": [
    "998332",
    [
      685204
    ]
  ],
  "./tr/content_migrations.json": [
    "487339",
    [
      659069
    ]
  ],
  "./nl/calendar_custom_recurring_event_natural_language.json": [
    "200176",
    [
      979332
    ]
  ],
  "./sv/discovery_page.json": [
    "106301",
    [
      501335
    ]
  ],
  "./cy/default_account_quotas.json": [
    "654365",
    [
      375475
    ]
  ],
  "./es/pairing_code_user_observees.json": [
    "677403",
    [
      743462
    ]
  ],
  "./ht/jobs.json": [
    "755726",
    [
      185858
    ]
  ],
  "./sl/outcome_reporting.json": [
    "548732",
    [
      337232
    ]
  ],
  "./it/authentication_providers.json": [
    "723428",
    [
      516584
    ]
  ],
  "./el/accessibility_course_statistics.json": [
    "321561",
    [
      764003
    ]
  ],
  "./en-GB-x-ukhe/calculator.json": [
    "495920",
    [
      463224
    ]
  ],
  "./hi/discussion_posts.json": [
    "937039",
    [
      913621
    ]
  ],
  "./ko/rate_limiting_settings.json": [
    "396602",
    [
      637458
    ]
  ],
  "./hu/comm_messages.json": [
    "414556",
    [
      488036
    ]
  ],
  "./mi/course_paces_pace_picker.json": [
    "779735",
    [
      285349
    ]
  ],
  "./uk/bulk_edit_students_table.json": [
    "617975",
    [
      687989
    ]
  ],
  "./el/blueprint_settingsMigrationOptions.json": [
    "561002",
    [
      578574
    ]
  ],
  "./he/discussion_row.json": [
    "904852",
    [
      272332
    ]
  ],
  "./pt-BR/permissions_v2_add_tray.json": [
    "530518",
    [
      470080
    ]
  ],
  "./mi/AlignmentSummary.json": [
    "910351",
    [
      548269
    ]
  ],
  "./ht/manage_avatars.json": [
    "819472",
    [
      247124
    ]
  ],
  "./ca/canvascareer.json": [
    "942748",
    [
      695764
    ]
  ],
  "./mi/context_modules_v2.json": [
    "44430",
    [
      744510
    ]
  ],
  "./fi/default_account_quotas.json": [
    "766914",
    [
      140434
    ]
  ],
  "./el/quizzes_index.json": [
    "507773",
    [
      835447
    ]
  ],
  "./id/submit_assignment.json": [
    "360507",
    [
      48301
    ]
  ],
  "./es/user_logins.json": [
    "744136",
    [
      240605
    ]
  ],
  "./da/course_paces_blackout_dates_modal.json": [
    "47907",
    [
      937353
    ]
  ],
  "./es/job_stats.json": [
    "871177",
    [
      516024
    ]
  ],
  "./de/account_course_user_search.json": [
    "929225",
    [
      757872
    ]
  ],
  "./fa/upload_button.json": [
    "241073",
    [
      359527
    ]
  ],
  "./nb-x-k12/assignments_2_student_header_date_title.json": [
    "694195",
    [
      996673
    ]
  ],
  "./en-GB-x-lbs/authentication_providers.json": [
    "693037",
    [
      618059
    ]
  ],
  "./ru/course_paces_modal.json": [
    "533905",
    [
      346231
    ]
  ],
  "./uk/terms_of_use.json": [
    "629055",
    [
      922893
    ]
  ],
  "./fa/calendar_appointment_group_edit.json": [
    "20034",
    [
      624450
    ]
  ],
  "./it/assignments_2_peer_review.json": [
    "269534",
    [
      31090
    ]
  ],
  "./vi/k5_course.json": [
    "284147",
    [
      497985
    ]
  ],
  "./fi/quizzes_regrade_modal.json": [
    "642075",
    [
      927529
    ]
  ],
  "./is/submissions_show_preview.json": [
    "860142",
    [
      179894
    ]
  ],
  "./fr-CA/student_study_drawer.json": [
    "186434",
    [
      498134
    ]
  ],
  "./nb-x-k12/gradebookActionMenu.json": [
    "66547",
    [
      723761
    ]
  ],
  "./nb-x-k12/blueprint_coursesExpandableLockOptions.json": [
    "479657",
    [
      225439
    ]
  ],
  "./th/discussion_topics_edit.json": [
    "58448",
    [
      13620
    ]
  ],
  "./fa/question_bank.json": [
    "685912",
    [
      610192
    ]
  ],
  "./en-GB-x-ukhe/course_paces_header.json": [
    "805470",
    [
      770582
    ]
  ],
  "./th/account_settings_jsx_bundle.json": [
    "152025",
    [
      546930
    ]
  ],
  "./fi/assignments_2_MoreOptions.json": [
    "456762",
    [
      614122
    ]
  ],
  "./nb/ai_experiences_show.json": [
    "363914",
    [
      387102
    ]
  ],
  "./id/peer_review_configuration_tray.json": [
    "14848",
    [
      60772
    ]
  ],
  "./ko/grade_details.json": [
    "468364",
    [
      291514
    ]
  ],
  "./el/LogoutButton.json": [
    "665663",
    [
      310321
    ]
  ],
  "./ar/lti_registrations.json": [
    "393667",
    [
      829733
    ]
  ],
  "./cy/lti_registrations.json": [
    "499688",
    [
      142616
    ]
  ],
  "./is/account_notification_settings.json": [
    "14188",
    [
      7189
    ]
  ],
  "./ko/blueprint_settingsSyncHistory.json": [
    "200666",
    [
      368882
    ]
  ],
  "./ms/enhanced_individual_gradebook_submit_score.json": [
    "925101",
    [
      525379
    ]
  ],
  "./nl/horizon_toggle.json": [
    "635408",
    [
      813844
    ]
  ],
  "./ja/blueprint_course_child.json": [
    "315181",
    [
      388
    ]
  ],
  "./nn/ignite_agent.json": [
    "330194",
    [
      987030
    ]
  ],
  "./fa/assignment_index_menu.json": [
    "765387",
    [
      154281
    ]
  ],
  "./ru/canvas_file_upload.json": [
    "182240",
    [
      697944
    ]
  ],
  "./vi/sis_import.json": [
    "733182",
    [
      203478
    ]
  ],
  "./es-ES/calendar_appointment_group_edit.json": [
    "835306",
    [
      715818
    ]
  ],
  "./nb/sharedSetDefaultGradeDialog.json": [
    "475769",
    [
      609347
    ]
  ],
  "./sv/blueprint_settingsCourseFilter.json": [
    "532267",
    [
      757117
    ]
  ],
  "./ar/sharedCurveGradesDialog.json": [
    "741665",
    [
      657187
    ]
  ],
  "./it/discussion_posts.json": [
    "443049",
    [
      25683
    ]
  ],
  "./ko/progress_pill.json": [
    "578383",
    [
      305533
    ]
  ],
  "./pt/assignments_2_shared_Steps.json": [
    "445771",
    [
      279061
    ]
  ],
  "./hy/content_migrations.json": [
    "220832",
    [
      617080
    ]
  ],
  "./nn/ProfileTray.json": [
    "420583",
    [
      755401
    ]
  ],
  "./sl/moderate_quiz.json": [
    "582142",
    [
      128410
    ]
  ],
  "./ms/AssignmentGroupListItemView.json": [
    "151092",
    [
      736684
    ]
  ],
  "./is/quizzes_regrade_modal.json": [
    "907254",
    [
      996862
    ]
  ],
  "./id/progress_pill.json": [
    "907024",
    [
      821292
    ]
  ],
  "./he/OutcomeDescriptionModal.json": [
    "808898",
    [
      695482
    ]
  ],
  "./nb-x-k12/k5_dashboard_card.json": [
    "255278",
    [
      345814
    ]
  ],
  "./nb/speed_grader_helpers.json": [
    "125439",
    [
      595713
    ]
  ],
  "./sv/custom_emoji_deny_list.json": [
    "489883",
    [
      570581
    ]
  ],
  "./uk/blueprint_course_sidebar.json": [
    "479320",
    [
      91544
    ]
  ],
  "./uk/course_paces_empty_state.json": [
    "795040",
    [
      476848
    ]
  ],
  "./ru/account_calendars.json": [
    "346360",
    [
      131120
    ]
  ],
  "./pt-BR/course_logging_details.json": [
    "898899",
    [
      158454
    ]
  ],
  "./sv/DueDateOverrideView.json": [
    "779480",
    [
      419468
    ]
  ],
  "./hu/SpeedGraderPostGradesMenu.json": [
    "581512",
    [
      472280
    ]
  ],
  "./nb-x-k12/blueprint_settingsUnsyncedChanges.json": [
    "295741",
    [
      422603
    ]
  ],
  "./nb/choose_mastery_path.json": [
    "433021",
    [
      150847
    ]
  ],
  "./it/react_developer_keys.json": [
    "556058",
    [
      832694
    ]
  ],
  "./en-AU/youtube_migration.json": [
    "831394",
    [
      53355
    ]
  ],
  "./tr/content_share_preview_overlay.json": [
    "783381",
    [
      249183
    ]
  ],
  "./fr-CA/course_paces_assignment_row.json": [
    "688162",
    [
      92662
    ]
  ],
  "./zh-Hant/media_player_iframe_content.json": [
    "549851",
    [
      493
    ]
  ],
  "./en-GB-x-lbs/outcomes_user_outcome_results.json": [
    "110715",
    [
      171497
    ]
  ],
  "./pl/blueprint_settingsSyncHistory.json": [
    "143244",
    [
      55080
    ]
  ],
  "./ca/assignment_index_deep_linking_handlers.json": [
    "315636",
    [
      422236
    ]
  ],
  "./sv/quiz_log_auditing.json": [
    "75379",
    [
      473333
    ]
  ],
  "./el/AlignmentSummary.json": [
    "31434",
    [
      237806
    ]
  ],
  "./de/conferences_alternatives.json": [
    "287",
    [
      360842
    ]
  ],
  "./id/pairing_code_user_observees.json": [
    "352786",
    [
      82702
    ]
  ],
  "./vi/users.json": [
    "386035",
    [
      154865
    ]
  ],
  "./vi/video_conference.json": [
    "249167",
    [
      936997
    ]
  ],
  "./is/permissions_role_tray.json": [
    "142888",
    [
      395808
    ]
  ],
  "./es-ES/assignments_2_submission_helpers.json": [
    "787207",
    [
      497757
    ]
  ],
  "./ja/calculator.json": [
    "234629",
    [
      67324
    ]
  ],
  "./pl/account_calendar_settings_utils.json": [
    "565517",
    [
      790158
    ]
  ],
  "./el/bulk_edit_students.json": [
    "817283",
    [
      826045
    ]
  ],
  "./ja/blueprint_settingsMigrationOptions.json": [
    "47930",
    [
      266595
    ]
  ],
  "./mi/course_paces_footer.json": [
    "988180",
    [
      868332
    ]
  ],
  "./ms/question_bank.json": [
    "795089",
    [
      140143
    ]
  ],
  "./nb/blueprint_coursesExpandableLockOptions.json": [
    "823443",
    [
      974549
    ]
  ],
  "./pt-BR/nav_tourpoints.json": [
    "856466",
    [
      87763
    ]
  ],
  "./pl/Navigation.json": [
    "257976",
    [
      266983
    ]
  ],
  "./nl/canvas_file_upload.json": [
    "871869",
    [
      885871
    ]
  ],
  "./hy/course_paces_header.json": [
    "891427",
    [
      840273
    ]
  ],
  "./uk/grades_summary.json": [
    "189109",
    [
      915051
    ]
  ],
  "./ru/nav_tourpoints.json": [
    "128354",
    [
      107202
    ]
  ],
  "./ht/MoveOutcomesModal.json": [
    "485363",
    [
      545741
    ]
  ],
  "./ko/quiz_migration_notifications.json": [
    "215077",
    [
      800059
    ]
  ],
  "./hu/internal-settings.json": [
    "285064",
    [
      874200
    ]
  ],
  "./ca/courses_show.json": [
    "131648",
    [
      597712
    ]
  ],
  "./ga/LearningMasteryGradebook.json": [
    "62501",
    [
      928083
    ]
  ],
  "./ht/permissions_v2_add_tray.json": [
    "760728",
    [
      293348
    ]
  ],
  "./zh-Hans/course_stats.json": [
    "872470",
    [
      474590
    ]
  ],
  "./en-GB-x-lbs/permission_button.json": [
    "149260",
    [
      290300
    ]
  ],
  "./fr-CA/content_share_preview_overlay.json": [
    "836910",
    [
      565346
    ]
  ],
  "./fa/gradebookActionMenu.json": [
    "536348",
    [
      611180
    ]
  ],
  "./en-GB/editGroup.json": [
    "656084",
    [
      698549
    ]
  ],
  "./nb/course_restore.json": [
    "737142",
    [
      489250
    ]
  ],
  "./da/pseudonyms_mobile_login.json": [
    "645197",
    [
      77747
    ]
  ],
  "./ca/outcome_reporting.json": [
    "86923",
    [
      47489
    ]
  ],
  "./ga/ignite_agent.json": [
    "169426",
    [
      140498
    ]
  ],
  "./nb/copy_course.json": [
    "692913",
    [
      37867
    ]
  ],
  "./sl/blueprint_settingsSyncChange.json": [
    "776997",
    [
      796231
    ]
  ],
  "./ja/account_calendars_modal.json": [
    "376286",
    [
      110719
    ]
  ],
  "./ga/assignments_2_student_points_display.json": [
    "554336",
    [
      445768
    ]
  ],
  "./en-CA/assignments_2_student_header_date_title.json": [
    "409309",
    [
      63275
    ]
  ],
  "./tr/youtube_migration.json": [
    "515658",
    [
      45646
    ]
  ],
  "./en-GB/discussion_topics.json": [
    "625466",
    [
      556831
    ]
  ],
  "./pt-BR/assignments_2_login_action_prompt.json": [
    "305740",
    [
      870753
    ]
  ],
  "./sl/grade_details.json": [
    "122071",
    [
      609409
    ]
  ],
  "./zh-Hans/section.json": [
    "348566",
    [
      994142
    ]
  ],
  "./en-AU/calendar_custom_recurring_event_repeat_picker.json": [
    "62730",
    [
      606419
    ]
  ],
  "./fr-CA/ignite_agent.json": [
    "326081",
    [
      59331
    ]
  ],
  "./en-CA/conferences.json": [
    "362537",
    [
      71183
    ]
  ],
  "./is/gradingGradeSummary.json": [
    "160691",
    [
      52033
    ]
  ],
  "./ms/announcements_on_home_page.json": [
    "535746",
    [
      964698
    ]
  ],
  "./sv-x-k12/bulk_edit_students_table.json": [
    "221654",
    [
      583486
    ]
  ],
  "./id/a2_AccessibleTipContent.json": [
    "272603",
    [
      936373
    ]
  ],
  "./ru/OutcomeDescriptionModal.json": [
    "830040",
    [
      497856
    ]
  ],
  "./uk/assignment_index.json": [
    "672892",
    [
      983604
    ]
  ],
  "./hi/LogoutButton.json": [
    "490465",
    [
      280727
    ]
  ],
  "./ja/custom_help_link.json": [
    "250753",
    [
      811328
    ]
  ],
  "./da-x-k12/sections_tooltip.json": [
    "45933",
    [
      934775
    ]
  ],
  "./cy/react_developer_keys.json": [
    "111929",
    [
      561831
    ]
  ],
  "./nb/course_paces_change_tracking.json": [
    "700023",
    [
      130729
    ]
  ],
  "./cy/custom_help_link.json": [
    "724050",
    [
      432906
    ]
  ],
  "./es-ES/comm_messages.json": [
    "951498",
    [
      985594
    ]
  ],
  "./tr/course_default_due_time.json": [
    "878954",
    [
      83478
    ]
  ],
  "./ja/new_user_tutorial.json": [
    "272428",
    [
      141097
    ]
  ],
  "./fi/account_calendars_results_area.json": [
    "779963",
    [
      833081
    ]
  ],
  "./en-AU-x-unimelb/outcome_management.json": [
    "993904",
    [
      163820
    ]
  ],
  "./fi/content_exports.json": [
    "976902",
    [
      798798
    ]
  ],
  "./zh-Hant/discussion_create.json": [
    "565693",
    [
      437623
    ]
  ],
  "./da/appt_calendar_event_dialog.json": [
    "861511",
    [
      663013
    ]
  ],
  "./ko/user_profile.json": [
    "30765",
    [
      946963
    ]
  ],
  "./ru/sections_tooltip.json": [
    "560817",
    [
      750039
    ]
  ],
  "./en-GB/course_template_details.json": [
    "765962",
    [
      207199
    ]
  ],
  "./th/assignments_2_attempt_tab.json": [
    "682255",
    [
      484985
    ]
  ],
  "./mi/edit_section_view.json": [
    "985020",
    [
      938340
    ]
  ],
  "./tr/assignments_2_MoreOptions_CanvasFiles.json": [
    "445525",
    [
      839287
    ]
  ],
  "./ru/default_account_quotas.json": [
    "573954",
    [
      51938
    ]
  ],
  "./sl/account_calendar_settings_account_tree.json": [
    "290292",
    [
      141536
    ]
  ],
  "./cy/modules_home_page.json": [
    "637595",
    [
      95521
    ]
  ],
  "./it/course_paces_blackout_dates_modal.json": [
    "999549",
    [
      761063
    ]
  ],
  "./el/upload_button.json": [
    "208693",
    [
      151375
    ]
  ],
  "./hy/SpeedGraderSettingsMenu.json": [
    "493335",
    [
      969437
    ]
  ],
  "./ca/conferences_alternatives.json": [
    "960658",
    [
      388666
    ]
  ],
  "./ht/OutcomeDescriptionModal.json": [
    "103378",
    [
      413991
    ]
  ],
  "./ja/overview_page.json": [
    "166296",
    [
      446781
    ]
  ],
  "./pl/course_restore.json": [
    "798182",
    [
      197394
    ]
  ],
  "./mi/roster_publicjs.json": [
    "550586",
    [
      871618
    ]
  ],
  "./pt/todos_page.json": [
    "842471",
    [
      190457
    ]
  ],
  "./mi/mutationActivity.json": [
    "750158",
    [
      602302
    ]
  ],
  "./ru/course_template_details.json": [
    "243814",
    [
      518894
    ]
  ],
  "./nb/admin_split.json": [
    "568758",
    [
      925754
    ]
  ],
  "./uk/quiz_show.json": [
    "538757",
    [
      803579
    ]
  ],
  "./es-ES/add_edit_pseudonym.json": [
    "727696",
    [
      6024
    ]
  ],
  "./el/modelsQuiz.json": [
    "813630",
    [
      904602
    ]
  ],
  "./ga/OutcomeMoveModal.json": [
    "133968",
    [
      381736
    ]
  ],
  "./de/todos_page.json": [
    "11838",
    [
      72583
    ]
  ],
  "./es/blueprint_settingsSyncHistory.json": [
    "155948",
    [
      39321
    ]
  ],
  "./fa/peer_reviews_student.json": [
    "933135",
    [
      536037
    ]
  ],
  "./hu/discussion_insights.json": [
    "295033",
    [
      778247
    ]
  ],
  "./cy/discussion_topics_edit.json": [
    "824712",
    [
      428888
    ]
  ],
  "./nb-x-k12/modules_page_icon_legend.json": [
    "576849",
    [
      815735
    ]
  ],
  "./ga/registration.json": [
    "917503",
    [
      864885
    ]
  ],
  "./hy/quiz_log_auditing.json": [
    "991757",
    [
      622571
    ]
  ],
  "./ms/security_panel.json": [
    "204221",
    [
      164147
    ]
  ],
  "./fr-CA/react_scheduler.json": [
    "136550",
    [
      773066
    ]
  ],
  "./sv/quizzes_openModerateStudentDialog.json": [
    "61033",
    [
      360027
    ]
  ],
  "./zh-Hans/sections_tooltip.json": [
    "430655",
    [
      870053
    ]
  ],
  "./it/empty_modules.json": [
    "87372",
    [
      782080
    ]
  ],
  "./en-AU-x-unimelb/remove_pace_warning_modal.json": [
    "669961",
    [
      680203
    ]
  ],
  "./fr-CA/user_grades.json": [
    "805391",
    [
      261937
    ]
  ],
  "./nn/course_link_validator.json": [
    "952737",
    [
      15931
    ]
  ],
  "./sv-x-k12/account_calendar_settings_footer.json": [
    "215927",
    [
      196605
    ]
  ],
  "./nb-x-k12/account_notification_settings.json": [
    "461933",
    [
      379003
    ]
  ],
  "./nb/a2LatePolicyStatusDisplay.json": [
    "726733",
    [
      528999
    ]
  ],
  "./en-GB-x-lbs/account_course_user_search.json": [
    "439118",
    [
      851078
    ]
  ],
  "./fr/todo.json": [
    "33246",
    [
      168011
    ]
  ],
  "./de/peer_review_configuration_tray.json": [
    "721902",
    [
      486135
    ]
  ],
  "./hi/group_submission_reminder.json": [
    "690306",
    [
      393826
    ]
  ],
  "./sl/content_migrations_redesign.json": [
    "621274",
    [
      111102
    ]
  ],
  "./id/MoveOutcomesModal.json": [
    "615742",
    [
      791866
    ]
  ],
  "./nn/rootFoldersFinder.json": [
    "286279",
    [
      179505
    ]
  ],
  "./ar/a2_AccessibleTipContent.json": [
    "541025",
    [
      896971
    ]
  ],
  "./fi/discussionTopicKeyboradShortcutModal.json": [
    "7734",
    [
      315086
    ]
  ],
  "./nl/assignments.no_assignments_search.json": [
    "692435",
    [
      625140
    ]
  ],
  "./pt/FindOutcomesModal.json": [
    "526997",
    [
      168903
    ]
  ],
  "./sv/course_paces_blackout_date_row.json": [
    "58985",
    [
      993419
    ]
  ],
  "./da-x-k12/context_modules_v2.json": [
    "137275",
    [
      249189
    ]
  ],
  "./ht/important_dates.json": [
    "707930",
    [
      774878
    ]
  ],
  "./uk/course_paces_search.json": [
    "93601",
    [
      752495
    ]
  ],
  "./sv-x-k12/assignments_2_student_header_date_title.json": [
    "261210",
    [
      11818
    ]
  ],
  "./fa/LearningMasteryGradebook.json": [
    "5422",
    [
      591654
    ]
  ],
  "./vi/license_help.json": [
    "345250",
    [
      211058
    ]
  ],
  "./en-CA/course_paces_projected_dates.json": [
    "862837",
    [
      973075
    ]
  ],
  "./ar/roster_publicjs.json": [
    "938051",
    [
      4157
    ]
  ],
  "./vi.eager.json": [
    "683190",
    [
      649649
    ]
  ],
  "./vi/peer_review_allocation_rules_tray.json": [
    "157246",
    [
      483014
    ]
  ],
  "./zh-Hans/outcomes_user_outcome_results.json": [
    "875090",
    [
      657122
    ]
  ],
  "./nb-x-k12/important_dates.json": [
    "892264",
    [
      779792
    ]
  ],
  "./pt/a2_AccessibleTipContent.json": [
    "545138",
    [
      686582
    ]
  ],
  "./zh-Hans/ai_experiences_ai_conversations.json": [
    "204421",
    [
      779795
    ]
  ],
  "./pt/accessibility_course_statistics.json": [
    "342908",
    [
      335728
    ]
  ],
  "./hu/gradingGradeSummary.json": [
    "284896",
    [
      89280
    ]
  ],
  "./da/entity_search_form.json": [
    "103312",
    [
      320768
    ]
  ],
  "./fi/discovery_page.json": [
    "406209",
    [
      69623
    ]
  ],
  "./cy/knowledge_check_not_ready.json": [
    "342115",
    [
      694073
    ]
  ],
  "./en-GB-x-ukhe/quiz_statistics.json": [
    "792513",
    [
      501271
    ]
  ],
  "./nl/course_link_validator.json": [
    "339791",
    [
      875657
    ]
  ],
  "./vi/user_date_range_search.json": [
    "711398",
    [
      686190
    ]
  ],
  "./ar/announcements_v2.json": [
    "452922",
    [
      228798
    ]
  ],
  "./es/direct_share_course_import_panel.json": [
    "8478",
    [
      969743
    ]
  ],
  "./th/course_paces_change_tracking.json": [
    "725343",
    [
      415473
    ]
  ],
  "./ht/AddGroup.json": [
    "641464",
    [
      616636
    ]
  ],
  "./fa/new_user_tutorial.json": [
    "331352",
    [
      781968
    ]
  ],
  "./pt/discussionTopicKeyboradShortcutModal.json": [
    "954785",
    [
      562051
    ]
  ],
  "./hi/speed_grader_helpers.json": [
    "589918",
    [
      182998
    ]
  ],
  "./ar/dashboard_grades_page.json": [
    "666420",
    [
      562960
    ]
  ],
  "./it/choose_mastery_path.json": [
    "889948",
    [
      124856
    ]
  ],
  "./nb-x-k12/rootFoldersFinder.json": [
    "133877",
    [
      252035
    ]
  ],
  "./he/account_calendars_modal.json": [
    "992732",
    [
      318244
    ]
  ],
  "./it/file_not_found.json": [
    "74110",
    [
      195818
    ]
  ],
  "./de/assignments_2_attempt_tab.json": [
    "814052",
    [
      773801
    ]
  ],
  "./el/keyboardShortcutModal.json": [
    "257979",
    [
      143357
    ]
  ],
  "./en-CA/user_lists.json": [
    "607531",
    [
      66041
    ]
  ],
  "./uk/conferences.json": [
    "66441",
    [
      962759
    ]
  ],
  "./it/CoursesTray.json": [
    "188261",
    [
      926583
    ]
  ],
  "./nb/user_date_range_search.json": [
    "12313",
    [
      941107
    ]
  ],
  "./hi/a2LatePolicyStatusDisplay.json": [
    "791322",
    [
      512954
    ]
  ],
  "./zh-Hans/lti_registrations.json": [
    "863483",
    [
      902057
    ]
  ],
  "./da/job_stats.json": [
    "809414",
    [
      31446
    ]
  ],
  "./zh-Hant/k5_course.json": [
    "484040",
    [
      634516
    ]
  ],
  "./sv-x-k12/media_immersive_view.json": [
    "864215",
    [
      407645
    ]
  ],
  "./ca/question_bank.json": [
    "399249",
    [
      100767
    ]
  ],
  "./uk/bounced_emails.json": [
    "908230",
    [
      764598
    ]
  ],
  "./ja/gradebook_default_gradebook_components_content_filters_module_filter.json": [
    "956633",
    [
      732312
    ]
  ],
  "./th/student_study_drawer.json": [
    "853889",
    [
      850747
    ]
  ],
  "./es-ES/peer_review_allocation_rules_tray.json": [
    "305214",
    [
      752598
    ]
  ],
  "./mi/default_account_quotas.json": [
    "453815",
    [
      933285
    ]
  ],
  "./tr/calendar_custom_recurring_event_natural_language.json": [
    "556796",
    [
      158128
    ]
  ],
  "./sv-x-k12/ignite_agent.json": [
    "953367",
    [
      579069
    ]
  ],
  "./hi/discussion_create.json": [
    "638128",
    [
      803960
    ]
  ],
  "./de/assignments_2_student_points_display.json": [
    "21293",
    [
      187788
    ]
  ],
  "./id/wiki_page_index.json": [
    "581706",
    [
      419150
    ]
  ],
  "./ca/assignments_2_file_upload.json": [
    "745864",
    [
      416904
    ]
  ],
  "./vi/assignments_2_student_points_display.json": [
    "309707",
    [
      900089
    ]
  ],
  "./ko/IndividualStudentMasteryOutcome.json": [
    "987909",
    [
      253531
    ]
  ],
  "./ru/authentication_providers.json": [
    "674948",
    [
      51220
    ]
  ],
  "./mi/collaborations.json": [
    "723570",
    [
      185770
    ]
  ],
  "./zh-Hans/progressbar_view.json": [
    "202639",
    [
      535941
    ]
  ],
  "./zh-Hant/assignments_peer_reviews.json": [
    "179441",
    [
      930155
    ]
  ],
  "./de/blueprint_settingsSyncHistory.json": [
    "974115",
    [
      91654
    ]
  ],
  "./el/external_content_cancel.json": [
    "158055",
    [
      39289
    ]
  ],
  "./fr-CA/a2_AccessibleTipContent.json": [
    "597759",
    [
      997113
    ]
  ],
  "./ko/account_calendars.json": [
    "517687",
    [
      506261
    ]
  ],
  "./fi/grades_empty_page.json": [
    "758519",
    [
      227309
    ]
  ],
  "./nn/peer_reviews_student.json": [
    "486848",
    [
      143492
    ]
  ],
  "./ar/self_enrollment.json": [
    "560038",
    [
      582578
    ]
  ],
  "./ca/video_conference.json": [
    "950868",
    [
      633596
    ]
  ],
  "./de/upload_button.json": [
    "587335",
    [
      83490
    ]
  ],
  "./hy/discussion_topics.json": [
    "150896",
    [
      257336
    ]
  ],
  "./pl/link_validator.json": [
    "564595",
    [
      717221
    ]
  ],
  "./sv-x-k12/gradingPeriodTemplate.json": [
    "429162",
    [
      552554
    ]
  ],
  "./pt/calendar_custom_recurring_event_repeat_picker.json": [
    "296412",
    [
      835592
    ]
  ],
  "./ht/courses.json": [
    "820668",
    [
      319584
    ]
  ],
  "./cy/assignmentsToggleShowByView.json": [
    "385389",
    [
      906467
    ]
  ],
  "./ar/internal-settings.json": [
    "427980",
    [
      312896
    ]
  ],
  "./en-GB-x-ukhe/SpeedGraderPostGradesMenu.json": [
    "188093",
    [
      67147
    ]
  ],
  "./nb-x-k12/account_calendars_modal.json": [
    "203425",
    [
      716567
    ]
  ],
  "./it/account_calendar_settings.json": [
    "460581",
    [
      395647
    ]
  ],
  "./hy/k5_dashboard.json": [
    "944752",
    [
      790136
    ]
  ],
  "./pt-BR/bulk_edit_students.json": [
    "535543",
    [
      311890
    ]
  ],
  "./fr/MoveOutcomesModal.json": [
    "547931",
    [
      479402
    ]
  ],
  "./ht/course_paces_empty_state.json": [
    "365496",
    [
      522332
    ]
  ],
  "./he/reset_pace_warning_modal.json": [
    "823133",
    [
      676083
    ]
  ],
  "./is/MoveOutcomesModal.json": [
    "79175",
    [
      354365
    ]
  ],
  "./en-GB-x-ukhe/accessibility_scan.json": [
    "893952",
    [
      595688
    ]
  ],
  "./ar/OutcomeMoveModal.json": [
    "961641",
    [
      679123
    ]
  ],
  "./de/roster_section_input.json": [
    "47507",
    [
      687942
    ]
  ],
  "./en-GB-x-ukhe/FindOutcomesModal.json": [
    "392527",
    [
      86293
    ]
  ],
  "./fi/assignment_index_deep_linking_handlers.json": [
    "306615",
    [
      179613
    ]
  ],
  "./nn/a2LatePolicyToolTipContent.json": [
    "421419",
    [
      272453
    ]
  ],
  "./de/discussion_posts.json": [
    "539703",
    [
      987666
    ]
  ],
  "./da-x-k12/k5_course.json": [
    "694623",
    [
      227073
    ]
  ],
  "./fa/assignments_peer_reviews.json": [
    "813388",
    [
      475036
    ]
  ],
  "./nb/self_enrollment.json": [
    "864037",
    [
      909751
    ]
  ],
  "./pt/important_dates.json": [
    "981426",
    [
      371974
    ]
  ],
  "./sv-x-k12/quizzes_openModerateStudentDialog.json": [
    "662407",
    [
      760813
    ]
  ],
  "./en-AU-x-unimelb/add_edit_pseudonym.json": [
    "340999",
    [
      956481
    ]
  ],
  "./sv/assignments_2_media_attempt.json": [
    "291853",
    [
      381903
    ]
  ],
  "./fr-CA/LogoutButton.json": [
    "518143",
    [
      938545
    ]
  ],
  "./da/course_paces_no_results.json": [
    "798980",
    [
      632908
    ]
  ],
  "./fr-CA/MoveOutcomesModal.json": [
    "244970",
    [
      665622
    ]
  ],
  "./ms/appointment_groups.json": [
    "456552",
    [
      373848
    ]
  ],
  "./zh-Hant/accessibility_scan.json": [
    "282988",
    [
      346632
    ]
  ],
  "./nl/jobs.json": [
    "188792",
    [
      336900
    ]
  ],
  "./hu/modules_page_icon_legend.json": [
    "322222",
    [
      648702
    ]
  ],
  "./sv/accessibility_scan.json": [
    "542505",
    [
      303003
    ]
  ],
  "./es/widget_dashboard.json": [
    "699809",
    [
      604592
    ]
  ],
  "./en-GB-x-lbs/AssignmentListItemView.json": [
    "352015",
    [
      162709
    ]
  ],
  "./nb/calculator.json": [
    "657094",
    [
      109498
    ]
  ],
  "./ca/CommentLibrary.json": [
    "667782",
    [
      487542
    ]
  ],
  "./nb/CoursesTray.json": [
    "688916",
    [
      155776
    ]
  ],
  "./ht/notebook.json": [
    "835123",
    [
      63941
    ]
  ],
  "./it/self_enrollment.json": [
    "779552",
    [
      875540
    ]
  ],
  "./nn/blueprint_settingsSyncHistory.json": [
    "258968",
    [
      776196
    ]
  ],
  "./en-CA/react_files.json": [
    "784701",
    [
      850475
    ]
  ],
  "./fi/sections_tooltip.json": [
    "240689",
    [
      200807
    ]
  ],
  "./cy/webcam_modal.json": [
    "364977",
    [
      791759
    ]
  ],
  "./es/new_user_tutorial.json": [
    "808017",
    [
      724832
    ]
  ],
  "./nb-x-k12/conferences.json": [
    "448483",
    [
      979857
    ]
  ],
  "./ht/student_annotation_preview.json": [
    "205048",
    [
      36188
    ]
  ],
  "./de/calendar_custom_recurring_event_natural_language.json": [
    "423819",
    [
      93694
    ]
  ],
  "./en-GB/dashboard.json": [
    "506023",
    [
      449862
    ]
  ],
  "./ko/assignment_show.json": [
    "666015",
    [
      458765
    ]
  ],
  "./pt-BR/reset_pace_warning_modal.json": [
    "284659",
    [
      721686
    ]
  ],
  "./vi/course_paces_assignment_row.json": [
    "786286",
    [
      98774
    ]
  ],
  "./ko/assignments_2_student_header.json": [
    "346657",
    [
      712143
    ]
  ],
  "./ga/quizzes_quiz_submission.json": [
    "460486",
    [
      116782
    ]
  ],
  "./zh-Hans/quiz_log_auditing.json": [
    "626002",
    [
      86515
    ]
  ],
  "./pt/assignments_2_initial_query.json": [
    "686165",
    [
      825711
    ]
  ],
  "./en-AU-x-unimelb/quiz_statistics.json": [
    "959627",
    [
      595829
    ]
  ],
  "./es/quiz_log_auditing.json": [
    "727758",
    [
      146975
    ]
  ],
  "./sv-x-k12/assignments_2_attempt_tab.json": [
    "734156",
    [
      74796
    ]
  ],
  "./zh-Hans/todos_page.json": [
    "274974",
    [
      354534
    ]
  ],
  "./th/account_calendar_settings_footer.json": [
    "100310",
    [
      332362
    ]
  ],
  "./uk/account_calendars_results_area.json": [
    "179372",
    [
      495268
    ]
  ],
  "./id/quiz_log_auditing.json": [
    "528687",
    [
      951377
    ]
  ],
  "./ca/calendar_appointment_group_edit.json": [
    "537371",
    [
      133841
    ]
  ],
  "./tr/submit_online_url_assignment.json": [
    "613564",
    [
      157544
    ]
  ],
  "./fr-CA/user_restore.json": [
    "505331",
    [
      548205
    ]
  ],
  "./de/CommentLibrary.json": [
    "633819",
    [
      194366
    ]
  ],
  "./en-AU-x-unimelb/course_paces_search.json": [
    "397761",
    [
      727123
    ]
  ],
  "./es/confirmMasteryModal.json": [
    "555212",
    [
      624697
    ]
  ],
  "./ga/GroupsTray.json": [
    "151038",
    [
      32774
    ]
  ],
  "./zh-Hans/SpeedGraderCheckpoints.json": [
    "931364",
    [
      778868
    ]
  ],
  "./uk/AddGroup.json": [
    "257584",
    [
      479232
    ]
  ],
  "./da/blueprint_coursesExpandableLockOptions.json": [
    "977126",
    [
      773174
    ]
  ],
  "./en-GB-x-ukhe/k5_dashboard.json": [
    "222407",
    [
      116653
    ]
  ],
  "./hi/pseudonyms_mobile_login.json": [
    "671257",
    [
      474271
    ]
  ],
  "./fr/module_student_view_peer_reviews.json": [
    "881961",
    [
      617180
    ]
  ],
  "./uk/react_files.json": [
    "101917",
    [
      239843
    ]
  ],
  "./ga/blueprint_settingsMigrationOptions.json": [
    "792781",
    [
      785323
    ]
  ],
  "./es/course_paces_no_results.json": [
    "319667",
    [
      193918
    ]
  ],
  "./fi/eportfolio.json": [
    "945280",
    [
      370024
    ]
  ],
  "./ja/assignment_grade_summary.json": [
    "606587",
    [
      33910
    ]
  ],
  "./ca/ai_experiences_ai_conversations.json": [
    "885054",
    [
      84126
    ]
  ],
  "./ru/assignment_index_deep_linking_handlers.json": [
    "415735",
    [
      74573
    ]
  ],
  "./th/accessibility_checker.json": [
    "550558",
    [
      780130
    ]
  ],
  "./hi/MobileGlobalMenu.json": [
    "344657",
    [
      807015
    ]
  ],
  "./zh-Hant/quizzes_regrade_modal.json": [
    "492672",
    [
      110020
    ]
  ],
  "./it/roster_section_selector.json": [
    "379450",
    [
      140366
    ]
  ],
  "./ar/roster_section_input.json": [
    "751355",
    [
      463917
    ]
  ],
  "./nn/account_calendar_settings_account_calendar_item.json": [
    "556508",
    [
      763297
    ]
  ],
  "./pt-BR/quizzes_regrade_modal.json": [
    "227147",
    [
      445230
    ]
  ],
  "./en-GB-x-lbs/a2LatePolicyStatusDisplay.json": [
    "64763",
    [
      721193
    ]
  ],
  "./fr/account_course_user_search.json": [
    "48292",
    [
      33621
    ]
  ],
  "./sv/blueprint_settingsMigrationSync.json": [
    "774379",
    [
      852077
    ]
  ],
  "./fr/jobs.json": [
    "891878",
    [
      2475
    ]
  ],
  "./it/unpublished_changes_button_props.json": [
    "725258",
    [
      452950
    ]
  ],
  "./nn/HelpTray.json": [
    "626509",
    [
      202815
    ]
  ],
  "./zh-Hans/notebook_index.json": [
    "851521",
    [
      98679
    ]
  ],
  "./tr/assignments.no_assignments_search.json": [
    "4983",
    [
      812808
    ]
  ],
  "./pt/gradinggradingPeriodCollection.json": [
    "977123",
    [
      41941
    ]
  ],
  "./mi/grade_change_logging_content.json": [
    "988755",
    [
      367488
    ]
  ],
  "./sv-x-k12/manage_avatars.json": [
    "299753",
    [
      237551
    ]
  ],
  "./tr/quiz_migration_notifications.json": [
    "440121",
    [
      882059
    ]
  ],
  "./vi/assignments_2_submission_helpers.json": [
    "85383",
    [
      135309
    ]
  ],
  "./th/gradebook_default_gradebook_components_content_filters_module_filter.json": [
    "461006",
    [
      292842
    ]
  ],
  "./es/media_immersive_view.json": [
    "45502",
    [
      452207
    ]
  ],
  "./ga/OutcomeDescriptionModal.json": [
    "850377",
    [
      556927
    ]
  ],
  "./sl/assignments_2_student_content_rubric_self_assessment.json": [
    "902506",
    [
      239294
    ]
  ],
  "./pl/edit_section_end_date.json": [
    "331893",
    [
      66319
    ]
  ],
  "./zh-Hans/syllabus_revisions.json": [
    "430449",
    [
      959543
    ]
  ],
  "./tr/lti_registration.wizard.json": [
    "990534",
    [
      837189
    ]
  ],
  "./pl/horizon_toggle.json": [
    "66706",
    [
      721846
    ]
  ],
  "./is/assignments_2_attempt_tab.json": [
    "503491",
    [
      300321
    ]
  ],
  "./de/AccountsTray.json": [
    "214327",
    [
      808482
    ]
  ],
  "./hu/assignments_2_shared_Steps.json": [
    "786890",
    [
      482098
    ]
  ],
  "./it/self_unenrollment_modal.json": [
    "820433",
    [
      981227
    ]
  ],
  "./es/dashboard.json": [
    "469974",
    [
      736743
    ]
  ],
  "./hu/user_name.json": [
    "2794",
    [
      492722
    ]
  ],
  "./en-GB-x-ukhe/restore_content_pane.json": [
    "702907",
    [
      79625
    ]
  ],
  "./tr/available_pronouns_list.json": [
    "681093",
    [
      183911
    ]
  ],
  "./de/internal-settings.json": [
    "105380",
    [
      934233
    ]
  ],
  "./ht/account_calendar_settings_account_calendar_item.json": [
    "354363",
    [
      924445
    ]
  ],
  "./tr/horizon_toggle.json": [
    "561324",
    [
      880
    ]
  ],
  "./vi/student_study_drawer.json": [
    "672398",
    [
      496310
    ]
  ],
  "./ga/account_calendar_settings_account_list.json": [
    "770533",
    [
      801091
    ]
  ],
  "./hy/discussion_create.json": [
    "557312",
    [
      567560
    ]
  ],
  "./da-x-k12/quizzes_openModerateStudentDialog.json": [
    "730017",
    [
      563947
    ]
  ],
  "./nn/users.json": [
    "311338",
    [
      78654
    ]
  ],
  "./hi/error_form.json": [
    "426954",
    [
      614138
    ]
  ],
  "./sv-x-k12/copy_course.json": [
    "892890",
    [
      65626
    ]
  ],
  "./zh-Hant/content_migrations_redesign.json": [
    "627559",
    [
      53609
    ]
  ],
  "./ru/discussion_topics.json": [
    "948710",
    [
      496366
    ]
  ],
  "./uk/grade_summaryGroupView.json": [
    "280336",
    [
      355680
    ]
  ],
  "./es/webzip_export.json": [
    "23734",
    [
      573191
    ]
  ],
  "./ht/blueprint_settingsAssociationsTable.json": [
    "530549",
    [
      766735
    ]
  ],
  "./pt-BR/account_settings.json": [
    "875860",
    [
      817689
    ]
  ],
  "./ru/courses.show.json": [
    "642868",
    [
      412135
    ]
  ],
  "./fa/blueprint_course_sidebar.json": [
    "812743",
    [
      29405
    ]
  ],
  "./ht/rubrics-export.json": [
    "987065",
    [
      363899
    ]
  ],
  "./cy/outcome_management.json": [
    "125384",
    [
      712344
    ]
  ],
  "./ht/user_date_range_search.json": [
    "458873",
    [
      694304
    ]
  ],
  "./ht/assignment_index_menu.json": [
    "470586",
    [
      300766
    ]
  ],
  "./ms/ImportConfirmBox.json": [
    "128698",
    [
      653154
    ]
  ],
  "./zh-Hant/blueprint_settingsSyncChange.json": [
    "513306",
    [
      780790
    ]
  ],
  "./th/calendar_edit.json": [
    "981249",
    [
      660083
    ]
  ],
  "./it/notebook.json": [
    "104712",
    [
      524812
    ]
  ],
  "./da/account_settings_jsx_bundle.json": [
    "171801",
    [
      648311
    ]
  ],
  "./ko/assignment_index_deep_linking_handlers.json": [
    "920186",
    [
      58706
    ]
  ],
  "./sv-x-k12/outcome_alignment_v2.json": [
    "268796",
    [
      291308
    ]
  ],
  "./vi/calculator_command.json": [
    "333151",
    [
      859893
    ]
  ],
  "./ko/course_paces_no_results.json": [
    "111233",
    [
      234671
    ]
  ],
  "./sv-x-k12/course_paces_blueprint_lock.json": [
    "66125",
    [
      288859
    ]
  ],
  "./ja/lti_registration.wizard.json": [
    "525374",
    [
      885008
    ]
  ],
  "./ko/assignmentsToggleShowByView.json": [
    "12207",
    [
      74141
    ]
  ],
  "./pt-BR/quizzes.take_quiz.json": [
    "303085",
    [
      440748
    ]
  ],
  "./tr/editAssignmentGroupWeights.json": [
    "759341",
    [
      204655
    ]
  ],
  "./ar/course_paces_flaggable_number_input.json": [
    "370124",
    [
      720256
    ]
  ],
  "./nl/course_restore.json": [
    "12500",
    [
      688080
    ]
  ],
  "./zh-Hans/assignment_index_deep_linking_handlers.json": [
    "492321",
    [
      324551
    ]
  ],
  "./pt-BR/courses.show.json": [
    "767076",
    [
      339225
    ]
  ],
  "./ru/quantitative_data_options.json": [
    "872218",
    [
      126250
    ]
  ],
  "./fr/calendar_edit.json": [
    "91361",
    [
      406516
    ]
  ],
  "./hi/course_paces_blackout_dates_modal.json": [
    "40583",
    [
      970813
    ]
  ],
  "./nn/discussion_posts.json": [
    "776470",
    [
      162178
    ]
  ],
  "./en-CA/assignments_bulk_edit.json": [
    "785186",
    [
      314994
    ]
  ],
  "./es-ES/context_modules_v2.json": [
    "542991",
    [
      542965
    ]
  ],
  "./sv/MasteryScale.json": [
    "510864",
    [
      990276
    ]
  ],
  "./tr/permissions_v2.json": [
    "173941",
    [
      906983
    ]
  ],
  "./pt-BR/outcome_alignment_v2.json": [
    "479270",
    [
      470047
    ]
  ],
  "./de/course_paces_flaggable_number_input.json": [
    "879140",
    [
      71961
    ]
  ],
  "./da/calendar_custom_recurring_event_repeat_picker.json": [
    "123503",
    [
      503517
    ]
  ],
  "./mi/files_v2.json": [
    "113468",
    [
      564132
    ]
  ],
  "./nb/module_sequence_footer.json": [
    "154124",
    [
      319520
    ]
  ],
  "./ms/permissions.json": [
    "307542",
    [
      122902
    ]
  ],
  "./ms/question_banks.json": [
    "42814",
    [
      480174
    ]
  ],
  "./en-GB-x-lbs/youtube_migration.json": [
    "729710",
    [
      339462
    ]
  ],
  "./zh-Hans/MobileNavigation.json": [
    "462199",
    [
      631773
    ]
  ],
  "./ms/syllabus_revisions.json": [
    "979336",
    [
      366648
    ]
  ],
  "./en-GB-x-ukhe/dashboard.json": [
    "45252",
    [
      761540
    ]
  ],
  "./es-ES/SpeedGraderSettingsMenu.json": [
    "6265",
    [
      324191
    ]
  ],
  "./sv-x-k12/grade_change_logging_content.json": [
    "776175",
    [
      102453
    ]
  ],
  "./ht/video_conference.json": [
    "31404",
    [
      276640
    ]
  ],
  "./is/jobs.json": [
    "516962",
    [
      813746
    ]
  ],
  "./ja/conferences_alternatives.json": [
    "852601",
    [
      836024
    ]
  ],
  "./fa/account_calendars_modal.json": [
    "675466",
    [
      401962
    ]
  ],
  "./da/assignments_2_initial_query.json": [
    "406846",
    [
      198014
    ]
  ],
  "./it/quizzes_regrade_modal.json": [
    "821883",
    [
      443437
    ]
  ],
  "./ht/direct_share_course_import_panel.json": [
    "483214",
    [
      932002
    ]
  ],
  "./th/assignments_2_external_tool.json": [
    "376004",
    [
      536256
    ]
  ],
  "./de/account_calendar_settings_confirmation_modal.json": [
    "295995",
    [
      37966
    ]
  ],
  "./hy/grade_change_logging_content.json": [
    "414943",
    [
      535173
    ]
  ],
  "./zh-Hans/edit_section_start_date.json": [
    "72237",
    [
      763979
    ]
  ],
  "./ht/empty_course.json": [
    "359889",
    [
      504467
    ]
  ],
  "./pt-BR/ldap_cert_upload.json": [
    "169813",
    [
      808340
    ]
  ],
  "./vi/external_content_cancel.json": [
    "467403",
    [
      643865
    ]
  ],
  "./nn/user_restore.json": [
    "931880",
    [
      844340
    ]
  ],
  "./nb/course_paces_app.json": [
    "262768",
    [
      678188
    ]
  ],
  "./vi/outcome_alignment_v2.json": [
    "67590",
    [
      903454
    ]
  ],
  "./da-x-k12/progressbar_view.json": [
    "436345",
    [
      893587
    ]
  ],
  "./fi/LogoutButton.json": [
    "356163",
    [
      789889
    ]
  ],
  "./fr/discussion_topics.json": [
    "614027",
    [
      711938
    ]
  ],
  "./ga/edit_section_dates.json": [
    "180336",
    [
      686536
    ]
  ],
  "./en-GB-x-lbs/widget_dashboard.json": [
    "572111",
    [
      886085
    ]
  ],
  "./pl/quiz_statistics.json": [
    "419155",
    [
      782741
    ]
  ],
  "./en-AU-x-unimelb/modelsQuiz.json": [
    "449025",
    [
      744547
    ]
  ],
  "./uk/ai_experiences_show.json": [
    "299298",
    [
      979530
    ]
  ],
  "./fi/ai_experiences_edit.json": [
    "795678",
    [
      754182
    ]
  ],
  "./fr-CA/assignments_bulk_edit_use_save_assignment.json": [
    "693923",
    [
      340205
    ]
  ],
  "./ko/sidenav.json": [
    "573940",
    [
      447100
    ]
  ],
  "./it/discussion_row.json": [
    "266130",
    [
      67046
    ]
  ],
  "./hu/syllabus_revisions.json": [
    "763685",
    [
      915115
    ]
  ],
  "./en-GB-x-lbs/users.json": [
    "981912",
    [
      619088
    ]
  ],
  "./fr-CA/add_edit_pseudonym.json": [
    "955564",
    [
      521688
    ]
  ],
  "./da-x-k12/roster_section_selector.json": [
    "899166",
    [
      373946
    ]
  ],
  "./tr/bounced_emails.json": [
    "359276",
    [
      985496
    ]
  ],
  "./vi/quizzes_public.json": [
    "301934",
    [
      549046
    ]
  ],
  "./hi/progress_pill.json": [
    "254766",
    [
      673286
    ]
  ],
  "./es-ES/ImportConfirmBox.json": [
    "292681",
    [
      865487
    ]
  ],
  "./pl/dashboard.json": [
    "134710",
    [
      73250
    ]
  ],
  "./ja/assignments_2_initial_query.json": [
    "679252",
    [
      368209
    ]
  ],
  "./fa/account_calendars_results_area.json": [
    "22099",
    [
      894337
    ]
  ],
  "./uk/course_paces_settings.json": [
    "712636",
    [
      649716
    ]
  ],
  "./en-GB/SpeedGraderSettingsMenu.json": [
    "597949",
    [
      72144
    ]
  ],
  "./ko/CreateEditAssignmentModal.json": [
    "918070",
    [
      32262
    ]
  ],
  "./ar/bulk_edit_students.json": [
    "591201",
    [
      19315
    ]
  ],
  "./nb-x-k12/group_submission_reminder.json": [
    "842571",
    [
      413481
    ]
  ],
  "./it/lti_registration.wizard.json": [
    "867685",
    [
      363392
    ]
  ],
  "./nn/student_annotation_preview.json": [
    "401492",
    [
      342280
    ]
  ],
  "./th/jobs_v2.json": [
    "117947",
    [
      7741
    ]
  ],
  "./tr/quizzes_index.json": [
    "865610",
    [
      35382
    ]
  ],
  "./nl/section.json": [
    "526727",
    [
      808417
    ]
  ],
  "./nl/discussionTopicKeyboradShortcutModal.json": [
    "633935",
    [
      739769
    ]
  ],
  "./uk/course_paces_blackout_dates_table.json": [
    "401717",
    [
      34731
    ]
  ],
  "./he/top_navigation_tools.json": [
    "911177",
    [
      671799
    ]
  ],
  "./ca/grade_summary.json": [
    "230870",
    [
      462086
    ]
  ],
  "./da/quizzes_public.json": [
    "707344",
    [
      378944
    ]
  ],
  "./el/account_calendars_modal.json": [
    "433966",
    [
      740306
    ]
  ],
  "./en-AU/course_paces_search.json": [
    "421695",
    [
      662690
    ]
  ],
  "./es/react_files.json": [
    "981957",
    [
      454156
    ]
  ],
  "./de/gradebook_default_gradebook_components_content_filters_module_filter.json": [
    "830139",
    [
      880510
    ]
  ],
  "./fi/horizon_toggle.json": [
    "824377",
    [
      268975
    ]
  ],
  "./ko/assignments.json": [
    "763186",
    [
      691578
    ]
  ],
  "./uk/default_account_quotas.json": [
    "658693",
    [
      593275
    ]
  ],
  "./fr/speed_grader_helpers.json": [
    "702839",
    [
      372638
    ]
  ],
  "./ca/course_default_due_time.json": [
    "377208",
    [
      420536
    ]
  ],
  "./en-GB/content_exports.json": [
    "903874",
    [
      400815
    ]
  ],
  "./hy/moderate_quiz.json": [
    "697110",
    [
      539006
    ]
  ],
  "./cy/quizzes_quiz_submission.json": [
    "370786",
    [
      686458
    ]
  ],
  "./sv/a2LatePolicyStatusDisplay.json": [
    "360956",
    [
      102200
    ]
  ],
  "./fr-CA/appointment_groups.json": [
    "628547",
    [
      507341
    ]
  ],
  "./da/EditMasteryScaleLink.json": [
    "81098",
    [
      667042
    ]
  ],
  "./fr-CA/admin_split.json": [
    "795499",
    [
      566373
    ]
  ],
  "./hi/assignments_2_student_content.json": [
    "600800",
    [
      936776
    ]
  ],
  "./id/calculator.json": [
    "238297",
    [
      549731
    ]
  ],
  "./ms/calculator.json": [
    "619262",
    [
      605774
    ]
  ],
  "./cy/grade_summary.json": [
    "270366",
    [
      363502
    ]
  ],
  "./en-GB-x-ukhe/assignments_2_student_content.json": [
    "415769",
    [
      989567
    ]
  ],
  "./nb-x-k12/ProfileTray.json": [
    "794941",
    [
      227611
    ]
  ],
  "./en-GB-x-lbs/sections_tooltip.json": [
    "510860",
    [
      578860
    ]
  ],
  "./zh-Hant/account_calendar_settings_account_group.json": [
    "819082",
    [
      134694
    ]
  ],
  "./sv-x-k12/assignments_2_student_header.json": [
    "526026",
    [
      221834
    ]
  ],
  "./fr/a2_AccessibleTipContent.json": [
    "877266",
    [
      733287
    ]
  ],
  "./ht/assignments_2_MoreOptions.json": [
    "559623",
    [
      397089
    ]
  ],
  "./hi/react_files.json": [
    "554026",
    [
      965914
    ]
  ],
  "./cy/CourseAvailabilityOptions.json": [
    "335418",
    [
      395458
    ]
  ],
  "./da/Navigation.json": [
    "33113",
    [
      149879
    ]
  ],
  "./fr/assignments_bulk_edit.json": [
    "85650",
    [
      902551
    ]
  ],
  "./pl/empty_course.json": [
    "801345",
    [
      343459
    ]
  ],
  "./zh-Hans/user_name.json": [
    "380718",
    [
      614214
    ]
  ],
  "./cy/copy_warnings_modal.json": [
    "440191",
    [
      851101
    ]
  ],
  "./ja/account_calendar_settings_utils.json": [
    "403971",
    [
      65566
    ]
  ],
  "./ja/quizzes_quiz_submission.json": [
    "120039",
    [
      884650
    ]
  ],
  "./en-AU-x-unimelb/context_modules_v2.json": [
    "242188",
    [
      678296
    ]
  ],
  "./uk/content_share_preview_overlay.json": [
    "921287",
    [
      939653
    ]
  ],
  "./th/SpeedGraderCheckpoints.json": [
    "946953",
    [
      418051
    ]
  ],
  "./de/course_paces_module.json": [
    "584850",
    [
      354211
    ]
  ],
  "./en-CA/discussion_create.json": [
    "799791",
    [
      692421
    ]
  ],
  "./ms/MoveOutcomesModal.json": [
    "609355",
    [
      616113
    ]
  ],
  "./he/gradebook_uploads.json": [
    "191526",
    [
      862406
    ]
  ],
  "./pt-BR/comm_messages.json": [
    "687082",
    [
      778283
    ]
  ],
  "./pt/account_calendars.json": [
    "400109",
    [
      894239
    ]
  ],
  "./zh-Hans/assignments.never_drop.json": [
    "443185",
    [
      947852
    ]
  ],
  "./en-AU/roster_publicjs.json": [
    "839858",
    [
      249979
    ]
  ],
  "./nb-x-k12/course_stats.json": [
    "250613",
    [
      645907
    ]
  ],
  "./hi/editAssignmentGroupWeights.json": [
    "856634",
    [
      109482
    ]
  ],
  "./nb/courses.show.json": [
    "952643",
    [
      433182
    ]
  ],
  "./el/CourseAvailabilityOptions.json": [
    "320659",
    [
      293925
    ]
  ],
  "./mi/direct_share_course_import_panel.json": [
    "315024",
    [
      430064
    ]
  ],
  "./ru/custom_help_link.json": [
    "353981",
    [
      434299
    ]
  ],
  "./pl/course_paces_blackout_dates_table.json": [
    "468669",
    [
      720023
    ]
  ],
  "./vi/link_validator.json": [
    "745664",
    [
      681400
    ]
  ],
  "./fi/notebook_index.json": [
    "976043",
    [
      799353
    ]
  ],
  "./ms/blueprint_course_sidebar.json": [
    "891224",
    [
      327944
    ]
  ],
  "./cy/filter_calendars_modal.json": [
    "610546",
    [
      908586
    ]
  ],
  "./pt/announcements_on_home_page.json": [
    "178418",
    [
      291670
    ]
  ],
  "./nb-x-k12/react_files.json": [
    "437147",
    [
      295449
    ]
  ],
  "./el.eager.json": [
    "173642",
    [
      796817
    ]
  ],
  "./he/group_submission_reminder.json": [
    "255942",
    [
      711334
    ]
  ],
  "./ht/user_name.json": [
    "653633",
    [
      947331
    ]
  ],
  "./it/pseudonyms_mobile_login.json": [
    "464403",
    [
      818757
    ]
  ],
  "./uk/eportfolio.json": [
    "487427",
    [
      194121
    ]
  ],
  "./zh-Hant/upload_button.json": [
    "47410",
    [
      545406
    ]
  ],
  "./da-x-k12/discussion_posts.json": [
    "587293",
    [
      263423
    ]
  ],
  "./ja/calendar_custom_recurring_event_repeat_picker.json": [
    "932361",
    [
      519432
    ]
  ],
  "./ga/courses.show.json": [
    "41399",
    [
      245350
    ]
  ],
  "./en-AU-x-unimelb/conferences_alternatives.json": [
    "796082",
    [
      997526
    ]
  ],
  "./ca/student_study_drawer.json": [
    "437009",
    [
      81503
    ]
  ],
  "./pl/registration.json": [
    "870427",
    [
      106749
    ]
  ],
  "./ru/link_validator.json": [
    "218480",
    [
      743128
    ]
  ],
  "./fr/assignment_grade_summary.json": [
    "632792",
    [
      109513
    ]
  ],
  "./pl/last_attended.json": [
    "118342",
    [
      80042
    ]
  ],
  "./hy/gradingGradeSummary.json": [
    "864428",
    [
      480572
    ]
  ],
  "./sl.json": [
    "706350",
    [
      835740
    ]
  ],
  "./zh-Hant/new_user_tutorial.json": [
    "429723",
    [
      186469
    ]
  ],
  "./tr/group_submission_reminder.json": [
    "937507",
    [
      430109
    ]
  ],
  "./id/jobs.json": [
    "542665",
    [
      408323
    ]
  ],
  "./is/account_settings.json": [
    "497743",
    [
      706069
    ]
  ],
  "./sl/plugins.json": [
    "924889",
    [
      907043
    ]
  ],
  "./ca/ai_experiences_edit.json": [
    "246591",
    [
      432013
    ]
  ],
  "./pt/roster_section_input.json": [
    "723514",
    [
      754782
    ]
  ],
  "./es/roster_section_input.json": [
    "850802",
    [
      153003
    ]
  ],
  "./ht/self_enrollment.json": [
    "466757",
    [
      769079
    ]
  ],
  "./he/blueprint_settingsMigrationOptions.json": [
    "929992",
    [
      444920
    ]
  ],
  "./hu/outcome_management.json": [
    "645669",
    [
      321611
    ]
  ],
  "./fr/SpeedGraderCheckpoints.json": [
    "742889",
    [
      765988
    ]
  ],
  "./fr/bulk_edit_students.json": [
    "271240",
    [
      465697
    ]
  ],
  "./it/epub_exports.json": [
    "662039",
    [
      235417
    ]
  ],
  "./cy/account_calendar_settings_account_calendar_item.json": [
    "13595",
    [
      859457
    ]
  ],
  "./en/canvas_file_upload.json": [
    "935286",
    [
      412114
    ]
  ],
  "./ht/permissions_v2.json": [
    "622659",
    [
      565189
    ]
  ],
  "./hu/course_paces_app.json": [
    "363609",
    [
      178599
    ]
  ],
  "./hu/filter_calendars_modal.json": [
    "431643",
    [
      595393
    ]
  ],
  "./fr-CA/account_calendars_results_area.json": [
    "867455",
    [
      83049
    ]
  ],
  "./nb-x-k12/custom_emoji_deny_list.json": [
    "212506",
    [
      527645
    ]
  ],
  "./sl/edit_section_view.json": [
    "555281",
    [
      39179
    ]
  ],
  "./en-GB-x-lbs/MoveOutcomesModal.json": [
    "700445",
    [
      844315
    ]
  ],
  "./ms/widget_dashboard.json": [
    "425593",
    [
      774695
    ]
  ],
  "./he/GroupDetailView.json": [
    "144394",
    [
      165650
    ]
  ],
  "./id/permission_button.json": [
    "26095",
    [
      297689
    ]
  ],
  "./uk/admin_split.json": [
    "277870",
    [
      493454
    ]
  ],
  "./nb/course_paces_footer.json": [
    "317122",
    [
      917494
    ]
  ],
  "./ga/new_user_tutorial.json": [
    "719053",
    [
      372171
    ]
  ],
  "./ar/pseudonyms_mobile_login.json": [
    "840873",
    [
      407851
    ]
  ],
  "./en-GB-x-lbs/course_paces_projected_dates.json": [
    "561223",
    [
      654733
    ]
  ],
  "./id/context_modules_v2.json": [
    "901231",
    [
      61457
    ]
  ],
  "./hu/mutationActivity.json": [
    "486985",
    [
      190039
    ]
  ],
  "./da/registration.json": [
    "848498",
    [
      907514
    ]
  ],
  "./en-GB/notebook_index.json": [
    "463007",
    [
      868590
    ]
  ],
  "./ca/course_paces_projected_dates.json": [
    "272213",
    [
      837835
    ]
  ],
  "./en-AU-x-unimelb/bulk_edit_students.json": [
    "628824",
    [
      797236
    ]
  ],
  "./nb-x-k12/knowledge_check_not_ready.json": [
    "730573",
    [
      213899
    ]
  ],
  "./zh-Hans/top_navigation_tools.json": [
    "514501",
    [
      294083
    ]
  ],
  "./zh-Hant/video_conference.json": [
    "615274",
    [
      804398
    ]
  ],
  "./nl/mutationActivity.json": [
    "713690",
    [
      461582
    ]
  ],
  "./fa/canvascareer.json": [
    "815711",
    [
      900773
    ]
  ],
  "./hu/module_student_view_peer_reviews.json": [
    "463440",
    [
      485168
    ]
  ],
  "./ms/lti_registrations.json": [
    "289904",
    [
      81392
    ]
  ],
  "./ja/registration.json": [
    "239156",
    [
      993521
    ]
  ],
  "./da-x-k12/assignments_2_file_upload.json": [
    "291197",
    [
      969583
    ]
  ],
  "./da/assignments_2_login_action_prompt.json": [
    "352038",
    [
      370934
    ]
  ],
  "./es/custom_emoji_deny_list.json": [
    "326524",
    [
      899977
    ]
  ],
  "./ht/question_bank.json": [
    "472697",
    [
      410835
    ]
  ],
  "./ht/progression_module_header.json": [
    "486250",
    [
      272582
    ]
  ],
  "./it/course_paces_change_tracking.json": [
    "429304",
    [
      295892
    ]
  ],
  "./sl/course_paces_errors.json": [
    "500281",
    [
      733491
    ]
  ],
  "./sl/account_calendar_settings_account_list.json": [
    "86292",
    [
      383816
    ]
  ],
  "./el/edit_section_start_date.json": [
    "145883",
    [
      801277
    ]
  ],
  "./ko/sections_tooltip.json": [
    "335804",
    [
      176340
    ]
  ],
  "./sv-x-k12/add_edit_pseudonym.json": [
    "945290",
    [
      368586
    ]
  ],
  "./tr/wiki_page_index.json": [
    "931661",
    [
      191655
    ]
  ],
  "./fr/sidenav.json": [
    "517474",
    [
      133775
    ]
  ],
  "./fi/course_paces_header.json": [
    "506869",
    [
      676163
    ]
  ],
  "./he/folder_tree.json": [
    "137112",
    [
      846843
    ]
  ],
  "./uk/CoursesTray.json": [
    "874060",
    [
      33668
    ]
  ],
  "./ga/keyboardShortcutModal.json": [
    "388366",
    [
      705286
    ]
  ],
  "./pt/notebook_index.json": [
    "662280",
    [
      725716
    ]
  ],
  "./pl/course_paces_no_results.json": [
    "231891",
    [
      869061
    ]
  ],
  "./vi/pseudonyms_mobile_login.json": [
    "474883",
    [
      732417
    ]
  ],
  "./tr/plugins.json": [
    "385308",
    [
      471240
    ]
  ],
  "./da/assignments_2_submission_histories_query.json": [
    "386011",
    [
      367601
    ]
  ],
  "./hy/assignments.json": [
    "629511",
    [
      448621
    ]
  ],
  "./th/MoveOutcomesModal.json": [
    "537019",
    [
      152085
    ]
  ],
  "./ar/paginated_list.json": [
    "606419",
    [
      438821
    ]
  ],
  "./tr/blueprint_settingsSyncChange.json": [
    "222522",
    [
      21670
    ]
  ],
  "./he/MobileGlobalMenu.json": [
    "399901",
    [
      417075
    ]
  ],
  "./ar/gradebookOutcomeGradebookView.json": [
    "160180",
    [
      774200
    ]
  ],
  "./en-AU-x-unimelb/gradinggradingPeriodCollection.json": [
    "202259",
    [
      704221
    ]
  ],
  "./mi/MasteryScale.json": [
    "647193",
    [
      367591
    ]
  ],
  "./fa/course_pace_date_input.json": [
    "203880",
    [
      891216
    ]
  ],
  "./ga/assignments_2_student_content_rubric_self_assessment.json": [
    "846107",
    [
      512921
    ]
  ],
  "./tr/accessibility_checker.json": [
    "668728",
    [
      351484
    ]
  ],
  "./tr/gradebookActionMenu.json": [
    "649851",
    [
      959173
    ]
  ],
  "./el/calendar_sidebar.json": [
    "264104",
    [
      283964
    ]
  ],
  "./ga/auth_logging.json": [
    "916622",
    [
      53430
    ]
  ],
  "./sv-x-k12/assignment_show.json": [
    "555426",
    [
      368290
    ]
  ],
  "./ar/courses_show.json": [
    "587913",
    [
      324611
    ]
  ],
  "./sl/user_restore.json": [
    "809969",
    [
      981691
    ]
  ],
  "./ar/authentication_providers.json": [
    "156242",
    [
      756462
    ]
  ],
  "./mi/notebook.json": [
    "524049",
    [
      369692
    ]
  ],
  "./mi/conversations_2.json": [
    "653681",
    [
      194415
    ]
  ],
  "./zh-Hant/blueprint_settingsCourseFilter.json": [
    "835830",
    [
      981170
    ]
  ],
  "./zh-Hans/AlignmentSummary.json": [
    "353392",
    [
      362392
    ]
  ],
  "./nb-x-k12/assignments_2_student_content_rubric_self_assessment.json": [
    "666733",
    [
      18555
    ]
  ],
  "./fr-CA/reset_pace_warning_modal.json": [
    "455951",
    [
      857329
    ]
  ],
  "./fi/edit_section_start_date.json": [
    "422823",
    [
      167789
    ]
  ],
  "./vi/self_unenrollment_modal.json": [
    "434913",
    [
      481367
    ]
  ],
  "./pt/account_calendar_settings_confirmation_modal.json": [
    "882830",
    [
      561341
    ]
  ],
  "./tr/discovery_page.json": [
    "547936",
    [
      871796
    ]
  ],
  "./es-ES/CreateEditAssignmentModalAdapter.json": [
    "684572",
    [
      937516
    ]
  ],
  "./fr-CA/user_logins.json": [
    "634821",
    [
      13143
    ]
  ],
  "./ar/student_annotation_preview.json": [
    "627245",
    [
      647831
    ]
  ],
  "./fi/gradingGradeSummary.json": [
    "670698",
    [
      208458
    ]
  ],
  "./da/account_calendars_results_area.json": [
    "243265",
    [
      597679
    ]
  ],
  "./fr-CA/section.json": [
    "252048",
    [
      74244
    ]
  ],
  "./hu.eager.json": [
    "262444",
    [
      264383
    ]
  ],
  "./pt/jobs_v2.json": [
    "907899",
    [
      253933
    ]
  ],
  "./ru/discovery_page.json": [
    "1217",
    [
      667847
    ]
  ],
  "./uk/discussion_insights.json": [
    "299414",
    [
      283526
    ]
  ],
  "./es-ES/progressbar_view.json": [
    "727237",
    [
      147683
    ]
  ],
  "./es-ES/assignments_2_external_tool.json": [
    "484357",
    [
      281139
    ]
  ],
  "./mi/course_paces_assignment_row.json": [
    "188901",
    [
      125323
    ]
  ],
  "./pl/account_calendar_settings.json": [
    "910984",
    [
      445588
    ]
  ],
  "./es-ES/student_study_drawer.json": [
    "249486",
    [
      901638
    ]
  ],
  "./id/account_calendar_settings_confirmation_modal.json": [
    "564593",
    [
      603027
    ]
  ],
  "./uk/MobileGlobalMenu.json": [
    "603228",
    [
      148820
    ]
  ],
  "./pt/submit_online_url_assignment.json": [
    "217454",
    [
      567490
    ]
  ],
  "./cy/user_profile.json": [
    "502731",
    [
      795089
    ]
  ],
  "./mi/assignment_2_assignment_toggle_details.json": [
    "274872",
    [
      478312
    ]
  ],
  "./nb-x-k12/course_paces_search.json": [
    "56895",
    [
      169509
    ]
  ],
  "./hy/assignments_2_student_points_display.json": [
    "424581",
    [
      118147
    ]
  ],
  "./ru/error_form.json": [
    "400220",
    [
      392972
    ]
  ],
  "./cy/discussion_settings.json": [
    "174606",
    [
      843902
    ]
  ],
  "./en-GB/submit_assignment.json": [
    "901479",
    [
      676190
    ]
  ],
  "./hi/MoveOutcomesModal.json": [
    "890780",
    [
      112188
    ]
  ],
  "./pt-BR/account_calendar_settings_account_calendar_item.json": [
    "228042",
    [
      482219
    ]
  ],
  "./nb/SpeedGraderCheckpoints.json": [
    "648801",
    [
      162331
    ]
  ],
  "./ja/course_paces_assignment_row.json": [
    "64498",
    [
      718683
    ]
  ],
  "./ko/calculator.json": [
    "122552",
    [
      310552
    ]
  ],
  "./ru/security_panel.json": [
    "3422",
    [
      872742
    ]
  ],
  "./hu/youtube_migration.json": [
    "524043",
    [
      612849
    ]
  ],
  "./pt-BR/upload_button.json": [
    "642537",
    [
      494240
    ]
  ],
  "./it/gradingGradeSummary.json": [
    "646602",
    [
      542750
    ]
  ],
  "./tr/course_paces_blackout_dates_modal.json": [
    "28282",
    [
      151102
    ]
  ],
  "./fa/CommentLibrary.json": [
    "744605",
    [
      860859
    ]
  ],
  "./id/assignments_2_MoreOptions_CanvasFiles.json": [
    "745522",
    [
      771038
    ]
  ],
  "./he/LearningMasteryGradebook.json": [
    "593032",
    [
      910200
    ]
  ],
  "./tr/new_user_tutorial.json": [
    "567547",
    [
      186901
    ]
  ],
  "./da/k5_dashboard_card.json": [
    "930787",
    [
      124553
    ]
  ],
  "./de/peer_review_student_select.json": [
    "3861",
    [
      173348
    ]
  ],
  "./mi/admin_split.json": [
    "856676",
    [
      602076
    ]
  ],
  "./tr/course_stats.json": [
    "910861",
    [
      927196
    ]
  ],
  "./de/assignments_2_file_upload.json": [
    "99467",
    [
      729150
    ]
  ],
  "./ar/blueprint_course_sidebar.json": [
    "354685",
    [
      384175
    ]
  ],
  "./th/discussion_row.json": [
    "931721",
    [
      872907
    ]
  ],
  "./ms/OutcomeMoveModal.json": [
    "799156",
    [
      296268
    ]
  ],
  "./ms/rate_limiting_settings.json": [
    "985748",
    [
      869676
    ]
  ],
  "./th/terms_of_use.json": [
    "972015",
    [
      746705
    ]
  ],
  "./pt/gradebook_history.json": [
    "688071",
    [
      818665
    ]
  ],
  "./zh-Hant/bulk_edit_students_table.json": [
    "937745",
    [
      456163
    ]
  ],
  "./de/terms_of_service_modal.json": [
    "727448",
    [
      990213
    ]
  ],
  "./pl/assignments_2_submission_helpers.json": [
    "373092",
    [
      537368
    ]
  ],
  "./sv-x-k12/comm_messages.json": [
    "497928",
    [
      129824
    ]
  ],
  "./he/discovery_page.json": [
    "725327",
    [
      482637
    ]
  ],
  "./cy/important_dates_empty.json": [
    "714320",
    [
      144112
    ]
  ],
  "./nl/MobileGlobalMenu.json": [
    "45662",
    [
      488386
    ]
  ],
  "./ja/course_pace_date_input.json": [
    "640748",
    [
      515049
    ]
  ],
  "./th/last_attended.json": [
    "89550",
    [
      27685
    ]
  ],
  "./it/appointment_groups.json": [
    "282215",
    [
      899473
    ]
  ],
  "./ko/user_restore.json": [
    "986194",
    [
      559066
    ]
  ],
  "./es-ES/assignments_2_student_annotation.json": [
    "438112",
    [
      552552
    ]
  ],
  "./tr/terms_of_service_modal.json": [
    "135987",
    [
      735693
    ]
  ],
  "./id/gradingPeriodTemplate.json": [
    "364064",
    [
      29012
    ]
  ],
  "./en-CA/a2_AccessibleTipContent.json": [
    "727010",
    [
      478226
    ]
  ],
  "./pl/unpublished_changes_tray_contents.json": [
    "740487",
    [
      30273
    ]
  ],
  "./sv/module_sequence_footer.json": [
    "227671",
    [
      363457
    ]
  ],
  "./ca/CreateEditAssignmentModalAdapter.json": [
    "73727",
    [
      373837
    ]
  ],
  "./cy/EditMasteryScaleLink.json": [
    "583643",
    [
      132385
    ]
  ],
  "./fa/filter_calendars_modal.json": [
    "90853",
    [
      938579
    ]
  ],
  "./sv/edit_section_start_date.json": [
    "135979",
    [
      21389
    ]
  ],
  "./hu/file_not_found.json": [
    "375240",
    [
      616824
    ]
  ],
  "./zh-Hans/CoursesTray.json": [
    "238087",
    [
      632589
    ]
  ],
  "./da-x-k12/react_files.json": [
    "657312",
    [
      91612
    ]
  ],
  "./zh-Hant/progressbar_view.json": [
    "875880",
    [
      650300
    ]
  ],
  "./da-x-k12/notebook.json": [
    "148660",
    [
      444048
    ]
  ],
  "./fr-CA/OutcomeMoveModal.json": [
    "894975",
    [
      502249
    ]
  ],
  "./ga/modelsQuiz.json": [
    "466477",
    [
      522859
    ]
  ],
  "./cy/ai_experiences_ai_conversations.json": [
    "97558",
    [
      411638
    ]
  ],
  "./he/editGroup.json": [
    "998674",
    [
      163338
    ]
  ],
  "./hi/discussion_settings.json": [
    "492093",
    [
      818459
    ]
  ],
  "./hy/CourseAvailabilityOptions.json": [
    "340257",
    [
      183015
    ]
  ],
  "./zh-Hant/content_copy_redesign.json": [
    "291107",
    [
      216781
    ]
  ],
  "./sv-x-k12/notebook_index.json": [
    "524169",
    [
      747727
    ]
  ],
  "./en-GB-x-lbs/bulk_edit_students.json": [
    "661222",
    [
      40670
    ]
  ],
  "./zh-Hans/discussion_topics.json": [
    "88264",
    [
      373344
    ]
  ],
  "./tr/assignments_peer_reviews_student.json": [
    "892313",
    [
      626043
    ]
  ],
  "./de/direct_share_course_import_panel.json": [
    "62571",
    [
      796478
    ]
  ],
  "./nb/assignments_2_student_annotation.json": [
    "493779",
    [
      468981
    ]
  ],
  "./nn/course_paces_time_selection.json": [
    "53397",
    [
      301959
    ]
  ],
  "./en-GB-x-ukhe/assignments_2_peer_review.json": [
    "312685",
    [
      764907
    ]
  ],
  "./sl/assignments_2_MoreOptions.json": [
    "142944",
    [
      166900
    ]
  ],
  "./el/grade_summary.json": [
    "411139",
    [
      182613
    ]
  ],
  "./es/login.json": [
    "43031",
    [
      628010
    ]
  ],
  "./en-AU/notebook_index.json": [
    "583646",
    [
      109983
    ]
  ],
  "./es-ES/rootFoldersFinder.json": [
    "842058",
    [
      836170
    ]
  ],
  "./fa/account_settings_jsx_bundle.json": [
    "193167",
    [
      264325
    ]
  ],
  "./hy/internal-settings.json": [
    "228620",
    [
      183132
    ]
  ],
  "./pt/horizon_toggle.json": [
    "838250",
    [
      912446
    ]
  ],
  "./nb/quantitative_data_options.json": [
    "354195",
    [
      848645
    ]
  ],
  "./id/assignmentsToggleShowByView.json": [
    "909416",
    [
      110028
    ]
  ],
  "./id/permissions.json": [
    "925635",
    [
      430341
    ]
  ],
  "./zh-Hans/grade_change_logging_content.json": [
    "726327",
    [
      794125
    ]
  ],
  "./da/unpublished_changes_button_props.json": [
    "994084",
    [
      196076
    ]
  ],
  "./ja/sis_import.json": [
    "666210",
    [
      699019
    ]
  ],
  "./ht/jobs_v2.json": [
    "399587",
    [
      232549
    ]
  ],
  "./nn/editGroup.json": [
    "101113",
    [
      117795
    ]
  ],
  "./sv-x-k12/security_panel.json": [
    "408240",
    [
      310760
    ]
  ],
  "./ja/wiki_page_index.json": [
    "769558",
    [
      845271
    ]
  ],
  "./pt-BR/content_migrations_redesign.json": [
    "462092",
    [
      399345
    ]
  ],
  "./es-ES/course_stats.json": [
    "362508",
    [
      334332
    ]
  ],
  "./hu/MobileGlobalMenu.json": [
    "17293",
    [
      926563
    ]
  ],
  "./de/outcome_reporting.json": [
    "923372",
    [
      44769
    ]
  ],
  "./el/add_edit_pseudonym.json": [
    "14572",
    [
      635672
    ]
  ],
  "./vi/module_student_view_peer_reviews.json": [
    "793174",
    [
      314702
    ]
  ],
  "./en-GB/blueprint_course_sidebar.json": [
    "867603",
    [
      863626
    ]
  ],
  "./ga/blueprint_settingsSyncHistory.json": [
    "896152",
    [
      305392
    ]
  ],
  "./zh-Hans/outcome_detail.json": [
    "244367",
    [
      227605
    ]
  ],
  "./pt/accessibility_checker.json": [
    "706974",
    [
      57746
    ]
  ],
  "./id/course_paces_footer.json": [
    "57079",
    [
      291225
    ]
  ],
  "./da/courses_show.json": [
    "689541",
    [
      219227
    ]
  ],
  "./en-AU-x-unimelb/account_settings_jsx_bundle.json": [
    "6070",
    [
      861162
    ]
  ],
  "./id/peer-review-assignment-widget.json": [
    "251269",
    [
      777559
    ]
  ],
  "./da-x-k12/react_developer_keys.json": [
    "335190",
    [
      641642
    ]
  ],
  "./nb/assignments_2_initial_query.json": [
    "786749",
    [
      413543
    ]
  ],
  "./sv/assignments_2_peer_review.json": [
    "345682",
    [
      983574
    ]
  ],
  "./nb-x-k12/gradingPeriodTemplate.json": [
    "978531",
    [
      200686
    ]
  ],
  "./nb/ldap_cert_upload.json": [
    "850362",
    [
      94590
    ]
  ],
  "./th/submissions_show_preview.json": [
    "732282",
    [
      564638
    ]
  ],
  "./hi/blueprint_settingsAssociationsTable.json": [
    "801602",
    [
      209714
    ]
  ],
  "./en/course_template_details.json": [
    "966476",
    [
      911496
    ]
  ],
  "./pt/assignments_2_external_tool.json": [
    "35588",
    [
      252080
    ]
  ],
  "./sv/Navigation.json": [
    "268863",
    [
      729993
    ]
  ],
  "./ko/announcements_on_home_page.json": [
    "205044",
    [
      119612
    ]
  ],
  "./ar/GroupDetailView.json": [
    "577350",
    [
      213498
    ]
  ],
  "./sv-x-k12/student_groups.json": [
    "978587",
    [
      555289
    ]
  ],
  "./en-AU-x-unimelb/discussion_settings.json": [
    "792726",
    [
      193186
    ]
  ],
  "./es-ES/k5_dashboard_card.json": [
    "739025",
    [
      193175
    ]
  ],
  "./fr-CA/assignments_2_student_header.json": [
    "331036",
    [
      884384
    ]
  ],
  "./nb/media_player_iframe_content.json": [
    "83017",
    [
      961875
    ]
  ],
  "./vi/user_profile.json": [
    "685048",
    [
      472608
    ]
  ],
  "./ru/calculator_command.json": [
    "891791",
    [
      517589
    ]
  ],
  "./fr/admin_split.json": [
    "432766",
    [
      102723
    ]
  ],
  "./es-ES/account_calendar_settings_account_tree.json": [
    "438998",
    [
      325342
    ]
  ],
  "./fa/grade_change_logging_content.json": [
    "939989",
    [
      801299
    ]
  ],
  "./ja/MobileNavigation.json": [
    "567513",
    [
      708376
    ]
  ],
  "./nl/course_paces_blackout_date_row.json": [
    "941532",
    [
      291632
    ]
  ],
  "./zh-Hans/internal-settings.json": [
    "951620",
    [
      988388
    ]
  ],
  "./nb/context_roster_user_services.json": [
    "572134",
    [
      931378
    ]
  ],
  "./nn/k5_dashboard.json": [
    "421073",
    [
      123931
    ]
  ],
  "./ga/grade_summary.json": [
    "701922",
    [
      868725
    ]
  ],
  "./en-GB/assignmentsToggleShowByView.json": [
    "91164",
    [
      981125
    ]
  ],
  "./da/DueDateOverrideView.json": [
    "975042",
    [
      269578
    ]
  ],
  "./en-AU/theme_editor.json": [
    "99979",
    [
      785894
    ]
  ],
  "./en-GB/discussion_insights.json": [
    "777499",
    [
      367546
    ]
  ],
  "./ar/moderate_quiz.json": [
    "78038",
    [
      731930
    ]
  ],
  "./pt-BR/edit_section_end_date.json": [
    "555320",
    [
      460421
    ]
  ],
  "./it/permissions_role_tray_table_row.json": [
    "274829",
    [
      106391
    ]
  ],
  "./ms/SpeedGraderCheckpoints.json": [
    "193734",
    [
      512903
    ]
  ],
  "./hi/ai_experiences_ai_conversations.json": [
    "467197",
    [
      589051
    ]
  ],
  "./nb/not_found_page_slide_puzzle.json": [
    "968609",
    [
      813507
    ]
  ],
  "./ga/homeroom_page.json": [
    "307256",
    [
      944608
    ]
  ],
  "./ru/react_collaborations.json": [
    "214627",
    [
      494945
    ]
  ],
  "./sv/assignments.never_drop.json": [
    "578667",
    [
      157950
    ]
  ],
  "./sv/registration.json": [
    "809588",
    [
      566200
    ]
  ],
  "./nn/assignments_2_url_entry.json": [
    "572964",
    [
      585848
    ]
  ],
  "./da-x-k12/edit_section_view.json": [
    "948795",
    [
      145549
    ]
  ],
  "./es/course_statistics.json": [
    "506667",
    [
      507638
    ]
  ],
  "./ca/choose_mastery_path.json": [
    "897717",
    [
      463595
    ]
  ],
  "./hu/unpublished_warning_modal.json": [
    "423455",
    [
      176317
    ]
  ],
  "./mi/peer_review_allocation_rules_tray.json": [
    "524513",
    [
      487231
    ]
  ],
  "./ca/course_paces_change_tracking.json": [
    "619279",
    [
      30493
    ]
  ],
  "./hy/blueprint_settingsAssociationsTable.json": [
    "790642",
    [
      714210
    ]
  ],
  "./hu/discussion_topics_edit.json": [
    "80521",
    [
      567607
    ]
  ],
  "./en-GB/permissions_v2.json": [
    "352192",
    [
      88401
    ]
  ],
  "./de/assignments_2_media_attempt.json": [
    "409715",
    [
      145462
    ]
  ],
  "./da-x-k12/blueprint_settingsSyncHistory.json": [
    "12101",
    [
      54743
    ]
  ],
  "./it/calculator.json": [
    "400553",
    [
      832051
    ]
  ],
  "./pt-BR/context_roster_user_services.json": [
    "964673",
    [
      874904
    ]
  ],
  "./tr/course_paces_footer.json": [
    "25924",
    [
      523032
    ]
  ],
  "./hu/a2LatePolicyStatusDisplay.json": [
    "920142",
    [
      505598
    ]
  ],
  "./nb-x-k12/quiz_log_auditing.json": [
    "182588",
    [
      672892
    ]
  ],
  "./hu/gradinggradingPeriodCollection.json": [
    "865894",
    [
      699046
    ]
  ],
  "./fi/user_date_range_search.json": [
    "648214",
    [
      370046
    ]
  ],
  "./ms/webzip_export.json": [
    "483086",
    [
      694302
    ]
  ],
  "./pt/terms_of_service_modal.json": [
    "939613",
    [
      120279
    ]
  ],
  "./ca/nav_tourpoints.json": [
    "528293",
    [
      93403
    ]
  ],
  "./ca/course_paces_assignment_row.json": [
    "705319",
    [
      504229
    ]
  ],
  "./vi/nav_tourpoints.json": [
    "347634",
    [
      403829
    ]
  ],
  "./zh-Hans/course_paces_no_results.json": [
    "807392",
    [
      462088
    ]
  ],
  "./fr/quiz_statistics.json": [
    "951291",
    [
      981058
    ]
  ],
  "./de/default_account_quotas.json": [
    "89860",
    [
      937881
    ]
  ],
  "./cy/important_dates.json": [
    "478202",
    [
      892354
    ]
  ],
  "./pl/mutationActivity.json": [
    "783688",
    [
      274188
    ]
  ],
  "./da/permissions_v2.json": [
    "204610",
    [
      102602
    ]
  ],
  "./zh-Hans/quizzes_public.json": [
    "420228",
    [
      484420
    ]
  ],
  "./th/dashboard_grading_period_select.json": [
    "359112",
    [
      471956
    ]
  ],
  "./en-GB-x-ukhe/course_paces_search.json": [
    "194867",
    [
      760881
    ]
  ],
  "./pt/calendar_edit.json": [
    "350529",
    [
      376899
    ]
  ],
  "./hi/user_grades.json": [
    "37621",
    [
      842083
    ]
  ],
  "./ar/user_lists.json": [
    "884182",
    [
      343466
    ]
  ],
  "./cy/outcome_detail.json": [
    "489446",
    [
      944358
    ]
  ],
  "./zh-Hant/user_restore.json": [
    "133446",
    [
      924506
    ]
  ],
  "./en/course_paces_projected_dates.json": [
    "864000",
    [
      202012
    ]
  ],
  "./fr/react_collaborations.json": [
    "793424",
    [
      13889
    ]
  ],
  "./el/bounced_emails.json": [
    "970205",
    [
      997495
    ]
  ],
  "./ko/accessibility_checker.json": [
    "751108",
    [
      338572
    ]
  ],
  "./it/discovery_page.json": [
    "547105",
    [
      627147
    ]
  ],
  "./mi/roster_section_selector.json": [
    "135633",
    [
      301071
    ]
  ],
  "./pl/upload_button.json": [
    "677708",
    [
      574504
    ]
  ],
  "./en/quizzes.take_quiz.json": [
    "85979",
    [
      597528
    ]
  ],
  "./is/progress_pill.json": [
    "737201",
    [
      400775
    ]
  ],
  "./ar/k5_dashboard_card.json": [
    "863319",
    [
      71697
    ]
  ],
  "./en-GB-x-ukhe/blueprint_settingsCoursePickerTable.json": [
    "499150",
    [
      576134
    ]
  ],
  "./en-GB-x-lbs/quiz_statistics.json": [
    "829545",
    [
      997775
    ]
  ],
  "./mi/account_calendar_settings_filter_controls.json": [
    "122604",
    [
      426484
    ]
  ],
  "./hy/bounced_emails.json": [
    "214671",
    [
      316661
    ]
  ],
  "./en-GB-x-ukhe/peer_review_allocation_rule_card.json": [
    "997282",
    [
      807730
    ]
  ],
  "./sv/courses.json": [
    "243393",
    [
      932427
    ]
  ],
  "./he/bulk_edit_students_table.json": [
    "126970",
    [
      103682
    ]
  ],
  "./da-x-k12/assignment_index_menu.json": [
    "928719",
    [
      302673
    ]
  ],
  "./th/self_enrollment.json": [
    "9069",
    [
      781215
    ]
  ],
  "./da-x-k12/assignments_2_media_attempt.json": [
    "879429",
    [
      340351
    ]
  ],
  "./sv-x-k12/assignment_grade_summary.json": [
    "159705",
    [
      653983
    ]
  ],
  "./mi/bulk_edit_students.json": [
    "664634",
    [
      353986
    ]
  ],
  "./he/module_sequence_footer.json": [
    "799517",
    [
      29779
    ]
  ],
  "./pt/edit_section_start_date.json": [
    "554490",
    [
      743262
    ]
  ],
  "./hu/AccountsTray.json": [
    "264211",
    [
      420425
    ]
  ],
  "./nl/error_form.json": [
    "335933",
    [
      55079
    ]
  ],
  "./ca/SpeedGraderSettingsMenu.json": [
    "926320",
    [
      713792
    ]
  ],
  "./es-ES/course_template_details.json": [
    "523222",
    [
      877918
    ]
  ],
  "./fi/new_nav.json": [
    "633043",
    [
      674561
    ]
  ],
  "./hu/assignment_index_deep_linking_handlers.json": [
    "136389",
    [
      395787
    ]
  ],
  "./zh-Hant/account_calendar_settings_account_list.json": [
    "479543",
    [
      654809
    ]
  ],
  "./en-AU/user_logins.json": [
    "170014",
    [
      880287
    ]
  ],
  "./en-GB/youtube_migration.json": [
    "885181",
    [
      882080
    ]
  ],
  "./hu/CourseAvailabilityOptions.json": [
    "137981",
    [
      734963
    ]
  ],
  "./id/assignments_2_submission_histories_query.json": [
    "871697",
    [
      638843
    ]
  ],
  "./is/outcomes_user_outcome_results.json": [
    "681445",
    [
      795187
    ]
  ],
  "./ru/react_scheduler.json": [
    "462938",
    [
      709578
    ]
  ],
  "./hu/course_paces_change_tracking.json": [
    "287590",
    [
      840198
    ]
  ],
  "./es-ES/terms_of_use.json": [
    "133408",
    [
      799336
    ]
  ],
  "./ht/important_dates_empty.json": [
    "108336",
    [
      810764
    ]
  ],
  "./nl/GroupDetailView.json": [
    "318243",
    [
      46629
    ]
  ],
  "./zh-Hans/calendar_custom_recurring_event_natural_language.json": [
    "341099",
    [
      288505
    ]
  ],
  "./nn/suppress_notifications.json": [
    "600522",
    [
      802390
    ]
  ],
  "./da/accessibility_checker.json": [
    "212077",
    [
      347411
    ]
  ],
  "./fr-CA/assignment_index_deep_linking_handlers.json": [
    "933275",
    [
      410573
    ]
  ],
  "./nb-x-k12/users.json": [
    "163460",
    [
      207524
    ]
  ],
  "./zh-Hant/peer_review_allocation_rule_card.json": [
    "438326",
    [
      532562
    ]
  ],
  "./sl/quiz_log_auditing.json": [
    "149589",
    [
      298559
    ]
  ],
  "./pt/student_entries.json": [
    "877502",
    [
      641802
    ]
  ],
  "./ru/student_groups.json": [
    "621865",
    [
      82639
    ]
  ],
  "./ga/quizzes_public.json": [
    "166825",
    [
      34831
    ]
  ],
  "./uk/assignments_2_attempt_tab.json": [
    "64383",
    [
      407117
    ]
  ],
  "./de/account_calendar_settings_account_group.json": [
    "533279",
    [
      414042
    ]
  ],
  "./ja/question_banks.json": [
    "269921",
    [
      976416
    ]
  ],
  "./ga/quantitative_data_options.json": [
    "17575",
    [
      506413
    ]
  ],
  "./cy/sis_import.json": [
    "461825",
    [
      414175
    ]
  ],
  "./cy/CommentLibrary.json": [
    "461358",
    [
      474206
    ]
  ],
  "./da/course_paces_modal.json": [
    "473855",
    [
      749421
    ]
  ],
  "./en-GB/courses_show.json": [
    "415667",
    [
      813674
    ]
  ],
  "./pt/account_calendar_settings_account_calendar_item.json": [
    "139187",
    [
      633893
    ]
  ],
  "./nn/user_logins.json": [
    "462572",
    [
      984488
    ]
  ],
  "./zh-Hant/OutcomeDescriptionModal.json": [
    "359235",
    [
      732261
    ]
  ],
  "./nb-x-k12/content_migrations.json": [
    "648355",
    [
      530593
    ]
  ],
  "./de/courses.show.json": [
    "366838",
    [
      986511
    ]
  ],
  "./nb-x-k12/bulk_edit_students_table.json": [
    "202329",
    [
      501631
    ]
  ],
  "./da-x-k12/course_paces_module.json": [
    "7568",
    [
      76876
    ]
  ],
  "./mi/grade_summaryGroupView.json": [
    "110862",
    [
      879742
    ]
  ],
  "./pl/GroupDetailView.json": [
    "98001",
    [
      95731
    ]
  ],
  "./fa/jobs.json": [
    "884305",
    [
      276615
    ]
  ],
  "./fr-CA/progression_module_header.json": [
    "965739",
    [
      253237
    ]
  ],
  "./pl/edit_section_start_date.json": [
    "860914",
    [
      670854
    ]
  ],
  "./es-ES/bulk_edit_students.json": [
    "195607",
    [
      659117
    ]
  ],
  "./fr/peer_review_allocation_rules_tray.json": [
    "404067",
    [
      76818
    ]
  ],
  "./ms/ai_experiences_edit.json": [
    "597247",
    [
      470749
    ]
  ],
  "./el/auth_logging.json": [
    "792809",
    [
      931995
    ]
  ],
  "./he/blueprint_settingsSyncHistory.json": [
    "71263",
    [
      262749
    ]
  ],
  "./sl/Navigation.json": [
    "797013",
    [
      785839
    ]
  ],
  "./sv/submit_assignment.json": [
    "564407",
    [
      946441
    ]
  ],
  "./el/section.json": [
    "398160",
    [
      614596
    ]
  ],
  "./es-ES/course_paces_search.json": [
    "317512",
    [
      878704
    ]
  ],
  "./fi/user_grades.json": [
    "346067",
    [
      71361
    ]
  ],
  "./th/blueprint_settingsSyncHistory.json": [
    "499044",
    [
      181792
    ]
  ],
  "./th/important_dates_empty.json": [
    "295992",
    [
      842484
    ]
  ],
  "./ja/roster_section_selector.json": [
    "265606",
    [
      639431
    ]
  ],
  "./he/internal-settings.json": [
    "14104",
    [
      381800
    ]
  ],
  "./it/learning_mastery_gradebook.json": [
    "300632",
    [
      913556
    ]
  ],
  "./zh-Hant/assignments.no_assignments_search.json": [
    "93143",
    [
      412440
    ]
  ],
  "./en-CA/theme_editor.json": [
    "355241",
    [
      840671
    ]
  ],
  "./sv/ldap_cert_upload.json": [
    "359305",
    [
      580755
    ]
  ],
  "./ga/SpeedGraderPostGradesMenu.json": [
    "295515",
    [
      151513
    ]
  ],
  "./pt-BR/authentication_providers.json": [
    "545012",
    [
      428793
    ]
  ],
  "./it/CommentLibrary.json": [
    "605749",
    [
      164327
    ]
  ],
  "./sv/progression_module_header.json": [
    "151163",
    [
      107909
    ]
  ],
  "./ko/unpublished_changes_button_props.json": [
    "930767",
    [
      511869
    ]
  ],
  "./en-AU/react_developer_keys.json": [
    "686611",
    [
      960590
    ]
  ],
  "./ht/sharedCurveGradesDialog.json": [
    "442322",
    [
      591246
    ]
  ],
  "./sl/course_navigation_settings.json": [
    "522167",
    [
      972633
    ]
  ],
  "./th/course_paces_flaggable_number_input.json": [
    "411703",
    [
      116641
    ]
  ],
  "./cy/internal-settings.json": [
    "290051",
    [
      518073
    ]
  ],
  "./de/assignment_index_menu.json": [
    "618985",
    [
      699936
    ]
  ],
  "./tr/assignments.json": [
    "474950",
    [
      572138
    ]
  ],
  "./fi/question_bank.json": [
    "63696",
    [
      456184
    ]
  ],
  "./vi/assignments_2_MoreOptions.json": [
    "55626",
    [
      271706
    ]
  ],
  "./fa/enhanced_individual_gradebook_submit_score.json": [
    "840730",
    [
      536090
    ]
  ],
  "./nn/manage_avatars.json": [
    "347644",
    [
      5840
    ]
  ],
  "./pt/group_submission_reminder.json": [
    "607937",
    [
      915075
    ]
  ],
  "./vi/direct_share_course_import_panel.json": [
    "100849",
    [
      433895
    ]
  ],
  "./zh-Hant/bulk_edit_students.json": [
    "289578",
    [
      871782
    ]
  ],
  "./nn/calendar_appointment_group_edit.json": [
    "613151",
    [
      734329
    ]
  ],
  "./en/assignments_2_file_upload.json": [
    "294931",
    [
      876085
    ]
  ],
  "./fr/assignments_2_external_tool.json": [
    "183012",
    [
      340421
    ]
  ],
  "./id/IndividualStudentMasteryOutcome.json": [
    "768382",
    [
      750722
    ]
  ],
  "./fr/notebook.json": [
    "689147",
    [
      58802
    ]
  ],
  "./th/grades_summary.json": [
    "13797",
    [
      386511
    ]
  ],
  "./zh-Hant/bulk_edit_students_actions.json": [
    "970226",
    [
      460750
    ]
  ],
  "./de/assignments_2_shared_Steps.json": [
    "550206",
    [
      378423
    ]
  ],
  "./es/course_paces_empty_state.json": [
    "957992",
    [
      896701
    ]
  ],
  "./hy/media_player_iframe_content.json": [
    "586722",
    [
      845906
    ]
  ],
  "./id/assignments_2_student_header.json": [
    "155112",
    [
      644108
    ]
  ],
  "./pl/assignment_index_menu.json": [
    "210826",
    [
      60001
    ]
  ],
  "./hy/roster_section_input.json": [
    "684091",
    [
      65577
    ]
  ],
  "./ru/account_course_user_search.json": [
    "25851",
    [
      147609
    ]
  ],
  "./ms/course_paces_empty_state.json": [
    "690592",
    [
      848768
    ]
  ],
  "./ar/course_pace_date_input.json": [
    "718538",
    [
      912774
    ]
  ],
  "./ga/course_paces_change_tracking.json": [
    "112387",
    [
      719105
    ]
  ],
  "./nl/course_paces_modal.json": [
    "410188",
    [
      273048
    ]
  ],
  "./ja/webcam_modal.json": [
    "243734",
    [
      699671
    ]
  ],
  "./en-AU-x-unimelb/user_logins.json": [
    "748512",
    [
      580820
    ]
  ],
  "./it/content_migrations.json": [
    "350850",
    [
      146350
    ]
  ],
  "./hy/notebook_index.json": [
    "273113",
    [
      879167
    ]
  ],
  "./fi/FindOutcomesModal.json": [
    "868968",
    [
      204960
    ]
  ],
  "./sv/account_calendar_settings_account_list.json": [
    "34610",
    [
      286078
    ]
  ],
  "./ko/calendar_appointment_group_edit.json": [
    "148057",
    [
      834615
    ]
  ],
  "./en-GB-x-ukhe/rootFoldersFinder.json": [
    "820609",
    [
      662887
    ]
  ],
  "./he/conferences.json": [
    "103718",
    [
      535974
    ]
  ],
  "./fr/conversations_2.json": [
    "967915",
    [
      925306
    ]
  ],
  "./en-GB-x-lbs/learning_mastery_gradebook.json": [
    "319897",
    [
      72751
    ]
  ],
  "./tr/terms_index.json": [
    "916828",
    [
      678000
    ]
  ],
  "./nb-x-k12/terms_of_service_modal.json": [
    "627819",
    [
      978681
    ]
  ],
  "./de/account_calendar_settings_account_tree.json": [
    "895940",
    [
      994553
    ]
  ],
  "./fr/CreateEditAssignmentModalAdapter.json": [
    "787599",
    [
      442470
    ]
  ],
  "./cy/course_default_due_time.json": [
    "105552",
    [
      993040
    ]
  ],
  "./fr-CA/permissions_role_tray_table_row.json": [
    "524001",
    [
      947835
    ]
  ],
  "./fi/lti_registration.wizard.json": [
    "232773",
    [
      64540
    ]
  ],
  "./ms/peer_review_allocation_rule_card.json": [
    "991796",
    [
      226188
    ]
  ],
  "./sv/LogoutButton.json": [
    "237679",
    [
      368097
    ]
  ],
  "./tr/assignmentsToggleShowByView.json": [
    "998347",
    [
      422605
    ]
  ],
  "./fr-CA/assignments_2_student_content_rubric_self_assessment.json": [
    "722480",
    [
      708628
    ]
  ],
  "./pt-BR/peer_reviews_student.json": [
    "482663",
    [
      39650
    ]
  ],
  "./zh-Hant/course_paces_errors.json": [
    "3668",
    [
      806368
    ]
  ],
  "./tr/lti_registrations.json": [
    "924922",
    [
      362446
    ]
  ],
  "./da-x-k12/empty_modules.json": [
    "965312",
    [
      679980
    ]
  ],
  "./ko/course_paces_actions.json": [
    "83194",
    [
      784978
    ]
  ],
  "./tr/assignments_2_student_points_display.json": [
    "664918",
    [
      225482
    ]
  ],
  "./es-ES/authentication_providers.json": [
    "562964",
    [
      73508
    ]
  ],
  "./ru/MoveOutcomesModal.json": [
    "694062",
    [
      723670
    ]
  ],
  "./de/react_files.json": [
    "501906",
    [
      705491
    ]
  ],
  "./vi/CourseAvailabilityOptions.json": [
    "687055",
    [
      216517
    ]
  ],
  "./nl/user_name.json": [
    "534575",
    [
      907593
    ]
  ],
  "./sv-x-k12/user_lists.json": [
    "378758",
    [
      395422
    ]
  ],
  "./ht/CoursesTray.json": [
    "336500",
    [
      988096
    ]
  ],
  "./nn/outcome_reporting.json": [
    "521855",
    [
      389497
    ]
  ],
  "./pl/copy_course.json": [
    "856129",
    [
      452987
    ]
  ],
  "./es-ES/conferences.json": [
    "230536",
    [
      152256
    ]
  ],
  "./fi/ai_experiences_ai_conversations.json": [
    "925299",
    [
      113633
    ]
  ],
  "./fa/pseudonyms_mobile_login.json": [
    "483323",
    [
      171945
    ]
  ],
  "./nn/modules_page_icon_legend.json": [
    "546275",
    [
      191189
    ]
  ],
  "./da-x-k12/sis_import.json": [
    "976282",
    [
      454294
    ]
  ],
  "./zh-Hant/course_link_validator.json": [
    "327379",
    [
      61085
    ]
  ],
  "./hi/custom_emoji_deny_list.json": [
    "840445",
    [
      669195
    ]
  ],
  "./nb/assignmentsToggleShowByView.json": [
    "258221",
    [
      290703
    ]
  ],
  "./pt-BR/quizzes_quiz_submission.json": [
    "522883",
    [
      613030
    ]
  ],
  "./da/use_switch_experience.json": [
    "539684",
    [
      693228
    ]
  ],
  "./sl/edit_section_end_date.json": [
    "133706",
    [
      953694
    ]
  ],
  "./es/sections_tooltip.json": [
    "608794",
    [
      882579
    ]
  ],
  "./tr/collaborations.json": [
    "655682",
    [
      396606
    ]
  ],
  "./en/calendar_custom_recurring_event_repeat_picker.json": [
    "20363",
    [
      127293
    ]
  ],
  "./cy/theme_editor.json": [
    "118641",
    [
      879887
    ]
  ],
  "./de/progression_module_header.json": [
    "152561",
    [
      971480
    ]
  ],
  "./es/peer-review-assignment-widget.json": [
    "539316",
    [
      294529
    ]
  ],
  "./nb/sis_import.json": [
    "613569",
    [
      272507
    ]
  ],
  "./pt/quiz_show.json": [
    "70645",
    [
      854223
    ]
  ],
  "./cy/user_restore.json": [
    "465548",
    [
      507476
    ]
  ],
  "./hu/bulk_edit_students_actions.json": [
    "199157",
    [
      146715
    ]
  ],
  "./id/nav_tourpoints.json": [
    "494290",
    [
      593510
    ]
  ],
  "./nb/password_complexity_configuration.json": [
    "766885",
    [
      732719
    ]
  ],
  "./hu/unpublished_changes_tray_contents.json": [
    "934696",
    [
      149496
    ]
  ],
  "./ar/assignments_2_student_header_date_title.json": [
    "288362",
    [
      676350
    ]
  ],
  "./el/GroupsTray.json": [
    "549069",
    [
      714543
    ]
  ],
  "./ga/assignments_bulk_edit.json": [
    "241086",
    [
      663910
    ]
  ],
  "./de/MoveOutcomesModal.json": [
    "350516",
    [
      225817
    ]
  ],
  "./uk/a2LatePolicyToolTipContent.json": [
    "112191",
    [
      231885
    ]
  ],
  "./pl/discussionTopicKeyboradShortcutModal.json": [
    "455257",
    [
      667691
    ]
  ],
  "./th/account_calendar_settings_utils.json": [
    "24962",
    [
      462262
    ]
  ],
  "./fr/gradebook.json": [
    "410448",
    [
      229233
    ]
  ],
  "./hi/courses_show.json": [
    "181401",
    [
      598991
    ]
  ],
  "./fr/blueprint_settingsCourseFilter.json": [
    "628368",
    [
      862945
    ]
  ],
  "./da/blueprint_settingsCoursePickerTable.json": [
    "737083",
    [
      63633
    ]
  ],
  "./vi/course_paces_modal.json": [
    "200577",
    [
      830487
    ]
  ],
  "./es/outcomes_user_outcome_results.json": [
    "392025",
    [
      455144
    ]
  ],
  "./pt/sharedCurveGradesDialog.json": [
    "522842",
    [
      32134
    ]
  ],
  "./it/link_validator.json": [
    "789584",
    [
      135972
    ]
  ],
  "./mi/blueprint_settingsCoursePicker.json": [
    "88558",
    [
      308286
    ]
  ],
  "./sl/OutcomeMoveModal.json": [
    "921489",
    [
      77843
    ]
  ],
  "./sv-x-k12/epub_exports.json": [
    "992609",
    [
      970903
    ]
  ],
  "./fr/login.json": [
    "550479",
    [
      954358
    ]
  ],
  "./ht/gradinggradingPeriodCollection.json": [
    "107851",
    [
      911469
    ]
  ],
  "./zh-Hant/student_entries.json": [
    "631456",
    [
      63100
    ]
  ],
  "./nn/new_user_tutorial.json": [
    "3341",
    [
      967615
    ]
  ],
  "./pt/grades_summary.json": [
    "997093",
    [
      903743
    ]
  ],
  "./sv/roster_publicjs.json": [
    "175393",
    [
      629315
    ]
  ],
  "./nl/course_paces_settings.json": [
    "703434",
    [
      51686
    ]
  ],
  "./nb-x-k12/grade_summary.json": [
    "327588",
    [
      749860
    ]
  ],
  "./zh-Hant/conferences.json": [
    "336571",
    [
      232093
    ]
  ],
  "./ga/file_not_found.json": [
    "61277",
    [
      224779
    ]
  ],
  "./ht/bounced_emails.json": [
    "748830",
    [
      530866
    ]
  ],
  "./ca/MobileGlobalMenu.json": [
    "423772",
    [
      233748
    ]
  ],
  "./uk/quizzes_quiz_submission.json": [
    "622938",
    [
      524114
    ]
  ],
  "./pt-BR/sidenav.json": [
    "950167",
    [
      156578
    ]
  ],
  "./cy/mutationActivity.json": [
    "568312",
    [
      479784
    ]
  ],
  "./pl/courses.json": [
    "796332",
    [
      298416
    ]
  ],
  "./id/content_share_preview_overlay.json": [
    "338194",
    [
      804342
    ]
  ],
  "./cy/remove_pace_warning_modal.json": [
    "894721",
    [
      146431
    ]
  ],
  "./de/course_logging_details.json": [
    "732817",
    [
      589240
    ]
  ],
  "./fr-CA/quiz_statistics.json": [
    "555254",
    [
      751010
    ]
  ],
  "./nn/youtube_migration.json": [
    "907512",
    [
      992460
    ]
  ],
  "./da/module_student_view_peer_reviews.json": [
    "228992",
    [
      782256
    ]
  ],
  "./da-x-k12/course_paces_projected_dates.json": [
    "269358",
    [
      43498
    ]
  ],
  "./en-GB/user.json": [
    "692802",
    [
      666743
    ]
  ],
  "./de/courses.json": [
    "913051",
    [
      509294
    ]
  ],
  "./fa/unpublished_changes_button_props.json": [
    "113122",
    [
      897202
    ]
  ],
  "./fr/course_paces_flaggable_number_input.json": [
    "883543",
    [
      539702
    ]
  ],
  "./pt-BR/NewTabIndicator.json": [
    "39437",
    [
      941180
    ]
  ],
  "./th/module_student_view_peer_reviews.json": [
    "574473",
    [
      461067
    ]
  ],
  "./es-ES/theme_collection_view.json": [
    "309085",
    [
      165627
    ]
  ],
  "./fr/roster_section_input.json": [
    "25754",
    [
      39423
    ]
  ],
  "./hi/DueDateOverrideView.json": [
    "912206",
    [
      170118
    ]
  ],
  "./id/entity_search_form.json": [
    "773322",
    [
      299286
    ]
  ],
  "./he/discussion_posts.json": [
    "684099",
    [
      164057
    ]
  ],
  "./nn/account_calendar_settings_account_calendar_item_dropdown.json": [
    "852017",
    [
      99955
    ]
  ],
  "./da-x-k12/account_course_user_search.json": [
    "74255",
    [
      134009
    ]
  ],
  "./pl/assignments_2_text_entry.json": [
    "721222",
    [
      620554
    ]
  ],
  "./pl/syllabus_revisions.json": [
    "131984",
    [
      107164
    ]
  ],
  "./ht/theme_collection_view.json": [
    "986224",
    [
      979316
    ]
  ],
  "./pt/module_student_view_peer_reviews.json": [
    "39881",
    [
      100923
    ]
  ],
  "./fr/accessibility_scan.json": [
    "216226",
    [
      973791
    ]
  ],
  "./is/assignment_index_deep_linking_handlers.json": [
    "579208",
    [
      183120
    ]
  ],
  "./es-ES/calendar_custom_recurring_event_repeat_picker.json": [
    "938077",
    [
      2315
    ]
  ],
  "./vi/terms_of_service_modal.json": [
    "722394",
    [
      281674
    ]
  ],
  "./pt/permissions.json": [
    "769766",
    [
      216522
    ]
  ],
  "./ht/grade_summaryGroupView.json": [
    "917768",
    [
      737772
    ]
  ],
  "./it/sidenav.json": [
    "182695",
    [
      574897
    ]
  ],
  "./zh-Hans/assignments_2_student_annotation.json": [
    "344786",
    [
      285426
    ]
  ],
  "./ko/theme_collection_view.json": [
    "898034",
    [
      803002
    ]
  ],
  "./es/quizzes_regrade_modal.json": [
    "931874",
    [
      461755
    ]
  ],
  "./id/collaborations.json": [
    "520599",
    [
      905361
    ]
  ],
  "./cy/direct_share_course_import_panel.json": [
    "166062",
    [
      815166
    ]
  ],
  "./ja/discussion_topics_edit.json": [
    "930399",
    [
      194018
    ]
  ],
  "./he/user_name.json": [
    "788410",
    [
      373442
    ]
  ],
  "./ca/blueprint_course_sidebar.json": [
    "527704",
    [
      321048
    ]
  ],
  "./en-GB/assignments_2_peer_review.json": [
    "906434",
    [
      932135
    ]
  ],
  "./zh-Hant/content_exports.json": [
    "786685",
    [
      58023
    ]
  ],
  "./da/assignments_2_url_entry.json": [
    "333059",
    [
      789545
    ]
  ],
  "./da-x-k12/rate_limiting_settings.json": [
    "992439",
    [
      90777
    ]
  ],
  "./hy/ProfileTray.json": [
    "736224",
    [
      339416
    ]
  ],
  "./is/content_migrations.json": [
    "361145",
    [
      454415
    ]
  ],
  "./zh-Hant/ai_experiences_edit.json": [
    "377529",
    [
      240235
    ]
  ],
  "./id/course_default_due_time.json": [
    "376045",
    [
      937791
    ]
  ],
  "./nn/ai_experiences_ai_conversations.json": [
    "739578",
    [
      375446
    ]
  ],
  "./da-x-k12/suppress_notifications.json": [
    "264805",
    [
      405199
    ]
  ],
  "./sl/link_validator.json": [
    "70406",
    [
      899082
    ]
  ],
  "./en-GB-x-lbs/calendar.header.json": [
    "814625",
    [
      996212
    ]
  ],
  "./ar/outcomes_user_outcome_results.json": [
    "841994",
    [
      894382
    ]
  ],
  "./fr-CA/course_paces_actions.json": [
    "492875",
    [
      26597
    ]
  ],
  "./hi/assignments_2_student_points_display.json": [
    "493525",
    [
      633811
    ]
  ],
  "./zh-Hans/course_paces_modal.json": [
    "405115",
    [
      395305
    ]
  ],
  "./fr/ImportConfirmBox.json": [
    "181834",
    [
      337471
    ]
  ],
  "./cy/AssignmentListItemView.json": [
    "538373",
    [
      848971
    ]
  ],
  "./cy/peer_review_configuration_tray.json": [
    "760827",
    [
      588353
    ]
  ],
  "./ar/question_banks.json": [
    "967827",
    [
      880781
    ]
  ],
  "./id/course_paces_search.json": [
    "687035",
    [
      754732
    ]
  ],
  "./ko/modules_page_icon_legend.json": [
    "139893",
    [
      242379
    ]
  ],
  "./es-ES/content_share_preview_overlay.json": [
    "899442",
    [
      37202
    ]
  ],
  "./he/course_paces_blackout_dates_modal.json": [
    "198275",
    [
      350521
    ]
  ],
  "./fr/appt_calendar_event_dialog.json": [
    "353782",
    [
      975291
    ]
  ],
  "./da-x-k12/assignmentsIndexView.json": [
    "85826",
    [
      366
    ]
  ],
  "./fa/auth_logging.json": [
    "564629",
    [
      227635
    ]
  ],
  "./sl/login.json": [
    "867236",
    [
      147064
    ]
  ],
  "./es-ES/progression_module_header.json": [
    "105135",
    [
      950149
    ]
  ],
  "./sv-x-k12/assignments_2_MoreOptions_CanvasFiles.json": [
    "379940",
    [
      292276
    ]
  ],
  "./fi/canvas_file_upload.json": [
    "605472",
    [
      719176
    ]
  ],
  "./sv-x-k12/peer_review_configuration_tray.json": [
    "596182",
    [
      743662
    ]
  ],
  "./de/webcam_modal.json": [
    "972340",
    [
      33977
    ]
  ],
  "./es/account_calendar_settings_utils.json": [
    "589978",
    [
      936819
    ]
  ],
  "./ca/pairing_code_user_observees.json": [
    "799555",
    [
      49929
    ]
  ],
  "./ga/submissions_show_preview.json": [
    "429302",
    [
      535118
    ]
  ],
  "./ko/edit_section_start_date.json": [
    "431604",
    [
      89148
    ]
  ],
  "./nb/canvas_file_upload.json": [
    "742955",
    [
      672645
    ]
  ],
  "./th/courses.json": [
    "756052",
    [
      275672
    ]
  ],
  "./en-GB/AssignmentListItemView.json": [
    "827026",
    [
      740199
    ]
  ],
  "./pt-BR/blueprint_settingsMigrationOptions.json": [
    "39110",
    [
      620719
    ]
  ],
  "./pt-BR/course_paces_modal.json": [
    "952161",
    [
      256408
    ]
  ],
  "./nl/course_paces_blackout_dates_table.json": [
    "35051",
    [
      125277
    ]
  ],
  "./mi/assignments.no_assignments_search.json": [
    "570471",
    [
      799012
    ]
  ],
  "./pt/blueprint_settingsCourseFilter.json": [
    "706736",
    [
      420204
    ]
  ],
  "./es/LearningMasteryGradebook.json": [
    "424809",
    [
      78744
    ]
  ],
  "./de/quiz_migration_notifications.json": [
    "375658",
    [
      502411
    ]
  ],
  "./es-ES/account_calendar_settings_account_group.json": [
    "555517",
    [
      111675
    ]
  ],
  "./fr-CA/AssignmentListItemView.json": [
    "452434",
    [
      134534
    ]
  ],
  "./id/gradingGradeSummary.json": [
    "631482",
    [
      618190
    ]
  ],
  "./es-ES/MobileGlobalMenu.json": [
    "674971",
    [
      431481
    ]
  ],
  "./ar/k5_dashboard.json": [
    "783984",
    [
      560388
    ]
  ],
  "./id/account_calendar_settings_account_tree.json": [
    "851254",
    [
      196154
    ]
  ],
  "./id/assignments_2_peer_review.json": [
    "776238",
    [
      223298
    ]
  ],
  "./tr/external_content_cancel.json": [
    "239616",
    [
      695972
    ]
  ],
  "./en-AU/sis_import.json": [
    "204955",
    [
      360246
    ]
  ],
  "./en-AU-x-unimelb/course_paces_blueprint_lock.json": [
    "650018",
    [
      182726
    ]
  ],
  "./ja/user_lists.json": [
    "616472",
    [
      174141
    ]
  ],
  "./ru/direct_share_course_import_panel.json": [
    "759745",
    [
      525191
    ]
  ],
  "./it/assignments_2_student_header_date_title.json": [
    "644972",
    [
      800776
    ]
  ],
  "./fi/entity_search_form.json": [
    "889690",
    [
      33786
    ]
  ],
  "./de/important_dates.json": [
    "288825",
    [
      247408
    ]
  ],
  "./is/content_exports.json": [
    "989719",
    [
      325293
    ]
  ],
  "./fr-CA/assignments_2_text_entry.json": [
    "300381",
    [
      918967
    ]
  ],
  "./uk/roster_section_input.json": [
    "566474",
    [
      977986
    ]
  ],
  "./ko/syllabus_revisions.json": [
    "315298",
    [
      193386
    ]
  ],
  "./vi/course_paces_projected_dates.json": [
    "383594",
    [
      25130
    ]
  ],
  "./ja/a2LatePolicyToolTipContent.json": [
    "370664",
    [
      213709
    ]
  ],
  "./mi/gradebook_history.json": [
    "877593",
    [
      922535
    ]
  ],
  "./sv/quiz_show.json": [
    "650580",
    [
      806288
    ]
  ],
  "./it/assignments_2_student_content_rubric_self_assessment.json": [
    "941204",
    [
      409272
    ]
  ],
  "./fi/course_paces_flaggable_number_input.json": [
    "788370",
    [
      829442
    ]
  ],
  "./fa/restore_content_pane.json": [
    "433310",
    [
      160438
    ]
  ],
  "./id/appt_calendar_event_dialog.json": [
    "413245",
    [
      679151
    ]
  ],
  "./ms/suppress_notifications.json": [
    "703422",
    [
      416846
    ]
  ],
  "./nl/OutcomeMoveModal.json": [
    "249510",
    [
      594522
    ]
  ],
  "./es-ES/available_pronouns_list.json": [
    "305258",
    [
      413050
    ]
  ],
  "./sv-x-k12/content_shares.json": [
    "452701",
    [
      869643
    ]
  ],
  "./tr/course_paces_search.json": [
    "34279",
    [
      728481
    ]
  ],
  "./hi/account_calendar_settings_account_list.json": [
    "696604",
    [
      560940
    ]
  ],
  "./fr-CA/outcome_detail.json": [
    "640061",
    [
      91239
    ]
  ],
  "./mi/edit_section_start_date.json": [
    "746192",
    [
      524304
    ]
  ],
  "./fr-CA/widget_dashboard.json": [
    "521830",
    [
      225994
    ]
  ],
  "./hy/link_to_students.json": [
    "586966",
    [
      874366
    ]
  ],
  "./sv-x-k12/quiz_show.json": [
    "747454",
    [
      423830
    ]
  ],
  "./en-GB/blueprint_settingsUnsyncedChanges.json": [
    "799642",
    [
      841807
    ]
  ],
  "./id/AssignmentListItemView.json": [
    "413742",
    [
      97842
    ]
  ],
  "./es-ES/content_exports.json": [
    "718390",
    [
      656046
    ]
  ],
  "./fr-CA/assignments_2_submission_histories_query.json": [
    "96045",
    [
      217031
    ]
  ],
  "./fr-CA/restore_content_pane.json": [
    "883306",
    [
      153998
    ]
  ],
  "./tr/accessibility_course_statistics.json": [
    "307506",
    [
      574902
    ]
  ],
  "./ca/unpublished_changes_tray_contents.json": [
    "408831",
    [
      307597
    ]
  ],
  "./it/account_calendar_settings_footer.json": [
    "649105",
    [
      535387
    ]
  ],
  "./en-GB-x-ukhe/sharedSetDefaultGradeDialog.json": [
    "114575",
    [
      499717
    ]
  ],
  "./fr-CA/assignments_peer_reviews.json": [
    "508504",
    [
      728583
    ]
  ],
  "./ja/available_pronouns_list.json": [
    "26030",
    [
      626191
    ]
  ],
  "./pl/self_unenrollment_modal.json": [
    "977636",
    [
      850480
    ]
  ],
  "./sv/student_entries.json": [
    "809191",
    [
      463313
    ]
  ],
  "./he/LogoutButton.json": [
    "230485",
    [
      777115
    ]
  ],
  "./fr-CA/grade_summaryGroupView.json": [
    "586011",
    [
      999285
    ]
  ],
  "./ga/react_files.json": [
    "247009",
    [
      726007
    ]
  ],
  "./ja/LearningMasteryGradebook.json": [
    "341762",
    [
      745963
    ]
  ],
  "./vi/FindOutcomesModal.json": [
    "142008",
    [
      309328
    ]
  ],
  "./uk/quizzes_openModerateStudentDialog.json": [
    "60364",
    [
      357188
    ]
  ],
  "./ht/overview_page.json": [
    "121893",
    [
      642439
    ]
  ],
  "./ht/course_paces_module.json": [
    "820869",
    [
      137439
    ]
  ],
  "./hu/progressbar_view.json": [
    "434075",
    [
      596385
    ]
  ],
  "./ms/rubrics-export.json": [
    "574401",
    [
      714911
    ]
  ],
  "./el/AddGroup.json": [
    "960571",
    [
      993477
    ]
  ],
  "./ga/course_paces_blackout_dates_table.json": [
    "898089",
    [
      491375
    ]
  ],
  "./nb-x-k12/admin_split.json": [
    "298124",
    [
      97180
    ]
  ],
  "./pl/available_pronouns_list.json": [
    "255895",
    [
      548449
    ]
  ],
  "./el/assignments_2_student_header.json": [
    "541788",
    [
      68960
    ]
  ],
  "./it/video_conference.json": [
    "990015",
    [
      511985
    ]
  ],
  "./pl/outcomes_user_outcome_results.json": [
    "349497",
    [
      756563
    ]
  ],
  "./en-GB-x-lbs/react_files.json": [
    "421935",
    [
      376997
    ]
  ],
  "./fr-CA/OutcomeDescriptionModal.json": [
    "805772",
    [
      491520
    ]
  ],
  "./en-AU/FindOutcomesModal.json": [
    "759675",
    [
      813014
    ]
  ],
  "./ja/assignment_2_assignment_toggle_details.json": [
    "401605",
    [
      222908
    ]
  ],
  "./ja/collaborations.json": [
    "854403",
    [
      153118
    ]
  ],
  "./es/assignments_2_external_tool.json": [
    "951836",
    [
      929897
    ]
  ],
  "./ru/webcam_modal.json": [
    "326930",
    [
      874658
    ]
  ],
  "./zh-Hans/calculator.json": [
    "561887",
    [
      385045
    ]
  ],
  "./he/assignments_2_student_header.json": [
    "826646",
    [
      994582
    ]
  ],
  "./vi/canvas_file_upload.json": [
    "863536",
    [
      306232
    ]
  ],
  "./he/permissions_v2.json": [
    "398882",
    [
      736506
    ]
  ],
  "./ca/quiz_migration_notifications.json": [
    "51379",
    [
      537465
    ]
  ],
  "./de/course_paces_pace_picker.json": [
    "627956",
    [
      108521
    ]
  ],
  "./sv-x-k12/permissions_v2.json": [
    "642902",
    [
      448222
    ]
  ],
  "./fa/context_prior_users.json": [
    "632132",
    [
      575764
    ]
  ],
  "./es/discussion_posts.json": [
    "481066",
    [
      52451
    ]
  ],
  "./en-GB-x-lbs/gradebook.json": [
    "686374",
    [
      530878
    ]
  ],
  "./pt-BR/empty_course.json": [
    "464802",
    [
      581891
    ]
  ],
  "./is/terms_of_service_modal.json": [
    "944262",
    [
      841327
    ]
  ],
  "./el/collaborations.json": [
    "859859",
    [
      258285
    ]
  ],
  "./ru/empty_modules.json": [
    "751916",
    [
      605132
    ]
  ],
  "./ar/jobs_v2.json": [
    "53320",
    [
      496004
    ]
  ],
  "./pl/account_calendars.json": [
    "352229",
    [
      332039
    ]
  ],
  "./mi/video_conference.json": [
    "108602",
    [
      249666
    ]
  ],
  "./nb-x-k12/user_grades.json": [
    "200492",
    [
      791852
    ]
  ],
  "./nb-x-k12/section.json": [
    "703107",
    [
      963793
    ]
  ],
  "./vi/modelsQuiz.json": [
    "367818",
    [
      42810
    ]
  ],
  "./es/account_calendar_settings_footer.json": [
    "230238",
    [
      81199
    ]
  ],
  "./cy/discovery_page.json": [
    "854782",
    [
      132846
    ]
  ],
  "./en-AU-x-unimelb/calendar_custom_recurring_event_repeat_picker.json": [
    "645260",
    [
      588704
    ]
  ],
  "./th/course_logging_details.json": [
    "331200",
    [
      652868
    ]
  ],
  "./uk/bulk_edit_students.json": [
    "35960",
    [
      832824
    ]
  ],
  "./es/gradinggradingPeriodCollection.json": [
    "715419",
    [
      310758
    ]
  ],
  "./ru/accessibility_checker.json": [
    "779431",
    [
      404493
    ]
  ],
  "./zh-Hans/content_shares.json": [
    "822101",
    [
      946867
    ]
  ],
  "./th/comm_messages.json": [
    "824823",
    [
      570169
    ]
  ],
  "./cy/appt_calendar_event_dialog.json": [
    "518670",
    [
      704926
    ]
  ],
  "./ms/quiz_show.json": [
    "333445",
    [
      957803
    ]
  ],
  "./fr-CA/quizzes_public.json": [
    "960058",
    [
      265238
    ]
  ],
  "./fr-CA/media_immersive_view.json": [
    "413769",
    [
      328139
    ]
  ],
  "./it/calculator_command.json": [
    "905391",
    [
      442265
    ]
  ],
  "./fa/assignments_2_MoreOptions_CanvasFiles.json": [
    "781482",
    [
      301850
    ]
  ],
  "./da/course_stats.json": [
    "405194",
    [
      680994
    ]
  ],
  "./pt/assignments_peer_reviews_student.json": [
    "26451",
    [
      115709
    ]
  ],
  "./hi/course_paces_footer.json": [
    "766969",
    [
      998991
    ]
  ],
  "./mi/peer_reviews_student.json": [
    "735326",
    [
      751534
    ]
  ],
  "./fi/modules_page_icon_legend.json": [
    "809656",
    [
      685680
    ]
  ],
  "./tr/outcomes_user_outcome_results.json": [
    "93319",
    [
      174065
    ]
  ],
  "./mi/assignments_2_MoreOptions_CanvasFiles.json": [
    "311845",
    [
      620811
    ]
  ],
  "./de/unpublished_changes_tray_contents.json": [
    "168708",
    [
      756761
    ]
  ],
  "./hi/editGroup.json": [
    "264606",
    [
      855302
    ]
  ],
  "./en-GB-x-ukhe/assignments_2_student_header_date_title.json": [
    "194839",
    [
      26109
    ]
  ],
  "./ht/quiz_log_auditing.json": [
    "678174",
    [
      318506
    ]
  ],
  "./ht/course_paces_projected_dates.json": [
    "123725",
    [
      15975
    ]
  ],
  "./zh-Hans/course_paces_header.json": [
    "301035",
    [
      446665
    ]
  ],
  "./hy/custom_help_link.json": [
    "54215",
    [
      174077
    ]
  ],
  "./sl/MobileGlobalMenu.json": [
    "885241",
    [
      516987
    ]
  ],
  "./fr/direct_share_course_import_panel.json": [
    "31366",
    [
      892427
    ]
  ],
  "./uk/direct_share_course_import_panel.json": [
    "606454",
    [
      848870
    ]
  ],
  "./fa/theme_editor.json": [
    "811862",
    [
      356670
    ]
  ],
  "./da/group_submission_reminder.json": [
    "65446",
    [
      871798
    ]
  ],
  "./pt-BR/account_calendar_settings_filter_controls.json": [
    "956259",
    [
      797497
    ]
  ],
  "./nl/SpeedGraderDiscussionsNavigation.json": [
    "47963",
    [
      906213
    ]
  ],
  "./id/assignments_2_attempt_tab.json": [
    "433054",
    [
      306210
    ]
  ],
  "./vi/course_restore.json": [
    "830189",
    [
      615339
    ]
  ],
  "./fr-CA/course_color_selector.json": [
    "752000",
    [
      250396
    ]
  ],
  "./hu/calculator.json": [
    "514203",
    [
      64353
    ]
  ],
  "./vi/collaborations.json": [
    "990903",
    [
      197965
    ]
  ],
  "./en-CA/course_paces_app.json": [
    "608936",
    [
      138016
    ]
  ],
  "./nl/assignments_2_MoreOptions.json": [
    "922041",
    [
      892987
    ]
  ],
  "./ca/assignments_2_student_content.json": [
    "984219",
    [
      757585
    ]
  ],
  "./nn/widget_dashboard.json": [
    "561229",
    [
      252687
    ]
  ],
  "./tr/peer_review_configuration_tray.json": [
    "427033",
    [
      682979
    ]
  ],
  "./hi/account_calendar_settings_account_calendar_item_dropdown.json": [
    "903144",
    [
      403344
    ]
  ],
  "./da-x-k12/widget_dashboard.json": [
    "355742",
    [
      19434
    ]
  ],
  "./fi/course_paces_blueprint_lock.json": [
    "723463",
    [
      48733
    ]
  ],
  "./da/custom_emoji_deny_list.json": [
    "191073",
    [
      515727
    ]
  ],
  "./en-GB-x-lbs/default_account_quotas.json": [
    "249523",
    [
      995585
    ]
  ],
  "./is/account_calendars.json": [
    "824401",
    [
      484519
    ]
  ],
  "./sv-x-k12/EditMasteryScaleLink.json": [
    "455390",
    [
      393142
    ]
  ],
  "./de/course_paces_no_results.json": [
    "315392",
    [
      203709
    ]
  ],
  "./sl/rubrics-export.json": [
    "230884",
    [
      121656
    ]
  ],
  "./fi/content_share_preview_overlay.json": [
    "373058",
    [
      241266
    ]
  ],
  "./en-GB-x-lbs/assignments_peer_reviews.json": [
    "895493",
    [
      914035
    ]
  ],
  "./nb-x-k12/speed_grader_helpers.json": [
    "342445",
    [
      491835
    ]
  ],
  "./pl/quiz_migration_notifications.json": [
    "360699",
    [
      479445
    ]
  ],
  "./tr/context_modules_v2.json": [
    "211870",
    [
      110986
    ]
  ],
  "./ca/new_nav.json": [
    "690090",
    [
      750306
    ]
  ],
  "./is/assignments_2_file_upload.json": [
    "991044",
    [
      600020
    ]
  ],
  "./fi/todos_page.json": [
    "620412",
    [
      192332
    ]
  ],
  "./tr/OutcomeDescriptionModal.json": [
    "407971",
    [
      649109
    ]
  ],
  "./ht/license_help.json": [
    "156997",
    [
      810095
    ]
  ],
  "./nb-x-k12/important_dates_empty.json": [
    "191930",
    [
      161482
    ]
  ],
  "./en-CA/sections_tooltip.json": [
    "585458",
    [
      157378
    ]
  ],
  "./ca/todo.json": [
    "190222",
    [
      613806
    ]
  ],
  "./cy/announcements_on_home_page.json": [
    "715418",
    [
      486082
    ]
  ],
  "./ht/ldap_cert_upload.json": [
    "99098",
    [
      985534
    ]
  ],
  "./ms/account_course_user_search.json": [
    "14164",
    [
      48876
    ]
  ],
  "./en-AU-x-unimelb/course_paces_projected_dates.json": [
    "196981",
    [
      88727
    ]
  ],
  "./tr/dashboard.json": [
    "43016",
    [
      316052
    ]
  ],
  "./tr/sidenav.json": [
    "137720",
    [
      309676
    ]
  ],
  "./es/user.json": [
    "496657",
    [
      700064
    ]
  ],
  "./pl/DueDateOverrideView.json": [
    "82393",
    [
      551867
    ]
  ],
  "./is/GroupsTray.json": [
    "181654",
    [
      570542
    ]
  ],
  "./fi/announcements_v2.json": [
    "478676",
    [
      578612
    ]
  ],
  "./pt-BR/IndividualStudentMasteryOutcome.json": [
    "520254",
    [
      96247
    ]
  ],
  "./fi/gradingPeriodTemplate.json": [
    "171792",
    [
      331224
    ]
  ],
  "./fr/ai_experiences.json": [
    "154074",
    [
      502495
    ]
  ],
  "./sv/assignments_2_student_content_rubric_self_assessment.json": [
    "986176",
    [
      366372
    ]
  ],
  "./is/account_calendar_settings.json": [
    "599060",
    [
      480820
    ]
  ],
  "./da-x-k12/calendar_edit.json": [
    "381072",
    [
      377276
    ]
  ],
  "./he/youtube_migration.json": [
    "342459",
    [
      749345
    ]
  ],
  "./nb-x-k12/grades_summary.json": [
    "946995",
    [
      157441
    ]
  ],
  "./de/entity_search_form.json": [
    "374316",
    [
      284321
    ]
  ],
  "./th/ProfileTray.json": [
    "162299",
    [
      698669
    ]
  ],
  "./tr/pseudonyms_mobile_login.json": [
    "444108",
    [
      914968
    ]
  ],
  "./da/course_color_selector.json": [
    "435994",
    [
      392498
    ]
  ],
  "./uk/account_calendar_settings_confirmation_modal.json": [
    "84318",
    [
      479166
    ]
  ],
  "./mi/conferences_alternatives.json": [
    "593172",
    [
      88556
    ]
  ],
  "./th/peer_review_allocation_rule_card.json": [
    "751012",
    [
      417976
    ]
  ],
  "./ca/blueprint_settingsUnsyncedChanges.json": [
    "298787",
    [
      478569
    ]
  ],
  "./en-AU-x-unimelb/default_account_quotas.json": [
    "707557",
    [
      546183
    ]
  ],
  "./ar/default_account_quotas.json": [
    "966252",
    [
      539080
    ]
  ],
  "./hy/roster_publicjs.json": [
    "136003",
    [
      862657
    ]
  ],
  "./de/users.json": [
    "428129",
    [
      777832
    ]
  ],
  "./pl/quizzes_quiz_submission.json": [
    "582258",
    [
      679910
    ]
  ],
  "./ar/account_calendar_settings_account_calendar_item.json": [
    "238280",
    [
      106612
    ]
  ],
  "./zh-Hans/course_search_results.json": [
    "502050",
    [
      878274
    ]
  ],
  "./en-AU.eager.json": [
    "874493",
    [
      441896
    ]
  ],
  "./pt-BR/student_annotation_preview.json": [
    "217367",
    [
      492850
    ]
  ],
  "./vi/account_course_user_search.json": [
    "609707",
    [
      352761
    ]
  ],
  "./fi/quizzes_openModerateStudentDialog.json": [
    "68669",
    [
      713019
    ]
  ],
  "./ht/discussion_insights.json": [
    "511022",
    [
      404770
    ]
  ],
  "./sl/content_exports.json": [
    "405016",
    [
      245396
    ]
  ],
  "./zh-Hans/auth_logging.json": [
    "900299",
    [
      783897
    ]
  ],
  "./en-GB-x-ukhe/conferences.json": [
    "580439",
    [
      641661
    ]
  ],
  "./it/account_calendar_settings_utils.json": [
    "541855",
    [
      754257
    ]
  ],
  "./it/course_paces_settings.json": [
    "561917",
    [
      840343
    ]
  ],
  "./sl/assignments_2_file_upload.json": [
    "991995",
    [
      753661
    ]
  ],
  "./tr/canvascareer.json": [
    "763726",
    [
      61034
    ]
  ],
  "./hi/epub_exports.json": [
    "733057",
    [
      368343
    ]
  ],
  "./zh-Hant/user_grades.json": [
    "146212",
    [
      550848
    ]
  ],
  "./ja/group_submission_reminder.json": [
    "162676",
    [
      971441
    ]
  ],
  "./mi/quiz_show.json": [
    "189907",
    [
      822121
    ]
  ],
  "./da-x-k12/OutcomeDescriptionModal.json": [
    "64980",
    [
      258592
    ]
  ],
  "./pt-BR/course_paces_module.json": [
    "690876",
    [
      541729
    ]
  ],
  "./nn/permission_button.json": [
    "856430",
    [
      381290
    ]
  ],
  "./th/discussion_create.json": [
    "444895",
    [
      591857
    ]
  ],
  "./mi/course_paces_search.json": [
    "365559",
    [
      535397
    ]
  ],
  "./en-AU/course_template_details.json": [
    "721533",
    [
      228404
    ]
  ],
  "./th/discussion_topics.json": [
    "334187",
    [
      365629
    ]
  ],
  "./ko/course_paces_modal.json": [
    "806700",
    [
      77956
    ]
  ],
  "./hu/submit_assignment.json": [
    "235225",
    [
      397319
    ]
  ],
  "./sl/user_date_range_search.json": [
    "421024",
    [
      834772
    ]
  ],
  "./th/course_paces_empty_state.json": [
    "868144",
    [
      899604
    ]
  ],
  "./he/admin_split.json": [
    "285937",
    [
      349199
    ]
  ],
  "./nb/epub_exports.json": [
    "346260",
    [
      685320
    ]
  ],
  "./sv/OutcomeDescriptionModal.json": [
    "835772",
    [
      266608
    ]
  ],
  "./cy/entity_search_form.json": [
    "739673",
    [
      631399
    ]
  ],
  "./vi/calendar_edit.json": [
    "612364",
    [
      847228
    ]
  ],
  "./zh-Hant/content_shares.json": [
    "843026",
    [
      885734
    ]
  ],
  "./pt-BR/webcam_modal.json": [
    "138882",
    [
      369267
    ]
  ],
  "./sl/sidenav.json": [
    "743981",
    [
      71471
    ]
  ],
  "./sv/account_calendar_settings_filter_controls.json": [
    "365279",
    [
      272625
    ]
  ],
  "./zh-Hant/assignment_show.json": [
    "702827",
    [
      463373
    ]
  ],
  "./cy/empty_modules.json": [
    "618405",
    [
      303691
    ]
  ],
  "./hi/important_dates.json": [
    "500593",
    [
      234007
    ]
  ],
  "./vi/notebook.json": [
    "349784",
    [
      166096
    ]
  ],
  "./el/files_v2.json": [
    "960697",
    [
      355163
    ]
  ],
  "./sv-x-k12/blueprint_settingsCoursePicker.json": [
    "557025",
    [
      947991
    ]
  ],
  "./ht/SpeedGraderCheckpoints.json": [
    "818497",
    [
      176795
    ]
  ],
  "./th/course_paces_blackout_dates_table.json": [
    "176613",
    [
      864191
    ]
  ],
  "./he/auth_logging.json": [
    "362279",
    [
      72245
    ]
  ],
  "./el/remove_pace_warning_modal.json": [
    "405168",
    [
      854428
    ]
  ],
  "./is/blueprint_settingsCourseFilter.json": [
    "150916",
    [
      658244
    ]
  ],
  "./ht/webcam_modal.json": [
    "144849",
    [
      295643
    ]
  ],
  "./fr-CA/DueDateOverrideView.json": [
    "469256",
    [
      80892
    ]
  ],
  "./da-x-k12/blueprint_settingsCourseFilter.json": [
    "102403",
    [
      533005
    ]
  ],
  "./da-x-k12/link_validator.json": [
    "412572",
    [
      293944
    ]
  ],
  "./zh-Hant/course_paces_change_tracking.json": [
    "25033",
    [
      332811
    ]
  ],
  "./th/copy_course.json": [
    "597657",
    [
      313376
    ]
  ],
  "./fi/course_paces_actions.json": [
    "910591",
    [
      149493
    ]
  ],
  "./ar/react_files.json": [
    "498202",
    [
      936838
    ]
  ],
  "./en-AU/assignments_2_peer_review.json": [
    "851913",
    [
      165992
    ]
  ],
  "./hi/bulk_edit_students_actions.json": [
    "767329",
    [
      74951
    ]
  ],
  "./nb-x-k12/user_logins.json": [
    "292702",
    [
      824006
    ]
  ],
  "./zh-Hans/sidenav.json": [
    "620637",
    [
      419147
    ]
  ],
  "./hu/external_content_cancel.json": [
    "620429",
    [
      114627
    ]
  ],
  "./da-x-k12/epub_exports.json": [
    "38211",
    [
      314301
    ]
  ],
  "./he/course_stats.json": [
    "318378",
    [
      149266
    ]
  ],
  "./ru/SpeedGraderPostGradesMenu.json": [
    "471234",
    [
      664834
    ]
  ],
  "./vi/important_dates.json": [
    "190208",
    [
      645377
    ]
  ],
  "./th/outcome_reporting.json": [
    "953435",
    [
      828485
    ]
  ],
  "./ca/assignments_peer_reviews.json": [
    "785999",
    [
      947101
    ]
  ],
  "./nl/peer_review_student_select.json": [
    "114434",
    [
      220793
    ]
  ],
  "./ja/peer_review_allocation_rule_card.json": [
    "144839",
    [
      372362
    ]
  ],
  "./nl/password_complexity_configuration.json": [
    "511087",
    [
      7545
    ]
  ],
  "./nl/IndividualStudentMasteryOutcome.json": [
    "618597",
    [
      736671
    ]
  ],
  "./vi/assignments_2_peer_review.json": [
    "716686",
    [
      844454
    ]
  ],
  "./ht/group_submission_reminder.json": [
    "240265",
    [
      557243
    ]
  ],
  "./en-AU-x-unimelb/new_user_tutorial.json": [
    "937465",
    [
      145571
    ]
  ],
  "./en-AU/account_calendars.json": [
    "527691",
    [
      890534
    ]
  ],
  "./en-GB-x-ukhe/blueprint_course_sidebar.json": [
    "104786",
    [
      532402
    ]
  ],
  "./hy/course_paces_blackout_dates_table.json": [
    "556478",
    [
      532598
    ]
  ],
  "./is/CourseAvailabilityOptions.json": [
    "249174",
    [
      361742
    ]
  ],
  "./ar/unpublished_warning_modal.json": [
    "40059",
    [
      420373
    ]
  ],
  "./da-x-k12/modelsQuiz.json": [
    "392870",
    [
      293626
    ]
  ],
  "./hu/content_shares.json": [
    "643049",
    [
      460375
    ]
  ],
  "./en-GB-x-lbs/edit_section_view.json": [
    "207448",
    [
      38752
    ]
  ],
  "./ga/new_nav.json": [
    "599438",
    [
      880086
    ]
  ],
  "./he/unpublished_warning_modal.json": [
    "69679",
    [
      326669
    ]
  ],
  "./vi/course_paces_blackout_date_row.json": [
    "356061",
    [
      144347
    ]
  ],
  "./vi/notebook_index.json": [
    "533979",
    [
      716553
    ]
  ],
  "./pt-BR/plugins.json": [
    "125643",
    [
      604958
    ]
  ],
  "./ar/account_calendars_results_area.json": [
    "917285",
    [
      857591
    ]
  ],
  "./zh-Hans/quiz_migration_notifications.json": [
    "736074",
    [
      181306
    ]
  ],
  "./ht/permissions_role_tray_table_row.json": [
    "864280",
    [
      674916
    ]
  ],
  "./es-ES/discussionTopicKeyboradShortcutModal.json": [
    "429862",
    [
      496622
    ]
  ],
  "./pt/suppress_notifications.json": [
    "52270",
    [
      431210
    ]
  ],
  "./zh-Hans/horizon_toggle.json": [
    "938107",
    [
      553721
    ]
  ],
  "./it/ImportConfirmBox.json": [
    "301305",
    [
      906811
    ]
  ],
  "./th/discussion_settings.json": [
    "834694",
    [
      541226
    ]
  ],
  "./ca/progress_pill.json": [
    "632837",
    [
      652027
    ]
  ],
  "./ht/gradebook.json": [
    "29400",
    [
      350228
    ]
  ],
  "./es/security_panel.json": [
    "702037",
    [
      140828
    ]
  ],
  "./nb-x-k12/SpeedGraderPostGradesMenu.json": [
    "612009",
    [
      766831
    ]
  ],
  "./nn/IndividualStudentMasteryOutcome.json": [
    "739919",
    [
      79153
    ]
  ],
  "./nb-x-k12/calendar_custom_recurring_event_natural_language.json": [
    "945316",
    [
      450932
    ]
  ],
  "./is/unpublished_warning_modal.json": [
    "549188",
    [
      877956
    ]
  ],
  "./ga/user_search_results.json": [
    "55951",
    [
      847861
    ]
  ],
  "./ca/outcome_alignment_v2.json": [
    "775465",
    [
      851623
    ]
  ],
  "./mi/calculator_command.json": [
    "641082",
    [
      964578
    ]
  ],
  "./th/pairing_code_user_observees.json": [
    "993331",
    [
      247957
    ]
  ],
  "./ga/grade_change_logging_content.json": [
    "737570",
    [
      284178
    ]
  ],
  "./mi/bulk_edit_students_actions.json": [
    "587362",
    [
      145466
    ]
  ],
  "./ht/assignment_show.json": [
    "258253",
    [
      120895
    ]
  ],
  "./sv/roster_section_selector.json": [
    "581190",
    [
      128682
    ]
  ],
  "./ht/restore_content_pane.json": [
    "396253",
    [
      37631
    ]
  ],
  "./en-GB-x-lbs/accessibility_scan.json": [
    "437400",
    [
      999184
    ]
  ],
  "./ca/account_notification_settings.json": [
    "842995",
    [
      492409
    ]
  ],
  "./da-x-k12/editGroup.json": [
    "207260",
    [
      256240
    ]
  ],
  "./en-GB-x-ukhe/discussion_topics.json": [
    "946385",
    [
      387271
    ]
  ],
  "./en-GB-x-lbs/password_complexity_configuration.json": [
    "912031",
    [
      513173
    ]
  ],
  "./he/course_paces_projected_dates.json": [
    "66516",
    [
      51084
    ]
  ],
  "./he/custom_help_link.json": [
    "42947",
    [
      404729
    ]
  ],
  "./en-GB-x-lbs/course_paces_empty_state.json": [
    "568002",
    [
      994098
    ]
  ],
  "./nl/LearningMasteryGradebook.json": [
    "669483",
    [
      790573
    ]
  ],
  "./cy/notebook.json": [
    "274451",
    [
      38217
    ]
  ],
  "./pt-BR/available_pronouns_list.json": [
    "771274",
    [
      244107
    ]
  ],
  "./sl/course_paces_blueprint_lock.json": [
    "879541",
    [
      23031
    ]
  ],
  "./mi/MobileNavigation.json": [
    "394300",
    [
      127204
    ]
  ],
  "./ga/calendar_custom_recurring_event_natural_language.json": [
    "508914",
    [
      678530
    ]
  ],
  "./ga/unpublished_changes_tray_contents.json": [
    "76955",
    [
      13785
    ]
  ],
  "./th/admin_split.json": [
    "281054",
    [
      159874
    ]
  ],
  "./hi/blueprint_settingsMigrationSync.json": [
    "881493",
    [
      226371
    ]
  ],
  "./el/account_calendar_settings_confirmation_modal.json": [
    "304853",
    [
      949895
    ]
  ],
  "./mi/assignments_2_student_content.json": [
    "840141",
    [
      259811
    ]
  ],
  "./fi/assignments_2_student_header.json": [
    "797592",
    [
      193200
    ]
  ],
  "./ru/terms_of_use.json": [
    "244080",
    [
      194808
    ]
  ],
  "./tr/user_logins.json": [
    "932886",
    [
      470866
    ]
  ],
  "./uk/course_paces_errors.json": [
    "49430",
    [
      815622
    ]
  ],
  "./pt/grade_change_logging_content.json": [
    "42494",
    [
      977426
    ]
  ],
  "./zh-Hans/upload_button.json": [
    "284071",
    [
      775421
    ]
  ],
  "./hy/peer_reviews_student.json": [
    "147625",
    [
      273983
    ]
  ],
  "./ht/file_not_found.json": [
    "622433",
    [
      115267
    ]
  ],
  "./en-GB-x-ukhe/grades_summary.json": [
    "949759",
    [
      534293
    ]
  ],
  "./da/custom_help_link.json": [
    "900771",
    [
      19465
    ]
  ],
  "./hi/course_paces_header.json": [
    "193779",
    [
      866017
    ]
  ],
  "./fi/progression_module_header.json": [
    "114719",
    [
      180133
    ]
  ],
  "./mi/assignment_index.json": [
    "976798",
    [
      392206
    ]
  ],
  "./nl/login.json": [
    "809870",
    [
      322603
    ]
  ],
  "./nb-x-k12/link_to_students.json": [
    "616957",
    [
      791627
    ]
  ],
  "./da/assignments_2_text_entry.json": [
    "335795",
    [
      509529
    ]
  ],
  "./fi/account_calendar_settings_footer.json": [
    "736881",
    [
      663223
    ]
  ],
  "./fi/react_collaborations.json": [
    "800803",
    [
      518609
    ]
  ],
  "./is/license_help.json": [
    "246585",
    [
      385503
    ]
  ],
  "./nn/assignments_2_external_tool.json": [
    "59336",
    [
      356788
    ]
  ],
  "./is/notebook_index.json": [
    "16476",
    [
      103596
    ]
  ],
  "./de/assignments_bulk_edit_use_save_assignment.json": [
    "56397",
    [
      126860
    ]
  ],
  "./ru/auth_logging.json": [
    "407837",
    [
      37595
    ]
  ],
  "./hi/assignments_peer_reviews_student.json": [
    "803474",
    [
      776066
    ]
  ],
  "./ga/gradebookOutcomeGradebookView.json": [
    "277627",
    [
      406825
    ]
  ],
  "./sv-x-k12/course_navigation_settings.json": [
    "254399",
    [
      355109
    ]
  ],
  "./es-ES/default_account_quotas.json": [
    "339218",
    [
      319922
    ]
  ],
  "./en-AU/nav_tourpoints.json": [
    "704267",
    [
      300326
    ]
  ],
  "./fa/DueDateOverrideView.json": [
    "521828",
    [
      843892
    ]
  ],
  "./nn/canvas_file_upload.json": [
    "366439",
    [
      347473
    ]
  ],
  "./ar/webzip_export.json": [
    "115621",
    [
      204431
    ]
  ],
  "./hy/AssignmentGroupListItemView.json": [
    "724807",
    [
      300301
    ]
  ],
  "./ko/permission_button.json": [
    "768700",
    [
      18644
    ]
  ],
  "./zh-Hans/blueprint_course_sidebar.json": [
    "791973",
    [
      520419
    ]
  ],
  "./pt/manage_avatars.json": [
    "718200",
    [
      338796
    ]
  ],
  "./pt/blueprint_settingsCoursePicker.json": [
    "513612",
    [
      234072
    ]
  ],
  "./hy/course_paces_footer.json": [
    "54601",
    [
      605599
    ]
  ],
  "./es/todo.json": [
    "92950",
    [
      572839
    ]
  ],
  "./is/dashboard.json": [
    "298402",
    [
      535810
    ]
  ],
  "./nb-x-k12/quiz_show.json": [
    "428779",
    [
      215913
    ]
  ],
  "./pt/sidenav.json": [
    "158018",
    [
      926382
    ]
  ],
  "./ru/assignments.never_drop.json": [
    "894263",
    [
      52174
    ]
  ],
  "./is/user_logins.json": [
    "583748",
    [
      385748
    ]
  ],
  "./hu/permissions_role_tray_table_row.json": [
    "441847",
    [
      393285
    ]
  ],
  "./en-AU-x-unimelb/license_help.json": [
    "541805",
    [
      716127
    ]
  ],
  "./fi/IndividualStudentMasteryOutcome.json": [
    "846958",
    [
      43030
    ]
  ],
  "./vi/gradebook_history.json": [
    "229478",
    [
      412014
    ]
  ],
  "./es-ES/blueprint_settingsUnsyncedChanges.json": [
    "777190",
    [
      295374
    ]
  ],
  "./it/terms_index.json": [
    "474815",
    [
      959537
    ]
  ],
  "./nb/assignments_2_url_entry.json": [
    "198600",
    [
      44332
    ]
  ],
  "./es/progressbar_view.json": [
    "606798",
    [
      633727
    ]
  ],
  "./he/account_settings.json": [
    "269130",
    [
      433938
    ]
  ],
  "./nl/rubrics-export.json": [
    "441551",
    [
      660281
    ]
  ],
  "./en-GB-x-lbs/assignments_2_student_content_rubric_self_assessment.json": [
    "221681",
    [
      550055
    ]
  ],
  "./nl/edit_section_end_date.json": [
    "478747",
    [
      891565
    ]
  ],
  "./is/user_restore.json": [
    "933376",
    [
      498904
    ]
  ],
  "./nn/user_grades.json": [
    "269302",
    [
      546146
    ]
  ],
  "./sv-x-k12/OutcomeDescriptionModal.json": [
    "167558",
    [
      170814
    ]
  ],
  "./th/quiz_statistics.json": [
    "951131",
    [
      725181
    ]
  ],
  "./nn/discussion_topics.json": [
    "548583",
    [
      611241
    ]
  ],
  "./da/quizzes.take_quiz.json": [
    "605623",
    [
      989816
    ]
  ],
  "./ja/quiz_statistics.json": [
    "583590",
    [
      943847
    ]
  ],
  "./sv/HelpTray.json": [
    "905342",
    [
      487618
    ]
  ],
  "./ga/lti_registrations.json": [
    "578812",
    [
      874556
    ]
  ],
  "./sl/course_pace_date_input.json": [
    "17682",
    [
      946758
    ]
  ],
  "./ja/peer_review_student_select.json": [
    "336327",
    [
      128714
    ]
  ],
  "./mi/announcements_on_home_page.json": [
    "269024",
    [
      522048
    ]
  ],
  "./nl/grades_summary.json": [
    "911031",
    [
      808081
    ]
  ],
  "./tr/edit_section_dates.json": [
    "279870",
    [
      422234
    ]
  ],
  "./ht/available_pronouns_list.json": [
    "701255",
    [
      130801
    ]
  ],
  "./ko/discussion_pinned_post.json": [
    "446102",
    [
      270246
    ]
  ],
  "./zh-Hant/NewTabIndicator.json": [
    "274062",
    [
      772418
    ]
  ],
  "./uk/roster_publicjs.json": [
    "246524",
    [
      580852
    ]
  ],
  "./ru/jobs_v2.json": [
    "182154",
    [
      441242
    ]
  ],
  "./fr/new_nav.json": [
    "71770",
    [
      967943
    ]
  ],
  "./de/discussion_settings.json": [
    "303685",
    [
      817172
    ]
  ],
  "./tr/copy_warnings_modal.json": [
    "508997",
    [
      54215
    ]
  ],
  "./es/sharedCurveGradesDialog.json": [
    "20290",
    [
      125019
    ]
  ],
  "./el/default_account_quotas.json": [
    "870318",
    [
      731490
    ]
  ],
  "./de/canvas_file_upload.json": [
    "442270",
    [
      392103
    ]
  ],
  "./es-ES/IndividualStudentMasteryOutcome.json": [
    "993566",
    [
      470774
    ]
  ],
  "./es-ES/content_copy_redesign.json": [
    "114548",
    [
      925396
    ]
  ],
  "./de/quizzes_regrade_modal.json": [
    "635129",
    [
      738560
    ]
  ],
  "./tr/HelpTray.json": [
    "672579",
    [
      660589
    ]
  ],
  "./he/context_roster_user_services.json": [
    "14559",
    [
      638781
    ]
  ],
  "./ms/user.json": [
    "397513",
    [
      26743
    ]
  ],
  "./uk/progress_pill.json": [
    "870981",
    [
      48507
    ]
  ],
  "./vi/react_scheduler.json": [
    "451466",
    [
      377386
    ]
  ],
  "./ar/password_complexity_configuration.json": [
    "542774",
    [
      915530
    ]
  ],
  "./sv/knowledge_check_not_ready.json": [
    "33618",
    [
      567958
    ]
  ],
  "./hu/media_player_iframe_content.json": [
    "992286",
    [
      223022
    ]
  ],
  "./es/conferences_alternatives.json": [
    "733098",
    [
      231491
    ]
  ],
  "./en-AU-x-unimelb/comm_messages.json": [
    "844903",
    [
      590385
    ]
  ],
  "./fa/sidenav.json": [
    "184559",
    [
      274773
    ]
  ],
  "./fr-CA/error_form.json": [
    "562560",
    [
      451916
    ]
  ],
  "./ht/discussion_create.json": [
    "988679",
    [
      682009
    ]
  ],
  "./is/grade_change_logging_content.json": [
    "399194",
    [
      230330
    ]
  ],
  "./fr-CA/blueprint_settingsAssociationsTable.json": [
    "692708",
    [
      730272
    ]
  ],
  "./fr/FindOutcomesModal.json": [
    "833781",
    [
      950632
    ]
  ],
  "./nl/AddGroup.json": [
    "334566",
    [
      231458
    ]
  ],
  "./fa/gradebook_uploads.json": [
    "115068",
    [
      698636
    ]
  ],
  "./sl/webzip_export.json": [
    "393229",
    [
      600911
    ]
  ],
  "./sv/CommentLibrary.json": [
    "555969",
    [
      910243
    ]
  ],
  "./th/gradebookActionMenu.json": [
    "262193",
    [
      486195
    ]
  ],
  "./vi/discovery_page.json": [
    "676945",
    [
      235495
    ]
  ],
  "./is/user_grades.json": [
    "981358",
    [
      929078
    ]
  ],
  "./nl/ImportConfirmBox.json": [
    "944936",
    [
      1404
    ]
  ],
  "./vi/grade_change_logging_content.json": [
    "382125",
    [
      13467
    ]
  ],
  "./id/self_unenrollment_modal.json": [
    "584321",
    [
      952411
    ]
  ],
  "./sl/course_search_results.json": [
    "675570",
    [
      847478
    ]
  ],
  "./vi/content_share_preview_overlay.json": [
    "239218",
    [
      336514
    ]
  ],
  "./hy/youtube_migration.json": [
    "996751",
    [
      495941
    ]
  ],
  "./zh-Hans/suppress_notifications.json": [
    "778311",
    [
      314749
    ]
  ],
  "./ms.eager.json": [
    "414003",
    [
      117494
    ]
  ],
  "./th/AssignmentListItemView.json": [
    "201805",
    [
      872479
    ]
  ],
  "./pt-BR/HelpTray.json": [
    "79922",
    [
      163331
    ]
  ],
  "./es/LogoutButton.json": [
    "239472",
    [
      279621
    ]
  ],
  "./ms/dashboard.json": [
    "827710",
    [
      700942
    ]
  ],
  "./it/blueprint_settingsSyncChange.json": [
    "537735",
    [
      353345
    ]
  ],
  "./id/sharedSetDefaultGradeDialog.json": [
    "481112",
    [
      923964
    ]
  ],
  "./id/course_paces_pace_picker.json": [
    "481370",
    [
      497694
    ]
  ],
  "./fa/AssignmentListItemView.json": [
    "851494",
    [
      78734
    ]
  ],
  "./cy/course_pace_date_input.json": [
    "271575",
    [
      951621
    ]
  ],
  "./ja/restore_content_pane.json": [
    "915098",
    [
      123715
    ]
  ],
  "./ru/k5_dashboard_card.json": [
    "169057",
    [
      765991
    ]
  ],
  "./fa/course_paces_blackout_dates_table.json": [
    "986300",
    [
      868956
    ]
  ],
  "./is/default_account_quotas.json": [
    "106001",
    [
      836295
    ]
  ],
  "./en-CA/course_paces_header.json": [
    "50468",
    [
      413924
    ]
  ],
  "./sv-x-k12/grade_summary.json": [
    "38789",
    [
      739203
    ]
  ],
  "./ko/assignment_index_menu.json": [
    "457332",
    [
      998460
    ]
  ],
  "./tr/assignments_2_peer_review.json": [
    "494705",
    [
      730459
    ]
  ],
  "./en-GB-x-lbs/outcome_management.json": [
    "111950",
    [
      283222
    ]
  ],
  "./fr/quiz_show.json": [
    "93717",
    [
      203360
    ]
  ],
  "./en-GB-x-ukhe/quizzes_openModerateStudentDialog.json": [
    "819458",
    [
      210210
    ]
  ],
  "./sv-x-k12/gradinggradingPeriodCollection.json": [
    "399306",
    [
      221562
    ]
  ],
  "./mi/grades_empty_page.json": [
    "412688",
    [
      914288
    ]
  ],
  "./hy/accessibility_scan.json": [
    "352295",
    [
      693229
    ]
  ],
  "./it/calendar_edit.json": [
    "903260",
    [
      435824
    ]
  ],
  "./zh-Hant/blueprint_settingsAssociationsTable.json": [
    "511519",
    [
      5281
    ]
  ],
  "./th/user_grades.json": [
    "936914",
    [
      553310
    ]
  ],
  "./da/confirmMasteryModal.json": [
    "750239",
    [
      2189
    ]
  ],
  "./cy/choose_mastery_path.json": [
    "38653",
    [
      591699
    ]
  ],
  "./el/speed_grader_helpers.json": [
    "575748",
    [
      405456
    ]
  ],
  "./he/account_notification_settings.json": [
    "561908",
    [
      442284
    ]
  ],
  "./hy/assignments_2_shared_Steps.json": [
    "921606",
    [
      43278
    ]
  ],
  "./cy/account_calendar_settings_confirmation_modal.json": [
    "753398",
    [
      174870
    ]
  ],
  "./nn/assignmentsIndexView.json": [
    "742153",
    [
      379771
    ]
  ],
  "./vi/course_paces_footer.json": [
    "597399",
    [
      510429
    ]
  ],
  "./nl/permissions_role_tray.json": [
    "622174",
    [
      253914
    ]
  ],
  "./fi/user_restore.json": [
    "755671",
    [
      597661
    ]
  ],
  "./sv/bulk_edit_students_actions.json": [
    "7767",
    [
      322473
    ]
  ],
  "./fr/k5_course.json": [
    "518006",
    [
      901907
    ]
  ],
  "./ja/modules_home_page.json": [
    "268514",
    [
      220811
    ]
  ],
  "./nb/context_modules_v2.json": [
    "333988",
    [
      102184
    ]
  ],
  "./is/media_immersive_view.json": [
    "291394",
    [
      194338
    ]
  ],
  "./nl/CoursesTray.json": [
    "170226",
    [
      432502
    ]
  ],
  "./cy/module_student_view_peer_reviews.json": [
    "235217",
    [
      668495
    ]
  ],
  "./ru/gradebook_default_gradebook_components_content_filters_module_filter.json": [
    "912773",
    [
      655459
    ]
  ],
  "./nb-x-k12/assignments_2_url_entry.json": [
    "795870",
    [
      29462
    ]
  ],
  "./fr-CA/EditMasteryScaleLink.json": [
    "382236",
    [
      632688
    ]
  ],
  "./mi/blueprint_settingsCourseFilter.json": [
    "802406",
    [
      288006
    ]
  ],
  "./nl/webcam_modal.json": [
    "274551",
    [
      179097
    ]
  ],
  "./it/new_nav.json": [
    "708467",
    [
      344645
    ]
  ],
  "./da-x-k12/appt_calendar_event_dialog.json": [
    "128897",
    [
      105979
    ]
  ],
  "./fa/permissions.json": [
    "5387",
    [
      291337
    ]
  ],
  "./pt-BR/question_bank.json": [
    "829376",
    [
      398797
    ]
  ],
  "./nb/student_entries.json": [
    "104278",
    [
      973298
    ]
  ],
  "./it/student_study_drawer.json": [
    "684222",
    [
      245090
    ]
  ],
  "./tr/account_settings.json": [
    "532901",
    [
      250903
    ]
  ],
  "./fr-CA/course_paces_search.json": [
    "422076",
    [
      963808
    ]
  ],
  "./hu/important_dates_empty.json": [
    "946655",
    [
      378589
    ]
  ],
  "./sl/calculator.json": [
    "589039",
    [
      977433
    ]
  ],
  "./en-GB-x-lbs/appt_calendar_event_dialog.json": [
    "443160",
    [
      846000
    ]
  ],
  "./fr-CA/horizon_toggle.json": [
    "787821",
    [
      96063
    ]
  ],
  "./ko/nav_tourpoints.json": [
    "497999",
    [
      221053
    ]
  ],
  "./nn/context_modules_v2.json": [
    "610376",
    [
      336860
    ]
  ],
  "./fa/lti_registrations.json": [
    "582249",
    [
      779535
    ]
  ],
  "./sv-x-k12/quantitative_data_options.json": [
    "16140",
    [
      723772
    ]
  ],
  "./ga/outcomes_user_outcome_results.json": [
    "579741",
    [
      903579
    ]
  ],
  "./el/accessibility_checker.json": [
    "110883",
    [
      21645
    ]
  ],
  "./ja/gradingGradeSummary.json": [
    "780134",
    [
      820583
    ]
  ],
  "./sl/notebook_index.json": [
    "238545",
    [
      37347
    ]
  ],
  "./da-x-k12/assignmentsToggleShowByView.json": [
    "376196",
    [
      284032
    ]
  ],
  "./nb-x-k12/GroupsTray.json": [
    "172492",
    [
      613228
    ]
  ],
  "./pl/content_copy_redesign.json": [
    "250537",
    [
      463611
    ]
  ],
  "./hi/gradinggradingPeriodCollection.json": [
    "48234",
    [
      27706
    ]
  ],
  "./en/content_shares.json": [
    "309645",
    [
      628983
    ]
  ],
  "./nn/calendar_edit.json": [
    "391541",
    [
      138759
    ]
  ],
  "./he.json": [
    "508322",
    [
      792900
    ]
  ],
  "./zh-Hant/reset_pace_warning_modal.json": [
    "973914",
    [
      201206
    ]
  ],
  "./en-AU-x-unimelb/course_paces_header.json": [
    "666852",
    [
      552320
    ]
  ],
  "./pl/unpublished_warning_modal.json": [
    "703536",
    [
      926820
    ]
  ],
  "./nb/internal-settings.json": [
    "214211",
    [
      979813
    ]
  ],
  "./fr-CA/knowledge_check_not_ready.json": [
    "691906",
    [
      83526
    ]
  ],
  "./pt-BR/grade_change_logging_content.json": [
    "370061",
    [
      143708
    ]
  ],
  "./en-GB/user_logins.json": [
    "883909",
    [
      322472
    ]
  ],
  "./tr/MobileGlobalMenu.json": [
    "565306",
    [
      853934
    ]
  ],
  "./pt/account_calendar_settings_filter_controls.json": [
    "587086",
    [
      562597
    ]
  ],
  "./es/course_logging_details.json": [
    "37416",
    [
      637533
    ]
  ],
  "./cy/roster_section_selector.json": [
    "746231",
    [
      274885
    ]
  ],
  "./fr-CA/ai_experiences_show.json": [
    "84183",
    [
      311873
    ]
  ],
  "./tr/widget_dashboard.json": [
    "791971",
    [
      834397
    ]
  ],
  "./fr-CA/job_stats.json": [
    "140068",
    [
      904560
    ]
  ],
  "./mi/entity_search_form.json": [
    "721811",
    [
      196425
    ]
  ],
  "./nb/submit_assignment.json": [
    "781402",
    [
      663734
    ]
  ],
  "./ms/assignments_2_media_attempt.json": [
    "669636",
    [
      679900
    ]
  ],
  "./el/assignment_index_menu.json": [
    "442295",
    [
      243761
    ]
  ],
  "./ko/grade_summary.json": [
    "587744",
    [
      56336
    ]
  ],
  "./de/quantitative_data_options.json": [
    "651636",
    [
      675945
    ]
  ],
  "./fr-CA/auth_logging.json": [
    "677033",
    [
      424219
    ]
  ],
  "./uk/student_groups.json": [
    "639686",
    [
      53750
    ]
  ],
  "./sv/custom_help_link.json": [
    "355457",
    [
      910027
    ]
  ],
  "./ca/OutcomeDescriptionModal.json": [
    "674077",
    [
      97699
    ]
  ],
  "./vi/edit_section_view.json": [
    "766951",
    [
      122381
    ]
  ],
  "./es-ES/copy_warnings_modal.json": [
    "84538",
    [
      206394
    ]
  ],
  "./pt/unpublished_warning_modal.json": [
    "299144",
    [
      690732
    ]
  ],
  "./vi/user.json": [
    "489966",
    [
      950422
    ]
  ],
  "./es/appointment_groups.json": [
    "110272",
    [
      813141
    ]
  ],
  "./he/AddGroup.json": [
    "332685",
    [
      23907
    ]
  ],
  "./fa/calendar_sidebar.json": [
    "347876",
    [
      100628
    ]
  ],
  "./mi/a2LatePolicyToolTipContent.json": [
    "14649",
    [
      895111
    ]
  ],
  "./vi/account_calendars_modal.json": [
    "197218",
    [
      228978
    ]
  ],
  "./da-x-k12/blueprint_settingsAssociationsTable.json": [
    "459660",
    [
      374016
    ]
  ],
  "./en-GB-x-lbs/progress_pill.json": [
    "268671",
    [
      899893
    ]
  ],
  "./fr-CA/terms_index.json": [
    "392179",
    [
      776453
    ]
  ],
  "./ms/entity_search_form.json": [
    "575009",
    [
      749375
    ]
  ],
  "./ru/CommentLibrary.json": [
    "302485",
    [
      955091
    ]
  ],
  "./ga/assignments_2_url_entry.json": [
    "831780",
    [
      648868
    ]
  ],
  "./hy/rootFoldersFinder.json": [
    "233724",
    [
      526012
    ]
  ],
  "./ru/course_statistics.json": [
    "638886",
    [
      296414
    ]
  ],
  "./sv-x-k12/enhanced_individual_gradebook_submit_score.json": [
    "92972",
    [
      585404
    ]
  ],
  "./nb-x-k12/AssignmentGroupListItemView.json": [
    "206650",
    [
      475946
    ]
  ],
  "./fa/peer_review_configuration_tray.json": [
    "621528",
    [
      34320
    ]
  ],
  "./ar/outcome_reporting.json": [
    "432884",
    [
      985168
    ]
  ],
  "./hu/edit_section_end_date.json": [
    "128006",
    [
      30438
    ]
  ],
  "./nl/course_search_results.json": [
    "313043",
    [
      372277
    ]
  ],
  "./cy.eager.json": [
    "690363",
    [
      621582
    ]
  ],
  "./en-AU-x-unimelb/roster_publicjs.json": [
    "304220",
    [
      11376
    ]
  ],
  "./fr/gradinggradingPeriodCollection.json": [
    "99331",
    [
      947962
    ]
  ],
  "./sl/new_user_tutorial.json": [
    "648885",
    [
      868534
    ]
  ],
  "./th/assignments.never_drop.json": [
    "208732",
    [
      999467
    ]
  ],
  "./ga/blueprint_settingsUnsyncedChanges.json": [
    "78047",
    [
      981845
    ]
  ],
  "./ga/conferences_alternatives.json": [
    "947702",
    [
      841438
    ]
  ],
  "./zh-Hans/content_exports.json": [
    "280200",
    [
      511760
    ]
  ],
  "./ga/calendar.header.json": [
    "209467",
    [
      878898
    ]
  ],
  "./sv/calendar_custom_recurring_event_natural_language.json": [
    "698265",
    [
      584467
    ]
  ],
  "./fi/reset_pace_warning_modal.json": [
    "347875",
    [
      991105
    ]
  ],
  "./da-x-k12/assignments_peer_reviews.json": [
    "282592",
    [
      412948
    ]
  ],
  "./ko/user_lists.json": [
    "463777",
    [
      902223
    ]
  ],
  "./en-GB-x-lbs/assignments_2_submission_helpers.json": [
    "321278",
    [
      734918
    ]
  ],
  "./nb-x-k12/HelpTray.json": [
    "720219",
    [
      744649
    ]
  ],
  "./nn/account_calendar_settings.json": [
    "586636",
    [
      738760
    ]
  ],
  "./sv/enhanced_individual_gradebook_submit_score.json": [
    "264446",
    [
      697106
    ]
  ],
  "./en-AU/blueprint_settingsUnsyncedChanges.json": [
    "130365",
    [
      840948
    ]
  ],
  "./sv-x-k12/internal-settings.json": [
    "679804",
    [
      775404
    ]
  ],
  "./pt/course_paces_empty_state.json": [
    "355248",
    [
      793636
    ]
  ],
  "./ms/theme_collection_view.json": [
    "826648",
    [
      467016
    ]
  ],
  "./mi/dashboard.json": [
    "696824",
    [
      4424
    ]
  ],
  "./cy/gradebook_uploads.json": [
    "10513",
    [
      663663
    ]
  ],
  "./cy/course_paces_actions.json": [
    "844104",
    [
      313080
    ]
  ],
  "./da/link_to_students.json": [
    "573234",
    [
      741690
    ]
  ],
  "./nb/license_help.json": [
    "599717",
    [
      205935
    ]
  ],
  "./ar/ai_experiences_show.json": [
    "977265",
    [
      851515
    ]
  ],
  "./ga/course_paces_assignment_row.json": [
    "902755",
    [
      921521
    ]
  ],
  "./zh-Hant/last_attended.json": [
    "14308",
    [
      846704
    ]
  ],
  "./it/ai_experiences_edit.json": [
    "42750",
    [
      90778
    ]
  ],
  "./ru/account_calendar_settings_utils.json": [
    "461183",
    [
      749445
    ]
  ],
  "./fa/todo.json": [
    "871305",
    [
      499183
    ]
  ],
  "./zh-Hant/ldap_cert_upload.json": [
    "708796",
    [
      626608
    ]
  ],
  "./es/discussion_topics_edit.json": [
    "684120",
    [
      975021
    ]
  ],
  "./de/course_paces_blackout_dates_table.json": [
    "763446",
    [
      865199
    ]
  ],
  "./sv/important_dates_empty.json": [
    "21010",
    [
      700327
    ]
  ],
  "./tr/gradebookOutcomeGradebookView.json": [
    "404445",
    [
      213487
    ]
  ],
  "./th/context_prior_users.json": [
    "510745",
    [
      699099
    ]
  ],
  "./ca/reset_pace_warning_modal.json": [
    "933084",
    [
      756244
    ]
  ],
  "./sv-x-k12/last_attended.json": [
    "198837",
    [
      278755
    ]
  ],
  "./ru/theme_collection_view.json": [
    "796525",
    [
      793483
    ]
  ],
  "./el/direct_share_course_import_panel.json": [
    "105613",
    [
      607815
    ]
  ],
  "./fr-CA/edit_section_start_date.json": [
    "789147",
    [
      190973
    ]
  ],
  "./sv/assignment_2_assignment_toggle_details.json": [
    "761669",
    [
      633047
    ]
  ],
  "./en-GB/course_navigation_settings.json": [
    "75641",
    [
      975076
    ]
  ],
  "./it/account_calendar_settings_account_group.json": [
    "338797",
    [
      372783
    ]
  ],
  "./th/announcements_on_home_page.json": [
    "386546",
    [
      532198
    ]
  ],
  "./fr-CA/discussion_topics_edit.json": [
    "831887",
    [
      1857
    ]
  ],
  "./zh-Hant/discussion_topics_edit.json": [
    "14746",
    [
      607190
    ]
  ],
  "./sv-x-k12/eportfolio.json": [
    "326234",
    [
      696410
    ]
  ],
  "./de/rate_limiting_settings.json": [
    "180541",
    [
      314060
    ]
  ],
  "./nl/ai_experiences_ai_conversations.json": [
    "61500",
    [
      826808
    ]
  ],
  "./hi/assignments_bulk_edit.json": [
    "685617",
    [
      913815
    ]
  ],
  "./pl/collaborations.json": [
    "499548",
    [
      179336
    ]
  ],
  "./zh-Hans/assignments_2_file_upload.json": [
    "773099",
    [
      811641
    ]
  ],
  "./en-GB-x-ukhe/progress_pill.json": [
    "522679",
    [
      554909
    ]
  ],
  "./ms/account_settings.json": [
    "518376",
    [
      385057
    ]
  ],
  "./id/user_lists.json": [
    "658892",
    [
      829344
    ]
  ],
  "./nn/AddGroup.json": [
    "220596",
    [
      848680
    ]
  ],
  "./ko/security_panel.json": [
    "356027",
    [
      736529
    ]
  ],
  "./de/course_paces_settings.json": [
    "392079",
    [
      942282
    ]
  ],
  "./nb/CreateEditAssignmentModalAdapter.json": [
    "784983",
    [
      265881
    ]
  ],
  "./nb-x-k12/course_pace_date_input.json": [
    "910065",
    [
      565735
    ]
  ],
  "./tr/AccountsTray.json": [
    "285192",
    [
      416540
    ]
  ],
  "./fr-CA/account_calendars.json": [
    "198140",
    [
      115440
    ]
  ],
  "./en-GB/assignments_2_student_content_rubric_self_assessment.json": [
    "48304",
    [
      940009
    ]
  ],
  "./nn/unpublished_changes_tray_contents.json": [
    "374107",
    [
      794629
    ]
  ],
  "./it/user_logins.json": [
    "598769",
    [
      733299
    ]
  ],
  "./sl/GroupDetailView.json": [
    "41918",
    [
      34042
    ]
  ],
  "./sv-x-k12/course_paces_blackout_dates_modal.json": [
    "660391",
    [
      563197
    ]
  ],
  "./mi/account_calendar_settings_footer.json": [
    "203052",
    [
      503636
    ]
  ],
  "./is/assignments_2_peer_review.json": [
    "957987",
    [
      3393
    ]
  ],
  "./tr/LearningMasteryGradebook.json": [
    "832751",
    [
      357361
    ]
  ],
  "./ca/suppress_notifications.json": [
    "571902",
    [
      194590
    ]
  ],
  "./zh-Hans/theme_editor.json": [
    "148904",
    [
      867152
    ]
  ],
  "./el/AssignmentListItemView.json": [
    "492306",
    [
      706374
    ]
  ],
  "./fr-CA/notebook.json": [
    "45452",
    [
      373488
    ]
  ],
  "./zh-Hant/gradingGradeSummary.json": [
    "367841",
    [
      800163
    ]
  ],
  "./ms/edit_section_end_date.json": [
    "791197",
    [
      674803
    ]
  ],
  "./da/blueprint_settingsCoursePicker.json": [
    "246325",
    [
      325387
    ]
  ],
  "./sl/rootFoldersFinder.json": [
    "668468",
    [
      763976
    ]
  ],
  "./de/a2LatePolicyToolTipContent.json": [
    "651558",
    [
      981887
    ]
  ],
  "./pl/choose_mastery_path.json": [
    "750189",
    [
      458351
    ]
  ],
  "./fr/assignments_2_submission_helpers.json": [
    "34796",
    [
      765125
    ]
  ],
  "./da/ImportConfirmBox.json": [
    "576767",
    [
      143213
    ]
  ],
  "./en-GB-x-lbs/quizzes_public.json": [
    "845951",
    [
      995573
    ]
  ],
  "./hy/gradebookOutcomeGradebookView.json": [
    "6644",
    [
      506564
    ]
  ],
  "./ca/course_paces_actions.json": [
    "655472",
    [
      768384
    ]
  ],
  "./fr/discussion_posts.json": [
    "164325",
    [
      242959
    ]
  ],
  "./he/grade_change_logging_content.json": [
    "849363",
    [
      891913
    ]
  ],
  "./en-GB-x-lbs/grade_summary.json": [
    "332400",
    [
      617432
    ]
  ],
  "./it.json": [
    "634704",
    [
      922922
    ]
  ],
  "./mi/student_entries.json": [
    "994096",
    [
      632976
    ]
  ],
  "./pl/gradingGradeSummary.json": [
    "92911",
    [
      531233
    ]
  ],
  "./hu/canvascareer.json": [
    "798701",
    [
      725027
    ]
  ],
  "./fa/CreateEditAssignmentModal.json": [
    "515017",
    [
      381375
    ]
  ],
  "./ht/course_paces_pace_picker.json": [
    "423293",
    [
      277927
    ]
  ],
  "./mi/course_paces_blackout_dates_table.json": [
    "94703",
    [
      416077
    ]
  ],
  "./fr-CA/account_calendar_settings_account_calendar_item.json": [
    "146478",
    [
      382922
    ]
  ],
  "./ca/calendar_edit.json": [
    "381489",
    [
      550335
    ]
  ],
  "./ms/terms_of_use.json": [
    "475199",
    [
      14077
    ]
  ],
  "./pt-BR/link_to_students.json": [
    "212672",
    [
      687677
    ]
  ],
  "./da/top_navigation_tools.json": [
    "75241",
    [
      992071
    ]
  ],
  "./is/important_dates.json": [
    "599062",
    [
      502190
    ]
  ],
  "./en-AU-x-unimelb/permissions_v2_add_tray.json": [
    "91488",
    [
      358452
    ]
  ],
  "./en-AU/roster_section_selector.json": [
    "941945",
    [
      197272
    ]
  ],
  "./pt/discovery_page.json": [
    "962486",
    [
      427578
    ]
  ],
  "./cy/discussion_create.json": [
    "395815",
    [
      102645
    ]
  ],
  "./th/sections_tooltip.json": [
    "690882",
    [
      303494
    ]
  ],
  "./fr-CA/entity_search_form.json": [
    "364846",
    [
      442250
    ]
  ],
  "./hi/quantitative_data_options.json": [
    "467948",
    [
      950012
    ]
  ],
  "./es-ES/quantitative_data_options.json": [
    "948682",
    [
      816602
    ]
  ],
  "./id/webcam_modal.json": [
    "156610",
    [
      879630
    ]
  ],
  "./ja/announcements_v2.json": [
    "645336",
    [
      217405
    ]
  ],
  "./it/assignment_index_deep_linking_handlers.json": [
    "757335",
    [
      540137
    ]
  ],
  "./nl/new_nav.json": [
    "290172",
    [
      9728
    ]
  ],
  "./nb/SpeedGraderSettingsMenu.json": [
    "290616",
    [
      448596
    ]
  ],
  "./fr-CA/account_calendar_settings_account_calendar_item_dropdown.json": [
    "922458",
    [
      253358
    ]
  ],
  "./ja/filter_calendars_modal.json": [
    "888097",
    [
      685472
    ]
  ],
  "./da/course_paces_module.json": [
    "448510",
    [
      745022
    ]
  ],
  "./id/course_paces_module.json": [
    "829180",
    [
      750656
    ]
  ],
  "./zh-Hans/question_bank.json": [
    "743990",
    [
      921166
    ]
  ],
  "./ga/content_exports.json": [
    "849103",
    [
      112789
    ]
  ],
  "./fr/student_groups.json": [
    "98134",
    [
      451363
    ]
  ],
  "./mi/unpublished_warning_modal.json": [
    "532806",
    [
      41990
    ]
  ],
  "./ms/FindOutcomesModal.json": [
    "128453",
    [
      233867
    ]
  ],
  "./pt-BR/user_grades.json": [
    "802979",
    [
      31638
    ]
  ],
  "./fr/blueprint_settingsSyncChange.json": [
    "480676",
    [
      588837
    ]
  ],
  "./es/folder_tree.json": [
    "141587",
    [
      62590
    ]
  ],
  "./zh-Hans/assignments_2_attempt_tab.json": [
    "498436",
    [
      216980
    ]
  ],
  "./sv-x-k12/discussion_topics_edit.json": [
    "475685",
    [
      304643
    ]
  ],
  "./hu/GroupDetailView.json": [
    "839802",
    [
      245826
    ]
  ],
  "./he/a2_AccessibleTipContent.json": [
    "119037",
    [
      234387
    ]
  ],
  "./th/account_calendars.json": [
    "395885",
    [
      135567
    ]
  ],
  "./ko/editAssignmentGroupWeights.json": [
    "18865",
    [
      783519
    ]
  ],
  "./en-GB/users.json": [
    "911615",
    [
      415686
    ]
  ],
  "./ru/course_paces_change_tracking.json": [
    "883288",
    [
      529568
    ]
  ],
  "./da/course_paces_actions.json": [
    "664337",
    [
      279039
    ]
  ],
  "./da/assignments_2_student_header_date_title.json": [
    "379526",
    [
      855702
    ]
  ],
  "./el/assignment_index.json": [
    "277103",
    [
      20057
    ]
  ],
  "./ja/account_calendar_settings_confirmation_modal.json": [
    "507205",
    [
      280188
    ]
  ],
  "./is/appointment_groups.json": [
    "756292",
    [
      424836
    ]
  ],
  "./pt/gradingPeriodTemplate.json": [
    "300265",
    [
      881107
    ]
  ],
  "./th/homeroom_page.json": [
    "505196",
    [
      89872
    ]
  ],
  "./is/course_paces_empty_state.json": [
    "71404",
    [
      17836
    ]
  ],
  "./en-GB-x-lbs/discussion_row.json": [
    "462859",
    [
      282825
    ]
  ],
  "./sl/user_logins.json": [
    "940415",
    [
      883409
    ]
  ],
  "./hy/AddGroup.json": [
    "308137",
    [
      809647
    ]
  ],
  "./da/course_paces_flaggable_number_input.json": [
    "14552",
    [
      127928
    ]
  ],
  "./pt/course_paces_blackout_dates_modal.json": [
    "683456",
    [
      798652
    ]
  ],
  "./pt-BR/assignments_2_external_tool.json": [
    "291301",
    [
      177204
    ]
  ],
  "./ga/assignmentsToggleShowByView.json": [
    "833249",
    [
      704007
    ]
  ],
  "./de/account_calendar_settings_utils.json": [
    "205141",
    [
      662884
    ]
  ],
  "./nb-x-k12/course_paces_time_selection.json": [
    "784879",
    [
      27029
    ]
  ],
  "./da/user_grades.json": [
    "210665",
    [
      39943
    ]
  ],
  "./id/link_to_students.json": [
    "475712",
    [
      298516
    ]
  ],
  "./zh-Hans/new_user_tutorial.json": [
    "794450",
    [
      668450
    ]
  ],
  "./fa/outcome_alignment_v2.json": [
    "335886",
    [
      5462
    ]
  ],
  "./ar/assignments_2_student_content_rubric_self_assessment.json": [
    "4962",
    [
      590078
    ]
  ],
  "./pt-BR/course_statistics.json": [
    "533577",
    [
      168319
    ]
  ],
  "./tr/modules_page_icon_legend.json": [
    "471929",
    [
      749531
    ]
  ],
  "./hi/calendar_custom_recurring_event_natural_language.json": [
    "349667",
    [
      63009
    ]
  ],
  "./sl/modules_page_icon_legend.json": [
    "594274",
    [
      59190
    ]
  ],
  "./zh-Hant/LogoutButton.json": [
    "550814",
    [
      183954
    ]
  ],
  "./ja/important_dates_empty.json": [
    "855077",
    [
      91228
    ]
  ],
  "./ca/quizzes_index.json": [
    "182324",
    [
      499612
    ]
  ],
  "./ht/course_paces_modal.json": [
    "852374",
    [
      353922
    ]
  ],
  "./pt/assignments_2_MoreOptions.json": [
    "43599",
    [
      309337
    ]
  ],
  "./hu/dashboard_grading_period_select.json": [
    "280843",
    [
      864017
    ]
  ],
  "./es-ES/module_student_view_peer_reviews.json": [
    "3222",
    [
      765534
    ]
  ],
  "./ms/folder_tree.json": [
    "409675",
    [
      210481
    ]
  ],
  "./pt-BR/course_paces_time_selection.json": [
    "433424",
    [
      366141
    ]
  ],
  "./en-GB/accessibility_checker.json": [
    "953315",
    [
      128690
    ]
  ],
  "./en-GB/collaborations.json": [
    "632787",
    [
      999890
    ]
  ],
  "./ko/CommentLibrary.json": [
    "517128",
    [
      644840
    ]
  ],
  "./nb-x-k12/outcome_reporting.json": [
    "356097",
    [
      283607
    ]
  ],
  "./pt/gradebook_uploads.json": [
    "574585",
    [
      501803
    ]
  ],
  "./nl/gradebook_history.json": [
    "950037",
    [
      261431
    ]
  ],
  "./el/permissions_v2.json": [
    "533440",
    [
      114668
    ]
  ],
  "./da-x-k12/quiz_show.json": [
    "717564",
    [
      314880
    ]
  ],
  "./cy/conferences_alternatives.json": [
    "683866",
    [
      913250
    ]
  ],
  "./pl/assignments_2_student_content_rubric_self_assessment.json": [
    "858639",
    [
      583393
    ]
  ],
  "./is/assignment_show.json": [
    "324905",
    [
      769199
    ]
  ],
  "./nb/top_navigation_tools.json": [
    "269568",
    [
      340636
    ]
  ],
  "./zh-Hant/user_profile.json": [
    "831281",
    [
      796051
    ]
  ],
  "./ko/account_calendars_modal.json": [
    "346325",
    [
      843115
    ]
  ],
  "./zh-Hant/syllabus_revisions.json": [
    "301854",
    [
      321258
    ]
  ],
  "./ja/progressbar_view.json": [
    "214113",
    [
      182880
    ]
  ],
  "./pl/permissions_v2_add_tray.json": [
    "380520",
    [
      332116
    ]
  ],
  "./sv/assignment_index.json": [
    "398943",
    [
      132937
    ]
  ],
  "./hi/appointment_groups.json": [
    "62069",
    [
      498419
    ]
  ],
  "./ca/jobs_v2.json": [
    "967115",
    [
      316417
    ]
  ],
  "./nn/assignments_2_login_action_prompt.json": [
    "591949",
    [
      93439
    ]
  ],
  "./pl/knowledge_check_not_ready.json": [
    "544019",
    [
      501701
    ]
  ],
  "./ru/quizzes_openModerateStudentDialog.json": [
    "297533",
    [
      285579
    ]
  ],
  "./nb-x-k12/direct_share_course_import_panel.json": [
    "125832",
    [
      536624
    ]
  ],
  "./id/sharedCurveGradesDialog.json": [
    "768879",
    [
      207881
    ]
  ],
  "./el/edit_section_dates.json": [
    "939383",
    [
      987553
    ]
  ],
  "./en-GB-x-ukhe/sharedCurveGradesDialog.json": [
    "829888",
    [
      157192
    ]
  ],
  "./he/GroupsTray.json": [
    "416967",
    [
      750037
    ]
  ],
  "./it/account_settings_jsx_bundle.json": [
    "690839",
    [
      707401
    ]
  ],
  "./uk/canvascareer.json": [
    "264284",
    [
      973972
    ]
  ],
  "./ru/learning_mastery_gradebook.json": [
    "828152",
    [
      902304
    ]
  ],
  "./ru/grade_change_logging_content.json": [
    "422813",
    [
      310632
    ]
  ],
  "./hi/notebook.json": [
    "763222",
    [
      316942
    ]
  ],
  "./id/terms_of_use.json": [
    "245120",
    [
      366908
    ]
  ],
  "./fi/grade_summary.json": [
    "853663",
    [
      886181
    ]
  ],
  "./ht/empty_modules.json": [
    "865157",
    [
      782511
    ]
  ],
  "./es-ES/keyboardShortcutModal.json": [
    "599175",
    [
      561421
    ]
  ],
  "./is/AddGroup.json": [
    "373084",
    [
      551468
    ]
  ],
  "./is/account_calendar_settings_account_calendar_item.json": [
    "552359",
    [
      910925
    ]
  ],
  "./ca/permissions_v2_add_tray.json": [
    "656320",
    [
      217616
    ]
  ],
  "./ms/assignments_2_peer_review.json": [
    "54047",
    [
      809213
    ]
  ],
  "./pt-BR/not_found_page_slide_puzzle.json": [
    "41564",
    [
      860913
    ]
  ],
  "./ru/assignments_2_attempt_tab.json": [
    "328878",
    [
      935350
    ]
  ],
  "./ru/files_v2.json": [
    "880621",
    [
      947547
    ]
  ],
  "./sl/auth_logging.json": [
    "471643",
    [
      165997
    ]
  ],
  "./vi/context_roster_user_services.json": [
    "19041",
    [
      817687
    ]
  ],
  "./pl/GroupsTray.json": [
    "925178",
    [
      962638
    ]
  ],
  "./zh-Hans/bulk_edit_students.json": [
    "511193",
    [
      844239
    ]
  ],
  "./th/quiz_show.json": [
    "651253",
    [
      342111
    ]
  ],
  "./ar/account_calendars.json": [
    "645414",
    [
      250194
    ]
  ],
  "./nb/link_to_students.json": [
    "362023",
    [
      152017
    ]
  ],
  "./ar/file_not_found.json": [
    "386756",
    [
      944320
    ]
  ],
  "./en-CA/quiz_show.json": [
    "11557",
    [
      917603
    ]
  ],
  "./en-GB-x-ukhe/eportfolio.json": [
    "29097",
    [
      62143
    ]
  ],
  "./id/account_calendar_settings_account_calendar_item_dropdown.json": [
    "571654",
    [
      940874
    ]
  ],
  "./mi/youtube_migration.json": [
    "613274",
    [
      238146
    ]
  ],
  "./nl/homeroom_page.json": [
    "801626",
    [
      758822
    ]
  ],
  "./ga/bounced_emails.json": [
    "971098",
    [
      199546
    ]
  ],
  "./vi/theme_editor.json": [
    "989246",
    [
      473110
    ]
  ],
  "./cy/course_paces_empty_state.json": [
    "882136",
    [
      327592
    ]
  ],
  "./ca/discussion_topics_edit.json": [
    "437056",
    [
      371088
    ]
  ],
  "./fr-CA/GroupDetailView.json": [
    "995500",
    [
      14792
    ]
  ],
  "./en-GB/rubrics-export.json": [
    "253574",
    [
      80187
    ]
  ],
  "./pt-BR/new_user_tutorial.json": [
    "664832",
    [
      636717
    ]
  ],
  "./uk/manage_avatars.json": [
    "230920",
    [
      614536
    ]
  ],
  "./da/account_calendar_settings_account_list.json": [
    "54384",
    [
      90912
    ]
  ],
  "./hy/assignments_2_submission_helpers.json": [
    "621141",
    [
      332675
    ]
  ],
  "./it/account_calendars_results_area.json": [
    "921947",
    [
      396933
    ]
  ],
  "./mi/course_paces_blackout_date_row.json": [
    "81280",
    [
      308096
    ]
  ],
  "./nl/permissions_v2.json": [
    "279961",
    [
      630299
    ]
  ],
  "./th/calculator.json": [
    "643950",
    [
      116578
    ]
  ],
  "./ru/assignments_bulk_edit_use_save_assignment.json": [
    "380743",
    [
      582253
    ]
  ],
  "./hy/GroupDetailView.json": [
    "775302",
    [
      517950
    ]
  ],
  "./ga/AddGroup.json": [
    "426484",
    [
      497108
    ]
  ],
  "./ko/modules_home_page.json": [
    "160257",
    [
      588911
    ]
  ],
  "./es/user_profile.json": [
    "260443",
    [
      173958
    ]
  ],
  "./ru/assignments_2_student_header_date_title.json": [
    "546956",
    [
      405852
    ]
  ],
  "./ko/gradebook_history.json": [
    "215029",
    [
      915339
    ]
  ],
  "./nl/modules_page_icon_legend.json": [
    "304917",
    [
      7847
    ]
  ],
  "./en/jobs_v2.json": [
    "160072",
    [
      51388
    ]
  ],
  "./ko/ai_experiences.json": [
    "787952",
    [
      183712
    ]
  ],
  "./hy/assignment_index_menu.json": [
    "843121",
    [
      368791
    ]
  ],
  "./th/CoursesTray.json": [
    "171164",
    [
      237576
    ]
  ],
  "./de/custom_emoji_deny_list.json": [
    "818485",
    [
      612327
    ]
  ],
  "./en-AU-x-unimelb/peer_review_allocation_rule_card.json": [
    "23636",
    [
      603920
    ]
  ],
  "./ga/important_dates.json": [
    "711454",
    [
      543686
    ]
  ],
  "./th/quizzes_public.json": [
    "82757",
    [
      507839
    ]
  ],
  "./ca/peer-review-assignment-widget.json": [
    "515052",
    [
      66084
    ]
  ],
  "./da/collaborations.json": [
    "98929",
    [
      529567
    ]
  ],
  "./fr/webcam_modal.json": [
    "966041",
    [
      879236
    ]
  ],
  "./ga/bulk_edit_students_actions.json": [
    "680464",
    [
      213416
    ]
  ],
  "./mi/quizzes_openModerateStudentDialog.json": [
    "712894",
    [
      553614
    ]
  ],
  "./pl/SpeedGraderSettingsMenu.json": [
    "498728",
    [
      927428
    ]
  ],
  "./hi/available_pronouns_list.json": [
    "938920",
    [
      792128
    ]
  ],
  "./ar/course_default_due_time.json": [
    "194591",
    [
      766641
    ]
  ],
  "./da/link_validator.json": [
    "439018",
    [
      965954
    ]
  ],
  "./pl/user.json": [
    "682481",
    [
      327483
    ]
  ],
  "./vi/syllabus_revisions.json": [
    "305035",
    [
      840585
    ]
  ],
  "./de/plugins.json": [
    "430985",
    [
      352160
    ]
  ],
  "./es-ES/accessibility_course_statistics.json": [
    "209557",
    [
      421875
    ]
  ],
  "./fa/reset_pace_warning_modal.json": [
    "230955",
    [
      547641
    ]
  ],
  "./hy/registration.json": [
    "322822",
    [
      740206
    ]
  ],
  "./fi/top_navigation_tools.json": [
    "547307",
    [
      911673
    ]
  ],
  "./hu/discussion_row.json": [
    "645316",
    [
      27708
    ]
  ],
  "./ko/course_statistics.json": [
    "488301",
    [
      797779
    ]
  ],
  "./nb/announcements_v2.json": [
    "843663",
    [
      420329
    ]
  ],
  "./en-CA/gradebook.json": [
    "154176",
    [
      873368
    ]
  ],
  "./ru/edit_section_view.json": [
    "53783",
    [
      852589
    ]
  ],
  "./ar/gradebook.json": [
    "269631",
    [
      805449
    ]
  ],
  "./en-AU-x-unimelb/quizzes_public.json": [
    "820309",
    [
      425239
    ]
  ],
  "./he/todo.json": [
    "7179",
    [
      461201
    ]
  ],
  "./nb-x-k12/available_pronouns_list.json": [
    "908877",
    [
      640891
    ]
  ],
  "./he/course_paces_actions.json": [
    "947505",
    [
      944079
    ]
  ],
  "./ar/AssignmentGroupListItemView.json": [
    "5831",
    [
      122353
    ]
  ],
  "./cy/MobileGlobalMenu.json": [
    "678884",
    [
      303420
    ]
  ],
  "./hy/speed_grader_helpers.json": [
    "591438",
    [
      427910
    ]
  ],
  "./it/AssignmentListItemView.json": [
    "73118",
    [
      92770
    ]
  ],
  "./it/assignments_2_student_content.json": [
    "228526",
    [
      156514
    ]
  ],
  "./ja/AssignmentGroupListItemView.json": [
    "859677",
    [
      868596
    ]
  ],
  "./nn/ai_experiences.json": [
    "445686",
    [
      73354
    ]
  ],
  "./sl/accessibility_scan.json": [
    "762623",
    [
      845241
    ]
  ],
  "./en-AU/a2LatePolicyStatusDisplay.json": [
    "563623",
    [
      673290
    ]
  ],
  "./hu/terms_index.json": [
    "343053",
    [
      886275
    ]
  ],
  "./hi/assignments.never_drop.json": [
    "914825",
    [
      856148
    ]
  ],
  "./fr/blueprint_settingsSyncHistory.json": [
    "991108",
    [
      183493
    ]
  ],
  "./fi/registration.json": [
    "318976",
    [
      458328
    ]
  ],
  "./da-x-k12/gradebookActionMenu.json": [
    "240216",
    [
      558180
    ]
  ],
  "./es-ES/quizzes_quiz_submission.json": [
    "532067",
    [
      143217
    ]
  ],
  "./mi/account_calendars_modal.json": [
    "305353",
    [
      894551
    ]
  ],
  "./ru/assignment_2_assignment_toggle_details.json": [
    "951489",
    [
      891719
    ]
  ],
  "./fr/account_settings_jsx_bundle.json": [
    "579110",
    [
      638259
    ]
  ],
  "./de/CreateEditAssignmentModal.json": [
    "641795",
    [
      577606
    ]
  ],
  "./es-ES/blueprint_course_child.json": [
    "515785",
    [
      783919
    ]
  ],
  "./sv-x-k12/reset_pace_warning_modal.json": [
    "808793",
    [
      240255
    ]
  ],
  "./ga/sharedSetDefaultGradeDialog.json": [
    "130077",
    [
      599467
    ]
  ],
  "./cy/assignment_show.json": [
    "76589",
    [
      845539
    ]
  ],
  "./cy/k5_course.json": [
    "168350",
    [
      253198
    ]
  ],
  "./de/bulk_edit_students_table.json": [
    "408702",
    [
      998007
    ]
  ],
  "./de/folder_tree.json": [
    "430980",
    [
      206361
    ]
  ],
  "./el/admin_split.json": [
    "339371",
    [
      149477
    ]
  ],
  "./pl/CommentLibrary.json": [
    "864286",
    [
      159666
    ]
  ],
  "./th/syllabus_revisions.json": [
    "98059",
    [
      767908
    ]
  ],
  "./uk/sharedSetDefaultGradeDialog.json": [
    "361281",
    [
      716815
    ]
  ],
  "./pt/edit_section_view.json": [
    "69626",
    [
      24006
    ]
  ],
  "./nb/assignments_bulk_edit.json": [
    "859354",
    [
      844030
    ]
  ],
  "./zh-Hans/modules_home_page.json": [
    "429176",
    [
      18016
    ]
  ],
  "./sv/gradebook_history.json": [
    "487090",
    [
      840126
    ]
  ],
  "./uk/collaborations.json": [
    "25668",
    [
      998380
    ]
  ],
  "./zh-Hans/assignments_bulk_edit_use_save_assignment.json": [
    "485485",
    [
      665307
    ]
  ],
  "./zh-Hans/a2LatePolicyStatusDisplay.json": [
    "260114",
    [
      444706
    ]
  ],
  "./uk/course_logging_details.json": [
    "519376",
    [
      41824
    ]
  ],
  "./nb/HelpTray.json": [
    "812289",
    [
      976179
    ]
  ],
  "./es-ES/course_default_due_time.json": [
    "546701",
    [
      972555
    ]
  ],
  "./nl/calendar_custom_recurring_event_repeat_picker.json": [
    "208046",
    [
      819338
    ]
  ],
  "./ht/users.json": [
    "847662",
    [
      305090
    ]
  ],
  "./mi/Navigation.json": [
    "202834",
    [
      650794
    ]
  ],
  "./zh-Hans/blueprint_settingsUnsyncedChanges.json": [
    "518504",
    [
      832992
    ]
  ],
  "./ht/suppress_notifications.json": [
    "811510",
    [
      944738
    ]
  ],
  "./da-x-k12/plugins.json": [
    "401743",
    [
      79561
    ]
  ],
  "./nb-x-k12/assignments_peer_reviews_student.json": [
    "686769",
    [
      990679
    ]
  ],
  "./en-GB/calendar.header.json": [
    "627330",
    [
      653535
    ]
  ],
  "./nl/todo.json": [
    "932456",
    [
      486428
    ]
  ],
  "./zh-Hant/roster_publicjs.json": [
    "117162",
    [
      699350
    ]
  ],
  "./pl/content_share_preview_overlay.json": [
    "438511",
    [
      770830
    ]
  ],
  "./hi/ProfileTray.json": [
    "342096",
    [
      972936
    ]
  ],
  "./sl/available_pronouns_list.json": [
    "721312",
    [
      152164
    ]
  ],
  "./vi/content_exports.json": [
    "469942",
    [
      187934
    ]
  ],
  "./sv-x-k12/empty_modules.json": [
    "333682",
    [
      825122
    ]
  ],
  "./ru/gradingGradeSummary.json": [
    "91178",
    [
      346938
    ]
  ],
  "./sv/assignments_bulk_edit_use_save_assignment.json": [
    "190803",
    [
      610013
    ]
  ],
  "./tr/direct_share_course_import_panel.json": [
    "983520",
    [
      852148
    ]
  ],
  "./vi/grades_summary.json": [
    "833758",
    [
      487206
    ]
  ],
  "./fa/a2_AccessibleTipContent.json": [
    "286179",
    [
      182481
    ]
  ],
  "./nb/rubrics-export.json": [
    "789465",
    [
      485819
    ]
  ],
  "./it/rate_limiting_settings.json": [
    "320075",
    [
      479141
    ]
  ],
  "./he/assignments_2_file_upload.json": [
    "247255",
    [
      243429
    ]
  ],
  "./tr/link_validator.json": [
    "405401",
    [
      478323
    ]
  ],
  "./da/sis_import.json": [
    "232052",
    [
      295228
    ]
  ],
  "./uk/grade_change_logging_content.json": [
    "196782",
    [
      140046
    ]
  ],
  "./fr-CA/ldap_cert_upload.json": [
    "831641",
    [
      173475
    ]
  ],
  "./hi/accessibility_scan.json": [
    "108887",
    [
      632925
    ]
  ],
  "./vi/react_collaborations.json": [
    "615027",
    [
      413505
    ]
  ],
  "./en-GB-x-ukhe/theme_collection_view.json": [
    "501498",
    [
      472858
    ]
  ],
  "./ms/change_password.json": [
    "448838",
    [
      194406
    ]
  ],
  "./el/discussion_posts.json": [
    "986309",
    [
      400223
    ]
  ],
  "./nl/SpeedGraderSettingsMenu.json": [
    "45186",
    [
      601902
    ]
  ],
  "./nl/assignments_2_url_entry.json": [
    "868642",
    [
      430982
    ]
  ],
  "./ru/notebook.json": [
    "518440",
    [
      207088
    ]
  ],
  "./hi/content_migrations_redesign.json": [
    "707474",
    [
      315106
    ]
  ],
  "./sv-x-k12/blueprint_settingsAssociationsTable.json": [
    "228194",
    [
      506418
    ]
  ],
  "./ca/editGroup.json": [
    "276453",
    [
      720987
    ]
  ],
  "./nn/files_v2.json": [
    "173102",
    [
      452362
    ]
  ],
  "./hi/course_paces_search.json": [
    "33462",
    [
      43214
    ]
  ],
  "./sl/assignment_grade_summary.json": [
    "829185",
    [
      474851
    ]
  ],
  "./mi/discussion_pinned_post.json": [
    "834738",
    [
      580682
    ]
  ],
  "./nb/MoveOutcomesModal.json": [
    "968851",
    [
      990925
    ]
  ],
  "./hi/discussionTopicKeyboradShortcutModal.json": [
    "421480",
    [
      935776
    ]
  ],
  "./hu/video_conference.json": [
    "462337",
    [
      238751
    ]
  ],
  "./zh-Hant/sis_import.json": [
    "399267",
    [
      154229
    ]
  ],
  "./fr/course_navigation_settings.json": [
    "862966",
    [
      457459
    ]
  ],
  "./en-CA/peer_reviews_student.json": [
    "237316",
    [
      223028
    ]
  ],
  "./es-ES/submit_online_url_assignment.json": [
    "361245",
    [
      78411
    ]
  ],
  "./ja/ignite_agent.json": [
    "944241",
    [
      166512
    ]
  ],
  "./nb-x-k12/reset_pace_warning_modal.json": [
    "106898",
    [
      165874
    ]
  ],
  "./es-ES/widget_dashboard.json": [
    "571242",
    [
      85818
    ]
  ],
  "./tr/student_annotation_preview.json": [
    "485902",
    [
      792674
    ]
  ],
  "./ca/assignments_2_login_action_prompt.json": [
    "4361",
    [
      237767
    ]
  ],
  "./uk/gradebook_uploads.json": [
    "570729",
    [
      463719
    ]
  ],
  "./he/gradebook.json": [
    "717515",
    [
      700465
    ]
  ],
  "./nb-x-k12/plugins.json": [
    "143108",
    [
      284884
    ]
  ],
  "./en/react_files.json": [
    "335770",
    [
      279838
    ]
  ],
  "./is/discussion_topics_edit.json": [
    "492876",
    [
      751356
    ]
  ],
  "./el/permissions_role_tray.json": [
    "324057",
    [
      561867
    ]
  ],
  "./hi/student_annotation_preview.json": [
    "910045",
    [
      871483
    ]
  ],
  "./en-AU/new_user_tutorial.json": [
    "340083",
    [
      838062
    ]
  ],
  "./ca/assignment_index_menu.json": [
    "16930",
    [
      161098
    ]
  ],
  "./pt-BR/course_paces_empty_state.json": [
    "658635",
    [
      856734
    ]
  ],
  "./ms/react_collaborations.json": [
    "701792",
    [
      153024
    ]
  ],
  "./ca/available_pronouns_list.json": [
    "360431",
    [
      973437
    ]
  ],
  "./hi/ai_experiences_show.json": [
    "230529",
    [
      441431
    ]
  ],
  "./es/roster_publicjs.json": [
    "279524",
    [
      153713
    ]
  ],
  "./ru/assignments_2_file_upload.json": [
    "240345",
    [
      297167
    ]
  ],
  "./ko/empty_course.json": [
    "871911",
    [
      43781
    ]
  ],
  "./en-GB/course_link_validator.json": [
    "18500",
    [
      446725
    ]
  ],
  "./el/assignments_2_MoreOptions.json": [
    "337486",
    [
      238330
    ]
  ],
  "./sl/unpublished_warning_modal.json": [
    "790899",
    [
      142165
    ]
  ],
  "./de/dashboard_grades_page.json": [
    "149308",
    [
      802657
    ]
  ],
  "./de/user_name.json": [
    "18382",
    [
      935047
    ]
  ],
  "./ko/unpublished_warning_modal.json": [
    "574866",
    [
      334618
    ]
  ],
  "./mi/assignments_2_login_action_prompt.json": [
    "488271",
    [
      697133
    ]
  ],
  "./id/enhanced_individual_gradebook_submit_score.json": [
    "288882",
    [
      210678
    ]
  ],
  "./cy/gradebook_default_gradebook_components_content_filters_module_filter.json": [
    "931782",
    [
      858182
    ]
  ],
  "./th/use_switch_experience.json": [
    "678819",
    [
      286997
    ]
  ],
  "./pt-BR/editGroup.json": [
    "221976",
    [
      376037
    ]
  ],
  "./uk/discussion_pinned_post.json": [
    "10628",
    [
      717676
    ]
  ],
  "./sv-x-k12/bulk_edit_students_actions.json": [
    "923201",
    [
      168775
    ]
  ],
  "./de/error_form.json": [
    "402802",
    [
      456563
    ]
  ],
  "./hu/account_calendar_settings_footer.json": [
    "130523",
    [
      841537
    ]
  ],
  "./ru/blueprint_settingsMigrationSync.json": [
    "630247",
    [
      232733
    ]
  ],
  "./fi/course_paces_time_selection.json": [
    "657504",
    [
      932712
    ]
  ],
  "./sv/blueprint_settingsCoursePickerTable.json": [
    "48097",
    [
      938963
    ]
  ],
  "./ja/calendar_appointment_group_edit.json": [
    "614822",
    [
      684967
    ]
  ],
  "./ko/edit_section_view.json": [
    "896680",
    [
      592648
    ]
  ],
  "./en-GB-x-lbs/outcome_reporting.json": [
    "784725",
    [
      602419
    ]
  ],
  "./de/discussion_row.json": [
    "242840",
    [
      998101
    ]
  ],
  "./it/k5_dashboard_card.json": [
    "2497",
    [
      249155
    ]
  ],
  "./de/course_search_results.json": [
    "696706",
    [
      663267
    ]
  ],
  "./en-GB/filter_calendars_modal.json": [
    "204305",
    [
      708636
    ]
  ],
  "./ga/SpeedGraderDiscussionsNavigation.json": [
    "758029",
    [
      458763
    ]
  ],
  "./nb/assignments_2_student_header_date_title.json": [
    "209621",
    [
      515255
    ]
  ],
  "./ht/calendar.header.json": [
    "966991",
    [
      608506
    ]
  ],
  "./hy/SpeedGraderPostGradesMenu.json": [
    "341868",
    [
      818876
    ]
  ],
  "./ms/pairing_code_user_observees.json": [
    "422147",
    [
      891065
    ]
  ],
  "./nb-x-k12/account_calendar_settings_confirmation_modal.json": [
    "397368",
    [
      695296
    ]
  ],
  "./nl/lti_registrations.json": [
    "638654",
    [
      162306
    ]
  ],
  "./it/knowledge_check_not_ready.json": [
    "971422",
    [
      805938
    ]
  ],
  "./de/CourseAvailabilityOptions.json": [
    "100793",
    [
      758608
    ]
  ],
  "./fa/edit_section_start_date.json": [
    "688767",
    [
      694421
    ]
  ],
  "./el/notebook_index.json": [
    "866207",
    [
      173417
    ]
  ],
  "./ca/content_shares.json": [
    "877468",
    [
      892948
    ]
  ],
  "./nn/course_paces_header.json": [
    "131552",
    [
      484820
    ]
  ],
  "./ar/grade_details.json": [
    "283695",
    [
      212929
    ]
  ],
  "./sv/sidenav.json": [
    "401331",
    [
      182269
    ]
  ],
  "./hy/job_stats.json": [
    "753026",
    [
      793858
    ]
  ],
  "./fr-CA/quiz_show.json": [
    "235172",
    [
      761056
    ]
  ],
  "./id/media_player_iframe_content.json": [
    "334168",
    [
      710476
    ]
  ],
  "./da/blueprint_settingsUnsyncedChanges.json": [
    "583356",
    [
      817236
    ]
  ],
  "./hu/accessibility_course_statistics.json": [
    "604375",
    [
      732549
    ]
  ],
  "./zh-Hans/roster_section_input.json": [
    "6387",
    [
      52369
    ]
  ],
  "./ja/DueDateOverrideView.json": [
    "817880",
    [
      377213
    ]
  ],
  "./fi/SpeedGraderSettingsMenu.json": [
    "896233",
    [
      967103
    ]
  ],
  "./is/self_enrollment.json": [
    "902913",
    [
      56423
    ]
  ],
  "./nl/quizzes_openModerateStudentDialog.json": [
    "712906",
    [
      210110
    ]
  ],
  "./ru/speed_grader_helpers.json": [
    "922616",
    [
      472528
    ]
  ],
  "./en/lti_registrations.json": [
    "268995",
    [
      839645
    ]
  ],
  "./cy/react_scheduler.json": [
    "94107",
    [
      234369
    ]
  ],
  "./he/progress_pill.json": [
    "621970",
    [
      558890
    ]
  ],
  "./da-x-k12/course_paces_header.json": [
    "151393",
    [
      97043
    ]
  ],
  "./id/upload_button.json": [
    "864297",
    [
      369619
    ]
  ],
  "./es-ES/user_name.json": [
    "582460",
    [
      644428
    ]
  ],
  "./fr/assignmentsToggleShowByView.json": [
    "174613",
    [
      127144
    ]
  ],
  "./ms/account_settings_jsx_bundle.json": [
    "837078",
    [
      443766
    ]
  ],
  "./en-GB/assignment_index_menu.json": [
    "854007",
    [
      600326
    ]
  ],
  "./pt/student_study_drawer.json": [
    "28417",
    [
      895147
    ]
  ],
  "./el/context_roster_user_services.json": [
    "381189",
    [
      73719
    ]
  ],
  "./ar/course_paces_app.json": [
    "19197",
    [
      356511
    ]
  ],
  "./nl/calendar_appointment_group_edit.json": [
    "609785",
    [
      473299
    ]
  ],
  "./ga/gradingGradeSummary.json": [
    "773947",
    [
      891257
    ]
  ],
  "./en-GB-x-lbs/SpeedGraderPostGradesMenu.json": [
    "729765",
    [
      839491
    ]
  ],
  "./ru/unpublished_changes_tray_contents.json": [
    "326874",
    [
      891978
    ]
  ],
  "./vi/suppress_notifications.json": [
    "888086",
    [
      6543
    ]
  ],
  "./hi/assignments_2_initial_query.json": [
    "938474",
    [
      527706
    ]
  ],
  "./ja/confirmMasteryModal.json": [
    "980781",
    [
      720132
    ]
  ],
  "./fr-CA/rate_limiting_settings.json": [
    "869279",
    [
      229817
    ]
  ],
  "./da-x-k12/course_template_details.json": [
    "649058",
    [
      25934
    ]
  ],
  "./en-GB-x-lbs/blueprint_course_child.json": [
    "834280",
    [
      575968
    ]
  ],
  "./da/canvas_file_upload.json": [
    "843546",
    [
      578226
    ]
  ],
  "./fr-CA/a2LatePolicyToolTipContent.json": [
    "501112",
    [
      894404
    ]
  ],
  "./hu/course_paces_errors.json": [
    "360789",
    [
      985275
    ]
  ],
  "./ja/quizzes_regrade_modal.json": [
    "672343",
    [
      609818
    ]
  ],
  "./ca/assignments_2_external_tool.json": [
    "767252",
    [
      340732
    ]
  ],
  "./hy.json": [
    "449510",
    [
      151064
    ]
  ],
  "./sl/discussion_insights.json": [
    "387469",
    [
      281839
    ]
  ],
  "./tr/account_notification_settings.json": [
    "45317",
    [
      411279
    ]
  ],
  "./nb-x-k12/progress_pill.json": [
    "78091",
    [
      868790
    ]
  ],
  "./ja/submissions_show_preview.json": [
    "399445",
    [
      588364
    ]
  ],
  "./es-ES/unpublished_changes_button_props.json": [
    "163354",
    [
      702282
    ]
  ],
  "./fr/comm_messages.json": [
    "376535",
    [
      317790
    ]
  ],
  "./pt-BR/course_template_details.json": [
    "306102",
    [
      105359
    ]
  ],
  "./tr/learning_mastery_gradebook.json": [
    "130669",
    [
      464599
    ]
  ],
  "./sl/bulk_edit_students_actions.json": [
    "460089",
    [
      359075
    ]
  ],
  "./hi/course_paces_time_selection.json": [
    "343646",
    [
      368134
    ]
  ],
  "./fr-CA.eager.json": [
    "38346",
    [
      200785
    ]
  ],
  "./es-ES/course_paces_flaggable_number_input.json": [
    "10050",
    [
      290658
    ]
  ],
  "./pt-BR/pseudonyms_mobile_login.json": [
    "323363",
    [
      297286
    ]
  ],
  "./en-GB-x-ukhe/progression_module_header.json": [
    "937432",
    [
      265200
    ]
  ],
  "./en-GB-x-ukhe/discussion_create.json": [
    "946081",
    [
      31831
    ]
  ],
  "./nn/blueprint_settingsAssociationsTable.json": [
    "276385",
    [
      132379
    ]
  ],
  "./ko/webcam_modal.json": [
    "657111",
    [
      199029
    ]
  ],
  "./en-GB/restore_content_pane.json": [
    "81386",
    [
      535935
    ]
  ],
  "./id/quiz_migration_notifications.json": [
    "603412",
    [
      543752
    ]
  ],
  "./sv-x-k12/progress_pill.json": [
    "703694",
    [
      616902
    ]
  ],
  "./is/modelsQuiz.json": [
    "535285",
    [
      758499
    ]
  ],
  "./nb-x-k12/user_search_results.json": [
    "182709",
    [
      953699
    ]
  ],
  "./en-GB-x-ukhe/outcome_management.json": [
    "416806",
    [
      375678
    ]
  ],
  "./pt.eager.json": [
    "194051",
    [
      613042
    ]
  ],
  "./sv/SpeedGraderDiscussionsNavigation.json": [
    "503426",
    [
      331574
    ]
  ],
  "./pt-BR/CreateEditAssignmentModal.json": [
    "625393",
    [
      45432
    ]
  ],
  "./ru/assignments_2_submission_helpers.json": [
    "407959",
    [
      935405
    ]
  ],
  "./vi/account_calendars.json": [
    "440648",
    [
      260304
    ]
  ],
  "./ar/assignments_2_student_points_display.json": [
    "318917",
    [
      403071
    ]
  ],
  "./ar/assignments.json": [
    "135431",
    [
      569721
    ]
  ],
  "./cy/horizon_toggle.json": [
    "356194",
    [
      229850
    ]
  ],
  "./pl/accessibility_scan.json": [
    "476330",
    [
      504534
    ]
  ],
  "./vi/course_navigation_settings.json": [
    "709157",
    [
      395139
    ]
  ],
  "./ko/terms_of_service_modal.json": [
    "98095",
    [
      558429
    ]
  ],
  "./sv-x-k12/sidenav.json": [
    "504485",
    [
      169699
    ]
  ],
  "./pl/react_collaborations.json": [
    "516296",
    [
      884116
    ]
  ],
  "./fr-CA/last_attended.json": [
    "482979",
    [
      265261
    ]
  ],
  "./tr/add_edit_pseudonym.json": [
    "370841",
    [
      210395
    ]
  ],
  "./ms/account_calendars_results_area.json": [
    "924140",
    [
      894036
    ]
  ],
  "./hi/default_account_quotas.json": [
    "95836",
    [
      772364
    ]
  ],
  "./en-AU-x-unimelb/dashboard.json": [
    "199454",
    [
      914370
    ]
  ],
  "./ca/grade_change_logging_content.json": [
    "832942",
    [
      349326
    ]
  ],
  "./hi/custom_help_link.json": [
    "738295",
    [
      895021
    ]
  ],
  "./hy/assignment_2_assignment_toggle_details.json": [
    "306867",
    [
      987921
    ]
  ],
  "./ja/comm_messages.json": [
    "689942",
    [
      381079
    ]
  ],
  "./fr/lti_registration.wizard.json": [
    "894544",
    [
      233433
    ]
  ],
  "./nb/important_dates_empty.json": [
    "765776",
    [
      458636
    ]
  ],
  "./es-ES/unpublished_changes_tray_contents.json": [
    "710090",
    [
      881594
    ]
  ],
  "./fa/change_password.json": [
    "172059",
    [
      707126
    ]
  ],
  "./he/content_shares.json": [
    "163993",
    [
      310023
    ]
  ],
  "./nb-x-k12/license_help.json": [
    "183683",
    [
      467153
    ]
  ],
  "./is/student_study_drawer.json": [
    "50357",
    [
      814323
    ]
  ],
  "./nb/a2_AccessibleTipContent.json": [
    "24122",
    [
      659726
    ]
  ],
  "./pt-BR/a2LatePolicyStatusDisplay.json": [
    "557600",
    [
      904717
    ]
  ],
  "./pt-BR/gradebook_uploads.json": [
    "420964",
    [
      68169
    ]
  ],
  "./ru/assignments_2_student_header.json": [
    "683672",
    [
      43680
    ]
  ],
  "./en-GB-x-lbs/blueprint_course_sidebar.json": [
    "183242",
    [
      780858
    ]
  ],
  "./it/permissions_v2.json": [
    "860764",
    [
      231016
    ]
  ],
  "./fa/submit_online_url_assignment.json": [
    "500949",
    [
      171971
    ]
  ],
  "./nl/discussion_insights.json": [
    "939368",
    [
      249620
    ]
  ],
  "./vi/assignments_2_MoreOptions_CanvasFiles.json": [
    "601554",
    [
      914674
    ]
  ],
  "./sv/course_paces_no_results.json": [
    "62850",
    [
      70534
    ]
  ],
  "./tr/user_profile.json": [
    "567377",
    [
      443811
    ]
  ],
  "./zh-Hans/react_scheduler.json": [
    "404076",
    [
      307996
    ]
  ],
  "./ms/discussion_row.json": [
    "791449",
    [
      873095
    ]
  ],
  "./es-ES/sharedSetDefaultGradeDialog.json": [
    "688696",
    [
      912496
    ]
  ],
  "./hi/collaborations.json": [
    "29309",
    [
      455275
    ]
  ],
  "./ga/outcome_reporting.json": [
    "237567",
    [
      840661
    ]
  ],
  "./ms/grade_summary.json": [
    "110358",
    [
      748150
    ]
  ],
  "./da/question_banks.json": [
    "839175",
    [
      985893
    ]
  ],
  "./zh-Hant/course_paces_assignment_row.json": [
    "397429",
    [
      988663
    ]
  ],
  "./da-x-k12/collaborations.json": [
    "469243",
    [
      810509
    ]
  ],
  "./hi/course_paces_no_results.json": [
    "282584",
    [
      731952
    ]
  ],
  "./nn/permissions_role_tray.json": [
    "449440",
    [
      858028
    ]
  ],
  "./en-GB/eportfolio.json": [
    "522188",
    [
      612653
    ]
  ],
  "./vi/GroupDetailView.json": [
    "486048",
    [
      103464
    ]
  ],
  "./es-ES/user_restore.json": [
    "993191",
    [
      141949
    ]
  ],
  "./th/HelpTray.json": [
    "50985",
    [
      996219
    ]
  ],
  "./zh-Hans/content_migrations_redesign.json": [
    "412906",
    [
      466218
    ]
  ],
  "./fr/discussion_pinned_post.json": [
    "762356",
    [
      230429
    ]
  ],
  "./en/question_bank.json": [
    "938382",
    [
      809810
    ]
  ],
  "./ms/account_calendar_settings.json": [
    "889904",
    [
      78928
    ]
  ],
  "./fa/question_banks.json": [
    "561645",
    [
      41563
    ]
  ],
  "./ja/security_panel.json": [
    "239722",
    [
      460435
    ]
  ],
  "./ar/gradebook_history.json": [
    "162152",
    [
      316540
    ]
  ],
  "./cy/upload_button.json": [
    "317884",
    [
      912804
    ]
  ],
  "./pt-BR/jobs_v2.json": [
    "517594",
    [
      637435
    ]
  ],
  "./it/SpeedGraderCheckpoints.json": [
    "111046",
    [
      900650
    ]
  ],
  "./he/user_date_range_search.json": [
    "617268",
    [
      247948
    ]
  ],
  "./nb-x-k12/quiz_statistics.json": [
    "618349",
    [
      846235
    ]
  ],
  "./es-ES/rate_limiting_settings.json": [
    "629339",
    [
      666473
    ]
  ],
  "./fr-CA/quiz_log_auditing.json": [
    "502371",
    [
      167269
    ]
  ],
  "./ar/quiz_log_auditing.json": [
    "191117",
    [
      946495
    ]
  ],
  "./da-x-k12/copy_warnings_modal.json": [
    "425030",
    [
      165322
    ]
  ],
  "./ja/direct_share_course_import_panel.json": [
    "198653",
    [
      663316
    ]
  ],
  "./vi/account_notification_settings.json": [
    "918654",
    [
      115814
    ]
  ],
  "./el/dashboard.json": [
    "786023",
    [
      449809
    ]
  ],
  "./fi/remove_pace_warning_modal.json": [
    "866188",
    [
      650412
    ]
  ],
  "./nb-x-k12/OutcomeMoveModal.json": [
    "344522",
    [
      210826
    ]
  ],
  "./ms/theme_editor.json": [
    "705033",
    [
      316996
    ]
  ],
  "./nn/dashboard_grading_period_select.json": [
    "962212",
    [
      741760
    ]
  ],
  "./hi/grade_summaryGroupView.json": [
    "976869",
    [
      359187
    ]
  ],
  "./es-ES/assignments_peer_reviews_student.json": [
    "597788",
    [
      241980
    ]
  ],
  "./he/discussion_settings.json": [
    "948529",
    [
      171375
    ]
  ],
  "./hi/new_nav.json": [
    "432097",
    [
      23079
    ]
  ],
  "./pl/modules_home_page.json": [
    "703563",
    [
      672685
    ]
  ],
  "./pt/copy_warnings_modal.json": [
    "739367",
    [
      392001
    ]
  ],
  "./nl/assignments_2_text_entry.json": [
    "668240",
    [
      174364
    ]
  ],
  "./id/plugins.json": [
    "681611",
    [
      478205
    ]
  ],
  "./nl/moderate_quiz.json": [
    "714071",
    [
      255265
    ]
  ],
  "./sv/lti_registrations.json": [
    "721106",
    [
      557031
    ]
  ],
  "./fa/unpublished_changes_tray_contents.json": [
    "447570",
    [
      94626
    ]
  ],
  "./hy/assignments_2_MoreOptions.json": [
    "892360",
    [
      751184
    ]
  ],
  "./pl/restore_content_pane.json": [
    "721613",
    [
      114511
    ]
  ],
  "./zh-Hans/k5_course.json": [
    "590845",
    [
      970651
    ]
  ],
  "./pt/user_profile.json": [
    "630787",
    [
      636237
    ]
  ],
  "./cy/assignments_2_submission_histories_query.json": [
    "968618",
    [
      858770
    ]
  ],
  "./it/peer_review_allocation_rule_card.json": [
    "202947",
    [
      289645
    ]
  ],
  "./nl/grade_summary.json": [
    "155200",
    [
      634356
    ]
  ],
  "./vi/blueprint_settingsCoursePickerTable.json": [
    "868309",
    [
      708259
    ]
  ],
  "./el/user_date_range_search.json": [
    "915930",
    [
      81678
    ]
  ],
  "./ko/calendar.header.json": [
    "963089",
    [
      754924
    ]
  ],
  "./mi/user.json": [
    "529295",
    [
      209005
    ]
  ],
  "./sl/assignment_2_assignment_toggle_details.json": [
    "897851",
    [
      712005
    ]
  ],
  "./da/assignments_2_student_header.json": [
    "65078",
    [
      728198
    ]
  ],
  "./tr/assignmentsIndexView.json": [
    "531655",
    [
      204705
    ]
  ],
  "./id/not_found_page_slide_puzzle.json": [
    "268892",
    [
      676992
    ]
  ],
  "./uk/OutcomeMoveModal.json": [
    "837940",
    [
      265308
    ]
  ],
  "./es-ES/user_search_results.json": [
    "120154",
    [
      8090
    ]
  ],
  "./id/SpeedGraderDiscussionsNavigation.json": [
    "672750",
    [
      849618
    ]
  ],
  "./pl/blueprint_coursesExpandableLockOptions.json": [
    "175427",
    [
      762757
    ]
  ],
  "./sv/course_statistics.json": [
    "433098",
    [
      163086
    ]
  ],
  "./nn/assignments_2_submission_histories_query.json": [
    "943366",
    [
      885810
    ]
  ],
  "./sl/account_calendar_settings_account_group.json": [
    "669647",
    [
      247369
    ]
  ],
  "./uk/new_nav.json": [
    "593789",
    [
      678434
    ]
  ],
  "./is/link_validator.json": [
    "303279",
    [
      354501
    ]
  ],
  "./ko/course_paces_settings.json": [
    "14314",
    [
      687746
    ]
  ],
  "./nb-x-k12/canvascareer.json": [
    "316998",
    [
      882094
    ]
  ],
  "./de/assignments_2_student_content_rubric_self_assessment.json": [
    "680474",
    [
      985147
    ]
  ],
  "./pt-BR/account_calendar_settings_utils.json": [
    "584559",
    [
      87786
    ]
  ],
  "./fi/calendar_custom_recurring_event_repeat_picker.json": [
    "876525",
    [
      78123
    ]
  ],
  "./en-GB-x-ukhe/account_settings.json": [
    "45121",
    [
      17543
    ]
  ],
  "./sl/appt_calendar_event_dialog.json": [
    "734539",
    [
      779805
    ]
  ],
  "./da/accessibility_scan.json": [
    "887371",
    [
      730273
    ]
  ],
  "./en-GB-x-ukhe/todo.json": [
    "968496",
    [
      978568
    ]
  ],
  "./uk/media_player_iframe_content.json": [
    "161441",
    [
      974703
    ]
  ],
  "./ar/content_migrations_redesign.json": [
    "110370",
    [
      474942
    ]
  ],
  "./ar/course_navigation_settings.json": [
    "987407",
    [
      410585
    ]
  ],
  "./ja/media_immersive_view.json": [
    "443129",
    [
      944248
    ]
  ],
  "./mi/pairing_code_user_observees.json": [
    "469061",
    [
      947787
    ]
  ],
  "./sv/section.json": [
    "443072",
    [
      456372
    ]
  ],
  "./vi/blueprint_settingsSyncChange.json": [
    "450007",
    [
      781437
    ]
  ],
  "./pl/peer_review_allocation_rules_tray.json": [
    "954651",
    [
      1477
    ]
  ],
  "./nl/assignments_2_submission_histories_query.json": [
    "666028",
    [
      437616
    ]
  ],
  "./zh-Hant/progress_pill.json": [
    "270307",
    [
      38909
    ]
  ],
  "./ms/quantitative_data_options.json": [
    "874203",
    [
      251329
    ]
  ],
  "./uk/course_paces_app.json": [
    "693640",
    [
      712
    ]
  ],
  "./es-ES/peer_review_configuration_tray.json": [
    "94240",
    [
      758936
    ]
  ],
  "./sv-x-k12/account_settings_jsx_bundle.json": [
    "630509",
    [
      332843
    ]
  ],
  "./ca/ignite_agent.json": [
    "760014",
    [
      310446
    ]
  ],
  "./ca/lti_registrations.json": [
    "697200",
    [
      598272
    ]
  ],
  "./en-AU/accessibility_scan.json": [
    "836548",
    [
      819937
    ]
  ],
  "./cy/assignments_2_student_header_date_title.json": [
    "444117",
    [
      865851
    ]
  ],
  "./sv-x-k12/blueprint_settingsSyncChange.json": [
    "340653",
    [
      482763
    ]
  ],
  "./id/react_developer_keys.json": [
    "738186",
    [
      542374
    ]
  ],
  "./he/discussionTopicKeyboradShortcutModal.json": [
    "344764",
    [
      982532
    ]
  ],
  "./vi/gradebookOutcomeGradebookView.json": [
    "562102",
    [
      630270
    ]
  ],
  "./uk/new_user_tutorial.json": [
    "429081",
    [
      464791
    ]
  ],
  "./pl/quiz_log_auditing.json": [
    "128686",
    [
      633562
    ]
  ],
  "./pt-BR/DueDateOverrideView.json": [
    "460092",
    [
      163057
    ]
  ],
  "./pt/quantitative_data_options.json": [
    "588171",
    [
      378413
    ]
  ],
  "./th/course_paces_settings.json": [
    "740748",
    [
      39952
    ]
  ],
  "./el/assignments_2_student_points_display.json": [
    "594855",
    [
      885145
    ]
  ],
  "./ht/context_roster_user_services.json": [
    "221190",
    [
      100146
    ]
  ],
  "./sv-x-k12/mutationActivity.json": [
    "821237",
    [
      430163
    ]
  ],
  "./cy/assignments.no_assignments_search.json": [
    "257085",
    [
      698702
    ]
  ],
  "./fr-CA/internal-settings.json": [
    "328506",
    [
      591950
    ]
  ],
  "./el/job_stats.json": [
    "650148",
    [
      738672
    ]
  ],
  "./vi/important_dates_empty.json": [
    "16977",
    [
      152695
    ]
  ],
  "./ca/syllabus_revisions.json": [
    "534152",
    [
      566856
    ]
  ],
  "./nb-x-k12/account_calendars_results_area.json": [
    "403950",
    [
      210358
    ]
  ],
  "./th/external_content_cancel.json": [
    "531290",
    [
      309702
    ]
  ],
  "./en-GB-x-ukhe/react_developer_keys.json": [
    "196247",
    [
      171037
    ]
  ],
  "./tr/roster_publicjs.json": [
    "530698",
    [
      683718
    ]
  ],
  "./hi/GroupsTray.json": [
    "803611",
    [
      619721
    ]
  ],
  "./cy/assignments_2_MoreOptions.json": [
    "134951",
    [
      364917
    ]
  ],
  "./de/account_calendar_settings_filter_controls.json": [
    "993281",
    [
      63464
    ]
  ],
  "./is/LearningMasteryGradebook.json": [
    "475917",
    [
      350539
    ]
  ],
  "./ru/blueprint_settingsSyncChange.json": [
    "634599",
    [
      720669
    ]
  ],
  "./sl/CommentLibrary.json": [
    "974315",
    [
      704413
    ]
  ],
  "./hy/terms_index.json": [
    "294209",
    [
      435975
    ]
  ],
  "./is/assignments_2_url_entry.json": [
    "908780",
    [
      135804
    ]
  ],
  "./ar/editAssignmentGroupWeights.json": [
    "717898",
    [
      723038
    ]
  ],
  "./de/ProfileTray.json": [
    "588520",
    [
      621205
    ]
  ],
  "./ms/available_pronouns_list.json": [
    "829615",
    [
      811341
    ]
  ],
  "./pt/unpublished_changes_button_props.json": [
    "590485",
    [
      44631
    ]
  ],
  "./is/assignments_2_text_entry.json": [
    "671274",
    [
      484010
    ]
  ],
  "./th/jobs.json": [
    "133958",
    [
      388762
    ]
  ],
  "./da-x-k12/content_migrations.json": [
    "751742",
    [
      238834
    ]
  ],
  "./ja/modelsQuiz.json": [
    "213774",
    [
      266415
    ]
  ],
  "./es/MoveOutcomesModal.json": [
    "474115",
    [
      373742
    ]
  ],
  "./ja/gradebookActionMenu.json": [
    "249216",
    [
      540037
    ]
  ],
  "./nb-x-k12/nav_tourpoints.json": [
    "578123",
    [
      671913
    ]
  ],
  "./da/courses.show.json": [
    "270186",
    [
      411017
    ]
  ],
  "./sl/courses.json": [
    "716363",
    [
      411925
    ]
  ],
  "./fa/bulk_edit_students_table.json": [
    "210276",
    [
      16340
    ]
  ],
  "./ar/modules_home_page.json": [
    "972208",
    [
      794748
    ]
  ],
  "./vi/account_settings.json": [
    "426676",
    [
      211028
    ]
  ],
  "./nb-x-k12/assignments_2_submission_histories_query.json": [
    "425272",
    [
      920480
    ]
  ],
  "./zh-Hant/self_enrollment.json": [
    "199331",
    [
      756741
    ]
  ],
  "./fi/progress_pill.json": [
    "964256",
    [
      156344
    ]
  ],
  "./ca/bulk_edit_students_actions.json": [
    "938268",
    [
      958420
    ]
  ],
  "./ht/unpublished_changes_button_props.json": [
    "595933",
    [
      306383
    ]
  ],
  "./hi/a2_AccessibleTipContent.json": [
    "9393",
    [
      387127
    ]
  ],
  "./sl/submit_online_url_assignment.json": [
    "314835",
    [
      651317
    ]
  ],
  "./ar/calendar.header.json": [
    "556644",
    [
      371203
    ]
  ],
  "./el/SpeedGraderPostGradesMenu.json": [
    "144918",
    [
      961602
    ]
  ],
  "./vi/gradebook_default_gradebook_components_content_filters_module_filter.json": [
    "647957",
    [
      334531
    ]
  ],
  "./ht/editGroup.json": [
    "546477",
    [
      295383
    ]
  ],
  "./nb-x-k12/sis_import.json": [
    "807707",
    [
      327753
    ]
  ],
  "./id/account_calendars_modal.json": [
    "115138",
    [
      115126
    ]
  ],
  "./uk/AssignmentGroupListItemView.json": [
    "966452",
    [
      839004
    ]
  ],
  "./fr/SpeedGraderPostGradesMenu.json": [
    "886751",
    [
      763617
    ]
  ],
  "./fr-CA/course_paces_pace_picker.json": [
    "856326",
    [
      341306
    ]
  ],
  "./ca/security_panel.json": [
    "212733",
    [
      791427
    ]
  ],
  "./en-GB/CourseAvailabilityOptions.json": [
    "550803",
    [
      951802
    ]
  ],
  "./ko/terms_index.json": [
    "276016",
    [
      612576
    ]
  ],
  "./ms/user_date_range_search.json": [
    "735601",
    [
      513615
    ]
  ],
  "./fa/calendar_edit.json": [
    "114052",
    [
      124388
    ]
  ],
  "./cy/files_v2.json": [
    "879154",
    [
      239082
    ]
  ],
  "./es-ES/assignments_2_attempt_tab.json": [
    "16894",
    [
      770822
    ]
  ],
  "./fa/Navigation.json": [
    "244483",
    [
      960897
    ]
  ],
  "./ar/MobileGlobalMenu.json": [
    "857345",
    [
      118267
    ]
  ],
  "./en-GB/LogoutButton.json": [
    "655999",
    [
      232934
    ]
  ],
  "./fa/assignments_2_submission_helpers.json": [
    "885391",
    [
      774501
    ]
  ],
  "./id/CoursesTray.json": [
    "707573",
    [
      429063
    ]
  ],
  "./nb/account_calendar_settings_account_list.json": [
    "142265",
    [
      836219
    ]
  ],
  "./nb-x-k12/account_settings_jsx_bundle.json": [
    "178820",
    [
      373812
    ]
  ],
  "./pl/learning_mastery_gradebook.json": [
    "741791",
    [
      63201
    ]
  ],
  "./zh-Hans/courses.json": [
    "233787",
    [
      946473
    ]
  ],
  "./es/grades_empty_page.json": [
    "417806",
    [
      427839
    ]
  ],
  "./ms/assignments_peer_reviews_student.json": [
    "323427",
    [
      251545
    ]
  ],
  "./en-GB-x-lbs/ProfileTray.json": [
    "264217",
    [
      362991
    ]
  ],
  "./hu/course_restore.json": [
    "885731",
    [
      834521
    ]
  ],
  "./ru/account_calendar_settings_footer.json": [
    "646001",
    [
      236295
    ]
  ],
  "./zh-Hans/add_edit_pseudonym.json": [
    "539234",
    [
      961906
    ]
  ],
  "./is/accessibility_scan.json": [
    "149854",
    [
      845622
    ]
  ],
  "./ms/course_logging_details.json": [
    "491728",
    [
      162256
    ]
  ],
  "./ja/student_annotation_preview.json": [
    "395475",
    [
      269230
    ]
  ],
  "./vi/youtube_migration.json": [
    "287337",
    [
      697343
    ]
  ],
  "./pt/jobs.json": [
    "202374",
    [
      84490
    ]
  ],
  "./vi/permissions_role_tray_table_row.json": [
    "972829",
    [
      563291
    ]
  ],
  "./nb/account_settings.json": [
    "811811",
    [
      406693
    ]
  ],
  "./en-GB-x-ukhe/assignments_2_student_header.json": [
    "490937",
    [
      22319
    ]
  ],
  "./es/assignments_2_text_entry.json": [
    "277414",
    [
      462359
    ]
  ],
  "./fa/accessibility_scan.json": [
    "401829",
    [
      668563
    ]
  ],
  "./hi/moderate_quiz.json": [
    "478822",
    [
      256526
    ]
  ],
  "./hi/bounced_emails.json": [
    "222303",
    [
      33797
    ]
  ],
  "./cy/calendar_sidebar.json": [
    "495635",
    [
      108713
    ]
  ],
  "./ar/account_calendar_settings_account_list.json": [
    "321612",
    [
      87560
    ]
  ],
  "./da/assignments_2_MoreOptions.json": [
    "357172",
    [
      687356
    ]
  ],
  "./es/question_banks.json": [
    "644230",
    [
      517047
    ]
  ],
  "./hi/assignments_2_text_entry.json": [
    "905695",
    [
      227525
    ]
  ],
  "./nb-x-k12/confirmMasteryModal.json": [
    "764518",
    [
      863358
    ]
  ],
  "./id/assignments_2_student_content_rubric_self_assessment.json": [
    "63268",
    [
      152392
    ]
  ],
  "./fi/bulk_edit_students.json": [
    "492519",
    [
      88525
    ]
  ],
  "./en-GB-x-lbs/webcam_modal.json": [
    "198535",
    [
      935037
    ]
  ],
  "./id/course_paces_assignment_row.json": [
    "560078",
    [
      643730
    ]
  ],
  "./sv/calendar_custom_recurring_event_repeat_picker.json": [
    "236489",
    [
      933003
    ]
  ],
  "./nb-x-k12/assignments_2_peer_review.json": [
    "335497",
    [
      882175
    ]
  ],
  "./en-GB-x-ukhe/assignments_2_url_entry.json": [
    "758234",
    [
      817898
    ]
  ],
  "./it/dashboard_grading_period_select.json": [
    "498689",
    [
      643395
    ]
  ],
  "./nb/courses.json": [
    "901916",
    [
      43552
    ]
  ],
  "./vi/upload_button.json": [
    "706633",
    [
      332783
    ]
  ],
  "./en-GB-x-lbs/accessibility_checker.json": [
    "609300",
    [
      657396
    ]
  ],
  "./en-AU/gradebook_history.json": [
    "877121",
    [
      194656
    ]
  ],
  "./tr/gradebook_history.json": [
    "824937",
    [
      338619
    ]
  ],
  "./ms/grades_summary.json": [
    "799458",
    [
      979547
    ]
  ],
  "./tr/peer-review-assignment-widget.json": [
    "858050",
    [
      114126
    ]
  ],
  "./fa/course_template_details.json": [
    "534718",
    [
      100838
    ]
  ],
  "./sl/DueDateOverrideView.json": [
    "875718",
    [
      637714
    ]
  ],
  "./ja/course_paces_empty_state.json": [
    "586583",
    [
      453338
    ]
  ],
  "./nb/collaborations.json": [
    "181772",
    [
      548152
    ]
  ],
  "./fa/assignmentsToggleShowByView.json": [
    "626176",
    [
      513000
    ]
  ],
  "./fa/suppress_notifications.json": [
    "90705",
    [
      417991
    ]
  ],
  "./cy/comm_messages.json": [
    "3167",
    [
      290013
    ]
  ],
  "./mi/gradebook.json": [
    "749650",
    [
      386602
    ]
  ],
  "./tr/course_paces_app.json": [
    "879726",
    [
      989322
    ]
  ],
  "./sv-x-k12/assignments_2_text_entry.json": [
    "618047",
    [
      609029
    ]
  ],
  "./pt/AlignmentSummary.json": [
    "734093",
    [
      919807
    ]
  ],
  "./pt-BR/sharedSetDefaultGradeDialog.json": [
    "737432",
    [
      49205
    ]
  ],
  "./ca/discussion_pinned_post.json": [
    "335108",
    [
      683692
    ]
  ],
  "./nn/modelsQuiz.json": [
    "884525",
    [
      687543
    ]
  ],
  "./da/assignmentsIndexView.json": [
    "107244",
    [
      460740
    ]
  ],
  "./cy/assignments_2_shared_Steps.json": [
    "760115",
    [
      86601
    ]
  ],
  "./zh-Hant/users.json": [
    "325772",
    [
      199336
    ]
  ],
  "./en/calendar_custom_recurring_event_natural_language.json": [
    "931411",
    [
      166461
    ]
  ],
  "./cy/assignments_bulk_edit.json": [
    "365146",
    [
      141506
    ]
  ],
  "./sl/accessibility_course_statistics.json": [
    "616851",
    [
      63773
    ]
  ],
  "./zh-Hant/CommentLibrary.json": [
    "731180",
    [
      943848
    ]
  ],
  "./is/announcements_v2.json": [
    "230411",
    [
      44921
    ]
  ],
  "./en-GB-x-ukhe/remove_pace_warning_modal.json": [
    "764483",
    [
      892273
    ]
  ],
  "./hi/copy_warnings_modal.json": [
    "858920",
    [
      825648
    ]
  ],
  "./zh-Hans/pairing_code_user_observees.json": [
    "913348",
    [
      146228
    ]
  ],
  "./fi/course_paces_blackout_date_row.json": [
    "987597",
    [
      27627
    ]
  ],
  "./th/account_settings.json": [
    "16171",
    [
      413805
    ]
  ],
  "./ar/FindOutcomesModal.json": [
    "106518",
    [
      168114
    ]
  ],
  "./nl/jobs_v2.json": [
    "788189",
    [
      693191
    ]
  ],
  "./ga/content_copy_redesign.json": [
    "379221",
    [
      582451
    ]
  ],
  "./pt-BR/restore_content_pane.json": [
    "89222",
    [
      660527
    ]
  ],
  "./fi/blueprint_settingsSyncHistory.json": [
    "477889",
    [
      265831
    ]
  ],
  "./cy/discussion_posts.json": [
    "580282",
    [
      381410
    ]
  ],
  "./hi/internal-settings.json": [
    "275036",
    [
      32940
    ]
  ],
  "./ru/submissions_show_preview.json": [
    "913009",
    [
      908663
    ]
  ],
  "./ht/quiz_show.json": [
    "535389",
    [
      408295
    ]
  ],
  "./en-AU/dashboard.json": [
    "946656",
    [
      528005
    ]
  ],
  "./hy/GroupsTray.json": [
    "738059",
    [
      863353
    ]
  ],
  "./zh-Hant/rubrics-export.json": [
    "829411",
    [
      868957
    ]
  ],
  "./en-CA/sidenav.json": [
    "884530",
    [
      407666
    ]
  ],
  "./ru/assignment_show.json": [
    "371700",
    [
      352788
    ]
  ],
  "./ca/external_content_cancel.json": [
    "437898",
    [
      442498
    ]
  ],
  "./en-GB-x-ukhe/assignment_index_menu.json": [
    "316252",
    [
      976348
    ]
  ],
  "./zh-Hant/empty_modules.json": [
    "99459",
    [
      701085
    ]
  ],
  "./tr/last_attended.json": [
    "356804",
    [
      456576
    ]
  ],
  "./nb-x-k12/modelsQuiz.json": [
    "333691",
    [
      618089
    ]
  ],
  "./el/choose_mastery_path.json": [
    "495776",
    [
      106236
    ]
  ],
  "./en-GB-x-lbs/sharedSetDefaultGradeDialog.json": [
    "790327",
    [
      206557
    ]
  ],
  "./es/bulk_edit_students.json": [
    "858208",
    [
      224821
    ]
  ],
  "./fr-CA/courses.show.json": [
    "516712",
    [
      33127
    ]
  ],
  "./id/filter_calendars_modal.json": [
    "689485",
    [
      333655
    ]
  ],
  "./is/peer-review-assignment-widget.json": [
    "293864",
    [
      497424
    ]
  ],
  "./zh-Hans/IndividualStudentMasteryOutcome.json": [
    "7084",
    [
      860348
    ]
  ],
  "./ru/modules_home_page.json": [
    "643166",
    [
      119545
    ]
  ],
  "./ja/course_paces_footer.json": [
    "579339",
    [
      613702
    ]
  ],
  "./sv/account_calendars.json": [
    "399564",
    [
      429120
    ]
  ],
  "./is/pseudonyms_mobile_login.json": [
    "668802",
    [
      424610
    ]
  ],
  "./da-x-k12/AssignmentListItemView.json": [
    "492442",
    [
      35302
    ]
  ],
  "./de/syllabus_revisions.json": [
    "278865",
    [
      252904
    ]
  ],
  "./zh-Hans/folder_tree.json": [
    "389924",
    [
      222500
    ]
  ],
  "./de/copy_warnings_modal.json": [
    "890048",
    [
      944973
    ]
  ],
  "./uk/theme_collection_view.json": [
    "343640",
    [
      241880
    ]
  ],
  "./is/calendar_custom_recurring_event_natural_language.json": [
    "235530",
    [
      415338
    ]
  ],
  "./pl.eager.json": [
    "68715",
    [
      939434
    ]
  ],
  "./vi/MoveOutcomesModal.json": [
    "235294",
    [
      459510
    ]
  ],
  "./vi/grade_summary.json": [
    "964879",
    [
      423477
    ]
  ],
  "./es/blueprint_settingsCourseFilter.json": [
    "459544",
    [
      317357
    ]
  ],
  "./ms/outcomes_user_outcome_results.json": [
    "279169",
    [
      880639
    ]
  ],
  "./sv-x-k12/outcomes_user_outcome_results.json": [
    "743610",
    [
      478842
    ]
  ],
  "./hi/calendar.header.json": [
    "955572",
    [
      730007
    ]
  ],
  "./pl/peer_review_configuration_tray.json": [
    "211499",
    [
      731085
    ]
  ],
  "./sl.eager.json": [
    "644312",
    [
      752407
    ]
  ],
  "./nb/conferences_alternatives.json": [
    "752474",
    [
      744134
    ]
  ],
  "./zh-Hant/content_share_preview_overlay.json": [
    "766773",
    [
      653999
    ]
  ],
  "./pt/gradebook.json": [
    "795248",
    [
      749756
    ]
  ],
  "./fr-CA/self_unenrollment_modal.json": [
    "731277",
    [
      295287
    ]
  ],
  "./ht/account_calendar_settings_filter_controls.json": [
    "840806",
    [
      627834
    ]
  ],
  "./en-GB-x-lbs/theme_collection_view.json": [
    "592450",
    [
      959666
    ]
  ],
  "./nb-x-k12/discussion_topics.json": [
    "973981",
    [
      346955
    ]
  ],
  "./date-formats.json": [
    "150484",
    [
      35006
    ]
  ],
  "./he/grades_summary.json": [
    "727024",
    [
      568016
    ]
  ],
  "./pl/student_study_drawer.json": [
    "278265",
    [
      459667
    ]
  ],
  "./zh-Hans/assignments_peer_reviews.json": [
    "116318",
    [
      174086
    ]
  ],
  "./en-GB-x-ukhe/jobs.json": [
    "390592",
    [
      284760
    ]
  ],
  "./zh-Hans/account_calendar_settings_footer.json": [
    "586351",
    [
      97669
    ]
  ],
  "./fi/important_dates_empty.json": [
    "179137",
    [
      20807
    ]
  ],
  "./el/authentication_providers.json": [
    "677488",
    [
      278228
    ]
  ],
  "./fr/jobs_v2.json": [
    "166875",
    [
      549506
    ]
  ],
  "./hi/unpublished_changes_tray_contents.json": [
    "712924",
    [
      948236
    ]
  ],
  "./ja/assignments_bulk_edit.json": [
    "102347",
    [
      755654
    ]
  ],
  "./is/account_calendar_settings_account_tree.json": [
    "764577",
    [
      470967
    ]
  ],
  "./sv-x-k12/k5_course.json": [
    "875221",
    [
      207683
    ]
  ],
  "./ja/user.json": [
    "292210",
    [
      223003
    ]
  ],
  "./fr-CA/GroupsTray.json": [
    "107661",
    [
      945007
    ]
  ],
  "./fa/course_paces_module.json": [
    "499828",
    [
      276596
    ]
  ],
  "./ko/assignments_2_submission_histories_query.json": [
    "94092",
    [
      384356
    ]
  ],
  "./el/OutcomeDescriptionModal.json": [
    "66956",
    [
      200704
    ]
  ],
  "./it/theme_collection_view.json": [
    "804429",
    [
      798415
    ]
  ],
  "./ru/blueprint_settingsCoursePicker.json": [
    "567143",
    [
      595981
    ]
  ],
  "./zh-Hans/blueprint_settingsSyncHistory.json": [
    "429507",
    [
      798065
    ]
  ],
  "./zh-Hant/important_dates_empty.json": [
    "630914",
    [
      401222
    ]
  ],
  "./el/restore_content_pane.json": [
    "812394",
    [
      404558
    ]
  ],
  "./pl/account_calendar_settings_confirmation_modal.json": [
    "276422",
    [
      968357
    ]
  ],
  "./sv/account_settings.json": [
    "350680",
    [
      789348
    ]
  ],
  "./en-GB-x-lbs/auth_logging.json": [
    "847196",
    [
      294492
    ]
  ],
  "./is/submit_assignment.json": [
    "658046",
    [
      370630
    ]
  ],
  "./el/assignments_2_student_header_date_title.json": [
    "789088",
    [
      973020
    ]
  ],
  "./ga/calculator.json": [
    "86514",
    [
      439762
    ]
  ],
  "./nn/outcome_detail.json": [
    "26738",
    [
      979334
    ]
  ],
  "./is/account_calendars_results_area.json": [
    "575824",
    [
      147176
    ]
  ],
  "./vi/custom_emoji_deny_list.json": [
    "986207",
    [
      821189
    ]
  ],
  "./ga/CreateEditAssignmentModal.json": [
    "827124",
    [
      489364
    ]
  ],
  "./fi/courses.show.json": [
    "670004",
    [
      894167
    ]
  ],
  "./pt-BR/question_banks.json": [
    "160805",
    [
      713556
    ]
  ],
  "./tr/account_calendar_settings_account_list.json": [
    "128535",
    [
      919305
    ]
  ],
  "./es-ES/quiz_log_auditing.json": [
    "148367",
    [
      580085
    ]
  ],
  "./sv-x-k12/video_conference.json": [
    "412181",
    [
      570979
    ]
  ],
  "./nn/assignments_2_file_upload.json": [
    "258444",
    [
      176544
    ]
  ],
  "./de/top_navigation_tools.json": [
    "905125",
    [
      826660
    ]
  ],
  "./sv-x-k12/course_pace_date_input.json": [
    "181434",
    [
      800298
    ]
  ],
  "./vi/calendar_appointment_group_edit.json": [
    "410154",
    [
      912282
    ]
  ],
  "./ar/course_paces_blackout_dates_modal.json": [
    "328471",
    [
      306801
    ]
  ],
  "./fr/course_paces_errors.json": [
    "195142",
    [
      186107
    ]
  ],
  "./he/outcomes_user_outcome_results.json": [
    "649286",
    [
      164934
    ]
  ],
  "./ca/course_stats.json": [
    "882843",
    [
      431697
    ]
  ],
  "./el/account_course_user_search.json": [
    "92647",
    [
      79065
    ]
  ],
  "./fr-CA/assignments_2_external_tool.json": [
    "951633",
    [
      800579
    ]
  ],
  "./mi/assignments_2_shared_Steps.json": [
    "869585",
    [
      933199
    ]
  ],
  "./nn/modules_home_page.json": [
    "219727",
    [
      607297
    ]
  ],
  "./da/course_paces_blackout_dates_table.json": [
    "208770",
    [
      504266
    ]
  ],
  "./mi/top_navigation_tools.json": [
    "244170",
    [
      103730
    ]
  ],
  "./ms/not_found_page_slide_puzzle.json": [
    "4681",
    [
      769655
    ]
  ],
  "./ga/progression_module_header.json": [
    "83190",
    [
      553150
    ]
  ],
  "./tr/change_password.json": [
    "832340",
    [
      708872
    ]
  ],
  "./ja/sections_tooltip.json": [
    "482277",
    [
      334684
    ]
  ],
  "./es-ES/question_bank.json": [
    "264800",
    [
      434840
    ]
  ],
  "./ms/Navigation.json": [
    "517760",
    [
      724256
    ]
  ],
  "./pl/gradebook_default_gradebook_components_content_filters_module_filter.json": [
    "794230",
    [
      980338
    ]
  ],
  "./is/security_panel.json": [
    "351945",
    [
      434175
    ]
  ],
  "./en-CA/suppress_notifications.json": [
    "237726",
    [
      348326
    ]
  ],
  "./ru/canvascareer.json": [
    "752119",
    [
      703837
    ]
  ],
  "./hy/new_user_tutorial.json": [
    "491722",
    [
      508330
    ]
  ],
  "./hy/keyboardShortcutModal.json": [
    "470445",
    [
      861179
    ]
  ],
  "./en-GB/section.json": [
    "157072",
    [
      543417
    ]
  ],
  "./pt-BR/assignments_2_student_header_date_title.json": [
    "968284",
    [
      649873
    ]
  ],
  "./pl/canvascareer.json": [
    "830260",
    [
      281656
    ]
  ],
  "./ar/horizon_toggle.json": [
    "406803",
    [
      61349
    ]
  ],
  "./it/discussion_topics.json": [
    "931654",
    [
      995050
    ]
  ],
  "./nn/discovery_page.json": [
    "615002",
    [
      507086
    ]
  ],
  "./zh-Hant/grades_empty_page.json": [
    "583872",
    [
      18884
    ]
  ],
  "./sl/course_paces_pace_picker.json": [
    "521700",
    [
      998328
    ]
  ],
  "./ko/EditMasteryScaleLink.json": [
    "841933",
    [
      396659
    ]
  ],
  "./hy/rate_limiting_settings.json": [
    "403589",
    [
      428179
    ]
  ],
  "./tr/outcome_management.json": [
    "16050",
    [
      183598
    ]
  ],
  "./zh-Hans/SpeedGraderSettingsMenu.json": [
    "239551",
    [
      611061
    ]
  ],
  "./id/accessibility_scan.json": [
    "205965",
    [
      589039
    ]
  ],
  "./uk/assignments_peer_reviews.json": [
    "737615",
    [
      233949
    ]
  ],
  "./de/dashboard_grading_period_select.json": [
    "788471",
    [
      855554
    ]
  ],
  "./es/collaborations.json": [
    "214844",
    [
      560201
    ]
  ],
  "./en-AU/account_calendar_settings_filter_controls.json": [
    "606548",
    [
      493041
    ]
  ],
  "./nl/todos_page.json": [
    "956525",
    [
      932879
    ]
  ],
  "./vi/calculator.json": [
    "849913",
    [
      774479
    ]
  ],
  "./da-x-k12/manage_avatars.json": [
    "485991",
    [
      372593
    ]
  ],
  "./ht/AlignmentSummary.json": [
    "716277",
    [
      10647
    ]
  ],
  "./ko/quantitative_data_options.json": [
    "259921",
    [
      340735
    ]
  ],
  "./zh-Hans/dashboard_grades_page.json": [
    "526428",
    [
      169532
    ]
  ],
  "./is/account_calendar_settings_utils.json": [
    "53334",
    [
      73966
    ]
  ],
  "./th/notebook.json": [
    "76059",
    [
      417223
    ]
  ],
  "./it/assignments_2_student_header.json": [
    "45368",
    [
      246236
    ]
  ],
  "./vi/modules_page_icon_legend.json": [
    "850568",
    [
      135328
    ]
  ],
  "./es/AlignmentSummary.json": [
    "787717",
    [
      319308
    ]
  ],
  "./zh-Hans/job_stats.json": [
    "87290",
    [
      435338
    ]
  ],
  "./fa/quiz_show.json": [
    "449792",
    [
      899672
    ]
  ],
  "./en-CA/eportfolio.json": [
    "297187",
    [
      537601
    ]
  ],
  "./uk/SpeedGraderPostGradesMenu.json": [
    "218767",
    [
      681245
    ]
  ],
  "./cy/enhanced_individual_gradebook_submit_score.json": [
    "390405",
    [
      268683
    ]
  ],
  "./hi/AddGroup.json": [
    "719801",
    [
      429951
    ]
  ],
  "./ko/user_date_range_search.json": [
    "158071",
    [
      464021
    ]
  ],
  "./id/a2LatePolicyStatusDisplay.json": [
    "44256",
    [
      662652
    ]
  ],
  "./ar/accessibility_checker.json": [
    "435017",
    [
      786795
    ]
  ],
  "./ru/courses.json": [
    "130973",
    [
      701083
    ]
  ],
  "./pt-BR/OutcomeMoveModal.json": [
    "842155",
    [
      861022
    ]
  ],
  "./sl/react_files.json": [
    "572930",
    [
      615302
    ]
  ],
  "./pt-BR/grade_summary.json": [
    "687215",
    [
      832890
    ]
  ],
  "./ja/edit_section_dates.json": [
    "333735",
    [
      567466
    ]
  ],
  "./id/assignments_2_student_header_date_title.json": [
    "708892",
    [
      890040
    ]
  ],
  "./ja/keyboardShortcutModal.json": [
    "984459",
    [
      488646
    ]
  ],
  "./ms/LearningMasteryGradebook.json": [
    "223921",
    [
      644303
    ]
  ],
  "./sv/modelsQuiz.json": [
    "786446",
    [
      27306
    ]
  ],
  "./da-x-k12/SpeedGraderSettingsMenu.json": [
    "928325",
    [
      552559
    ]
  ],
  "./fi/course_paces_settings.json": [
    "472093",
    [
      219243
    ]
  ],
  "./en-GB-x-lbs/course_template_details.json": [
    "354601",
    [
      291983
    ]
  ],
  "./el/quiz_log_auditing.json": [
    "486627",
    [
      670949
    ]
  ],
  "./sv-x-k12/account_calendars_modal.json": [
    "473048",
    [
      795184
    ]
  ],
  "./nb/comm_messages.json": [
    "829215",
    [
      29569
    ]
  ],
  "./en-GB-x-ukhe/authentication_providers.json": [
    "197717",
    [
      494147
    ]
  ],
  "./uk/learning_mastery_gradebook.json": [
    "966823",
    [
      111461
    ]
  ],
  "./ar/course_paces_settings.json": [
    "320407",
    [
      150529
    ]
  ],
  "./he/license_help.json": [
    "448524",
    [
      364948
    ]
  ],
  "./es-ES/jobs_v2.json": [
    "670714",
    [
      6986
    ]
  ],
  "./pt/account_calendars_modal.json": [
    "892691",
    [
      469501
    ]
  ],
  "./en-GB/permission_button.json": [
    "865963",
    [
      839850
    ]
  ],
  "./vi/discussion_insights.json": [
    "358159",
    [
      868389
    ]
  ],
  "./zh-Hant/assignments_2_url_entry.json": [
    "116870",
    [
      486986
    ]
  ],
  "./es-ES/AlignmentSummary.json": [
    "326006",
    [
      173022
    ]
  ],
  "./is/SpeedGraderDiscussionsNavigation.json": [
    "394133",
    [
      358435
    ]
  ],
  "./nb/user_logins.json": [
    "114296",
    [
      255492
    ]
  ],
  "./en/course_link_validator.json": [
    "929350",
    [
      882386
    ]
  ],
  "./nb/appt_calendar_event_dialog.json": [
    "674446",
    [
      20322
    ]
  ],
  "./nn/confirmMasteryModal.json": [
    "866048",
    [
      375780
    ]
  ],
  "./vi/react_developer_keys.json": [
    "215722",
    [
      163946
    ]
  ],
  "./he/accessibility_scan.json": [
    "252331",
    [
      879633
    ]
  ],
  "./en/announcements_v2.json": [
    "815610",
    [
      465286
    ]
  ],
  "./nn/account_settings.json": [
    "529287",
    [
      369081
    ]
  ],
  "./hu/reset_pace_warning_modal.json": [
    "289613",
    [
      199907
    ]
  ],
  "./pl/internal-settings.json": [
    "329875",
    [
      85173
    ]
  ],
  "./sv/blueprint_settingsSyncChange.json": [
    "371283",
    [
      586573
    ]
  ],
  "./id/course_paces_header.json": [
    "498757",
    [
      761743
    ]
  ],
  "./ru/quizzes.take_quiz.json": [
    "656989",
    [
      736074
    ]
  ],
  "./ko/gradebook_uploads.json": [
    "177859",
    [
      809001
    ]
  ],
  "./pt-BR/outcomes_user_outcome_results.json": [
    "361148",
    [
      633889
    ]
  ],
  "./ca/last_attended.json": [
    "545150",
    [
      332958
    ]
  ],
  "./sv-x-k12/custom_emoji_deny_list.json": [
    "96925",
    [
      809035
    ]
  ],
  "./sv-x-k12/account_calendars.json": [
    "17718",
    [
      427166
    ]
  ],
  "./it/accessibility_scan.json": [
    "338749",
    [
      569887
    ]
  ],
  "./fr-CA/grades_summary.json": [
    "551738",
    [
      116038
    ]
  ],
  "./da/account_course_user_search.json": [
    "485893",
    [
      144987
    ]
  ],
  "./hi/course_search_results.json": [
    "644794",
    [
      934282
    ]
  ],
  "./ca/course_paces_pace_picker.json": [
    "682213",
    [
      619995
    ]
  ],
  "./hu/submissions_show_preview.json": [
    "927727",
    [
      910477
    ]
  ],
  "./id/assignments_2_file_upload.json": [
    "975209",
    [
      312163
    ]
  ],
  "./sl/peer_review_allocation_rule_card.json": [
    "985725",
    [
      201799
    ]
  ],
  "./ms/quizzes_regrade_modal.json": [
    "272490",
    [
      185906
    ]
  ],
  "./ko/link_to_students.json": [
    "665001",
    [
      645063
    ]
  ],
  "./th/modules_page_icon_legend.json": [
    "551087",
    [
      41457
    ]
  ],
  "./tr/peer_reviews_student.json": [
    "183886",
    [
      508842
    ]
  ],
  "./pt/dashboard.json": [
    "938286",
    [
      156042
    ]
  ],
  "./da/outcome_alignment_v2.json": [
    "446168",
    [
      147512
    ]
  ],
  "./el/submissions_show_preview.json": [
    "888869",
    [
      135671
    ]
  ],
  "./ga/content_migrations.json": [
    "536145",
    [
      329079
    ]
  ],
  "./el/outcome_management.json": [
    "791299",
    [
      473629
    ]
  ],
  "./en-GB/terms_of_use.json": [
    "353116",
    [
      312653
    ]
  ],
  "./sv/add_edit_pseudonym.json": [
    "402332",
    [
      139720
    ]
  ],
  "./ca/sharedSetDefaultGradeDialog.json": [
    "923329",
    [
      80655
    ]
  ],
  "./hy/edit_section_start_date.json": [
    "801909",
    [
      338179
    ]
  ],
  "./el/account_calendars_results_area.json": [
    "110271",
    [
      981801
    ]
  ],
  "./ar/OutcomeDescriptionModal.json": [
    "156182",
    [
      560610
    ]
  ],
  "./ga/discussion_insights.json": [
    "794826",
    [
      408586
    ]
  ],
  "./is/password_complexity_configuration.json": [
    "436313",
    [
      948575
    ]
  ],
  "./sv-x-k12/course_paces_search.json": [
    "613718",
    [
      835278
    ]
  ],
  "./tr/assignment_index_deep_linking_handlers.json": [
    "319238",
    [
      445698
    ]
  ],
  "./sv/canvas_file_upload.json": [
    "6572",
    [
      523176
    ]
  ],
  "./ko/assignments_2_attempt_tab.json": [
    "282449",
    [
      840255
    ]
  ],
  "./sv-x-k12.eager.json": [
    "98224",
    [
      928611
    ]
  ],
  "./sl/peer-review-assignment-widget.json": [
    "268291",
    [
      65717
    ]
  ],
  "./da-x-k12/bulk_edit_students_table.json": [
    "238096",
    [
      972412
    ]
  ],
  "./es/ai_experiences_show.json": [
    "579834",
    [
      83635
    ]
  ],
  "./hi/video_conference.json": [
    "892789",
    [
      340451
    ]
  ],
  "./th/outcomes_user_outcome_results.json": [
    "961265",
    [
      964331
    ]
  ],
  "./tr/conferences_alternatives.json": [
    "928068",
    [
      500000
    ]
  ],
  "./zh-Hans/assignments_2_student_content_rubric_self_assessment.json": [
    "848250",
    [
      163370
    ]
  ],
  "./zh-Hant/permissions_role_tray.json": [
    "864034",
    [
      854206
    ]
  ],
  "./hi/OutcomeMoveModal.json": [
    "532985",
    [
      597455
    ]
  ],
  "./es/restore_content_pane.json": [
    "151853",
    [
      284372
    ]
  ],
  "./es/course_color_selector.json": [
    "197913",
    [
      335816
    ]
  ],
  "./nl/account_calendar_settings_account_calendar_item.json": [
    "799509",
    [
      161839
    ]
  ],
  "./nb/discussion_insights.json": [
    "654606",
    [
      953122
    ]
  ],
  "./zh-Hant/SpeedGraderCheckpoints.json": [
    "590653",
    [
      854977
    ]
  ],
  "./ar/grade_summaryGroupView.json": [
    "166677",
    [
      920623
    ]
  ],
  "./hu/blueprint_course_child.json": [
    "798187",
    [
      338737
    ]
  ],
  "./da/ignite_agent.json": [
    "462299",
    [
      573041
    ]
  ],
  "./en-AU-x-unimelb/file_not_found.json": [
    "674825",
    [
      669715
    ]
  ],
  "./zh-Hant/gradingPeriodTemplate.json": [
    "425387",
    [
      893085
    ]
  ],
  "./en-AU/assignments.json": [
    "616414",
    [
      211743
    ]
  ],
  "./sl/course_stats.json": [
    "352902",
    [
      550890
    ]
  ],
  "./en-GB/empty_course.json": [
    "322446",
    [
      149203
    ]
  ],
  "./nl/canvascareer.json": [
    "351986",
    [
      99998
    ]
  ],
  "./en-AU-x-unimelb/assignments_2_attempt_tab.json": [
    "49183",
    [
      355361
    ]
  ],
  "./nl/sections_tooltip.json": [
    "526127",
    [
      527400
    ]
  ],
  "./ga/webzip_export.json": [
    "800642",
    [
      568338
    ]
  ],
  "./id/assignments_2_student_content.json": [
    "35230",
    [
      533202
    ]
  ],
  "./zh-Hant.json": [
    "837619",
    [
      743575
    ]
  ],
  "./tr/permission_button.json": [
    "170448",
    [
      621508
    ]
  ],
  "./ja/course_template_details.json": [
    "865338",
    [
      735459
    ]
  ],
  "./he/announcements_v2.json": [
    "58102",
    [
      474838
    ]
  ],
  "./cy/discussion_topics.json": [
    "738003",
    [
      988233
    ]
  ],
  "./cy/gradinggradingPeriodCollection.json": [
    "518699",
    [
      769809
    ]
  ],
  "./hi/auth_logging.json": [
    "72323",
    [
      174657
    ]
  ],
  "./is/custom_emoji_deny_list.json": [
    "958496",
    [
      881288
    ]
  ],
  "./ms/account_notification_settings.json": [
    "674227",
    [
      282729
    ]
  ],
  "./pl/file_not_found.json": [
    "958193",
    [
      831219
    ]
  ],
  "./zh-Hant/discussion_insights.json": [
    "367020",
    [
      694504
    ]
  ],
  "./da-x-k12/course_paces_actions.json": [
    "229283",
    [
      358021
    ]
  ],
  "./pt/course_statistics.json": [
    "625827",
    [
      650197
    ]
  ],
  "./ca/dashboard.json": [
    "505726",
    [
      592478
    ]
  ],
  "./tr/license_help.json": [
    "11291",
    [
      536373
    ]
  ],
  "./hi/course_stats.json": [
    "73422",
    [
      499462
    ]
  ],
  "./pl/eportfolio.json": [
    "578171",
    [
      70837
    ]
  ],
  "./it/grade_summaryGroupView.json": [
    "130575",
    [
      644041
    ]
  ],
  "./sv/assignments_2_external_tool.json": [
    "85697",
    [
      268531
    ]
  ],
  "./vi/LearningMasteryGradebook.json": [
    "53206",
    [
      127454
    ]
  ],
  "./hu/peer_review_allocation_rule_card.json": [
    "819649",
    [
      110943
    ]
  ],
  "./it/context_prior_users.json": [
    "465132",
    [
      120352
    ]
  ],
  "./he/calendar_appointment_group_edit.json": [
    "668448",
    [
      356224
    ]
  ],
  "./en-AU/last_attended.json": [
    "519148",
    [
      680777
    ]
  ],
  "./vi/courses.json": [
    "513594",
    [
      116603
    ]
  ],
  "./he/outcome_alignment_v2.json": [
    "375352",
    [
      107080
    ]
  ],
  "./zh-Hant/default_account_quotas.json": [
    "116679",
    [
      174441
    ]
  ],
  "./mi/account_settings_jsx_bundle.json": [
    "846764",
    [
      881332
    ]
  ],
  "./ht/a2LatePolicyToolTipContent.json": [
    "355607",
    [
      826881
    ]
  ],
  "./sv-x-k12/account_calendar_settings_confirmation_modal.json": [
    "520147",
    [
      876689
    ]
  ],
  "./mi/account_calendar_settings_confirmation_modal.json": [
    "401568",
    [
      359360
    ]
  ],
  "./de/sis_import.json": [
    "910448",
    [
      880701
    ]
  ],
  "./nb.eager.json": [
    "587003",
    [
      580282
    ]
  ],
  "./it/webzip_export.json": [
    "752339",
    [
      144405
    ]
  ],
  "./nn/course_stats.json": [
    "309991",
    [
      110249
    ]
  ],
  "./en-GB-x-lbs/horizon_toggle.json": [
    "388704",
    [
      20872
    ]
  ],
  "./nb-x-k12/discussion_create.json": [
    "842245",
    [
      542691
    ]
  ],
  "./zh-Hans/unpublished_warning_modal.json": [
    "994147",
    [
      427089
    ]
  ],
  "./id/ignite_agent.json": [
    "753429",
    [
      215559
    ]
  ],
  "./he/outcome_management.json": [
    "388117",
    [
      642747
    ]
  ],
  "./he/speed_grader_helpers.json": [
    "195762",
    [
      716266
    ]
  ],
  "./vi/blueprint_settingsMigrationOptions.json": [
    "222182",
    [
      546990
    ]
  ],
  "./en-GB-x-lbs/ai_experiences.json": [
    "550227",
    [
      511112
    ]
  ],
  "./mi/rubrics-export.json": [
    "559379",
    [
      108617
    ]
  ],
  "./sv-x-k12/FindOutcomesModal.json": [
    "930982",
    [
      942974
    ]
  ],
  "./mi/self_unenrollment_modal.json": [
    "529422",
    [
      563902
    ]
  ],
  "./ar/notebook.json": [
    "296070",
    [
      202802
    ]
  ],
  "./fr/add_edit_pseudonym.json": [
    "574391",
    [
      241566
    ]
  ],
  "./sv-x-k12/assignments_2_student_content.json": [
    "339712",
    [
      178952
    ]
  ],
  "./fa/blueprint_settingsMigrationOptions.json": [
    "526270",
    [
      444598
    ]
  ],
  "./fa/todos_page.json": [
    "531972",
    [
      997028
    ]
  ],
  "./fi/peer_reviews_student.json": [
    "364407",
    [
      104573
    ]
  ],
  "./zh-Hans/registration.json": [
    "507486",
    [
      314966
    ]
  ],
  "./ja/discovery_page.json": [
    "888106",
    [
      200404
    ]
  ],
  "./nb-x-k12/discussion_insights.json": [
    "984052",
    [
      914116
    ]
  ],
  "./sv/discussion_insights.json": [
    "894987",
    [
      615925
    ]
  ],
  "./en/AssignmentGroupListItemView.json": [
    "635015",
    [
      578425
    ]
  ],
  "./en-AU-x-unimelb/CourseAvailabilityOptions.json": [
    "923266",
    [
      988302
    ]
  ],
  "./cy/registration.json": [
    "771531",
    [
      131569
    ]
  ],
  "./nl/file_not_found.json": [
    "865643",
    [
      987421
    ]
  ],
  "./nn/moderate_quiz.json": [
    "715749",
    [
      818583
    ]
  ],
  "./ga/calendar_edit.json": [
    "772469",
    [
      200067
    ]
  ],
  "./ga/accessibility_course_statistics.json": [
    "359288",
    [
      939312
    ]
  ],
  "./ht/syllabus_revisions.json": [
    "263392",
    [
      769804
    ]
  ],
  "./ru/gradebook_history.json": [
    "42358",
    [
      663438
    ]
  ],
  "./tr/peer_review_student_select.json": [
    "874118",
    [
      826618
    ]
  ],
  "./he/eportfolio.json": [
    "175470",
    [
      414110
    ]
  ],
  "./pt-BR/assignments_bulk_edit_use_save_assignment.json": [
    "424023",
    [
      610114
    ]
  ],
  "./hu/confirmMasteryModal.json": [
    "619855",
    [
      161677
    ]
  ],
  "./id/terms_index.json": [
    "881103",
    [
      380225
    ]
  ],
  "./sv-x-k12/assignment_2_assignment_toggle_details.json": [
    "83331",
    [
      417025
    ]
  ],
  "./ht/job_stats.json": [
    "22937",
    [
      386667
    ]
  ],
  "./nb/security_panel.json": [
    "758181",
    [
      137999
    ]
  ],
  "./pt/submissions_show_preview.json": [
    "541050",
    [
      92705
    ]
  ],
  "./ko/account_calendar_settings_utils.json": [
    "199116",
    [
      357924
    ]
  ],
  "./fi/assignment_grade_summary.json": [
    "457527",
    [
      567917
    ]
  ],
  "./fi/nav_tourpoints.json": [
    "49698",
    [
      598898
    ]
  ],
  "./sv/assignments_2_student_header.json": [
    "613772",
    [
      114448
    ]
  ],
  "./id/quiz_statistics.json": [
    "51762",
    [
      638510
    ]
  ],
  "./nb/LearningMasteryGradebook.json": [
    "512281",
    [
      708539
    ]
  ],
  "./sv/quiz_migration_notifications.json": [
    "733600",
    [
      484308
    ]
  ],
  "./pt-BR/SpeedGraderDiscussionsNavigation.json": [
    "286574",
    [
      596023
    ]
  ],
  "./pt-BR/assignments_2_file_upload.json": [
    "488553",
    [
      356896
    ]
  ],
  "./ca/content_copy_redesign.json": [
    "12641",
    [
      186543
    ]
  ],
  "./ru/course_navigation_settings.json": [
    "785205",
    [
      265699
    ]
  ],
  "./fr-CA/SpeedGraderPostGradesMenu.json": [
    "991702",
    [
      973634
    ]
  ],
  "./en-AU-x-unimelb/ldap_cert_upload.json": [
    "887570",
    [
      70510
    ]
  ],
  "./hi/assignment_index_menu.json": [
    "312929",
    [
      413959
    ]
  ],
  "./vi/ai_experiences_show.json": [
    "286947",
    [
      787169
    ]
  ],
  "./en-AU-x-unimelb/modules_page_icon_legend.json": [
    "338175",
    [
      260377
    ]
  ],
  "./ca/module_student_view_peer_reviews.json": [
    "908697",
    [
      779223
    ]
  ],
  "./nn/ImportConfirmBox.json": [
    "928918",
    [
      81978
    ]
  ],
  "./ca/course_paces_blackout_dates_table.json": [
    "807413",
    [
      422251
    ]
  ],
  "./he/calendar.header.json": [
    "54248",
    [
      699707
    ]
  ],
  "./ar/edit_section_end_date.json": [
    "83122",
    [
      629214
    ]
  ],
  "./ms/rootFoldersFinder.json": [
    "535459",
    [
      860793
    ]
  ],
  "./ar/wiki_page_index.json": [
    "658996",
    [
      31808
    ]
  ],
  "./sv/account_calendar_settings_footer.json": [
    "562493",
    [
      464471
    ]
  ],
  "./es/assignments_2_url_entry.json": [
    "15192",
    [
      362349
    ]
  ],
  "./fr/AccountsTray.json": [
    "892610",
    [
      525935
    ]
  ],
  "./vi/calendar_sidebar.json": [
    "728444",
    [
      840220
    ]
  ],
  "./nb/blueprint_settingsSyncHistory.json": [
    "983196",
    [
      95736
    ]
  ],
  "./fa/quizzes_quiz_submission.json": [
    "992507",
    [
      975881
    ]
  ],
  "./ar/jobs.json": [
    "681623",
    [
      444073
    ]
  ],
  "./da/assignments_2_media_attempt.json": [
    "87399",
    [
      331717
    ]
  ],
  "./hy/MasteryScale.json": [
    "467882",
    [
      457706
    ]
  ],
  "./nb/sidenav.json": [
    "109594",
    [
      422774
    ]
  ],
  "./pt/security_panel.json": [
    "431853",
    [
      976647
    ]
  ],
  "./uk/grade_summary.json": [
    "952662",
    [
      858566
    ]
  ],
  "./fr/assignments_2_file_upload.json": [
    "777432",
    [
      299105
    ]
  ],
  "./cy/MobileNavigation.json": [
    "23378",
    [
      513354
    ]
  ],
  "./nl/account_course_user_search.json": [
    "945969",
    [
      749802
    ]
  ],
  "./th/submit_assignment.json": [
    "478290",
    [
      870369
    ]
  ],
  "./nb/ImportConfirmBox.json": [
    "276738",
    [
      859238
    ]
  ],
  "./ru/assignments_2_submission_histories_query.json": [
    "977153",
    [
      298119
    ]
  ],
  "./it/syllabus_revisions.json": [
    "453371",
    [
      741381
    ]
  ],
  "./fr/bounced_emails.json": [
    "697558",
    [
      134344
    ]
  ],
  "./ja/empty_modules.json": [
    "75432",
    [
      895309
    ]
  ],
  "./ga/terms_of_use.json": [
    "877107",
    [
      534721
    ]
  ],
  "./pl/course_paces_empty_state.json": [
    "32456",
    [
      478092
    ]
  ],
  "./pt/blueprint_course_sidebar.json": [
    "903003",
    [
      36548
    ]
  ],
  "./sv-x-k12/pairing_code_user_observees.json": [
    "186188",
    [
      336172
    ]
  ],
  "./mi/course_paces_header.json": [
    "815090",
    [
      834410
    ]
  ],
  "./zh-Hant/new_nav.json": [
    "990560",
    [
      34292
    ]
  ],
  "./cy/outcomes_user_outcome_results.json": [
    "502185",
    [
      574039
    ]
  ],
  "./ga/CommentLibrary.json": [
    "613866",
    [
      92890
    ]
  ],
  "./ga/blueprint_settingsAssociationsTable.json": [
    "925089",
    [
      113703
    ]
  ],
  "./it/course_paces_flaggable_number_input.json": [
    "256242",
    [
      840318
    ]
  ],
  "./nb-x-k12/editGroup.json": [
    "757331",
    [
      318385
    ]
  ],
  "./uk/keyboardShortcutModal.json": [
    "211426",
    [
      486346
    ]
  ],
  "./ko/auth_logging.json": [
    "147167",
    [
      117540
    ]
  ],
  "./fi/grade_summaryGroupView.json": [
    "608943",
    [
      3013
    ]
  ],
  "./fr/learning_mastery_gradebook.json": [
    "274007",
    [
      116830
    ]
  ],
  "./pl/authentication_providers.json": [
    "834883",
    [
      838285
    ]
  ],
  "./ga/course_paces_header.json": [
    "854816",
    [
      512904
    ]
  ],
  "./es/CourseAvailabilityOptions.json": [
    "163466",
    [
      948771
    ]
  ],
  "./fa/ai_experiences_show.json": [
    "269179",
    [
      994569
    ]
  ],
  "./el/epub_exports.json": [
    "932987",
    [
      994333
    ]
  ],
  "./nn/permissions_v2.json": [
    "370919",
    [
      845913
    ]
  ],
  "./sv/calculator_command.json": [
    "52283",
    [
      266533
    ]
  ],
  "./zh-Hant/progression_module_header.json": [
    "614116",
    [
      908067
    ]
  ],
  "./de/blueprint_settingsSyncChange.json": [
    "828533",
    [
      654628
    ]
  ],
  "./en-GB-x-lbs/DueDateOverrideView.json": [
    "844543",
    [
      568757
    ]
  ],
  "./th/copy_warnings_modal.json": [
    "50535",
    [
      419889
    ]
  ],
  "./fr/assignments_2_student_points_display.json": [
    "272396",
    [
      320781
    ]
  ],
  "./ru/quizzes_regrade_modal.json": [
    "801883",
    [
      883129
    ]
  ],
  "./nl/grade_change_logging_content.json": [
    "915004",
    [
      690115
    ]
  ],
  "./vi/quiz_log_auditing.json": [
    "629839",
    [
      746821
    ]
  ],
  "./ko/section.json": [
    "257831",
    [
      225477
    ]
  ],
  "./nn/sharedSetDefaultGradeDialog.json": [
    "849053",
    [
      74599
    ]
  ],
  "./en-AU-x-unimelb/assignments_2_peer_review.json": [
    "34175",
    [
      261633
    ]
  ],
  "./fr/assignments_2_student_header_date_title.json": [
    "114061",
    [
      877040
    ]
  ],
  "./nn/assignments_2_MoreOptions_CanvasFiles.json": [
    "159791",
    [
      795057
    ]
  ],
  "./ca/gradebook.json": [
    "440224",
    [
      511024
    ]
  ],
  "./en-GB/learning_mastery_gradebook.json": [
    "960100",
    [
      477285
    ]
  ],
  "./hi/student_entries.json": [
    "970373",
    [
      98595
    ]
  ],
  "./fr-CA/assignments_2_student_content.json": [
    "480226",
    [
      168422
    ]
  ],
  "./ja/peer_reviews_student.json": [
    "325371",
    [
      560758
    ]
  ],
  "./ru/edit_section_dates.json": [
    "656579",
    [
      9505
    ]
  ],
  "./sl/course_paces_settings.json": [
    "605023",
    [
      475009
    ]
  ],
  "./ms/quizzes_quiz_submission.json": [
    "126106",
    [
      780226
    ]
  ],
  "./tr.json": [
    "656211",
    [
      187975
    ]
  ],
  "./vi/rubrics-export.json": [
    "151562",
    [
      409162
    ]
  ],
  "./ja/progress_pill.json": [
    "702204",
    [
      897721
    ]
  ],
  "./is/roster_section_input.json": [
    "137982",
    [
      90438
    ]
  ],
  "./de/blueprint_settingsUnsyncedChanges.json": [
    "886792",
    [
      793701
    ]
  ],
  "./pl/announcements_v2.json": [
    "55551",
    [
      930649
    ]
  ],
  "./sl/module_student_view_peer_reviews.json": [
    "548676",
    [
      390904
    ]
  ],
  "./es-ES/announcements_v2.json": [
    "408996",
    [
      481172
    ]
  ],
  "./hu/modules_home_page.json": [
    "243772",
    [
      879716
    ]
  ],
  "./ru/filter_calendars_modal.json": [
    "496029",
    [
      643467
    ]
  ],
  "./id/dashboard_grading_period_select.json": [
    "639345",
    [
      665139
    ]
  ],
  "./en-GB/assignment_2_assignment_toggle_details.json": [
    "738165",
    [
      640344
    ]
  ],
  "./hi/overview_page.json": [
    "530890",
    [
      664506
    ]
  ],
  "./hy/submit_assignment.json": [
    "636549",
    [
      841139
    ]
  ],
  "./is/ignite_agent.json": [
    "674266",
    [
      438282
    ]
  ],
  "./pl/react_developer_keys.json": [
    "631945",
    [
      450291
    ]
  ],
  "./ar/upload_button.json": [
    "424015",
    [
      223297
    ]
  ],
  "./pt-BR/speed_grader_helpers.json": [
    "879688",
    [
      726565
    ]
  ],
  "./en-GB/gradebook_uploads.json": [
    "659584",
    [
      303993
    ]
  ],
  "./fa/outcome_management.json": [
    "726367",
    [
      786965
    ]
  ],
  "./ru/job_stats.json": [
    "608984",
    [
      918512
    ]
  ],
  "./fi/sharedSetDefaultGradeDialog.json": [
    "188200",
    [
      520272
    ]
  ],
  "./uk/k5_dashboard.json": [
    "916093",
    [
      982851
    ]
  ],
  "./es/GroupDetailView.json": [
    "570801",
    [
      315776
    ]
  ],
  "./he/quiz_log_auditing.json": [
    "950361",
    [
      480263
    ]
  ],
  "./hi/user_logins.json": [
    "594343",
    [
      283357
    ]
  ],
  "./es-ES/account_course_user_search.json": [
    "928875",
    [
      201417
    ]
  ],
  "./ca/course_paces_search.json": [
    "23777",
    [
      617967
    ]
  ],
  "./pt/course_template_details.json": [
    "232116",
    [
      728401
    ]
  ],
  "./th/permissions.json": [
    "388198",
    [
      785530
    ]
  ],
  "./vi/comm_messages.json": [
    "735306",
    [
      918890
    ]
  ],
  "./es-ES/sharedCurveGradesDialog.json": [
    "117775",
    [
      296229
    ]
  ],
  "./ga/blueprint_settingsCoursePicker.json": [
    "765072",
    [
      848792
    ]
  ],
  "./nb-x-k12/courses.json": [
    "475466",
    [
      757610
    ]
  ],
  "./nb/entity_search_form.json": [
    "2758",
    [
      288403
    ]
  ],
  "./zh-Hans/announcements_v2.json": [
    "154370",
    [
      182418
    ]
  ],
  "./fa/folder_tree.json": [
    "641790",
    [
      322470
    ]
  ],
  "./el/rubrics-export.json": [
    "126214",
    [
      445354
    ]
  ],
  "./es-ES/CommentLibrary.json": [
    "374117",
    [
      604643
    ]
  ],
  "./en-GB-x-ukhe/horizon_toggle.json": [
    "236360",
    [
      937472
    ]
  ],
  "./nl/user_date_range_search.json": [
    "382295",
    [
      121222
    ]
  ],
  "./fr/empty_modules.json": [
    "962317",
    [
      644296
    ]
  ],
  "./es/CreateEditAssignmentModalAdapter.json": [
    "593607",
    [
      401882
    ]
  ],
  "./nl/course_paces_time_selection.json": [
    "738547",
    [
      612421
    ]
  ],
  "./zh-Hant/student_groups.json": [
    "962192",
    [
      518092
    ]
  ],
  "./ca/quizzes_openModerateStudentDialog.json": [
    "466060",
    [
      261060
    ]
  ],
  "./en-GB-x-lbs/assignments_2_peer_review.json": [
    "555045",
    [
      41907
    ]
  ],
  "./nl/assignments_2_student_content.json": [
    "779025",
    [
      566067
    ]
  ],
  "./en-GB-x-ukhe/course_paces_actions.json": [
    "383394",
    [
      482930
    ]
  ],
  "./da-x-k12/course_paces_blackout_date_row.json": [
    "676993",
    [
      651291
    ]
  ],
  "./pl/blueprint_course_child.json": [
    "75894",
    [
      373426
    ]
  ],
  "./pt/account_calendar_settings_account_calendar_item_dropdown.json": [
    "728453",
    [
      395927
    ]
  ],
  "./tr/GroupsTray.json": [
    "299268",
    [
      156120
    ]
  ],
  "./ca/course_paces_footer.json": [
    "681098",
    [
      54914
    ]
  ],
  "./pl/blueprint_settingsSyncChange.json": [
    "453308",
    [
      523096
    ]
  ],
  "./tr/context_roster_user_services.json": [
    "502768",
    [
      896668
    ]
  ],
  "./en-CA/blueprint_settingsCoursePicker.json": [
    "671068",
    [
      743980
    ]
  ],
  "./pt/custom_help_link.json": [
    "652714",
    [
      21534
    ]
  ],
  "./uk/permissions_role_tray.json": [
    "99788",
    [
      219204
    ]
  ],
  "./en-CA/notebook_index.json": [
    "293496",
    [
      473712
    ]
  ],
  "./is/quiz_show.json": [
    "332353",
    [
      301271
    ]
  ],
  "./pt/SpeedGraderDiscussionsNavigation.json": [
    "409169",
    [
      249739
    ]
  ],
  "./el/unpublished_changes_button_props.json": [
    "249854",
    [
      769690
    ]
  ],
  "./mi/sections_tooltip.json": [
    "623816",
    [
      672408
    ]
  ],
  "./cy/MoveOutcomesModal.json": [
    "204179",
    [
      889737
    ]
  ],
  "./nb/AlignmentSummary.json": [
    "752213",
    [
      119703
    ]
  ],
  "./sv/bulk_edit_students_table.json": [
    "746216",
    [
      283724
    ]
  ],
  "./fr-CA/self_enrollment.json": [
    "53444",
    [
      47064
    ]
  ],
  "./zh-Hans/assignments_2_shared_Steps.json": [
    "8670",
    [
      28118
    ]
  ],
  "./fr-CA/mutationActivity.json": [
    "761555",
    [
      464925
    ]
  ],
  "./sv-x-k12/course_paces_modal.json": [
    "625715",
    [
      152945
    ]
  ],
  "./sv/outcome_reporting.json": [
    "839658",
    [
      927526
    ]
  ],
  "./zh-Hant/account_calendar_settings.json": [
    "889758",
    [
      595517
    ]
  ],
  "./zh-Hant/pseudonyms_mobile_login.json": [
    "281727",
    [
      2824
    ]
  ],
  "./pt/last_attended.json": [
    "825550",
    [
      943906
    ]
  ],
  "./ca/quiz_log_auditing.json": [
    "859366",
    [
      208406
    ]
  ],
  "./hi/CreateEditAssignmentModal.json": [
    "457867",
    [
      943657
    ]
  ],
  "./ar/discussion_insights.json": [
    "880997",
    [
      147311
    ]
  ],
  "./da-x-k12/quizzes.take_quiz.json": [
    "977881",
    [
      822442
    ]
  ],
  "./nb/webzip_export.json": [
    "202822",
    [
      808138
    ]
  ],
  "./fr-CA/assignments_2_student_header_date_title.json": [
    "642848",
    [
      362972
    ]
  ],
  "./zh-Hans/notebook.json": [
    "788526",
    [
      611542
    ]
  ],
  "./hu/content_migrations.json": [
    "356268",
    [
      389524
    ]
  ],
  "./zh-Hant/user_search_results.json": [
    "15741",
    [
      856479
    ]
  ],
  "./sl/internal-settings.json": [
    "260244",
    [
      664960
    ]
  ],
  "./es-ES/assignments_2_student_header.json": [
    "72968",
    [
      863376
    ]
  ],
  "./mi/paginated_list.json": [
    "768780",
    [
      129364
    ]
  ],
  "./ru/calendar.header.json": [
    "641302",
    [
      510165
    ]
  ],
  "./de/account_notification_settings.json": [
    "387128",
    [
      601813
    ]
  ],
  "./ga/unpublished_warning_modal.json": [
    "754620",
    [
      978988
    ]
  ],
  "./is/gradebook_default_gradebook_components_content_filters_module_filter.json": [
    "641298",
    [
      265938
    ]
  ],
  "./en-GB/peer_review_allocation_rules_tray.json": [
    "925610",
    [
      189543
    ]
  ],
  "./nb-x-k12/react_developer_keys.json": [
    "231827",
    [
      583905
    ]
  ],
  "./en-AU-x-unimelb/blueprint_settingsUnsyncedChanges.json": [
    "998659",
    [
      566301
    ]
  ],
  "./sv/bulk_edit_students.json": [
    "610227",
    [
      309165
    ]
  ],
  "./hy/video_conference.json": [
    "516901",
    [
      463059
    ]
  ],
  "./ru/bulk_edit_students_table.json": [
    "213260",
    [
      34268
    ]
  ],
  "./id/course_paces_change_tracking.json": [
    "96584",
    [
      230948
    ]
  ],
  "./sv-x-k12/courses.show.json": [
    "609038",
    [
      963901
    ]
  ],
  "./tr/discussion_pinned_post.json": [
    "284130",
    [
      938038
    ]
  ],
  "./da-x-k12/outcome_detail.json": [
    "54165",
    [
      254087
    ]
  ],
  "./en-GB-x-lbs/assignments_2_file_upload.json": [
    "796790",
    [
      838574
    ]
  ],
  "./zh-Hans/peer_review_allocation_rule_card.json": [
    "641389",
    [
      485931
    ]
  ],
  "./pt/a2LatePolicyToolTipContent.json": [
    "839535",
    [
      75529
    ]
  ],
  "./pt/NewTabIndicator.json": [
    "266912",
    [
      911860
    ]
  ],
  "./id/user_restore.json": [
    "125511",
    [
      982305
    ]
  ],
  "./hy/account_settings.json": [
    "69166",
    [
      554742
    ]
  ],
  "./nb-x-k12/progression_module_header.json": [
    "219836",
    [
      325804
    ]
  ],
  "./ko/admin_split.json": [
    "654688",
    [
      717584
    ]
  ],
  "./he/blueprint_settingsUnsyncedChanges.json": [
    "840796",
    [
      41028
    ]
  ],
  "./de/blueprint_settingsCourseFilter.json": [
    "36621",
    [
      778636
    ]
  ],
  "./is/permissions.json": [
    "554786",
    [
      232562
    ]
  ],
  "./en-CA/assignments_2_peer_review.json": [
    "213695",
    [
      634501
    ]
  ],
  "./nn/assignmentsToggleShowByView.json": [
    "552225",
    [
      781635
    ]
  ],
  "./fr-CA/enhanced_individual_gradebook_submit_score.json": [
    "1134",
    [
      854082
    ]
  ],
  "./nl/assignments_2_student_annotation.json": [
    "529153",
    [
      193219
    ]
  ],
  "./pt/course_paces_assignment_row.json": [
    "245559",
    [
      734129
    ]
  ],
  "./ru/user_grades.json": [
    "173011",
    [
      142513
    ]
  ],
  "./es/available_pronouns_list.json": [
    "303799",
    [
      312874
    ]
  ],
  "./ko/users.json": [
    "13320",
    [
      820840
    ]
  ],
  "./sv-x-k12/LearningMasteryGradebook.json": [
    "864132",
    [
      618516
    ]
  ],
  "./es-ES/ProfileTray.json": [
    "383790",
    [
      620886
    ]
  ],
  "./da/assignments_2_peer_review.json": [
    "493908",
    [
      509340
    ]
  ],
  "./nl/course_logging_details.json": [
    "209618",
    [
      111798
    ]
  ],
  "./pt/account_calendar_settings_account_list.json": [
    "25521",
    [
      834243
    ]
  ],
  "./fr/account_calendar_settings_account_tree.json": [
    "201901",
    [
      585216
    ]
  ],
  "./zh-Hant/account_calendar_settings_filter_controls.json": [
    "64604",
    [
      414072
    ]
  ],
  "./it/assignments_2_shared_Steps.json": [
    "314736",
    [
      658140
    ]
  ],
  "./ca/GroupsTray.json": [
    "745554",
    [
      917498
    ]
  ],
  "./es/reset_pace_warning_modal.json": [
    "985972",
    [
      797633
    ]
  ],
  "./sl/assignments_2_text_entry.json": [
    "349815",
    [
      10657
    ]
  ],
  "./cy/AssignmentGroupListItemView.json": [
    "80220",
    [
      735652
    ]
  ],
  "./fr-CA/react_files.json": [
    "662728",
    [
      447612
    ]
  ],
  "./ca/registration.json": [
    "334227",
    [
      122905
    ]
  ],
  "./hu/assignments_2_student_content.json": [
    "891311",
    [
      422308
    ]
  ],
  "./hu/course_color_selector.json": [
    "398602",
    [
      801074
    ]
  ],
  "./it/EditMasteryScaleLink.json": [
    "426648",
    [
      138828
    ]
  ],
  "./it/gradebook_history.json": [
    "152534",
    [
      89938
    ]
  ],
  "./ms/permission_button.json": [
    "133834",
    [
      72178
    ]
  ],
  "./de/course_paces_footer.json": [
    "663329",
    [
      266104
    ]
  ],
  "./id/OutcomeMoveModal.json": [
    "105195",
    [
      864149
    ]
  ],
  "./da/grade_details.json": [
    "370131",
    [
      289401
    ]
  ],
  "./en-GB-x-ukhe/registration.json": [
    "127085",
    [
      479515
    ]
  ],
  "./is/learning_mastery_gradebook.json": [
    "824227",
    [
      674689
    ]
  ],
  "./sv/assignmentsToggleShowByView.json": [
    "389196",
    [
      754576
    ]
  ],
  "./mi/knowledge_check_not_ready.json": [
    "220901",
    [
      158219
    ]
  ],
  "./es/discussion_create.json": [
    "54903",
    [
      375210
    ]
  ],
  "./ga/IndividualStudentMasteryOutcome.json": [
    "73487",
    [
      737573
    ]
  ],
  "./da/course_template_details.json": [
    "848584",
    [
      374056
    ]
  ],
  "./fr-CA/k5_dashboard_card.json": [
    "66677",
    [
      413863
    ]
  ],
  "./uk/course_restore.json": [
    "439438",
    [
      564206
    ]
  ],
  "./en-GB-x-lbs/account_calendar_settings_footer.json": [
    "789384",
    [
      189376
    ]
  ],
  "./fr-CA/assignment_show.json": [
    "728536",
    [
      257620
    ]
  ],
  "./fr/lti_registrations.json": [
    "451136",
    [
      429041
    ]
  ],
  "./vi/account_calendar_settings_footer.json": [
    "257985",
    [
      987815
    ]
  ],
  "./zh-Hant/discussion_pinned_post.json": [
    "61058",
    [
      580774
    ]
  ],
  "./vi/appointment_groups.json": [
    "253559",
    [
      296493
    ]
  ],
  "./uk/nav_tourpoints.json": [
    "131813",
    [
      181147
    ]
  ],
  "./zh-Hant/restore_content_pane.json": [
    "63279",
    [
      733609
    ]
  ],
  "./id/gradebook.json": [
    "334341",
    [
      100415
    ]
  ],
  "./en-GB-x-lbs/discussion_posts.json": [
    "30340",
    [
      397460
    ]
  ],
  "./da/course_paces_blackout_date_row.json": [
    "249491",
    [
      438073
    ]
  ],
  "./th/announcements_v2.json": [
    "947831",
    [
      499889
    ]
  ],
  "./en-GB-x-ukhe/course_paces_modal.json": [
    "566868",
    [
      74724
    ]
  ],
  "./sv-x-k12/sis_import.json": [
    "509752",
    [
      728608
    ]
  ],
  "./fr-CA/assignments_2_MoreOptions.json": [
    "592206",
    [
      438458
    ]
  ],
  "./sv/assignment_show.json": [
    "594248",
    [
      643396
    ]
  ],
  "./ar/blueprint_settingsUnsyncedChanges.json": [
    "350064",
    [
      18588
    ]
  ],
  "./nl/not_found_page_slide_puzzle.json": [
    "192155",
    [
      817757
    ]
  ],
  "./ca/outcome_detail.json": [
    "394670",
    [
      897998
    ]
  ],
  "./fr-CA/filter_calendars_modal.json": [
    "829713",
    [
      146123
    ]
  ],
  "./vi/grades_empty_page.json": [
    "950247",
    [
      339197
    ]
  ],
  "./es-ES/submit_assignment.json": [
    "886171",
    [
      53193
    ]
  ],
  "./zh-Hans/account_notification_settings.json": [
    "903000",
    [
      202416
    ]
  ],
  "./ca/assignments_2_student_content_rubric_self_assessment.json": [
    "143175",
    [
      30085
    ]
  ],
  "./it/course_logging_details.json": [
    "958499",
    [
      928901
    ]
  ],
  "./ga/permissions_v2.json": [
    "69159",
    [
      573421
    ]
  ],
  "./ht/grades_empty_page.json": [
    "201214",
    [
      672386
    ]
  ],
  "./is/SpeedGraderCheckpoints.json": [
    "298541",
    [
      204811
    ]
  ],
  "./pl/quizzes_index.json": [
    "228476",
    [
      764136
    ]
  ],
  "./it/course_paces_empty_state.json": [
    "599419",
    [
      773885
    ]
  ],
  "./sv/youtube_migration.json": [
    "995405",
    [
      368367
    ]
  ],
  "./sv/media_player_iframe_content.json": [
    "447052",
    [
      695552
    ]
  ],
  "./ms/ldap_cert_upload.json": [
    "373938",
    [
      470538
    ]
  ],
  "./sl/horizon_toggle.json": [
    "123691",
    [
      149093
    ]
  ],
  "./sv-x-k12/link_validator.json": [
    "537422",
    [
      787334
    ]
  ],
  "./en-AU/IndividualStudentMasteryOutcome.json": [
    "367817",
    [
      665256
    ]
  ],
  "./de/quiz_show.json": [
    "545734",
    [
      7551
    ]
  ],
  "./mi/internal-settings.json": [
    "520905",
    [
      674199
    ]
  ],
  "./ga/link_to_students.json": [
    "761979",
    [
      856921
    ]
  ],
  "./fa/peer-review-assignment-widget.json": [
    "312013",
    [
      507899
    ]
  ],
  "./en-GB-x-ukhe/terms_index.json": [
    "594872",
    [
      500672
    ]
  ],
  "./sl/permissions_role_tray.json": [
    "755283",
    [
      45349
    ]
  ],
  "./it/assignments_2_initial_query.json": [
    "28280",
    [
      581604
    ]
  ],
  "./ca/course_color_selector.json": [
    "724641",
    [
      540143
    ]
  ],
  "./nl/course_default_due_time.json": [
    "693814",
    [
      238770
    ]
  ],
  "./nn/blueprint_settingsSyncChange.json": [
    "629288",
    [
      340788
    ]
  ],
  "./fa/assignments_bulk_edit.json": [
    "583487",
    [
      435157
    ]
  ],
  "./fr/progression_module_header.json": [
    "765362",
    [
      64863
    ]
  ],
  "./fa/sharedCurveGradesDialog.json": [
    "796583",
    [
      239165
    ]
  ],
  "./vi/appt_calendar_event_dialog.json": [
    "720669",
    [
      808379
    ]
  ],
  "./sv/course_paces_errors.json": [
    "722215",
    [
      751305
    ]
  ],
  "./nl/DueDateOverrideView.json": [
    "430383",
    [
      471609
    ]
  ],
  "./nn/assignment_index.json": [
    "75320",
    [
      498060
    ]
  ],
  "./da-x-k12/IndividualStudentMasteryOutcome.json": [
    "121258",
    [
      688998
    ]
  ],
  "./uk/sidenav.json": [
    "204690",
    [
      217082
    ]
  ],
  "./nn/available_pronouns_list.json": [
    "358747",
    [
      960533
    ]
  ],
  "./pt-BR/announcements_on_home_page.json": [
    "708077",
    [
      197500
    ]
  ],
  "./vi/new_user_tutorial.json": [
    "358560",
    [
      442952
    ]
  ],
  "./cy/modules_page_icon_legend.json": [
    "824551",
    [
      283445
    ]
  ],
  "./hi/outcome_alignment_v2.json": [
    "910812",
    [
      209708
    ]
  ],
  "./zh-Hans/account_settings_jsx_bundle.json": [
    "962869",
    [
      911331
    ]
  ],
  "./el/theme_editor.json": [
    "98618",
    [
      500022
    ]
  ],
  "./nb/MobileGlobalMenu.json": [
    "135908",
    [
      589448
    ]
  ],
  "./he/AlignmentSummary.json": [
    "42292",
    [
      654572
    ]
  ],
  "./hu/gradebook_uploads.json": [
    "945270",
    [
      929366
    ]
  ],
  "./hy/progressbar_view.json": [
    "255975",
    [
      860749
    ]
  ],
  "./da/edit_section_start_date.json": [
    "910337",
    [
      886063
    ]
  ],
  "./fr-CA/course_paces_blueprint_lock.json": [
    "291283",
    [
      572301
    ]
  ],
  "./mi/course_statistics.json": [
    "961433",
    [
      314343
    ]
  ],
  "./zh-Hant/quantitative_data_options.json": [
    "836637",
    [
      119743
    ]
  ],
  "./da/assignments.json": [
    "220203",
    [
      535425
    ]
  ],
  "./nn/permissions_v2_add_tray.json": [
    "644812",
    [
      914088
    ]
  ],
  "./ca/top_navigation_tools.json": [
    "186456",
    [
      25240
    ]
  ],
  "./ht/content_migrations.json": [
    "736157",
    [
      54527
    ]
  ],
  "./ca/student_annotation_preview.json": [
    "409376",
    [
      893872
    ]
  ],
  "./fi/enhanced_individual_gradebook_submit_score.json": [
    "957954",
    [
      490098
    ]
  ],
  "./he/assignments_2_student_content.json": [
    "100716",
    [
      230388
    ]
  ],
  "./en/files_v2.json": [
    "904423",
    [
      444193
    ]
  ],
  "./tr/gradingPeriodTemplate.json": [
    "534923",
    [
      353805
    ]
  ],
  "./ja/courses.show.json": [
    "370872",
    [
      269405
    ]
  ],
  "./vi/bulk_edit_students.json": [
    "215575",
    [
      885597
    ]
  ],
  "./da-x-k12/reset_pace_warning_modal.json": [
    "638583",
    [
      896017
    ]
  ],
  "./hi/IndividualStudentMasteryOutcome.json": [
    "174468",
    [
      975972
    ]
  ],
  "./sv-x-k12/course_color_selector.json": [
    "802846",
    [
      493606
    ]
  ],
  "./es-ES/account_calendar_settings.json": [
    "731349",
    [
      634579
    ]
  ],
  "./ko/change_password.json": [
    "857848",
    [
      900888
    ]
  ],
  "./he/calendar_edit.json": [
    "159858",
    [
      592714
    ]
  ],
  "./nl/outcome_alignment_v2.json": [
    "255259",
    [
      83285
    ]
  ],
  "./sv-x-k12/student_study_drawer.json": [
    "766900",
    [
      849172
    ]
  ],
  "./ms.json": [
    "322981",
    [
      435145
    ]
  ],
  "./tr/assignment_index.json": [
    "470830",
    [
      311546
    ]
  ],
  "./nb-x-k12/calendar_appointment_group_edit.json": [
    "70037",
    [
      304899
    ]
  ],
  "./fi/react_files.json": [
    "563820",
    [
      98188
    ]
  ],
  "./tr/assignment_grade_summary.json": [
    "730570",
    [
      672910
    ]
  ],
  "./ko/permissions_v2.json": [
    "455033",
    [
      47703
    ]
  ],
  "./tr/course_paces_blackout_dates_table.json": [
    "586495",
    [
      204945
    ]
  ],
  "./hu/notebook_index.json": [
    "93701",
    [
      697739
    ]
  ],
  "./en-AU-x-unimelb/peer_review_allocation_rules_tray.json": [
    "479091",
    [
      140837
    ]
  ],
  "./pl/course_paces_actions.json": [
    "132888",
    [
      35084
    ]
  ],
  "./fi/suppress_notifications.json": [
    "541177",
    [
      191935
    ]
  ],
  "./th/unpublished_changes_button_props.json": [
    "641173",
    [
      29607
    ]
  ],
  "./el/course_paces_actions.json": [
    "948875",
    [
      281509
    ]
  ],
  "./he/ImportConfirmBox.json": [
    "996703",
    [
      862205
    ]
  ],
  "./pt-BR/assignment_index.json": [
    "36923",
    [
      346254
    ]
  ],
  "./sv-x-k12/DueDateOverrideView.json": [
    "608238",
    [
      478534
    ]
  ],
  "./sv-x-k12/course_paces_settings.json": [
    "447783",
    [
      430525
    ]
  ],
  "./hi/Navigation.json": [
    "469325",
    [
      384475
    ]
  ],
  "./th/user_date_range_search.json": [
    "175681",
    [
      244795
    ]
  ],
  "./en-AU/a2LatePolicyToolTipContent.json": [
    "552497",
    [
      961232
    ]
  ],
  "./tr/gradinggradingPeriodCollection.json": [
    "726765",
    [
      918591
    ]
  ],
  "./es-ES/grades_summary.json": [
    "832094",
    [
      743030
    ]
  ],
  "./de/empty_modules.json": [
    "623370",
    [
      408123
    ]
  ],
  "./hu/course_paces_search.json": [
    "379858",
    [
      353066
    ]
  ],
  "./da-x-k12/content_shares.json": [
    "259827",
    [
      761901
    ]
  ],
  "./tr/conferences.json": [
    "683675",
    [
      549389
    ]
  ],
  "./en/course_paces_search.json": [
    "924934",
    [
      78794
    ]
  ],
  "./el/react_files.json": [
    "935048",
    [
      823292
    ]
  ],
  "./es/calendar_custom_recurring_event_repeat_picker.json": [
    "347396",
    [
      567825
    ]
  ],
  "./fa/course_paces_header.json": [
    "516573",
    [
      979259
    ]
  ],
  "./sl/discussion_pinned_post.json": [
    "206041",
    [
      117355
    ]
  ],
  "./de/gradebookOutcomeGradebookView.json": [
    "366140",
    [
      741889
    ]
  ],
  "./fr-CA/account_calendar_settings_footer.json": [
    "242221",
    [
      260999
    ]
  ],
  "./sv-x-k12/account_calendar_settings_account_list.json": [
    "540476",
    [
      883308
    ]
  ],
  "./nn/wiki_page_index.json": [
    "219575",
    [
      245473
    ]
  ],
  "./ga/edit_section_end_date.json": [
    "950833",
    [
      676887
    ]
  ],
  "./fa/content_exports.json": [
    "671886",
    [
      960345
    ]
  ],
  "./ht/IndividualStudentMasteryOutcome.json": [
    "674059",
    [
      576317
    ]
  ],
  "./th/folder_tree.json": [
    "508091",
    [
      222781
    ]
  ],
  "./zh-Hant/CourseAvailabilityOptions.json": [
    "77652",
    [
      177048
    ]
  ],
  "./zh-Hans/assignments_2_student_content.json": [
    "6024",
    [
      39680
    ]
  ],
  "./zh-Hant/self_unenrollment_modal.json": [
    "142270",
    [
      490130
    ]
  ],
  "./ga/rubrics-export.json": [
    "926117",
    [
      536259
    ]
  ],
  "./hu/account_calendar_settings_filter_controls.json": [
    "247677",
    [
      129107
    ]
  ],
  "./cy/assignment_grade_summary.json": [
    "860272",
    [
      725008
    ]
  ],
  "./pt-BR/top_navigation_tools.json": [
    "440923",
    [
      862846
    ]
  ],
  "./pl/reset_pace_warning_modal.json": [
    "13844",
    [
      308128
    ]
  ],
  "./en-AU-x-unimelb/accessibility_course_statistics.json": [
    "90956",
    [
      19048
    ]
  ],
  "./ht/sis_import.json": [
    "757025",
    [
      433723
    ]
  ],
  "./nb-x-k12/registration.json": [
    "328745",
    [
      548047
    ]
  ],
  "./pt-BR/quiz_log_auditing.json": [
    "817903",
    [
      196234
    ]
  ],
  "./uk/outcome_alignment_v2.json": [
    "124585",
    [
      271399
    ]
  ],
  "./hu/bounced_emails.json": [
    "223507",
    [
      336617
    ]
  ],
  "./uk/blueprint_settingsCoursePickerTable.json": [
    "594488",
    [
      871096
    ]
  ],
  "./ko/MoveOutcomesModal.json": [
    "188557",
    [
      188531
    ]
  ],
  "./nb/assignments_bulk_edit_use_save_assignment.json": [
    "215474",
    [
      183710
    ]
  ],
  "./hi/todos_page.json": [
    "437446",
    [
      454526
    ]
  ],
  "./is/conferences_alternatives.json": [
    "25342",
    [
      772566
    ]
  ],
  "./mi/course_paces_empty_state.json": [
    "455462",
    [
      127110
    ]
  ],
  "./sv-x-k12/student_annotation_preview.json": [
    "10429",
    [
      965307
    ]
  ],
  "./zh-Hans/media_player_iframe_content.json": [
    "806090",
    [
      674922
    ]
  ],
  "./ga/copy_course.json": [
    "754197",
    [
      352355
    ]
  ],
  "./es-ES/courses.json": [
    "14093",
    [
      723275
    ]
  ],
  "./ht/question_banks.json": [
    "930966",
    [
      212570
    ]
  ],
  "./it/auth_logging.json": [
    "891645",
    [
      496479
    ]
  ],
  "./vi/assignments_peer_reviews_student.json": [
    "225308",
    [
      623980
    ]
  ],
  "./th/course_paces_actions.json": [
    "404000",
    [
      353652
    ]
  ],
  "./hi/unpublished_changes_button_props.json": [
    "931768",
    [
      346512
    ]
  ],
  "./es/blueprint_settingsAssociationsTable.json": [
    "196677",
    [
      715596
    ]
  ],
  "./fr/assignment_index_deep_linking_handlers.json": [
    "894276",
    [
      746381
    ]
  ],
  "./hi/accessibility_checker.json": [
    "796889",
    [
      139071
    ]
  ],
  "./id/login.json": [
    "767942",
    [
      732162
    ]
  ],
  "./ga/top_navigation_tools.json": [
    "690964",
    [
      989428
    ]
  ],
  "./mi/content_shares.json": [
    "572226",
    [
      516762
    ]
  ],
  "./pt-BR/SpeedGraderSettingsMenu.json": [
    "642265",
    [
      876512
    ]
  ],
  "./es/account_calendar_settings_account_list.json": [
    "491433",
    [
      822712
    ]
  ],
  "./da-x-k12/modules_page_icon_legend.json": [
    "112284",
    [
      491680
    ]
  ],
  "./en-AU-x-unimelb/gradebook_history.json": [
    "688055",
    [
      28833
    ]
  ],
  "./es/modules_page_icon_legend.json": [
    "870199",
    [
      745386
    ]
  ],
  "./ga/permission_button.json": [
    "55790",
    [
      339398
    ]
  ],
  "./pl/permissions_v2.json": [
    "863571",
    [
      533621
    ]
  ],
  "./de/ignite_agent.json": [
    "839119",
    [
      176762
    ]
  ],
  "./zh-Hans/courses_show.json": [
    "743361",
    [
      596071
    ]
  ],
  "./uk/upload_button.json": [
    "579396",
    [
      797996
    ]
  ],
  "./da-x-k12/grade_details.json": [
    "884609",
    [
      494603
    ]
  ],
  "./hy/section.json": [
    "547678",
    [
      622070
    ]
  ],
  "./is/collaborations.json": [
    "735840",
    [
      131304
    ]
  ],
  "./ja/todos_page.json": [
    "443080",
    [
      582125
    ]
  ],
  "./el/confirmMasteryModal.json": [
    "230109",
    [
      720879
    ]
  ],
  "./nb/learning_mastery_gradebook.json": [
    "763631",
    [
      880945
    ]
  ],
  "./vi/SpeedGraderCheckpoints.json": [
    "451542",
    [
      374430
    ]
  ],
  "./uk/todo.json": [
    "463886",
    [
      597614
    ]
  ],
  "./de/notebook_index.json": [
    "518945",
    [
      564328
    ]
  ],
  "./fi/student_annotation_preview.json": [
    "51047",
    [
      821325
    ]
  ],
  "./nl/user.json": [
    "579987",
    [
      5245
    ]
  ],
  "./zh-Hant/section.json": [
    "341051",
    [
      447237
    ]
  ],
  "./vi/assignments_2_external_tool.json": [
    "145349",
    [
      633251
    ]
  ],
  "./id/student_study_drawer.json": [
    "207022",
    [
      515026
    ]
  ],
  "./pt-BR/quizzes_public.json": [
    "101838",
    [
      578183
    ]
  ],
  "./fa/user_logins.json": [
    "519721",
    [
      5007
    ]
  ],
  "./es-ES/last_attended.json": [
    "167559",
    [
      869181
    ]
  ],
  "./it/accessibility_course_statistics.json": [
    "933349",
    [
      230847
    ]
  ],
  "./ar/assignments_peer_reviews_student.json": [
    "719810",
    [
      641534
    ]
  ],
  "./pl/edit_section_view.json": [
    "512658",
    [
      667278
    ]
  ],
  "./pt-BR/assignment_index_deep_linking_handlers.json": [
    "670215",
    [
      931234
    ]
  ],
  "./nn/assignments_2_student_annotation.json": [
    "128087",
    [
      888777
    ]
  ],
  "./da/account_calendar_settings.json": [
    "928919",
    [
      400117
    ]
  ],
  "./mi/notebook_index.json": [
    "979702",
    [
      447030
    ]
  ],
  "./cy/license_help.json": [
    "500453",
    [
      431179
    ]
  ],
  "./ja/job_stats.json": [
    "991540",
    [
      216689
    ]
  ],
  "./es-ES/discussion_create.json": [
    "863850",
    [
      121242
    ]
  ],
  "./da/notebook_index.json": [
    "749813",
    [
      366411
    ]
  ],
  "./ms/outcome_reporting.json": [
    "679627",
    [
      620753
    ]
  ],
  "./pl/rubrics-export.json": [
    "335049",
    [
      414635
    ]
  ],
  "./sv-x-k12/course_paces_empty_state.json": [
    "147529",
    [
      867295
    ]
  ],
  "./id/CreateEditAssignmentModal.json": [
    "112049",
    [
      409307
    ]
  ],
  "./is/login.json": [
    "652891",
    [
      759177
    ]
  ],
  "./ga/permissions_v2_add_tray.json": [
    "903628",
    [
      264332
    ]
  ],
  "./cy/account_calendars.json": [
    "161909",
    [
      946811
    ]
  ],
  "./cy/ignite_agent.json": [
    "462678",
    [
      225590
    ]
  ],
  "./en-AU-x-unimelb/course_paces_modal.json": [
    "888958",
    [
      371762
    ]
  ],
  "./id/notebook.json": [
    "888248",
    [
      382204
    ]
  ],
  "./nb-x-k12/wiki_page_index.json": [
    "898597",
    [
      68115
    ]
  ],
  "./zh-Hans/jobs.json": [
    "901583",
    [
      755509
    ]
  ],
  "./th/ImportConfirmBox.json": [
    "524586",
    [
      546478
    ]
  ],
  "./it/login.json": [
    "841878",
    [
      922514
    ]
  ],
  "./el/widget_dashboard.json": [
    "48486",
    [
      257162
    ]
  ],
  "./sv/assignments_2_attempt_tab.json": [
    "748370",
    [
      928582
    ]
  ],
  "./id/webzip_export.json": [
    "890371",
    [
      488709
    ]
  ],
  "./da/terms_of_use.json": [
    "31734",
    [
      295302
    ]
  ],
  "./ru/syllabus_revisions.json": [
    "975451",
    [
      399465
    ]
  ],
  "./da/sharedSetDefaultGradeDialog.json": [
    "633742",
    [
      539982
    ]
  ],
  "./es/quiz_migration_notifications.json": [
    "279195",
    [
      598214
    ]
  ],
  "./sv/new_nav.json": [
    "506063",
    [
      579873
    ]
  ],
  "./fr/custom_emoji_deny_list.json": [
    "616084",
    [
      925509
    ]
  ],
  "./nb/course_paces_errors.json": [
    "444638",
    [
      929058
    ]
  ],
  "./pl/discussion_topics.json": [
    "739",
    [
      78933
    ]
  ],
  "./pt/assignments.json": [
    "925548",
    [
      128568
    ]
  ],
  "./nb/course_stats.json": [
    "623347",
    [
      721093
    ]
  ],
  "./ja/course_paces_actions.json": [
    "179131",
    [
      801078
    ]
  ],
  "./ar/peer-review-assignment-widget.json": [
    "54875",
    [
      804917
    ]
  ],
  "./ht/top_navigation_tools.json": [
    "141728",
    [
      761052
    ]
  ],
  "./fa/empty_course.json": [
    "414122",
    [
      631754
    ]
  ],
  "./ko/content_migrations_redesign.json": [
    "675715",
    [
      656489
    ]
  ],
  "./pt-BR/course_paces_blackout_dates_modal.json": [
    "766093",
    [
      511740
    ]
  ],
  "./id/course_paces_settings.json": [
    "713805",
    [
      730023
    ]
  ],
  "./pl/grades_empty_page.json": [
    "483630",
    [
      831250
    ]
  ],
  "./sv-x-k12/calendar_sidebar.json": [
    "123150",
    [
      787142
    ]
  ],
  "./pt-BR/course_paces_settings.json": [
    "780557",
    [
      445532
    ]
  ],
  "./en-GB-x-lbs/conferences.json": [
    "775807",
    [
      937557
    ]
  ],
  "./nn/AssignmentListItemView.json": [
    "804057",
    [
      718187
    ]
  ],
  "./ms/pseudonyms_mobile_login.json": [
    "926230",
    [
      91478
    ]
  ],
  "./th/SpeedGraderDiscussionsNavigation.json": [
    "962449",
    [
      45979
    ]
  ],
  "./pt-BR/discussionTopicKeyboradShortcutModal.json": [
    "975750",
    [
      562956
    ]
  ],
  "./en-GB-x-ukhe/permission_button.json": [
    "248404",
    [
      309620
    ]
  ],
  "./de/account_settings.json": [
    "293686",
    [
      309855
    ]
  ],
  "./sv-x-k12/keyboardShortcutModal.json": [
    "100669",
    [
      73579
    ]
  ],
  "./fa/modules_home_page.json": [
    "999174",
    [
      676462
    ]
  ],
  "./hu/manage_avatars.json": [
    "788925",
    [
      793235
    ]
  ],
  "./ar/assignments_2_attempt_tab.json": [
    "483516",
    [
      482240
    ]
  ],
  "./fa/canvas_file_upload.json": [
    "521320",
    [
      822624
    ]
  ],
  "./fi/context_roster_user_services.json": [
    "826033",
    [
      241735
    ]
  ],
  "./da/assignments_2_student_content_rubric_self_assessment.json": [
    "331334",
    [
      872534
    ]
  ],
  "./hi/calculator.json": [
    "352135",
    [
      519085
    ]
  ],
  "./sl/assignments_2_student_annotation.json": [
    "134850",
    [
      905550
    ]
  ],
  "./hu/account_calendar_settings_account_group.json": [
    "749467",
    [
      826145
    ]
  ],
  "./nb/blueprint_course_sidebar.json": [
    "61696",
    [
      108076
    ]
  ],
  "./ja/quizzes_public.json": [
    "611402",
    [
      123379
    ]
  ],
  "./mi/folder_tree.json": [
    "204569",
    [
      730279
    ]
  ],
  "./es-ES/assignments_2_media_attempt.json": [
    "793545",
    [
      394511
    ]
  ],
  "./es/blueprint_settingsCoursePicker.json": [
    "978804",
    [
      481441
    ]
  ],
  "./hy/course_navigation_settings.json": [
    "368335",
    [
      100629
    ]
  ],
  "./ko/quizzes_index.json": [
    "9046",
    [
      478182
    ]
  ],
  "./uk/HelpTray.json": [
    "818585",
    [
      766999
    ]
  ],
  "./sl/assignments.never_drop.json": [
    "199809",
    [
      654808
    ]
  ],
  "./pt-BR/blueprint_settingsCourseFilter.json": [
    "56663",
    [
      99842
    ]
  ],
  "./ar/peer_reviews_student.json": [
    "214889",
    [
      131795
    ]
  ],
  "./ja/rate_limiting_settings.json": [
    "345167",
    [
      752402
    ]
  ],
  "./nn/edit_section_end_date.json": [
    "240945",
    [
      622123
    ]
  ],
  "./cy/account_calendar_settings_account_calendar_item_dropdown.json": [
    "930301",
    [
      423251
    ]
  ],
  "./sv/discussion_topics.json": [
    "63530",
    [
      699742
    ]
  ],
  "./nn/assignments_2_student_header.json": [
    "439719",
    [
      305273
    ]
  ],
  "./it/quizzes_index.json": [
    "74065",
    [
      33275
    ]
  ],
  "./ca/content_share_preview_overlay.json": [
    "712007",
    [
      678853
    ]
  ],
  "./pt/eportfolio.json": [
    "469043",
    [
      540125
    ]
  ],
  "./th/speed_grader_helpers.json": [
    "610967",
    [
      463289
    ]
  ],
  "./ga/module_student_view_peer_reviews.json": [
    "89933",
    [
      96251
    ]
  ],
  "./it/last_attended.json": [
    "486551",
    [
      617313
    ]
  ],
  "./he/permission_button.json": [
    "756945",
    [
      756399
    ]
  ],
  "./ht/lti_registrations.json": [
    "462984",
    [
      811924
    ]
  ],
  "./ga/dashboard_grading_period_select.json": [
    "295780",
    [
      570372
    ]
  ],
  "./pl/question_bank.json": [
    "495305",
    [
      670147
    ]
  ],
  "./ca/outcomes_user_outcome_results.json": [
    "931585",
    [
      677967
    ]
  ],
  "./ga/ai_experiences_show.json": [
    "918302",
    [
      566486
    ]
  ],
  "./ga/add_edit_pseudonym.json": [
    "770683",
    [
      816681
    ]
  ],
  "./zh-Hant/canvas_file_upload.json": [
    "549713",
    [
      715395
    ]
  ],
  "./sv-x-k12/submit_online_url_assignment.json": [
    "403115",
    [
      229897
    ]
  ],
  "./fr-CA/account_notification_settings.json": [
    "912794",
    [
      417094
    ]
  ],
  "./ko/notebook_index.json": [
    "15610",
    [
      920530
    ]
  ],
  "./pl/gradingPeriodTemplate.json": [
    "519249",
    [
      74699
    ]
  ],
  "./fi/conversations_2.json": [
    "127826",
    [
      76626
    ]
  ],
  "./nb-x-k12/outcome_detail.json": [
    "760244",
    [
      561892
    ]
  ],
  "./it/youtube_migration.json": [
    "3897",
    [
      524203
    ]
  ],
  "./zh-Hans/ldap_cert_upload.json": [
    "661911",
    [
      966749
    ]
  ],
  "./nn/outcomes_user_outcome_results.json": [
    "426205",
    [
      72759
    ]
  ],
  "./es/SpeedGraderPostGradesMenu.json": [
    "952471",
    [
      639978
    ]
  ],
  "./pt-BR/submit_online_url_assignment.json": [
    "746237",
    [
      641148
    ]
  ],
  "./fr-CA/suppress_notifications.json": [
    "263533",
    [
      219311
    ]
  ],
  "./ga/course_paces_errors.json": [
    "645898",
    [
      163930
    ]
  ],
  "./nn/grades_summary.json": [
    "790201",
    [
      314499
    ]
  ],
  "./en-AU-x-unimelb/homeroom_page.json": [
    "242236",
    [
      203368
    ]
  ],
  "./hu/gradebook.json": [
    "186715",
    [
      12289
    ]
  ],
  "./da-x-k12/react_scheduler.json": [
    "950430",
    [
      650858
    ]
  ],
  "./ko/bulk_edit_students_table.json": [
    "851325",
    [
      631395
    ]
  ],
  "./mi/calendar_sidebar.json": [
    "120429",
    [
      63587
    ]
  ],
  "./nn/content_share_preview_overlay.json": [
    "813563",
    [
      821693
    ]
  ],
  "./zh-Hans/context_modules_v2.json": [
    "118441",
    [
      317580
    ]
  ],
  "./ca/discussion_insights.json": [
    "229590",
    [
      632646
    ]
  ],
  "./el/learning_mastery_gradebook.json": [
    "999524",
    [
      833760
    ]
  ],
  "./hy/user_profile.json": [
    "432094",
    [
      669782
    ]
  ],
  "./nn/context_roster_user_services.json": [
    "343770",
    [
      155494
    ]
  ],
  "./ko/module_sequence_footer.json": [
    "909590",
    [
      33830
    ]
  ],
  "./pt-BR/course_default_due_time.json": [
    "354029",
    [
      857084
    ]
  ],
  "./fr-CA/lti_registration.wizard.json": [
    "797025",
    [
      279244
    ]
  ],
  "./hu/sections_tooltip.json": [
    "301107",
    [
      637833
    ]
  ],
  "./el/user_lists.json": [
    "764584",
    [
      416060
    ]
  ],
  "./zh-Hant/direct_share_course_import_panel.json": [
    "455424",
    [
      457156
    ]
  ],
  "./ja/assignments_2_submission_helpers.json": [
    "843403",
    [
      791430
    ]
  ],
  "./nn/FindOutcomesModal.json": [
    "187073",
    [
      751939
    ]
  ],
  "./da/calendar_sidebar.json": [
    "410946",
    [
      615562
    ]
  ],
  "./el/accessibility_scan.json": [
    "822041",
    [
      120715
    ]
  ],
  "./ca/gradebook_history.json": [
    "416151",
    [
      677525
    ]
  ],
  "./ja/error_form.json": [
    "690864",
    [
      284981
    ]
  ],
  "./ht/assignments_2_shared_Steps.json": [
    "612819",
    [
      152333
    ]
  ],
  "./he/a2LatePolicyToolTipContent.json": [
    "193594",
    [
      549378
    ]
  ],
  "./pt-BR/homeroom_page.json": [
    "536121",
    [
      647600
    ]
  ],
  "./da/assignments_2_external_tool.json": [
    "654659",
    [
      406505
    ]
  ],
  "./ht/course_paces_search.json": [
    "995529",
    [
      461571
    ]
  ],
  "./pl/notebook_index.json": [
    "637200",
    [
      583564
    ]
  ],
  "./it/available_pronouns_list.json": [
    "851130",
    [
      388502
    ]
  ],
  "./de/context_prior_users.json": [
    "459922",
    [
      962675
    ]
  ],
  "./fr-CA/course_paces_time_selection.json": [
    "208092",
    [
      127224
    ]
  ],
  "./sl/assignments_2_media_attempt.json": [
    "415587",
    [
      41789
    ]
  ],
  "./en-AU-x-unimelb/account_course_user_search.json": [
    "287412",
    [
      377080
    ]
  ],
  "./pl/important_dates_empty.json": [
    "77312",
    [
      416828
    ]
  ],
  "./sv/CourseAvailabilityOptions.json": [
    "457507",
    [
      531573
    ]
  ],
  "./ga/permissions_role_tray.json": [
    "159328",
    [
      973800
    ]
  ],
  "./tr/reset_pace_warning_modal.json": [
    "9850",
    [
      127270
    ]
  ],
  "./fa/authentication_providers.json": [
    "700991",
    [
      776796
    ]
  ],
  "./sv/learning_mastery_gradebook.json": [
    "711348",
    [
      93104
    ]
  ],
  "./en-CA/content_shares.json": [
    "102268",
    [
      248364
    ]
  ],
  "./da-x-k12/peer_review_configuration_tray.json": [
    "246860",
    [
      989544
    ]
  ],
  "./he/k5_dashboard.json": [
    "994036",
    [
      766988
    ]
  ],
  "./is/grades_summary.json": [
    "594289",
    [
      320071
    ]
  ],
  "./sv/user_restore.json": [
    "767875",
    [
      427773
    ]
  ],
  "./th/quizzes_openModerateStudentDialog.json": [
    "182428",
    [
      228392
    ]
  ],
  "./ht/quizzes_index.json": [
    "576364",
    [
      749752
    ]
  ],
  "./mi/GroupsTray.json": [
    "808692",
    [
      968191
    ]
  ],
  "./el/ai_experiences_show.json": [
    "754519",
    [
      864513
    ]
  ],
  "./de/sections_tooltip.json": [
    "784287",
    [
      253850
    ]
  ],
  "./en-GB/quizzes_public.json": [
    "583290",
    [
      26423
    ]
  ],
  "./it/add_edit_pseudonym.json": [
    "636608",
    [
      88300
    ]
  ],
  "./mi/discussionTopicKeyboradShortcutModal.json": [
    "266323",
    [
      48169
    ]
  ],
  "./hy/lti_registration.wizard.json": [
    "592307",
    [
      296598
    ]
  ],
  "./cy/gradebook_history.json": [
    "222015",
    [
      714813
    ]
  ],
  "./ms/edit_section_dates.json": [
    "818164",
    [
      669260
    ]
  ],
  "./sv/blueprint_settingsSyncHistory.json": [
    "941357",
    [
      398599
    ]
  ],
  "./th/ai_experiences_ai_conversations.json": [
    "377518",
    [
      472810
    ]
  ],
  "./id/course_paces_modal.json": [
    "110689",
    [
      721603
    ]
  ],
  "./pt-BR/use_switch_experience.json": [
    "274386",
    [
      434041
    ]
  ],
  "./sl/choose_mastery_path.json": [
    "670238",
    [
      41650
    ]
  ],
  "./nl/theme_editor.json": [
    "607855",
    [
      68425
    ]
  ],
  "./uk/blueprint_settingsMigrationOptions.json": [
    "432081",
    [
      363743
    ]
  ],
  "./pt-BR/suppress_notifications.json": [
    "583753",
    [
      879872
    ]
  ],
  "./th/AddGroup.json": [
    "752992",
    [
      376868
    ]
  ],
  "./ca/course_restore.json": [
    "835918",
    [
      476462
    ]
  ],
  "./ko/quizzes_regrade_modal.json": [
    "588396",
    [
      835972
    ]
  ],
  "./ru.json": [
    "877040",
    [
      326414
    ]
  ],
  "./vi/quizzes_regrade_modal.json": [
    "751064",
    [
      482329
    ]
  ],
  "./zh-Hant/AccountsTray.json": [
    "373224",
    [
      417356
    ]
  ],
  "./pt/account_notification_settings.json": [
    "225187",
    [
      822349
    ]
  ],
  "./th/course_paces_assignment_row.json": [
    "546167",
    [
      508833
    ]
  ],
  "./tr/quizzes_quiz_submission.json": [
    "471812",
    [
      359368
    ]
  ],
  "./ar/SpeedGraderSettingsMenu.json": [
    "752151",
    [
      22513
    ]
  ],
  "./de/EditMasteryScaleLink.json": [
    "425382",
    [
      92511
    ]
  ],
  "./fr-CA/FindOutcomesModal.json": [
    "590444",
    [
      159280
    ]
  ],
  "./mi/announcements_v2.json": [
    "639413",
    [
      528731
    ]
  ],
  "./sv/course_navigation_settings.json": [
    "488169",
    [
      933907
    ]
  ],
  "./zh-Hant/CreateEditAssignmentModalAdapter.json": [
    "815049",
    [
      944459
    ]
  ],
  "./hy/filter_calendars_modal.json": [
    "827135",
    [
      665621
    ]
  ],
  "./ar/terms_of_service_modal.json": [
    "485808",
    [
      585252
    ]
  ],
  "./he/jobs.json": [
    "812907",
    [
      115441
    ]
  ],
  "./ko/assignments_2_login_action_prompt.json": [
    "967787",
    [
      114561
    ]
  ],
  "./es-ES/dashboard_grades_page.json": [
    "253786",
    [
      97850
    ]
  ],
  "./ca/rate_limiting_settings.json": [
    "854228",
    [
      520444
    ]
  ],
  "./nb/video_conference.json": [
    "715084",
    [
      385696
    ]
  ],
  "./es-ES/blueprint_settingsAssociationsTable.json": [
    "176712",
    [
      76112
    ]
  ],
  "./ht/files_v2.json": [
    "374738",
    [
      781998
    ]
  ],
  "./it/course_paces_errors.json": [
    "622395",
    [
      399101
    ]
  ],
  "./fa/blueprint_settingsAssociationsTable.json": [
    "608192",
    [
      208232
    ]
  ],
  "./mi/progressbar_view.json": [
    "209016",
    [
      979656
    ]
  ],
  "./nn/link_validator.json": [
    "173911",
    [
      738937
    ]
  ],
  "./zh-Hans/course_paces_search.json": [
    "211502",
    [
      604118
    ]
  ],
  "./pl/course_paces_time_selection.json": [
    "165641",
    [
      653339
    ]
  ],
  "./vi/course_search_results.json": [
    "905768",
    [
      490608
    ]
  ],
  "./es-ES/account_calendar_settings_account_calendar_item.json": [
    "851050",
    [
      125242
    ]
  ],
  "./de/student_groups.json": [
    "647859",
    [
      498230
    ]
  ],
  "./ar/courses.show.json": [
    "433150",
    [
      845713
    ]
  ],
  "./zh-Hans/knowledge_check_not_ready.json": [
    "251552",
    [
      670712
    ]
  ],
  "./ht/not_found_page_slide_puzzle.json": [
    "558145",
    [
      774915
    ]
  ],
  "./en-GB/lti_registrations.json": [
    "961909",
    [
      561640
    ]
  ],
  "./nn/assignment_index_menu.json": [
    "817182",
    [
      521666
    ]
  ],
  "./nn/gradebook_default_gradebook_components_content_filters_module_filter.json": [
    "850282",
    [
      592358
    ]
  ],
  "./el/FindOutcomesModal.json": [
    "989996",
    [
      265584
    ]
  ],
  "./el/content_exports.json": [
    "376130",
    [
      344318
    ]
  ],
  "./en-CA/quizzes_index.json": [
    "423828",
    [
      157476
    ]
  ],
  "./fr/youtube_migration.json": [
    "355676",
    [
      356101
    ]
  ],
  "./is/conversations_2.json": [
    "935639",
    [
      956397
    ]
  ],
  "./mi/AssignmentListItemView.json": [
    "459179",
    [
      618065
    ]
  ],
  "./es/submissions_show_preview.json": [
    "578386",
    [
      446795
    ]
  ],
  "./nb/dashboard_grades_page.json": [
    "160991",
    [
      272401
    ]
  ],
  "./sv-x-k12/dashboard.json": [
    "878853",
    [
      568547
    ]
  ],
  "./sv/copy_course.json": [
    "849936",
    [
      419564
    ]
  ],
  "./nn/course_paces_empty_state.json": [
    "810964",
    [
      658056
    ]
  ],
  "./zh-Hans/quizzes_openModerateStudentDialog.json": [
    "799455",
    [
      482965
    ]
  ],
  "./zh-Hans/unpublished_changes_tray_contents.json": [
    "108260",
    [
      948964
    ]
  ],
  "./vi/gradebookActionMenu.json": [
    "147466",
    [
      582692
    ]
  ],
  "./zh-Hant/remove_pace_warning_modal.json": [
    "771463",
    [
      898577
    ]
  ],
  "./th/assignments.json": [
    "471660",
    [
      376712
    ]
  ],
  "./ko/course_paces_header.json": [
    "280294",
    [
      522742
    ]
  ],
  "./pt-BR/gradebookActionMenu.json": [
    "917060",
    [
      827689
    ]
  ],
  "./th/assignments_2_student_annotation.json": [
    "773899",
    [
      27245
    ]
  ],
  "./fr-CA/AddGroup.json": [
    "234171",
    [
      739717
    ]
  ],
  "./cy/plugins.json": [
    "22998",
    [
      431126
    ]
  ],
  "./zh-Hans/last_attended.json": [
    "801885",
    [
      561595
    ]
  ],
  "./en-AU-x-unimelb/assignment_grade_summary.json": [
    "265864",
    [
      931004
    ]
  ],
  "./is/lti_registrations.json": [
    "51860",
    [
      545092
    ]
  ],
  "./ja/ProfileTray.json": [
    "877890",
    [
      817067
    ]
  ],
  "./pt-BR/course_paces_blackout_date_row.json": [
    "502397",
    [
      884124
    ]
  ],
  "./nn/canvascareer.json": [
    "627944",
    [
      96092
    ]
  ],
  "./sl/calendar_custom_recurring_event_natural_language.json": [
    "5755",
    [
      152069
    ]
  ],
  "./nb/account_calendars_modal.json": [
    "592667",
    [
      204853
    ]
  ],
  "./ja/blueprint_settingsCoursePicker.json": [
    "396227",
    [
      375710
    ]
  ],
  "./ja/course_color_selector.json": [
    "444816",
    [
      600405
    ]
  ],
  "./nl/assignments.json": [
    "685714",
    [
      649222
    ]
  ],
  "./tr/course_paces_time_selection.json": [
    "690263",
    [
      83529
    ]
  ],
  "./it/assignments_2_attempt_tab.json": [
    "988622",
    [
      855186
    ]
  ],
  "./da-x-k12/discussion_create.json": [
    "545742",
    [
      817450
    ]
  ],
  "./hi/account_calendars.json": [
    "756630",
    [
      168350
    ]
  ],
  "./pt/react_scheduler.json": [
    "379635",
    [
      189757
    ]
  ],
  "./en-GB/calendar_custom_recurring_event_natural_language.json": [
    "110569",
    [
      505444
    ]
  ],
  "./sv/accessibility_course_statistics.json": [
    "28905",
    [
      109939
    ]
  ],
  "./it/account_calendar_settings_confirmation_modal.json": [
    "837057",
    [
      583331
    ]
  ],
  "./pt-BR/outcome_management.json": [
    "952919",
    [
      180082
    ]
  ],
  "./ar/assignments_2_student_content.json": [
    "651984",
    [
      937196
    ]
  ],
  "./fi/course_paces_module.json": [
    "158764",
    [
      843324
    ]
  ],
  "./nb/peer_review_student_select.json": [
    "984188",
    [
      648408
    ]
  ],
  "./ms/file_not_found.json": [
    "318889",
    [
      698679
    ]
  ],
  "./cy/OutcomeMoveModal.json": [
    "352460",
    [
      23412
    ]
  ],
  "./nb/editAssignmentGroupWeights.json": [
    "910555",
    [
      398093
    ]
  ],
  "./es-ES/AssignmentListItemView.json": [
    "285134",
    [
      795926
    ]
  ],
  "./th/appt_calendar_event_dialog.json": [
    "595286",
    [
      794922
    ]
  ],
  "./nl/appt_calendar_event_dialog.json": [
    "444840",
    [
      919060
    ]
  ],
  "./fi/blueprint_course_sidebar.json": [
    "169471",
    [
      573477
    ]
  ],
  "./ca/progressbar_view.json": [
    "702614",
    [
      571782
    ]
  ],
  "./tr/outcome_reporting.json": [
    "96921",
    [
      114635
    ]
  ],
  "./es/progress_pill.json": [
    "322381",
    [
      861396
    ]
  ],
  "./th/entity_search_form.json": [
    "595505",
    [
      198443
    ]
  ],
  "./es/account_calendar_settings_account_calendar_item_dropdown.json": [
    "310797",
    [
      106388
    ]
  ],
  "./fi/quizzes_quiz_submission.json": [
    "119091",
    [
      569937
    ]
  ],
  "./cy/roster_publicjs.json": [
    "145204",
    [
      245708
    ]
  ],
  "./en-AU-x-unimelb/courses.json": [
    "435012",
    [
      595792
    ]
  ],
  "./en-GB-x-ukhe/account_calendars.json": [
    "205599",
    [
      393397
    ]
  ],
  "./da/grades_empty_page.json": [
    "77757",
    [
      339043
    ]
  ],
  "./es-ES/user_lists.json": [
    "230252",
    [
      150252
    ]
  ],
  "./fr/unpublished_warning_modal.json": [
    "311400",
    [
      571297
    ]
  ],
  "./hi/assignments_2_student_annotation.json": [
    "994186",
    [
      984186
    ]
  ],
  "./is/ProfileTray.json": [
    "647023",
    [
      847765
    ]
  ],
  "./nn/quizzes_quiz_submission.json": [
    "201670",
    [
      722202
    ]
  ],
  "./zh-Hant/quiz_migration_notifications.json": [
    "652697",
    [
      39355
    ]
  ],
  "./el/canvascareer.json": [
    "896939",
    [
      81885
    ]
  ],
  "./fr-CA/student_entries.json": [
    "406391",
    [
      316321
    ]
  ],
  "./fr-CA/not_found_page_slide_puzzle.json": [
    "50136",
    [
      68668
    ]
  ],
  "./mi/jobs_v2.json": [
    "192489",
    [
      372535
    ]
  ],
  "./fr-CA/calendar_appointment_group_edit.json": [
    "305014",
    [
      169850
    ]
  ],
  "./ja/course_paces_app.json": [
    "546675",
    [
      866958
    ]
  ],
  "./th/user_profile.json": [
    "952003",
    [
      931389
    ]
  ],
  "./fr/assignment_index.json": [
    "935692",
    [
      460405
    ]
  ],
  "./nb/discussion_create.json": [
    "776807",
    [
      127193
    ]
  ],
  "./cy/account_calendars_modal.json": [
    "392923",
    [
      329857
    ]
  ],
  "./cy/AlignmentSummary.json": [
    "152277",
    [
      256251
    ]
  ],
  "./ms/SpeedGraderSettingsMenu.json": [
    "395504",
    [
      421584
    ]
  ],
  "./de/AlignmentSummary.json": [
    "451280",
    [
      472685
    ]
  ],
  "./he/course_statistics.json": [
    "406712",
    [
      368264
    ]
  ],
  "./es-ES/important_dates_empty.json": [
    "342801",
    [
      825063
    ]
  ],
  "./ht/gradebookActionMenu.json": [
    "701833",
    [
      730443
    ]
  ],
  "./hu/course_paces_projected_dates.json": [
    "904836",
    [
      53628
    ]
  ],
  "./hu/custom_emoji_deny_list.json": [
    "551857",
    [
      522319
    ]
  ],
  "./hy/license_help.json": [
    "384792",
    [
      585200
    ]
  ],
  "./is/course_paces_actions.json": [
    "101676",
    [
      463468
    ]
  ],
  "./nn/assignments_2_student_points_display.json": [
    "143648",
    [
      721756
    ]
  ],
  "./nb/course_paces_blackout_dates_modal.json": [
    "851080",
    [
      972884
    ]
  ],
  "./en-AU/edit_section_view.json": [
    "623060",
    [
      666545
    ]
  ],
  "./sv-x-k12/conversations_2.json": [
    "41344",
    [
      225976
    ]
  ],
  "./da/new_user_tutorial.json": [
    "280286",
    [
      937246
    ]
  ],
  "./fa/jobs_v2.json": [
    "18658",
    [
      645330
    ]
  ],
  "./en-GB/calendar_appointment_group_edit.json": [
    "5622",
    [
      838955
    ]
  ],
  "./fr-CA/discussion_insights.json": [
    "53915",
    [
      222853
    ]
  ],
  "./de/available_pronouns_list.json": [
    "234448",
    [
      648781
    ]
  ],
  "./tr/IndividualStudentMasteryOutcome.json": [
    "713537",
    [
      617227
    ]
  ],
  "./it/admin_split.json": [
    "644239",
    [
      873577
    ]
  ],
  "./tr/outcome_detail.json": [
    "676396",
    [
      377816
    ]
  ],
  "./ko/HelpTray.json": [
    "996975",
    [
      688413
    ]
  ],
  "./th/webcam_modal.json": [
    "875321",
    [
      786755
    ]
  ],
  "./sv-x-k12/account_calendar_settings_account_tree.json": [
    "279964",
    [
      780876
    ]
  ],
  "./en-AU-x-unimelb/quiz_log_auditing.json": [
    "889030",
    [
      783802
    ]
  ],
  "./en-GB-x-ukhe/permissions.json": [
    "20036",
    [
      492212
    ]
  ],
  "./ca/announcements_v2.json": [
    "645671",
    [
      359589
    ]
  ],
  "./en-CA/ai_experiences_ai_conversations.json": [
    "770718",
    [
      869222
    ]
  ],
  "./is/grade_details.json": [
    "130664",
    [
      777648
    ]
  ],
  "./sv/password_complexity_configuration.json": [
    "154716",
    [
      756792
    ]
  ],
  "./pt/blueprint_course_child.json": [
    "664046",
    [
      89466
    ]
  ],
  "./es-ES/account_calendar_settings_footer.json": [
    "611841",
    [
      355223
    ]
  ],
  "./de/announcements_on_home_page.json": [
    "126899",
    [
      140742
    ]
  ],
  "./fr-CA/gradebook_uploads.json": [
    "211136",
    [
      872804
    ]
  ],
  "./nn.eager.json": [
    "758143",
    [
      381358
    ]
  ],
  "./uk/unpublished_changes_button_props.json": [
    "991205",
    [
      88091
    ]
  ],
  "./en-GB/gradebookActionMenu.json": [
    "766960",
    [
      70425
    ]
  ],
  "./es/blueprint_settingsMigrationSync.json": [
    "430342",
    [
      912119
    ]
  ],
  "./ht/course_paces_settings.json": [
    "10356",
    [
      252280
    ]
  ],
  "./es-ES/change_password.json": [
    "831971",
    [
      795409
    ]
  ],
  "./ru/outcome_detail.json": [
    "543713",
    [
      124135
    ]
  ],
  "./ja/content_share_preview_overlay.json": [
    "381022",
    [
      856108
    ]
  ],
  "./id/horizon_toggle.json": [
    "389801",
    [
      408331
    ]
  ],
  "./it/user_lists.json": [
    "711836",
    [
      980592
    ]
  ],
  "./ko/user_logins.json": [
    "438314",
    [
      610050
    ]
  ],
  "./mi/security_panel.json": [
    "412911",
    [
      77005
    ]
  ],
  "./th/users.json": [
    "47958",
    [
      392074
    ]
  ],
  "./fi/knowledge_check_not_ready.json": [
    "575806",
    [
      949622
    ]
  ],
  "./en-GB/grade_summary.json": [
    "116803",
    [
      349898
    ]
  ],
  "./el/outcome_alignment_v2.json": [
    "827818",
    [
      943486
    ]
  ],
  "./zh-Hans/keyboardShortcutModal.json": [
    "371573",
    [
      473235
    ]
  ],
  "./fr-CA/dashboard.json": [
    "181159",
    [
      188497
    ]
  ],
  "./ru/quizzes_quiz_submission.json": [
    "554291",
    [
      833729
    ]
  ],
  "./is/file_not_found.json": [
    "354453",
    [
      952979
    ]
  ],
  "./th/grade_summaryGroupView.json": [
    "384256",
    [
      769924
    ]
  ],
  "./mi/assignments_2_media_attempt.json": [
    "984886",
    [
      514934
    ]
  ],
  "./nb/enhanced_individual_gradebook_submit_score.json": [
    "462917",
    [
      420991
    ]
  ],
  "./de/accessibility_checker.json": [
    "274833",
    [
      277848
    ]
  ],
  "./zh-Hant/outcome_reporting.json": [
    "514233",
    [
      458811
    ]
  ],
  "./fr-CA/course_stats.json": [
    "783920",
    [
      202540
    ]
  ],
  "./es-ES/modelsQuiz.json": [
    "33034",
    [
      468074
    ]
  ],
  "./es-ES/section.json": [
    "360436",
    [
      247220
    ]
  ],
  "./pt-BR/account_calendars_modal.json": [
    "93122",
    [
      850723
    ]
  ],
  "./nb/discussion_settings.json": [
    "429710",
    [
      992594
    ]
  ],
  "./nb/restore_content_pane.json": [
    "528957",
    [
      100863
    ]
  ],
  "./pt-BR/context_prior_users.json": [
    "585116",
    [
      707953
    ]
  ],
  "./ja/ai_experiences.json": [
    "409717",
    [
      516652
    ]
  ],
  "./tr/section.json": [
    "292955",
    [
      862453
    ]
  ],
  "./nl/assignments_2_initial_query.json": [
    "127659",
    [
      714093
    ]
  ],
  "./fi/assignments_2_file_upload.json": [
    "212889",
    [
      402399
    ]
  ],
  "./uk/a2_AccessibleTipContent.json": [
    "314306",
    [
      895210
    ]
  ],
  "./pt-BR/eportfolio.json": [
    "646160",
    [
      347677
    ]
  ],
  "./sv/SpeedGraderPostGradesMenu.json": [
    "223302",
    [
      779378
    ]
  ],
  "./pt-BR/assignments_2_text_entry.json": [
    "850433",
    [
      98200
    ]
  ],
  "./uk/assignmentsToggleShowByView.json": [
    "861381",
    [
      854203
    ]
  ],
  "./ja/password_complexity_configuration.json": [
    "803996",
    [
      323353
    ]
  ],
  "./ms/assignment_grade_summary.json": [
    "658152",
    [
      276088
    ]
  ],
  "./fr/SpeedGraderSettingsMenu.json": [
    "860832",
    [
      916001
    ]
  ],
  "./da/media_player_iframe_content.json": [
    "636590",
    [
      713646
    ]
  ],
  "./en-GB-x-lbs/user.json": [
    "798531",
    [
      647185
    ]
  ],
  "./es/syllabus_revisions.json": [
    "128880",
    [
      35909
    ]
  ],
  "./fi/todo.json": [
    "30673",
    [
      407143
    ]
  ],
  "./hy/LogoutButton.json": [
    "722577",
    [
      898759
    ]
  ],
  "./nb/assignments.never_drop.json": [
    "218788",
    [
      407891
    ]
  ],
  "./sv/account_calendars_modal.json": [
    "335902",
    [
      191234
    ]
  ],
  "./sv/CoursesTray.json": [
    "326417",
    [
      224947
    ]
  ],
  "./th/assignmentsToggleShowByView.json": [
    "198581",
    [
      937943
    ]
  ],
  "./fr-CA/editGroup.json": [
    "331220",
    [
      279184
    ]
  ],
  "./nl/eportfolio.json": [
    "566993",
    [
      734267
    ]
  ],
  "./en-AU/eportfolio.json": [
    "129421",
    [
      229444
    ]
  ],
  "./pt-BR/canvas_file_upload.json": [
    "582800",
    [
      80925
    ]
  ],
  "./is/LogoutButton.json": [
    "119508",
    [
      98964
    ]
  ],
  "./nl/user_search_results.json": [
    "501905",
    [
      932595
    ]
  ],
  "./ru/quizzes_index.json": [
    "718577",
    [
      67063
    ]
  ],
  "./da-x-k12/AlignmentSummary.json": [
    "568322",
    [
      523278
    ]
  ],
  "./en-GB-x-ukhe/empty_modules.json": [
    "852807",
    [
      891005
    ]
  ],
  "./fi/question_banks.json": [
    "568949",
    [
      832275
    ]
  ],
  "./es-ES/permissions.json": [
    "547619",
    [
      713089
    ]
  ],
  "./ga/account_calendars_modal.json": [
    "84439",
    [
      58557
    ]
  ],
  "./ru/react_developer_keys.json": [
    "864890",
    [
      757386
    ]
  ],
  "./fr/course_paces_change_tracking.json": [
    "471359",
    [
      716198
    ]
  ],
  "./el/assignments_2_attempt_tab.json": [
    "308482",
    [
      232118
    ]
  ],
  "./sv-x-k12/edit_section_dates.json": [
    "99221",
    [
      673379
    ]
  ],
  "./da/OutcomeDescriptionModal.json": [
    "858338",
    [
      621034
    ]
  ],
  "./sl/terms_of_service_modal.json": [
    "95112",
    [
      619236
    ]
  ],
  "./zh-Hant/course_paces_flaggable_number_input.json": [
    "339417",
    [
      518147
    ]
  ],
  "./hu/user_grades.json": [
    "991353",
    [
      645895
    ]
  ],
  "./de/assignments_2_student_header_date_title.json": [
    "328930",
    [
      24739
    ]
  ],
  "./ht/choose_mastery_path.json": [
    "290461",
    [
      602495
    ]
  ],
  "./en-GB-x-lbs/paginated_list.json": [
    "836611",
    [
      658072
    ]
  ],
  "./mi/OutcomeMoveModal.json": [
    "556434",
    [
      123594
    ]
  ],
  "./fi/gradebook.json": [
    "55957",
    [
      163667
    ]
  ],
  "./en-AU-x-unimelb/syllabus_revisions.json": [
    "627304",
    [
      559996
    ]
  ],
  "./id/assignments_peer_reviews_student.json": [
    "323324",
    [
      581184
    ]
  ],
  "./ms/editAssignmentGroupWeights.json": [
    "655907",
    [
      900665
    ]
  ],
  "./id/course_paces_flaggable_number_input.json": [
    "554402",
    [
      127790
    ]
  ],
  "./nl/available_pronouns_list.json": [
    "426950",
    [
      251435
    ]
  ],
  "./ms/grade_details.json": [
    "395004",
    [
      22756
    ]
  ],
  "./hi/files_v2.json": [
    "853143",
    [
      357034
    ]
  ],
  "./pl/assignment_2_assignment_toggle_details.json": [
    "908814",
    [
      703914
    ]
  ],
  "./ht/copy_course.json": [
    "760081",
    [
      386539
    ]
  ],
  "./ga/a2LatePolicyStatusDisplay.json": [
    "176841",
    [
      678719
    ]
  ],
  "./ca/custom_help_link.json": [
    "959386",
    [
      497746
    ]
  ],
  "./hi/grades_summary.json": [
    "520972",
    [
      656892
    ]
  ],
  "./ru/media_immersive_view.json": [
    "190045",
    [
      697803
    ]
  ],
  "./vi/editAssignmentGroupWeights.json": [
    "723984",
    [
      999496
    ]
  ],
  "./hi/external_content_cancel.json": [
    "749929",
    [
      188207
    ]
  ],
  "./ko/ImportConfirmBox.json": [
    "248264",
    [
      791272
    ]
  ],
  "./th/assignment_index.json": [
    "511020",
    [
      56432
    ]
  ],
  "./en-AU-x-unimelb/accessibility_checker.json": [
    "708878",
    [
      593450
    ]
  ],
  "./en-GB-x-ukhe/gradebook_default_gradebook_components_content_filters_module_filter.json": [
    "556944",
    [
      716952
    ]
  ],
  "./hu/nav_tourpoints.json": [
    "692292",
    [
      399068
    ]
  ],
  "./nl/peer_review_configuration_tray.json": [
    "361613",
    [
      274375
    ]
  ],
  "./cy/terms_of_use.json": [
    "195127",
    [
      794405
    ]
  ],
  "./ga/course_paces_modal.json": [
    "326250",
    [
      28010
    ]
  ],
  "./de/link_to_students.json": [
    "528430",
    [
      261511
    ]
  ],
  "./el/reset_pace_warning_modal.json": [
    "234383",
    [
      656753
    ]
  ],
  "./cy/course_template_details.json": [
    "557167",
    [
      972461
    ]
  ],
  "./de/course_paces_projected_dates.json": [
    "278008",
    [
      273621
    ]
  ],
  "./en-AU-x-unimelb/roster_section_selector.json": [
    "485007",
    [
      964265
    ]
  ],
  "./en-GB-x-lbs/MobileGlobalMenu.json": [
    "991118",
    [
      492806
    ]
  ],
  "./es-ES/assignmentsIndexView.json": [
    "842454",
    [
      560062
    ]
  ],
  "./sl/student_groups.json": [
    "592931",
    [
      905085
    ]
  ],
  "./ms/users.json": [
    "664742",
    [
      943302
    ]
  ],
  "./hu/change_password.json": [
    "98989",
    [
      580099
    ]
  ],
  "./tr/course_paces_pace_picker.json": [
    "245351",
    [
      628185
    ]
  ],
  "./en-AU-x-unimelb/content_migrations_redesign.json": [
    "474777",
    [
      95907
    ]
  ],
  "./ms/sharedCurveGradesDialog.json": [
    "599050",
    [
      921874
    ]
  ],
  "./sv/unpublished_changes_tray_contents.json": [
    "547102",
    [
      359482
    ]
  ],
  "./da-x-k12/assignments_2_student_annotation.json": [
    "956860",
    [
      833464
    ]
  ],
  "./en-GB-x-lbs/blueprint_settingsUnsyncedChanges.json": [
    "905081",
    [
      268799
    ]
  ],
  "./fr-CA/syllabus_revisions.json": [
    "794495",
    [
      559017
    ]
  ],
  "./en-GB/assignments_2_file_upload.json": [
    "450085",
    [
      240560
    ]
  ],
  "./pt/course_paces_module.json": [
    "10279",
    [
      387415
    ]
  ],
  "./zh-Hans/blueprint_settingsCourseFilter.json": [
    "354349",
    [
      478907
    ]
  ],
  "./en-AU/gradebookActionMenu.json": [
    "423987",
    [
      210350
    ]
  ],
  "./nb-x-k12/MoveOutcomesModal.json": [
    "13001",
    [
      517087
    ]
  ],
  "./hy/SpeedGraderCheckpoints.json": [
    "2140",
    [
      416508
    ]
  ],
  "./en-AU-x-unimelb/react_collaborations.json": [
    "793472",
    [
      581364
    ]
  ],
  "./hi/quizzes_index.json": [
    "773159",
    [
      336605
    ]
  ],
  "./hu/available_pronouns_list.json": [
    "568900",
    [
      620956
    ]
  ],
  "./es/course_paces_pace_picker.json": [
    "499661",
    [
      723956
    ]
  ],
  "./pt-BR/sharedCurveGradesDialog.json": [
    "746863",
    [
      714234
    ]
  ],
  "./en/sections_tooltip.json": [
    "247751",
    [
      817513
    ]
  ],
  "./da-x-k12/entity_search_form.json": [
    "307398",
    [
      733738
    ]
  ],
  "./fr/question_banks.json": [
    "290798",
    [
      366931
    ]
  ],
  "./en-CA/question_bank.json": [
    "334833",
    [
      346295
    ]
  ],
  "./fr/course_paces_blueprint_lock.json": [
    "382930",
    [
      572815
    ]
  ],
  "./nn/reset_pace_warning_modal.json": [
    "216288",
    [
      913724
    ]
  ],
  "./en-AU-x-unimelb/account_calendar_settings_footer.json": [
    "64166",
    [
      782130
    ]
  ],
  "./ht/dashboard.json": [
    "246534",
    [
      899474
    ]
  ],
  "./pt/syllabus_revisions.json": [
    "190328",
    [
      531476
    ]
  ],
  "./da-x-k12/self_enrollment.json": [
    "657580",
    [
      501240
    ]
  ],
  "./es/self_unenrollment_modal.json": [
    "234628",
    [
      563537
    ]
  ],
  "./da/AlignmentSummary.json": [
    "971156",
    [
      938268
    ]
  ],
  "./ru/pairing_code_user_observees.json": [
    "134274",
    [
      969426
    ]
  ],
  "./zh-Hans/NewTabIndicator.json": [
    "802571",
    [
      850809
    ]
  ],
  "./nl/webzip_export.json": [
    "39716",
    [
      604344
    ]
  ],
  "./sv-x-k12/k5_dashboard_card.json": [
    "987975",
    [
      995005
    ]
  ],
  "./th/student_annotation_preview.json": [
    "316912",
    [
      726228
    ]
  ],
  "./hy/student_groups.json": [
    "789739",
    [
      972553
    ]
  ],
  "./hu/widget_dashboard.json": [
    "967960",
    [
      709736
    ]
  ],
  "./ja/terms_index.json": [
    "870403",
    [
      468062
    ]
  ],
  "./hi/users.json": [
    "52777",
    [
      838543
    ]
  ],
  "./en-GB/outcome_management.json": [
    "532099",
    [
      48226
    ]
  ],
  "./ru/course_paces_blackout_date_row.json": [
    "694413",
    [
      644475
    ]
  ],
  "./pt/discussion_posts.json": [
    "155890",
    [
      237678
    ]
  ],
  "./fr.json": [
    "394165",
    [
      752293
    ]
  ],
  "./mi/quizzes_index.json": [
    "246554",
    [
      457922
    ]
  ],
  "./pl/course_paces_pace_picker.json": [
    "897562",
    [
      18295
    ]
  ],
  "./ht/add_edit_pseudonym.json": [
    "786735",
    [
      711249
    ]
  ],
  "./en-CA/roster_publicjs.json": [
    "399708",
    [
      289532
    ]
  ],
  "./th/permissions_v2_add_tray.json": [
    "180752",
    [
      569148
    ]
  ],
  "./pl/assignment_index_deep_linking_handlers.json": [
    "406236",
    [
      866032
    ]
  ],
  "./uk/editGroup.json": [
    "803749",
    [
      884891
    ]
  ],
  "./fi/paginated_list.json": [
    "50533",
    [
      735155
    ]
  ],
  "./sv-x-k12/assignments_2_student_annotation.json": [
    "573290",
    [
      121466
    ]
  ],
  "./zh-Hant/course_paces_blackout_dates_table.json": [
    "133023",
    [
      182113
    ]
  ],
  "./fr/assignments_2_submission_histories_query.json": [
    "186914",
    [
      888191
    ]
  ],
  "./ga/submit_online_url_assignment.json": [
    "841954",
    [
      370306
    ]
  ],
  "./ko/assignments_2_submission_helpers.json": [
    "547630",
    [
      310510
    ]
  ],
  "./ms/gradingGradeSummary.json": [
    "999847",
    [
      483541
    ]
  ],
  "./el/terms_of_service_modal.json": [
    "251526",
    [
      928554
    ]
  ],
  "./is/a2LatePolicyToolTipContent.json": [
    "57731",
    [
      396209
    ]
  ],
  "./cy/quizzes_public.json": [
    "259149",
    [
      627875
    ]
  ],
  "./vi/progressbar_view.json": [
    "828805",
    [
      873683
    ]
  ],
  "./ca/theme_editor.json": [
    "53705",
    [
      111175
    ]
  ],
  "./de/course_paces_assignment_row.json": [
    "274556",
    [
      226737
    ]
  ],
  "./nn/account_calendars_results_area.json": [
    "641752",
    [
      848156
    ]
  ],
  "./ga/self_enrollment.json": [
    "614745",
    [
      246351
    ]
  ],
  "./it/assignments_peer_reviews.json": [
    "427236",
    [
      656000
    ]
  ],
  "./ca/blueprint_settingsCoursePickerTable.json": [
    "408248",
    [
      566072
    ]
  ],
  "./ar/users.json": [
    "548313",
    [
      478251
    ]
  ],
  "./de/youtube_migration.json": [
    "877463",
    [
      340738
    ]
  ],
  "./pt-BR/assignments_2_url_entry.json": [
    "206593",
    [
      346472
    ]
  ],
  "./mi/nav_tourpoints.json": [
    "400371",
    [
      568233
    ]
  ],
  "./fr-CA/calendar_custom_recurring_event_repeat_picker.json": [
    "963481",
    [
      356379
    ]
  ],
  "./ja/student_groups.json": [
    "506109",
    [
      687188
    ]
  ],
  "./fa/wiki_page_index.json": [
    "417698",
    [
      497730
    ]
  ],
  "./uk/permissions_v2_add_tray.json": [
    "622336",
    [
      749648
    ]
  ],
  "./ca/course_paces_app.json": [
    "514184",
    [
      85640
    ]
  ],
  "./nb-x-k12/LogoutButton.json": [
    "637430",
    [
      308574
    ]
  ],
  "./pt/ai_experiences.json": [
    "738746",
    [
      200638
    ]
  ],
  "./zh-Hant/admin_split.json": [
    "563092",
    [
      725328
    ]
  ],
  "./en-GB/quizzes_openModerateStudentDialog.json": [
    "126873",
    [
      235996
    ]
  ],
  "./da-x-k12/self_unenrollment_modal.json": [
    "543301",
    [
      795671
    ]
  ],
  "./is/last_attended.json": [
    "891626",
    [
      649546
    ]
  ],
  "./mi/course_color_selector.json": [
    "464835",
    [
      63993
    ]
  ],
  "./ht/edit_section_dates.json": [
    "286380",
    [
      741536
    ]
  ],
  "./en-CA/blueprint_course_sidebar.json": [
    "934904",
    [
      105072
    ]
  ],
  "./de/keyboardShortcutModal.json": [
    "768597",
    [
      594740
    ]
  ],
  "./en-GB/webzip_export.json": [
    "536495",
    [
      732550
    ]
  ],
  "./ko/MobileNavigation.json": [
    "584320",
    [
      998704
    ]
  ],
  "./da-x-k12/course_paces_flaggable_number_input.json": [
    "815214",
    [
      176146
    ]
  ],
  "./el/HelpTray.json": [
    "745518",
    [
      208946
    ]
  ],
  "./is/assignment_index.json": [
    "60560",
    [
      506888
    ]
  ],
  "./ko/quizzes.take_quiz.json": [
    "98742",
    [
      274087
    ]
  ],
  "./en-AU-x-unimelb/MasteryScale.json": [
    "537267",
    [
      81061
    ]
  ],
  "./nb-x-k12/course_paces_modal.json": [
    "359568",
    [
      766792
    ]
  ],
  "./nb-x-k12/webzip_export.json": [
    "214032",
    [
      228264
    ]
  ],
  "./nn/auth_logging.json": [
    "77390",
    [
      697770
    ]
  ],
  "./mi/homeroom_page.json": [
    "790038",
    [
      502774
    ]
  ],
  "./es/course_pace_date_input.json": [
    "541575",
    [
      281306
    ]
  ],
  "./hy/assignments_peer_reviews.json": [
    "336374",
    [
      307918
    ]
  ],
  "./id/bulk_edit_students.json": [
    "694071",
    [
      95697
    ]
  ],
  "./sl/quizzes_index.json": [
    "526143",
    [
      487033
    ]
  ],
  "./zh-Hans/assignments_2_external_tool.json": [
    "959079",
    [
      419933
    ]
  ],
  "./mi/courses_show.json": [
    "727594",
    [
      504946
    ]
  ],
  "./pl/context_roster_user_services.json": [
    "16630",
    [
      451714
    ]
  ],
  "./tr/k5_course.json": [
    "842408",
    [
      548388
    ]
  ],
  "./da/self_unenrollment_modal.json": [
    "9519",
    [
      330845
    ]
  ],
  "./id/peer_reviews_student.json": [
    "826727",
    [
      940521
    ]
  ],
  "./nb-x-k12/blueprint_settingsAssociationsTable.json": [
    "845591",
    [
      917581
    ]
  ],
  "./en-AU/self_unenrollment_modal.json": [
    "226054",
    [
      443431
    ]
  ],
  "./en-GB-x-ukhe/pairing_code_user_observees.json": [
    "778369",
    [
      583495
    ]
  ],
  "./nn/GroupsTray.json": [
    "85438",
    [
      470066
    ]
  ],
  "./zh-Hans/copy_warnings_modal.json": [
    "736864",
    [
      981099
    ]
  ],
  "./ko/assignments_bulk_edit_use_save_assignment.json": [
    "152868",
    [
      707756
    ]
  ],
  "./en/assignments_2_peer_review.json": [
    "931960",
    [
      367292
    ]
  ],
  "./sv-x-k12/calendar_edit.json": [
    "64110",
    [
      842838
    ]
  ],
  "./ar/react_scheduler.json": [
    "327380",
    [
      706704
    ]
  ],
  "./en-GB-x-ukhe/jobs_v2.json": [
    "943909",
    [
      558787
    ]
  ],
  "./en-GB/account_calendar_settings_footer.json": [
    "907373",
    [
      442648
    ]
  ],
  "./el/new_user_tutorial.json": [
    "268668",
    [
      715432
    ]
  ],
  "./ko/assignments_2_MoreOptions_CanvasFiles.json": [
    "234953",
    [
      743271
    ]
  ],
  "./ar/announcements_on_home_page.json": [
    "740923",
    [
      344733
    ]
  ],
  "./en-GB/k5_dashboard.json": [
    "201438",
    [
      811347
    ]
  ],
  "./uk/content_migrations.json": [
    "775285",
    [
      242155
    ]
  ],
  "./ga/blueprint_coursesExpandableLockOptions.json": [
    "105015",
    [
      483181
    ]
  ],
  "./nl/knowledge_check_not_ready.json": [
    "488761",
    [
      867067
    ]
  ],
  "./nn/entity_search_form.json": [
    "733485",
    [
      529863
    ]
  ],
  "./nl/conferences.json": [
    "815311",
    [
      879265
    ]
  ],
  "./nl/widget_dashboard.json": [
    "905631",
    [
      954297
    ]
  ],
  "./ms/a2LatePolicyToolTipContent.json": [
    "33727",
    [
      509693
    ]
  ],
  "./vi/CreateEditAssignmentModal.json": [
    "794705",
    [
      104375
    ]
  ],
  "./de/modules_page_icon_legend.json": [
    "112146",
    [
      479651
    ]
  ],
  "./en-AU/module_sequence_footer.json": [
    "208122",
    [
      182851
    ]
  ],
  "./id/courses.show.json": [
    "268452",
    [
      214067
    ]
  ],
  "./nb/new_nav.json": [
    "138114",
    [
      257678
    ]
  ],
  "./ms/modules_home_page.json": [
    "814387",
    [
      593481
    ]
  ],
  "./en-AU.json": [
    "995931",
    [
      689459
    ]
  ],
  "./ht/GroupsTray.json": [
    "514250",
    [
      883838
    ]
  ],
  "./fa/react_scheduler.json": [
    "466130",
    [
      386338
    ]
  ],
  "./en-GB-x-ukhe/blueprint_settingsMigrationOptions.json": [
    "643579",
    [
      399849
    ]
  ],
  "./nb-x-k12/ai_experiences.json": [
    "335028",
    [
      211988
    ]
  ],
  "./fa/grade_details.json": [
    "630565",
    [
      140483
    ]
  ],
  "./ar/user_restore.json": [
    "41225",
    [
      219835
    ]
  ],
  "./ru/account_settings.json": [
    "696772",
    [
      609268
    ]
  ],
  "./de/course_restore.json": [
    "821407",
    [
      316682
    ]
  ],
  "./nl/user_logins.json": [
    "261450",
    [
      633654
    ]
  ],
  "./nb-x-k12/jobs.json": [
    "119972",
    [
      900276
    ]
  ],
  "./da-x-k12/module_sequence_footer.json": [
    "818239",
    [
      527697
    ]
  ],
  "./en-GB/assignments_2_media_attempt.json": [
    "181405",
    [
      600000
    ]
  ],
  "./de/SpeedGraderSettingsMenu.json": [
    "559711",
    [
      895690
    ]
  ],
  "./ca/quizzes_quiz_submission.json": [
    "656922",
    [
      992082
    ]
  ],
  "./nb/MobileNavigation.json": [
    "755922",
    [
      629862
    ]
  ],
  "./ca/knowledge_check_not_ready.json": [
    "947035",
    [
      818897
    ]
  ],
  "./hy/react_scheduler.json": [
    "525332",
    [
      885204
    ]
  ],
  "./hy/account_calendar_settings_confirmation_modal.json": [
    "416931",
    [
      204673
    ]
  ],
  "./mi/assignments_2_file_upload.json": [
    "615178",
    [
      178770
    ]
  ],
  "./es-ES/permissions_role_tray_table_row.json": [
    "785629",
    [
      356139
    ]
  ],
  "./fa/permissions_role_tray.json": [
    "356005",
    [
      420051
    ]
  ],
  "./hy/user_date_range_search.json": [
    "958728",
    [
      985808
    ]
  ],
  "./pt-BR/theme_collection_view.json": [
    "140797",
    [
      169004
    ]
  ],
  "./is/AccountsTray.json": [
    "966062",
    [
      917286
    ]
  ],
  "./fa/discussion_insights.json": [
    "209719",
    [
      481533
    ]
  ],
  "./it/course_statistics.json": [
    "528262",
    [
      244538
    ]
  ],
  "./id/assignments_2_url_entry.json": [
    "228609",
    [
      585739
    ]
  ],
  "./en-GB-x-lbs/AssignmentGroupListItemView.json": [
    "966854",
    [
      728526
    ]
  ],
  "./es-ES/ai_experiences_ai_conversations.json": [
    "244963",
    [
      531969
    ]
  ],
  "./zh-Hans/ImportConfirmBox.json": [
    "92027",
    [
      838713
    ]
  ],
  "./es/gradebookActionMenu.json": [
    "186361",
    [
      866984
    ]
  ],
  "./nb-x-k12/notebook.json": [
    "79193",
    [
      117679
    ]
  ],
  "./uk/calculator_command.json": [
    "147492",
    [
      402636
    ]
  ],
  "./cy/ImportConfirmBox.json": [
    "728194",
    [
      334042
    ]
  ],
  "./zh-Hans/calendar_custom_recurring_event_repeat_picker.json": [
    "500851",
    [
      525729
    ]
  ],
  "./nb-x-k12/content_share_preview_overlay.json": [
    "888669",
    [
      715787
    ]
  ],
  "./ga/learning_mastery_gradebook.json": [
    "133531",
    [
      437481
    ]
  ],
  "./th/conferences_alternatives.json": [
    "35554",
    [
      803150
    ]
  ],
  "./sv-x-k12/login.json": [
    "60764",
    [
      51004
    ]
  ],
  "./pt/assignments_2_file_upload.json": [
    "190776",
    [
      881964
    ]
  ],
  "./pl/course_paces_header.json": [
    "460508",
    [
      407264
    ]
  ],
  "./is/context_roster_user_services.json": [
    "291698",
    [
      195682
    ]
  ],
  "./ms/CreateEditAssignmentModalAdapter.json": [
    "377087",
    [
      840893
    ]
  ],
  "./uk/quizzes_public.json": [
    "567669",
    [
      710891
    ]
  ],
  "./cy/content_copy_redesign.json": [
    "113241",
    [
      136839
    ]
  ],
  "./ht/appt_calendar_event_dialog.json": [
    "590766",
    [
      914082
    ]
  ],
  "./uk/pseudonyms_mobile_login.json": [
    "906710",
    [
      686342
    ]
  ],
  "./ru/assignments_peer_reviews.json": [
    "585156",
    [
      187060
    ]
  ],
  "./he/files_v2.json": [
    "866059",
    [
      163377
    ]
  ],
  "./fr-CA/custom_emoji_deny_list.json": [
    "957291",
    [
      123109
    ]
  ],
  "./cy/blueprint_coursesExpandableLockOptions.json": [
    "328851",
    [
      360617
    ]
  ],
  "./cy/assignments_2_student_header.json": [
    "83747",
    [
      96601
    ]
  ],
  "./nb-x-k12/outcome_alignment_v2.json": [
    "264207",
    [
      942917
    ]
  ],
  "./pt/account_course_user_search.json": [
    "79556",
    [
      852864
    ]
  ],
  "./sv-x-k12/admin_split.json": [
    "646957",
    [
      941211
    ]
  ],
  "./el/course_restore.json": [
    "499889",
    [
      510539
    ]
  ],
  "./cy/epub_exports.json": [
    "578388",
    [
      48268
    ]
  ],
  "./fi/react_scheduler.json": [
    "428762",
    [
      454746
    ]
  ],
  "./fr-CA/assignments_bulk_edit.json": [
    "952539",
    [
      522397
    ]
  ],
  "./is/webzip_export.json": [
    "624346",
    [
      430842
    ]
  ],
  "./ht/quantitative_data_options.json": [
    "963955",
    [
      132549
    ]
  ],
  "./mi/gradebookActionMenu.json": [
    "488267",
    [
      616625
    ]
  ],
  "./zh-Hant/epub_exports.json": [
    "738438",
    [
      246194
    ]
  ],
  "./id/quantitative_data_options.json": [
    "487082",
    [
      320230
    ]
  ],
  "./ms/eportfolio.json": [
    "836035",
    [
      277305
    ]
  ],
  "./vi/dashboard_grading_period_select.json": [
    "340561",
    [
      309591
    ]
  ],
  "./fr/discussionTopicKeyboradShortcutModal.json": [
    "195137",
    [
      410420
    ]
  ],
  "./hu/blueprint_settingsMigrationOptions.json": [
    "232216",
    [
      809224
    ]
  ],
  "./en-GB/widget_dashboard.json": [
    "757030",
    [
      528443
    ]
  ],
  "./ko/permissions_role_tray_table_row.json": [
    "996266",
    [
      35458
    ]
  ],
  "./fr-CA/assignment_2_assignment_toggle_details.json": [
    "903029",
    [
      108423
    ]
  ],
  "./fr-CA/conferences.json": [
    "140316",
    [
      462544
    ]
  ],
  "./ga/assignments_2_text_entry.json": [
    "838162",
    [
      917218
    ]
  ],
  "./uk/assignment_index_menu.json": [
    "597154",
    [
      485578
    ]
  ],
  "./mi/horizon_toggle.json": [
    "367420",
    [
      597732
    ]
  ],
  "./ar/top_navigation_tools.json": [
    "537437",
    [
      956991
    ]
  ],
  "./ko/account_calendar_settings_account_list.json": [
    "517939",
    [
      888089
    ]
  ],
  "./nl/course_paces_app.json": [
    "533106",
    [
      546462
    ]
  ],
  "./th/edit_section_end_date.json": [
    "405805",
    [
      136967
    ]
  ],
  "./nb/peer_review_allocation_rule_card.json": [
    "666732",
    [
      105504
    ]
  ],
  "./pt-BR/important_dates.json": [
    "442995",
    [
      412678
    ]
  ],
  "./sv/outcome_detail.json": [
    "810445",
    [
      922103
    ]
  ],
  "./de/paginated_list.json": [
    "880027",
    [
      245822
    ]
  ],
  "./zh-Hans/choose_mastery_path.json": [
    "758318",
    [
      379222
    ]
  ],
  "./es/SpeedGraderCheckpoints.json": [
    "919185",
    [
      578528
    ]
  ],
  "./hy/account_calendars_results_area.json": [
    "286885",
    [
      513203
    ]
  ],
  "./nl/folder_tree.json": [
    "675181",
    [
      655031
    ]
  ],
  "./ht/keyboardShortcutModal.json": [
    "607082",
    [
      640206
    ]
  ],
  "./nn/course_paces_footer.json": [
    "280870",
    [
      134106
    ]
  ],
  "./nn/user_search_results.json": [
    "332687",
    [
      322369
    ]
  ],
  "./pt/gradebookOutcomeGradebookView.json": [
    "468703",
    [
      732521
    ]
  ],
  "./sv-x-k12/sharedCurveGradesDialog.json": [
    "651249",
    [
      889031
    ]
  ],
  "./zh-Hant/notebook.json": [
    "35841",
    [
      362459
    ]
  ],
  "./sl/quizzes_public.json": [
    "179828",
    [
      575080
    ]
  ],
  "./fr/sections_tooltip.json": [
    "7266",
    [
      98215
    ]
  ],
  "./fr/CourseAvailabilityOptions.json": [
    "58450",
    [
      84663
    ]
  ],
  "./nl/course_stats.json": [
    "964497",
    [
      80259
    ]
  ],
  "./el/discussion_settings.json": [
    "180867",
    [
      894173
    ]
  ],
  "./tr/user_date_range_search.json": [
    "861667",
    [
      370597
    ]
  ],
  "./nb/course_paces_blueprint_lock.json": [
    "478858",
    [
      11862
    ]
  ],
  "./ms/course_paces_flaggable_number_input.json": [
    "256135",
    [
      525301
    ]
  ],
  "./hi/CoursesTray.json": [
    "184719",
    [
      71429
    ]
  ],
  "./ht/ignite_agent.json": [
    "255030",
    [
      687450
    ]
  ],
  "./de/account_calendar_settings_footer.json": [
    "514639",
    [
      352282
    ]
  ],
  "./el/blueprint_settingsCoursePicker.json": [
    "319859",
    [
      846349
    ]
  ],
  "./ja/paginated_list.json": [
    "714361",
    [
      50168
    ]
  ],
  "./pl/terms_of_service_modal.json": [
    "474821",
    [
      945743
    ]
  ],
  "./ar/course_stats.json": [
    "979230",
    [
      272682
    ]
  ],
  "./es/sidenav.json": [
    "679754",
    [
      675011
    ]
  ],
  "./ht/account_calendar_settings_account_group.json": [
    "946568",
    [
      437212
    ]
  ],
  "./da/user_name.json": [
    "307290",
    [
      326578
    ]
  ],
  "./es/user_lists.json": [
    "750787",
    [
      845102
    ]
  ],
  "./ht/terms_index.json": [
    "674074",
    [
      601102
    ]
  ],
  "./es-ES/sections_tooltip.json": [
    "23969",
    [
      560967
    ]
  ],
  "./pl/bulk_edit_students_table.json": [
    "238719",
    [
      834337
    ]
  ],
  "./pt-BR/quizzes_openModerateStudentDialog.json": [
    "923309",
    [
      374892
    ]
  ],
  "./sv/ai_experiences_show.json": [
    "898759",
    [
      432753
    ]
  ],
  "./pt-BR/react_developer_keys.json": [
    "394122",
    [
      240747
    ]
  ],
  "./fr-CA/login.json": [
    "28674",
    [
      410638
    ]
  ],
  "./he/choose_mastery_path.json": [
    "713522",
    [
      826570
    ]
  ],
  "./sv/dashboard_grades_page.json": [
    "132262",
    [
      489466
    ]
  ],
  "./da-x-k12/terms_index.json": [
    "366571",
    [
      835109
    ]
  ],
  "./ru/course_paces_module.json": [
    "579244",
    [
      201516
    ]
  ],
  "./ja/grades_summary.json": [
    "118762",
    [
      335059
    ]
  ],
  "./ko/ProfileTray.json": [
    "379305",
    [
      557959
    ]
  ],
  "./hy/calculator.json": [
    "972983",
    [
      914909
    ]
  ],
  "./is/webcam_modal.json": [
    "843597",
    [
      330091
    ]
  ],
  "./de/rubrics-export.json": [
    "658068",
    [
      323497
    ]
  ],
  "./mi/course_restore.json": [
    "568672",
    [
      257952
    ]
  ],
  "./nn/horizon_toggle.json": [
    "491510",
    [
      777274
    ]
  ],
  "./pt-BR.json": [
    "366848",
    [
      69998
    ]
  ],
  "./en/a2LatePolicyStatusDisplay.json": [
    "104842",
    [
      624670
    ]
  ],
  "./hu/ai_experiences.json": [
    "130599",
    [
      582645
    ]
  ],
  "./it/blueprint_settingsCoursePicker.json": [
    "786311",
    [
      927873
    ]
  ],
  "./it/copy_warnings_modal.json": [
    "833482",
    [
      700102
    ]
  ],
  "./hy/account_settings_jsx_bundle.json": [
    "187005",
    [
      395995
    ]
  ],
  "./fi/CoursesTray.json": [
    "483653",
    [
      782419
    ]
  ],
  "./sl/course_paces_change_tracking.json": [
    "748986",
    [
      746654
    ]
  ],
  "./ca/course_paces_module.json": [
    "260253",
    [
      334755
    ]
  ],
  "./vi/ai_experiences.json": [
    "938689",
    [
      41991
    ]
  ],
  "./da/outcome_reporting.json": [
    "667016",
    [
      112552
    ]
  ],
  "./pl/course_paces_footer.json": [
    "596338",
    [
      855974
    ]
  ],
  "./de/course_paces_blueprint_lock.json": [
    "7749",
    [
      597316
    ]
  ],
  "./da/react_files.json": [
    "890814",
    [
      792382
    ]
  ],
  "./hi/blueprint_coursesExpandableLockOptions.json": [
    "731274",
    [
      203754
    ]
  ],
  "./nb-x-k12/external_content_cancel.json": [
    "285432",
    [
      994192
    ]
  ],
  "./hu/ProfileTray.json": [
    "520444",
    [
      763556
    ]
  ],
  "./ms/user_profile.json": [
    "142707",
    [
      811465
    ]
  ],
  "./hy/assignments_2_login_action_prompt.json": [
    "997010",
    [
      262994
    ]
  ],
  "./nb/blueprint_settingsCourseFilter.json": [
    "387592",
    [
      450868
    ]
  ],
  "./en-AU-x-unimelb/sharedCurveGradesDialog.json": [
    "266794",
    [
      422878
    ]
  ],
  "./it/password_complexity_configuration.json": [
    "317440",
    [
      23452
    ]
  ],
  "./es/content_migrations.json": [
    "896525",
    [
      561684
    ]
  ],
  "./id/a2LatePolicyToolTipContent.json": [
    "422420",
    [
      578432
    ]
  ],
  "./fa/MobileGlobalMenu.json": [
    "785075",
    [
      815665
    ]
  ],
  "./ru/new_nav.json": [
    "153043",
    [
      901777
    ]
  ],
  "./pt/restore_content_pane.json": [
    "369861",
    [
      652247
    ]
  ],
  "./zh-Hans/grade_details.json": [
    "811911",
    [
      377885
    ]
  ],
  "./cy/student_groups.json": [
    "531598",
    [
      995422
    ]
  ],
  "./de/bounced_emails.json": [
    "596839",
    [
      401634
    ]
  ],
  "./is/use_switch_experience.json": [
    "988167",
    [
      222733
    ]
  ],
  "./id/todos_page.json": [
    "358380",
    [
      574576
    ]
  ],
  "./ga/knowledge_check_not_ready.json": [
    "477367",
    [
      54221
    ]
  ],
  "./uk/youtube_migration.json": [
    "743596",
    [
      906148
    ]
  ],
  "./ar/course_paces_pace_picker.json": [
    "95964",
    [
      227832
    ]
  ],
  "./id/ProfileTray.json": [
    "561998",
    [
      123634
    ]
  ],
  "./fr/epub_exports.json": [
    "290012",
    [
      56949
    ]
  ],
  "./fr-CA/modelsQuiz.json": [
    "972798",
    [
      233562
    ]
  ],
  "./nb/account_calendar_settings_filter_controls.json": [
    "97926",
    [
      899514
    ]
  ],
  "./nl/user_restore.json": [
    "173554",
    [
      549510
    ]
  ],
  "./ga/entity_search_form.json": [
    "409517",
    [
      338299
    ]
  ],
  "./hi.eager.json": [
    "946832",
    [
      928803
    ]
  ],
  "./es/modules_home_page.json": [
    "860715",
    [
      431446
    ]
  ],
  "./en-GB-x-lbs/assignments.no_assignments_search.json": [
    "627011",
    [
      462720
    ]
  ],
  "./fi/account_calendar_settings.json": [
    "854021",
    [
      808115
    ]
  ],
  "./da-x-k12/top_navigation_tools.json": [
    "928455",
    [
      273321
    ]
  ],
  "./da-x-k12/course_paces_assignment_row.json": [
    "882170",
    [
      134742
    ]
  ],
  "./sv/account_course_user_search.json": [
    "736727",
    [
      608265
    ]
  ],
  "./nb-x-k12/assignmentsIndexView.json": [
    "828751",
    [
      454533
    ]
  ],
  "./fr/roster_publicjs.json": [
    "299980",
    [
      90458
    ]
  ],
  "./mi/important_dates.json": [
    "48016",
    [
      338448
    ]
  ],
  "./fi/assignments_2_login_action_prompt.json": [
    "901948",
    [
      795260
    ]
  ],
  "./ga/account_calendar_settings_account_calendar_item.json": [
    "659311",
    [
      203941
    ]
  ],
  "./pt/sis_import.json": [
    "129334",
    [
      429075
    ]
  ],
  "./sv-x-k12/calendar_appointment_group_edit.json": [
    "98412",
    [
      724972
    ]
  ],
  "./el/course_stats.json": [
    "66608",
    [
      940140
    ]
  ],
  "./cy/course_paces_modal.json": [
    "62646",
    [
      139158
    ]
  ],
  "./fa/gradebookOutcomeGradebookView.json": [
    "580014",
    [
      999110
    ]
  ],
  "./nb-x-k12/link_validator.json": [
    "592673",
    [
      593495
    ]
  ],
  "./sv/license_help.json": [
    "167790",
    [
      194690
    ]
  ],
  "./fa/discussion_settings.json": [
    "71775",
    [
      97781
    ]
  ],
  "./hy/bulk_edit_students_table.json": [
    "286118",
    [
      436078
    ]
  ],
  "./it/sharedCurveGradesDialog.json": [
    "883167",
    [
      422969
    ]
  ],
  "./ko/SpeedGraderPostGradesMenu.json": [
    "841621",
    [
      270251
    ]
  ],
  "./ar/course_color_selector.json": [
    "600974",
    [
      351850
    ]
  ],
  "./sv/jobs.json": [
    "402165",
    [
      181663
    ]
  ],
  "./is/outcome_management.json": [
    "761388",
    [
      878380
    ]
  ],
  "./fa/media_player_iframe_content.json": [
    "119408",
    [
      376856
    ]
  ],
  "./vi/file_not_found.json": [
    "420270",
    [
      623382
    ]
  ],
  "./sl/calendar_custom_recurring_event_repeat_picker.json": [
    "491459",
    [
      621346
    ]
  ],
  "./ca/EditMasteryScaleLink.json": [
    "18467",
    [
      151273
    ]
  ],
  "./el/ProfileTray.json": [
    "452658",
    [
      167110
    ]
  ],
  "./en-GB-x-ukhe/theme_editor.json": [
    "446343",
    [
      547165
    ]
  ],
  "./ko/student_study_drawer.json": [
    "710867",
    [
      481081
    ]
  ],
  "./en-GB-x-ukhe/a2_AccessibleTipContent.json": [
    "369036",
    [
      756236
    ]
  ],
  "./hu/roster_section_selector.json": [
    "69424",
    [
      156784
    ]
  ],
  "./zh-Hans/license_help.json": [
    "868784",
    [
      300216
    ]
  ],
  "./de/assignments_2_peer_review.json": [
    "730336",
    [
      168077
    ]
  ],
  "./pt/assignmentsToggleShowByView.json": [
    "437410",
    [
      46151
    ]
  ],
  "./ja/entity_search_form.json": [
    "588990",
    [
      109535
    ]
  ],
  "./hy/user_lists.json": [
    "302230",
    [
      344974
    ]
  ],
  "./en-AU-x-unimelb/MoveOutcomesModal.json": [
    "252779",
    [
      689341
    ]
  ],
  "./en-AU-x-unimelb/course_color_selector.json": [
    "683265",
    [
      862819
    ]
  ],
  "./sv/dashboard_grading_period_select.json": [
    "811253",
    [
      336679
    ]
  ],
  "./th/job_stats.json": [
    "517777",
    [
      767395
    ]
  ],
  "./id/course_navigation_settings.json": [
    "195525",
    [
      920927
    ]
  ],
  "./nn/course_paces_blackout_dates_table.json": [
    "195241",
    [
      462275
    ]
  ],
  "./el/content_shares.json": [
    "343755",
    [
      839565
    ]
  ],
  "./nn/peer_review_allocation_rules_tray.json": [
    "552279",
    [
      873105
    ]
  ],
  "./en-CA/Navigation.json": [
    "702752",
    [
      420776
    ]
  ],
  "./pl/job_stats.json": [
    "584425",
    [
      191003
    ]
  ],
  "./vi/course_stats.json": [
    "798412",
    [
      949132
    ]
  ],
  "./ms/course_color_selector.json": [
    "787873",
    [
      621183
    ]
  ],
  "./hu/discussion_topics.json": [
    "79532",
    [
      597300
    ]
  ],
  "./zh-Hant/account_calendars_modal.json": [
    "695609",
    [
      66987
    ]
  ],
  "./en-AU-x-unimelb/k5_dashboard_card.json": [
    "162640",
    [
      811764
    ]
  ],
  "./en-AU/custom_help_link.json": [
    "286468",
    [
      35041
    ]
  ],
  "./sv/calendar_appointment_group_edit.json": [
    "494694",
    [
      920234
    ]
  ],
  "./sv/AccountsTray.json": [
    "126285",
    [
      513143
    ]
  ],
  "./nb/blueprint_settingsAssociationsTable.json": [
    "358165",
    [
      860303
    ]
  ],
  "./it/user_grades.json": [
    "559539",
    [
      69909
    ]
  ],
  "./da-x-k12/assignments.json": [
    "704737",
    [
      901387
    ]
  ],
  "./ar/CourseAvailabilityOptions.json": [
    "741857",
    [
      369019
    ]
  ],
  "./fi/copy_course.json": [
    "926108",
    [
      899148
    ]
  ],
  "./da/progressbar_view.json": [
    "425931",
    [
      421665
    ]
  ],
  "./es-ES/pseudonyms_mobile_login.json": [
    "329411",
    [
      669617
    ]
  ],
  "./sv/account_calendar_settings_account_calendar_item_dropdown.json": [
    "839850",
    [
      7934
    ]
  ],
  "./zh-Hans/youtube_migration.json": [
    "40055",
    [
      931261
    ]
  ],
  "./ga/DueDateOverrideView.json": [
    "382581",
    [
      184083
    ]
  ],
  "./vi/course_paces_actions.json": [
    "544751",
    [
      880325
    ]
  ],
  "./pl/LogoutButton.json": [
    "319696",
    [
      357108
    ]
  ],
  "./sv/EditMasteryScaleLink.json": [
    "31596",
    [
      867904
    ]
  ],
  "./fi/blueprint_settingsMigrationSync.json": [
    "489063",
    [
      918093
    ]
  ],
  "./en-AU/quizzes.take_quiz.json": [
    "666106",
    [
      786307
    ]
  ],
  "./ga/error_form.json": [
    "18911",
    [
      422421
    ]
  ],
  "./ms/gradebook.json": [
    "762208",
    [
      754944
    ]
  ],
  "./es-ES/course_paces_blueprint_lock.json": [
    "807415",
    [
      624189
    ]
  ],
  "./pl/submit_assignment.json": [
    "609290",
    [
      203046
    ]
  ],
  "./hy/edit_section_dates.json": [
    "381605",
    [
      832083
    ]
  ],
  "./da-x-k12/new_nav.json": [
    "581687",
    [
      398961
    ]
  ],
  "./de/course_statistics.json": [
    "362212",
    [
      662089
    ]
  ],
  "./pt/assignment_index_menu.json": [
    "608114",
    [
      165446
    ]
  ],
  "./zh-Hans/terms_of_use.json": [
    "661930",
    [
      351674
    ]
  ],
  "./ar/notebook_index.json": [
    "971353",
    [
      949603
    ]
  ],
  "./es/a2_AccessibleTipContent.json": [
    "812138",
    [
      116323
    ]
  ],
  "./ga/nav_tourpoints.json": [
    "433065",
    [
      867823
    ]
  ],
  "./pt/important_dates_empty.json": [
    "391224",
    [
      300996
    ]
  ],
  "./ko/FindOutcomesModal.json": [
    "239255",
    [
      514293
    ]
  ],
  "./da-x-k12/course_restore.json": [
    "396921",
    [
      227883
    ]
  ],
  "./ko/sharedCurveGradesDialog.json": [
    "698760",
    [
      403240
    ]
  ],
  "./nn/course_paces_blackout_date_row.json": [
    "679842",
    [
      720870
    ]
  ],
  "./ca/assignments_2_student_header_date_title.json": [
    "994237",
    [
      422275
    ]
  ],
  "./pt-BR/MobileNavigation.json": [
    "20149",
    [
      16596
    ]
  ],
  "./ar/peer_review_allocation_rules_tray.json": [
    "637588",
    [
      390976
    ]
  ],
  "./da-x-k12/discussion_settings.json": [
    "108827",
    [
      169469
    ]
  ],
  "./en-GB-x-ukhe/quiz_show.json": [
    "89319",
    [
      478829
    ]
  ],
  "./ko/assignments_peer_reviews_student.json": [
    "754101",
    [
      394187
    ]
  ],
  "./es/calculator_command.json": [
    "532684",
    [
      404409
    ]
  ],
  "./tr/course_paces_projected_dates.json": [
    "502091",
    [
      183621
    ]
  ],
  "./ht/discussion_pinned_post.json": [
    "290972",
    [
      789955
    ]
  ],
  "./es/course_default_due_time.json": [
    "591424",
    [
      755477
    ]
  ],
  "./ja/ai_experiences_ai_conversations.json": [
    "752215",
    [
      287450
    ]
  ],
  "./nb/AssignmentGroupListItemView.json": [
    "643612",
    [
      157072
    ]
  ],
  "./th/upload_button.json": [
    "66548",
    [
      611792
    ]
  ],
  "./da/plugins.json": [
    "55973",
    [
      348027
    ]
  ],
  "./hy/ImportConfirmBox.json": [
    "724032",
    [
      917601
    ]
  ],
  "./es-ES/password_complexity_configuration.json": [
    "480528",
    [
      278904
    ]
  ],
  "./en-GB-x-lbs/custom_help_link.json": [
    "63968",
    [
      721496
    ]
  ],
  "./fr/course_template_details.json": [
    "926055",
    [
      8182
    ]
  ],
  "./ko/content_share_preview_overlay.json": [
    "452673",
    [
      140335
    ]
  ],
  "./es/mutationActivity.json": [
    "395880",
    [
      869021
    ]
  ],
  "./es-ES/lti_registrations.json": [
    "559841",
    [
      180135
    ]
  ],
  "./cy/external_content_cancel.json": [
    "349650",
    [
      246986
    ]
  ],
  "./th/calendar.header.json": [
    "2116",
    [
      672130
    ]
  ],
  "./tr/users.json": [
    "799404",
    [
      58456
    ]
  ],
  "./fr/canvas_file_upload.json": [
    "841747",
    [
      283154
    ]
  ],
  "./tr/course_paces_errors.json": [
    "801908",
    [
      888880
    ]
  ],
  "./id/edit_section_view.json": [
    "515847",
    [
      474961
    ]
  ],
  "./ga/account_calendar_settings_account_group.json": [
    "454164",
    [
      927204
    ]
  ],
  "./it/restore_content_pane.json": [
    "639062",
    [
      491946
    ]
  ],
  "./nl/content_shares.json": [
    "964086",
    [
      89546
    ]
  ],
  "./cy/assignments.never_drop.json": [
    "940388",
    [
      271943
    ]
  ],
  "./ko/lti_registration.wizard.json": [
    "37890",
    [
      360789
    ]
  ],
  "./ht/new_nav.json": [
    "425954",
    [
      533710
    ]
  ],
  "./uk/self_unenrollment_modal.json": [
    "143068",
    [
      404180
    ]
  ],
  "./fr-CA/external_content_cancel.json": [
    "538215",
    [
      544185
    ]
  ],
  "./zh-Hans/assignment_index_menu.json": [
    "174793",
    [
      409951
    ]
  ],
  "./hu/todos_page.json": [
    "89898",
    [
      756690
    ]
  ],
  "./da-x-k12/account_calendars_modal.json": [
    "739878",
    [
      26930
    ]
  ],
  "./mi/remove_pace_warning_modal.json": [
    "659607",
    [
      336165
    ]
  ],
  "./en-GB/appointment_groups.json": [
    "377027",
    [
      966130
    ]
  ],
  "./ar/remove_pace_warning_modal.json": [
    "306538",
    [
      370878
    ]
  ],
  "./hu/course_paces_time_selection.json": [
    "333762",
    [
      249562
    ]
  ],
  "./pt/assignments_2_MoreOptions_CanvasFiles.json": [
    "304211",
    [
      117250
    ]
  ],
  "./hu/submit_online_url_assignment.json": [
    "136383",
    [
      32349
    ]
  ],
  "./it/appt_calendar_event_dialog.json": [
    "298061",
    [
      56575
    ]
  ],
  "./sv-x-k12/progressbar_view.json": [
    "129495",
    [
      852893
    ]
  ],
  "./zh-Hant/edit_section_start_date.json": [
    "745824",
    [
      829372
    ]
  ],
  "./cy/gradingPeriodTemplate.json": [
    "922689",
    [
      948543
    ]
  ],
  "./ja/account_calendars_results_area.json": [
    "173935",
    [
      852274
    ]
  ],
  "./ko/enhanced_individual_gradebook_submit_score.json": [
    "406731",
    [
      903393
    ]
  ],
  "./da-x-k12/calendar_appointment_group_edit.json": [
    "227838",
    [
      84954
    ]
  ],
  "./fi/assignment_show.json": [
    "337524",
    [
      12964
    ]
  ],
  "./mi/course_paces_actions.json": [
    "979022",
    [
      746814
    ]
  ],
  "./cy/gradebookOutcomeGradebookView.json": [
    "567159",
    [
      140645
    ]
  ],
  "./ca/quizzes_regrade_modal.json": [
    "209258",
    [
      984610
    ]
  ],
  "./ca/blueprint_settingsMigrationOptions.json": [
    "44561",
    [
      549983
    ]
  ],
  "./pl/blueprint_settingsUnsyncedChanges.json": [
    "433931",
    [
      363325
    ]
  ],
  "./ja/media_player_iframe_content.json": [
    "23052",
    [
      682825
    ]
  ],
  "./it/job_stats.json": [
    "243128",
    [
      214404
    ]
  ],
  "./cy/authentication_providers.json": [
    "931091",
    [
      262761
    ]
  ],
  "./nb-x-k12/blueprint_course_sidebar.json": [
    "698990",
    [
      526118
    ]
  ],
  "./nb/ai_experiences_edit.json": [
    "281495",
    [
      171113
    ]
  ],
  "./el/peer-review-assignment-widget.json": [
    "911009",
    [
      788899
    ]
  ],
  "./pt-BR/license_help.json": [
    "658498",
    [
      28963
    ]
  ],
  "./id/group_submission_reminder.json": [
    "67352",
    [
      761620
    ]
  ],
  "./ko/roster_section_selector.json": [
    "702653",
    [
      264227
    ]
  ],
  "./sl/assignments_peer_reviews.json": [
    "914830",
    [
      456754
    ]
  ],
  "./cy/theme_collection_view.json": [
    "79696",
    [
      633424
    ]
  ],
  "./en-GB-x-ukhe/course_search_results.json": [
    "997563",
    [
      733689
    ]
  ],
  "./zh-Hant/eportfolio.json": [
    "969045",
    [
      161247
    ]
  ],
  "./fa/account_calendar_settings_confirmation_modal.json": [
    "108473",
    [
      968319
    ]
  ],
  "./ht/user.json": [
    "182913",
    [
      252075
    ]
  ],
  "./nn/rubrics-export.json": [
    "227877",
    [
      240583
    ]
  ],
  "./th/assignments_2_student_header.json": [
    "538539",
    [
      358413
    ]
  ],
  "./ko/course_template_details.json": [
    "881625",
    [
      574711
    ]
  ],
  "./en-CA/student_groups.json": [
    "873958",
    [
      655393
    ]
  ],
  "./zh-Hans/peer_reviews_student.json": [
    "861857",
    [
      314439
    ]
  ],
  "./en-AU-x-unimelb/quizzes_index.json": [
    "15828",
    [
      154888
    ]
  ],
  "./pt-BR/account_calendar_settings_footer.json": [
    "778657",
    [
      720680
    ]
  ],
  "./vi/quizzes_index.json": [
    "239553",
    [
      422551
    ]
  ],
  "./it/LogoutButton.json": [
    "854243",
    [
      799925
    ]
  ],
  "./th/content_migrations.json": [
    "247301",
    [
      847399
    ]
  ],
  "./en-GB-x-lbs/k5_dashboard.json": [
    "107983",
    [
      844229
    ]
  ],
  "./en-GB/assignments_bulk_edit.json": [
    "536027",
    [
      231362
    ]
  ],
  "./uk/permissions.json": [
    "456918",
    [
      925958
    ]
  ],
  "./ja/course_paces_no_results.json": [
    "41346",
    [
      84651
    ]
  ],
  "./es/CommentLibrary.json": [
    "586110",
    [
      576335
    ]
  ],
  "./fr-CA/choose_mastery_path.json": [
    "85344",
    [
      635708
    ]
  ],
  "./de/context_roster_user_services.json": [
    "154843",
    [
      366126
    ]
  ],
  "./he/unpublished_changes_button_props.json": [
    "131844",
    [
      300732
    ]
  ],
  "./sl/sis_import.json": [
    "734720",
    [
      42484
    ]
  ],
  "./de/security_panel.json": [
    "98568",
    [
      584789
    ]
  ],
  "./it/announcements_on_home_page.json": [
    "829181",
    [
      442215
    ]
  ],
  "./pt/knowledge_check_not_ready.json": [
    "653867",
    [
      545293
    ]
  ],
  "./fr/gradebook_history.json": [
    "998823",
    [
      750622
    ]
  ],
  "./en-AU/bulk_edit_students_table.json": [
    "748697",
    [
      604792
    ]
  ],
  "./mi/blueprint_settingsUnsyncedChanges.json": [
    "201189",
    [
      315979
    ]
  ],
  "./ja/permissions_role_tray.json": [
    "346601",
    [
      988968
    ]
  ],
  "./pt/gradebook_default_gradebook_components_content_filters_module_filter.json": [
    "748878",
    [
      803194
    ]
  ],
  "./pt/pseudonyms_mobile_login.json": [
    "236966",
    [
      711402
    ]
  ],
  "./tr/account_calendar_settings_account_calendar_item.json": [
    "424465",
    [
      785147
    ]
  ],
  "./zh-Hant/course_paces_projected_dates.json": [
    "641707",
    [
      41749
    ]
  ],
  "./en-GB-x-ukhe/course_navigation_settings.json": [
    "260844",
    [
      782988
    ]
  ],
  "./en-GB-x-lbs/student_groups.json": [
    "288276",
    [
      390516
    ]
  ],
  "./ms/course_default_due_time.json": [
    "846392",
    [
      807080
    ]
  ],
  "./fr-CA/account_calendar_settings_filter_controls.json": [
    "331375",
    [
      813697
    ]
  ],
  "./ms/bulk_edit_students_table.json": [
    "735908",
    [
      306277
    ]
  ],
  "./fr/account_calendar_settings_utils.json": [
    "779042",
    [
      476407
    ]
  ],
  "./es-ES/confirmMasteryModal.json": [
    "482377",
    [
      702143
    ]
  ],
  "./ht/context_prior_users.json": [
    "822081",
    [
      972163
    ]
  ],
  "./he/terms_of_use.json": [
    "646678",
    [
      376982
    ]
  ],
  "./pt-BR/outcome_reporting.json": [
    "796398",
    [
      950919
    ]
  ],
  "./nb-x-k12/assignments_2_initial_query.json": [
    "750103",
    [
      295402
    ]
  ],
  "./nb/assignments_2_student_header.json": [
    "257123",
    [
      527173
    ]
  ],
  "./ht/course_default_due_time.json": [
    "550512",
    [
      996676
    ]
  ],
  "./es/course_paces_search.json": [
    "3001",
    [
      465000
    ]
  ],
  "./pt/SpeedGraderCheckpoints.json": [
    "88713",
    [
      13619
    ]
  ],
  "./ja/content_shares.json": [
    "442075",
    [
      915030
    ]
  ],
  "./nb/terms_of_service_modal.json": [
    "874037",
    [
      988543
    ]
  ],
  "./ja/assignments_2_url_entry.json": [
    "253117",
    [
      121940
    ]
  ],
  "./en-GB-x-lbs/webzip_export.json": [
    "856148",
    [
      209796
    ]
  ],
  "./fa/grade_summary.json": [
    "9735",
    [
      123069
    ]
  ],
  "./is/question_banks.json": [
    "736650",
    [
      301930
    ]
  ],
  "./nl/submit_assignment.json": [
    "93592",
    [
      985332
    ]
  ],
  "./pl/account_calendar_settings_filter_controls.json": [
    "348438",
    [
      998858
    ]
  ],
  "./ga/course_paces_time_selection.json": [
    "334421",
    [
      542435
    ]
  ],
  "./hy/course_stats.json": [
    "139998",
    [
      699030
    ]
  ],
  "./da-x-k12/appointment_groups.json": [
    "174635",
    [
      758957
    ]
  ],
  "./uk/ImportConfirmBox.json": [
    "167482",
    [
      135602
    ]
  ],
  "./ms/course_paces_change_tracking.json": [
    "657871",
    [
      375853
    ]
  ],
  "./ar/quizzes_openModerateStudentDialog.json": [
    "101367",
    [
      302713
    ]
  ],
  "./ms/grade_summaryGroupView.json": [
    "252688",
    [
      709648
    ]
  ],
  "./zh-Hans/assignment_index.json": [
    "413909",
    [
      452707
    ]
  ],
  "./th/lti_registration.wizard.json": [
    "350192",
    [
      95803
    ]
  ],
  "./mi/gradinggradingPeriodCollection.json": [
    "440477",
    [
      935475
    ]
  ],
  "./sv/default_account_quotas.json": [
    "24062",
    [
      935813
    ]
  ],
  "./zh-Hant/peer_reviews_student.json": [
    "642350",
    [
      6682
    ]
  ],
  "./da-x-k12/context_roster_user_services.json": [
    "943613",
    [
      352407
    ]
  ],
  "./ht/calculator.json": [
    "170470",
    [
      270714
    ]
  ],
  "./en-GB/blueprint_settingsCoursePickerTable.json": [
    "660817",
    [
      785380
    ]
  ],
  "./pt/context_prior_users.json": [
    "19033",
    [
      666507
    ]
  ],
  "./fa/account_notification_settings.json": [
    "94086",
    [
      157566
    ]
  ],
  "./ru/outcome_reporting.json": [
    "927998",
    [
      89174
    ]
  ],
  "./ru/course_paces_pace_picker.json": [
    "955978",
    [
      397690
    ]
  ],
  "./fi/k5_dashboard_card.json": [
    "975073",
    [
      753015
    ]
  ],
  "./fr-CA/discussion_pinned_post.json": [
    "201167",
    [
      250489
    ]
  ],
  "./ja/lti_registrations.json": [
    "577381",
    [
      604060
    ]
  ],
  "./tr/sis_import.json": [
    "15235",
    [
      132101
    ]
  ],
  "./pl/peer_review_student_select.json": [
    "192300",
    [
      389896
    ]
  ],
  "./ja/change_password.json": [
    "696599",
    [
      77722
    ]
  ],
  "./hi/assignments_2_student_content_rubric_self_assessment.json": [
    "39698",
    [
      516594
    ]
  ],
  "./sv-x-k12/peer-review-assignment-widget.json": [
    "169227",
    [
      54393
    ]
  ],
  "./fr/discovery_page.json": [
    "902870",
    [
      576667
    ]
  ],
  "./ja/upload_button.json": [
    "729317",
    [
      124316
    ]
  ],
  "./th/CreateEditAssignmentModal.json": [
    "245152",
    [
      276260
    ]
  ],
  "./fi/auth_logging.json": [
    "434973",
    [
      654763
    ]
  ],
  "./es/assignment_show.json": [
    "528541",
    [
      646724
    ]
  ],
  "./da-x-k12/password_complexity_configuration.json": [
    "881860",
    [
      965864
    ]
  ],
  "./el/react_collaborations.json": [
    "962375",
    [
      427873
    ]
  ],
  "./en-GB/ai_experiences_ai_conversations.json": [
    "338023",
    [
      453702
    ]
  ],
  "./id/accessibility_checker.json": [
    "703159",
    [
      724577
    ]
  ],
  "./mi/syllabus_revisions.json": [
    "318958",
    [
      715102
    ]
  ],
  "./tr/CourseAvailabilityOptions.json": [
    "570740",
    [
      254760
    ]
  ],
  "./zh-Hans/blueprint_settingsMigrationSync.json": [
    "452989",
    [
      598715
    ]
  ],
  "./fr-CA/ai_experiences_ai_conversations.json": [
    "637415",
    [
      704209
    ]
  ],
  "./fa/grade_summaryGroupView.json": [
    "543655",
    [
      926477
    ]
  ],
  "./fr/account_calendar_settings_account_calendar_item.json": [
    "604563",
    [
      288522
    ]
  ],
  "./fa/calculator_command.json": [
    "927911",
    [
      115725
    ]
  ],
  "./nl/assignmentsIndexView.json": [
    "180347",
    [
      591061
    ]
  ],
  "./sv/a2_AccessibleTipContent.json": [
    "704687",
    [
      984361
    ]
  ],
  "./ja/bulk_edit_students_actions.json": [
    "765591",
    [
      852186
    ]
  ],
  "./nb/accessibility_scan.json": [
    "352314",
    [
      20582
    ]
  ],
  "./fi/quizzes.take_quiz.json": [
    "946653",
    [
      682650
    ]
  ],
  "./en-GB-x-ukhe/ImportConfirmBox.json": [
    "122912",
    [
      766280
    ]
  ],
  "./hi/password_complexity_configuration.json": [
    "876934",
    [
      43310
    ]
  ],
  "./en-CA/course_paces_change_tracking.json": [
    "268335",
    [
      444757
    ]
  ],
  "./nb-x-k12/discussion_settings.json": [
    "554356",
    [
      733412
    ]
  ],
  "./en-GB/account_settings_jsx_bundle.json": [
    "956923",
    [
      11666
    ]
  ],
  "./fa/widget_dashboard.json": [
    "901138",
    [
      920322
    ]
  ],
  "./id/bounced_emails.json": [
    "874593",
    [
      770027
    ]
  ],
  "./ja/MoveOutcomesModal.json": [
    "643738",
    [
      748931
    ]
  ],
  "./nl/modelsQuiz.json": [
    "141879",
    [
      436569
    ]
  ],
  "./ru/last_attended.json": [
    "620023",
    [
      626925
    ]
  ],
  "./th/conversations_2.json": [
    "186891",
    [
      445445
    ]
  ],
  "./vi/context_prior_users.json": [
    "816572",
    [
      694447
    ]
  ],
  "./en-AU/OutcomeMoveModal.json": [
    "714570",
    [
      471443
    ]
  ],
  "./vi/speed_grader_helpers.json": [
    "724328",
    [
      328496
    ]
  ],
  "./ga/conferences.json": [
    "954661",
    [
      718883
    ]
  ],
  "./en-GB-x-ukhe/epub_exports.json": [
    "386706",
    [
      623890
    ]
  ],
  "./da/grade_summary.json": [
    "317873",
    [
      88799
    ]
  ],
  "./ru/file_not_found.json": [
    "97374",
    [
      628918
    ]
  ],
  "./es/conversations_2.json": [
    "129875",
    [
      90526
    ]
  ],
  "./th/react_collaborations.json": [
    "70960",
    [
      441468
    ]
  ],
  "./de/modules_home_page.json": [
    "451032",
    [
      358885
    ]
  ],
  "./fr-CA/discussion_topics.json": [
    "693370",
    [
      450606
    ]
  ],
  "./id/dashboard_grades_page.json": [
    "616826",
    [
      865246
    ]
  ],
  "./nb/gradinggradingPeriodCollection.json": [
    "759275",
    [
      203437
    ]
  ],
  "./mi/SpeedGraderPostGradesMenu.json": [
    "207825",
    [
      193007
    ]
  ],
  "./sv-x-k12/grades_empty_page.json": [
    "157161",
    [
      411919
    ]
  ],
  "./he/permissions_role_tray.json": [
    "851807",
    [
      344541
    ]
  ],
  "./ar/LearningMasteryGradebook.json": [
    "292871",
    [
      284256
    ]
  ],
  "./pl/k5_dashboard.json": [
    "689573",
    [
      978479
    ]
  ],
  "./pt-BR/course_paces_pace_picker.json": [
    "407642",
    [
      224091
    ]
  ],
  "./ar.eager.json": [
    "140640",
    [
      824983
    ]
  ],
  "./en-GB-x-lbs/calculator_command.json": [
    "954662",
    [
      117118
    ]
  ],
  "./hu/content_copy_redesign.json": [
    "206674",
    [
      755210
    ]
  ],
  "./zh-Hans/accessibility_checker.json": [
    "284785",
    [
      812135
    ]
  ],
  "./fi/context_modules_v2.json": [
    "406303",
    [
      712725
    ]
  ],
  "./sv/conferences.json": [
    "484812",
    [
      720832
    ]
  ],
  "./mi/grade_details.json": [
    "868278",
    [
      620406
    ]
  ],
  "./th/calendar_custom_recurring_event_natural_language.json": [
    "479014",
    [
      600466
    ]
  ],
  "./pt-BR/user_profile.json": [
    "723288",
    [
      144725
    ]
  ],
  "./zh-Hans/custom_emoji_deny_list.json": [
    "963157",
    [
      33555
    ]
  ],
  "./ga/comm_messages.json": [
    "901931",
    [
      103977
    ]
  ],
  "./de/course_default_due_time.json": [
    "876983",
    [
      842162
    ]
  ],
  "./sl/ldap_cert_upload.json": [
    "54055",
    [
      524265
    ]
  ],
  "./sl/AddGroup.json": [
    "217345",
    [
      98123
    ]
  ],
  "./ko/copy_course.json": [
    "280987",
    [
      14513
    ]
  ],
  "./ar/CoursesTray.json": [
    "963615",
    [
      757617
    ]
  ],
  "./el/grade_summaryGroupView.json": [
    "566683",
    [
      361909
    ]
  ],
  "./he/entity_search_form.json": [
    "470960",
    [
      866288
    ]
  ],
  "./hy/content_exports.json": [
    "705248",
    [
      568632
    ]
  ],
  "./is/blueprint_settingsSyncChange.json": [
    "413760",
    [
      52344
    ]
  ],
  "./ht/edit_section_end_date.json": [
    "720549",
    [
      378335
    ]
  ],
  "./cy/course_paces_header.json": [
    "90188",
    [
      986292
    ]
  ],
  "./ko/account_course_user_search.json": [
    "572286",
    [
      25790
    ]
  ],
  "./tr/conversations_2.json": [
    "823969",
    [
      98387
    ]
  ],
  "./da-x-k12/important_dates.json": [
    "211279",
    [
      918849
    ]
  ],
  "./nb/knowledge_check_not_ready.json": [
    "478563",
    [
      257237
    ]
  ],
  "./ht/peer_review_student_select.json": [
    "552348",
    [
      542168
    ]
  ],
  "./ht/blueprint_settingsSyncChange.json": [
    "772876",
    [
      393352
    ]
  ],
  "./ms/submit_assignment.json": [
    "986114",
    [
      917242
    ]
  ],
  "./ko/todos_page.json": [
    "147597",
    [
      49779
    ]
  ],
  "./pt/account_calendar_settings_account_tree.json": [
    "963213",
    [
      444399
    ]
  ],
  "./tr/pairing_code_user_observees.json": [
    "284309",
    [
      776727
    ]
  ],
  "./en-AU/course_paces_empty_state.json": [
    "863646",
    [
      452895
    ]
  ],
  "./ms/bulk_edit_students_actions.json": [
    "138012",
    [
      45284
    ]
  ],
  "./fr-CA/context_modules_v2.json": [
    "726723",
    [
      897861
    ]
  ],
  "./en-AU/files_v2.json": [
    "250020",
    [
      380801
    ]
  ],
  "./de/quiz_log_auditing.json": [
    "710405",
    [
      878740
    ]
  ],
  "./da-x-k12/default_account_quotas.json": [
    "676870",
    [
      236290
    ]
  ],
  "./fr/account_notification_settings.json": [
    "572611",
    [
      223394
    ]
  ],
  "./nn/assignments_2_peer_review.json": [
    "148507",
    [
      853845
    ]
  ],
  "./uk/wiki_page_index.json": [
    "146259",
    [
      391001
    ]
  ],
  "./da/user.json": [
    "315768",
    [
      728344
    ]
  ],
  "./sl/account_course_user_search.json": [
    "207993",
    [
      75091
    ]
  ],
  "./de/quizzes.take_quiz.json": [
    "249891",
    [
      320934
    ]
  ],
  "./id/HelpTray.json": [
    "23090",
    [
      56294
    ]
  ],
  "./ca/modules_page_icon_legend.json": [
    "713695",
    [
      579181
    ]
  ],
  "./es/overview_page.json": [
    "317045",
    [
      552892
    ]
  ],
  "./en-AU/quizzes_public.json": [
    "149851",
    [
      894902
    ]
  ],
  "./en-GB-x-ukhe/context_modules_v2.json": [
    "389466",
    [
      61882
    ]
  ],
  "./en-GB-x-ukhe/media_player_iframe_content.json": [
    "333463",
    [
      346381
    ]
  ],
  "./he/content_copy_redesign.json": [
    "963234",
    [
      859098
    ]
  ],
  "./ms/CoursesTray.json": [
    "724684",
    [
      222740
    ]
  ],
  "./ms/calendar_sidebar.json": [
    "321275",
    [
      236353
    ]
  ],
  "./en-GB/assignments.json": [
    "748089",
    [
      678620
    ]
  ],
  "./hi/course_paces_modal.json": [
    "286291",
    [
      826161
    ]
  ],
  "./mi/account_course_user_search.json": [
    "644386",
    [
      941210
    ]
  ],
  "./mi/outcome_management.json": [
    "904066",
    [
      607962
    ]
  ],
  "./sl/blueprint_settingsCourseFilter.json": [
    "531466",
    [
      394663
    ]
  ],
  "./pt/link_validator.json": [
    "986235",
    [
      100925
    ]
  ],
  "./sl/dashboard_grades_page.json": [
    "632716",
    [
      887440
    ]
  ],
  "./sv-x-k12/course_link_validator.json": [
    "667702",
    [
      529902
    ]
  ],
  "./ht/discussion_settings.json": [
    "839022",
    [
      444242
    ]
  ],
  "./ko/SpeedGraderSettingsMenu.json": [
    "973986",
    [
      748010
    ]
  ],
  "./sv/peer-review-assignment-widget.json": [
    "74449",
    [
      156883
    ]
  ],
  "./tr/course_paces_assignment_row.json": [
    "578325",
    [
      920903
    ]
  ],
  "./he/question_banks.json": [
    "503079",
    [
      354133
    ]
  ],
  "./tr/module_student_view_peer_reviews.json": [
    "257615",
    [
      863041
    ]
  ],
  "./zh-Hans/account_calendar_settings.json": [
    "391843",
    [
      207377
    ]
  ],
  "./en-GB/discussion_row.json": [
    "302606",
    [
      447955
    ]
  ],
  "./pt-BR/terms_of_use.json": [
    "227392",
    [
      335165
    ]
  ],
  "./da/course_paces_footer.json": [
    "675765",
    [
      205707
    ]
  ],
  "./fr-CA/AccountsTray.json": [
    "807421",
    [
      654247
    ]
  ],
  "./da/quantitative_data_options.json": [
    "287512",
    [
      628472
    ]
  ],
  "./pt-BR/blueprint_settingsAssociationsTable.json": [
    "829096",
    [
      643957
    ]
  ],
  "./mi/assignments_2_submission_histories_query.json": [
    "95488",
    [
      249376
    ]
  ],
  "./tr/submit_assignment.json": [
    "52300",
    [
      582056
    ]
  ],
  "./zh-Hans/accessibility_scan.json": [
    "347279",
    [
      218437
    ]
  ],
  "./fr-CA/assignments_2_peer_review.json": [
    "613314",
    [
      553286
    ]
  ],
  "./hy/course_statistics.json": [
    "306492",
    [
      962588
    ]
  ],
  "./ru/moderate_quiz.json": [
    "41668",
    [
      878372
    ]
  ],
  "./da-x-k12/DueDateOverrideView.json": [
    "449248",
    [
      273372
    ]
  ],
  "./nn/permissions.json": [
    "673546",
    [
      782110
    ]
  ],
  "./pt-BR/sis_import.json": [
    "375134",
    [
      491751
    ]
  ],
  "./pl/progress_pill.json": [
    "473389",
    [
      674663
    ]
  ],
  "./uk/webcam_modal.json": [
    "202217",
    [
      844263
    ]
  ],
  "./ga/permissions.json": [
    "663114",
    [
      807178
    ]
  ],
  "./is/modules_page_icon_legend.json": [
    "692171",
    [
      354585
    ]
  ],
  "./nb/edit_section_dates.json": [
    "87436",
    [
      92192
    ]
  ],
  "./zh-Hant/quizzes.take_quiz.json": [
    "592514",
    [
      875815
    ]
  ],
  "./pl/LearningMasteryGradebook.json": [
    "797769",
    [
      566955
    ]
  ],
  "./zh-Hant/assignments_2_student_annotation.json": [
    "116781",
    [
      255567
    ]
  ],
  "./ca/user_date_range_search.json": [
    "604081",
    [
      14847
    ]
  ],
  "./he/assignments_2_shared_Steps.json": [
    "227066",
    [
      965410
    ]
  ],
  "./da/unpublished_changes_tray_contents.json": [
    "771352",
    [
      656312
    ]
  ],
  "./ja/last_attended.json": [
    "372595",
    [
      541326
    ]
  ],
  "./en-GB-x-ukhe/outcomes_user_outcome_results.json": [
    "727651",
    [
      784353
    ]
  ],
  "./ja/question_bank.json": [
    "297268",
    [
      228977
    ]
  ],
  "./nl/a2LatePolicyStatusDisplay.json": [
    "554699",
    [
      466189
    ]
  ],
  "./uk/license_help.json": [
    "102029",
    [
      287635
    ]
  ],
  "./ga/restore_content_pane.json": [
    "910545",
    [
      372823
    ]
  ],
  "./hi/edit_section_start_date.json": [
    "901925",
    [
      329907
    ]
  ],
  "./nb/ProfileTray.json": [
    "386131",
    [
      719045
    ]
  ],
  "./pt/course_paces_settings.json": [
    "93068",
    [
      713952
    ]
  ],
  "./hu/course_paces_header.json": [
    "539167",
    [
      465405
    ]
  ],
  "./is/quiz_migration_notifications.json": [
    "783167",
    [
      505909
    ]
  ],
  "./uk/speed_grader_helpers.json": [
    "79079",
    [
      897893
    ]
  ],
  "./cy/user_date_range_search.json": [
    "612313",
    [
      980903
    ]
  ],
  "./zh-Hant/external_content_cancel.json": [
    "789472",
    [
      837076
    ]
  ],
  "./ms/editGroup.json": [
    "598437",
    [
      714699
    ]
  ],
  "./de/student_study_drawer.json": [
    "668924",
    [
      49297
    ]
  ],
  "./cy/SpeedGraderSettingsMenu.json": [
    "67064",
    [
      134472
    ]
  ],
  "./fr/entity_search_form.json": [
    "941393",
    [
      611420
    ]
  ],
  "./hi/course_paces_blackout_date_row.json": [
    "419247",
    [
      12101
    ]
  ],
  "./en-GB-x-lbs/comm_messages.json": [
    "598897",
    [
      303175
    ]
  ],
  "./es-ES/course_paces_change_tracking.json": [
    "808744",
    [
      466032
    ]
  ],
  "./ar/gradebook_uploads.json": [
    "655986",
    [
      363310
    ]
  ],
  "./nb-x-k12/course_paces_settings.json": [
    "197134",
    [
      96310
    ]
  ],
  "./fr-CA/assignment_index.json": [
    "524399",
    [
      183129
    ]
  ],
  "./de/moderate_quiz.json": [
    "462030",
    [
      699175
    ]
  ],
  "./fi/calendar_edit.json": [
    "817724",
    [
      292108
    ]
  ],
  "./en-GB/GroupDetailView.json": [
    "471212",
    [
      775965
    ]
  ],
  "./da-x-k12/assignments_bulk_edit.json": [
    "96883",
    [
      391869
    ]
  ],
  "./fr-CA/new_nav.json": [
    "91263",
    [
      144785
    ]
  ],
  "./ms/edit_section_start_date.json": [
    "548778",
    [
      473458
    ]
  ],
  "./nn/job_stats.json": [
    "551957",
    [
      264295
    ]
  ],
  "./pt/question_banks.json": [
    "205710",
    [
      853954
    ]
  ],
  "./sl/MasteryScale.json": [
    "734050",
    [
      281718
    ]
  ],
  "./en/OutcomeMoveModal.json": [
    "824873",
    [
      829515
    ]
  ],
  "./es-ES/account_calendar_settings_account_list.json": [
    "12822",
    [
      980030
    ]
  ],
  "./uk/course_paces_footer.json": [
    "750922",
    [
      705794
    ]
  ],
  "./es-ES/course_paces_blackout_dates_modal.json": [
    "972397",
    [
      931307
    ]
  ],
  "./nb-x-k12/gradebook_history.json": [
    "71425",
    [
      893159
    ]
  ],
  "./sv/webzip_export.json": [
    "318559",
    [
      377665
    ]
  ],
  "./ca/blueprint_settingsSyncHistory.json": [
    "866324",
    [
      193020
    ]
  ],
  "./vi/confirmMasteryModal.json": [
    "925897",
    [
      724303
    ]
  ],
  "./sv-x-k12/course_paces_projected_dates.json": [
    "804848",
    [
      882904
    ]
  ],
  "./zh-Hans/course_logging_details.json": [
    "588721",
    [
      494279
    ]
  ],
  "./pt-BR/assignments_2_student_annotation.json": [
    "54016",
    [
      87133
    ]
  ],
  "./nb/discovery_page.json": [
    "810366",
    [
      983922
    ]
  ],
  "./hu/course_paces_blackout_dates_modal.json": [
    "122963",
    [
      639862
    ]
  ],
  "./nb-x-k12/empty_course.json": [
    "813635",
    [
      864497
    ]
  ],
  "./zh-Hans/LearningMasteryGradebook.json": [
    "485660",
    [
      304956
    ]
  ],
  "./hy/mutationActivity.json": [
    "945285",
    [
      783555
    ]
  ],
  "./pl/files_v2.json": [
    "494242",
    [
      164830
    ]
  ],
  "./ko/files_v2.json": [
    "52056",
    [
      868920
    ]
  ],
  "./cy/SpeedGraderPostGradesMenu.json": [
    "471079",
    [
      894869
    ]
  ],
  "./fa/quiz_statistics.json": [
    "926426",
    [
      904538
    ]
  ],
  "./en-GB-x-lbs/context_modules_v2.json": [
    "849698",
    [
      191186
    ]
  ],
  "./ko/bulk_edit_students.json": [
    "625686",
    [
      227558
    ]
  ],
  "./nb/discussion_topics_edit.json": [
    "412552",
    [
      867564
    ]
  ],
  "./fi/assignments_2_submission_helpers.json": [
    "498839",
    [
      231421
    ]
  ],
  "./en-GB-x-ukhe/modules_page_icon_legend.json": [
    "639597",
    [
      536555
    ]
  ],
  "./en-AU/comm_messages.json": [
    "11677",
    [
      240020
    ]
  ],
  "./mi/unpublished_changes_button_props.json": [
    "513323",
    [
      411377
    ]
  ],
  "./ru/assignments_2_text_entry.json": [
    "46673",
    [
      869303
    ]
  ],
  "./en-GB-x-lbs/user_logins.json": [
    "685914",
    [
      709914
    ]
  ],
  "./vi/content_migrations_redesign.json": [
    "868908",
    [
      577948
    ]
  ],
  "./da/filter_calendars_modal.json": [
    "116779",
    [
      116097
    ]
  ],
  "./fi/confirmMasteryModal.json": [
    "348409",
    [
      483615
    ]
  ],
  "./ga/MobileNavigation.json": [
    "427478",
    [
      682110
    ]
  ],
  "./nl/context_modules_v2.json": [
    "41778",
    [
      695886
    ]
  ],
  "./ar/license_help.json": [
    "224024",
    [
      658380
    ]
  ],
  "./sl/quizzes_regrade_modal.json": [
    "713481",
    [
      841635
    ]
  ],
  "./nb/user.json": [
    "28897",
    [
      984555
    ]
  ],
  "./da/reset_pace_warning_modal.json": [
    "684157",
    [
      904675
    ]
  ],
  "./id/assignments_2_MoreOptions.json": [
    "27114",
    [
      885670
    ]
  ],
  "./sv-x-k12/react_developer_keys.json": [
    "775951",
    [
      900543
    ]
  ],
  "./da/calculator_command.json": [
    "798161",
    [
      30015
    ]
  ],
  "./fi/section.json": [
    "947716",
    [
      293332
    ]
  ],
  "./vi/AddGroup.json": [
    "685151",
    [
      701541
    ]
  ],
  "./hi/ai_experiences_edit.json": [
    "668032",
    [
      249992
    ]
  ],
  "./ht/user_profile.json": [
    "747243",
    [
      552549
    ]
  ],
  "./en-GB-x-ukhe/sections_tooltip.json": [
    "904196",
    [
      845172
    ]
  ],
  "./es-ES/k5_course.json": [
    "485299",
    [
      393201
    ]
  ],
  "./cy/assignments_2_media_attempt.json": [
    "693708",
    [
      810420
    ]
  ],
  "./hu/LearningMasteryGradebook.json": [
    "866520",
    [
      94600
    ]
  ],
  "./nl/external_content_cancel.json": [
    "822044",
    [
      32960
    ]
  ],
  "./sl/assignment_index_menu.json": [
    "851577",
    [
      177531
    ]
  ],
  "./sv-x-k12/peer_review_student_select.json": [
    "537069",
    [
      917739
    ]
  ],
  "./cy/course_paces_flaggable_number_input.json": [
    "793887",
    [
      211869
    ]
  ],
  "./es-ES/course_paces_settings.json": [
    "93677",
    [
      148235
    ]
  ],
  "./ga/account_calendar_settings_utils.json": [
    "238558",
    [
      946118
    ]
  ],
  "./ga/user_date_range_search.json": [
    "453453",
    [
      40395
    ]
  ],
  "./fa/bulk_edit_students.json": [
    "744671",
    [
      138741
    ]
  ],
  "./id/assignments.json": [
    "14285",
    [
      880655
    ]
  ],
  "./fr-CA/quiz_migration_notifications.json": [
    "402704",
    [
      992708
    ]
  ],
  "./en-GB/discussion_posts.json": [
    "763973",
    [
      103488
    ]
  ],
  "./sv/permissions_role_tray_table_row.json": [
    "537425",
    [
      560555
    ]
  ],
  "./en-AU/link_validator.json": [
    "39329",
    [
      35136
    ]
  ],
  "./uk/group_submission_reminder.json": [
    "620977",
    [
      376063
    ]
  ],
  "./pl/assignments.never_drop.json": [
    "151732",
    [
      282147
    ]
  ],
  "./ja/horizon_toggle.json": [
    "813821",
    [
      357460
    ]
  ],
  "./en-GB/todo.json": [
    "698053",
    [
      9288
    ]
  ],
  "./zh-Hant/error_form.json": [
    "671161",
    [
      598787
    ]
  ],
  "./mi/appointment_groups.json": [
    "331350",
    [
      609046
    ]
  ],
  "./mi/new_nav.json": [
    "356688",
    [
      124432
    ]
  ],
  "./tr.eager.json": [
    "68581",
    [
      985452
    ]
  ],
  "./da/editAssignmentGroupWeights.json": [
    "861670",
    [
      931190
    ]
  ],
  "./pt-BR/courses_show.json": [
    "237695",
    [
      756506
    ]
  ],
  "./fi/add_edit_pseudonym.json": [
    "435552",
    [
      78632
    ]
  ],
  "./hy/course_paces_module.json": [
    "781802",
    [
      915082
    ]
  ],
  "./sl/course_paces_footer.json": [
    "551217",
    [
      314291
    ]
  ],
  "./zh-Hans/rootFoldersFinder.json": [
    "432772",
    [
      793428
    ]
  ],
  "./en-GB/horizon_toggle.json": [
    "411053",
    [
      628992
    ]
  ],
  "./ms/assignments_2_submission_helpers.json": [
    "237660",
    [
      358788
    ]
  ],
  "./pl/course_paces_settings.json": [
    "971972",
    [
      296488
    ]
  ],
  "./nb/account_calendar_settings_footer.json": [
    "754702",
    [
      171170
    ]
  ],
  "./pt-BR/dashboard_grades_page.json": [
    "683578",
    [
      544779
    ]
  ],
  "./vi/CreateEditAssignmentModalAdapter.json": [
    "211420",
    [
      78172
    ]
  ],
  "./id/MasteryScale.json": [
    "377031",
    [
      59016
    ]
  ],
  "./hu/blueprint_coursesExpandableLockOptions.json": [
    "649622",
    [
      244342
    ]
  ],
  "./fr-CA/student_annotation_preview.json": [
    "708739",
    [
      228381
    ]
  ],
  "./da/student_entries.json": [
    "449",
    [
      393775
    ]
  ],
  "./fi/submit_assignment.json": [
    "43339",
    [
      450089
    ]
  ],
  "./ga/discussion_topics_edit.json": [
    "86628",
    [
      8004
    ]
  ],
  "./hu/AlignmentSummary.json": [
    "317988",
    [
      234268
    ]
  ],
  "./ko/job_stats.json": [
    "691823",
    [
      443997
    ]
  ],
  "./is/roster_section_selector.json": [
    "954107",
    [
      80361
    ]
  ],
  "./es/react_collaborations.json": [
    "434856",
    [
      899773
    ]
  ],
  "./mi/courses.json": [
    "911794",
    [
      216554
    ]
  ],
  "./nb/NewTabIndicator.json": [
    "656776",
    [
      724044
    ]
  ],
  "./nl/assignments_2_shared_Steps.json": [
    "348445",
    [
      26175
    ]
  ],
  "./ca/Navigation.json": [
    "816704",
    [
      217808
    ]
  ],
  "./fr-CA/gradebook_default_gradebook_components_content_filters_module_filter.json": [
    "436617",
    [
      715171
    ]
  ],
  "./nn/AssignmentGroupListItemView.json": [
    "137824",
    [
      790724
    ]
  ],
  "./uk/copy_course.json": [
    "795113",
    [
      216231
    ]
  ],
  "./nl/filter_calendars_modal.json": [
    "296928",
    [
      904484
    ]
  ],
  "./is/peer_review_student_select.json": [
    "603184",
    [
      304360
    ]
  ],
  "./nl/quantitative_data_options.json": [
    "117425",
    [
      941779
    ]
  ],
  "./en-CA/quizzes.take_quiz.json": [
    "169516",
    [
      702441
    ]
  ],
  "./tr/content_migrations_redesign.json": [
    "289607",
    [
      825593
    ]
  ],
  "./pt-BR/course_pace_date_input.json": [
    "599232",
    [
      524074
    ]
  ],
  "./ar/homeroom_page.json": [
    "680899",
    [
      96773
    ]
  ],
  "./zh-Hans/webcam_modal.json": [
    "951828",
    [
      343844
    ]
  ],
  "./ht/assignments_bulk_edit_use_save_assignment.json": [
    "896082",
    [
      912030
    ]
  ],
  "./nb/quizzes_openModerateStudentDialog.json": [
    "780532",
    [
      977504
    ]
  ],
  "./ar/sections_tooltip.json": [
    "964359",
    [
      787537
    ]
  ],
  "./da-x-k12/terms_of_use.json": [
    "888372",
    [
      713752
    ]
  ],
  "./fr/permission_button.json": [
    "91418",
    [
      359351
    ]
  ],
  "./zh-Hant/user_date_range_search.json": [
    "187139",
    [
      290901
    ]
  ],
  "./fr/permissions_role_tray.json": [
    "962428",
    [
      558765
    ]
  ],
  "./vi/accessibility_course_statistics.json": [
    "472789",
    [
      903811
    ]
  ],
  "./zh-Hans/submit_assignment.json": [
    "879965",
    [
      648667
    ]
  ],
  "./de/discussion_create.json": [
    "720472",
    [
      518837
    ]
  ],
  "./hy/file_not_found.json": [
    "688516",
    [
      426084
    ]
  ],
  "./hy/assignments_2_external_tool.json": [
    "403055",
    [
      664213
    ]
  ],
  "./hy/CoursesTray.json": [
    "457695",
    [
      425813
    ]
  ],
  "./fa/course_paces_search.json": [
    "408480",
    [
      18536
    ]
  ],
  "./ko/peer_review_allocation_rule_card.json": [
    "534202",
    [
      58450
    ]
  ],
  "./zh-Hant/account_calendar_settings_footer.json": [
    "409596",
    [
      522232
    ]
  ],
  "./nl/users.json": [
    "676200",
    [
      494196
    ]
  ],
  "./ga/account_settings_jsx_bundle.json": [
    "212210",
    [
      66722
    ]
  ],
  "./en/discussion_posts.json": [
    "72959",
    [
      822249
    ]
  ],
  "./da-x-k12/student_entries.json": [
    "288319",
    [
      227841
    ]
  ],
  "./nn/assignments_2_shared_Steps.json": [
    "30431",
    [
      440553
    ]
  ],
  "./sv/calculator.json": [
    "575173",
    [
      669919
    ]
  ],
  "./ga/progressbar_view.json": [
    "103722",
    [
      441946
    ]
  ],
  "./ru/calendar_edit.json": [
    "935356",
    [
      128092
    ]
  ],
  "./en-GB/a2LatePolicyStatusDisplay.json": [
    "559756",
    [
      495069
    ]
  ],
  "./en-CA/appointment_groups.json": [
    "847240",
    [
      782848
    ]
  ],
  "./fr/media_immersive_view.json": [
    "61270",
    [
      839051
    ]
  ],
  "./ru/quiz_migration_notifications.json": [
    "116132",
    [
      2884
    ]
  ],
  "./ar/SpeedGraderCheckpoints.json": [
    "164380",
    [
      937360
    ]
  ],
  "./fi/job_stats.json": [
    "759704",
    [
      687008
    ]
  ],
  "./ms/authentication_providers.json": [
    "949387",
    [
      149137
    ]
  ],
  "./he/assignments_2_student_header_date_title.json": [
    "994278",
    [
      500326
    ]
  ],
  "./fr-CA/IndividualStudentMasteryOutcome.json": [
    "257010",
    [
      990598
    ]
  ],
  "./de/comm_messages.json": [
    "424944",
    [
      25357
    ]
  ],
  "./pl/change_password.json": [
    "55742",
    [
      471338
    ]
  ],
  "./hu/edit_section_start_date.json": [
    "336625",
    [
      911407
    ]
  ],
  "./hu/account_calendar_settings_account_tree.json": [
    "766696",
    [
      708216
    ]
  ],
  "./en-GB-x-ukhe/calendar_edit.json": [
    "745567",
    [
      675685
    ]
  ],
  "./de/permission_button.json": [
    "414197",
    [
      771700
    ]
  ],
  "./fr-CA/roster_publicjs.json": [
    "547249",
    [
      220435
    ]
  ],
  "./ms/notebook_index.json": [
    "712024",
    [
      823368
    ]
  ],
  "./zh-Hans/course_paces_blackout_date_row.json": [
    "206983",
    [
      929709
    ]
  ],
  "./fr/empty_course.json": [
    "991529",
    [
      150172
    ]
  ],
  "./sv/modules_page_icon_legend.json": [
    "740164",
    [
      982755
    ]
  ],
  "./id/grades_summary.json": [
    "833278",
    [
      187866
    ]
  ],
  "./zh-Hans/SpeedGraderDiscussionsNavigation.json": [
    "452492",
    [
      644940
    ]
  ],
  "./es-ES/calendar_custom_recurring_event_natural_language.json": [
    "139941",
    [
      742867
    ]
  ],
  "./de/discussionTopicKeyboradShortcutModal.json": [
    "338224",
    [
      200525
    ]
  ],
  "./hu/course_paces_blackout_dates_table.json": [
    "174994",
    [
      913226
    ]
  ],
  "./de/account_calendars_results_area.json": [
    "386909",
    [
      735852
    ]
  ],
  "./sl/todo.json": [
    "108359",
    [
      925193
    ]
  ],
  "./nl/gradebook_uploads.json": [
    "822051",
    [
      134213
    ]
  ],
  "./nn/dashboard_grades_page.json": [
    "841083",
    [
      506141
    ]
  ],
  "./en-GB/assignments_2_student_points_display.json": [
    "883111",
    [
      8862
    ]
  ],
  "./es-ES/link_validator.json": [
    "305920",
    [
      899240
    ]
  ],
  "./ru/discussion_insights.json": [
    "14156",
    [
      967237
    ]
  ],
  "./vi/unpublished_changes_button_props.json": [
    "663514",
    [
      156666
    ]
  ],
  "./fa/comm_messages.json": [
    "639954",
    [
      462754
    ]
  ],
  "./de/SpeedGraderCheckpoints.json": [
    "288388",
    [
      687849
    ]
  ],
  "./sv-x-k12/calculator_command.json": [
    "720557",
    [
      530827
    ]
  ],
  "./da/announcements_v2.json": [
    "281686",
    [
      644646
    ]
  ],
  "./he/blueprint_settingsCoursePicker.json": [
    "383061",
    [
      371003
    ]
  ],
  "./en-GB-x-lbs/course_search_results.json": [
    "512643",
    [
      434161
    ]
  ],
  "./sv-x-k12/modelsQuiz.json": [
    "689276",
    [
      142076
    ]
  ],
  "./zh-Hans/MasteryScale.json": [
    "568018",
    [
      27778
    ]
  ],
  "./ht/canvas_file_upload.json": [
    "854539",
    [
      321989
    ]
  ],
  "./el/eportfolio.json": [
    "546316",
    [
      999832
    ]
  ],
  "./de/question_bank.json": [
    "147222",
    [
      497119
    ]
  ],
  "./pt-BR/confirmMasteryModal.json": [
    "766569",
    [
      27072
    ]
  ],
  "./sl/announcements_on_home_page.json": [
    "692707",
    [
      906781
    ]
  ],
  "./es-ES/account_calendar_settings_confirmation_modal.json": [
    "475281",
    [
      342583
    ]
  ],
  "./nn/blueprint_settingsCoursePicker.json": [
    "134672",
    [
      675260
    ]
  ],
  "./is/empty_modules.json": [
    "909033",
    [
      293215
    ]
  ],
  "./ru/gradebookActionMenu.json": [
    "841748",
    [
      815108
    ]
  ],
  "./zh-Hant/moderate_quiz.json": [
    "648123",
    [
      276501
    ]
  ],
  "./uk/authentication_providers.json": [
    "53835",
    [
      964353
    ]
  ],
  "./zh-Hant/files_v2.json": [
    "690124",
    [
      711736
    ]
  ],
  "./es-ES/quiz_statistics.json": [
    "561810",
    [
      615954
    ]
  ],
  "./es-ES/blueprint_settingsCoursePickerTable.json": [
    "766165",
    [
      171219
    ]
  ],
  "./th/grades_empty_page.json": [
    "821862",
    [
      721290
    ]
  ],
  "./is/assignments_2_submission_helpers.json": [
    "13088",
    [
      621240
    ]
  ],
  "./th/a2LatePolicyToolTipContent.json": [
    "280495",
    [
      301081
    ]
  ],
  "./es/react_developer_keys.json": [
    "148649",
    [
      979448
    ]
  ],
  "./cy/IndividualStudentMasteryOutcome.json": [
    "789931",
    [
      453969
    ]
  ],
  "./zh-Hans/account_calendar_settings_account_list.json": [
    "851908",
    [
      689956
    ]
  ],
  "./de/assignment_index.json": [
    "807605",
    [
      873508
    ]
  ],
  "./en-GB/assignment_grade_summary.json": [
    "510507",
    [
      644546
    ]
  ],
  "./pt/react_developer_keys.json": [
    "99281",
    [
      80939
    ]
  ],
  "./hy/assignments_2_student_header.json": [
    "406106",
    [
      268410
    ]
  ],
  "./da-x-k12/AccountsTray.json": [
    "918981",
    [
      184071
    ]
  ],
  "./he/AssignmentGroupListItemView.json": [
    "176403",
    [
      136777
    ]
  ],
  "./sv/widget_dashboard.json": [
    "719702",
    [
      612026
    ]
  ],
  "./fr/blueprint_settingsUnsyncedChanges.json": [
    "828627",
    [
      928890
    ]
  ],
  "./fr.eager.json": [
    "449507",
    [
      545746
    ]
  ],
  "./fr/account_calendars.json": [
    "283405",
    [
      440368
    ]
  ],
  "./fr/GroupsTray.json": [
    "619490",
    [
      168439
    ]
  ],
  "./es/horizon_toggle.json": [
    "863090",
    [
      425995
    ]
  ],
  "./nb-x-k12/user_profile.json": [
    "614105",
    [
      340575
    ]
  ],
  "./nn/course_paces_pace_picker.json": [
    "884361",
    [
      379123
    ]
  ],
  "./sl/AlignmentSummary.json": [
    "627648",
    [
      586564
    ]
  ],
  "./es/unpublished_warning_modal.json": [
    "325776",
    [
      237349
    ]
  ],
  "./fr-CA/ai_experiences.json": [
    "518597",
    [
      816167
    ]
  ],
  "./nb-x-k12/outcomes_user_outcome_results.json": [
    "141343",
    [
      646917
    ]
  ],
  "./sv-x-k12/CreateEditAssignmentModalAdapter.json": [
    "285190",
    [
      959662
    ]
  ],
  "./es/file_not_found.json": [
    "532177",
    [
      220672
    ]
  ],
  "./hy/lti_registrations.json": [
    "194307",
    [
      469793
    ]
  ],
  "./he/conferences_alternatives.json": [
    "129083",
    [
      920609
    ]
  ],
  "./de/bulk_edit_students_actions.json": [
    "529385",
    [
      641824
    ]
  ],
  "./uk/announcements_v2.json": [
    "825127",
    [
      274661
    ]
  ],
  "./da-x-k12/roster_section_input.json": [
    "339045",
    [
      150879
    ]
  ],
  "./en-AU/react_files.json": [
    "630811",
    [
      959734
    ]
  ],
  "./pt/assignments_2_student_annotation.json": [
    "563915",
    [
      376829
    ]
  ],
  "./is/edit_section_start_date.json": [
    "74622",
    [
      341926
    ]
  ],
  "./de/course_paces_header.json": [
    "247051",
    [
      543502
    ]
  ],
  "./nb-x-k12/accessibility_checker.json": [
    "528720",
    [
      433848
    ]
  ],
  "./en-AU/grade_summary.json": [
    "602276",
    [
      802497
    ]
  ],
  "./fi/roster_section_selector.json": [
    "589082",
    [
      236362
    ]
  ],
  "./ja/react_collaborations.json": [
    "757975",
    [
      221466
    ]
  ],
  "./el/course_statistics.json": [
    "631386",
    [
      994398
    ]
  ],
  "./es-ES/webcam_modal.json": [
    "503394",
    [
      649138
    ]
  ],
  "./it/webcam_modal.json": [
    "737842",
    [
      236542
    ]
  ],
  "./mi/add_edit_pseudonym.json": [
    "765257",
    [
      969559
    ]
  ],
  "./de/course_paces_errors.json": [
    "346153",
    [
      821136
    ]
  ],
  "./en-GB/link_validator.json": [
    "464900",
    [
      564173
    ]
  ],
  "./it/grades_summary.json": [
    "293134",
    [
      629802
    ]
  ],
  "./is/blueprint_settingsCoursePicker.json": [
    "749336",
    [
      253264
    ]
  ],
  "./ca/FindOutcomesModal.json": [
    "535749",
    [
      384891
    ]
  ],
  "./sv-x-k12/assignments_2_shared_Steps.json": [
    "871894",
    [
      494654
    ]
  ],
  "./hu/MoveOutcomesModal.json": [
    "185824",
    [
      399680
    ]
  ],
  "./vi/account_calendar_settings_confirmation_modal.json": [
    "13713",
    [
      178471
    ]
  ],
  "./uk/SpeedGraderSettingsMenu.json": [
    "892336",
    [
      762176
    ]
  ],
  "./en/bulk_edit_students_table.json": [
    "248102",
    [
      45714
    ]
  ],
  "./cy/SpeedGraderDiscussionsNavigation.json": [
    "255465",
    [
      332311
    ]
  ],
  "./cy/assignment_index_deep_linking_handlers.json": [
    "815692",
    [
      795764
    ]
  ],
  "./he/editAssignmentGroupWeights.json": [
    "906246",
    [
      11622
    ]
  ],
  "./is/quiz_log_auditing.json": [
    "568410",
    [
      556410
    ]
  ],
  "./fr/account_calendar_settings_filter_controls.json": [
    "789550",
    [
      217827
    ]
  ],
  "./tr/assignments_2_attempt_tab.json": [
    "520477",
    [
      613775
    ]
  ],
  "./fa/blueprint_settingsCourseFilter.json": [
    "794991",
    [
      585365
    ]
  ],
  "./ga/course_default_due_time.json": [
    "316012",
    [
      476556
    ]
  ],
  "./is/GroupDetailView.json": [
    "766821",
    [
      72659
    ]
  ],
  "./ru/link_to_students.json": [
    "192592",
    [
      179320
    ]
  ],
  "./zh-Hant/quiz_log_auditing.json": [
    "677556",
    [
      62376
    ]
  ],
  "./fi/assignments_2_url_entry.json": [
    "787089",
    [
      737335
    ]
  ],
  "./zh-Hant/webcam_modal.json": [
    "540803",
    [
      48117
    ]
  ],
  "./cy/sharedSetDefaultGradeDialog.json": [
    "732921",
    [
      30663
    ]
  ],
  "./ko/keyboardShortcutModal.json": [
    "351972",
    [
      999212
    ]
  ],
  "./hy/folder_tree.json": [
    "580108",
    [
      38652
    ]
  ],
  "./hy/new_nav.json": [
    "964273",
    [
      554807
    ]
  ],
  "./tr/sharedCurveGradesDialog.json": [
    "91932",
    [
      795960
    ]
  ],
  "./fi/assignments.no_assignments_search.json": [
    "140724",
    [
      226181
    ]
  ],
  "./fa/blueprint_settingsMigrationSync.json": [
    "529887",
    [
      107797
    ]
  ],
  "./ja/admin_split.json": [
    "188507",
    [
      486614
    ]
  ],
  "./ko/assignmentsIndexView.json": [
    "571547",
    [
      992177
    ]
  ],
  "./nb/progression_module_header.json": [
    "868682",
    [
      472326
    ]
  ],
  "./zh-Hans/eportfolio.json": [
    "740402",
    [
      157826
    ]
  ],
  "./en-GB/discussion_settings.json": [
    "645507",
    [
      37602
    ]
  ],
  "./en/quiz_statistics.json": [
    "268996",
    [
      747136
    ]
  ],
  "./es/password_complexity_configuration.json": [
    "661461",
    [
      394012
    ]
  ],
  "./fr-CA/plugins.json": [
    "179319",
    [
      886377
    ]
  ],
  "./cy/course_link_validator.json": [
    "368501",
    [
      749979
    ]
  ],
  "./pl/context_prior_users.json": [
    "615281",
    [
      148371
    ]
  ],
  "./id/choose_mastery_path.json": [
    "331628",
    [
      900168
    ]
  ],
  "./es-ES/assignments_bulk_edit_use_save_assignment.json": [
    "139319",
    [
      624202
    ]
  ],
  "./ko/student_annotation_preview.json": [
    "233402",
    [
      879826
    ]
  ],
  "./ru/content_share_preview_overlay.json": [
    "413570",
    [
      647394
    ]
  ],
  "./de/assignments_2_submission_histories_query.json": [
    "446191",
    [
      574986
    ]
  ],
  "./es-ES/course_paces_app.json": [
    "697407",
    [
      549269
    ]
  ],
  "./nb-x-k12/peer_review_allocation_rule_card.json": [
    "594014",
    [
      901190
    ]
  ],
  "./nn/course_color_selector.json": [
    "132269",
    [
      439415
    ]
  ],
  "./ms/remove_pace_warning_modal.json": [
    "701801",
    [
      930327
    ]
  ],
  "./id/files_v2.json": [
    "543325",
    [
      820495
    ]
  ],
  "./hy/comm_messages.json": [
    "799576",
    [
      979152
    ]
  ],
  "./en-GB-x-lbs/terms_of_service_modal.json": [
    "772991",
    [
      142117
    ]
  ],
  "./zh-Hant/assignments_peer_reviews_student.json": [
    "838841",
    [
      868299
    ]
  ],
  "./en-GB/react_developer_keys.json": [
    "463358",
    [
      610939
    ]
  ],
  "./nb-x-k12/CreateEditAssignmentModalAdapter.json": [
    "82033",
    [
      337767
    ]
  ],
  "./ru/available_pronouns_list.json": [
    "494810",
    [
      46762
    ]
  ],
  "./fr/discussion_topics_edit.json": [
    "512816",
    [
      768489
    ]
  ],
  "./cy/terms_of_service_modal.json": [
    "743861",
    [
      696475
    ]
  ],
  "./da-x-k12/blueprint_settingsMigrationOptions.json": [
    "760690",
    [
      232430
    ]
  ],
  "./fa/courses_show.json": [
    "830887",
    [
      99341
    ]
  ],
  "./pt/custom_emoji_deny_list.json": [
    "240756",
    [
      482992
    ]
  ],
  "./en-AU-x-unimelb/rootFoldersFinder.json": [
    "779907",
    [
      952949
    ]
  ],
  "./cy/lti_registration.wizard.json": [
    "558600",
    [
      666543
    ]
  ],
  "./ga/content_share_preview_overlay.json": [
    "967099",
    [
      326617
    ]
  ],
  "./ht/registration.json": [
    "517867",
    [
      727085
    ]
  ],
  "./vi/assignments_2_student_content_rubric_self_assessment.json": [
    "664452",
    [
      319476
    ]
  ],
  "./hi/context_roster_user_services.json": [
    "263379",
    [
      949297
    ]
  ],
  "./hu/registration.json": [
    "717058",
    [
      475514
    ]
  ],
  "./hy/course_paces_search.json": [
    "944838",
    [
      863966
    ]
  ],
  "./id/outcome_detail.json": [
    "151057",
    [
      746411
    ]
  ],
  "./nb/overview_page.json": [
    "422597",
    [
      633927
    ]
  ],
  "./nl/pairing_code_user_observees.json": [
    "917673",
    [
      556123
    ]
  ],
  "./hi/permissions_v2_add_tray.json": [
    "812475",
    [
      576777
    ]
  ],
  "./es-ES/discussion_settings.json": [
    "663191",
    [
      852013
    ]
  ],
  "./ru/homeroom_page.json": [
    "218377",
    [
      503327
    ]
  ],
  "./de/discussion_pinned_post.json": [
    "414217",
    [
      641472
    ]
  ],
  "./da/submit_assignment.json": [
    "842601",
    [
      509831
    ]
  ],
  "./fr-CA/terms_of_service_modal.json": [
    "451462",
    [
      744298
    ]
  ],
  "./hu/course_paces_blueprint_lock.json": [
    "957665",
    [
      558527
    ]
  ],
  "./pl/course_search_results.json": [
    "132829",
    [
      253863
    ]
  ],
  "./es-ES/outcome_detail.json": [
    "938097",
    [
      100151
    ]
  ],
  "./en-AU-x-unimelb/content_migrations.json": [
    "218901",
    [
      692815
    ]
  ],
  "./fa/appointment_groups.json": [
    "140079",
    [
      89365
    ]
  ],
  "./id/course_stats.json": [
    "827308",
    [
      419656
    ]
  ],
  "./zh-Hant/edit_section_end_date.json": [
    "445455",
    [
      971921
    ]
  ],
  "./nn/bulk_edit_students_actions.json": [
    "61392",
    [
      697772
    ]
  ],
  "./nn/media_player_iframe_content.json": [
    "261293",
    [
      229367
    ]
  ],
  "./ko/content_copy_redesign.json": [
    "432799",
    [
      942733
    ]
  ],
  "./fa/gradingGradeSummary.json": [
    "672002",
    [
      598642
    ]
  ],
  "./hy/pseudonyms_mobile_login.json": [
    "582057",
    [
      590319
    ]
  ],
  "./en-AU-x-unimelb/moderate_quiz.json": [
    "386129",
    [
      97707
    ]
  ],
  "./ko/appt_calendar_event_dialog.json": [
    "52040",
    [
      598952
    ]
  ],
  "./mi/account_calendars.json": [
    "934227",
    [
      270281
    ]
  ],
  "./ca/overview_page.json": [
    "667181",
    [
      421619
    ]
  ],
  "./sv-x-k12/unpublished_changes_tray_contents.json": [
    "255804",
    [
      540620
    ]
  ],
  "./en-GB/modelsQuiz.json": [
    "435134",
    [
      230635
    ]
  ],
  "./sv/files_v2.json": [
    "745417",
    [
      488875
    ]
  ],
  "./da-x-k12/course_link_validator.json": [
    "493132",
    [
      892608
    ]
  ],
  "./de/overview_page.json": [
    "937010",
    [
      161331
    ]
  ],
  "./ar/assignments_2_peer_review.json": [
    "288056",
    [
      11604
    ]
  ],
  "./fa/discussion_row.json": [
    "551722",
    [
      848362
    ]
  ],
  "./fa/user_profile.json": [
    "371904",
    [
      535128
    ]
  ],
  "./sv-x-k12/moderate_quiz.json": [
    "319814",
    [
      200142
    ]
  ],
  "./en-GB/user_name.json": [
    "816952",
    [
      384865
    ]
  ],
  "./en/assignments_2_student_content.json": [
    "733328",
    [
      943044
    ]
  ],
  "./hu/assignments_2_submission_histories_query.json": [
    "606059",
    [
      965937
    ]
  ],
  "./pt/homeroom_page.json": [
    "868332",
    [
      677984
    ]
  ],
  "./ca/manage_avatars.json": [
    "627400",
    [
      526792
    ]
  ],
  "./sv-x-k12/permissions_v2_add_tray.json": [
    "868443",
    [
      780745
    ]
  ],
  "./da-x-k12/announcements_v2.json": [
    "163216",
    [
      730404
    ]
  ],
  "./hu/content_exports.json": [
    "162404",
    [
      238940
    ]
  ],
  "./ms/courses.json": [
    "64100",
    [
      335740
    ]
  ],
  "./sl/assignments_bulk_edit_use_save_assignment.json": [
    "729021",
    [
      34879
    ]
  ],
  "./sl/change_password.json": [
    "154345",
    [
      531355
    ]
  ],
  "./es/assignments_2_MoreOptions_CanvasFiles.json": [
    "607771",
    [
      702982
    ]
  ],
  "./ca/bounced_emails.json": [
    "304710",
    [
      160502
    ]
  ],
  "./nb-x-k12/permissions_role_tray_table_row.json": [
    "3230",
    [
      321174
    ]
  ],
  "./th/permission_button.json": [
    "434426",
    [
      497430
    ]
  ],
  "./vi/course_paces_search.json": [
    "11080",
    [
      368896
    ]
  ],
  "./en-GB-x-lbs/sidenav.json": [
    "670340",
    [
      454564
    ]
  ],
  "./vi/edit_section_end_date.json": [
    "602328",
    [
      213904
    ]
  ],
  "./vi/conversations_2.json": [
    "154978",
    [
      954626
    ]
  ],
  "./nl/OutcomeDescriptionModal.json": [
    "123175",
    [
      212281
    ]
  ],
  "./pt-BR/quizzes_index.json": [
    "33441",
    [
      610392
    ]
  ],
  "./en-GB/sharedCurveGradesDialog.json": [
    "295355",
    [
      619178
    ]
  ],
  "./sl/ignite_agent.json": [
    "135935",
    [
      54889
    ]
  ],
  "./ga/discussion_settings.json": [
    "297338",
    [
      14842
    ]
  ],
  "./is/assignments_2_student_header.json": [
    "101231",
    [
      509749
    ]
  ],
  "./fa/bounced_emails.json": [
    "176297",
    [
      889519
    ]
  ],
  "./da/peer_review_configuration_tray.json": [
    "349474",
    [
      616938
    ]
  ],
  "./fr/users.json": [
    "7286",
    [
      981659
    ]
  ],
  "./ko/blueprint_settingsSyncChange.json": [
    "527078",
    [
      541494
    ]
  ],
  "./pl/outcome_alignment_v2.json": [
    "906865",
    [
      767355
    ]
  ],
  "./hu/editGroup.json": [
    "782786",
    [
      743994
    ]
  ],
  "./nb-x-k12/unpublished_warning_modal.json": [
    "309390",
    [
      603334
    ]
  ],
  "./da-x-k12/enhanced_individual_gradebook_submit_score.json": [
    "341542",
    [
      891618
    ]
  ],
  "./ga/k5_dashboard_card.json": [
    "757932",
    [
      976620
    ]
  ],
  "./hy/assignmentsToggleShowByView.json": [
    "428406",
    [
      762350
    ]
  ],
  "./sl/discussionTopicKeyboradShortcutModal.json": [
    "685984",
    [
      130268
    ]
  ],
  "./vi/user_search_results.json": [
    "620762",
    [
      324554
    ]
  ],
  "./ar/new_nav.json": [
    "159409",
    [
      298579
    ]
  ],
  "./en-CA/user_logins.json": [
    "709600",
    [
      618328
    ]
  ],
  "./vi/assignments_2_attempt_tab.json": [
    "300222",
    [
      972310
    ]
  ],
  "./sv-x-k12/pseudonyms_mobile_login.json": [
    "859001",
    [
      678239
    ]
  ],
  "./es/terms_of_service_modal.json": [
    "686757",
    [
      871212
    ]
  ],
  "./zh-Hans.json": [
    "511902",
    [
      677760
    ]
  ],
  "./da-x-k12/confirmMasteryModal.json": [
    "40629",
    [
      183439
    ]
  ],
  "./nl.eager.json": [
    "336425",
    [
      447440
    ]
  ],
  "./ja/course_search_results.json": [
    "555092",
    [
      57681
    ]
  ],
  "./ru/gradebookOutcomeGradebookView.json": [
    "430726",
    [
      585374
    ]
  ],
  "./id/account_calendars_results_area.json": [
    "838731",
    [
      381557
    ]
  ],
  "./en/dashboard.json": [
    "214165",
    [
      296559
    ]
  ],
  "./pt/appointment_groups.json": [
    "256856",
    [
      246636
    ]
  ],
  "./nl/quiz_migration_notifications.json": [
    "472581",
    [
      475495
    ]
  ],
  "./zh-Hant/modules_home_page.json": [
    "282061",
    [
      190639
    ]
  ],
  "./da/dashboard_grades_page.json": [
    "779640",
    [
      761432
    ]
  ],
  "./fi/AddGroup.json": [
    "162671",
    [
      721237
    ]
  ],
  "./fr/assignmentsIndexView.json": [
    "498829",
    [
      469984
    ]
  ],
  "./ht/unpublished_changes_tray_contents.json": [
    "599063",
    [
      267185
    ]
  ],
  "./ja/course_paces_modal.json": [
    "662421",
    [
      881228
    ]
  ],
  "./ca/link_validator.json": [
    "529835",
    [
      910433
    ]
  ],
  "./zh-Hans/terms_of_service_modal.json": [
    "5176",
    [
      729376
    ]
  ],
  "./sl/group_submission_reminder.json": [
    "405082",
    [
      861598
    ]
  ],
  "./sv/rate_limiting_settings.json": [
    "933263",
    [
      504745
    ]
  ],
  "./id/SpeedGraderCheckpoints.json": [
    "897654",
    [
      948314
    ]
  ],
  "./ga/gradebookActionMenu.json": [
    "323509",
    [
      739587
    ]
  ],
  "./de/remove_pace_warning_modal.json": [
    "769122",
    [
      897059
    ]
  ],
  "./en-GB-x-ukhe/conversations_2.json": [
    "171829",
    [
      272931
    ]
  ],
  "./is/empty_course.json": [
    "998597",
    [
      538563
    ]
  ],
  "./sv/k5_course.json": [
    "597623",
    [
      173937
    ]
  ],
  "./zh-Hans/media_immersive_view.json": [
    "149327",
    [
      800261
    ]
  ],
  "./it/internal-settings.json": [
    "957254",
    [
      312714
    ]
  ],
  "./hy/conversations_2.json": [
    "888880",
    [
      607688
    ]
  ],
  "./da-x-k12/assignments_2_text_entry.json": [
    "820629",
    [
      434071
    ]
  ],
  "./da/discussion_insights.json": [
    "102441",
    [
      398983
    ]
  ],
  "./fr/grade_change_logging_content.json": [
    "233182",
    [
      560995
    ]
  ],
  "./pt/user_date_range_search.json": [
    "729473",
    [
      915979
    ]
  ],
  "./uk/GroupsTray.json": [
    "581650",
    [
      929338
    ]
  ],
  "./fr-CA/course_pace_date_input.json": [
    "264188",
    [
      550520
    ]
  ],
  "./fi/rate_limiting_settings.json": [
    "445611",
    [
      159049
    ]
  ],
  "./nb-x-k12.eager.json": [
    "305341",
    [
      520928
    ]
  ],
  "./de/module_student_view_peer_reviews.json": [
    "405908",
    [
      995913
    ]
  ],
  "./fa/account_calendar_settings_account_list.json": [
    "740894",
    [
      950566
    ]
  ],
  "./ms/assignments.json": [
    "105980",
    [
      865060
    ]
  ],
  "./da-x-k12/course_paces_blackout_dates_table.json": [
    "907128",
    [
      474404
    ]
  ],
  "./de/discovery_page.json": [
    "364691",
    [
      692358
    ]
  ],
  "./de/assignments_2_login_action_prompt.json": [
    "788490",
    [
      171083
    ]
  ],
  "./en-GB/default_account_quotas.json": [
    "535982",
    [
      590115
    ]
  ],
  "./sv-x-k12/AssignmentGroupListItemView.json": [
    "619351",
    [
      894077
    ]
  ],
  "./sl/link_to_students.json": [
    "971838",
    [
      84706
    ]
  ],
  "./sv-x-k12/dashboard_grading_period_select.json": [
    "78687",
    [
      222485
    ]
  ],
  "./tr/assignments_2_text_entry.json": [
    "325636",
    [
      796400
    ]
  ],
  "./es/outcome_detail.json": [
    "373430",
    [
      428135
    ]
  ],
  "./en-GB-x-lbs/blueprint_settingsCoursePicker.json": [
    "79370",
    [
      476218
    ]
  ],
  "./cy/self_enrollment.json": [
    "886245",
    [
      745099
    ]
  ],
  "./hi/react_collaborations.json": [
    "289997",
    [
      665323
    ]
  ],
  "./ht/AssignmentListItemView.json": [
    "100133",
    [
      110583
    ]
  ],
  "./ht/todos_page.json": [
    "554719",
    [
      205409
    ]
  ],
  "./it/SpeedGraderSettingsMenu.json": [
    "472521",
    [
      171211
    ]
  ],
  "./hy/peer_review_configuration_tray.json": [
    "604870",
    [
      10302
    ]
  ],
  "./ar/add_edit_pseudonym.json": [
    "535002",
    [
      636646
    ]
  ],
  "./fa/overview_page.json": [
    "668364",
    [
      12204
    ]
  ],
  "./ja/assignments.no_assignments_search.json": [
    "914368",
    [
      499397
    ]
  ],
  "./el/content_share_preview_overlay.json": [
    "561518",
    [
      468578
    ]
  ],
  "./en-GB-x-lbs/change_password.json": [
    "427528",
    [
      203616
    ]
  ],
  "./vi/course_paces_flaggable_number_input.json": [
    "853570",
    [
      940626
    ]
  ],
  "./uk/blueprint_settingsCoursePicker.json": [
    "258172",
    [
      835956
    ]
  ],
  "./ms/account_calendar_settings_account_calendar_item.json": [
    "968835",
    [
      847289
    ]
  ],
  "./nb-x-k12/course_paces_change_tracking.json": [
    "260993",
    [
      787431
    ]
  ],
  "./sl/learning_mastery_gradebook.json": [
    "935470",
    [
      902045
    ]
  ],
  "./ru/assignments_2_shared_Steps.json": [
    "12432",
    [
      187384
    ]
  ],
  "./mi/epub_exports.json": [
    "95158",
    [
      66454
    ]
  ],
  "./ja/accessibility_course_statistics.json": [
    "361385",
    [
      280616
    ]
  ],
  "./ms/content_share_preview_overlay.json": [
    "543239",
    [
      572789
    ]
  ],
  "./fr/assignments.no_assignments_search.json": [
    "468965",
    [
      742144
    ]
  ],
  "./nb/a2LatePolicyToolTipContent.json": [
    "477111",
    [
      933121
    ]
  ],
  "./en-GB/quizzes_index.json": [
    "591549",
    [
      879304
    ]
  ],
  "./pl/use_switch_experience.json": [
    "949275",
    [
      191789
    ]
  ],
  "./ht/discussion_posts.json": [
    "117978",
    [
      907814
    ]
  ],
  "./tr/blueprint_coursesExpandableLockOptions.json": [
    "547153",
    [
      818699
    ]
  ],
  "./zh-Hans/content_migrations.json": [
    "954344",
    [
      454352
    ]
  ],
  "./ja/blueprint_settingsCoursePickerTable.json": [
    "884769",
    [
      834784
    ]
  ],
  "./ca/youtube_migration.json": [
    "142316",
    [
      37732
    ]
  ],
  "./th/content_share_preview_overlay.json": [
    "95863",
    [
      699625
    ]
  ],
  "./nl/permissions.json": [
    "479132",
    [
      271760
    ]
  ],
  "./en-GB-x-ukhe/assignment_2_assignment_toggle_details.json": [
    "763812",
    [
      103892
    ]
  ],
  "./hu/horizon_toggle.json": [
    "799887",
    [
      25037
    ]
  ],
  "./mi/user_profile.json": [
    "338529",
    [
      863071
    ]
  ],
  "./nb/assignments_2_elide_string.json": [
    "783643",
    [
      760493
    ]
  ],
  "./ga/admin_split.json": [
    "71410",
    [
      927986
    ]
  ],
  "./uk/discovery_page.json": [
    "355046",
    [
      293206
    ]
  ],
  "./fa/default_account_quotas.json": [
    "61498",
    [
      859802
    ]
  ],
  "./da-x-k12/error_form.json": [
    "221496",
    [
      484140
    ]
  ],
  "./hi/FindOutcomesModal.json": [
    "759878",
    [
      684158
    ]
  ],
  "./mi/quiz_statistics.json": [
    "996885",
    [
      103643
    ]
  ],
  "./th/error_form.json": [
    "477043",
    [
      964005
    ]
  ],
  "./ms/group_submission_reminder.json": [
    "705777",
    [
      296271
    ]
  ],
  "./ht/epub_exports.json": [
    "51316",
    [
      289480
    ]
  ],
  "./fr-CA/LearningMasteryGradebook.json": [
    "887346",
    [
      450750
    ]
  ],
  "./sl/react_collaborations.json": [
    "790757",
    [
      367263
    ]
  ],
  "./zh-Hans/account_settings.json": [
    "844054",
    [
      585902
    ]
  ],
  "./da/conferences_alternatives.json": [
    "956059",
    [
      679089
    ]
  ],
  "./fi/accessibility_course_statistics.json": [
    "467589",
    [
      869523
    ]
  ],
  "./pt-BR/content_exports.json": [
    "306390",
    [
      301919
    ]
  ],
  "./fi/link_validator.json": [
    "623472",
    [
      656968
    ]
  ],
  "./fr/terms_of_use.json": [
    "478607",
    [
      602214
    ]
  ],
  "./he/submit_online_url_assignment.json": [
    "105039",
    [
      653933
    ]
  ],
  "./de/assignments.json": [
    "638991",
    [
      794650
    ]
  ],
  "./ko/assignments_2_initial_query.json": [
    "465291",
    [
      275681
    ]
  ],
  "./it/modelsQuiz.json": [
    "914266",
    [
      19878
    ]
  ],
  "./pt/user_grades.json": [
    "400530",
    [
      639630
    ]
  ],
  "./he/course_paces_module.json": [
    "57822",
    [
      997646
    ]
  ],
  "./zh-Hant/license_help.json": [
    "327803",
    [
      282757
    ]
  ],
  "./zh-Hans/user_lists.json": [
    "338046",
    [
      151654
    ]
  ],
  "./ar/calendar_custom_recurring_event_natural_language.json": [
    "158739",
    [
      158597
    ]
  ],
  "./en-GB/jobs_v2.json": [
    "883166",
    [
      287563
    ]
  ],
  "./hy/course_paces_modal.json": [
    "659715",
    [
      389217
    ]
  ],
  "./hy/learning_mastery_gradebook.json": [
    "590390",
    [
      866542
    ]
  ],
  "./nb-x-k12/permissions.json": [
    "571800",
    [
      423456
    ]
  ],
  "./hy/course_link_validator.json": [
    "211334",
    [
      200222
    ]
  ],
  "./zh-Hans/ignite_agent.json": [
    "712815",
    [
      279493
    ]
  ],
  "./uk/modelsQuiz.json": [
    "228385",
    [
      340207
    ]
  ],
  "./mi/modules_page_icon_legend.json": [
    "885961",
    [
      910647
    ]
  ],
  "./hi/course_restore.json": [
    "775175",
    [
      949389
    ]
  ],
  "./ar/module_student_view_peer_reviews.json": [
    "482748",
    [
      985208
    ]
  ],
  "./ja/copy_warnings_modal.json": [
    "521902",
    [
      365967
    ]
  ],
  "./nl/blueprint_settingsAssociationsTable.json": [
    "227499",
    [
      647133
    ]
  ],
  "./fa/CourseAvailabilityOptions.json": [
    "296503",
    [
      10685
    ]
  ],
  "./ar/CommentLibrary.json": [
    "136371",
    [
      616669
    ]
  ],
  "./hi/account_calendar_settings_footer.json": [
    "693783",
    [
      59325
    ]
  ],
  "./ko/course_paces_search.json": [
    "446715",
    [
      629265
    ]
  ],
  "./zh-Hans/course_paces_settings.json": [
    "300591",
    [
      62261
    ]
  ],
  "./da-x-k12/gradebook.json": [
    "498577",
    [
      551939
    ]
  ],
  "./es/epub_exports.json": [
    "980196",
    [
      724689
    ]
  ],
  "./en-GB-x-lbs/CourseAvailabilityOptions.json": [
    "255016",
    [
      95088
    ]
  ],
  "./fi/grade_change_logging_content.json": [
    "536733",
    [
      549995
    ]
  ],
  "./en-AU-x-unimelb/calendar_appointment_group_edit.json": [
    "918907",
    [
      419069
    ]
  ],
  "./he/course_paces_change_tracking.json": [
    "630358",
    [
      636918
    ]
  ],
  "./ar/quantitative_data_options.json": [
    "842268",
    [
      287008
    ]
  ],
  "./nl/custom_emoji_deny_list.json": [
    "649774",
    [
      365338
    ]
  ],
  "./ca/dashboard_grades_page.json": [
    "58263",
    [
      691541
    ]
  ],
  "./is/conferences.json": [
    "497117",
    [
      472939
    ]
  ],
  "./pl/roster_publicjs.json": [
    "942340",
    [
      216464
    ]
  ],
  "./zh-Hans.eager.json": [
    "888104",
    [
      970635
    ]
  ],
  "./da/blueprint_settingsSyncChange.json": [
    "537841",
    [
      361119
    ]
  ],
  "./sl/filter_calendars_modal.json": [
    "756279",
    [
      444313
    ]
  ],
  "./cy/quantitative_data_options.json": [
    "739411",
    [
      232073
    ]
  ],
  "./tr/keyboardShortcutModal.json": [
    "437440",
    [
      52988
    ]
  ],
  "./zh-Hans/link_validator.json": [
    "202646",
    [
      702590
    ]
  ],
  "./el/wiki_page_index.json": [
    "690630",
    [
      457594
    ]
  ],
  "./nl/assignment_index.json": [
    "732514",
    [
      78385
    ]
  ],
  "./ga/assignmentsIndexView.json": [
    "325769",
    [
      714127
    ]
  ],
  "./es-ES/HelpTray.json": [
    "58066",
    [
      636482
    ]
  ],
  "./fi/change_password.json": [
    "651315",
    [
      561713
    ]
  ],
  "./pt-BR/calendar_edit.json": [
    "967660",
    [
      856081
    ]
  ],
  "./de/user.json": [
    "246004",
    [
      536841
    ]
  ],
  "./ja/course_logging_details.json": [
    "632991",
    [
      54498
    ]
  ],
  "./en-AU/canvas_file_upload.json": [
    "363145",
    [
      424104
    ]
  ],
  "./fa/FindOutcomesModal.json": [
    "179760",
    [
      313752
    ]
  ],
  "./pt-BR/add_edit_pseudonym.json": [
    "913520",
    [
      110621
    ]
  ],
  "./es/discussion_pinned_post.json": [
    "256268",
    [
      263289
    ]
  ],
  "./en-AU-x-unimelb/discussion_topics.json": [
    "892891",
    [
      878453
    ]
  ],
  "./nb-x-k12/account_settings.json": [
    "727677",
    [
      880859
    ]
  ],
  "./nb/quizzes_regrade_modal.json": [
    "454610",
    [
      247406
    ]
  ],
  "./pl/assignments_2_MoreOptions.json": [
    "538711",
    [
      413905
    ]
  ],
  "./es/account_calendars.json": [
    "378053",
    [
      878316
    ]
  ],
  "./en-GB/course_paces_app.json": [
    "501379",
    [
      25626
    ]
  ],
  "./ht/assignments_2_peer_review.json": [
    "385863",
    [
      373489
    ]
  ],
  "./th/outcome_detail.json": [
    "583870",
    [
      739538
    ]
  ],
  "./nl/account_calendars_modal.json": [
    "534837",
    [
      586343
    ]
  ],
  "./it/assignment_2_assignment_toggle_details.json": [
    "562913",
    [
      178819
    ]
  ],
  "./zh-Hans/course_default_due_time.json": [
    "744279",
    [
      900173
    ]
  ],
  "./da/account_calendar_settings_filter_controls.json": [
    "631853",
    [
      870803
    ]
  ],
  "./pt-BR/blueprint_coursesExpandableLockOptions.json": [
    "998932",
    [
      239929
    ]
  ],
  "./de/gradebook.json": [
    "532567",
    [
      792242
    ]
  ],
  "./pt-BR/moderate_quiz.json": [
    "813972",
    [
      291977
    ]
  ],
  "./da-x-k12/bounced_emails.json": [
    "462421",
    [
      713175
    ]
  ],
  "./hi/account_course_user_search.json": [
    "323569",
    [
      669415
    ]
  ],
  "./ga/gradebook_history.json": [
    "409499",
    [
      950505
    ]
  ],
  "./pl/course_navigation_settings.json": [
    "461550",
    [
      572874
    ]
  ],
  "./ru/new_user_tutorial.json": [
    "202032",
    [
      501096
    ]
  ],
  "./en-GB-x-ukhe/permissions_v2.json": [
    "955041",
    [
      591479
    ]
  ],
  "./zh-Hans/quantitative_data_options.json": [
    "56596",
    [
      342836
    ]
  ],
  "./id/registration.json": [
    "622544",
    [
      798900
    ]
  ],
  "./en-AU-x-unimelb/accessibility_scan.json": [
    "483538",
    [
      78006
    ]
  ],
  "./sv-x-k12/AssignmentListItemView.json": [
    "187444",
    [
      558852
    ]
  ],
  "./he/grade_details.json": [
    "89395",
    [
      107913
    ]
  ],
  "./id/lti_registration.wizard.json": [
    "549141",
    [
      103792
    ]
  ],
  "./da-x-k12/homeroom_page.json": [
    "837781",
    [
      260159
    ]
  ],
  "./fr/account_calendar_settings_confirmation_modal.json": [
    "437870",
    [
      503115
    ]
  ],
  "./ja/account_calendar_settings_account_tree.json": [
    "728970",
    [
      878899
    ]
  ],
  "./sv/SpeedGraderCheckpoints.json": [
    "575066",
    [
      180142
    ]
  ],
  "./fi/Navigation.json": [
    "513755",
    [
      244457
    ]
  ],
  "./hu/course_paces_settings.json": [
    "185795",
    [
      103737
    ]
  ],
  "./ht/SpeedGraderDiscussionsNavigation.json": [
    "459337",
    [
      993715
    ]
  ],
  "./nn/sis_import.json": [
    "561701",
    [
      114111
    ]
  ],
  "./da-x-k12/todo.json": [
    "989277",
    [
      327351
    ]
  ],
  "./da-x-k12/progress_pill.json": [
    "569124",
    [
      516712
    ]
  ],
  "./nb/assignments_2_submission_histories_query.json": [
    "207594",
    [
      805462
    ]
  ],
  "./sl/license_help.json": [
    "548352",
    [
      420236
    ]
  ],
  "./zh-Hans/lti_registration.wizard.json": [
    "817403",
    [
      646286
    ]
  ],
  "./ga/HelpTray.json": [
    "832397",
    [
      359755
    ]
  ],
  "./hi/self_unenrollment_modal.json": [
    "413419",
    [
      105561
    ]
  ],
  "./tr/link_to_students.json": [
    "994453",
    [
      673367
    ]
  ],
  "./zh-Hant/gradebookOutcomeGradebookView.json": [
    "59389",
    [
      296575
    ]
  ],
  "./ko/top_navigation_tools.json": [
    "39358",
    [
      444030
    ]
  ],
  "./en-GB-x-lbs.eager.json": [
    "225017",
    [
      223236
    ]
  ],
  "./fa/ai_experiences_ai_conversations.json": [
    "11915",
    [
      949449
    ]
  ],
  "./hy/change_password.json": [
    "706673",
    [
      543239
    ]
  ],
  "./id/rate_limiting_settings.json": [
    "901243",
    [
      541909
    ]
  ],
  "./vi/discussion_posts.json": [
    "185273",
    [
      727167
    ]
  ],
  "./ms/edit_section_view.json": [
    "14122",
    [
      111218
    ]
  ],
  "./ja/assignments_2_student_content.json": [
    "27730",
    [
      547259
    ]
  ],
  "./de/sharedCurveGradesDialog.json": [
    "715561",
    [
      955216
    ]
  ],
  "./nl/sharedSetDefaultGradeDialog.json": [
    "629159",
    [
      730857
    ]
  ],
  "./nn/courses.json": [
    "73968",
    [
      364836
    ]
  ],
  "./zh-Hant/k5_dashboard_card.json": [
    "280454",
    [
      257858
    ]
  ],
  "./da-x-k12/grade_summary.json": [
    "483243",
    [
      953525
    ]
  ],
  "./hu/course_paces_actions.json": [
    "956641",
    [
      575231
    ]
  ],
  "./ms/gradebook_uploads.json": [
    "78505",
    [
      275895
    ]
  ],
  "./en-GB-x-ukhe/k5_dashboard_card.json": [
    "471666",
    [
      508002
    ]
  ],
  "./id/link_validator.json": [
    "405344",
    [
      338932
    ]
  ],
  "./mi/permissions_v2.json": [
    "434501",
    [
      861547
    ]
  ],
  "./nl/content_exports.json": [
    "836073",
    [
      238835
    ]
  ],
  "./pt-BR/todo.json": [
    "970657",
    [
      889976
    ]
  ],
  "./id/assignments_2_student_points_display.json": [
    "442539",
    [
      678173
    ]
  ],
  "./en-AU/add_edit_pseudonym.json": [
    "821873",
    [
      74192
    ]
  ],
  "./da-x-k12/user_date_range_search.json": [
    "473570",
    [
      84846
    ]
  ],
  "./is/assignment_index_menu.json": [
    "745558",
    [
      67502
    ]
  ],
  "./en-GB-x-ukhe/editGroup.json": [
    "392879",
    [
      23157
    ]
  ],
  "./ko/blueprint_settingsCoursePicker.json": [
    "407834",
    [
      206386
    ]
  ],
  "./ga/accessibility_scan.json": [
    "689430",
    [
      920446
    ]
  ],
  "./pt-BR/progress_pill.json": [
    "685264",
    [
      540941
    ]
  ],
  "./tr/assignments_2_file_upload.json": [
    "67418",
    [
      709926
    ]
  ],
  "./es-ES/copy_course.json": [
    "135500",
    [
      850988
    ]
  ],
  "./sv/question_bank.json": [
    "127412",
    [
      165912
    ]
  ],
  "./hu/speed_grader_helpers.json": [
    "172322",
    [
      784730
    ]
  ],
  "./it/account_calendar_settings_filter_controls.json": [
    "603443",
    [
      67237
    ]
  ],
  "./ru/comm_messages.json": [
    "539802",
    [
      657738
    ]
  ],
  "./sl/account_calendar_settings_confirmation_modal.json": [
    "143147",
    [
      658053
    ]
  ],
  "./ca/calculator_command.json": [
    "15908",
    [
      472460
    ]
  ],
  "./en/course_paces_change_tracking.json": [
    "551458",
    [
      366502
    ]
  ],
  "./fi/MoveOutcomesModal.json": [
    "983726",
    [
      132646
    ]
  ],
  "./is/user_name.json": [
    "372053",
    [
      142451
    ]
  ],
  "./pl/sidenav.json": [
    "697706",
    [
      501254
    ]
  ],
  "./id/blueprint_settingsSyncChange.json": [
    "491895",
    [
      958897
    ]
  ],
  "./nb-x-k12/content_migrations_redesign.json": [
    "466015",
    [
      129797
    ]
  ],
  "./nn/question_banks.json": [
    "760146",
    [
      851478
    ]
  ],
  "./pl/OutcomeDescriptionModal.json": [
    "654165",
    [
      563447
    ]
  ],
  "./zh-Hant/discussion_topics.json": [
    "100533",
    [
      696487
    ]
  ],
  "./en-GB-x-ukhe/course_paces_module.json": [
    "981671",
    [
      134653
    ]
  ],
  "./ca/assignments_2_student_points_display.json": [
    "330940",
    [
      362548
    ]
  ],
  "./pl/bulk_edit_students.json": [
    "845632",
    [
      411668
    ]
  ],
  "./pl/a2_AccessibleTipContent.json": [
    "88330",
    [
      761502
    ]
  ],
  "./vi/ai_experiences_ai_conversations.json": [
    "419491",
    [
      332465
    ]
  ],
  "./zh-Hans/gradebookActionMenu.json": [
    "470934",
    [
      952334
    ]
  ],
  "./da/AccountsTray.json": [
    "703523",
    [
      170249
    ]
  ],
  "./tr/assignments_bulk_edit.json": [
    "192860",
    [
      830304
    ]
  ],
  "./hu/upload_button.json": [
    "941955",
    [
      33817
    ]
  ],
  "./tr/Navigation.json": [
    "487682",
    [
      650742
    ]
  ],
  "./nn/quiz_show.json": [
    "897929",
    [
      334355
    ]
  ],
  "./fr-CA/k5_dashboard.json": [
    "579934",
    [
      956882
    ]
  ],
  "./da/bulk_edit_students_table.json": [
    "701722",
    [
      267954
    ]
  ],
  "./ga/course_paces_blackout_dates_modal.json": [
    "151868",
    [
      834172
    ]
  ],
  "./el/file_not_found.json": [
    "279290",
    [
      70710
    ]
  ],
  "./hu/restore_content_pane.json": [
    "357780",
    [
      722956
    ]
  ],
  "./hi/plugins.json": [
    "64737",
    [
      523111
    ]
  ],
  "./pl/calendar_sidebar.json": [
    "678275",
    [
      739485
    ]
  ],
  "./pt-BR/calendar_appointment_group_edit.json": [
    "306890",
    [
      507547
    ]
  ],
  "./es/assignments_2_submission_helpers.json": [
    "954180",
    [
      173137
    ]
  ],
  "./ca/course_paces_settings.json": [
    "616060",
    [
      325236
    ]
  ],
  "./da-x-k12/permissions_v2.json": [
    "206552",
    [
      530316
    ]
  ],
  "./da/a2LatePolicyStatusDisplay.json": [
    "215358",
    [
      249662
    ]
  ],
  "./da/quiz_log_auditing.json": [
    "8569",
    [
      316887
    ]
  ],
  "./mi/react_collaborations.json": [
    "639938",
    [
      434330
    ]
  ],
  "./nb/sections_tooltip.json": [
    "458346",
    [
      227214
    ]
  ],
  "./da-x-k12/context_prior_users.json": [
    "579360",
    [
      375964
    ]
  ],
  "./fr-CA/CommentLibrary.json": [
    "98545",
    [
      524307
    ]
  ],
  "./ko/permissions.json": [
    "560764",
    [
      170708
    ]
  ],
  "./nl/discussion_row.json": [
    "468187",
    [
      371434
    ]
  ],
  "./pl/gradebookOutcomeGradebookView.json": [
    "78023",
    [
      809761
    ]
  ],
  "./pt/quiz_log_auditing.json": [
    "743030",
    [
      786706
    ]
  ],
  "./en-GB-x-lbs/content_shares.json": [
    "911750",
    [
      154542
    ]
  ],
  "./nl/gradebook.json": [
    "674518",
    [
      528218
    ]
  ],
  "./sv-x-k12/course_paces_no_results.json": [
    "380216",
    [
      935920
    ]
  ],
  "./vi/GroupsTray.json": [
    "361225",
    [
      393807
    ]
  ],
  "./da-x-k12/discussion_pinned_post.json": [
    "815015",
    [
      234649
    ]
  ],
  "./ja/nav_tourpoints.json": [
    "554062",
    [
      849839
    ]
  ],
  "./en-GB-x-lbs/account_calendars_modal.json": [
    "538853",
    [
      941987
    ]
  ],
  "./zh-Hans/student_annotation_preview.json": [
    "423045",
    [
      56019
    ]
  ],
  "./he/unpublished_changes_tray_contents.json": [
    "88824",
    [
      391304
    ]
  ],
  "./is/discussion_posts.json": [
    "139726",
    [
      131222
    ]
  ],
  "./ja/unpublished_warning_modal.json": [
    "188921",
    [
      312184
    ]
  ],
  "./sv-x-k12/rootFoldersFinder.json": [
    "376204",
    [
      426284
    ]
  ],
  "./ja/section.json": [
    "431936",
    [
      156229
    ]
  ],
  "./de/outcome_management.json": [
    "512393",
    [
      44288
    ]
  ],
  "./mi/user_logins.json": [
    "29222",
    [
      145606
    ]
  ],
  "./ja/course_paces_projected_dates.json": [
    "789350",
    [
      171623
    ]
  ],
  "./ru/FindOutcomesModal.json": [
    "579304",
    [
      51248
    ]
  ],
  "./da-x-k12/CoursesTray.json": [
    "762153",
    [
      481795
    ]
  ],
  "./de/suppress_notifications.json": [
    "81639",
    [
      624866
    ]
  ],
  "./ca/discussion_create.json": [
    "170639",
    [
      99421
    ]
  ],
  "./tr/todo.json": [
    "565540",
    [
      287576
    ]
  ],
  "./is/module_student_view_peer_reviews.json": [
    "662533",
    [
      874147
    ]
  ],
  "./vi/a2LatePolicyToolTipContent.json": [
    "106932",
    [
      397924
    ]
  ],
  "./fi/user_lists.json": [
    "638844",
    [
      295564
    ]
  ],
  "./nb-x-k12/IndividualStudentMasteryOutcome.json": [
    "841289",
    [
      810895
    ]
  ],
  "./en-AU-x-unimelb/notebook_index.json": [
    "377080",
    [
      405932
    ]
  ],
  "./pt/account_calendar_settings.json": [
    "49600",
    [
      70140
    ]
  ],
  "./zh-Hans/CourseAvailabilityOptions.json": [
    "872921",
    [
      264911
    ]
  ],
  "./ar/modules_page_icon_legend.json": [
    "78026",
    [
      772342
    ]
  ],
  "./th/peer_review_student_select.json": [
    "35636",
    [
      350256
    ]
  ],
  "./sl/discovery_page.json": [
    "818147",
    [
      746277
    ]
  ],
  "./en/grade_summary.json": [
    "562645",
    [
      83711
    ]
  ],
  "./fi/CreateEditAssignmentModalAdapter.json": [
    "935340",
    [
      567628
    ]
  ],
  "./fr/assignments_2_student_content_rubric_self_assessment.json": [
    "493943",
    [
      589646
    ]
  ],
  "./sv-x-k12/assignments_2_peer_review.json": [
    "688776",
    [
      816272
    ]
  ],
  "./da/assignment_2_assignment_toggle_details.json": [
    "491919",
    [
      524605
    ]
  ],
  "./fr-CA/blueprint_settingsMigrationOptions.json": [
    "520490",
    [
      809678
    ]
  ],
  "./zh-Hant/blueprint_course_sidebar.json": [
    "511638",
    [
      338514
    ]
  ],
  "./ja/remove_pace_warning_modal.json": [
    "588192",
    [
      661202
    ]
  ],
  "./hu/bulk_edit_students_table.json": [
    "680106",
    [
      758834
    ]
  ],
  "./is/course_paces_change_tracking.json": [
    "644171",
    [
      266361
    ]
  ],
  "./sv-x-k12/account_course_user_search.json": [
    "320017",
    [
      763239
    ]
  ],
  "./sv/course_paces_search.json": [
    "185164",
    [
      584560
    ]
  ],
  "./th/AlignmentSummary.json": [
    "170701",
    [
      138191
    ]
  ],
  "./mi/submit_online_url_assignment.json": [
    "285804",
    [
      744436
    ]
  ],
  "./th/submit_online_url_assignment.json": [
    "333294",
    [
      15269
    ]
  ],
  "./hi/course_navigation_settings.json": [
    "810335",
    [
      261285
    ]
  ],
  "./es/assignments_2_student_annotation.json": [
    "812067",
    [
      9774
    ]
  ],
  "./ga/user_name.json": [
    "661725",
    [
      315403
    ]
  ],
  "./en-AU/blueprint_course_sidebar.json": [
    "770414",
    [
      188399
    ]
  ],
  "./ru/assignments_2_peer_review.json": [
    "936190",
    [
      858822
    ]
  ],
  "./sl/account_calendar_settings_filter_controls.json": [
    "33265",
    [
      61611
    ]
  ],
  "./ar/content_shares.json": [
    "518285",
    [
      665359
    ]
  ],
  "./en-AU/modules_page_icon_legend.json": [
    "125137",
    [
      517744
    ]
  ],
  "./pt-BR/course_paces_projected_dates.json": [
    "864074",
    [
      264235
    ]
  ],
  "./en-AU/CoursesTray.json": [
    "256430",
    [
      121007
    ]
  ],
  "./fa/nav_tourpoints.json": [
    "727194",
    [
      727930
    ]
  ],
  "./nb/outcome_reporting.json": [
    "512067",
    [
      370349
    ]
  ],
  "./en-AU/discussion_insights.json": [
    "875572",
    [
      920785
    ]
  ],
  "./el/account_notification_settings.json": [
    "303066",
    [
      231686
    ]
  ],
  "./da/rate_limiting_settings.json": [
    "79137",
    [
      842127
    ]
  ],
  "./de/eportfolio.json": [
    "891026",
    [
      927139
    ]
  ],
  "./pt-BR/grade_summaryGroupView.json": [
    "43903",
    [
      747930
    ]
  ],
  "./uk/blueprint_course_child.json": [
    "965694",
    [
      731678
    ]
  ],
  "./ht/assignment_2_assignment_toggle_details.json": [
    "482622",
    [
      699578
    ]
  ],
  "./es/account_course_user_search.json": [
    "709868",
    [
      113145
    ]
  ],
  "./fi/new_user_tutorial.json": [
    "785667",
    [
      988984
    ]
  ],
  "./da/MasteryScale.json": [
    "634302",
    [
      681150
    ]
  ],
  "./hi/outcome_reporting.json": [
    "448996",
    [
      253252
    ]
  ],
  "./is/sharedSetDefaultGradeDialog.json": [
    "377653",
    [
      896275
    ]
  ],
  "./vi/mutationActivity.json": [
    "368615",
    [
      270781
    ]
  ],
  "./fa/gradebook.json": [
    "129389",
    [
      894715
    ]
  ],
  "./hu/AddGroup.json": [
    "688573",
    [
      716179
    ]
  ],
  "./hu/plugins.json": [
    "101973",
    [
      189371
    ]
  ],
  "./id/user_grades.json": [
    "418339",
    [
      544133
    ]
  ],
  "./is/new_nav.json": [
    "400806",
    [
      736222
    ]
  ],
  "./es-ES/pairing_code_user_observees.json": [
    "253298",
    [
      281474
    ]
  ],
  "./pt/MobileGlobalMenu.json": [
    "240972",
    [
      906912
    ]
  ],
  "./hu/theme_collection_view.json": [
    "547343",
    [
      362861
    ]
  ],
  "./sl/peer_review_configuration_tray.json": [
    "840702",
    [
      736034
    ]
  ],
  "./vi/edit_section_dates.json": [
    "746419",
    [
      956737
    ]
  ],
  "./th/course_pace_date_input.json": [
    "920335",
    [
      227809
    ]
  ],
  "./ca/admin_split.json": [
    "289710",
    [
      814990
    ]
  ],
  "./en-AU/DueDateOverrideView.json": [
    "319179",
    [
      126374
    ]
  ],
  "./en/quizzes_index.json": [
    "720695",
    [
      38609
    ]
  ],
  "./ja/react_files.json": [
    "262648",
    [
      725533
    ]
  ],
  "./da/grades_summary.json": [
    "644304",
    [
      118464
    ]
  ],
  "./zh-Hant/course_restore.json": [
    "305712",
    [
      175996
    ]
  ],
  "./uk/a2LatePolicyStatusDisplay.json": [
    "495973",
    [
      654363
    ]
  ],
  "./ar/LogoutButton.json": [
    "561809",
    [
      99043
    ]
  ],
  "./nb-x-k12/calendar.header.json": [
    "968669",
    [
      477016
    ]
  ],
  "./fa/course_paces_app.json": [
    "361495",
    [
      134061
    ]
  ],
  "./nn/error_form.json": [
    "953311",
    [
      237697
    ]
  ],
  "./uk/gradingPeriodTemplate.json": [
    "977785",
    [
      124407
    ]
  ],
  "./sl/account_settings.json": [
    "644710",
    [
      319514
    ]
  ],
  "./ru/self_enrollment.json": [
    "48960",
    [
      106968
    ]
  ],
  "./en-AU/discussion_create.json": [
    "55493",
    [
      207324
    ]
  ],
  "./sl/gradingGradeSummary.json": [
    "103284",
    [
      609224
    ]
  ],
  "./zh-Hant/course_default_due_time.json": [
    "481994",
    [
      420518
    ]
  ],
  "./id/gradebook_default_gradebook_components_content_filters_module_filter.json": [
    "983285",
    [
      593695
    ]
  ],
  "./da/files_v2.json": [
    "145323",
    [
      894977
    ]
  ],
  "./tr/course_navigation_settings.json": [
    "62080",
    [
      937327
    ]
  ],
  "./zh-Hant/announcements_v2.json": [
    "169477",
    [
      769463
    ]
  ],
  "./ga/assignments_2_shared_Steps.json": [
    "649503",
    [
      216981
    ]
  ],
  "./da-x-k12/permission_button.json": [
    "254451",
    [
      425365
    ]
  ],
  "./nb-x-k12/entity_search_form.json": [
    "92139",
    [
      185417
    ]
  ],
  "./is/ai_experiences_edit.json": [
    "655867",
    [
      105209
    ]
  ],
  "./sv-x-k12/webcam_modal.json": [
    "24284",
    [
      302140
    ]
  ],
  "./zh-Hant/course_logging_details.json": [
    "553110",
    [
      597178
    ]
  ],
  "./hi/assignments_2_MoreOptions_CanvasFiles.json": [
    "179204",
    [
      129460
    ]
  ],
  "./sl/sharedCurveGradesDialog.json": [
    "846713",
    [
      189219
    ]
  ],
  "./ca.eager.json": [
    "681523",
    [
      595558
    ]
  ],
  "./is/moderate_quiz.json": [
    "395229",
    [
      67691
    ]
  ],
  "./nn/bulk_edit_students_table.json": [
    "100923",
    [
      777037
    ]
  ],
  "./fa/course_paces_assignment_row.json": [
    "726742",
    [
      468334
    ]
  ],
  "./ko/moderate_quiz.json": [
    "513527",
    [
      543125
    ]
  ],
  "./pt-BR/copy_warnings_modal.json": [
    "169498",
    [
      513291
    ]
  ],
  "./sv/assignments_2_submission_helpers.json": [
    "541707",
    [
      607005
    ]
  ],
  "./id/edit_section_end_date.json": [
    "972216",
    [
      565092
    ]
  ],
  "./ga/course_statistics.json": [
    "472303",
    [
      267093
    ]
  ],
  "./es/appt_calendar_event_dialog.json": [
    "343742",
    [
      826479
    ]
  ],
  "./hi/gradingPeriodTemplate.json": [
    "770826",
    [
      156458
    ]
  ],
  "./es/peer_review_allocation_rule_card.json": [
    "603740",
    [
      780585
    ]
  ],
  "./pl/course_statistics.json": [
    "658699",
    [
      421549
    ]
  ],
  "./ga/notebook.json": [
    "170087",
    [
      117661
    ]
  ],
  "./nb-x-k12/course_paces_no_results.json": [
    "968213",
    [
      310867
    ]
  ],
  "./hy/account_calendar_settings_account_list.json": [
    "379660",
    [
      106908
    ]
  ],
  "./nb/permissions_role_tray.json": [
    "554772",
    [
      39760
    ]
  ],
  "./vi/permissions_v2.json": [
    "637196",
    [
      917772
    ]
  ],
  "./nb/manage_avatars.json": [
    "537456",
    [
      369044
    ]
  ],
  "./ht/link_to_students.json": [
    "971719",
    [
      42961
    ]
  ],
  "./en-CA/ImportConfirmBox.json": [
    "897946",
    [
      354890
    ]
  ],
  "./fr/security_panel.json": [
    "723469",
    [
      864616
    ]
  ],
  "./nb-x-k12/suppress_notifications.json": [
    "616732",
    [
      86716
    ]
  ],
  "./el/filter_calendars_modal.json": [
    "184209",
    [
      323019
    ]
  ],
  "./id/gradebook_uploads.json": [
    "131748",
    [
      445160
    ]
  ],
  "./hu/remove_pace_warning_modal.json": [
    "261110",
    [
      478262
    ]
  ],
  "./pt-BR/todos_page.json": [
    "231084",
    [
      330705
    ]
  ],
  "./th/quizzes_index.json": [
    "229700",
    [
      375888
    ]
  ],
  "./cy/account_settings_jsx_bundle.json": [
    "874926",
    [
      531390
    ]
  ],
  "./nb/CommentLibrary.json": [
    "442542",
    [
      327042
    ]
  ],
  "./hi/assignments_2_submission_helpers.json": [
    "168421",
    [
      239955
    ]
  ],
  "./pt-BR/unpublished_warning_modal.json": [
    "249373",
    [
      837308
    ]
  ],
  "./sv/assignments_2_MoreOptions.json": [
    "197534",
    [
      390730
    ]
  ],
  "./nb/calculator_command.json": [
    "953212",
    [
      51032
    ]
  ],
  "./fr/quizzes_openModerateStudentDialog.json": [
    "562044",
    [
      329981
    ]
  ],
  "./vi/plugins.json": [
    "827819",
    [
      624265
    ]
  ],
  "./en-GB-x-ukhe/permissions_v2_add_tray.json": [
    "437038",
    [
      9878
    ]
  ],
  "./vi/gradebook_uploads.json": [
    "866372",
    [
      800196
    ]
  ],
  "./da/CreateEditAssignmentModal.json": [
    "609631",
    [
      134669
    ]
  ],
  "./en-AU/ProfileTray.json": [
    "827325",
    [
      804596
    ]
  ],
  "./hi/course_paces_projected_dates.json": [
    "66064",
    [
      386072
    ]
  ],
  "./th/sis_import.json": [
    "685897",
    [
      920643
    ]
  ],
  "./zh-Hant/course_stats.json": [
    "564845",
    [
      402079
    ]
  ],
  "./da-x-k12/account_calendar_settings_account_group.json": [
    "608497",
    [
      134315
    ]
  ],
  "./es-ES/choose_mastery_path.json": [
    "149196",
    [
      625164
    ]
  ],
  "./es/course_paces_blueprint_lock.json": [
    "708538",
    [
      946803
    ]
  ],
  "./pt/user_name.json": [
    "715097",
    [
      130763
    ]
  ],
  "./de/react_scheduler.json": [
    "255756",
    [
      173025
    ]
  ],
  "./ht/ProfileTray.json": [
    "298675",
    [
      67717
    ]
  ],
  "./es-ES/theme_editor.json": [
    "109950",
    [
      540486
    ]
  ],
  "./es-ES/auth_logging.json": [
    "824845",
    [
      883979
    ]
  ],
  "./fa/course_color_selector.json": [
    "998916",
    [
      534116
    ]
  ],
  "./ru/conversations_2.json": [
    "162002",
    [
      879285
    ]
  ],
  "./cy/course_paces_blackout_date_row.json": [
    "17350",
    [
      810054
    ]
  ],
  "./he/course_paces_time_selection.json": [
    "152178",
    [
      315338
    ]
  ],
  "./is/course_paces_flaggable_number_input.json": [
    "631451",
    [
      60281
    ]
  ],
  "./vi/bulk_edit_students_actions.json": [
    "523419",
    [
      994617
    ]
  ],
  "./zh-Hant/plugins.json": [
    "403196",
    [
      249144
    ]
  ],
  "./sv/upload_button.json": [
    "462885",
    [
      804543
    ]
  ],
  "./en-GB/bulk_edit_students_actions.json": [
    "560903",
    [
      723966
    ]
  ],
  "./da-x-k12/assignments_2_student_content.json": [
    "10234",
    [
      138822
    ]
  ],
  "./ko/course_paces_footer.json": [
    "595880",
    [
      57608
    ]
  ],
  "./ms/course_paces_settings.json": [
    "195644",
    [
      467076
    ]
  ],
  "./es/link_validator.json": [
    "868371",
    [
      153630
    ]
  ],
  "./fr/assignments_2_shared_Steps.json": [
    "586859",
    [
      566330
    ]
  ],
  "./ja/permissions_role_tray_table_row.json": [
    "109457",
    [
      829968
    ]
  ],
  "./he/assignment_grade_summary.json": [
    "18485",
    [
      598811
    ]
  ],
  "./hu/assignments.never_drop.json": [
    "121877",
    [
      993872
    ]
  ],
  "./el/student_groups.json": [
    "758861",
    [
      40783
    ]
  ],
  "./hy/course_paces_actions.json": [
    "666957",
    [
      889931
    ]
  ],
  "./nl/assignments_2_media_attempt.json": [
    "127578",
    [
      747590
    ]
  ],
  "./el/sharedSetDefaultGradeDialog.json": [
    "770652",
    [
      167904
    ]
  ],
  "./fa/course_paces_blackout_dates_modal.json": [
    "934965",
    [
      372691
    ]
  ],
  "./sv/accessibility_checker.json": [
    "661843",
    [
      995261
    ]
  ],
  "./es/course_paces_app.json": [
    "843168",
    [
      100469
    ]
  ],
  "./zh-Hans/student_study_drawer.json": [
    "133212",
    [
      141644
    ]
  ],
  "./en-GB-x-lbs/eportfolio.json": [
    "892801",
    [
      303911
    ]
  ],
  "./uk/quiz_statistics.json": [
    "301547",
    [
      518241
    ]
  ],
  "./pt/lti_registrations.json": [
    "662496",
    [
      967740
    ]
  ],
  "./is/AssignmentListItemView.json": [
    "999841",
    [
      232455
    ]
  ],
  "./cy/overview_page.json": [
    "20677",
    [
      824043
    ]
  ],
  "./tr/assignments_2_shared_Steps.json": [
    "323265",
    [
      115059
    ]
  ],
  "./fa/dashboard.json": [
    "540683",
    [
      244729
    ]
  ],
  "./en-AU/video_conference.json": [
    "877650",
    [
      86619
    ]
  ],
  "./nl/ai_experiences_edit.json": [
    "380213",
    [
      589767
    ]
  ],
  "./sv-x-k12/react_files.json": [
    "546058",
    [
      90586
    ]
  ],
  "./en-AU-x-unimelb/course_paces_change_tracking.json": [
    "602479",
    [
      46073
    ]
  ],
  "./zh-Hans/gradebook_uploads.json": [
    "845210",
    [
      929978
    ]
  ],
  "./fr-CA/submit_assignment.json": [
    "969383",
    [
      805049
    ]
  ],
  "./en-AU-x-unimelb/user_name.json": [
    "247241",
    [
      760883
    ]
  ],
  "./pt-BR/login.json": [
    "580486",
    [
      648815
    ]
  ],
  "./pl/quizzes_public.json": [
    "542909",
    [
      846711
    ]
  ],
  "./pl/default_account_quotas.json": [
    "65613",
    [
      817063
    ]
  ],
  "./ht/nav_tourpoints.json": [
    "643421",
    [
      720007
    ]
  ],
  "./id/moderate_quiz.json": [
    "35732",
    [
      675896
    ]
  ],
  "./fa/webzip_export.json": [
    "471371",
    [
      104713
    ]
  ],
  "./es-ES/CoursesTray.json": [
    "24789",
    [
      656371
    ]
  ],
  "./ko/submit_assignment.json": [
    "685624",
    [
      336728
    ]
  ],
  "./ru/HelpTray.json": [
    "117058",
    [
      801330
    ]
  ],
  "./ga/todo.json": [
    "599498",
    [
      426154
    ]
  ],
  "./vi/assignment_index.json": [
    "280475",
    [
      53177
    ]
  ],
  "./nn/group_submission_reminder.json": [
    "498725",
    [
      230039
    ]
  ],
  "./fi/ldap_cert_upload.json": [
    "921221",
    [
      862195
    ]
  ],
  "./nb/pairing_code_user_observees.json": [
    "36779",
    [
      978029
    ]
  ],
  "./fa/empty_modules.json": [
    "694356",
    [
      544372
    ]
  ],
  "./ru/assignment_index_menu.json": [
    "185651",
    [
      626609
    ]
  ],
  "./is/progressbar_view.json": [
    "381682",
    [
      698738
    ]
  ],
  "./cy/quizzes_regrade_modal.json": [
    "573778",
    [
      397450
    ]
  ],
  "./mi/license_help.json": [
    "973131",
    [
      325713
    ]
  ],
  "./ja/todo.json": [
    "353077",
    [
      795500
    ]
  ],
  "./sv/unpublished_changes_button_props.json": [
    "485038",
    [
      811530
    ]
  ],
  "./cy/admin_split.json": [
    "55798",
    [
      467798
    ]
  ],
  "./da-x-k12/quiz_migration_notifications.json": [
    "763240",
    [
      632228
    ]
  ],
  "./nl/lti_registration.wizard.json": [
    "220898",
    [
      555985
    ]
  ],
  "./en-GB-x-ukhe/blueprint_settingsMigrationSync.json": [
    "442152",
    [
      462448
    ]
  ],
  "./en-AU/user_lists.json": [
    "111341",
    [
      147108
    ]
  ],
  "./nb/account_calendar_settings_account_tree.json": [
    "235989",
    [
      78343
    ]
  ],
  "./id/job_stats.json": [
    "249224",
    [
      552852
    ]
  ],
  "./nl/assignments_2_file_upload.json": [
    "778566",
    [
      221666
    ]
  ],
  "./fi/HelpTray.json": [
    "321218",
    [
      549666
    ]
  ],
  "./id/unpublished_changes_button_props.json": [
    "741370",
    [
      13318
    ]
  ],
  "./nb/DueDateOverrideView.json": [
    "136233",
    [
      490891
    ]
  ],
  "./ms/filter_calendars_modal.json": [
    "213866",
    [
      992690
    ]
  ],
  "./is/peer_review_allocation_rule_card.json": [
    "584296",
    [
      49424
    ]
  ],
  "./nb-x-k12/SpeedGraderSettingsMenu.json": [
    "588822",
    [
      873854
    ]
  ],
  "./fi/assignmentsToggleShowByView.json": [
    "48536",
    [
      283952
    ]
  ],
  "./nb-x-k12/password_complexity_configuration.json": [
    "678603",
    [
      356073
    ]
  ],
  "./el/copy_warnings_modal.json": [
    "350750",
    [
      827754
    ]
  ],
  "./da-x-k12/internal-settings.json": [
    "273522",
    [
      415854
    ]
  ],
  "./ht/new_user_tutorial.json": [
    "360705",
    [
      838835
    ]
  ],
  "./pt/AccountsTray.json": [
    "290786",
    [
      891726
    ]
  ],
  "./ht/todo.json": [
    "393798",
    [
      317666
    ]
  ],
  "./ja/account_calendar_settings_account_calendar_item.json": [
    "672990",
    [
      386111
    ]
  ],
  "./cy/available_pronouns_list.json": [
    "286055",
    [
      166197
    ]
  ],
  "./fr/eportfolio.json": [
    "721555",
    [
      369202
    ]
  ],
  "./zh-Hans/permissions_v2_add_tray.json": [
    "932483",
    [
      958433
    ]
  ],
  "./nb/ai_experiences.json": [
    "783506",
    [
      901254
    ]
  ],
  "./ga/course_paces_projected_dates.json": [
    "944521",
    [
      826095
    ]
  ],
  "./ar/assignment_2_assignment_toggle_details.json": [
    "248819",
    [
      415749
    ]
  ],
  "./he/course_paces_search.json": [
    "522434",
    [
      198938
    ]
  ],
  "./hi/assignments_2_peer_review.json": [
    "909032",
    [
      42512
    ]
  ],
  "./fr-CA/default_account_quotas.json": [
    "161390",
    [
      593378
    ]
  ],
  "./nb/conversations_2.json": [
    "423555",
    [
      112541
    ]
  ],
  "./en-GB/unpublished_warning_modal.json": [
    "372617",
    [
      962892
    ]
  ],
  "./ca/self_unenrollment_modal.json": [
    "177052",
    [
      355796
    ]
  ],
  "./de/epub_exports.json": [
    "965817",
    [
      197888
    ]
  ],
  "./sv-x-k12/canvas_file_upload.json": [
    "534790",
    [
      369694
    ]
  ],
  "./ru/a2LatePolicyStatusDisplay.json": [
    "578768",
    [
      855112
    ]
  ],
  "./ga/assignments.json": [
    "311152",
    [
      468152
    ]
  ],
  "./ms/course_search_results.json": [
    "184789",
    [
      41147
    ]
  ],
  "./en-GB-x-ukhe/user_profile.json": [
    "65909",
    [
      422323
    ]
  ],
  "./fr-CA/blueprint_course_child.json": [
    "241514",
    [
      863615
    ]
  ],
  "./sv/course_color_selector.json": [
    "830864",
    [
      38828
    ]
  ],
  "./uk/editAssignmentGroupWeights.json": [
    "734371",
    [
      476841
    ]
  ],
  "./it/course_paces_blackout_dates_table.json": [
    "917444",
    [
      430312
    ]
  ],
  "./ko/quiz_log_auditing.json": [
    "466824",
    [
      460648
    ]
  ],
  "./pl/quiz_show.json": [
    "220941",
    [
      213815
    ]
  ],
  "./pt/internal-settings.json": [
    "205307",
    [
      862445
    ]
  ],
  "./hi/lti_registrations.json": [
    "808915",
    [
      457585
    ]
  ],
  "./ga/context_modules_v2.json": [
    "802760",
    [
      347408
    ]
  ],
  "./mi/blueprint_settingsMigrationSync.json": [
    "341004",
    [
      974388
    ]
  ],
  "./ar/edit_section_view.json": [
    "302057",
    [
      687115
    ]
  ],
  "./fa/calculator.json": [
    "799377",
    [
      94615
    ]
  ],
  "./nb-x-k12/webcam_modal.json": [
    "943259",
    [
      793641
    ]
  ],
  "./en-GB-x-lbs/terms_index.json": [
    "59872",
    [
      991992
    ]
  ],
  "./id/account_course_user_search.json": [
    "637707",
    [
      8061
    ]
  ],
  "./sv/new_user_tutorial.json": [
    "903980",
    [
      429656
    ]
  ],
  "./en-GB-x-ukhe/question_bank.json": [
    "938379",
    [
      737273
    ]
  ],
  "./ht/assignments_2_url_entry.json": [
    "700840",
    [
      680812
    ]
  ],
  "./fa/conferences.json": [
    "719536",
    [
      21160
    ]
  ],
  "./en-GB-x-lbs/add_edit_pseudonym.json": [
    "285989",
    [
      132531
    ]
  ],
  "./nn/permissions_role_tray_table_row.json": [
    "301516",
    [
      171912
    ]
  ],
  "./pt-BR/account_calendars.json": [
    "578152",
    [
      467909
    ]
  ],
  "./de/course_paces_blackout_date_row.json": [
    "627815",
    [
      460530
    ]
  ],
  "./mi/canvas_file_upload.json": [
    "293249",
    [
      319039
    ]
  ],
  "./hy/a2LatePolicyToolTipContent.json": [
    "391502",
    [
      793318
    ]
  ],
  "./mi/assignmentsIndexView.json": [
    "798711",
    [
      676869
    ]
  ],
  "./zh-Hant/user.json": [
    "503487",
    [
      678169
    ]
  ],
  "./da-x-k12/job_stats.json": [
    "267260",
    [
      156304
    ]
  ],
  "./pt/content_share_preview_overlay.json": [
    "55351",
    [
      505369
    ]
  ],
  "./el/dashboard_grading_period_select.json": [
    "12421",
    [
      288247
    ]
  ],
  "./pl/group_submission_reminder.json": [
    "850073",
    [
      902315
    ]
  ],
  "./ca/account_calendar_settings_filter_controls.json": [
    "369182",
    [
      5182
    ]
  ],
  "./he/MoveOutcomesModal.json": [
    "266480",
    [
      737296
    ]
  ],
  "./ru/assignmentsIndexView.json": [
    "937894",
    [
      757774
    ]
  ],
  "./sl/MobileNavigation.json": [
    "110695",
    [
      424937
    ]
  ],
  "./mi/file_not_found.json": [
    "572335",
    [
      572397
    ]
  ],
  "./en-GB/epub_exports.json": [
    "635451",
    [
      901666
    ]
  ],
  "./nl/files_v2.json": [
    "653944",
    [
      607956
    ]
  ],
  "./uk/content_copy_redesign.json": [
    "592865",
    [
      511023
    ]
  ],
  "./zh-Hans/gradinggradingPeriodCollection.json": [
    "528210",
    [
      176626
    ]
  ],
  "./tr/course_statistics.json": [
    "697001",
    [
      772163
    ]
  ],
  "./pt/password_complexity_configuration.json": [
    "753885",
    [
      858711
    ]
  ],
  "./es-ES/ignite_agent.json": [
    "698293",
    [
      173491
    ]
  ],
  "./ca/theme_collection_view.json": [
    "763416",
    [
      917400
    ]
  ],
  "./th/wiki_page_index.json": [
    "403107",
    [
      530973
    ]
  ],
  "./fr/widget_dashboard.json": [
    "30345",
    [
      169212
    ]
  ],
  "./es-ES/edit_section_end_date.json": [
    "788440",
    [
      196096
    ]
  ],
  "./fi/gradebook_uploads.json": [
    "919028",
    [
      334228
    ]
  ],
  "./ht/module_sequence_footer.json": [
    "931500",
    [
      850336
    ]
  ],
  "./nl/assignmentsToggleShowByView.json": [
    "798223",
    [
      945041
    ]
  ],
  "./ht/course_paces_blackout_dates_table.json": [
    "85645",
    [
      289031
    ]
  ],
  "./de/MasteryScale.json": [
    "414066",
    [
      145187
    ]
  ],
  "./ht/peer_review_configuration_tray.json": [
    "169243",
    [
      177309
    ]
  ],
  "./is/custom_help_link.json": [
    "585022",
    [
      733670
    ]
  ],
  "./sl/permission_button.json": [
    "526693",
    [
      775767
    ]
  ],
  "./da-x-k12/ai_experiences_show.json": [
    "541791",
    [
      762657
    ]
  ],
  "./sv-x-k12/assignments.json": [
    "545015",
    [
      180797
    ]
  ],
  "./ms/self_unenrollment_modal.json": [
    "646236",
    [
      59076
    ]
  ],
  "./sl/lti_registration.wizard.json": [
    "713483",
    [
      440466
    ]
  ],
  "./ht/assignments_2_initial_query.json": [
    "454749",
    [
      891303
    ]
  ],
  "./hu/last_attended.json": [
    "641513",
    [
      560983
    ]
  ],
  "./hy/CommentLibrary.json": [
    "438131",
    [
      505345
    ]
  ],
  "./sv-x-k12/permission_button.json": [
    "712061",
    [
      991115
    ]
  ],
  "./es-ES/calculator_command.json": [
    "207199",
    [
      616485
    ]
  ],
  "./tr/module_sequence_footer.json": [
    "543090",
    [
      487158
    ]
  ],
  "./tr/copy_course.json": [
    "149319",
    [
      627809
    ]
  ],
  "./tr/blueprint_settingsMigrationSync.json": [
    "584828",
    [
      814048
    ]
  ],
  "./de/Navigation.json": [
    "284101",
    [
      424036
    ]
  ],
  "./hy/content_share_preview_overlay.json": [
    "193864",
    [
      522912
    ]
  ],
  "./fr-CA/course_paces_modal.json": [
    "477925",
    [
      555703
    ]
  ],
  "./hi/announcements_v2.json": [
    "498858",
    [
      329962
    ]
  ],
  "./he/gradinggradingPeriodCollection.json": [
    "462070",
    [
      937398
    ]
  ],
  "./fr/calendar_custom_recurring_event_repeat_picker.json": [
    "656124",
    [
      887821
    ]
  ],
  "./ga/GroupDetailView.json": [
    "847549",
    [
      691099
    ]
  ],
  "./da/lti_registrations.json": [
    "525839",
    [
      736317
    ]
  ],
  "./de/assignment_grade_summary.json": [
    "80561",
    [
      773816
    ]
  ],
  "./he/users.json": [
    "666285",
    [
      72131
    ]
  ],
  "./ru/course_paces_time_selection.json": [
    "201696",
    [
      401848
    ]
  ],
  "./he/bounced_emails.json": [
    "271715",
    [
      423801
    ]
  ],
  "./ht/quizzes.take_quiz.json": [
    "30548",
    [
      633173
    ]
  ],
  "./ru/sharedCurveGradesDialog.json": [
    "647231",
    [
      343957
    ]
  ],
  "./hu/NewTabIndicator.json": [
    "486375",
    [
      191029
    ]
  ],
  "./pt-BR/quantitative_data_options.json": [
    "484074",
    [
      612747
    ]
  ],
  "./cy/suppress_notifications.json": [
    "824150",
    [
      489526
    ]
  ],
  "./mi/bulk_edit_students_table.json": [
    "269601",
    [
      987135
    ]
  ],
  "./he/new_nav.json": [
    "582933",
    [
      403515
    ]
  ],
  "./en-AU-x-unimelb/blueprint_settingsCoursePickerTable.json": [
    "509784",
    [
      218388
    ]
  ],
  "./nb/last_attended.json": [
    "695958",
    [
      237306
    ]
  ],
  "./ca/AlignmentSummary.json": [
    "719837",
    [
      753123
    ]
  ],
  "./de/assignments_bulk_edit.json": [
    "159481",
    [
      459184
    ]
  ],
  "./fi/conferences.json": [
    "786456",
    [
      359520
    ]
  ],
  "./hi/course_paces_assignment_row.json": [
    "106484",
    [
      416020
    ]
  ],
  "./ko/quiz_statistics.json": [
    "469273",
    [
      288503
    ]
  ],
  "./tr/permissions_role_tray.json": [
    "808706",
    [
      170574
    ]
  ],
  "./vi/grade_summaryGroupView.json": [
    "911007",
    [
      163285
    ]
  ],
  "./is/lti_registration.wizard.json": [
    "246844",
    [
      946787
    ]
  ],
  "./cy/group_submission_reminder.json": [
    "554473",
    [
      203639
    ]
  ],
  "./is/course_statistics.json": [
    "493719",
    [
      204429
    ]
  ],
  "./cy/grades_summary.json": [
    "401837",
    [
      944483
    ]
  ],
  "./cy/dashboard_grading_period_select.json": [
    "400224",
    [
      459296
    ]
  ],
  "./en-GB-x-ukhe/assignmentsToggleShowByView.json": [
    "280039",
    [
      837245
    ]
  ],
  "./pt/k5_course.json": [
    "730198",
    [
      975938
    ]
  ],
  "./hy/nav_tourpoints.json": [
    "232048",
    [
      387672
    ]
  ],
  "./ht/dashboard_grading_period_select.json": [
    "897536",
    [
      507052
    ]
  ],
  "./he/discussion_pinned_post.json": [
    "191069",
    [
      271507
    ]
  ],
  "./fa/horizon_toggle.json": [
    "812033",
    [
      621735
    ]
  ],
  "./ja/syllabus_revisions.json": [
    "865967",
    [
      571826
    ]
  ],
  "./hy/users.json": [
    "798233",
    [
      944063
    ]
  ],
  "./it/course_default_due_time.json": [
    "972989",
    [
      301263
    ]
  ],
  "./es/paginated_list.json": [
    "223870",
    [
      828079
    ]
  ],
  "./ko/discovery_page.json": [
    "223052",
    [
      277540
    ]
  ],
  "./es-ES/assignments_2_url_entry.json": [
    "774241",
    [
      630423
    ]
  ],
  "./it/course_navigation_settings.json": [
    "114965",
    [
      203887
    ]
  ],
  "./ht/account_calendar_settings_account_tree.json": [
    "599221",
    [
      882247
    ]
  ],
  "./ko/permissions_role_tray.json": [
    "935102",
    [
      580158
    ]
  ],
  "./pt/notebook.json": [
    "756891",
    [
      103069
    ]
  ],
  "./ar/admin_split.json": [
    "311421",
    [
      4631
    ]
  ],
  "./sv-x-k12/error_form.json": [
    "50410",
    [
      905530
    ]
  ],
  "./it/course_paces_app.json": [
    "640495",
    [
      410289
    ]
  ],
  "./nn/course_search_results.json": [
    "201062",
    [
      581091
    ]
  ],
  "./sv/video_conference.json": [
    "769315",
    [
      233845
    ]
  ],
  "./sv/AssignmentGroupListItemView.json": [
    "157661",
    [
      342319
    ]
  ],
  "./fi/assignments_2_initial_query.json": [
    "807576",
    [
      98208
    ]
  ],
  "./th/assignments_2_student_header_date_title.json": [
    "937434",
    [
      502703
    ]
  ],
  "./ko/self_enrollment.json": [
    "432807",
    [
      268485
    ]
  ],
  "./zh-Hans/course_paces_footer.json": [
    "592385",
    [
      820263
    ]
  ],
  "./ga/account_calendar_settings.json": [
    "988236",
    [
      180604
    ]
  ],
  "./ga/SpeedGraderSettingsMenu.json": [
    "37308",
    [
      590700
    ]
  ],
  "./fa/content_shares.json": [
    "478543",
    [
      209333
    ]
  ],
  "./da/accessibility_course_statistics.json": [
    "374759",
    [
      502085
    ]
  ],
  "./is/gradebookActionMenu.json": [
    "300605",
    [
      398683
    ]
  ],
  "./fa/quizzes_index.json": [
    "432713",
    [
      827631
    ]
  ],
  "./fr/nav_tourpoints.json": [
    "255317",
    [
      447424
    ]
  ],
  "./th/course_paces_modal.json": [
    "112846",
    [
      763770
    ]
  ],
  "./nb-x-k12/assignments_2_student_header.json": [
    "470885",
    [
      366035
    ]
  ],
  "./nn/react_files.json": [
    "741089",
    [
      517019
    ]
  ],
  "./sl/important_dates_empty.json": [
    "535163",
    [
      937781
    ]
  ],
  "./en-GB-x-ukhe/peer_review_allocation_rules_tray.json": [
    "795301",
    [
      526083
    ]
  ],
  "./es-ES/gradebook.json": [
    "642021",
    [
      43571
    ]
  ],
  "./nb/submissions_show_preview.json": [
    "444258",
    [
      85894
    ]
  ],
  "./vi/lti_registration.wizard.json": [
    "180469",
    [
      336812
    ]
  ],
  "./he/direct_share_course_import_panel.json": [
    "687172",
    [
      974245
    ]
  ],
  "./nb/auth_logging.json": [
    "260914",
    [
      70606
    ]
  ],
  "./ar/sharedSetDefaultGradeDialog.json": [
    "952786",
    [
      330262
    ]
  ],
  "./fr-CA/new_user_tutorial.json": [
    "563964",
    [
      337320
    ]
  ],
  "./cy/context_prior_users.json": [
    "232097",
    [
      214495
    ]
  ],
  "./en-GB-x-ukhe/course_paces_blueprint_lock.json": [
    "628020",
    [
      188404
    ]
  ],
  "./es-ES/collaborations.json": [
    "447415",
    [
      487581
    ]
  ],
  "./pt/epub_exports.json": [
    "558396",
    [
      27296
    ]
  ],
  "./nb/account_calendar_settings_confirmation_modal.json": [
    "109174",
    [
      316290
    ]
  ],
  "./th/CommentLibrary.json": [
    "903702",
    [
      294922
    ]
  ],
  "./zh-Hans/conferences.json": [
    "740194",
    [
      853218
    ]
  ],
  "./en-AU/user_name.json": [
    "258619",
    [
      578902
    ]
  ],
  "./nb-x-k12/accessibility_scan.json": [
    "318084",
    [
      304004
    ]
  ],
  "./nb-x-k12/conversations_2.json": [
    "674457",
    [
      879087
    ]
  ],
  "./hi/assignments_2_shared_Steps.json": [
    "750454",
    [
      400830
    ]
  ],
  "./sv/MobileGlobalMenu.json": [
    "85279",
    [
      957689
    ]
  ],
  "./cy/rate_limiting_settings.json": [
    "54892",
    [
      518548
    ]
  ],
  "./pt/blueprint_settingsCoursePickerTable.json": [
    "504328",
    [
      500380
    ]
  ],
  "./hu/calendar.header.json": [
    "750104",
    [
      778539
    ]
  ],
  "./ar/assignments_bulk_edit_use_save_assignment.json": [
    "35909",
    [
      542271
    ]
  ],
  "./da/conferences.json": [
    "948166",
    [
      857814
    ]
  ],
  "./ja/assignments_2_MoreOptions_CanvasFiles.json": [
    "348582",
    [
      530727
    ]
  ],
  "./is/NewTabIndicator.json": [
    "355964",
    [
      842428
    ]
  ],
  "./nb-x-k12/question_bank.json": [
    "793703",
    [
      149725
    ]
  ],
  "./ja/canvascareer.json": [
    "38651",
    [
      227702
    ]
  ],
  "./el/ImportConfirmBox.json": [
    "255181",
    [
      393567
    ]
  ],
  "./mi/assignments_2_text_entry.json": [
    "297108",
    [
      733292
    ]
  ],
  "./el/assignments_2_external_tool.json": [
    "463825",
    [
      943363
    ]
  ],
  "./fr-CA/user_profile.json": [
    "591412",
    [
      576064
    ]
  ],
  "./da-x-k12/webzip_export.json": [
    "583463",
    [
      600369
    ]
  ],
  "./en-AU-x-unimelb/assignments_2_file_upload.json": [
    "272680",
    [
      429780
    ]
  ],
  "./en-AU-x-unimelb/gradebook.json": [
    "816768",
    [
      278372
    ]
  ],
  "./hy/jobs_v2.json": [
    "858184",
    [
      878803
    ]
  ],
  "./is/react_collaborations.json": [
    "524772",
    [
      892340
    ]
  ],
  "./ga/assignments_2_student_annotation.json": [
    "325207",
    [
      408061
    ]
  ],
  "./nb-x-k12/ai_experiences_edit.json": [
    "587489",
    [
      429783
    ]
  ],
  "./nl/course_paces_module.json": [
    "589583",
    [
      388729
    ]
  ],
  "./pt/file_not_found.json": [
    "550649",
    [
      307147
    ]
  ],
  "./sl/knowledge_check_not_ready.json": [
    "924752",
    [
      213556
    ]
  ],
  "./ca/GroupDetailView.json": [
    "43225",
    [
      148055
    ]
  ],
  "./mi/new_user_tutorial.json": [
    "547051",
    [
      226225
    ]
  ],
  "./en-AU/blueprint_settingsCoursePicker.json": [
    "710006",
    [
      334871
    ]
  ],
  "./ar/course_logging_details.json": [
    "757289",
    [
      457835
    ]
  ],
  "./fa/course_paces_settings.json": [
    "618197",
    [
      604691
    ]
  ],
  "./pl/assignments_2_external_tool.json": [
    "990204",
    [
      486584
    ]
  ],
  "./de/assignments_2_MoreOptions.json": [
    "621520",
    [
      111773
    ]
  ],
  "./ga/bulk_edit_students_table.json": [
    "125115",
    [
      802297
    ]
  ],
  "./el/internal-settings.json": [
    "218490",
    [
      985998
    ]
  ],
  "./en-GB-x-lbs/account_settings.json": [
    "950041",
    [
      841039
    ]
  ],
  "./ht/LogoutButton.json": [
    "353888",
    [
      848548
    ]
  ],
  "./hu/new_user_tutorial.json": [
    "741038",
    [
      102686
    ]
  ],
  "./mi/section.json": [
    "681931",
    [
      275089
    ]
  ],
  "./nb/course_logging_details.json": [
    "755128",
    [
      475580
    ]
  ],
  "./ja/context_prior_users.json": [
    "218904",
    [
      101117
    ]
  ],
  "./ru/group_submission_reminder.json": [
    "949224",
    [
      298944
    ]
  ],
  "./tr/outcome_alignment_v2.json": [
    "750279",
    [
      393089
    ]
  ],
  "./el/content_migrations.json": [
    "408630",
    [
      786066
    ]
  ],
  "./zh-Hans/video_conference.json": [
    "689885",
    [
      74299
    ]
  ],
  "./hi/mutationActivity.json": [
    "847253",
    [
      715987
    ]
  ],
  "./is/course_pace_date_input.json": [
    "298331",
    [
      874969
    ]
  ],
  "./nl/blueprint_coursesExpandableLockOptions.json": [
    "427205",
    [
      210703
    ]
  ],
  "./ca/gradebookOutcomeGradebookView.json": [
    "733935",
    [
      460861
    ]
  ],
  "./pt/course_stats.json": [
    "868779",
    [
      23373
    ]
  ],
  "./nl/discussion_posts.json": [
    "241748",
    [
      439624
    ]
  ],
  "./ru/module_student_view_peer_reviews.json": [
    "558502",
    [
      916590
    ]
  ],
  "./uk/course_paces_pace_picker.json": [
    "150181",
    [
      390491
    ]
  ],
  "./id/youtube_migration.json": [
    "370633",
    [
      718907
    ]
  ],
  "./ca/roster_section_selector.json": [
    "94959",
    [
      61053
    ]
  ],
  "./ht/eportfolio.json": [
    "197707",
    [
      647013
    ]
  ],
  "./zh-Hant/grade_summaryGroupView.json": [
    "240702",
    [
      313378
    ]
  ],
  "./da-x-k12/outcomes_user_outcome_results.json": [
    "723176",
    [
      846604
    ]
  ],
  "./cy/user_search_results.json": [
    "55035",
    [
      167521
    ]
  ],
  "./nl/notebook.json": [
    "787813",
    [
      12991
    ]
  ],
  "./sl/assignments_2_external_tool.json": [
    "669815",
    [
      545585
    ]
  ],
  "./pt-BR/assignments.json": [
    "882573",
    [
      706316
    ]
  ],
  "./ja/discussion_posts.json": [
    "961141",
    [
      525695
    ]
  ],
  "./de/module_sequence_footer.json": [
    "161417",
    [
      398048
    ]
  ],
  "./nb-x-k12/epub_exports.json": [
    "693630",
    [
      554006
    ]
  ],
  "./tr/account_calendars_modal.json": [
    "929241",
    [
      370267
    ]
  ],
  "./vi/outcome_detail.json": [
    "979057",
    [
      641543
    ]
  ],
  "./da/add_edit_pseudonym.json": [
    "350350",
    [
      523854
    ]
  ],
  "./hi/theme_collection_view.json": [
    "623803",
    [
      827369
    ]
  ],
  "./de/terms_of_use.json": [
    "702474",
    [
      416299
    ]
  ],
  "./mi/blueprint_settingsMigrationOptions.json": [
    "944895",
    [
      265469
    ]
  ],
  "./mi/user_date_range_search.json": [
    "292659",
    [
      721449
    ]
  ],
  "./ar/Navigation.json": [
    "645085",
    [
      290351
    ]
  ],
  "./de/theme_editor.json": [
    "993416",
    [
      782165
    ]
  ],
  "./en-GB-x-ukhe/accessibility_course_statistics.json": [
    "457230",
    [
      210502
    ]
  ],
  "./hy/appt_calendar_event_dialog.json": [
    "545171",
    [
      599457
    ]
  ],
  "./sl/media_immersive_view.json": [
    "375391",
    [
      142649
    ]
  ],
  "./nb-x-k12/react_scheduler.json": [
    "865917",
    [
      334443
    ]
  ],
  "./sv-x-k12/module_sequence_footer.json": [
    "531713",
    [
      936807
    ]
  ],
  "./sl/a2_AccessibleTipContent.json": [
    "379849",
    [
      945355
    ]
  ],
  "./vi/module_sequence_footer.json": [
    "108131",
    [
      612689
    ]
  ],
  "./en-AU/gradingGradeSummary.json": [
    "21385",
    [
      214696
    ]
  ],
  "./ht/ai_experiences_edit.json": [
    "344119",
    [
      622761
    ]
  ],
  "./he/pairing_code_user_observees.json": [
    "827336",
    [
      126296
    ]
  ],
  "./fi/blueprint_settingsUnsyncedChanges.json": [
    "505046",
    [
      621038
    ]
  ],
  "./sv-x-k12/files_v2.json": [
    "215479",
    [
      241469
    ]
  ],
  "./cy/student_annotation_preview.json": [
    "893144",
    [
      322856
    ]
  ],
  "./fi/OutcomeDescriptionModal.json": [
    "394840",
    [
      619472
    ]
  ],
  "./vi/question_banks.json": [
    "893189",
    [
      630339
    ]
  ],
  "./en-CA/discussion_row.json": [
    "917497",
    [
      509727
    ]
  ],
  "./es/student_annotation_preview.json": [
    "747368",
    [
      326077
    ]
  ],
  "./tr/blueprint_settingsCourseFilter.json": [
    "461142",
    [
      32642
    ]
  ],
  "./nb-x-k12/assignments_2_student_content.json": [
    "68677",
    [
      6691
    ]
  ],
  "./mi/CreateEditAssignmentModal.json": [
    "721338",
    [
      506690
    ]
  ],
  "./ga/terms_index.json": [
    "749774",
    [
      476534
    ]
  ],
  "./pt-BR/editAssignmentGroupWeights.json": [
    "789936",
    [
      564909
    ]
  ],
  "./it/blueprint_course_child.json": [
    "377849",
    [
      589035
    ]
  ],
  "./uk/content_migrations_redesign.json": [
    "49529",
    [
      72311
    ]
  ],
  "./id/add_edit_pseudonym.json": [
    "588400",
    [
      59420
    ]
  ],
  "./pl/SpeedGraderPostGradesMenu.json": [
    "462071",
    [
      132545
    ]
  ],
  "./ja/not_found_page_slide_puzzle.json": [
    "440411",
    [
      988781
    ]
  ],
  "./is/course_navigation_settings.json": [
    "343082",
    [
      352618
    ]
  ],
  "./ms/react_scheduler.json": [
    "605379",
    [
      144441
    ]
  ],
  "./nn/nav_tourpoints.json": [
    "734825",
    [
      898995
    ]
  ],
  "./ru/assignments_2_url_entry.json": [
    "738641",
    [
      945927
    ]
  ],
  "./ca/account_settings.json": [
    "155323",
    [
      482481
    ]
  ],
  "./cy/blueprint_settingsUnsyncedChanges.json": [
    "546971",
    [
      478561
    ]
  ],
  "./ht/user_logins.json": [
    "3672",
    [
      604164
    ]
  ],
  "./nb/question_banks.json": [
    "867318",
    [
      334490
    ]
  ],
  "./nn/calendar_custom_recurring_event_natural_language.json": [
    "979314",
    [
      34622
    ]
  ],
  "./pl/MobileNavigation.json": [
    "35778",
    [
      5718
    ]
  ],
  "./ms/course_paces_blueprint_lock.json": [
    "139266",
    [
      93658
    ]
  ],
  "./zh-Hans/user.json": [
    "834580",
    [
      695892
    ]
  ],
  "./fi/edit_section_end_date.json": [
    "702920",
    [
      13856
    ]
  ],
  "./hi/account_calendars_modal.json": [
    "332792",
    [
      591216
    ]
  ],
  "./nl/bulk_edit_students_table.json": [
    "243293",
    [
      729231
    ]
  ],
  "./pt/user_search_results.json": [
    "683747",
    [
      844149
    ]
  ],
  "./fi/quiz_show.json": [
    "25416",
    [
      914096
    ]
  ],
  "./is/gradebookOutcomeGradebookView.json": [
    "304739",
    [
      222081
    ]
  ],
  "./da-x-k12/GroupDetailView.json": [
    "140948",
    [
      376936
    ]
  ],
  "./fi/bounced_emails.json": [
    "657745",
    [
      557383
    ]
  ],
  "./sl/copy_course.json": [
    "610178",
    [
      91054
    ]
  ],
  "./uk/conversations_2.json": [
    "330171",
    [
      118577
    ]
  ],
  "./ga/assignments_2_peer_review.json": [
    "550107",
    [
      345513
    ]
  ],
  "./en-GB-x-ukhe/IndividualStudentMasteryOutcome.json": [
    "480909",
    [
      649211
    ]
  ],
  "./ko/jobs_v2.json": [
    "142717",
    [
      29859
    ]
  ],
  "./en-AU-x-unimelb/Navigation.json": [
    "777056",
    [
      335988
    ]
  ],
  "./it/nav_tourpoints.json": [
    "878402",
    [
      237974
    ]
  ],
  "./sv/account_calendar_settings.json": [
    "727145",
    [
      792339
    ]
  ],
  "./nb-x-k12/theme_editor.json": [
    "562187",
    [
      397785
    ]
  ],
  "./is/assignments_2_student_annotation.json": [
    "515247",
    [
      701253
    ]
  ],
  "./fr-CA/pseudonyms_mobile_login.json": [
    "758927",
    [
      639073
    ]
  ],
  "./ru/assignments_2_initial_query.json": [
    "351768",
    [
      458416
    ]
  ],
  "./en-GB-x-ukhe/account_calendars_modal.json": [
    "715997",
    [
      293195
    ]
  ],
  "./fi/account_calendar_settings_account_list.json": [
    "515814",
    [
      428510
    ]
  ],
  "./da/sidenav.json": [
    "376409",
    [
      964215
    ]
  ],
  "./zh-Hant/security_panel.json": [
    "555295",
    [
      35537
    ]
  ],
  "./hy/reset_pace_warning_modal.json": [
    "962601",
    [
      151279
    ]
  ],
  "./is/calculator_command.json": [
    "905328",
    [
      856104
    ]
  ],
  "./ru/login.json": [
    "938678",
    [
      794446
    ]
  ],
  "./hu/conferences.json": [
    "111702",
    [
      921430
    ]
  ],
  "./id/empty_modules.json": [
    "443132",
    [
      942832
    ]
  ],
  "./en/link_validator.json": [
    "350782",
    [
      133986
    ]
  ],
  "./el/syllabus_revisions.json": [
    "587135",
    [
      377513
    ]
  ],
  "./ko/AssignmentGroupListItemView.json": [
    "238038",
    [
      314726
    ]
  ],
  "./en-GB/manage_avatars.json": [
    "366175",
    [
      832646
    ]
  ],
  "./hi/submissions_show_preview.json": [
    "279443",
    [
      401937
    ]
  ],
  "./pt-BR/calculator_command.json": [
    "756095",
    [
      474554
    ]
  ],
  "./es-ES/blueprint_settingsSyncHistory.json": [
    "362641",
    [
      533511
    ]
  ],
  "./cy/assignments_2_initial_query.json": [
    "833085",
    [
      470355
    ]
  ],
  "./es-ES/courses_show.json": [
    "348639",
    [
      62693
    ]
  ],
  "./hu/assignment_index.json": [
    "526329",
    [
      394503
    ]
  ],
  "./th/change_password.json": [
    "864950",
    [
      739810
    ]
  ],
  "./zh-Hant/edit_section_view.json": [
    "76172",
    [
      678024
    ]
  ],
  "./vi/not_found_page_slide_puzzle.json": [
    "636924",
    [
      795996
    ]
  ],
  "./fi/EditMasteryScaleLink.json": [
    "173560",
    [
      610016
    ]
  ],
  "./en/permissions.json": [
    "173901",
    [
      929535
    ]
  ],
  "./ja/assignments.json": [
    "319913",
    [
      536744
    ]
  ],
  "./sv/account_calendar_settings_confirmation_modal.json": [
    "268613",
    [
      417335
    ]
  ],
  "./th/restore_content_pane.json": [
    "632517",
    [
      501799
    ]
  ],
  "./hu/assignments_2_peer_review.json": [
    "489412",
    [
      315740
    ]
  ],
  "./da-x-k12/wiki_page_index.json": [
    "148494",
    [
      206170
    ]
  ],
  "./nb-x-k12/announcements_v2.json": [
    "739581",
    [
      461531
    ]
  ],
  "./mi/content_migrations.json": [
    "650171",
    [
      116257
    ]
  ],
  "./en-AU/dashboard_grades_page.json": [
    "3825",
    [
      285136
    ]
  ],
  "./cy/editAssignmentGroupWeights.json": [
    "988571",
    [
      292897
    ]
  ],
  "./ja/discussionTopicKeyboradShortcutModal.json": [
    "54034",
    [
      196731
    ]
  ],
  "./fr/permissions_role_tray_table_row.json": [
    "350720",
    [
      105905
    ]
  ],
  "./nb/gradebookActionMenu.json": [
    "715241",
    [
      278795
    ]
  ],
  "./id/course_paces_actions.json": [
    "297167",
    [
      433225
    ]
  ],
  "./nl/content_migrations.json": [
    "209695",
    [
      828049
    ]
  ],
  "./zh-Hant/ImportConfirmBox.json": [
    "294052",
    [
      259048
    ]
  ],
  "./da/course_paces_empty_state.json": [
    "700269",
    [
      4051
    ]
  ],
  "./is/course_paces_blackout_dates_table.json": [
    "43809",
    [
      589239
    ]
  ],
  "./it/wiki_page_index.json": [
    "614330",
    [
      940414
    ]
  ],
  "./nl/edit_section_view.json": [
    "48328",
    [
      721428
    ]
  ],
  "./en-AU-x-unimelb/theme_editor.json": [
    "191529",
    [
      776851
    ]
  ],
  "./sv-x-k12/CommentLibrary.json": [
    "250627",
    [
      809777
    ]
  ],
  "./ca/assignments_bulk_edit_use_save_assignment.json": [
    "40394",
    [
      111042
    ]
  ],
  "./id/user_search_results.json": [
    "319866",
    [
      225990
    ]
  ],
  "./ar/discussionTopicKeyboradShortcutModal.json": [
    "841752",
    [
      486108
    ]
  ],
  "./it/course_paces_no_results.json": [
    "16574",
    [
      317778
    ]
  ],
  "./de/blueprint_course_child.json": [
    "686407",
    [
      884338
    ]
  ],
  "./he/account_settings_jsx_bundle.json": [
    "93817",
    [
      799431
    ]
  ],
  "./he/jobs_v2.json": [
    "127924",
    [
      19948
    ]
  ],
  "./hi/discussion_topics.json": [
    "521024",
    [
      700488
    ]
  ],
  "./ko/account_calendar_settings_account_group.json": [
    "383702",
    [
      447782
    ]
  ],
  "./sl/blueprint_settingsUnsyncedChanges.json": [
    "348824",
    [
      114716
    ]
  ],
  "./tr/dashboard_grades_page.json": [
    "726137",
    [
      682219
    ]
  ],
  "./nl/gradebookActionMenu.json": [
    "922039",
    [
      398625
    ]
  ],
  "./nl/modules_home_page.json": [
    "396577",
    [
      7139
    ]
  ],
  "./en-AU/authentication_providers.json": [
    "466937",
    [
      780824
    ]
  ],
  "./nl/submissions_show_preview.json": [
    "94432",
    [
      714132
    ]
  ],
  "./es/sharedSetDefaultGradeDialog.json": [
    "75657",
    [
      649291
    ]
  ],
  "./it/change_password.json": [
    "365651",
    [
      493421
    ]
  ],
  "./sl/progression_module_header.json": [
    "863105",
    [
      438779
    ]
  ],
  "./ht/confirmMasteryModal.json": [
    "131164",
    [
      950256
    ]
  ],
  "./pl/NewTabIndicator.json": [
    "995800",
    [
      265052
    ]
  ],
  "./fr-CA/course_paces_errors.json": [
    "208663",
    [
      862905
    ]
  ],
  "./he/sharedSetDefaultGradeDialog.json": [
    "856302",
    [
      200766
    ]
  ],
  "./ga/content_shares.json": [
    "630456",
    [
      699472
    ]
  ],
  "./hy/add_edit_pseudonym.json": [
    "342618",
    [
      13946
    ]
  ],
  "./hi/modelsQuiz.json": [
    "479516",
    [
      850684
    ]
  ],
  "./zh-Hans/appt_calendar_event_dialog.json": [
    "751995",
    [
      743545
    ]
  ],
  "./uk/outcome_reporting.json": [
    "171851",
    [
      915905
    ]
  ],
  "./zh-Hans/assignments_2_media_attempt.json": [
    "592851",
    [
      804161
    ]
  ],
  "./fa/quizzes_regrade_modal.json": [
    "68483",
    [
      493761
    ]
  ],
  "./pt-BR/accessibility_checker.json": [
    "769911",
    [
      36194
    ]
  ],
  "./sv-x-k12/self_unenrollment_modal.json": [
    "423563",
    [
      309529
    ]
  ],
  "./uk/file_not_found.json": [
    "447273",
    [
      763687
    ]
  ],
  "./ar/AlignmentSummary.json": [
    "461560",
    [
      187844
    ]
  ],
  "./ar/quizzes_public.json": [
    "808620",
    [
      970984
    ]
  ],
  "./mi/sis_import.json": [
    "462208",
    [
      544521
    ]
  ],
  "./pt-BR/appt_calendar_event_dialog.json": [
    "707261",
    [
      375164
    ]
  ],
  "./ko/dashboard_grades_page.json": [
    "167685",
    [
      49435
    ]
  ],
  "./ar/assignments_2_MoreOptions_CanvasFiles.json": [
    "468820",
    [
      144456
    ]
  ],
  "./ht/CommentLibrary.json": [
    "22286",
    [
      205122
    ]
  ],
  "./en-GB-x-ukhe/terms_of_use.json": [
    "366429",
    [
      609451
    ]
  ],
  "./sv-x-k12/assignmentsIndexView.json": [
    "394880",
    [
      82824
    ]
  ],
  "./sl/youtube_migration.json": [
    "16423",
    [
      797193
    ]
  ],
  "./nl/top_navigation_tools.json": [
    "329502",
    [
      472866
    ]
  ],
  "./cy/peer-review-assignment-widget.json": [
    "912644",
    [
      390620
    ]
  ],
  "./de/course_paces_blackout_dates_modal.json": [
    "29903",
    [
      252042
    ]
  ],
  "./ga/lti_registration.wizard.json": [
    "578100",
    [
      894443
    ]
  ],
  "./pl/AccountsTray.json": [
    "892938",
    [
      117081
    ]
  ],
  "./pt/MoveOutcomesModal.json": [
    "945787",
    [
      855749
    ]
  ],
  "./tr/registration.json": [
    "635073",
    [
      398059
    ]
  ],
  "./ga/sections_tooltip.json": [
    "326926",
    [
      874102
    ]
  ],
  "./id/quizzes_openModerateStudentDialog.json": [
    "915181",
    [
      363535
    ]
  ],
  "./nb-x-k12/quizzes_regrade_modal.json": [
    "822264",
    [
      398128
    ]
  ],
  "./da-x-k12/pseudonyms_mobile_login.json": [
    "780471",
    [
      46721
    ]
  ],
  "./nn/account_calendar_settings_account_tree.json": [
    "552681",
    [
      776219
    ]
  ],
  "./hy/account_course_user_search.json": [
    "788897",
    [
      543703
    ]
  ],
  "./en/notebook_index.json": [
    "572697",
    [
      743851
    ]
  ],
  "./el/assignment_2_assignment_toggle_details.json": [
    "631861",
    [
      152135
    ]
  ],
  "./zh-Hans/Navigation.json": [
    "773157",
    [
      787907
    ]
  ],
  "./cy/quizzes_index.json": [
    "737228",
    [
      181716
    ]
  ],
  "./fr-CA/outcome_reporting.json": [
    "809562",
    [
      263446
    ]
  ],
  "./is/discussion_topics.json": [
    "689247",
    [
      523893
    ]
  ],
  "./da-x-k12/knowledge_check_not_ready.json": [
    "688490",
    [
      885798
    ]
  ],
  "./he/default_account_quotas.json": [
    "473808",
    [
      584400
    ]
  ],
  "./nn/react_scheduler.json": [
    "888343",
    [
      587809
    ]
  ],
  "./en-GB-x-ukhe/course_link_validator.json": [
    "872743",
    [
      435197
    ]
  ],
  "./pl/sections_tooltip.json": [
    "305274",
    [
      220958
    ]
  ],
  "./ms/course_paces_projected_dates.json": [
    "310805",
    [
      598587
    ]
  ],
  "./zh-Hant/course_paces_empty_state.json": [
    "160310",
    [
      400346
    ]
  ],
  "./es/peer_review_allocation_rules_tray.json": [
    "635899",
    [
      212166
    ]
  ],
  "./es-ES/course_paces_actions.json": [
    "203247",
    [
      825045
    ]
  ],
  "./en-GB/roster_section_selector.json": [
    "498486",
    [
      919019
    ]
  ],
  "./he/assignments.no_assignments_search.json": [
    "412754",
    [
      485887
    ]
  ],
  "./nb/SpeedGraderPostGradesMenu.json": [
    "158823",
    [
      156337
    ]
  ],
  "./ru/question_banks.json": [
    "163957",
    [
      78307
    ]
  ],
  "./uk/course_template_details.json": [
    "888919",
    [
      345813
    ]
  ],
  "./zh-Hans/mutationActivity.json": [
    "519565",
    [
      981083
    ]
  ],
  "./th/course_paces_app.json": [
    "533240",
    [
      890420
    ]
  ],
  "./sv-x-k12/context_prior_users.json": [
    "788778",
    [
      533530
    ]
  ],
  "./ms/collaborations.json": [
    "897284",
    [
      56732
    ]
  ],
  "./cy/conversations_2.json": [
    "136579",
    [
      109081
    ]
  ],
  "./nb-x-k12/self_unenrollment_modal.json": [
    "412870",
    [
      365438
    ]
  ],
  "./th/theme_editor.json": [
    "420185",
    [
      308907
    ]
  ],
  "./en-CA/account_calendar_settings_footer.json": [
    "752230",
    [
      616078
    ]
  ],
  "./en-GB-x-ukhe/grade_summary.json": [
    "88280",
    [
      496240
    ]
  ],
  "./ja/gradinggradingPeriodCollection.json": [
    "459444",
    [
      301681
    ]
  ],
  "./zh-Hans/assignments_2_student_points_display.json": [
    "819469",
    [
      471451
    ]
  ],
  "./en-GB-x-lbs/conversations_2.json": [
    "355405",
    [
      27115
    ]
  ],
  "./fa.eager.json": [
    "352526",
    [
      5721
    ]
  ],
  "./cy/ai_experiences_edit.json": [
    "757719",
    [
      988325
    ]
  ],
  "./da/course_paces_assignment_row.json": [
    "704880",
    [
      31584
    ]
  ],
  "./fr/quizzes_regrade_modal.json": [
    "219482",
    [
      525463
    ]
  ],
  "./id/pseudonyms_mobile_login.json": [
    "829027",
    [
      194837
    ]
  ],
  "./fi/k5_course.json": [
    "22819",
    [
      441681
    ]
  ],
  "./is/calendar.header.json": [
    "638819",
    [
      953386
    ]
  ],
  "./mi/theme_editor.json": [
    "796323",
    [
      651737
    ]
  ],
  "./nl/editAssignmentGroupWeights.json": [
    "487121",
    [
      544803
    ]
  ],
  "./zh-Hans/assignments_2_login_action_prompt.json": [
    "496810",
    [
      466906
    ]
  ],
  "./pt-BR/assignments.no_assignments_search.json": [
    "113668",
    [
      826633
    ]
  ],
  "./nb-x-k12/DueDateOverrideView.json": [
    "760715",
    [
      767817
    ]
  ],
  "./da-x-k12/blueprint_course_child.json": [
    "81413",
    [
      171999
    ]
  ],
  "./hi/outcomes_user_outcome_results.json": [
    "169626",
    [
      753018
    ]
  ],
  "./he/calendar_custom_recurring_event_repeat_picker.json": [
    "259343",
    [
      876013
    ]
  ],
  "./uk/content_exports.json": [
    "616491",
    [
      34145
    ]
  ],
  "./ru/webzip_export.json": [
    "701363",
    [
      315153
    ]
  ],
  "./is/speed_grader_helpers.json": [
    "306915",
    [
      139505
    ]
  ],
  "./zh-Hant/submit_assignment.json": [
    "720044",
    [
      938456
    ]
  ],
  "./cy/calendar.header.json": [
    "407215",
    [
      560230
    ]
  ],
  "./en-CA/discussion_posts.json": [
    "322786",
    [
      98194
    ]
  ],
  "./en-AU-x-unimelb/widget_dashboard.json": [
    "49113",
    [
      747235
    ]
  ],
  "./nb-x-k12/course_paces_empty_state.json": [
    "682910",
    [
      968665
    ]
  ],
  "./pt/progression_module_header.json": [
    "415570",
    [
      741054
    ]
  ],
  "./tr/calendar_appointment_group_edit.json": [
    "563709",
    [
      327911
    ]
  ],
  "./es/assignments_2_MoreOptions.json": [
    "889847",
    [
      114154
    ]
  ],
  "./fr/not_found_page_slide_puzzle.json": [
    "59225",
    [
      325260
    ]
  ],
  "./ga/assignments_2_student_content.json": [
    "813767",
    [
      596173
    ]
  ],
  "./he/external_content_cancel.json": [
    "651645",
    [
      266867
    ]
  ],
  "./hu/sidenav.json": [
    "336553",
    [
      558135
    ]
  ],
  "./sv/user_profile.json": [
    "714884",
    [
      134800
    ]
  ],
  "./mi/discussion_create.json": [
    "738989",
    [
      264995
    ]
  ],
  "./ca/unpublished_changes_button_props.json": [
    "901797",
    [
      198747
    ]
  ],
  "./en-GB-x-lbs/MobileNavigation.json": [
    "795504",
    [
      877912
    ]
  ],
  "./es/assignments_2_initial_query.json": [
    "304461",
    [
      68564
    ]
  ],
  "./en-GB-x-lbs/modules_home_page.json": [
    "904113",
    [
      103479
    ]
  ],
  "./ga/student_groups.json": [
    "357842",
    [
      444882
    ]
  ],
  "./nb-x-k12/self_enrollment.json": [
    "309819",
    [
      6217
    ]
  ],
  "./ru/theme_editor.json": [
    "575662",
    [
      605622
    ]
  ],
  "./sv/epub_exports.json": [
    "327947",
    [
      271149
    ]
  ],
  "./sv-x-k12/grades_summary.json": [
    "565676",
    [
      16572
    ]
  ],
  "./fi/internal-settings.json": [
    "236198",
    [
      209374
    ]
  ],
  "./hu/license_help.json": [
    "816828",
    [
      718532
    ]
  ],
  "./nn/content_shares.json": [
    "932216",
    [
      560828
    ]
  ],
  "./sl/course_color_selector.json": [
    "976038",
    [
      192682
    ]
  ],
  "./zh-Hant/bounced_emails.json": [
    "845644",
    [
      113256
    ]
  ],
  "./th/blueprint_settingsAssociationsTable.json": [
    "769565",
    [
      795767
    ]
  ],
  "./es/comm_messages.json": [
    "976847",
    [
      21154
    ]
  ],
  "./fi/password_complexity_configuration.json": [
    "66464",
    [
      716760
    ]
  ],
  "./cy/ProfileTray.json": [
    "905747",
    [
      381033
    ]
  ],
  "./fr/authentication_providers.json": [
    "457147",
    [
      284570
    ]
  ],
  "./ga/filter_calendars_modal.json": [
    "229862",
    [
      750894
    ]
  ],
  "./en-GB-x-lbs/discussion_pinned_post.json": [
    "461254",
    [
      298590
    ]
  ],
  "./mi/copy_course.json": [
    "304759",
    [
      88453
    ]
  ],
  "./nn/course_paces_projected_dates.json": [
    "626441",
    [
      389891
    ]
  ],
  "./pl/a2LatePolicyStatusDisplay.json": [
    "511517",
    [
      518967
    ]
  ],
  "./da/gradebook.json": [
    "114411",
    [
      755777
    ]
  ],
  "./de/course_paces_modal.json": [
    "566427",
    [
      851630
    ]
  ],
  "./en-AU/webcam_modal.json": [
    "256603",
    [
      172470
    ]
  ],
  "./en/user_lists.json": [
    "281174",
    [
      93330
    ]
  ],
  "./nn/speed_grader_helpers.json": [
    "741483",
    [
      762269
    ]
  ],
  "./en-AU/discussion_settings.json": [
    "478516",
    [
      295825
    ]
  ],
  "./zh-Hant/EditMasteryScaleLink.json": [
    "654329",
    [
      132851
    ]
  ],
  "./he/copy_warnings_modal.json": [
    "994116",
    [
      985436
    ]
  ],
  "./ca/assignments_2_media_attempt.json": [
    "47044",
    [
      338028
    ]
  ],
  "./zh-Hans/k5_dashboard_card.json": [
    "896175",
    [
      150197
    ]
  ],
  "./ht/assignments_2_submission_histories_query.json": [
    "355082",
    [
      998358
    ]
  ],
  "./en-AU/assignmentsIndexView.json": [
    "791567",
    [
      208754
    ]
  ],
  "./fr/course_search_results.json": [
    "364645",
    [
      996432
    ]
  ],
  "./en-GB-x-lbs/user_lists.json": [
    "541169",
    [
      583415
    ]
  ],
  "./nb-x-k12/assignments_2_login_action_prompt.json": [
    "170439",
    [
      158573
    ]
  ],
  "./el/terms_of_use.json": [
    "725596",
    [
      89208
    ]
  ],
  "./sv-x-k12/course_paces_pace_picker.json": [
    "193868",
    [
      128380
    ]
  ],
  "./zh-Hans/a2_AccessibleTipContent.json": [
    "782521",
    [
      407055
    ]
  ],
  "./ht/media_immersive_view.json": [
    "80046",
    [
      825970
    ]
  ],
  "./ms/account_calendar_settings_utils.json": [
    "130162",
    [
      766378
    ]
  ],
  "./ga/roster_section_selector.json": [
    "210227",
    [
      471985
    ]
  ],
  "./pl/account_calendar_settings_account_group.json": [
    "884280",
    [
      290476
    ]
  ],
  "./is/change_password.json": [
    "431642",
    [
      916682
    ]
  ],
  "./en-AU/GroupDetailView.json": [
    "622383",
    [
      716818
    ]
  ],
  "./sv/discussion_topics_edit.json": [
    "408031",
    [
      330449
    ]
  ],
  "./pt-BR/user_restore.json": [
    "107783",
    [
      838978
    ]
  ],
  "./sl/account_calendars_results_area.json": [
    "968314",
    [
      8375
    ]
  ],
  "./sv/assignment_index_menu.json": [
    "184135",
    [
      197825
    ]
  ],
  "./it/bulk_edit_students_table.json": [
    "611756",
    [
      205136
    ]
  ],
  "./nb-x-k12/roster_section_selector.json": [
    "487545",
    [
      269327
    ]
  ],
  "./pt-BR/course_paces_assignment_row.json": [
    "816398",
    [
      48231
    ]
  ],
  "./mi/MoveOutcomesModal.json": [
    "389505",
    [
      362783
    ]
  ],
  "./sl/modules_home_page.json": [
    "218216",
    [
      146812
    ]
  ],
  "./tr/custom_help_link.json": [
    "928924",
    [
      800624
    ]
  ],
  "./nb/available_pronouns_list.json": [
    "651303",
    [
      977969
    ]
  ],
  "./ja/k5_dashboard.json": [
    "48302",
    [
      97807
    ]
  ],
  "./it/collaborations.json": [
    "382759",
    [
      462817
    ]
  ],
  "./fr-CA/peer_reviews_student.json": [
    "859179",
    [
      996941
    ]
  ],
  "./el/sections_tooltip.json": [
    "937269",
    [
      768791
    ]
  ],
  "./is/unpublished_changes_tray_contents.json": [
    "561427",
    [
      331937
    ]
  ],
  "./ms/course_pace_date_input.json": [
    "568159",
    [
      535773
    ]
  ],
  "./nl/quizzes_quiz_submission.json": [
    "43864",
    [
      611324
    ]
  ],
  "./pt-BR/direct_share_course_import_panel.json": [
    "890833",
    [
      86056
    ]
  ],
  "./it/notebook_index.json": [
    "867595",
    [
      828661
    ]
  ],
  "./pt-BR/important_dates_empty.json": [
    "959089",
    [
      751736
    ]
  ],
  "./hu/announcements_v2.json": [
    "406470",
    [
      846182
    ]
  ],
  "./is/sis_import.json": [
    "823821",
    [
      512459
    ]
  ],
  "./tr/CommentLibrary.json": [
    "906956",
    [
      601272
    ]
  ],
  "./es.eager.json": [
    "954571",
    [
      703998
    ]
  ],
  "./ko/account_calendar_settings_account_tree.json": [
    "122055",
    [
      700069
    ]
  ],
  "./fr-CA/course_paces_empty_state.json": [
    "742343",
    [
      745449
    ]
  ],
  "./ru/course_restore.json": [
    "800093",
    [
      68747
    ]
  ],
  "./zh-Hans/edit_section_end_date.json": [
    "544410",
    [
      644986
    ]
  ],
  "./en-GB/course_logging_details.json": [
    "353839",
    [
      944262
    ]
  ],
  "./zh-Hant/conferences_alternatives.json": [
    "714916",
    [
      717648
    ]
  ],
  "./da/account_calendar_settings_utils.json": [
    "252425",
    [
      751591
    ]
  ],
  "./is/confirmMasteryModal.json": [
    "245368",
    [
      742592
    ]
  ],
  "./en-GB-x-lbs/IndividualStudentMasteryOutcome.json": [
    "68437",
    [
      238867
    ]
  ],
  "./uk/courses.json": [
    "796260",
    [
      30988
    ]
  ],
  "./ca/folder_tree.json": [
    "570891",
    [
      347201
    ]
  ],
  "./ga/assignments_2_attempt_tab.json": [
    "982971",
    [
      350153
    ]
  ],
  "./pt/auth_logging.json": [
    "797514",
    [
      1974
    ]
  ],
  "./zh-Hans/course_paces_empty_state.json": [
    "208465",
    [
      391383
    ]
  ],
  "./ar/theme_editor.json": [
    "738976",
    [
      834708
    ]
  ],
  "./ga/conversations_2.json": [
    "779375",
    [
      784021
    ]
  ],
  "./hy/OutcomeDescriptionModal.json": [
    "381014",
    [
      647150
    ]
  ],
  "./nb/folder_tree.json": [
    "548899",
    [
      468933
    ]
  ],
  "./sv/discussion_row.json": [
    "455614",
    [
      415714
    ]
  ],
  "./zh-Hans/permissions_v2.json": [
    "911934",
    [
      857110
    ]
  ],
  "./hy/webcam_modal.json": [
    "908812",
    [
      381964
    ]
  ],
  "./es/content_copy_redesign.json": [
    "205321",
    [
      698904
    ]
  ],
  "./hy/course_paces_settings.json": [
    "610519",
    [
      469645
    ]
  ],
  "./fr-CA/quizzes_openModerateStudentDialog.json": [
    "647321",
    [
      60363
    ]
  ],
  "./en-AU-x-unimelb.json": [
    "981445",
    [
      782733
    ]
  ],
  "./ga/assignment_index_deep_linking_handlers.json": [
    "878064",
    [
      754184
    ]
  ],
  "./mi/question_bank.json": [
    "44767",
    [
      107485
    ]
  ],
  "./th/account_calendar_settings_confirmation_modal.json": [
    "822670",
    [
      817082
    ]
  ],
  "./en-GB/terms_index.json": [
    "641267",
    [
      942106
    ]
  ],
  "./es/gradebook_default_gradebook_components_content_filters_module_filter.json": [
    "813142",
    [
      210247
    ]
  ],
  "./he/user_logins.json": [
    "702819",
    [
      307737
    ]
  ],
  "./ar/MobileNavigation.json": [
    "674159",
    [
      26217
    ]
  ],
  "./nb-x-k12/unpublished_changes_tray_contents.json": [
    "737825",
    [
      825751
    ]
  ],
  "./nn/assignments_bulk_edit.json": [
    "47550",
    [
      979938
    ]
  ],
  "./th/account_calendar_settings.json": [
    "456384",
    [
      324972
    ]
  ],
  "./ko/upload_button.json": [
    "73982",
    [
      812030
    ]
  ],
  "./tr/assignments_2_external_tool.json": [
    "738262",
    [
      991626
    ]
  ],
  "./id/quizzes_quiz_submission.json": [
    "544899",
    [
      350733
    ]
  ],
  "./es/theme_collection_view.json": [
    "785408",
    [
      359061
    ]
  ],
  "./en-GB-x-ukhe/GroupDetailView.json": [
    "978875",
    [
      309001
    ]
  ],
  "./tr/SpeedGraderPostGradesMenu.json": [
    "429729",
    [
      795720
    ]
  ],
  "./es-ES/account_settings_jsx_bundle.json": [
    "621159",
    [
      818333
    ]
  ],
  "./es-ES/license_help.json": [
    "394402",
    [
      908866
    ]
  ],
  "./da-x-k12/login.json": [
    "257770",
    [
      785262
    ]
  ],
  "./it/permissions_v2_add_tray.json": [
    "872153",
    [
      45515
    ]
  ],
  "./es-ES/ai_experiences_show.json": [
    "899107",
    [
      726897
    ]
  ],
  "./hi/sections_tooltip.json": [
    "963799",
    [
      90189
    ]
  ],
  "./da/permission_button.json": [
    "472241",
    [
      306847
    ]
  ],
  "./ar/discussion_topics.json": [
    "350256",
    [
      945788
    ]
  ],
  "./cy/blueprint_settingsCourseFilter.json": [
    "67016",
    [
      589400
    ]
  ],
  "./es/user_name.json": [
    "222993",
    [
      289056
    ]
  ],
  "./hu/unpublished_changes_button_props.json": [
    "629876",
    [
      664940
    ]
  ],
  "./pl/MasteryScale.json": [
    "933003",
    [
      388101
    ]
  ],
  "./th/quizzes.take_quiz.json": [
    "35708",
    [
      454685
    ]
  ],
  "./sl/content_share_preview_overlay.json": [
    "444144",
    [
      414636
    ]
  ],
  "./th/progressbar_view.json": [
    "299206",
    [
      816618
    ]
  ],
  "./fr-CA/SpeedGraderCheckpoints.json": [
    "487722",
    [
      727422
    ]
  ],
  "./vi/link_to_students.json": [
    "586656",
    [
      352984
    ]
  ],
  "./nn.json": [
    "103521",
    [
      194481
    ]
  ],
  "./da/course_search_results.json": [
    "383630",
    [
      414862
    ]
  ],
  "./nb-x-k12/top_navigation_tools.json": [
    "255762",
    [
      978546
    ]
  ],
  "./pl/self_enrollment.json": [
    "542453",
    [
      534535
    ]
  ],
  "./cy/calendar_appointment_group_edit.json": [
    "879715",
    [
      109721
    ]
  ],
  "./fa/edit_section_view.json": [
    "291311",
    [
      308549
    ]
  ],
  "./en-GB/gradebook_history.json": [
    "527170",
    [
      91199
    ]
  ],
  "./ht/content_shares.json": [
    "467140",
    [
      74712
    ]
  ],
  "./de/grade_summary.json": [
    "450525",
    [
      760220
    ]
  ],
  "./fa/manage_avatars.json": [
    "706123",
    [
      828793
    ]
  ],
  "./fi/dashboard.json": [
    "805283",
    [
      725921
    ]
  ],
  "./hu/course_paces_footer.json": [
    "304805",
    [
      433099
    ]
  ],
  "./id/use_switch_experience.json": [
    "207634",
    [
      167678
    ]
  ],
  "./en-GB-x-ukhe/password_complexity_configuration.json": [
    "29335",
    [
      32925
    ]
  ],
  "./mi/unpublished_changes_tray_contents.json": [
    "690825",
    [
      916119
    ]
  ],
  "./sl/assignments.json": [
    "597439",
    [
      764537
    ]
  ],
  "./sv/course_paces_settings.json": [
    "796289",
    [
      23499
    ]
  ],
  "./sv-x-k12/editGroup.json": [
    "549374",
    [
      974470
    ]
  ],
  "./nb-x-k12/a2LatePolicyStatusDisplay.json": [
    "356007",
    [
      333757
    ]
  ],
  "./en-GB-x-ukhe/gradebookActionMenu.json": [
    "824047",
    [
      117013
    ]
  ],
  "./zh-Hant/assignments_2_media_attempt.json": [
    "812774",
    [
      469330
    ]
  ],
  "./da/blueprint_course_child.json": [
    "757211",
    [
      936689
    ]
  ],
  "./pt-BR/internal-settings.json": [
    "334070",
    [
      695919
    ]
  ],
  "./el/course_logging_details.json": [
    "215919",
    [
      496849
    ]
  ],
  "./en-AU-x-unimelb/a2_AccessibleTipContent.json": [
    "615714",
    [
      282878
    ]
  ],
  "./he/quizzes.take_quiz.json": [
    "816407",
    [
      329480
    ]
  ],
  "./nl/course_template_details.json": [
    "65081",
    [
      262363
    ]
  ],
  "./nl/assignments_peer_reviews.json": [
    "565493",
    [
      474063
    ]
  ],
  "./da/quiz_migration_notifications.json": [
    "48198",
    [
      594390
    ]
  ],
  "./hu/job_stats.json": [
    "984310",
    [
      384790
    ]
  ],
  "./is/top_navigation_tools.json": [
    "651068",
    [
      840492
    ]
  ],
  "./es-ES/user.json": [
    "572782",
    [
      837350
    ]
  ],
  "./th/widget_dashboard.json": [
    "434281",
    [
      519147
    ]
  ],
  "./tr/DueDateOverrideView.json": [
    "512003",
    [
      103117
    ]
  ],
  "./nb-x-k12/discussion_pinned_post.json": [
    "314250",
    [
      694346
    ]
  ],
  "./id/courses.json": [
    "818285",
    [
      29639
    ]
  ],
  "./sl/gradingPeriodTemplate.json": [
    "360722",
    [
      993182
    ]
  ],
  "./ja/CreateEditAssignmentModalAdapter.json": [
    "853560",
    [
      902173
    ]
  ],
  "./pl/bulk_edit_students_actions.json": [
    "118404",
    [
      439408
    ]
  ],
  "./sl/discussion_create.json": [
    "785320",
    [
      298068
    ]
  ],
  "./zh-Hant/assignments_2_student_content_rubric_self_assessment.json": [
    "214053",
    [
      918191
    ]
  ],
  "./he/react_scheduler.json": [
    "140232",
    [
      331672
    ]
  ],
  "./th/edit_section_start_date.json": [
    "924218",
    [
      686670
    ]
  ],
  "./nl/assignments_2_peer_review.json": [
    "670741",
    [
      642031
    ]
  ],
  "./is/peer_review_configuration_tray.json": [
    "914551",
    [
      604909
    ]
  ],
  "./is/CreateEditAssignmentModalAdapter.json": [
    "113419",
    [
      680329
    ]
  ],
  "./cy/ai_experiences_show.json": [
    "233418",
    [
      234610
    ]
  ],
  "./pt/react_collaborations.json": [
    "452144",
    [
      228300
    ]
  ],
  "./nl/account_calendar_settings.json": [
    "597186",
    [
      911118
    ]
  ],
  "./sl/speed_grader_helpers.json": [
    "502326",
    [
      164066
    ]
  ],
  "./vi/user_grades.json": [
    "958595",
    [
      646801
    ]
  ],
  "./zh-Hant/homeroom_page.json": [
    "523238",
    [
      282578
    ]
  ],
  "./vi/gradingGradeSummary.json": [
    "986138",
    [
      779674
    ]
  ],
  "./ar/permission_button.json": [
    "706125",
    [
      907351
    ]
  ],
  "./en-GB-x-lbs/assignment_index_menu.json": [
    "538724",
    [
      763284
    ]
  ],
  "./nb-x-k12/assignment_grade_summary.json": [
    "280130",
    [
      479490
    ]
  ],
  "./da/homeroom_page.json": [
    "483791",
    [
      643901
    ]
  ],
  "./ht/outcome_management.json": [
    "823144",
    [
      981468
    ]
  ],
  "./is/wiki_page_index.json": [
    "395103",
    [
      245733
    ]
  ],
  "./ms/AddGroup.json": [
    "909680",
    [
      577712
    ]
  ],
  "./ko/assignments_2_student_header_date_title.json": [
    "42863",
    [
      583197
    ]
  ],
  "./pt/assignment_index.json": [
    "7148",
    [
      987232
    ]
  ],
  "./en-GB/grade_details.json": [
    "370409",
    [
      256476
    ]
  ],
  "./da/available_pronouns_list.json": [
    "925844",
    [
      916828
    ]
  ],
  "./es/calendar_custom_recurring_event_natural_language.json": [
    "358398",
    [
      415215
    ]
  ],
  "./es/AddGroup.json": [
    "489864",
    [
      539965
    ]
  ],
  "./hi/CourseAvailabilityOptions.json": [
    "61201",
    [
      971223
    ]
  ],
  "./ht/peer_reviews_student.json": [
    "815484",
    [
      67888
    ]
  ],
  "./da-x-k12/AddGroup.json": [
    "947683",
    [
      979493
    ]
  ],
  "./he/assignments_2_external_tool.json": [
    "81059",
    [
      493369
    ]
  ],
  "./id/important_dates.json": [
    "465331",
    [
      324797
    ]
  ],
  "./it/empty_course.json": [
    "155186",
    [
      449926
    ]
  ],
  "./pt-BR/mutationActivity.json": [
    "283591",
    [
      867762
    ]
  ],
  "./hi/account_calendar_settings_account_group.json": [
    "325399",
    [
      347725
    ]
  ],
  "./es-ES/assignment_index_deep_linking_handlers.json": [
    "357863",
    [
      574589
    ]
  ],
  "./pt/IndividualStudentMasteryOutcome.json": [
    "335619",
    [
      765541
    ]
  ],
  "./sv-x-k12/discussion_settings.json": [
    "627997",
    [
      610523
    ]
  ],
  "./th/course_default_due_time.json": [
    "789352",
    [
      405916
    ]
  ],
  "./uk/course_paces_actions.json": [
    "520944",
    [
      188160
    ]
  ],
  "./de/password_complexity_configuration.json": [
    "804270",
    [
      602439
    ]
  ],
  "./ms/discussion_create.json": [
    "763343",
    [
      62125
    ]
  ],
  "./nl/course_paces_header.json": [
    "416966",
    [
      355642
    ]
  ],
  "./zh-Hant/modelsQuiz.json": [
    "213827",
    [
      527221
    ]
  ],
  "./fr-CA/rootFoldersFinder.json": [
    "326518",
    [
      756090
    ]
  ],
  "./ja/permissions.json": [
    "515487",
    [
      774946
    ]
  ],
  "./en-AU-x-unimelb/react_scheduler.json": [
    "834147",
    [
      885541
    ]
  ],
  "./en-GB/wiki_page_index.json": [
    "602502",
    [
      974603
    ]
  ],
  "./el/OutcomeMoveModal.json": [
    "433343",
    [
      99817
    ]
  ],
  "./ja/grade_change_logging_content.json": [
    "801481",
    [
      872219
    ]
  ],
  "./hy/course_paces_errors.json": [
    "810657",
    [
      755543
    ]
  ],
  "./pl/permission_button.json": [
    "97410",
    [
      26558
    ]
  ],
  "./pt/widget_dashboard.json": [
    "751657",
    [
      674459
    ]
  ],
  "./mi/quizzes_public.json": [
    "70019",
    [
      362169
    ]
  ],
  "./sv/assignment_index_deep_linking_handlers.json": [
    "374795",
    [
      586666
    ]
  ],
  "./nb-x-k12/discovery_page.json": [
    "605448",
    [
      377520
    ]
  ],
  "./en-GB/permissions_role_tray.json": [
    "787609",
    [
      983580
    ]
  ],
  "./es/course_paces_module.json": [
    "37269",
    [
      210844
    ]
  ],
  "./fi/rootFoldersFinder.json": [
    "554682",
    [
      62378
    ]
  ],
  "./id/assignments_2_external_tool.json": [
    "34981",
    [
      914247
    ]
  ],
  "./tr/files_v2.json": [
    "747052",
    [
      861896
    ]
  ],
  "./tr/react_files.json": [
    "102803",
    [
      976701
    ]
  ],
  "./ms/assignments_2_text_entry.json": [
    "461470",
    [
      754510
    ]
  ],
  "./ga/a2_AccessibleTipContent.json": [
    "452622",
    [
      524598
    ]
  ],
  "./ht/course_paces_app.json": [
    "51856",
    [
      569132
    ]
  ],
  "./hi/terms_index.json": [
    "954801",
    [
      130871
    ]
  ],
  "./tr/important_dates_empty.json": [
    "534114",
    [
      943062
    ]
  ],
  "./ht/CreateEditAssignmentModal.json": [
    "551480",
    [
      290236
    ]
  ],
  "./uk/roster_section_selector.json": [
    "60975",
    [
      593085
    ]
  ],
  "./hu/appointment_groups.json": [
    "843193",
    [
      419079
    ]
  ],
  "./nb-x-k12/folder_tree.json": [
    "380209",
    [
      485287
    ]
  ],
  "./pl/assignments_2_student_header.json": [
    "547507",
    [
      182914
    ]
  ],
  "./th/permissions_role_tray.json": [
    "304156",
    [
      83480
    ]
  ],
  "./uk/assignments_2_MoreOptions.json": [
    "102335",
    [
      63693
    ]
  ],
  "./ca/comm_messages.json": [
    "245703",
    [
      245893
    ]
  ],
  "./de/ai_experiences_edit.json": [
    "556776",
    [
      918405
    ]
  ],
  "./en-GB-x-lbs/link_validator.json": [
    "841133",
    [
      34651
    ]
  ],
  "./da/discovery_page.json": [
    "49711",
    [
      358109
    ]
  ],
  "./is/blueprint_settingsAssociationsTable.json": [
    "592233",
    [
      352767
    ]
  ],
  "./pt/assignments_2_student_header.json": [
    "609131",
    [
      102845
    ]
  ],
  "./es-ES/assignments.no_assignments_search.json": [
    "874980",
    [
      896997
    ]
  ],
  "./hi/course_paces_change_tracking.json": [
    "264421",
    [
      694146
    ]
  ],
  "./fr-CA/gradingPeriodTemplate.json": [
    "124276",
    [
      207176
    ]
  ],
  "./th/context_modules_v2.json": [
    "902236",
    [
      259424
    ]
  ],
  "./th/AssignmentGroupListItemView.json": [
    "191428",
    [
      19992
    ]
  ],
  "./el/quizzes_quiz_submission.json": [
    "225335",
    [
      536577
    ]
  ],
  "./nb/Navigation.json": [
    "947208",
    [
      200932
    ]
  ],
  "./is/grades_empty_page.json": [
    "896466",
    [
      894962
    ]
  ],
  "./is/terms_index.json": [
    "99078",
    [
      73950
    ]
  ],
  "./id/discussion_settings.json": [
    "60919",
    [
      167537
    ]
  ],
  "./ja/EditMasteryScaleLink.json": [
    "593964",
    [
      480041
    ]
  ],
  "./fi/keyboardShortcutModal.json": [
    "448311",
    [
      231661
    ]
  ],
  "./sv/account_calendar_settings_account_tree.json": [
    "350666",
    [
      115038
    ]
  ],
  "./en-GB/OutcomeDescriptionModal.json": [
    "7244",
    [
      369701
    ]
  ],
  "./hi/dashboard.json": [
    "519717",
    [
      449379
    ]
  ],
  "./uk/course_link_validator.json": [
    "660845",
    [
      422835
    ]
  ],
  "./hy/unpublished_changes_tray_contents.json": [
    "612684",
    [
      41724
    ]
  ],
  "./ja/widget_dashboard.json": [
    "283222",
    [
      347031
    ]
  ],
  "./ko/mutationActivity.json": [
    "18106",
    [
      82258
    ]
  ],
  "./ru/blueprint_settingsUnsyncedChanges.json": [
    "733910",
    [
      26366
    ]
  ],
  "./it/conferences.json": [
    "198456",
    [
      104908
    ]
  ],
  "./nn/peer-review-assignment-widget.json": [
    "682947",
    [
      148476
    ]
  ],
  "./ca/quantitative_data_options.json": [
    "559899",
    [
      246737
    ]
  ],
  "./ga/choose_mastery_path.json": [
    "332945",
    [
      30359
    ]
  ],
  "./ru/submit_assignment.json": [
    "753675",
    [
      758137
    ]
  ],
  "./zh-Hant/blueprint_settingsSyncHistory.json": [
    "299982",
    [
      882546
    ]
  ],
  "./uk/FindOutcomesModal.json": [
    "620677",
    [
      736955
    ]
  ],
  "./uk/syllabus_revisions.json": [
    "665736",
    [
      497032
    ]
  ],
  "./el/rate_limiting_settings.json": [
    "525535",
    [
      560889
    ]
  ],
  "./el/course_link_validator.json": [
    "373956",
    [
      564768
    ]
  ],
  "./es/group_submission_reminder.json": [
    "725945",
    [
      283368
    ]
  ],
  "./he/course_logging_details.json": [
    "299469",
    [
      653904
    ]
  ],
  "./fi/CreateEditAssignmentModal.json": [
    "406113",
    [
      284519
    ]
  ],
  "./nn/not_found_page_slide_puzzle.json": [
    "281565",
    [
      520191
    ]
  ],
  "./hu/assignments_2_attempt_tab.json": [
    "315576",
    [
      813544
    ]
  ],
  "./ca/react_scheduler.json": [
    "483459",
    [
      823689
    ]
  ],
  "./ht/bulk_edit_students.json": [
    "66192",
    [
      527364
    ]
  ],
  "./cy/course_paces_blackout_dates_table.json": [
    "504749",
    [
      466275
    ]
  ],
  "./hu/account_settings_jsx_bundle.json": [
    "376233",
    [
      719479
    ]
  ],
  "./ko/assignments_2_student_content.json": [
    "578609",
    [
      190751
    ]
  ],
  "./nb/discussion_row.json": [
    "51057",
    [
      526931
    ]
  ],
  "./sv/GroupDetailView.json": [
    "901340",
    [
      158200
    ]
  ],
  "./ru/ai_experiences.json": [
    "341201",
    [
      942439
    ]
  ],
  "./ar/gradebookActionMenu.json": [
    "689166",
    [
      939410
    ]
  ],
  "./ru/grade_summaryGroupView.json": [
    "932335",
    [
      682357
    ]
  ],
  "./it/course_paces_modal.json": [
    "908017",
    [
      482707
    ]
  ],
  "./sv-x-k12/course_paces_flaggable_number_input.json": [
    "707132",
    [
      313644
    ]
  ],
  "./hu/assignments.no_assignments_search.json": [
    "639682",
    [
      923823
    ]
  ],
  "./ar/ProfileTray.json": [
    "242144",
    [
      267740
    ]
  ],
  "./hu/permissions_role_tray.json": [
    "53103",
    [
      400109
    ]
  ],
  "./fi/quiz_statistics.json": [
    "468898",
    [
      924594
    ]
  ],
  "./nb-x-k12/permissions_v2.json": [
    "587133",
    [
      670123
    ]
  ],
  "./hi/pairing_code_user_observees.json": [
    "974380",
    [
      101804
    ]
  ],
  "./cy/media_immersive_view.json": [
    "911246",
    [
      692510
    ]
  ],
  "./tr/ai_experiences.json": [
    "784924",
    [
      824720
    ]
  ],
  "./pl/assignment_index.json": [
    "562916",
    [
      8744
    ]
  ],
  "./fr/OutcomeDescriptionModal.json": [
    "836269",
    [
      712272
    ]
  ],
  "./is/dashboard_grades_page.json": [
    "10051",
    [
      426273
    ]
  ],
  "./hu/course_stats.json": [
    "957626",
    [
      969186
    ]
  ],
  "./ko/filter_calendars_modal.json": [
    "556544",
    [
      849008
    ]
  ],
  "./hi/peer_review_configuration_tray.json": [
    "857590",
    [
      66158
    ]
  ],
  "./is/assignments.json": [
    "448632",
    [
      812176
    ]
  ],
  "./es-ES/roster_section_input.json": [
    "996025",
    [
      669999
    ]
  ],
  "./es/license_help.json": [
    "949013",
    [
      360796
    ]
  ],
  "./is/discussion_row.json": [
    "59077",
    [
      946179
    ]
  ],
  "./ms/course_stats.json": [
    "534171",
    [
      307041
    ]
  ],
  "./id/calculator_command.json": [
    "914623",
    [
      349353
    ]
  ],
  "./ca/AssignmentGroupListItemView.json": [
    "528500",
    [
      202844
    ]
  ],
  "./nb/GroupsTray.json": [
    "64874",
    [
      722622
    ]
  ],
  "./nn/assignments_2_student_content.json": [
    "176583",
    [
      284233
    ]
  ],
  "./nn/terms_of_service_modal.json": [
    "311505",
    [
      945915
    ]
  ],
  "./ru/terms_of_service_modal.json": [
    "874218",
    [
      249002
    ]
  ],
  "./el/a2_AccessibleTipContent.json": [
    "910207",
    [
      226105
    ]
  ],
  "./pl/nav_tourpoints.json": [
    "124589",
    [
      10551
    ]
  ],
  "./tr/file_not_found.json": [
    "128351",
    [
      55537
    ]
  ],
  "./nb/rootFoldersFinder.json": [
    "618379",
    [
      195749
    ]
  ],
  "./th/video_conference.json": [
    "931652",
    [
      244920
    ]
  ],
  "./mi/discussion_posts.json": [
    "423528",
    [
      932024
    ]
  ],
  "./es/rootFoldersFinder.json": [
    "171483",
    [
      697158
    ]
  ],
  "./nn/course_paces_no_results.json": [
    "301751",
    [
      536857
    ]
  ],
  "./zh-Hant/terms_of_use.json": [
    "600745",
    [
      785483
    ]
  ],
  "./da/sharedCurveGradesDialog.json": [
    "860821",
    [
      623339
    ]
  ],
  "./da/syllabus_revisions.json": [
    "243797",
    [
      130155
    ]
  ],
  "./mi/assignments_2_external_tool.json": [
    "415110",
    [
      459462
    ]
  ],
  "./sv-x-k12/course_paces_errors.json": [
    "477617",
    [
      371719
    ]
  ],
  "./pl/courses.show.json": [
    "691059",
    [
      461070
    ]
  ],
  "./fr/discussion_settings.json": [
    "694886",
    [
      877595
    ]
  ],
  "./pt-BR/blueprint_settingsMigrationSync.json": [
    "791447",
    [
      87154
    ]
  ],
  "./en-GB/MoveOutcomesModal.json": [
    "693418",
    [
      347927
    ]
  ],
  "./mi/AddGroup.json": [
    "442634",
    [
      382994
    ]
  ],
  "./zh-Hant/context_roster_user_services.json": [
    "501584",
    [
      833452
    ]
  ],
  "./ga/bulk_edit_students.json": [
    "518828",
    [
      679212
    ]
  ],
  "./en-GB/accessibility_course_statistics.json": [
    "330201",
    [
      615492
    ]
  ],
  "./es/nav_tourpoints.json": [
    "682957",
    [
      938516
    ]
  ],
  "./ru/account_calendar_settings_filter_controls.json": [
    "86739",
    [
      574849
    ]
  ],
  "./mi/outcome_detail.json": [
    "400828",
    [
      108580
    ]
  ],
  "./en-GB-x-lbs/account_settings_jsx_bundle.json": [
    "467776",
    [
      608248
    ]
  ],
  "./en-GB/react_collaborations.json": [
    "323975",
    [
      74230
    ]
  ],
  "./da-x-k12/assignments.no_assignments_search.json": [
    "962456",
    [
      988373
    ]
  ],
  "./sv-x-k12/account_calendar_settings_account_calendar_item.json": [
    "455608",
    [
      544048
    ]
  ],
  "./sl/course_paces_no_results.json": [
    "237136",
    [
      694612
    ]
  ],
  "./sv/course_paces_module.json": [
    "442616",
    [
      948060
    ]
  ],
  "./ht/assignmentsToggleShowByView.json": [
    "120397",
    [
      768463
    ]
  ],
  "./es/account_calendar_settings_account_group.json": [
    "154712",
    [
      173709
    ]
  ],
  "./fi/manage_avatars.json": [
    "693072",
    [
      887457
    ]
  ],
  "./el/permissions.json": [
    "730127",
    [
      111025
    ]
  ],
  "./id/direct_share_course_import_panel.json": [
    "277009",
    [
      602075
    ]
  ],
  "./ru/custom_emoji_deny_list.json": [
    "189999",
    [
      431077
    ]
  ],
  "./nn/self_unenrollment_modal.json": [
    "210096",
    [
      46156
    ]
  ],
  "./de/course_paces_search.json": [
    "895822",
    [
      569655
    ]
  ],
  "./da/epub_exports.json": [
    "425917",
    [
      46627
    ]
  ],
  "./is/rubrics-export.json": [
    "625149",
    [
      270731
    ]
  ],
  "./pt-BR/gradebook_history.json": [
    "234374",
    [
      387503
    ]
  ],
  "./fr/outcome_alignment_v2.json": [
    "214649",
    [
      499620
    ]
  ],
  "./cy/progression_module_header.json": [
    "812554",
    [
      722322
    ]
  ],
  "./he/context_modules_v2.json": [
    "531965",
    [
      883091
    ]
  ],
  "./tr/edit_section_end_date.json": [
    "816431",
    [
      689697
    ]
  ],
  "./pt-BR/custom_help_link.json": [
    "942381",
    [
      957852
    ]
  ],
  "./ms/video_conference.json": [
    "575188",
    [
      858092
    ]
  ],
  "./mi/blueprint_settingsCoursePickerTable.json": [
    "796634",
    [
      545474
    ]
  ],
  "./hu/outcome_reporting.json": [
    "744888",
    [
      736296
    ]
  ],
  "./hy/courses.json": [
    "544259",
    [
      970913
    ]
  ],
  "./fr-CA/blueprint_settingsSyncHistory.json": [
    "278109",
    [
      315831
    ]
  ],
  "./ko/canvascareer.json": [
    "315154",
    [
      854490
    ]
  ],
  "./ko/widget_dashboard.json": [
    "505855",
    [
      810285
    ]
  ],
  "./is/MasteryScale.json": [
    "124703",
    [
      434405
    ]
  ],
  "./ms/HelpTray.json": [
    "470681",
    [
      639399
    ]
  ],
  "./pt/assignments_2_media_attempt.json": [
    "677172",
    [
      103848
    ]
  ],
  "./da-x-k12/MoveOutcomesModal.json": [
    "900146",
    [
      482678
    ]
  ],
  "./sv/pairing_code_user_observees.json": [
    "45206",
    [
      268866
    ]
  ],
  "./uk/course_paces_module.json": [
    "330077",
    [
      985635
    ]
  ],
  "./uk/security_panel.json": [
    "816253",
    [
      879171
    ]
  ],
  "./ca/mutationActivity.json": [
    "485008",
    [
      321504
    ]
  ],
  "./fr-CA/editAssignmentGroupWeights.json": [
    "153524",
    [
      230376
    ]
  ],
  "./nb-x-k12/discussion_row.json": [
    "175911",
    [
      514989
    ]
  ],
  "./sl/widget_dashboard.json": [
    "106988",
    [
      255504
    ]
  ],
  "./th/GroupDetailView.json": [
    "478345",
    [
      239851
    ]
  ],
  "./de/roster_section_selector.json": [
    "555860",
    [
      15353
    ]
  ],
  "./fr/bulk_edit_students_table.json": [
    "677767",
    [
      913774
    ]
  ],
  "./hu/discussion_pinned_post.json": [
    "8365",
    [
      599523
    ]
  ],
  "./zh-Hans/course_statistics.json": [
    "653572",
    [
      347860
    ]
  ],
  "./it/course_paces_blackout_date_row.json": [
    "55917",
    [
      136607
    ]
  ],
  "./mi/course_paces_change_tracking.json": [
    "189817",
    [
      497191
    ]
  ],
  "./pt/theme_collection_view.json": [
    "250056",
    [
      12796
    ]
  ],
  "./es-ES/new_user_tutorial.json": [
    "256672",
    [
      536408
    ]
  ],
  "./ru/editAssignmentGroupWeights.json": [
    "842176",
    [
      368296
    ]
  ],
  "./pt/course_paces_blackout_date_row.json": [
    "839009",
    [
      908290
    ]
  ],
  "./zh-Hant/outcome_alignment_v2.json": [
    "764839",
    [
      476177
    ]
  ],
  "./sv/edit_section_end_date.json": [
    "536852",
    [
      71360
    ]
  ],
  "./ga/account_notification_settings.json": [
    "121799",
    [
      654541
    ]
  ],
  "./da/k5_dashboard.json": [
    "222292",
    [
      770396
    ]
  ],
  "./fa/rubrics-export.json": [
    "486802",
    [
      957538
    ]
  ],
  "./fi/dashboard_grades_page.json": [
    "150154",
    [
      532122
    ]
  ],
  "./hi/edit_section_view.json": [
    "385433",
    [
      745583
    ]
  ],
  "./hy/content_migrations_redesign.json": [
    "829346",
    [
      771314
    ]
  ],
  "./ht/assignments_2_submission_helpers.json": [
    "705460",
    [
      615496
    ]
  ],
  "./mi/sidenav.json": [
    "224040",
    [
      124600
    ]
  ],
  "./fi/course_search_results.json": [
    "583416",
    [
      751840
    ]
  ],
  "./nb/roster_section_selector.json": [
    "864567",
    [
      427929
    ]
  ],
  "./nn/AlignmentSummary.json": [
    "260857",
    [
      492123
    ]
  ],
  "./pl/ai_experiences.json": [
    "464994",
    [
      813654
    ]
  ],
  "./zh-Hans/epub_exports.json": [
    "922521",
    [
      154687
    ]
  ],
  "./pt/student_groups.json": [
    "82742",
    [
      979282
    ]
  ],
  "./ht/bulk_edit_students_actions.json": [
    "403380",
    [
      569024
    ]
  ],
  "./pl/blueprint_settingsCourseFilter.json": [
    "831160",
    [
      896996
    ]
  ],
  "./hu/blueprint_settingsCourseFilter.json": [
    "470449",
    [
      976495
    ]
  ],
  "./zh-Hant/blueprint_settingsMigrationOptions.json": [
    "193615",
    [
      870601
    ]
  ],
  "./zh-Hans/empty_modules.json": [
    "306218",
    [
      470858
    ]
  ],
  "./nl/CommentLibrary.json": [
    "854184",
    [
      136820
    ]
  ],
  "./ar/media_player_iframe_content.json": [
    "867746",
    [
      68902
    ]
  ],
  "./sv/course_paces_blueprint_lock.json": [
    "297475",
    [
      611581
    ]
  ],
  "./ar/assignments.no_assignments_search.json": [
    "208734",
    [
      179367
    ]
  ],
  "./ja/account_course_user_search.json": [
    "805719",
    [
      160730
    ]
  ],
  "./de/outcome_detail.json": [
    "68527",
    [
      145898
    ]
  ],
  "./fr-CA/assignments_2_student_annotation.json": [
    "37028",
    [
      970072
    ]
  ],
  "./he/keyboardShortcutModal.json": [
    "63193",
    [
      740039
    ]
  ],
  "./hi/NewTabIndicator.json": [
    "658275",
    [
      412097
    ]
  ],
  "./nb-x-k12/lti_registration.wizard.json": [
    "473406",
    [
      843009
    ]
  ],
  "./hi/MobileNavigation.json": [
    "58719",
    [
      868533
    ]
  ],
  "./fr-CA/todos_page.json": [
    "324792",
    [
      493916
    ]
  ],
  "./is/k5_course.json": [
    "4682",
    [
      507658
    ]
  ],
  "./zh-Hans/link_to_students.json": [
    "548814",
    [
      416486
    ]
  ],
  "./zh-Hans/external_content_cancel.json": [
    "104929",
    [
      63767
    ]
  ],
  "./zh-Hant/ai_experiences_show.json": [
    "425208",
    [
      939732
    ]
  ],
  "./id/quizzes.take_quiz.json": [
    "13869",
    [
      637846
    ]
  ],
  "./mi/roster_section_input.json": [
    "724580",
    [
      470492
    ]
  ],
  "./nb/notebook.json": [
    "684691",
    [
      385925
    ]
  ],
  "./pt-BR/calculator.json": [
    "594649",
    [
      228608
    ]
  ],
  "./en-GB/blueprint_settingsCourseFilter.json": [
    "532507",
    [
      187698
    ]
  ],
  "./en-CA/course_template_details.json": [
    "831287",
    [
      525917
    ]
  ],
  "./pt/ai_experiences_edit.json": [
    "848207",
    [
      540785
    ]
  ],
  "./de/notebook.json": [
    "429134",
    [
      770455
    ]
  ],
  "./en-AU/submit_assignment.json": [
    "636116",
    [
      963569
    ]
  ],
  "./fi/AssignmentListItemView.json": [
    "502590",
    [
      762038
    ]
  ],
  "./ja/account_calendar_settings_account_calendar_item_dropdown.json": [
    "838634",
    [
      192403
    ]
  ],
  "./it/ai_experiences_show.json": [
    "801427",
    [
      487709
    ]
  ],
  "./vi/bulk_edit_students_table.json": [
    "866492",
    [
      99708
    ]
  ],
  "./nl/course_paces_blueprint_lock.json": [
    "598127",
    [
      823728
    ]
  ],
  "./en/blueprint_course_sidebar.json": [
    "917501",
    [
      530948
    ]
  ],
  "./fr-CA/blueprint_settingsSyncChange.json": [
    "120675",
    [
      134237
    ]
  ],
  "./nl/course_pace_date_input.json": [
    "187861",
    [
      68343
    ]
  ],
  "./nl/syllabus_revisions.json": [
    "587714",
    [
      807470
    ]
  ],
  "./en-GB/assignments_peer_reviews_student.json": [
    "221704",
    [
      746065
    ]
  ],
  "./sv-x-k12/job_stats.json": [
    "560914",
    [
      150002
    ]
  ],
  "./sv/sharedCurveGradesDialog.json": [
    "328075",
    [
      643109
    ]
  ],
  "./sl/empty_modules.json": [
    "500922",
    [
      116558
    ]
  ],
  "./uk/course_paces_time_selection.json": [
    "418545",
    [
      384895
    ]
  ],
  "./da-x-k12/horizon_toggle.json": [
    "279349",
    [
      236511
    ]
  ],
  "./fr/account_calendars_results_area.json": [
    "868988",
    [
      702133
    ]
  ],
  "./es-ES/not_found_page_slide_puzzle.json": [
    "617276",
    [
      940780
    ]
  ],
  "./en/ProfileTray.json": [
    "808800",
    [
      208452
    ]
  ],
  "./sv-x-k12/users.json": [
    "993673",
    [
      838351
    ]
  ],
  "./it/content_copy_redesign.json": [
    "121828",
    [
      465944
    ]
  ],
  "./sv/top_navigation_tools.json": [
    "306159",
    [
      944921
    ]
  ],
  "./el/assignments_2_submission_histories_query.json": [
    "100013",
    [
      448583
    ]
  ],
  "./ga/canvascareer.json": [
    "467176",
    [
      355776
    ]
  ],
  "./hy/account_notification_settings.json": [
    "475072",
    [
      230600
    ]
  ],
  "./hy/course_paces_pace_picker.json": [
    "71772",
    [
      225004
    ]
  ],
  "./de/assignments_peer_reviews_student.json": [
    "921642",
    [
      851131
    ]
  ],
  "./ms/course_paces_no_results.json": [
    "187563",
    [
      583153
    ]
  ],
  "./pt-BR/edit_section_view.json": [
    "805063",
    [
      678850
    ]
  ],
  "./sl/calendar_sidebar.json": [
    "888006",
    [
      151045
    ]
  ],
  "./ko/assignments_2_url_entry.json": [
    "680962",
    [
      263114
    ]
  ],
  "./es/quantitative_data_options.json": [
    "813379",
    [
      999534
    ]
  ],
  "./en-GB-x-lbs/grades_summary.json": [
    "468327",
    [
      439117
    ]
  ],
  "./sl/calendar_appointment_group_edit.json": [
    "274772",
    [
      144200
    ]
  ],
  "./en-GB/LearningMasteryGradebook.json": [
    "688114",
    [
      864335
    ]
  ],
  "./ar/nav_tourpoints.json": [
    "930288",
    [
      253188
    ]
  ],
  "./da/user_logins.json": [
    "788739",
    [
      960041
    ]
  ],
  "./he/calculator.json": [
    "484267",
    [
      369649
    ]
  ],
  "./pt-BR/roster_section_input.json": [
    "353817",
    [
      984912
    ]
  ],
  "./en/content_migrations.json": [
    "698272",
    [
      185268
    ]
  ],
  "./fr-CA/copy_course.json": [
    "647840",
    [
      306684
    ]
  ],
  "./hu/announcements_on_home_page.json": [
    "42343",
    [
      295029
    ]
  ],
  "./hy/calendar_appointment_group_edit.json": [
    "663228",
    [
      951836
    ]
  ],
  "./en-GB-x-lbs/choose_mastery_path.json": [
    "785355",
    [
      55897
    ]
  ],
  "./mi/accessibility_course_statistics.json": [
    "331266",
    [
      624922
    ]
  ],
  "./hy/sis_import.json": [
    "448744",
    [
      548464
    ]
  ],
  "./fa/calendar_custom_recurring_event_repeat_picker.json": [
    "868117",
    [
      27459
    ]
  ],
  "./pt-BR/peer_review_allocation_rules_tray.json": [
    "176926",
    [
      328919
    ]
  ],
  "./sv-x-k12/CourseAvailabilityOptions.json": [
    "31921",
    [
      967364
    ]
  ],
  "./uk/assignments_2_student_content.json": [
    "193499",
    [
      534737
    ]
  ],
  "./vi/empty_course.json": [
    "787458",
    [
      712274
    ]
  ],
  "./ja/canvas_file_upload.json": [
    "284268",
    [
      365673
    ]
  ],
  "./fr-CA/webcam_modal.json": [
    "627206",
    [
      715106
    ]
  ],
  "./fr/assignments_2_text_entry.json": [
    "515278",
    [
      798259
    ]
  ],
  "./ga/react_scheduler.json": [
    "690391",
    [
      825725
    ]
  ],
  "./fi/assignmentsIndexView.json": [
    "524070",
    [
      552990
    ]
  ],
  "./nl/unpublished_changes_tray_contents.json": [
    "803741",
    [
      671911
    ]
  ],
  "./zh-Hant/registration.json": [
    "380385",
    [
      271867
    ]
  ],
  "./pt-BR/ignite_agent.json": [
    "735701",
    [
      463284
    ]
  ],
  "./nb/course_paces_blackout_date_row.json": [
    "927238",
    [
      431466
    ]
  ],
  "./el/course_paces_settings.json": [
    "58609",
    [
      656059
    ]
  ],
  "./es-ES/student_annotation_preview.json": [
    "432375",
    [
      831085
    ]
  ],
  "./sl/MoveOutcomesModal.json": [
    "4516",
    [
      588216
    ]
  ],
  "./ar/calculator_command.json": [
    "474269",
    [
      693639
    ]
  ],
  "./ca/accessibility_scan.json": [
    "228530",
    [
      745050
    ]
  ],
  "./ht/k5_dashboard.json": [
    "299669",
    [
      645183
    ]
  ],
  "./ko/outcome_alignment_v2.json": [
    "658856",
    [
      223633
    ]
  ],
  "./en-GB/peer_review_configuration_tray.json": [
    "743780",
    [
      594301
    ]
  ],
  "./hi/grades_empty_page.json": [
    "38665",
    [
      669455
    ]
  ],
  "./tr/question_bank.json": [
    "689167",
    [
      92777
    ]
  ],
  "./hu/editAssignmentGroupWeights.json": [
    "519638",
    [
      183670
    ]
  ],
  "./id/lti_registrations.json": [
    "151937",
    [
      452083
    ]
  ],
  "./ga/course_paces_empty_state.json": [
    "835156",
    [
      630116
    ]
  ],
  "./is/plugins.json": [
    "915610",
    [
      631034
    ]
  ],
  "./hi/last_attended.json": [
    "823957",
    [
      335139
    ]
  ],
  "./is/course_search_results.json": [
    "429297",
    [
      674695
    ]
  ],
  "./ja/ai_experiences_edit.json": [
    "504090",
    [
      253827
    ]
  ],
  "./en-CA/assignments.json": [
    "851228",
    [
      48620
    ]
  ],
  "./vi/security_panel.json": [
    "970574",
    [
      203654
    ]
  ],
  "./da-x-k12/user_grades.json": [
    "3431",
    [
      718737
    ]
  ],
  "./sv/unpublished_warning_modal.json": [
    "925049",
    [
      872331
    ]
  ],
  "./zh-Hant/OutcomeMoveModal.json": [
    "218946",
    [
      173270
    ]
  ],
  "./hi/question_banks.json": [
    "620867",
    [
      929153
    ]
  ],
  "./ja.eager.json": [
    "197722",
    [
      285253
    ]
  ],
  "./sl/submissions_show_preview.json": [
    "532523",
    [
      427285
    ]
  ],
  "./fa/blueprint_settingsSyncChange.json": [
    "349119",
    [
      98421
    ]
  ],
  "./nb/module_student_view_peer_reviews.json": [
    "706513",
    [
      94195
    ]
  ],
  "./is/account_calendar_settings_footer.json": [
    "221298",
    [
      113842
    ]
  ],
  "./tr/assignments_2_student_header_date_title.json": [
    "839627",
    [
      956941
    ]
  ],
  "./fi/AssignmentGroupListItemView.json": [
    "20153",
    [
      16655
    ]
  ],
  "./ht/discussion_topics.json": [
    "209843",
    [
      898181
    ]
  ],
  "./ga/pseudonyms_mobile_login.json": [
    "482170",
    [
      607402
    ]
  ],
  "./ar/link_to_students.json": [
    "497238",
    [
      685986
    ]
  ],
  "./it/new_user_tutorial.json": [
    "163984",
    [
      732220
    ]
  ],
  "./da/account_calendar_settings_account_tree.json": [
    "43480",
    [
      738296
    ]
  ],
  "./sl/entity_search_form.json": [
    "148540",
    [
      394024
    ]
  ],
  "./sv-x-k12/lti_registration.wizard.json": [
    "826851",
    [
      731558
    ]
  ],
  "./ko/course_paces_pace_picker.json": [
    "782211",
    [
      854185
    ]
  ],
  "./da-x-k12/moderate_quiz.json": [
    "711576",
    [
      194756
    ]
  ],
  "./fr-CA/peer_review_allocation_rules_tray.json": [
    "446058",
    [
      372582
    ]
  ],
  "./en-GB-x-ukhe/blueprint_settingsSyncChange.json": [
    "509582",
    [
      324246
    ]
  ],
  "./nn/module_sequence_footer.json": [
    "226480",
    [
      225204
    ]
  ],
  "./ru/AddGroup.json": [
    "958511",
    [
      69509
    ]
  ],
  "./fr/keyboardShortcutModal.json": [
    "733970",
    [
      239095
    ]
  ],
  "./fr/moderate_quiz.json": [
    "475393",
    [
      797415
    ]
  ],
  "./nn/content_migrations.json": [
    "860113",
    [
      705843
    ]
  ],
  "./mi/course_default_due_time.json": [
    "771674",
    [
      467490
    ]
  ],
  "./fa/a2LatePolicyToolTipContent.json": [
    "782460",
    [
      981500
    ]
  ],
  "./it/gradinggradingPeriodCollection.json": [
    "83968",
    [
      804004
    ]
  ],
  "./nl/outcome_reporting.json": [
    "957893",
    [
      522823
    ]
  ],
  "./da/user_restore.json": [
    "955181",
    [
      935315
    ]
  ],
  "./pt/top_navigation_tools.json": [
    "950760",
    [
      63220
    ]
  ],
  "./ja/link_validator.json": [
    "774484",
    [
      214417
    ]
  ],
  "./ca/dashboard_grading_period_select.json": [
    "867096",
    [
      505624
    ]
  ],
  "./ms/course_restore.json": [
    "311054",
    [
      471998
    ]
  ],
  "./uk/lti_registrations.json": [
    "782128",
    [
      950336
    ]
  ],
  "./ar/EditMasteryScaleLink.json": [
    "937102",
    [
      122250
    ]
  ],
  "./nl/conferences_alternatives.json": [
    "64320",
    [
      419548
    ]
  ],
  "./pl/lti_registrations.json": [
    "321464",
    [
      790692
    ]
  ],
  "./da-x-k12/blueprint_coursesExpandableLockOptions.json": [
    "789712",
    [
      367028
    ]
  ],
  "./sv-x-k12/AlignmentSummary.json": [
    "20264",
    [
      264640
    ]
  ],
  "./ko/pairing_code_user_observees.json": [
    "372297",
    [
      522215
    ]
  ],
  "./en-GB/assignments_2_student_header_date_title.json": [
    "16544",
    [
      859681
    ]
  ],
  "./vi/folder_tree.json": [
    "53142",
    [
      789454
    ]
  ],
  "./ko/quizzes_public.json": [
    "743631",
    [
      969597
    ]
  ],
  "./th/terms_of_service_modal.json": [
    "315293",
    [
      32359
    ]
  ],
  "./vi/IndividualStudentMasteryOutcome.json": [
    "8350",
    [
      32678
    ]
  ],
  "./zh-Hans/dashboard.json": [
    "464797",
    [
      907755
    ]
  ],
  "./en-CA/quiz_statistics.json": [
    "55115",
    [
      815785
    ]
  ],
  "./pl/account_calendar_settings_account_tree.json": [
    "669285",
    [
      410327
    ]
  ],
  "./nb/calendar_edit.json": [
    "768729",
    [
      15819
    ]
  ],
  "./hy/canvas_file_upload.json": [
    "6646",
    [
      529326
    ]
  ],
  "./en-GB/add_edit_pseudonym.json": [
    "220396",
    [
      125677
    ]
  ],
  "./he/content_exports.json": [
    "922804",
    [
      406188
    ]
  ],
  "./en-AU-x-unimelb/lti_registration.wizard.json": [
    "783264",
    [
      852323
    ]
  ],
  "./ar/gradebook_default_gradebook_components_content_filters_module_filter.json": [
    "899379",
    [
      348149
    ]
  ],
  "./ht/change_password.json": [
    "645262",
    [
      950426
    ]
  ],
  "./fi/license_help.json": [
    "972786",
    [
      309282
    ]
  ],
  "./mi/empty_modules.json": [
    "981267",
    [
      29865
    ]
  ],
  "./nl/account_calendar_settings_footer.json": [
    "156472",
    [
      449860
    ]
  ],
  "./el/account_calendar_settings_account_list.json": [
    "977282",
    [
      615950
    ]
  ],
  "./en-AU/grade_details.json": [
    "612910",
    [
      715951
    ]
  ],
  "./en-GB-x-lbs/notebook_index.json": [
    "969674",
    [
      137498
    ]
  ],
  "./da/user_date_range_search.json": [
    "888276",
    [
      538844
    ]
  ],
  "./hi/paginated_list.json": [
    "645731",
    [
      763185
    ]
  ],
  "./nb/CreateEditAssignmentModal.json": [
    "173208",
    [
      489980
    ]
  ],
  "./fr-CA/gradebook_history.json": [
    "595074",
    [
      832590
    ]
  ],
  "./es-ES/course_paces_header.json": [
    "982565",
    [
      133283
    ]
  ],
  "./it/assignments_2_student_points_display.json": [
    "894587",
    [
      473133
    ]
  ],
  "./zh-Hant/module_student_view_peer_reviews.json": [
    "646895",
    [
      551761
    ]
  ],
  "./pt-BR/progressbar_view.json": [
    "963173",
    [
      883876
    ]
  ],
  "./zh-Hant/gradebook.json": [
    "761250",
    [
      447110
    ]
  ],
  "./hi/courses.json": [
    "109715",
    [
      531249
    ]
  ],
  "./nn/assignments.never_drop.json": [
    "899272",
    [
      737063
    ]
  ],
  "./el/youtube_migration.json": [
    "996797",
    [
      984991
    ]
  ],
  "./sv-x-k12/progression_module_header.json": [
    "425081",
    [
      744671
    ]
  ],
  "./th/top_navigation_tools.json": [
    "664168",
    [
      161508
    ]
  ],
  "./sv-x-k12/dashboard_grades_page.json": [
    "186628",
    [
      411796
    ]
  ],
  "./hi/copy_course.json": [
    "591994",
    [
      424602
    ]
  ],
  "./mi/ImportConfirmBox.json": [
    "769780",
    [
      764140
    ]
  ],
  "./sv-x-k12/student_entries.json": [
    "45093",
    [
      805539
    ]
  ],
  "./en-AU-x-unimelb/AlignmentSummary.json": [
    "860797",
    [
      646663
    ]
  ],
  "./ja/quantitative_data_options.json": [
    "573486",
    [
      532623
    ]
  ],
  "./es/discussion_row.json": [
    "543841",
    [
      782000
    ]
  ],
  "./es/lti_registration.wizard.json": [
    "703992",
    [
      894381
    ]
  ],
  "./id/confirmMasteryModal.json": [
    "904873",
    [
      620171
    ]
  ],
  "./sl/pseudonyms_mobile_login.json": [
    "319809",
    [
      456235
    ]
  ],
  "./es-ES/courses.show.json": [
    "576260",
    [
      929015
    ]
  ],
  "./nn/announcements_v2.json": [
    "353411",
    [
      746509
    ]
  ],
  "./pt-BR/rubrics-export.json": [
    "97450",
    [
      39435
    ]
  ],
  "./sv/admin_split.json": [
    "450907",
    [
      887490
    ]
  ],
  "./sv-x-k12/discussion_create.json": [
    "50448",
    [
      546424
    ]
  ],
  "./ko/grades_summary.json": [
    "786391",
    [
      491445
    ]
  ],
  "./ja/AccountsTray.json": [
    "956493",
    [
      673636
    ]
  ],
  "./nn/grade_summary.json": [
    "320994",
    [
      892430
    ]
  ],
  "./pt/calendar_sidebar.json": [
    "30539",
    [
      466453
    ]
  ],
  "./fr-CA/assignments_2_MoreOptions_CanvasFiles.json": [
    "358294",
    [
      532498
    ]
  ],
  "./ms/unpublished_changes_tray_contents.json": [
    "43391",
    [
      47229
    ]
  ],
  "./id/permissions_role_tray.json": [
    "583309",
    [
      961615
    ]
  ],
  "./da-x-k12/Navigation.json": [
    "808791",
    [
      302809
    ]
  ],
  "./nb-x-k12/AlignmentSummary.json": [
    "421991",
    [
      68653
    ]
  ],
  "./pt/LogoutButton.json": [
    "575496",
    [
      164284
    ]
  ],
  "./de/SpeedGraderDiscussionsNavigation.json": [
    "239340",
    [
      627153
    ]
  ],
  "./ko/accessibility_course_statistics.json": [
    "204886",
    [
      564070
    ]
  ],
  "./mi/use_switch_experience.json": [
    "286945",
    [
      553471
    ]
  ],
  "./ar/learning_mastery_gradebook.json": [
    "693110",
    [
      562378
    ]
  ],
  "./ca/account_calendars_results_area.json": [
    "440172",
    [
      344484
    ]
  ],
  "./en-AU-x-unimelb/horizon_toggle.json": [
    "942778",
    [
      835414
    ]
  ],
  "./en-GB-x-ukhe/discussion_pinned_post.json": [
    "55550",
    [
      586758
    ]
  ],
  "./it/gradebook_uploads.json": [
    "514708",
    [
      177816
    ]
  ],
  "./th/a2LatePolicyStatusDisplay.json": [
    "393621",
    [
      303439
    ]
  ],
  "./nn/change_password.json": [
    "286738",
    [
      246430
    ]
  ],
  "./sv/permissions_v2_add_tray.json": [
    "464125",
    [
      479167
    ]
  ],
  "./en-GB/announcements_v2.json": [
    "358408",
    [
      574169
    ]
  ],
  "./hy/course_paces_blackout_dates_modal.json": [
    "625623",
    [
      628557
    ]
  ],
  "./es/AssignmentListItemView.json": [
    "790997",
    [
      312124
    ]
  ],
  "./fa/appt_calendar_event_dialog.json": [
    "643797",
    [
      884419
    ]
  ],
  "./it/quiz_migration_notifications.json": [
    "106372",
    [
      202360
    ]
  ],
  "./fr/AssignmentListItemView.json": [
    "154413",
    [
      503488
    ]
  ],
  "./tr/student_entries.json": [
    "684608",
    [
      187884
    ]
  ],
  "./nb-x-k12/course_color_selector.json": [
    "107723",
    [
      293817
    ]
  ],
  "./cy/blueprint_settingsCoursePicker.json": [
    "774820",
    [
      414300
    ]
  ],
  "./es-ES/peer_reviews_student.json": [
    "829191",
    [
      644573
    ]
  ],
  "./pt/filter_calendars_modal.json": [
    "943930",
    [
      193390
    ]
  ],
  "./it/top_navigation_tools.json": [
    "694475",
    [
      333013
    ]
  ],
  "./zh-Hant/DueDateOverrideView.json": [
    "15907",
    [
      562365
    ]
  ],
  "./fr/permissions_v2_add_tray.json": [
    "227824",
    [
      847918
    ]
  ],
  "./en-AU-x-unimelb/last_attended.json": [
    "337374",
    [
      245514
    ]
  ],
  "./en-AU/announcements_v2.json": [
    "263357",
    [
      307444
    ]
  ],
  "./fa/discussion_create.json": [
    "106994",
    [
      46082
    ]
  ],
  "./ko/media_player_iframe_content.json": [
    "854975",
    [
      87021
    ]
  ],
  "./hi/assignment_show.json": [
    "432194",
    [
      661346
    ]
  ],
  "./he/react_collaborations.json": [
    "173817",
    [
      539431
    ]
  ],
  "./he/appt_calendar_event_dialog.json": [
    "103975",
    [
      819253
    ]
  ],
  "./el/quiz_statistics.json": [
    "966198",
    [
      902434
    ]
  ],
  "./nb-x-k12/quizzes_public.json": [
    "532635",
    [
      703097
    ]
  ],
  "./es/last_attended.json": [
    "916582",
    [
      537239
    ]
  ],
  "./nb-x-k12/gradinggradingPeriodCollection.json": [
    "423829",
    [
      590771
    ]
  ],
  "./cy/course_logging_details.json": [
    "31096",
    [
      992360
    ]
  ],
  "./uk/discussion_settings.json": [
    "861942",
    [
      755110
    ]
  ],
  "./ms/assignments_2_initial_query.json": [
    "8517",
    [
      116427
    ]
  ],
  "./en-GB/student_groups.json": [
    "737805",
    [
      234864
    ]
  ],
  "./hu/auth_logging.json": [
    "604887",
    [
      802405
    ]
  ],
  "./ms/knowledge_check_not_ready.json": [
    "261339",
    [
      574241
    ]
  ],
  "./mi/context_roster_user_services.json": [
    "722400",
    [
      116608
    ]
  ],
  "./tr/user_lists.json": [
    "642389",
    [
      898623
    ]
  ],
  "./de/assignments.no_assignments_search.json": [
    "82566",
    [
      741391
    ]
  ],
  "./en-GB-x-ukhe/edit_section_view.json": [
    "892368",
    [
      883816
    ]
  ],
  "./cy/content_migrations.json": [
    "209469",
    [
      837331
    ]
  ],
  "./cy/section.json": [
    "231409",
    [
      887919
    ]
  ],
  "./pt/account_calendar_settings_account_group.json": [
    "377184",
    [
      778788
    ]
  ],
  "./es-ES/canvas_file_upload.json": [
    "485552",
    [
      873128
    ]
  ],
  "./hi/important_dates_empty.json": [
    "840051",
    [
      251969
    ]
  ],
  "./vi/AccountsTray.json": [
    "645345",
    [
      607047
    ]
  ],
  "./vi/sharedSetDefaultGradeDialog.json": [
    "546680",
    [
      885120
    ]
  ],
  "./ht/blueprint_coursesExpandableLockOptions.json": [
    "774515",
    [
      778453
    ]
  ],
  "./hy/authentication_providers.json": [
    "648402",
    [
      185698
    ]
  ],
  "./ja/dashboard_grading_period_select.json": [
    "696501",
    [
      237292
    ]
  ],
  "./en-GB/blueprint_settingsAssociationsTable.json": [
    "615396",
    [
      481605
    ]
  ],
  "./pl/discovery_page.json": [
    "952622",
    [
      122146
    ]
  ],
  "./ko/NewTabIndicator.json": [
    "61610",
    [
      284162
    ]
  ],
  "./es/question_bank.json": [
    "310633",
    [
      361944
    ]
  ],
  "./nn/outcome_alignment_v2.json": [
    "572181",
    [
      119551
    ]
  ],
  "./sv/dashboard.json": [
    "590679",
    [
      400449
    ]
  ],
  "./hi/manage_avatars.json": [
    "861577",
    [
      361519
    ]
  ],
  "./it/filter_calendars_modal.json": [
    "430781",
    [
      857543
    ]
  ],
  "./ga/widget_dashboard.json": [
    "471501",
    [
      524251
    ]
  ],
  "./he/error_form.json": [
    "2326",
    [
      284822
    ]
  ],
  "./ht/ImportConfirmBox.json": [
    "874722",
    [
      750182
    ]
  ],
  "./ko/user_search_results.json": [
    "243761",
    [
      962463
    ]
  ],
  "./es/rate_limiting_settings.json": [
    "794652",
    [
      118889
    ]
  ],
  "./fi/folder_tree.json": [
    "830950",
    [
      762430
    ]
  ],
  "./nl/new_user_tutorial.json": [
    "392615",
    [
      870913
    ]
  ],
  "./ar/suppress_notifications.json": [
    "681295",
    [
      815817
    ]
  ],
  "./cy/gradebook.json": [
    "886200",
    [
      374408
    ]
  ],
  "./en-GB-x-lbs/gradebook_uploads.json": [
    "46899",
    [
      264401
    ]
  ],
  "./hy/calendar_custom_recurring_event_repeat_picker.json": [
    "519115",
    [
      997673
    ]
  ],
  "./da/file_not_found.json": [
    "102104",
    [
      746808
    ]
  ],
  "./de/grade_change_logging_content.json": [
    "578647",
    [
      348306
    ]
  ],
  "./da-x-k12/CourseAvailabilityOptions.json": [
    "95979",
    [
      790469
    ]
  ],
  "./id/content_shares.json": [
    "797047",
    [
      956825
    ]
  ],
  "./pl/assignments_2_student_points_display.json": [
    "693492",
    [
      352480
    ]
  ],
  "./ca/discussion_row.json": [
    "316313",
    [
      660311
    ]
  ],
  "./en-GB/assignmentsIndexView.json": [
    "69194",
    [
      124095
    ]
  ],
  "./fi/quizzes_index.json": [
    "600945",
    [
      743847
    ]
  ],
  "./pl/todo.json": [
    "278774",
    [
      873074
    ]
  ],
  "./fr/editGroup.json": [
    "485218",
    [
      676672
    ]
  ],
  "./is/content_copy_redesign.json": [
    "724909",
    [
      438235
    ]
  ],
  "./vi/assignments_2_text_entry.json": [
    "633249",
    [
      561367
    ]
  ],
  "./sv-x-k12/assignment_index_deep_linking_handlers.json": [
    "605913",
    [
      622255
    ]
  ],
  "./vi/peer_review_configuration_tray.json": [
    "777888",
    [
      998952
    ]
  ],
  "./he/assignment_index.json": [
    "342601",
    [
      484503
    ]
  ],
  "./da/users.json": [
    "965069",
    [
      343923
    ]
  ],
  "./he/rate_limiting_settings.json": [
    "506689",
    [
      280415
    ]
  ],
  "./hi/quizzes_openModerateStudentDialog.json": [
    "851687",
    [
      652077
    ]
  ],
  "./ja/login.json": [
    "126834",
    [
      835163
    ]
  ],
  "./sl/assignments_2_submission_histories_query.json": [
    "895967",
    [
      58425
    ]
  ],
  "./tr/assignments_2_student_annotation.json": [
    "312973",
    [
      215263
    ]
  ],
  "./ar/copy_warnings_modal.json": [
    "718648",
    [
      639268
    ]
  ],
  "./ar/grade_summary.json": [
    "85845",
    [
      637815
    ]
  ],
  "./fr-CA/manage_avatars.json": [
    "742943",
    [
      901841
    ]
  ],
  "./fa/k5_dashboard_card.json": [
    "202265",
    [
      438911
    ]
  ],
  "./fr-CA/blueprint_settingsCourseFilter.json": [
    "325851",
    [
      415533
    ]
  ],
  "./ru/a2_AccessibleTipContent.json": [
    "254347",
    [
      39609
    ]
  ],
  "./th/discovery_page.json": [
    "811318",
    [
      663210
    ]
  ],
  "./vi/SpeedGraderSettingsMenu.json": [
    "79353",
    [
      238255
    ]
  ],
  "./de/announcements_v2.json": [
    "3682",
    [
      385491
    ]
  ],
  "./ht/FindOutcomesModal.json": [
    "580781",
    [
      245359
    ]
  ],
  "./id/assignment_index_menu.json": [
    "862371",
    [
      205949
    ]
  ],
  "./nl/registration.json": [
    "699909",
    [
      532575
    ]
  ],
  "./sv-x-k12/webzip_export.json": [
    "96213",
    [
      413891
    ]
  ],
  "./is/course_paces_header.json": [
    "654472",
    [
      684864
    ]
  ],
  "./nb-x-k12/mutationActivity.json": [
    "588886",
    [
      282814
    ]
  ],
  "./hy/discussion_row.json": [
    "178432",
    [
      103867
    ]
  ],
  "./sl/editAssignmentGroupWeights.json": [
    "223282",
    [
      285086
    ]
  ],
  "./cy/assignments_2_login_action_prompt.json": [
    "220641",
    [
      939359
    ]
  ],
  "./fa/course_logging_details.json": [
    "139467",
    [
      880345
    ]
  ],
  "./sv-x-k12/sections_tooltip.json": [
    "766327",
    [
      804365
    ]
  ],
  "./en-AU/sidenav.json": [
    "471952",
    [
      534069
    ]
  ],
  "./pt/theme_editor.json": [
    "724377",
    [
      881147
    ]
  ],
  "./en/calendar_appointment_group_edit.json": [
    "679164",
    [
      473744
    ]
  ],
  "./en-AU-x-unimelb/course_paces_actions.json": [
    "218832",
    [
      773484
    ]
  ],
  "./fr-CA/empty_modules.json": [
    "553784",
    [
      813260
    ]
  ],
  "./nl/media_player_iframe_content.json": [
    "642527",
    [
      49377
    ]
  ],
  "./el/quizzes.take_quiz.json": [
    "560721",
    [
      434058
    ]
  ],
  "./es-ES/question_banks.json": [
    "447045",
    [
      686387
    ]
  ],
  "./el/content_migrations_redesign.json": [
    "307032",
    [
      691964
    ]
  ],
  "./pl/course_paces_modal.json": [
    "705926",
    [
      386706
    ]
  ],
  "./sv-x-k12/modules_home_page.json": [
    "355712",
    [
      941496
    ]
  ],
  "./cy/accessibility_checker.json": [
    "502358",
    [
      518326
    ]
  ],
  "./sv-x-k12/syllabus_revisions.json": [
    "837513",
    [
      955199
    ]
  ],
  "./id/conferences_alternatives.json": [
    "549549",
    [
      525951
    ]
  ],
  "./en-CA/quiz_log_auditing.json": [
    "461702",
    [
      878590
    ]
  ],
  "./nb/AddGroup.json": [
    "736856",
    [
      938620
    ]
  ],
  "./vi/new_nav.json": [
    "302243",
    [
      427313
    ]
  ],
  "./pt/self_unenrollment_modal.json": [
    "507468",
    [
      19016
    ]
  ],
  "./en-GB-x-ukhe/course_pace_date_input.json": [
    "373597",
    [
      115755
    ]
  ],
  "./ca/plugins.json": [
    "968350",
    [
      37630
    ]
  ],
  "./ca/link_to_students.json": [
    "109999",
    [
      370429
    ]
  ],
  "./de/k5_dashboard_card.json": [
    "877327",
    [
      336810
    ]
  ],
  "./en-GB-x-ukhe/course_paces_blackout_dates_table.json": [
    "160339",
    [
      662081
    ]
  ],
  "./da/user_profile.json": [
    "461586",
    [
      773658
    ]
  ],
  "./en/peer_reviews_student.json": [
    "411305",
    [
      839819
    ]
  ],
  "./ru/discussion_create.json": [
    "987162",
    [
      788170
    ]
  ],
  "./zh-Hant/MoveOutcomesModal.json": [
    "571377",
    [
      790259
    ]
  ],
  "./mi/CoursesTray.json": [
    "523750",
    [
      234310
    ]
  ],
  "./ar/account_calendar_settings_account_calendar_item_dropdown.json": [
    "235192",
    [
      224964
    ]
  ],
  "./nb-x-k12/course_paces_projected_dates.json": [
    "636947",
    [
      203329
    ]
  ],
  "./ca/account_calendar_settings_account_calendar_item.json": [
    "850115",
    [
      383369
    ]
  ],
  "./is/course_paces_time_selection.json": [
    "110045",
    [
      937787
    ]
  ],
  "./it/assignmentsToggleShowByView.json": [
    "492216",
    [
      239260
    ]
  ],
  "./fr/course_color_selector.json": [
    "448977",
    [
      899596
    ]
  ],
  "./hu/quiz_show.json": [
    "102498",
    [
      9242
    ]
  ],
  "./mi/assignments_2_initial_query.json": [
    "688575",
    [
      289853
    ]
  ],
  "./nl/manage_avatars.json": [
    "955546",
    [
      494590
    ]
  ],
  "./ko/react_collaborations.json": [
    "698086",
    [
      629366
    ]
  ],
  "./pt/quizzes_public.json": [
    "976261",
    [
      650575
    ]
  ],
  "./sv/blueprint_settingsCoursePicker.json": [
    "141059",
    [
      774941
    ]
  ],
  "./sv/notebook_index.json": [
    "652303",
    [
      989977
    ]
  ],
  "./zh-Hant/custom_help_link.json": [
    "663612",
    [
      207328
    ]
  ],
  "./zh-Hans/account_calendar_settings_account_tree.json": [
    "915172",
    [
      561028
    ]
  ],
  "./da-x-k12/outcome_alignment_v2.json": [
    "156866",
    [
      381150
    ]
  ],
  "./cy/FindOutcomesModal.json": [
    "871693",
    [
      114275
    ]
  ],
  "./fi/courses.json": [
    "610973",
    [
      688363
    ]
  ],
  "./ru/important_dates.json": [
    "884784",
    [
      9697
    ]
  ],
  "./vi/blueprint_settingsAssociationsTable.json": [
    "998472",
    [
      622144
    ]
  ],
  "./en-GB-x-lbs/copy_course.json": [
    "171371",
    [
      271641
    ]
  ],
  "./fr-CA/course_search_results.json": [
    "97380",
    [
      421840
    ]
  ],
  "./zh-Hant/manage_avatars.json": [
    "258158",
    [
      464274
    ]
  ],
  "./ms/new_nav.json": [
    "84010",
    [
      330290
    ]
  ],
  "./nb/outcome_management.json": [
    "558920",
    [
      815772
    ]
  ],
  "./da/gradebookOutcomeGradebookView.json": [
    "46704",
    [
      91616
    ]
  ],
  "./pt-BR/quiz_show.json": [
    "161048",
    [
      398965
    ]
  ],
  "./nb/blueprint_settingsCoursePicker.json": [
    "5860",
    [
      224064
    ]
  ],
  "./is/bulk_edit_students_table.json": [
    "909811",
    [
      329473
    ]
  ],
  "./sl/conversations_2.json": [
    "298536",
    [
      713924
    ]
  ],
  "./hi/course_paces_empty_state.json": [
    "23465",
    [
      485791
    ]
  ],
  "./en-AU-x-unimelb/ai_experiences_show.json": [
    "688962",
    [
      66766
    ]
  ],
  "./ar/plugins.json": [
    "201585",
    [
      978915
    ]
  ],
  "./uk/account_notification_settings.json": [
    "52275",
    [
      269561
    ]
  ],
  "./it/calendar_appointment_group_edit.json": [
    "850394",
    [
      859150
    ]
  ],
  "./mi/pseudonyms_mobile_login.json": [
    "324316",
    [
      695556
    ]
  ],
  "./is/react_developer_keys.json": [
    "354037",
    [
      257299
    ]
  ],
  "./ms/manage_avatars.json": [
    "102536",
    [
      62584
    ]
  ],
  "./fi/courses_show.json": [
    "504367",
    [
      708549
    ]
  ],
  "./pt/lti_registration.wizard.json": [
    "785264",
    [
      770283
    ]
  ],
  "./da/admin_split.json": [
    "379473",
    [
      815423
    ]
  ],
  "./hu/course_search_results.json": [
    "221790",
    [
      903246
    ]
  ],
  "./hy/assignments_2_media_attempt.json": [
    "165035",
    [
      98313
    ]
  ],
  "./en-AU-x-unimelb/section.json": [
    "966425",
    [
      184547
    ]
  ],
  "./it/use_switch_experience.json": [
    "877602",
    [
      986638
    ]
  ],
  "./ko/peer_review_allocation_rules_tray.json": [
    "547133",
    [
      260195
    ]
  ],
  "./is/gradinggradingPeriodCollection.json": [
    "910935",
    [
      157853
    ]
  ],
  "./hu/outcomes_user_outcome_results.json": [
    "935926",
    [
      505974
    ]
  ],
  "./el/gradebook_uploads.json": [
    "458432",
    [
      740516
    ]
  ],
  "./fi/DueDateOverrideView.json": [
    "336716",
    [
      441260
    ]
  ],
  "./en-GB-x-ukhe/assignments_peer_reviews.json": [
    "558637",
    [
      141259
    ]
  ],
  "./sl/account_calendar_settings_account_calendar_item.json": [
    "184176",
    [
      165812
    ]
  ],
  "./en-GB/choose_mastery_path.json": [
    "808928",
    [
      335521
    ]
  ],
  "./fr/edit_section_view.json": [
    "687642",
    [
      914551
    ]
  ],
  "./sl/student_annotation_preview.json": [
    "233205",
    [
      209879
    ]
  ],
  "./sv/SpeedGraderSettingsMenu.json": [
    "666765",
    [
      154719
    ]
  ],
  "./tr/auth_logging.json": [
    "292416",
    [
      517396
    ]
  ],
  "./es/content_share_preview_overlay.json": [
    "20239",
    [
      197858
    ]
  ],
  "./hi/account_calendar_settings_filter_controls.json": [
    "436905",
    [
      141167
    ]
  ],
  "./sv/calendar_sidebar.json": [
    "269707",
    [
      800204
    ]
  ],
  "./vi/OutcomeMoveModal.json": [
    "702283",
    [
      832905
    ]
  ],
  "./nb-x-k12/assignments_2_shared_Steps.json": [
    "956649",
    [
      639631
    ]
  ],
  "./ga/peer-review-assignment-widget.json": [
    "542512",
    [
      839144
    ]
  ],
  "./da/account_calendar_settings_account_calendar_item_dropdown.json": [
    "13252",
    [
      345484
    ]
  ],
  "./id/course_paces_time_selection.json": [
    "177104",
    [
      87884
    ]
  ],
  "./ms/account_calendar_settings_account_calendar_item_dropdown.json": [
    "381045",
    [
      90683
    ]
  ],
  "./nb-x-k12/course_paces_blackout_dates_modal.json": [
    "456738",
    [
      453746
    ]
  ],
  "./hy/editGroup.json": [
    "7182",
    [
      111990
    ]
  ],
  "./el/assignments_peer_reviews.json": [
    "176600",
    [
      414068
    ]
  ],
  "./es/editAssignmentGroupWeights.json": [
    "388523",
    [
      296534
    ]
  ],
  "./da-x-k12/bulk_edit_students.json": [
    "662715",
    [
      348061
    ]
  ],
  "./mi/assignments_2_peer_review.json": [
    "116801",
    [
      90796
    ]
  ],
  "./cy/course_paces_settings.json": [
    "400148",
    [
      297548
    ]
  ],
  "./nn/gradebook_uploads.json": [
    "647757",
    [
      190415
    ]
  ],
  "./sv-x-k12/discussionTopicKeyboradShortcutModal.json": [
    "34888",
    [
      493664
    ]
  ],
  "./th/empty_modules.json": [
    "394541",
    [
      763447
    ]
  ],
  "./tr/rate_limiting_settings.json": [
    "66790",
    [
      201666
    ]
  ],
  "./ru/course_link_validator.json": [
    "177304",
    [
      947616
    ]
  ],
  "./ja/external_content_cancel.json": [
    "688183",
    [
      536954
    ]
  ],
  "./nb/assignments_2_student_content.json": [
    "411763",
    [
      554213
    ]
  ],
  "./es/outcome_alignment_v2.json": [
    "74257",
    [
      702880
    ]
  ],
  "./fa/blueprint_settingsSyncHistory.json": [
    "695113",
    [
      852415
    ]
  ],
  "./sv-x-k12/assignments_2_external_tool.json": [
    "234847",
    [
      956069
    ]
  ],
  "./sv/AssignmentListItemView.json": [
    "780578",
    [
      634198
    ]
  ],
  "./en/account_calendars.json": [
    "567910",
    [
      330762
    ]
  ],
  "./fa/ai_experiences_edit.json": [
    "353270",
    [
      983470
    ]
  ],
  "./zh-Hant/roster_section_input.json": [
    "277012",
    [
      877864
    ]
  ],
  "./fr/section.json": [
    "201929",
    [
      121020
    ]
  ],
  "./ko/registration.json": [
    "5733",
    [
      906427
    ]
  ],
  "./cy/link_validator.json": [
    "514819",
    [
      995097
    ]
  ],
  "./ru/calculator.json": [
    "642377",
    [
      840431
    ]
  ],
  "./el/modules_page_icon_legend.json": [
    "176436",
    [
      541056
    ]
  ],
  "./nb/default_account_quotas.json": [
    "134365",
    [
      808503
    ]
  ],
  "./nl/edit_section_dates.json": [
    "135106",
    [
      341166
    ]
  ],
  "./pt-BR/choose_mastery_path.json": [
    "193324",
    [
      591729
    ]
  ],
  "./fr-CA/quizzes_index.json": [
    "350653",
    [
      598839
    ]
  ],
  "./ja/notebook_index.json": [
    "764815",
    [
      271314
    ]
  ],
  "./fr/assignments.json": [
    "324172",
    [
      223549
    ]
  ],
  "./ms/OutcomeDescriptionModal.json": [
    "659613",
    [
      435923
    ]
  ],
  "./pl/quantitative_data_options.json": [
    "441507",
    [
      317525
    ]
  ],
  "./vi/editGroup.json": [
    "343160",
    [
      527152
    ]
  ],
  "./ja/bulk_edit_students_table.json": [
    "42856",
    [
      756813
    ]
  ],
  "./fi/quiz_log_auditing.json": [
    "131711",
    [
      798613
    ]
  ],
  "./hu/epub_exports.json": [
    "855661",
    [
      80419
    ]
  ],
  "./nn/discussion_row.json": [
    "15085",
    [
      683855
    ]
  ],
  "./en-GB-x-ukhe/course_paces_pace_picker.json": [
    "259435",
    [
      977993
    ]
  ],
  "./fa/copy_course.json": [
    "377220",
    [
      863012
    ]
  ],
  "./fi/ai_experiences_show.json": [
    "685427",
    [
      498449
    ]
  ],
  "./hi/ldap_cert_upload.json": [
    "376255",
    [
      744085
    ]
  ],
  "./pt/SpeedGraderPostGradesMenu.json": [
    "4095",
    [
      586585
    ]
  ],
  "./ht/SpeedGraderSettingsMenu.json": [
    "801112",
    [
      601428
    ]
  ],
  "./en-GB/FindOutcomesModal.json": [
    "522540",
    [
      355829
    ]
  ],
  "./de/user_lists.json": [
    "672158",
    [
      595047
    ]
  ],
  "./hi/MasteryScale.json": [
    "35450",
    [
      690362
    ]
  ],
  "./sl/assignments_2_shared_Steps.json": [
    "252878",
    [
      939386
    ]
  ],
  "./th/discussionTopicKeyboradShortcutModal.json": [
    "230689",
    [
      126547
    ]
  ],
  "./ms/course_link_validator.json": [
    "143853",
    [
      946339
    ]
  ],
  "./da-x-k12/license_help.json": [
    "157622",
    [
      271730
    ]
  ],
  "./hy/react_collaborations.json": [
    "156893",
    [
      777467
    ]
  ],
  "./nb-x-k12/assignments.no_assignments_search.json": [
    "320111",
    [
      530980
    ]
  ],
  "./fr-CA/course_paces_header.json": [
    "605721",
    [
      517043
    ]
  ],
  "./en-AU-x-unimelb/course_pace_date_input.json": [
    "788351",
    [
      275545
    ]
  ],
  "./th/quizzes_quiz_submission.json": [
    "174986",
    [
      38398
    ]
  ],
  "./tr/courses.json": [
    "623490",
    [
      721318
    ]
  ],
  "./nl/quizzes_index.json": [
    "699126",
    [
      636466
    ]
  ],
  "./ms/peer-review-assignment-widget.json": [
    "346284",
    [
      303956
    ]
  ],
  "./ar.json": [
    "587622",
    [
      699868
    ]
  ],
  "./es/courses.json": [
    "554636",
    [
      461913
    ]
  ],
  "./fi/discussion_create.json": [
    "276826",
    [
      53370
    ]
  ],
  "./hy/HelpTray.json": [
    "877172",
    [
      74820
    ]
  ],
  "./ar/user_date_range_search.json": [
    "120968",
    [
      800788
    ]
  ],
  "./nb/assignments_2_student_points_display.json": [
    "551652",
    [
      862160
    ]
  ],
  "./ko/a2_AccessibleTipContent.json": [
    "27940",
    [
      113772
    ]
  ],
  "./sv/gradebook_uploads.json": [
    "159760",
    [
      730484
    ]
  ],
  "./da/permissions_v2_add_tray.json": [
    "869159",
    [
      184133
    ]
  ],
  "./de/peer_reviews_student.json": [
    "224641",
    [
      965336
    ]
  ],
  "./en-AU/SpeedGraderPostGradesMenu.json": [
    "223209",
    [
      445851
    ]
  ],
  "./uk/auth_logging.json": [
    "609306",
    [
      840018
    ]
  ],
  "./ar/important_dates.json": [
    "106753",
    [
      145819
    ]
  ],
  "./zh-Hans/course_paces_actions.json": [
    "262181",
    [
      263091
    ]
  ],
  "./pt-BR/assignments_2_student_content_rubric_self_assessment.json": [
    "629604",
    [
      496377
    ]
  ],
  "./ar/sidenav.json": [
    "355893",
    [
      143343
    ]
  ],
  "./pl/quizzes_openModerateStudentDialog.json": [
    "209252",
    [
      321680
    ]
  ],
  "./hi/edit_section_dates.json": [
    "523189",
    [
      346595
    ]
  ],
  "./is/media_player_iframe_content.json": [
    "389749",
    [
      344611
    ]
  ],
  "./sv-x-k12/change_password.json": [
    "349601",
    [
      209623
    ]
  ],
  "./ru/gradebook.json": [
    "127618",
    [
      429411
    ]
  ],
  "./da-x-k12/conferences.json": [
    "7796",
    [
      843824
    ]
  ],
  "./en-GB/assignments_2_url_entry.json": [
    "346733",
    [
      99480
    ]
  ],
  "./uk/assignments.no_assignments_search.json": [
    "356693",
    [
      246566
    ]
  ],
  "./fi/dashboard_grading_period_select.json": [
    "673057",
    [
      380167
    ]
  ],
  "./id/error_form.json": [
    "926892",
    [
      756312
    ]
  ],
  "./fr/courses.json": [
    "587060",
    [
      451533
    ]
  ],
  "./nb/assignment_index_deep_linking_handlers.json": [
    "944652",
    [
      278304
    ]
  ],
  "./nn/submissions_show_preview.json": [
    "405110",
    [
      404570
    ]
  ],
  "./hi/gradebookActionMenu.json": [
    "441278",
    [
      484742
    ]
  ],
  "./sv-x-k12/outcome_management.json": [
    "340513",
    [
      479655
    ]
  ],
  "./hu/todo.json": [
    "43899",
    [
      866497
    ]
  ],
  "./pt-BR/calendar_custom_recurring_event_repeat_picker.json": [
    "693437",
    [
      550012
    ]
  ],
  "./mi/react_scheduler.json": [
    "605221",
    [
      443243
    ]
  ],
  "./th/file_not_found.json": [
    "380537",
    [
      159035
    ]
  ],
  "./en-GB-x-lbs/assignments_2_student_header.json": [
    "149105",
    [
      609143
    ]
  ],
  "./id/assignments.never_drop.json": [
    "872327",
    [
      215994
    ]
  ],
  "./es-ES/discussion_insights.json": [
    "37263",
    [
      910069
    ]
  ],
  "./ca/bulk_edit_students.json": [
    "388024",
    [
      902648
    ]
  ],
  "./en/outcome_management.json": [
    "587537",
    [
      639147
    ]
  ],
  "./fa/OutcomeDescriptionModal.json": [
    "975776",
    [
      397928
    ]
  ],
  "./fr-CA/course_paces_no_results.json": [
    "582962",
    [
      416438
    ]
  ],
  "./pt-BR/course_paces_search.json": [
    "548731",
    [
      718517
    ]
  ],
  "./ko/LearningMasteryGradebook.json": [
    "397579",
    [
      702817
    ]
  ],
  "./pt-BR/enhanced_individual_gradebook_submit_score.json": [
    "976434",
    [
      652691
    ]
  ],
  "./fi/restore_content_pane.json": [
    "314294",
    [
      395486
    ]
  ],
  "./nn/user_profile.json": [
    "93511",
    [
      817009
    ]
  ],
  "./da-x-k12/account_calendar_settings_account_calendar_item_dropdown.json": [
    "432578",
    [
      124238
    ]
  ],
  "./ms/context_prior_users.json": [
    "503529",
    [
      75031
    ]
  ],
  "./tr/restore_content_pane.json": [
    "535055",
    [
      633497
    ]
  ],
  "./sl/custom_emoji_deny_list.json": [
    "727205",
    [
      363175
    ]
  ],
  "./da/gradebook_uploads.json": [
    "752198",
    [
      802006
    ]
  ],
  "./hu/assignments_2_MoreOptions_CanvasFiles.json": [
    "701648",
    [
      988624
    ]
  ],
  "./el/ai_experiences_edit.json": [
    "936074",
    [
      756118
    ]
  ],
  "./pt-BR/LogoutButton.json": [
    "908115",
    [
      279958
    ]
  ],
  "./sv-x-k12/gradebook.json": [
    "922767",
    [
      183669
    ]
  ],
  "./vi/media_immersive_view.json": [
    "898061",
    [
      235563
    ]
  ],
  "./vi/change_password.json": [
    "839139",
    [
      838977
    ]
  ],
  "./sl/grade_change_logging_content.json": [
    "411047",
    [
      996225
    ]
  ],
  "./pt-BR/AddGroup.json": [
    "468735",
    [
      96362
    ]
  ],
  "./nl/video_conference.json": [
    "793102",
    [
      293138
    ]
  ],
  "./nb/sharedCurveGradesDialog.json": [
    "752370",
    [
      954766
    ]
  ],
  "./th/assignment_2_assignment_toggle_details.json": [
    "607990",
    [
      986565
    ]
  ],
  "./tr/unpublished_warning_modal.json": [
    "760278",
    [
      507466
    ]
  ],
  "./uk/AlignmentSummary.json": [
    "382941",
    [
      151843
    ]
  ],
  "./nn/gradebook_history.json": [
    "210139",
    [
      541661
    ]
  ],
  "./ga/account_course_user_search.json": [
    "391848",
    [
      995520
    ]
  ],
  "./pt/error_form.json": [
    "503859",
    [
      6997
    ]
  ],
  "./da/bounced_emails.json": [
    "347971",
    [
      580073
    ]
  ],
  "./fa/blueprint_settingsUnsyncedChanges.json": [
    "908014",
    [
      312374
    ]
  ],
  "./fr-CA/change_password.json": [
    "895143",
    [
      909665
    ]
  ],
  "./sv-x-k12/question_bank.json": [
    "348766",
    [
      531942
    ]
  ],
  "./nn/roster_section_input.json": [
    "82630",
    [
      582522
    ]
  ],
  "./vi/files_v2.json": [
    "788221",
    [
      549691
    ]
  ],
  "./nb-x-k12/assignments_bulk_edit_use_save_assignment.json": [
    "967760",
    [
      67352
    ]
  ],
  "./fr-CA/account_calendar_settings_confirmation_modal.json": [
    "132309",
    [
      850375
    ]
  ],
  "./de/media_player_iframe_content.json": [
    "194730",
    [
      171003
    ]
  ],
  "./da/jobs.json": [
    "536843",
    [
      192993
    ]
  ],
  "./es/discussionTopicKeyboradShortcutModal.json": [
    "895993",
    [
      551816
    ]
  ],
  "./fr-CA/blueprint_settingsMigrationSync.json": [
    "936411",
    [
      697949
    ]
  ],
  "./da-x-k12/ai_experiences_ai_conversations.json": [
    "956095",
    [
      505137
    ]
  ],
  "./cy/course_color_selector.json": [
    "667017",
    [
      720151
    ]
  ],
  "./mi/speed_grader_helpers.json": [
    "958261",
    [
      257019
    ]
  ],
  "./sv/calendar_edit.json": [
    "471064",
    [
      502380
    ]
  ],
  "./ga/account_calendars.json": [
    "712889",
    [
      624479
    ]
  ],
  "./id/new_user_tutorial.json": [
    "375616",
    [
      654892
    ]
  ],
  "./en-AU/appointment_groups.json": [
    "675838",
    [
      505343
    ]
  ],
  "./fi/blueprint_course_child.json": [
    "638361",
    [
      230031
    ]
  ],
  "./th/gradingGradeSummary.json": [
    "47383",
    [
      317577
    ]
  ],
  "./nb/group_submission_reminder.json": [
    "442153",
    [
      756987
    ]
  ],
  "./da-x-k12/assignments_2_student_content_rubric_self_assessment.json": [
    "888680",
    [
      126452
    ]
  ],
  "./da/ai_experiences.json": [
    "753815",
    [
      596789
    ]
  ],
  "./el/blueprint_settingsCoursePickerTable.json": [
    "318097",
    [
      680131
    ]
  ],
  "./ja/blueprint_settingsCourseFilter.json": [
    "152363",
    [
      13542
    ]
  ],
  "./fi/edit_section_dates.json": [
    "79811",
    [
      759857
    ]
  ],
  "./mi/user_name.json": [
    "91299",
    [
      127801
    ]
  ],
  "./pl/assignments_peer_reviews.json": [
    "269383",
    [
      890001
    ]
  ],
  "./ja/course_paces_header.json": [
    "273097",
    [
      73864
    ]
  ],
  "./pt-BR/pairing_code_user_observees.json": [
    "125458",
    [
      275043
    ]
  ],
  "./id.eager.json": [
    "852630",
    [
      991469
    ]
  ],
  "./da-x-k12/accessibility_checker.json": [
    "433355",
    [
      393837
    ]
  ],
  "./ar/course_paces_assignment_row.json": [
    "602308",
    [
      801640
    ]
  ],
  "./ca/discussion_topics.json": [
    "615163",
    [
      556401
    ]
  ],
  "./pt-BR/keyboardShortcutModal.json": [
    "356519",
    [
      377746
    ]
  ],
  "./ga/theme_editor.json": [
    "277341",
    [
      868283
    ]
  ],
  "./hu/rootFoldersFinder.json": [
    "138800",
    [
      144688
    ]
  ],
  "./vi/HelpTray.json": [
    "482597",
    [
      605522
    ]
  ],
  "./en-AU-x-unimelb/user_lists.json": [
    "165483",
    [
      29133
    ]
  ],
  "./en-GB/AlignmentSummary.json": [
    "251530",
    [
      576223
    ]
  ],
  "./nn/account_calendar_settings_utils.json": [
    "904990",
    [
      782322
    ]
  ],
  "./zh-Hant/assignments_2_student_header.json": [
    "658989",
    [
      435087
    ]
  ],
  "./en-GB-x-lbs/blueprint_settingsMigrationOptions.json": [
    "377619",
    [
      726961
    ]
  ],
  "./ko/course_default_due_time.json": [
    "620822",
    [
      196646
    ]
  ],
  "./de/file_not_found.json": [
    "744060",
    [
      380401
    ]
  ],
  "./vi/remove_pace_warning_modal.json": [
    "182076",
    [
      368956
    ]
  ],
  "./de/terms_index.json": [
    "764697",
    [
      63920
    ]
  ],
  "./pt-BR/OutcomeDescriptionModal.json": [
    "368552",
    [
      901653
    ]
  ],
  "./en-GB-x-lbs/calendar_custom_recurring_event_natural_language.json": [
    "416160",
    [
      188248
    ]
  ],
  "./mi/discussion_insights.json": [
    "199932",
    [
      147268
    ]
  ],
  "./sv/FindOutcomesModal.json": [
    "563900",
    [
      952704
    ]
  ],
  "./vi/group_submission_reminder.json": [
    "330552",
    [
      904480
    ]
  ],
  "./fi/pseudonyms_mobile_login.json": [
    "937075",
    [
      731473
    ]
  ],
  "./pt/AssignmentListItemView.json": [
    "566925",
    [
      357103
    ]
  ],
  "./it/upload_button.json": [
    "741497",
    [
      730275
    ]
  ],
  "./fr/peer-review-assignment-widget.json": [
    "108668",
    [
      447981
    ]
  ],
  "./zh-Hans/discussion_settings.json": [
    "504293",
    [
      301171
    ]
  ],
  "./id/top_navigation_tools.json": [
    "784987",
    [
      737253
    ]
  ],
  "./nn/conversations_2.json": [
    "493679",
    [
      382393
    ]
  ],
  "./he/epub_exports.json": [
    "720221",
    [
      433363
    ]
  ],
  "./ms/lti_registration.wizard.json": [
    "706944",
    [
      533591
    ]
  ],
  "./he/peer_review_allocation_rules_tray.json": [
    "451448",
    [
      610440
    ]
  ],
  "./da/course_statistics.json": [
    "452120",
    [
      325432
    ]
  ],
  "./id/auth_logging.json": [
    "337005",
    [
      631951
    ]
  ],
  "./nb/unpublished_warning_modal.json": [
    "114656",
    [
      536212
    ]
  ],
  "./ms/course_paces_search.json": [
    "858081",
    [
      709951
    ]
  ],
  "./ga/external_content_cancel.json": [
    "285118",
    [
      475734
    ]
  ],
  "./zh-Hant/course_paces_pace_picker.json": [
    "430855",
    [
      678953
    ]
  ],
  "./da/react_developer_keys.json": [
    "167960",
    [
      380664
    ]
  ],
  "./da/video_conference.json": [
    "293937",
    [
      745823
    ]
  ],
  "./is/blueprint_settingsUnsyncedChanges.json": [
    "664471",
    [
      329309
    ]
  ],
  "./ja/grade_details.json": [
    "362329",
    [
      36632
    ]
  ],
  "./de/roster_publicjs.json": [
    "960187",
    [
      327534
    ]
  ],
  "./fa/OutcomeMoveModal.json": [
    "564755",
    [
      983073
    ]
  ],
  "./hi/course_default_due_time.json": [
    "694639",
    [
      672533
    ]
  ],
  "./es-ES/notebook_index.json": [
    "966747",
    [
      684377
    ]
  ],
  "./nn/course_default_due_time.json": [
    "57196",
    [
      4400
    ]
  ],
  "./zh-Hans/learning_mastery_gradebook.json": [
    "491646",
    [
      86342
    ]
  ],
  "./en/course_paces_assignment_row.json": [
    "166660",
    [
      626944
    ]
  ],
  "./ja/blueprint_coursesExpandableLockOptions.json": [
    "999704",
    [
      570429
    ]
  ],
  "./en-CA/blueprint_settingsSyncChange.json": [
    "426804",
    [
      548356
    ]
  ],
  "./pt-BR/permissions.json": [
    "310275",
    [
      27158
    ]
  ],
  "./zh-Hant/k5_dashboard.json": [
    "107299",
    [
      147405
    ]
  ],
  "./da/rubrics-export.json": [
    "405600",
    [
      3920
    ]
  ],
  "./pl/content_migrations_redesign.json": [
    "166769",
    [
      898371
    ]
  ],
  "./sl/course_statistics.json": [
    "150292",
    [
      280176
    ]
  ],
  "./nn/bulk_edit_students.json": [
    "842796",
    [
      458320
    ]
  ],
  "./da/nav_tourpoints.json": [
    "908948",
    [
      218972
    ]
  ],
  "./id/module_student_view_peer_reviews.json": [
    "279606",
    [
      503234
    ]
  ],
  "./ht/assignments_2_text_entry.json": [
    "960502",
    [
      473946
    ]
  ],
  "./pl/gradebookActionMenu.json": [
    "653209",
    [
      649083
    ]
  ],
  "./en-GB-x-lbs/video_conference.json": [
    "505982",
    [
      160806
    ]
  ],
  "./en-GB-x-ukhe/notebook_index.json": [
    "90866",
    [
      215922
    ]
  ],
  "./fa/editAssignmentGroupWeights.json": [
    "222648",
    [
      163712
    ]
  ],
  "./nb/assignment_index.json": [
    "489044",
    [
      312536
    ]
  ],
  "./it/submit_online_url_assignment.json": [
    "402509",
    [
      199503
    ]
  ],
  "./sv/student_annotation_preview.json": [
    "230739",
    [
      237933
    ]
  ],
  "./pt-BR/gradingPeriodTemplate.json": [
    "430816",
    [
      458829
    ]
  ],
  "./fr-CA/account_course_user_search.json": [
    "619239",
    [
      796121
    ]
  ],
  "./pt-BR/ai_experiences_edit.json": [
    "980686",
    [
      109511
    ]
  ],
  "./es/notebook.json": [
    "931843",
    [
      336814
    ]
  ],
  "./en-GB-x-ukhe/comm_messages.json": [
    "412169",
    [
      25647
    ]
  ],
  "./da/important_dates_empty.json": [
    "74351",
    [
      175261
    ]
  ],
  "./tr/user_restore.json": [
    "95142",
    [
      501546
    ]
  ],
  "./cy/course_paces_blueprint_lock.json": [
    "482826",
    [
      244850
    ]
  ],
  "./ja/calendar_edit.json": [
    "481240",
    [
      292733
    ]
  ],
  "./en-GB/calendar_edit.json": [
    "84872",
    [
      781313
    ]
  ],
  "./zh-Hans/content_copy_redesign.json": [
    "92534",
    [
      857854
    ]
  ],
  "./nn/assignments_bulk_edit_use_save_assignment.json": [
    "668254",
    [
      770986
    ]
  ],
  "./vi/section.json": [
    "761140",
    [
      639524
    ]
  ],
  "./pl/grade_details.json": [
    "861412",
    [
      894864
    ]
  ],
  "./es-ES/AccountsTray.json": [
    "122785",
    [
      227319
    ]
  ],
  "./es-ES/horizon_toggle.json": [
    "972233",
    [
      691343
    ]
  ],
  "./ht/appointment_groups.json": [
    "21424",
    [
      625620
    ]
  ],
  "./ko/CourseAvailabilityOptions.json": [
    "294392",
    [
      398040
    ]
  ],
  "./es-ES/discovery_page.json": [
    "887697",
    [
      195735
    ]
  ],
  "./nb-x-k12/grade_details.json": [
    "57902",
    [
      894134
    ]
  ],
  "./pl/users.json": [
    "839390",
    [
      859154
    ]
  ],
  "./cy/wiki_page_index.json": [
    "436475",
    [
      786433
    ]
  ],
  "./ar/account_calendar_settings_account_tree.json": [
    "12844",
    [
      845280
    ]
  ],
  "./el/manage_avatars.json": [
    "226527",
    [
      325265
    ]
  ],
  "./es-ES/calendar.header.json": [
    "80070",
    [
      453509
    ]
  ],
  "./he/gradingGradeSummary.json": [
    "23664",
    [
      959824
    ]
  ],
  "./en-GB/ImportConfirmBox.json": [
    "326605",
    [
      294336
    ]
  ],
  "./ca/important_dates.json": [
    "280034",
    [
      215434
    ]
  ],
  "./es/edit_section_start_date.json": [
    "117714",
    [
      510507
    ]
  ],
  "./is/assignments_2_student_points_display.json": [
    "363656",
    [
      203328
    ]
  ],
  "./nl/course_paces_actions.json": [
    "520474",
    [
      983886
    ]
  ],
  "./sv/k5_dashboard_card.json": [
    "84901",
    [
      570071
    ]
  ],
  "./ht/edit_section_start_date.json": [
    "280674",
    [
      733654
    ]
  ],
  "./nl/account_calendars.json": [
    "490647",
    [
      255161
    ]
  ],
  "./en-AU/quizzes_regrade_modal.json": [
    "43128",
    [
      790589
    ]
  ],
  "./es/assignments_peer_reviews.json": [
    "223847",
    [
      103642
    ]
  ],
  "./el/calendar_appointment_group_edit.json": [
    "829174",
    [
      509946
    ]
  ],
  "./fr-CA/authentication_providers.json": [
    "575856",
    [
      367956
    ]
  ],
  "./tr/overview_page.json": [
    "278995",
    [
      162341
    ]
  ],
  "./ko/jobs.json": [
    "882584",
    [
      149304
    ]
  ],
  "./it/moderate_quiz.json": [
    "223396",
    [
      504456
    ]
  ],
  "./fa/group_submission_reminder.json": [
    "49472",
    [
      475992
    ]
  ],
  "./sl/assignment_index.json": [
    "753189",
    [
      955151
    ]
  ],
  "./id/AssignmentGroupListItemView.json": [
    "284457",
    [
      830187
    ]
  ],
  "./nb-x-k12/peer_review_configuration_tray.json": [
    "668785",
    [
      93079
    ]
  ],
  "./ru/course_stats.json": [
    "606799",
    [
      45740
    ]
  ],
  "./da/quiz_show.json": [
    "664658",
    [
      15962
    ]
  ],
  "./vi/submit_assignment.json": [
    "630363",
    [
      652889
    ]
  ],
  "./nb/react_scheduler.json": [
    "857243",
    [
      321013
    ]
  ],
  "./he/bulk_edit_students.json": [
    "572245",
    [
      133659
    ]
  ],
  "./fi.eager.json": [
    "301414",
    [
      625537
    ]
  ],
  "./fi/assignments_2_text_entry.json": [
    "215185",
    [
      983335
    ]
  ],
  "./mi/permissions.json": [
    "609056",
    [
      985440
    ]
  ],
  "./ko/direct_share_course_import_panel.json": [
    "477036",
    [
      499396
    ]
  ],
  "./tr/error_form.json": [
    "395289",
    [
      214387
    ]
  ],
  "./pt-BR/lti_registrations.json": [
    "441153",
    [
      97259
    ]
  ],
  "./cy/password_complexity_configuration.json": [
    "654949",
    [
      142091
    ]
  ],
  "./ru/sis_import.json": [
    "467822",
    [
      896758
    ]
  ],
  "./sv/assignments_2_student_points_display.json": [
    "379863",
    [
      377462
    ]
  ],
  "./id/module_sequence_footer.json": [
    "140547",
    [
      214893
    ]
  ],
  "./fr-CA/course_paces_app.json": [
    "749827",
    [
      52005
    ]
  ],
  "./it/link_to_students.json": [
    "706288",
    [
      716228
    ]
  ],
  "./ru/discussion_topics_edit.json": [
    "621459",
    [
      262081
    ]
  ],
  "./el/gradebook.json": [
    "895193",
    [
      249571
    ]
  ],
  "./nn/section.json": [
    "703309",
    [
      523644
    ]
  ],
  "./vi/course_paces_empty_state.json": [
    "799339",
    [
      201609
    ]
  ],
  "./en-AU-x-unimelb/course_paces_errors.json": [
    "436854",
    [
      775986
    ]
  ],
  "./ms/course_paces_header.json": [
    "659588",
    [
      127900
    ]
  ],
  "./nb-x-k12/assignments_2_student_annotation.json": [
    "27157",
    [
      946067
    ]
  ],
  "./fr-CA/context_roster_user_services.json": [
    "139397",
    [
      451575
    ]
  ],
  "./it/discussion_pinned_post.json": [
    "515755",
    [
      480693
    ]
  ],
  "./ht/theme_editor.json": [
    "436113",
    [
      54019
    ]
  ],
  "./fr/question_bank.json": [
    "56577",
    [
      141580
    ]
  ],
  "./ga/course_stats.json": [
    "149223",
    [
      497357
    ]
  ],
  "./nb/course_statistics.json": [
    "3131",
    [
      612893
    ]
  ],
  "./is/assignments_2_media_attempt.json": [
    "371112",
    [
      730176
    ]
  ],
  "./he/media_player_iframe_content.json": [
    "109710",
    [
      258526
    ]
  ],
  "./ru/blueprint_coursesExpandableLockOptions.json": [
    "323620",
    [
      543380
    ]
  ],
  "./de/content_exports.json": [
    "970152",
    [
      916898
    ]
  ],
  "./ko/roster_publicjs.json": [
    "589830",
    [
      211094
    ]
  ],
  "./he/modules_page_icon_legend.json": [
    "866142",
    [
      25262
    ]
  ],
  "./en-GB-x-lbs/quiz_show.json": [
    "832111",
    [
      565925
    ]
  ],
  "./el/calendar_custom_recurring_event_repeat_picker.json": [
    "10521",
    [
      256283
    ]
  ],
  "./da-x-k12/assignments_2_external_tool.json": [
    "178473",
    [
      669219
    ]
  ],
  "./ru/MasteryScale.json": [
    "788772",
    [
      230996
    ]
  ],
  "./da-x-k12/account_calendar_settings_utils.json": [
    "926987",
    [
      899749
    ]
  ],
  "./ru/announcements_on_home_page.json": [
    "375261",
    [
      137243
    ]
  ],
  "./mi/password_complexity_configuration.json": [
    "43603",
    [
      9641
    ]
  ],
  "./pt-BR/announcements_v2.json": [
    "565828",
    [
      692713
    ]
  ],
  "./tr/webcam_modal.json": [
    "492771",
    [
      614021
    ]
  ],
  "./es-ES/conversations_2.json": [
    "237218",
    [
      227058
    ]
  ],
  "./ru/outcome_alignment_v2.json": [
    "657878",
    [
      10558
    ]
  ],
  "./id/CourseAvailabilityOptions.json": [
    "857199",
    [
      173377
    ]
  ],
  "./mi/course_pace_date_input.json": [
    "57497",
    [
      374119
    ]
  ],
  "./fi/grades_summary.json": [
    "413486",
    [
      511062
    ]
  ],
  "./ca/accessibility_checker.json": [
    "237294",
    [
      959438
    ]
  ],
  "./he/course_search_results.json": [
    "983982",
    [
      408222
    ]
  ],
  "./tr/react_developer_keys.json": [
    "223083",
    [
      988077
    ]
  ],
  "./ms/AccountsTray.json": [
    "254866",
    [
      180682
    ]
  ],
  "./en/theme_editor.json": [
    "511968",
    [
      163164
    ]
  ],
  "./da/todos_page.json": [
    "62266",
    [
      459730
    ]
  ],
  "./es-ES/account_calendar_settings_account_calendar_item_dropdown.json": [
    "911398",
    [
      70974
    ]
  ],
  "./id/calendar_edit.json": [
    "189420",
    [
      768320
    ]
  ],
  "./fi/unpublished_changes_button_props.json": [
    "391914",
    [
      32490
    ]
  ],
  "./nb-x-k12/last_attended.json": [
    "548012",
    [
      280428
    ]
  ],
  "./uk/user.json": [
    "915657",
    [
      24903
    ]
  ],
  "./da/keyboardShortcutModal.json": [
    "439929",
    [
      870487
    ]
  ],
  "./it/content_migrations_redesign.json": [
    "437180",
    [
      366323
    ]
  ],
  "./uk/user_profile.json": [
    "296563",
    [
      883065
    ]
  ],
  "./it/quiz_log_auditing.json": [
    "279455",
    [
      911105
    ]
  ],
  "./nl/course_paces_empty_state.json": [
    "758066",
    [
      305014
    ]
  ],
  "./fi/discussion_topics.json": [
    "754726",
    [
      217278
    ]
  ],
  "./fr/assignments_2_student_header.json": [
    "288651",
    [
      86930
    ]
  ],
  "./id/course_paces_app.json": [
    "310047",
    [
      192481
    ]
  ],
  "./sv-x-k12/account_notification_settings.json": [
    "341424",
    [
      247192
    ]
  ],
  "./nl/course_paces_blackout_dates_modal.json": [
    "85902",
    [
      597218
    ]
  ],
  "./uk/submit_online_url_assignment.json": [
    "385214",
    [
      109470
    ]
  ],
  "./es-ES/gradebookOutcomeGradebookView.json": [
    "501686",
    [
      890510
    ]
  ],
  "./ar/rubrics-export.json": [
    "518140",
    [
      517560
    ]
  ],
  "./nn/outcome_management.json": [
    "492564",
    [
      199800
    ]
  ],
  "./tr/content_copy_redesign.json": [
    "805763",
    [
      798077
    ]
  ],
  "./ga/unpublished_changes_button_props.json": [
    "560545",
    [
      860695
    ]
  ],
  "./uk/registration.json": [
    "655763",
    [
      401113
    ]
  ],
  "./ca/accessibility_course_statistics.json": [
    "622316",
    [
      605476
    ]
  ],
  "./ca/react_files.json": [
    "597405",
    [
      561379
    ]
  ],
  "./pt/course_paces_errors.json": [
    "876454",
    [
      987162
    ]
  ],
  "./pt-BR/course_paces_footer.json": [
    "918775",
    [
      954834
    ]
  ],
  "./sv-x-k12/group_submission_reminder.json": [
    "554274",
    [
      167586
    ]
  ],
  "./en-GB-x-ukhe/AssignmentListItemView.json": [
    "719063",
    [
      153261
    ]
  ],
  "./mi/gradingPeriodTemplate.json": [
    "508475",
    [
      532097
    ]
  ],
  "./da-x-k12/CommentLibrary.json": [
    "302809",
    [
      46067
    ]
  ],
  "./id/copy_course.json": [
    "548460",
    [
      443144
    ]
  ],
  "./zh-Hans/course_navigation_settings.json": [
    "111527",
    [
      472189
    ]
  ],
  "./en-GB-x-ukhe/accessibility_checker.json": [
    "782268",
    [
      998188
    ]
  ],
  "./hu/assignment_2_assignment_toggle_details.json": [
    "679999",
    [
      114237
    ]
  ],
  "./fr-CA/a2LatePolicyStatusDisplay.json": [
    "750284",
    [
      767624
    ]
  ],
  "./ms/peer_review_allocation_rules_tray.json": [
    "101587",
    [
      105673
    ]
  ],
  "./pt-BR/folder_tree.json": [
    "275958",
    [
      427087
    ]
  ],
  "./en-GB/user_profile.json": [
    "729268",
    [
      922565
    ]
  ],
  "./tr/enhanced_individual_gradebook_submit_score.json": [
    "913807",
    [
      621681
    ]
  ],
  "./mi/k5_dashboard_card.json": [
    "37142",
    [
      501526
    ]
  ],
  "./da/calendar_custom_recurring_event_natural_language.json": [
    "845615",
    [
      505757
    ]
  ],
  "./nn/authentication_providers.json": [
    "664495",
    [
      187081
    ]
  ],
  "./pt/direct_share_course_import_panel.json": [
    "760102",
    [
      228522
    ]
  ],
  "./he/canvas_file_upload.json": [
    "65658",
    [
      692770
    ]
  ],
  "./sl/student_entries.json": [
    "40045",
    [
      584327
    ]
  ],
  "./fr-CA/eportfolio.json": [
    "59852",
    [
      309400
    ]
  ],
  "./hu/ai_experiences_show.json": [
    "425805",
    [
      189283
    ]
  ],
  "./nl/GroupsTray.json": [
    "438760",
    [
      28412
    ]
  ],
  "./hu/sis_import.json": [
    "751460",
    [
      530492
    ]
  ],
  "./is/user_lists.json": [
    "210231",
    [
      358477
    ]
  ],
  "./mi/blueprint_course_child.json": [
    "920420",
    [
      902300
    ]
  ],
  "./nb-x-k12/assignments_2_attempt_tab.json": [
    "409461",
    [
      685155
    ]
  ],
  "./da-x-k12/peer_review_allocation_rule_card.json": [
    "717999",
    [
      618273
    ]
  ],
  "./ar/assignment_index_deep_linking_handlers.json": [
    "343337",
    [
      213171
    ]
  ],
  "./it/external_content_cancel.json": [
    "501979",
    [
      103661
    ]
  ],
  "./el/user_name.json": [
    "763832",
    [
      980060
    ]
  ],
  "./es-ES/wiki_page_index.json": [
    "495850",
    [
      412170
    ]
  ],
  "./fi/outcome_detail.json": [
    "948705",
    [
      127127
    ]
  ],
  "./en-AU/roster_section_input.json": [
    "905660",
    [
      517017
    ]
  ],
  "./th/blueprint_settingsUnsyncedChanges.json": [
    "370099",
    [
      156869
    ]
  ],
  "./da/CourseAvailabilityOptions.json": [
    "177421",
    [
      784051
    ]
  ],
  "./ko/account_calendar_settings_footer.json": [
    "157592",
    [
      564472
    ]
  ],
  "./es/copy_warnings_modal.json": [
    "161807",
    [
      354434
    ]
  ],
  "./hi/AssignmentListItemView.json": [
    "70356",
    [
      419012
    ]
  ],
  "./es/MasteryScale.json": [
    "935019",
    [
      526454
    ]
  ],
  "./ca/widget_dashboard.json": [
    "284921",
    [
      140535
    ]
  ],
  "./en-GB/blueprint_settingsCoursePicker.json": [
    "713075",
    [
      513042
    ]
  ],
  "./nb/wiki_page_index.json": [
    "795963",
    [
      928149
    ]
  ],
  "./sv/users.json": [
    "198063",
    [
      656193
    ]
  ],
  "./ko/entity_search_form.json": [
    "547367",
    [
      906117
    ]
  ],
  "./nn/discussion_insights.json": [
    "71562",
    [
      81342
    ]
  ],
  "./zh-Hans/EditMasteryScaleLink.json": [
    "455238",
    [
      410254
    ]
  ],
  "./zh-Hant/use_switch_experience.json": [
    "155025",
    [
      32488
    ]
  ],
  "./de/CoursesTray.json": [
    "821607",
    [
      228370
    ]
  ],
  "./de/user_logins.json": [
    "380015",
    [
      250602
    ]
  ],
  "./sl/video_conference.json": [
    "919917",
    [
      715303
    ]
  ],
  "./ja/account_settings.json": [
    "314072",
    [
      630141
    ]
  ],
  "./ga/submit_assignment.json": [
    "652518",
    [
      799646
    ]
  ],
  "./ga/ai_experiences.json": [
    "143926",
    [
      206462
    ]
  ],
  "./sl/comm_messages.json": [
    "218336",
    [
      587052
    ]
  ],
  "./fi/terms_index.json": [
    "915551",
    [
      99957
    ]
  ],
  "./ar/media_immersive_view.json": [
    "414439",
    [
      239225
    ]
  ],
  "./en-GB-x-lbs/discussion_insights.json": [
    "968472",
    [
      374048
    ]
  ],
  "./fr/gradebook_default_gradebook_components_content_filters_module_filter.json": [
    "340270",
    [
      573339
    ]
  ],
  "./tr/comm_messages.json": [
    "293749",
    [
      703743
    ]
  ],
  "./ru/enhanced_individual_gradebook_submit_score.json": [
    "737026",
    [
      891330
    ]
  ],
  "./da/assignment_index_menu.json": [
    "395405",
    [
      183987
    ]
  ],
  "./ht/user_search_results.json": [
    "619547",
    [
      251389
    ]
  ],
  "./da/appointment_groups.json": [
    "272169",
    [
      990471
    ]
  ],
  "./nb/terms_of_use.json": [
    "908151",
    [
      915673
    ]
  ],
  "./nb/account_notification_settings.json": [
    "822635",
    [
      634341
    ]
  ],
  "./mi/assignments_2_student_points_display.json": [
    "634822",
    [
      985798
    ]
  ],
  "./ar/content_share_preview_overlay.json": [
    "831048",
    [
      153836
    ]
  ],
  "./pt/SpeedGraderSettingsMenu.json": [
    "708608",
    [
      243692
    ]
  ],
  "./en-GB-x-lbs/assignments_2_media_attempt.json": [
    "639498",
    [
      685562
    ]
  ],
  "./ca/users.json": [
    "448614",
    [
      678166
    ]
  ],
  "./fi/course_paces_no_results.json": [
    "315614",
    [
      44838
    ]
  ],
  "./mi/assignment_index_deep_linking_handlers.json": [
    "218486",
    [
      986678
    ]
  ],
  "./zh-Hans/permissions_role_tray_table_row.json": [
    "715587",
    [
      27057
    ]
  ],
  "./ko/choose_mastery_path.json": [
    "412827",
    [
      420209
    ]
  ],
  "./hi/outcome_management.json": [
    "761281",
    [
      152871
    ]
  ],
  "./ko/user_name.json": [
    "208783",
    [
      721085
    ]
  ],
  "./fr-CA/course_default_due_time.json": [
    "860665",
    [
      951835
    ]
  ],
  "./ar/content_copy_redesign.json": [
    "436670",
    [
      320210
    ]
  ],
  "./da-x-k12/assignments_2_student_header.json": [
    "308804",
    [
      940096
    ]
  ],
  "./en-GB-x-lbs/external_content_cancel.json": [
    "699756",
    [
      973180
    ]
  ],
  "./mi/webcam_modal.json": [
    "701427",
    [
      283881
    ]
  ],
  "./fr/outcome_reporting.json": [
    "586491",
    [
      175482
    ]
  ],
  "./fr-CA/important_dates.json": [
    "935063",
    [
      710561
    ]
  ],
  "./pt-BR/overview_page.json": [
    "368004",
    [
      130233
    ]
  ],
  "./ru/SpeedGraderCheckpoints.json": [
    "933414",
    [
      352638
    ]
  ],
  "./cy/account_course_user_search.json": [
    "326460",
    [
      446244
    ]
  ],
  "./da/speed_grader_helpers.json": [
    "929618",
    [
      898970
    ]
  ],
  "./fa/course_default_due_time.json": [
    "171605",
    [
      645555
    ]
  ],
  "./en-GB-x-ukhe/notebook.json": [
    "814077",
    [
      747835
    ]
  ],
  "./fr-CA/dashboard_grading_period_select.json": [
    "686597",
    [
      23863
    ]
  ],
  "./el/assignment_grade_summary.json": [
    "778411",
    [
      385661
    ]
  ],
  "./hu/blueprint_settingsCoursePicker.json": [
    "896037",
    [
      322955
    ]
  ],
  "./tr/FindOutcomesModal.json": [
    "664131",
    [
      277509
    ]
  ],
  "./vi/course_paces_module.json": [
    "838108",
    [
      617740
    ]
  ],
  "./en-AU-x-unimelb/lti_registrations.json": [
    "8336",
    [
      191876
    ]
  ],
  "./pl/ai_experiences_ai_conversations.json": [
    "216230",
    [
      965858
    ]
  ],
  "./ru/OutcomeMoveModal.json": [
    "745819",
    [
      597417
    ]
  ],
  "./pt/discussion_pinned_post.json": [
    "158228",
    [
      100568
    ]
  ],
  "./cy/peer_review_allocation_rule_card.json": [
    "608172",
    [
      467028
    ]
  ],
  "./sl/copy_warnings_modal.json": [
    "532624",
    [
      290148
    ]
  ],
  "./en-GB-x-ukhe/submit_assignment.json": [
    "920000",
    [
      526328
    ]
  ],
  "./es-ES/canvascareer.json": [
    "646983",
    [
      709229
    ]
  ],
  "./fi/LearningMasteryGradebook.json": [
    "276294",
    [
      503214
    ]
  ],
  "./vi/MobileNavigation.json": [
    "648533",
    [
      453891
    ]
  ],
  "./zh-Hans/AddGroup.json": [
    "728625",
    [
      491015
    ]
  ],
  "./it/assignments_2_media_attempt.json": [
    "603769",
    [
      226347
    ]
  ],
  "./en-GB/course_color_selector.json": [
    "335488",
    [
      626241
    ]
  ],
  "./id/ldap_cert_upload.json": [
    "432853",
    [
      397519
    ]
  ],
  "./en-AU/AssignmentListItemView.json": [
    "174579",
    [
      760430
    ]
  ],
  "./fr-CA/link_validator.json": [
    "841668",
    [
      706584
    ]
  ],
  "./is/CreateEditAssignmentModal.json": [
    "112796",
    [
      472236
    ]
  ],
  "./en-GB-x-lbs/grade_change_logging_content.json": [
    "395871",
    [
      942668
    ]
  ],
  "./pl/terms_index.json": [
    "707882",
    [
      424446
    ]
  ],
  "./nb/CourseAvailabilityOptions.json": [
    "347130",
    [
      997310
    ]
  ],
  "./ht/assignments_2_MoreOptions_CanvasFiles.json": [
    "980907",
    [
      848413
    ]
  ],
  "./sl/quiz_show.json": [
    "231350",
    [
      109026
    ]
  ],
  "./nn/calendar_sidebar.json": [
    "397567",
    [
      795273
    ]
  ],
  "./de/confirmMasteryModal.json": [
    "65355",
    [
      461022
    ]
  ],
  "./en-GB-x-ukhe/Navigation.json": [
    "819310",
    [
      127814
    ]
  ],
  "./is/course_paces_assignment_row.json": [
    "71035",
    [
      850393
    ]
  ],
  "./es/quizzes_openModerateStudentDialog.json": [
    "92996",
    [
      935345
    ]
  ],
  "./hi/account_calendar_settings_confirmation_modal.json": [
    "71283",
    [
      216401
    ]
  ],
  "./fr-CA/HelpTray.json": [
    "505454",
    [
      367090
    ]
  ],
  "./nb/blueprint_settingsMigrationSync.json": [
    "857782",
    [
      933250
    ]
  ],
  "./fr/course_paces_module.json": [
    "961325",
    [
      952952
    ]
  ],
  "./fi/peer_review_configuration_tray.json": [
    "420304",
    [
      790264
    ]
  ],
  "./ko/collaborations.json": [
    "892750",
    [
      31438
    ]
  ],
  "./sv-x-k12/calculator.json": [
    "739239",
    [
      810477
    ]
  ],
  "./ms/submit_online_url_assignment.json": [
    "543614",
    [
      157390
    ]
  ],
  "./th/unpublished_changes_tray_contents.json": [
    "413679",
    [
      961641
    ]
  ],
  "./vi/pairing_code_user_observees.json": [
    "167410",
    [
      233074
    ]
  ],
  "./ms/add_edit_pseudonym.json": [
    "221927",
    [
      725909
    ]
  ],
  "./it/discussion_insights.json": [
    "135551",
    [
      661225
    ]
  ],
  "./es/jobs.json": [
    "187358",
    [
      917135
    ]
  ],
  "./da.eager.json": [
    "47996",
    [
      659647
    ]
  ],
  "./ar/assignments_bulk_edit.json": [
    "69281",
    [
      505691
    ]
  ],
  "./ja/assignments.never_drop.json": [
    "572267",
    [
      452582
    ]
  ],
  "./ms/k5_dashboard.json": [
    "245885",
    [
      915603
    ]
  ],
  "./id/submit_online_url_assignment.json": [
    "323882",
    [
      681535
    ]
  ],
  "./da-x-k12/quiz_log_auditing.json": [
    "20667",
    [
      769989
    ]
  ],
  "./de/account_calendars_modal.json": [
    "826752",
    [
      846173
    ]
  ],
  "./ga/MoveOutcomesModal.json": [
    "552863",
    [
      311301
    ]
  ],
  "./hi/dashboard_grading_period_select.json": [
    "138943",
    [
      165781
    ]
  ],
  "./en-CA/FindOutcomesModal.json": [
    "474405",
    [
      907251
    ]
  ],
  "./id/calendar_sidebar.json": [
    "71836",
    [
      708912
    ]
  ],
  "./it/modules_home_page.json": [
    "141886",
    [
      593538
    ]
  ],
  "./ru/lti_registrations.json": [
    "10417",
    [
      368823
    ]
  ],
  "./de/rootFoldersFinder.json": [
    "580324",
    [
      655401
    ]
  ],
  "./es/assignmentsIndexView.json": [
    "352677",
    [
      808812
    ]
  ],
  "./ga/user_restore.json": [
    "771112",
    [
      799504
    ]
  ],
  "./fr-CA/announcements_v2.json": [
    "123208",
    [
      990084
    ]
  ],
  "./cy/assignments_2_student_content.json": [
    "620787",
    [
      953065
    ]
  ],
  "./mi/assignments_bulk_edit_use_save_assignment.json": [
    "29192",
    [
      923096
    ]
  ],
  "./pl/student_annotation_preview.json": [
    "701128",
    [
      534156
    ]
  ],
  "./sv-x-k12/GroupsTray.json": [
    "189627",
    [
      911113
    ]
  ],
  "./ca/SpeedGraderCheckpoints.json": [
    "323481",
    [
      619799
    ]
  ],
  "./fi/roster_section_input.json": [
    "369353",
    [
      20239
    ]
  ],
  "./fa/edit_section_end_date.json": [
    "984816",
    [
      707128
    ]
  ],
  "./hu/grades_empty_page.json": [
    "864589",
    [
      282083
    ]
  ],
  "./da/modelsQuiz.json": [
    "148200",
    [
      388936
    ]
  ],
  "./ca/course_navigation_settings.json": [
    "692454",
    [
      132694
    ]
  ],
  "./uk/external_content_cancel.json": [
    "403914",
    [
      974530
    ]
  ],
  "./nn/assignment_2_assignment_toggle_details.json": [
    "541554",
    [
      471598
    ]
  ],
  "./fr/dashboard_grading_period_select.json": [
    "92136",
    [
      754281
    ]
  ],
  "./hu/rubrics-export.json": [
    "973072",
    [
      103248
    ]
  ],
  "./sv-x-k12/roster_section_input.json": [
    "774059",
    [
      745785
    ]
  ],
  "./vi/assignment_grade_summary.json": [
    "242183",
    [
      416733
    ]
  ],
  "./sl/user_lists.json": [
    "806286",
    [
      838954
    ]
  ],
  "./es-ES/important_dates.json": [
    "899347",
    [
      478001
    ]
  ],
  "./el/webcam_modal.json": [
    "728134",
    [
      769058
    ]
  ],
  "./nb/calendar_custom_recurring_event_repeat_picker.json": [
    "970836",
    [
      388848
    ]
  ],
  "./nn/jobs.json": [
    "670186",
    [
      878686
    ]
  ],
  "./id/GroupsTray.json": [
    "150377",
    [
      824667
    ]
  ],
  "./fr/student_study_drawer.json": [
    "783777",
    [
      442636
    ]
  ],
  "./ru/course_paces_blueprint_lock.json": [
    "267655",
    [
      291085
    ]
  ],
  "./ru/calendar_custom_recurring_event_natural_language.json": [
    "266677",
    [
      572643
    ]
  ],
  "./hy/context_roster_user_services.json": [
    "186947",
    [
      894561
    ]
  ],
  "./zh-Hant/suppress_notifications.json": [
    "931700",
    [
      381672
    ]
  ],
  "./en-GB-x-lbs/mutationActivity.json": [
    "39946",
    [
      44154
    ]
  ],
  "./sl/course_paces_app.json": [
    "142261",
    [
      755231
    ]
  ],
  "./fr/last_attended.json": [
    "533038",
    [
      507955
    ]
  ],
  "./ko/account_calendars_results_area.json": [
    "405258",
    [
      629346
    ]
  ],
  "./ko/remove_pace_warning_modal.json": [
    "252539",
    [
      119569
    ]
  ],
  "./ru/assignments_2_student_content_rubric_self_assessment.json": [
    "868148",
    [
      969684
    ]
  ],
  "./ca/rubrics-export.json": [
    "99265",
    [
      743183
    ]
  ],
  "./it/courses_show.json": [
    "237327",
    [
      716529
    ]
  ],
  "./hy/ai_experiences_edit.json": [
    "736592",
    [
      858712
    ]
  ],
  "./en-CA/filter_calendars_modal.json": [
    "755402",
    [
      384314
    ]
  ],
  "./pt-BR/permissions_v2.json": [
    "997356",
    [
      997793
    ]
  ],
  "./hu/quizzes_index.json": [
    "771339",
    [
      708401
    ]
  ],
  "./da/assignments_bulk_edit_use_save_assignment.json": [
    "176969",
    [
      911335
    ]
  ],
  "./nn/course_pace_date_input.json": [
    "333635",
    [
      331685
    ]
  ],
  "./hy/user_name.json": [
    "305654",
    [
      370430
    ]
  ],
  "./nb-x-k12/discussion_topics_edit.json": [
    "998354",
    [
      982450
    ]
  ],
  "./it/gradebookOutcomeGradebookView.json": [
    "279078",
    [
      6826
    ]
  ],
  "./ms/assignments_bulk_edit_use_save_assignment.json": [
    "363850",
    [
      176882
    ]
  ],
  "./sv-x-k12/course_template_details.json": [
    "382780",
    [
      934796
    ]
  ],
  "./en-AU/grade_change_logging_content.json": [
    "79416",
    [
      467261
    ]
  ],
  "./el/assignments_2_submission_helpers.json": [
    "766664",
    [
      18029
    ]
  ],
  "./is/copy_course.json": [
    "858141",
    [
      394779
    ]
  ],
  "./en-GB-x-ukhe/quiz_log_auditing.json": [
    "464816",
    [
      116552
    ]
  ],
  "./fr/rate_limiting_settings.json": [
    "383652",
    [
      546221
    ]
  ],
  "./ja/user_grades.json": [
    "120767",
    [
      925954
    ]
  ],
  "./en-AU-x-unimelb/submissions_show_preview.json": [
    "486954",
    [
      513398
    ]
  ],
  "./is/content_shares.json": [
    "489408",
    [
      659240
    ]
  ],
  "./fa/user.json": [
    "717110",
    [
      946286
    ]
  ],
  "./en-GB-x-lbs/roster_section_selector.json": [
    "156013",
    [
      945835
    ]
  ],
  "./fr-CA/confirmMasteryModal.json": [
    "237981",
    [
      464815
    ]
  ],
  "./sv-x-k12/choose_mastery_path.json": [
    "539094",
    [
      78670
    ]
  ],
  "./ru/student_entries.json": [
    "801651",
    [
      219297
    ]
  ],
  "./hu/assignments_2_submission_helpers.json": [
    "658865",
    [
      218319
    ]
  ],
  "./sl/course_paces_blackout_date_row.json": [
    "495223",
    [
      436913
    ]
  ],
  "./fr/account_calendar_settings_account_group.json": [
    "312960",
    [
      193801
    ]
  ],
  "./pt-BR/course_search_results.json": [
    "692360",
    [
      827621
    ]
  ],
  "./hu/accessibility_checker.json": [
    "196413",
    [
      936083
    ]
  ],
  "./de/DueDateOverrideView.json": [
    "939958",
    [
      170415
    ]
  ],
  "./hu/quiz_statistics.json": [
    "461120",
    [
      960480
    ]
  ],
  "./ru/youtube_migration.json": [
    "745433",
    [
      770655
    ]
  ],
  "./ga/MasteryScale.json": [
    "282135",
    [
      470234
    ]
  ],
  "./fr-CA/peer_review_student_select.json": [
    "477687",
    [
      854633
    ]
  ],
  "./sv/react_scheduler.json": [
    "135190",
    [
      136826
    ]
  ],
  "./pl/module_sequence_footer.json": [
    "770236",
    [
      644195
    ]
  ],
  "./th/license_help.json": [
    "282877",
    [
      876807
    ]
  ],
  "./de/nav_tourpoints.json": [
    "66088",
    [
      884005
    ]
  ],
  "./es-ES/external_content_cancel.json": [
    "160760",
    [
      417481
    ]
  ],
  "./it/assignments.json": [
    "524509",
    [
      352415
    ]
  ],
  "./mi/course_link_validator.json": [
    "395299",
    [
      985465
    ]
  ],
  "./el/AssignmentGroupListItemView.json": [
    "391949",
    [
      953311
    ]
  ],
  "./en-AU/discussion_row.json": [
    "364263",
    [
      911690
    ]
  ],
  "./fr/top_navigation_tools.json": [
    "711368",
    [
      743385
    ]
  ],
  "./ht/quiz_statistics.json": [
    "359075",
    [
      331013
    ]
  ],
  "./hu/peer_review_student_select.json": [
    "90801",
    [
      876719
    ]
  ],
  "./hu/user_lists.json": [
    "589930",
    [
      170866
    ]
  ],
  "./nb-x-k12/context_prior_users.json": [
    "225580",
    [
      583445
    ]
  ],
  "./nl/assignments_2_student_points_display.json": [
    "242930",
    [
      341097
    ]
  ],
  "./sl/blueprint_settingsMigrationOptions.json": [
    "297076",
    [
      211936
    ]
  ],
  "./mi/not_found_page_slide_puzzle.json": [
    "421167",
    [
      245517
    ]
  ],
  "./sl/user_profile.json": [
    "933126",
    [
      241378
    ]
  ],
  "./zh-Hant/assignments_2_initial_query.json": [
    "469199",
    [
      672801
    ]
  ],
  "./zh-Hans/assignments.json": [
    "302511",
    [
      316517
    ]
  ],
  "./en-GB-x-ukhe/webzip_export.json": [
    "519372",
    [
      731500
    ]
  ],
  "./hu/calendar_custom_recurring_event_repeat_picker.json": [
    "779135",
    [
      198109
    ]
  ],
  "./nb/MasteryScale.json": [
    "624187",
    [
      60149
    ]
  ],
  "./es-ES/course_pace_date_input.json": [
    "539936",
    [
      800616
    ]
  ],
  "./pt-BR/assignment_index_menu.json": [
    "929123",
    [
      805974
    ]
  ],
  "./da-x-k12/NewTabIndicator.json": [
    "269393",
    [
      341435
    ]
  ],
  "./ms/horizon_toggle.json": [
    "856026",
    [
      561058
    ]
  ],
  "./fr-CA/user_name.json": [
    "492088",
    [
      444124
    ]
  ],
  "./el/submit_assignment.json": [
    "595431",
    [
      972473
    ]
  ],
  "./es-ES/moderate_quiz.json": [
    "202164",
    [
      972500
    ]
  ],
  "./nl/plugins.json": [
    "840504",
    [
      810564
    ]
  ],
  "./sl/assignmentsIndexView.json": [
    "394328",
    [
      223980
    ]
  ],
  "./sv-x-k12/horizon_toggle.json": [
    "981859",
    [
      931697
    ]
  ],
  "./sl/syllabus_revisions.json": [
    "958209",
    [
      224627
    ]
  ],
  "./ca/assignmentsIndexView.json": [
    "807229",
    [
      654083
    ]
  ],
  "./sv/OutcomeMoveModal.json": [
    "843439",
    [
      268953
    ]
  ],
  "./ar/course_paces_time_selection.json": [
    "178094",
    [
      653266
    ]
  ],
  "./ca/course_paces_flaggable_number_input.json": [
    "15943",
    [
      930949
    ]
  ],
  "./es-ES/assignment_2_assignment_toggle_details.json": [
    "381457",
    [
      843351
    ]
  ],
  "./fa/quiz_migration_notifications.json": [
    "410908",
    [
      592636
    ]
  ],
  "./ja/peer_review_configuration_tray.json": [
    "927796",
    [
      177905
    ]
  ],
  "./ru/peer_review_configuration_tray.json": [
    "127120",
    [
      288264
    ]
  ],
  "./zh-Hant/assignments_bulk_edit_use_save_assignment.json": [
    "366904",
    [
      679404
    ]
  ],
  "./pt-BR/notebook.json": [
    "945080",
    [
      477765
    ]
  ],
  "./vi/learning_mastery_gradebook.json": [
    "389320",
    [
      478976
    ]
  ],
  "./ca/gradebookActionMenu.json": [
    "450977",
    [
      669359
    ]
  ],
  "./ms/course_paces_module.json": [
    "610909",
    [
      790227
    ]
  ],
  "./es-ES/assignments.json": [
    "525997",
    [
      323803
    ]
  ],
  "./ja/sidenav.json": [
    "696691",
    [
      56462
    ]
  ],
  "./en-AU-x-unimelb/blueprint_course_child.json": [
    "28894",
    [
      480594
    ]
  ],
  "./hu/conferences_alternatives.json": [
    "396299",
    [
      804273
    ]
  ],
  "./it/assignment_grade_summary.json": [
    "637463",
    [
      105353
    ]
  ],
  "./mi/blueprint_course_sidebar.json": [
    "603942",
    [
      682278
    ]
  ],
  "./zh-Hans/course_paces_time_selection.json": [
    "665942",
    [
      712878
    ]
  ],
  "./da/calendar.header.json": [
    "935112",
    [
      707115
    ]
  ],
  "./da/manage_avatars.json": [
    "56429",
    [
      768915
    ]
  ],
  "./hi/peer_review_allocation_rules_tray.json": [
    "840868",
    [
      799524
    ]
  ],
  "./hu/context_roster_user_services.json": [
    "757647",
    [
      125549
    ]
  ],
  "./zh-Hans/self_unenrollment_modal.json": [
    "50643",
    [
      107569
    ]
  ],
  "./ms/reset_pace_warning_modal.json": [
    "296604",
    [
      16516
    ]
  ],
  "./mi/CourseAvailabilityOptions.json": [
    "577924",
    [
      997148
    ]
  ],
  "./fa/SpeedGraderCheckpoints.json": [
    "61390",
    [
      381094
    ]
  ],
  "./nn/webcam_modal.json": [
    "647429",
    [
      610991
    ]
  ],
  "./da-x-k12/SpeedGraderPostGradesMenu.json": [
    "352174",
    [
      896930
    ]
  ],
  "./it/module_sequence_footer.json": [
    "352883",
    [
      395933
    ]
  ],
  "./nn/gradebookActionMenu.json": [
    "600245",
    [
      204823
    ]
  ],
  "./sv/CreateEditAssignmentModal.json": [
    "172749",
    [
      417927
    ]
  ],
  "./zh-Hans/direct_share_course_import_panel.json": [
    "109259",
    [
      112249
    ]
  ],
  "./pt-BR/k5_course.json": [
    "278227",
    [
      850246
    ]
  ],
  "./fa/courses.json": [
    "455829",
    [
      319731
    ]
  ],
  "./pt/user_logins.json": [
    "239120",
    [
      147052
    ]
  ],
  "./ru/context_roster_user_services.json": [
    "712113",
    [
      48439
    ]
  ],
  "./en-GB-x-lbs/course_paces_header.json": [
    "592182",
    [
      160830
    ]
  ],
  "./is/ai_experiences.json": [
    "321758",
    [
      147510
    ]
  ],
  "./sv/reset_pace_warning_modal.json": [
    "85119",
    [
      173793
    ]
  ],
  "./nb-x-k12/assignments_2_media_attempt.json": [
    "245310",
    [
      727286
    ]
  ],
  "./pl/calendar_custom_recurring_event_natural_language.json": [
    "506782",
    [
      970442
    ]
  ],
  "./en-GB-x-lbs/discovery_page.json": [
    "763132",
    [
      172956
    ]
  ],
  "./pl/ProfileTray.json": [
    "193667",
    [
      62453
    ]
  ],
  "./sv.json": [
    "404900",
    [
      695806
    ]
  ],
  "./es-ES/gradinggradingPeriodCollection.json": [
    "999120",
    [
      480728
    ]
  ],
  "./hu/default_account_quotas.json": [
    "534048",
    [
      143776
    ]
  ],
  "./en-GB-x-lbs/nav_tourpoints.json": [
    "401663",
    [
      626261
    ]
  ],
  "./es-ES/nav_tourpoints.json": [
    "432178",
    [
      626066
    ]
  ],
  "./ja/content_exports.json": [
    "413362",
    [
      862491
    ]
  ],
  "./ja/unpublished_changes_button_props.json": [
    "142958",
    [
      126351
    ]
  ],
  "./tr/course_link_validator.json": [
    "407475",
    [
      809549
    ]
  ],
  "./ko/blueprint_course_child.json": [
    "270104",
    [
      885496
    ]
  ],
  "./uk/react_scheduler.json": [
    "879363",
    [
      644233
    ]
  ],
  "./zh-Hant/internal-settings.json": [
    "917689",
    [
      867155
    ]
  ],
  "./nn/account_calendar_settings_filter_controls.json": [
    "432946",
    [
      521094
    ]
  ],
  "./he/course_paces_footer.json": [
    "549653",
    [
      802363
    ]
  ],
  "./vi/user_lists.json": [
    "260991",
    [
      715164
    ]
  ],
  "./hy/outcome_detail.json": [
    "925175",
    [
      12141
    ]
  ],
  "./it/react_scheduler.json": [
    "553978",
    [
      748590
    ]
  ],
  "./ms/blueprint_course_child.json": [
    "938046",
    [
      158542
    ]
  ],
  "./de/account_calendar_settings.json": [
    "370243",
    [
      633254
    ]
  ],
  "./ga/context_roster_user_services.json": [
    "661850",
    [
      29914
    ]
  ],
  "./ht/account_notification_settings.json": [
    "94795",
    [
      150373
    ]
  ],
  "./zh-Hans/content_share_preview_overlay.json": [
    "104544",
    [
      312616
    ]
  ],
  "./fr/quantitative_data_options.json": [
    "898219",
    [
      202306
    ]
  ],
  "./id/paginated_list.json": [
    "435701",
    [
      930399
    ]
  ],
  "./da-x-k12/discovery_page.json": [
    "696773",
    [
      848039
    ]
  ],
  "./da-x-k12/paginated_list.json": [
    "137521",
    [
      888707
    ]
  ],
  "./pt-BR/appointment_groups.json": [
    "704343",
    [
      332322
    ]
  ],
  "./ru/top_navigation_tools.json": [
    "444779",
    [
      222153
    ]
  ],
  "./da/remove_pace_warning_modal.json": [
    "431782",
    [
      533174
    ]
  ],
  "./ht/remove_pace_warning_modal.json": [
    "439137",
    [
      444955
    ]
  ],
  "./it/conversations_2.json": [
    "953330",
    [
      220838
    ]
  ],
  "./en/accessibility_checker.json": [
    "781961",
    [
      81843
    ]
  ],
  "./ja/assignment_index_menu.json": [
    "864775",
    [
      569610
    ]
  ],
  "./mi/ldap_cert_upload.json": [
    "823564",
    [
      507796
    ]
  ],
  "./pl/terms_of_use.json": [
    "945223",
    [
      29353
    ]
  ],
  "./pt-BR/account_calendar_settings_confirmation_modal.json": [
    "901809",
    [
      364520
    ]
  ],
  "./pt-BR/assignmentsIndexView.json": [
    "970294",
    [
      362415
    ]
  ],
  "./pt-BR/discussion_row.json": [
    "988482",
    [
      226819
    ]
  ],
  "./ru/outcomes_user_outcome_results.json": [
    "361580",
    [
      304492
    ]
  ],
  "./th/calendar_appointment_group_edit.json": [
    "103115",
    [
      802933
    ]
  ],
  "./nn/k5_dashboard_card.json": [
    "42220",
    [
      955000
    ]
  ],
  "./da/security_panel.json": [
    "643844",
    [
      332556
    ]
  ],
  "./ru/section.json": [
    "467716",
    [
      372548
    ]
  ],
  "./uk/gradebook_history.json": [
    "17431",
    [
      29589
    ]
  ],
  "./ms/plugins.json": [
    "362270",
    [
      78798
    ]
  ],
  "./pl/epub_exports.json": [
    "991620",
    [
      184248
    ]
  ],
  "./fr/assignments_2_student_content.json": [
    "532075",
    [
      249314
    ]
  ],
  "./pl/direct_share_course_import_panel.json": [
    "870910",
    [
      877106
    ]
  ],
  "./pt/course_paces_header.json": [
    "205748",
    [
      89480
    ]
  ],
  "./nb/courses_show.json": [
    "940120",
    [
      735700
    ]
  ],
  "./tr/assignments_2_student_header.json": [
    "378061",
    [
      298303
    ]
  ],
  "./th/modelsQuiz.json": [
    "299761",
    [
      494427
    ]
  ],
  "./nl/gradinggradingPeriodCollection.json": [
    "987841",
    [
      120131
    ]
  ],
  "./es/account_calendars_modal.json": [
    "87947",
    [
      644374
    ]
  ],
  "./zh-Hans/assignments_2_peer_review.json": [
    "222848",
    [
      601816
    ]
  ],
  "./sl/top_navigation_tools.json": [
    "592693",
    [
      860415
    ]
  ],
  "./sv-x-k12/new_user_tutorial.json": [
    "302650",
    [
      638522
    ]
  ],
  "./es-ES/epub_exports.json": [
    "76615",
    [
      985325
    ]
  ],
  "./pl/quizzes_regrade_modal.json": [
    "491330",
    [
      737950
    ]
  ],
  "./ca/pseudonyms_mobile_login.json": [
    "940694",
    [
      637958
    ]
  ],
  "./sv-x-k12/content_exports.json": [
    "337680",
    [
      163144
    ]
  ],
  "./pl/media_player_iframe_content.json": [
    "641593",
    [
      533379
    ]
  ],
  "./th/sharedSetDefaultGradeDialog.json": [
    "600273",
    [
      178779
    ]
  ],
  "./fr-CA/course_paces_change_tracking.json": [
    "355524",
    [
      360736
    ]
  ],
  "./es/accessibility_checker.json": [
    "166790",
    [
      624599
    ]
  ],
  "./ar/important_dates_empty.json": [
    "237315",
    [
      613301
    ]
  ],
  "./cy/assignments_2_peer_review.json": [
    "160551",
    [
      723509
    ]
  ],
  "./da-x-k12/restore_content_pane.json": [
    "694994",
    [
      231214
    ]
  ],
  "./fr/user_profile.json": [
    "3235",
    [
      464418
    ]
  ],
  "./id/assignments_2_login_action_prompt.json": [
    "297612",
    [
      616240
    ]
  ],
  "./ca/assignmentsToggleShowByView.json": [
    "423429",
    [
      218043
    ]
  ],
  "./pl/conferences.json": [
    "189681",
    [
      459019
    ]
  ],
  "./en-GB-x-lbs/k5_course.json": [
    "414444",
    [
      955436
    ]
  ],
  "./de/peer_review_allocation_rules_tray.json": [
    "770060",
    [
      300385
    ]
  ],
  "./da/empty_modules.json": [
    "235078",
    [
      89622
    ]
  ],
  "./en-GB-x-lbs/content_migrations_redesign.json": [
    "59123",
    [
      879665
    ]
  ],
  "./da/internal-settings.json": [
    "493880",
    [
      291800
    ]
  ],
  "./pl/media_immersive_view.json": [
    "664030",
    [
      312469
    ]
  ],
  "./pt-BR/assignments_2_submission_histories_query.json": [
    "103569",
    [
      157480
    ]
  ],
  "./hy/course_restore.json": [
    "555607",
    [
      856413
    ]
  ],
  "./th/user.json": [
    "507129",
    [
      216899
    ]
  ],
  "./is/youtube_migration.json": [
    "805408",
    [
      481832
    ]
  ],
  "./it/LearningMasteryGradebook.json": [
    "813926",
    [
      86146
    ]
  ],
  "./en-GB/bulk_edit_students_table.json": [
    "354104",
    [
      325217
    ]
  ],
  "./es/course_paces_footer.json": [
    "885522",
    [
      589739
    ]
  ],
  "./ja/FindOutcomesModal.json": [
    "460028",
    [
      97785
    ]
  ],
  "./it/GroupsTray.json": [
    "399609",
    [
      476587
    ]
  ],
  "./nb-x-k12/upload_button.json": [
    "424890",
    [
      719565
    ]
  ],
  "./en/a2LatePolicyToolTipContent.json": [
    "824718",
    [
      645586
    ]
  ],
  "./nb-x-k12/video_conference.json": [
    "942418",
    [
      418562
    ]
  ],
  "./sl/folder_tree.json": [
    "885620",
    [
      649440
    ]
  ],
  "./en-GB/license_help.json": [
    "751422",
    [
      867315
    ]
  ],
  "./vi/assignments_2_login_action_prompt.json": [
    "199916",
    [
      632844
    ]
  ],
  "./ja/gradebook_uploads.json": [
    "396944",
    [
      665109
    ]
  ],
  "./ga/editGroup.json": [
    "337465",
    [
      444207
    ]
  ],
  "./uk/user_grades.json": [
    "173218",
    [
      225546
    ]
  ],
  "./ja/user_restore.json": [
    "716995",
    [
      114846
    ]
  ],
  "./uk/assignments_2_student_header_date_title.json": [
    "697981",
    [
      806531
    ]
  ],
  "./he/paginated_list.json": [
    "860063",
    [
      281469
    ]
  ],
  "./zh-Hans/blueprint_settingsMigrationOptions.json": [
    "410052",
    [
      412916
    ]
  ],
  "./de/assignments_2_initial_query.json": [
    "667986",
    [
      758099
    ]
  ],
  "./ja/permissions_v2.json": [
    "850768",
    [
      48533
    ]
  ],
  "./hi/course_template_details.json": [
    "476572",
    [
      730828
    ]
  ],
  "./fr-CA/assignment_grade_summary.json": [
    "193387",
    [
      957693
    ]
  ],
  "./hu/discussion_create.json": [
    "721364",
    [
      493228
    ]
  ],
  "./da/assignment_grade_summary.json": [
    "171349",
    [
      14507
    ]
  ],
  "./ms/login.json": [
    "939263",
    [
      199613
    ]
  ],
  "./da/SpeedGraderDiscussionsNavigation.json": [
    "111616",
    [
      757168
    ]
  ],
  "./nn/assignment_grade_summary.json": [
    "371044",
    [
      778992
    ]
  ],
  "./zh-Hans/account_course_user_search.json": [
    "765865",
    [
      793295
    ]
  ],
  "./sl/grade_summary.json": [
    "698061",
    [
      34295
    ]
  ],
  "./en-GB-x-ukhe/user_date_range_search.json": [
    "858287",
    [
      440629
    ]
  ],
  "./pl/assignment_show.json": [
    "259709",
    [
      969423
    ]
  ],
  "./mi/FindOutcomesModal.json": [
    "109523",
    [
      156873
    ]
  ],
  "./ca/assignments_2_initial_query.json": [
    "385925",
    [
      858363
    ]
  ],
  "./zh-Hant/CreateEditAssignmentModal.json": [
    "476714",
    [
      811270
    ]
  ],
  "./fa/context_modules_v2.json": [
    "829047",
    [
      220989
    ]
  ],
  "./pt-BR/account_notification_settings.json": [
    "313822",
    [
      744375
    ]
  ],
  "./uk/suppress_notifications.json": [
    "247422",
    [
      228574
    ]
  ],
  "./hu/conversations_2.json": [
    "12852",
    [
      268
    ]
  ],
  "./sl/default_account_quotas.json": [
    "119956",
    [
      573064
    ]
  ],
  "./sv/calendar.header.json": [
    "419058",
    [
      748037
    ]
  ],
  "./it/assignment_index.json": [
    "992011",
    [
      674933
    ]
  ],
  "./ht/k5_dashboard_card.json": [
    "940680",
    [
      343940
    ]
  ],
  "./hu/MasteryScale.json": [
    "488846",
    [
      588414
    ]
  ],
  "./pt/account_settings.json": [
    "220651",
    [
      71325
    ]
  ],
  "./th/react_scheduler.json": [
    "569459",
    [
      510541
    ]
  ],
  "./nl/security_panel.json": [
    "506779",
    [
      376925
    ]
  ],
  "./pl/notebook.json": [
    "604515",
    [
      260053
    ]
  ],
  "./mi/gradingGradeSummary.json": [
    "809137",
    [
      687247
    ]
  ],
  "./ar/submit_online_url_assignment.json": [
    "838843",
    [
      860597
    ]
  ],
  "./hy/jobs.json": [
    "76631",
    [
      694989
    ]
  ],
  "./hi/HelpTray.json": [
    "979812",
    [
      596660
    ]
  ],
  "./is/blueprint_settingsMigrationOptions.json": [
    "684341",
    [
      359619
    ]
  ],
  "./mi/login.json": [
    "731477",
    [
      143771
    ]
  ],
  "./sl/peer_reviews_student.json": [
    "975377",
    [
      35219
    ]
  ],
  "./en/assignments_2_student_points_display.json": [
    "391877",
    [
      278823
    ]
  ],
  "./mi/LearningMasteryGradebook.json": [
    "54335",
    [
      456701
    ]
  ],
  "./sl/keyboardShortcutModal.json": [
    "576165",
    [
      463695
    ]
  ],
  "./fr-CA/MasteryScale.json": [
    "898464",
    [
      19796
    ]
  ],
  "./fr-CA/calendar.header.json": [
    "151618",
    [
      688981
    ]
  ],
  "./ht/a2_AccessibleTipContent.json": [
    "511642",
    [
      296206
    ]
  ],
  "./he/discussion_insights.json": [
    "514505",
    [
      220375
    ]
  ],
  "./is/progression_module_header.json": [
    "39390",
    [
      314838
    ]
  ],
  "./ru/account_notification_settings.json": [
    "477902",
    [
      410502
    ]
  ],
  "./id/assignment_index_deep_linking_handlers.json": [
    "970055",
    [
      566105
    ]
  ],
  "./hu/login.json": [
    "668128",
    [
      862592
    ]
  ],
  "./nb/assignments_2_attempt_tab.json": [
    "630087",
    [
      740241
    ]
  ],
  "./uk/quizzes.take_quiz.json": [
    "915468",
    [
      874961
    ]
  ],
  "./fr-CA/conversations_2.json": [
    "364766",
    [
      72866
    ]
  ],
  "./zh-Hant/account_calendar_settings_confirmation_modal.json": [
    "28176",
    [
      302668
    ]
  ],
  "./ru/permissions.json": [
    "358547",
    [
      647601
    ]
  ],
  "./is/SpeedGraderPostGradesMenu.json": [
    "600531",
    [
      154593
    ]
  ],
  "./vi/Navigation.json": [
    "643307",
    [
      51993
    ]
  ],
  "./es/internal-settings.json": [
    "750771",
    [
      218654
    ]
  ],
  "./th/courses.show.json": [
    "956827",
    [
      895254
    ]
  ],
  "./hu/password_complexity_configuration.json": [
    "436090",
    [
      657986
    ]
  ],
  "./en-GB/CoursesTray.json": [
    "919489",
    [
      360964
    ]
  ],
  "./it/assignment_index_menu.json": [
    "460819",
    [
      338541
    ]
  ],
  "./zh-Hans/course_restore.json": [
    "309439",
    [
      37365
    ]
  ],
  "./el/roster_section_selector.json": [
    "576694",
    [
      527578
    ]
  ],
  "./hi/conferences_alternatives.json": [
    "823495",
    [
      314317
    ]
  ],
  "./is/terms_of_use.json": [
    "941707",
    [
      482761
    ]
  ],
  "./th/canvas_file_upload.json": [
    "948915",
    [
      627629
    ]
  ],
  "./zh-Hant/important_dates.json": [
    "507552",
    [
      939164
    ]
  ],
  "./en-GB/webcam_modal.json": [
    "248710",
    [
      304995
    ]
  ],
  "./pt-BR/error_form.json": [
    "799596",
    [
      197377
    ]
  ],
  "./ko/todo.json": [
    "83720",
    [
      159336
    ]
  ],
  "./ca/speed_grader_helpers.json": [
    "729959",
    [
      478117
    ]
  ],
  "./en-GB-x-lbs/sharedCurveGradesDialog.json": [
    "73848",
    [
      35792
    ]
  ],
  "./tr/AssignmentListItemView.json": [
    "368411",
    [
      330013
    ]
  ],
  "./uk/modules_page_icon_legend.json": [
    "665311",
    [
      349677
    ]
  ],
  "./sv/job_stats.json": [
    "844276",
    [
      332928
    ]
  ],
  "./id/blueprint_course_child.json": [
    "118185",
    [
      422747
    ]
  ],
  "./zh-Hant/react_scheduler.json": [
    "865749",
    [
      603279
    ]
  ],
  "./hi/assignment_grade_summary.json": [
    "280441",
    [
      272479
    ]
  ],
  "./th/edit_section_dates.json": [
    "209316",
    [
      575640
    ]
  ],
  "./nl/editGroup.json": [
    "872407",
    [
      721409
    ]
  ],
  "./fa/assignmentsIndexView.json": [
    "308638",
    [
      704614
    ]
  ],
  "./th/grade_change_logging_content.json": [
    "396094",
    [
      294786
    ]
  ],
  "./sl/AssignmentListItemView.json": [
    "614972",
    [
      232648
    ]
  ],
  "./ru/bulk_edit_students.json": [
    "69287",
    [
      847997
    ]
  ],
  "./cy/peer_reviews_student.json": [
    "211548",
    [
      889572
    ]
  ],
  "./sv/editAssignmentGroupWeights.json": [
    "585220",
    [
      516152
    ]
  ],
  "./pt-BR/security_panel.json": [
    "232814",
    [
      511255
    ]
  ],
  "./is/knowledge_check_not_ready.json": [
    "785535",
    [
      481829
    ]
  ],
  "./zh-Hant/question_banks.json": [
    "756540",
    [
      156904
    ]
  ],
  "./he/rubrics-export.json": [
    "551040",
    [
      941331
    ]
  ],
  "./fr-CA/empty_course.json": [
    "184590",
    [
      178354
    ]
  ],
  "./ar/IndividualStudentMasteryOutcome.json": [
    "968052",
    [
      868184
    ]
  ],
  "./ja/discussion_topics.json": [
    "804010",
    [
      435155
    ]
  ],
  "./ht/outcome_reporting.json": [
    "589091",
    [
      925165
    ]
  ],
  "./tr/account_calendars.json": [
    "32963",
    [
      232805
    ]
  ],
  "./tr/course_paces_actions.json": [
    "168862",
    [
      322498
    ]
  ],
  "./en-AU-x-unimelb/discussion_create.json": [
    "743471",
    [
      871017
    ]
  ],
  "./sv/outcome_alignment_v2.json": [
    "837594",
    [
      743086
    ]
  ],
  "./is/rootFoldersFinder.json": [
    "915247",
    [
      695349
    ]
  ],
  "./da-x-k12/MasteryScale.json": [
    "562152",
    [
      298356
    ]
  ],
  "./pt-BR/k5_dashboard.json": [
    "441858",
    [
      665763
    ]
  ],
  "./da/blueprint_settingsMigrationSync.json": [
    "505761",
    [
      327375
    ]
  ],
  "./hi/user_date_range_search.json": [
    "130232",
    [
      471360
    ]
  ],
  "./pl/unpublished_changes_button_props.json": [
    "553421",
    [
      276063
    ]
  ],
  "./da/discussion_settings.json": [
    "457937",
    [
      374079
    ]
  ],
  "./fi/course_paces_empty_state.json": [
    "351387",
    [
      521881
    ]
  ],
  "./zh-Hans/course_paces_app.json": [
    "416805",
    [
      936227
    ]
  ],
  "./fi/peer_review_allocation_rules_tray.json": [
    "325646",
    [
      593974
    ]
  ],
  "./ja.json": [
    "975012",
    [
      780642
    ]
  ],
  "./zh-Hant/choose_mastery_path.json": [
    "723319",
    [
      830577
    ]
  ],
  "./it/account_notification_settings.json": [
    "176174",
    [
      58986
    ]
  ],
  "./ar/assignment_show.json": [
    "841842",
    [
      546790
    ]
  ],
  "./sv-x-k12/assignments_peer_reviews_student.json": [
    "92402",
    [
      913346
    ]
  ],
  "./th/roster_section_input.json": [
    "619386",
    [
      7214
    ]
  ],
  "./fi/peer_review_student_select.json": [
    "986331",
    [
      716057
    ]
  ],
  "./fi/user_profile.json": [
    "8808",
    [
      834800
    ]
  ],
  "./ca/courses.show.json": [
    "557387",
    [
      118522
    ]
  ],
  "./en-GB-x-lbs/sis_import.json": [
    "388231",
    [
      88989
    ]
  ],
  "./he/permissions.json": [
    "403089",
    [
      187087
    ]
  ],
  "./es/student_groups.json": [
    "244094",
    [
      672623
    ]
  ],
  "./id/blueprint_settingsMigrationSync.json": [
    "39575",
    [
      325657
    ]
  ],
  "./it/gradebookActionMenu.json": [
    "306292",
    [
      508776
    ]
  ],
  "./mi/manage_avatars.json": [
    "349438",
    [
      997998
    ]
  ],
  "./cy/question_bank.json": [
    "556185",
    [
      430567
    ]
  ],
  "./nb-x-k12/course_paces_blueprint_lock.json": [
    "958440",
    [
      876832
    ]
  ],
  "./de/progress_pill.json": [
    "139062",
    [
      160079
    ]
  ],
  "./th/peer_review_configuration_tray.json": [
    "684675",
    [
      24869
    ]
  ],
  "./uk/choose_mastery_path.json": [
    "483893",
    [
      114475
    ]
  ],
  "./nb/course_paces_projected_dates.json": [
    "589933",
    [
      847207
    ]
  ],
  "./th/group_submission_reminder.json": [
    "34305",
    [
      566195
    ]
  ],
  "./pl/outcome_management.json": [
    "217592",
    [
      261644
    ]
  ],
  "./sv/paginated_list.json": [
    "36153",
    [
      299155
    ]
  ],
  "./sv/course_search_results.json": [
    "843796",
    [
      953408
    ]
  ],
  "./hu/context_modules_v2.json": [
    "946157",
    [
      410627
    ]
  ],
  "./ga/gradebook.json": [
    "381884",
    [
      6588
    ]
  ],
  "./tr/grade_details.json": [
    "992902",
    [
      896682
    ]
  ],
  "./nl/unpublished_changes_button_props.json": [
    "613743",
    [
      306049
    ]
  ],
  "./it/course_paces_header.json": [
    "190165",
    [
      316575
    ]
  ],
  "./hy/CreateEditAssignmentModal.json": [
    "255931",
    [
      49049
    ]
  ],
  "./fr/manage_avatars.json": [
    "194136",
    [
      565281
    ]
  ],
  "./he/content_share_preview_overlay.json": [
    "981900",
    [
      503892
    ]
  ],
  "./en-GB-x-ukhe/course_paces_change_tracking.json": [
    "225485",
    [
      721387
    ]
  ],
  "./ar/assignments_2_initial_query.json": [
    "754618",
    [
      249446
    ]
  ],
  "./es-ES/blueprint_settingsSyncChange.json": [
    "504407",
    [
      335501
    ]
  ],
  "./fr/user_logins.json": [
    "526000",
    [
      734305
    ]
  ],
  "./ja/context_roster_user_services.json": [
    "309749",
    [
      802604
    ]
  ],
  "./en-AU/account_calendar_settings_footer.json": [
    "80756",
    [
      145425
    ]
  ],
  "./sl/jobs.json": [
    "297951",
    [
      427881
    ]
  ],
  "./nn/discussion_settings.json": [
    "90426",
    [
      130654
    ]
  ],
  "./da-x-k12/course_paces_blackout_dates_modal.json": [
    "437145",
    [
      987067
    ]
  ],
  "./it/manage_avatars.json": [
    "901827",
    [
      778325
    ]
  ],
  "./nb-x-k12/course_paces_header.json": [
    "400474",
    [
      691562
    ]
  ],
  "./tr/appointment_groups.json": [
    "707430",
    [
      822138
    ]
  ],
  "./it/license_help.json": [
    "588178",
    [
      340310
    ]
  ],
  "./nl/ldap_cert_upload.json": [
    "336480",
    [
      314212
    ]
  ],
  "./da-x-k12/conversations_2.json": [
    "334246",
    [
      228098
    ]
  ],
  "./en-GB-x-ukhe/content_copy_redesign.json": [
    "644167",
    [
      244269
    ]
  ],
  "./ca/course_link_validator.json": [
    "80621",
    [
      98355
    ]
  ],
  "./fa/job_stats.json": [
    "175728",
    [
      162376
    ]
  ],
  "./el/gradingGradeSummary.json": [
    "923702",
    [
      860026
    ]
  ],
  "./pl/paginated_list.json": [
    "407582",
    [
      767002
    ]
  ],
  "./th/GroupsTray.json": [
    "733634",
    [
      225622
    ]
  ],
  "./es-ES/entity_search_form.json": [
    "30122",
    [
      447706
    ]
  ],
  "./ga/CoursesTray.json": [
    "51280",
    [
      119064
    ]
  ],
  "./nn/quantitative_data_options.json": [
    "132327",
    [
      524009
    ]
  ],
  "./ht/roster_publicjs.json": [
    "797780",
    [
      888192
    ]
  ],
  "./ht/modules_home_page.json": [
    "878331",
    [
      919101
    ]
  ],
  "./cy/notebook_index.json": [
    "293568",
    [
      890048
    ]
  ],
  "./ga/account_settings.json": [
    "439559",
    [
      633181
    ]
  ],
  "./ms/permissions_role_tray.json": [
    "582796",
    [
      867796
    ]
  ],
  "./is/course_paces_app.json": [
    "219692",
    [
      915100
    ]
  ],
  "./nn/blueprint_settingsMigrationOptions.json": [
    "2893",
    [
      756295
    ]
  ],
  "./is/DueDateOverrideView.json": [
    "763853",
    [
      138139
    ]
  ],
  "./pl/lti_registration.wizard.json": [
    "56216",
    [
      505155
    ]
  ],
  "./ht/assignment_index_deep_linking_handlers.json": [
    "862764",
    [
      565856
    ]
  ],
  "./ar/bulk_edit_students_actions.json": [
    "224817",
    [
      797027
    ]
  ],
  "./da/announcements_on_home_page.json": [
    "817943",
    [
      78069
    ]
  ],
  "./en-GB-x-lbs/course_paces_change_tracking.json": [
    "33125",
    [
      762387
    ]
  ],
  "./pl/assignments_2_shared_Steps.json": [
    "426083",
    [
      272317
    ]
  ],
  "./cy/quiz_show.json": [
    "132349",
    [
      614195
    ]
  ],
  "./is/notebook.json": [
    "788815",
    [
      496437
    ]
  ],
  "./sv/course_paces_actions.json": [
    "861947",
    [
      30293
    ]
  ],
  "./zh-Hant/knowledge_check_not_ready.json": [
    "488885",
    [
      607735
    ]
  ],
  "./en-GB-x-ukhe/OutcomeDescriptionModal.json": [
    "110079",
    [
      657989
    ]
  ],
  "./he/courses.json": [
    "838495",
    [
      4861
    ]
  ],
  "./ja/MobileGlobalMenu.json": [
    "842847",
    [
      897058
    ]
  ],
  "./tr/course_paces_header.json": [
    "863554",
    [
      889894
    ]
  ],
  "./ht/blueprint_settingsCoursePickerTable.json": [
    "183200",
    [
      234436
    ]
  ],
  "./mi/GroupDetailView.json": [
    "403783",
    [
      645269
    ]
  ],
  "./sv-x-k12/roster_publicjs.json": [
    "105715",
    [
      223569
    ]
  ],
  "./ja/NewTabIndicator.json": [
    "165321",
    [
      191368
    ]
  ],
  "./es/external_content_cancel.json": [
    "722658",
    [
      334075
    ]
  ],
  "./el/calculator_command.json": [
    "952939",
    [
      495637
    ]
  ],
  "./nn/login.json": [
    "463091",
    [
      336629
    ]
  ],
  "./da/modules_page_icon_legend.json": [
    "721022",
    [
      212094
    ]
  ],
  "./fi/account_calendars.json": [
    "636024",
    [
      492320
    ]
  ],
  "./he/mutationActivity.json": [
    "365913",
    [
      552231
    ]
  ],
  "./de/authentication_providers.json": [
    "839290",
    [
      245355
    ]
  ],
  "./ht/account_calendar_settings_utils.json": [
    "417898",
    [
      649886
    ]
  ],
  "./ht/module_student_view_peer_reviews.json": [
    "636401",
    [
      943283
    ]
  ],
  "./nl/pseudonyms_mobile_login.json": [
    "157768",
    [
      70580
    ]
  ],
  "./nl/submit_online_url_assignment.json": [
    "569528",
    [
      589764
    ]
  ],
  "./hu/lti_registration.wizard.json": [
    "697015",
    [
      970426
    ]
  ],
  "./uk/terms_index.json": [
    "638818",
    [
      620298
    ]
  ],
  "./zh-Hant/assignments_2_login_action_prompt.json": [
    "422911",
    [
      833921
    ]
  ],
  "./fr-CA/jobs.json": [
    "519941",
    [
      625903
    ]
  ],
  "./pt/video_conference.json": [
    "704388",
    [
      330920
    ]
  ],
  "./en-AU/moderate_quiz.json": [
    "613443",
    [
      733438
    ]
  ],
  "./id/editAssignmentGroupWeights.json": [
    "979568",
    [
      307876
    ]
  ],
  "./en-GB-x-lbs/grade_details.json": [
    "828290",
    [
      171218
    ]
  ],
  "./en-AU/todo.json": [
    "618252",
    [
      195689
    ]
  ],
  "./fa/GroupsTray.json": [
    "344529",
    [
      504231
    ]
  ],
  "./ms/bounced_emails.json": [
    "779846",
    [
      335014
    ]
  ],
  "./ga/confirmMasteryModal.json": [
    "72960",
    [
      274360
    ]
  ],
  "./en-AU/dashboard_grading_period_select.json": [
    "164598",
    [
      36375
    ]
  ],
  "./ru/confirmMasteryModal.json": [
    "768889",
    [
      691439
    ]
  ],
  "./en-GB-x-ukhe/account_notification_settings.json": [
    "295929",
    [
      369791
    ]
  ],
  "./th/custom_emoji_deny_list.json": [
    "695092",
    [
      413184
    ]
  ],
  "./ht/submit_assignment.json": [
    "90490",
    [
      218550
    ]
  ],
  "./pt-BR/password_complexity_configuration.json": [
    "832304",
    [
      189517
    ]
  ],
  "./en-GB-x-lbs/course_paces_blackout_dates_table.json": [
    "150107",
    [
      733273
    ]
  ],
  "./pt-BR/wiki_page_index.json": [
    "43018",
    [
      85403
    ]
  ],
  "./ko/conversations_2.json": [
    "426333",
    [
      383939
    ]
  ],
  "./fr/SpeedGraderDiscussionsNavigation.json": [
    "667825",
    [
      149996
    ]
  ],
  "./ko/quiz_show.json": [
    "16223",
    [
      420557
    ]
  ],
  "./pt-BR/file_not_found.json": [
    "98638",
    [
      130663
    ]
  ],
  "./es/quizzes_quiz_submission.json": [
    "634066",
    [
      731659
    ]
  ],
  "./he/assignments.never_drop.json": [
    "348261",
    [
      849504
    ]
  ],
  "./ht/pseudonyms_mobile_login.json": [
    "120574",
    [
      559122
    ]
  ],
  "./it/conferences_alternatives.json": [
    "431389",
    [
      511791
    ]
  ],
  "./id/internal-settings.json": [
    "44854",
    [
      121850
    ]
  ],
  "./ru/rubrics-export.json": [
    "414842",
    [
      3562
    ]
  ],
  "./is/edit_section_dates.json": [
    "105947",
    [
      779280
    ]
  ],
  "./pt/bulk_edit_students.json": [
    "754920",
    [
      399852
    ]
  ],
  "./vi/course_paces_errors.json": [
    "436203",
    [
      883993
    ]
  ],
  "./it/outcomes_user_outcome_results.json": [
    "488908",
    [
      167448
    ]
  ],
  "./it/ProfileTray.json": [
    "179582",
    [
      48482
    ]
  ],
  "./nb-x-k12/assignments_2_student_points_display.json": [
    "131534",
    [
      695110
    ]
  ],
  "./mi/editGroup.json": [
    "42411",
    [
      327985
    ]
  ],
  "./nb/unpublished_changes_tray_contents.json": [
    "485303",
    [
      565022
    ]
  ],
  "./fr/AddGroup.json": [
    "17280",
    [
      951033
    ]
  ],
  "./ga/horizon_toggle.json": [
    "189750",
    [
      964670
    ]
  ],
  "./hi/assignments_2_MoreOptions.json": [
    "172152",
    [
      965888
    ]
  ],
  "./fr-CA/quizzes_regrade_modal.json": [
    "547207",
    [
      764409
    ]
  ],
  "./pt/context_roster_user_services.json": [
    "706686",
    [
      680090
    ]
  ],
  "./uk/course_search_results.json": [
    "701781",
    [
      195915
    ]
  ],
  "./ca/terms_index.json": [
    "650658",
    [
      941834
    ]
  ],
  "./pl/wiki_page_index.json": [
    "811755",
    [
      296197
    ]
  ],
  "./pl/course_paces_projected_dates.json": [
    "268221",
    [
      42743
    ]
  ],
  "./ga/pairing_code_user_observees.json": [
    "484287",
    [
      28357
    ]
  ],
  "./mi/dashboard_grading_period_select.json": [
    "793870",
    [
      107070
    ]
  ],
  "./pl/speed_grader_helpers.json": [
    "272783",
    [
      736721
    ]
  ],
  "./hu/student_groups.json": [
    "989751",
    [
      591109
    ]
  ],
  "./id/Navigation.json": [
    "50507",
    [
      927733
    ]
  ],
  "./fr/MobileGlobalMenu.json": [
    "885356",
    [
      154613
    ]
  ],
  "./id/assignments_2_media_attempt.json": [
    "627561",
    [
      132187
    ]
  ],
  "./cy.json": [
    "42461",
    [
      214225
    ]
  ],
  "./nl/discussion_topics_edit.json": [
    "490214",
    [
      997602
    ]
  ],
  "./nn/direct_share_course_import_panel.json": [
    "821898",
    [
      126302
    ]
  ],
  "./ca/empty_course.json": [
    "293721",
    [
      58519
    ]
  ],
  "./zh-Hant/copy_warnings_modal.json": [
    "270629",
    [
      966756
    ]
  ],
  "./en-GB/conversations_2.json": [
    "840478",
    [
      775971
    ]
  ],
  "./cy/assignments_2_student_points_display.json": [
    "215268",
    [
      113788
    ]
  ],
  "./sl/assignments_2_attempt_tab.json": [
    "910900",
    [
      204032
    ]
  ],
  "./ms/assignments.no_assignments_search.json": [
    "913301",
    [
      223190
    ]
  ],
  "./zh-Hans/copy_course.json": [
    "876940",
    [
      992194
    ]
  ],
  "./fr/roster_section_selector.json": [
    "377695",
    [
      450134
    ]
  ],
  "./zh-Hant/course_paces_header.json": [
    "45538",
    [
      933110
    ]
  ],
  "./fr/blueprint_coursesExpandableLockOptions.json": [
    "957883",
    [
      213378
    ]
  ],
  "./uk/module_sequence_footer.json": [
    "527252",
    [
      533372
    ]
  ],
  "./en/discussion_topics.json": [
    "628144",
    [
      199316
    ]
  ],
  "./he/account_calendar_settings_account_list.json": [
    "229200",
    [
      533744
    ]
  ],
  "./en-GB-x-ukhe/gradingPeriodTemplate.json": [
    "74919",
    [
      965053
    ]
  ],
  "./zh-Hans/security_panel.json": [
    "961768",
    [
      471600
    ]
  ],
  "./ja/manage_avatars.json": [
    "737103",
    [
      685138
    ]
  ],
  "./fr/IndividualStudentMasteryOutcome.json": [
    "598883",
    [
      34378
    ]
  ],
  "./he/change_password.json": [
    "595069",
    [
      566355
    ]
  ],
  "./fi/calculator_command.json": [
    "315023",
    [
      665285
    ]
  ],
  "./en-AU-x-unimelb/sidenav.json": [
    "689074",
    [
      487782
    ]
  ],
  "./fi/empty_course.json": [
    "333202",
    [
      937026
    ]
  ],
  "./ht/HelpTray.json": [
    "201889",
    [
      654195
    ]
  ],
  "./fr/video_conference.json": [
    "46372",
    [
      688621
    ]
  ],
  "./hu/enhanced_individual_gradebook_submit_score.json": [
    "971424",
    [
      185504
    ]
  ],
  "./he/conversations_2.json": [
    "478308",
    [
      594940
    ]
  ],
  "./pt-BR/course_paces_errors.json": [
    "787339",
    [
      719662
    ]
  ],
  "./ko/add_edit_pseudonym.json": [
    "451733",
    [
      536427
    ]
  ],
  "./pl/quizzes.take_quiz.json": [
    "763204",
    [
      413477
    ]
  ],
  "./nb/context_prior_users.json": [
    "565985",
    [
      520515
    ]
  ],
  "./nn/blueprint_course_sidebar.json": [
    "496612",
    [
      194272
    ]
  ],
  "./pt-BR/lti_registration.wizard.json": [
    "527125",
    [
      426868
    ]
  ],
  "./it/CourseAvailabilityOptions.json": [
    "393439",
    [
      763761
    ]
  ],
  "./ja/editGroup.json": [
    "863044",
    [
      172865
    ]
  ],
  "./ru/assignments_2_media_attempt.json": [
    "830553",
    [
      565791
    ]
  ],
  "./de/blueprint_settingsCoursePicker.json": [
    "719545",
    [
      687936
    ]
  ],
  "./en-GB/content_shares.json": [
    "885323",
    [
      673618
    ]
  ],
  "./en-GB-x-ukhe/blueprint_settingsCourseFilter.json": [
    "966898",
    [
      941394
    ]
  ],
  "./vi/quiz_migration_notifications.json": [
    "83828",
    [
      97508
    ]
  ],
  "./nl/ai_experiences_show.json": [
    "620828",
    [
      54760
    ]
  ],
  "./sv-x-k12/terms_index.json": [
    "690385",
    [
      255543
    ]
  ],
  "./es-ES/empty_course.json": [
    "944578",
    [
      247970
    ]
  ],
  "./sv/gradebookOutcomeGradebookView.json": [
    "91642",
    [
      755598
    ]
  ],
  "./ca/student_entries.json": [
    "685838",
    [
      357742
    ]
  ],
  "./fr/important_dates_empty.json": [
    "45016",
    [
      595241
    ]
  ],
  "./sv-x-k12/appt_calendar_event_dialog.json": [
    "416579",
    [
      88625
    ]
  ],
  "./cy/bounced_emails.json": [
    "988478",
    [
      228494
    ]
  ],
  "./es-ES/self_unenrollment_modal.json": [
    "87393",
    [
      27815
    ]
  ],
  "./vi/modules_home_page.json": [
    "370606",
    [
      438022
    ]
  ],
  "./hu/discussionTopicKeyboradShortcutModal.json": [
    "95596",
    [
      382964
    ]
  ],
  "./hy/outcome_reporting.json": [
    "233524",
    [
      614676
    ]
  ],
  "./nb-x-k12/quizzes_quiz_submission.json": [
    "616540",
    [
      751852
    ]
  ],
  "./ms/content_exports.json": [
    "342507",
    [
      27921
    ]
  ],
  "./nb/gradebookOutcomeGradebookView.json": [
    "469431",
    [
      110673
    ]
  ],
  "./ms/restore_content_pane.json": [
    "891605",
    [
      430395
    ]
  ],
  "./nn/calendar_custom_recurring_event_repeat_picker.json": [
    "125587",
    [
      225484
    ]
  ],
  "./fr/sis_import.json": [
    "405737",
    [
      47108
    ]
  ],
  "./hy/progress_pill.json": [
    "782462",
    [
      359510
    ]
  ],
  "./ar/gradingPeriodTemplate.json": [
    "127098",
    [
      668702
    ]
  ],
  "./is/folder_tree.json": [
    "98911",
    [
      33845
    ]
  ],
  "./nb-x-k12/a2LatePolicyToolTipContent.json": [
    "501233",
    [
      936711
    ]
  ],
  "./zh-Hans/grades_empty_page.json": [
    "542273",
    [
      258839
    ]
  ],
  "./zh-Hans/k5_dashboard.json": [
    "862952",
    [
      466528
    ]
  ],
  "./ms/calendar_edit.json": [
    "777329",
    [
      864463
    ]
  ],
  "./pt/calculator_command.json": [
    "27828",
    [
      828160
    ]
  ],
  "./ms/empty_course.json": [
    "945049",
    [
      518855
    ]
  ],
  "./uk/gradebookActionMenu.json": [
    "520801",
    [
      803887
    ]
  ],
  "./hi/courses.show.json": [
    "908782",
    [
      361341
    ]
  ],
  "./en-GB-x-lbs/gradebookActionMenu.json": [
    "814279",
    [
      676605
    ]
  ],
  "./fr-CA/notebook_index.json": [
    "839775",
    [
      990505
    ]
  ],
  "./pl.json": [
    "294637",
    [
      604717
    ]
  ],
  "./en-AU-x-unimelb/edit_section_dates.json": [
    "862740",
    [
      291728
    ]
  ],
  "./hi/webzip_export.json": [
    "304501",
    [
      470275
    ]
  ],
  "./hy/course_logging_details.json": [
    "595049",
    [
      5807
    ]
  ],
  "./hy/k5_course.json": [
    "472773",
    [
      85011
    ]
  ],
  "./en-AU/widget_dashboard.json": [
    "45899",
    [
      311078
    ]
  ],
  "./he/outcome_detail.json": [
    "321067",
    [
      243217
    ]
  ],
  "./th/CourseAvailabilityOptions.json": [
    "677746",
    [
      615414
    ]
  ],
  "./es/announcements_on_home_page.json": [
    "305930",
    [
      113283
    ]
  ],
  "./mi/job_stats.json": [
    "551907",
    [
      769753
    ]
  ],
  "./pt-BR/roster_section_selector.json": [
    "970826",
    [
      997243
    ]
  ],
  "./ru/ignite_agent.json": [
    "843141",
    [
      891779
    ]
  ],
  "./en-AU/course_color_selector.json": [
    "763787",
    [
      678
    ]
  ],
  "./zh-Hans/peer_review_allocation_rules_tray.json": [
    "580716",
    [
      732124
    ]
  ],
  "./en-GB-x-ukhe/new_user_tutorial.json": [
    "836831",
    [
      147973
    ]
  ],
  "./id/content_migrations.json": [
    "964242",
    [
      932094
    ]
  ],
  "./is/theme_editor.json": [
    "694853",
    [
      471635
    ]
  ],
  "./nl/gradebook_default_gradebook_components_content_filters_module_filter.json": [
    "554488",
    [
      305548
    ]
  ],
  "./nb/GroupDetailView.json": [
    "899265",
    [
      364195
    ]
  ],
  "./fr/self_unenrollment_modal.json": [
    "782188",
    [
      37901
    ]
  ],
  "./mi/group_submission_reminder.json": [
    "391667",
    [
      858281
    ]
  ],
  "./vi/quizzes.take_quiz.json": [
    "955277",
    [
      282922
    ]
  ],
  "./da-x-k12/course_paces_empty_state.json": [
    "553631",
    [
      74313
    ]
  ],
  "./ms/assignments.never_drop.json": [
    "924332",
    [
      655359
    ]
  ],
  "./el/blueprint_course_child.json": [
    "605885",
    [
      248511
    ]
  ],
  "./zh-Hans/outcome_reporting.json": [
    "754572",
    [
      224508
    ]
  ],
  "./fr/ProfileTray.json": [
    "867547",
    [
      754066
    ]
  ],
  "./ko/content_migrations.json": [
    "304447",
    [
      605933
    ]
  ],
  "./hy/default_account_quotas.json": [
    "804012",
    [
      368796
    ]
  ],
  "./en-AU-x-unimelb/conferences.json": [
    "401449",
    [
      316395
    ]
  ],
  "./ja/assignments_2_student_annotation.json": [
    "798516",
    [
      471921
    ]
  ],
  "./hu/permission_button.json": [
    "938497",
    [
      661791
    ]
  ],
  "./ca/a2LatePolicyStatusDisplay.json": [
    "782821",
    [
      932571
    ]
  ],
  "./fr-CA/accessibility_course_statistics.json": [
    "629593",
    [
      407267
    ]
  ],
  "./sv/courses.show.json": [
    "711224",
    [
      731191
    ]
  ],
  "./el/CommentLibrary.json": [
    "728689",
    [
      396883
    ]
  ],
  "./it/custom_help_link.json": [
    "688925",
    [
      402167
    ]
  ],
  "./nl/quizzes_regrade_modal.json": [
    "613708",
    [
      294688
    ]
  ],
  "./nn/react_collaborations.json": [
    "864972",
    [
      808648
    ]
  ],
  "./sl/OutcomeDescriptionModal.json": [
    "86062",
    [
      92642
    ]
  ],
  "./sv/copy_warnings_modal.json": [
    "760622",
    [
      912250
    ]
  ],
  "./is/choose_mastery_path.json": [
    "676057",
    [
      457423
    ]
  ],
  "./nb-x-k12/overview_page.json": [
    "653595",
    [
      12505
    ]
  ],
  "./ht/assignments.json": [
    "687556",
    [
      301984
    ]
  ],
  "./ca/assignments_2_submission_helpers.json": [
    "417948",
    [
      314324
    ]
  ],
  "./nb/submit_online_url_assignment.json": [
    "446086",
    [
      705386
    ]
  ],
  "./th/course_paces_projected_dates.json": [
    "263429",
    [
      823871
    ]
  ],
  "./is/peer_review_allocation_rules_tray.json": [
    "33519",
    [
      463717
    ]
  ],
  "./nn/course_paces_change_tracking.json": [
    "794307",
    [
      831333
    ]
  ],
  "./sl/outcomes_user_outcome_results.json": [
    "193442",
    [
      155182
    ]
  ],
  "./cy/calendar_custom_recurring_event_repeat_picker.json": [
    "476372",
    [
      752620
    ]
  ],
  "./hu/jobs_v2.json": [
    "588836",
    [
      71964
    ]
  ],
  "./en-GB-x-ukhe/assignment_grade_summary.json": [
    "248054",
    [
      108894
    ]
  ],
  "./it/important_dates.json": [
    "129315",
    [
      20525
    ]
  ],
  "./hy/announcements_v2.json": [
    "542650",
    [
      332986
    ]
  ],
  "./vi/add_edit_pseudonym.json": [
    "642320",
    [
      928504
    ]
  ],
  "./en-GB-x-ukhe/speed_grader_helpers.json": [
    "75273",
    [
      907407
    ]
  ],
  "./nl/course_paces_search.json": [
    "392603",
    [
      376661
    ]
  ],
  "./fi/login.json": [
    "190006",
    [
      253342
    ]
  ],
  "./id/user_date_range_search.json": [
    "411398",
    [
      466666
    ]
  ],
  "./ca/not_found_page_slide_puzzle.json": [
    "382089",
    [
      46727
    ]
  ],
  "./en-GB/auth_logging.json": [
    "814889",
    [
      994508
    ]
  ],
  "./uk/moderate_quiz.json": [
    "619057",
    [
      788223
    ]
  ],
  "./he/gradebook_history.json": [
    "338860",
    [
      548340
    ]
  ],
  "./ar/blueprint_settingsAssociationsTable.json": [
    "439346",
    [
      538510
    ]
  ],
  "./hy/quizzes_public.json": [
    "110380",
    [
      549948
    ]
  ],
  "./ca/LogoutButton.json": [
    "611800",
    [
      914904
    ]
  ],
  "./fa/registration.json": [
    "82360",
    [
      689824
    ]
  ],
  "./en-GB-x-ukhe/permissions_role_tray.json": [
    "757942",
    [
      608862
    ]
  ],
  "./pl/discussion_topics_edit.json": [
    "157624",
    [
      669724
    ]
  ],
  "./vi/custom_help_link.json": [
    "14221",
    [
      608923
    ]
  ],
  "./ga/moderate_quiz.json": [
    "96677",
    [
      474147
    ]
  ],
  "./nb-x-k12/assignment_2_assignment_toggle_details.json": [
    "215408",
    [
      921384
    ]
  ],
  "./ja/pseudonyms_mobile_login.json": [
    "134687",
    [
      542818
    ]
  ],
  "./zh-Hant/quizzes_openModerateStudentDialog.json": [
    "268878",
    [
      1922
    ]
  ],
  "./zh-Hant/dashboard_grading_period_select.json": [
    "990078",
    [
      325818
    ]
  ],
  "./ga/theme_collection_view.json": [
    "486236",
    [
      782716
    ]
  ],
  "./fi/available_pronouns_list.json": [
    "59610",
    [
      942746
    ]
  ],
  "./fr/upload_button.json": [
    "970516",
    [
      741845
    ]
  ],
  "./it/terms_of_service_modal.json": [
    "254282",
    [
      237118
    ]
  ],
  "./nn/restore_content_pane.json": [
    "843281",
    [
      313043
    ]
  ],
  "./da/quizzes_quiz_submission.json": [
    "385769",
    [
      758535
    ]
  ],
  "./de/last_attended.json": [
    "368317",
    [
      217036
    ]
  ],
  "./el/discussion_topics.json": [
    "427194",
    [
      710702
    ]
  ],
  "./ru/self_unenrollment_modal.json": [
    "379057",
    [
      649335
    ]
  ],
  "./zh-Hant/not_found_page_slide_puzzle.json": [
    "259103",
    [
      511569
    ]
  ],
  "./ca/grades_empty_page.json": [
    "493046",
    [
      746726
    ]
  ],
  "./hi/restore_content_pane.json": [
    "102600",
    [
      706512
    ]
  ],
  "./ko/eportfolio.json": [
    "227377",
    [
      20895
    ]
  ],
  "./nb/course_search_results.json": [
    "831629",
    [
      851991
    ]
  ],
  "./ca/upload_button.json": [
    "857604",
    [
      401516
    ]
  ],
  "./en-AU-x-unimelb/assignments_bulk_edit.json": [
    "80162",
    [
      419886
    ]
  ],
  "./es/context_modules_v2.json": [
    "207828",
    [
      469025
    ]
  ],
  "./it/widget_dashboard.json": [
    "641370",
    [
      961198
    ]
  ],
  "./de/gradingGradeSummary.json": [
    "553924",
    [
      991353
    ]
  ],
  "./tr/quizzes_openModerateStudentDialog.json": [
    "315502",
    [
      63378
    ]
  ],
  "./zh-Hans/account_calendar_settings_account_group.json": [
    "759807",
    [
      875621
    ]
  ],
  "./hi/add_edit_pseudonym.json": [
    "606442",
    [
      41802
    ]
  ],
  "./ar/course_restore.json": [
    "253847",
    [
      282417
    ]
  ],
  "./ca/course_paces_empty_state.json": [
    "843424",
    [
      706352
    ]
  ],
  "./sv/blueprint_course_child.json": [
    "910381",
    [
      622191
    ]
  ],
  "./nn/link_to_students.json": [
    "851707",
    [
      223061
    ]
  ],
  "./hu/react_files.json": [
    "121038",
    [
      224638
    ]
  ],
  "./en-GB-x-lbs/calculator.json": [
    "993288",
    [
      859968
    ]
  ],
  "./fi/assignments_2_MoreOptions_CanvasFiles.json": [
    "702914",
    [
      419778
    ]
  ],
  "./en-GB-x-ukhe/rate_limiting_settings.json": [
    "571906",
    [
      210482
    ]
  ],
  "./zh-Hant/HelpTray.json": [
    "676771",
    [
      47581
    ]
  ],
  "./nb/editGroup.json": [
    "433165",
    [
      996439
    ]
  ],
  "./fr/GroupDetailView.json": [
    "28521",
    [
      668668
    ]
  ],
  "./es/learning_mastery_gradebook.json": [
    "266623",
    [
      129906
    ]
  ],
  "./ht/course_paces_blackout_date_row.json": [
    "340838",
    [
      139498
    ]
  ],
  "./sv-x-k12/entity_search_form.json": [
    "456644",
    [
      324932
    ]
  ],
  "./nb/course_default_due_time.json": [
    "646992",
    [
      843844
    ]
  ],
  "./en-GB-x-ukhe/assignments_bulk_edit.json": [
    "652360",
    [
      399120
    ]
  ],
  "./da/content_copy_redesign.json": [
    "495170",
    [
      882762
    ]
  ],
  "./pl/youtube_migration.json": [
    "647460",
    [
      695880
    ]
  ],
  "./ht/announcements_on_home_page.json": [
    "705594",
    [
      528206
    ]
  ],
  "./da/permissions_role_tray_table_row.json": [
    "382119",
    [
      282053
    ]
  ],
  "./ru/appt_calendar_event_dialog.json": [
    "236845",
    [
      644763
    ]
  ],
  "./ru/external_content_cancel.json": [
    "678843",
    [
      336441
    ]
  ],
  "./en-GB-x-ukhe/roster_section_input.json": [
    "256912",
    [
      111752
    ]
  ],
  "./fr/wiki_page_index.json": [
    "477891",
    [
      967810
    ]
  ],
  "./da-x-k12/course_search_results.json": [
    "659772",
    [
      910896
    ]
  ],
  "./it/a2_AccessibleTipContent.json": [
    "269995",
    [
      589573
    ]
  ],
  "./fr-CA/wiki_page_index.json": [
    "126790",
    [
      318138
    ]
  ],
  "./pl/blueprint_settingsAssociationsTable.json": [
    "839269",
    [
      347231
    ]
  ],
  "./ko/SpeedGraderDiscussionsNavigation.json": [
    "488507",
    [
      597329
    ]
  ],
  "./da-x-k12/a2LatePolicyStatusDisplay.json": [
    "366580",
    [
      962408
    ]
  ],
  "./de/assignment_2_assignment_toggle_details.json": [
    "770155",
    [
      426174
    ]
  ],
  "./fr-CA/discussion_settings.json": [
    "921923",
    [
      508125
    ]
  ],
  "./nl/peer-review-assignment-widget.json": [
    "296254",
    [
      52858
    ]
  ],
  "./en-CA.eager.json": [
    "251027",
    [
      450398
    ]
  ],
  "./ga/react_collaborations.json": [
    "448588",
    [
      77580
    ]
  ],
  "./pt-BR/course_link_validator.json": [
    "394792",
    [
      57141
    ]
  ],
  "./sl/discussion_topics_edit.json": [
    "349677",
    [
      243727
    ]
  ],
  "./sv-x-k12/outcome_detail.json": [
    "241863",
    [
      548445
    ]
  ],
  "./hi/content_copy_redesign.json": [
    "910414",
    [
      833254
    ]
  ],
  "./cy/courses.json": [
    "577244",
    [
      399300
    ]
  ],
  "./fr/CreateEditAssignmentModal.json": [
    "468160",
    [
      746489
    ]
  ],
  "./id/copy_warnings_modal.json": [
    "307802",
    [
      224854
    ]
  ],
  "./nb/modules_page_icon_legend.json": [
    "173287",
    [
      563465
    ]
  ],
  "./zh-Hant/AlignmentSummary.json": [
    "715391",
    [
      800297
    ]
  ],
  "./pt/accessibility_scan.json": [
    "838594",
    [
      937342
    ]
  ],
  "./sl/permissions.json": [
    "701013",
    [
      173287
    ]
  ],
  "./da/peer_reviews_student.json": [
    "251733",
    [
      198955
    ]
  ],
  "./fi/course_link_validator.json": [
    "533848",
    [
      325424
    ]
  ],
  "./zh-Hans/unpublished_changes_button_props.json": [
    "56384",
    [
      341704
    ]
  ],
  "./es-ES/quiz_show.json": [
    "606136",
    [
      25552
    ]
  ],
  "./fr/announcements_on_home_page.json": [
    "583570",
    [
      689351
    ]
  ],
  "./ar/todo.json": [
    "922719",
    [
      425033
    ]
  ],
  "./ko/custom_emoji_deny_list.json": [
    "103950",
    [
      207118
    ]
  ],
  "./de/grades_empty_page.json": [
    "372961",
    [
      250952
    ]
  ],
  "./it/media_player_iframe_content.json": [
    "201096",
    [
      470460
    ]
  ],
  "./ja/license_help.json": [
    "592750",
    [
      519695
    ]
  ],
  "./uk/edit_section_end_date.json": [
    "308189",
    [
      503075
    ]
  ],
  "./nb-x-k12/course_restore.json": [
    "879176",
    [
      449312
    ]
  ],
  "./es/course_paces_flaggable_number_input.json": [
    "137615",
    [
      208546
    ]
  ],
  "./is/react_files.json": [
    "105849",
    [
      875327
    ]
  ],
  "./mi/content_exports.json": [
    "745933",
    [
      59299
    ]
  ],
  "./nl/module_student_view_peer_reviews.json": [
    "252059",
    [
      340333
    ]
  ],
  "./en-GB/k5_course.json": [
    "373991",
    [
      571830
    ]
  ],
  "./es-ES/edit_section_view.json": [
    "442132",
    [
      836285
    ]
  ],
  "./hu/grades_summary.json": [
    "501408",
    [
      531776
    ]
  ],
  "./fr/submissions_show_preview.json": [
    "536282",
    [
      549615
    ]
  ],
  "./sv/editGroup.json": [
    "649156",
    [
      300288
    ]
  ],
  "./mi/discussion_topics.json": [
    "403077",
    [
      119307
    ]
  ],
  "./pt/course_paces_flaggable_number_input.json": [
    "398263",
    [
      735505
    ]
  ],
  "./en-GB-x-lbs/LogoutButton.json": [
    "395530",
    [
      70746
    ]
  ],
  "./ru/ai_experiences_edit.json": [
    "216158",
    [
      243030
    ]
  ],
  "./zh-Hans/discovery_page.json": [
    "392307",
    [
      322033
    ]
  ],
  "./hu/FindOutcomesModal.json": [
    "440354",
    [
      544442
    ]
  ],
  "./de/content_migrations_redesign.json": [
    "784778",
    [
      931643
    ]
  ],
  "./da/theme_editor.json": [
    "277172",
    [
      714172
    ]
  ],
  "./ja/appt_calendar_event_dialog.json": [
    "863817",
    [
      343624
    ]
  ],
  "./ja/course_paces_pace_picker.json": [
    "259126",
    [
      513079
    ]
  ],
  "./pt/course_paces_time_selection.json": [
    "158529",
    [
      12771
    ]
  ],
  "./nb-x-k12/youtube_migration.json": [
    "734754",
    [
      624258
    ]
  ],
  "./pt-BR/account_calendars_results_area.json": [
    "869451",
    [
      113054
    ]
  ],
  "./hi/blueprint_settingsSyncChange.json": [
    "737229",
    [
      985931
    ]
  ],
  "./en-GB-x-ukhe/user_name.json": [
    "735383",
    [
      757725
    ]
  ],
  "./is/external_content_cancel.json": [
    "825766",
    [
      978382
    ]
  ],
  "./nn/content_copy_redesign.json": [
    "669333",
    [
      994855
    ]
  ],
  "./fi/outcome_alignment_v2.json": [
    "244054",
    [
      799630
    ]
  ],
  "./pt-BR/account_calendar_settings_account_list.json": [
    "36918",
    [
      109039
    ]
  ],
  "./pt-BR/collaborations.json": [
    "882775",
    [
      854210
    ]
  ],
  "./nb/OutcomeDescriptionModal.json": [
    "54341",
    [
      261159
    ]
  ],
  "./da/todo.json": [
    "840683",
    [
      380161
    ]
  ],
  "./nn/edit_section_view.json": [
    "596638",
    [
      693818
    ]
  ],
  "./zh-Hans/user_logins.json": [
    "442767",
    [
      204693
    ]
  ],
  "./pt-BR/admin_split.json": [
    "125375",
    [
      580042
    ]
  ],
  "./sv-x-k12/user_logins.json": [
    "13575",
    [
      408029
    ]
  ],
  "./it/jobs.json": [
    "157977",
    [
      797523
    ]
  ],
  "./da-x-k12/assignments_2_student_points_display.json": [
    "769839",
    [
      367417
    ]
  ],
  "./hu/course_paces_blackout_date_row.json": [
    "64643",
    [
      383801
    ]
  ],
  "./hy/edit_section_view.json": [
    "102697",
    [
      560511
    ]
  ],
  "./ar/account_calendar_settings_utils.json": [
    "134237",
    [
      447343
    ]
  ],
  "./ko/important_dates_empty.json": [
    "755958",
    [
      127174
    ]
  ],
  "./sl/course_paces_modal.json": [
    "335371",
    [
      13173
    ]
  ],
  "./pt-BR/bulk_edit_students_table.json": [
    "150812",
    [
      430161
    ]
  ],
  "./nb-x-k12/lti_registrations.json": [
    "596578",
    [
      216690
    ]
  ],
  "./hy/webzip_export.json": [
    "734693",
    [
      582643
    ]
  ],
  "./da/HelpTray.json": [
    "916936",
    [
      788904
    ]
  ],
  "./fr-CA/account_calendar_settings_account_list.json": [
    "224898",
    [
      44558
    ]
  ],
  "./da-x-k12/user_logins.json": [
    "141597",
    [
      542519
    ]
  ],
  "./hy/pairing_code_user_observees.json": [
    "814364",
    [
      626652
    ]
  ],
  "./nl/question_bank.json": [
    "236627",
    [
      760397
    ]
  ],
  "./ca/k5_course.json": [
    "144198",
    [
      352566
    ]
  ],
  "./ht/a2LatePolicyStatusDisplay.json": [
    "857325",
    [
      329255
    ]
  ],
  "./vi/copy_course.json": [
    "499788",
    [
      684060
    ]
  ],
  "./hi/dashboard_grades_page.json": [
    "167332",
    [
      15700
    ]
  ],
  "./en-GB-x-ukhe/gradinggradingPeriodCollection.json": [
    "240617",
    [
      252847
    ]
  ],
  "./el/grades_summary.json": [
    "853562",
    [
      225350
    ]
  ],
  "./nb/job_stats.json": [
    "866937",
    [
      87723
    ]
  ],
  "./ko/ldap_cert_upload.json": [
    "630400",
    [
      158832
    ]
  ],
  "./es-ES/users.json": [
    "673395",
    [
      578241
    ]
  ],
  "./hi/gradebook_history.json": [
    "345784",
    [
      9440
    ]
  ],
  "./de/webzip_export.json": [
    "556893",
    [
      693612
    ]
  ],
  "./ga/calendar_custom_recurring_event_repeat_picker.json": [
    "641856",
    [
      518728
    ]
  ],
  "./el/blueprint_settingsAssociationsTable.json": [
    "218660",
    [
      899936
    ]
  ],
  "./ko/modelsQuiz.json": [
    "777943",
    [
      386869
    ]
  ],
  "./hi/quiz_migration_notifications.json": [
    "627234",
    [
      403714
    ]
  ],
  "./it/discussionTopicKeyboradShortcutModal.json": [
    "962390",
    [
      597922
    ]
  ],
  "./sv-x-k12/HelpTray.json": [
    "584132",
    [
      219828
    ]
  ],
  "./zh-Hans/theme_collection_view.json": [
    "249379",
    [
      234670
    ]
  ],
  "./ar/link_validator.json": [
    "636606",
    [
      294986
    ]
  ],
  "./ms/copy_warnings_modal.json": [
    "757783",
    [
      227749
    ]
  ],
  "./es/AccountsTray.json": [
    "603690",
    [
      19651
    ]
  ],
  "./fi/SpeedGraderCheckpoints.json": [
    "610022",
    [
      309518
    ]
  ],
  "./fa/assignments_2_submission_histories_query.json": [
    "85305",
    [
      672159
    ]
  ],
  "./th/assignments_2_initial_query.json": [
    "452866",
    [
      739423
    ]
  ],
  "./vi/course_pace_date_input.json": [
    "569760",
    [
      593752
    ]
  ],
  "./zh-Hant/link_to_students.json": [
    "509493",
    [
      629191
    ]
  ],
  "./da/account_calendars.json": [
    "88226",
    [
      119146
    ]
  ],
  "./es-ES/youtube_migration.json": [
    "976873",
    [
      475119
    ]
  ],
  "./ko/assignment_2_assignment_toggle_details.json": [
    "489455",
    [
      245300
    ]
  ],
  "./fr/course_paces_blackout_dates_modal.json": [
    "453024",
    [
      119857
    ]
  ],
  "./nb-x-k12/calculator.json": [
    "37524",
    [
      95540
    ]
  ],
  "./id/AlignmentSummary.json": [
    "81558",
    [
      751754
    ]
  ],
  "./ru/suppress_notifications.json": [
    "864569",
    [
      835759
    ]
  ],
  "./is/CoursesTray.json": [
    "659160",
    [
      68432
    ]
  ],
  "./cy/user_lists.json": [
    "223955",
    [
      839561
    ]
  ],
  "./fa/course_paces_modal.json": [
    "981929",
    [
      682799
    ]
  ],
  "./he/authentication_providers.json": [
    "725222",
    [
      879238
    ]
  ],
  "./fr-CA/assignments_2_shared_Steps.json": [
    "150252",
    [
      113848
    ]
  ],
  "./ko/course_paces_errors.json": [
    "395267",
    [
      396000
    ]
  ],
  "./nl/content_migrations_redesign.json": [
    "713379",
    [
      36725
    ]
  ],
  "./th/module_sequence_footer.json": [
    "497764",
    [
      788120
    ]
  ],
  "./ja/rubrics-export.json": [
    "969302",
    [
      574807
    ]
  ],
  "./sv-x-k12/assignments_bulk_edit.json": [
    "375697",
    [
      826263
    ]
  ],
  "./hu/grade_summaryGroupView.json": [
    "427001",
    [
      953479
    ]
  ],
  "./hy/terms_of_service_modal.json": [
    "323568",
    [
      655400
    ]
  ],
  "./mi/CreateEditAssignmentModalAdapter.json": [
    "288345",
    [
      770087
    ]
  ],
  "./nb-x-k12/media_immersive_view.json": [
    "719504",
    [
      661624
    ]
  ],
  "./tr/internal-settings.json": [
    "714649",
    [
      294595
    ]
  ],
  "./nb-x-k12/peer-review-assignment-widget.json": [
    "548330",
    [
      104106
    ]
  ],
  "./pt/assignments_2_submission_helpers.json": [
    "851980",
    [
      616963
    ]
  ],
  "./cy/blueprint_course_child.json": [
    "239910",
    [
      45254
    ]
  ],
  "./mi/modules_home_page.json": [
    "495549",
    [
      830451
    ]
  ],
  "./nb/k5_course.json": [
    "484126",
    [
      134650
    ]
  ],
  "./en-GB-x-lbs/registration.json": [
    "982133",
    [
      12467
    ]
  ],
  "./en-AU-x-unimelb/todo.json": [
    "474286",
    [
      713874
    ]
  ],
  "./da/module_sequence_footer.json": [
    "143869",
    [
      716707
    ]
  ],
  "./nb/assignments.no_assignments_search.json": [
    "891581",
    [
      189122
    ]
  ],
  "./es-ES/quizzes.take_quiz.json": [
    "457357",
    [
      440122
    ]
  ],
  "./ja/conferences.json": [
    "361804",
    [
      380361
    ]
  ],
  "./de/blueprint_course_sidebar.json": [
    "11077",
    [
      379940
    ]
  ],
  "./de/discussion_topics.json": [
    "403496",
    [
      82821
    ]
  ],
  "./de/grades_summary.json": [
    "672052",
    [
      888201
    ]
  ],
  "./da/eportfolio.json": [
    "767758",
    [
      234830
    ]
  ],
  "./ja/gradebookOutcomeGradebookView.json": [
    "239866",
    [
      12003
    ]
  ],
  "./id/course_paces_blueprint_lock.json": [
    "349335",
    [
      31761
    ]
  ],
  "./fa/sections_tooltip.json": [
    "189321",
    [
      19215
    ]
  ],
  "./is/permission_button.json": [
    "386262",
    [
      328030
    ]
  ],
  "./hi/jobs_v2.json": [
    "241816",
    [
      720400
    ]
  ],
  "./fa/course_search_results.json": [
    "580144",
    [
      441288
    ]
  ],
  "./hu/roster_publicjs.json": [
    "787111",
    [
      972597
    ]
  ],
  "./id/appointment_groups.json": [
    "862871",
    [
      84097
    ]
  ],
  "./pl/assignments_2_initial_query.json": [
    "668141",
    [
      490007
    ]
  ],
  "./ja/outcome_reporting.json": [
    "313578",
    [
      197971
    ]
  ],
  "./ko/peer_review_student_select.json": [
    "548130",
    [
      48362
    ]
  ],
  "./uk/account_settings_jsx_bundle.json": [
    "168790",
    [
      537606
    ]
  ],
  "./el/MoveOutcomesModal.json": [
    "622250",
    [
      938006
    ]
  ],
  "./hi/assignments.json": [
    "157143",
    [
      56125
    ]
  ],
  "./cy/youtube_migration.json": [
    "825332",
    [
      897132
    ]
  ],
  "./en-GB-x-ukhe/add_edit_pseudonym.json": [
    "487853",
    [
      250059
    ]
  ],
  "./es/assignments_bulk_edit.json": [
    "609930",
    [
      895043
    ]
  ],
  "./en-AU-x-unimelb/blueprint_settingsCoursePicker.json": [
    "820508",
    [
      96272
    ]
  ],
  "./th/manage_avatars.json": [
    "728568",
    [
      402940
    ]
  ],
  "./it/ai_experiences_ai_conversations.json": [
    "662611",
    [
      686909
    ]
  ],
  "./ms/blueprint_settingsCoursePicker.json": [
    "2940",
    [
      654916
    ]
  ],
  "./sl/calculator_command.json": [
    "570309",
    [
      623815
    ]
  ],
  "./id/reset_pace_warning_modal.json": [
    "358387",
    [
      874517
    ]
  ],
  "./de/ai_experiences_show.json": [
    "574009",
    [
      919232
    ]
  ],
  "./ar/not_found_page_slide_puzzle.json": [
    "701658",
    [
      479110
    ]
  ],
  "./de/submit_assignment.json": [
    "156541",
    [
      250476
    ]
  ],
  "./da-x-k12/user_name.json": [
    "466128",
    [
      56764
    ]
  ],
  "./mi/self_enrollment.json": [
    "428851",
    [
      932745
    ]
  ],
  "./nl/account_calendar_settings_account_group.json": [
    "150454",
    [
      435186
    ]
  ],
  "./is/calendar_sidebar.json": [
    "451479",
    [
      650749
    ]
  ],
  "./hu/calendar_sidebar.json": [
    "691122",
    [
      326730
    ]
  ],
  "./zh-Hans/peer-review-assignment-widget.json": [
    "111795",
    [
      773617
    ]
  ],
  "./da-x-k12/file_not_found.json": [
    "118002",
    [
      235926
    ]
  ],
  "./is/keyboardShortcutModal.json": [
    "843414",
    [
      404529
    ]
  ],
  "./nl/account_calendars_results_area.json": [
    "175466",
    [
      431302
    ]
  ],
  "./pt/assignment_2_assignment_toggle_details.json": [
    "153462",
    [
      89474
    ]
  ],
  "./cy/content_share_preview_overlay.json": [
    "629407",
    [
      540957
    ]
  ],
  "./de/content_copy_redesign.json": [
    "244630",
    [
      666671
    ]
  ],
  "./it/OutcomeMoveModal.json": [
    "997947",
    [
      764197
    ]
  ],
  "./nl/rate_limiting_settings.json": [
    "564442",
    [
      700582
    ]
  ],
  "./pl/calculator_command.json": [
    "259308",
    [
      454536
    ]
  ],
  "./fi/assignments_bulk_edit_use_save_assignment.json": [
    "17479",
    [
      106493
    ]
  ],
  "./nn/webzip_export.json": [
    "903362",
    [
      591558
    ]
  ],
  "./fr/user_name.json": [
    "563449",
    [
      345964
    ]
  ],
  "./ga/modules_page_icon_legend.json": [
    "570467",
    [
      745025
    ]
  ],
  "./fa/assignments_2_shared_Steps.json": [
    "493960",
    [
      3536
    ]
  ],
  "./hu/keyboardShortcutModal.json": [
    "704105",
    [
      182231
    ]
  ],
  "./da-x-k12/account_settings.json": [
    "394224",
    [
      230932
    ]
  ],
  "./id/canvas_file_upload.json": [
    "257680",
    [
      14412
    ]
  ],
  "./cy/ai_experiences.json": [
    "752274",
    [
      632810
    ]
  ],
  "./en-GB-x-ukhe/link_to_students.json": [
    "350833",
    [
      861927
    ]
  ],
  "./el/permissions_v2_add_tray.json": [
    "627373",
    [
      652399
    ]
  ],
  "./sl/custom_help_link.json": [
    "995087",
    [
      448145
    ]
  ],
  "./vi/discussion_topics.json": [
    "483606",
    [
      326990
    ]
  ],
  "./nb-x-k12/AssignmentListItemView.json": [
    "242803",
    [
      313598
    ]
  ],
  "./ca/grades_summary.json": [
    "585589",
    [
      310955
    ]
  ],
  "./pl/course_paces_search.json": [
    "918617",
    [
      277363
    ]
  ],
  "./ar/lti_registration.wizard.json": [
    "851123",
    [
      392082
    ]
  ],
  "./en-CA/accessibility_checker.json": [
    "413902",
    [
      201254
    ]
  ],
  "./da/account_calendar_settings_account_group.json": [
    "84491",
    [
      448801
    ]
  ],
  "./el/assignmentsToggleShowByView.json": [
    "6044",
    [
      683040
    ]
  ],
  "./uk/blueprint_settingsMigrationSync.json": [
    "846750",
    [
      293822
    ]
  ],
  "./zh-Hans/discussion_pinned_post.json": [
    "881513",
    [
      575103
    ]
  ],
  "./el/quizzes_public.json": [
    "932090",
    [
      631062
    ]
  ],
  "./fi/appt_calendar_event_dialog.json": [
    "758893",
    [
      82027
    ]
  ],
  "./nl/blueprint_settingsCoursePickerTable.json": [
    "257590",
    [
      682610
    ]
  ],
  "./en-GB-x-lbs/unpublished_warning_modal.json": [
    "956962",
    [
      954722
    ]
  ],
  "./es/bounced_emails.json": [
    "755502",
    [
      556575
    ]
  ],
  "./en-GB/discussionTopicKeyboradShortcutModal.json": [
    "930658",
    [
      575151
    ]
  ],
  "./uk/gradingGradeSummary.json": [
    "719015",
    [
      89829
    ]
  ],
  "./nb-x-k12/appointment_groups.json": [
    "712529",
    [
      680086
    ]
  ],
  "./ko/lti_registrations.json": [
    "807518",
    [
      160926
    ]
  ],
  "./es/empty_modules.json": [
    "573973",
    [
      240732
    ]
  ],
  "./en-AU/course_paces_projected_dates.json": [
    "128595",
    [
      702478
    ]
  ],
  "./nb-x-k12/student_annotation_preview.json": [
    "820502",
    [
      908782
    ]
  ],
  "./ms/accessibility_course_statistics.json": [
    "914284",
    [
      751175
    ]
  ],
  "./sv/LearningMasteryGradebook.json": [
    "880322",
    [
      79182
    ]
  ],
  "./fr/internal-settings.json": [
    "686875",
    [
      862338
    ]
  ],
  "./sv-x-k12/a2LatePolicyStatusDisplay.json": [
    "562874",
    [
      286714
    ]
  ],
  "./en-GB-x-lbs/peer_review_configuration_tray.json": [
    "940829",
    [
      685979
    ]
  ],
  "./fr/assignments_peer_reviews_student.json": [
    "517363",
    [
      11154
    ]
  ],
  "./nb/jobs_v2.json": [
    "222211",
    [
      956517
    ]
  ],
  "./da/k5_course.json": [
    "14513",
    [
      968479
    ]
  ],
  "./ar/ignite_agent.json": [
    "860007",
    [
      776681
    ]
  ],
  "./de/course_paces_empty_state.json": [
    "929137",
    [
      326248
    ]
  ],
  "./en-GB-x-ukhe/learning_mastery_gradebook.json": [
    "175201",
    [
      303847
    ]
  ],
  "./de/custom_help_link.json": [
    "472191",
    [
      281274
    ]
  ],
  "./fa/GroupDetailView.json": [
    "789304",
    [
      221776
    ]
  ],
  "./ht/grade_details.json": [
    "569524",
    [
      623232
    ]
  ],
  "./nb-x-k12/blueprint_settingsCourseFilter.json": [
    "155982",
    [
      463238
    ]
  ],
  "./id/theme_collection_view.json": [
    "74045",
    [
      94591
    ]
  ],
  "./pt-BR/LearningMasteryGradebook.json": [
    "686902",
    [
      829215
    ]
  ],
  "./id/speed_grader_helpers.json": [
    "223752",
    [
      251412
    ]
  ],
  "./fr-CA/quizzes.take_quiz.json": [
    "745041",
    [
      687242
    ]
  ],
  "./en-GB-x-ukhe/announcements_on_home_page.json": [
    "962876",
    [
      159708
    ]
  ],
  "./mi/module_student_view_peer_reviews.json": [
    "856703",
    [
      288541
    ]
  ],
  "./id/important_dates_empty.json": [
    "375985",
    [
      55299
    ]
  ],
  "./es/assignments.never_drop.json": [
    "683668",
    [
      912353
    ]
  ],
  "./fi/video_conference.json": [
    "702367",
    [
      900629
    ]
  ],
  "./ko/assignments_2_MoreOptions.json": [
    "180377",
    [
      678391
    ]
  ],
  "./fr/folder_tree.json": [
    "733531",
    [
      822677
    ]
  ],
  "./ru/copy_course.json": [
    "753052",
    [
      387708
    ]
  ],
  "./sl/not_found_page_slide_puzzle.json": [
    "883810",
    [
      115270
    ]
  ],
  "./el/lti_registration.wizard.json": [
    "175777",
    [
      601996
    ]
  ],
  "./da/account_settings.json": [
    "583658",
    [
      699778
    ]
  ],
  "./sv-x-k12/outcome_reporting.json": [
    "570884",
    [
      995716
    ]
  ],
  "./th/account_calendar_settings_account_group.json": [
    "631264",
    [
      636852
    ]
  ],
  "./pl/k5_course.json": [
    "748110",
    [
      545194
    ]
  ],
  "./mi/course_paces_flaggable_number_input.json": [
    "983785",
    [
      59575
    ]
  ],
  "./sv-x-k12/LogoutButton.json": [
    "265985",
    [
      883287
    ]
  ],
  "./fa/rate_limiting_settings.json": [
    "314275",
    [
      139889
    ]
  ],
  "./fi/blueprint_settingsMigrationOptions.json": [
    "261078",
    [
      565374
    ]
  ],
  "./hy/quizzes.take_quiz.json": [
    "83483",
    [
      958156
    ]
  ],
  "./fr-CA/bulk_edit_students_table.json": [
    "553336",
    [
      498332
    ]
  ],
  "./nb-x-k12/course_paces_pace_picker.json": [
    "103439",
    [
      77221
    ]
  ],
  "./zh-Hant/course_pace_date_input.json": [
    "110089",
    [
      705291
    ]
  ],
  "./pt/course_paces_search.json": [
    "326065",
    [
      850171
    ]
  ],
  "./fr-CA/SpeedGraderDiscussionsNavigation.json": [
    "273554",
    [
      173574
    ]
  ],
  "./ko/outcomes_user_outcome_results.json": [
    "115883",
    [
      853505
    ]
  ],
  "./ar/calendar_appointment_group_edit.json": [
    "996796",
    [
      749960
    ]
  ],
  "./en-GB-x-ukhe/assignments_2_student_points_display.json": [
    "630186",
    [
      791290
    ]
  ],
  "./en-AU/peer_review_allocation_rule_card.json": [
    "445470",
    [
      151711
    ]
  ],
  "./es/users.json": [
    "297982",
    [
      717423
    ]
  ],
  "./id/roster_section_input.json": [
    "697881",
    [
      541435
    ]
  ],
  "./nl/confirmMasteryModal.json": [
    "858642",
    [
      607086
    ]
  ],
  "./vi/authentication_providers.json": [
    "111060",
    [
      894708
    ]
  ],
  "./da/context_prior_users.json": [
    "829966",
    [
      472718
    ]
  ],
  "./zh-Hans/course_paces_change_tracking.json": [
    "919050",
    [
      46954
    ]
  ],
  "./de/assignments_2_student_header.json": [
    "477378",
    [
      926995
    ]
  ],
  "./nb/quizzes.take_quiz.json": [
    "97268",
    [
      78357
    ]
  ],
  "./zh-Hans/conversations_2.json": [
    "303096",
    [
      479008
    ]
  ],
  "./id/CreateEditAssignmentModalAdapter.json": [
    "425788",
    [
      826512
    ]
  ],
  "./ru/account_calendar_settings.json": [
    "881477",
    [
      109955
    ]
  ],
  "./cy/assignments_2_external_tool.json": [
    "749036",
    [
      390612
    ]
  ],
  "./cy/last_attended.json": [
    "937046",
    [
      609174
    ]
  ],
  "./da-x-k12/AssignmentGroupListItemView.json": [
    "756309",
    [
      272127
    ]
  ],
  "./sl/CreateEditAssignmentModalAdapter.json": [
    "25630",
    [
      864698
    ]
  ],
  "./vi/account_calendar_settings_account_calendar_item.json": [
    "759850",
    [
      951338
    ]
  ],
  "./sv/assignments_2_student_header_date_title.json": [
    "655760",
    [
      543884
    ]
  ],
  "./ja/account_calendar_settings_account_list.json": [
    "484978",
    [
      269659
    ]
  ],
  "./es-ES/assignment_show.json": [
    "561892",
    [
      832516
    ]
  ],
  "./el/jobs_v2.json": [
    "638686",
    [
      683290
    ]
  ],
  "./fa/HelpTray.json": [
    "936650",
    [
      666330
    ]
  ],
  "./zh-Hant/gradebookActionMenu.json": [
    "316571",
    [
      981941
    ]
  ],
  "./sv/collaborations.json": [
    "725827",
    [
      793181
    ]
  ],
  "./en-AU-x-unimelb/discussion_posts.json": [
    "808418",
    [
      645910
    ]
  ],
  "./ko/outcome_detail.json": [
    "436520",
    [
      520904
    ]
  ],
  "./pt-BR/rootFoldersFinder.json": [
    "412842",
    [
      674843
    ]
  ],
  "./de/pseudonyms_mobile_login.json": [
    "745265",
    [
      761560
    ]
  ],
  "./hi/folder_tree.json": [
    "636892",
    [
      552460
    ]
  ],
  "./cy/module_sequence_footer.json": [
    "135052",
    [
      944852
    ]
  ],
  "./he/SpeedGraderSettingsMenu.json": [
    "468531",
    [
      380457
    ]
  ],
  "./en-GB-x-ukhe/user_logins.json": [
    "381106",
    [
      249186
    ]
  ],
  "./ms/job_stats.json": [
    "901441",
    [
      727071
    ]
  ],
  "./ms/sharedSetDefaultGradeDialog.json": [
    "29569",
    [
      924895
    ]
  ],
  "./de/wiki_page_index.json": [
    "646908",
    [
      816993
    ]
  ],
  "./es-ES/dashboard_grading_period_select.json": [
    "970193",
    [
      132263
    ]
  ],
  "./en-GB-x-ukhe/section.json": [
    "481647",
    [
      586917
    ]
  ],
  "./pt-BR/roster_publicjs.json": [
    "286421",
    [
      601668
    ]
  ],
  "./he/FindOutcomesModal.json": [
    "307218",
    [
      534250
    ]
  ],
  "./es/course_stats.json": [
    "898051",
    [
      891022
    ]
  ],
  "./fr-CA/content_migrations_redesign.json": [
    "603928",
    [
      307388
    ]
  ],
  "./pt/blueprint_coursesExpandableLockOptions.json": [
    "844379",
    [
      305069
    ]
  ],
  "./es/assignments_bulk_edit_use_save_assignment.json": [
    "398690",
    [
      688667
    ]
  ],
  "./hi/comm_messages.json": [
    "940072",
    [
      702560
    ]
  ],
  "./hu/security_panel.json": [
    "193428",
    [
      193036
    ]
  ],
  "./nn/file_not_found.json": [
    "363037",
    [
      184127
    ]
  ],
  "./ms/GroupsTray.json": [
    "930258",
    [
      677162
    ]
  ],
  "./sv/ai_experiences_edit.json": [
    "624666",
    [
      618598
    ]
  ],
  "./cy/AddGroup.json": [
    "645784",
    [
      58248
    ]
  ],
  "./mi/content_migrations_redesign.json": [
    "225303",
    [
      387589
    ]
  ],
  "./mi/blueprint_coursesExpandableLockOptions.json": [
    "262241",
    [
      986335
    ]
  ],
  "./ru/progress_pill.json": [
    "81888",
    [
      189000
    ]
  ],
  "./sl/discussion_posts.json": [
    "119527",
    [
      331665
    ]
  ],
  "./sl/appointment_groups.json": [
    "978173",
    [
      484671
    ]
  ],
  "./es/account_notification_settings.json": [
    "283355",
    [
      955430
    ]
  ],
  "./pt-BR/user.json": [
    "488078",
    [
      42151
    ]
  ],
  "./ca/gradinggradingPeriodCollection.json": [
    "552627",
    [
      589561
    ]
  ],
  "./cy/syllabus_revisions.json": [
    "126080",
    [
      160640
    ]
  ],
  "./fi/MasteryScale.json": [
    "815908",
    [
      317412
    ]
  ],
  "./es-ES/top_navigation_tools.json": [
    "596283",
    [
      223321
    ]
  ],
  "./zh-Hant/assignmentsIndexView.json": [
    "844967",
    [
      728369
    ]
  ],
  "./da/webzip_export.json": [
    "883753",
    [
      739335
    ]
  ],
  "./de/blueprint_coursesExpandableLockOptions.json": [
    "74530",
    [
      867891
    ]
  ],
  "./id/ai_experiences_edit.json": [
    "118990",
    [
      662634
    ]
  ],
  "./id/media_immersive_view.json": [
    "440621",
    [
      931231
    ]
  ],
  "./vi/DueDateOverrideView.json": [
    "70428",
    [
      814236
    ]
  ],
  "./hu/discussion_posts.json": [
    "708531",
    [
      782985
    ]
  ],
  "./ga/quizzes.take_quiz.json": [
    "206936",
    [
      554765
    ]
  ],
  "./fi/sidenav.json": [
    "777543",
    [
      761693
    ]
  ],
  "./fa/discussionTopicKeyboradShortcutModal.json": [
    "142606",
    [
      176630
    ]
  ],
  "./it/user_name.json": [
    "940012",
    [
      363344
    ]
  ],
  "./nn/homeroom_page.json": [
    "926328",
    [
      229516
    ]
  ],
  "./vi/accessibility_scan.json": [
    "650861",
    [
      180459
    ]
  ],
  "./ja/k5_course.json": [
    "456951",
    [
      207930
    ]
  ],
  "./ga/quiz_log_auditing.json": [
    "354850",
    [
      575442
    ]
  ],
  "./nl/permission_button.json": [
    "112156",
    [
      891632
    ]
  ],
  "./pt-BR/EditMasteryScaleLink.json": [
    "363944",
    [
      700997
    ]
  ],
  "./sv/mutationActivity.json": [
    "937859",
    [
      514701
    ]
  ],
  "./hu/progress_pill.json": [
    "117346",
    [
      268282
    ]
  ],
  "./nl/k5_dashboard.json": [
    "868159",
    [
      867385
    ]
  ],
  "./sv-x-k12/course_paces_blackout_date_row.json": [
    "586319",
    [
      205957
    ]
  ],
  "./hi/security_panel.json": [
    "96144",
    [
      434728
    ]
  ],
  "./fr-CA/grades_empty_page.json": [
    "727875",
    [
      204637
    ]
  ],
  "./en-CA/wiki_page_index.json": [
    "456435",
    [
      572689
    ]
  ],
  "./da-x-k12/jobs.json": [
    "787293",
    [
      386447
    ]
  ],
  "./nb/quizzes_index.json": [
    "517964",
    [
      741240
    ]
  ],
  "./el/jobs.json": [
    "142469",
    [
      388015
    ]
  ],
  "./it/grade_details.json": [
    "35469",
    [
      877823
    ]
  ],
  "./nb/user_lists.json": [
    "349843",
    [
      828573
    ]
  ],
  "./fr/course_stats.json": [
    "596811",
    [
      91106
    ]
  ],
  "./mi/IndividualStudentMasteryOutcome.json": [
    "599281",
    [
      113103
    ]
  ],
  "./pl/homeroom_page.json": [
    "786148",
    [
      606152
    ]
  ],
  "./fa/blueprint_course_child.json": [
    "105441",
    [
      198055
    ]
  ],
  "./el/assignments_2_shared_Steps.json": [
    "82924",
    [
      635192
    ]
  ],
  "./ms/admin_split.json": [
    "128494",
    [
      225470
    ]
  ],
  "./nb/assignmentsIndexView.json": [
    "842549",
    [
      700135
    ]
  ],
  "./hi/course_pace_date_input.json": [
    "473434",
    [
      660458
    ]
  ],
  "./fi/outcome_management.json": [
    "158247",
    [
      213837
    ]
  ],
  "./nn/course_template_details.json": [
    "598595",
    [
      394509
    ]
  ],
  "./fi/student_groups.json": [
    "26857",
    [
      979423
    ]
  ],
  "./pt-BR/accessibility_course_statistics.json": [
    "794805",
    [
      110548
    ]
  ],
  "./es/peer_review_student_select.json": [
    "939148",
    [
      25913
    ]
  ],
  "./ht/internal-settings.json": [
    "451235",
    [
      534629
    ]
  ],
  "./ar/blueprint_settingsSyncChange.json": [
    "549437",
    [
      5511
    ]
  ],
  "./sv-x-k12/appointment_groups.json": [
    "559957",
    [
      825203
    ]
  ],
  "./sv-x-k12/important_dates_empty.json": [
    "376787",
    [
      164417
    ]
  ],
  "./en-CA/assignments_2_student_content.json": [
    "564347",
    [
      181465
    ]
  ],
  "./pt/MasteryScale.json": [
    "522755",
    [
      209965
    ]
  ],
  "./th/accessibility_course_statistics.json": [
    "694076",
    [
      564448
    ]
  ],
  "./ja/quiz_log_auditing.json": [
    "97267",
    [
      743694
    ]
  ],
  "./tr/blueprint_settingsAssociationsTable.json": [
    "211391",
    [
      596561
    ]
  ],
  "./nn/add_edit_pseudonym.json": [
    "94651",
    [
      68589
    ]
  ],
  "./pl/blueprint_settingsCoursePickerTable.json": [
    "667248",
    [
      244852
    ]
  ],
  "./fr/assignments_bulk_edit_use_save_assignment.json": [
    "967258",
    [
      851463
    ]
  ],
  "./fr/canvascareer.json": [
    "718412",
    [
      969429
    ]
  ],
  "./ru/paginated_list.json": [
    "645541",
    [
      868963
    ]
  ],
  "./ht/conferences_alternatives.json": [
    "462906",
    [
      429830
    ]
  ],
  "./en-GB-x-lbs/modelsQuiz.json": [
    "739527",
    [
      154525
    ]
  ],
  "./cy/course_paces_assignment_row.json": [
    "778047",
    [
      829725
    ]
  ],
  "./ja/a2LatePolicyStatusDisplay.json": [
    "924284",
    [
      422713
    ]
  ],
  "./el/blueprint_course_sidebar.json": [
    "522963",
    [
      222229
    ]
  ],
  "./tr/a2LatePolicyStatusDisplay.json": [
    "143471",
    [
      403569
    ]
  ],
  "./uk/course_stats.json": [
    "204379",
    [
      709905
    ]
  ],
  "./zh-Hans/sis_import.json": [
    "646416",
    [
      227016
    ]
  ],
  "./ht/grades_summary.json": [
    "847053",
    [
      188887
    ]
  ],
  "./da/theme_collection_view.json": [
    "840447",
    [
      142509
    ]
  ],
  "./tr/ai_experiences_edit.json": [
    "812249",
    [
      364923
    ]
  ],
  "./is/student_annotation_preview.json": [
    "386028",
    [
      707628
    ]
  ],
  "./da-x-k12/permissions_role_tray.json": [
    "926625",
    [
      456107
    ]
  ],
  "./uk/peer_reviews_student.json": [
    "468580",
    [
      902796
    ]
  ],
  "./da/new_nav.json": [
    "775733",
    [
      885963
    ]
  ],
  "./fr-CA/course_logging_details.json": [
    "979247",
    [
      458129
    ]
  ],
  "./en-GB/self_unenrollment_modal.json": [
    "932749",
    [
      864808
    ]
  ],
  "./fr-CA/accessibility_scan.json": [
    "942873",
    [
      746315
    ]
  ],
  "./pt/add_edit_pseudonym.json": [
    "591511",
    [
      973353
    ]
  ],
  "./cy/context_modules_v2.json": [
    "965348",
    [
      601276
    ]
  ],
  "./pt-BR/self_enrollment.json": [
    "606672",
    [
      41757
    ]
  ],
  "./nl/blueprint_settingsMigrationSync.json": [
    "209792",
    [
      201316
    ]
  ],
  "./cy/sections_tooltip.json": [
    "458730",
    [
      153810
    ]
  ],
  "./nb-x-k12/bulk_edit_students_actions.json": [
    "95642",
    [
      897658
    ]
  ],
  "./fa/discovery_page.json": [
    "782233",
    [
      640319
    ]
  ],
  "./en-GB/permissions.json": [
    "441871",
    [
      419654
    ]
  ],
  "./pl/course_logging_details.json": [
    "199432",
    [
      345420
    ]
  ],
  "./id/discussion_row.json": [
    "626306",
    [
      904534
    ]
  ],
  "./uk/terms_of_service_modal.json": [
    "363117",
    [
      170547
    ]
  ],
  "./he/accessibility_checker.json": [
    "681933",
    [
      817955
    ]
  ],
  "./pl/moderate_quiz.json": [
    "457350",
    [
      828235
    ]
  ],
  "./ms/sidenav.json": [
    "472530",
    [
      488810
    ]
  ],
  "./uk/permission_button.json": [
    "626058",
    [
      962690
    ]
  ],
  "./en-GB-x-ukhe/discussion_row.json": [
    "965699",
    [
      810417
    ]
  ],
  "./da-x-k12/assignments_2_student_header_date_title.json": [
    "695704",
    [
      13372
    ]
  ],
  "./ga/a2LatePolicyToolTipContent.json": [
    "40491",
    [
      686537
    ]
  ],
  "./sl/outcome_alignment_v2.json": [
    "702484",
    [
      483104
    ]
  ],
  "./zh-Hant/assignment_2_assignment_toggle_details.json": [
    "560200",
    [
      12020
    ]
  ],
  "./ca/user_profile.json": [
    "975027",
    [
      604857
    ]
  ],
  "./ht/section.json": [
    "723857",
    [
      49843
    ]
  ],
  "./hu/ImportConfirmBox.json": [
    "568655",
    [
      674605
    ]
  ],
  "./is/edit_section_end_date.json": [
    "377177",
    [
      924591
    ]
  ],
  "./fa/assignments_2_student_header.json": [
    "833920",
    [
      457704
    ]
  ],
  "./hy/assignments_2_attempt_tab.json": [
    "598268",
    [
      83836
    ]
  ],
  "./hi/quiz_log_auditing.json": [
    "323133",
    [
      909723
    ]
  ],
  "./ko/gradinggradingPeriodCollection.json": [
    "713953",
    [
      527823
    ]
  ],
  "./nb/permissions_v2.json": [
    "490787",
    [
      687109
    ]
  ],
  "./pl/content_exports.json": [
    "96579",
    [
      566669
    ]
  ],
  "./sv-x-k12/paginated_list.json": [
    "267395",
    [
      639217
    ]
  ],
  "./th.eager.json": [
    "758403",
    [
      813538
    ]
  ],
  "./zh-Hant/GroupDetailView.json": [
    "649783",
    [
      849257
    ]
  ],
  "./pl/dashboard_grading_period_select.json": [
    "83312",
    [
      900220
    ]
  ],
  "./tr/assignments_2_media_attempt.json": [
    "823046",
    [
      243650
    ]
  ],
  "./cy/calculator_command.json": [
    "727932",
    [
      706180
    ]
  ],
  "./es/pseudonyms_mobile_login.json": [
    "966510",
    [
      271743
    ]
  ],
  "./he/blueprint_settingsAssociationsTable.json": [
    "217094",
    [
      416070
    ]
  ],
  "./es-ES/terms_index.json": [
    "736879",
    [
      11605
    ]
  ],
  "./ht/default_account_quotas.json": [
    "792317",
    [
      822967
    ]
  ],
  "./hu/copy_course.json": [
    "533366",
    [
      199798
    ]
  ],
  "./hy/syllabus_revisions.json": [
    "34841",
    [
      8175
    ]
  ],
  "./pt-BR/knowledge_check_not_ready.json": [
    "121774",
    [
      453367
    ]
  ],
  "./en-AU/content_migrations_redesign.json": [
    "43551",
    [
      160386
    ]
  ],
  "./fi/admin_split.json": [
    "722415",
    [
      76469
    ]
  ],
  "./fi/progressbar_view.json": [
    "670293",
    [
      284995
    ]
  ],
  "./hi/assignments_peer_reviews.json": [
    "211366",
    [
      154366
    ]
  ],
  "./es-ES/lti_registration.wizard.json": [
    "906485",
    [
      650492
    ]
  ],
  "./nb-x-k12/edit_section_view.json": [
    "487572",
    [
      891044
    ]
  ],
  "./nb-x-k12/discussionTopicKeyboradShortcutModal.json": [
    "214379",
    [
      245865
    ]
  ],
  "./fa/modules_page_icon_legend.json": [
    "705216",
    [
      462504
    ]
  ],
  "./ja/permission_button.json": [
    "306331",
    [
      187990
    ]
  ],
  "./fr/EditMasteryScaleLink.json": [
    "549459",
    [
      345002
    ]
  ],
  "./nb-x-k12/courses.show.json": [
    "952061",
    [
      903656
    ]
  ],
  "./es-ES/course_paces_empty_state.json": [
    "166763",
    [
      506745
    ]
  ],
  "./uk/quizzes_index.json": [
    "420468",
    [
      896092
    ]
  ],
  "./da/a2LatePolicyToolTipContent.json": [
    "779994",
    [
      753202
    ]
  ],
  "./ht/announcements_v2.json": [
    "712431",
    [
      311273
    ]
  ],
  "./it/course_link_validator.json": [
    "412088",
    [
      386484
    ]
  ],
  "./sl/blueprint_course_child.json": [
    "492407",
    [
      918057
    ]
  ],
  "./th/student_groups.json": [
    "314166",
    [
      497058
    ]
  ],
  "./uk/MoveOutcomesModal.json": [
    "101579",
    [
      489857
    ]
  ],
  "./sv-x-k12/assignments_2_file_upload.json": [
    "907203",
    [
      84129
    ]
  ],
  "./sv-x-k12/terms_of_use.json": [
    "375906",
    [
      257378
    ]
  ],
  "./ru/course_paces_actions.json": [
    "324415",
    [
      348581
    ]
  ],
  "./es-ES/grades_empty_page.json": [
    "187303",
    [
      381901
    ]
  ],
  "./ko/bulk_edit_students_actions.json": [
    "32654",
    [
      2318
    ]
  ],
  "./zh-Hant/quiz_show.json": [
    "548035",
    [
      469709
    ]
  ],
  "./ca/account_settings_jsx_bundle.json": [
    "730838",
    [
      901446
    ]
  ],
  "./is/discovery_page.json": [
    "626514",
    [
      901890
    ]
  ],
  "./sv-x-k12.json": [
    "995926",
    [
      757096
    ]
  ],
  "./nb-x-k12/submit_assignment.json": [
    "358164",
    [
      540484
    ]
  ],
  "./el/course_paces_no_results.json": [
    "169010",
    [
      28086
    ]
  ],
  "./th/link_validator.json": [
    "595707",
    [
      491373
    ]
  ],
  "./ko/blueprint_settingsCourseFilter.json": [
    "687258",
    [
      958898
    ]
  ],
  "./ar/self_unenrollment_modal.json": [
    "544283",
    [
      948517
    ]
  ],
  "./hi/canvascareer.json": [
    "131105",
    [
      848247
    ]
  ],
  "./uk/Navigation.json": [
    "169152",
    [
      229648
    ]
  ],
  "./es-ES/OutcomeMoveModal.json": [
    "460363",
    [
      742745
    ]
  ],
  "./hu/OutcomeMoveModal.json": [
    "464485",
    [
      473195
    ]
  ],
  "./ms/assignments_2_attempt_tab.json": [
    "149183",
    [
      568477
    ]
  ],
  "./fi/assignments_bulk_edit.json": [
    "350215",
    [
      942125
    ]
  ],
  "./sl/bulk_edit_students_table.json": [
    "43886",
    [
      72122
    ]
  ],
  "./th/learning_mastery_gradebook.json": [
    "166372",
    [
      337625
    ]
  ],
  "./es/account_calendar_settings_filter_controls.json": [
    "831158",
    [
      801927
    ]
  ],
  "./fa/assignments_2_url_entry.json": [
    "316825",
    [
      460367
    ]
  ],
  "./zh-Hant/todo.json": [
    "715268",
    [
      116328
    ]
  ],
  "./pt/content_migrations_redesign.json": [
    "136329",
    [
      298635
    ]
  ],
  "./ar/course_paces_empty_state.json": [
    "492473",
    [
      216987
    ]
  ],
  "./ko/discussion_settings.json": [
    "493624",
    [
      268056
    ]
  ],
  "./ar/discussion_pinned_post.json": [
    "72017",
    [
      83371
    ]
  ],
  "./tr/announcements_v2.json": [
    "687269",
    [
      413063
    ]
  ],
  "./sv/course_paces_change_tracking.json": [
    "479060",
    [
      200752
    ]
  ],
  "./ja/permissions_v2_add_tray.json": [
    "63869",
    [
      116308
    ]
  ],
  "./nb-x-k12/assignment_index.json": [
    "163350",
    [
      614926
    ]
  ],
  "./ru/course_paces_flaggable_number_input.json": [
    "731154",
    [
      996274
    ]
  ],
  "./da/widget_dashboard.json": [
    "517000",
    [
      897512
    ]
  ],
  "./hy/context_prior_users.json": [
    "295034",
    [
      350538
    ]
  ],
  "./el/user_logins.json": [
    "718277",
    [
      354647
    ]
  ],
  "./de/copy_course.json": [
    "248850",
    [
      167587
    ]
  ],
  "./ca/conferences.json": [
    "78281",
    [
      767943
    ]
  ],
  "./nb-x-k12/remove_pace_warning_modal.json": [
    "745999",
    [
      835301
    ]
  ],
  "./mi/account_calendar_settings_account_calendar_item_dropdown.json": [
    "428567",
    [
      880453
    ]
  ],
  "./nl/empty_modules.json": [
    "728335",
    [
      811385
    ]
  ],
  "./sv/course_default_due_time.json": [
    "196393",
    [
      803083
    ]
  ],
  "./es/keyboardShortcutModal.json": [
    "798810",
    [
      769459
    ]
  ],
  "./fa/users.json": [
    "360715",
    [
      880537
    ]
  ],
  "./fr/todos_page.json": [
    "503623",
    [
      615278
    ]
  ],
  "./ko/k5_dashboard_card.json": [
    "908074",
    [
      656130
    ]
  ],
  "./sl/direct_share_course_import_panel.json": [
    "367963",
    [
      998877
    ]
  ],
  "./uk/unpublished_warning_modal.json": [
    "3928",
    [
      494680
    ]
  ],
  "./zh-Hans/HelpTray.json": [
    "889084",
    [
      51324
    ]
  ],
  "./ja/theme_editor.json": [
    "229706",
    [
      349619
    ]
  ],
  "./fi/assignments_peer_reviews_student.json": [
    "171500",
    [
      104156
    ]
  ],
  "./ru/roster_section_selector.json": [
    "540634",
    [
      824730
    ]
  ],
  "./fa/error_form.json": [
    "386919",
    [
      644900
    ]
  ],
  "./zh-Hans/homeroom_page.json": [
    "143355",
    [
      575273
    ]
  ],
  "./id/account_settings.json": [
    "138900",
    [
      280800
    ]
  ],
  "./es/suppress_notifications.json": [
    "906886",
    [
      903127
    ]
  ],
  "./ht/gradebook_uploads.json": [
    "822769",
    [
      358003
    ]
  ],
  "./hy/course_paces_assignment_row.json": [
    "321284",
    [
      800484
    ]
  ],
  "./es/assignments_2_student_content_rubric_self_assessment.json": [
    "256175",
    [
      963426
    ]
  ],
  "./fr-CA/custom_help_link.json": [
    "444145",
    [
      899771
    ]
  ],
  "./zh-Hans/jobs_v2.json": [
    "597888",
    [
      591080
    ]
  ],
  "./zh-Hant/Navigation.json": [
    "649954",
    [
      444902
    ]
  ],
  "./is/bounced_emails.json": [
    "849106",
    [
      229410
    ]
  ],
  "./ar/conversations_2.json": [
    "690928",
    [
      893380
    ]
  ],
  "./uk/course_paces_assignment_row.json": [
    "143271",
    [
      140389
    ]
  ],
  "./it/edit_section_dates.json": [
    "894115",
    [
      851149
    ]
  ],
  "./fr/outcomes_user_outcome_results.json": [
    "301201",
    [
      777596
    ]
  ],
  "./pl/pairing_code_user_observees.json": [
    "967163",
    [
      248637
    ]
  ],
  "./tr/bulk_edit_students_table.json": [
    "669681",
    [
      58003
    ]
  ],
  "./nb-x-k12/sections_tooltip.json": [
    "805056",
    [
      3416
    ]
  ],
  "./pt-BR/new_nav.json": [
    "871107",
    [
      349110
    ]
  ],
  "./cy/courses_show.json": [
    "51992",
    [
      624584
    ]
  ],
  "./ru/mutationActivity.json": [
    "205303",
    [
      622557
    ]
  ],
  "./sv/ai_experiences.json": [
    "458357",
    [
      565271
    ]
  ],
  "./th/todos_page.json": [
    "319124",
    [
      219689
    ]
  ],
  "./fr-CA/account_settings.json": [
    "402728",
    [
      85364
    ]
  ],
  "./hu/group_submission_reminder.json": [
    "947606",
    [
      415734
    ]
  ],
  "./nl/student_study_drawer.json": [
    "368371",
    [
      68157
    ]
  ],
  "./zh-Hans/paginated_list.json": [
    "368955",
    [
      614457
    ]
  ],
  "./en-GB-x-ukhe/moderate_quiz.json": [
    "65503",
    [
      969141
    ]
  ],
  "./fr/course_paces_blackout_dates_table.json": [
    "92101",
    [
      827840
    ]
  ],
  "./es-ES/context_roster_user_services.json": [
    "811169",
    [
      391719
    ]
  ],
  "./hu/quizzes_regrade_modal.json": [
    "907397",
    [
      843563
    ]
  ],
  "./zh-Hans/quizzes_index.json": [
    "738383",
    [
      478933
    ]
  ],
  "./en-GB-x-lbs/OutcomeDescriptionModal.json": [
    "518295",
    [
      402701
    ]
  ],
  "./is/ai_experiences_ai_conversations.json": [
    "357426",
    [
      334146
    ]
  ],
  "./ca/account_calendars.json": [
    "860509",
    [
      68899
    ]
  ],
  "./cy/homeroom_page.json": [
    "850100",
    [
      965164
    ]
  ],
  "./en-GB/content_migrations.json": [
    "926198",
    [
      35347
    ]
  ],
  "./ms/appt_calendar_event_dialog.json": [
    "934054",
    [
      664070
    ]
  ],
  "./nn/submit_online_url_assignment.json": [
    "523874",
    [
      476550
    ]
  ],
  "./fa/accessibility_course_statistics.json": [
    "500141",
    [
      200619
    ]
  ],
  "./ga/student_entries.json": [
    "281370",
    [
      19722
    ]
  ],
  "./da-x-k12/gradebook_default_gradebook_components_content_filters_module_filter.json": [
    "778673",
    [
      912067
    ]
  ],
  "./ht/student_study_drawer.json": [
    "767945",
    [
      735107
    ]
  ],
  "./ja/ai_experiences_show.json": [
    "503239",
    [
      507018
    ]
  ],
  "./nb/course_link_validator.json": [
    "791285",
    [
      662287
    ]
  ],
  "./hi/quizzes_quiz_submission.json": [
    "976413",
    [
      569515
    ]
  ],
  "./nn/conferences_alternatives.json": [
    "923510",
    [
      723330
    ]
  ],
  "./en-GB/calendar_custom_recurring_event_repeat_picker.json": [
    "689817",
    [
      8076
    ]
  ],
  "./fr/DueDateOverrideView.json": [
    "511489",
    [
      233412
    ]
  ],
  "./sv-x-k12/todos_page.json": [
    "900390",
    [
      745918
    ]
  ],
  "./ht/NewTabIndicator.json": [
    "677160",
    [
      583372
    ]
  ],
  "./sl/password_complexity_configuration.json": [
    "663710",
    [
      528010
    ]
  ],
  "./en-GB/gradingGradeSummary.json": [
    "904438",
    [
      173483
    ]
  ],
  "./is/canvas_file_upload.json": [
    "406127",
    [
      216341
    ]
  ],
  "./ja/file_not_found.json": [
    "274378",
    [
      597299
    ]
  ],
  "./tr/jobs_v2.json": [
    "170297",
    [
      576787
    ]
  ],
  "./nn/quizzes_regrade_modal.json": [
    "779438",
    [
      497770
    ]
  ],
  "./zh-Hans/discussion_topics_edit.json": [
    "883965",
    [
      535275
    ]
  ],
  "./nn/calendar.header.json": [
    "407419",
    [
      269318
    ]
  ],
  "./fa/IndividualStudentMasteryOutcome.json": [
    "243270",
    [
      518430
    ]
  ],
  "./ms/permissions_v2.json": [
    "275851",
    [
      419857
    ]
  ],
  "./nb.json": [
    "379997",
    [
      373917
    ]
  ],
  "./ca/context_prior_users.json": [
    "152873",
    [
      65255
    ]
  ],
  "./ht/error_form.json": [
    "618075",
    [
      902797
    ]
  ],
  "./hu/assignments_bulk_edit.json": [
    "883773",
    [
      721939
    ]
  ],
  "./vi/media_player_iframe_content.json": [
    "456056",
    [
      918416
    ]
  ],
  "./de/job_stats.json": [
    "302938",
    [
      961691
    ]
  ],
  "./nl/terms_of_service_modal.json": [
    "736655",
    [
      360457
    ]
  ],
  "./he/lti_registration.wizard.json": [
    "60999",
    [
      683466
    ]
  ],
  "./ht/OutcomeMoveModal.json": [
    "225772",
    [
      851200
    ]
  ],
  "./tr/sections_tooltip.json": [
    "68952",
    [
      829380
    ]
  ],
  "./fa/announcements_on_home_page.json": [
    "425557",
    [
      157427
    ]
  ],
  "./da-x-k12/available_pronouns_list.json": [
    "119126",
    [
      378570
    ]
  ],
  "./es-ES/conferences_alternatives.json": [
    "567821",
    [
      189211
    ]
  ],
  "./ru/user_profile.json": [
    "498024",
    [
      316352
    ]
  ],
  "./sl/discussion_row.json": [
    "597128",
    [
      131684
    ]
  ],
  "./tr/assignments_2_MoreOptions.json": [
    "627221",
    [
      960583
    ]
  ],
  "./ca/change_password.json": [
    "326918",
    [
      673526
    ]
  ],
  "./tr/course_paces_modal.json": [
    "684296",
    [
      734260
    ]
  ],
  "./ru/EditMasteryScaleLink.json": [
    "71032",
    [
      321904
    ]
  ],
  "./fi/canvascareer.json": [
    "262903",
    [
      124045
    ]
  ],
  "./da-x-k12/sidenav.json": [
    "766923",
    [
      142701
    ]
  ],
  "./ms/discussion_pinned_post.json": [
    "466628",
    [
      792316
    ]
  ],
  "./tr/discussionTopicKeyboradShortcutModal.json": [
    "587619",
    [
      522682
    ]
  ],
  "./ko/wiki_page_index.json": [
    "364601",
    [
      137815
    ]
  ],
  "./da-x-k12/ImportConfirmBox.json": [
    "468949",
    [
      369919
    ]
  ],
  "./ga/course_paces_module.json": [
    "304753",
    [
      555159
    ]
  ],
  "./zh-Hant/assignments.json": [
    "951334",
    [
      215674
    ]
  ],
  "./hi/permissions_role_tray_table_row.json": [
    "424107",
    [
      516745
    ]
  ],
  "./ru/admin_split.json": [
    "549359",
    [
      169701
    ]
  ],
  "./zh-Hans/assignments_2_MoreOptions_CanvasFiles.json": [
    "450364",
    [
      24540
    ]
  ],
  "./es/assignments.no_assignments_search.json": [
    "291245",
    [
      980948
    ]
  ],
  "./ko/use_switch_experience.json": [
    "673701",
    [
      536059
    ]
  ],
  "./hu/link_to_students.json": [
    "256866",
    [
      777978
    ]
  ],
  "./fr-CA/outcome_management.json": [
    "267267",
    [
      524573
    ]
  ],
  "./is/user_profile.json": [
    "558591",
    [
      361013
    ]
  ],
  "./de/assignments_2_url_entry.json": [
    "493319",
    [
      663218
    ]
  ],
  "./ko/editGroup.json": [
    "205495",
    [
      901141
    ]
  ],
  "./pt/entity_search_form.json": [
    "629489",
    [
      110843
    ]
  ],
  "./fa/account_settings.json": [
    "238444",
    [
      503356
    ]
  ],
  "./fi/gradebookOutcomeGradebookView.json": [
    "390214",
    [
      859886
    ]
  ],
  "./hi/quiz_statistics.json": [
    "283028",
    [
      827028
    ]
  ],
  "./nb/course_paces_modal.json": [
    "590518",
    [
      704578
    ]
  ],
  "./el/AccountsTray.json": [
    "496445",
    [
      1255
    ]
  ],
  "./es/account_calendar_settings_account_calendar_item.json": [
    "445195",
    [
      742550
    ]
  ],
  "./ru/gradingPeriodTemplate.json": [
    "331600",
    [
      454472
    ]
  ],
  "./hy/theme_editor.json": [
    "899744",
    [
      345208
    ]
  ],
  "./id/quizzes_public.json": [
    "739662",
    [
      307162
    ]
  ],
  "./ko/discussion_topics.json": [
    "575881",
    [
      94759
    ]
  ],
  "./ga/LogoutButton.json": [
    "221580",
    [
      119420
    ]
  ],
  "./nn/course_navigation_settings.json": [
    "664690",
    [
      40590
    ]
  ],
  "./fi/sharedCurveGradesDialog.json": [
    "695679",
    [
      870597
    ]
  ],
  "./vi/unpublished_changes_tray_contents.json": [
    "611274",
    [
      685738
    ]
  ],
  "./el/conversations_2.json": [
    "734430",
    [
      472738
    ]
  ],
  "./en-GB/theme_editor.json": [
    "861754",
    [
      357527
    ]
  ],
  "./th/blueprint_settingsMigrationOptions.json": [
    "650657",
    [
      3995
    ]
  ],
  "./hi/quizzes_public.json": [
    "648924",
    [
      922668
    ]
  ],
  "./sl/course_paces_actions.json": [
    "567093",
    [
      313095
    ]
  ],
  "./el/media_player_iframe_content.json": [
    "340476",
    [
      75504
    ]
  ],
  "./ht/assignments_peer_reviews_student.json": [
    "542283",
    [
      960101
    ]
  ],
  "./ko/context_modules_v2.json": [
    "11538",
    [
      996442
    ]
  ],
  "./zh-Hans/calculator_command.json": [
    "307221",
    [
      468035
    ]
  ],
  "./en-GB-x-ukhe/discussion_insights.json": [
    "788816",
    [
      826376
    ]
  ],
  "./ru/courses_show.json": [
    "477231",
    [
      139829
    ]
  ],
  "./fi/SpeedGraderDiscussionsNavigation.json": [
    "471326",
    [
      167446
    ]
  ],
  "./hi.json": [
    "982646",
    [
      351528
    ]
  ],
  "./is/assignments_peer_reviews.json": [
    "513043",
    [
      968945
    ]
  ],
  "./fr/license_help.json": [
    "34397",
    [
      308376
    ]
  ],
  "./nn/submit_assignment.json": [
    "453158",
    [
      356354
    ]
  ],
  "./nl/learning_mastery_gradebook.json": [
    "62409",
    [
      734499
    ]
  ],
  "./tr/moderate_quiz.json": [
    "450139",
    [
      992837
    ]
  ],
  "./cy/course_paces_errors.json": [
    "244766",
    [
      238606
    ]
  ],
  "./sl/assignment_index_deep_linking_handlers.json": [
    "931953",
    [
      509427
    ]
  ],
  "./ar/user_logins.json": [
    "915383",
    [
      688593
    ]
  ],
  "./it/blueprint_settingsMigrationSync.json": [
    "174727",
    [
      625289
    ]
  ],
  "./zh-Hant/account_calendar_settings_utils.json": [
    "354600",
    [
      378212
    ]
  ],
  "./nb/lti_registration.wizard.json": [
    "858952",
    [
      47347
    ]
  ],
  "./pt/grade_summary.json": [
    "774854",
    [
      626850
    ]
  ],
  "./ms/important_dates_empty.json": [
    "683688",
    [
      260472
    ]
  ],
  "./ms/assignments_2_student_content.json": [
    "815451",
    [
      973633
    ]
  ],
  "./es/authentication_providers.json": [
    "167651",
    [
      778606
    ]
  ],
  "./hi/GroupDetailView.json": [
    "154966",
    [
      297742
    ]
  ],
  "./nn/DueDateOverrideView.json": [
    "175669",
    [
      127959
    ]
  ],
  "./es-ES/outcome_reporting.json": [
    "282318",
    [
      34278
    ]
  ],
  "./es/assignment_2_assignment_toggle_details.json": [
    "612718",
    [
      528319
    ]
  ],
  "./nb-x-k12/use_switch_experience.json": [
    "864281",
    [
      393023
    ]
  ],
  "./de/user_profile.json": [
    "183862",
    [
      473519
    ]
  ],
  "./mi/course_paces_time_selection.json": [
    "174439",
    [
      589205
    ]
  ],
  "./th/react_developer_keys.json": [
    "654353",
    [
      556539
    ]
  ],
  "./nb-x-k12/default_account_quotas.json": [
    "543471",
    [
      13285
    ]
  ],
  "./en-AU-x-unimelb/course_paces_empty_state.json": [
    "416000",
    [
      826732
    ]
  ],
  "./pt/permission_button.json": [
    "276090",
    [
      792198
    ]
  ],
  "./zh-Hant/custom_emoji_deny_list.json": [
    "740354",
    [
      33998
    ]
  ],
  "./da/blueprint_course_sidebar.json": [
    "993561",
    [
      363639
    ]
  ],
  "./ar/available_pronouns_list.json": [
    "772664",
    [
      620132
    ]
  ],
  "./en-GB/last_attended.json": [
    "723875",
    [
      243378
    ]
  ],
  "./da/course_logging_details.json": [
    "770861",
    [
      501395
    ]
  ],
  "./el/grade_change_logging_content.json": [
    "826041",
    [
      113531
    ]
  ],
  "./en-GB-x-lbs/keyboardShortcutModal.json": [
    "607956",
    [
      41108
    ]
  ],
  "./he/discussion_topics.json": [
    "15484",
    [
      992260
    ]
  ],
  "./ht/assignments.never_drop.json": [
    "841092",
    [
      938707
    ]
  ],
  "./he/modelsQuiz.json": [
    "20232",
    [
      576952
    ]
  ],
  "./fa/permissions_v2_add_tray.json": [
    "493873",
    [
      441767
    ]
  ],
  "./ht/media_player_iframe_content.json": [
    "413161",
    [
      439635
    ]
  ],
  "./tr/epub_exports.json": [
    "713318",
    [
      345730
    ]
  ],
  "./da-x-k12/permissions_role_tray_table_row.json": [
    "67817",
    [
      219611
    ]
  ],
  "./hy/peer_review_student_select.json": [
    "668957",
    [
      888187
    ]
  ],
  "./pt-BR/GroupsTray.json": [
    "23081",
    [
      822912
    ]
  ],
  "./th/react_files.json": [
    "963277",
    [
      419335
    ]
  ],
  "./it/announcements_v2.json": [
    "839412",
    [
      734704
    ]
  ],
  "./fi/collaborations.json": [
    "902535",
    [
      422973
    ]
  ],
  "./ru/course_paces_blackout_dates_table.json": [
    "375204",
    [
      612740
    ]
  ],
  "./nb-x-k12/courses_show.json": [
    "828706",
    [
      931442
    ]
  ],
  "./sv-x-k12/quizzes_quiz_submission.json": [
    "194365",
    [
      773483
    ]
  ],
  "./ca/wiki_page_index.json": [
    "234003",
    [
      570457
    ]
  ],
  "./nb-x-k12/auth_logging.json": [
    "887880",
    [
      344464
    ]
  ],
  "./nn/appt_calendar_event_dialog.json": [
    "291850",
    [
      587070
    ]
  ],
  "./ms/account_calendar_settings_account_group.json": [
    "370928",
    [
      275312
    ]
  ],
  "./en-GB-x-lbs/empty_course.json": [
    "310583",
    [
      355645
    ]
  ],
  "./zh-Hans/rubrics-export.json": [
    "660340",
    [
      295316
    ]
  ],
  "./en/appointment_groups.json": [
    "301541",
    [
      661863
    ]
  ],
  "./en-GB/course_paces_time_selection.json": [
    "54319",
    [
      682221
    ]
  ],
  "./en-AU-x-unimelb/bulk_edit_students_table.json": [
    "970519",
    [
      745473
    ]
  ],
  "./en-AU/modules_home_page.json": [
    "670981",
    [
      89948
    ]
  ],
  "./es-ES/assignments.never_drop.json": [
    "88615",
    [
      319678
    ]
  ],
  "./ar/ImportConfirmBox.json": [
    "411923",
    [
      216741
    ]
  ],
  "./en-GB-x-lbs/gradingGradeSummary.json": [
    "850573",
    [
      98779
    ]
  ],
  "./ja/SpeedGraderPostGradesMenu.json": [
    "55942",
    [
      544135
    ]
  ],
  "./sv-x-k12/conferences_alternatives.json": [
    "908647",
    [
      695821
    ]
  ],
  "./tr/user.json": [
    "901087",
    [
      15625
    ]
  ],
  "./es-ES/roster_publicjs.json": [
    "758069",
    [
      334787
    ]
  ],
  "./en-AU/peer_review_allocation_rules_tray.json": [
    "870329",
    [
      269848
    ]
  ],
  "./vi/peer_reviews_student.json": [
    "966087",
    [
      6829
    ]
  ],
  "./fa/submissions_show_preview.json": [
    "596201",
    [
      926735
    ]
  ],
  "./pl/ai_experiences_edit.json": [
    "81991",
    [
      769433
    ]
  ],
  "./th/grade_details.json": [
    "87468",
    [
      524088
    ]
  ],
  "./pt/default_account_quotas.json": [
    "75029",
    [
      282015
    ]
  ],
  "./pl/bounced_emails.json": [
    "206670",
    [
      407234
    ]
  ],
  "./he/MobileNavigation.json": [
    "73563",
    [
      694913
    ]
  ],
  "./ca/content_migrations.json": [
    "127349",
    [
      828331
    ]
  ],
  "./sv-x-k12/content_share_preview_overlay.json": [
    "37176",
    [
      391536
    ]
  ],
  "./el/folder_tree.json": [
    "669914",
    [
      417326
    ]
  ],
  "./sl/AssignmentGroupListItemView.json": [
    "851679",
    [
      758513
    ]
  ],
  "./sv/assignments_2_MoreOptions_CanvasFiles.json": [
    "968742",
    [
      890978
    ]
  ],
  "./de/course_navigation_settings.json": [
    "144903",
    [
      45794
    ]
  ],
  "./cy/appointment_groups.json": [
    "1168",
    [
      646288
    ]
  ],
  "./ca/CreateEditAssignmentModal.json": [
    "149168",
    [
      101184
    ]
  ],
  "./hy/manage_avatars.json": [
    "59705",
    [
      893407
    ]
  ],
  "./id/content_migrations_redesign.json": [
    "689420",
    [
      150512
    ]
  ],
  "./fr-CA/sections_tooltip.json": [
    "52085",
    [
      803031
    ]
  ],
  "./ht/ai_experiences_show.json": [
    "436202",
    [
      355102
    ]
  ],
  "./hi/content_exports.json": [
    "526064",
    [
      972552
    ]
  ],
  "./es/Navigation.json": [
    "901016",
    [
      631597
    ]
  ],
  "./is/quizzes_openModerateStudentDialog.json": [
    "392056",
    [
      136816
    ]
  ],
  "./zh-Hant/rate_limiting_settings.json": [
    "413510",
    [
      947986
    ]
  ],
  "./da-x-k12/discussion_row.json": [
    "22854",
    [
      482770
    ]
  ],
  "./hu/permissions_v2.json": [
    "345458",
    [
      328074
    ]
  ],
  "./nb/jobs.json": [
    "987950",
    [
      401986
    ]
  ],
  "./mi/filter_calendars_modal.json": [
    "787596",
    [
      408564
    ]
  ],
  "./pl/progressbar_view.json": [
    "485230",
    [
      589906
    ]
  ],
  "./en-AU/ai_experiences_show.json": [
    "901200",
    [
      158901
    ]
  ],
  "./da/course_default_due_time.json": [
    "776899",
    [
      477929
    ]
  ],
  "./ja/self_enrollment.json": [
    "253748",
    [
      362481
    ]
  ],
  "./es-ES/DueDateOverrideView.json": [
    "635676",
    [
      713612
    ]
  ],
  "./ko/ignite_agent.json": [
    "740860",
    [
      998996
    ]
  ],
  "./es-ES/discussion_row.json": [
    "588066",
    [
      110114
    ]
  ],
  "./sl/gradebook_uploads.json": [
    "601226",
    [
      231726
    ]
  ],
  "./nn/peer_review_student_select.json": [
    "623800",
    [
      852708
    ]
  ],
  "./de/grade_details.json": [
    "135655",
    [
      97602
    ]
  ],
  "./fa/homeroom_page.json": [
    "353313",
    [
      604727
    ]
  ],
  "./id/overview_page.json": [
    "589764",
    [
      811280
    ]
  ],
  "./ko/courses.show.json": [
    "626809",
    [
      128100
    ]
  ],
  "./es-ES/course_paces_projected_dates.json": [
    "171946",
    [
      806138
    ]
  ],
  "./nn/content_exports.json": [
    "47055",
    [
      230729
    ]
  ],
  "./pt-BR/user_logins.json": [
    "411969",
    [
      78840
    ]
  ],
  "./sv-x-k12/gradebook_history.json": [
    "706072",
    [
      751904
    ]
  ],
  "./pl/SpeedGraderDiscussionsNavigation.json": [
    "74425",
    [
      317187
    ]
  ],
  "./cy/peer_review_student_select.json": [
    "229244",
    [
      838980
    ]
  ],
  "./mi/blueprint_settingsAssociationsTable.json": [
    "345839",
    [
      875469
    ]
  ],
  "./mi/SpeedGraderDiscussionsNavigation.json": [
    "143751",
    [
      430293
    ]
  ],
  "./mi/OutcomeDescriptionModal.json": [
    "638227",
    [
      258601
    ]
  ],
  "./fr/user_grades.json": [
    "402418",
    [
      913519
    ]
  ],
  "./ms/CommentLibrary.json": [
    "659270",
    [
      476294
    ]
  ],
  "./pt/outcomes_user_outcome_results.json": [
    "278577",
    [
      259931
    ]
  ],
  "./ht/DueDateOverrideView.json": [
    "630409",
    [
      942539
    ]
  ],
  "./ja/accessibility_checker.json": [
    "56889",
    [
      445806
    ]
  ],
  "./sv-x-k12/user_date_range_search.json": [
    "705624",
    [
      611200
    ]
  ],
  "./vi/course_paces_no_results.json": [
    "862894",
    [
      539798
    ]
  ],
  "./nb-x-k12/course_statistics.json": [
    "722337",
    [
      580647
    ]
  ],
  "./zh-Hans/not_found_page_slide_puzzle.json": [
    "899154",
    [
      642546
    ]
  ],
  "./en/blueprint_settingsCoursePicker.json": [
    "966609",
    [
      179179
    ]
  ],
  "./id/blueprint_settingsCoursePicker.json": [
    "872343",
    [
      875473
    ]
  ],
  "./nb-x-k12/ai_experiences_show.json": [
    "219472",
    [
      888728
    ]
  ],
  "./vi/progression_module_header.json": [
    "995695",
    [
      302869
    ]
  ],
  "./is/outcome_reporting.json": [
    "654615",
    [
      643837
    ]
  ],
  "./cy/gradebookActionMenu.json": [
    "372777",
    [
      580471
    ]
  ],
  "./ht/roster_section_selector.json": [
    "615191",
    [
      580761
    ]
  ],
  "./he/peer-review-assignment-widget.json": [
    "12223",
    [
      575965
    ]
  ],
  "./hu/module_sequence_footer.json": [
    "714669",
    [
      213411
    ]
  ],
  "./fi/module_student_view_peer_reviews.json": [
    "165734",
    [
      255550
    ]
  ],
  "./th/ignite_agent.json": [
    "203070",
    [
      521378
    ]
  ],
  "./ca/HelpTray.json": [
    "746713",
    [
      294295
    ]
  ],
  "./da/ai_experiences_show.json": [
    "341949",
    [
      96291
    ]
  ],
  "./it/blueprint_settingsAssociationsTable.json": [
    "805560",
    [
      875764
    ]
  ],
  "./sv-x-k12/nav_tourpoints.json": [
    "285440",
    [
      961672
    ]
  ],
  "./da/grade_change_logging_content.json": [
    "768947",
    [
      117977
    ]
  ],
  "./fa/sis_import.json": [
    "389142",
    [
      946174
    ]
  ],
  "./nl/remove_pace_warning_modal.json": [
    "378459",
    [
      299637
    ]
  ],
  "./ca/account_calendar_settings_utils.json": [
    "838194",
    [
      146906
    ]
  ],
  "./es/courses_show.json": [
    "806024",
    [
      4093
    ]
  ],
  "./ms/a2_AccessibleTipContent.json": [
    "817474",
    [
      188333
    ]
  ],
  "./fi/homeroom_page.json": [
    "100745",
    [
      739983
    ]
  ],
  "./sv/theme_editor.json": [
    "923274",
    [
      826310
    ]
  ],
  "./pl/auth_logging.json": [
    "408642",
    [
      847006
    ]
  ],
  "./ga/empty_course.json": [
    "700397",
    [
      845819
    ]
  ],
  "./fi/not_found_page_slide_puzzle.json": [
    "743884",
    [
      507532
    ]
  ],
  "./ar/student_groups.json": [
    "487979",
    [
      817341
    ]
  ],
  "./fa/AssignmentGroupListItemView.json": [
    "181345",
    [
      984679
    ]
  ],
  "./fr-CA/group_submission_reminder.json": [
    "322468",
    [
      38592
    ]
  ],
  "./hi/conversations_2.json": [
    "451936",
    [
      35384
    ]
  ],
  "./en/FindOutcomesModal.json": [
    "408214",
    [
      339994
    ]
  ],
  "./nl/user_profile.json": [
    "741837",
    [
      840719
    ]
  ],
  "./ja/IndividualStudentMasteryOutcome.json": [
    "633250",
    [
      886923
    ]
  ],
  "./ar/bulk_edit_students_table.json": [
    "793958",
    [
      785274
    ]
  ],
  "./fa/file_not_found.json": [
    "588310",
    [
      851310
    ]
  ],
  "./ht/account_calendars_results_area.json": [
    "911044",
    [
      302520
    ]
  ],
  "./ko/gradebook_default_gradebook_components_content_filters_module_filter.json": [
    "947608",
    [
      72376
    ]
  ],
  "./pt-BR/assignment_grade_summary.json": [
    "867815",
    [
      483730
    ]
  ],
  "./zh-Hant/assignment_index_menu.json": [
    "353728",
    [
      272508
    ]
  ],
  "./ca/peer_reviews_student.json": [
    "603108",
    [
      999372
    ]
  ],
  "./id/course_paces_errors.json": [
    "925643",
    [
      534797
    ]
  ],
  "./ru/react_files.json": [
    "907116",
    [
      843516
    ]
  ],
  "./vi/keyboardShortcutModal.json": [
    "626631",
    [
      468061
    ]
  ],
  "./da/quizzes_regrade_modal.json": [
    "749333",
    [
      285547
    ]
  ],
  "./ms/course_paces_blackout_date_row.json": [
    "763454",
    [
      204846
    ]
  ],
  "./sv-x-k12/custom_help_link.json": [
    "890711",
    [
      609197
    ]
  ],
  "./nn/account_calendar_settings_footer.json": [
    "843530",
    [
      7902
    ]
  ],
  "./tr/CoursesTray.json": [
    "465302",
    [
      886826
    ]
  ],
  "./da-x-k12/quantitative_data_options.json": [
    "753814",
    [
      78218
    ]
  ],
  "./sv/gradebookActionMenu.json": [
    "633280",
    [
      489876
    ]
  ],
  "./fr-CA/top_navigation_tools.json": [
    "873695",
    [
      158857
    ]
  ],
  "./es-ES/SpeedGraderDiscussionsNavigation.json": [
    "181454",
    [
      222326
    ]
  ],
  "./en-CA/AlignmentSummary.json": [
    "375165",
    [
      403179
    ]
  ],
  "./it/outcome_detail.json": [
    "90369",
    [
      91035
    ]
  ],
  "./nb/link_validator.json": [
    "557123",
    [
      137717
    ]
  ],
  "./tr/courses_show.json": [
    "982714",
    [
      19326
    ]
  ],
  "./mi/sharedCurveGradesDialog.json": [
    "343596",
    [
      699860
    ]
  ],
  "./fr/outcome_detail.json": [
    "925534",
    [
      950771
    ]
  ],
  "./ko/discussion_create.json": [
    "68825",
    [
      835895
    ]
  ],
  "./zh-Hans/password_complexity_configuration.json": [
    "786382",
    [
      156870
    ]
  ],
  "./zh-Hant/unpublished_warning_modal.json": [
    "78582",
    [
      629978
    ]
  ],
  "./vi/account_calendar_settings_account_tree.json": [
    "707286",
    [
      511886
    ]
  ],
  "./he/CourseAvailabilityOptions.json": [
    "52589",
    [
      703843
    ]
  ],
  "./en-GB-x-lbs/assignments_peer_reviews_student.json": [
    "152005",
    [
      637267
    ]
  ],
  "./en-GB-x-ukhe/course_paces_errors.json": [
    "265192",
    [
      244544
    ]
  ],
  "./cy/assignments_peer_reviews_student.json": [
    "325547",
    [
      851985
    ]
  ],
  "./zh-Hant/account_settings.json": [
    "699397",
    [
      249767
    ]
  ],
  "./th/blueprint_settingsCoursePicker.json": [
    "129932",
    [
      827336
    ]
  ],
  "./id/course_logging_details.json": [
    "395347",
    [
      932853
    ]
  ],
  "./it/dashboard.json": [
    "295043",
    [
      470893
    ]
  ],
  "./da-x-k12/accessibility_course_statistics.json": [
    "970401",
    [
      560131
    ]
  ],
  "./tr/k5_dashboard.json": [
    "787395",
    [
      846749
    ]
  ],
  "./ko/rubrics-export.json": [
    "401199",
    [
      569949
    ]
  ],
  "./th/edit_section_view.json": [
    "132922",
    [
      578678
    ]
  ],
  "./sl/blueprint_settingsAssociationsTable.json": [
    "994826",
    [
      843534
    ]
  ],
  "./nn/registration.json": [
    "78271",
    [
      34513
    ]
  ],
  "./da/password_complexity_configuration.json": [
    "943594",
    [
      627202
    ]
  ],
  "./zh-Hans/assignments_2_initial_query.json": [
    "327858",
    [
      890258
    ]
  ],
  "./ar/course_paces_no_results.json": [
    "73448",
    [
      162580
    ]
  ],
  "./es-ES/submissions_show_preview.json": [
    "600481",
    [
      365031
    ]
  ],
  "./ru/change_password.json": [
    "685491",
    [
      496033
    ]
  ],
  "./es/EditMasteryScaleLink.json": [
    "477739",
    [
      59862
    ]
  ],
  "./nn/course_paces_module.json": [
    "581489",
    [
      533675
    ]
  ],
  "./pt/courses.show.json": [
    "217627",
    [
      925222
    ]
  ],
  "./hi/course_paces_errors.json": [
    "896081",
    [
      579655
    ]
  ],
  "./is/assignments_2_student_content_rubric_self_assessment.json": [
    "148435",
    [
      449729
    ]
  ],
  "./cy/pairing_code_user_observees.json": [
    "828139",
    [
      521937
    ]
  ],
  "./fa/course_paces_no_results.json": [
    "864022",
    [
      541550
    ]
  ],
  "./fr-CA/blueprint_settingsUnsyncedChanges.json": [
    "320090",
    [
      458046
    ]
  ],
  "./ga/direct_share_course_import_panel.json": [
    "19018",
    [
      739946
    ]
  ],
  "./hi/wiki_page_index.json": [
    "415588",
    [
      478036
    ]
  ],
  "./ht/ai_experiences.json": [
    "369522",
    [
      779334
    ]
  ],
  "./ru/permissions_v2_add_tray.json": [
    "47673",
    [
      949551
    ]
  ],
  "./da/bulk_edit_students_actions.json": [
    "53701",
    [
      368411
    ]
  ],
  "./uk/login.json": [
    "222975",
    [
      195789
    ]
  ],
  "./hi/blueprint_course_child.json": [
    "934703",
    [
      407525
    ]
  ],
  "./sl/dashboard.json": [
    "277037",
    [
      936039
    ]
  ],
  "./fr-CA/remove_pace_warning_modal.json": [
    "430128",
    [
      60060
    ]
  ],
  "./nb-x-k12/student_groups.json": [
    "859656",
    [
      353728
    ]
  ],
  "./fr-CA/roster_section_input.json": [
    "267469",
    [
      669119
    ]
  ],
  "./id/AccountsTray.json": [
    "439617",
    [
      394331
    ]
  ],
  "./es-ES/use_switch_experience.json": [
    "509106",
    [
      759538
    ]
  ],
  "./ht/homeroom_page.json": [
    "784980",
    [
      499672
    ]
  ],
  "./mi/AssignmentGroupListItemView.json": [
    "208338",
    [
      618090
    ]
  ],
  "./th/account_calendars_modal.json": [
    "778259",
    [
      335757
    ]
  ],
  "./fr-CA/permission_button.json": [
    "933867",
    [
      377589
    ]
  ],
  "./nb-x-k12/gradebookOutcomeGradebookView.json": [
    "389109",
    [
      29347
    ]
  ],
  "./fa/important_dates.json": [
    "713147",
    [
      142009
    ]
  ],
  "./ht/outcome_detail.json": [
    "791878",
    [
      530682
    ]
  ],
  "./uk/discussion_posts.json": [
    "563394",
    [
      151914
    ]
  ],
  "./sl/user_name.json": [
    "580926",
    [
      282810
    ]
  ],
  "./uk/assignments.json": [
    "255356",
    [
      380148
    ]
  ],
  "./fr/AssignmentGroupListItemView.json": [
    "368804",
    [
      886637
    ]
  ],
  "./ga/collaborations.json": [
    "903576",
    [
      512752
    ]
  ],
  "./pl/password_complexity_configuration.json": [
    "220085",
    [
      636159
    ]
  ],
  "./nb-x-k12/dashboard_grades_page.json": [
    "529073",
    [
      863479
    ]
  ],
  "./ru/IndividualStudentMasteryOutcome.json": [
    "988142",
    [
      773574
    ]
  ],
  "./ru/ai_experiences_show.json": [
    "105907",
    [
      351425
    ]
  ],
  "./zh-Hans/change_password.json": [
    "556505",
    [
      178655
    ]
  ],
  "./he/course_link_validator.json": [
    "584698",
    [
      751170
    ]
  ],
  "./nn/quiz_migration_notifications.json": [
    "736391",
    [
      381617
    ]
  ],
  "./ca/outcome_management.json": [
    "2896",
    [
      676512
    ]
  ],
  "./mi/quizzes_regrade_modal.json": [
    "64752",
    [
      655472
    ]
  ],
  "./id/assignments_2_submission_helpers.json": [
    "249319",
    [
      601113
    ]
  ],
  "./nl/progression_module_header.json": [
    "174080",
    [
      19100
    ]
  ],
  "./es-ES/peer_review_student_select.json": [
    "746347",
    [
      303609
    ]
  ],
  "./ru/account_calendar_settings_account_group.json": [
    "520845",
    [
      14155
    ]
  ],
  "./vi/empty_modules.json": [
    "516764",
    [
      666284
    ]
  ],
  "./uk/bulk_edit_students_actions.json": [
    "216476",
    [
      520468
    ]
  ],
  "./mi/gradebookOutcomeGradebookView.json": [
    "318989",
    [
      690147
    ]
  ],
  "./de/choose_mastery_path.json": [
    "220110",
    [
      547639
    ]
  ],
  "./sl/context_modules_v2.json": [
    "36281",
    [
      348715
    ]
  ],
  "./fi/course_paces_assignment_row.json": [
    "965982",
    [
      910502
    ]
  ],
  "./fr-CA/peer_review_allocation_rule_card.json": [
    "741655",
    [
      191105
    ]
  ],
  "./ko/announcements_v2.json": [
    "892569",
    [
      785335
    ]
  ],
  "./nb-x-k12/learning_mastery_gradebook.json": [
    "766917",
    [
      6771
    ]
  ],
  "./vi/restore_content_pane.json": [
    "131558",
    [
      753518
    ]
  ],
  "./fr-CA/assignments_2_submission_helpers.json": [
    "825755",
    [
      477677
    ]
  ],
  "./id/course_color_selector.json": [
    "700844",
    [
      541960
    ]
  ],
  "./ja/SpeedGraderSettingsMenu.json": [
    "806669",
    [
      399844
    ]
  ],
  "./nl/ai_experiences.json": [
    "372048",
    [
      181476
    ]
  ],
  "./fr/assignment_show.json": [
    "339589",
    [
      333832
    ]
  ],
  "./sl/account_calendar_settings_account_calendar_item_dropdown.json": [
    "672688",
    [
      677252
    ]
  ],
  "./ar/MasteryScale.json": [
    "307114",
    [
      519862
    ]
  ],
  "./ru/calendar_appointment_group_edit.json": [
    "914490",
    [
      100346
    ]
  ],
  "./da-x-k12/not_found_page_slide_puzzle.json": [
    "321296",
    [
      831964
    ]
  ],
  "./fa/security_panel.json": [
    "917030",
    [
      205518
    ]
  ],
  "./ga/media_player_iframe_content.json": [
    "542317",
    [
      413227
    ]
  ],
  "./ar/course_paces_search.json": [
    "668102",
    [
      22178
    ]
  ],
  "./mi/a2LatePolicyStatusDisplay.json": [
    "126732",
    [
      604157
    ]
  ],
  "./en-CA/conversations_2.json": [
    "229787",
    [
      969961
    ]
  ],
  "./ru/todo.json": [
    "543505",
    [
      619863
    ]
  ],
  "./da-x-k12/course_paces_no_results.json": [
    "612042",
    [
      854102
    ]
  ],
  "./el/peer_review_allocation_rules_tray.json": [
    "802218",
    [
      191526
    ]
  ],
  "./sl/quizzes_quiz_submission.json": [
    "157189",
    [
      149727
    ]
  ],
  "./sv/quiz_statistics.json": [
    "693222",
    [
      910482
    ]
  ],
  "./th/assignment_grade_summary.json": [
    "944696",
    [
      589908
    ]
  ],
  "./fi/student_study_drawer.json": [
    "203486",
    [
      792550
    ]
  ],
  "./th/pseudonyms_mobile_login.json": [
    "267366",
    [
      440986
    ]
  ],
  "./uk/sections_tooltip.json": [
    "146770",
    [
      471226
    ]
  ],
  "./fa/peer_review_student_select.json": [
    "419251",
    [
      25857
    ]
  ],
  "./zh-Hant/course_paces_blackout_dates_modal.json": [
    "503322",
    [
      878254
    ]
  ],
  "./cy/assignments_bulk_edit_use_save_assignment.json": [
    "813426",
    [
      736842
    ]
  ],
  "./nb/assignments.json": [
    "485796",
    [
      469664
    ]
  ],
  "./pt-BR/theme_editor.json": [
    "596830",
    [
      70055
    ]
  ],
  "./de/filter_calendars_modal.json": [
    "473511",
    [
      127666
    ]
  ],
  "./vi/submissions_show_preview.json": [
    "187681",
    [
      690775
    ]
  ],
  "./fa/internal-settings.json": [
    "388254",
    [
      300710
    ]
  ],
  "./fr/OutcomeMoveModal.json": [
    "949316",
    [
      717485
    ]
  ],
  "./en-GB-x-ukhe/content_exports.json": [
    "146017",
    [
      706695
    ]
  ],
  "./pt-BR/a2_AccessibleTipContent.json": [
    "250587",
    [
      86958
    ]
  ],
  "./ar/NewTabIndicator.json": [
    "730515",
    [
      743837
    ]
  ],
  "./nl/announcements_on_home_page.json": [
    "622548",
    [
      28688
    ]
  ],
  "./zh-Hant/youtube_migration.json": [
    "141226",
    [
      85054
    ]
  ],
  "./en-AU-x-unimelb/assignments_2_student_header_date_title.json": [
    "597213",
    [
      801639
    ]
  ],
  "./fr/user_search_results.json": [
    "306947",
    [
      430618
    ]
  ],
  "./zh-Hans/courses.show.json": [
    "773846",
    [
      323765
    ]
  ],
  "./nl/peer_reviews_student.json": [
    "462450",
    [
      745758
    ]
  ],
  "./da/MobileGlobalMenu.json": [
    "758525",
    [
      274467
    ]
  ],
  "./pl/discussion_pinned_post.json": [
    "626220",
    [
      817824
    ]
  ],
  "./hi/course_paces_flaggable_number_input.json": [
    "441948",
    [
      533292
    ]
  ],
  "./da-x-k12/submit_assignment.json": [
    "109759",
    [
      676057
    ]
  ],
  "./nn/keyboardShortcutModal.json": [
    "678478",
    [
      368050
    ]
  ],
  "./id/context_prior_users.json": [
    "723420",
    [
      692112
    ]
  ],
  "./en-GB-x-lbs/assignmentsToggleShowByView.json": [
    "249023",
    [
      117989
    ]
  ],
  "./hu/assignments_bulk_edit_use_save_assignment.json": [
    "159129",
    [
      83239
    ]
  ],
  "./tr/sharedSetDefaultGradeDialog.json": [
    "128051",
    [
      929333
    ]
  ],
  "./da/edit_section_end_date.json": [
    "978902",
    [
      472038
    ]
  ],
  "./hu/course_paces_pace_picker.json": [
    "352816",
    [
      825936
    ]
  ],
  "./id/context_roster_user_services.json": [
    "319937",
    [
      961059
    ]
  ],
  "./pt/link_to_students.json": [
    "979839",
    [
      673497
    ]
  ],
  "./vi/job_stats.json": [
    "779048",
    [
      427216
    ]
  ],
  "./zh-Hant/sidenav.json": [
    "76376",
    [
      185212
    ]
  ],
  "./fa/a2LatePolicyStatusDisplay.json": [
    "247480",
    [
      799664
    ]
  ],
  "./ja/assignment_show.json": [
    "523976",
    [
      607789
    ]
  ],
  "./sv-x-k12/ai_experiences.json": [
    "717019",
    [
      799897
    ]
  ],
  "./fr/blueprint_settingsMigrationSync.json": [
    "974734",
    [
      198123
    ]
  ],
  "./fr/unpublished_changes_tray_contents.json": [
    "847823",
    [
      856142
    ]
  ],
  "./is/quantitative_data_options.json": [
    "867039",
    [
      905781
    ]
  ],
  "./ja/edit_section_start_date.json": [
    "508971",
    [
      731238
    ]
  ],
  "./hi/assignmentsToggleShowByView.json": [
    "825350",
    [
      489214
    ]
  ],
  "./en-GB/gradingPeriodTemplate.json": [
    "707764",
    [
      644509
    ]
  ],
  "./es-ES/ldap_cert_upload.json": [
    "837493",
    [
      54547
    ]
  ],
  "./id/CommentLibrary.json": [
    "324101",
    [
      473399
    ]
  ],
  "./mi/module_sequence_footer.json": [
    "98306",
    [
      765338
    ]
  ],
  "./it/keyboardShortcutModal.json": [
    "581911",
    [
      246393
    ]
  ],
  "./sv/outcome_management.json": [
    "18643",
    [
      730541
    ]
  ],
  "./nn/paginated_list.json": [
    "513154",
    [
      962238
    ]
  ],
  "./es-ES/assignments_2_shared_Steps.json": [
    "284064",
    [
      323912
    ]
  ],
  "./sv/edit_section_dates.json": [
    "637287",
    [
      240657
    ]
  ],
  "./ga/FindOutcomesModal.json": [
    "386433",
    [
      974599
    ]
  ],
  "./de/LearningMasteryGradebook.json": [
    "464508",
    [
      731681
    ]
  ],
  "./en-AU-x-unimelb/DueDateOverrideView.json": [
    "641521",
    [
      327515
    ]
  ],
  "./sl/media_player_iframe_content.json": [
    "454970",
    [
      705062
    ]
  ],
  "./pl/rate_limiting_settings.json": [
    "75004",
    [
      415216
    ]
  ],
  "./nb/content_copy_redesign.json": [
    "667353",
    [
      220267
    ]
  ],
  "./vi/react_files.json": [
    "597404",
    [
      19676
    ]
  ],
  "./zh-Hans/course_paces_pace_picker.json": [
    "98452",
    [
      23092
    ]
  ],
  "./hu/assignments_2_initial_query.json": [
    "465966",
    [
      682622
    ]
  ],
  "./fr-CA/account_calendars_modal.json": [
    "147950",
    [
      140178
    ]
  ],
  "./ar/AssignmentListItemView.json": [
    "596964",
    [
      198664
    ]
  ],
  "./ja/folder_tree.json": [
    "591242",
    [
      485555
    ]
  ],
  "./ms/discussion_topics.json": [
    "724219",
    [
      171681
    ]
  ],
  "./el/discovery_page.json": [
    "921581",
    [
      625991
    ]
  ],
  "./ga/change_password.json": [
    "572434",
    [
      999570
    ]
  ],
  "./sv/MoveOutcomesModal.json": [
    "370266",
    [
      668294
    ]
  ],
  "./zh-Hans/self_enrollment.json": [
    "919502",
    [
      801270
    ]
  ],
  "./he/edit_section_end_date.json": [
    "174326",
    [
      649430
    ]
  ],
  "./fi/account_calendar_settings_account_calendar_item.json": [
    "576186",
    [
      79514
    ]
  ],
  "./cy/content_shares.json": [
    "827684",
    [
      559004
    ]
  ],
  "./sv/GroupsTray.json": [
    "704189",
    [
      241247
    ]
  ],
  "./uk/CreateEditAssignmentModal.json": [
    "862320",
    [
      822976
    ]
  ],
  "./it/module_student_view_peer_reviews.json": [
    "964038",
    [
      241682
    ]
  ],
  "./ms/react_developer_keys.json": [
    "653665",
    [
      25631
    ]
  ],
  "./zh-Hans/react_collaborations.json": [
    "747765",
    [
      501891
    ]
  ],
  "./nl/a2LatePolicyToolTipContent.json": [
    "251741",
    [
      824343
    ]
  ],
  "./ko/course_paces_assignment_row.json": [
    "594521",
    [
      75191
    ]
  ],
  "./da-x-k12/account_settings_jsx_bundle.json": [
    "490067",
    [
      161101
    ]
  ],
  "./uk/add_edit_pseudonym.json": [
    "908327",
    [
      218853
    ]
  ],
  "./sv-x-k12/MasteryScale.json": [
    "159066",
    [
      292922
    ]
  ],
  "./tr/important_dates.json": [
    "576640",
    [
      465260
    ]
  ],
  "./zh-Hans/blueprint_settingsSyncChange.json": [
    "306261",
    [
      349027
    ]
  ],
  "./zh-Hant/announcements_on_home_page.json": [
    "379920",
    [
      94396
    ]
  ],
  "./sv/content_share_preview_overlay.json": [
    "835294",
    [
      902290
    ]
  ],
  "./ko/course_paces_blackout_dates_table.json": [
    "546059",
    [
      462753
    ]
  ],
  "./el/course_template_details.json": [
    "67274",
    [
      705390
    ]
  ],
  "./fr/external_content_cancel.json": [
    "176698",
    [
      235847
    ]
  ],
  "./id/course_statistics.json": [
    "466742",
    [
      445546
    ]
  ],
  "./nn/account_course_user_search.json": [
    "289128",
    [
      686404
    ]
  ],
  "./fr/overview_page.json": [
    "971581",
    [
      477632
    ]
  ],
  "./de/assignments.never_drop.json": [
    "354449",
    [
      404360
    ]
  ],
  "./da/change_password.json": [
    "619549",
    [
      545987
    ]
  ],
  "./id/discussion_topics.json": [
    "662966",
    [
      375002
    ]
  ],
  "./ca/edit_section_view.json": [
    "905066",
    [
      466146
    ]
  ],
  "./en-AU/ImportConfirmBox.json": [
    "398108",
    [
      226425
    ]
  ],
  "./fr/grade_summaryGroupView.json": [
    "632800",
    [
      880665
    ]
  ],
  "./ja/OutcomeMoveModal.json": [
    "875887",
    [
      82802
    ]
  ],
  "./ru/SpeedGraderDiscussionsNavigation.json": [
    "380446",
    [
      928710
    ]
  ],
  "./nb/course_paces_empty_state.json": [
    "400024",
    [
      836636
    ]
  ],
  "./fr-CA/learning_mastery_gradebook.json": [
    "269860",
    [
      689248
    ]
  ],
  "./nb/file_not_found.json": [
    "46081",
    [
      237187
    ]
  ],
  "./da-x-k12/assignments_2_attempt_tab.json": [
    "433610",
    [
      546262
    ]
  ],
  "./es/quiz_show.json": [
    "851309",
    [
      400596
    ]
  ],
  "./fa/rootFoldersFinder.json": [
    "70754",
    [
      437474
    ]
  ],
  "./ja/gradingPeriodTemplate.json": [
    "802532",
    [
      479201
    ]
  ],
  "./pt/mutationActivity.json": [
    "246720",
    [
      297044
    ]
  ],
  "./hu/AssignmentListItemView.json": [
    "930512",
    [
      243408
    ]
  ],
  "./fr/content_migrations.json": [
    "379237",
    [
      518872
    ]
  ],
  "./ko/GroupsTray.json": [
    "809864",
    [
      104744
    ]
  ],
  "./nb/assignment_2_assignment_toggle_details.json": [
    "522782",
    [
      895674
    ]
  ],
  "./sv/homeroom_page.json": [
    "869261",
    [
      799663
    ]
  ],
  "./el/content_copy_redesign.json": [
    "169808",
    [
      436900
    ]
  ],
  "./pt/assignments_bulk_edit.json": [
    "73458",
    [
      238310
    ]
  ],
  "./ja/user_name.json": [
    "578536",
    [
      777613
    ]
  ],
  "./fr-CA/homeroom_page.json": [
    "318909",
    [
      915615
    ]
  ],
  "./zh-Hans/AccountsTray.json": [
    "939799",
    [
      441885
    ]
  ],
  "./zh-Hant/calendar_edit.json": [
    "394587",
    [
      424005
    ]
  ],
  "./zh-Hans/users.json": [
    "78785",
    [
      963447
    ]
  ],
  "./es/course_paces_header.json": [
    "408444",
    [
      222601
    ]
  ],
  "./is/course_paces_errors.json": [
    "955890",
    [
      98994
    ]
  ],
  "./hy/auth_logging.json": [
    "401203",
    [
      673457
    ]
  ],
  "./mi/course_paces_no_results.json": [
    "809949",
    [
      937427
    ]
  ],
  "./nl/gradingPeriodTemplate.json": [
    "767119",
    [
      785361
    ]
  ],
  "./es/section.json": [
    "169633",
    [
      390448
    ]
  ],
  "./sv/submissions_show_preview.json": [
    "361941",
    [
      95463
    ]
  ],
  "./nb-x-k12/GroupDetailView.json": [
    "679983",
    [
      317781
    ]
  ],
  "./ca/edit_section_dates.json": [
    "372980",
    [
      801372
    ]
  ],
  "./de/HelpTray.json": [
    "711964",
    [
      536929
    ]
  ],
  "./it/section.json": [
    "669092",
    [
      183832
    ]
  ],
  "./ar/job_stats.json": [
    "989378",
    [
      387038
    ]
  ],
  "./pt-BR/course_paces_flaggable_number_input.json": [
    "369122",
    [
      316163
    ]
  ],
  "./cy/permissions_v2_add_tray.json": [
    "491768",
    [
      314248
    ]
  ],
  "./en-AU/sections_tooltip.json": [
    "557888",
    [
      959909
    ]
  ],
  "./es-ES/assignments_2_MoreOptions_CanvasFiles.json": [
    "992786",
    [
      286818
    ]
  ],
  "./sv-x-k12/grade_details.json": [
    "406751",
    [
      950917
    ]
  ],
  "./sv-x-k12/CreateEditAssignmentModal.json": [
    "205227",
    [
      717417
    ]
  ],
  "./vi/terms_index.json": [
    "917615",
    [
      763173
    ]
  ],
  "./fi/blueprint_coursesExpandableLockOptions.json": [
    "698148",
    [
      920772
    ]
  ],
  "./zh-Hant/assignments_2_shared_Steps.json": [
    "761377",
    [
      683875
    ]
  ],
  "./pt/sections_tooltip.json": [
    "417538",
    [
      935670
    ]
  ],
  "./hu/student_annotation_preview.json": [
    "298865",
    [
      389999
    ]
  ],
  "./pt/content_shares.json": [
    "396460",
    [
      877648
    ]
  ],
  "./th/assignment_index_deep_linking_handlers.json": [
    "845476",
    [
      696024
    ]
  ],
  "./sv-x-k12/course_paces_header.json": [
    "108307",
    [
      174433
    ]
  ],
  "./da/course_paces_time_selection.json": [
    "909202",
    [
      898202
    ]
  ],
  "./ru/announcements_v2.json": [
    "798804",
    [
      463812
    ]
  ],
  "./pt/rubrics-export.json": [
    "748241",
    [
      10627
    ]
  ],
  "./nb-x-k12/CommentLibrary.json": [
    "148132",
    [
      31556
    ]
  ],
  "./pt/course_link_validator.json": [
    "792669",
    [
      329639
    ]
  ],
  "./hu/files_v2.json": [
    "64155",
    [
      179137
    ]
  ],
  "./en-GB-x-ukhe/assignments_2_login_action_prompt.json": [
    "430067",
    [
      967521
    ]
  ],
  "./pt/LearningMasteryGradebook.json": [
    "985537",
    [
      985491
    ]
  ],
  "./it/assignments_2_login_action_prompt.json": [
    "370844",
    [
      460480
    ]
  ],
  "./ko/content_exports.json": [
    "116681",
    [
      53415
    ]
  ],
  "./vi/rootFoldersFinder.json": [
    "695882",
    [
      538010
    ]
  ],
  "./es/plugins.json": [
    "689830",
    [
      985431
    ]
  ],
  "./ru/blueprint_course_child.json": [
    "445401",
    [
      568959
    ]
  ],
  "./cy/quizzes.take_quiz.json": [
    "852596",
    [
      864633
    ]
  ],
  "./uk/user_name.json": [
    "258409",
    [
      186919
    ]
  ],
  "./en-AU/course_paces_change_tracking.json": [
    "674497",
    [
      212896
    ]
  ],
  "./da-x-k12/jobs_v2.json": [
    "902038",
    [
      261754
    ]
  ],
  "./ga/ldap_cert_upload.json": [
    "213054",
    [
      78358
    ]
  ],
  "./nb/assignments_2_MoreOptions_CanvasFiles.json": [
    "418891",
    [
      357789
    ]
  ],
  "./ko/external_content_cancel.json": [
    "880124",
    [
      613204
    ]
  ],
  "./sv-x-k12/account_calendar_settings_filter_controls.json": [
    "279625",
    [
      260143
    ]
  ],
  "./id/react_files.json": [
    "59324",
    [
      38288
    ]
  ],
  "./sv/modules_home_page.json": [
    "336546",
    [
      811318
    ]
  ],
  "./hu/calculator_command.json": [
    "718209",
    [
      90943
    ]
  ],
  "./da-x-k12/syllabus_revisions.json": [
    "479319",
    [
      303049
    ]
  ],
  "./el/GroupDetailView.json": [
    "423852",
    [
      197768
    ]
  ],
  "./en-CA/context_modules_v2.json": [
    "393804",
    [
      46188
    ]
  ],
  "./ja/calendar_custom_recurring_event_natural_language.json": [
    "5529",
    [
      850712
    ]
  ],
  "./mi/permission_button.json": [
    "225344",
    [
      111328
    ]
  ],
  "./vi/internal-settings.json": [
    "991254",
    [
      392686
    ]
  ],
  "./nl/courses_show.json": [
    "835310",
    [
      664578
    ]
  ],
  "./da-x-k12/webcam_modal.json": [
    "170190",
    [
      248898
    ]
  ],
  "./nl/bulk_edit_students_actions.json": [
    "460974",
    [
      844650
    ]
  ],
  "./fr-CA/blueprint_coursesExpandableLockOptions.json": [
    "227272",
    [
      19668
    ]
  ],
  "./en-GB/assignments_2_student_content.json": [
    "690850",
    [
      839143
    ]
  ],
  "./hi/calendar_appointment_group_edit.json": [
    "644748",
    [
      668268
    ]
  ],
  "./ga/quizzes_regrade_modal.json": [
    "972974",
    [
      814054
    ]
  ],
  "./ht/mutationActivity.json": [
    "925336",
    [
      791356
    ]
  ],
  "./sv-x-k12/user_search_results.json": [
    "443228",
    [
      543676
    ]
  ],
  "./he/calendar_sidebar.json": [
    "975714",
    [
      105914
    ]
  ],
  "./th/discussion_posts.json": [
    "737714",
    [
      267774
    ]
  ],
  "./es/outcome_reporting.json": [
    "650003",
    [
      258014
    ]
  ],
  "./ga/jobs_v2.json": [
    "376775",
    [
      573293
    ]
  ],
  "./ms/dashboard_grading_period_select.json": [
    "159064",
    [
      254984
    ]
  ],
  "./fr/quizzes.take_quiz.json": [
    "712284",
    [
      933061
    ]
  ],
  "./el/progress_pill.json": [
    "136044",
    [
      957384
    ]
  ],
  "./en-GB/mutationActivity.json": [
    "996755",
    [
      31810
    ]
  ],
  "./fi/self_enrollment.json": [
    "14784",
    [
      6568
    ]
  ],
  "./el/rootFoldersFinder.json": [
    "894198",
    [
      102266
    ]
  ],
  "./en-GB-x-ukhe/account_settings_jsx_bundle.json": [
    "799288",
    [
      22592
    ]
  ],
  "./hy/terms_of_use.json": [
    "990834",
    [
      335250
    ]
  ],
  "./nb-x-k12/course_template_details.json": [
    "209597",
    [
      403787
    ]
  ],
  "./is/todo.json": [
    "349314",
    [
      232914
    ]
  ],
  "./sv-x-k12/grade_summaryGroupView.json": [
    "554821",
    [
      499027
    ]
  ],
  "./tr/roster_section_selector.json": [
    "124225",
    [
      323763
    ]
  ],
  "./en-GB/react_files.json": [
    "395464",
    [
      294145
    ]
  ],
  "./it/accessibility_checker.json": [
    "354759",
    [
      970481
    ]
  ],
  "./sl/student_study_drawer.json": [
    "727852",
    [
      383528
    ]
  ],
  "./zh-Hans/gradebook_default_gradebook_components_content_filters_module_filter.json": [
    "607579",
    [
      485081
    ]
  ],
  "./de/accessibility_course_statistics.json": [
    "253827",
    [
      177158
    ]
  ],
  "./he/course_restore.json": [
    "725011",
    [
      678985
    ]
  ],
  "./ca/blueprint_course_child.json": [
    "806526",
    [
      697694
    ]
  ],
  "./nb-x-k12/assignments_2_submission_helpers.json": [
    "25762",
    [
      397746
    ]
  ],
  "./pt/OutcomeDescriptionModal.json": [
    "564173",
    [
      793791
    ]
  ],
  "./es-ES/k5_dashboard.json": [
    "693410",
    [
      455266
    ]
  ],
  "./ca/MasteryScale.json": [
    "17235",
    [
      964377
    ]
  ],
  "./ru/calendar_custom_recurring_event_repeat_picker.json": [
    "768365",
    [
      755995
    ]
  ],
  "./ru/DueDateOverrideView.json": [
    "757196",
    [
      129276
    ]
  ],
  "./is/blueprint_settingsCoursePickerTable.json": [
    "643508",
    [
      361300
    ]
  ],
  "./es-ES/assignment_index.json": [
    "902171",
    [
      90377
    ]
  ],
  "./zh-Hans/empty_course.json": [
    "209364",
    [
      316980
    ]
  ],
  "./zh-Hans/react_developer_keys.json": [
    "510660",
    [
      281572
    ]
  ],
  "./th/editGroup.json": [
    "33557",
    [
      721343
    ]
  ],
  "./is/course_paces_pace_picker.json": [
    "689153",
    [
      57495
    ]
  ],
  "./th/assignments_2_MoreOptions.json": [
    "816847",
    [
      495113
    ]
  ],
  "./ru/student_annotation_preview.json": [
    "45351",
    [
      469149
    ]
  ],
  "./nn/NewTabIndicator.json": [
    "521156",
    [
      607512
    ]
  ],
  "./ar/assignments_2_text_entry.json": [
    "622831",
    [
      240161
    ]
  ],
  "./pt/permissions_v2.json": [
    "591067",
    [
      184941
    ]
  ],
  "./da/question_bank.json": [
    "924826",
    [
      459826
    ]
  ],
  "./ko/assignments_2_external_tool.json": [
    "321746",
    [
      163802
    ]
  ],
  "./en-AU-x-unimelb/link_to_students.json": [
    "783759",
    [
      243489
    ]
  ],
  "./en-GB-x-lbs/CreateEditAssignmentModal.json": [
    "809030",
    [
      158062
    ]
  ],
  "./en-CA/widget_dashboard.json": [
    "563481",
    [
      261663
    ]
  ],
  "./sv/submit_online_url_assignment.json": [
    "608633",
    [
      813131
    ]
  ],
  "./sv-x-k12/course_paces_app.json": [
    "289709",
    [
      812443
    ]
  ],
  "./ko/course_paces_module.json": [
    "913775",
    [
      957405
    ]
  ],
  "./vi/blueprint_course_sidebar.json": [
    "7087",
    [
      679285
    ]
  ],
  "./zh-Hant/ai_experiences_ai_conversations.json": [
    "674120",
    [
      8820
    ]
  ],
  "./ru/quizzes_public.json": [
    "433502",
    [
      189270
    ]
  ],
  "./fr/modelsQuiz.json": [
    "575121",
    [
      314188
    ]
  ],
  "./fa/assignments_bulk_edit_use_save_assignment.json": [
    "164111",
    [
      727445
    ]
  ],
  "./ru/user.json": [
    "410046",
    [
      220534
    ]
  ],
  "./es/speed_grader_helpers.json": [
    "928623",
    [
      231490
    ]
  ],
  "./cy/edit_section_start_date.json": [
    "967490",
    [
      288634
    ]
  ],
  "./fr-CA/gradebookActionMenu.json": [
    "43376",
    [
      101572
    ]
  ],
  "./sv/todos_page.json": [
    "45640",
    [
      757356
    ]
  ],
  "./sv-x-k12/password_complexity_configuration.json": [
    "200422",
    [
      635694
    ]
  ],
  "./th/bulk_edit_students_table.json": [
    "806951",
    [
      864009
    ]
  ],
  "./it/calendar_custom_recurring_event_natural_language.json": [
    "301205",
    [
      918655
    ]
  ],
  "./nb-x-k12/course_paces_flaggable_number_input.json": [
    "826113",
    [
      237239
    ]
  ],
  "./zh-Hant/terms_index.json": [
    "865212",
    [
      620320
    ]
  ],
  "./en-AU-x-unimelb/quizzes_regrade_modal.json": [
    "318922",
    [
      981950
    ]
  ],
  "./nb-x-k12/login.json": [
    "999005",
    [
      241499
    ]
  ],
  "./uk/course_statistics.json": [
    "475699",
    [
      486073
    ]
  ],
  "./en-GB/blueprint_settingsSyncChange.json": [
    "830051",
    [
      110530
    ]
  ],
  "./nl/upload_button.json": [
    "924382",
    [
      945930
    ]
  ],
  "./sv/ignite_agent.json": [
    "498993",
    [
      975667
    ]
  ],
  "./tr/k5_dashboard_card.json": [
    "160038",
    [
      833394
    ]
  ],
  "./th/user_logins.json": [
    "861712",
    [
      472412
    ]
  ],
  "./it/peer_review_allocation_rules_tray.json": [
    "660142",
    [
      822330
    ]
  ],
  "./zh-Hans/gradebook.json": [
    "262135",
    [
      190509
    ]
  ],
  "./fa/paginated_list.json": [
    "330509",
    [
      37099
    ]
  ],
  "./ru/blueprint_settingsSyncHistory.json": [
    "518401",
    [
      626167
    ]
  ],
  "./th/modules_home_page.json": [
    "711043",
    [
      43461
    ]
  ],
  "./nl/NewTabIndicator.json": [
    "371402",
    [
      731550
    ]
  ],
  "./nb-x-k12/submit_online_url_assignment.json": [
    "548756",
    [
      774772
    ]
  ],
  "./nb/FindOutcomesModal.json": [
    "805005",
    [
      690543
    ]
  ],
  "./ru/dashboard_grades_page.json": [
    "309962",
    [
      642346
    ]
  ],
  "./th/student_entries.json": [
    "309438",
    [
      383706
    ]
  ],
  "./cy/DueDateOverrideView.json": [
    "129257",
    [
      358455
    ]
  ],
  "./fr/course_paces_footer.json": [
    "864762",
    [
      448671
    ]
  ],
  "./es-ES/CreateEditAssignmentModal.json": [
    "564113",
    [
      260167
    ]
  ],
  "./en-AU-x-unimelb/account_calendar_settings_filter_controls.json": [
    "826430",
    [
      359914
    ]
  ],
  "./zh-Hant/course_paces_blackout_date_row.json": [
    "638864",
    [
      658772
    ]
  ],
  "./pt/registration.json": [
    "704195",
    [
      468213
    ]
  ],
  "./da/rootFoldersFinder.json": [
    "226432",
    [
      920240
    ]
  ],
  "./ca/enhanced_individual_gradebook_submit_score.json": [
    "653421",
    [
      343667
    ]
  ],
  "./ja/modules_page_icon_legend.json": [
    "998276",
    [
      849345
    ]
  ],
  "./fr-CA/announcements_on_home_page.json": [
    "227521",
    [
      595547
    ]
  ],
  "./mi/comm_messages.json": [
    "779621",
    [
      872427
    ]
  ],
  "./ru/assignments_peer_reviews_student.json": [
    "564268",
    [
      643404
    ]
  ],
  "./sv-x-k12/assignment_index_menu.json": [
    "561025",
    [
      326407
    ]
  ],
  "./fr/quizzes_public.json": [
    "415077",
    [
      569760
    ]
  ],
  "./vi/jobs.json": [
    "97513",
    [
      112911
    ]
  ],
  "./nb-x-k12/modules_home_page.json": [
    "488005",
    [
      30579
    ]
  ],
  "./fa/ignite_agent.json": [
    "803757",
    [
      671627
    ]
  ],
  "./he/react_files.json": [
    "201886",
    [
      988750
    ]
  ],
  "./ga/terms_of_service_modal.json": [
    "473745",
    [
      852183
    ]
  ],
  "./nb/assignments_2_submission_helpers.json": [
    "21204",
    [
      250056
    ]
  ],
  "./ca/restore_content_pane.json": [
    "343253",
    [
      251403
    ]
  ],
  "./ga/discussionTopicKeyboradShortcutModal.json": [
    "992837",
    [
      618371
    ]
  ],
  "./sl/CoursesTray.json": [
    "744375",
    [
      436081
    ]
  ],
  "./sv-x-k12/gradebookActionMenu.json": [
    "725342",
    [
      793158
    ]
  ],
  "./en-AU/grades_summary.json": [
    "579891",
    [
      511918
    ]
  ],
  "./da-x-k12/blueprint_settingsSyncChange.json": [
    "630107",
    [
      316157
    ]
  ],
  "./he/course_paces_pace_picker.json": [
    "410240",
    [
      275680
    ]
  ],
  "./mi/lti_registration.wizard.json": [
    "387062",
    [
      228033
    ]
  ],
  "./de/assignments_2_student_content.json": [
    "285416",
    [
      668325
    ]
  ],
  "./uk/assignments_2_shared_Steps.json": [
    "211131",
    [
      657329
    ]
  ],
  "./fi/assignments_2_shared_Steps.json": [
    "18128",
    [
      386024
    ]
  ],
  "./uk/ai_experiences_ai_conversations.json": [
    "734270",
    [
      994718
    ]
  ],
  "./da-x-k12/a2_AccessibleTipContent.json": [
    "920727",
    [
      389657
    ]
  ],
  "./mi/assignments_peer_reviews.json": [
    "292193",
    [
      736159
    ]
  ],
  "./ht/rootFoldersFinder.json": [
    "85099",
    [
      750565
    ]
  ],
  "./sv-x-k12/registration.json": [
    "790262",
    [
      198526
    ]
  ],
  "./fr/announcements_v2.json": [
    "74391",
    [
      408358
    ]
  ],
  "./pl/jobs_v2.json": [
    "322387",
    [
      665589
    ]
  ],
  "./th/eportfolio.json": [
    "802099",
    [
      844781
    ]
  ],
  "./is/courses.show.json": [
    "42575",
    [
      858286
    ]
  ],
  "./nb/assignments_2_file_upload.json": [
    "899904",
    [
      823908
    ]
  ],
  "./sv/blueprint_coursesExpandableLockOptions.json": [
    "660696",
    [
      787172
    ]
  ],
  "./uk/peer_review_allocation_rule_card.json": [
    "777844",
    [
      336175
    ]
  ],
  "./it/courses.json": [
    "777725",
    [
      322583
    ]
  ],
  "./hi/change_password.json": [
    "913281",
    [
      502679
    ]
  ],
  "./hi/course_paces_blueprint_lock.json": [
    "661293",
    [
      54491
    ]
  ],
  "./pl/remove_pace_warning_modal.json": [
    "701329",
    [
      346283
    ]
  ],
  "./uk/MobileNavigation.json": [
    "282986",
    [
      740194
    ]
  ],
  "./ga/gradingPeriodTemplate.json": [
    "625509",
    [
      744531
    ]
  ],
  "./de/MobileNavigation.json": [
    "321239",
    [
      752098
    ]
  ],
  "./ar/blueprint_settingsSyncHistory.json": [
    "400667",
    [
      525413
    ]
  ],
  "./he.eager.json": [
    "47132",
    [
      408431
    ]
  ],
  "./ko/canvas_file_upload.json": [
    "768989",
    [
      587523
    ]
  ],
  "./mi/outcome_alignment_v2.json": [
    "596343",
    [
      220101
    ]
  ],
  "./sl/mutationActivity.json": [
    "153757",
    [
      192175
    ]
  ],
  "./ar/blueprint_settingsMigrationOptions.json": [
    "805788",
    [
      398176
    ]
  ],
  "./es-ES/permissions_v2_add_tray.json": [
    "82505",
    [
      132287
    ]
  ],
  "./nl/outcomes_user_outcome_results.json": [
    "399627",
    [
      43861
    ]
  ],
  "./cy/react_collaborations.json": [
    "918424",
    [
      269288
    ]
  ],
  "./is/assignments_2_student_content.json": [
    "677247",
    [
      48789
    ]
  ],
  "./ca/question_banks.json": [
    "567678",
    [
      769566
    ]
  ],
  "./en-GB-x-ukhe/auth_logging.json": [
    "533620",
    [
      912708
    ]
  ],
  "./hu/calendar_custom_recurring_event_natural_language.json": [
    "172607",
    [
      179805
    ]
  ],
  "./da-x-k12/assignments_2_MoreOptions_CanvasFiles.json": [
    "556510",
    [
      791858
    ]
  ],
  "./pt/assignments_2_login_action_prompt.json": [
    "969401",
    [
      161755
    ]
  ],
  "./nb/blueprint_settingsCoursePickerTable.json": [
    "967040",
    [
      328004
    ]
  ],
  "./sv/announcements_on_home_page.json": [
    "164337",
    [
      263051
    ]
  ],
  "./mi/course_paces_module.json": [
    "594771",
    [
      753129
    ]
  ],
  "./uk/context_roster_user_services.json": [
    "240910",
    [
      225774
    ]
  ],
  "./hi/account_calendar_settings_account_calendar_item.json": [
    "560088",
    [
      99312
    ]
  ],
  "./id/MobileNavigation.json": [
    "283189",
    [
      941407
    ]
  ],
  "./pt/bulk_edit_students_table.json": [
    "385191",
    [
      879865
    ]
  ],
  "./hi/user_lists.json": [
    "459878",
    [
      104030
    ]
  ],
  "./sv-x-k12/course_logging_details.json": [
    "256601",
    [
      747519
    ]
  ],
  "./pt-BR/accessibility_scan.json": [
    "531085",
    [
      16108
    ]
  ],
  "./uk/calendar_custom_recurring_event_repeat_picker.json": [
    "684140",
    [
      832676
    ]
  ],
  "./es-ES/LogoutButton.json": [
    "414579",
    [
      82273
    ]
  ],
  "./hi/login.json": [
    "214332",
    [
      51196
    ]
  ],
  "./ru/course_paces_footer.json": [
    "732404",
    [
      225597
    ]
  ],
  "./ms/discussion_insights.json": [
    "580246",
    [
      865398
    ]
  ],
  "./hu.json": [
    "394770",
    [
      847348
    ]
  ],
  "./ga/quizzes_index.json": [
    "168984",
    [
      90720
    ]
  ],
  "./fr-CA/bulk_edit_students_actions.json": [
    "870663",
    [
      213081
    ]
  ],
  "./ms/submissions_show_preview.json": [
    "810058",
    [
      940146
    ]
  ],
  "./zh-Hans/user_grades.json": [
    "651869",
    [
      799739
    ]
  ],
  "./sl/quiz_migration_notifications.json": [
    "256954",
    [
      168030
    ]
  ],
  "./ru/k5_course.json": [
    "872099",
    [
      488865
    ]
  ],
  "./ru/assignmentsToggleShowByView.json": [
    "592728",
    [
      440288
    ]
  ],
  "./pt/files_v2.json": [
    "364346",
    [
      664710
    ]
  ],
  "./es-ES/grade_change_logging_content.json": [
    "951277",
    [
      957963
    ]
  ],
  "./ms/IndividualStudentMasteryOutcome.json": [
    "523667",
    [
      894025
    ]
  ],
  "./el/plugins.json": [
    "200375",
    [
      590057
    ]
  ],
  "./ga/todos_page.json": [
    "79179",
    [
      638841
    ]
  ],
  "./is/jobs_v2.json": [
    "696287",
    [
      879445
    ]
  ],
  "./ms/unpublished_changes_button_props.json": [
    "205157",
    [
      803787
    ]
  ],
  "./sl/grade_summaryGroupView.json": [
    "841565",
    [
      954607
    ]
  ],
  "./en-GB/a2_AccessibleTipContent.json": [
    "799231",
    [
      536894
    ]
  ],
  "./ja/content_copy_redesign.json": [
    "377920",
    [
      124549
    ]
  ],
  "./fr/react_files.json": [
    "414253",
    [
      920856
    ]
  ],
  "./pt-BR/account_settings_jsx_bundle.json": [
    "160455",
    [
      897090
    ]
  ],
  "./fr/account_calendar_settings_footer.json": [
    "452726",
    [
      438267
    ]
  ],
  "./vi/account_calendar_settings_account_calendar_item_dropdown.json": [
    "560230",
    [
      984014
    ]
  ],
  "./hu/assignments_2_file_upload.json": [
    "724487",
    [
      897109
    ]
  ],
  "./is/sections_tooltip.json": [
    "987142",
    [
      499838
    ]
  ],
  "./pt-BR/quiz_migration_notifications.json": [
    "248148",
    [
      273449
    ]
  ],
  "./sv-x-k12/quiz_migration_notifications.json": [
    "80194",
    [
      900546
    ]
  ],
  "./hi/module_student_view_peer_reviews.json": [
    "934860",
    [
      614492
    ]
  ],
  "./pt-BR/dashboard.json": [
    "290739",
    [
      643702
    ]
  ],
  "./hu/Navigation.json": [
    "131273",
    [
      579703
    ]
  ],
  "./hy/modules_page_icon_legend.json": [
    "570186",
    [
      2730
    ]
  ],
  "./pt-BR/user_date_range_search.json": [
    "914950",
    [
      250479
    ]
  ],
  "./el/course_paces_search.json": [
    "701052",
    [
      286752
    ]
  ],
  "./sv/course_pace_date_input.json": [
    "796140",
    [
      638888
    ]
  ],
  "./th/MasteryScale.json": [
    "918595",
    [
      554045
    ]
  ],
  "./en-GB-x-ukhe/filter_calendars_modal.json": [
    "183160",
    [
      342224
    ]
  ],
  "./da-x-k12/choose_mastery_path.json": [
    "72936",
    [
      149916
    ]
  ],
  "./zh-Hant/assignmentsToggleShowByView.json": [
    "939627",
    [
      987613
    ]
  ],
  "./es/important_dates_empty.json": [
    "862944",
    [
      904789
    ]
  ],
  "./nn/eportfolio.json": [
    "848519",
    [
      856753
    ]
  ],
  "./ko/MobileGlobalMenu.json": [
    "800318",
    [
      491902
    ]
  ],
  "./pl/react_files.json": [
    "937125",
    [
      791327
    ]
  ],
  "./de/calendar_sidebar.json": [
    "203830",
    [
      942415
    ]
  ],
  "./cy/course_stats.json": [
    "941171",
    [
      336073
    ]
  ],
  "./is/permissions_v2.json": [
    "232479",
    [
      678677
    ]
  ],
  "./da-x-k12/peer_reviews_student.json": [
    "386435",
    [
      484525
    ]
  ],
  "./nb-x-k12/blueprint_settingsCoursePicker.json": [
    "872118",
    [
      67966
    ]
  ],
  "./uk/notebook.json": [
    "569131",
    [
      816929
    ]
  ],
  "./en-GB-x-ukhe/quizzes_regrade_modal.json": [
    "847332",
    [
      752484
    ]
  ],
  "./nl/youtube_migration.json": [
    "77278",
    [
      495602
    ]
  ],
  "./ms/content_copy_redesign.json": [
    "75873",
    [
      320671
    ]
  ],
  "./pt/section.json": [
    "966441",
    [
      916827
    ]
  ],
  "./zh-Hant/wiki_page_index.json": [
    "247597",
    [
      626071
    ]
  ],
  "./it/gradebook_default_gradebook_components_content_filters_module_filter.json": [
    "938789",
    [
      622159
    ]
  ],
  "./sl/ai_experiences.json": [
    "833507",
    [
      538765
    ]
  ],
  "./ja/blueprint_settingsMigrationSync.json": [
    "733163",
    [
      929702
    ]
  ],
  "./is/edit_section_view.json": [
    "363606",
    [
      868334
    ]
  ],
  "./sv/empty_modules.json": [
    "111016",
    [
      216828
    ]
  ],
  "./es/media_player_iframe_content.json": [
    "667801",
    [
      688584
    ]
  ],
  "./nl/discussion_settings.json": [
    "582872",
    [
      136468
    ]
  ],
  "./hu/k5_dashboard.json": [
    "897860",
    [
      906972
    ]
  ],
  "./pt-BR/MoveOutcomesModal.json": [
    "904958",
    [
      777031
    ]
  ],
  "./ja/assignments_2_peer_review.json": [
    "111698",
    [
      348987
    ]
  ],
  "./tr/submissions_show_preview.json": [
    "390540",
    [
      560608
    ]
  ],
  "./da/auth_logging.json": [
    "594311",
    [
      340197
    ]
  ],
  "./es/notebook_index.json": [
    "757296",
    [
      523909
    ]
  ],
  "./it/todos_page.json": [
    "440796",
    [
      281760
    ]
  ],
  "./pl/a2LatePolicyToolTipContent.json": [
    "41479",
    [
      403345
    ]
  ],
  "./sv-x-k12/content_migrations.json": [
    "417648",
    [
      377064
    ]
  ],
  "./id/course_paces_blackout_dates_modal.json": [
    "757965",
    [
      782455
    ]
  ],
  "./pt-BR/ProfileTray.json": [
    "946638",
    [
      411575
    ]
  ],
  "./cy/speed_grader_helpers.json": [
    "742911",
    [
      369021
    ]
  ],
  "./es-ES/GroupsTray.json": [
    "373449",
    [
      682015
    ]
  ],
  "./en-AU-x-unimelb/user.json": [
    "915881",
    [
      280475
    ]
  ],
  "./hy/quiz_statistics.json": [
    "485572",
    [
      960772
    ]
  ],
  "./pt/quiz_statistics.json": [
    "108379",
    [
      223917
    ]
  ],
  "./he/blueprint_settingsMigrationSync.json": [
    "3905",
    [
      982335
    ]
  ],
  "./ca/user_search_results.json": [
    "498931",
    [
      516537
    ]
  ],
  "./pt-BR/modules_page_icon_legend.json": [
    "50664",
    [
      622165
    ]
  ],
  "./da/course_pace_date_input.json": [
    "575678",
    [
      914302
    ]
  ],
  "./da-x-k12/theme_collection_view.json": [
    "945809",
    [
      275819
    ]
  ],
  "./es-ES/user_date_range_search.json": [
    "890854",
    [
      123038
    ]
  ],
  "./he/assignment_2_assignment_toggle_details.json": [
    "376751",
    [
      718893
    ]
  ],
  "./ht/discussionTopicKeyboradShortcutModal.json": [
    "156713",
    [
      917211
    ]
  ],
  "./nl/Navigation.json": [
    "527414",
    [
      327258
    ]
  ],
  "./vi/assignments_2_submission_histories_query.json": [
    "940593",
    [
      575719
    ]
  ],
  "./el/SpeedGraderSettingsMenu.json": [
    "690941",
    [
      172815
    ]
  ],
  "./nn/GroupDetailView.json": [
    "45501",
    [
      999327
    ]
  ],
  "./es/assignments_2_media_attempt.json": [
    "703548",
    [
      868233
    ]
  ],
  "./ga/rate_limiting_settings.json": [
    "452848",
    [
      160808
    ]
  ],
  "./hi/course_paces_module.json": [
    "709050",
    [
      407514
    ]
  ],
  "./en-GB-x-ukhe/assignments_2_student_content_rubric_self_assessment.json": [
    "143593",
    [
      39695
    ]
  ],
  "./nb/quiz_show.json": [
    "122621",
    [
      109351
    ]
  ],
  "./da-x-k12/peer_review_allocation_rules_tray.json": [
    "416482",
    [
      378438
    ]
  ],
  "./fr/accessibility_checker.json": [
    "462910",
    [
      317027
    ]
  ],
  "./da/GroupsTray.json": [
    "587559",
    [
      496453
    ]
  ],
  "./sv-x-k12/user_profile.json": [
    "96622",
    [
      380870
    ]
  ],
  "./fa/context_roster_user_services.json": [
    "213801",
    [
      483983
    ]
  ],
  "./nl/reset_pace_warning_modal.json": [
    "415686",
    [
      297154
    ]
  ],
  "./fr-CA/copy_warnings_modal.json": [
    "806878",
    [
      512298
    ]
  ],
  "./pt/Navigation.json": [
    "295376",
    [
      300988
    ]
  ],
  "./ca/rootFoldersFinder.json": [
    "426403",
    [
      47337
    ]
  ],
  "./da-x-k12/group_submission_reminder.json": [
    "522812",
    [
      478432
    ]
  ],
  "./hi/AccountsTray.json": [
    "700575",
    [
      899413
    ]
  ],
  "./hy/FindOutcomesModal.json": [
    "907158",
    [
      888078
    ]
  ],
  "./en-AU-x-unimelb/copy_course.json": [
    "658185",
    [
      795099
    ]
  ],
  "./nn/important_dates_empty.json": [
    "268100",
    [
      358416
    ]
  ],
  "./es/gradebook.json": [
    "853128",
    [
      118429
    ]
  ],
  "./en/horizon_toggle.json": [
    "692627",
    [
      42285
    ]
  ],
  "./id/last_attended.json": [
    "112039",
    [
      365617
    ]
  ],
  "./hy/accessibility_checker.json": [
    "725129",
    [
      826159
    ]
  ],
  "./fr-CA/assignments.never_drop.json": [
    "508795",
    [
      410318
    ]
  ],
  "./nb-x-k12/empty_modules.json": [
    "577787",
    [
      206569
    ]
  ],
  "./sl/add_edit_pseudonym.json": [
    "923954",
    [
      566822
    ]
  ],
  "./nl/calculator.json": [
    "164568",
    [
      943492
    ]
  ],
  "./es-ES/outcome_management.json": [
    "949687",
    [
      596845
    ]
  ],
  "./ca/calendar.header.json": [
    "168935",
    [
      717118
    ]
  ],
  "./uk/submissions_show_preview.json": [
    "914506",
    [
      757698
    ]
  ],
  "./mi/blueprint_settingsSyncHistory.json": [
    "912062",
    [
      473806
    ]
  ],
  "./ms/account_calendar_settings_footer.json": [
    "111302",
    [
      443590
    ]
  ],
  "./fi/notebook.json": [
    "722600",
    [
      504256
    ]
  ],
  "./en-CA/quizzes_public.json": [
    "736725",
    [
      777203
    ]
  ],
  "./mi/account_notification_settings.json": [
    "553909",
    [
      787515
    ]
  ],
  "./pl/peer_review_allocation_rule_card.json": [
    "26172",
    [
      570288
    ]
  ],
  "./sv/overview_page.json": [
    "505112",
    [
      575172
    ]
  ],
  "./sl/edit_section_dates.json": [
    "409069",
    [
      156503
    ]
  ],
  "./hu/top_navigation_tools.json": [
    "35225",
    [
      154951
    ]
  ],
  "./ca/CoursesTray.json": [
    "369548",
    [
      355204
    ]
  ],
  "./ht/assignments_2_student_points_display.json": [
    "142532",
    [
      90704
    ]
  ],
  "./th/assignments_2_submission_helpers.json": [
    "729484",
    [
      781504
    ]
  ],
  "./fr-CA/submit_online_url_assignment.json": [
    "531657",
    [
      249627
    ]
  ],
  "./zh-Hant.eager.json": [
    "996805",
    [
      445020
    ]
  ],
  "./it/assignments_2_url_entry.json": [
    "870961",
    [
      967035
    ]
  ],
  "./fa/assignment_2_assignment_toggle_details.json": [
    "443289",
    [
      459007
    ]
  ],
  "./it/courses.show.json": [
    "471188",
    [
      985891
    ]
  ],
  "./nn/choose_mastery_path.json": [
    "609681",
    [
      290355
    ]
  ],
  "./pt/blueprint_settingsMigrationOptions.json": [
    "745889",
    [
      178027
    ]
  ],
  "./en-GB/discovery_page.json": [
    "858349",
    [
      811032
    ]
  ],
  "./fr/copy_course.json": [
    "780985",
    [
      63124
    ]
  ],
  "./cy/account_calendar_settings_account_tree.json": [
    "659925",
    [
      906683
    ]
  ],
  "./cy/canvascareer.json": [
    "617156",
    [
      417468
    ]
  ],
  "./fa/link_validator.json": [
    "172072",
    [
      495152
    ]
  ],
  "./fi/copy_warnings_modal.json": [
    "812266",
    [
      284378
    ]
  ],
  "./es/homeroom_page.json": [
    "902148",
    [
      265265
    ]
  ],
  "./hi/discovery_page.json": [
    "420811",
    [
      160313
    ]
  ],
  "./sl/canvascareer.json": [
    "649193",
    [
      710651
    ]
  ],
  "./zh-Hans/calendar.header.json": [
    "594316",
    [
      361983
    ]
  ],
  "./zh-Hant/courses_show.json": [
    "521498",
    [
      49102
    ]
  ],
  "./da/webcam_modal.json": [
    "569112",
    [
      645240
    ]
  ],
  "./sv/terms_of_service_modal.json": [
    "570614",
    [
      16282
    ]
  ],
  "./ht/plugins.json": [
    "407734",
    [
      499498
    ]
  ],
  "./zh-Hant/quizzes_index.json": [
    "118826",
    [
      695206
    ]
  ],
  "./id/react_collaborations.json": [
    "235987",
    [
      311917
    ]
  ],
  "./pt-BR/blueprint_settingsCoursePickerTable.json": [
    "571829",
    [
      346804
    ]
  ],
  "./ar/section.json": [
    "226462",
    [
      593794
    ]
  ],
  "./da-x-k12/overview_page.json": [
    "746912",
    [
      541492
    ]
  ],
  "./nl/quizzes.take_quiz.json": [
    "363862",
    [
      849691
    ]
  ],
  "./nb/react_developer_keys.json": [
    "618553",
    [
      384867
    ]
  ],
  "./vi/knowledge_check_not_ready.json": [
    "705313",
    [
      311846
    ]
  ],
  "./de/unpublished_warning_modal.json": [
    "850819",
    [
      554566
    ]
  ],
  "./zh-Hant/outcomes_user_outcome_results.json": [
    "534356",
    [
      367169
    ]
  ],
  "./nn/peer_review_configuration_tray.json": [
    "26415",
    [
      574433
    ]
  ],
  "./ar/copy_course.json": [
    "655018",
    [
      412590
    ]
  ],
  "./fa/NewTabIndicator.json": [
    "780821",
    [
      167635
    ]
  ],
  "./nl/accessibility_scan.json": [
    "427272",
    [
      901300
    ]
  ],
  "./cy/copy_course.json": [
    "253553",
    [
      776495
    ]
  ],
  "./ko/overview_page.json": [
    "948183",
    [
      197877
    ]
  ],
  "./pt/account_settings_jsx_bundle.json": [
    "737606",
    [
      662178
    ]
  ],
  "./fi/account_calendar_settings_account_tree.json": [
    "428646",
    [
      998078
    ]
  ],
  "./pt-BR/terms_of_service_modal.json": [
    "209466",
    [
      892171
    ]
  ],
  "./en-GB-x-ukhe/gradebook_history.json": [
    "837261",
    [
      146283
    ]
  ],
  "./ht/course_paces_flaggable_number_input.json": [
    "717055",
    [
      646409
    ]
  ],
  "./fa/add_edit_pseudonym.json": [
    "915592",
    [
      523008
    ]
  ],
  "./ht/accessibility_course_statistics.json": [
    "606900",
    [
      789720
    ]
  ],
  "./de/user_date_range_search.json": [
    "101904",
    [
      509021
    ]
  ],
  "./nb-x-k12/course_paces_assignment_row.json": [
    "287869",
    [
      138827
    ]
  ],
  "./nb/syllabus_revisions.json": [
    "721600",
    [
      120460
    ]
  ],
  "./pt/peer_review_allocation_rule_card.json": [
    "403492",
    [
      71528
    ]
  ],
  "./zh-Hans/default_account_quotas.json": [
    "859172",
    [
      769879
    ]
  ],
  "./fa/gradebook_history.json": [
    "869918",
    [
      178230
    ]
  ],
  "./es/calendar_appointment_group_edit.json": [
    "921683",
    [
      928382
    ]
  ],
  "./hu/not_found_page_slide_puzzle.json": [
    "484014",
    [
      972254
    ]
  ],
  "./mi/peer_review_allocation_rule_card.json": [
    "486278",
    [
      483782
    ]
  ],
  "./nn/sidenav.json": [
    "526310",
    [
      653794
    ]
  ],
  "./it/calendar_custom_recurring_event_repeat_picker.json": [
    "932685",
    [
      949311
    ]
  ],
  "./pl/peer_reviews_student.json": [
    "434252",
    [
      567008
    ]
  ],
  "./en-GB/quiz_statistics.json": [
    "30966",
    [
      173699
    ]
  ],
  "./cy/peer_review_allocation_rules_tray.json": [
    "16651",
    [
      866801
    ]
  ],
  "./en-AU/react_collaborations.json": [
    "921882",
    [
      868515
    ]
  ],
  "./pt/assignments_2_text_entry.json": [
    "305646",
    [
      748962
    ]
  ],
  "./da/assignments_2_attempt_tab.json": [
    "134024",
    [
      773416
    ]
  ],
  "./sv-x-k12/discussion_posts.json": [
    "569647",
    [
      627797
    ]
  ],
  "./is/upload_button.json": [
    "983600",
    [
      204808
    ]
  ],
  "./uk/remove_pace_warning_modal.json": [
    "617001",
    [
      690919
    ]
  ],
  "./is/course_paces_blackout_date_row.json": [
    "432842",
    [
      944954
    ]
  ],
  "./fi/AlignmentSummary.json": [
    "263942",
    [
      789950
    ]
  ],
  "./sv/course_paces_pace_picker.json": [
    "353142",
    [
      441578
    ]
  ],
  "./th/course_paces_header.json": [
    "190516",
    [
      227992
    ]
  ],
  "./he/submissions_show_preview.json": [
    "224831",
    [
      724765
    ]
  ],
  "./ca/peer_review_configuration_tray.json": [
    "518131",
    [
      702201
    ]
  ],
  "./nb-x-k12/edit_section_dates.json": [
    "335782",
    [
      709150
    ]
  ],
  "./zh-Hans/peer_review_student_select.json": [
    "12917",
    [
      985603
    ]
  ],
  "./ar/course_paces_header.json": [
    "614691",
    [
      938549
    ]
  ],
  "./tr/account_calendars_results_area.json": [
    "990854",
    [
      285394
    ]
  ],
  "./en-GB-x-ukhe/course_paces_settings.json": [
    "797074",
    [
      66978
    ]
  ],
  "./tr/manage_avatars.json": [
    "362702",
    [
      982146
    ]
  ],
  "./fi/ai_experiences.json": [
    "262545",
    [
      606455
    ]
  ],
  "./pl/jobs.json": [
    "854526",
    [
      969938
    ]
  ],
  "./en-AU/wiki_page_index.json": [
    "361445",
    [
      825084
    ]
  ],
  "./ar/permissions_v2_add_tray.json": [
    "44107",
    [
      103917
    ]
  ],
  "./en-GB-x-ukhe/announcements_v2.json": [
    "372081",
    [
      308759
    ]
  ],
  "./ar/assignments_2_student_annotation.json": [
    "647642",
    [
      499854
    ]
  ],
  "./zh-Hans/reset_pace_warning_modal.json": [
    "536625",
    [
      976583
    ]
  ],
  "./id/account_calendars.json": [
    "288936",
    [
      907324
    ]
  ],
  "./nl/assignments_2_external_tool.json": [
    "112690",
    [
      844246
    ]
  ],
  "./de/assignments_2_submission_helpers.json": [
    "872621",
    [
      979996
    ]
  ],
  "./en-AU-x-unimelb/speed_grader_helpers.json": [
    "180999",
    [
      913969
    ]
  ],
  "./pt-BR/assignments_2_initial_query.json": [
    "925128",
    [
      53701
    ]
  ],
  "./uk/calculator.json": [
    "270654",
    [
      289950
    ]
  ],
  "./sv/course_paces_header.json": [
    "415689",
    [
      839139
    ]
  ],
  "./ht/copy_warnings_modal.json": [
    "163551",
    [
      603625
    ]
  ],
  "./ar/confirmMasteryModal.json": [
    "156819",
    [
      589429
    ]
  ],
  "./en/blueprint_settingsCoursePickerTable.json": [
    "187767",
    [
      448945
    ]
  ],
  "./sv/important_dates.json": [
    "398247",
    [
      288881
    ]
  ],
  "./ga/security_panel.json": [
    "969505",
    [
      901895
    ]
  ],
  "./en-CA/modelsQuiz.json": [
    "891073",
    [
      749287
    ]
  ],
  "./nb-x-k12/account_calendar_settings_utils.json": [
    "134032",
    [
      998600
    ]
  ],
  "./ca/file_not_found.json": [
    "843753",
    [
      159591
    ]
  ],
  "./ms/terms_index.json": [
    "489442",
    [
      131354
    ]
  ],
  "./nn/blueprint_settingsMigrationSync.json": [
    "493098",
    [
      715734
    ]
  ],
  "./en-GB/security_panel.json": [
    "694202",
    [
      540135
    ]
  ],
  "./ca/assignments.json": [
    "267196",
    [
      701684
    ]
  ],
  "./fr-CA/course_paces_blackout_dates_modal.json": [
    "910881",
    [
      578331
    ]
  ],
  "./th/quizzes_regrade_modal.json": [
    "810938",
    [
      130518
    ]
  ],
  "./sv/user_logins.json": [
    "405845",
    [
      249255
    ]
  ],
  "./nn/quizzes_openModerateStudentDialog.json": [
    "423024",
    [
      204748
    ]
  ],
  "./pt-BR/permissions_role_tray.json": [
    "650061",
    [
      992876
    ]
  ],
  "./de/assignments_peer_reviews.json": [
    "844990",
    [
      414503
    ]
  ],
  "./hi/account_notification_settings.json": [
    "25296",
    [
      521368
    ]
  ],
  "./is/calendar_custom_recurring_event_repeat_picker.json": [
    "205448",
    [
      438240
    ]
  ],
  "./ja/use_switch_experience.json": [
    "779318",
    [
      820663
    ]
  ],
  "./is/dashboard_grading_period_select.json": [
    "281676",
    [
      988828
    ]
  ],
  "./sv/user_search_results.json": [
    "35838",
    [
      713946
    ]
  ],
  "./en-AU-x-unimelb/react_files.json": [
    "307261",
    [
      530815
    ]
  ],
  "./he/quiz_statistics.json": [
    "565584",
    [
      907440
    ]
  ],
  "./ja/eportfolio.json": [
    "601020",
    [
      425529
    ]
  ],
  "./ga/content_migrations_redesign.json": [
    "771309",
    [
      689611
    ]
  ],
  "./uk/notebook_index.json": [
    "840408",
    [
      911896
    ]
  ],
  "./th/conferences.json": [
    "576313",
    [
      688627
    ]
  ],
  "./ga/quizzes_openModerateStudentDialog.json": [
    "125872",
    [
      504376
    ]
  ],
  "./ja/roster_section_input.json": [
    "688893",
    [
      240212
    ]
  ],
  "./tr/GroupDetailView.json": [
    "148311",
    [
      463001
    ]
  ],
  "./th/course_paces_errors.json": [
    "98406",
    [
      699402
    ]
  ],
  "./ms/course_paces_app.json": [
    "654856",
    [
      776504
    ]
  ],
  "./sv-x-k12/courses.json": [
    "750451",
    [
      682481
    ]
  ],
  "./ca/job_stats.json": [
    "579457",
    [
      403279
    ]
  ],
  "./en-GB/assignments_2_submission_helpers.json": [
    "490907",
    [
      5906
    ]
  ],
  "./sl/calendar.header.json": [
    "741212",
    [
      708099
    ]
  ],
  "./hu/HelpTray.json": [
    "623032",
    [
      937320
    ]
  ],
  "./vi/question_bank.json": [
    "913120",
    [
      603176
    ]
  ],
  "./cy/grades_empty_page.json": [
    "677086",
    [
      373038
    ]
  ],
  "./pt/assignments_peer_reviews.json": [
    "63199",
    [
      526809
    ]
  ],
  "./ms/moderate_quiz.json": [
    "776753",
    [
      343023
    ]
  ],
  "./pt-BR/account_calendar_settings_account_group.json": [
    "558429",
    [
      298604
    ]
  ],
  "./da/pairing_code_user_observees.json": [
    "572904",
    [
      91912
    ]
  ],
  "./vi/permission_button.json": [
    "836623",
    [
      885845
    ]
  ],
  "./fi/editGroup.json": [
    "195656",
    [
      360800
    ]
  ],
  "./ms/blueprint_settingsSyncHistory.json": [
    "697556",
    [
      410444
    ]
  ],
  "./de/assignment_index_deep_linking_handlers.json": [
    "63553",
    [
      396024
    ]
  ],
  "./uk/theme_editor.json": [
    "858889",
    [
      873031
    ]
  ],
  "./ga/last_attended.json": [
    "666290",
    [
      453986
    ]
  ],
  "./it/OutcomeDescriptionModal.json": [
    "874680",
    [
      586860
    ]
  ],
  "./th/important_dates.json": [
    "722738",
    [
      143113
    ]
  ],
  "./uk/CourseAvailabilityOptions.json": [
    "805666",
    [
      501962
    ]
  ],
  "./is/homeroom_page.json": [
    "727760",
    [
      951272
    ]
  ],
  "./fr-CA/question_bank.json": [
    "549348",
    [
      553288
    ]
  ],
  "./ru/discussionTopicKeyboradShortcutModal.json": [
    "796278",
    [
      471038
    ]
  ],
  "./tr/theme_editor.json": [
    "245523",
    [
      327821
    ]
  ],
  "./ms/quizzes.take_quiz.json": [
    "423244",
    [
      108929
    ]
  ],
  "./ca/course_template_details.json": [
    "922903",
    [
      813781
    ]
  ],
  "./es-ES/quizzes_openModerateStudentDialog.json": [
    "942861",
    [
      398491
    ]
  ],
  "./fr-CA/MobileNavigation.json": [
    "11913",
    [
      66211
    ]
  ],
  "./hy/assignments_2_student_header_date_title.json": [
    "640234",
    [
      149786
    ]
  ],
  "./pt/MobileNavigation.json": [
    "731450",
    [
      223934
    ]
  ],
  "./zh-Hans/ai_experiences_show.json": [
    "459481",
    [
      369183
    ]
  ],
  "./pt/course_search_results.json": [
    "450757",
    [
      17599
    ]
  ],
  "./ko/gradingGradeSummary.json": [
    "161853",
    [
      389795
    ]
  ],
  "./en-GB-x-ukhe/assignments_2_file_upload.json": [
    "698638",
    [
      486934
    ]
  ],
  "./tr/remove_pace_warning_modal.json": [
    "583847",
    [
      422017
    ]
  ],
  "./fr/react_developer_keys.json": [
    "91185",
    [
      944332
    ]
  ],
  "./ko/grades_empty_page.json": [
    "356076",
    [
      933508
    ]
  ],
  "./ja/course_paces_errors.json": [
    "378151",
    [
      637162
    ]
  ],
  "./hi/knowledge_check_not_ready.json": [
    "662792",
    [
      960496
    ]
  ],
  "./fa/ProfileTray.json": [
    "754745",
    [
      816302
    ]
  ],
  "./ms/permissions_role_tray_table_row.json": [
    "475120",
    [
      202544
    ]
  ],
  "./es-ES/course_paces_errors.json": [
    "337643",
    [
      45449
    ]
  ],
  "./es/ai_experiences.json": [
    "108738",
    [
      98299
    ]
  ],
  "./hy/assignmentsIndexView.json": [
    "207056",
    [
      971064
    ]
  ],
  "./is/course_paces_blueprint_lock.json": [
    "638734",
    [
      396166
    ]
  ],
  "./es-ES/SpeedGraderPostGradesMenu.json": [
    "622450",
    [
      621618
    ]
  ],
  "./es/not_found_page_slide_puzzle.json": [
    "112465",
    [
      735392
    ]
  ],
  "./id/DueDateOverrideView.json": [
    "598396",
    [
      932304
    ]
  ],
  "./ko/gradebookActionMenu.json": [
    "813271",
    [
      571573
    ]
  ],
  "./nn/MasteryScale.json": [
    "442903",
    [
      758337
    ]
  ],
  "./ms/peer_review_configuration_tray.json": [
    "2099",
    [
      447305
    ]
  ],
  "./vi/discussion_topics_edit.json": [
    "649507",
    [
      220833
    ]
  ],
  "./hy/quizzes_quiz_submission.json": [
    "400397",
    [
      465243
    ]
  ],
  "./fa/notebook_index.json": [
    "832275",
    [
      615025
    ]
  ],
  "./ja/peer_review_allocation_rules_tray.json": [
    "27290",
    [
      107651
    ]
  ],
  "./es-ES/accessibility_scan.json": [
    "232685",
    [
      652955
    ]
  ],
  "./zh-Hant/folder_tree.json": [
    "469449",
    [
      908339
    ]
  ],
  "./it/question_banks.json": [
    "958933",
    [
      53623
    ]
  ],
  "./ht/discussion_row.json": [
    "808849",
    [
      405011
    ]
  ],
  "./ms/dashboard_grades_page.json": [
    "121495",
    [
      404325
    ]
  ],
  "./ca/course_paces_modal.json": [
    "178334",
    [
      950270
    ]
  ],
  "./el/sharedCurveGradesDialog.json": [
    "819515",
    [
      530453
    ]
  ],
  "./da-x-k12/unpublished_changes_tray_contents.json": [
    "918406",
    [
      581162
    ]
  ],
  "./es-ES/a2_AccessibleTipContent.json": [
    "654779",
    [
      637481
    ]
  ],
  "./vi/terms_of_use.json": [
    "319840",
    [
      136728
    ]
  ],
  "./cy/self_unenrollment_modal.json": [
    "193364",
    [
      233260
    ]
  ],
  "./es/terms_of_use.json": [
    "655783",
    [
      953466
    ]
  ],
  "./ja/ImportConfirmBox.json": [
    "98749",
    [
      162516
    ]
  ],
  "./hu/sharedSetDefaultGradeDialog.json": [
    "484414",
    [
      593550
    ]
  ],
  "./sv-x-k12/accessibility_course_statistics.json": [
    "509163",
    [
      162902
    ]
  ],
  "./fr-CA/gradinggradingPeriodCollection.json": [
    "909892",
    [
      935080
    ]
  ],
  "./th/course_template_details.json": [
    "876423",
    [
      470241
    ]
  ],
  "./hi/discussion_topics_edit.json": [
    "776325",
    [
      164803
    ]
  ],
  "./tr/course_paces_change_tracking.json": [
    "884137",
    [
      317979
    ]
  ],
  "./fr/homeroom_page.json": [
    "685836",
    [
      994549
    ]
  ],
  "./fr-CA/account_calendar_settings.json": [
    "296537",
    [
      268867
    ]
  ],
  "./en-AU/peer_reviews_student.json": [
    "95990",
    [
      56471
    ]
  ],
  "./ht/course_color_selector.json": [
    "621673",
    [
      667347
    ]
  ],
  "./fr/student_entries.json": [
    "670622",
    [
      27179
    ]
  ],
  "./he/blueprint_course_sidebar.json": [
    "820665",
    [
      509383
    ]
  ],
  "./pt/CreateEditAssignmentModalAdapter.json": [
    "274991",
    [
      32193
    ]
  ],
  "./sv/course_link_validator.json": [
    "551092",
    [
      399888
    ]
  ],
  "./es/SpeedGraderSettingsMenu.json": [
    "75080",
    [
      797789
    ]
  ],
  "./hy/quizzes_regrade_modal.json": [
    "962961",
    [
      229031
    ]
  ],
  "./da-x-k12/user_search_results.json": [
    "449014",
    [
      783690
    ]
  ],
  "./ja/course_paces_flaggable_number_input.json": [
    "499014",
    [
      325639
    ]
  ],
  "./ko/OutcomeMoveModal.json": [
    "808198",
    [
      189142
    ]
  ],
  "./es-ES/assignment_index_menu.json": [
    "259715",
    [
      322561
    ]
  ],
  "./sl/assignments_2_student_header.json": [
    "338610",
    [
      870782
    ]
  ],
  "./vi/ai_experiences_edit.json": [
    "614510",
    [
      591798
    ]
  ],
  "./is/accessibility_course_statistics.json": [
    "901408",
    [
      779752
    ]
  ],
  "./ms/copy_course.json": [
    "129385",
    [
      579159
    ]
  ],
  "./ht/course_paces_blueprint_lock.json": [
    "314282",
    [
      489622
    ]
  ],
  "./hi/appt_calendar_event_dialog.json": [
    "304355",
    [
      511153
    ]
  ],
  "./ms/progress_pill.json": [
    "28677",
    [
      998219
    ]
  ],
  "./nb/react_collaborations.json": [
    "995032",
    [
      841188
    ]
  ],
  "./pl/manage_avatars.json": [
    "409664",
    [
      569060
    ]
  ],
  "./cy/jobs_v2.json": [
    "501507",
    [
      993913
    ]
  ],
  "./it/blueprint_coursesExpandableLockOptions.json": [
    "593540",
    [
      297840
    ]
  ],
  "./ms/homeroom_page.json": [
    "673372",
    [
      46436
    ]
  ],
  "./hy/LearningMasteryGradebook.json": [
    "491060",
    [
      390436
    ]
  ],
  "./nb-x-k12/file_not_found.json": [
    "442343",
    [
      62509
    ]
  ],
  "./sl/theme_editor.json": [
    "410584",
    [
      112916
    ]
  ],
  "./sv-x-k12/upload_button.json": [
    "861055",
    [
      292901
    ]
  ],
  "./sv-x-k12/assignments_2_MoreOptions.json": [
    "402968",
    [
      739648
    ]
  ],
  "./cy/change_password.json": [
    "372078",
    [
      276350
    ]
  ],
  "./uk/course_paces_blackout_dates_modal.json": [
    "282096",
    [
      64320
    ]
  ],
  "./hy/user_logins.json": [
    "409463",
    [
      154733
    ]
  ],
  "./sl/question_bank.json": [
    "265062",
    [
      449450
    ]
  ],
  "./hi/gradebook_default_gradebook_components_content_filters_module_filter.json": [
    "571363",
    [
      542929
    ]
  ],
  "./en-AU/gradinggradingPeriodCollection.json": [
    "416725",
    [
      342124
    ]
  ],
  "./hy/restore_content_pane.json": [
    "520696",
    [
      211264
    ]
  ],
  "./id/account_notification_settings.json": [
    "80798",
    [
      963290
    ]
  ],
  "./ko/dashboard_grading_period_select.json": [
    "547314",
    [
      789178
    ]
  ],
  "./ar/assignmentsIndexView.json": [
    "274320",
    [
      804204
    ]
  ],
  "./ms/new_user_tutorial.json": [
    "936857",
    [
      295879
    ]
  ],
  "./nl/calendar_edit.json": [
    "487559",
    [
      161
    ]
  ],
  "./pt/copy_course.json": [
    "61977",
    [
      220259
    ]
  ],
  "./sv/ProfileTray.json": [
    "480386",
    [
      189462
    ]
  ],
  "./el/roster_section_input.json": [
    "507917",
    [
      934719
    ]
  ],
  "./he/restore_content_pane.json": [
    "117668",
    [
      718492
    ]
  ],
  "./en-GB/sharedSetDefaultGradeDialog.json": [
    "204316",
    [
      95845
    ]
  ],
  "./zh-Hans/sharedSetDefaultGradeDialog.json": [
    "300202",
    [
      761306
    ]
  ],
  "./hy/unpublished_warning_modal.json": [
    "154811",
    [
      569561
    ]
  ],
  "./es-ES/Navigation.json": [
    "706731",
    [
      170761
    ]
  ],
  "./ca/gradingPeriodTemplate.json": [
    "397561",
    [
      799927
    ]
  ],
  "./nn/a2_AccessibleTipContent.json": [
    "193806",
    [
      592066
    ]
  ],
  "./pt/discussion_create.json": [
    "640927",
    [
      232897
    ]
  ],
  "./is/gradebook_uploads.json": [
    "441461",
    [
      113923
    ]
  ],
  "./ko/homeroom_page.json": [
    "953338",
    [
      65554
    ]
  ],
  "./fr/self_enrollment.json": [
    "622413",
    [
      723360
    ]
  ],
  "./pt-BR/discovery_page.json": [
    "378993",
    [
      70568
    ]
  ],
  "./fi/peer_review_allocation_rule_card.json": [
    "297763",
    [
      827025
    ]
  ],
  "./es-ES/empty_modules.json": [
    "270428",
    [
      969404
    ]
  ],
  "./fr/theme_editor.json": [
    "545593",
    [
      228700
    ]
  ],
  "./tr/account_calendar_settings_account_calendar_item_dropdown.json": [
    "366471",
    [
      931553
    ]
  ],
  "./en-AU-x-unimelb/calendar_custom_recurring_event_natural_language.json": [
    "104918",
    [
      964842
    ]
  ],
  "./fi/assignments_2_student_content.json": [
    "136590",
    [
      274358
    ]
  ],
  "./fr-CA/assignments_2_student_points_display.json": [
    "953703",
    [
      518041
    ]
  ],
  "./fr/rootFoldersFinder.json": [
    "750291",
    [
      257234
    ]
  ],
  "./ht/discussion_topics_edit.json": [
    "800872",
    [
      882028
    ]
  ],
  "./hu/gradingPeriodTemplate.json": [
    "781542",
    [
      500582
    ]
  ],
  "./nb/assignments_2_shared_Steps.json": [
    "858547",
    [
      258573
    ]
  ],
  "./nl/blueprint_course_child.json": [
    "987320",
    [
      575276
    ]
  ],
  "./ja/webzip_export.json": [
    "694687",
    [
      329122
    ]
  ],
  "./nb/rate_limiting_settings.json": [
    "826732",
    [
      378592
    ]
  ],
  "./tr/course_paces_settings.json": [
    "124358",
    [
      193298
    ]
  ],
  "./fr/assignments_2_login_action_prompt.json": [
    "328793",
    [
      399740
    ]
  ],
  "./uk/paginated_list.json": [
    "955750",
    [
      68246
    ]
  ],
  "./vi/SpeedGraderPostGradesMenu.json": [
    "167218",
    [
      322978
    ]
  ],
  "./sv-x-k12/quizzes_regrade_modal.json": [
    "917473",
    [
      786071
    ]
  ],
  "./de/course_paces_app.json": [
    "600645",
    [
      461668
    ]
  ],
  "./nn/grades_empty_page.json": [
    "434986",
    [
      989710
    ]
  ],
  "./fr/gradingPeriodTemplate.json": [
    "69769",
    [
      443780
    ]
  ],
  "./mi/terms_of_use.json": [
    "406905",
    [
      232263
    ]
  ],
  "./en-AU/grades_empty_page.json": [
    "897176",
    [
      424797
    ]
  ],
  "./da-x-k12/unpublished_warning_modal.json": [
    "253521",
    [
      531515
    ]
  ],
  "./ms/external_content_cancel.json": [
    "907082",
    [
      190738
    ]
  ],
  "./fa/custom_help_link.json": [
    "488405",
    [
      643059
    ]
  ],
  "./ar/widget_dashboard.json": [
    "352036",
    [
      856784
    ]
  ],
  "./el/Navigation.json": [
    "120047",
    [
      846777
    ]
  ],
  "./nb-x-k12/gradingGradeSummary.json": [
    "131337",
    [
      794383
    ]
  ],
  "./fa/top_navigation_tools.json": [
    "937747",
    [
      856913
    ]
  ],
  "./nb/modelsQuiz.json": [
    "670473",
    [
      822547
    ]
  ],
  "./da-x-k12/course_paces_settings.json": [
    "250569",
    [
      372699
    ]
  ],
  "./uk/account_course_user_search.json": [
    "92628",
    [
      231804
    ]
  ],
  "./vi/assignments_2_student_header_date_title.json": [
    "231228",
    [
      344444
    ]
  ],
  "./fr-CA/question_banks.json": [
    "737937",
    [
      216803
    ]
  ],
  "./pt/OutcomeMoveModal.json": [
    "237540",
    [
      373800
    ]
  ],
  "./pt/edit_section_end_date.json": [
    "542061",
    [
      867671
    ]
  ],
  "./pl/assignmentsToggleShowByView.json": [
    "527549",
    [
      404959
    ]
  ],
  "./fr/mutationActivity.json": [
    "825504",
    [
      458041
    ]
  ],
  "./hy/link_validator.json": [
    "938366",
    [
      544342
    ]
  ],
  "./hi/assignmentsIndexView.json": [
    "981024",
    [
      1224
    ]
  ],
  "./is/user.json": [
    "777389",
    [
      530459
    ]
  ],
  "./it/remove_pace_warning_modal.json": [
    "77484",
    [
      226392
    ]
  ],
  "./en-GB-x-lbs/course_restore.json": [
    "24740",
    [
      563844
    ]
  ],
  "./nn/module_student_view_peer_reviews.json": [
    "892813",
    [
      952495
    ]
  ],
  "./ru/LearningMasteryGradebook.json": [
    "591430",
    [
      820030
    ]
  ],
  "./ca/jobs.json": [
    "624534",
    [
      705990
    ]
  ],
  "./cy/edit_section_end_date.json": [
    "53253",
    [
      672779
    ]
  ],
  "./pl/error_form.json": [
    "963467",
    [
      529373
    ]
  ],
  "./fa/react_files.json": [
    "906116",
    [
      627380
    ]
  ],
  "./is/assignments_2_initial_query.json": [
    "342433",
    [
      572791
    ]
  ],
  "./ca/permission_button.json": [
    "24778",
    [
      610626
    ]
  ],
  "./ko/assignments_2_student_annotation.json": [
    "12577",
    [
      297807
    ]
  ],
  "./ru/assignment_grade_summary.json": [
    "289015",
    [
      642301
    ]
  ],
  "./sv-x-k12/account_calendar_settings_account_calendar_item_dropdown.json": [
    "183560",
    [
      937552
    ]
  ],
  "./en-GB-x-ukhe/gradebook_uploads.json": [
    "661019",
    [
      588873
    ]
  ],
  "./ar/appt_calendar_event_dialog.json": [
    "164243",
    [
      217757
    ]
  ],
  "./ga/calendar_appointment_group_edit.json": [
    "430367",
    [
      747429
    ]
  ],
  "./es/k5_dashboard_card.json": [
    "534872",
    [
      553101
    ]
  ],
  "./nb/canvascareer.json": [
    "543620",
    [
      764232
    ]
  ],
  "./sv-x-k12/a2_AccessibleTipContent.json": [
    "657489",
    [
      591095
    ]
  ],
  "./ca/discussionTopicKeyboradShortcutModal.json": [
    "514737",
    [
      206335
    ]
  ],
  "./de/course_link_validator.json": [
    "995630",
    [
      792919
    ]
  ],
  "./it/AlignmentSummary.json": [
    "951014",
    [
      225178
    ]
  ],
  "./ja/add_edit_pseudonym.json": [
    "373852",
    [
      230425
    ]
  ],
  "./it/SpeedGraderDiscussionsNavigation.json": [
    "516862",
    [
      810146
    ]
  ],
  "./es-ES/upload_button.json": [
    "25993",
    [
      557119
    ]
  ],
  "./el/calendar.header.json": [
    "557186",
    [
      881237
    ]
  ],
  "./ht/gradebook_default_gradebook_components_content_filters_module_filter.json": [
    "355302",
    [
      182274
    ]
  ],
  "./pt/content_exports.json": [
    "722587",
    [
      55893
    ]
  ],
  "./da/assignmentsToggleShowByView.json": [
    "565730",
    [
      119530
    ]
  ],
  "./ca/gradebook_default_gradebook_components_content_filters_module_filter.json": [
    "654142",
    [
      9310
    ]
  ],
  "./nn/course_paces_assignment_row.json": [
    "621731",
    [
      136509
    ]
  ],
  "./nn/folder_tree.json": [
    "534439",
    [
      454137
    ]
  ],
  "./pt-BR/media_player_iframe_content.json": [
    "106840",
    [
      317125
    ]
  ],
  "./uk/course_paces_change_tracking.json": [
    "983119",
    [
      821213
    ]
  ],
  "./it/comm_messages.json": [
    "151930",
    [
      977806
    ]
  ],
  "./es-ES/course_paces_no_results.json": [
    "564334",
    [
      240006
    ]
  ],
  "./ja/jobs.json": [
    "389301",
    [
      424940
    ]
  ],
  "./pt/course_navigation_settings.json": [
    "13462",
    [
      340386
    ]
  ],
  "./is/student_groups.json": [
    "46042",
    [
      670154
    ]
  ],
  "./zh-Hans/assignments_2_student_header.json": [
    "107810",
    [
      249522
    ]
  ],
  "./he/dashboard.json": [
    "313025",
    [
      167711
    ]
  ],
  "./it/FindOutcomesModal.json": [
    "781448",
    [
      652
    ]
  ],
  "./nl/roster_section_selector.json": [
    "129181",
    [
      47487
    ]
  ],
  "./sv-x-k12/self_enrollment.json": [
    "218006",
    [
      207470
    ]
  ],
  "./fr/content_migrations_redesign.json": [
    "214249",
    [
      100844
    ]
  ],
  "./es-ES/account_calendars_results_area.json": [
    "741291",
    [
      588185
    ]
  ],
  "./tr/homeroom_page.json": [
    "96710",
    [
      865378
    ]
  ],
  "./pl/filter_calendars_modal.json": [
    "651362",
    [
      330470
    ]
  ],
  "./ar/group_submission_reminder.json": [
    "208658",
    [
      139806
    ]
  ],
  "./es/HelpTray.json": [
    "66769",
    [
      870720
    ]
  ],
  "./fr/group_submission_reminder.json": [
    "632609",
    [
      173300
    ]
  ],
  "./ca/auth_logging.json": [
    "287770",
    [
      78162
    ]
  ],
  "./pl/react_scheduler.json": [
    "151019",
    [
      303365
    ]
  ],
  "./sl/assignments_2_peer_review.json": [
    "240624",
    [
      733396
    ]
  ],
  "./ga/available_pronouns_list.json": [
    "617563",
    [
      964473
    ]
  ],
  "./tr/filter_calendars_modal.json": [
    "325116",
    [
      5568
    ]
  ],
  "./sl/account_calendar_settings_utils.json": [
    "281061",
    [
      357935
    ]
  ],
  "./en-AU-x-unimelb/discussion_insights.json": [
    "927670",
    [
      140754
    ]
  ],
  "./zh-Hans/moderate_quiz.json": [
    "519918",
    [
      128166
    ]
  ],
  "./ga/edit_section_start_date.json": [
    "896774",
    [
      336862
    ]
  ],
  "./zh-Hant/assignments_bulk_edit.json": [
    "394044",
    [
      452528
    ]
  ],
  "./da-x-k12/assignments_2_MoreOptions.json": [
    "225238",
    [
      362010
    ]
  ],
  "./zh-Hans/assignments_bulk_edit.json": [
    "898585",
    [
      90959
    ]
  ],
  "./is/course_logging_details.json": [
    "921980",
    [
      539948
    ]
  ],
  "./es/discussion_insights.json": [
    "146814",
    [
      8367
    ]
  ],
  "./el/custom_help_link.json": [
    "828657",
    [
      453051
    ]
  ],
  "./it/error_form.json": [
    "238076",
    [
      716264
    ]
  ],
  "./nl/AssignmentGroupListItemView.json": [
    "534582",
    [
      194010
    ]
  ],
  "./nl/assignments_2_MoreOptions_CanvasFiles.json": [
    "480873",
    [
      496443
    ]
  ],
  "./mi/DueDateOverrideView.json": [
    "365523",
    [
      599817
    ]
  ],
  "./ru/blueprint_settingsAssociationsTable.json": [
    "624856",
    [
      123488
    ]
  ],
  "./ht/assignments_2_student_content.json": [
    "674003",
    [
      70245
    ]
  ],
  "./pl/user_logins.json": [
    "431464",
    [
      914439
    ]
  ],
  "./pt/blueprint_settingsSyncChange.json": [
    "835140",
    [
      590096
    ]
  ],
  "./de/homeroom_page.json": [
    "707803",
    [
      92750
    ]
  ],
  "./tr/suppress_notifications.json": [
    "521940",
    [
      227096
    ]
  ],
  "./es/context_prior_users.json": [
    "607761",
    [
      329120
    ]
  ],
  "./ga/link_validator.json": [
    "872151",
    [
      379005
    ]
  ],
  "./pt/context_modules_v2.json": [
    "171484",
    [
      278160
    ]
  ],
  "./uk/account_calendar_settings_account_list.json": [
    "232449",
    [
      94223
    ]
  ],
  "./en-AU-x-unimelb/quiz_show.json": [
    "674149",
    [
      425687
    ]
  ],
  "./sl/course_logging_details.json": [
    "662593",
    [
      491819
    ]
  ],
  "./vi/sidenav.json": [
    "685303",
    [
      171053
    ]
  ],
  "./fr/k5_dashboard_card.json": [
    "990464",
    [
      271457
    ]
  ],
  "./pt/ai_experiences_show.json": [
    "584082",
    [
      474902
    ]
  ],
  "./es-ES/assignments_peer_reviews.json": [
    "764564",
    [
      689732
    ]
  ],
  "./es/announcements_v2.json": [
    "383967",
    [
      870802
    ]
  ],
  "./pt/new_user_tutorial.json": [
    "414729",
    [
      651851
    ]
  ],
  "./hy/context_modules_v2.json": [
    "104305",
    [
      521943
    ]
  ],
  "./sl/roster_section_selector.json": [
    "258084",
    [
      175368
    ]
  ],
  "./fi/plugins.json": [
    "400859",
    [
      988249
    ]
  ],
  "./da-x-k12/quizzes_index.json": [
    "915829",
    [
      436247
    ]
  ],
  "./pt-BR/discussion_create.json": [
    "971018",
    [
      363179
    ]
  ],
  "./ht/content_share_preview_overlay.json": [
    "791807",
    [
      738001
    ]
  ],
  "./ko/question_bank.json": [
    "914227",
    [
      885785
    ]
  ],
  "./de/unpublished_changes_button_props.json": [
    "792224",
    [
      807645
    ]
  ],
  "./he/wiki_page_index.json": [
    "943880",
    [
      580792
    ]
  ],
  "./zh-Hans/course_pace_date_input.json": [
    "314242",
    [
      149410
    ]
  ],
  "./da-x-k12/discussionTopicKeyboradShortcutModal.json": [
    "271674",
    [
      817566
    ]
  ],
  "./sv/appointment_groups.json": [
    "464947",
    [
      434685
    ]
  ],
  "./en-GB-x-ukhe/discovery_page.json": [
    "19700",
    [
      337796
    ]
  ],
  "./id/custom_help_link.json": [
    "205421",
    [
      672007
    ]
  ],
  "./id/default_account_quotas.json": [
    "163058",
    [
      393302
    ]
  ],
  "./ca/webzip_export.json": [
    "603598",
    [
      15342
    ]
  ],
  "./ca/course_paces_no_results.json": [
    "202027",
    [
      540385
    ]
  ],
  "./fr-CA/discussionTopicKeyboradShortcutModal.json": [
    "1250",
    [
      532350
    ]
  ],
  "./da-x-k12/discussion_insights.json": [
    "645043",
    [
      327525
    ]
  ],
  "./is/discussion_settings.json": [
    "2578",
    [
      408930
    ]
  ],
  "./sl/assignments_2_student_header_date_title.json": [
    "133138",
    [
      60606
    ]
  ],
  "./nl/link_to_students.json": [
    "129609",
    [
      370235
    ]
  ],
  "./ga.json": [
    "757985",
    [
      411333
    ]
  ],
  "./ca/direct_share_course_import_panel.json": [
    "517046",
    [
      443174
    ]
  ],
  "./cy/discussionTopicKeyboradShortcutModal.json": [
    "296265",
    [
      583159
    ]
  ],
  "./nn/course_restore.json": [
    "925450",
    [
      360790
    ]
  ],
  "./vi/peer-review-assignment-widget.json": [
    "376997",
    [
      385712
    ]
  ],
  "./he/widget_dashboard.json": [
    "637288",
    [
      515192
    ]
  ],
  "./nn/grade_change_logging_content.json": [
    "419490",
    [
      705894
    ]
  ],
  "./id/peer_review_allocation_rules_tray.json": [
    "168798",
    [
      133994
    ]
  ],
  "./fa/files_v2.json": [
    "335477",
    [
      484067
    ]
  ],
  "./ht/student_entries.json": [
    "543350",
    [
      832626
    ]
  ],
  "./sv-x-k12/blueprint_settingsCourseFilter.json": [
    "721269",
    [
      109299
    ]
  ],
  "./hy/copy_warnings_modal.json": [
    "995384",
    [
      84096
    ]
  ],
  "./th/assignments_2_submission_histories_query.json": [
    "101826",
    [
      294830
    ]
  ],
  "./fr-CA/course_paces_blackout_dates_table.json": [
    "359520",
    [
      485188
    ]
  ],
  "./en-CA/blueprint_settingsUnsyncedChanges.json": [
    "632515",
    [
      949425
    ]
  ],
  "./nn/user_name.json": [
    "425373",
    [
      632063
    ]
  ],
  "./ht/custom_help_link.json": [
    "159154",
    [
      883158
    ]
  ],
  "./sv/grade_summaryGroupView.json": [
    "977291",
    [
      8485
    ]
  ],
  "./pl/user_date_range_search.json": [
    "258761",
    [
      405859
    ]
  ],
  "./es/course_search_results.json": [
    "677053",
    [
      649636
    ]
  ],
  "./uk/filter_calendars_modal.json": [
    "686276",
    [
      68002
    ]
  ],
  "./ms/LogoutButton.json": [
    "263128",
    [
      70472
    ]
  ],
  "./pt-BR/conversations_2.json": [
    "44802",
    [
      449907
    ]
  ],
  "./fr/user_restore.json": [
    "828324",
    [
      662629
    ]
  ],
  "./es-ES/mutationActivity.json": [
    "151527",
    [
      472141
    ]
  ],
  "./uk/quiz_log_auditing.json": [
    "460646",
    [
      338089
    ]
  ],
  "./hy/password_complexity_configuration.json": [
    "839926",
    [
      277918
    ]
  ],
  "./fr/peer_review_configuration_tray.json": [
    "296291",
    [
      61530
    ]
  ],
  "./fi/mutationActivity.json": [
    "401527",
    [
      579565
    ]
  ],
  "./fa/course_paces_actions.json": [
    "212695",
    [
      561629
    ]
  ],
  "./da/gradinggradingPeriodCollection.json": [
    "379286",
    [
      228710
    ]
  ],
  "./en-AU/calendar_appointment_group_edit.json": [
    "164693",
    [
      768300
    ]
  ],
  "./pt-BR/react_scheduler.json": [
    "386922",
    [
      303083
    ]
  ],
  "./vi/roster_section_input.json": [
    "865337",
    [
      673183
    ]
  ],
  "./hu/wiki_page_index.json": [
    "514648",
    [
      635080
    ]
  ],
  "./nl/copy_warnings_modal.json": [
    "261753",
    [
      52971
    ]
  ],
  "./fi/assignments_peer_reviews.json": [
    "270020",
    [
      319204
    ]
  ],
  "./he/course_paces_assignment_row.json": [
    "350992",
    [
      704144
    ]
  ],
  "./es-ES/speed_grader_helpers.json": [
    "826728",
    [
      810624
    ]
  ],
  "./ht/course_paces_footer.json": [
    "501474",
    [
      369142
    ]
  ],
  "./it/outcome_management.json": [
    "958535",
    [
      464033
    ]
  ],
  "./el/submit_online_url_assignment.json": [
    "638665",
    [
      77019
    ]
  ],
  "./cy/account_calendars_results_area.json": [
    "58276",
    [
      312636
    ]
  ],
  "./zh-Hans/appointment_groups.json": [
    "696045",
    [
      127995
    ]
  ],
  "./id/gradebook_history.json": [
    "945158",
    [
      642
    ]
  ],
  "./da-x-k12/courses.json": [
    "601321",
    [
      88251
    ]
  ],
  "./he/registration.json": [
    "701842",
    [
      99850
    ]
  ],
  "./de/gradinggradingPeriodCollection.json": [
    "834354",
    [
      913939
    ]
  ],
  "./el/blueprint_coursesExpandableLockOptions.json": [
    "850056",
    [
      287444
    ]
  ],
  "./da-x-k12/calendar_custom_recurring_event_natural_language.json": [
    "196609",
    [
      170947
    ]
  ],
  "./el/quiz_show.json": [
    "847460",
    [
      258016
    ]
  ],
  "./ga/course_template_details.json": [
    "857411",
    [
      19985
    ]
  ],
  "./de/context_modules_v2.json": [
    "402441",
    [
      478784
    ]
  ],
  "./cy/editGroup.json": [
    "141069",
    [
      581251
    ]
  ],
  "./nl/custom_help_link.json": [
    "966544",
    [
      378948
    ]
  ],
  "./pl/course_pace_date_input.json": [
    "953959",
    [
      140217
    ]
  ],
  "./da/account_calendar_settings_footer.json": [
    "807787",
    [
      316737
    ]
  ],
  "./el/error_form.json": [
    "93696",
    [
      80972
    ]
  ],
  "./pt/not_found_page_slide_puzzle.json": [
    "543417",
    [
      604267
    ]
  ],
  "./it/horizon_toggle.json": [
    "539801",
    [
      35771
    ]
  ],
  "./ja/conversations_2.json": [
    "482734",
    [
      237775
    ]
  ],
  "./mi/peer_review_student_select.json": [
    "740566",
    [
      869622
    ]
  ],
  "./fi/external_content_cancel.json": [
    "243643",
    [
      310953
    ]
  ],
  "./es-ES/roster_section_selector.json": [
    "510122",
    [
      298154
    ]
  ],
  "./ms/assignment_index_deep_linking_handlers.json": [
    "825012",
    [
      101708
    ]
  ],
  "./mi/copy_warnings_modal.json": [
    "406421",
    [
      568315
    ]
  ],
  "./mi/account_calendar_settings.json": [
    "978894",
    [
      234782
    ]
  ],
  "./pl/course_paces_assignment_row.json": [
    "221039",
    [
      826617
    ]
  ],
  "./pl/custom_emoji_deny_list.json": [
    "923932",
    [
      344552
    ]
  ],
  "./zh-Hant/authentication_providers.json": [
    "471233",
    [
      921635
    ]
  ],
  "./ms/roster_section_input.json": [
    "249354",
    [
      406258
    ]
  ],
  "./th/assignments_2_student_content.json": [
    "413323",
    [
      800541
    ]
  ],
  "./id/peer_review_allocation_rule_card.json": [
    "378995",
    [
      957533
    ]
  ],
  "./cy/assignments_2_student_content_rubric_self_assessment.json": [
    "255199",
    [
      41661
    ]
  ],
  "./hi/license_help.json": [
    "989480",
    [
      755648
    ]
  ],
  "./cy/grade_summaryGroupView.json": [
    "867560",
    [
      841944
    ]
  ],
  "./zh-Hans/assignments_2_text_entry.json": [
    "717895",
    [
      76573
    ]
  ],
  "./zh-Hant/dashboard_grades_page.json": [
    "209689",
    [
      323483
    ]
  ],
  "./da/overview_page.json": [
    "735958",
    [
      958182
    ]
  ],
  "./ja/GroupsTray.json": [
    "616445",
    [
      149460
    ]
  ],
  "./en/quiz_show.json": [
    "864910",
    [
      902458
    ]
  ],
  "./hu/assignments_2_media_attempt.json": [
    "422071",
    [
      478917
    ]
  ],
  "./is/admin_split.json": [
    "640250",
    [
      405290
    ]
  ],
  "./ms/canvas_file_upload.json": [
    "782435",
    [
      14265
    ]
  ],
  "./nb-x-k12/k5_course.json": [
    "932016",
    [
      367144
    ]
  ],
  "./nb/account_calendar_settings.json": [
    "591832",
    [
      299940
    ]
  ],
  "./ga/AccountsTray.json": [
    "144390",
    [
      162958
    ]
  ],
  "./sv-x-k12/blueprint_settingsCoursePickerTable.json": [
    "514503",
    [
      693677
    ]
  ],
  "./pt-BR/MobileGlobalMenu.json": [
    "993659",
    [
      938046
    ]
  ],
  "./ht/blueprint_course_child.json": [
    "374790",
    [
      622242
    ]
  ],
  "./tr/confirmMasteryModal.json": [
    "959774",
    [
      300298
    ]
  ],
  "./fr/assignments_2_attempt_tab.json": [
    "654191",
    [
      46078
    ]
  ],
  "./id/users.json": [
    "145747",
    [
      56869
    ]
  ],
  "./hu/copy_warnings_modal.json": [
    "957844",
    [
      748076
    ]
  ],
  "./mi/account_settings.json": [
    "859349",
    [
      581595
    ]
  ],
  "./cy/rubrics-export.json": [
    "194969",
    [
      968423
    ]
  ],
  "./zh-Hant/grade_change_logging_content.json": [
    "819408",
    [
      486580
    ]
  ],
  "./ko/manage_avatars.json": [
    "161146",
    [
      165266
    ]
  ],
  "./mi/SpeedGraderCheckpoints.json": [
    "573991",
    [
      993525
    ]
  ],
  "./mi/ai_experiences.json": [
    "472972",
    [
      969044
    ]
  ],
  "./th/peer_reviews_student.json": [
    "435380",
    [
      582408
    ]
  ],
  "./mi/progression_module_header.json": [
    "812884",
    [
      905388
    ]
  ],
  "./is/calculator.json": [
    "360794",
    [
      657322
    ]
  ],
  "./pl/CreateEditAssignmentModalAdapter.json": [
    "626855",
    [
      601321
    ]
  ],
  "./es-ES.eager.json": [
    "752246",
    [
      812257
    ]
  ],
  "./ru/student_study_drawer.json": [
    "617310",
    [
      504470
    ]
  ],
  "./hy/conferences.json": [
    "468554",
    [
      564794
    ]
  ],
  "./hu/user_date_range_search.json": [
    "420484",
    [
      685660
    ]
  ],
  "./fi/MobileNavigation.json": [
    "228997",
    [
      225043
    ]
  ],
  "./en-GB.eager.json": [
    "8010",
    [
      610017
    ]
  ],
  "./sl/context_prior_users.json": [
    "269890",
    [
      609334
    ]
  ],
  "./tr/assignments_2_student_content_rubric_self_assessment.json": [
    "678597",
    [
      834495
    ]
  ],
  "./zh-Hant/theme_editor.json": [
    "420275",
    [
      792637
    ]
  ],
  "./mi/change_password.json": [
    "922500",
    [
      405244
    ]
  ],
  "./mi/dashboard_grades_page.json": [
    "341001",
    [
      468407
    ]
  ],
  "./sv-x-k12/gradingGradeSummary.json": [
    "737692",
    [
      858380
    ]
  ],
  "./nb/quiz_migration_notifications.json": [
    "260107",
    [
      267301
    ]
  ],
  "./nb/user_search_results.json": [
    "567675",
    [
      799741
    ]
  ],
  "./nb/question_bank.json": [
    "261529",
    [
      624704
    ]
  ],
  "./nb/OutcomeMoveModal.json": [
    "121868",
    [
      960256
    ]
  ],
  "./zh-Hant/todos_page.json": [
    "542321",
    [
      190131
    ]
  ],
  "./ca/copy_course.json": [
    "290601",
    [
      537767
    ]
  ],
  "./fa/blueprint_coursesExpandableLockOptions.json": [
    "535596",
    [
      356796
    ]
  ],
  "./ko/blueprint_settingsUnsyncedChanges.json": [
    "998601",
    [
      207207
    ]
  ],
  "./ga/Navigation.json": [
    "210188",
    [
      432956
    ]
  ],
  "./sl/ai_experiences_edit.json": [
    "739512",
    [
      896932
    ]
  ],
  "./en-GB-x-lbs/security_panel.json": [
    "281227",
    [
      166457
    ]
  ],
  "./nb/nav_tourpoints.json": [
    "163773",
    [
      841927
    ]
  ],
  "./fa/link_to_students.json": [
    "666632",
    [
      855184
    ]
  ],
  "./de/accessibility_scan.json": [
    "890607",
    [
      792346
    ]
  ],
  "./nb/gradebook.json": [
    "820664",
    [
      51284
    ]
  ],
  "./vi/course_paces_change_tracking.json": [
    "473960",
    [
      6016
    ]
  ],
  "./sv-x-k12/announcements_on_home_page.json": [
    "947435",
    [
      913177
    ]
  ],
  "./hy/direct_share_course_import_panel.json": [
    "872384",
    [
      851441
    ]
  ],
  "./es-ES/assignments_2_submission_histories_query.json": [
    "380465",
    [
      106935
    ]
  ],
  "./zh-Hant/blueprint_settingsCoursePickerTable.json": [
    "406442",
    [
      733990
    ]
  ],
  "./ko/calendar_custom_recurring_event_natural_language.json": [
    "616272",
    [
      311744
    ]
  ],
  "./th/assignments_2_peer_review.json": [
    "141103",
    [
      742937
    ]
  ],
  "./hi/peer_review_allocation_rule_card.json": [
    "54309",
    [
      272819
    ]
  ],
  "./ht/pairing_code_user_observees.json": [
    "864971",
    [
      455789
    ]
  ],
  "./ht/ai_experiences_ai_conversations.json": [
    "441398",
    [
      399954
    ]
  ],
  "./sl/permissions_v2.json": [
    "181550",
    [
      853234
    ]
  ],
  "./en-GB/comm_messages.json": [
    "994598",
    [
      419771
    ]
  ],
  "./fi/CommentLibrary.json": [
    "223829",
    [
      642115
    ]
  ],
  "./sv/remove_pace_warning_modal.json": [
    "254432",
    [
      437964
    ]
  ],
  "./fa/remove_pace_warning_modal.json": [
    "582116",
    [
      105492
    ]
  ],
  "./nb/terms_index.json": [
    "418810",
    [
      252430
    ]
  ],
  "./ga/SpeedGraderCheckpoints.json": [
    "662597",
    [
      263411
    ]
  ],
  "./hi/blueprint_settingsCourseFilter.json": [
    "984341",
    [
      915443
    ]
  ],
  "./vi/edit_section_start_date.json": [
    "441655",
    [
      335965
    ]
  ],
  "./zh-Hant/react_collaborations.json": [
    "535378",
    [
      365558
    ]
  ],
  "./de/group_submission_reminder.json": [
    "396810",
    [
      460075
    ]
  ],
  "./th/CreateEditAssignmentModalAdapter.json": [
    "298351",
    [
      324625
    ]
  ],
  "./en-AU-x-unimelb/course_paces_settings.json": [
    "837724",
    [
      479432
    ]
  ],
  "./da-x-k12/gradebookOutcomeGradebookView.json": [
    "941650",
    [
      382206
    ]
  ],
  "./nl/terms_index.json": [
    "642768",
    [
      472196
    ]
  ],
  "./ru/assignment_index.json": [
    "871147",
    [
      517657
    ]
  ],
  "./cy/course_navigation_settings.json": [
    "765790",
    [
      967342
    ]
  ],
  "./ht/SpeedGraderPostGradesMenu.json": [
    "878087",
    [
      956593
    ]
  ],
  "./sv/user_name.json": [
    "832616",
    [
      425164
    ]
  ],
  "./fr-CA/account_calendar_settings_account_group.json": [
    "732281",
    [
      755595
    ]
  ],
  "./nl/CreateEditAssignmentModalAdapter.json": [
    "265493",
    [
      576055
    ]
  ],
  "./en-AU/k5_course.json": [
    "968176",
    [
      912469
    ]
  ],
  "./mi/student_groups.json": [
    "980531",
    [
      210048
    ]
  ],
  "./zh-Hans/course_template_details.json": [
    "827556",
    [
      394276
    ]
  ],
  "./es-ES/outcomes_user_outcome_results.json": [
    "543900",
    [
      209692
    ]
  ],
  "./ru/epub_exports.json": [
    "105655",
    [
      99933
    ]
  ],
  "./da-x-k12/course_pace_date_input.json": [
    "763156",
    [
      992408
    ]
  ],
  "./ca/default_account_quotas.json": [
    "983173",
    [
      559291
    ]
  ],
  "./mi/account_calendar_settings_account_calendar_item.json": [
    "688193",
    [
      925599
    ]
  ],
  "./it/AccountsTray.json": [
    "469169",
    [
      44363
    ]
  ],
  "./id/eportfolio.json": [
    "773456",
    [
      773020
    ]
  ],
  "./ja/default_account_quotas.json": [
    "539390",
    [
      243871
    ]
  ],
  "./uk/files_v2.json": [
    "321642",
    [
      936738
    ]
  ],
  "./zh-Hant/blueprint_coursesExpandableLockOptions.json": [
    "10673",
    [
      538107
    ]
  ],
  "./de/quizzes_openModerateStudentDialog.json": [
    "191231",
    [
      918442
    ]
  ],
  "./th/dashboard.json": [
    "299630",
    [
      425306
    ]
  ],
  "./en-GB-x-lbs/assignment_2_assignment_toggle_details.json": [
    "326604",
    [
      290636
    ]
  ],
  "./is/calendar_edit.json": [
    "377213",
    [
      604507
    ]
  ],
  "./nl/blueprint_settingsSyncHistory.json": [
    "39802",
    [
      305726
    ]
  ],
  "./mi/user_restore.json": [
    "168438",
    [
      135446
    ]
  ],
  "./sv-x-k12/confirmMasteryModal.json": [
    "104355",
    [
      899937
    ]
  ],
  "./da/assignments_peer_reviews.json": [
    "845746",
    [
      454970
    ]
  ],
  "./hi/announcements_on_home_page.json": [
    "570123",
    [
      335705
    ]
  ],
  "./da/progression_module_header.json": [
    "568573",
    [
      144931
    ]
  ],
  "./it/question_bank.json": [
    "799088",
    [
      809812
    ]
  ],
  "./uk/blueprint_settingsAssociationsTable.json": [
    "376301",
    [
      32819
    ]
  ],
  "./id/manage_avatars.json": [
    "801203",
    [
      507397
    ]
  ],
  "./zh-Hans/accessibility_course_statistics.json": [
    "152867",
    [
      236529
    ]
  ],
  "./ja/assignments_2_login_action_prompt.json": [
    "283608",
    [
      498493
    ]
  ],
  "./nb-x-k12/context_modules_v2.json": [
    "232582",
    [
      167998
    ]
  ],
  "./en-GB/gradebook.json": [
    "772825",
    [
      925444
    ]
  ],
  "./nl/authentication_providers.json": [
    "128733",
    [
      888031
    ]
  ],
  "./fi/user.json": [
    "413566",
    [
      498118
    ]
  ],
  "./da/SpeedGraderSettingsMenu.json": [
    "504403",
    [
      936505
    ]
  ],
  "./nl/blueprint_course_sidebar.json": [
    "800602",
    [
      787446
    ]
  ],
  "./pt/submit_assignment.json": [
    "484306",
    [
      280350
    ]
  ],
  "./th/discussion_insights.json": [
    "273350",
    [
      108826
    ]
  ],
  "./de/self_enrollment.json": [
    "844142",
    [
      909175
    ]
  ],
  "./ms/permissions_v2_add_tray.json": [
    "125504",
    [
      2720
    ]
  ],
  "./hy/account_calendars_modal.json": [
    "543016",
    [
      170848
    ]
  ],
  "./fr/account_calendar_settings.json": [
    "503520",
    [
      225393
    ]
  ],
  "./vi/assignmentsToggleShowByView.json": [
    "953992",
    [
      248064
    ]
  ],
  "./fi/calendar_custom_recurring_event_natural_language.json": [
    "516277",
    [
      539251
    ]
  ],
  "./tr/discussion_topics.json": [
    "197461",
    [
      134295
    ]
  ],
  "./fr-CA/registration.json": [
    "725252",
    [
      39816
    ]
  ],
  "./it/assignments_2_text_entry.json": [
    "37873",
    [
      137371
    ]
  ],
  "./pt/upload_button.json": [
    "169076",
    [
      161408
    ]
  ],
  "./nb/outcome_detail.json": [
    "100838",
    [
      652602
    ]
  ],
  "./hi/student_groups.json": [
    "639355",
    [
      679257
    ]
  ],
  "./ru/gradinggradingPeriodCollection.json": [
    "503392",
    [
      478888
    ]
  ],
  "./fr-CA/terms_of_use.json": [
    "215260",
    [
      736248
    ]
  ],
  "./zh-Hant/blueprint_settingsUnsyncedChanges.json": [
    "821685",
    [
      926567
    ]
  ],
  "./da/content_migrations.json": [
    "63100",
    [
      880980
    ]
  ],
  "./fa/modelsQuiz.json": [
    "482306",
    [
      304802
    ]
  ],
  "./ga/blueprint_settingsCourseFilter.json": [
    "529820",
    [
      302252
    ]
  ],
  "./id/progression_module_header.json": [
    "829071",
    [
      64825
    ]
  ],
  "./ja/progression_module_header.json": [
    "564859",
    [
      280182
    ]
  ],
  "./uk/folder_tree.json": [
    "559051",
    [
      248046
    ]
  ],
  "./sv/user_date_range_search.json": [
    "255914",
    [
      961310
    ]
  ],
  "./tr/nav_tourpoints.json": [
    "964387",
    [
      99405
    ]
  ],
  "./vi/copy_warnings_modal.json": [
    "618938",
    [
      189834
    ]
  ],
  "./vi/assignments_peer_reviews.json": [
    "560788",
    [
      56596
    ]
  ],
  "./pl/question_banks.json": [
    "303846",
    [
      985610
    ]
  ],
  "./nb/blueprint_settingsSyncChange.json": [
    "19820",
    [
      740936
    ]
  ],
  "./pt/grade_details.json": [
    "744044",
    [
      37544
    ]
  ],
  "./hy/assignments_bulk_edit.json": [
    "359393",
    [
      453063
    ]
  ],
  "./zh-Hans/speed_grader_helpers.json": [
    "441830",
    [
      144526
    ]
  ],
  "./fa/important_dates_empty.json": [
    "406377",
    [
      601535
    ]
  ],
  "./nb-x-k12/course_paces_footer.json": [
    "181996",
    [
      898668
    ]
  ],
  "./nn/account_notification_settings.json": [
    "968263",
    [
      679947
    ]
  ],
  "./sl/SpeedGraderCheckpoints.json": [
    "483572",
    [
      971344
    ]
  ],
  "./nb-x-k12/roster_publicjs.json": [
    "465010",
    [
      276034
    ]
  ],
  "./en-AU-x-unimelb/courses.show.json": [
    "979051",
    [
      96046
    ]
  ],
  "./is/assignments_2_external_tool.json": [
    "791136",
    [
      72280
    ]
  ],
  "./ko/notebook.json": [
    "155909",
    [
      3291
    ]
  ],
  "./th/assignments_2_student_points_display.json": [
    "73388",
    [
      771544
    ]
  ],
  "./ru/permissions_role_tray_table_row.json": [
    "115565",
    [
      823355
    ]
  ],
  "./es/assignments_2_shared_Steps.json": [
    "783875",
    [
      380750
    ]
  ],
  "./es/bulk_edit_students_actions.json": [
    "434340",
    [
      532945
    ]
  ],
  "./nb/outcomes_user_outcome_results.json": [
    "223913",
    [
      852739
    ]
  ],
  "./is/add_edit_pseudonym.json": [
    "576931",
    [
      229313
    ]
  ],
  "./ht/quizzes_public.json": [
    "877421",
    [
      837831
    ]
  ],
  "./en-GB/moderate_quiz.json": [
    "743840",
    [
      265945
    ]
  ],
  "./th/permissions_v2.json": [
    "889755",
    [
      643485
    ]
  ],
  "./es/course_paces_assignment_row.json": [
    "932815",
    [
      718274
    ]
  ],
  "./he/gradebookOutcomeGradebookView.json": [
    "331728",
    [
      115120
    ]
  ],
  "./it/account_course_user_search.json": [
    "48987",
    [
      825293
    ]
  ],
  "./da-x-k12/course_color_selector.json": [
    "342376",
    [
      663036
    ]
  ],
  "./en-GB-x-ukhe/course_paces_time_selection.json": [
    "758571",
    [
      674905
    ]
  ],
  "./el/MobileNavigation.json": [
    "695497",
    [
      30819
    ]
  ],
  "./is/SpeedGraderSettingsMenu.json": [
    "273412",
    [
      230308
    ]
  ],
  "./nl/paginated_list.json": [
    "249472",
    [
      400868
    ]
  ],
  "./zh-Hant/editAssignmentGroupWeights.json": [
    "791053",
    [
      241951
    ]
  ],
  "./zh-Hant/assignments_2_submission_histories_query.json": [
    "607280",
    [
      46372
    ]
  ],
  "./he/blueprint_settingsSyncChange.json": [
    "570705",
    [
      379503
    ]
  ],
  "./ga/paginated_list.json": [
    "211394",
    [
      14338
    ]
  ],
  "./he/lti_registrations.json": [
    "378287",
    [
      250061
    ]
  ],
  "./fi/speed_grader_helpers.json": [
    "508792",
    [
      852448
    ]
  ],
  "./he/webzip_export.json": [
    "218121",
    [
      739863
    ]
  ],
  "./mi/assignments_2_MoreOptions.json": [
    "345573",
    [
      721227
    ]
  ],
  "./en-GB/SpeedGraderCheckpoints.json": [
    "862314",
    [
      680303
    ]
  ],
  "./th/empty_course.json": [
    "219721",
    [
      15179
    ]
  ],
  "./it/quizzes.take_quiz.json": [
    "907773",
    [
      126630
    ]
  ],
  "./pt/media_player_iframe_content.json": [
    "439921",
    [
      843691
    ]
  ],
  "./zh-Hant/quiz_statistics.json": [
    "653189",
    [
      776759
    ]
  ],
  "./fa/course_paces_time_selection.json": [
    "257992",
    [
      791136
    ]
  ],
  "./is/modules_home_page.json": [
    "85847",
    [
      300621
    ]
  ],
  "./nb/discussion_topics.json": [
    "228819",
    [
      343365
    ]
  ],
  "./cy/Navigation.json": [
    "476808",
    [
      668952
    ]
  ],
  "./ms/grades_empty_page.json": [
    "602102",
    [
      894422
    ]
  ],
  "./vi/account_calendar_settings_utils.json": [
    "120975",
    [
      465810
    ]
  ],
  "./hu/course_link_validator.json": [
    "318122",
    [
      617906
    ]
  ],
  "./sl/LogoutButton.json": [
    "407401",
    [
      377251
    ]
  ],
  "./es/blueprint_coursesExpandableLockOptions.json": [
    "214563",
    [
      980846
    ]
  ],
  "./hu/account_calendar_settings.json": [
    "722631",
    [
      203957
    ]
  ],
  "./ja/assignments_2_attempt_tab.json": [
    "265618",
    [
      164603
    ]
  ],
  "./th/todo.json": [
    "743998",
    [
      124666
    ]
  ],
  "./hi/modules_page_icon_legend.json": [
    "624890",
    [
      55770
    ]
  ],
  "./ko/course_paces_projected_dates.json": [
    "889591",
    [
      802453
    ]
  ],
  "./da-x-k12/courses.show.json": [
    "723008",
    [
      214279
    ]
  ],
  "./fa/assignments_2_external_tool.json": [
    "973869",
    [
      966043
    ]
  ],
  "./pl/calculator.json": [
    "847510",
    [
      49098
    ]
  ],
  "./pt-BR/link_validator.json": [
    "767520",
    [
      291997
    ]
  ],
  "./ja/files_v2.json": [
    "534921",
    [
      402376
    ]
  ],
  "./ru/appointment_groups.json": [
    "781703",
    [
      180493
    ]
  ],
  "./sv/manage_avatars.json": [
    "708879",
    [
      457089
    ]
  ],
  "./ru/blueprint_settingsMigrationOptions.json": [
    "240406",
    [
      746894
    ]
  ],
  "./th/suppress_notifications.json": [
    "577582",
    [
      41338
    ]
  ],
  "./uk/gradebook_default_gradebook_components_content_filters_module_filter.json": [
    "624830",
    [
      403806
    ]
  ],
  "./vi/unpublished_warning_modal.json": [
    "416893",
    [
      957563
    ]
  ],
  "./nl/terms_of_use.json": [
    "752917",
    [
      197335
    ]
  ],
  "./he/CoursesTray.json": [
    "820083",
    [
      729641
    ]
  ],
  "./hu/content_migrations_redesign.json": [
    "559846",
    [
      136134
    ]
  ],
  "./cy/restore_content_pane.json": [
    "19133",
    [
      974515
    ]
  ],
  "./ru/LogoutButton.json": [
    "329027",
    [
      415921
    ]
  ],
  "./en/assignmentsIndexView.json": [
    "661776",
    [
      511652
    ]
  ],
  "./hi/youtube_migration.json": [
    "760319",
    [
      869109
    ]
  ],
  "./vi/webcam_modal.json": [
    "178850",
    [
      188226
    ]
  ],
  "./ca/quiz_statistics.json": [
    "389291",
    [
      181345
    ]
  ],
  "./it/roster_section_input.json": [
    "878377",
    [
      386635
    ]
  ],
  "./tr/assignments_2_student_content.json": [
    "718365",
    [
      410383
    ]
  ],
  "./en-AU/assignments_2_shared_Steps.json": [
    "198825",
    [
      558600
    ]
  ],
  "./ga/appointment_groups.json": [
    "626556",
    [
      740972
    ]
  ],
  "./nb-x-k12/course_navigation_settings.json": [
    "312040",
    [
      290768
    ]
  ],
  "./mi/overview_page.json": [
    "418051",
    [
      9561
    ]
  ],
  "./ht/react_developer_keys.json": [
    "479065",
    [
      321635
    ]
  ],
  "./is/ai_experiences_show.json": [
    "390054",
    [
      687630
    ]
  ],
  "./ja/dashboard.json": [
    "198103",
    [
      502298
    ]
  ],
  "./en-GB-x-lbs/submit_assignment.json": [
    "522088",
    [
      709584
    ]
  ],
  "./cy/confirmMasteryModal.json": [
    "134652",
    [
      211780
    ]
  ],
  "./th/k5_dashboard_card.json": [
    "191648",
    [
      947068
    ]
  ],
  "./vi/course_paces_header.json": [
    "918181",
    [
      121555
    ]
  ],
  "./uk/context_prior_users.json": [
    "739049",
    [
      199783
    ]
  ],
  "./es-ES/quizzes_index.json": [
    "385409",
    [
      129223
    ]
  ],
  "./nn/content_migrations_redesign.json": [
    "490285",
    [
      50431
    ]
  ],
  "./es/video_conference.json": [
    "111740",
    [
      759561
    ]
  ],
  "./nn/todo.json": [
    "478154",
    [
      414886
    ]
  ],
  "./fr/conferences_alternatives.json": [
    "33602",
    [
      413823
    ]
  ],
  "./uk/quizzes_regrade_modal.json": [
    "789482",
    [
      309090
    ]
  ],
  "./nn/conferences.json": [
    "448741",
    [
      640703
    ]
  ],
  "./cy/assignments_2_url_entry.json": [
    "35656",
    [
      283992
    ]
  ],
  "./vi/use_switch_experience.json": [
    "964914",
    [
      313186
    ]
  ],
  "./sv/assignments_2_file_upload.json": [
    "599253",
    [
      283263
    ]
  ],
  "./is/epub_exports.json": [
    "452240",
    [
      327704
    ]
  ],
  "./fr-CA/outcomes_user_outcome_results.json": [
    "222816",
    [
      768748
    ]
  ],
  "./pt-BR/course_paces_blueprint_lock.json": [
    "605655",
    [
      25954
    ]
  ],
  "./hi/assignments_2_external_tool.json": [
    "739839",
    [
      721701
    ]
  ],
  "./ar/filter_calendars_modal.json": [
    "989375",
    [
      410329
    ]
  ],
  "./th/permissions_role_tray_table_row.json": [
    "96032",
    [
      543628
    ]
  ],
  "./ru/peer_review_allocation_rules_tray.json": [
    "70862",
    [
      830502
    ]
  ],
  "./da-x-k12/conferences_alternatives.json": [
    "652945",
    [
      863723
    ]
  ],
  "./nb/account_calendar_settings_utils.json": [
    "846346",
    [
      953246
    ]
  ],
  "./sv/webcam_modal.json": [
    "838998",
    [
      451314
    ]
  ],
  "./zh-Hans/grades_summary.json": [
    "391892",
    [
      826452
    ]
  ],
  "./es/peer_review_configuration_tray.json": [
    "505739",
    [
      711990
    ]
  ],
  "./uk/peer_review_configuration_tray.json": [
    "257331",
    [
      852985
    ]
  ],
  "./tr/discussion_posts.json": [
    "177208",
    [
      463916
    ]
  ],
  "./ar/video_conference.json": [
    "427173",
    [
      316583
    ]
  ],
  "./nb/content_migrations.json": [
    "610045",
    [
      888831
    ]
  ],
  "./es/react_scheduler.json": [
    "669771",
    [
      254614
    ]
  ],
  "./fr/course_pace_date_input.json": [
    "465263",
    [
      740406
    ]
  ],
  "./sv-x-k12/conferences.json": [
    "316730",
    [
      985418
    ]
  ],
  "./mi/assignments_2_student_header_date_title.json": [
    "971835",
    [
      921729
    ]
  ],
  "./zh-Hant/empty_course.json": [
    "154587",
    [
      892869
    ]
  ],
  "./de/empty_course.json": [
    "510324",
    [
      298729
    ]
  ],
  "./en-GB/new_user_tutorial.json": [
    "12412",
    [
      629821
    ]
  ],
  "./nn/license_help.json": [
    "157697",
    [
      583723
    ]
  ],
  "./zh-Hans/account_calendars_results_area.json": [
    "170621",
    [
      542139
    ]
  ],
  "./da/choose_mastery_path.json": [
    "624338",
    [
      164890
    ]
  ],
  "./ht/discovery_page.json": [
    "78494",
    [
      862002
    ]
  ],
  "./mi/assignment_grade_summary.json": [
    "315418",
    [
      534402
    ]
  ],
  "./en-AU/assignments_2_attempt_tab.json": [
    "655541",
    [
      919692
    ]
  ],
  "./nl/overview_page.json": [
    "360183",
    [
      601513
    ]
  ],
  "./uk/ai_experiences.json": [
    "32650",
    [
      469378
    ]
  ],
  "./es/account_calendar_settings_account_tree.json": [
    "9349",
    [
      794700
    ]
  ],
  "./ca/assignment_2_assignment_toggle_details.json": [
    "858022",
    [
      632086
    ]
  ],
  "./uk/user_lists.json": [
    "957195",
    [
      636865
    ]
  ],
  "./sv-x-k12/ImportConfirmBox.json": [
    "631939",
    [
      742897
    ]
  ],
  "./ga/AssignmentGroupListItemView.json": [
    "418848",
    [
      892584
    ]
  ],
  "./fr-CA/ImportConfirmBox.json": [
    "91405",
    [
      641183
    ]
  ],
  "./pl/AssignmentListItemView.json": [
    "79797",
    [
      526887
    ]
  ],
  "./zh-Hans/account_calendars.json": [
    "293310",
    [
      791350
    ]
  ],
  "./ja/account_calendars.json": [
    "263820",
    [
      643145
    ]
  ],
  "./en-AU-x-unimelb/OutcomeMoveModal.json": [
    "519764",
    [
      313904
    ]
  ],
  "./en-GB-x-lbs/blueprint_settingsMigrationSync.json": [
    "873808",
    [
      246952
    ]
  ],
  "./sv-x-k12/context_modules_v2.json": [
    "650977",
    [
      640487
    ]
  ],
  "./de/course_stats.json": [
    "824566",
    [
      915055
    ]
  ],
  "./el/course_paces_module.json": [
    "762120",
    [
      714604
    ]
  ],
  "./ms/last_attended.json": [
    "424638",
    [
      455662
    ]
  ],
  "./th/sharedCurveGradesDialog.json": [
    "499290",
    [
      246710
    ]
  ],
  "./mi/assignmentsToggleShowByView.json": [
    "172539",
    [
      142913
    ]
  ],
  "./is/course_paces_modal.json": [
    "833922",
    [
      400690
    ]
  ],
  "./is/restore_content_pane.json": [
    "815577",
    [
      454191
    ]
  ],
  "./ms/course_navigation_settings.json": [
    "892198",
    [
      195334
    ]
  ],
  "./pt/course_paces_app.json": [
    "1784",
    [
      840164
    ]
  ],
  "./sv-x-k12/external_content_cancel.json": [
    "454217",
    [
      392175
    ]
  ],
  "./ko/student_entries.json": [
    "242228",
    [
      58492
    ]
  ],
  "./pt/conversations_2.json": [
    "91275",
    [
      695957
    ]
  ],
  "./de/MobileGlobalMenu.json": [
    "324809",
    [
      549712
    ]
  ],
  "./fa/notebook.json": [
    "393424",
    [
      855416
    ]
  ],
  "./ca/permissions.json": [
    "468758",
    [
      247494
    ]
  ],
  "./pl/user_name.json": [
    "165617",
    [
      179539
    ]
  ],
  "./sv/course_paces_blackout_dates_table.json": [
    "77904",
    [
      376692
    ]
  ],
  "./da-x-k12/content_migrations_redesign.json": [
    "234624",
    [
      613916
    ]
  ],
  "./it/gradingPeriodTemplate.json": [
    "572208",
    [
      512420
    ]
  ],
  "./fr-CA/NewTabIndicator.json": [
    "511449",
    [
      264539
    ]
  ],
  "./fr/assignments_2_MoreOptions.json": [
    "523311",
    [
      337422
    ]
  ],
  "./hi/outcome_detail.json": [
    "576743",
    [
      672413
    ]
  ],
  "./zh-Hans/AssignmentListItemView.json": [
    "546188",
    [
      127468
    ]
  ],
  "./es-ES/registration.json": [
    "473776",
    [
      280376
    ]
  ],
  "./it/user_date_range_search.json": [
    "65014",
    [
      602778
    ]
  ],
  "./ht/assignments_2_external_tool.json": [
    "729356",
    [
      625448
    ]
  ],
  "./ga/custom_emoji_deny_list.json": [
    "833336",
    [
      215472
    ]
  ],
  "./de/collaborations.json": [
    "454421",
    [
      733204
    ]
  ],
  "./fr-CA/CoursesTray.json": [
    "186753",
    [
      729507
    ]
  ],
  "./en-GB-x-lbs/jobs.json": [
    "886312",
    [
      69456
    ]
  ],
  "./ga/account_calendar_settings_filter_controls.json": [
    "413042",
    [
      184786
    ]
  ],
  "./ko/OutcomeDescriptionModal.json": [
    "443271",
    [
      508389
    ]
  ],
  "./nn/CourseAvailabilityOptions.json": [
    "29950",
    [
      428898
    ]
  ],
  "./fr/custom_help_link.json": [
    "686346",
    [
      889087
    ]
  ],
  "./zh-Hans/permission_button.json": [
    "83285",
    [
      987123
    ]
  ],
  "./nb-x-k12/user_restore.json": [
    "526254",
    [
      779670
    ]
  ],
  "./pt/rootFoldersFinder.json": [
    "495603",
    [
      198909
    ]
  ],
  "./sv-x-k12/notebook.json": [
    "846198",
    [
      423758
    ]
  ],
  "./he/peer_reviews_student.json": [
    "336245",
    [
      779099
    ]
  ],
  "./cy/progressbar_view.json": [
    "303966",
    [
      660526
    ]
  ],
  "./is/internal-settings.json": [
    "477855",
    [
      215893
    ]
  ],
  "./sv-x-k12/unpublished_warning_modal.json": [
    "864875",
    [
      559593
    ]
  ],
  "./vi/quiz_show.json": [
    "583179",
    [
      585792
    ]
  ],
  "./hy/permissions_role_tray.json": [
    "457339",
    [
      846137
    ]
  ],
  "./nb-x-k12/blueprint_settingsMigrationSync.json": [
    "516420",
    [
      418484
    ]
  ],
  "./pt/users.json": [
    "453398",
    [
      251770
    ]
  ],
  "./nb/assignments_2_student_content_rubric_self_assessment.json": [
    "509983",
    [
      427377
    ]
  ],
  "./zh-Hans/LogoutButton.json": [
    "262617",
    [
      87615
    ]
  ],
  "./uk/copy_warnings_modal.json": [
    "993303",
    [
      34901
    ]
  ],
  "./es-ES/ai_experiences_edit.json": [
    "558638",
    [
      912742
    ]
  ],
  "./hy/course_template_details.json": [
    "53260",
    [
      529724
    ]
  ],
  "./hi/k5_dashboard.json": [
    "789280",
    [
      383400
    ]
  ],
  "./ru/peer_review_student_select.json": [
    "464283",
    [
      789353
    ]
  ],
  "./hi/submit_online_url_assignment.json": [
    "23947",
    [
      733065
    ]
  ],
  "./id/edit_section_dates.json": [
    "218579",
    [
      604349
    ]
  ],
  "./en-GB-x-ukhe/assignmentsIndexView.json": [
    "209123",
    [
      949905
    ]
  ],
  "./zh-Hant/permission_button.json": [
    "844272",
    [
      620372
    ]
  ],
  "./pl/user_lists.json": [
    "321891",
    [
      231213
    ]
  ],
  "./fr/gradingGradeSummary.json": [
    "904631",
    [
      178286
    ]
  ],
  "./pl/EditMasteryScaleLink.json": [
    "794827",
    [
      519405
    ]
  ],
  "./zh-Hant/available_pronouns_list.json": [
    "459429",
    [
      858135
    ]
  ],
  "./cy/blueprint_settingsSyncChange.json": [
    "324716",
    [
      763348
    ]
  ],
  "./da/discussion_pinned_post.json": [
    "196029",
    [
      998819
    ]
  ],
  "./ga/internal-settings.json": [
    "954887",
    [
      474029
    ]
  ],
  "./ga/blueprint_settingsCoursePickerTable.json": [
    "314476",
    [
      426076
    ]
  ],
  "./vi/AlignmentSummary.json": [
    "471414",
    [
      987022
    ]
  ],
  "./ar/course_paces_blueprint_lock.json": [
    "476701",
    [
      386871
    ]
  ],
  "./pl/announcements_on_home_page.json": [
    "449642",
    [
      392158
    ]
  ],
  "./da/react_collaborations.json": [
    "719833",
    [
      751607
    ]
  ],
  "./fr/account_settings.json": [
    "957899",
    [
      703858
    ]
  ],
  "./pt/authentication_providers.json": [
    "740379",
    [
      46773
    ]
  ],
  "./ru/unpublished_warning_modal.json": [
    "237325",
    [
      669915
    ]
  ],
  "./sl/quizzes.take_quiz.json": [
    "79635",
    [
      933808
    ]
  ],
  "./nl/entity_search_form.json": [
    "257607",
    [
      36601
    ]
  ],
  "./th/account_calendar_settings_account_calendar_item_dropdown.json": [
    "548165",
    [
      363847
    ]
  ],
  "./nn/react_developer_keys.json": [
    "659517",
    [
      614727
    ]
  ],
  "./sv/a2LatePolicyToolTipContent.json": [
    "760040",
    [
      924276
    ]
  ],
  "./ca/edit_section_start_date.json": [
    "563242",
    [
      776098
    ]
  ],
  "./hu/ai_experiences_ai_conversations.json": [
    "614393",
    [
      690375
    ]
  ],
  "./pt/assignments_2_student_points_display.json": [
    "560428",
    [
      572360
    ]
  ],
  "./uk/assignments_2_external_tool.json": [
    "205204",
    [
      976892
    ]
  ],
  "./ms/unpublished_warning_modal.json": [
    "88728",
    [
      950024
    ]
  ],
  "./en-AU-x-unimelb/assignments_2_student_content.json": [
    "823675",
    [
      363477
    ]
  ],
  "./en-AU/gradebook_uploads.json": [
    "435215",
    [
      349426
    ]
  ],
  "./ca/eportfolio.json": [
    "134979",
    [
      182281
    ]
  ],
  "./vi/assignment_index_deep_linking_handlers.json": [
    "819879",
    [
      357677
    ]
  ],
  "./hi/grade_summary.json": [
    "846629",
    [
      795587
    ]
  ],
  "./en-AU-x-unimelb/course_paces_pace_picker.json": [
    "625413",
    [
      604247
    ]
  ],
  "./da/jobs_v2.json": [
    "652628",
    [
      833948
    ]
  ],
  "./fi/discussion_insights.json": [
    "371295",
    [
      709781
    ]
  ],
  "./fr/submit_online_url_assignment.json": [
    "147854",
    [
      910995
    ]
  ],
  "./sv-x-k12/IndividualStudentMasteryOutcome.json": [
    "532004",
    [
      32676
    ]
  ],
  "./zh-Hant/LearningMasteryGradebook.json": [
    "195087",
    [
      527585
    ]
  ],
  "./nl/student_annotation_preview.json": [
    "770522",
    [
      238558
    ]
  ],
  "./ar/account_settings_jsx_bundle.json": [
    "468029",
    [
      816959
    ]
  ],
  "./cy/react_files.json": [
    "182229",
    [
      586363
    ]
  ],
  "./ar/course_paces_errors.json": [
    "533921",
    [
      598963
    ]
  ],
  "./de/section.json": [
    "656822",
    [
      719247
    ]
  ],
  "./ca/edit_section_end_date.json": [
    "727965",
    [
      178595
    ]
  ],
  "./fr/assignment_2_assignment_toggle_details.json": [
    "399062",
    [
      870355
    ]
  ],
  "./nb/copy_warnings_modal.json": [
    "478655",
    [
      151977
    ]
  ],
  "./zh-Hans/course_paces_blackout_dates_table.json": [
    "465366",
    [
      292094
    ]
  ],
  "./ca/internal-settings.json": [
    "775883",
    [
      368449
    ]
  ],
  "./is/course_paces_module.json": [
    "244294",
    [
      207887
    ]
  ],
  "./he/grade_summaryGroupView.json": [
    "986569",
    [
      858903
    ]
  ],
  "./ga/grades_empty_page.json": [
    "634346",
    [
      785978
    ]
  ],
  "./nn/blueprint_coursesExpandableLockOptions.json": [
    "163063",
    [
      675657
    ]
  ],
  "./ms/student_study_drawer.json": [
    "985361",
    [
      774863
    ]
  ],
  "./zh-Hant/discussionTopicKeyboradShortcutModal.json": [
    "910851",
    [
      496541
    ]
  ],
  "./th/section.json": [
    "591209",
    [
      270955
    ]
  ],
  "./da-x-k12/assignment_index.json": [
    "253063",
    [
      73081
    ]
  ],
  "./pt-BR/assignmentsToggleShowByView.json": [
    "682088",
    [
      99637
    ]
  ],
  "./pl/account_calendars_modal.json": [
    "579243",
    [
      430789
    ]
  ],
  "./sv-x-k12/permissions_role_tray_table_row.json": [
    "79627",
    [
      57097
    ]
  ],
  "./zh-Hant/courses.json": [
    "961122",
    [
      569462
    ]
  ],
  "./zh-Hant/peer-review-assignment-widget.json": [
    "31842",
    [
      883422
    ]
  ],
  "./it/direct_share_course_import_panel.json": [
    "511393",
    [
      531371
    ]
  ],
  "./ca/progression_module_header.json": [
    "336258",
    [
      836394
    ]
  ],
  "./vi/course_color_selector.json": [
    "457484",
    [
      726396
    ]
  ],
  "./pt/empty_course.json": [
    "614601",
    [
      657339
    ]
  ],
  "./zh-Hans/discussionTopicKeyboradShortcutModal.json": [
    "633680",
    [
      913720
    ]
  ],
  "./fr-CA/lti_registrations.json": [
    "29813",
    [
      893047
    ]
  ],
  "./es/lti_registrations.json": [
    "943896",
    [
      989901
    ]
  ],
  "./id/discussionTopicKeyboradShortcutModal.json": [
    "961862",
    [
      236562
    ]
  ],
  "./ga/CreateEditAssignmentModalAdapter.json": [
    "694515",
    [
      12993
    ]
  ],
  "./es-ES/self_enrollment.json": [
    "988912",
    [
      126280
    ]
  ],
  "./en-AU/assignments_2_file_upload.json": [
    "713794",
    [
      489291
    ]
  ],
  "./en-GB-x-ukhe/paginated_list.json": [
    "453144",
    [
      667184
    ]
  ],
  "./sv/assignments_peer_reviews_student.json": [
    "655032",
    [
      351228
    ]
  ],
  "./sv/question_banks.json": [
    "157089",
    [
      508339
    ]
  ],
  "./tr/assignments_2_initial_query.json": [
    "115503",
    [
      825457
    ]
  ],
  "./el/course_paces_projected_dates.json": [
    "357686",
    [
      701194
    ]
  ],
  "./fr-CA/pairing_code_user_observees.json": [
    "163942",
    [
      104466
    ]
  ],
  "./nl/conversations_2.json": [
    "588605",
    [
      585631
    ]
  ],
  "./es/progression_module_header.json": [
    "104922",
    [
      876403
    ]
  ],
  "./en-AU/section.json": [
    "152771",
    [
      335678
    ]
  ],
  "./pt-BR/peer_review_student_select.json": [
    "149259",
    [
      961502
    ]
  ],
  "./vi/user_logins.json": [
    "968545",
    [
      470583
    ]
  ],
  "./en-GB-x-ukhe/course_paces_app.json": [
    "970858",
    [
      529722
    ]
  ],
  "./en-GB/canvas_file_upload.json": [
    "929372",
    [
      873869
    ]
  ],
  "./fa/CoursesTray.json": [
    "59245",
    [
      478059
    ]
  ],
  "./cy/blueprint_settingsMigrationOptions.json": [
    "409625",
    [
      528743
    ]
  ],
  "./ja/copy_course.json": [
    "825744",
    [
      49109
    ]
  ],
  "./pt/assignments.no_assignments_search.json": [
    "949125",
    [
      694970
    ]
  ],
  "./sv-x-k12/edit_section_end_date.json": [
    "154242",
    [
      31314
    ]
  ],
  "./ms/default_account_quotas.json": [
    "631045",
    [
      4235
    ]
  ],
  "./is/question_bank.json": [
    "735733",
    [
      642019
    ]
  ],
  "./en-GB/AssignmentGroupListItemView.json": [
    "988173",
    [
      662624
    ]
  ],
  "./id/LearningMasteryGradebook.json": [
    "244278",
    [
      666322
    ]
  ],
  "./ms/AssignmentListItemView.json": [
    "716989",
    [
      245587
    ]
  ],
  "./ja/courses_show.json": [
    "152291",
    [
      703230
    ]
  ],
  "./sv/conversations_2.json": [
    "580718",
    [
      521586
    ]
  ],
  "./de/LogoutButton.json": [
    "648889",
    [
      72928
    ]
  ],
  "./da/edit_section_dates.json": [
    "831745",
    [
      444527
    ]
  ],
  "./ga/user_profile.json": [
    "932743",
    [
      774029
    ]
  ],
  "./ms/blueprint_settingsMigrationSync.json": [
    "289502",
    [
      914894
    ]
  ],
  "./pt-BR/blueprint_settingsSyncChange.json": [
    "136631",
    [
      987634
    ]
  ],
  "./pt-BR/account_calendar_settings.json": [
    "428533",
    [
      947060
    ]
  ],
  "./ga/edit_section_view.json": [
    "795998",
    [
      2502
    ]
  ],
  "./da-x-k12/assignments_2_shared_Steps.json": [
    "726756",
    [
      94680
    ]
  ],
  "./tr/calendar.header.json": [
    "929189",
    [
      269935
    ]
  ],
  "./ar/course_paces_actions.json": [
    "734221",
    [
      409671
    ]
  ],
  "./fr-CA/assignments_2_login_action_prompt.json": [
    "741416",
    [
      257068
    ]
  ],
  "./da-x-k12/notebook_index.json": [
    "317895",
    [
      329097
    ]
  ],
  "./th/progression_module_header.json": [
    "902866",
    [
      502126
    ]
  ],
  "./el/blueprint_settingsMigrationSync.json": [
    "678427",
    [
      642333
    ]
  ],
  "./nb-x-k12/syllabus_revisions.json": [
    "228262",
    [
      126238
    ]
  ],
  "./nl/speed_grader_helpers.json": [
    "509921",
    [
      281739
    ]
  ],
  "./is/course_color_selector.json": [
    "837941",
    [
      579875
    ]
  ],
  "./pl/CoursesTray.json": [
    "288196",
    [
      490800
    ]
  ],
  "./fi/assignments_2_student_header_date_title.json": [
    "647116",
    [
      996204
    ]
  ],
  "./pt/discussion_row.json": [
    "191177",
    [
      446011
    ]
  ],
  "./ms/blueprint_settingsMigrationOptions.json": [
    "120017",
    [
      595567
    ]
  ],
  "./tr/ai_experiences_ai_conversations.json": [
    "447592",
    [
      466212
    ]
  ],
  "./mi/calendar_custom_recurring_event_natural_language.json": [
    "363372",
    [
      50100
    ]
  ],
  "./ms/self_enrollment.json": [
    "888765",
    [
      916083
    ]
  ],
  "./ca/sections_tooltip.json": [
    "967314",
    [
      72506
    ]
  ],
  "./sl/important_dates.json": [
    "835465",
    [
      966363
    ]
  ],
  "./nn/default_account_quotas.json": [
    "297881",
    [
      266003
    ]
  ],
  "./de.json": [
    "340862",
    [
      304624
    ]
  ],
  "./en-GB/grades_summary.json": [
    "174970",
    [
      660999
    ]
  ],
  "./de/change_password.json": [
    "131257",
    [
      324224
    ]
  ],
  "./en/Navigation.json": [
    "338141",
    [
      774935
    ]
  ],
  "./nb-x-k12/bulk_edit_students.json": [
    "501714",
    [
      936898
    ]
  ],
  "./zh-Hant/assignments_2_MoreOptions_CanvasFiles.json": [
    "714613",
    [
      668199
    ]
  ],
  "./es/user_restore.json": [
    "777628",
    [
      555913
    ]
  ],
  "./he/discussion_create.json": [
    "356548",
    [
      552988
    ]
  ],
  "./hi/gradingGradeSummary.json": [
    "969660",
    [
      66316
    ]
  ],
  "./pl/k5_dashboard_card.json": [
    "422584",
    [
      140436
    ]
  ],
  "./fa/quantitative_data_options.json": [
    "457394",
    [
      894370
    ]
  ],
  "./fr-CA/link_to_students.json": [
    "789988",
    [
      513080
    ]
  ],
  "./fi/self_unenrollment_modal.json": [
    "943857",
    [
      543559
    ]
  ],
  "./de/OutcomeDescriptionModal.json": [
    "299262",
    [
      544423
    ]
  ],
  "./es/ProfileTray.json": [
    "891875",
    [
      121582
    ]
  ],
  "./it/MobileGlobalMenu.json": [
    "169163",
    [
      210661
    ]
  ],
  "./fr/quiz_migration_notifications.json": [
    "359011",
    [
      649954
    ]
  ],
  "./en-GB-x-lbs/pairing_code_user_observees.json": [
    "961049",
    [
      194767
    ]
  ],
  "./cy/NewTabIndicator.json": [
    "28616",
    [
      404856
    ]
  ],
  "./ru/content_migrations_redesign.json": [
    "147676",
    [
      449212
    ]
  ],
  "./sl/k5_dashboard.json": [
    "164888",
    [
      322244
    ]
  ],
  "./nl/course_paces_errors.json": [
    "927120",
    [
      990348
    ]
  ],
  "./da/progress_pill.json": [
    "663858",
    [
      854202
    ]
  ],
  "./sv/rootFoldersFinder.json": [
    "690374",
    [
      213066
    ]
  ],
  "./ga/course_color_selector.json": [
    "842157",
    [
      834283
    ]
  ],
  "./en-GB/ai_experiences.json": [
    "141829",
    [
      314072
    ]
  ],
  "./fa/course_paces_footer.json": [
    "493695",
    [
      19829
    ]
  ],
  "./ht/widget_dashboard.json": [
    "49873",
    [
      405235
    ]
  ],
  "./ja/discussion_create.json": [
    "246246",
    [
      388455
    ]
  ],
  "./nb/account_calendars_results_area.json": [
    "608740",
    [
      594488
    ]
  ],
  "./ru/account_calendar_settings_account_tree.json": [
    "537766",
    [
      873454
    ]
  ],
  "./ru/peer-review-assignment-widget.json": [
    "128053",
    [
      967715
    ]
  ],
  "./ar/accessibility_course_statistics.json": [
    "680603",
    [
      153181
    ]
  ],
  "./sl/question_banks.json": [
    "468731",
    [
      968525
    ]
  ],
  "./th/Navigation.json": [
    "536720",
    [
      388844
    ]
  ],
  "./it/bulk_edit_students_actions.json": [
    "928363",
    [
      81725
    ]
  ],
  "./zh-Hans/filter_calendars_modal.json": [
    "91271",
    [
      130605
    ]
  ],
  "./en-GB/CreateEditAssignmentModal.json": [
    "185629",
    [
      857480
    ]
  ],
  "./pt/paginated_list.json": [
    "395606",
    [
      540674
    ]
  ],
  "./ms/calculator_command.json": [
    "461092",
    [
      183068
    ]
  ],
  "./he/course_paces_blackout_dates_table.json": [
    "637410",
    [
      879322
    ]
  ],
  "./id/calendar.header.json": [
    "97766",
    [
      824217
    ]
  ],
  "./hy/discussion_insights.json": [
    "157733",
    [
      265907
    ]
  ],
  "./es/assignment_grade_summary.json": [
    "755584",
    [
      382069
    ]
  ],
  "./nb-x-k12/announcements_on_home_page.json": [
    "662776",
    [
      493504
    ]
  ],
  "./id/restore_content_pane.json": [
    "433286",
    [
      837274
    ]
  ],
  "./hi/AssignmentGroupListItemView.json": [
    "637367",
    [
      659709
    ]
  ],
  "./sv/assignments_peer_reviews.json": [
    "242472",
    [
      420164
    ]
  ],
  "./th/account_calendar_settings_filter_controls.json": [
    "401934",
    [
      180258
    ]
  ],
  "./da/discussion_topics_edit.json": [
    "70553",
    [
      995383
    ]
  ],
  "./mi/calendar_appointment_group_edit.json": [
    "904109",
    [
      492867
    ]
  ],
  "./ga/assignments.no_assignments_search.json": [
    "971846",
    [
      966010
    ]
  ],
  "./ko/edit_section_end_date.json": [
    "606843",
    [
      697873
    ]
  ],
  "./ht/course_stats.json": [
    "986195",
    [
      841605
    ]
  ],
  "./ko/course_paces_change_tracking.json": [
    "485429",
    [
      93515
    ]
  ],
  "./da/blueprint_settingsCourseFilter.json": [
    "840065",
    [
      664047
    ]
  ],
  "./pt/CommentLibrary.json": [
    "179094",
    [
      99418
    ]
  ],
  "./da/NewTabIndicator.json": [
    "600407",
    [
      317493
    ]
  ],
  "./el/DueDateOverrideView.json": [
    "756936",
    [
      158716
    ]
  ],
  "./cy/new_user_tutorial.json": [
    "856673",
    [
      377631
    ]
  ],
  "./en-GB/password_complexity_configuration.json": [
    "585132",
    [
      419805
    ]
  ],
  "./hi/SpeedGraderSettingsMenu.json": [
    "227271",
    [
      681293
    ]
  ],
  "./is/sidenav.json": [
    "698126",
    [
      998054
    ]
  ],
  "./pt/user_lists.json": [
    "105275",
    [
      593333
    ]
  ],
  "./sl/wiki_page_index.json": [
    "262668",
    [
      852352
    ]
  ],
  "./th/keyboardShortcutModal.json": [
    "760882",
    [
      47350
    ]
  ],
  "./ht/progressbar_view.json": [
    "739966",
    [
      584706
    ]
  ],
  "./ms/direct_share_course_import_panel.json": [
    "598025",
    [
      597078
    ]
  ],
  "./es/assignments_2_student_points_display.json": [
    "463956",
    [
      85921
    ]
  ],
  "./nl/LogoutButton.json": [
    "674714",
    [
      643630
    ]
  ],
  "./sv/bounced_emails.json": [
    "532813",
    [
      15143
    ]
  ],
  "./zh-Hans/terms_index.json": [
    "259833",
    [
      150255
    ]
  ],
  "./it/edit_section_start_date.json": [
    "743303",
    [
      110185
    ]
  ],
  "./ar/empty_modules.json": [
    "545730",
    [
      720078
    ]
  ],
  "./de/assignment_show.json": [
    "187402",
    [
      773419
    ]
  ],
  "./th/peer_review_allocation_rules_tray.json": [
    "143555",
    [
      776653
    ]
  ],
  "./pl/conversations_2.json": [
    "382259",
    [
      700877
    ]
  ],
  "./he/self_unenrollment_modal.json": [
    "153935",
    [
      840685
    ]
  ],
  "./nb-x-k12/peer_review_allocation_rules_tray.json": [
    "587449",
    [
      420287
    ]
  ],
  "./tr/ai_experiences_show.json": [
    "226072",
    [
      724164
    ]
  ],
  "./is/module_sequence_footer.json": [
    "222248",
    [
      293104
    ]
  ],
  "./sv-x-k12/not_found_page_slide_puzzle.json": [
    "191690",
    [
      106810
    ]
  ],
  "./ar/context_roster_user_services.json": [
    "505027",
    [
      280917
    ]
  ],
  "./hu/assignments_2_student_points_display.json": [
    "447225",
    [
      99655
    ]
  ],
  "./de/react_developer_keys.json": [
    "549668",
    [
      32729
    ]
  ],
  "./hu/overview_page.json": [
    "84582",
    [
      438886
    ]
  ],
  "./da-x-k12/sharedSetDefaultGradeDialog.json": [
    "299316",
    [
      921088
    ]
  ],
  "./el/login.json": [
    "866370",
    [
      211214
    ]
  ],
  "./it/course_restore.json": [
    "793533",
    [
      477255
    ]
  ],
  "./es/permission_button.json": [
    "602101",
    [
      846043
    ]
  ],
  "./fi/webzip_export.json": [
    "583731",
    [
      674593
    ]
  ],
  "./en-GB-x-ukhe/mutationActivity.json": [
    "665938",
    [
      855986
    ]
  ],
  "./ht/auth_logging.json": [
    "428754",
    [
      191118
    ]
  ],
  "./vi/account_settings_jsx_bundle.json": [
    "682279",
    [
      125133
    ]
  ],
  "./hy/peer-review-assignment-widget.json": [
    "901339",
    [
      253609
    ]
  ],
  "./ms/media_immersive_view.json": [
    "211142",
    [
      753574
    ]
  ],
  "./mi/authentication_providers.json": [
    "583665",
    [
      595695
    ]
  ],
  "./nb-x-k12/account_calendar_settings.json": [
    "448502",
    [
      971870
    ]
  ],
  "./da/calendar_edit.json": [
    "779858",
    [
      728538
    ]
  ],
  "./en-GB/quizzes_regrade_modal.json": [
    "130695",
    [
      15646
    ]
  ],
  "./da/wiki_page_index.json": [
    "167848",
    [
      497224
    ]
  ],
  "./it/assignments_2_student_annotation.json": [
    "1584",
    [
      635908
    ]
  ],
  "./pl/gradebook_uploads.json": [
    "638849",
    [
      279779
    ]
  ],
  "./sl/CreateEditAssignmentModal.json": [
    "749811",
    [
      911013
    ]
  ],
  "./tr/assignments_2_submission_histories_query.json": [
    "381136",
    [
      406292
    ]
  ],
  "./en-CA/files_v2.json": [
    "659914",
    [
      23290
    ]
  ],
  "./nb/EditMasteryScaleLink.json": [
    "510043",
    [
      950525
    ]
  ],
  "./ca/modelsQuiz.json": [
    "392289",
    [
      328367
    ]
  ],
  "./en-GB-x-ukhe/copy_course.json": [
    "84947",
    [
      899345
    ]
  ],
  "./is/assignments.no_assignments_search.json": [
    "915169",
    [
      385970
    ]
  ],
  "./sl/announcements_v2.json": [
    "384882",
    [
      627518
    ]
  ],
  "./nb-x-k12/calculator_command.json": [
    "114002",
    [
      983650
    ]
  ],
  "./en-CA/assignments_2_student_points_display.json": [
    "851804",
    [
      997676
    ]
  ],
  "./sv-x-k12/content_copy_redesign.json": [
    "154990",
    [
      229350
    ]
  ],
  "./is/eportfolio.json": [
    "746959",
    [
      735573
    ]
  ],
  "./ht/assignments_2_file_upload.json": [
    "509600",
    [
      624164
    ]
  ],
  "./vi/available_pronouns_list.json": [
    "266346",
    [
      580618
    ]
  ],
  "./en-GB/nav_tourpoints.json": [
    "212926",
    [
      384579
    ]
  ],
  "./es-ES/blueprint_settingsMigrationOptions.json": [
    "119654",
    [
      736798
    ]
  ],
  "./fr/files_v2.json": [
    "312474",
    [
      360631
    ]
  ],
  "./zh-Hans/modules_page_icon_legend.json": [
    "510962",
    [
      428450
    ]
  ],
  "./it/account_calendar_settings_account_list.json": [
    "430278",
    [
      410786
    ]
  ],
  "./da/MoveOutcomesModal.json": [
    "287056",
    [
      175616
    ]
  ],
  "./id/account_calendar_settings.json": [
    "915189",
    [
      600015
    ]
  ],
  "./de/a2LatePolicyStatusDisplay.json": [
    "624434",
    [
      264387
    ]
  ],
  "./hi/discussion_pinned_post.json": [
    "529665",
    [
      561447
    ]
  ],
  "./ko/discussionTopicKeyboradShortcutModal.json": [
    "571439",
    [
      863965
    ]
  ],
  "./fi/permissions_v2_add_tray.json": [
    "612473",
    [
      455647
    ]
  ],
  "./nn/account_calendar_settings_account_group.json": [
    "806036",
    [
      391608
    ]
  ],
  "./pt-BR/course_stats.json": [
    "809580",
    [
      89889
    ]
  ],
  "./ga/course_paces_actions.json": [
    "552372",
    [
      532836
    ]
  ],
  "./ga/assignments_2_MoreOptions_CanvasFiles.json": [
    "723695",
    [
      432917
    ]
  ],
  "./da-x-k12/assignments_2_submission_helpers.json": [
    "503027",
    [
      78157
    ]
  ],
  "./ms/course_paces_assignment_row.json": [
    "811559",
    [
      885173
    ]
  ],
  "./ru/question_bank.json": [
    "181328",
    [
      442888
    ]
  ],
  "./tr/a2LatePolicyToolTipContent.json": [
    "147849",
    [
      862547
    ]
  ],
  "./fi/discussion_settings.json": [
    "952199",
    [
      529869
    ]
  ],
  "./de/react_collaborations.json": [
    "515669",
    [
      440420
    ]
  ],
  "./nb-x-k12/assignments_2_elide_string.json": [
    "806041",
    [
      138479
    ]
  ],
  "./ms/outcome_management.json": [
    "964432",
    [
      402224
    ]
  ],
  "./uk/discussion_row.json": [
    "919833",
    [
      748055
    ]
  ],
  "./es/moderate_quiz.json": [
    "144441",
    [
      421960
    ]
  ],
  "./hi/filter_calendars_modal.json": [
    "204079",
    [
      987781
    ]
  ],
  "./pl/course_stats.json": [
    "267491",
    [
      642613
    ]
  ],
  "./vi/registration.json": [
    "953328",
    [
      320808
    ]
  ],
  "./en-GB-x-ukhe/default_account_quotas.json": [
    "34763",
    [
      716937
    ]
  ],
  "./pt/course_paces_blueprint_lock.json": [
    "49970",
    [
      180910
    ]
  ],
  "./ga/discussion_create.json": [
    "439219",
    [
      171009
    ]
  ],
  "./ru/modules_page_icon_legend.json": [
    "641144",
    [
      797696
    ]
  ],
  "./nb/use_switch_experience.json": [
    "967947",
    [
      879773
    ]
  ],
  "./sv/internal-settings.json": [
    "781418",
    [
      352510
    ]
  ],
  "./sv/progress_pill.json": [
    "457852",
    [
      506776
    ]
  ],
  "./vi/choose_mastery_path.json": [
    "205452",
    [
      174428
    ]
  ],
  "./nb/conferences.json": [
    "418401",
    [
      466619
    ]
  ],
  "./da-x-k12/course_paces_pace_picker.json": [
    "955294",
    [
      982362
    ]
  ],
  "./ar/user.json": [
    "804156",
    [
      597024
    ]
  ],
  "./zh-Hans/conferences_alternatives.json": [
    "598143",
    [
      902645
    ]
  ],
  "./es-ES/admin_split.json": [
    "885215",
    [
      96533
    ]
  ],
  "./zh-Hans/file_not_found.json": [
    "290460",
    [
      860748
    ]
  ],
  "./ko/discussion_posts.json": [
    "810932",
    [
      146748
    ]
  ],
  "./hi/authentication_providers.json": [
    "12674",
    [
      834834
    ]
  ],
  "./da-x-k12/nav_tourpoints.json": [
    "17750",
    [
      238754
    ]
  ],
  "./sl/a2LatePolicyToolTipContent.json": [
    "691094",
    [
      725933
    ]
  ],
  "./tr/account_settings_jsx_bundle.json": [
    "276540",
    [
      704592
    ]
  ],
  "./zh-Hans/sharedCurveGradesDialog.json": [
    "892361",
    [
      830543
    ]
  ],
  "./zh-Hant/account_calendar_settings_account_calendar_item.json": [
    "466865",
    [
      640907
    ]
  ],
  "./da-x-k12/CreateEditAssignmentModal.json": [
    "284485",
    [
      678327
    ]
  ],
  "./es/empty_course.json": [
    "430817",
    [
      325168
    ]
  ],
  "./ms/assignments_2_student_annotation.json": [
    "954683",
    [
      231873
    ]
  ],
  "./pl/course_paces_flaggable_number_input.json": [
    "562415",
    [
      628633
    ]
  ],
  "./el/MobileGlobalMenu.json": [
    "903535",
    [
      77833
    ]
  ],
  "./mi/enhanced_individual_gradebook_submit_score.json": [
    "336863",
    [
      354077
    ]
  ],
  "./he/question_bank.json": [
    "596538",
    [
      580386
    ]
  ],
  "./pl/roster_section_selector.json": [
    "137575",
    [
      424841
    ]
  ],
  "./sl/eportfolio.json": [
    "865986",
    [
      489574
    ]
  ],
  "./nb-x-k12/AddGroup.json": [
    "280274",
    [
      14674
    ]
  ],
  "./zh-Hans/quiz_show.json": [
    "127846",
    [
      460558
    ]
  ],
  "./id/SpeedGraderSettingsMenu.json": [
    "664281",
    [
      768475
    ]
  ],
  "./en-GB/course_paces_search.json": [
    "145660",
    [
      24997
    ]
  ],
  "./ko/question_banks.json": [
    "625352",
    [
      857896
    ]
  ],
  "./nl/k5_course.json": [
    "314908",
    [
      274584
    ]
  ],
  "./sl/content_copy_redesign.json": [
    "176966",
    [
      644690
    ]
  ],
  "./sv/keyboardShortcutModal.json": [
    "408651",
    [
      953037
    ]
  ],
  "./ms/auth_logging.json": [
    "455450",
    [
      498050
    ]
  ],
  "./pl/course_default_due_time.json": [
    "435104",
    [
      119252
    ]
  ],
  "./es-ES/content_shares.json": [
    "720791",
    [
      664285
    ]
  ],
  "./fr/gradebookActionMenu.json": [
    "655633",
    [
      88052
    ]
  ],
  "./he/add_edit_pseudonym.json": [
    "318382",
    [
      717278
    ]
  ],
  "./ja/authentication_providers.json": [
    "96192",
    [
      91525
    ]
  ],
  "./es-ES/filter_calendars_modal.json": [
    "52269",
    [
      920155
    ]
  ],
  "./fr/course_statistics.json": [
    "514307",
    [
      437306
    ]
  ],
  "./sl/assignments_2_MoreOptions_CanvasFiles.json": [
    "381164",
    [
      544712
    ]
  ],
  "./nb/peer_reviews_student.json": [
    "786716",
    [
      647472
    ]
  ],
  "./es-ES/assignment_grade_summary.json": [
    "34759",
    [
      464717
    ]
  ],
  "./es/assignments.json": [
    "764052",
    [
      537633
    ]
  ],
  "./hy/calculator_command.json": [
    "798237",
    [
      856091
    ]
  ],
  "./vi/overview_page.json": [
    "222756",
    [
      11444
    ]
  ],
  "./ko.eager.json": [
    "950921",
    [
      66524
    ]
  ],
  "./da-x-k12/SpeedGraderDiscussionsNavigation.json": [
    "445626",
    [
      236582
    ]
  ],
  "./fi.json": [
    "425712",
    [
      312926
    ]
  ],
  "./ja/account_calendar_settings_footer.json": [
    "875069",
    [
      822228
    ]
  ],
  "./ar/assignments_2_external_tool.json": [
    "684079",
    [
      909425
    ]
  ],
  "./el/discussion_row.json": [
    "530510",
    [
      635058
    ]
  ],
  "./hu/empty_modules.json": [
    "171350",
    [
      200726
    ]
  ],
  "./en-AU-x-unimelb/blueprint_settingsCourseFilter.json": [
    "6912",
    [
      613572
    ]
  ],
  "./pt-BR/k5_dashboard_card.json": [
    "745009",
    [
      969096
    ]
  ],
  "./pl/not_found_page_slide_puzzle.json": [
    "494001",
    [
      454995
    ]
  ],
  "./ru/account_calendars_results_area.json": [
    "486779",
    [
      731433
    ]
  ],
  "./es-ES/discussion_topics.json": [
    "82134",
    [
      322846
    ]
  ],
  "./ca/keyboardShortcutModal.json": [
    "114850",
    [
      161866
    ]
  ],
  "./nb/account_settings_jsx_bundle.json": [
    "547694",
    [
      305530
    ]
  ],
  "./zh-Hans/comm_messages.json": [
    "371472",
    [
      626936
    ]
  ],
  "./ko/reset_pace_warning_modal.json": [
    "569638",
    [
      376438
    ]
  ],
  "./fi/AccountsTray.json": [
    "450321",
    [
      211863
    ]
  ],
  "./nb/account_calendar_settings_account_group.json": [
    "882280",
    [
      204124
    ]
  ],
  "./es-ES/grade_summary.json": [
    "352655",
    [
      418053
    ]
  ],
  "./uk/link_validator.json": [
    "133355",
    [
      998177
    ]
  ],
  "./cy/context_roster_user_services.json": [
    "844326",
    [
      972230
    ]
  ],
  "./ko/course_stats.json": [
    "839409",
    [
      36639
    ]
  ],
  "./ca/calendar_custom_recurring_event_repeat_picker.json": [
    "271916",
    [
      314980
    ]
  ],
  "./ga/calendar_sidebar.json": [
    "307839",
    [
      436757
    ]
  ],
  "./it/progress_pill.json": [
    "219200",
    [
      204764
    ]
  ],
  "./nn/accessibility_scan.json": [
    "13398",
    [
      25186
    ]
  ],
  "./th/blueprint_settingsMigrationSync.json": [
    "596718",
    [
      111802
    ]
  ],
  "./is/todos_page.json": [
    "837875",
    [
      723633
    ]
  ],
  "./is/comm_messages.json": [
    "90467",
    [
      118129
    ]
  ],
  "./zh-Hant/ProfileTray.json": [
    "161733",
    [
      82055
    ]
  ],
  "./id/section.json": [
    "367444",
    [
      569608
    ]
  ],
  "./ms/context_modules_v2.json": [
    "724588",
    [
      80596
    ]
  ],
  "./sv/content_migrations.json": [
    "699654",
    [
      836642
    ]
  ],
  "./tr/announcements_on_home_page.json": [
    "153136",
    [
      657324
    ]
  ],
  "./fa/assignments_2_student_points_display.json": [
    "891459",
    [
      326497
    ]
  ],
  "./zh-Hans/student_groups.json": [
    "372307",
    [
      166017
    ]
  ],
  "./fr-CA/course_paces_module.json": [
    "349960",
    [
      801004
    ]
  ],
  "./fr/CoursesTray.json": [
    "764988",
    [
      596573
    ]
  ],
  "./nl/assignments_2_student_header.json": [
    "604225",
    [
      176803
    ]
  ],
  "./fr-CA/edit_section_view.json": [
    "114243",
    [
      789293
    ]
  ],
  "./pl/HelpTray.json": [
    "538417",
    [
      749155
    ]
  ],
  "./tr/account_calendar_settings.json": [
    "937150",
    [
      27450
    ]
  ],
  "./da/course_paces_errors.json": [
    "756837",
    [
      98171
    ]
  ],
  "./pt-BR/learning_mastery_gradebook.json": [
    "766760",
    [
      681525
    ]
  ],
  "./fa/assignments_2_attempt_tab.json": [
    "656854",
    [
      977918
    ]
  ],
  "./hu/course_paces_module.json": [
    "511054",
    [
      208318
    ]
  ],
  "./ko/webzip_export.json": [
    "675076",
    [
      875020
    ]
  ],
  "./es-ES/course_paces_blackout_date_row.json": [
    "158109",
    [
      875595
    ]
  ],
  "./da-x-k12/account_calendar_settings_footer.json": [
    "260565",
    [
      930663
    ]
  ],
  "./sv/moderate_quiz.json": [
    "505808",
    [
      219924
    ]
  ],
  "./es-ES/course_color_selector.json": [
    "831372",
    [
      163564
    ]
  ],
  "./fa/course_navigation_settings.json": [
    "130829",
    [
      342907
    ]
  ],
  "./nl/accessibility_course_statistics.json": [
    "102774",
    [
      822154
    ]
  ],
  "./fi/media_immersive_view.json": [
    "292573",
    [
      666011
    ]
  ],
  "./mi/link_validator.json": [
    "326121",
    [
      720599
    ]
  ],
  "./sl/self_enrollment.json": [
    "397470",
    [
      919474
    ]
  ],
  "./da/course_paces_projected_dates.json": [
    "317236",
    [
      360892
    ]
  ],
  "./fr/course_link_validator.json": [
    "943421",
    [
      325768
    ]
  ],
  "./de/account_calendar_settings_account_list.json": [
    "377764",
    [
      466329
    ]
  ],
  "./vi/password_complexity_configuration.json": [
    "718736",
    [
      70440
    ]
  ],
  "./ht/paginated_list.json": [
    "988206",
    [
      179402
    ]
  ],
  "./vi/account_calendars_results_area.json": [
    "518123",
    [
      289161
    ]
  ],
  "./es/enhanced_individual_gradebook_submit_score.json": [
    "658133",
    [
      446012
    ]
  ],
  "./hy/Navigation.json": [
    "579485",
    [
      346859
    ]
  ],
  "./nb-x-k12/blueprint_course_child.json": [
    "362284",
    [
      558556
    ]
  ],
  "./zh-Hant/a2_AccessibleTipContent.json": [
    "174368",
    [
      853996
    ]
  ],
  "./pl/sharedSetDefaultGradeDialog.json": [
    "48937",
    [
      920627
    ]
  ],
  "./es/registration.json": [
    "651899",
    [
      154246
    ]
  ],
  "./ar/account_calendar_settings_account_group.json": [
    "898247",
    [
      863113
    ]
  ],
  "./cy/terms_index.json": [
    "20090",
    [
      866498
    ]
  ],
  "./fr/terms_of_service_modal.json": [
    "303293",
    [
      868792
    ]
  ],
  "./it/assignments_2_submission_histories_query.json": [
    "749537",
    [
      263179
    ]
  ],
  "./el/appt_calendar_event_dialog.json": [
    "607193",
    [
      92571
    ]
  ],
  "./pt-BR/ai_experiences.json": [
    "592993",
    [
      214152
    ]
  ],
  "./ca/blueprint_coursesExpandableLockOptions.json": [
    "181387",
    [
      440961
    ]
  ],
  "./ht/blueprint_settingsCoursePicker.json": [
    "972164",
    [
      932096
    ]
  ],
  "./en-GB-x-ukhe/license_help.json": [
    "934287",
    [
      553765
    ]
  ],
  "./es/user_search_results.json": [
    "320427",
    [
      683190
    ]
  ],
  "./uk/rootFoldersFinder.json": [
    "27683",
    [
      399401
    ]
  ],
  "./vi/course_paces_settings.json": [
    "167661",
    [
      174792
    ]
  ],
  "./zh-Hant/sharedCurveGradesDialog.json": [
    "389052",
    [
      143464
    ]
  ],
  "./da-x-k12/registration.json": [
    "919004",
    [
      381480
    ]
  ],
  "./uk/AccountsTray.json": [
    "925074",
    [
      802618
    ]
  ],
  "./th/courses_show.json": [
    "744752",
    [
      653644
    ]
  ],
  "./id/new_nav.json": [
    "427075",
    [
      608405
    ]
  ],
  "./nb/ai_experiences_ai_conversations.json": [
    "374422",
    [
      703314
    ]
  ],
  "./hu/ldap_cert_upload.json": [
    "558571",
    [
      618673
    ]
  ],
  "./nn/course_paces_blackout_dates_modal.json": [
    "449020",
    [
      269944
    ]
  ],
  "./ca/account_calendar_settings.json": [
    "575600",
    [
      914048
    ]
  ],
  "./nn/MoveOutcomesModal.json": [
    "353503",
    [
      183209
    ]
  ],
  "./ja/quizzes_openModerateStudentDialog.json": [
    "292137",
    [
      419496
    ]
  ],
  "./ru/pseudonyms_mobile_login.json": [
    "372275",
    [
      417505
    ]
  ],
  "./pt-BR/submissions_show_preview.json": [
    "624641",
    [
      261784
    ]
  ],
  "./id/assignments_bulk_edit.json": [
    "366871",
    [
      556057
    ]
  ],
  "./ht/course_navigation_settings.json": [
    "103294",
    [
      922362
    ]
  ],
  "./th/internal-settings.json": [
    "868859",
    [
      905277
    ]
  ],
  "./th/media_immersive_view.json": [
    "934454",
    [
      618298
    ]
  ],
  "./mi/course_paces_errors.json": [
    "417988",
    [
      132572
    ]
  ],
  "./de/calendar_appointment_group_edit.json": [
    "340068",
    [
      638281
    ]
  ],
  "./tr/dashboard_grading_period_select.json": [
    "988062",
    [
      905770
    ]
  ],
  "./zh-Hant/discussion_settings.json": [
    "376268",
    [
      678424
    ]
  ],
  "./he/ProfileTray.json": [
    "926188",
    [
      483540
    ]
  ],
  "./vi/user_name.json": [
    "674812",
    [
      844028
    ]
  ],
  "./nb-x-k12/assignments_2_MoreOptions_CanvasFiles.json": [
    "664077",
    [
      983307
    ]
  ],
  "./fi/user_logins.json": [
    "854865",
    [
      1031
    ]
  ],
  "./nb-x-k12/custom_help_link.json": [
    "818116",
    [
      393684
    ]
  ],
  "./ca/account_calendar_settings_footer.json": [
    "807942",
    [
      716854
    ]
  ],
  "./fr/student_annotation_preview.json": [
    "78736",
    [
      664521
    ]
  ],
  "./mi/keyboardShortcutModal.json": [
    "61904",
    [
      682128
    ]
  ],
  "./de/video_conference.json": [
    "155645",
    [
      68844
    ]
  ],
  "./pt-BR/filter_calendars_modal.json": [
    "193037",
    [
      943852
    ]
  ],
  "./th/question_banks.json": [
    "130145",
    [
      817330
    ]
  ],
  "./nn/pairing_code_user_observees.json": [
    "203263",
    [
      352561
    ]
  ],
  "./fr-CA/discovery_page.json": [
    "235117",
    [
      599239
    ]
  ],
  "./nb/calendar_sidebar.json": [
    "598803",
    [
      295853
    ]
  ],
  "./fi/discussion_posts.json": [
    "452233",
    [
      188719
    ]
  ],
  "./hu/ignite_agent.json": [
    "475627",
    [
      847857
    ]
  ],
  "./ko/empty_modules.json": [
    "17199",
    [
      484061
    ]
  ],
  "./ga/courses.json": [
    "269104",
    [
      137288
    ]
  ],
  "./it/overview_page.json": [
    "228884",
    [
      433632
    ]
  ],
  "./el/webzip_export.json": [
    "701359",
    [
      83537
    ]
  ],
  "./ms/account_calendars_modal.json": [
    "562211",
    [
      453337
    ]
  ],
  "./pt/outcome_management.json": [
    "173728",
    [
      96823
    ]
  ],
  "./he/NewTabIndicator.json": [
    "255799",
    [
      907205
    ]
  ],
  "./en-GB-x-ukhe/GroupsTray.json": [
    "215856",
    [
      279624
    ]
  ],
  "./ar/course_template_details.json": [
    "312076",
    [
      231632
    ]
  ],
  "./fa/syllabus_revisions.json": [
    "668755",
    [
      807009
    ]
  ],
  "./ga/webcam_modal.json": [
    "486661",
    [
      659539
    ]
  ],
  "./vi/outcome_reporting.json": [
    "106830",
    [
      274998
    ]
  ],
  "./cy/GroupDetailView.json": [
    "21441",
    [
      319807
    ]
  ],
  "./nb-x-k12/course_paces_blackout_dates_table.json": [
    "952903",
    [
      621645
    ]
  ],
  "./nn/blueprint_course_child.json": [
    "638218",
    [
      369190
    ]
  ],
  "./ko/course_restore.json": [
    "821940",
    [
      876988
    ]
  ],
  "./cy/user_name.json": [
    "869153",
    [
      206367
    ]
  ],
  "./hy/choose_mastery_path.json": [
    "461574",
    [
      185374
    ]
  ],
  "./ru/GroupsTray.json": [
    "943449",
    [
      542895
    ]
  ],
  "./el/react_scheduler.json": [
    "319782",
    [
      80650
    ]
  ],
  "./mi/student_study_drawer.json": [
    "188303",
    [
      821677
    ]
  ],
  "./ja/course_paces_blackout_dates_modal.json": [
    "956081",
    [
      356272
    ]
  ],
  "./pt-BR/discussion_settings.json": [
    "922615",
    [
      767218
    ]
  ],
  "./ar/terms_of_use.json": [
    "346418",
    [
      886606
    ]
  ],
  "./ca/permissions_role_tray_table_row.json": [
    "183152",
    [
      712000
    ]
  ],
  "./de/jobs.json": [
    "282607",
    [
      236778
    ]
  ],
  "./es/quizzes_public.json": [
    "237341",
    [
      478052
    ]
  ],
  "./zh-Hant/assignments_2_file_upload.json": [
    "409850",
    [
      991286
    ]
  ],
  "./ko/assignments_2_shared_Steps.json": [
    "698685",
    [
      225443
    ]
  ],
  "./ko/submit_online_url_assignment.json": [
    "414808",
    [
      101048
    ]
  ],
  "./ru/grade_details.json": [
    "393261",
    [
      741675
    ]
  ],
  "./sv-x-k12/CoursesTray.json": [
    "5167",
    [
      196101
    ]
  ],
  "./de/outcomes_user_outcome_results.json": [
    "414962",
    [
      98307
    ]
  ],
  "./fr/modules_page_icon_legend.json": [
    "928911",
    [
      267942
    ]
  ],
  "./nb/outcome_alignment_v2.json": [
    "994913",
    [
      983019
    ]
  ],
  "./hi/calendar_edit.json": [
    "769294",
    [
      415574
    ]
  ],
  "./sv-x-k12/empty_course.json": [
    "680332",
    [
      848316
    ]
  ],
  "./es/calendar.header.json": [
    "611039",
    [
      626098
    ]
  ],
  "./pt/assignments_2_attempt_tab.json": [
    "136015",
    [
      280137
    ]
  ],
  "./sv/context_roster_user_services.json": [
    "187573",
    [
      642791
    ]
  ],
  "./sv/todo.json": [
    "970613",
    [
      430919
    ]
  ],
  "./fi/content_shares.json": [
    "908743",
    [
      315645
    ]
  ],
  "./en-AU-x-unimelb/permissions.json": [
    "930998",
    [
      553586
    ]
  ],
  "./es/a2LatePolicyStatusDisplay.json": [
    "486013",
    [
      413604
    ]
  ],
  "./en-GB-x-ukhe/MasteryScale.json": [
    "269837",
    [
      772747
    ]
  ],
  "./sv/assignments.no_assignments_search.json": [
    "263232",
    [
      858533
    ]
  ],
  "./pt-BR.eager.json": [
    "665174",
    [
      885425
    ]
  ],
  "./th/assignments_2_file_upload.json": [
    "921784",
    [
      756540
    ]
  ],
  "./uk/horizon_toggle.json": [
    "984410",
    [
      921426
    ]
  ],
  "./id/permissions_v2_add_tray.json": [
    "813801",
    [
      999835
    ]
  ],
  "./es/calculator.json": [
    "850102",
    [
      133063
    ]
  ],
  "./pt/discussion_settings.json": [
    "757894",
    [
      731066
    ]
  ],
  "./ru/ai_experiences_ai_conversations.json": [
    "66483",
    [
      26769
    ]
  ],
  "./es-ES/EditMasteryScaleLink.json": [
    "576520",
    [
      146304
    ]
  ],
  "./cy/assignment_index.json": [
    "664084",
    [
      291244
    ]
  ],
  "./es/edit_section_end_date.json": [
    "973333",
    [
      3388
    ]
  ],
  "./fr/content_shares.json": [
    "474508",
    [
      818405
    ]
  ],
  "./fr-CA/folder_tree.json": [
    "459098",
    [
      213998
    ]
  ],
  "./fr/peer_reviews_student.json": [
    "890580",
    [
      71005
    ]
  ],
  "./fr/context_roster_user_services.json": [
    "887006",
    [
      492731
    ]
  ],
  "./ar/assignments_2_submission_histories_query.json": [
    "915639",
    [
      98233
    ]
  ],
  "./it/blueprint_settingsMigrationOptions.json": [
    "245750",
    [
      911613
    ]
  ],
  "./id/quiz_show.json": [
    "674136",
    [
      423188
    ]
  ],
  "./es/default_account_quotas.json": [
    "40493",
    [
      15092
    ]
  ],
  "./ms/speed_grader_helpers.json": [
    "761959",
    [
      699733
    ]
  ],
  "./pt/discussion_insights.json": [
    "343430",
    [
      354058
    ]
  ],
  "./vi/dashboard.json": [
    "101779",
    [
      105713
    ]
  ],
  "./nb/gradingPeriodTemplate.json": [
    "163393",
    [
      211003
    ]
  ],
  "./en-GB-x-lbs/permissions.json": [
    "496172",
    [
      487852
    ]
  ],
  "./hy/edit_section_end_date.json": [
    "889586",
    [
      528290
    ]
  ],
  "./nl/question_banks.json": [
    "964456",
    [
      442244
    ]
  ],
  "./sv/course_restore.json": [
    "33409",
    [
      994011
    ]
  ],
  "./de/calculator.json": [
    "853567",
    [
      825866
    ]
  ],
  "./sv/sis_import.json": [
    "381026",
    [
      651526
    ]
  ],
  "./zh-Hans/DueDateOverrideView.json": [
    "137110",
    [
      378846
    ]
  ],
  "./nl/account_calendar_settings_confirmation_modal.json": [
    "513188",
    [
      131984
    ]
  ],
  "./cy/quizzes_openModerateStudentDialog.json": [
    "292404",
    [
      311148
    ]
  ],
  "./zh-Hant/course_paces_search.json": [
    "607495",
    [
      523281
    ]
  ],
  "./ja/calendar_sidebar.json": [
    "236856",
    [
      576605
    ]
  ],
  "./fi/direct_share_course_import_panel.json": [
    "366977",
    [
      613975
    ]
  ],
  "./ga/copy_warnings_modal.json": [
    "971843",
    [
      75777
    ]
  ],
  "./es-ES/bulk_edit_students_actions.json": [
    "538075",
    [
      399273
    ]
  ],
  "./hu/blueprint_settingsSyncChange.json": [
    "328001",
    [
      804127
    ]
  ],
  "./hi/terms_of_use.json": [
    "879426",
    [
      654818
    ]
  ],
  "./hu/grade_change_logging_content.json": [
    "325859",
    [
      91673
    ]
  ],
  "./hi/confirmMasteryModal.json": [
    "814787",
    [
      591521
    ]
  ],
  "./hu/user_search_results.json": [
    "355704",
    [
      272136
    ]
  ],
  "./mi/context_prior_users.json": [
    "285767",
    [
      203349
    ]
  ],
  "./th/blueprint_course_sidebar.json": [
    "343816",
    [
      873620
    ]
  ],
  "./sv/course_paces_modal.json": [
    "196501",
    [
      679975
    ]
  ],
  "./sv/content_migrations_redesign.json": [
    "765544",
    [
      346700
    ]
  ],
  "./hi/gradebook.json": [
    "786799",
    [
      64501
    ]
  ],
  "./ar/keyboardShortcutModal.json": [
    "180333",
    [
      139215
    ]
  ],
  "./nl/important_dates.json": [
    "244980",
    [
      20288
    ]
  ],
  "./es/account_settings_jsx_bundle.json": [
    "771806",
    [
      383247
    ]
  ],
  "./fr/peer_review_allocation_rule_card.json": [
    "858244",
    [
      215149
    ]
  ],
  "./fr/permissions_v2.json": [
    "677051",
    [
      710978
    ]
  ],
  "./el/nav_tourpoints.json": [
    "355262",
    [
      548994
    ]
  ],
  "./nn/roster_section_selector.json": [
    "435059",
    [
      713125
    ]
  ],
  "./pt/new_nav.json": [
    "726842",
    [
      714710
    ]
  ],
  "./ga/course_logging_details.json": [
    "283316",
    [
      747636
    ]
  ],
  "./fa/assignments.json": [
    "759333",
    [
      378579
    ]
  ],
  "./da-x-k12/speed_grader_helpers.json": [
    "436220",
    [
      806192
    ]
  ],
  "./uk/edit_section_start_date.json": [
    "529258",
    [
      824482
    ]
  ],
  "./mi/jobs.json": [
    "977196",
    [
      417972
    ]
  ],
  "./ko/available_pronouns_list.json": [
    "652985",
    [
      117911
    ]
  ],
  "./mi/ai_experiences_show.json": [
    "171848",
    [
      770904
    ]
  ],
  "./zh-Hans/permissions.json": [
    "855525",
    [
      874163
    ]
  ],
  "./da-x-k12/calendar_custom_recurring_event_repeat_picker.json": [
    "727361",
    [
      765499
    ]
  ],
  "./uk/assignments_2_submission_histories_query.json": [
    "961618",
    [
      877818
    ]
  ],
  "./sv/available_pronouns_list.json": [
    "606126",
    [
      243578
    ]
  ],
  "./pl/MoveOutcomesModal.json": [
    "251811",
    [
      306461
    ]
  ],
  "./tr/grade_summary.json": [
    "553324",
    [
      364096
    ]
  ],
  "./he/assignments_2_student_points_display.json": [
    "731593",
    [
      242775
    ]
  ],
  "./ru/important_dates_empty.json": [
    "338945",
    [
      688343
    ]
  ],
  "./sl/progress_pill.json": [
    "754502",
    [
      607906
    ]
  ],
  "./tr/account_calendar_settings_account_tree.json": [
    "611187",
    [
      190613
    ]
  ],
  "./de/k5_dashboard.json": [
    "277320",
    [
      723941
    ]
  ],
  "./hu/pairing_code_user_observees.json": [
    "685432",
    [
      196808
    ]
  ],
  "./da/peer-review-assignment-widget.json": [
    "129887",
    [
      437517
    ]
  ],
  "./fi/learning_mastery_gradebook.json": [
    "350200",
    [
      20944
    ]
  ],
  "./ms/conferences.json": [
    "917065",
    [
      320631
    ]
  ],
  "./ko/student_groups.json": [
    "848324",
    [
      219084
    ]
  ],
  "./ru/ldap_cert_upload.json": [
    "241349",
    [
      56611
    ]
  ],
  "./tr/canvas_file_upload.json": [
    "176881",
    [
      218963
    ]
  ],
  "./fi/comm_messages.json": [
    "422170",
    [
      120794
    ]
  ],
  "./ru/progression_module_header.json": [
    "142175",
    [
      738229
    ]
  ],
  "./th/ai_experiences.json": [
    "680506",
    [
      108814
    ]
  ],
  "./tr/job_stats.json": [
    "999699",
    [
      613357
    ]
  ],
  "./ar/assignments_2_MoreOptions.json": [
    "777608",
    [
      445108
    ]
  ],
  "./en-GB-x-lbs/quizzes.take_quiz.json": [
    "305222",
    [
      534415
    ]
  ],
  "./en-GB-x-ukhe/calendar_custom_recurring_event_repeat_picker.json": [
    "319974",
    [
      713390
    ]
  ],
  "./ko/outcome_reporting.json": [
    "6053",
    [
      373435
    ]
  ],
  "./el/assignments_2_file_upload.json": [
    "454501",
    [
      593935
    ]
  ],
  "./en-AU/password_complexity_configuration.json": [
    "537163",
    [
      61350
    ]
  ],
  "./en-GB-x-lbs/discussion_create.json": [
    "464329",
    [
      215791
    ]
  ],
  "./fa/roster_section_input.json": [
    "38817",
    [
      853655
    ]
  ],
  "./pt-BR/AssignmentListItemView.json": [
    "917294",
    [
      658423
    ]
  ],
  "./sl/blueprint_settingsCoursePicker.json": [
    "473161",
    [
      417987
    ]
  ],
  "./zh-Hans/blueprint_coursesExpandableLockOptions.json": [
    "156098",
    [
      196274
    ]
  ],
  "./zh-Hant/user_logins.json": [
    "297334",
    [
      134146
    ]
  ],
  "./fr/courses_show.json": [
    "765264",
    [
      514673
    ]
  ],
  "./pl/account_calendar_settings_footer.json": [
    "718206",
    [
      79762
    ]
  ],
  "./id/sidenav.json": [
    "506135",
    [
      697953
    ]
  ],
  "./sv/login.json": [
    "206386",
    [
      889918
    ]
  ],
  "./sv-x-k12/blueprint_course_child.json": [
    "371087",
    [
      31013
    ]
  ],
  "./ja/gradebook.json": [
    "262249",
    [
      438760
    ]
  ],
  "./nb-x-k12/bounced_emails.json": [
    "190452",
    [
      769828
    ]
  ],
  "./mi/last_attended.json": [
    "110612",
    [
      308268
    ]
  ],
  "./tr/bulk_edit_students_actions.json": [
    "152338",
    [
      580254
    ]
  ],
  "./zh-Hant/a2LatePolicyToolTipContent.json": [
    "272553",
    [
      900259
    ]
  ],
  "./ga/outcome_alignment_v2.json": [
    "639445",
    [
      832627
    ]
  ],
  "./fr/modules_home_page.json": [
    "551203",
    [
      76026
    ]
  ],
  "./en-GB-x-ukhe/calendar_appointment_group_edit.json": [
    "932689",
    [
      610327
    ]
  ],
  "./hu/user.json": [
    "297352",
    [
      529560
    ]
  ],
  "./ga/important_dates_empty.json": [
    "977988",
    [
      636548
    ]
  ],
  "./ht/accessibility_scan.json": [
    "747162",
    [
      669926
    ]
  ],
  "./ja/link_to_students.json": [
    "377396",
    [
      785777
    ]
  ],
  "./sv/theme_collection_view.json": [
    "837897",
    [
      40891
    ]
  ],
  "./nn/MobileGlobalMenu.json": [
    "897832",
    [
      837660
    ]
  ],
  "./is/editAssignmentGroupWeights.json": [
    "89591",
    [
      158749
    ]
  ],
  "./nb/filter_calendars_modal.json": [
    "939762",
    [
      256246
    ]
  ],
  "./pt/question_bank.json": [
    "973537",
    [
      222699
    ]
  ],
  "./sl/paginated_list.json": [
    "261067",
    [
      526565
    ]
  ],
  "./sv-x-k12/copy_warnings_modal.json": [
    "294984",
    [
      134064
    ]
  ],
  "./es-ES/student_groups.json": [
    "107609",
    [
      133439
    ]
  ],
  "./de/edit_section_start_date.json": [
    "194957",
    [
      723484
    ]
  ],
  "./en-GB-x-lbs/epub_exports.json": [
    "723914",
    [
      448378
    ]
  ],
  "./vi/admin_split.json": [
    "392479",
    [
      233541
    ]
  ],
  "./ht/content_exports.json": [
    "871379",
    [
      644349
    ]
  ],
  "./id/unpublished_warning_modal.json": [
    "736029",
    [
      699839
    ]
  ],
  "./da/user_search_results.json": [
    "165032",
    [
      267976
    ]
  ],
  "./de/restore_content_pane.json": [
    "594208",
    [
      169773
    ]
  ],
  "./fr/edit_section_end_date.json": [
    "897933",
    [
      901816
    ]
  ],
  "./th/AccountsTray.json": [
    "733154",
    [
      84350
    ]
  ],
  "./hi/blueprint_settingsCoursePicker.json": [
    "442113",
    [
      492868
    ]
  ],
  "./vi/assignment_2_assignment_toggle_details.json": [
    "144593",
    [
      310119
    ]
  ],
  "./en-GB-x-lbs/course_color_selector.json": [
    "394327",
    [
      394413
    ]
  ],
  "./fa/course_link_validator.json": [
    "347968",
    [
      814952
    ]
  ],
  "./nn/mutationActivity.json": [
    "327860",
    [
      189960
    ]
  ],
  "./ru/conferences.json": [
    "129752",
    [
      721680
    ]
  ],
  "./de/student_annotation_preview.json": [
    "40421",
    [
      485684
    ]
  ],
  "./en-AU/lti_registrations.json": [
    "623778",
    [
      251883
    ]
  ],
  "./he/quizzes_public.json": [
    "102320",
    [
      580528
    ]
  ],
  "./uk/accessibility_course_statistics.json": [
    "471532",
    [
      516068
    ]
  ],
  "./en.runtime.json": [
    "978744",
    [
      123671
    ]
  ],
  "./fi/account_notification_settings.json": [
    "921038",
    [
      99158
    ]
  ],
  "./fr-CA/react_developer_keys.json": [
    "265278",
    [
      724618
    ]
  ],
  "./es/permissions.json": [
    "100318",
    [
      704815
    ]
  ],
  "./da-x-k12/course_paces_search.json": [
    "283620",
    [
      828032
    ]
  ],
  "./en-GB-x-lbs/quizzes_index.json": [
    "607110",
    [
      63934
    ]
  ],
  "./ht/course_template_details.json": [
    "494287",
    [
      588777
    ]
  ],
  "./pl/assignments.json": [
    "842804",
    [
      844464
    ]
  ],
  "./ru/assignments.no_assignments_search.json": [
    "369588",
    [
      299189
    ]
  ],
  "./sl/SpeedGraderDiscussionsNavigation.json": [
    "256796",
    [
      659720
    ]
  ],
  "./es/ldap_cert_upload.json": [
    "22442",
    [
      772131
    ]
  ],
  "./id/k5_dashboard.json": [
    "943234",
    [
      364614
    ]
  ],
  "./he/k5_course.json": [
    "938001",
    [
      926223
    ]
  ],
  "./he/assignments_2_submission_histories_query.json": [
    "228923",
    [
      226881
    ]
  ],
  "./fi/GroupsTray.json": [
    "889945",
    [
      630719
    ]
  ],
  "./ms/course_template_details.json": [
    "392087",
    [
      497925
    ]
  ],
  "./sv-x-k12/gradebook_default_gradebook_components_content_filters_module_filter.json": [
    "66691",
    [
      544145
    ]
  ],
  "./ar/blueprint_course_child.json": [
    "730015",
    [
      884073
    ]
  ],
  "./cy/bulk_edit_students_actions.json": [
    "970471",
    [
      973132
    ]
  ],
  "./he/filter_calendars_modal.json": [
    "626827",
    [
      130545
    ]
  ],
  "./cy/video_conference.json": [
    "566604",
    [
      840756
    ]
  ],
  "./ga/gradinggradingPeriodCollection.json": [
    "917439",
    [
      483029
    ]
  ],
  "./nn/upload_button.json": [
    "134904",
    [
      592324
    ]
  ],
  "./pt-BR/assignments_2_MoreOptions_CanvasFiles.json": [
    "423474",
    [
      472483
    ]
  ],
  "./tr/upload_button.json": [
    "940690",
    [
      737262
    ]
  ],
  "./nn/edit_section_start_date.json": [
    "637958",
    [
      111962
    ]
  ],
  "./es/theme_editor.json": [
    "58049",
    [
      770288
    ]
  ],
  "./pl/discussion_settings.json": [
    "910398",
    [
      604418
    ]
  ],
  "./tr/discussion_row.json": [
    "122399",
    [
      118721
    ]
  ],
  "./vi/LogoutButton.json": [
    "341683",
    [
      904273
    ]
  ],
  "./pl/external_content_cancel.json": [
    "991746",
    [
      920430
    ]
  ],
  "./ar/ai_experiences_edit.json": [
    "943504",
    [
      762404
    ]
  ],
  "./ru/course_paces_projected_dates.json": [
    "855802",
    [
      675914
    ]
  ],
  "./el/edit_section_view.json": [
    "931203",
    [
      66925
    ]
  ],
  "./el/link_to_students.json": [
    "768868",
    [
      198072
    ]
  ],
  "./fi/blueprint_settingsSyncChange.json": [
    "748519",
    [
      36717
    ]
  ],
  "./ga/MobileGlobalMenu.json": [
    "808104",
    [
      682720
    ]
  ],
  "./ca/homeroom_page.json": [
    "793884",
    [
      585748
    ]
  ],
  "./el/outcome_reporting.json": [
    "12397",
    [
      303510
    ]
  ],
  "./hu/outcome_alignment_v2.json": [
    "75368",
    [
      391864
    ]
  ],
  "./it/permissions_role_tray.json": [
    "192957",
    [
      360127
    ]
  ],
  "./en-GB-x-ukhe/SpeedGraderSettingsMenu.json": [
    "547514",
    [
      852618
    ]
  ],
  "./nb/empty_course.json": [
    "942961",
    [
      900307
    ]
  ],
  "./pt/GroupsTray.json": [
    "132290",
    [
      55622
    ]
  ],
  "./da-x-k12/course_paces_footer.json": [
    "863731",
    [
      969565
    ]
  ],
  "./tr/course_logging_details.json": [
    "300662",
    [
      603050
    ]
  ],
  "./ja/course_paces_blueprint_lock.json": [
    "580675",
    [
      580126
    ]
  ],
  "./nb-x-k12/calendar_custom_recurring_event_repeat_picker.json": [
    "931914",
    [
      995386
    ]
  ],
  "./vi/blueprint_settingsSyncHistory.json": [
    "884177",
    [
      302807
    ]
  ],
  "./pt/media_immersive_view.json": [
    "592886",
    [
      596842
    ]
  ],
  "./sl/new_nav.json": [
    "723801",
    [
      226707
    ]
  ],
  "./sv/plugins.json": [
    "904519",
    [
      710905
    ]
  ],
  "./fr-CA/dashboard_grades_page.json": [
    "417430",
    [
      571562
    ]
  ],
  "./fr-CA/permissions_v2.json": [
    "728960",
    [
      626028
    ]
  ],
  "./nb/youtube_migration.json": [
    "979892",
    [
      34072
    ]
  ],
  "./is/assignments_2_submission_histories_query.json": [
    "282942",
    [
      911878
    ]
  ],
  "./nl/progress_pill.json": [
    "196271",
    [
      16761
    ]
  ],
  "./pt/available_pronouns_list.json": [
    "418687",
    [
      565881
    ]
  ],
  "./th/authentication_providers.json": [
    "558107",
    [
      739493
    ]
  ],
  "./hu/bulk_edit_students.json": [
    "326149",
    [
      405259
    ]
  ],
  "./ja/homeroom_page.json": [
    "210189",
    [
      698788
    ]
  ],
  "./nb-x-k12/assignments_2_text_entry.json": [
    "718220",
    [
      738796
    ]
  ],
  "./id/available_pronouns_list.json": [
    "793290",
    [
      718566
    ]
  ],
  "./ja/context_modules_v2.json": [
    "396787",
    [
      552974
    ]
  ],
  "./pt/assignment_show.json": [
    "540325",
    [
      890535
    ]
  ],
  "./ja/course_link_validator.json": [
    "79284",
    [
      198257
    ]
  ],
  "./en-CA/discussion_pinned_post.json": [
    "181732",
    [
      666324
    ]
  ],
  "./ga/editAssignmentGroupWeights.json": [
    "266079",
    [
      657525
    ]
  ],
  "./en-GB-x-ukhe/user_lists.json": [
    "394425",
    [
      336239
    ]
  ],
  "./es-ES/edit_section_dates.json": [
    "578611",
    [
      590609
    ]
  ],
  "./hy/copy_course.json": [
    "149098",
    [
      549578
    ]
  ],
  "./tr/grade_change_logging_content.json": [
    "208240",
    [
      289476
    ]
  ],
  "./it/course_paces_search.json": [
    "65816",
    [
      894556
    ]
  ],
  "./pt-BR/course_paces_app.json": [
    "47007",
    [
      947210
    ]
  ],
  "./ar/editGroup.json": [
    "243534",
    [
      115634
    ]
  ],
  "./fa/peer_review_allocation_rule_card.json": [
    "811067",
    [
      32441
    ]
  ],
  "./pt/quizzes_quiz_submission.json": [
    "931530",
    [
      545646
    ]
  ],
  "./pt/react_files.json": [
    "915725",
    [
      874807
    ]
  ],
  "./ms/progressbar_view.json": [
    "843286",
    [
      215670
    ]
  ],
  "./tr/entity_search_form.json": [
    "393091",
    [
      939477
    ]
  ],
  "./nl/discovery_page.json": [
    "341484",
    [
      872800
    ]
  ],
  "./cy/bulk_edit_students.json": [
    "8048",
    [
      128176
    ]
  ],
  "./da/lti_registration.wizard.json": [
    "669735",
    [
      979514
    ]
  ],
  "./es/DueDateOverrideView.json": [
    "519993",
    [
      948584
    ]
  ],
  "./id/unpublished_changes_tray_contents.json": [
    "667946",
    [
      575958
    ]
  ],
  "./ms/paginated_list.json": [
    "827366",
    [
      474502
    ]
  ],
  "./tr/course_paces_module.json": [
    "748899",
    [
      923405
    ]
  ],
  "./fi/assignments.json": [
    "288253",
    [
      728187
    ]
  ],
  "./de/appointment_groups.json": [
    "929805",
    [
      518316
    ]
  ],
  "./it/important_dates_empty.json": [
    "479521",
    [
      842163
    ]
  ],
  "./it/student_groups.json": [
    "211721",
    [
      504763
    ]
  ],
  "./zh-Hans/MobileGlobalMenu.json": [
    "868265",
    [
      719279
    ]
  ],
  "./es-ES/modules_page_icon_legend.json": [
    "181192",
    [
      958352
    ]
  ],
  "./pt/use_switch_experience.json": [
    "65763",
    [
      776261
    ]
  ],
  "./fr/choose_mastery_path.json": [
    "505125",
    [
      545656
    ]
  ],
  "./fi/discussion_row.json": [
    "592178",
    [
      896386
    ]
  ],
  "./fa/mutationActivity.json": [
    "794559",
    [
      499461
    ]
  ],
  "./sv/choose_mastery_path.json": [
    "28592",
    [
      331020
    ]
  ],
  "./he/terms_index.json": [
    "994365",
    [
      473331
    ]
  ],
  "./de/grade_summaryGroupView.json": [
    "144621",
    [
      469212
    ]
  ],
  "./mi/quizzes.take_quiz.json": [
    "828498",
    [
      173323
    ]
  ],
  "./cy/webzip_export.json": [
    "4166",
    [
      976870
    ]
  ],
  "./hu/gradebook_history.json": [
    "497500",
    [
      679396
    ]
  ],
  "./pt/course_paces_actions.json": [
    "355360",
    [
      65124
    ]
  ],
  "./nb-x-k12/assignments_2_external_tool.json": [
    "795710",
    [
      874950
    ]
  ],
  "./th/gradinggradingPeriodCollection.json": [
    "367843",
    [
      446757
    ]
  ],
  "./el/course_paces_app.json": [
    "381123",
    [
      721573
    ]
  ],
  "./en-GB/course_paces_module.json": [
    "73544",
    [
      341169
    ]
  ],
  "./fr-CA/peer_review_configuration_tray.json": [
    "537124",
    [
      158792
    ]
  ],
  "./fa/LogoutButton.json": [
    "545835",
    [
      755801
    ]
  ],
  "./ca/paginated_list.json": [
    "352230",
    [
      464150
    ]
  ],
  "./mi/account_calendar_settings_account_group.json": [
    "898714",
    [
      836322
    ]
  ],
  "./fa/entity_search_form.json": [
    "771186",
    [
      614850
    ]
  ],
  "./en-AU-x-unimelb/course_link_validator.json": [
    "947149",
    [
      436799
    ]
  ],
  "./id/outcome_alignment_v2.json": [
    "823334",
    [
      750026
    ]
  ],
  "./it/DueDateOverrideView.json": [
    "250156",
    [
      917504
    ]
  ],
  "./nb-x-k12/SpeedGraderDiscussionsNavigation.json": [
    "632015",
    [
      216085
    ]
  ],
  "./es/discovery_page.json": [
    "784142",
    [
      527903
    ]
  ],
  "./fa/content_copy_redesign.json": [
    "777756",
    [
      118268
    ]
  ],
  "./el/registration.json": [
    "519812",
    [
      619912
    ]
  ],
  "./fi/ImportConfirmBox.json": [
    "889049",
    [
      212527
    ]
  ],
  "./pt/blueprint_settingsSyncHistory.json": [
    "902372",
    [
      371440
    ]
  ],
  "./es/MobileGlobalMenu.json": [
    "386900",
    [
      778849
    ]
  ],
  "./pl/user_restore.json": [
    "171580",
    [
      229496
    ]
  ],
  "./tr/peer_review_allocation_rules_tray.json": [
    "465265",
    [
      166739
    ]
  ],
  "./en-GB-x-lbs/GroupDetailView.json": [
    "313491",
    [
      821425
    ]
  ],
  "./pt-BR/remove_pace_warning_modal.json": [
    "914140",
    [
      869713
    ]
  ],
  "./pl/calendar_appointment_group_edit.json": [
    "94003",
    [
      542877
    ]
  ],
  "./uk/blueprint_settingsSyncChange.json": [
    "15892",
    [
      836540
    ]
  ],
  "./it/account_calendar_settings_account_calendar_item_dropdown.json": [
    "883702",
    [
      817978
    ]
  ],
  "./el/course_paces_pace_picker.json": [
    "428294",
    [
      624698
    ]
  ],
  "./zh-Hant/assignments_2_MoreOptions.json": [
    "966242",
    [
      973751
    ]
  ],
  "./sv-x-k12/quizzes_index.json": [
    "916999",
    [
      280221
    ]
  ],
  "./hi/theme_editor.json": [
    "976464",
    [
      377256
    ]
  ],
  "./ga/assignment_2_assignment_toggle_details.json": [
    "999858",
    [
      165698
    ]
  ],
  "./nb-x-k12/assignment_index_menu.json": [
    "248296",
    [
      794160
    ]
  ],
  "./en-GB-x-lbs/rootFoldersFinder.json": [
    "589081",
    [
      246479
    ]
  ],
  "./zh-Hans/course_link_validator.json": [
    "921934",
    [
      988630
    ]
  ],
  "./es-ES/CourseAvailabilityOptions.json": [
    "872527",
    [
      373813
    ]
  ],
  "./el/course_paces_time_selection.json": [
    "662812",
    [
      644600
    ]
  ],
  "./en-GB/peer_review_allocation_rule_card.json": [
    "406807",
    [
      907638
    ]
  ],
  "./ru/not_found_page_slide_puzzle.json": [
    "288076",
    [
      781884
    ]
  ],
  "./fi/content_migrations_redesign.json": [
    "603484",
    [
      512684
    ]
  ],
  "./pl/MobileGlobalMenu.json": [
    "272692",
    [
      951640
    ]
  ],
  "./ht/login.json": [
    "726983",
    [
      611993
    ]
  ],
  "./it/canvas_file_upload.json": [
    "555584",
    [
      890172
    ]
  ],
  "./de/ai_experiences.json": [
    "782835",
    [
      848118
    ]
  ],
  "./cy/unpublished_changes_button_props.json": [
    "731901",
    [
      750451
    ]
  ],
  "./es-ES/user_grades.json": [
    "346947",
    [
      94689
    ]
  ],
  "./ar/discussion_create.json": [
    "756672",
    [
      429652
    ]
  ],
  "./ga/blueprint_settingsSyncChange.json": [
    "947368",
    [
      740560
    ]
  ],
  "./nb/authentication_providers.json": [
    "858387",
    [
      663453
    ]
  ],
  "./ru/assignments_2_external_tool.json": [
    "394965",
    [
      700611
    ]
  ],
  "./ms/assignments_peer_reviews.json": [
    "149519",
    [
      216173
    ]
  ],
  "./zh-Hant/accessibility_checker.json": [
    "889048",
    [
      612620
    ]
  ],
  "./cy/edit_section_view.json": [
    "521890",
    [
      426458
    ]
  ],
  "./ht/assignment_grade_summary.json": [
    "343952",
    [
      617260
    ]
  ],
  "./pt-BR/ai_experiences_show.json": [
    "736643",
    [
      546406
    ]
  ],
  "./he/HelpTray.json": [
    "189032",
    [
      20184
    ]
  ],
  "./es-ES/editAssignmentGroupWeights.json": [
    "800592",
    [
      109304
    ]
  ],
  "./es/unpublished_changes_button_props.json": [
    "126957",
    [
      151636
    ]
  ],
  "./ht/user_restore.json": [
    "813612",
    [
      46152
    ]
  ],
  "./ko/theme_editor.json": [
    "972815",
    [
      427197
    ]
  ],
  "./th/not_found_page_slide_puzzle.json": [
    "840825",
    [
      83835
    ]
  ],
  "./nl/license_help.json": [
    "374535",
    [
      630113
    ]
  ],
  "./hi/gradebook_uploads.json": [
    "17506",
    [
      873618
    ]
  ],
  "./ar/courses.json": [
    "739395",
    [
      483797
    ]
  ],
  "./sv/course_paces_footer.json": [
    "921611",
    [
      816973
    ]
  ],
  "./id/course_restore.json": [
    "104653",
    [
      986391
    ]
  ],
  "./uk/rate_limiting_settings.json": [
    "529748",
    [
      554428
    ]
  ],
  "./nb-x-k12/peer_review_student_select.json": [
    "837806",
    [
      364918
    ]
  ],
  "./nl/assignments_2_student_header_date_title.json": [
    "960847",
    [
      646865
    ]
  ],
  "./en-GB/calculator_command.json": [
    "204971",
    [
      160042
    ]
  ],
  "./fr/course_paces_header.json": [
    "589524",
    [
      277837
    ]
  ],
  "./fi/calendar_sidebar.json": [
    "585004",
    [
      56556
    ]
  ],
  "./en/conferences.json": [
    "632394",
    [
      220214
    ]
  ],
  "./id/homeroom_page.json": [
    "757881",
    [
      513003
    ]
  ],
  "./it/ldap_cert_upload.json": [
    "390437",
    [
      367903
    ]
  ],
  "./hi/course_paces_app.json": [
    "219661",
    [
      98267
    ]
  ],
  "./ms/course_paces_footer.json": [
    "31754",
    [
      887570
    ]
  ],
  "./de/admin_split.json": [
    "483781",
    [
      668004
    ]
  ],
  "./fr-CA/content_copy_redesign.json": [
    "58384",
    [
      664036
    ]
  ],
  "./hi/permission_button.json": [
    "770589",
    [
      248651
    ]
  ],
  "./pl/keyboardShortcutModal.json": [
    "781626",
    [
      715582
    ]
  ],
  "./sl/modelsQuiz.json": [
    "996932",
    [
      873376
    ]
  ],
  "./uk/content_shares.json": [
    "480988",
    [
      497044
    ]
  ],
  "./ca.json": [
    "595429",
    [
      811225
    ]
  ],
  "./it/rubrics-export.json": [
    "838938",
    [
      259278
    ]
  ],
  "./fi/assignments_2_external_tool.json": [
    "850773",
    [
      865171
    ]
  ],
  "./ca/quizzes_public.json": [
    "964149",
    [
      623147
    ]
  ],
  "./ca/account_calendar_settings_account_group.json": [
    "174832",
    [
      261056
    ]
  ],
  "./is/calendar_appointment_group_edit.json": [
    "942439",
    [
      582013
    ]
  ],
  "./th/course_paces_blueprint_lock.json": [
    "4402",
    [
      818046
    ]
  ],
  "./nb/roster_publicjs.json": [
    "941812",
    [
      28864
    ]
  ],
  "./fi/appointment_groups.json": [
    "688583",
    [
      589149
    ]
  ],
  "./da/peer_review_student_select.json": [
    "746113",
    [
      353903
    ]
  ],
  "./hu/question_banks.json": [
    "7479",
    [
      315237
    ]
  ],
  "./id/discussion_pinned_post.json": [
    "978299",
    [
      386949
    ]
  ],
  "./pt-BR/course_paces_no_results.json": [
    "103758",
    [
      992231
    ]
  ],
  "./ru/edit_section_end_date.json": [
    "862728",
    [
      161584
    ]
  ],
  "./de/pairing_code_user_observees.json": [
    "786404",
    [
      48361
    ]
  ],
  "./el/k5_course.json": [
    "274855",
    [
      309025
    ]
  ],
  "./fi/unpublished_changes_tray_contents.json": [
    "581658",
    [
      331866
    ]
  ],
  "./ko/speed_grader_helpers.json": [
    "543361",
    [
      796399
    ]
  ],
  "./bundle-namespaces.json": [
    "488804",
    []
  ],
  "./ko/rootFoldersFinder.json": [
    "573929",
    [
      639367
    ]
  ],
  "./ja/enhanced_individual_gradebook_submit_score.json": [
    "934206",
    [
      213279
    ]
  ],
  "./es-ES/syllabus_revisions.json": [
    "467723",
    [
      620313
    ]
  ],
  "./da-x-k12/rubrics-export.json": [
    "767454",
    [
      21706
    ]
  ],
  "./zh-Hant/a2LatePolicyStatusDisplay.json": [
    "579151",
    [
      860161
    ]
  ],
  "./en-GB/assignments_2_student_header.json": [
    "40412",
    [
      579461
    ]
  ],
  "./pt-BR/student_study_drawer.json": [
    "346606",
    [
      299911
    ]
  ],
  "./ar/new_user_tutorial.json": [
    "691082",
    [
      516470
    ]
  ],
  "./de/permissions_role_tray.json": [
    "838979",
    [
      707814
    ]
  ],
  "./en-GB-x-ukhe/youtube_migration.json": [
    "232470",
    [
      169054
    ]
  ],
  "./pl/todos_page.json": [
    "174127",
    [
      103377
    ]
  ],
  "./en-CA/calendar_custom_recurring_event_natural_language.json": [
    "435158",
    [
      510030
    ]
  ],
  "./ms/assignments_2_submission_histories_query.json": [
    "596434",
    [
      101354
    ]
  ],
  "./sl/progressbar_view.json": [
    "672415",
    [
      190617
    ]
  ],
  "./fa/MoveOutcomesModal.json": [
    "368150",
    [
      491806
    ]
  ],
  "./ht/outcome_alignment_v2.json": [
    "491393",
    [
      403435
    ]
  ],
  "./en-GB-x-ukhe/assignments_2_submission_helpers.json": [
    "738390",
    [
      753870
    ]
  ],
  "./hy/gradebook_history.json": [
    "962792",
    [
      649424
    ]
  ],
  "./da/assignment_index_deep_linking_handlers.json": [
    "386165",
    [
      877579
    ]
  ],
  "./fi/assignments_2_attempt_tab.json": [
    "301422",
    [
      109542
    ]
  ],
  "./es-ES/course_logging_details.json": [
    "628403",
    [
      350721
    ]
  ],
  "./fi/assignment_2_assignment_toggle_details.json": [
    "842369",
    [
      340919
    ]
  ],
  "./it/course_color_selector.json": [
    "334684",
    [
      215864
    ]
  ],
  "./is/quizzes.take_quiz.json": [
    "120608",
    [
      675653
    ]
  ],
  "./da-x-k12/LearningMasteryGradebook.json": [
    "743802",
    [
      158
    ]
  ],
  "./ko/ai_experiences_edit.json": [
    "993877",
    [
      346219
    ]
  ],
  "./it/CreateEditAssignmentModalAdapter.json": [
    "795532",
    [
      584672
    ]
  ],
  "./hy/collaborations.json": [
    "329069",
    [
      298971
    ]
  ],
  "./fr/assignments_2_media_attempt.json": [
    "130708",
    [
      580013
    ]
  ],
  "./zh-Hant/peer_review_allocation_rules_tray.json": [
    "102033",
    [
      495907
    ]
  ],
  "./ms/assignments_2_student_header_date_title.json": [
    "190333",
    [
      860275
    ]
  ],
  "./fr-CA/course_template_details.json": [
    "564490",
    [
      420270
    ]
  ],
  "./nn/LogoutButton.json": [
    "382348",
    [
      806880
    ]
  ],
  "./ar/calculator.json": [
    "554935",
    [
      965593
    ]
  ],
  "./ja/assignments_2_shared_Steps.json": [
    "274748",
    [
      305721
    ]
  ],
  "./nb-x-k12/module_student_view_peer_reviews.json": [
    "908343",
    [
      511901
    ]
  ],
  "./th/assignments_bulk_edit_use_save_assignment.json": [
    "47738",
    [
      681574
    ]
  ],
  "./fa/student_groups.json": [
    "17009",
    [
      448951
    ]
  ],
  "./mi/conferences.json": [
    "390859",
    [
      854353
    ]
  ],
  "./en-GB-x-ukhe/calendar.header.json": [
    "720201",
    [
      618380
    ]
  ],
  "./it/content_exports.json": [
    "636006",
    [
      790770
    ]
  ],
  "./ga/account_calendars_results_area.json": [
    "788504",
    [
      520544
    ]
  ],
  "./nl/use_switch_experience.json": [
    "399301",
    [
      674575
    ]
  ],
  "./ru/keyboardShortcutModal.json": [
    "608119",
    [
      526205
    ]
  ],
  "./da-x-k12/ai_experiences_edit.json": [
    "8546",
    [
      50934
    ]
  ],
  "./hy/eportfolio.json": [
    "392362",
    [
      535498
    ]
  ],
  "./uk/LogoutButton.json": [
    "933336",
    [
      193112
    ]
  ],
  "./zh-Hant/discussion_posts.json": [
    "48984",
    [
      130876
    ]
  ],
  "./id/external_content_cancel.json": [
    "595499",
    [
      404861
    ]
  ],
  "./ga/account_calendar_settings_footer.json": [
    "557002",
    [
      905882
    ]
  ],
  "./en-GB-x-ukhe/lti_registrations.json": [
    "5318",
    [
      71166
    ]
  ],
  "./vi/course_paces_app.json": [
    "526975",
    [
      842629
    ]
  ],
  "./hi/ImportConfirmBox.json": [
    "618275",
    [
      512369
    ]
  ],
  "./sv/AlignmentSummary.json": [
    "113466",
    [
      699230
    ]
  ],
  "./he/edit_section_start_date.json": [
    "109025",
    [
      810463
    ]
  ],
  "./th/account_calendar_settings_account_list.json": [
    "313777",
    [
      617619
    ]
  ],
  "./en-AU-x-unimelb/sections_tooltip.json": [
    "71090",
    [
      800510
    ]
  ],
  "./zh-Hant/MasteryScale.json": [
    "881481",
    [
      39275
    ]
  ],
  "./fr/new_user_tutorial.json": [
    "208105",
    [
      524204
    ]
  ],
  "./ht/course_paces_header.json": [
    "505644",
    [
      118800
    ]
  ],
  "./ja/calculator_command.json": [
    "522107",
    [
      348534
    ]
  ],
  "./ca/course_statistics.json": [
    "390771",
    [
      617657
    ]
  ],
  "./sv-x-k12/restore_content_pane.json": [
    "972392",
    [
      304464
    ]
  ],
  "./en-GB/outcomes_user_outcome_results.json": [
    "917088",
    [
      355377
    ]
  ],
  "./ga/student_study_drawer.json": [
    "652381",
    [
      315755
    ]
  ],
  "./uk/react_collaborations.json": [
    "18912",
    [
      209200
    ]
  ],
  "./sv-x-k12/blueprint_course_sidebar.json": [
    "266925",
    [
      761627
    ]
  ],
  "./el/a2LatePolicyToolTipContent.json": [
    "559096",
    [
      365252
    ]
  ],
  "./ru/course_paces_settings.json": [
    "631901",
    [
      261288
    ]
  ],
  "./ru/NewTabIndicator.json": [
    "444861",
    [
      864347
    ]
  ],
  "./en-GB-x-lbs/course_logging_details.json": [
    "735618",
    [
      221698
    ]
  ],
  "./ru/course_paces_blackout_dates_modal.json": [
    "826461",
    [
      550939
    ]
  ],
  "./tr/assignment_2_assignment_toggle_details.json": [
    "7272",
    [
      855684
    ]
  ],
  "./it/theme_editor.json": [
    "725390",
    [
      628986
    ]
  ],
  "./uk/gradinggradingPeriodCollection.json": [
    "775475",
    [
      256697
    ]
  ],
  "./nb-x-k12/dashboard.json": [
    "898592",
    [
      13896
    ]
  ],
  "./da-x-k12/canvascareer.json": [
    "181715",
    [
      899645
    ]
  ],
  "./mi/moderate_quiz.json": [
    "918923",
    [
      91217
    ]
  ],
  "./nb-x-k12/AccountsTray.json": [
    "112864",
    [
      296347
    ]
  ],
  "./ca/courses.json": [
    "670180",
    [
      619212
    ]
  ],
  "./nn/pseudonyms_mobile_login.json": [
    "223354",
    [
      472366
    ]
  ],
  "./pt/editAssignmentGroupWeights.json": [
    "687219",
    [
      363189
    ]
  ],
  "./zh-Hans/course_color_selector.json": [
    "286838",
    [
      221198
    ]
  ],
  "./uk/assignments_2_student_header.json": [
    "662971",
    [
      783217
    ]
  ],
  "./mi/edit_section_dates.json": [
    "495214",
    [
      965406
    ]
  ],
  "./en-GB-x-lbs/files_v2.json": [
    "83144",
    [
      245440
    ]
  ],
  "./ru/AssignmentListItemView.json": [
    "309630",
    [
      26822
    ]
  ],
  "./es/dashboard_grades_page.json": [
    "554863",
    [
      681890
    ]
  ],
  "./da/blueprint_settingsAssociationsTable.json": [
    "28262",
    [
      793718
    ]
  ],
  "./fa/theme_collection_view.json": [
    "372997",
    [
      696899
    ]
  ],
  "./ht/account_calendars.json": [
    "65045",
    [
      1495
    ]
  ],
  "./it/calendar.header.json": [
    "76918",
    [
      471209
    ]
  ],
  "./es-ES/media_player_iframe_content.json": [
    "15224",
    [
      708160
    ]
  ],
  "./hy/grade_summary.json": [
    "704917",
    [
      537331
    ]
  ],
  "./hi/assignments_bulk_edit_use_save_assignment.json": [
    "222485",
    [
      680755
    ]
  ],
  "./hy/OutcomeMoveModal.json": [
    "51369",
    [
      813567
    ]
  ],
  "./nb/permissions_v2_add_tray.json": [
    "86136",
    [
      656868
    ]
  ],
  "./pt-BR/conferences.json": [
    "81320",
    [
      392594
    ]
  ],
  "./ht/peer-review-assignment-widget.json": [
    "36388",
    [
      818336
    ]
  ],
  "./sv-x-k12/course_paces_module.json": [
    "848858",
    [
      715930
    ]
  ],
  "./he/blueprint_settingsCoursePickerTable.json": [
    "444507",
    [
      636033
    ]
  ],
  "./pt-BR/webzip_export.json": [
    "668611",
    [
      703478
    ]
  ],
  "./tr/assignments_2_submission_helpers.json": [
    "202682",
    [
      948830
    ]
  ],
  "./ko/accessibility_scan.json": [
    "613928",
    [
      702408
    ]
  ],
  "./ar/AddGroup.json": [
    "514025",
    [
      141771
    ]
  ],
  "./nn/gradebookOutcomeGradebookView.json": [
    "640443",
    [
      683589
    ]
  ],
  "./da-x-k12/GroupsTray.json": [
    "668677",
    [
      644623
    ]
  ],
  "./da-x-k12/discussion_topics_edit.json": [
    "426839",
    [
      135841
    ]
  ],
  "./id/suppress_notifications.json": [
    "80201",
    [
      229243
    ]
  ],
  "./sv/sharedSetDefaultGradeDialog.json": [
    "188588",
    [
      899888
    ]
  ],
  "./fr-CA/files_v2.json": [
    "924665",
    [
      453576
    ]
  ],
  "./it.eager.json": [
    "668294",
    [
      277213
    ]
  ],
  "./zh-Hant/user_name.json": [
    "855552",
    [
      770237
    ]
  ],
  "./vi/blueprint_settingsCoursePicker.json": [
    "851767",
    [
      826349
    ]
  ],
  "./it/permission_button.json": [
    "452799",
    [
      713193
    ]
  ],
  "./ht/folder_tree.json": [
    "427779",
    [
      817605
    ]
  ],
  "./hu/suppress_notifications.json": [
    "176283",
    [
      156065
    ]
  ],
  "./es-ES/GroupDetailView.json": [
    "790816",
    [
      863672
    ]
  ],
  "./is/course_template_details.json": [
    "618651",
    [
      527705
    ]
  ],
  "./es-ES/assignments_2_login_action_prompt.json": [
    "356844",
    [
      693020
    ]
  ],
  "./fr-CA/discussion_create.json": [
    "631126",
    [
      909258
    ]
  ],
  "./is/OutcomeDescriptionModal.json": [
    "797105",
    [
      99415
    ]
  ],
  "./en-GB-x-lbs/FindOutcomesModal.json": [
    "756423",
    [
      604253
    ]
  ],
  "./th/account_notification_settings.json": [
    "388515",
    [
      785949
    ]
  ],
  "./ga/dashboard_grades_page.json": [
    "34619",
    [
      583177
    ]
  ],
  "./ms/upload_button.json": [
    "737092",
    [
      891292
    ]
  ],
  "./tr/media_player_iframe_content.json": [
    "554171",
    [
      420285
    ]
  ],
  "./ht/MobileGlobalMenu.json": [
    "158468",
    [
      480392
    ]
  ],
  "./mi/reset_pace_warning_modal.json": [
    "817706",
    [
      202994
    ]
  ],
  "./ko/progressbar_view.json": [
    "561268",
    [
      666172
    ]
  ],
  "./sl/course_template_details.json": [
    "434164",
    [
      763664
    ]
  ],
  "./ga/course_search_results.json": [
    "688569",
    [
      261887
    ]
  ],
  "./ja/blueprint_settingsUnsyncedChanges.json": [
    "53610",
    [
      421715
    ]
  ],
  "./de/login.json": [
    "350260",
    [
      498937
    ]
  ],
  "./zh-Hans/overview_page.json": [
    "487314",
    [
      416914
    ]
  ],
  "./ms/jobs.json": [
    "863702",
    [
      291894
    ]
  ],
  "./pl/assignments_2_url_entry.json": [
    "377528",
    [
      378908
    ]
  ],
  "./nb/permission_button.json": [
    "243826",
    [
      678894
    ]
  ],
  "./hu/theme_editor.json": [
    "59364",
    [
      604092
    ]
  ],
  "./es/grades_summary.json": [
    "739997",
    [
      506052
    ]
  ],
  "./nb/announcements_on_home_page.json": [
    "132506",
    [
      634446
    ]
  ],
  "./he/collaborations.json": [
    "277137",
    [
      367855
    ]
  ],
  "./hu/assignment_index_menu.json": [
    "537725",
    [
      413491
    ]
  ],
  "./sv/IndividualStudentMasteryOutcome.json": [
    "587874",
    [
      158838
    ]
  ],
  "./tr/progressbar_view.json": [
    "275848",
    [
      538348
    ]
  ],
  "./da-x-k12/grade_change_logging_content.json": [
    "144017",
    [
      548187
    ]
  ],
  "./da/content_exports.json": [
    "337620",
    [
      948380
    ]
  ],
  "./es-ES/bounced_emails.json": [
    "709505",
    [
      709543
    ]
  ],
  "./hy/course_paces_time_selection.json": [
    "897070",
    [
      261782
    ]
  ],
  "./nb/LogoutButton.json": [
    "955008",
    [
      244388
    ]
  ],
  "./fr-CA/sidenav.json": [
    "63555",
    [
      831885
    ]
  ],
  "./pt-BR/course_restore.json": [
    "983181",
    [
      929900
    ]
  ],
  "./nb-x-k12/CreateEditAssignmentModal.json": [
    "15106",
    [
      406722
    ]
  ],
  "./es-ES/assignments_2_student_content.json": [
    "579326",
    [
      410326
    ]
  ],
  "./ga/assignments_2_submission_histories_query.json": [
    "393670",
    [
      75934
    ]
  ],
  "./nb-x-k12/enhanced_individual_gradebook_submit_score.json": [
    "800951",
    [
      107293
    ]
  ],
  "./pt-BR/student_entries.json": [
    "218179",
    [
      444230
    ]
  ],
  "./fi/editAssignmentGroupWeights.json": [
    "364224",
    [
      575704
    ]
  ],
  "./ru/edit_section_start_date.json": [
    "374375",
    [
      614781
    ]
  ],
  "./sv/module_student_view_peer_reviews.json": [
    "139010",
    [
      874782
    ]
  ],
  "./ht/upload_button.json": [
    "370332",
    [
      813656
    ]
  ],
  "./fr/course_paces_actions.json": [
    "153024",
    [
      515657
    ]
  ],
  "./it/AssignmentGroupListItemView.json": [
    "161817",
    [
      658587
    ]
  ],
  "./vi/account_calendar_settings_account_group.json": [
    "671869",
    [
      465387
    ]
  ],
  "./en/course_paces_app.json": [
    "101501",
    [
      120391
    ]
  ],
  "./nn/theme_collection_view.json": [
    "776348",
    [
      14064
    ]
  ],
  "./fi/modelsQuiz.json": [
    "340154",
    [
      341002
    ]
  ],
  "./sl/users.json": [
    "242129",
    [
      405675
    ]
  ],
  "./sv-x-k12/assignments_2_login_action_prompt.json": [
    "189378",
    [
      920930
    ]
  ],
  "./nl/assignment_grade_summary.json": [
    "327070",
    [
      616370
    ]
  ],
  "./de/edit_section_view.json": [
    "359745",
    [
      867608
    ]
  ],
  "./sv-x-k12/discovery_page.json": [
    "945067",
    [
      36345
    ]
  ],
  "./ja/content_migrations_redesign.json": [
    "640936",
    [
      69069
    ]
  ],
  "./vi/student_groups.json": [
    "135961",
    [
      235823
    ]
  ],
  "./es-ES/enhanced_individual_gradebook_submit_score.json": [
    "69778",
    [
      680594
    ]
  ],
  "./nb-x-k12/rate_limiting_settings.json": [
    "332750",
    [
      292950
    ]
  ],
  "./sl/assignments_bulk_edit.json": [
    "514921",
    [
      830171
    ]
  ],
  "./nb/edit_section_end_date.json": [
    "590981",
    [
      509855
    ]
  ],
  "./sv-x-k12/user_name.json": [
    "934694",
    [
      181006
    ]
  ],
  "./ko/pseudonyms_mobile_login.json": [
    "312552",
    [
      262600
    ]
  ],
  "./fr-CA/gradebookOutcomeGradebookView.json": [
    "824010",
    [
      254494
    ]
  ],
  "./en-GB-x-ukhe/course_paces_assignment_row.json": [
    "138785",
    [
      679191
    ]
  ],
  "./en-GB-x-ukhe/course_restore.json": [
    "954956",
    [
      987548
    ]
  ],
  "./nn/LearningMasteryGradebook.json": [
    "38309",
    [
      753543
    ]
  ],
  "./pl/user_grades.json": [
    "295274",
    [
      953046
    ]
  ],
  "./sv/course_template_details.json": [
    "360506",
    [
      708446
    ]
  ],
  "./en-GB-x-lbs/new_user_tutorial.json": [
    "733847",
    [
      258093
    ]
  ],
  "./date-name-overrides.json": [
    "81735",
    []
  ],
  "./ar/blueprint_settingsCoursePicker.json": [
    "295185",
    [
      267203
    ]
  ],
  "./en/gradebook.json": [
    "655295",
    [
      787297
    ]
  ],
  "./nb/gradingGradeSummary.json": [
    "730335",
    [
      443345
    ]
  ],
  "./pt/ProfileTray.json": [
    "202299",
    [
      290621
    ]
  ],
  "./cy/unpublished_changes_tray_contents.json": [
    "719031",
    [
      428901
    ]
  ],
  "./en-GB-x-lbs/blueprint_settingsCourseFilter.json": [
    "71306",
    [
      245850
    ]
  ],
  "./is/course_paces_settings.json": [
    "515600",
    [
      95496
    ]
  ],
  "./mi/submit_assignment.json": [
    "622940",
    [
      970308
    ]
  ],
  "./id/grade_change_logging_content.json": [
    "725325",
    [
      308351
    ]
  ],
  "./nn/gradingGradeSummary.json": [
    "50683",
    [
      637821
    ]
  ],
  "./ht/course_paces_no_results.json": [
    "989827",
    [
      81109
    ]
  ],
  "./ar/blueprint_settingsCoursePickerTable.json": [
    "86135",
    [
      549833
    ]
  ],
  "./ko/learning_mastery_gradebook.json": [
    "266153",
    [
      364807
    ]
  ],
  "./mi/course_navigation_settings.json": [
    "935536",
    [
      268432
    ]
  ],
  "./zh-Hant/student_annotation_preview.json": [
    "873774",
    [
      854610
    ]
  ],
  "./hu/authentication_providers.json": [
    "309878",
    [
      540758
    ]
  ],
  "./nl/assignments_peer_reviews_student.json": [
    "464661",
    [
      473191
    ]
  ],
  "./fr/discussion_create.json": [
    "225535",
    [
      222886
    ]
  ],
  "./en-CA/outcome_management.json": [
    "145520",
    [
      537960
    ]
  ],
  "./fi/bulk_edit_students_actions.json": [
    "302539",
    [
      765513
    ]
  ],
  "./da-x-k12/blueprint_settingsCoursePickerTable.json": [
    "998745",
    [
      460131
    ]
  ],
  "./ja/courses.json": [
    "674113",
    [
      377344
    ]
  ],
  "./da-x-k12/SpeedGraderCheckpoints.json": [
    "420306",
    [
      289438
    ]
  ],
  "./zh-Hant/user_lists.json": [
    "535413",
    [
      42575
    ]
  ],
  "./ar/gradingGradeSummary.json": [
    "71340",
    [
      474696
    ]
  ],
  "./en-GB-x-lbs/calendar_edit.json": [
    "769303",
    [
      828333
    ]
  ],
  "./en-GB-x-ukhe/ProfileTray.json": [
    "627233",
    [
      364135
    ]
  ],
  "./ht/sidenav.json": [
    "62394",
    [
      698806
    ]
  ],
  "./hu/blueprint_settingsAssociationsTable.json": [
    "974518",
    [
      895670
    ]
  ],
  "./id/account_calendar_settings_account_calendar_item.json": [
    "663306",
    [
      102134
    ]
  ],
  "./ja/sharedSetDefaultGradeDialog.json": [
    "431596",
    [
      535337
    ]
  ],
  "./ko/internal-settings.json": [
    "346477",
    [
      265427
    ]
  ],
  "./nb-x-k12/accessibility_course_statistics.json": [
    "835114",
    [
      929754
    ]
  ],
  "./hi/canvas_file_upload.json": [
    "227174",
    [
      42910
    ]
  ],
  "./fr/course_paces_empty_state.json": [
    "710736",
    [
      499785
    ]
  ],
  "./fr-CA/discussion_posts.json": [
    "234802",
    [
      95199
    ]
  ],
  "./nb-x-k12/peer_reviews_student.json": [
    "890166",
    [
      815150
    ]
  ],
  "./pt/job_stats.json": [
    "505937",
    [
      642803
    ]
  ],
  "./en-AU-x-unimelb/announcements_v2.json": [
    "110663",
    [
      167353
    ]
  ],
  "./th/add_edit_pseudonym.json": [
    "585303",
    [
      684025
    ]
  ],
  "./zh-Hant/notebook_index.json": [
    "658918",
    [
      219538
    ]
  ],
  "./de/todo.json": [
    "935191",
    [
      639282
    ]
  ],
  "./th/MobileGlobalMenu.json": [
    "550495",
    [
      228656
    ]
  ],
  "./sl/IndividualStudentMasteryOutcome.json": [
    "998652",
    [
      778776
    ]
  ],
  "./ar/ldap_cert_upload.json": [
    "736815",
    [
      609193
    ]
  ],
  "./en-GB-x-lbs/moderate_quiz.json": [
    "898503",
    [
      514605
    ]
  ],
  "./fa/user_grades.json": [
    "179115",
    [
      450857
    ]
  ],
  "./th/assignments_peer_reviews_student.json": [
    "741203",
    [
      759501
    ]
  ],
  "./mi/edit_section_end_date.json": [
    "884991",
    [
      164349
    ]
  ],
  "./es-ES/gradebook_default_gradebook_components_content_filters_module_filter.json": [
    "359957",
    [
      137395
    ]
  ],
  "./tr/quiz_log_auditing.json": [
    "55060",
    [
      275960
    ]
  ],
  "./vi/submit_online_url_assignment.json": [
    "990173",
    [
      5883
    ]
  ],
  "./vi/assignments_bulk_edit_use_save_assignment.json": [
    "496887",
    [
      383885
    ]
  ],
  "./is/courses.json": [
    "941128",
    [
      398992
    ]
  ],
  "./ar/react_developer_keys.json": [
    "192716",
    [
      619488
    ]
  ],
  "./fi/user_search_results.json": [
    "560298",
    [
      603770
    ]
  ],
  "./fa/bulk_edit_students_actions.json": [
    "548003",
    [
      177073
    ]
  ],
  "./fr/important_dates.json": [
    "24210",
    [
      49079
    ]
  ],
  "./he/course_paces_app.json": [
    "967401",
    [
      206583
    ]
  ],
  "./hu/SpeedGraderCheckpoints.json": [
    "63048",
    [
      363800
    ]
  ],
  "./sl/a2LatePolicyStatusDisplay.json": [
    "892706",
    [
      860182
    ]
  ],
  "./ko/course_logging_details.json": [
    "141810",
    [
      770298
    ]
  ],
  "./vi/MasteryScale.json": [
    "497236",
    [
      721332
    ]
  ],
  "./zh-Hant/calendar_custom_recurring_event_repeat_picker.json": [
    "174578",
    [
      605262
    ]
  ],
  "./es-ES/custom_emoji_deny_list.json": [
    "48031",
    [
      732309
    ]
  ],
  "./da-x-k12/dashboard_grading_period_select.json": [
    "90381",
    [
      965911
    ]
  ],
  "./pt/assignments_2_student_header_date_title.json": [
    "840685",
    [
      423903
    ]
  ],
  "./en-GB/conferences.json": [
    "873052",
    [
      743925
    ]
  ],
  "./fi/permissions_v2.json": [
    "755708",
    [
      692764
    ]
  ],
  "./ja/empty_course.json": [
    "169470",
    [
      946079
    ]
  ],
  "./hu/calendar_appointment_group_edit.json": [
    "89680",
    [
      999024
    ]
  ],
  "./nb/custom_help_link.json": [
    "836562",
    [
      475862
    ]
  ],
  "./fr-CA/gradingGradeSummary.json": [
    "697206",
    [
      547322
    ]
  ],
  "./ja/blueprint_settingsSyncHistory.json": [
    "441517",
    [
      270852
    ]
  ],
  "./sl/ai_experiences_show.json": [
    "676841",
    [
      502395
    ]
  ],
  "./ar/syllabus_revisions.json": [
    "227225",
    [
      810803
    ]
  ],
  "./ga/assignments_2_login_action_prompt.json": [
    "294797",
    [
      379419
    ]
  ],
  "./hy/epub_exports.json": [
    "278673",
    [
      55527
    ]
  ],
  "./ms/peer_review_student_select.json": [
    "106660",
    [
      405084
    ]
  ],
  "./da-x-k12/roster_publicjs.json": [
    "237129",
    [
      850611
    ]
  ],
  "./th/course_statistics.json": [
    "432163",
    [
      598245
    ]
  ],
  "./fi/peer-review-assignment-widget.json": [
    "571189",
    [
      177139
    ]
  ],
  "./tr/assignment_index_menu.json": [
    "61216",
    [
      866700
    ]
  ],
  "./hi/CommentLibrary.json": [
    "423395",
    [
      933745
    ]
  ],
  "./is/accessibility_checker.json": [
    "230298",
    [
      828074
    ]
  ],
  "./nl/choose_mastery_path.json": [
    "287867",
    [
      942213
    ]
  ],
  "./hu/webcam_modal.json": [
    "510216",
    [
      92600
    ]
  ],
  "./tr/unpublished_changes_button_props.json": [
    "903227",
    [
      677805
    ]
  ],
  "./nl/empty_course.json": [
    "636615",
    [
      393345
    ]
  ],
  "./pt/GroupDetailView.json": [
    "211785",
    [
      305051
    ]
  ],
  "./pt/assignments.never_drop.json": [
    "97052",
    [
      114907
    ]
  ],
  "./en-AU/modelsQuiz.json": [
    "345531",
    [
      563478
    ]
  ],
  "./ht/course_paces_change_tracking.json": [
    "481815",
    [
      299497
    ]
  ],
  "./he/comm_messages.json": [
    "647340",
    [
      843700
    ]
  ],
  "./ga/grade_summaryGroupView.json": [
    "479652",
    [
      652212
    ]
  ],
  "./sl/user_grades.json": [
    "300013",
    [
      831599
    ]
  ],
  "./sv-x-k12/assignments_2_student_content_rubric_self_assessment.json": [
    "544818",
    [
      885682
    ]
  ],
  "./en-CA/OutcomeMoveModal.json": [
    "34132",
    [
      199908
    ]
  ],
  "./sv-x-k12/assignmentsToggleShowByView.json": [
    "786790",
    [
      723582
    ]
  ],
  "./fi/upload_button.json": [
    "84825",
    [
      331551
    ]
  ],
  "./da/copy_course.json": [
    "11878",
    [
      145142
    ]
  ],
  "./nb-x-k12/outcome_management.json": [
    "859930",
    [
      413466
    ]
  ],
  "./da/login.json": [
    "463504",
    [
      457856
    ]
  ],
  "./ru/course_paces_app.json": [
    "275535",
    [
      702821
    ]
  ],
  "./en-GB/quiz_show.json": [
    "560036",
    [
      12229
    ]
  ],
  "./da/ProfileTray.json": [
    "14476",
    [
      535908
    ]
  ],
  "./nn/quiz_statistics.json": [
    "471015",
    [
      823961
    ]
  ],
  "./ca/sharedCurveGradesDialog.json": [
    "129866",
    [
      164994
    ]
  ],
  "./es/sis_import.json": [
    "365009",
    [
      926848
    ]
  ],
  "./hu/new_nav.json": [
    "421861",
    [
      890187
    ]
  ],
  "./he/AccountsTray.json": [
    "112835",
    [
      830713
    ]
  ],
  "./ht/assignments_peer_reviews.json": [
    "748215",
    [
      529249
    ]
  ],
  "./uk/progressbar_view.json": [
    "882070",
    [
      970502
    ]
  ],
  "./es-ES/assignmentsToggleShowByView.json": [
    "440584",
    [
      283536
    ]
  ],
  "./es-ES/unpublished_warning_modal.json": [
    "448061",
    [
      714571
    ]
  ],
  "./da/outcome_management.json": [
    "238325",
    [
      62219
    ]
  ],
  "./nl/ProfileTray.json": [
    "71753",
    [
      194123
    ]
  ],
  "./fr-CA/courses.json": [
    "507665",
    [
      230811
    ]
  ],
  "./uk/assignments_2_media_attempt.json": [
    "484996",
    [
      974188
    ]
  ],
  "./tr/discussion_settings.json": [
    "663596",
    [
      250280
    ]
  ],
  "./zh-Hans/confirmMasteryModal.json": [
    "370027",
    [
      889657
    ]
  ],
  "./ca/entity_search_form.json": [
    "129825",
    [
      319599
    ]
  ],
  "./pl/submit_online_url_assignment.json": [
    "229462",
    [
      104762
    ]
  ],
  "./hy/assignments_2_file_upload.json": [
    "466899",
    [
      163281
    ]
  ],
  "./hu/canvas_file_upload.json": [
    "643658",
    [
      536242
    ]
  ],
  "./ms/nav_tourpoints.json": [
    "3429",
    [
      704107
    ]
  ],
  "./mi/important_dates_empty.json": [
    "484018",
    [
      311882
    ]
  ],
  "./en-GB/roster_section_input.json": [
    "465549",
    [
      453984
    ]
  ],
  "./da/submissions_show_preview.json": [
    "290911",
    [
      391309
    ]
  ],
  "./en-GB/discussion_create.json": [
    "79574",
    [
      53787
    ]
  ],
  "./ar/calendar_custom_recurring_event_repeat_picker.json": [
    "329355",
    [
      881269
    ]
  ],
  "./da-x-k12/quiz_statistics.json": [
    "506414",
    [
      868546
    ]
  ],
  "./ko/important_dates.json": [
    "350932",
    [
      934556
    ]
  ],
  "./nn/assignments.json": [
    "805232",
    [
      941276
    ]
  ],
  "./fr/content_copy_redesign.json": [
    "745713",
    [
      833700
    ]
  ],
  "./id/calendar_appointment_group_edit.json": [
    "38666",
    [
      926334
    ]
  ],
  "./nb-x-k12/authentication_providers.json": [
    "538169",
    [
      208879
    ]
  ],
  "./id/course_search_results.json": [
    "625608",
    [
      217044
    ]
  ],
  "./mi/bounced_emails.json": [
    "772316",
    [
      718564
    ]
  ],
  "./th/course_paces_blackout_dates_modal.json": [
    "223424",
    [
      746348
    ]
  ],
  "./hy/calendar_sidebar.json": [
    "57662",
    [
      856086
    ]
  ],
  "./fr-CA/unpublished_warning_modal.json": [
    "563145",
    [
      187035
    ]
  ],
  "./tr/roster_section_input.json": [
    "541748",
    [
      48024
    ]
  ],
  "./zh-Hans/OutcomeDescriptionModal.json": [
    "60382",
    [
      40998
    ]
  ],
  "./uk/plugins.json": [
    "94430",
    [
      965758
    ]
  ],
  "./nn/progress_pill.json": [
    "388185",
    [
      998579
    ]
  ],
  "./nl/CourseAvailabilityOptions.json": [
    "510744",
    [
      912460
    ]
  ],
  "./ms/peer_reviews_student.json": [
    "151460",
    [
      297372
    ]
  ],
  "./hy/login.json": [
    "758188",
    [
      808748
    ]
  ],
  "./zh-Hant/assignments_2_student_header_date_title.json": [
    "558187",
    [
      270109
    ]
  ],
  "./ar/terms_index.json": [
    "800129",
    [
      688139
    ]
  ],
  "./da-x-k12/assignments_2_url_entry.json": [
    "861941",
    [
      988903
    ]
  ],
  "./en-GB-x-ukhe/react_files.json": [
    "70375",
    [
      494061
    ]
  ],
  "./ht/conversations_2.json": [
    "509667",
    [
      971869
    ]
  ],
  "./ms/section.json": [
    "103353",
    [
      487591
    ]
  ],
  "./nn/internal-settings.json": [
    "755527",
    [
      484505
    ]
  ],
  "./ja/roster_publicjs.json": [
    "822862",
    [
      822240
    ]
  ],
  "./fr-CA/quantitative_data_options.json": [
    "518590",
    [
      968938
    ]
  ],
  "./ru/account_calendar_settings_account_calendar_item.json": [
    "528186",
    [
      456138
    ]
  ],
  "./is/blueprint_course_child.json": [
    "523090",
    [
      789714
    ]
  ],
  "./pl/sharedCurveGradesDialog.json": [
    "914338",
    [
      318
    ]
  ],
  "./it/confirmMasteryModal.json": [
    "631513",
    [
      309691
    ]
  ],
  "./es-ES/content_migrations.json": [
    "643634",
    [
      702946
    ]
  ],
  "./fa/copy_warnings_modal.json": [
    "30354",
    [
      635666
    ]
  ],
  "./pl/blueprint_settingsCoursePicker.json": [
    "821844",
    [
      533488
    ]
  ],
  "./ca/files_v2.json": [
    "249770",
    [
      980386
    ]
  ],
  "./id/assignment_grade_summary.json": [
    "425191",
    [
      387481
    ]
  ],
  "./hu/add_edit_pseudonym.json": [
    "209694",
    [
      57742
    ]
  ],
  "./en-AU-x-unimelb/youtube_migration.json": [
    "205068",
    [
      890408
    ]
  ],
  "./es-ES/blueprint_course_sidebar.json": [
    "972079",
    [
      761093
    ]
  ],
  "./sl/calendar_edit.json": [
    "182934",
    [
      407890
    ]
  ],
  "./cy/permissions_role_tray.json": [
    "842900",
    [
      364172
    ]
  ],
  "./hu/k5_dashboard_card.json": [
    "694963",
    [
      323785
    ]
  ],
  "./en-GB-x-lbs/bulk_edit_students_actions.json": [
    "180414",
    [
      374886
    ]
  ],
  "./pl/account_notification_settings.json": [
    "347899",
    [
      625141
    ]
  ],
  "./pl/editGroup.json": [
    "688861",
    [
      119015
    ]
  ],
  "./uk/internal-settings.json": [
    "377163",
    [
      720513
    ]
  ],
  "./zh-Hans/todo.json": [
    "229239",
    [
      521997
    ]
  ],
  "./pl/entity_search_form.json": [
    "549641",
    [
      788739
    ]
  ],
  "./en-GB-x-lbs/permissions_v2.json": [
    "766441",
    [
      647471
    ]
  ],
  "./zh-Hans/edit_section_view.json": [
    "396897",
    [
      760263
    ]
  ],
  "./ja/youtube_migration.json": [
    "703181",
    [
      920164
    ]
  ],
  "./id/discussion_posts.json": [
    "665049",
    [
      566403
    ]
  ],
  "./pl/account_settings_jsx_bundle.json": [
    "479614",
    [
      625610
    ]
  ],
  "./en-CA/ProfileTray.json": [
    "277515",
    [
      963961
    ]
  ],
  "./fi/assignments_2_student_content_rubric_self_assessment.json": [
    "724916",
    [
      707524
    ]
  ],
  "./fr-CA/assignments_peer_reviews_student.json": [
    "72904",
    [
      225356
    ]
  ],
  "./fr/assignments_2_student_annotation.json": [
    "951083",
    [
      837650
    ]
  ],
  "./he/assignments.json": [
    "805195",
    [
      306961
    ]
  ],
  "./th/assignmentsIndexView.json": [
    "151277",
    [
      906463
    ]
  ],
  "./zh-Hans/a2LatePolicyToolTipContent.json": [
    "352710",
    [
      797710
    ]
  ],
  "./en-GB-x-ukhe/empty_course.json": [
    "274287",
    [
      77349
    ]
  ],
  "./pl/course_paces_errors.json": [
    "844750",
    [
      222994
    ]
  ],
  "./tr/todos_page.json": [
    "590993",
    [
      436163
    ]
  ],
  "./ms/comm_messages.json": [
    "641543",
    [
      133173
    ]
  ],
  "./hu/account_settings.json": [
    "699898",
    [
      314114
    ]
  ],
  "./en/ai_experiences_ai_conversations.json": [
    "641645",
    [
      61031
    ]
  ],
  "./da-x-k12/keyboardShortcutModal.json": [
    "647267",
    [
      404701
    ]
  ],
  "./ga/assignments_2_MoreOptions.json": [
    "665419",
    [
      162393
    ]
  ],
  "./fr/enhanced_individual_gradebook_submit_score.json": [
    "741725",
    [
      312904
    ]
  ],
  "./ga/peer_reviews_student.json": [
    "70464",
    [
      163608
    ]
  ],
  "./ca/user_lists.json": [
    "121099",
    [
      625025
    ]
  ],
  "./ht/entity_search_form.json": [
    "695353",
    [
      937747
    ]
  ],
  "./es-ES/SpeedGraderCheckpoints.json": [
    "219798",
    [
      341870
    ]
  ],
  "./nn/course_statistics.json": [
    "272943",
    [
      721089
    ]
  ],
  "./ru/module_sequence_footer.json": [
    "795155",
    [
      741361
    ]
  ],
  "./sl/lti_registrations.json": [
    "641291",
    [
      698149
    ]
  ],
  "./sl/terms_of_use.json": [
    "654925",
    [
      164814
    ]
  ],
  "./pl/overview_page.json": [
    "90389",
    [
      417943
    ]
  ],
  "./fa/plugins.json": [
    "865523",
    [
      55873
    ]
  ],
  "./en-CA/link_validator.json": [
    "674251",
    [
      298537
    ]
  ],
  "./fi/NewTabIndicator.json": [
    "410685",
    [
      307179
    ]
  ],
  "./fr-CA/password_complexity_configuration.json": [
    "621932",
    [
      177032
    ]
  ],
  "./zh-Hans/collaborations.json": [
    "143477",
    [
      717587
    ]
  ],
  "./en-AU-x-unimelb/assignments_2_student_points_display.json": [
    "462940",
    [
      759104
    ]
  ],
  "./fa/choose_mastery_path.json": [
    "52068",
    [
      48548
    ]
  ],
  "./id/comm_messages.json": [
    "908842",
    [
      466878
    ]
  ],
  "./it/course_paces_footer.json": [
    "988775",
    [
      547401
    ]
  ],
  "./ca/blueprint_settingsCourseFilter.json": [
    "743392",
    [
      267504
    ]
  ],
  "./nn/course_logging_details.json": [
    "121076",
    [
      452936
    ]
  ],
  "./hi/assignments_2_student_header.json": [
    "995946",
    [
      725002
    ]
  ],
  "./ms/modules_page_icon_legend.json": [
    "77215",
    [
      27261
    ]
  ],
  "./sl/remove_pace_warning_modal.json": [
    "134546",
    [
      92670
    ]
  ],
  "./vi/entity_search_form.json": [
    "346730",
    [
      271274
    ]
  ],
  "./ja/internal-settings.json": [
    "424426",
    [
      794899
    ]
  ],
  "./ms/user_search_results.json": [
    "849587",
    [
      175465
    ]
  ],
  "./ms/module_sequence_footer.json": [
    "499604",
    [
      263948
    ]
  ],
  "./ko/assignments_2_student_content_rubric_self_assessment.json": [
    "112001",
    [
      269679
    ]
  ],
  "./sv/external_content_cancel.json": [
    "288567",
    [
      764361
    ]
  ],
  "./ar/quizzes.take_quiz.json": [
    "799195",
    [
      581744
    ]
  ],
  "./ar/outcome_detail.json": [
    "623415",
    [
      622089
    ]
  ],
  "./es-ES/notebook.json": [
    "10392",
    [
      380576
    ]
  ],
  "./is/assignment_grade_summary.json": [
    "924012",
    [
      880316
    ]
  ],
  "./fr-CA/modules_home_page.json": [
    "771026",
    [
      839142
    ]
  ],
  "./ca/course_logging_details.json": [
    "843856",
    [
      7840
    ]
  ],
  "./mi/blueprint_settingsSyncChange.json": [
    "780522",
    [
      750002
    ]
  ],
  "./mi/suppress_notifications.json": [
    "101956",
    [
      720444
    ]
  ],
  "./vi/quizzes_quiz_submission.json": [
    "540387",
    [
      405985
    ]
  ],
  "./en-GB-x-ukhe/change_password.json": [
    "593808",
    [
      742968
    ]
  ],
  "./fi/account_calendars_modal.json": [
    "80818",
    [
      791906
    ]
  ],
  "./sv-x-k12/assignment_index.json": [
    "247149",
    [
      832843
    ]
  ],
  "./nl/assignments_bulk_edit.json": [
    "860256",
    [
      735972
    ]
  ],
  "./pt/license_help.json": [
    "489981",
    [
      512375
    ]
  ],
  "./zh-Hans/account_calendar_settings_utils.json": [
    "69621",
    [
      967683
    ]
  ],
  "./mi/custom_emoji_deny_list.json": [
    "553682",
    [
      777354
    ]
  ],
  "./zh-Hans/question_banks.json": [
    "764491",
    [
      787833
    ]
  ],
  "./sv-x-k12/blueprint_settingsSyncHistory.json": [
    "512491",
    [
      868297
    ]
  ],
  "./ru/notebook_index.json": [
    "571051",
    [
      731625
    ]
  ],
  "./sv/use_switch_experience.json": [
    "657206",
    [
      634802
    ]
  ],
  "./fr/error_form.json": [
    "156243",
    [
      123002
    ]
  ],
  "./el/LearningMasteryGradebook.json": [
    "632690",
    [
      47038
    ]
  ],
  "./nb/user_profile.json": [
    "274635",
    [
      948389
    ]
  ],
  "./ms/grade_change_logging_content.json": [
    "871534",
    [
      593502
    ]
  ],
  "./fa/user_name.json": [
    "704612",
    [
      833876
    ]
  ],
  "./fr-CA/video_conference.json": [
    "970675",
    [
      543493
    ]
  ],
  "./ht/assignments.no_assignments_search.json": [
    "297757",
    [
      113666
    ]
  ],
  "./es-ES/modules_home_page.json": [
    "877358",
    [
      918070
    ]
  ],
  "./da/discussionTopicKeyboradShortcutModal.json": [
    "759708",
    [
      483124
    ]
  ],
  "./ht/quizzes_quiz_submission.json": [
    "101762",
    [
      906774
    ]
  ],
  "./pt/modules_home_page.json": [
    "592515",
    [
      898389
    ]
  ],
  "./ar/appointment_groups.json": [
    "389669",
    [
      554495
    ]
  ],
  "./ht/calendar_appointment_group_edit.json": [
    "915907",
    [
      433549
    ]
  ],
  "./nb-x-k12/calendar_sidebar.json": [
    "510981",
    [
      605987
    ]
  ],
  "./nb-x-k12/roster_section_input.json": [
    "758460",
    [
      767452
    ]
  ],
  "./ar/permissions_v2.json": [
    "797254",
    [
      249138
    ]
  ],
  "./pl/course_color_selector.json": [
    "716281",
    [
      430723
    ]
  ],
  "./pt/wiki_page_index.json": [
    "79203",
    [
      590253
    ]
  ],
  "./tr/ImportConfirmBox.json": [
    "891652",
    [
      573016
    ]
  ],
  "./uk/blueprint_coursesExpandableLockOptions.json": [
    "781131",
    [
      737217
    ]
  ],
  "./en-GB-x-ukhe/react_collaborations.json": [
    "697486",
    [
      730710
    ]
  ],
  "./ga/course_paces_flaggable_number_input.json": [
    "890659",
    [
      148497
    ]
  ],
  "./da-x-k12/eportfolio.json": [
    "4692",
    [
      68216
    ]
  ],
  "./pt/sharedSetDefaultGradeDialog.json": [
    "715793",
    [
      449131
    ]
  ],
  "./id/course_paces_projected_dates.json": [
    "219338",
    [
      795374
    ]
  ],
  "./da/user_lists.json": [
    "100122",
    [
      38450
    ]
  ],
  "./es-ES/discussion_topics_edit.json": [
    "119267",
    [
      975825
    ]
  ],
  "./id/modules_page_icon_legend.json": [
    "608040",
    [
      61556
    ]
  ],
  "./th/auth_logging.json": [
    "293514",
    [
      353094
    ]
  ],
  "./fi/account_course_user_search.json": [
    "547899",
    [
      649513
    ]
  ],
  "./es/gradingGradeSummary.json": [
    "904655",
    [
      938082
    ]
  ],
  "./de/user_search_results.json": [
    "795124",
    [
      513721
    ]
  ],
  "./fr/MobileNavigation.json": [
    "296154",
    [
      606751
    ]
  ],
  "./he/section.json": [
    "490066",
    [
      286858
    ]
  ],
  "./el/user.json": [
    "310402",
    [
      935414
    ]
  ],
  "./hu/react_scheduler.json": [
    "444856",
    [
      43016
    ]
  ],
  "./zh-Hant/calendar_appointment_group_edit.json": [
    "885277",
    [
      371255
    ]
  ],
  "./nl/bounced_emails.json": [
    "194792",
    [
      183732
    ]
  ],
  "./de/blueprint_settingsCoursePickerTable.json": [
    "9855",
    [
      880042
    ]
  ],
  "./sv-x-k12/plugins.json": [
    "320302",
    [
      190695
    ]
  ],
  "./vi/OutcomeDescriptionModal.json": [
    "604808",
    [
      944288
    ]
  ],
  "./pl/new_nav.json": [
    "564530",
    [
      206718
    ]
  ],
  "./ca/user_logins.json": [
    "593280",
    [
      573200
    ]
  ],
  "./pt/courses_show.json": [
    "832048",
    [
      769980
    ]
  ],
  "./el/new_nav.json": [
    "515647",
    [
      143825
    ]
  ],
  "./ja/course_paces_blackout_date_row.json": [
    "19433",
    [
      437416
    ]
  ],
  "./fr-CA/permissions_v2_add_tray.json": [
    "748333",
    [
      502383
    ]
  ],
  "./ko/restore_content_pane.json": [
    "36291",
    [
      997417
    ]
  ],
  "./pt-BR/paginated_list.json": [
    "797877",
    [
      811796
    ]
  ],
  "./cy/modelsQuiz.json": [
    "649737",
    [
      708055
    ]
  ],
  "./es-ES/discussion_posts.json": [
    "154041",
    [
      30799
    ]
  ],
  "./hu/assignments_2_url_entry.json": [
    "99379",
    [
      855593
    ]
  ],
  "./pl/assignments_2_student_header_date_title.json": [
    "893285",
    [
      743495
    ]
  ],
  "./en-CA/calendar_custom_recurring_event_repeat_picker.json": [
    "544012",
    [
      401500
    ]
  ],
  "./hu/webzip_export.json": [
    "42681",
    [
      351175
    ]
  ],
  "./th/horizon_toggle.json": [
    "230058",
    [
      120046
    ]
  ],
  "./en-AU/k5_dashboard.json": [
    "551435",
    [
      439206
    ]
  ],
  "./ga/plugins.json": [
    "510818",
    [
      509010
    ]
  ],
  "./nb-x-k12/blueprint_settingsSyncHistory.json": [
    "602758",
    [
      29710
    ]
  ],
  "./de/user_restore.json": [
    "940257",
    [
      306168
    ]
  ],
  "./is/announcements_on_home_page.json": [
    "280934",
    [
      782526
    ]
  ],
  "./zh-Hant/media_immersive_view.json": [
    "638232",
    [
      756028
    ]
  ],
  "./vi/MobileGlobalMenu.json": [
    "101275",
    [
      994473
    ]
  ],
  "./pt/assignments_2_student_content_rubric_self_assessment.json": [
    "663319",
    [
      450777
    ]
  ],
  "./sv-x-k12/account_calendars_results_area.json": [
    "230869",
    [
      227459
    ]
  ],
  "./ru/grades_empty_page.json": [
    "952503",
    [
      304714
    ]
  ],
  "./es/canvas_file_upload.json": [
    "38971",
    [
      269862
    ]
  ],
  "./ga/peer_review_student_select.json": [
    "726520",
    [
      324736
    ]
  ],
  "./tr/unpublished_changes_tray_contents.json": [
    "426649",
    [
      622291
    ]
  ],
  "./th/ai_experiences_show.json": [
    "455506",
    [
      214310
    ]
  ],
  "./hy/grades_summary.json": [
    "243964",
    [
      478636
    ]
  ],
  "./mi/quiz_log_auditing.json": [
    "212964",
    [
      176188
    ]
  ],
  "./ht/AssignmentGroupListItemView.json": [
    "843644",
    [
      118480
    ]
  ],
  "./hu/rate_limiting_settings.json": [
    "358833",
    [
      540303
    ]
  ],
  "./da/MobileNavigation.json": [
    "42747",
    [
      520401
    ]
  ],
  "./ga/quiz_migration_notifications.json": [
    "54471",
    [
      470349
    ]
  ],
  "./hu/course_navigation_settings.json": [
    "732971",
    [
      65265
    ]
  ],
  "./sl/rate_limiting_settings.json": [
    "580397",
    [
      954487
    ]
  ],
  "./ms/gradebookOutcomeGradebookView.json": [
    "81519",
    [
      376237
    ]
  ],
  "./pl/permissions_role_tray_table_row.json": [
    "182536",
    [
      1268
    ]
  ],
  "./th/assignments.no_assignments_search.json": [
    "612786",
    [
      204938
    ]
  ],
  "./el/course_paces_blackout_dates_table.json": [
    "210336",
    [
      973764
    ]
  ],
  "./he/ai_experiences.json": [
    "219959",
    [
      750405
    ]
  ],
  "./da-x-k12/MobileNavigation.json": [
    "16369",
    [
      990147
    ]
  ],
  "./fr/sharedSetDefaultGradeDialog.json": [
    "236209",
    [
      921420
    ]
  ],
  "./fr/grade_summary.json": [
    "340390",
    [
      599475
    ]
  ],
  "./sv-x-k12/permissions_role_tray.json": [
    "6155",
    [
      674793
    ]
  ],
  "./nb-x-k12/question_banks.json": [
    "80452",
    [
      950164
    ]
  ],
  "./ca/gradebook_uploads.json": [
    "969449",
    [
      595303
    ]
  ],
  "./da-x-k12/youtube_migration.json": [
    "860517",
    [
      720511
    ]
  ],
  "./mi/permissions_v2_add_tray.json": [
    "271202",
    [
      297530
    ]
  ],
  "./sv-x-k12/authentication_providers.json": [
    "490082",
    [
      216338
    ]
  ],
  "./ko/context_prior_users.json": [
    "337907",
    [
      478937
    ]
  ],
  "./hu/assignments_peer_reviews.json": [
    "409634",
    [
      864122
    ]
  ],
  "./mi/ai_experiences_edit.json": [
    "277353",
    [
      380055
    ]
  ],
  "./cy/calculator.json": [
    "302022",
    [
      822054
    ]
  ],
  "./pt-BR/custom_emoji_deny_list.json": [
    "423935",
    [
      371146
    ]
  ],
  "./sv/account_calendar_settings_account_group.json": [
    "471465",
    [
      882427
    ]
  ],
  "./de/NewTabIndicator.json": [
    "292011",
    [
      148798
    ]
  ],
  "./en/roster_section_input.json": [
    "377019",
    [
      458821
    ]
  ],
  "./cy/assignments_peer_reviews.json": [
    "100567",
    [
      526245
    ]
  ],
  "./ga/sharedCurveGradesDialog.json": [
    "286606",
    [
      62662
    ]
  ],
  "./zh-Hans/context_prior_users.json": [
    "225010",
    [
      874066
    ]
  ],
  "./da-x-k12/account_calendar_settings_filter_controls.json": [
    "318263",
    [
      91809
    ]
  ],
  "./nb-x-k12/EditMasteryScaleLink.json": [
    "496545",
    [
      87767
    ]
  ],
  "./ht/collaborations.json": [
    "328620",
    [
      426232
    ]
  ],
  "./uk/restore_content_pane.json": [
    "692373",
    [
      154827
    ]
  ],
  "./ca/filter_calendars_modal.json": [
    "565994",
    [
      34018
    ]
  ],
  "./id/discussion_insights.json": [
    "998703",
    [
      723225
    ]
  ],
  "./ht/context_modules_v2.json": [
    "418820",
    [
      751528
    ]
  ],
  "./es/edit_section_view.json": [
    "11250",
    [
      204171
    ]
  ],
  "./pt/ImportConfirmBox.json": [
    "843434",
    [
      494686
    ]
  ],
  "./pt/conferences_alternatives.json": [
    "256610",
    [
      455966
    ]
  ],
  "./is/assignments.never_drop.json": [
    "124992",
    [
      434947
    ]
  ],
  "./nb-x-k12/filter_calendars_modal.json": [
    "222100",
    [
      976756
    ]
  ],
  "./ko/calendar_custom_recurring_event_repeat_picker.json": [
    "538510",
    [
      181518
    ]
  ],
  "./hu/moderate_quiz.json": [
    "22026",
    [
      43410
    ]
  ],
  "./nb-x-k12/CoursesTray.json": [
    "386350",
    [
      51526
    ]
  ],
  "./nn/custom_emoji_deny_list.json": [
    "671096",
    [
      996884
    ]
  ],
  "./it/quantitative_data_options.json": [
    "7930",
    [
      785078
    ]
  ],
  "./da/outcomes_user_outcome_results.json": [
    "380070",
    [
      421942
    ]
  ],
  "./ja/notebook.json": [
    "201852",
    [
      900793
    ]
  ],
  "./sv/appt_calendar_event_dialog.json": [
    "894985",
    [
      896523
    ]
  ],
  "./hi/discussion_insights.json": [
    "965045",
    [
      768259
    ]
  ],
  "./fr/calendar_appointment_group_edit.json": [
    "506539",
    [
      700298
    ]
  ],
  "./da/folder_tree.json": [
    "653880",
    [
      210904
    ]
  ],
  "./pt-BR/course_navigation_settings.json": [
    "5893",
    [
      472788
    ]
  ],
  "./mi/react_developer_keys.json": [
    "515803",
    [
      2145
    ]
  ],
  "./nn/password_complexity_configuration.json": [
    "338241",
    [
      83627
    ]
  ],
  "./pt-BR/unpublished_changes_tray_contents.json": [
    "676074",
    [
      533099
    ]
  ],
  "./ms/quizzes_openModerateStudentDialog.json": [
    "100620",
    [
      945620
    ]
  ],
  "./ar/question_bank.json": [
    "600078",
    [
      52970
    ]
  ],
  "./ht/assignment_index.json": [
    "832052",
    [
      203480
    ]
  ],
  "./pt/self_enrollment.json": [
    "417197",
    [
      745871
    ]
  ],
  "./ko/blueprint_settingsMigrationSync.json": [
    "906848",
    [
      275472
    ]
  ],
  "./cy/course_search_results.json": [
    "962189",
    [
      288387
    ]
  ],
  "./en-AU-x-unimelb/content_shares.json": [
    "185852",
    [
      956328
    ]
  ],
  "./ga/upload_button.json": [
    "515832",
    [
      845888
    ]
  ],
  "./cy/outcome_alignment_v2.json": [
    "456033",
    [
      142751
    ]
  ],
  "./ms/todo.json": [
    "945742",
    [
      978206
    ]
  ],
  "./pl/section.json": [
    "154369",
    [
      355715
    ]
  ],
  "./el/bulk_edit_students_table.json": [
    "615224",
    [
      261276
    ]
  ],
  "./ko/link_validator.json": [
    "985661",
    [
      873571
    ]
  ],
  "./da/assignments_2_MoreOptions_CanvasFiles.json": [
    "761056",
    [
      794832
    ]
  ],
  "./is/users.json": [
    "477010",
    [
      646066
    ]
  ],
  "./da/dashboard.json": [
    "742305",
    [
      382799
    ]
  ],
  "./mi/course_stats.json": [
    "833885",
    [
      792595
    ]
  ],
  "./nb-x-k12/copy_course.json": [
    "558015",
    [
      555333
    ]
  ],
  "./ru/outcome_management.json": [
    "735015",
    [
      495581
    ]
  ],
  "./sv-x-k12/bulk_edit_students.json": [
    "74833",
    [
      263447
    ]
  ],
  "./da-x-k12/grade_summaryGroupView.json": [
    "114771",
    [
      561941
    ]
  ],
  "./en-GB-x-lbs/rate_limiting_settings.json": [
    "156042",
    [
      652394
    ]
  ],
  "./tr/permissions_role_tray_table_row.json": [
    "148646",
    [
      60722
    ]
  ],
  "./th/notebook_index.json": [
    "974152",
    [
      857636
    ]
  ],
  "./he/AssignmentListItemView.json": [
    "894336",
    [
      293568
    ]
  ],
  "./es/discussion_topics.json": [
    "660547",
    [
      534830
    ]
  ],
  "./es/gradebookOutcomeGradebookView.json": [
    "592615",
    [
      708794
    ]
  ],
  "./vi/grade_details.json": [
    "310045",
    [
      480907
    ]
  ],
  "./ga/speed_grader_helpers.json": [
    "808747",
    [
      671465
    ]
  ],
  "./en-AU/conferences.json": [
    "584931",
    [
      162014
    ]
  ],
  "./zh-Hant/add_edit_pseudonym.json": [
    "342265",
    [
      664299
    ]
  ],
  "./th/canvascareer.json": [
    "353791",
    [
      323824
    ]
  ],
  "./nb/suppress_notifications.json": [
    "419926",
    [
      413922
    ]
  ],
  "./tr/account_calendar_settings_filter_controls.json": [
    "976764",
    [
      753384
    ]
  ],
  "./fi/blueprint_settingsCourseFilter.json": [
    "68903",
    [
      746397
    ]
  ],
  "./zh-Hant/account_calendar_settings_account_tree.json": [
    "206803",
    [
      466789
    ]
  ],
  "./ga/gradebook_uploads.json": [
    "847117",
    [
      867115
    ]
  ],
  "./ga/course_link_validator.json": [
    "662625",
    [
      318247
    ]
  ],
  "./vi/epub_exports.json": [
    "349255",
    [
      253629
    ]
  ],
  "./it/submit_assignment.json": [
    "23851",
    [
      199581
    ]
  ],
  "./ga/account_calendar_settings_account_tree.json": [
    "494633",
    [
      311919
    ]
  ],
  "./fa/course_restore.json": [
    "765989",
    [
      699091
    ]
  ],
  "./fi/overview_page.json": [
    "615924",
    [
      238052
    ]
  ],
  "./ko/roster_section_input.json": [
    "572744",
    [
      141672
    ]
  ],
  "./nb-x-k12/assignment_index_deep_linking_handlers.json": [
    "498830",
    [
      64374
    ]
  ],
  "./nn/blueprint_settingsUnsyncedChanges.json": [
    "375199",
    [
      114753
    ]
  ],
  "./vi/self_enrollment.json": [
    "328944",
    [
      227768
    ]
  ],
  "./th/course_paces_time_selection.json": [
    "576897",
    [
      316243
    ]
  ],
  "./es-ES/media_immersive_view.json": [
    "900877",
    [
      657851
    ]
  ],
  "./nl/dashboard.json": [
    "396332",
    [
      324952
    ]
  ],
  "./ko/blueprint_coursesExpandableLockOptions.json": [
    "326821",
    [
      771387
    ]
  ],
  "./ga/assignments_bulk_edit_use_save_assignment.json": [
    "648350",
    [
      2582
    ]
  ],
  "./hi/course_paces_settings.json": [
    "217543",
    [
      518077
    ]
  ],
  "./id/gradebookOutcomeGradebookView.json": [
    "994134",
    [
      914970
    ]
  ],
  "./fi/content_copy_redesign.json": [
    "444868",
    [
      641460
    ]
  ],
  "./sl/edit_section_start_date.json": [
    "711133",
    [
      435287
    ]
  ],
  "./ru/folder_tree.json": [
    "174246",
    [
      437550
    ]
  ],
  "./en-GB-x-lbs/courses.json": [
    "623798",
    [
      640238
    ]
  ],
  "./ja/quizzes_index.json": [
    "317773",
    [
      653943
    ]
  ],
  "./nl/default_account_quotas.json": [
    "335651",
    [
      1685
    ]
  ],
  "./el/suppress_notifications.json": [
    "28397",
    [
      515311
    ]
  ],
  "./ca/course_paces_blackout_dates_modal.json": [
    "687792",
    [
      968192
    ]
  ],
  "./en-GB-x-ukhe/bulk_edit_students_actions.json": [
    "619574",
    [
      848129
    ]
  ],
  "./is/mutationActivity.json": [
    "566492",
    [
      13676
    ]
  ],
  "./nn/last_attended.json": [
    "285362",
    [
      54518
    ]
  ],
  "./ca/MobileNavigation.json": [
    "619882",
    [
      341474
    ]
  ],
  "./pl/widget_dashboard.json": [
    "333825",
    [
      463619
    ]
  ],
  "./th/quiz_log_auditing.json": [
    "957110",
    [
      866114
    ]
  ],
  "./zh-Hans/canvascareer.json": [
    "627769",
    [
      465119
    ]
  ],
  "./ru/todos_page.json": [
    "673916",
    [
      356892
    ]
  ],
  "./sv-x-k12/jobs.json": [
    "943431",
    [
      765725
    ]
  ],
  "./id/assignments_2_initial_query.json": [
    "668808",
    [
      225268
    ]
  ],
  "./hu/link_validator.json": [
    "321626",
    [
      530498
    ]
  ],
  "./nb/course_pace_date_input.json": [
    "256855",
    [
      847465
    ]
  ],
  "./zh-Hans/SpeedGraderPostGradesMenu.json": [
    "743716",
    [
      368452
    ]
  ],
  "./vi/course_statistics.json": [
    "663190",
    [
      310526
    ]
  ],
  "./en-GB-x-lbs/editGroup.json": [
    "136967",
    [
      738621
    ]
  ],
  "./ca/new_user_tutorial.json": [
    "827801",
    [
      112727
    ]
  ],
  "./en-GB-x-ukhe/bulk_edit_students_table.json": [
    "324421",
    [
      663235
    ]
  ],
  "./nl/courses.json": [
    "955270",
    [
      22650
    ]
  ],
  "./hu/account_notification_settings.json": [
    "216996",
    [
      660700
    ]
  ],
  "./sv/assignments_2_initial_query.json": [
    "898196",
    [
      943680
    ]
  ],
  "./zh-Hant/course_paces_blueprint_lock.json": [
    "459312",
    [
      598676
    ]
  ],
  "./vi/peer_review_allocation_rule_card.json": [
    "948627",
    [
      675425
    ]
  ],
  "./el/course_navigation_settings.json": [
    "992441",
    [
      713507
    ]
  ],
  "./fr/password_complexity_configuration.json": [
    "370493",
    [
      939128
    ]
  ],
  "./hu/course_paces_empty_state.json": [
    "295517",
    [
      914835
    ]
  ],
  "./id/outcome_reporting.json": [
    "507182",
    [
      153274
    ]
  ],
  "./ms/sis_import.json": [
    "27705",
    [
      879943
    ]
  ],
  "./fr-CA/assignments_2_file_upload.json": [
    "156965",
    [
      266447
    ]
  ],
  "./hi/react_scheduler.json": [
    "90084",
    [
      991588
    ]
  ],
  "./mi/quiz_migration_notifications.json": [
    "67529",
    [
      632311
    ]
  ],
  "./ja/reset_pace_warning_modal.json": [
    "865151",
    [
      709698
    ]
  ],
  "./zh-Hant/course_navigation_settings.json": [
    "397024",
    [
      256172
    ]
  ],
  "./zh-Hant/assignments.never_drop.json": [
    "334670",
    [
      369241
    ]
  ],
  "./pl/assignments_peer_reviews_student.json": [
    "400827",
    [
      328053
    ]
  ],
  "./sl/editGroup.json": [
    "304166",
    [
      279538
    ]
  ],
  "./en-AU/course_paces_app.json": [
    "929222",
    [
      426087
    ]
  ],
  "./en-CA/lti_registrations.json": [
    "581008",
    [
      307272
    ]
  ],
  "./ar/outcome_alignment_v2.json": [
    "116364",
    [
      579680
    ]
  ],
  "./ar/roster_section_selector.json": [
    "404684",
    [
      643336
    ]
  ],
  "./fr/notebook_index.json": [
    "480488",
    [
      819833
    ]
  ],
  "./ht/reset_pace_warning_modal.json": [
    "468068",
    [
      745104
    ]
  ],
  "./ja/assignments_2_submission_histories_query.json": [
    "989149",
    [
      877492
    ]
  ],
  "./pt-BR/video_conference.json": [
    "367535",
    [
      742570
    ]
  ],
  "./da-x-k12/calendar_sidebar.json": [
    "865728",
    [
      860124
    ]
  ],
  "./ru/upload_button.json": [
    "202457",
    [
      382991
    ]
  ],
  "./uk/courses_show.json": [
    "453184",
    [
      359568
    ]
  ],
  "./sv-x-k12/GroupDetailView.json": [
    "172854",
    [
      488334
    ]
  ],
  "./da/assignments.never_drop.json": [
    "131461",
    [
      720208
    ]
  ],
  "./th/custom_help_link.json": [
    "222122",
    [
      485198
    ]
  ],
  "./ga/announcements_v2.json": [
    "263683",
    [
      907137
    ]
  ],
  "./ga/discussion_posts.json": [
    "686742",
    [
      599150
    ]
  ],
  "./en-AU-x-unimelb/course_paces_module.json": [
    "745469",
    [
      814479
    ]
  ],
  "./ko/assignments_2_student_points_display.json": [
    "679890",
    [
      432346
    ]
  ],
  "./he/ai_experiences_show.json": [
    "111389",
    [
      426419
    ]
  ],
  "./cy/LearningMasteryGradebook.json": [
    "116313",
    [
      381031
    ]
  ],
  "./ru/ImportConfirmBox.json": [
    "209177",
    [
      891167
    ]
  ],
  "./fr-CA/canvas_file_upload.json": [
    "180892",
    [
      828760
    ]
  ],
  "./sv-x-k12/todo.json": [
    "155343",
    [
      679989
    ]
  ],
  "./id/assignment_index.json": [
    "299963",
    [
      271781
    ]
  ],
  "./tr/ProfileTray.json": [
    "403621",
    [
      886487
    ]
  ],
  "./ar/ai_experiences.json": [
    "528683",
    [
      451021
    ]
  ],
  "./fa/assignments.no_assignments_search.json": [
    "654236",
    [
      833930
    ]
  ],
  "./es/module_student_view_peer_reviews.json": [
    "7745",
    [
      89808
    ]
  ],
  "./cy/quiz_migration_notifications.json": [
    "286795",
    [
      108625
    ]
  ],
  "./ar/outcome_management.json": [
    "603857",
    [
      189939
    ]
  ],
  "./ms/registration.json": [
    "501907",
    [
      210441
    ]
  ],
  "./ru/discussion_row.json": [
    "670834",
    [
      193266
    ]
  ],
  "./hi/EditMasteryScaleLink.json": [
    "193150",
    [
      311542
    ]
  ],
  "./hi/account_calendar_settings.json": [
    "642283",
    [
      876393
    ]
  ],
  "./sv-x-k12/quizzes.take_quiz.json": [
    "461451",
    [
      144732
    ]
  ],
  "./nb-x-k12/assignment_show.json": [
    "617728",
    [
      221057
    ]
  ],
  "./es/grade_summary.json": [
    "785998",
    [
      90431
    ]
  ],
  "./he/bulk_edit_students_actions.json": [
    "70885",
    [
      590731
    ]
  ],
  "./ms/assignment_2_assignment_toggle_details.json": [
    "367398",
    [
      110694
    ]
  ],
  "./fa/available_pronouns_list.json": [
    "245010",
    [
      534850
    ]
  ],
  "./fi/conferences_alternatives.json": [
    "648701",
    [
      899579
    ]
  ],
  "./zh-Hans/AssignmentGroupListItemView.json": [
    "724911",
    [
      313317
    ]
  ],
  "./ar/security_panel.json": [
    "414272",
    [
      89892
    ]
  ],
  "./is/files_v2.json": [
    "552790",
    [
      452414
    ]
  ],
  "./sv-x-k12/editAssignmentGroupWeights.json": [
    "262554",
    [
      686954
    ]
  ],
  "./es-ES/todo.json": [
    "88897",
    [
      583559
    ]
  ],
  "./fr-CA/course_paces_flaggable_number_input.json": [
    "816982",
    [
      267186
    ]
  ],
  "./sv/quizzes_regrade_modal.json": [
    "586903",
    [
      833225
    ]
  ],
  "./th/assignment_show.json": [
    "626341",
    [
      278135
    ]
  ],
  "./en-AU-x-unimelb/blueprint_settingsSyncChange.json": [
    "277300",
    [
      211640
    ]
  ],
  "./en-AU/a2_AccessibleTipContent.json": [
    "385960",
    [
      669677
    ]
  ],
  "./tr/security_panel.json": [
    "790527",
    [
      265601
    ]
  ],
  "./es/course_paces_change_tracking.json": [
    "704775",
    [
      445306
    ]
  ],
  "./fa/react_developer_keys.json": [
    "893074",
    [
      20930
    ]
  ],
  "./uk/unpublished_changes_tray_contents.json": [
    "3135",
    [
      403725
    ]
  ],
  "./is/ImportConfirmBox.json": [
    "900350",
    [
      717398
    ]
  ],
  "./fi/last_attended.json": [
    "502391",
    [
      828125
    ]
  ],
  "./nb-x-k12/todo.json": [
    "984844",
    [
      421004
    ]
  ],
  "./cy/blueprint_settingsSyncHistory.json": [
    "315356",
    [
      505188
    ]
  ],
  "./hi/sidenav.json": [
    "565765",
    [
      502115
    ]
  ],
  "./mi/appt_calendar_event_dialog.json": [
    "594108",
    [
      970436
    ]
  ],
  "./nb-x-k12/account_calendar_settings_footer.json": [
    "639156",
    [
      169236
    ]
  ],
  "./pl/AddGroup.json": [
    "114728",
    [
      403148
    ]
  ],
  "./he/ignite_agent.json": [
    "112571",
    [
      892929
    ]
  ],
  "./sv/course_paces_projected_dates.json": [
    "243686",
    [
      540858
    ]
  ],
  "./nb-x-k12/moderate_quiz.json": [
    "478979",
    [
      84113
    ]
  ],
  "./pt-BR/notebook_index.json": [
    "657275",
    [
      626398
    ]
  ],
  "./da-x-k12/sharedCurveGradesDialog.json": [
    "934627",
    [
      564981
    ]
  ],
  "./ht/CreateEditAssignmentModalAdapter.json": [
    "263415",
    [
      631321
    ]
  ],
  "./es/AssignmentGroupListItemView.json": [
    "422828",
    [
      796377
    ]
  ],
  "./nn/external_content_cancel.json": [
    "509950",
    [
      378986
    ]
  ],
  "./pt-BR/ImportConfirmBox.json": [
    "122217",
    [
      340272
    ]
  ],
  "./zh-Hant/nav_tourpoints.json": [
    "876931",
    [
      520061
    ]
  ],
  "./ca/discovery_page.json": [
    "751526",
    [
      689110
    ]
  ],
  "./fr-CA/grade_summary.json": [
    "875907",
    [
      510037
    ]
  ],
  "./fr/blueprint_settingsCoursePickerTable.json": [
    "475816",
    [
      140497
    ]
  ],
  "./ko/course_navigation_settings.json": [
    "360100",
    [
      797740
    ]
  ],
  "./tr/quizzes_regrade_modal.json": [
    "966816",
    [
      621332
    ]
  ],
  "./ga/reset_pace_warning_modal.json": [
    "240480",
    [
      811688
    ]
  ],
  "./ms/important_dates.json": [
    "401954",
    [
      446106
    ]
  ],
  "./es/quizzes_index.json": [
    "763932",
    [
      661833
    ]
  ],
  "./da/ldap_cert_upload.json": [
    "506459",
    [
      70385
    ]
  ],
  "./id/todo.json": [
    "936225",
    [
      838403
    ]
  ],
  "./ms/assignments_2_MoreOptions_CanvasFiles.json": [
    "52035",
    [
      413593
    ]
  ],
  "./pt-BR/SpeedGraderPostGradesMenu.json": [
    "853970",
    [
      868627
    ]
  ],
  "./hi/course_paces_blackout_dates_table.json": [
    "50702",
    [
      687814
    ]
  ],
  "./nb-x-k12/account_calendar_settings_account_calendar_item.json": [
    "689305",
    [
      444703
    ]
  ],
  "./sv/permission_button.json": [
    "921883",
    [
      116773
    ]
  ],
  "./ca/moderate_quiz.json": [
    "380913",
    [
      391743
    ]
  ],
  "./is/assignments_2_shared_Steps.json": [
    "367447",
    [
      82333
    ]
  ],
  "./en-AU/course_paces_header.json": [
    "398426",
    [
      126883
    ]
  ],
  "./zh-Hans/wiki_page_index.json": [
    "903964",
    [
      310972
    ]
  ],
  "./en-GB-x-ukhe/collaborations.json": [
    "365830",
    [
      292654
    ]
  ],
  "./he/terms_of_service_modal.json": [
    "237956",
    [
      607676
    ]
  ],
  "./fr-CA/jobs_v2.json": [
    "461790",
    [
      129498
    ]
  ],
  "./ms/accessibility_checker.json": [
    "300526",
    [
      479230
    ]
  ],
  "./sv-x-k12/assignments_peer_reviews.json": [
    "747654",
    [
      535870
    ]
  ],
  "./hi/content_migrations.json": [
    "361616",
    [
      50280
    ]
  ],
  "./nb/peer_review_configuration_tray.json": [
    "361531",
    [
      469277
    ]
  ],
  "./id/FindOutcomesModal.json": [
    "96792",
    [
      113564
    ]
  ],
  "./hi/section.json": [
    "45934",
    [
      864774
    ]
  ],
  "./en-GB-x-lbs/course_paces_assignment_row.json": [
    "801033",
    [
      394991
    ]
  ],
  "./nn/bounced_emails.json": [
    "272858",
    [
      361006
    ]
  ],
  "./ru/account_settings_jsx_bundle.json": [
    "216439",
    [
      890797
    ]
  ],
  "./sv-x-k12/youtube_migration.json": [
    "188383",
    [
      611573
    ]
  ],
  "./da-x-k12/calculator_command.json": [
    "366403",
    [
      322357
    ]
  ],
  "./zh-Hans/bulk_edit_students_table.json": [
    "167966",
    [
      836918
    ]
  ],
  "./ca/a2LatePolicyToolTipContent.json": [
    "833983",
    [
      892218
    ]
  ],
  "./hi/content_share_preview_overlay.json": [
    "851992",
    [
      665712
    ]
  ],
  "./fr-CA/assignments_2_url_entry.json": [
    "145261",
    [
      802311
    ]
  ],
  "./zh-Hans/gradingGradeSummary.json": [
    "304292",
    [
      881220
    ]
  ],
  "./sl/course_link_validator.json": [
    "968670",
    [
      702666
    ]
  ],
  "./is/important_dates_empty.json": [
    "721420",
    [
      139484
    ]
  ],
  "./ca/k5_dashboard_card.json": [
    "510064",
    [
      190592
    ]
  ],
  "./hy/calendar_edit.json": [
    "190494",
    [
      56102
    ]
  ],
  "./zh-Hans/assignments_2_MoreOptions.json": [
    "344688",
    [
      279144
    ]
  ],
  "./da/course_paces_blueprint_lock.json": [
    "22417",
    [
      939647
    ]
  ],
  "./th/assignments_2_login_action_prompt.json": [
    "214265",
    [
      801131
    ]
  ],
  "./es-ES/FindOutcomesModal.json": [
    "315640",
    [
      575808
    ]
  ],
  "./cy/collaborations.json": [
    "304460",
    [
      970740
    ]
  ],
  "./id/grade_summaryGroupView.json": [
    "540351",
    [
      74105
    ]
  ],
  "./pt-BR/Navigation.json": [
    "923211",
    [
      853870
    ]
  ],
  "./fa/MobileNavigation.json": [
    "853613",
    [
      388331
    ]
  ],
  "./hi/conferences.json": [
    "986586",
    [
      860746
    ]
  ],
  "./en-AU-x-unimelb/ImportConfirmBox.json": [
    "383578",
    [
      864598
    ]
  ],
  "./ga/progress_pill.json": [
    "285465",
    [
      667199
    ]
  ],
  "./hu/AssignmentGroupListItemView.json": [
    "812131",
    [
      528857
    ]
  ],
  "./da-x-k12/ignite_agent.json": [
    "788585",
    [
      281315
    ]
  ],
  "./da-x-k12/permissions_v2_add_tray.json": [
    "64197",
    [
      821071
    ]
  ],
  "./es-ES/a2LatePolicyToolTipContent.json": [
    "759220",
    [
      517428
    ]
  ],
  "./de/link_validator.json": [
    "896694",
    [
      384015
    ]
  ],
  "./en-GB-x-lbs/file_not_found.json": [
    "760443",
    [
      13081
    ]
  ],
  "./zh-Hant/context_prior_users.json": [
    "842167",
    [
      372953
    ]
  ],
  "./zh-Hant/link_validator.json": [
    "687417",
    [
      688931
    ]
  ],
  "./ja/course_paces_change_tracking.json": [
    "702228",
    [
      162129
    ]
  ],
  "./zh-Hans/account_calendars_modal.json": [
    "947616",
    [
      430024
    ]
  ],
  "./nb/direct_share_course_import_panel.json": [
    "491246",
    [
      566562
    ]
  ],
  "./fi/unpublished_warning_modal.json": [
    "209869",
    [
      799915
    ]
  ],
  "./is/discussionTopicKeyboradShortcutModal.json": [
    "731133",
    [
      716363
    ]
  ],
  "./es-ES/homeroom_page.json": [
    "656153",
    [
      552239
    ]
  ],
  "./nb/quiz_statistics.json": [
    "75715",
    [
      471685
    ]
  ],
  "./ht/modules_page_icon_legend.json": [
    "646087",
    [
      987894
    ]
  ],
  "./id/GroupDetailView.json": [
    "467904",
    [
      84124
    ]
  ],
  "./id/k5_dashboard_card.json": [
    "972145",
    [
      229939
    ]
  ],
  "./ms/password_complexity_configuration.json": [
    "919853",
    [
      973475
    ]
  ],
  "./pl/assignments_2_MoreOptions_CanvasFiles.json": [
    "385531",
    [
      898957
    ]
  ],
  "./nb/quiz_log_auditing.json": [
    "614334",
    [
      763690
    ]
  ],
  "./nb/theme_collection_view.json": [
    "526288",
    [
      110836
    ]
  ],
  "./ca/context_modules_v2.json": [
    "279404",
    [
      949476
    ]
  ],
  "./en-GB-x-ukhe/custom_help_link.json": [
    "213464",
    [
      619776
    ]
  ],
  "./fa/speed_grader_helpers.json": [
    "183600",
    [
      401800
    ]
  ],
  "./zh-Hans/assignmentsIndexView.json": [
    "896347",
    [
      248704
    ]
  ],
  "./fr-CA/content_shares.json": [
    "262091",
    [
      671053
    ]
  ],
  "./mi/users.json": [
    "759516",
    [
      180068
    ]
  ],
  "./fi/terms_of_service_modal.json": [
    "550826",
    [
      13434
    ]
  ],
  "./ca/ai_experiences.json": [
    "912778",
    [
      381634
    ]
  ],
  "./pt-BR/media_immersive_view.json": [
    "96557",
    [
      490540
    ]
  ],
  "./es-ES/course_navigation_settings.json": [
    "807589",
    [
      527059
    ]
  ],
  "./ga/course_paces_app.json": [
    "995044",
    [
      996
    ]
  ],
  "./ru/course_search_results.json": [
    "743224",
    [
      693648
    ]
  ],
  "./fr-CA/course_paces_footer.json": [
    "241339",
    [
      793469
    ]
  ],
  "./ar/grades_summary.json": [
    "942204",
    [
      818344
    ]
  ],
  "./el/ignite_agent.json": [
    "254849",
    [
      786179
    ]
  ],
  "./nn/video_conference.json": [
    "1200",
    [
      851668
    ]
  ],
  "./sl/blueprint_settingsCoursePickerTable.json": [
    "510095",
    [
      854857
    ]
  ],
  "./nb-x-k12/LearningMasteryGradebook.json": [
    "535271",
    [
      997245
    ]
  ],
  "./da-x-k12/discussion_topics.json": [
    "503698",
    [
      350158
    ]
  ],
  "./sv-x-k12/account_calendar_settings_account_group.json": [
    "706935",
    [
      212301
    ]
  ],
  "./ko/file_not_found.json": [
    "461323",
    [
      823969
    ]
  ],
  "./sl/assignments_2_submission_helpers.json": [
    "231581",
    [
      798647
    ]
  ],
  "./is/HelpTray.json": [
    "311125",
    [
      301187
    ]
  ],
  "./pt-BR/peer-review-assignment-widget.json": [
    "967941",
    [
      345940
    ]
  ],
  "./ga/assignments_2_external_tool.json": [
    "340360",
    [
      87728
    ]
  ],
  "./vi/assignments_2_shared_Steps.json": [
    "138976",
    [
      797080
    ]
  ],
  "./ca/peer_review_allocation_rule_card.json": [
    "688436",
    [
      152860
    ]
  ],
  "./en-GB-x-ukhe/quizzes_public.json": [
    "590839",
    [
      882589
    ]
  ],
  "./pt/reset_pace_warning_modal.json": [
    "876748",
    [
      335016
    ]
  ],
  "./ar/peer_review_allocation_rule_card.json": [
    "91157",
    [
      796103
    ]
  ],
  "./ja/suppress_notifications.json": [
    "611549",
    [
      729332
    ]
  ],
  "./ar/custom_help_link.json": [
    "964487",
    [
      49425
    ]
  ],
  "./ar/calendar_edit.json": [
    "571422",
    [
      11410
    ]
  ],
  "./es/context_roster_user_services.json": [
    "866134",
    [
      148903
    ]
  ],
  "./fi/quizzes_public.json": [
    "838494",
    [
      680582
    ]
  ],
  "./he/roster_section_input.json": [
    "996775",
    [
      937653
    ]
  ],
  "./id/user_name.json": [
    "728604",
    [
      566976
    ]
  ],
  "./sl/terms_index.json": [
    "612073",
    [
      366603
    ]
  ],
  "./is/k5_dashboard_card.json": [
    "576836",
    [
      973556
    ]
  ],
  "./th/bulk_edit_students_actions.json": [
    "401644",
    [
      119128
    ]
  ],
  "./da-x-k12/course_paces_errors.json": [
    "525919",
    [
      859481
    ]
  ],
  "./en-GB/account_settings.json": [
    "637928",
    [
      320105
    ]
  ],
  "./en-GB-x-lbs/assignments_2_url_entry.json": [
    "116210",
    [
      64402
    ]
  ],
  "./vi/outcome_management.json": [
    "111095",
    [
      234237
    ]
  ],
  "./da-x-k12/account_calendar_settings_account_calendar_item.json": [
    "828006",
    [
      349290
    ]
  ],
  "./ht/account_course_user_search.json": [
    "228380",
    [
      869320
    ]
  ],
  "./it/files_v2.json": [
    "10317",
    [
      194303
    ]
  ],
  "./nb-x-k12/account_calendar_settings_account_list.json": [
    "790975",
    [
      139605
    ]
  ],
  "./pl/webzip_export.json": [
    "419094",
    [
      254490
    ]
  ],
  "./th/user_restore.json": [
    "801540",
    [
      558784
    ]
  ],
  "./da-x-k12/course_paces_change_tracking.json": [
    "178700",
    [
      24384
    ]
  ],
  "./zh-Hans/blueprint_settingsAssociationsTable.json": [
    "281530",
    [
      866106
    ]
  ],
  "./de/IndividualStudentMasteryOutcome.json": [
    "840844",
    [
      115905
    ]
  ],
  "./ms/quiz_migration_notifications.json": [
    "89971",
    [
      494217
    ]
  ],
  "./sl/gradebookOutcomeGradebookView.json": [
    "476844",
    [
      551352
    ]
  ],
  "./vi/student_annotation_preview.json": [
    "57399",
    [
      452349
    ]
  ],
  "./fr/editAssignmentGroupWeights.json": [
    "336915",
    [
      882970
    ]
  ],
  "./es/course_paces_blackout_dates_table.json": [
    "219549",
    [
      899204
    ]
  ],
  "./ru/user_restore.json": [
    "728535",
    [
      739437
    ]
  ],
  "./sl/course_restore.json": [
    "977839",
    [
      886513
    ]
  ],
  "./fr-CA/edit_section_dates.json": [
    "591479",
    [
      71521
    ]
  ],
  "./tr/ldap_cert_upload.json": [
    "983708",
    [
      657568
    ]
  ],
  "./ar/permissions.json": [
    "376013",
    [
      494823
    ]
  ],
  "./vi/assignments_2_student_annotation.json": [
    "187296",
    [
      890616
    ]
  ],
  "./cy/permissions_v2.json": [
    "973283",
    [
      677945
    ]
  ],
  "./zh-Hans/files_v2.json": [
    "956271",
    [
      764229
    ]
  ],
  "./en-AU-x-unimelb/a2LatePolicyStatusDisplay.json": [
    "145413",
    [
      403287
    ]
  ],
  "./vi.json": [
    "368224",
    [
      285806
    ]
  ],
  "./en-AU-x-unimelb/course_restore.json": [
    "882350",
    [
      918450
    ]
  ],
  "./mi/assignments_peer_reviews_student.json": [
    "751433",
    [
      148887
    ]
  ],
  "./nb/grade_details.json": [
    "448980",
    [
      98368
    ]
  ],
  "./pt-BR/dashboard_grading_period_select.json": [
    "391217",
    [
      866136
    ]
  ],
  "./sl/EditMasteryScaleLink.json": [
    "208118",
    [
      542026
    ]
  ],
  "./da-x-k12/module_student_view_peer_reviews.json": [
    "214314",
    [
      257550
    ]
  ],
  "./ko/CoursesTray.json": [
    "187410",
    [
      975706
    ]
  ],
  "./en-GB/user_date_range_search.json": [
    "837914",
    [
      541279
    ]
  ],
  "./es-ES/calendar_edit.json": [
    "453516",
    [
      254956
    ]
  ],
  "./zh-Hans/plugins.json": [
    "459113",
    [
      844191
    ]
  ],
  "./tr/course_paces_empty_state.json": [
    "864214",
    [
      740714
    ]
  ],
  "./ar/a2LatePolicyToolTipContent.json": [
    "10574",
    [
      386266
    ]
  ],
  "./it/account_settings.json": [
    "683236",
    [
      472304
    ]
  ],
  "./sv-x-k12/Navigation.json": [
    "196269",
    [
      675867
    ]
  ],
  "./ar/canvascareer.json": [
    "804721",
    [
      948795
    ]
  ],
  "./de/content_shares.json": [
    "364789",
    [
      768916
    ]
  ],
  "./es/unpublished_changes_tray_contents.json": [
    "108775",
    [
      68858
    ]
  ],
  "./ca/course_paces_errors.json": [
    "979606",
    [
      681094
    ]
  ],
  "./ko/SpeedGraderCheckpoints.json": [
    "110251",
    [
      28097
    ]
  ],
  "./nb/course_paces_blackout_dates_table.json": [
    "63085",
    [
      880839
    ]
  ],
  "./sv/assignment_grade_summary.json": [
    "70907",
    [
      711501
    ]
  ],
  "./en-GB-x-lbs/SpeedGraderSettingsMenu.json": [
    "493202",
    [
      257394
    ]
  ],
  "./tr/self_enrollment.json": [
    "365955",
    [
      41333
    ]
  ],
  "./en-GB/peer_reviews_student.json": [
    "57259",
    [
      424978
    ]
  ],
  "./ca/empty_modules.json": [
    "292797",
    [
      601411
    ]
  ],
  "./en-CA/calendar_appointment_group_edit.json": [
    "863163",
    [
      169481
    ]
  ],
  "./ru/discussion_posts.json": [
    "772361",
    [
      381471
    ]
  ],
  "./zh-Hant/blueprint_settingsMigrationSync.json": [
    "94428",
    [
      812112
    ]
  ],
  "./pt/user.json": [
    "33017",
    [
      699507
    ]
  ],
  "./sv/peer_review_student_select.json": [
    "618823",
    [
      710457
    ]
  ],
  "./en/LearningMasteryGradebook.json": [
    "181748",
    [
      310440
    ]
  ],
  "./ko/default_account_quotas.json": [
    "667459",
    [
      347561
    ]
  ],
  "./nb/keyboardShortcutModal.json": [
    "982986",
    [
      771726
    ]
  ],
  "./pt/content_migrations.json": [
    "805957",
    [
      639159
    ]
  ],
  "./vi/moderate_quiz.json": [
    "211956",
    [
      181060
    ]
  ],
  "./ht/lti_registration.wizard.json": [
    "911976",
    [
      683827
    ]
  ],
  "./fr-CA/direct_share_course_import_panel.json": [
    "518349",
    [
      219399
    ]
  ],
  "./ga/quiz_show.json": [
    "134281",
    [
      160911
    ]
  ],
  "./is/quizzes_quiz_submission.json": [
    "645646",
    [
      984070
    ]
  ],
  "./ja/calendar.header.json": [
    "122994",
    [
      108443
    ]
  ],
  "./ar/youtube_migration.json": [
    "196111",
    [
      445129
    ]
  ],
  "./en-GB-x-ukhe/MobileNavigation.json": [
    "120408",
    [
      304400
    ]
  ],
  "./mi/grades_summary.json": [
    "733371",
    [
      692545
    ]
  ],
  "./nl/user_grades.json": [
    "657456",
    [
      513084
    ]
  ],
  "./pt-BR/user_name.json": [
    "215516",
    [
      534225
    ]
  ],
  "./sl/unpublished_changes_button_props.json": [
    "649488",
    [
      287732
    ]
  ],
  "./zh-Hant/assignment_index.json": [
    "400846",
    [
      636810
    ]
  ],
  "./fi/assignments.never_drop.json": [
    "570871",
    [
      359006
    ]
  ],
  "./nb/course_paces_pace_picker.json": [
    "997405",
    [
      592231
    ]
  ],
  "./he/canvascareer.json": [
    "695069",
    [
      401875
    ]
  ],
  "./zh-Hans/quiz_statistics.json": [
    "435183",
    [
      882508
    ]
  ],
  "./nl/course_paces_assignment_row.json": [
    "22393",
    [
      935803
    ]
  ],
  "./nb-x-k12/todos_page.json": [
    "916425",
    [
      645983
    ]
  ],
  "./el/NewTabIndicator.json": [
    "578265",
    [
      235419
    ]
  ],
  "./sv-x-k12/course_search_results.json": [
    "481242",
    [
      846730
    ]
  ],
  "./el/gradebook_history.json": [
    "794690",
    [
      877774
    ]
  ],
  "./cy/submissions_show_preview.json": [
    "579362",
    [
      579706
    ]
  ],
  "./he/user_lists.json": [
    "426042",
    [
      302850
    ]
  ],
  "./en-GB-x-ukhe/users.json": [
    "837440",
    [
      629192
    ]
  ],
  "./id/submissions_show_preview.json": [
    "182017",
    [
      913379
    ]
  ],
  "./uk/permissions_v2.json": [
    "404235",
    [
      177537
    ]
  ],
  "./sv-x-k12/ldap_cert_upload.json": [
    "18783",
    [
      974613
    ]
  ],
  "./en-GB-x-ukhe/discussion_settings.json": [
    "860544",
    [
      907192
    ]
  ],
  "./ja/account_settings_jsx_bundle.json": [
    "73195",
    [
      77734
    ]
  ],
  "./nl/assignments_2_student_content_rubric_self_assessment.json": [
    "305249",
    [
      443115
    ]
  ],
  "./ga/mutationActivity.json": [
    "238132",
    [
      99220
    ]
  ],
  "./sl/account_calendars.json": [
    "95790",
    [
      118610
    ]
  ],
  "./pt-BR/blueprint_course_child.json": [
    "621737",
    [
      224208
    ]
  ],
  "./sv/blueprint_settingsAssociationsTable.json": [
    "667284",
    [
      360208
    ]
  ],
  "./ga/k5_dashboard.json": [
    "260305",
    [
      574983
    ]
  ],
  "./pl/account_course_user_search.json": [
    "225356",
    [
      916632
    ]
  ],
  "./ar/submissions_show_preview.json": [
    "49859",
    [
      140437
    ]
  ],
  "./hi/react_developer_keys.json": [
    "534812",
    [
      41324
    ]
  ],
  "./ja/appointment_groups.json": [
    "422195",
    [
      230542
    ]
  ],
  "./ja/assignments_2_media_attempt.json": [
    "408525",
    [
      141284
    ]
  ],
  "./en-AU/link_to_students.json": [
    "588797",
    [
      696500
    ]
  ],
  "./pl/discussion_create.json": [
    "876055",
    [
      588937
    ]
  ],
  "./da-x-k12/peer-review-assignment-widget.json": [
    "101561",
    [
      915267
    ]
  ],
  "./en-AU/horizon_toggle.json": [
    "693892",
    [
      391713
    ]
  ],
  "./ms/account_calendars.json": [
    "969565",
    [
      991667
    ]
  ],
  "./nl/quiz_log_auditing.json": [
    "872936",
    [
      853420
    ]
  ],
  "./ms/youtube_migration.json": [
    "251372",
    [
      997748
    ]
  ],
  "./sv/lti_registration.wizard.json": [
    "431057",
    [
      481020
    ]
  ],
  "./pl/blueprint_settingsMigrationOptions.json": [
    "712073",
    [
      458211
    ]
  ],
  "./ru/modelsQuiz.json": [
    "877306",
    [
      732954
    ]
  ],
  "./da-x-k12/canvas_file_upload.json": [
    "740804",
    [
      768696
    ]
  ],
  "./pt/roster_publicjs.json": [
    "576172",
    [
      748584
    ]
  ],
  "./ar/permissions_role_tray.json": [
    "167227",
    [
      720869
    ]
  ],
  "./fi/GroupDetailView.json": [
    "625136",
    [
      614552
    ]
  ],
  "./ms/assignmentsIndexView.json": [
    "355581",
    [
      666547
    ]
  ],
  "./ms/license_help.json": [
    "948173",
    [
      973059
    ]
  ],
  "./es/blueprint_settingsMigrationOptions.json": [
    "534185",
    [
      923160
    ]
  ],
  "./nl/roster_section_input.json": [
    "531688",
    [
      848172
    ]
  ],
  "./it/react_files.json": [
    "135180",
    [
      937952
    ]
  ],
  "./tr/user_grades.json": [
    "136772",
    [
      517040
    ]
  ],
  "./hy/permissions_v2_add_tray.json": [
    "268939",
    [
      979225
    ]
  ],
  "./it/account_calendars.json": [
    "932248",
    [
      790252
    ]
  ],
  "./nb-x-k12/student_study_drawer.json": [
    "811111",
    [
      672621
    ]
  ],
  "./tr/AddGroup.json": [
    "60122",
    [
      314630
    ]
  ],
  "./nn/account_calendars_modal.json": [
    "309271",
    [
      406689
    ]
  ],
  "./sv/context_prior_users.json": [
    "857067",
    [
      458284
    ]
  ],
  "./fr-CA/course_paces_settings.json": [
    "343793",
    [
      124475
    ]
  ],
  "./he/job_stats.json": [
    "702438",
    [
      441286
    ]
  ],
  "./nl/course_paces_flaggable_number_input.json": [
    "691197",
    [
      645511
    ]
  ],
  "./pt-BR/blueprint_settingsUnsyncedChanges.json": [
    "346310",
    [
      998303
    ]
  ],
  "./ht/react_collaborations.json": [
    "286776",
    [
      261604
    ]
  ],
  "./es/calendar_edit.json": [
    "578793",
    [
      834904
    ]
  ],
  "./nb/IndividualStudentMasteryOutcome.json": [
    "899947",
    [
      879677
    ]
  ],
  "./da/default_account_quotas.json": [
    "604144",
    [
      252768
    ]
  ],
  "./sv/permissions_role_tray.json": [
    "453673",
    [
      120923
    ]
  ],
  "./ja/moderate_quiz.json": [
    "216208",
    [
      796885
    ]
  ],
  "./vi/theme_collection_view.json": [
    "80861",
    [
      339179
    ]
  ],
  "./pt-BR/CoursesTray.json": [
    "92213",
    [
      468820
    ]
  ],
  "./vi/blueprint_coursesExpandableLockOptions.json": [
    "248564",
    [
      404020
    ]
  ],
  "./he/quizzes_openModerateStudentDialog.json": [
    "134571",
    [
      132241
    ]
  ],
  "./ru/discussion_pinned_post.json": [
    "572875",
    [
      690681
    ]
  ],
  "./sv-x-k12/theme_collection_view.json": [
    "453979",
    [
      739817
    ]
  ],
  "./ja/submit_online_url_assignment.json": [
    "974969",
    [
      851640
    ]
  ],
  "./es-ES/user_logins.json": [
    "410721",
    [
      680679
    ]
  ],
  "./pt-BR/assignment_show.json": [
    "788548",
    [
      535673
    ]
  ],
  "./id/assignments_2_student_annotation.json": [
    "440192",
    [
      87956
    ]
  ],
  "./id/AddGroup.json": [
    "895551",
    [
      621577
    ]
  ],
  "./de/external_content_cancel.json": [
    "1",
    [
      69224
    ]
  ],
  "./zh-Hant/SpeedGraderDiscussionsNavigation.json": [
    "770551",
    [
      71441
    ]
  ],
  "./hi/a2LatePolicyToolTipContent.json": [
    "475678",
    [
      849206
    ]
  ],
  "./nb-x-k12/permission_button.json": [
    "281896",
    [
      979296
    ]
  ],
  "./nb/edit_section_start_date.json": [
    "339714",
    [
      97174
    ]
  ],
  "./zh-Hans/bulk_edit_students_actions.json": [
    "709129",
    [
      473951
    ]
  ],
  "./ru/eportfolio.json": [
    "998784",
    [
      828184
    ]
  ],
  "./nn/announcements_on_home_page.json": [
    "314254",
    [
      324706
    ]
  ],
  "./ht/blueprint_settingsUnsyncedChanges.json": [
    "882683",
    [
      305869
    ]
  ],
  "./hi/ai_experiences.json": [
    "996731",
    [
      923865
    ]
  ],
  "./ms/choose_mastery_path.json": [
    "248373",
    [
      794171
    ]
  ],
  "./is/a2_AccessibleTipContent.json": [
    "489990",
    [
      377662
    ]
  ],
  "./ja/CreateEditAssignmentModal.json": [
    "540493",
    [
      561956
    ]
  ],
  "./ko/peer-review-assignment-widget.json": [
    "73694",
    [
      369758
    ]
  ],
  "./ko/course_color_selector.json": [
    "854439",
    [
      842437
    ]
  ],
  "./nb-x-k12/gradebook_default_gradebook_components_content_filters_module_filter.json": [
    "959628",
    [
      87324
    ]
  ],
  "./es/remove_pace_warning_modal.json": [
    "842417",
    [
      968384
    ]
  ],
  "./cy/grade_details.json": [
    "392340",
    [
      843756
    ]
  ],
  "./ga/permissions_role_tray_table_row.json": [
    "118732",
    [
      592892
    ]
  ],
  "./de/quizzes_quiz_submission.json": [
    "947477",
    [
      21300
    ]
  ],
  "./ms/top_navigation_tools.json": [
    "734808",
    [
      902952
    ]
  ],
  "./fi/assignments_2_student_points_display.json": [
    "916187",
    [
      332713
    ]
  ],
  "./es/blueprint_settingsUnsyncedChanges.json": [
    "487147",
    [
      21590
    ]
  ],
  "./fr-CA/moderate_quiz.json": [
    "502944",
    [
      63332
    ]
  ],
  "./hu/permissions.json": [
    "156961",
    [
      918047
    ]
  ],
  "./is/suppress_notifications.json": [
    "758466",
    [
      717010
    ]
  ],
  "./en-GB/registration.json": [
    "863108",
    [
      960349
    ]
  ],
  "./nb/progress_pill.json": [
    "995581",
    [
      18551
    ]
  ],
  "./ru/rootFoldersFinder.json": [
    "748666",
    [
      887930
    ]
  ],
  "./el/outcome_detail.json": [
    "499389",
    [
      565927
    ]
  ],
  "./hy/horizon_toggle.json": [
    "708563",
    [
      124929
    ]
  ],
  "./th/password_complexity_configuration.json": [
    "245277",
    [
      516903
    ]
  ],
  "./da/gradebook_history.json": [
    "618636",
    [
      718180
    ]
  ],
  "./hu/sharedCurveGradesDialog.json": [
    "627717",
    [
      861035
    ]
  ],
  "./fr/media_player_iframe_content.json": [
    "432017",
    [
      530636
    ]
  ],
  "./he/sidenav.json": [
    "829561",
    [
      869319
    ]
  ],
  "./sl/content_migrations.json": [
    "356504",
    [
      33932
    ]
  ],
  "./is/EditMasteryScaleLink.json": [
    "150663",
    [
      159117
    ]
  ],
  "./he/confirmMasteryModal.json": [
    "827519",
    [
      283517
    ]
  ],
  "./fa/youtube_migration.json": [
    "899489",
    [
      712967
    ]
  ],
  "./en-AU/bulk_edit_students.json": [
    "268690",
    [
      286427
    ]
  ],
  "./nb/ignite_agent.json": [
    "648726",
    [
      566938
    ]
  ],
  "./sv/user_grades.json": [
    "170559",
    [
      663265
    ]
  ],
  "./ko/calendar_edit.json": [
    "759719",
    [
      690629
    ]
  ],
  "./en-AU-x-unimelb/modules_home_page.json": [
    "536979",
    [
      473485
    ]
  ],
  "./ar/progress_pill.json": [
    "163390",
    [
      727778
    ]
  ],
  "./it/course_template_details.json": [
    "635590",
    [
      317050
    ]
  ],
  "./nb-x-k12/course_paces_module.json": [
    "299739",
    [
      782185
    ]
  ],
  "./nb-x-k12/student_entries.json": [
    "2328",
    [
      934288
    ]
  ],
  "./es/content_migrations_redesign.json": [
    "47633",
    [
      15616
    ]
  ],
  "./nb/assignments_2_peer_review.json": [
    "641127",
    [
      89585
    ]
  ],
  "./sl/grades_summary.json": [
    "771236",
    [
      422440
    ]
  ],
  "./id/rootFoldersFinder.json": [
    "123626",
    [
      112286
    ]
  ],
  "./hi/media_player_iframe_content.json": [
    "562578",
    [
      449410
    ]
  ],
  "./de/courses_show.json": [
    "540833",
    [
      355096
    ]
  ],
  "./cy/course_paces_pace_picker.json": [
    "245981",
    [
      62547
    ]
  ],
  "./es-ES/link_to_students.json": [
    "186144",
    [
      918792
    ]
  ],
  "./pl/webcam_modal.json": [
    "943585",
    [
      438923
    ]
  ],
  "./hi/calculator_command.json": [
    "506957",
    [
      204043
    ]
  ],
  "./en-GB-x-ukhe/assignment_index_deep_linking_handlers.json": [
    "785794",
    [
      602418
    ]
  ],
  "./ht/unpublished_warning_modal.json": [
    "960512",
    [
      336468
    ]
  ],
  "./nb-x-k12/grade_change_logging_content.json": [
    "715000",
    [
      309504
    ]
  ],
  "./fr-CA/assignments_2_initial_query.json": [
    "415556",
    [
      976240
    ]
  ],
  "./ko/new_user_tutorial.json": [
    "868295",
    [
      584741
    ]
  ],
  "./ga/notebook_index.json": [
    "630580",
    [
      593300
    ]
  ],
  "./ca/assignments.no_assignments_search.json": [
    "762389",
    [
      634086
    ]
  ],
  "./zh-Hans/quizzes_quiz_submission.json": [
    "687605",
    [
      217971
    ]
  ],
  "./ms/link_to_students.json": [
    "250671",
    [
      535501
    ]
  ],
  "./fr-CA/blueprint_settingsCoursePicker.json": [
    "506419",
    [
      51853
    ]
  ],
  "./es/account_calendar_settings.json": [
    "871784",
    [
      109885
    ]
  ],
  "./hy/paginated_list.json": [
    "908179",
    [
      602721
    ]
  ],
  "./pt/bounced_emails.json": [
    "84662",
    [
      734650
    ]
  ],
  "./sl/accessibility_checker.json": [
    "588481",
    [
      627627
    ]
  ],
  "./es/error_form.json": [
    "53931",
    [
      576822
    ]
  ],
  "./de/new_user_tutorial.json": [
    "48050",
    [
      675203
    ]
  ],
  "./mi/EditMasteryScaleLink.json": [
    "727593",
    [
      368151
    ]
  ],
  "./ca/terms_of_use.json": [
    "823871",
    [
      161037
    ]
  ],
  "./tr/assignments_peer_reviews.json": [
    "315089",
    [
      556219
    ]
  ],
  "./id/epub_exports.json": [
    "739751",
    [
      960553
    ]
  ],
  "./vi/rate_limiting_settings.json": [
    "513499",
    [
      175769
    ]
  ],
  "./en-AU/context_modules_v2.json": [
    "441798",
    [
      938663
    ]
  ],
  "./nb/accessibility_course_statistics.json": [
    "285908",
    [
      93080
    ]
  ],
  "./fr/blueprint_course_child.json": [
    "514318",
    [
      362075
    ]
  ],
  "./da-x-k12/course_logging_details.json": [
    "304855",
    [
      314097
    ]
  ],
  "./fa/assignments_2_student_content.json": [
    "580966",
    [
      995262
    ]
  ],
  "./id/ai_experiences_ai_conversations.json": [
    "344963",
    [
      801946
    ]
  ],
  "./es-ES/accessibility_checker.json": [
    "624727",
    [
      603645
    ]
  ],
  "./de/license_help.json": [
    "953104",
    [
      788301
    ]
  ],
  "./cy/paginated_list.json": [
    "231630",
    [
      173854
    ]
  ],
  "./zh-Hans/assignmentsToggleShowByView.json": [
    "788190",
    [
      439494
    ]
  ],
  "./hy/blueprint_course_child.json": [
    "567775",
    [
      466005
    ]
  ],
  "./mi/media_immersive_view.json": [
    "536680",
    [
      44536
    ]
  ],
  "./ga/blueprint_course_child.json": [
    "800458",
    [
      848954
    ]
  ],
  "./nn/discussion_create.json": [
    "239859",
    [
      141845
    ]
  ],
  "./da/assignments.no_assignments_search.json": [
    "722866",
    [
      229359
    ]
  ],
  "./da-x-k12/user.json": [
    "225626",
    [
      223958
    ]
  ],
  "./ru/collaborations.json": [
    "497543",
    [
      816493
    ]
  ],
  "./zh-Hant/edit_section_dates.json": [
    "31198",
    [
      11434
    ]
  ],
  "./it/assignments_2_external_tool.json": [
    "232117",
    [
      431191
    ]
  ],
  "./es/course_paces_settings.json": [
    "610276",
    [
      832017
    ]
  ],
  "./ms/terms_of_service_modal.json": [
    "819117",
    [
      469475
    ]
  ],
  "./fr-CA/users.json": [
    "941951",
    [
      665425
    ]
  ],
  "./ko/account_calendar_settings_account_calendar_item.json": [
    "651637",
    [
      939083
    ]
  ],
  "./pt-BR/conferences_alternatives.json": [
    "992173",
    [
      711084
    ]
  ],
  "./th/SpeedGraderSettingsMenu.json": [
    "929792",
    [
      426652
    ]
  ],
  "./zh-Hant/AssignmentListItemView.json": [
    "535675",
    [
      931213
    ]
  ],
  "./ht/webzip_export.json": [
    "733670",
    [
      816650
    ]
  ],
  "./sv-x-k12/accessibility_scan.json": [
    "492343",
    [
      959709
    ]
  ],
  "./es-ES/files_v2.json": [
    "349373",
    [
      637739
    ]
  ],
  "./fr/HelpTray.json": [
    "19785",
    [
      122156
    ]
  ],
  "./is/copy_warnings_modal.json": [
    "440203",
    [
      928121
    ]
  ],
  "./ar/calendar_sidebar.json": [
    "967934",
    [
      974706
    ]
  ],
  "./fr/calculator.json": [
    "787598",
    [
      550499
    ]
  ],
  "./pl/theme_editor.json": [
    "985441",
    [
      15027
    ]
  ],
  "./ko/media_immersive_view.json": [
    "47476",
    [
      19836
    ]
  ],
  "./hu/assignments_2_student_annotation.json": [
    "270182",
    [
      725830
    ]
  ],
  "./hy/a2_AccessibleTipContent.json": [
    "282209",
    [
      814823
    ]
  ],
  "./sv-x-k12/use_switch_experience.json": [
    "939560",
    [
      15456
    ]
  ],
  "./mi/course_paces_app.json": [
    "308830",
    [
      515150
    ]
  ],
  "./en-GB-x-ukhe/LearningMasteryGradebook.json": [
    "324899",
    [
      586113
    ]
  ],
  "./en-GB-x-ukhe/last_attended.json": [
    "558568",
    [
      886352
    ]
  ],
  "./tr/not_found_page_slide_puzzle.json": [
    "231743",
    [
      25665
    ]
  ],
  "./ca/account_calendar_settings_account_calendar_item_dropdown.json": [
    "932917",
    [
      206571
    ]
  ],
  "./de/submit_online_url_assignment.json": [
    "987043",
    [
      527366
    ]
  ],
  "./pl/progression_module_header.json": [
    "733370",
    [
      825910
    ]
  ],
  "./pt/course_logging_details.json": [
    "349888",
    [
      330548
    ]
  ],
  "./ja/course_paces_blackout_dates_table.json": [
    "253328",
    [
      423765
    ]
  ],
  "./de/sidenav.json": [
    "260157",
    [
      135932
    ]
  ],
  "./en-GB-x-lbs/course_paces_search.json": [
    "57771",
    [
      697401
    ]
  ],
  "./is/blueprint_settingsSyncHistory.json": [
    "321696",
    [
      683720
    ]
  ],
  "./zh-Hans/CommentLibrary.json": [
    "889659",
    [
      306521
    ]
  ],
  "./ht/GroupDetailView.json": [
    "493729",
    [
      223523
    ]
  ],
  "./hy/remove_pace_warning_modal.json": [
    "421290",
    [
      350682
    ]
  ],
  "./pt/course_paces_footer.json": [
    "722970",
    [
      530494
    ]
  ],
  "./tr/top_navigation_tools.json": [
    "641338",
    [
      815694
    ]
  ],
  "./nb/login.json": [
    "284775",
    [
      173145
    ]
  ],
  "./ko/sis_import.json": [
    "633879",
    [
      13877
    ]
  ],
  "./fa/content_migrations.json": [
    "638506",
    [
      464058
    ]
  ],
  "./en-GB-x-lbs/blueprint_settingsAssociationsTable.json": [
    "11419",
    [
      81225
    ]
  ],
  "./is/course_paces_projected_dates.json": [
    "387809",
    [
      929431
    ]
  ],
  "./ar/account_calendar_settings_confirmation_modal.json": [
    "887395",
    [
      553925
    ]
  ],
  "./hi/course_paces_pace_picker.json": [
    "401964",
    [
      230524
    ]
  ],
  "./fa/assignments_2_file_upload.json": [
    "36913",
    [
      829351
    ]
  ],
  "./de/discussion_topics_edit.json": [
    "798621",
    [
      110076
    ]
  ],
  "./zh-Hant/change_password.json": [
    "999220",
    [
      389144
    ]
  ],
  "./ru/unpublished_changes_button_props.json": [
    "301034",
    [
      687066
    ]
  ],
  "./en-GB-x-lbs/content_migrations.json": [
    "851503",
    [
      929525
    ]
  ],
  "./el/unpublished_warning_modal.json": [
    "620553",
    [
      966683
    ]
  ],
  "./hu/k5_course.json": [
    "407009",
    [
      367135
    ]
  ],
  "./sl/quiz_statistics.json": [
    "986924",
    [
      776475
    ]
  ],
  "./sv/link_to_students.json": [
    "326132",
    [
      445000
    ]
  ],
  "./sv/context_modules_v2.json": [
    "829875",
    [
      193013
    ]
  ],
  "./ht/course_restore.json": [
    "249814",
    [
      367330
    ]
  ],
  "./da-x-k12/student_study_drawer.json": [
    "270394",
    [
      974006
    ]
  ],
  "./th/unpublished_warning_modal.json": [
    "624072",
    [
      825276
    ]
  ],
  "./mi/account_calendar_settings_utils.json": [
    "398296",
    [
      124616
    ]
  ],
  "./pt/choose_mastery_path.json": [
    "612293",
    [
      358359
    ]
  ],
  "./ar/edit_section_start_date.json": [
    "577077",
    [
      386903
    ]
  ],
  "./nl/account_calendar_settings_account_calendar_item_dropdown.json": [
    "233371",
    [
      417845
    ]
  ],
  "./ar/CreateEditAssignmentModalAdapter.json": [
    "962326",
    [
      459002
    ]
  ],
  "./de/user_grades.json": [
    "964797",
    [
      879468
    ]
  ],
  "./fi/SpeedGraderPostGradesMenu.json": [
    "443778",
    [
      449362
    ]
  ],
  "./nb-x-k12/OutcomeDescriptionModal.json": [
    "327995",
    [
      425897
    ]
  ],
  "./ja/announcements_on_home_page.json": [
    "875441",
    [
      114928
    ]
  ],
  "./id/account_calendar_settings_filter_controls.json": [
    "389795",
    [
      349781
    ]
  ],
  "./uk/react_developer_keys.json": [
    "454433",
    [
      808303
    ]
  ],
  "./nb-x-k12/account_course_user_search.json": [
    "907274",
    [
      393434
    ]
  ],
  "./fi/theme_collection_view.json": [
    "153069",
    [
      541083
    ]
  ],
  "./th/account_course_user_search.json": [
    "427524",
    [
      186640
    ]
  ],
  "./pl/important_dates.json": [
    "544746",
    [
      478094
    ]
  ],
  "./nb-x-k12/assignments_peer_reviews.json": [
    "909961",
    [
      318687
    ]
  ],
  "./en-CA/assignmentsIndexView.json": [
    "281437",
    [
      974667
    ]
  ],
  "./mi/outcomes_user_outcome_results.json": [
    "613047",
    [
      907653
    ]
  ],
  "./zh-Hant/assignments_2_submission_helpers.json": [
    "604506",
    [
      784622
    ]
  ],
  "./pl/grade_summaryGroupView.json": [
    "804088",
    [
      465148
    ]
  ],
  "./pl/submissions_show_preview.json": [
    "816690",
    [
      525526
    ]
  ],
  "./en/GroupDetailView.json": [
    "610438",
    [
      956770
    ]
  ],
  "./sv/auth_logging.json": [
    "104153",
    [
      686155
    ]
  ],
  "./uk.eager.json": [
    "697715",
    [
      6630
    ]
  ],
  "./de/quiz_statistics.json": [
    "309052",
    [
      335953
    ]
  ],
  "./hi/blueprint_settingsUnsyncedChanges.json": [
    "188000",
    [
      614248
    ]
  ],
  "./da-x-k12/react_collaborations.json": [
    "813631",
    [
      891201
    ]
  ],
  "./da-x-k12/upload_button.json": [
    "813549",
    [
      346479
    ]
  ],
  "./en-AU-x-unimelb/eportfolio.json": [
    "855139",
    [
      842453
    ]
  ],
  "./hy/permission_button.json": [
    "990413",
    [
      38907
    ]
  ],
  "./is/blueprint_settingsMigrationSync.json": [
    "922274",
    [
      64722
    ]
  ],
  "./de/FindOutcomesModal.json": [
    "15038",
    [
      490439
    ]
  ],
  "./id/question_bank.json": [
    "567488",
    [
      844964
    ]
  ],
  "./he/assignments_peer_reviews.json": [
    "839506",
    [
      957610
    ]
  ],
  "./nn/course_paces_flaggable_number_input.json": [
    "241955",
    [
      736509
    ]
  ],
  "./zh-Hant/course_search_results.json": [
    "50887",
    [
      332102
    ]
  ],
  "./sl/registration.json": [
    "148078",
    [
      115970
    ]
  ],
  "./th/peer-review-assignment-widget.json": [
    "707612",
    [
      449976
    ]
  ],
  "./da-x-k12/pairing_code_user_observees.json": [
    "256654",
    [
      269042
    ]
  ],
  "./fr/content_share_preview_overlay.json": [
    "533399",
    [
      393038
    ]
  ],
  "./pt-BR/grades_empty_page.json": [
    "238663",
    [
      997554
    ]
  ],
  "./hu/assignments_2_login_action_prompt.json": [
    "959094",
    [
      163638
    ]
  ],
  "./zh-Hant/appointment_groups.json": [
    "712390",
    [
      224202
    ]
  ],
  "./ht/editAssignmentGroupWeights.json": [
    "705403",
    [
      291853
    ]
  ],
  "./zh-Hans/react_files.json": [
    "852338",
    [
      952242
    ]
  ],
  "./da/SpeedGraderPostGradesMenu.json": [
    "149176",
    [
      467864
    ]
  ],
  "./es/files_v2.json": [
    "937474",
    [
      869467
    ]
  ],
  "./fi/theme_editor.json": [
    "86446",
    [
      227174
    ]
  ],
  "./nl/account_settings_jsx_bundle.json": [
    "23376",
    [
      671108
    ]
  ],
  "./es-ES/react_scheduler.json": [
    "141898",
    [
      842298
    ]
  ],
  "./pl/top_navigation_tools.json": [
    "950000",
    [
      253964
    ]
  ],
  "./da-x-k12/submit_online_url_assignment.json": [
    "11921",
    [
      540603
    ]
  ],
  "./nb/assignments_2_media_attempt.json": [
    "111372",
    [
      597456
    ]
  ],
  "./id/modules_home_page.json": [
    "587278",
    [
      689490
    ]
  ],
  "./fr-CA/conferences_alternatives.json": [
    "262377",
    [
      115851
    ]
  ],
  "./pt/announcements_v2.json": [
    "265527",
    [
      714753
    ]
  ],
  "./da/react_scheduler.json": [
    "9384",
    [
      384712
    ]
  ],
  "./pt/comm_messages.json": [
    "109047",
    [
      639401
    ]
  ],
  "./fi/link_to_students.json": [
    "872464",
    [
      848744
    ]
  ],
  "./vi/homeroom_page.json": [
    "850841",
    [
      246463
    ]
  ],
  "./da-x-k12/blueprint_course_sidebar.json": [
    "61339",
    [
      551989
    ]
  ],
  "./sl/LearningMasteryGradebook.json": [
    "873612",
    [
      571104
    ]
  ],
  "./tr/use_switch_experience.json": [
    "217841",
    [
      671147
    ]
  ],
  "./ms/announcements_v2.json": [
    "786343",
    [
      667189
    ]
  ],
  "./ca/AddGroup.json": [
    "185712",
    [
      6528
    ]
  ],
  "./cy/grade_change_logging_content.json": [
    "849158",
    [
      559558
    ]
  ],
  "./da-x-k12/gradebook_uploads.json": [
    "377416",
    [
      339716
    ]
  ],
  "./da-x-k12/assignments_2_login_action_prompt.json": [
    "845440",
    [
      528268
    ]
  ],
  "./is/context_modules_v2.json": [
    "841024",
    [
      548376
    ]
  ],
  "./sv/discussion_create.json": [
    "299366",
    [
      14490
    ]
  ],
  "./es-ES/gradebook_history.json": [
    "867174",
    [
      946878
    ]
  ],
  "./nl/assignment_index_menu.json": [
    "521364",
    [
      821088
    ]
  ],
  "./cy/account_calendar_settings_account_list.json": [
    "654585",
    [
      508007
    ]
  ],
  "./es-ES/permission_button.json": [
    "657935",
    [
      223525
    ]
  ],
  "./fr/account_calendar_settings_account_list.json": [
    "143569",
    [
      159028
    ]
  ],
  "./ms/GroupDetailView.json": [
    "165145",
    [
      11079
    ]
  ],
  "./ms/blueprint_settingsSyncChange.json": [
    "174292",
    [
      414764
    ]
  ],
  "./fr/copy_warnings_modal.json": [
    "88327",
    [
      398246
    ]
  ],
  "./en-GB-x-ukhe/blueprint_settingsCoursePicker.json": [
    "501842",
    [
      868050
    ]
  ],
  "./nl/self_enrollment.json": [
    "242759",
    [
      898841
    ]
  ],
  "./sl/account_settings_jsx_bundle.json": [
    "286981",
    [
      453119
    ]
  ],
  "./pt-BR/assignments_peer_reviews_student.json": [
    "937148",
    [
      575937
    ]
  ],
  "./nl/wiki_page_index.json": [
    "930777",
    [
      700867
    ]
  ],
  "./fr/blueprint_settingsMigrationOptions.json": [
    "162241",
    [
      734732
    ]
  ],
  "./tr/permissions_v2_add_tray.json": [
    "697682",
    [
      992070
    ]
  ],
  "./ca/content_migrations_redesign.json": [
    "611577",
    [
      436151
    ]
  ],
  "./fi/module_sequence_footer.json": [
    "988115",
    [
      416929
    ]
  ],
  "./sl/NewTabIndicator.json": [
    "789915",
    [
      564381
    ]
  ],
  "./da/not_found_page_slide_puzzle.json": [
    "42462",
    [
      497630
    ]
  ],
  "./nb-x-k12/MasteryScale.json": [
    "882113",
    [
      935463
    ]
  ],
  "./ga/assignments_2_submission_helpers.json": [
    "118120",
    [
      515760
    ]
  ],
  "./mi/gradebook_default_gradebook_components_content_filters_module_filter.json": [
    "30020",
    [
      139868
    ]
  ],
  "./tr/react_collaborations.json": [
    "700978",
    [
      170758
    ]
  ],
  "./uk/AssignmentListItemView.json": [
    "744637",
    [
      375555
    ]
  ],
  "./ht/account_calendar_settings_confirmation_modal.json": [
    "633686",
    [
      836674
    ]
  ],
  "./uk/pairing_code_user_observees.json": [
    "237507",
    [
      686089
    ]
  ],
  "./hu/blueprint_settingsSyncHistory.json": [
    "314991",
    [
      135405
    ]
  ],
  "./en-GB-x-ukhe/SpeedGraderCheckpoints.json": [
    "24899",
    [
      882145
    ]
  ],
  "./ru/calendar_sidebar.json": [
    "905132",
    [
      781564
    ]
  ],
  "./zh-Hans/assignments.no_assignments_search.json": [
    "733094",
    [
      565315
    ]
  ],
  "./hi/roster_section_selector.json": [
    "149884",
    [
      607516
    ]
  ],
  "./cy/calendar_custom_recurring_event_natural_language.json": [
    "671438",
    [
      483934
    ]
  ],
  "./pt-BR/bulk_edit_students_actions.json": [
    "60859",
    [
      306574
    ]
  ],
  "./zh-Hant/gradebook_uploads.json": [
    "366583",
    [
      894377
    ]
  ],
  "./ja/assignments_2_text_entry.json": [
    "177197",
    [
      558276
    ]
  ],
  "./da/upload_button.json": [
    "211955",
    [
      602841
    ]
  ],
  "./nb/empty_modules.json": [
    "547365",
    [
      773999
    ]
  ],
  "./sv-x-k12/canvascareer.json": [
    "251713",
    [
      450807
    ]
  ],
  "./ga/gradebook_default_gradebook_components_content_filters_module_filter.json": [
    "864938",
    [
      554618
    ]
  ],
  "./ja/auth_logging.json": [
    "876249",
    [
      962411
    ]
  ],
  "./nn/user_date_range_search.json": [
    "291213",
    [
      831815
    ]
  ],
  "./el/blueprint_settingsCourseFilter.json": [
    "885147",
    [
      86957
    ]
  ],
  "./hi/calendar_custom_recurring_event_repeat_picker.json": [
    "877787",
    [
      958777
    ]
  ],
  "./es/content_exports.json": [
    "816547",
    [
      356558
    ]
  ],
  "./fa/SpeedGraderSettingsMenu.json": [
    "769233",
    [
      439447
    ]
  ],
  "./hy/accessibility_course_statistics.json": [
    "347035",
    [
      383033
    ]
  ],
  "./he/webcam_modal.json": [
    "641720",
    [
      121576
    ]
  ],
  "./zh-Hans/assignments_2_submission_histories_query.json": [
    "821327",
    [
      227733
    ]
  ],
  "./hy/wiki_page_index.json": [
    "373300",
    [
      160932
    ]
  ],
  "./en-GB/change_password.json": [
    "370855",
    [
      464470
    ]
  ],
  "./pt/student_annotation_preview.json": [
    "882736",
    [
      34532
    ]
  ],
  "./sv/react_collaborations.json": [
    "795543",
    [
      389809
    ]
  ],
  "./vi/content_shares.json": [
    "364375",
    [
      149357
    ]
  ],
  "./fi/important_dates.json": [
    "628227",
    [
      923345
    ]
  ],
  "./he/blueprint_settingsCourseFilter.json": [
    "913633",
    [
      149471
    ]
  ],
  "./th/self_unenrollment_modal.json": [
    "426124",
    [
      283288
    ]
  ],
  "./he/courses_show.json": [
    "306597",
    [
      598763
    ]
  ],
  "./id/blueprint_coursesExpandableLockOptions.json": [
    "782420",
    [
      205312
    ]
  ],
  "./nb-x-k12/assignments_2_file_upload.json": [
    "931522",
    [
      476242
    ]
  ],
  "./pl/assignments_2_file_upload.json": [
    "730960",
    [
      139508
    ]
  ],
  "./de/course_template_details.json": [
    "14212",
    [
      526233
    ]
  ],
  "./fi/course_paces_search.json": [
    "414136",
    [
      413712
    ]
  ],
  "./is/FindOutcomesModal.json": [
    "544713",
    [
      24703
    ]
  ],
  "./ar/todos_page.json": [
    "240598",
    [
      838986
    ]
  ],
  "./en-GB/permissions_v2_add_tray.json": [
    "433453",
    [
      619248
    ]
  ],
  "./fa/react_collaborations.json": [
    "473979",
    [
      3417
    ]
  ],
  "./is/peer_reviews_student.json": [
    "867288",
    [
      824384
    ]
  ],
  "./de/question_banks.json": [
    "415019",
    [
      160798
    ]
  ],
  "./hi/jobs.json": [
    "468775",
    [
      795165
    ]
  ],
  "./fi/calendar_appointment_group_edit.json": [
    "773306",
    [
      124426
    ]
  ],
  "./is/pairing_code_user_observees.json": [
    "228871",
    [
      931613
    ]
  ],
  "./nb-x-k12/add_edit_pseudonym.json": [
    "125361",
    [
      475351
    ]
  ],
  "./pt/course_paces_change_tracking.json": [
    "506655",
    [
      729473
    ]
  ],
  "./nb-x-k12/notebook_index.json": [
    "44958",
    [
      639414
    ]
  ],
  "./hu/terms_of_service_modal.json": [
    "381236",
    [
      332780
    ]
  ],
  "./uk/course_paces_header.json": [
    "895108",
    [
      177836
    ]
  ],
  "./vi/course_logging_details.json": [
    "885171",
    [
      915441
    ]
  ],
  "./tr/blueprint_course_sidebar.json": [
    "227958",
    [
      781570
    ]
  ],
  "./vi/manage_avatars.json": [
    "128275",
    [
      760049
    ]
  ],
  "./de/not_found_page_slide_puzzle.json": [
    "388914",
    [
      976531
    ]
  ],
  "./ca/appt_calendar_event_dialog.json": [
    "734310",
    [
      859030
    ]
  ],
  "./en-CA/discussion_insights.json": [
    "311286",
    [
      45838
    ]
  ],
  "./pl/ldap_cert_upload.json": [
    "588490",
    [
      906318
    ]
  ],
  "./pt/AssignmentGroupListItemView.json": [
    "608644",
    [
      475496
    ]
  ],
  "./pl/grade_summary.json": [
    "273646",
    [
      811450
    ]
  ],
  "./ru/knowledge_check_not_ready.json": [
    "603262",
    [
      588934
    ]
  ],
  "./ht/comm_messages.json": [
    "982655",
    [
      554433
    ]
  ],
  "./pl/account_calendar_settings_account_list.json": [
    "492489",
    [
      384331
    ]
  ],
  "./nb/calendar.header.json": [
    "167535",
    [
      749178
    ]
  ],
  "./pt/calendar_custom_recurring_event_natural_language.json": [
    "811622",
    [
      250306
    ]
  ],
  "./en-AU/gradingPeriodTemplate.json": [
    "640739",
    [
      693150
    ]
  ],
  "./hu/account_calendar_settings_account_calendar_item_dropdown.json": [
    "965556",
    [
      732044
    ]
  ],
  "./nb-x-k12/jobs_v2.json": [
    "525761",
    [
      679735
    ]
  ],
  "./hi/assignments_2_submission_histories_query.json": [
    "856711",
    [
      258077
    ]
  ],
  "./ja/account_calendar_settings_filter_controls.json": [
    "326559",
    [
      271266
    ]
  ],
  "./ja/new_nav.json": [
    "44367",
    [
      587429
    ]
  ],
  "./pl/SpeedGraderCheckpoints.json": [
    "29425",
    [
      362219
    ]
  ],
  "./sl/error_form.json": [
    "874978",
    [
      71470
    ]
  ],
  "./es/CreateEditAssignmentModal.json": [
    "156808",
    [
      906301
    ]
  ],
  "./sv-x-k12/account_calendar_settings_utils.json": [
    "611821",
    [
      854443
    ]
  ],
  "./es/accessibility_scan.json": [
    "730122",
    [
      518691
    ]
  ],
  "./es/course_paces_time_selection.json": [
    "891305",
    [
      130520
    ]
  ],
  "./el/sis_import.json": [
    "723282",
    [
      584758
    ]
  ],
  "./fa/confirmMasteryModal.json": [
    "870513",
    [
      794535
    ]
  ],
  "./nl/permissions_v2_add_tray.json": [
    "606534",
    [
      892714
    ]
  ],
  "./id/student_annotation_preview.json": [
    "406999",
    [
      8881
    ]
  ],
  "./en-GB/account_calendars.json": [
    "646588",
    [
      874229
    ]
  ],
  "./cy/conferences.json": [
    "775265",
    [
      295583
    ]
  ],
  "./th/course_paces_pace_picker.json": [
    "567189",
    [
      309023
    ]
  ],
  "./he/context_prior_users.json": [
    "299822",
    [
      488158
    ]
  ],
  "./nb/plugins.json": [
    "760150",
    [
      223466
    ]
  ],
  "./en-GB-x-lbs/calendar_custom_recurring_event_repeat_picker.json": [
    "277342",
    [
      886486
    ]
  ],
  "./ru/course_paces_assignment_row.json": [
    "26526",
    [
      365494
    ]
  ],
  "./zh-Hans/nav_tourpoints.json": [
    "193160",
    [
      883616
    ]
  ],
  "./en-GB-x-lbs/bulk_edit_students_table.json": [
    "771533",
    [
      10491
    ]
  ],
  "./en-GB/MobileNavigation.json": [
    "247113",
    [
      962628
    ]
  ],
  "./id/account_settings_jsx_bundle.json": [
    "904135",
    [
      646182
    ]
  ],
  "./nn/quiz_log_auditing.json": [
    "155490",
    [
      376334
    ]
  ],
  "./ko/ai_experiences_show.json": [
    "932924",
    [
      529364
    ]
  ],
  "./pl/copy_warnings_modal.json": [
    "685999",
    [
      359321
    ]
  ],
  "./sl/sharedSetDefaultGradeDialog.json": [
    "395482",
    [
      966422
    ]
  ],
  "./pt-BR/user_lists.json": [
    "15244",
    [
      166769
    ]
  ],
  "./da-x-k12/custom_help_link.json": [
    "380137",
    [
      628827
    ]
  ],
  "./ga/ImportConfirmBox.json": [
    "839190",
    [
      484254
    ]
  ],
  "./ga/user_grades.json": [
    "775222",
    [
      697294
    ]
  ],
  "./uk/k5_course.json": [
    "187846",
    [
      118
    ]
  ],
  "./ca/blueprint_settingsCoursePicker.json": [
    "518972",
    [
      168820
    ]
  ],
  "./ht/course_paces_errors.json": [
    "460670",
    [
      380706
    ]
  ],
  "./ja/HelpTray.json": [
    "505598",
    [
      315039
    ]
  ],
  "./ja/plugins.json": [
    "298247",
    [
      542154
    ]
  ],
  "./sv/speed_grader_helpers.json": [
    "880756",
    [
      532224
    ]
  ],
  "./nl/blueprint_settingsSyncChange.json": [
    "820166",
    [
      132610
    ]
  ],
  "./hu/account_calendar_settings_utils.json": [
    "536057",
    [
      441319
    ]
  ],
  "./fr/use_switch_experience.json": [
    "388739",
    [
      804138
    ]
  ],
  "./zh-Hant/confirmMasteryModal.json": [
    "552254",
    [
      244666
    ]
  ],
  "./mi/account_calendars_results_area.json": [
    "204470",
    [
      997814
    ]
  ],
  "./cy/jobs.json": [
    "485870",
    [
      189310
    ]
  ],
  "./de/learning_mastery_gradebook.json": [
    "663774",
    [
      809511
    ]
  ],
  "./es/assignments_2_peer_review.json": [
    "743159",
    [
      112618
    ]
  ],
  "./pt/grades_empty_page.json": [
    "960870",
    [
      546682
    ]
  ],
  "./sv-x-k12/assignments_bulk_edit_use_save_assignment.json": [
    "810613",
    [
      283379
    ]
  ],
  "./sv-x-k12/course_paces_time_selection.json": [
    "578366",
    [
      602502
    ]
  ],
  "./sv/folder_tree.json": [
    "133386",
    [
      657054
    ]
  ],
  "./en/account_calendar_settings_footer.json": [
    "741735",
    [
      994529
    ]
  ],
  "./en/IndividualStudentMasteryOutcome.json": [
    "348404",
    [
      297328
    ]
  ],
  "./fr/dashboard.json": [
    "398670",
    [
      836331
    ]
  ],
  "./fi/course_paces_blackout_dates_table.json": [
    "146340",
    [
      198420
    ]
  ],
  "./ht/account_calendar_settings_footer.json": [
    "578670",
    [
      536610
    ]
  ],
  "./he/course_paces_empty_state.json": [
    "744781",
    [
      417539
    ]
  ],
  "./ja/grades_empty_page.json": [
    "429043",
    [
      800334
    ]
  ],
  "./pt/rate_limiting_settings.json": [
    "642756",
    [
      230312
    ]
  ],
  "./en-GB-x-ukhe/a2LatePolicyStatusDisplay.json": [
    "466211",
    [
      330977
    ]
  ],
  "./nl/sharedCurveGradesDialog.json": [
    "340264",
    [
      115012
    ]
  ],
  "./nn/editAssignmentGroupWeights.json": [
    "163359",
    [
      826433
    ]
  ],
  "./sl/jobs_v2.json": [
    "317136",
    [
      907780
    ]
  ],
  "./fi/course_paces_projected_dates.json": [
    "453370",
    [
      132826
    ]
  ],
  "./it/SpeedGraderPostGradesMenu.json": [
    "891170",
    [
      473470
    ]
  ],
  "./en-GB-x-ukhe/webcam_modal.json": [
    "233839",
    [
      211413
    ]
  ],
  "./id/rubrics-export.json": [
    "735274",
    [
      115166
    ]
  ],
  "./mi/student_annotation_preview.json": [
    "730334",
    [
      646254
    ]
  ],
  "./ga/assignments_peer_reviews.json": [
    "311179",
    [
      843737
    ]
  ],
  "./nb-x-k12/course_link_validator.json": [
    "575595",
    [
      457465
    ]
  ],
  "./nl/enhanced_individual_gradebook_submit_score.json": [
    "868587",
    [
      937741
    ]
  ],
  "./nb/course_template_details.json": [
    "991471",
    [
      435945
    ]
  ],
  "./en-CA/horizon_toggle.json": [
    "375546",
    [
      23594
    ]
  ],
  "./zh-Hans/gradebook_history.json": [
    "106832",
    [
      99656
    ]
  ],
  "./zh-Hant/sections_tooltip.json": [
    "980280",
    [
      160468
    ]
  ],
  "./el/canvas_file_upload.json": [
    "489820",
    [
      675992
    ]
  ],
  "./pt-BR/course_paces_blackout_dates_table.json": [
    "767028",
    [
      133545
    ]
  ],
  "./ga/course_navigation_settings.json": [
    "283762",
    [
      139554
    ]
  ],
  "./sv-x-k12/quiz_statistics.json": [
    "515188",
    [
      533972
    ]
  ],
  "./is/submit_online_url_assignment.json": [
    "674058",
    [
      24410
    ]
  ],
  "./mi/auth_logging.json": [
    "41648",
    [
      610000
    ]
  ],
  "./el/user_profile.json": [
    "939828",
    [
      210752
    ]
  ],
  "./ga/login.json": [
    "696819",
    [
      74961
    ]
  ],
  "./hi/blueprint_settingsMigrationOptions.json": [
    "813004",
    [
      155052
    ]
  ],
  "./hu/self_unenrollment_modal.json": [
    "413247",
    [
      903389
    ]
  ],
  "./vi/discussionTopicKeyboradShortcutModal.json": [
    "619494",
    [
      833886
    ]
  ],
  "./en-GB-x-lbs/lti_registration.wizard.json": [
    "97234",
    [
      763773
    ]
  ],
  "./ga/outcome_management.json": [
    "684948",
    [
      313444
    ]
  ],
  "./ca/user_grades.json": [
    "668706",
    [
      30730
    ]
  ],
  "./ko/course_paces_blackout_date_row.json": [
    "78908",
    [
      636500
    ]
  ],
  "./ja/discussion_pinned_post.json": [
    "598111",
    [
      388578
    ]
  ],
  "./fr/course_paces_pace_picker.json": [
    "59445",
    [
      218528
    ]
  ],
  "./sv-x-k12/course_paces_footer.json": [
    "107929",
    [
      307407
    ]
  ],
  "./fa/user_date_range_search.json": [
    "745022",
    [
      918838
    ]
  ],
  "./sl/courses.show.json": [
    "642246",
    [
      123921
    ]
  ],
  "./sv-x-k12/content_migrations_redesign.json": [
    "356402",
    [
      549474
    ]
  ],
  "./uk/edit_section_dates.json": [
    "504564",
    [
      731548
    ]
  ],
  "./el/assignments.json": [
    "276473",
    [
      582443
    ]
  ],
  "./pt-BR/blueprint_settingsCoursePicker.json": [
    "386711",
    [
      698018
    ]
  ],
  "./ga/folder_tree.json": [
    "40359",
    [
      835821
    ]
  ],
  "./ar/progression_module_header.json": [
    "388841",
    [
      716987
    ]
  ],
  "./pl/AlignmentSummary.json": [
    "139813",
    [
      408167
    ]
  ],
  "./tr/a2_AccessibleTipContent.json": [
    "815360",
    [
      648092
    ]
  ],
  "./pl/dashboard_grades_page.json": [
    "344527",
    [
      305153
    ]
  ],
  "./th/course_restore.json": [
    "886750",
    [
      460202
    ]
  ],
  "./hu/outcome_detail.json": [
    "627643",
    [
      647393
    ]
  ],
  "./nb/SpeedGraderDiscussionsNavigation.json": [
    "44201",
    [
      628275
    ]
  ],
  "./da-x-k12.eager.json": [
    "602098",
    [
      22385
    ]
  ],
  "./id/course_paces_no_results.json": [
    "125774",
    [
      940386
    ]
  ],
  "./sv/authentication_providers.json": [
    "449664",
    [
      320292
    ]
  ],
  "./ja/student_study_drawer.json": [
    "785714",
    [
      605723
    ]
  ],
  "./de/student_entries.json": [
    "824445",
    [
      455548
    ]
  ],
  "./ja/module_student_view_peer_reviews.json": [
    "222018",
    [
      757803
    ]
  ],
  "./en-GB-x-lbs/discussionTopicKeyboradShortcutModal.json": [
    "697023",
    [
      678453
    ]
  ],
  "./mi/peer_review_configuration_tray.json": [
    "743657",
    [
      579607
    ]
  ],
  "./nb/homeroom_page.json": [
    "579700",
    [
      974808
    ]
  ],
  "./es-ES/calculator.json": [
    "723302",
    [
      110687
    ]
  ],
  "./en-GB/SpeedGraderPostGradesMenu.json": [
    "284822",
    [
      132771
    ]
  ],
  "./fi/syllabus_revisions.json": [
    "398683",
    [
      829177
    ]
  ],
  "./it/paginated_list.json": [
    "633925",
    [
      310639
    ]
  ],
  "./da-x-k12/assignments_bulk_edit_use_save_assignment.json": [
    "215243",
    [
      627277
    ]
  ],
  "./fr-CA/security_panel.json": [
    "587322",
    [
      71334
    ]
  ],
  "./fa/assignment_grade_summary.json": [
    "76863",
    [
      582181
    ]
  ],
  "./ht/gradingGradeSummary.json": [
    "158143",
    [
      894993
    ]
  ],
  "./ht/quizzes_regrade_modal.json": [
    "901042",
    [
      599534
    ]
  ],
  "./ms/user_name.json": [
    "53097",
    [
      294807
    ]
  ],
  "./sv-x-k12/calendar_custom_recurring_event_natural_language.json": [
    "852163",
    [
      357025
    ]
  ],
  "./is/assignments_bulk_edit.json": [
    "32118",
    [
      51758
    ]
  ],
  "./id/sections_tooltip.json": [
    "686273",
    [
      724307
    ]
  ],
  "./fi/ProfileTray.json": [
    "970334",
    [
      970486
    ]
  ],
  "./ja/course_navigation_settings.json": [
    "30889",
    [
      650088
    ]
  ],
  "./ht/Navigation.json": [
    "39080",
    [
      362148
    ]
  ],
  "./ht/user_grades.json": [
    "86010",
    [
      251078
    ]
  ],
  "./is/filter_calendars_modal.json": [
    "118862",
    [
      982918
    ]
  ],
  "./fr-CA/context_prior_users.json": [
    "474408",
    [
      744124
    ]
  ],
  "./nb-x-k12/job_stats.json": [
    "436763",
    [
      993561
    ]
  ],
  "./tr/EditMasteryScaleLink.json": [
    "664153",
    [
      560707
    ]
  ],
  "./ca/content_exports.json": [
    "220587",
    [
      213601
    ]
  ],
  "./pt-BR/permissions_role_tray_table_row.json": [
    "812733",
    [
      144604
    ]
  ],
  "./en-AU/sharedSetDefaultGradeDialog.json": [
    "292891",
    [
      847734
    ]
  ],
  "./sv/gradingGradeSummary.json": [
    "83750",
    [
      262442
    ]
  ],
  "./nb-x-k12/user_date_range_search.json": [
    "75675",
    [
      722473
    ]
  ],
  "./fr-CA/content_exports.json": [
    "428162",
    [
      670974
    ]
  ],
  "./hu/assignment_show.json": [
    "779022",
    [
      817406
    ]
  ],
  "./id/assignmentsIndexView.json": [
    "314358",
    [
      837642
    ]
  ],
  "./th/calendar_sidebar.json": [
    "81291",
    [
      208197
    ]
  ],
  "./ar/user_profile.json": [
    "271326",
    [
      963170
    ]
  ],
  "./en-AU/discussion_topics.json": [
    "822813",
    [
      25620
    ]
  ],
  "./pt-BR/files_v2.json": [
    "600157",
    [
      801532
    ]
  ],
  "./ru/course_color_selector.json": [
    "577468",
    [
      290076
    ]
  ],
  "./sv-x-k12/course_restore.json": [
    "314663",
    [
      309069
    ]
  ],
  "./de/peer-review-assignment-widget.json": [
    "135059",
    [
      766246
    ]
  ],
  "./ms/ai_experiences_ai_conversations.json": [
    "177022",
    [
      504718
    ]
  ],
  "./en-AU-x-unimelb/account_settings.json": [
    "929691",
    [
      501077
    ]
  ],
  "./de/dashboard.json": [
    "939709",
    [
      354076
    ]
  ],
  "./hi/SpeedGraderDiscussionsNavigation.json": [
    "539988",
    [
      450116
    ]
  ],
  "./ms/a2LatePolicyStatusDisplay.json": [
    "580773",
    [
      845195
    ]
  ],
  "./el/grade_details.json": [
    "112297",
    [
      510059
    ]
  ],
  "./nl/course_statistics.json": [
    "129293",
    [
      120503
    ]
  ],
  "./vi/bounced_emails.json": [
    "615809",
    [
      100631
    ]
  ],
  "./en-AU/lti_registration.wizard.json": [
    "258750",
    [
      822143
    ]
  ],
  "./pt/DueDateOverrideView.json": [
    "515809",
    [
      687187
    ]
  ],
  "./es/manage_avatars.json": [
    "691680",
    [
      664885
    ]
  ],
  "./pt/webcam_modal.json": [
    "34937",
    [
      888979
    ]
  ],
  "./en-AU-x-unimelb/course_template_details.json": [
    "719991",
    [
      173849
    ]
  ],
  "./it/outcome_reporting.json": [
    "575966",
    [
      824106
    ]
  ],
  "./nl/progressbar_view.json": [
    "566804",
    [
      717208
    ]
  ],
  "./ja/accessibility_scan.json": [
    "55465",
    [
      466408
    ]
  ],
  "./pl/video_conference.json": [
    "40988",
    [
      844144
    ]
  ],
  "./zh-Hant/webzip_export.json": [
    "257544",
    [
      92044
    ]
  ],
  "./fr-CA/course_restore.json": [
    "660721",
    [
      164555
    ]
  ],
  "./hi/choose_mastery_path.json": [
    "899062",
    [
      770254
    ]
  ],
  "./da-x-k12/media_immersive_view.json": [
    "142961",
    [
      713259
    ]
  ],
  "./ru/progressbar_view.json": [
    "990421",
    [
      497395
    ]
  ],
  "./en-GB-x-lbs/assignments_2_student_content.json": [
    "334977",
    [
      637911
    ]
  ],
  "./ja/ldap_cert_upload.json": [
    "541513",
    [
      590024
    ]
  ],
  "./ar/modelsQuiz.json": [
    "71276",
    [
      861536
    ]
  ],
  "./th/gradebook_history.json": [
    "156103",
    [
      427193
    ]
  ],
  "./el/lti_registrations.json": [
    "157941",
    [
      805540
    ]
  ],
  "./fr-CA/comm_messages.json": [
    "753702",
    [
      122826
    ]
  ],
  "./fi/lti_registrations.json": [
    "300081",
    [
      627143
    ]
  ],
  "./nl/internal-settings.json": [
    "999821",
    [
      334183
    ]
  ],
  "./ru/peer_reviews_student.json": [
    "261879",
    [
      519949
    ]
  ],
  "./es/filter_calendars_modal.json": [
    "92226",
    [
      611867
    ]
  ],
  "./ja/discussion_row.json": [
    "985342",
    [
      489311
    ]
  ],
  "./ht/account_calendars_modal.json": [
    "815035",
    [
      841333
    ]
  ],
  "./tr/quizzes.take_quiz.json": [
    "390562",
    [
      68951
    ]
  ],
  "./es-ES/calendar_sidebar.json": [
    "907580",
    [
      273996
    ]
  ],
  "./ru/user_search_results.json": [
    "980778",
    [
      426538
    ]
  ],
  "./fa/custom_emoji_deny_list.json": [
    "975831",
    [
      729549
    ]
  ],
  "./da-x-k12/dashboard.json": [
    "563119",
    [
      834801
    ]
  ],
  "./ca/confirmMasteryModal.json": [
    "706308",
    [
      50924
    ]
  ],
  "./pt/speed_grader_helpers.json": [
    "683159",
    [
      7913
    ]
  ],
  "./hi/student_study_drawer.json": [
    "301972",
    [
      251220
    ]
  ],
  "./fi/file_not_found.json": [
    "502366",
    [
      924326
    ]
  ],
  "./ar/registration.json": [
    "162054",
    [
      354114
    ]
  ],
  "./es-ES/gradingPeriodTemplate.json": [
    "897024",
    [
      335544
    ]
  ],
  "./it/user.json": [
    "561886",
    [
      919682
    ]
  ],
  "./mi/available_pronouns_list.json": [
    "654933",
    [
      35707
    ]
  ],
  "./en/moderate_quiz.json": [
    "551830",
    [
      92018
    ]
  ],
  "./pt/webzip_export.json": [
    "319358",
    [
      896978
    ]
  ],
  "./el/user_grades.json": [
    "568527",
    [
      605937
    ]
  ],
  "./de/GroupDetailView.json": [
    "654990",
    [
      695511
    ]
  ],
  "./ht.json": [
    "546173",
    [
      340893
    ]
  ],
  "./id/assignment_2_assignment_toggle_details.json": [
    "270001",
    [
      898067
    ]
  ],
  "./ms/quizzes_index.json": [
    "578164",
    [
      852012
    ]
  ],
  "./ga/user_logins.json": [
    "968492",
    [
      632748
    ]
  ],
  "./ru/assignments_bulk_edit.json": [
    "510023",
    [
      994397
    ]
  ],
  "./nb-x-k12/internal-settings.json": [
    "160513",
    [
      407383
    ]
  ],
  "./en-GB-x-lbs/wiki_page_index.json": [
    "396201",
    [
      845503
    ]
  ],
  "./mi/discovery_page.json": [
    "925040",
    [
      600752
    ]
  ],
  "./uk/lti_registration.wizard.json": [
    "687424",
    [
      306151
    ]
  ],
  "./ar/collaborations.json": [
    "27309",
    [
      140887
    ]
  ],
  "./da-x-k12/submissions_show_preview.json": [
    "687485",
    [
      563479
    ]
  ],
  "./fi/authentication_providers.json": [
    "843460",
    [
      715396
    ]
  ],
  "./pl/license_help.json": [
    "469301",
    [
      922239
    ]
  ],
  "./en-GB-x-lbs/assignments.json": [
    "48002",
    [
      191906
    ]
  ],
  "./ru/CourseAvailabilityOptions.json": [
    "246207",
    [
      480805
    ]
  ],
  "./sl/blueprint_settingsMigrationSync.json": [
    "715053",
    [
      654935
    ]
  ],
  "./sv-x-k12/terms_of_service_modal.json": [
    "721952",
    [
      582520
    ]
  ],
  "./sv/assignments_2_text_entry.json": [
    "874093",
    [
      88327
    ]
  ],
  "./zh-Hant/assignments_2_student_content.json": [
    "451965",
    [
      704415
    ]
  ],
  "./he/syllabus_revisions.json": [
    "636469",
    [
      198267
    ]
  ],
  "./is/account_calendar_settings_filter_controls.json": [
    "711130",
    [
      329642
    ]
  ],
  "./vi/discussion_pinned_post.json": [
    "989915",
    [
      835993
    ]
  ],
  "./ko/LogoutButton.json": [
    "353082",
    [
      818514
    ]
  ],
  "./ar/SpeedGraderDiscussionsNavigation.json": [
    "957316",
    [
      254024
    ]
  ],
  "./es-ES/assignments_2_file_upload.json": [
    "799753",
    [
      641855
    ]
  ],
  "./da/student_study_drawer.json": [
    "679664",
    [
      35808
    ]
  ],
  "./hi/k5_course.json": [
    "458549",
    [
      604867
    ]
  ],
  "./ja/dashboard_grades_page.json": [
    "251622",
    [
      758439
    ]
  ],
  "./fr-CA/media_player_iframe_content.json": [
    "154364",
    [
      550384
    ]
  ],
  "./hu/assignment_grade_summary.json": [
    "376645",
    [
      119851
    ]
  ],
  "./ca/assignments_2_attempt_tab.json": [
    "834879",
    [
      685325
    ]
  ],
  "./ca/permissions_v2.json": [
    "800715",
    [
      573441
    ]
  ],
  "./sv/assignments_2_submission_histories_query.json": [
    "624925",
    [
      382327
    ]
  ],
  "./zh-Hans/course_paces_module.json": [
    "730802",
    [
      590594
    ]
  ],
  "./en-AU/assignment_grade_summary.json": [
    "865922",
    [
      762443
    ]
  ],
  "./nb-x-k12/assignmentsToggleShowByView.json": [
    "975075",
    [
      647809
    ]
  ],
  "./pt-BR/permission_button.json": [
    "315311",
    [
      674522
    ]
  ],
  "./en-GB-x-ukhe/choose_mastery_path.json": [
    "322963",
    [
      482065
    ]
  ],
  "./sv/content_shares.json": [
    "6875",
    [
      969885
    ]
  ],
  "./mi/ProfileTray.json": [
    "858850",
    [
      694107
    ]
  ],
  "./sv-x-k12/knowledge_check_not_ready.json": [
    "610728",
    [
      734256
    ]
  ],
  "./ja/editAssignmentGroupWeights.json": [
    "282116",
    [
      368577
    ]
  ],
  "./es/assignments_2_attempt_tab.json": [
    "586007",
    [
      924234
    ]
  ],
  "./nb/confirmMasteryModal.json": [
    "686396",
    [
      498608
    ]
  ],
  "./ht/assignments_2_student_annotation.json": [
    "889971",
    [
      834421
    ]
  ],
  "./ms/mutationActivity.json": [
    "625680",
    [
      491728
    ]
  ],
  "./nn/AccountsTray.json": [
    "305158",
    [
      765442
    ]
  ],
  "./nn/grade_details.json": [
    "557200",
    [
      121036
    ]
  ],
  "./fi/a2_AccessibleTipContent.json": [
    "302795",
    [
      49993
    ]
  ],
  "./uk/calendar_edit.json": [
    "619633",
    [
      946815
    ]
  ],
  "./fa/lti_registration.wizard.json": [
    "784301",
    [
      922772
    ]
  ],
  "./ar/gradinggradingPeriodCollection.json": [
    "170522",
    [
      688686
    ]
  ],
  "./cy/SpeedGraderCheckpoints.json": [
    "162657",
    [
      53663
    ]
  ],
  "./ru/entity_search_form.json": [
    "982810",
    [
      574218
    ]
  ],
  "./fr/permissions.json": [
    "939974",
    [
      73963
    ]
  ],
  "./id/blueprint_settingsCoursePickerTable.json": [
    "240757",
    [
      173879
    ]
  ],
  "./da/terms_of_service_modal.json": [
    "479012",
    [
      655340
    ]
  ],
  "./nn/overview_page.json": [
    "275478",
    [
      18891
    ]
  ],
  "./sv/permissions_v2.json": [
    "657488",
    [
      338428
    ]
  ],
  "./uk/reset_pace_warning_modal.json": [
    "401052",
    [
      526740
    ]
  ],
  "./en-AU/SpeedGraderCheckpoints.json": [
    "189231",
    [
      237650
    ]
  ],
  "./cy/assignments_2_student_annotation.json": [
    "224915",
    [
      328489
    ]
  ],
  "./en-GB-x-lbs/self_unenrollment_modal.json": [
    "360650",
    [
      563562
    ]
  ],
  "./it/assignments_bulk_edit_use_save_assignment.json": [
    "225511",
    [
      58993
    ]
  ],
  "./zh-Hant/modules_page_icon_legend.json": [
    "200345",
    [
      550795
    ]
  ],
  "./ga/media_immersive_view.json": [
    "346",
    [
      889194
    ]
  ],
  "./ca/todos_page.json": [
    "128919",
    [
      640085
    ]
  ],
  "./pl/account_calendar_settings_account_calendar_item.json": [
    "651371",
    [
      688365
    ]
  ],
  "./en-AU/CreateEditAssignmentModal.json": [
    "397122",
    [
      169931
    ]
  ],
  "./tr/content_exports.json": [
    "446749",
    [
      227287
    ]
  ],
  "./ga/assignment_index_menu.json": [
    "527070",
    [
      436358
    ]
  ],
  "./nb/grade_summary.json": [
    "593822",
    [
      775210
    ]
  ],
  "./pl/permissions.json": [
    "325886",
    [
      361810
    ]
  ],
  "./da-x-k12.json": [
    "648876",
    [
      841582
    ]
  ],
  "./el/theme_collection_view.json": [
    "886169",
    [
      410635
    ]
  ],
  "./en-GB-x-lbs/dashboard.json": [
    "644444",
    [
      543916
    ]
  ],
  "./nb/important_dates.json": [
    "185402",
    [
      915550
    ]
  ],
  "./zh-Hans/blueprint_course_child.json": [
    "180775",
    [
      218445
    ]
  ],
  "./ms/assignment_index_menu.json": [
    "857781",
    [
      423258
    ]
  ],
  "./hu/course_paces_assignment_row.json": [
    "721504",
    [
      329376
    ]
  ],
  "./en-GB-x-lbs/assignments_2_student_header_date_title.json": [
    "657535",
    [
      323669
    ]
  ],
  "./it/MasteryScale.json": [
    "361732",
    [
      144472
    ]
  ],
  "./th/gradebookOutcomeGradebookView.json": [
    "506399",
    [
      982457
    ]
  ],
  "./ms/CreateEditAssignmentModal.json": [
    "947120",
    [
      892656
    ]
  ],
  "./el/context_prior_users.json": [
    "782312",
    [
      834940
    ]
  ],
  "./ko/discussion_row.json": [
    "139259",
    [
      206737
    ]
  ],
  "./cy/add_edit_pseudonym.json": [
    "596431",
    [
      708109
    ]
  ],
  "./nl/FindOutcomesModal.json": [
    "635767",
    [
      436537
    ]
  ],
  "./th/outcome_alignment_v2.json": [
    "934169",
    [
      591491
    ]
  ],
  "./mi/todo.json": [
    "219220",
    [
      598860
    ]
  ],
  "./zh-Hant/calculator_command.json": [
    "639306",
    [
      315206
    ]
  ],
  "./mi/course_logging_details.json": [
    "704614",
    [
      637414
    ]
  ],
  "./da-x-k12/media_player_iframe_content.json": [
    "314564",
    [
      954384
    ]
  ],
  "./en-AU-x-unimelb/calendar_sidebar.json": [
    "235803",
    [
      756221
    ]
  ],
  "./ht/EditMasteryScaleLink.json": [
    "573307",
    [
      370941
    ]
  ],
  "./he/user_profile.json": [
    "104562",
    [
      625354
    ]
  ],
  "./id/course_paces_blackout_date_row.json": [
    "471677",
    [
      50159
    ]
  ],
  "./it/student_entries.json": [
    "817235",
    [
      864893
    ]
  ],
  "./pl/grades_summary.json": [
    "550589",
    [
      217063
    ]
  ],
  "./zh-Hans/module_student_view_peer_reviews.json": [
    "579316",
    [
      328020
    ]
  ],
  "./tr/admin_split.json": [
    "653300",
    [
      535616
    ]
  ],
  "./ar/eportfolio.json": [
    "974314",
    [
      477734
    ]
  ],
  "./fr-CA/sis_import.json": [
    "336082",
    [
      88374
    ]
  ],
  "./ht/MasteryScale.json": [
    "603227",
    [
      664309
    ]
  ],
  "./hu/collaborations.json": [
    "543745",
    [
      837919
    ]
  ],
  "./sv/canvascareer.json": [
    "204475",
    [
      511405
    ]
  ],
  "./en-GB/MobileGlobalMenu.json": [
    "606703",
    [
      551758
    ]
  ],
  "./da/assignments_2_shared_Steps.json": [
    "807130",
    [
      520178
    ]
  ],
  "./de/files_v2.json": [
    "356943",
    [
      326746
    ]
  ],
  "./ga/ai_experiences_edit.json": [
    "166723",
    [
      814449
    ]
  ],
  "./tr/MasteryScale.json": [
    "721449",
    [
      38939
    ]
  ],
  "./ms/assignments_bulk_edit.json": [
    "712002",
    [
      387482
    ]
  ],
  "./pl/course_paces_blackout_dates_modal.json": [
    "457528",
    [
      862468
    ]
  ],
  "./ja/assignments_bulk_edit_use_save_assignment.json": [
    "119891",
    [
      640686
    ]
  ],
  "./fr/auth_logging.json": [
    "352554",
    [
      823015
    ]
  ],
  "./pt-BR/widget_dashboard.json": [
    "130698",
    [
      761003
    ]
  ],
  "./sv/suppress_notifications.json": [
    "882461",
    [
      569951
    ]
  ],
  "./en-AU-x-unimelb/canvas_file_upload.json": [
    "975363",
    [
      708885
    ]
  ],
  "./es-ES/plugins.json": [
    "445739",
    [
      501753
    ]
  ],
  "./nb-x-k12/ai_experiences_ai_conversations.json": [
    "378832",
    [
      908923
    ]
  ],
  "./ja/MasteryScale.json": [
    "496528",
    [
      742101
    ]
  ],
  "./el/k5_dashboard.json": [
    "220446",
    [
      133906
    ]
  ],
  "./id/EditMasteryScaleLink.json": [
    "708008",
    [
      711644
    ]
  ],
  "./fr/ai_experiences_ai_conversations.json": [
    "414734",
    [
      655035
    ]
  ],
  "./nn/course_paces_blueprint_lock.json": [
    "627142",
    [
      226130
    ]
  ],
  "./es-ES/knowledge_check_not_ready.json": [
    "557902",
    [
      410198
    ]
  ],
  "./da/CommentLibrary.json": [
    "930151",
    [
      31621
    ]
  ],
  "./pl/modelsQuiz.json": [
    "952185",
    [
      46147
    ]
  ],
  "./ht/course_pace_date_input.json": [
    "508023",
    [
      378281
    ]
  ],
  "./uk/jobs_v2.json": [
    "93195",
    [
      244545
    ]
  ],
  "./da-x-k12/section.json": [
    "477096",
    [
      611172
    ]
  ],
  "./id/k5_course.json": [
    "791315",
    [
      933709
    ]
  ],
  "./ca/sis_import.json": [
    "326649",
    [
      836087
    ]
  ],
  "./ar/AccountsTray.json": [
    "232623",
    [
      125825
    ]
  ],
  "./ca/context_roster_user_services.json": [
    "877070",
    [
      435054
    ]
  ],
  "./nn/k5_course.json": [
    "142386",
    [
      239278
    ]
  ],
  "./nl/quiz_statistics.json": [
    "488313",
    [
      119723
    ]
  ],
  "./nl/calendar.header.json": [
    "175601",
    [
      690024
    ]
  ],
  "./ja/course_paces_module.json": [
    "110392",
    [
      298909
    ]
  ],
  "./ru/course_paces_empty_state.json": [
    "666523",
    [
      445801
    ]
  ],
  "./hu/calendar_edit.json": [
    "837698",
    [
      176218
    ]
  ],
  "./ru.eager.json": [
    "533734",
    [
      380049
    ]
  ],
  "./is/AssignmentGroupListItemView.json": [
    "342440",
    [
      644192
    ]
  ],
  "./th/assignments_2_url_entry.json": [
    "569616",
    [
      167764
    ]
  ],
  "./nl/discussion_create.json": [
    "978681",
    [
      318163
    ]
  ],
  "./en-GB/edit_section_view.json": [
    "46339",
    [
      543154
    ]
  ],
  "./fa/learning_mastery_gradebook.json": [
    "87520",
    [
      867176
    ]
  ],
  "./el/course_paces_modal.json": [
    "714277",
    [
      324279
    ]
  ],
  "./hi/todo.json": [
    "858543",
    [
      709429
    ]
  ],
  "./ht/calendar_edit.json": [
    "552889",
    [
      540683
    ]
  ],
  "./hu/gradebookActionMenu.json": [
    "649218",
    [
      959962
    ]
  ],
  "./id/conversations_2.json": [
    "67138",
    [
      725622
    ]
  ],
  "./ca/DueDateOverrideView.json": [
    "149137",
    [
      576991
    ]
  ],
  "./hu/a2LatePolicyToolTipContent.json": [
    "724906",
    [
      696178
    ]
  ],
  "./ko/new_nav.json": [
    "642844",
    [
      296180
    ]
  ],
  "./nl/assignment_index_deep_linking_handlers.json": [
    "503258",
    [
      280646
    ]
  ],
  "./da-x-k12/security_panel.json": [
    "362946",
    [
      816198
    ]
  ],
  "./ht/horizon_toggle.json": [
    "246082",
    [
      28550
    ]
  ],
  "./he/user.json": [
    "695384",
    [
      941352
    ]
  ],
  "./ga/license_help.json": [
    "996929",
    [
      996727
    ]
  ],
  "./hu/peer_review_allocation_rules_tray.json": [
    "398760",
    [
      444536
    ]
  ],
  "./hu/important_dates.json": [
    "247389",
    [
      237203
    ]
  ],
  "./pt-BR/react_collaborations.json": [
    "891923",
    [
      718214
    ]
  ],
  "./tr/account_calendar_settings_footer.json": [
    "182556",
    [
      3080
    ]
  ],
  "./ru/blueprint_course_sidebar.json": [
    "484607",
    [
      995221
    ]
  ],
  "./fr/content_exports.json": [
    "63419",
    [
      658362
    ]
  ],
  "./hu/homeroom_page.json": [
    "984959",
    [
      470141
    ]
  ],
  "./fa/peer_review_allocation_rules_tray.json": [
    "196902",
    [
      879934
    ]
  ],
  "./ca/media_player_iframe_content.json": [
    "723489",
    [
      338543
    ]
  ],
  "./th/roster_section_selector.json": [
    "738047",
    [
      748449
    ]
  ],
  "./pt/user_restore.json": [
    "327620",
    [
      782736
    ]
  ],
  "./da-x-k12/external_content_cancel.json": [
    "776719",
    [
      958169
    ]
  ],
  "./uk/ignite_agent.json": [
    "81550",
    [
      588654
    ]
  ],
  "./hy.eager.json": [
    "390560",
    [
      987059
    ]
  ],
  "./zh-Hans/course_paces_assignment_row.json": [
    "460764",
    [
      308172
    ]
  ],
  "./he/SpeedGraderPostGradesMenu.json": [
    "187544",
    [
      273704
    ]
  ],
  "./ru/gradebook_uploads.json": [
    "629364",
    [
      526180
    ]
  ],
  "./sv-x-k12/OutcomeMoveModal.json": [
    "182553",
    [
      311631
    ]
  ],
  "./es/link_to_students.json": [
    "493047",
    [
      848938
    ]
  ],
  "./ga/announcements_on_home_page.json": [
    "416974",
    [
      560470
    ]
  ],
  "./ca/assignment_show.json": [
    "979125",
    [
      98091
    ]
  ],
  "./ht/edit_section_view.json": [
    "937666",
    [
      731038
    ]
  ],
  "./en-GB-x-ukhe/roster_publicjs.json": [
    "509550",
    [
      137910
    ]
  ],
  "./fa/student_annotation_preview.json": [
    "424287",
    [
      889557
    ]
  ],
  "./hy/roster_section_selector.json": [
    "145868",
    [
      45356
    ]
  ],
  "./ar/unpublished_changes_button_props.json": [
    "810728",
    [
      882036
    ]
  ],
  "./is/available_pronouns_list.json": [
    "253299",
    [
      361153
    ]
  ],
  "./hu/assignments_2_external_tool.json": [
    "155603",
    [
      658473
    ]
  ],
  "./id/user.json": [
    "937294",
    [
      42482
    ]
  ],
  "./sl/blueprint_settingsSyncHistory.json": [
    "421747",
    [
      786213
    ]
  ],
  "./en-GB-x-ukhe/user.json": [
    "532827",
    [
      871033
    ]
  ],
  "./el/pseudonyms_mobile_login.json": [
    "529679",
    [
      120353
    ]
  ],
  "./hi/accessibility_course_statistics.json": [
    "460299",
    [
      400169
    ]
  ],
  "./ar/course_paces_blackout_date_row.json": [
    "464127",
    [
      286129
    ]
  ],
  "./mi/MobileGlobalMenu.json": [
    "653226",
    [
      700594
    ]
  ],
  "./el/sidenav.json": [
    "376131",
    [
      897741
    ]
  ],
  "./el/mutationActivity.json": [
    "850451",
    [
      641309
    ]
  ],
  "./en-AU-x-unimelb/k5_course.json": [
    "450022",
    [
      331530
    ]
  ],
  "./sv/CreateEditAssignmentModalAdapter.json": [
    "137656",
    [
      46764
    ]
  ],
  "./ms/assignmentsToggleShowByView.json": [
    "529669",
    [
      254635
    ]
  ],
  "./da-x-k12/lti_registration.wizard.json": [
    "608489",
    [
      651116
    ]
  ],
  "./da/horizon_toggle.json": [
    "791775",
    [
      471693
    ]
  ],
  "./en-AU-x-unimelb/password_complexity_configuration.json": [
    "935437",
    [
      330015
    ]
  ],
  "./fr-CA/assignment_index_menu.json": [
    "270519",
    [
      378417
    ]
  ],
  "./hi/course_color_selector.json": [
    "740286",
    [
      581158
    ]
  ],
  "./zh-Hant/conversations_2.json": [
    "410177",
    [
      388547
    ]
  ],
  "./fi/modules_home_page.json": [
    "932830",
    [
      902038
    ]
  ],
  "./hi/ignite_agent.json": [
    "151991",
    [
      976509
    ]
  ],
  "./hu/custom_help_link.json": [
    "400787",
    [
      276745
    ]
  ],
  "./nb-x-k12/permissions_role_tray.json": [
    "568634",
    [
      230762
    ]
  ],
  "./pt/course_pace_date_input.json": [
    "189903",
    [
      704849
    ]
  ],
  "./fi/MobileGlobalMenu.json": [
    "887147",
    [
      413209
    ]
  ],
  "./tr/paginated_list.json": [
    "453532",
    [
      760000
    ]
  ],
  "./ga/grade_details.json": [
    "938128",
    [
      70760
    ]
  ],
  "./he/DueDateOverrideView.json": [
    "123170",
    [
      710842
    ]
  ],
  "./id/gradinggradingPeriodCollection.json": [
    "843376",
    [
      281684
    ]
  ],
  "./ja/Navigation.json": [
    "779519",
    [
      72578
    ]
  ],
  "./hy/course_paces_app.json": [
    "108925",
    [
      532299
    ]
  ],
  "./es/copy_course.json": [
    "325153",
    [
      320624
    ]
  ],
  "./da-x-k12/assignments.never_drop.json": [
    "488147",
    [
      458862
    ]
  ],
  "./de/content_share_preview_overlay.json": [
    "516864",
    [
      360189
    ]
  ],
  "./ca/discussion_settings.json": [
    "792118",
    [
      104230
    ]
  ],
  "./th/DueDateOverrideView.json": [
    "2401",
    [
      817155
    ]
  ],
  "./ht/bulk_edit_students_table.json": [
    "240655",
    [
      165649
    ]
  ],
  "./sl/pairing_code_user_observees.json": [
    "902036",
    [
      203296
    ]
  ],
  "./it/group_submission_reminder.json": [
    "892744",
    [
      942660
    ]
  ],
  "./uk/CommentLibrary.json": [
    "787654",
    [
      575286
    ]
  ],
  "./da-x-k12/filter_calendars_modal.json": [
    "938809",
    [
      507947
    ]
  ],
  "./en-CA/account_calendars.json": [
    "693565",
    [
      568267
    ]
  ],
  "./id/assignments.no_assignments_search.json": [
    "621892",
    [
      678713
    ]
  ],
  "./ms/ai_experiences_show.json": [
    "580130",
    [
      932794
    ]
  ],
  "./ms/course_paces_blackout_dates_table.json": [
    "441973",
    [
      48859
    ]
  ],
  "./mi/outcome_reporting.json": [
    "661225",
    [
      911319
    ]
  ],
  "./vi/gradebook.json": [
    "302565",
    [
      822851
    ]
  ],
  "./sv/gradebook_default_gradebook_components_content_filters_module_filter.json": [
    "483097",
    [
      344883
    ]
  ],
  "./nl/SpeedGraderCheckpoints.json": [
    "716683",
    [
      794949
    ]
  ],
  "./en-CA/discussion_topics.json": [
    "465563",
    [
      261241
    ]
  ],
  "./es-ES/react_collaborations.json": [
    "569907",
    [
      668209
    ]
  ],
  "./pt/AddGroup.json": [
    "343136",
    [
      737620
    ]
  ],
  "./ms/course_paces_actions.json": [
    "203824",
    [
      661104
    ]
  ],
  "./fi/user_name.json": [
    "472396",
    [
      353964
    ]
  ],
  "./tr/modules_home_page.json": [
    "809389",
    [
      372031
    ]
  ],
  "./fi/course_paces_modal.json": [
    "440785",
    [
      809607
    ]
  ],
  "./mi/webzip_export.json": [
    "479896",
    [
      49832
    ]
  ],
  "./tr/blueprint_settingsCoursePickerTable.json": [
    "147594",
    [
      968822
    ]
  ],
  "./ht/assignments_2_login_action_prompt.json": [
    "989825",
    [
      562995
    ]
  ],
  "./el/course_paces_assignment_row.json": [
    "931554",
    [
      608246
    ]
  ],
  "./en-GB-x-lbs/rubrics-export.json": [
    "154335",
    [
      30805
    ]
  ],
  "./fr/sharedCurveGradesDialog.json": [
    "556538",
    [
      340407
    ]
  ],
  "./pt/terms_of_use.json": [
    "607023",
    [
      691201
    ]
  ],
  "./uk/GroupDetailView.json": [
    "439129",
    [
      484951
    ]
  ],
  "./hu/blueprint_settingsMigrationSync.json": [
    "431377",
    [
      893199
    ]
  ],
  "./hy/discussion_settings.json": [
    "408013",
    [
      761835
    ]
  ],
  "./hy/permissions.json": [
    "870093",
    [
      724267
    ]
  ],
  "./fa/ImportConfirmBox.json": [
    "531329",
    [
      532775
    ]
  ],
  "./ms/calendar_custom_recurring_event_repeat_picker.json": [
    "267884",
    [
      289236
    ]
  ],
  "./nn/roster_publicjs.json": [
    "792208",
    [
      823788
    ]
  ],
  "./zh-Hant/jobs_v2.json": [
    "556249",
    [
      251619
    ]
  ],
  "./cy/GroupsTray.json": [
    "802154",
    [
      203538
    ]
  ],
  "./th/course_link_validator.json": [
    "807901",
    [
      704695
    ]
  ],
  "./fr-CA/file_not_found.json": [
    "397754",
    [
      187254
    ]
  ],
  "./en-GB/custom_help_link.json": [
    "679345",
    [
      233996
    ]
  ],
  "./es/content_shares.json": [
    "84532",
    [
      843233
    ]
  ],
  "./da-x-k12/calculator.json": [
    "361917",
    [
      508943
    ]
  ],
  "./fr-CA/unpublished_changes_button_props.json": [
    "978366",
    [
      304154
    ]
  ],
  "./nn/important_dates.json": [
    "425758",
    [
      234146
    ]
  ],
  "./ko/blueprint_settingsCoursePickerTable.json": [
    "831446",
    [
      645478
    ]
  ],
  "./en-GB-x-lbs/ImportConfirmBox.json": [
    "61336",
    [
      174256
    ]
  ],
  "./zh-Hans/MoveOutcomesModal.json": [
    "728404",
    [
      829412
    ]
  ],
  "./ms/assignments_2_student_points_display.json": [
    "424508",
    [
      268836
    ]
  ],
  "./hu/blueprint_settingsCoursePickerTable.json": [
    "328107",
    [
      420689
    ]
  ],
  "./en-GB-x-ukhe/video_conference.json": [
    "238454",
    [
      5070
    ]
  ],
  "./ga/course_paces_blueprint_lock.json": [
    "908166",
    [
      536750
    ]
  ],
  "./da-x-k12/k5_dashboard_card.json": [
    "795981",
    [
      624839
    ]
  ],
  "./ca/assignments_bulk_edit.json": [
    "648770",
    [
      877866
    ]
  ],
  "./el/security_panel.json": [
    "101946",
    [
      830886
    ]
  ],
  "./en-AU/account_settings_jsx_bundle.json": [
    "910596",
    [
      534113
    ]
  ],
  "./nb-x-k12/unpublished_changes_button_props.json": [
    "233507",
    [
      156126
    ]
  ],
  "./tr/quiz_statistics.json": [
    "359141",
    [
      627367
    ]
  ],
  "./fr-CA/course_statistics.json": [
    "759002",
    [
      395294
    ]
  ],
  "./hi/progressbar_view.json": [
    "326007",
    [
      138717
    ]
  ],
  "./nb/account_calendar_settings_account_calendar_item.json": [
    "497947",
    [
      734045
    ]
  ],
  "./mi/canvascareer.json": [
    "971550",
    [
      908398
    ]
  ],
  "./da/unpublished_warning_modal.json": [
    "605263",
    [
      35197
    ]
  ],
  "./nl/account_notification_settings.json": [
    "892689",
    [
      285515
    ]
  ],
  "./tr/AssignmentGroupListItemView.json": [
    "456258",
    [
      665398
    ]
  ],
  "./da-x-k12/course_paces_blueprint_lock.json": [
    "11323",
    [
      618413
    ]
  ],
  "./fr/syllabus_revisions.json": [
    "101912",
    [
      14137
    ]
  ],
  "./ga/assignments_peer_reviews_student.json": [
    "391175",
    [
      419197
    ]
  ],
  "./da-x-k12/CreateEditAssignmentModalAdapter.json": [
    "675936",
    [
      21020
    ]
  ],
  "./da/GroupDetailView.json": [
    "353450",
    [
      367170
    ]
  ],
  "./fr/NewTabIndicator.json": [
    "296448",
    [
      747929
    ]
  ],
  "./nb-x-k12/new_user_tutorial.json": [
    "519859",
    [
      931377
    ]
  ],
  "./ja/choose_mastery_path.json": [
    "322736",
    [
      519349
    ]
  ],
  "./pt/pairing_code_user_observees.json": [
    "493491",
    [
      996101
    ]
  ],
  "./uk/course_paces_no_results.json": [
    "168043",
    [
      72417
    ]
  ],
  "./nn/enhanced_individual_gradebook_submit_score.json": [
    "541393",
    [
      541867
    ]
  ],
  "./fi/announcements_on_home_page.json": [
    "897309",
    [
      891755
    ]
  ],
  "./ru/course_paces_errors.json": [
    "966555",
    [
      510969
    ]
  ],
  "./th/blueprint_settingsSyncChange.json": [
    "606788",
    [
      411616
    ]
  ],
  "./da/student_annotation_preview.json": [
    "200257",
    [
      680239
    ]
  ],
  "./ko/AssignmentListItemView.json": [
    "409631",
    [
      104333
    ]
  ],
  "./uk/user_logins.json": [
    "97792",
    [
      251664
    ]
  ],
  "./ko/not_found_page_slide_puzzle.json": [
    "729595",
    [
      598097
    ]
  ],
  "./sv/k5_dashboard.json": [
    "802926",
    [
      741090
    ]
  ],
  "./sv-x-k12/course_paces_assignment_row.json": [
    "546708",
    [
      650388
    ]
  ],
  "./ga/empty_modules.json": [
    "115905",
    [
      300455
    ]
  ],
  "./ja/module_sequence_footer.json": [
    "87703",
    [
      41754
    ]
  ],
  "./nb-x-k12/content_copy_redesign.json": [
    "540523",
    [
      457545
    ]
  ],
  "./en-GB-x-ukhe/CreateEditAssignmentModal.json": [
    "390862",
    [
      965670
    ]
  ],
  "./ja/rootFoldersFinder.json": [
    "13958",
    [
      188743
    ]
  ],
  "./sv-x-k12/homeroom_page.json": [
    "46803",
    [
      855473
    ]
  ],
  "./en-GB/context_modules_v2.json": [
    "475203",
    [
      237690
    ]
  ],
  "./de/media_immersive_view.json": [
    "175535",
    [
      491834
    ]
  ],
  "./nb-x-k12/course_paces_errors.json": [
    "516748",
    [
      632156
    ]
  ],
  "./zh-Hant/assignments_2_external_tool.json": [
    "984246",
    [
      77274
    ]
  ],
  "./en-AU/account_course_user_search.json": [
    "991306",
    [
      637715
    ]
  ],
  "./uk/section.json": [
    "835513",
    [
      442871
    ]
  ],
  "./mi/course_paces_blueprint_lock.json": [
    "916096",
    [
      663072
    ]
  ],
  "./da-x-k12/assignment_grade_summary.json": [
    "233139",
    [
      289437
    ]
  ],
  "./id/syllabus_revisions.json": [
    "394859",
    [
      852341
    ]
  ],
  "./th/quantitative_data_options.json": [
    "45835",
    [
      815357
    ]
  ],
  "./en-AU-x-unimelb/appointment_groups.json": [
    "179272",
    [
      984772
    ]
  ],
  "./sv-x-k12/modules_page_icon_legend.json": [
    "139866",
    [
      437274
    ]
  ],
  "./sl/AccountsTray.json": [
    "774151",
    [
      404033
    ]
  ],
  "./ko/outcome_management.json": [
    "224990",
    [
      175390
    ]
  ],
  "./sl/assignmentsToggleShowByView.json": [
    "654958",
    [
      751650
    ]
  ],
  "./ga/users.json": [
    "545066",
    [
      947002
    ]
  ],
  "./da/bulk_edit_students.json": [
    "286965",
    [
      79499
    ]
  ],
  "./da/external_content_cancel.json": [
    "468893",
    [
      559811
    ]
  ],
  "./de/permissions_role_tray_table_row.json": [
    "727459",
    [
      646374
    ]
  ],
  "./fi/submissions_show_preview.json": [
    "81521",
    [
      855047
    ]
  ],
  "./cy/ldap_cert_upload.json": [
    "266682",
    [
      301026
    ]
  ],
  "./cy/unpublished_warning_modal.json": [
    "429472",
    [
      981280
    ]
  ],
  "./tr/LogoutButton.json": [
    "26257",
    [
      203202
    ]
  ],
  "./es/change_password.json": [
    "180062",
    [
      269007
    ]
  ],
  "./ga/question_bank.json": [
    "69997",
    [
      582315
    ]
  ],
  "./hi/syllabus_revisions.json": [
    "85289",
    [
      628415
    ]
  ],
  "./hi/horizon_toggle.json": [
    "603331",
    [
      55665
    ]
  ],
  "./pt/external_content_cancel.json": [
    "512154",
    [
      794070
    ]
  ],
  "./ga/suppress_notifications.json": [
    "762762",
    [
      886762
    ]
  ],
  "./de/self_unenrollment_modal.json": [
    "946931",
    [
      920102
    ]
  ],
  "./ja/user_search_results.json": [
    "926590",
    [
      696351
    ]
  ],
  "./en-GB-x-lbs/accessibility_course_statistics.json": [
    "654854",
    [
      710830
    ]
  ],
  "./hy/sharedCurveGradesDialog.json": [
    "482849",
    [
      956567
    ]
  ],
  "./ko/user_grades.json": [
    "280272",
    [
      543104
    ]
  ],
  "./hy/MobileNavigation.json": [
    "763887",
    [
      370885
    ]
  ],
  "./fr-CA/keyboardShortcutModal.json": [
    "137339",
    [
      367613
    ]
  ],
  "./tr/course_restore.json": [
    "386640",
    [
      978764
    ]
  ],
  "./fr/link_to_students.json": [
    "726431",
    [
      942734
    ]
  ],
  "./hu/course_default_due_time.json": [
    "657619",
    [
      101033
    ]
  ],
  "./it/blueprint_settingsCoursePickerTable.json": [
    "785445",
    [
      552551
    ]
  ],
  "./da/roster_section_input.json": [
    "821255",
    [
      307045
    ]
  ],
  "./is/remove_pace_warning_modal.json": [
    "962378",
    [
      488203
    ]
  ],
  "./ja/course_paces_settings.json": [
    "542529",
    [
      86080
    ]
  ],
  "./ko/horizon_toggle.json": [
    "507056",
    [
      464288
    ]
  ],
  "./pl/calendar_custom_recurring_event_repeat_picker.json": [
    "508580",
    [
      10112
    ]
  ],
  "./uk/assignments_2_submission_helpers.json": [
    "23708",
    [
      203668
    ]
  ],
  "./nl/group_submission_reminder.json": [
    "374783",
    [
      626585
    ]
  ],
  "./es/course_paces_errors.json": [
    "490286",
    [
      802943
    ]
  ],
  "./pt-BR/youtube_migration.json": [
    "659849",
    [
      237168
    ]
  ],
  "./ga/sis_import.json": [
    "143653",
    [
      790355
    ]
  ],
  "./fr/grades_summary.json": [
    "915013",
    [
      85584
    ]
  ],
  "./tr/calculator_command.json": [
    "547306",
    [
      115990
    ]
  ],
  "./de/a2_AccessibleTipContent.json": [
    "286169",
    [
      203120
    ]
  ],
  "./de/lti_registration.wizard.json": [
    "514075",
    [
      917342
    ]
  ],
  "./it/GroupDetailView.json": [
    "672912",
    [
      406508
    ]
  ],
  "./da-x-k12/editAssignmentGroupWeights.json": [
    "70220",
    [
      297096
    ]
  ],
  "./hu/gradebookOutcomeGradebookView.json": [
    "729024",
    [
      982688
    ]
  ],
  "./he/file_not_found.json": [
    "785720",
    [
      750504
    ]
  ],
  "./ms/blueprint_coursesExpandableLockOptions.json": [
    "690763",
    [
      820497
    ]
  ],
  "./nn/course_paces_errors.json": [
    "438986",
    [
      103406
    ]
  ],
  "./tr/MoveOutcomesModal.json": [
    "620817",
    [
      650851
    ]
  ],
  "./nn/sections_tooltip.json": [
    "416654",
    [
      241458
    ]
  ],
  "./da-x-k12/k5_dashboard.json": [
    "849206",
    [
      394610
    ]
  ],
  "./tr/course_paces_flaggable_number_input.json": [
    "796345",
    [
      946611
    ]
  ],
  "./ar/assignments_2_submission_helpers.json": [
    "818261",
    [
      392951
    ]
  ],
  "./tr/course_paces_no_results.json": [
    "492621",
    [
      331327
    ]
  ],
  "./uk/peer_review_allocation_rules_tray.json": [
    "61331",
    [
      109913
    ]
  ],
  "./ko/a2LatePolicyToolTipContent.json": [
    "436925",
    [
      925475
    ]
  ],
  "./ru/assignments_2_student_annotation.json": [
    "722768",
    [
      515480
    ]
  ],
  "./zh-Hans/remove_pace_warning_modal.json": [
    "896706",
    [
      675650
    ]
  ],
  "./zh-Hant/GroupsTray.json": [
    "24612",
    [
      761448
    ]
  ],
  "./hi/submit_assignment.json": [
    "766005",
    [
      977059
    ]
  ],
  "./pt-BR/course_paces_actions.json": [
    "953103",
    [
      329802
    ]
  ],
  "./vi/top_navigation_tools.json": [
    "345147",
    [
      795625
    ]
  ],
  "./ru/reset_pace_warning_modal.json": [
    "663011",
    [
      913393
    ]
  ],
  "./ca/assignments_2_url_entry.json": [
    "431424",
    [
      860496
    ]
  ],
  "./hi/suppress_notifications.json": [
    "90591",
    [
      644805
    ]
  ],
  "./fa/content_migrations_redesign.json": [
    "328164",
    [
      629892
    ]
  ],
  "./hu/user_logins.json": [
    "978675",
    [
      146665
    ]
  ],
  "./sv-x-k12/react_scheduler.json": [
    "629444",
    [
      698532
    ]
  ],
  "./nb/blueprint_settingsUnsyncedChanges.json": [
    "482587",
    [
      381325
    ]
  ],
  "./ca/NewTabIndicator.json": [
    "758896",
    [
      483200
    ]
  ],
  "./ar/GroupsTray.json": [
    "803659",
    [
      691149
    ]
  ],
  "./fa/course_paces_pace_picker.json": [
    "834178",
    [
      198674
    ]
  ],
  "./fr/calendar_sidebar.json": [
    "314859",
    [
      360634
    ]
  ],
  "./cy/account_calendar_settings_footer.json": [
    "272910",
    [
      396158
    ]
  ],
  "./vi/conferences.json": [
    "231624",
    [
      771888
    ]
  ],
  "./es-ES/remove_pace_warning_modal.json": [
    "426236",
    [
      280204
    ]
  ],
  "./en-AU/quiz_statistics.json": [
    "594285",
    [
      726820
    ]
  ],
  "./fi/assignments_2_student_annotation.json": [
    "330000",
    [
      836552
    ]
  ],
  "./mi/error_form.json": [
    "379977",
    [
      979095
    ]
  ],
  "./es/quiz_statistics.json": [
    "956147",
    [
      380126
    ]
  ],
  "./da-x-k12/student_annotation_preview.json": [
    "72539",
    [
      749949
    ]
  ],
  "./ht/rate_limiting_settings.json": [
    "236940",
    [
      909408
    ]
  ],
  "./ko/assignments.never_drop.json": [
    "783954",
    [
      58713
    ]
  ],
  "./nb/add_edit_pseudonym.json": [
    "152719",
    [
      61905
    ]
  ],
  "./ca/assignments_2_student_header.json": [
    "782779",
    [
      992497
    ]
  ],
  "./en-GB-x-lbs/calendar_appointment_group_edit.json": [
    "19689",
    [
      864031
    ]
  ],
  "./ca/horizon_toggle.json": [
    "380890",
    [
      317330
    ]
  ],
  "./id/assignments_2_text_entry.json": [
    "407809",
    [
      585771
    ]
  ],
  "./it/quizzes_quiz_submission.json": [
    "888403",
    [
      516829
    ]
  ],
  "./ms/assignment_index.json": [
    "634108",
    [
      566308
    ]
  ],
  "./sv/self_enrollment.json": [
    "301748",
    [
      420808
    ]
  ],
  "./cy/permission_button.json": [
    "644530",
    [
      34186
    ]
  ],
  "./fa/gradebook_default_gradebook_components_content_filters_module_filter.json": [
    "160877",
    [
      256235
    ]
  ],
  "./hi/eportfolio.json": [
    "181754",
    [
      405018
    ]
  ],
  "./vi/context_modules_v2.json": [
    "553167",
    [
      786725
    ]
  ],
  "./pt/assignment_grade_summary.json": [
    "418680",
    [
      491620
    ]
  ],
  "./it/terms_of_use.json": [
    "88400",
    [
      283276
    ]
  ],
  "./ja/terms_of_service_modal.json": [
    "671478",
    [
      898743
    ]
  ],
  "./en-GB-x-ukhe/student_groups.json": [
    "827772",
    [
      749740
    ]
  ],
  "./nb-x-k12/assignments_2_MoreOptions.json": [
    "9773",
    [
      852555
    ]
  ],
  "./fa/quiz_log_auditing.json": [
    "811575",
    [
      98813
    ]
  ],
  "./id/theme_editor.json": [
    "614558",
    [
      789002
    ]
  ],
  "./en-GB-x-lbs/permissions_role_tray.json": [
    "998190",
    [
      196198
    ]
  ],
  "./fr-CA/license_help.json": [
    "613566",
    [
      185618
    ]
  ],
  "./he/announcements_on_home_page.json": [
    "481975",
    [
      498629
    ]
  ],
  "./uk/blueprint_settingsCourseFilter.json": [
    "966240",
    [
      418288
    ]
  ],
  "./uk/modules_home_page.json": [
    "306611",
    [
      883513
    ]
  ],
  "./ko/courses_show.json": [
    "501774",
    [
      683662
    ]
  ],
  "./fa/permissions_v2.json": [
    "289108",
    [
      286052
    ]
  ],
  "./es/OutcomeMoveModal.json": [
    "999420",
    [
      657993
    ]
  ],
  "./ja/blueprint_course_sidebar.json": [
    "645315",
    [
      948702
    ]
  ],
  "./pt-BR/CourseAvailabilityOptions.json": [
    "370543",
    [
      461085
    ]
  ],
  "./ko/copy_warnings_modal.json": [
    "917977",
    [
      850359
    ]
  ],
  "./nn/discussion_pinned_post.json": [
    "592832",
    [
      933924
    ]
  ],
  "./sv-x-k12/MoveOutcomesModal.json": [
    "606524",
    [
      371004
    ]
  ],
  "./nl/MobileNavigation.json": [
    "47392",
    [
      38100
    ]
  ],
  "./nn/assignments_peer_reviews.json": [
    "286987",
    [
      237637
    ]
  ],
  "./nn/Navigation.json": [
    "628236",
    [
      306808
    ]
  ],
  "./ar/module_sequence_footer.json": [
    "877873",
    [
      996939
    ]
  ],
  "./es/assignment_index_menu.json": [
    "205610",
    [
      503171
    ]
  ],
  "./es/course_paces_projected_dates.json": [
    "592477",
    [
      551620
    ]
  ],
  "./ca/assignments_peer_reviews_student.json": [
    "20067",
    [
      393577
    ]
  ],
  "./hy/sharedSetDefaultGradeDialog.json": [
    "671762",
    [
      354226
    ]
  ],
  "./nb-x-k12/context_roster_user_services.json": [
    "201432",
    [
      765376
    ]
  ],
  "./nb/grades_summary.json": [
    "744301",
    [
      310807
    ]
  ],
  "./ca/notebook_index.json": [
    "720536",
    [
      824152
    ]
  ],
  "./ru/user_lists.json": [
    "692348",
    [
      728060
    ]
  ],
  "./da-x-k12/a2LatePolicyToolTipContent.json": [
    "370192",
    [
      179172
    ]
  ],
  "./fi/account_calendar_settings_filter_controls.json": [
    "239827",
    [
      684177
    ]
  ],
  "./da-x-k12/courses_show.json": [
    "38283",
    [
      254549
    ]
  ],
  "./mi/plugins.json": [
    "67372",
    [
      896852
    ]
  ],
  "./sv/blueprint_settingsMigrationOptions.json": [
    "675642",
    [
      244574
    ]
  ],
  "./en-GB/jobs.json": [
    "105093",
    [
      672080
    ]
  ],
  "./ru/roster_publicjs.json": [
    "500421",
    [
      450899
    ]
  ],
  "./he/edit_section_view.json": [
    "568029",
    [
      275091
    ]
  ],
  "./fa/license_help.json": [
    "234954",
    [
      410026
    ]
  ],
  "./en-GB-x-ukhe/peer_review_configuration_tray.json": [
    "835557",
    [
      82675
    ]
  ],
  "./sl/outcome_detail.json": [
    "18751",
    [
      226185
    ]
  ],
  "./zh-Hant/MobileNavigation.json": [
    "251724",
    [
      466480
    ]
  ],
  "./ga.eager.json": [
    "508223",
    [
      386418
    ]
  ],
  "./he/theme_editor.json": [
    "463700",
    [
      979436
    ]
  ],
  "./sl/gradebookActionMenu.json": [
    "598022",
    [
      590290
    ]
  ],
  "./cy/top_navigation_tools.json": [
    "587328",
    [
      202720
    ]
  ],
  "./hi/empty_modules.json": [
    "605266",
    [
      397858
    ]
  ],
  "./nl/a2_AccessibleTipContent.json": [
    "13444",
    [
      754912
    ]
  ],
  "./nn/SpeedGraderSettingsMenu.json": [
    "262140",
    [
      718568
    ]
  ],
  "./pl/new_user_tutorial.json": [
    "765233",
    [
      765635
    ]
  ],
  "./ar/context_modules_v2.json": [
    "296689",
    [
      934891
    ]
  ],
  "./en/roster_publicjs.json": [
    "579267",
    [
      748245
    ]
  ],
  "./sv-x-k12/user.json": [
    "793836",
    [
      452412
    ]
  ],
  "./fr/calendar_custom_recurring_event_natural_language.json": [
    "355014",
    [
      816019
    ]
  ],
  "./hu/learning_mastery_gradebook.json": [
    "668970",
    [
      445906
    ]
  ],
  "./es/assignments_peer_reviews_student.json": [
    "512347",
    [
      862438
    ]
  ],
  "./is/account_course_user_search.json": [
    "617648",
    [
      717368
    ]
  ],
  "./ru/quiz_log_auditing.json": [
    "842047",
    [
      456613
    ]
  ],
  "./sl/security_panel.json": [
    "586552",
    [
      693988
    ]
  ],
  "./sv-x-k12/gradebookOutcomeGradebookView.json": [
    "602980",
    [
      101908
    ]
  ],
  "./th/sidenav.json": [
    "243842",
    [
      822782
    ]
  ],
  "./it/speed_grader_helpers.json": [
    "803992",
    [
      60900
    ]
  ],
  "./th/assignments_peer_reviews.json": [
    "778975",
    [
      648393
    ]
  ],
  "./tr/discussion_create.json": [
    "762461",
    [
      439623
    ]
  ],
  "./da/discussion_row.json": [
    "901428",
    [
      120572
    ]
  ],
  "./it/k5_course.json": [
    "252355",
    [
      299389
    ]
  ],
  "./ms/module_student_view_peer_reviews.json": [
    "212057",
    [
      705095
    ]
  ],
  "./nb/course_paces_time_selection.json": [
    "903705",
    [
      232555
    ]
  ],
  "./vi/quiz_statistics.json": [
    "291858",
    [
      595074
    ]
  ],
  "./it/progressbar_view.json": [
    "599349",
    [
      90855
    ]
  ],
  "./sv-x-k12/blueprint_coursesExpandableLockOptions.json": [
    "444970",
    [
      42474
    ]
  ],
  "./it/enhanced_individual_gradebook_submit_score.json": [
    "918306",
    [
      66150
    ]
  ],
  "./en-AU/accessibility_checker.json": [
    "261264",
    [
      765813
    ]
  ],
  "./zh-Hans/group_submission_reminder.json": [
    "322346",
    [
      401818
    ]
  ],
  "./mi/assignments_2_student_annotation.json": [
    "546653",
    [
      972435
    ]
  ],
  "./hy/MoveOutcomesModal.json": [
    "196044",
    [
      986092
    ]
  ],
  "./en-GB/course_paces_assignment_row.json": [
    "273122",
    [
      764439
    ]
  ],
  "./hy/entity_search_form.json": [
    "803764",
    [
      640020
    ]
  ],
  "./en-CA/permissions.json": [
    "408438",
    [
      952206
    ]
  ],
  "./fa/course_paces_projected_dates.json": [
    "580562",
    [
      384066
    ]
  ],
  "./da-x-k12/course_paces_time_selection.json": [
    "216644",
    [
      145624
    ]
  ],
  "./th/a2_AccessibleTipContent.json": [
    "691506",
    [
      912006
    ]
  ],
  "./da-x-k12/user_lists.json": [
    "46512",
    [
      965980
    ]
  ],
  "./es/blueprint_settingsCoursePickerTable.json": [
    "715792",
    [
      700165
    ]
  ],
  "./ht/assignments_2_student_header.json": [
    "83651",
    [
      695941
    ]
  ],
  "./ko/MasteryScale.json": [
    "93269",
    [
      190187
    ]
  ],
  "./nb-x-k12/CourseAvailabilityOptions.json": [
    "762812",
    [
      673052
    ]
  ],
  "./uk/NewTabIndicator.json": [
    "671152",
    [
      303744
    ]
  ],
  "./zh-Hans/user_restore.json": [
    "487041",
    [
      711015
    ]
  ],
  "./th/webzip_export.json": [
    "964286",
    [
      689890
    ]
  ],
  "./pt/enhanced_individual_gradebook_submit_score.json": [
    "359613",
    [
      648039
    ]
  ],
  "./nn/lti_registrations.json": [
    "379452",
    [
      283896
    ]
  ],
  "./pt/ignite_agent.json": [
    "389950",
    [
      672978
    ]
  ],
  "./cy/calendar_edit.json": [
    "736601",
    [
      307623
    ]
  ],
  "./ga/AlignmentSummary.json": [
    "171129",
    [
      259327
    ]
  ],
  "./sv-x-k12/MobileNavigation.json": [
    "876223",
    [
      99061
    ]
  ],
  "./vi/conferences_alternatives.json": [
    "934029",
    [
      991019
    ]
  ],
  "./tr/blueprint_settingsMigrationOptions.json": [
    "90991",
    [
      174489
    ]
  ],
  "./zh-Hant/gradebook_history.json": [
    "956489",
    [
      715
    ]
  ],
  "./ko/group_submission_reminder.json": [
    "204383",
    [
      345293
    ]
  ],
  "./de/permissions_v2.json": [
    "62622",
    [
      412279
    ]
  ],
  "./en-AU-x-unimelb/empty_course.json": [
    "811065",
    [
      56515
    ]
  ],
  "./hu/OutcomeDescriptionModal.json": [
    "893298",
    [
      217770
    ]
  ],
  "./he/plugins.json": [
    "589765",
    [
      753707
    ]
  ],
  "./he/dashboard_grading_period_select.json": [
    "725787",
    [
      693601
    ]
  ],
  "./ko/AddGroup.json": [
    "419142",
    [
      528726
    ]
  ],
  "./nb/course_paces_header.json": [
    "595276",
    [
      667152
    ]
  ],
  "./nn/peer_review_allocation_rule_card.json": [
    "528176",
    [
      813044
    ]
  ],
  "./en-GB-x-ukhe/assignments_2_media_attempt.json": [
    "296914",
    [
      730418
    ]
  ],
  "./es-ES/sidenav.json": [
    "790775",
    [
      973117
    ]
  ],
  "./ca/user_name.json": [
    "731113",
    [
      23015
    ]
  ],
  "./uk/assignments_bulk_edit.json": [
    "228994",
    [
      202346
    ]
  ],
  "./ga/module_sequence_footer.json": [
    "388720",
    [
      532520
    ]
  ],
  "./vi/ImportConfirmBox.json": [
    "658505",
    [
      350015
    ]
  ],
  "./pt-BR/canvascareer.json": [
    "966247",
    [
      275890
    ]
  ],
  "./da-x-k12/content_copy_redesign.json": [
    "558056",
    [
      386500
    ]
  ],
  "./de/gradingPeriodTemplate.json": [
    "354722",
    [
      46771
    ]
  ],
  "./pt-BR/content_migrations.json": [
    "289362",
    [
      593443
    ]
  ],
  "./fa/quizzes_openModerateStudentDialog.json": [
    "19877",
    [
      690355
    ]
  ],
  "./pt-BR/discussion_insights.json": [
    "860399",
    [
      85802
    ]
  ],
  "./da/outcome_detail.json": [
    "630027",
    [
      880097
    ]
  ],
  "./sl/assignments_2_student_content.json": [
    "288792",
    [
      197996
    ]
  ],
  "./sv/empty_course.json": [
    "576958",
    [
      533794
    ]
  ],
  "./zh-Hant/jobs.json": [
    "150940",
    [
      589944
    ]
  ],
  "./vi/AssignmentListItemView.json": [
    "438606",
    [
      414265
    ]
  ],
  "./nn/context_prior_users.json": [
    "952477",
    [
      696383
    ]
  ],
  "./it/unpublished_changes_tray_contents.json": [
    "985978",
    [
      887142
    ]
  ],
  "./sv/syllabus_revisions.json": [
    "230895",
    [
      754009
    ]
  ],
  "./tr/react_scheduler.json": [
    "573493",
    [
      49407
    ]
  ],
  "./hu/account_calendar_settings_account_list.json": [
    "418176",
    [
      789088
    ]
  ],
  "./fr-CA/calendar_edit.json": [
    "843976",
    [
      56796
    ]
  ],
  "./it/grade_summary.json": [
    "129407",
    [
      664145
    ]
  ],
  "./ja/speed_grader_helpers.json": [
    "488372",
    [
      483249
    ]
  ],
  "./sv-x-k12/account_calendar_settings.json": [
    "435851",
    [
      166505
    ]
  ],
  "./ca/course_pace_date_input.json": [
    "436639",
    [
      891117
    ]
  ],
  "./hy/ai_experiences_show.json": [
    "254001",
    [
      935175
    ]
  ],
  "./hy/ai_experiences.json": [
    "830443",
    [
      932617
    ]
  ],
  "./it/default_account_quotas.json": [
    "978914",
    [
      405126
    ]
  ],
  "./pl/account_settings.json": [
    "789491",
    [
      900469
    ]
  ],
  "./nb/pseudonyms_mobile_login.json": [
    "537310",
    [
      922642
    ]
  ],
  "./fa/blueprint_settingsCoursePickerTable.json": [
    "908813",
    [
      695915
    ]
  ],
  "./da/gradebookActionMenu.json": [
    "267410",
    [
      48282
    ]
  ],
  "./en-GB-x-lbs/ai_experiences_ai_conversations.json": [
    "784684",
    [
      285484
    ]
  ],
  "./fi/choose_mastery_path.json": [
    "131132",
    [
      156396
    ]
  ],
  "./hi/modules_home_page.json": [
    "644960",
    [
      682680
    ]
  ],
  "./id/account_calendar_settings_account_group.json": [
    "815389",
    [
      186655
    ]
  ],
  "./ko/blueprint_course_sidebar.json": [
    "873850",
    [
      30098
    ]
  ],
  "./hy/course_paces_projected_dates.json": [
    "654464",
    [
      302600
    ]
  ],
  "./pl/pseudonyms_mobile_login.json": [
    "756366",
    [
      251586
    ]
  ],
  "./vi/roster_section_selector.json": [
    "486186",
    [
      59642
    ]
  ],
  "./mi/assignments_2_student_content_rubric_self_assessment.json": [
    "77205",
    [
      226299
    ]
  ],
  "./ga/blueprint_settingsMigrationSync.json": [
    "826666",
    [
      231178
    ]
  ],
  "./ar/discussion_row.json": [
    "876672",
    [
      43940
    ]
  ],
  "./es/assignments_2_submission_histories_query.json": [
    "78490",
    [
      449619
    ]
  ],
  "./en-AU-x-unimelb/discussion_pinned_post.json": [
    "912420",
    [
      156544
    ]
  ],
  "./es/discussion_settings.json": [
    "912798",
    [
      844143
    ]
  ],
  "./th/epub_exports.json": [
    "662908",
    [
      708496
    ]
  ],
  "./es-ES/dashboard.json": [
    "8979",
    [
      619713
    ]
  ],
  "./mi/assignments_2_student_header.json": [
    "212861",
    [
      360723
    ]
  ],
  "./he/SpeedGraderCheckpoints.json": [
    "209368",
    [
      169896
    ]
  ],
  "./hi/user_search_results.json": [
    "537980",
    [
      235260
    ]
  ],
  "./fr/user_lists.json": [
    "481755",
    [
      919322
    ]
  ],
  "./de/knowledge_check_not_ready.json": [
    "928192",
    [
      701357
    ]
  ],
  "./de/theme_collection_view.json": [
    "477059",
    [
      380854
    ]
  ],
  "./es/admin_split.json": [
    "291558",
    [
      823863
    ]
  ],
  "./it/dashboard_grades_page.json": [
    "860714",
    [
      901582
    ]
  ],
  "./en-AU-x-unimelb/account_calendars.json": [
    "637245",
    [
      77031
    ]
  ],
  "./he/progressbar_view.json": [
    "67691",
    [
      171825
    ]
  ],
  "./pt-BR/assignments_2_shared_Steps.json": [
    "349203",
    [
      843709
    ]
  ],
  "./nn/new_nav.json": [
    "920654",
    [
      30490
    ]
  ],
  "./ko/a2LatePolicyStatusDisplay.json": [
    "372011",
    [
      81153
    ]
  ],
  "./da-x-k12/OutcomeMoveModal.json": [
    "52343",
    [
      852809
    ]
  ],
  "./en-GB-x-ukhe/dashboard_grading_period_select.json": [
    "920138",
    [
      391386
    ]
  ],
  "./hy/calendar.header.json": [
    "754596",
    [
      7687
    ]
  ],
  "./nn/empty_modules.json": [
    "734977",
    [
      568427
    ]
  ],
  "./nn/gradebook.json": [
    "661884",
    [
      943400
    ]
  ],
  "./ar/SpeedGraderPostGradesMenu.json": [
    "227116",
    [
      829440
    ]
  ],
  "./pt/quizzes.take_quiz.json": [
    "261436",
    [
      189069
    ]
  ],
  "./fa/AccountsTray.json": [
    "467769",
    [
      351631
    ]
  ],
  "./da-x-k12/assignments_peer_reviews_student.json": [
    "225744",
    [
      50476
    ]
  ],
  "./nb/content_exports.json": [
    "364083",
    [
      785021
    ]
  ],
  "./da-x-k12/account_calendar_settings_account_list.json": [
    "137338",
    [
      82798
    ]
  ],
  "./pt-BR/grades_summary.json": [
    "711806",
    [
      858935
    ]
  ],
  "./ar/course_paces_blackout_dates_table.json": [
    "259326",
    [
      234546
    ]
  ],
  "./da/account_calendar_settings_confirmation_modal.json": [
    "792815",
    [
      382749
    ]
  ],
  "./fi/assignments_2_peer_review.json": [
    "908734",
    [
      998838
    ]
  ],
  "./es-ES/assignments_2_text_entry.json": [
    "526881",
    [
      357895
    ]
  ],
  "./es/roster_section_selector.json": [
    "116871",
    [
      835258
    ]
  ],
  "./th/paginated_list.json": [
    "630678",
    [
      973330
    ]
  ],
  "./ko/context_roster_user_services.json": [
    "534116",
    [
      594156
    ]
  ],
  "./ms/learning_mastery_gradebook.json": [
    "888359",
    [
      291765
    ]
  ],
  "./nl/important_dates_empty.json": [
    "798998",
    [
      640013
    ]
  ],
  "./da/course_paces_pace_picker.json": [
    "843104",
    [
      470864
    ]
  ],
  "./en-GB-x-lbs/content_exports.json": [
    "844313",
    [
      57135
    ]
  ],
  "./sv/assignments_2_student_content.json": [
    "705938",
    [
      791766
    ]
  ],
  "./ko/calendar_sidebar.json": [
    "811737",
    [
      407031
    ]
  ],
  "./en-GB/user_lists.json": [
    "378408",
    [
      211585
    ]
  ],
  "./sv/peer_review_allocation_rule_card.json": [
    "721671",
    [
      20017
    ]
  ],
  "./ms/link_validator.json": [
    "4971",
    [
      113201
    ]
  ],
  "./en-GB-x-ukhe/files_v2.json": [
    "972080",
    [
      580248
    ]
  ],
  "./en/unpublished_changes_button_props.json": [
    "901864",
    [
      195212
    ]
  ],
  "./sv-x-k12/wiki_page_index.json": [
    "737284",
    [
      668628
    ]
  ],
  "./en-GB/lti_registration.wizard.json": [
    "998497",
    [
      29444
    ]
  ],
  "./ca/assignments_2_MoreOptions_CanvasFiles.json": [
    "280579",
    [
      383753
    ]
  ],
  "./he/course_paces_modal.json": [
    "87647",
    [
      609469
    ]
  ],
  "./hu/ai_experiences_edit.json": [
    "309540",
    [
      174844
    ]
  ],
  "./fi/edit_section_view.json": [
    "859799",
    [
      282973
    ]
  ],
  "./mi/media_player_iframe_content.json": [
    "408011",
    [
      392030
    ]
  ],
  "./nb-x-k12/files_v2.json": [
    "131940",
    [
      676324
    ]
  ],
  "./de/peer_review_allocation_rule_card.json": [
    "182541",
    [
      27740
    ]
  ],
  "./ca/remove_pace_warning_modal.json": [
    "387497",
    [
      969127
    ]
  ],
  "./ca/ProfileTray.json": [
    "123755",
    [
      340577
    ]
  ],
  "./ja/assignmentsIndexView.json": [
    "560442",
    [
      491427
    ]
  ],
  "./ca/notebook.json": [
    "497259",
    [
      860577
    ]
  ],
  "./fa/course_paces_errors.json": [
    "848835",
    [
      65153
    ]
  ],
  "./en-GB/grade_change_logging_content.json": [
    "454841",
    [
      63948
    ]
  ],
  "./fi/course_template_details.json": [
    "292262",
    [
      643838
    ]
  ],
  "./fr/courses.show.json": [
    "340027",
    [
      615090
    ]
  ],
  "./nb/new_user_tutorial.json": [
    "406177",
    [
      284019
    ]
  ],
  "./en-GB-x-lbs/appointment_groups.json": [
    "552402",
    [
      815378
    ]
  ],
  "./nb/account_calendars.json": [
    "758453",
    [
      446679
    ]
  ],
  "./es-ES/gradebook_uploads.json": [
    "913796",
    [
      353588
    ]
  ],
  "./hi/rootFoldersFinder.json": [
    "37228",
    [
      167468
    ]
  ],
  "./da-x-k12/video_conference.json": [
    "821579",
    [
      956901
    ]
  ],
  "./tr/blueprint_settingsUnsyncedChanges.json": [
    "421653",
    [
      887031
    ]
  ],
  "./ms/roster_section_selector.json": [
    "80495",
    [
      508749
    ]
  ],
  "./fr/course_paces_settings.json": [
    "295468",
    [
      280885
    ]
  ],
  "./el/course_paces_errors.json": [
    "360919",
    [
      540409
    ]
  ],
  "./nb/assignment_grade_summary.json": [
    "265776",
    [
      415212
    ]
  ],
  "./it/user_restore.json": [
    "438903",
    [
      489937
    ]
  ],
  "./nn/calculator.json": [
    "20914",
    [
      951046
    ]
  ],
  "./ca/course_paces_time_selection.json": [
    "980593",
    [
      748735
    ]
  ],
  "./en-AU-x-unimelb/self_unenrollment_modal.json": [
    "311932",
    [
      801104
    ]
  ],
  "./de/conversations_2.json": [
    "144664",
    [
      214885
    ]
  ],
  "./es/GroupsTray.json": [
    "881306",
    [
      642067
    ]
  ],
  "./ga/assignment_show.json": [
    "585105",
    [
      545831
    ]
  ],
  "./pl/assignments_2_submission_histories_query.json": [
    "413882",
    [
      843622
    ]
  ],
  "./ms/assignments_2_login_action_prompt.json": [
    "638921",
    [
      493687
    ]
  ],
  "./ms/jobs_v2.json": [
    "361035",
    [
      762673
    ]
  ],
  "./nl/restore_content_pane.json": [
    "13155",
    [
      233389
    ]
  ],
  "./es/terms_index.json": [
    "637002",
    [
      657763
    ]
  ],
  "./fr/grade_details.json": [
    "691212",
    [
      295149
    ]
  ],
  "./pt/course_paces_blackout_dates_table.json": [
    "626725",
    [
      123631
    ]
  ],
  "./de/account_calendars.json": [
    "542430",
    [
      229079
    ]
  ],
  "./zh-Hant/filter_calendars_modal.json": [
    "69212",
    [
      675888
    ]
  ],
  "./ht/AccountsTray.json": [
    "940346",
    [
      547414
    ]
  ],
  "./fr-CA/SpeedGraderSettingsMenu.json": [
    "396477",
    [
      176975
    ]
  ],
  "./vi/a2_AccessibleTipContent.json": [
    "820603",
    [
      591705
    ]
  ],
  "./ja/quiz_migration_notifications.json": [
    "178656",
    [
      149349
    ]
  ],
  "./ru/content_copy_redesign.json": [
    "604676",
    [
      819748
    ]
  ],
  "./fi/account_calendar_settings_confirmation_modal.json": [
    "822561",
    [
      275735
    ]
  ],
  "./nb-x-k12/account_calendar_settings_filter_controls.json": [
    "270612",
    [
      984628
    ]
  ],
  "./ga/modules_home_page.json": [
    "419087",
    [
      881685
    ]
  ],
  "./nn/ai_experiences_edit.json": [
    "959811",
    [
      126085
    ]
  ],
  "./pl/CreateEditAssignmentModal.json": [
    "650600",
    [
      679884
    ]
  ],
  "./th/available_pronouns_list.json": [
    "512319",
    [
      236777
    ]
  ],
  "./es-ES/rubrics-export.json": [
    "306122",
    [
      58362
    ]
  ],
  "./uk/calendar_appointment_group_edit.json": [
    "386587",
    [
      44433
    ]
  ],
  "./fi/group_submission_reminder.json": [
    "405416",
    [
      798576
    ]
  ],
  "./th/security_panel.json": [
    "740397",
    [
      330711
    ]
  ],
  "./hi/upload_button.json": [
    "116575",
    [
      865637
    ]
  ],
  "./cy/assignments_2_text_entry.json": [
    "377046",
    [
      637334
    ]
  ],
  "./pl/canvas_file_upload.json": [
    "10587",
    [
      548341
    ]
  ],
  "./cy/auth_logging.json": [
    "821298",
    [
      554634
    ]
  ],
  "./pt-BR/manage_avatars.json": [
    "679731",
    [
      662326
    ]
  ],
  "./is/appt_calendar_event_dialog.json": [
    "700658",
    [
      841874
    ]
  ],
  "./vi/NewTabIndicator.json": [
    "279149",
    [
      67963
    ]
  ],
  "./el/assignments_bulk_edit.json": [
    "419611",
    [
      611549
    ]
  ],
  "./nl/module_sequence_footer.json": [
    "566262",
    [
      735242
    ]
  ],
  "./hy/gradebook_uploads.json": [
    "456626",
    [
      291234
    ]
  ],
  "./ja/course_paces_search.json": [
    "646412",
    [
      723401
    ]
  ],
  "./ms/wiki_page_index.json": [
    "872275",
    [
      560617
    ]
  ],
  "./en-AU-x-unimelb/permissions_v2.json": [
    "786155",
    [
      536405
    ]
  ],
  "./it/user_search_results.json": [
    "173834",
    [
      800150
    ]
  ],
  "./tr/password_complexity_configuration.json": [
    "812515",
    [
      660077
    ]
  ],
  "./es/auth_logging.json": [
    "264354",
    [
      253979
    ]
  ],
  "./fa/webcam_modal.json": [
    "276026",
    [
      907946
    ]
  ],
  "./fr-CA/use_switch_experience.json": [
    "273286",
    [
      318402
    ]
  ],
  "./da-x-k12/assignments_2_submission_histories_query.json": [
    "229349",
    [
      203431
    ]
  ],
  "./fr-CA/user_date_range_search.json": [
    "463322",
    [
      618318
    ]
  ],
  "./hu/assignments_2_MoreOptions.json": [
    "119140",
    [
      884412
    ]
  ],
  "./ms/blueprint_settingsUnsyncedChanges.json": [
    "933347",
    [
      416697
    ]
  ],
  "./pt/change_password.json": [
    "294518",
    [
      240210
    ]
  ],
  "./da-x-k12/mutationActivity.json": [
    "99099",
    [
      290685
    ]
  ],
  "./vi/account_calendar_settings.json": [
    "621589",
    [
      437859
    ]
  ],
  "./pt/assignments_bulk_edit_use_save_assignment.json": [
    "374266",
    [
      866326
    ]
  ],
  "./ht/admin_split.json": [
    "258454",
    [
      758074
    ]
  ],
  "./ko/course_paces_blackout_dates_modal.json": [
    "16622",
    [
      158894
    ]
  ],
  "./hu/account_calendars_modal.json": [
    "548940",
    [
      236564
    ]
  ],
  "./da/empty_course.json": [
    "788272",
    [
      336160
    ]
  ],
  "./nb/gradebook_default_gradebook_components_content_filters_module_filter.json": [
    "747334",
    [
      186754
    ]
  ],
  "./vi/discussion_create.json": [
    "394730",
    [
      794282
    ]
  ],
  "./he/assignments_2_media_attempt.json": [
    "502599",
    [
      693141
    ]
  ],
  "./nb-x-k12/error_form.json": [
    "737441",
    [
      478679
    ]
  ],
  "./en/sharedCurveGradesDialog.json": [
    "540385",
    [
      392971
    ]
  ],
  "./es/choose_mastery_path.json": [
    "358925",
    [
      160532
    ]
  ],
  "./pl/blueprint_course_sidebar.json": [
    "431824",
    [
      307900
    ]
  ],
  "./el/password_complexity_configuration.json": [
    "124332",
    [
      720904
    ]
  ],
  "./nn/blueprint_settingsCoursePickerTable.json": [
    "665772",
    [
      89792
    ]
  ],
  "./tr/terms_of_use.json": [
    "182665",
    [
      113851
    ]
  ],
  "./ko/custom_help_link.json": [
    "438704",
    [
      223200
    ]
  ],
  "./hi/discussion_row.json": [
    "515728",
    [
      545848
    ]
  ],
  "./he/assignmentsToggleShowByView.json": [
    "490370",
    [
      562746
    ]
  ],
  "./zh-Hant/theme_collection_view.json": [
    "797974",
    [
      77050
    ]
  ],
  "./id/dashboard.json": [
    "803827",
    [
      454429
    ]
  ],
  "./fr/available_pronouns_list.json": [
    "765279",
    [
      247278
    ]
  ],
  "./ms/notebook.json": [
    "221227",
    [
      635089
    ]
  ],
  "./en/conversations_2.json": [
    "971504",
    [
      891116
    ]
  ],
  "./pl/sis_import.json": [
    "710769",
    [
      239595
    ]
  ],
  "./pt/conferences.json": [
    "929657",
    [
      456483
    ]
  ],
  "./tr/discussion_topics_edit.json": [
    "252602",
    [
      797990
    ]
  ],
  "./ja/outcomes_user_outcome_results.json": [
    "733904",
    [
      752981
    ]
  ],
  "./ca/assignments_2_student_annotation.json": [
    "651323",
    [
      235185
    ]
  ],
  "./nn/assignment_show.json": [
    "783057",
    [
      632387
    ]
  ],
  "./is/reset_pace_warning_modal.json": [
    "850856",
    [
      871360
    ]
  ],
  "./pt-BR/terms_index.json": [
    "488124",
    [
      671146
    ]
  ],
  "./es-ES/peer_review_allocation_rule_card.json": [
    "226003",
    [
      910769
    ]
  ],
  "./zh-Hant/password_complexity_configuration.json": [
    "285187",
    [
      657853
    ]
  ],
  "./uk/course_paces_projected_dates.json": [
    "636053",
    [
      628555
    ]
  ],
  "./nb-x-k12/pairing_code_user_observees.json": [
    "674893",
    [
      593803
    ]
  ],
  "./ca/announcements_on_home_page.json": [
    "336002",
    [
      993194
    ]
  ],
  "./ja/user_profile.json": [
    "268420",
    [
      341057
    ]
  ],
  "./el/users.json": [
    "226495",
    [
      538577
    ]
  ],
  "./tr/quizzes_public.json": [
    "122035",
    [
      90829
    ]
  ],
  "./en-CA/blueprint_settingsCoursePickerTable.json": [
    "20459",
    [
      507824
    ]
  ],
  "./fa/progressbar_view.json": [
    "24733",
    [
      338203
    ]
  ],
  "./cy/course_restore.json": [
    "934966",
    [
      602422
    ]
  ],
  "./fi/OutcomeMoveModal.json": [
    "425691",
    [
      656377
    ]
  ],
  "./es/self_enrollment.json": [
    "182101",
    [
      77340
    ]
  ],
  "./hu/GroupsTray.json": [
    "355063",
    [
      501253
    ]
  ],
  "./ru/ProfileTray.json": [
    "797278",
    [
      964953
    ]
  ],
  "./vi/AssignmentGroupListItemView.json": [
    "325129",
    [
      236159
    ]
  ],
  "./ar/peer_review_student_select.json": [
    "771677",
    [
      525175
    ]
  ],
  "./mi/course_paces_projected_dates.json": [
    "654843",
    [
      734849
    ]
  ],
  "./fa/course_stats.json": [
    "36564",
    [
      907364
    ]
  ],
  "./nn/account_calendars.json": [
    "513529",
    [
      66203
    ]
  ],
  "./hy/peer_review_allocation_rules_tray.json": [
    "934740",
    [
      730132
    ]
  ],
  "./th/OutcomeMoveModal.json": [
    "41508",
    [
      109624
    ]
  ],
  "./ht/progress_pill.json": [
    "891037",
    [
      27063
    ]
  ],
  "./ja/edit_section_end_date.json": [
    "556948",
    [
      681297
    ]
  ],
  "./en-GB-x-lbs/assignment_grade_summary.json": [
    "970222",
    [
      660838
    ]
  ],
  "./ht/submissions_show_preview.json": [
    "890498",
    [
      771590
    ]
  ],
  "./es-ES/content_migrations_redesign.json": [
    "289132",
    [
      359308
    ]
  ],
  "./mi/todos_page.json": [
    "197921",
    [
      638047
    ]
  ],
  "./cy/submit_assignment.json": [
    "545882",
    [
      142882
    ]
  ],
  "./pt/assignments_2_url_entry.json": [
    "371024",
    [
      558372
    ]
  ],
  "./zh-Hans/progression_module_header.json": [
    "229969",
    [
      178503
    ]
  ],
  "./ja/grade_summary.json": [
    "835379",
    [
      323278
    ]
  ],
  "./pt-BR/peer_review_configuration_tray.json": [
    "529216",
    [
      656909
    ]
  ],
  "./zh-Hant/mutationActivity.json": [
    "214334",
    [
      66386
    ]
  ],
  "./en-CA/grade_summary.json": [
    "964982",
    [
      350046
    ]
  ],
  "./de/horizon_toggle.json": [
    "615899",
    [
      418654
    ]
  ],
  "./sv/conferences_alternatives.json": [
    "39929",
    [
      435995
    ]
  ],
  "./fr-CA/gradebook.json": [
    "447961",
    [
      431523
    ]
  ],
  "./en-GB-x-lbs/react_developer_keys.json": [
    "621727",
    [
      679893
    ]
  ],
  "./es-ES/course_paces_assignment_row.json": [
    "402286",
    [
      49542
    ]
  ],
  "./nl/quiz_show.json": [
    "305215",
    [
      443833
    ]
  ],
  "./vi/a2LatePolicyStatusDisplay.json": [
    "909267",
    [
      388456
    ]
  ],
  "./zh-Hant/comm_messages.json": [
    "578645",
    [
      337551
    ]
  ],
  "./cy/assignments_2_file_upload.json": [
    "198272",
    [
      20992
    ]
  ],
  "./en-AU-x-unimelb/CoursesTray.json": [
    "608684",
    [
      125776
    ]
  ],
  "./id/sis_import.json": [
    "502430",
    [
      55666
    ]
  ],
  "./he/edit_section_dates.json": [
    "622753",
    [
      215423
    ]
  ],
  "./sl/canvas_file_upload.json": [
    "328750",
    [
      872170
    ]
  ],
  "./en-GB-x-lbs/OutcomeMoveModal.json": [
    "857430",
    [
      333422
    ]
  ],
  "./en-AU/quizzes_index.json": [
    "813106",
    [
      932347
    ]
  ],
  "./ko/calculator_command.json": [
    "699062",
    [
      187334
    ]
  ],
  "./uk/course_navigation_settings.json": [
    "970662",
    [
      694742
    ]
  ],
  "./nb/peer_review_allocation_rules_tray.json": [
    "43083",
    [
      330037
    ]
  ],
  "./zh-Hant/permissions.json": [
    "331888",
    [
      178452
    ]
  ],
  "./ja/course_statistics.json": [
    "173706",
    [
      491251
    ]
  ],
  "./pt/module_sequence_footer.json": [
    "592228",
    [
      377640
    ]
  ],
  "./fa/quizzes_public.json": [
    "748022",
    [
      506926
    ]
  ],
  "./es-ES/progress_pill.json": [
    "420464",
    [
      775704
    ]
  ],
  "./vi/CoursesTray.json": [
    "984725",
    [
      409859
    ]
  ],
  "./es/entity_search_form.json": [
    "835177",
    [
      439192
    ]
  ],
  "./ca/assignments_2_shared_Steps.json": [
    "932923",
    [
      95281
    ]
  ],
  "./cy/announcements_v2.json": [
    "573135",
    [
      72045
    ]
  ],
  "./nn/grade_summaryGroupView.json": [
    "95031",
    [
      165816
    ]
  ],
  "./mi/a2_AccessibleTipContent.json": [
    "918448",
    [
      24592
    ]
  ],
  "./fa/assignments_2_initial_query.json": [
    "695024",
    [
      388744
    ]
  ],
  "./mi/theme_collection_view.json": [
    "678438",
    [
      802534
    ]
  ],
  "./zh-Hant/horizon_toggle.json": [
    "888972",
    [
      763296
    ]
  ],
  "./pt/edit_section_dates.json": [
    "970468",
    [
      799496
    ]
  ],
  "./it/quiz_statistics.json": [
    "420546",
    [
      457982
    ]
  ],
  "./da/important_dates.json": [
    "990253",
    [
      545107
    ]
  ],
  "./ko/module_student_view_peer_reviews.json": [
    "134587",
    [
      77649
    ]
  ],
  "./mi/assignments.json": [
    "760265",
    [
      436918
    ]
  ],
  "./nb/todos_page.json": [
    "247359",
    [
      44193
    ]
  ],
  "./en/ImportConfirmBox.json": [
    "775827",
    [
      773261
    ]
  ],
  "./it/course_pace_date_input.json": [
    "904080",
    [
      246700
    ]
  ],
  "./de/course_color_selector.json": [
    "449558",
    [
      941855
    ]
  ],
  "./th/login.json": [
    "874351",
    [
      942881
    ]
  ],
  "./es/ai_experiences_edit.json": [
    "268263",
    [
      251930
    ]
  ],
  "./en-GB/MasteryScale.json": [
    "36320",
    [
      680073
    ]
  ],
  "./hi/question_bank.json": [
    "577086",
    [
      588326
    ]
  ],
  "./da-x-k12/admin_split.json": [
    "434291",
    [
      305477
    ]
  ],
  "./hi/k5_dashboard_card.json": [
    "556327",
    [
      736189
    ]
  ],
  "./fr-CA/webzip_export.json": [
    "295599",
    [
      811921
    ]
  ],
  "./zh-Hans/use_switch_experience.json": [
    "382032",
    [
      433112
    ]
  ],
  "./el/video_conference.json": [
    "188979",
    [
      29317
    ]
  ],
  "./th/LogoutButton.json": [
    "118728",
    [
      644812
    ]
  ],
  "./tr/notebook_index.json": [
    "817414",
    [
      957122
    ]
  ],
  "./es-ES/reset_pace_warning_modal.json": [
    "177747",
    [
      443361
    ]
  ],
  "./fr-CA/paginated_list.json": [
    "249289",
    [
      348195
    ]
  ],
  "./pt-BR/discussion_topics.json": [
    "952182",
    [
      866447
    ]
  ],
  "./vi/permissions.json": [
    "269859",
    [
      742097
    ]
  ],
  "./ja/peer-review-assignment-widget.json": [
    "826193",
    [
      61155
    ]
  ],
  "./hu/DueDateOverrideView.json": [
    "94514",
    [
      609354
    ]
  ],
  "./vi/peer_review_student_select.json": [
    "443115",
    [
      981641
    ]
  ],
  "./fr/assignment_index_menu.json": [
    "636818",
    [
      310071
    ]
  ],
  "./zh-Hant/terms_of_service_modal.json": [
    "424339",
    [
      385309
    ]
  ],
  "./ht/course_paces_time_selection.json": [
    "604217",
    [
      710315
    ]
  ],
  "./de/blueprint_settingsMigrationOptions.json": [
    "129956",
    [
      188809
    ]
  ],
  "./en-AU/assignments_bulk_edit.json": [
    "379204",
    [
      266465
    ]
  ],
  "./ko/react_files.json": [
    "416671",
    [
      660941
    ]
  ],
  "./nb/remove_pace_warning_modal.json": [
    "410369",
    [
      161051
    ]
  ],
  "./ar/CreateEditAssignmentModal.json": [
    "657531",
    [
      189221
    ]
  ],
  "./fi/permission_button.json": [
    "538719",
    [
      899205
    ]
  ],
  "./it/outcome_alignment_v2.json": [
    "107446",
    [
      48090
    ]
  ],
  "./ru/manage_avatars.json": [
    "65699",
    [
      883473
    ]
  ],
  "./cy/user_logins.json": [
    "670840",
    [
      361288
    ]
  ],
  "./ga/appt_calendar_event_dialog.json": [
    "910922",
    [
      786394
    ]
  ],
  "./fr/submit_assignment.json": [
    "206258",
    [
      269183
    ]
  ],
  "./hy/content_copy_redesign.json": [
    "726782",
    [
      728406
    ]
  ],
  "./pt-BR/account_calendar_settings_account_calendar_item_dropdown.json": [
    "292486",
    [
      941628
    ]
  ],
  "./cy/assignments_2_submission_helpers.json": [
    "560212",
    [
      586092
    ]
  ],
  "./en/student_groups.json": [
    "231979",
    [
      358693
    ]
  ],
  "./fa/terms_of_use.json": [
    "588264",
    [
      867728
    ]
  ],
  "./id/roster_section_selector.json": [
    "992842",
    [
      66142
    ]
  ],
  "./fr-CA/outcome_alignment_v2.json": [
    "69034",
    [
      493182
    ]
  ],
  "./el/assignments.no_assignments_search.json": [
    "866768",
    [
      660213
    ]
  ],
  "./he/link_to_students.json": [
    "49874",
    [
      874986
    ]
  ],
  "./fr/CommentLibrary.json": [
    "564662",
    [
      238267
    ]
  ],
  "./sv-x-k12/filter_calendars_modal.json": [
    "786255",
    [
      611269
    ]
  ],
  "./nb/quizzes_public.json": [
    "315021",
    [
      959751
    ]
  ],
  "./vi/horizon_toggle.json": [
    "164425",
    [
      140319
    ]
  ],
  "./ja/a2_AccessibleTipContent.json": [
    "954351",
    [
      975218
    ]
  ],
  "./da-x-k12/user_profile.json": [
    "542220",
    [
      533280
    ]
  ],
  "./el/CreateEditAssignmentModal.json": [
    "861789",
    [
      6423
    ]
  ],
  "./ar/assignments_2_media_attempt.json": [
    "446059",
    [
      405629
    ]
  ],
  "./nb-x-k12/gradebook.json": [
    "763338",
    [
      621546
    ]
  ],
  "./sv/discussionTopicKeyboradShortcutModal.json": [
    "65554",
    [
      983598
    ]
  ],
  "./th/accessibility_scan.json": [
    "270466",
    [
      996078
    ]
  ],
  "./nl/accessibility_checker.json": [
    "26980",
    [
      752648
    ]
  ],
  "./sv-x-k12/roster_section_selector.json": [
    "67804",
    [
      811484
    ]
  ],
  "./nb-x-k12/k5_dashboard.json": [
    "270219",
    [
      955529
    ]
  ],
  "./en-GB-x-ukhe/courses.show.json": [
    "760769",
    [
      942980
    ]
  ],
  "./id/accessibility_course_statistics.json": [
    "526581",
    [
      475343
    ]
  ],
  "./hu/react_developer_keys.json": [
    "34728",
    [
      825016
    ]
  ],
  "./es-ES/context_prior_users.json": [
    "92668",
    [
      752428
    ]
  ],
  "./da/AssignmentListItemView.json": [
    "589664",
    [
      316880
    ]
  ],
  "./nb-x-k12/widget_dashboard.json": [
    "365963",
    [
      374057
    ]
  ],
  "./pt-BR/MasteryScale.json": [
    "581684",
    [
      394233
    ]
  ],
  "./sl/manage_avatars.json": [
    "247345",
    [
      655051
    ]
  ],
  "./fi/accessibility_checker.json": [
    "135975",
    [
      770781
    ]
  ],
  "./pl/gradebook_history.json": [
    "264783",
    [
      812033
    ]
  ],
  "./is/ldap_cert_upload.json": [
    "111910",
    [
      564270
    ]
  ],
  "./it/content_shares.json": [
    "740007",
    [
      841225
    ]
  ],
  "./fr/course_logging_details.json": [
    "783008",
    [
      372825
    ]
  ],
  "./ru/account_calendar_settings_account_list.json": [
    "141286",
    [
      355534
    ]
  ],
  "./tr/assignments.never_drop.json": [
    "401134",
    [
      439497
    ]
  ],
  "./cy/rootFoldersFinder.json": [
    "228427",
    [
      473105
    ]
  ],
  "./ht/external_content_cancel.json": [
    "136754",
    [
      367742
    ]
  ],
  "./en-GB-x-ukhe/wiki_page_index.json": [
    "157425",
    [
      632439
    ]
  ],
  "./en/discussion_pinned_post.json": [
    "270609",
    [
      829187
    ]
  ],
  "./pl/course_link_validator.json": [
    "124485",
    [
      796063
    ]
  ],
  "./sl/assignment_show.json": [
    "474746",
    [
      883686
    ]
  ],
  "./en-AU/assignments_2_student_header_date_title.json": [
    "761587",
    [
      381166
    ]
  ],
  "./hy/modelsQuiz.json": [
    "489324",
    [
      806988
    ]
  ],
  "./pt-BR/assignments_2_student_header.json": [
    "283496",
    [
      552418
    ]
  ],
  "./fi/webcam_modal.json": [
    "354066",
    [
      250066
    ]
  ],
  "./fr/suppress_notifications.json": [
    "615118",
    [
      119499
    ]
  ],
  "./en-GB-x-lbs/blueprint_settingsCoursePickerTable.json": [
    "174662",
    [
      467182
    ]
  ],
  "./en-AU-x-unimelb/IndividualStudentMasteryOutcome.json": [
    "459059",
    [
      706733
    ]
  ],
  "./sv/file_not_found.json": [
    "977610",
    [
      899590
    ]
  ],
  "./pl/enhanced_individual_gradebook_submit_score.json": [
    "753141",
    [
      684463
    ]
  ],
  "./vi/auth_logging.json": [
    "703245",
    [
      620091
    ]
  ],
  "./id/change_password.json": [
    "537027",
    [
      584733
    ]
  ],
  "./th/outcome_management.json": [
    "728224",
    [
      213588
    ]
  ],
  "./it/course_paces_actions.json": [
    "736351",
    [
      461977
    ]
  ],
  "./en-AU/student_groups.json": [
    "713352",
    [
      125197
    ]
  ],
  "./hi/assignment_index_deep_linking_handlers.json": [
    "260601",
    [
      783535
    ]
  ],
  "./fr-CA/progressbar_view.json": [
    "831345",
    [
      471923
    ]
  ],
  "./da-x-k12/question_banks.json": [
    "129833",
    [
      242883
    ]
  ],
  "./fr/ignite_agent.json": [
    "928670",
    [
      477283
    ]
  ],
  "./ko/error_form.json": [
    "754973",
    [
      458435
    ]
  ],
  "./nl/roster_publicjs.json": [
    "523814",
    [
      983634
    ]
  ],
  "./pl/assignments_2_peer_review.json": [
    "428759",
    [
      43681
    ]
  ],
  "./zh-Hant/AssignmentGroupListItemView.json": [
    "248738",
    [
      711846
    ]
  ],
  "./cy/dashboard.json": [
    "324774",
    [
      227974
    ]
  ],
  "./hu/accessibility_scan.json": [
    "167483",
    [
      155681
    ]
  ],
  "./nn/discussion_topics_edit.json": [
    "924388",
    [
      102392
    ]
  ],
  "./pl/content_shares.json": [
    "340308",
    [
      289352
    ]
  ],
  "./vi/accessibility_checker.json": [
    "103383",
    [
      679578
    ]
  ],
  "./en-AU-x-unimelb/files_v2.json": [
    "608778",
    [
      660990
    ]
  ],
  "./id/custom_emoji_deny_list.json": [
    "920383",
    [
      581913
    ]
  ],
  "./da/submit_online_url_assignment.json": [
    "267695",
    [
      826141
    ]
  ],
  "./vi/assignments_2_student_header.json": [
    "359131",
    [
      405376
    ]
  ],
  "./mi/user_grades.json": [
    "224564",
    [
      847084
    ]
  ],
  "./uk/DueDateOverrideView.json": [
    "218961",
    [
      227871
    ]
  ],
  "./he/course_paces_settings.json": [
    "664371",
    [
      131241
    ]
  ],
  "./tr/gradebook_default_gradebook_components_content_filters_module_filter.json": [
    "333044",
    [
      397256
    ]
  ],
  "./en-AU/license_help.json": [
    "170032",
    [
      875838
    ]
  ],
  "./sv/account_notification_settings.json": [
    "153290",
    [
      100278
    ]
  ],
  "./ja/LogoutButton.json": [
    "334127",
    [
      21106
    ]
  ],
  "./is/quiz_statistics.json": [
    "357023",
    [
      584885
    ]
  ],
  "./zh-Hant/course_paces_settings.json": [
    "521702",
    [
      961794
    ]
  ],
  "./ar/quiz_migration_notifications.json": [
    "7666",
    [
      377310
    ]
  ],
  "./is/permissions_v2_add_tray.json": [
    "280228",
    [
      298759
    ]
  ],
  "./zh-Hant/SpeedGraderSettingsMenu.json": [
    "123006",
    [
      488234
    ]
  ],
  "./he/ai_experiences_ai_conversations.json": [
    "269193",
    [
      75927
    ]
  ],
  "./en/todo.json": [
    "326431",
    [
      279905
    ]
  ],
  "./hy/grade_details.json": [
    "902767",
    [
      911989
    ]
  ],
  "./nl/MasteryScale.json": [
    "379637",
    [
      599735
    ]
  ],
  "./hu/peer-review-assignment-widget.json": [
    "896431",
    [
      235917
    ]
  ],
  "./nb-x-k12/comm_messages.json": [
    "916509",
    [
      765483
    ]
  ],
  "./da/context_modules_v2.json": [
    "490269",
    [
      73283
    ]
  ],
  "./ca/important_dates_empty.json": [
    "620456",
    [
      20072
    ]
  ],
  "./mi/question_banks.json": [
    "759084",
    [
      641428
    ]
  ],
  "./fr-CA/todo.json": [
    "596549",
    [
      828375
    ]
  ],
  "./is/authentication_providers.json": [
    "621239",
    [
      182189
    ]
  ],
  "./ar/assignmentsToggleShowByView.json": [
    "709430",
    [
      115490
    ]
  ],
  "./fi/jobs.json": [
    "118969",
    [
      563711
    ]
  ],
  "./hi/link_to_students.json": [
    "617094",
    [
      145710
    ]
  ],
  "./hi/account_settings_jsx_bundle.json": [
    "67085",
    [
      582123
    ]
  ],
  "./pt-BR/auth_logging.json": [
    "835629",
    [
      273596
    ]
  ],
  "./en-AU-x-unimelb/roster_section_input.json": [
    "286442",
    [
      661638
    ]
  ],
  "./zh-Hant/account_notification_settings.json": [
    "312101",
    [
      513631
    ]
  ],
  "./nb/moderate_quiz.json": [
    "72713",
    [
      934459
    ]
  ],
  "./ca/CourseAvailabilityOptions.json": [
    "92514",
    [
      780170
    ]
  ],
  "./cy/course_paces_time_selection.json": [
    "701657",
    [
      272999
    ]
  ],
  "./da-x-k12/outcome_management.json": [
    "309979",
    [
      696701
    ]
  ],
  "./da-x-k12/ai_experiences.json": [
    "524557",
    [
      654535
    ]
  ],
  "./th/course_navigation_settings.json": [
    "266262",
    [
      865202
    ]
  ],
  "./zh-Hant/assignments_2_attempt_tab.json": [
    "64445",
    [
      619263
    ]
  ],
  "./sv-x-k12/rate_limiting_settings.json": [
    "46133",
    [
      587747
    ]
  ],
  "./nb/upload_button.json": [
    "956284",
    [
      288792
    ]
  ],
  "./th/content_copy_redesign.json": [
    "628305",
    [
      867715
    ]
  ],
  "./de/auth_logging.json": [
    "36331",
    [
      321438
    ]
  ],
  "./en/blueprint_settingsSyncChange.json": [
    "180797",
    [
      653119
    ]
  ],
  "./hi/terms_of_service_modal.json": [
    "325696",
    [
      442680
    ]
  ],
  "./it/edit_section_end_date.json": [
    "564840",
    [
      709460
    ]
  ],
  "./hu/pseudonyms_mobile_login.json": [
    "961661",
    [
      5811
    ]
  ],
  "./ga/assignments_2_initial_query.json": [
    "794185",
    [
      156719
    ]
  ],
  "./nb/roster_section_input.json": [
    "881154",
    [
      130454
    ]
  ],
  "./da/courses.json": [
    "707903",
    [
      860909
    ]
  ],
  "./zh-Hant/lti_registrations.json": [
    "594714",
    [
      762654
    ]
  ],
  "./es/todos_page.json": [
    "242620",
    [
      48834
    ]
  ],
  "./ja/edit_section_view.json": [
    "253779",
    [
      424302
    ]
  ],
  "./en-GB-x-lbs/dashboard_grading_period_select.json": [
    "91330",
    [
      65730
    ]
  ],
  "./fr/pairing_code_user_observees.json": [
    "933075",
    [
      993450
    ]
  ],
  "./ar/discussion_settings.json": [
    "614925",
    [
      765159
    ]
  ],
  "./ja/blueprint_settingsSyncChange.json": [
    "777107",
    [
      595502
    ]
  ],
  "./ga/context_prior_users.json": [
    "159389",
    [
      973259
    ]
  ],
  "./pt-BR/quiz_statistics.json": [
    "29426",
    [
      10611
    ]
  ],
  "./pl/appt_calendar_event_dialog.json": [
    "94686",
    [
      396850
    ]
  ],
  "./nn/rate_limiting_settings.json": [
    "290608",
    [
      667572
    ]
  ],
  "./zh-Hant/sharedSetDefaultGradeDialog.json": [
    "207891",
    [
      54117
    ]
  ],
  "./mi/rate_limiting_settings.json": [
    "801686",
    [
      481174
    ]
  ],
  "./is/blueprint_course_sidebar.json": [
    "584332",
    [
      854812
    ]
  ],
  "./sv-x-k12/AccountsTray.json": [
    "755711",
    [
      501973
    ]
  ],
  "./ms/student_entries.json": [
    "807758",
    [
      779102
    ]
  ],
  "./ht/gradebookOutcomeGradebookView.json": [
    "630551",
    [
      626705
    ]
  ],
  "./hu/course_logging_details.json": [
    "293053",
    [
      68499
    ]
  ],
  "./is/k5_dashboard.json": [
    "906953",
    [
      947023
    ]
  ],
  "./fr-CA/account_calendar_settings_account_tree.json": [
    "114458",
    [
      316078
    ]
  ],
  "./en-AU-x-unimelb/terms_of_use.json": [
    "554783",
    [
      918281
    ]
  ],
  "./th/MobileNavigation.json": [
    "604026",
    [
      71214
    ]
  ],
  "./en-GB-x-lbs/quizzes_regrade_modal.json": [
    "197340",
    [
      777164
    ]
  ],
  "./sl/course_paces_empty_state.json": [
    "874689",
    [
      987483
    ]
  ],
  "./fi/assignment_index.json": [
    "551019",
    [
      271273
    ]
  ],
  "./it/a2LatePolicyStatusDisplay.json": [
    "98416",
    [
      607756
    ]
  ],
  "./cy/custom_emoji_deny_list.json": [
    "777932",
    [
      521140
    ]
  ],
  "./hu/CommentLibrary.json": [
    "800791",
    [
      412485
    ]
  ],
  "./nl/account_settings.json": [
    "108905",
    [
      989867
    ]
  ],
  "./sl/course_paces_time_selection.json": [
    "766982",
    [
      289426
    ]
  ],
  "./tr/calendar_sidebar.json": [
    "893725",
    [
      887815
    ]
  ],
  "./zh-Hant/account_calendars_results_area.json": [
    "368102",
    [
      135266
    ]
  ],
  "./zh-Hant/quizzes_quiz_submission.json": [
    "308516",
    [
      459352
    ]
  ],
  "./hi/user.json": [
    "305100",
    [
      481852
    ]
  ],
  "./de/sharedSetDefaultGradeDialog.json": [
    "350154",
    [
      903403
    ]
  ],
  "./ar/account_settings.json": [
    "979438",
    [
      920794
    ]
  ],
  "./it/lti_registrations.json": [
    "446865",
    [
      718339
    ]
  ],
  "./zh-Hans/assignment_show.json": [
    "164394",
    [
      417210
    ]
  ],
  "./en-GB-x-lbs/user_profile.json": [
    "314909",
    [
      904811
    ]
  ],
  "./mi/gradebook_uploads.json": [
    "906855",
    [
      806933
    ]
  ],
  "./es-ES/MoveOutcomesModal.json": [
    "363614",
    [
      775046
    ]
  ],
  "./es-ES/internal-settings.json": [
    "257558",
    [
      975614
    ]
  ],
  "./fr-CA/CourseAvailabilityOptions.json": [
    "257683",
    [
      320037
    ]
  ],
  "./hi/quiz_show.json": [
    "590110",
    [
      304662
    ]
  ],
  "./ht/quizzes_openModerateStudentDialog.json": [
    "221716",
    [
      902048
    ]
  ],
  "./hy/assignment_grade_summary.json": [
    "849225",
    [
      494191
    ]
  ],
  "./zh-Hans/user_profile.json": [
    "282966",
    [
      583902
    ]
  ],
  "./ar/user_name.json": [
    "542006",
    [
      118906
    ]
  ],
  "./es-ES/MobileNavigation.json": [
    "420501",
    [
      260851
    ]
  ],
  "./el/paginated_list.json": [
    "83785",
    [
      827107
    ]
  ],
  "./sl/course_paces_projected_dates.json": [
    "37352",
    [
      10244
    ]
  ],
  "./it/peer-review-assignment-widget.json": [
    "292373",
    [
      783079
    ]
  ],
  "./sv-x-k12/license_help.json": [
    "518984",
    [
      874560
    ]
  ],
  "./nb-x-k12/course_paces_blackout_date_row.json": [
    "283656",
    [
      367360
    ]
  ],
  "./pt-BR/gradingGradeSummary.json": [
    "493178",
    [
      39963
    ]
  ],
  "./en-GB-x-lbs/assignments_bulk_edit.json": [
    "150800",
    [
      533576
    ]
  ],
  "./th/NewTabIndicator.json": [
    "202144",
    [
      748164
    ]
  ],
  "./fr/confirmMasteryModal.json": [
    "912052",
    [
      537405
    ]
  ],
  "./zh-Hans/entity_search_form.json": [
    "740940",
    [
      295292
    ]
  ],
  "./ru/blueprint_settingsCoursePickerTable.json": [
    "825989",
    [
      903683
    ]
  ],
  "./pt/peer_review_allocation_rules_tray.json": [
    "807427",
    [
      940541
    ]
  ],
  "./pt-BR/CommentLibrary.json": [
    "202629",
    [
      898564
    ]
  ],
  "./fi/course_paces_footer.json": [
    "89543",
    [
      811629
    ]
  ],
  "./sv-x-k12/course_paces_change_tracking.json": [
    "608562",
    [
      190978
    ]
  ],
  "./da-x-k12/change_password.json": [
    "983279",
    [
      112449
    ]
  ],
  "./sv-x-k12/k5_dashboard.json": [
    "737216",
    [
      985960
    ]
  ],
  "./tr/course_color_selector.json": [
    "639283",
    [
      364245
    ]
  ],
  "./uk/assignments_2_file_upload.json": [
    "975368",
    [
      138696
    ]
  ],
  "./he/notebook.json": [
    "559794",
    [
      816746
    ]
  ],
  "./da-x-k12/content_exports.json": [
    "193418",
    [
      461406
    ]
  ],
  "./da/gradingGradeSummary.json": [
    "116496",
    [
      161216
    ]
  ],
  "./da-x-k12/important_dates_empty.json": [
    "690269",
    [
      572983
    ]
  ],
  "./fa/conferences_alternatives.json": [
    "588453",
    [
      407603
    ]
  ],
  "./nb/course_paces_assignment_row.json": [
    "34687",
    [
      56393
    ]
  ],
  "./fr-CA/appt_calendar_event_dialog.json": [
    "401049",
    [
      655195
    ]
  ],
  "./fr/course_default_due_time.json": [
    "907464",
    [
      977857
    ]
  ],
  "./id/progressbar_view.json": [
    "226213",
    [
      912023
    ]
  ],
  "./mi/registration.json": [
    "726641",
    [
      107471
    ]
  ],
  "./ru/content_migrations.json": [
    "813218",
    [
      808018
    ]
  ],
  "./da-x-k12/HelpTray.json": [
    "395670",
    [
      399826
    ]
  ],
  "./hu/content_share_preview_overlay.json": [
    "835388",
    [
      573316
    ]
  ],
  "./ru/copy_warnings_modal.json": [
    "232746",
    [
      314666
    ]
  ],
  "./uk/SpeedGraderCheckpoints.json": [
    "999001",
    [
      653783
    ]
  ],
  "./nb/assignments_2_external_tool.json": [
    "117676",
    [
      664040
    ]
  ],
  "./el/calendar_edit.json": [
    "663304",
    [
      380124
    ]
  ],
  "./sv-x-k12/blueprint_settingsMigrationSync.json": [
    "804405",
    [
      283075
    ]
  ],
  "./uk/webzip_export.json": [
    "325390",
    [
      895470
    ]
  ],
  "./en-GB-x-ukhe/manage_avatars.json": [
    "445554",
    [
      421362
    ]
  ],
  "./vi/filter_calendars_modal.json": [
    "289325",
    [
      109291
    ]
  ],
  "./el/roster_publicjs.json": [
    "501873",
    [
      821971
    ]
  ],
  "./zh-Hant/peer_review_student_select.json": [
    "264742",
    [
      23146
    ]
  ],
  "./ja/CommentLibrary.json": [
    "70721",
    [
      225664
    ]
  ],
  "./is/OutcomeMoveModal.json": [
    "626792",
    [
      427632
    ]
  ],
  "./vi/sharedCurveGradesDialog.json": [
    "12367",
    [
      250677
    ]
  ],
  "./th/assignments_2_text_entry.json": [
    "52782",
    [
      159634
    ]
  ],
  "./he/notebook_index.json": [
    "930837",
    [
      586459
    ]
  ],
  "./en-AU/LearningMasteryGradebook.json": [
    "470631",
    [
      843914
    ]
  ],
  "./ht/content_migrations_redesign.json": [
    "432609",
    [
      950035
    ]
  ],
  "./fa/discussion_posts.json": [
    "288961",
    [
      947223
    ]
  ],
  "./hu/course_paces_modal.json": [
    "261455",
    [
      812717
    ]
  ],
  "./is/job_stats.json": [
    "684269",
    [
      19643
    ]
  ],
  "./mi/content_copy_redesign.json": [
    "860595",
    [
      870281
    ]
  ],
  "./da/paginated_list.json": [
    "676159",
    [
      387373
    ]
  ],
  "./fa/AddGroup.json": [
    "393847",
    [
      923597
    ]
  ],
  "./fr-CA/calendar_custom_recurring_event_natural_language.json": [
    "265449",
    [
      665123
    ]
  ],
  "./nl/SpeedGraderPostGradesMenu.json": [
    "838709",
    [
      849663
    ]
  ],
  "./sv/link_validator.json": [
    "691028",
    [
      204840
    ]
  ],
  "./vi/webzip_export.json": [
    "625059",
    [
      70321
    ]
  ],
  "./en-GB-x-ukhe/quizzes_index.json": [
    "307422",
    [
      455814
    ]
  ],
  "./fi/media_player_iframe_content.json": [
    "460328",
    [
      95904
    ]
  ],
  "./ko/assignment_grade_summary.json": [
    "984958",
    [
      795838
    ]
  ],
  "./en-GB-x-ukhe.json": [
    "3023",
    [
      773815
    ]
  ],
  "./is/account_calendar_settings_account_calendar_item_dropdown.json": [
    "486809",
    [
      771375
    ]
  ],
  "./sl/dashboard_grading_period_select.json": [
    "296231",
    [
      348713
    ]
  ],
  "./cy/bulk_edit_students_table.json": [
    "867567",
    [
      499245
    ]
  ],
  "./el/assignments.never_drop.json": [
    "140475",
    [
      731726
    ]
  ],
  "./nb-x-k12/ImportConfirmBox.json": [
    "592796",
    [
      495724
    ]
  ],
  "./fi/custom_help_link.json": [
    "33853",
    [
      387307
    ]
  ],
  "./ru/k5_dashboard.json": [
    "758354",
    [
      239506
    ]
  ],
  "./zh-Hant/ai_experiences.json": [
    "62204",
    [
      999072
    ]
  ],
  "./da-x-k12/student_groups.json": [
    "571285",
    [
      848367
    ]
  ],
  "./nb/course_paces_actions.json": [
    "197384",
    [
      892412
    ]
  ],
  "./en-GB-x-ukhe/AssignmentGroupListItemView.json": [
    "253422",
    [
      438918
    ]
  ],
  "./nn/remove_pace_warning_modal.json": [
    "266053",
    [
      86751
    ]
  ],
  "./ar/restore_content_pane.json": [
    "587960",
    [
      145668
    ]
  ],
  "./pt-BR/blueprint_settingsSyncHistory.json": [
    "972081",
    [
      267416
    ]
  ],
  "./hi/assignment_2_assignment_toggle_details.json": [
    "835043",
    [
      94657
    ]
  ],
  "./is/courses_show.json": [
    "617044",
    [
      87748
    ]
  ],
  "./zh-Hans/ai_experiences.json": [
    "209875",
    [
      922561
    ]
  ],
  "./en-GB-x-ukhe/canvas_file_upload.json": [
    "831189",
    [
      403939
    ]
  ],
  "./mi/assignment_index_menu.json": [
    "898160",
    [
      21424
    ]
  ],
  "./it/submissions_show_preview.json": [
    "593041",
    [
      100147
    ]
  ],
  "./zh-Hans/grade_summary.json": [
    "513149",
    [
      106731
    ]
  ],
  "./sv-x-k12/question_banks.json": [
    "134051",
    [
      805185
    ]
  ],
  "./th/new_nav.json": [
    "936890",
    [
      408134
    ]
  ],
  "./it/copy_course.json": [
    "642748",
    [
      141080
    ]
  ],
  "./en-CA/todo.json": [
    "68846",
    [
      164278
    ]
  ],
  "./zh-Hant/quizzes_public.json": [
    "212435",
    [
      268605
    ]
  ],
  "./el/assignments_2_student_content.json": [
    "943266",
    [
      42598
    ]
  ],
  "./es-ES/course_paces_modal.json": [
    "68225",
    [
      29927
    ]
  ],
  "./es/account_calendars_results_area.json": [
    "738004",
    [
      340001
    ]
  ],
  "./nb/users.json": [
    "295630",
    [
      866242
    ]
  ],
  "./de/calendar_edit.json": [
    "644422",
    [
      664687
    ]
  ],
  "./es-ES/permissions_role_tray.json": [
    "681517",
    [
      729307
    ]
  ],
  "./es/course_navigation_settings.json": [
    "774286",
    [
      520511
    ]
  ],
  "./it/homeroom_page.json": [
    "911465",
    [
      922971
    ]
  ],
  "./sv-x-k12/SpeedGraderDiscussionsNavigation.json": [
    "751988",
    [
      587396
    ]
  ],
  "./ga/jobs.json": [
    "275178",
    [
      32010
    ]
  ],
  "./cy/a2LatePolicyStatusDisplay.json": [
    "832269",
    [
      541187
    ]
  ],
  "./ca/webcam_modal.json": [
    "880681",
    [
      82407
    ]
  ],
  "./en/AlignmentSummary.json": [
    "746488",
    [
      773948
    ]
  ],
  "./nb/user_name.json": [
    "350049",
    [
      132035
    ]
  ],
  "./ja/course_restore.json": [
    "870465",
    [
      205440
    ]
  ],
  "./ru/course_paces_header.json": [
    "927349",
    [
      525747
    ]
  ],
  "./de/quizzes_public.json": [
    "407332",
    [
      685017
    ]
  ],
  "./fi/course_logging_details.json": [
    "730691",
    [
      604769
    ]
  ],
  "./sl/roster_publicjs.json": [
    "670379",
    [
      824701
    ]
  ],
  "./fi/outcomes_user_outcome_results.json": [
    "321068",
    [
      478140
    ]
  ],
  "./cy/manage_avatars.json": [
    "58992",
    [
      6320
    ]
  ],
  "./cy/login.json": [
    "133415",
    [
      975125
    ]
  ],
  "./ga/rootFoldersFinder.json": [
    "485639",
    [
      664125
    ]
  ],
  "./ar/student_study_drawer.json": [
    "156292",
    [
      963752
    ]
  ],
  "./de/editGroup.json": [
    "222838",
    [
      281919
    ]
  ],
  "./sl/ai_experiences_ai_conversations.json": [
    "857813",
    [
      715215
    ]
  ],
  "./hi/course_statistics.json": [
    "454156",
    [
      302764
    ]
  ],
  "./hi/gradebookOutcomeGradebookView.json": [
    "400068",
    [
      376084
    ]
  ],
  "./da-x-k12/assignments_2_peer_review.json": [
    "238890",
    [
      418406
    ]
  ],
  "./pl/course_template_details.json": [
    "560959",
    [
      738041
    ]
  ],
  "./ms/user_grades.json": [
    "507490",
    [
      261690
    ]
  ],
  "./ru/assignments_2_student_points_display.json": [
    "704731",
    [
      422489
    ]
  ],
  "./ht/courses.show.json": [
    "20131",
    [
      37342
    ]
  ],
  "./fr/appointment_groups.json": [
    "235960",
    [
      278049
    ]
  ],
  "./hi/blueprint_settingsSyncHistory.json": [
    "48971",
    [
      142473
    ]
  ],
  "./pt/quiz_migration_notifications.json": [
    "568835",
    [
      429901
    ]
  ],
  "./hi/grade_change_logging_content.json": [
    "694543",
    [
      605621
    ]
  ],
  "./id/grades_empty_page.json": [
    "949447",
    [
      594497
    ]
  ],
  "./tr/eportfolio.json": [
    "746805",
    [
      216271
    ]
  ],
  "./es-ES/manage_avatars.json": [
    "934995",
    [
      151489
    ]
  ],
  "./el/moderate_quiz.json": [
    "545248",
    [
      130404
    ]
  ],
  "./zh-Hant/CoursesTray.json": [
    "503670",
    [
      983450
    ]
  ],
  "./zh-Hant/question_bank.json": [
    "715439",
    [
      102809
    ]
  ],
  "./he/course_paces_no_results.json": [
    "604068",
    [
      427324
    ]
  ],
  "./ca/license_help.json": [
    "780493",
    [
      525779
    ]
  ],
  "./ca/peer_review_allocation_rules_tray.json": [
    "467027",
    [
      497433
    ]
  ],
  "./es-ES/student_entries.json": [
    "711587",
    [
      168785
    ]
  ],
  "./nn/assignments_2_media_attempt.json": [
    "415648",
    [
      902484
    ]
  ],
  "./de/calendar_custom_recurring_event_repeat_picker.json": [
    "310483",
    [
      357846
    ]
  ],
  "./cy/CoursesTray.json": [
    "13524",
    [
      894028
    ]
  ],
  "./da/AddGroup.json": [
    "775277",
    [
      819859
    ]
  ],
  "./en-AU/speed_grader_helpers.json": [
    "538989",
    [
      960356
    ]
  ],
  "./it/custom_emoji_deny_list.json": [
    "936271",
    [
      448041
    ]
  ],
  "./mi/k5_dashboard.json": [
    "914451",
    [
      116425
    ]
  ],
  "./cy/sharedCurveGradesDialog.json": [
    "347250",
    [
      940906
    ]
  ],
  "./fa/MasteryScale.json": [
    "271628",
    [
      340572
    ]
  ],
  "./ms/k5_dashboard_card.json": [
    "619120",
    [
      335408
    ]
  ],
  "./nl/permissions_role_tray_table_row.json": [
    "710794",
    [
      787110
    ]
  ],
  "./da-x-k12/blueprint_settingsMigrationSync.json": [
    "219187",
    [
      149053
    ]
  ],
  "./ru/AssignmentGroupListItemView.json": [
    "564345",
    [
      710559
    ]
  ],
  "./en-GB-x-lbs/AlignmentSummary.json": [
    "330899",
    [
      522721
    ]
  ],
  "./fr/context_prior_users.json": [
    "969785",
    [
      947884
    ]
  ],
  "./en-CA/course_paces_assignment_row.json": [
    "843719",
    [
      457197
    ]
  ],
  "./ko/course_paces_time_selection.json": [
    "517459",
    [
      193401
    ]
  ],
  "./mi/CommentLibrary.json": [
    "25308",
    [
      798212
    ]
  ],
  "./ht/account_settings_jsx_bundle.json": [
    "932430",
    [
      783290
    ]
  ],
  "./zh-Hant/student_study_drawer.json": [
    "580863",
    [
      217273
    ]
  ],
  "./sv/quizzes_public.json": [
    "888138",
    [
      898150
    ]
  ],
  "./nn/account_calendar_settings_account_list.json": [
    "312229",
    [
      356551
    ]
  ],
  "./pl/CourseAvailabilityOptions.json": [
    "835242",
    [
      61870
    ]
  ],
  "./fi/blueprint_settingsAssociationsTable.json": [
    "198424",
    [
      641712
    ]
  ],
  "./hy/discussion_posts.json": [
    "376511",
    [
      236869
    ]
  ],
  "./is/assignments_2_login_action_prompt.json": [
    "200101",
    [
      475555
    ]
  ],
  "./en-CA/GroupDetailView.json": [
    "110585",
    [
      159791
    ]
  ],
  "./nn/empty_course.json": [
    "861165",
    [
      292687
    ]
  ],
  "./fa/outcomes_user_outcome_results.json": [
    "130420",
    [
      835508
    ]
  ],
  "./cy/CreateEditAssignmentModalAdapter.json": [
    "29079",
    [
      526149
    ]
  ],
  "./is/assignments_2_MoreOptions.json": [
    "472467",
    [
      226673
    ]
  ],
  "./fi/a2LatePolicyToolTipContent.json": [
    "303172",
    [
      294676
    ]
  ],
  "./ko/sharedSetDefaultGradeDialog.json": [
    "252295",
    [
      363026
    ]
  ],
  "./nb/AssignmentListItemView.json": [
    "992901",
    [
      579767
    ]
  ],
  "./pt/plugins.json": [
    "314926",
    [
      240658
    ]
  ],
  "./he/copy_course.json": [
    "131078",
    [
      382150
    ]
  ],
  "./ru/rate_limiting_settings.json": [
    "769003",
    [
      881337
    ]
  ],
  "./hu/account_calendars.json": [
    "570514",
    [
      286506
    ]
  ],
  "./pt-BR/jobs.json": [
    "577097",
    [
      621760
    ]
  ],
  "./ht/modelsQuiz.json": [
    "886057",
    [
      983763
    ]
  ],
  "./de/canvascareer.json": [
    "279129",
    [
      341536
    ]
  ],
  "./id/blueprint_settingsMigrationOptions.json": [
    "450310",
    [
      730234
    ]
  ],
  "./sv-x-k12/gradebook_uploads.json": [
    "308354",
    [
      616082
    ]
  ],
  "./tr/assignments_bulk_edit_use_save_assignment.json": [
    "29912",
    [
      134428
    ]
  ],
  "./pt-BR/blueprint_course_sidebar.json": [
    "688015",
    [
      988794
    ]
  ],
  "./fa/gradingPeriodTemplate.json": [
    "870328",
    [
      947696
    ]
  ],
  "./it/registration.json": [
    "276960",
    [
      872516
    ]
  ],
  "./pt/nav_tourpoints.json": [
    "111285",
    [
      532335
    ]
  ],
  "./ar/comm_messages.json": [
    "696856",
    [
      190572
    ]
  ],
  "./is/bulk_edit_students_actions.json": [
    "706344",
    [
      771088
    ]
  ],
  "./nb-x-k12/copy_warnings_modal.json": [
    "996317",
    [
      608699
    ]
  ],
  "./ga/video_conference.json": [
    "911472",
    [
      657000
    ]
  ],
  "./cy/blueprint_settingsCoursePickerTable.json": [
    "59264",
    [
      211552
    ]
  ],
  "./da/assignments_peer_reviews_student.json": [
    "197654",
    [
      69798
    ]
  ],
  "./ko/account_settings.json": [
    "983177",
    [
      781991
    ]
  ],
  "./ja/assignments_2_file_upload.json": [
    "195029",
    [
      5900
    ]
  ],
  "./de/widget_dashboard.json": [
    "348348",
    [
      457566
    ]
  ],
  "./ru/terms_index.json": [
    "742495",
    [
      959813
    ]
  ],
  "./fa/accessibility_checker.json": [
    "970479",
    [
      599989
    ]
  ],
  "./es-ES/grade_summaryGroupView.json": [
    "276639",
    [
      170213
    ]
  ],
  "./tr/choose_mastery_path.json": [
    "780439",
    [
      414593
    ]
  ],
  "./tr/CreateEditAssignmentModal.json": [
    "424714",
    [
      679734
    ]
  ],
  "./cy/course_statistics.json": [
    "140539",
    [
      773985
    ]
  ],
  "./th/choose_mastery_path.json": [
    "756357",
    [
      53959
    ]
  ],
  "./nb/peer-review-assignment-widget.json": [
    "749124",
    [
      785952
    ]
  ],
  "./ca/IndividualStudentMasteryOutcome.json": [
    "231699",
    [
      641497
    ]
  ],
  "./cy/sidenav.json": [
    "698074",
    [
      422210
    ]
  ],
  "./pt-BR/assignments_2_peer_review.json": [
    "289582",
    [
      390199
    ]
  ],
  "./pt/CoursesTray.json": [
    "234652",
    [
      682712
    ]
  ],
  "./sv-x-k12/theme_editor.json": [
    "874544",
    [
      496168
    ]
  ],
  "./th/media_player_iframe_content.json": [
    "145009",
    [
      94171
    ]
  ],
  "./ga/assignments.never_drop.json": [
    "61512",
    [
      996827
    ]
  ],
  "./hu/LogoutButton.json": [
    "209797",
    [
      659659
    ]
  ],
  "./ru/user_logins.json": [
    "198161",
    [
      374871
    ]
  ],
  "./he/blueprint_course_child.json": [
    "788219",
    [
      8001
    ]
  ],
  "./hu/blueprint_settingsUnsyncedChanges.json": [
    "997676",
    [
      736212
    ]
  ],
  "./id/content_exports.json": [
    "328726",
    [
      770850
    ]
  ],
  "./is/a2LatePolicyStatusDisplay.json": [
    "619889",
    [
      112983
    ]
  ],
  "./tr/account_calendar_settings_utils.json": [
    "190472",
    [
      643956
    ]
  ],
  "./es/bulk_edit_students_table.json": [
    "112863",
    [
      292786
    ]
  ],
  "./en-GB/content_migrations_redesign.json": [
    "672536",
    [
      936737
    ]
  ],
  "./ga/course_pace_date_input.json": [
    "495875",
    [
      609297
    ]
  ],
  "./it/bounced_emails.json": [
    "100593",
    [
      993595
    ]
  ],
  "./nb/blueprint_course_child.json": [
    "914982",
    [
      607778
    ]
  ],
  "./pt/grade_summaryGroupView.json": [
    "296384",
    [
      615924
    ]
  ],
  "./id/discussion_topics_edit.json": [
    "448387",
    [
      18805
    ]
  ],
  "./en-AU/discussion_posts.json": [
    "621888",
    [
      57765
    ]
  ],
  "./en-CA/IndividualStudentMasteryOutcome.json": [
    "886963",
    [
      898497
    ]
  ],
  "./es/course_paces_blackout_date_row.json": [
    "338646",
    [
      806151
    ]
  ],
  "./ga/react_developer_keys.json": [
    "726781",
    [
      15339
    ]
  ],
  "./ru/wiki_page_index.json": [
    "535066",
    [
      86522
    ]
  ],
  "./fi/course_stats.json": [
    "339964",
    [
      400220
    ]
  ],
  "./ja/grade_summaryGroupView.json": [
    "403979",
    [
      274694
    ]
  ],
  "./sv/ai_experiences_ai_conversations.json": [
    "780567",
    [
      220033
    ]
  ],
  "./el/peer_review_configuration_tray.json": [
    "111908",
    [
      54984
    ]
  ],
  "./fr/Navigation.json": [
    "219120",
    [
      493489
    ]
  ],
  "./tr/blueprint_course_child.json": [
    "974900",
    [
      788072
    ]
  ],
  "./vi/assignments.never_drop.json": [
    "547047",
    [
      543854
    ]
  ],
  "./ga/course_restore.json": [
    "623690",
    [
      672762
    ]
  ],
  "./he/account_calendars_results_area.json": [
    "726798",
    [
      611647
    ]
  ],
  "./he/sharedCurveGradesDialog.json": [
    "61557",
    [
      289691
    ]
  ],
  "./th/SpeedGraderPostGradesMenu.json": [
    "500671",
    [
      170089
    ]
  ],
  "./th/account_calendar_settings_account_calendar_item.json": [
    "997747",
    [
      269877
    ]
  ],
  "./it/plugins.json": [
    "199995",
    [
      140973
    ]
  ],
  "./pt-BR/default_account_quotas.json": [
    "666610",
    [
      69043
    ]
  ],
  "./sv/account_calendar_settings_utils.json": [
    "239107",
    [
      795989
    ]
  ],
  "./tr/course_paces_blackout_date_row.json": [
    "736432",
    [
      775780
    ]
  ],
  "./hi/direct_share_course_import_panel.json": [
    "288611",
    [
      898689
    ]
  ],
  "./en-GB-x-lbs/question_bank.json": [
    "121187",
    [
      533505
    ]
  ],
  "./sv/change_password.json": [
    "659351",
    [
      89937
    ]
  ],
  "./pt-BR/FindOutcomesModal.json": [
    "386008",
    [
      711109
    ]
  ],
  "./zh-Hans/outcome_management.json": [
    "120470",
    [
      797951
    ]
  ],
  "./en-GB-x-ukhe/grade_change_logging_content.json": [
    "772196",
    [
      724564
    ]
  ],
  "./hu/quizzes_quiz_submission.json": [
    "328761",
    [
      924231
    ]
  ],
  "./en-GB-x-ukhe/courses_show.json": [
    "472854",
    [
      444526
    ]
  ],
  "./es-ES/assignments_bulk_edit.json": [
    "167287",
    [
      155021
    ]
  ],
  "./ca/course_paces_header.json": [
    "308932",
    [
      526956
    ]
  ],
  "./fr/MasteryScale.json": [
    "374371",
    [
      509698
    ]
  ],
  "./is/course_restore.json": [
    "654885",
    [
      420530
    ]
  ],
  "./ht/calendar_custom_recurring_event_natural_language.json": [
    "396142",
    [
      929274
    ]
  ],
  "./ru/course_default_due_time.json": [
    "848669",
    [
      784027
    ]
  ],
  "./en-AU-x-unimelb/notebook.json": [
    "401419",
    [
      891381
    ]
  ],
  "./ht/react_scheduler.json": [
    "489147",
    [
      180341
    ]
  ],
  "./is/entity_search_form.json": [
    "95301",
    [
      465123
    ]
  ],
  "./hu/appt_calendar_event_dialog.json": [
    "82071",
    [
      57509
    ]
  ],
  "./hy/ignite_agent.json": [
    "20775",
    [
      691565
    ]
  ],
  "./it/k5_dashboard.json": [
    "803698",
    [
      806710
    ]
  ],
  "./nb/registration.json": [
    "326603",
    [
      606573
    ]
  ],
  "./pl/editAssignmentGroupWeights.json": [
    "414219",
    [
      263101
    ]
  ],
  "./sv-x-k12/assignments_2_student_points_display.json": [
    "724213",
    [
      191699
    ]
  ],
  "./es/custom_help_link.json": [
    "903970",
    [
      340027
    ]
  ],
  "./sl/course_paces_module.json": [
    "406786",
    [
      228534
    ]
  ],
  "./fi/gradebook_history.json": [
    "848374",
    [
      401182
    ]
  ],
  "./nl/blueprint_settingsCourseFilter.json": [
    "105786",
    [
      720694
    ]
  ],
  "./zh-Hans/grade_summaryGroupView.json": [
    "187213",
    [
      895403
    ]
  ],
  "./zh-Hant/outcome_management.json": [
    "248274",
    [
      819614
    ]
  ],
  "./hi/top_navigation_tools.json": [
    "44941",
    [
      888379
    ]
  ],
  "./hi/lti_registration.wizard.json": [
    "471043",
    [
      527590
    ]
  ],
  "./zh-Hans/enhanced_individual_gradebook_submit_score.json": [
    "882964",
    [
      573492
    ]
  ],
  "./ru/accessibility_scan.json": [
    "906717",
    [
      142667
    ]
  ],
  "./da/ai_experiences_ai_conversations.json": [
    "824425",
    [
      620679
    ]
  ],
  "./hi/blueprint_course_sidebar.json": [
    "527629",
    [
      863771
    ]
  ],
  "./pt/admin_split.json": [
    "948126",
    [
      866418
    ]
  ],
  "./sl/notebook.json": [
    "869310",
    [
      675506
    ]
  ],
  "./th/course_search_results.json": [
    "873733",
    [
      555023
    ]
  ],
  "./ht/assignments_2_student_header_date_title.json": [
    "493493",
    [
      264695
    ]
  ],
  "./es-ES/course_paces_pace_picker.json": [
    "936186",
    [
      194794
    ]
  ],
  "./ru/add_edit_pseudonym.json": [
    "12320",
    [
      657624
    ]
  ],
  "./fa/user_lists.json": [
    "574020",
    [
      254340
    ]
  ],
  "./hi/media_immersive_view.json": [
    "575159",
    [
      326045
    ]
  ],
  "./it/AddGroup.json": [
    "768079",
    [
      820889
    ]
  ],
  "./ko/discussion_topics_edit.json": [
    "949446",
    [
      780310
    ]
  ],
  "./hi/SpeedGraderPostGradesMenu.json": [
    "731324",
    [
      305868
    ]
  ],
  "./pt/CourseAvailabilityOptions.json": [
    "16626",
    [
      100934
    ]
  ],
  "./en-CA/canvas_file_upload.json": [
    "126979",
    [
      157953
    ]
  ],
  "./ms/SpeedGraderPostGradesMenu.json": [
    "819919",
    [
      351501
    ]
  ],
  "./fr-CA/blueprint_course_sidebar.json": [
    "66835",
    [
      755989
    ]
  ],
  "./ja/custom_emoji_deny_list.json": [
    "10011",
    [
      947734
    ]
  ],
  "./ms/react_files.json": [
    "436189",
    [
      294483
    ]
  ],
  "./fa/pairing_code_user_observees.json": [
    "656970",
    [
      853242
    ]
  ],
  "./en-AU-x-unimelb/react_developer_keys.json": [
    "685185",
    [
      40083
    ]
  ],
  "./en.json": [
    "785126",
    [
      564628
    ]
  ],
  "./fa/roster_publicjs.json": [
    "613309",
    [
      564555
    ]
  ],
  "./pt-BR/assignments_peer_reviews.json": [
    "534708",
    [
      665369
    ]
  ],
  "./sl/suppress_notifications.json": [
    "272087",
    [
      849801
    ]
  ],
  "./hy/quizzes_index.json": [
    "399735",
    [
      466605
    ]
  ],
  "./sv/discussion_posts.json": [
    "297333",
    [
      73359
    ]
  ],
  "./cy/course_paces_footer.json": [
    "659778",
    [
      497018
    ]
  ],
  "./en-GB/link_to_students.json": [
    "541540",
    [
      222189
    ]
  ],
  "./vi/blueprint_course_child.json": [
    "600073",
    [
      773343
    ]
  ],
  "./fi/course_paces_change_tracking.json": [
    "480856",
    [
      88912
    ]
  ],
  "./zh-Hans/course_paces_projected_dates.json": [
    "219096",
    [
      171184
    ]
  ],
  "./es-ES/login.json": [
    "486054",
    [
      811966
    ]
  ],
  "./pt-BR/modules_home_page.json": [
    "876494",
    [
      208151
    ]
  ],
  "./da-x-k12/link_to_students.json": [
    "413948",
    [
      889240
    ]
  ],
  "./nb/assignments_2_login_action_prompt.json": [
    "895841",
    [
      154803
    ]
  ],
  "./tr/appt_calendar_event_dialog.json": [
    "130316",
    [
      815128
    ]
  ],
  "./ht/account_calendar_settings_account_calendar_item_dropdown.json": [
    "330589",
    [
      820319
    ]
  ],
  "./pt/modules_page_icon_legend.json": [
    "505135",
    [
      643585
    ]
  ],
  "./en-AU/user_grades.json": [
    "235692",
    [
      917065
    ]
  ],
  "./nb-x-k12/progressbar_view.json": [
    "783328",
    [
      548360
    ]
  ],
  "./es/use_switch_experience.json": [
    "930683",
    [
      77190
    ]
  ],
  "./nb-x-k12/Navigation.json": [
    "989370",
    [
      281770
    ]
  ],
  "./cy/assignmentsIndexView.json": [
    "262837",
    [
      991963
    ]
  ],
  "./fr/blueprint_settingsAssociationsTable.json": [
    "529917",
    [
      445128
    ]
  ],
  "./ar/edit_section_dates.json": [
    "573989",
    [
      226327
    ]
  ],
  "./es-ES/grade_details.json": [
    "454941",
    [
      905051
    ]
  ],
  "./id/learning_mastery_gradebook.json": [
    "956392",
    [
      232484
    ]
  ],
  "./is/course_default_due_time.json": [
    "992356",
    [
      325959
    ]
  ],
  "./th/course_paces_footer.json": [
    "558490",
    [
      984494
    ]
  ],
  "./tr/rootFoldersFinder.json": [
    "563325",
    [
      6551
    ]
  ],
  "./he/learning_mastery_gradebook.json": [
    "376090",
    [
      451394
    ]
  ],
  "./nb-x-k12/theme_collection_view.json": [
    "328222",
    [
      22566
    ]
  ],
  "./fr-CA/AlignmentSummary.json": [
    "16330",
    [
      945262
    ]
  ],
  "./sv-x-k12/assignments_2_submission_histories_query.json": [
    "114151",
    [
      921245
    ]
  ],
  "./es/course_paces_modal.json": [
    "239334",
    [
      924727
    ]
  ],
  "./da-x-k12/assignment_index_deep_linking_handlers.json": [
    "33907",
    [
      837037
    ]
  ],
  "./fa/content_share_preview_overlay.json": [
    "930074",
    [
      158330
    ]
  ],
  "./ru/AccountsTray.json": [
    "423185",
    [
      106855
    ]
  ],
  "./sl/assignments.no_assignments_search.json": [
    "959798",
    [
      791847
    ]
  ],
  "./ar/assignments_2_file_upload.json": [
    "868499",
    [
      31869
    ]
  ],
  "./fr/quizzes_quiz_submission.json": [
    "248554",
    [
      790799
    ]
  ],
  "./hy/error_form.json": [
    "977722",
    [
      394474
    ]
  ],
  "./fr/terms_index.json": [
    "34450",
    [
      480039
    ]
  ],
  "./fi/course_pace_date_input.json": [
    "630256",
    [
      399496
    ]
  ],
  "./he/login.json": [
    "437360",
    [
      1616
    ]
  ],
  "./da-x-k12/users.json": [
    "355911",
    [
      11249
    ]
  ],
  "./he/quizzes_index.json": [
    "911867",
    [
      806561
    ]
  ],
  "./nl/calendar_sidebar.json": [
    "301561",
    [
      601235
    ]
  ],
  "./nn/MobileNavigation.json": [
    "517206",
    [
      995946
    ]
  ],
  "./mi/SpeedGraderSettingsMenu.json": [
    "171758",
    [
      260478
    ]
  ],
  "./es-ES/new_nav.json": [
    "81571",
    [
      370721
    ]
  ],
  "./en-GB-x-lbs/manage_avatars.json": [
    "499018",
    [
      993434
    ]
  ],
  "./ms/assignments_2_external_tool.json": [
    "389844",
    [
      564268
    ]
  ],
  "./sv-x-k12/discussion_row.json": [
    "54128",
    [
      905528
    ]
  ],
  "./hi/nav_tourpoints.json": [
    "399008",
    [
      863259
    ]
  ],
  "./uk/ai_experiences_edit.json": [
    "316415",
    [
      82893
    ]
  ],
  "./he/moderate_quiz.json": [
    "690458",
    [
      332130
    ]
  ],
  "./ca/ImportConfirmBox.json": [
    "988026",
    [
      736882
    ]
  ],
  "./th/OutcomeDescriptionModal.json": [
    "699725",
    [
      578831
    ]
  ],
  "./th/gradingPeriodTemplate.json": [
    "840425",
    [
      867043
    ]
  ],
  "./nn/a2LatePolicyStatusDisplay.json": [
    "775241",
    [
      460003
    ]
  ],
  "./tr/bulk_edit_students.json": [
    "226570",
    [
      680278
    ]
  ],
  "./nb/self_unenrollment_modal.json": [
    "992916",
    [
      629280
    ]
  ],
  "./ru/submit_online_url_assignment.json": [
    "242413",
    [
      568091
    ]
  ],
  "./mi/calendar_edit.json": [
    "491403",
    [
      674033
    ]
  ],
  "./it/assignments.never_drop.json": [
    "232151",
    [
      719626
    ]
  ],
  "./sv-x-k12/submit_assignment.json": [
    "261717",
    [
      719523
    ]
  ],
  "./he/sections_tooltip.json": [
    "480835",
    [
      745817
    ]
  ],
  "./pt-BR/assignments_2_attempt_tab.json": [
    "946398",
    [
      497063
    ]
  ],
  "./th/ldap_cert_upload.json": [
    "230626",
    [
      349094
    ]
  ],
  "./ar/course_statistics.json": [
    "505852",
    [
      928112
    ]
  ],
  "./zh-Hans/admin_split.json": [
    "814181",
    [
      527331
    ]
  ],
  "./ga/canvas_file_upload.json": [
    "42471",
    [
      696445
    ]
  ],
  "./ja/unpublished_changes_tray_contents.json": [
    "204318",
    [
      167103
    ]
  ],
  "./fa/announcements_v2.json": [
    "791708",
    [
      166380
    ]
  ],
  "./sl/user_search_results.json": [
    "27236",
    [
      656352
    ]
  ],
  "./sl/account_calendar_settings.json": [
    "751187",
    [
      35053
    ]
  ],
  "./th/calendar_custom_recurring_event_repeat_picker.json": [
    "188124",
    [
      398936
    ]
  ],
  "./uk/entity_search_form.json": [
    "777761",
    [
      249775
    ]
  ],
  "./pt/course_restore.json": [
    "301662",
    [
      371642
    ]
  ],
  "./zh-Hant/permissions_role_tray_table_row.json": [
    "332230",
    [
      572098
    ]
  ],
  "./pt/course_paces_pace_picker.json": [
    "650709",
    [
      51279
    ]
  ],
  "./zh-Hans/account_calendar_settings_account_calendar_item_dropdown.json": [
    "357888",
    [
      910872
    ]
  ],
  "./fr-CA/discussion_row.json": [
    "679374",
    [
      170674
    ]
  ],
  "./ar/account_calendar_settings_filter_controls.json": [
    "683609",
    [
      569003
    ]
  ],
  "./mi/k5_course.json": [
    "792184",
    [
      133928
    ]
  ],
  "./pt-BR/context_modules_v2.json": [
    "742703",
    [
      641258
    ]
  ],
  "./en-AU/question_bank.json": [
    "87271",
    [
      65226
    ]
  ],
  "./ga/accessibility_checker.json": [
    "390706",
    [
      75986
    ]
  ],
  "./el/conferences.json": [
    "431836",
    [
      701456
    ]
  ],
  "./ca/ai_experiences_show.json": [
    "229474",
    [
      845002
    ]
  ],
  "./pt-BR/module_student_view_peer_reviews.json": [
    "409782",
    [
      631759
    ]
  ],
  "./es/webcam_modal.json": [
    "817153",
    [
      674416
    ]
  ],
  "./cy/user.json": [
    "522721",
    [
      315615
    ]
  ],
  "./ga/ProfileTray.json": [
    "410151",
    [
      128765
    ]
  ],
  "./cy/accessibility_course_statistics.json": [
    "720532",
    [
      18060
    ]
  ],
  "./sv-x-k12/learning_mastery_gradebook.json": [
    "961542",
    [
      179102
    ]
  ],
  "./ms/outcome_alignment_v2.json": [
    "807465",
    [
      683863
    ]
  ],
  "./ar/overview_page.json": [
    "526394",
    [
      87854
    ]
  ],
  "./nl/discussion_topics.json": [
    "421033",
    [
      901275
    ]
  ],
  "./es/calendar_sidebar.json": [
    "948387",
    [
      520494
    ]
  ],
  "./he/calculator_command.json": [
    "844593",
    [
      817455
    ]
  ],
  "./it/canvascareer.json": [
    "508887",
    [
      280169
    ]
  ],
  "./cy/AccountsTray.json": [
    "893338",
    [
      473442
    ]
  ],
  "./pt-BR/syllabus_revisions.json": [
    "719979",
    [
      75166
    ]
  ],
  "./ca/unpublished_warning_modal.json": [
    "290776",
    [
      772888
    ]
  ],
  "./nl/grade_details.json": [
    "174418",
    [
      670022
    ]
  ],
  "./en-GB-x-ukhe/module_sequence_footer.json": [
    "715134",
    [
      915334
    ]
  ],
  "./es-ES/gradingGradeSummary.json": [
    "939930",
    [
      556586
    ]
  ],
  "./fi/context_prior_users.json": [
    "376332",
    [
      966412
    ]
  ],
  "./fr-CA/speed_grader_helpers.json": [
    "22020",
    [
      772944
    ]
  ],
  "./nn/SpeedGraderPostGradesMenu.json": [
    "410267",
    [
      583029
    ]
  ],
  "./sl/enhanced_individual_gradebook_submit_score.json": [
    "586500",
    [
      231080
    ]
  ],
  "./ar/change_password.json": [
    "508721",
    [
      710811
    ]
  ],
  "./ru/bounced_emails.json": [
    "958782",
    [
      39351
    ]
  ],
  "./ca/blueprint_settingsAssociationsTable.json": [
    "190061",
    [
      727795
    ]
  ],
  "./is/Navigation.json": [
    "746004",
    [
      462324
    ]
  ],
  "./uk/error_form.json": [
    "300099",
    [
      403145
    ]
  ],
  "./hi/link_validator.json": [
    "757230",
    [
      911302
    ]
  ],
  "./is/assignmentsToggleShowByView.json": [
    "27785",
    [
      273087
    ]
  ],
  "./nn/OutcomeMoveModal.json": [
    "223696",
    [
      776212
    ]
  ],
  "./fr/quizzes_index.json": [
    "527460",
    [
      326133
    ]
  ],
  "./id/self_enrollment.json": [
    "629008",
    [
      361348
    ]
  ],
  "./en-GB/dashboard_grading_period_select.json": [
    "387205",
    [
      160680
    ]
  ],
  "./pl/theme_collection_view.json": [
    "893280",
    [
      154692
    ]
  ],
  "./he/peer_review_allocation_rule_card.json": [
    "727825",
    [
      58287
    ]
  ],
  "./fa/new_nav.json": [
    "890603",
    [
      133769
    ]
  ],
  "./ja/pairing_code_user_observees.json": [
    "264918",
    [
      228183
    ]
  ],
  "./he/roster_section_selector.json": [
    "372320",
    [
      477600
    ]
  ],
  "./ht/gradingPeriodTemplate.json": [
    "549985",
    [
      563131
    ]
  ],
  "./sv.eager.json": [
    "954714",
    [
      406561
    ]
  ],
  "./fa/course_paces_change_tracking.json": [
    "576800",
    [
      252808
    ]
  ],
  "./fi/CourseAvailabilityOptions.json": [
    "218751",
    [
      990805
    ]
  ],
  "./ja/account_calendar_settings_account_group.json": [
    "568937",
    [
      939816
    ]
  ],
  "./nb/course_paces_search.json": [
    "321769",
    [
      9923
    ]
  ],
  "./hu/assignmentsToggleShowByView.json": [
    "694578",
    [
      547818
    ]
  ],
  "./hu/course_template_details.json": [
    "626008",
    [
      250984
    ]
  ],
  "./fi/course_paces_blackout_dates_modal.json": [
    "597597",
    [
      38219
    ]
  ],
  "./pt-BR/progression_module_header.json": [
    "826063",
    [
      790874
    ]
  ],
  "./el/link_validator.json": [
    "42180",
    [
      184920
    ]
  ],
  "./zh-Hans/editGroup.json": [
    "405974",
    [
      549262
    ]
  ],
  "./de.eager.json": [
    "198792",
    [
      728859
    ]
  ],
  "./id/announcements_v2.json": [
    "828868",
    [
      969280
    ]
  ],
  "./pt/bulk_edit_students_actions.json": [
    "682540",
    [
      573032
    ]
  ],
  "./ca/submit_assignment.json": [
    "393410",
    [
      548842
    ]
  ],
  "./es-ES/file_not_found.json": [
    "425966",
    [
      77638
    ]
  ],
  "./de/blueprint_settingsMigrationSync.json": [
    "14109",
    [
      324620
    ]
  ],
  "./en.eager.json": [
    "907488",
    []
  ],
  "./id/editGroup.json": [
    "735064",
    [
      285428
    ]
  ],
  "./hi/learning_mastery_gradebook.json": [
    "834918",
    [
      85278
    ]
  ],
  "./hy/self_unenrollment_modal.json": [
    "285467",
    [
      884937
    ]
  ],
  "./ht/wiki_page_index.json": [
    "27035",
    [
      787477
    ]
  ],
  "./pt-BR/gradebook_default_gradebook_components_content_filters_module_filter.json": [
    "721909",
    [
      995604
    ]
  ],
  "./zh-Hant/overview_page.json": [
    "636595",
    [
      414901
    ]
  ],
  "./de/reset_pace_warning_modal.json": [
    "166417",
    [
      257848
    ]
  ],
  "./mi/content_share_preview_overlay.json": [
    "549637",
    [
      484171
    ]
  ],
  "./en-CA/content_migrations.json": [
    "886869",
    [
      754531
    ]
  ],
  "./is/gradingPeriodTemplate.json": [
    "92173",
    [
      85227
    ]
  ],
  "./el/license_help.json": [
    "657534",
    [
      491090
    ]
  ],
  "./nb-x-k12/assignments_bulk_edit.json": [
    "984004",
    [
      235028
    ]
  ],
  "./es/grade_summaryGroupView.json": [
    "879000",
    [
      713869
    ]
  ],
  "./fr/calendar.header.json": [
    "588791",
    [
      373406
    ]
  ],
  "./nl/theme_collection_view.json": [
    "450194",
    [
      553142
    ]
  ],
  "./ga/outcome_detail.json": [
    "724978",
    [
      187234
    ]
  ],
  "./es-ES/appt_calendar_event_dialog.json": [
    "423133",
    [
      489675
    ]
  ],
  "./ca/error_form.json": [
    "947651",
    [
      391305
    ]
  ],
  "./el/self_unenrollment_modal.json": [
    "691853",
    [
      835831
    ]
  ],
  "./hu/dashboard.json": [
    "217457",
    [
      454863
    ]
  ],
  "./pt/EditMasteryScaleLink.json": [
    "355763",
    [
      867525
    ]
  ],
  "./sv/gradebook.json": [
    "106153",
    [
      824307
    ]
  ],
  "./nb-x-k12/blueprint_settingsSyncChange.json": [
    "755138",
    [
      628466
    ]
  ],
  "./pl/outcome_detail.json": [
    "463830",
    [
      305194
    ]
  ],
  "./ms/user_lists.json": [
    "822155",
    [
      273393
    ]
  ],
  "./en-GB-x-ukhe/link_validator.json": [
    "148197",
    [
      424387
    ]
  ],
  "./fr/discussion_row.json": [
    "525353",
    [
      386396
    ]
  ],
  "./nb-x-k12/quiz_migration_notifications.json": [
    "551329",
    [
      605111
    ]
  ],
  "./nb/todo.json": [
    "168550",
    [
      50146
    ]
  ],
  "./nb/user_grades.json": [
    "901082",
    [
      902406
    ]
  ],
  "./zh-Hans/blueprint_settingsCoursePickerTable.json": [
    "176351",
    [
      844373
    ]
  ],
  "./he/assignments_bulk_edit.json": [
    "701389",
    [
      816547
    ]
  ],
  "./zh-Hant/course_color_selector.json": [
    "560339",
    [
      116485
    ]
  ],
  "./tr/speed_grader_helpers.json": [
    "398341",
    [
      467807
    ]
  ],
  "./sv/terms_of_use.json": [
    "965516",
    [
      85160
    ]
  ],
  "./nn/discussionTopicKeyboradShortcutModal.json": [
    "582149",
    [
      129687
    ]
  ],
  "./nn/calculator_command.json": [
    "781048",
    [
      85284
    ]
  ],
  "./es/ai_experiences_ai_conversations.json": [
    "782342",
    [
      784087
    ]
  ],
  "./ru/video_conference.json": [
    "22495",
    [
      526917
    ]
  ],
  "./fr/account_calendars_modal.json": [
    "133683",
    [
      130706
    ]
  ],
  "./hu/CoursesTray.json": [
    "697475",
    [
      530937
    ]
  ],
  "./pt-BR/course_color_selector.json": [
    "767596",
    [
      762321
    ]
  ],
  "./th/editAssignmentGroupWeights.json": [
    "802675",
    [
      482725
    ]
  ],
  "./th/rate_limiting_settings.json": [
    "741700",
    [
      124088
    ]
  ],
  "./uk/video_conference.json": [
    "613972",
    [
      32316
    ]
  ],
  "./sv/permissions.json": [
    "608095",
    [
      281665
    ]
  ],
  "./pl/OutcomeMoveModal.json": [
    "229724",
    [
      776208
    ]
  ],
  "./da/permissions.json": [
    "191025",
    [
      429727
    ]
  ],
  "./es-ES/a2LatePolicyStatusDisplay.json": [
    "180416",
    [
      944440
    ]
  ],
  "./sl/homeroom_page.json": [
    "539883",
    [
      493253
    ]
  ],
  "./en-AU-x-unimelb/peer_reviews_student.json": [
    "762116",
    [
      60160
    ]
  ],
  "./pt/moderate_quiz.json": [
    "906337",
    [
      103715
    ]
  ],
  "./pt-BR/account_calendar_settings_account_tree.json": [
    "67766",
    [
      896847
    ]
  ],
  "./en-GB-x-lbs/suppress_notifications.json": [
    "849752",
    [
      565344
    ]
  ],
  "./sv/confirmMasteryModal.json": [
    "226925",
    [
      407999
    ]
  ],
  "./en-AU-x-unimelb/calendar_edit.json": [
    "385041",
    [
      59419
    ]
  ],
  "./tr/syllabus_revisions.json": [
    "165758",
    [
      694426
    ]
  ],
  "./uk/discussion_topics.json": [
    "216443",
    [
      424817
    ]
  ],
  "./hu/courses_show.json": [
    "853909",
    [
      191195
    ]
  ],
  "./ms/content_migrations.json": [
    "572533",
    [
      872315
    ]
  ],
  "./da-x-k12/dashboard_grades_page.json": [
    "323358",
    [
      498634
    ]
  ],
  "./is/quizzes_public.json": [
    "858561",
    [
      618327
    ]
  ],
  "./ko/folder_tree.json": [
    "845325",
    [
      384243
    ]
  ],
  "./nb-x-k12/account_calendars.json": [
    "581387",
    [
      816585
    ]
  ],
  "./nl/student_entries.json": [
    "779220",
    [
      984096
    ]
  ],
  "./nn/course_paces_search.json": [
    "165533",
    [
      211671
    ]
  ],
  "./nb-x-k12/course_default_due_time.json": [
    "762226",
    [
      524386
    ]
  ],
  "./en-GB/OutcomeMoveModal.json": [
    "646527",
    [
      391406
    ]
  ],
  "./de/quizzes_index.json": [
    "847279",
    [
      264938
    ]
  ],
  "./es/course_restore.json": [
    "200838",
    [
      207799
    ]
  ],
  "./ca/appointment_groups.json": [
    "11368",
    [
      508520
    ]
  ],
  "./vi/blueprint_settingsUnsyncedChanges.json": [
    "301926",
    [
      753694
    ]
  ],
  "./pt.json": [
    "67925",
    [
      7557
    ]
  ],
  "./cy/security_panel.json": [
    "511461",
    [
      402507
    ]
  ],
  "./id/modelsQuiz.json": [
    "208746",
    [
      940406
    ]
  ],
  "./it/course_paces_module.json": [
    "844492",
    [
      454480
    ]
  ],
  "./sv/account_calendars_results_area.json": [
    "783279",
    [
      706009
    ]
  ],
  "./nb-x-k12/editAssignmentGroupWeights.json": [
    "959413",
    [
      782963
    ]
  ],
  "./ms/accessibility_scan.json": [
    "190066",
    [
      899562
    ]
  ],
  "./ar/discovery_page.json": [
    "860763",
    [
      658533
    ]
  ],
  "./da/notebook.json": [
    "732818",
    [
      410714
    ]
  ],
  "./fi/course_paces_pace_picker.json": [
    "640842",
    [
      961290
    ]
  ],
  "./it/discussion_create.json": [
    "142970",
    [
      745534
    ]
  ],
  "./en-AU-x-unimelb/course_paces_assignment_row.json": [
    "942023",
    [
      860889
    ]
  ],
  "./fr-CA/theme_editor.json": [
    "240250",
    [
      569718
    ]
  ],
  "./it/peer_review_configuration_tray.json": [
    "112624",
    [
      808980
    ]
  ],
  "./nl/gradingGradeSummary.json": [
    "424413",
    [
      80927
    ]
  ],
  "./hy/assignment_index.json": [
    "703421",
    [
      598075
    ]
  ],
  "./th.json": [
    "251029",
    [
      191829
    ]
  ],
  "./sv/horizon_toggle.json": [
    "112381",
    [
      996943
    ]
  ],
  "./vi/account_calendar_settings_filter_controls.json": [
    "630083",
    [
      848417
    ]
  ],
  "./hi/webcam_modal.json": [
    "487484",
    [
      699580
    ]
  ],
  "./en-GB/calendar_sidebar.json": [
    "790056",
    [
      274977
    ]
  ],
  "./he/account_calendar_settings_confirmation_modal.json": [
    "582415",
    [
      344109
    ]
  ],
  "./da/discussion_topics.json": [
    "457564",
    [
      354100
    ]
  ],
  "./nb-x-k12/rubrics-export.json": [
    "363211",
    [
      317769
    ]
  ],
  "./pt-BR/bounced_emails.json": [
    "236769",
    [
      743192
    ]
  ],
  "./sv-x-k12/media_player_iframe_content.json": [
    "288242",
    [
      683778
    ]
  ],
  "./uk/password_complexity_configuration.json": [
    "363245",
    [
      742899
    ]
  ],
  "./uk/question_banks.json": [
    "171198",
    [
      373662
    ]
  ],
  "./ht/security_panel.json": [
    "90693",
    [
      16079
    ]
  ],
  "./ms/discussion_topics_edit.json": [
    "84928",
    [
      22816
    ]
  ],
  "./ar/assignments_peer_reviews.json": [
    "360566",
    [
      686258
    ]
  ],
  "./ru/CoursesTray.json": [
    "826949",
    [
      851491
    ]
  ],
  "./en-AU/ai_experiences_ai_conversations.json": [
    "448464",
    [
      15221
    ]
  ],
  "./hi/account_calendars_results_area.json": [
    "65013",
    [
      33603
    ]
  ],
  "./ms/MobileNavigation.json": [
    "760554",
    [
      966194
    ]
  ],
  "./pt-BR/calendar.header.json": [
    "75430",
    [
      456847
    ]
  ],
  "./fi/blueprint_settingsCoursePickerTable.json": [
    "883205",
    [
      358944
    ]
  ],
  "./es-ES/terms_of_service_modal.json": [
    "899226",
    [
      178010
    ]
  ],
  "./fr-CA/overview_page.json": [
    "741672",
    [
      873876
    ]
  ],
  "./ru/restore_content_pane.json": [
    "728118",
    [
      471630
    ]
  ],
  "./sv/sections_tooltip.json": [
    "995173",
    [
      603527
    ]
  ],
  "./hi/file_not_found.json": [
    "53172",
    [
      944916
    ]
  ],
  "./ko/account_calendar_settings_account_calendar_item_dropdown.json": [
    "686203",
    [
      520593
    ]
  ],
  "./th/context_roster_user_services.json": [
    "148094",
    [
      670058
    ]
  ],
  "./pl/link_to_students.json": [
    "917399",
    [
      710081
    ]
  ],
  "./hi/assignments_2_url_entry.json": [
    "308399",
    [
      914405
    ]
  ],
  "./fr-CA/calculator_command.json": [
    "456491",
    [
      143189
    ]
  ],
  "./pt/folder_tree.json": [
    "509947",
    [
      635501
    ]
  ],
  "./id/calendar_custom_recurring_event_repeat_picker.json": [
    "914237",
    [
      899183
    ]
  ],
  "./es/conferences.json": [
    "144913",
    [
      530848
    ]
  ],
  "./hy/security_panel.json": [
    "232384",
    [
      456984
    ]
  ],
  "./da-x-k12/grades_summary.json": [
    "38482",
    [
      99750
    ]
  ],
  "./ms/ai_experiences.json": [
    "904266",
    [
      863282
    ]
  ],
  "./nb/files_v2.json": [
    "801010",
    [
      103982
    ]
  ],
  "./sl/courses_show.json": [
    "378129",
    [
      602819
    ]
  ],
  "./pt/quizzes_index.json": [
    "96388",
    [
      871008
    ]
  ],
  "./zh-Hans/important_dates.json": [
    "904153",
    [
      898607
    ]
  ],
  "./fr-CA/roster_section_selector.json": [
    "297014",
    [
      749018
    ]
  ],
  "./fa/assignments_2_student_header_date_title.json": [
    "889444",
    [
      225556
    ]
  ],
  "./nb-x-k12/appt_calendar_event_dialog.json": [
    "641828",
    [
      788420
    ]
  ],
  "./nl/change_password.json": [
    "843435",
    [
      610892
    ]
  ],
  "./da/edit_section_view.json": [
    "364477",
    [
      575843
    ]
  ],
  "./fi/youtube_migration.json": [
    "35097",
    [
      802191
    ]
  ],
  "./fi/filter_calendars_modal.json": [
    "688989",
    [
      779707
    ]
  ],
  "./ms/courses_show.json": [
    "782976",
    [
      740800
    ]
  ],
  "./es-ES/group_submission_reminder.json": [
    "917304",
    [
      344720
    ]
  ],
  "./sv/nav_tourpoints.json": [
    "620302",
    [
      931666
    ]
  ],
  "./id/jobs_v2.json": [
    "73562",
    [
      557414
    ]
  ],
  "./nb-x-k12/grade_summaryGroupView.json": [
    "78886",
    [
      441086
    ]
  ],
  "./en-AU-x-unimelb/quizzes.take_quiz.json": [
    "596844",
    [
      254853
    ]
  ],
  "./it/permissions.json": [
    "252915",
    [
      564149
    ]
  ],
  "./en-GB-x-ukhe/k5_course.json": [
    "353860",
    [
      893236
    ]
  ],
  "./pl/empty_modules.json": [
    "796853",
    [
      901887
    ]
  ],
  "./mi/learning_mastery_gradebook.json": [
    "877437",
    [
      371315
    ]
  ],
  "./vi/dashboard_grades_page.json": [
    "334362",
    [
      561994
    ]
  ],
  "./fr/context_modules_v2.json": [
    "385852",
    [
      439506
    ]
  ],
  "./sl/admin_split.json": [
    "121781",
    [
      199447
    ]
  ],
  "./da-x-k12/gradingPeriodTemplate.json": [
    "688508",
    [
      753192
    ]
  ],
  "./da-x-k12/quizzes_regrade_modal.json": [
    "358927",
    [
      418969
    ]
  ],
  "./hi/progression_module_header.json": [
    "419033",
    [
      970911
    ]
  ],
  "./sl/course_paces_header.json": [
    "494587",
    [
      73077
    ]
  ],
  "./en-AU/calendar_custom_recurring_event_natural_language.json": [
    "1828",
    [
      532865
    ]
  ],
  "./sv-x-k12/overview_page.json": [
    "80874",
    [
      608122
    ]
  ],
  "./ms/error_form.json": [
    "648707",
    [
      231673
    ]
  ],
  "./is/user_date_range_search.json": [
    "675285",
    [
      268739
    ]
  ],
  "./pl/accessibility_checker.json": [
    "363430",
    [
      15306
    ]
  ],
  "./id/user_logins.json": [
    "543681",
    [
      472835
    ]
  ],
  "./zh-Hant/rootFoldersFinder.json": [
    "849501",
    [
      724743
    ]
  ],
  "./el/discussionTopicKeyboradShortcutModal.json": [
    "770338",
    [
      417342
    ]
  ],
  "./fa/module_student_view_peer_reviews.json": [
    "748158",
    [
      609190
    ]
  ],
  "./zh-Hans/outcome_alignment_v2.json": [
    "125316",
    [
      74596
    ]
  ],
  "./cy/account_settings.json": [
    "954531",
    [
      70681
    ]
  ],
  "./ht/permission_button.json": [
    "402130",
    [
      717358
    ]
  ],
  "./ja/student_entries.json": [
    "62247",
    [
      512554
    ]
  ],
  "./fr-CA/assignments_2_attempt_tab.json": [
    "44930",
    [
      226806
    ]
  ],
  "./nl.json": [
    "719527",
    [
      824875
    ]
  ],
  "./nl/rootFoldersFinder.json": [
    "438217",
    [
      664691
    ]
  ],
  "./fa/k5_dashboard.json": [
    "851370",
    [
      587562
    ]
  ],
  "./fa/outcome_detail.json": [
    "126009",
    [
      64735
    ]
  ],
  "./sv-x-k12/suppress_notifications.json": [
    "74559",
    [
      268293
    ]
  ],
  "./sv/direct_share_course_import_panel.json": [
    "717565",
    [
      379831
    ]
  ],
  "./th/reset_pace_warning_modal.json": [
    "558156",
    [
      109176
    ]
  ],
  "./zh-Hant/auth_logging.json": [
    "200416",
    [
      482980
    ]
  ],
  "./pt/outcome_alignment_v2.json": [
    "241113",
    [
      291379
    ]
  ],
  "./nl/AssignmentListItemView.json": [
    "966143",
    [
      831169
    ]
  ],
  "./fr-CA/bounced_emails.json": [
    "16541",
    [
      597559
    ]
  ],
  "./mi/accessibility_scan.json": [
    "998044",
    [
      337220
    ]
  ],
  "./pt-BR/AlignmentSummary.json": [
    "818518",
    [
      76047
    ]
  ],
  "./ru/assignments_2_MoreOptions.json": [
    "484218",
    [
      941562
    ]
  ],
  "./ar/quiz_statistics.json": [
    "287620",
    [
      178312
    ]
  ],
  "./es/new_nav.json": [
    "289106",
    [
      139499
    ]
  ],
  "./hy/widget_dashboard.json": [
    "441764",
    [
      330692
    ]
  ],
  "./fr/course_paces_no_results.json": [
    "196059",
    [
      181106
    ]
  ],
  "./hy/dashboard.json": [
    "697045",
    [
      754259
    ]
  ],
  "./nb-x-k12/content_exports.json": [
    "143253",
    [
      722211
    ]
  ],
  "./ja/CoursesTray.json": [
    "91665",
    [
      86544
    ]
  ],
  "./vi/course_paces_time_selection.json": [
    "327216",
    [
      109656
    ]
  ],
  "./it/jobs_v2.json": [
    "880170",
    [
      217782
    ]
  ],
  "./pl/roster_section_input.json": [
    "398738",
    [
      757862
    ]
  ],
  "./sl/epub_exports.json": [
    "991241",
    [
      436987
    ]
  ],
  "./pt/course_color_selector.json": [
    "855537",
    [
      228395
    ]
  ],
  "./sv/error_form.json": [
    "978352",
    [
      655676
    ]
  ],
  "./ht/blueprint_settingsMigrationOptions.json": [
    "231033",
    [
      713011
    ]
  ],
  "./ht/notebook_index.json": [
    "253536",
    [
      116540
    ]
  ],
  "./de/edit_section_dates.json": [
    "806205",
    [
      858220
    ]
  ],
  "./id.json": [
    "610752",
    [
      331802
    ]
  ],
  "./id/password_complexity_configuration.json": [
    "824176",
    [
      479372
    ]
  ],
  "./nb-x-k12/collaborations.json": [
    "822810",
    [
      220458
    ]
  ],
  "./vi/ProfileTray.json": [
    "703470",
    [
      204646
    ]
  ],
  "./pl/FindOutcomesModal.json": [
    "711549",
    [
      374815
    ]
  ],
  "./pt/discussion_topics.json": [
    "785195",
    [
      864365
    ]
  ],
  "./mi/course_paces_modal.json": [
    "524728",
    [
      656840
    ]
  ],
  "./nb/student_annotation_preview.json": [
    "687704",
    [
      142428
    ]
  ],
  "./sv/rubrics-export.json": [
    "27862",
    [
      363962
    ]
  ],
  "./es-ES/blueprint_settingsCoursePicker.json": [
    "299447",
    [
      140765
    ]
  ],
  "./tr/assignment_show.json": [
    "651851",
    [
      221949
    ]
  ],
  "./ms/internal-settings.json": [
    "884939",
    [
      164465
    ]
  ],
  "./en-AU-x-unimelb/course_paces_time_selection.json": [
    "141713",
    [
      191995
    ]
  ],
  "./es-ES/course_restore.json": [
    "851053",
    [
      688411
    ]
  ],
  "./is/discussion_pinned_post.json": [
    "483416",
    [
      545664
    ]
  ],
  "./pl/gradinggradingPeriodCollection.json": [
    "697915",
    [
      690813
    ]
  ],
  "./fr/assignments_2_MoreOptions_CanvasFiles.json": [
    "817139",
    [
      233722
    ]
  ],
  "./tr/course_search_results.json": [
    "19431",
    [
      153097
    ]
  ],
  "./id/account_calendar_settings_utils.json": [
    "316335",
    [
      877153
    ]
  ],
  "./hi/permissions_role_tray.json": [
    "793131",
    [
      278697
    ]
  ],
  "./hu/discovery_page.json": [
    "650975",
    [
      635293
    ]
  ],
  "./es-ES/AssignmentGroupListItemView.json": [
    "892681",
    [
      354927
    ]
  ],
  "./fr/progress_pill.json": [
    "520245",
    [
      687952
    ]
  ],
  "./ms/NewTabIndicator.json": [
    "880816",
    [
      603376
    ]
  ],
  "./nl/sis_import.json": [
    "427748",
    [
      184505
    ]
  ],
  "./hi/OutcomeDescriptionModal.json": [
    "20646",
    [
      966846
    ]
  ],
  "./it/assignments_2_MoreOptions_CanvasFiles.json": [
    "932002",
    [
      600014
    ]
  ],
  "./es/knowledge_check_not_ready.json": [
    "590771",
    [
      752254
    ]
  ],
  "./fr/blueprint_settingsCoursePicker.json": [
    "372396",
    [
      580490
    ]
  ],
  "./ca/LearningMasteryGradebook.json": [
    "860401",
    [
      753279
    ]
  ],
  "./mi/upload_button.json": [
    "454786",
    [
      828602
    ]
  ],
  "./ms/student_groups.json": [
    "511302",
    [
      160358
    ]
  ],
  "./it/CreateEditAssignmentModal.json": [
    "780225",
    [
      21739
    ]
  ],
  "./fr-CA/course_navigation_settings.json": [
    "385401",
    [
      739427
    ]
  ],
  "./en-AU-x-unimelb/assignmentsIndexView.json": [
    "322589",
    [
      56791
    ]
  ],
  "./uk/submit_assignment.json": [
    "478338",
    [
      900906
    ]
  ],
  "./hy/AlignmentSummary.json": [
    "551288",
    [
      598064
    ]
  ],
  "./nb-x-k12/module_sequence_footer.json": [
    "206074",
    [
      805658
    ]
  ],
  "./uk/confirmMasteryModal.json": [
    "776132",
    [
      701804
    ]
  ],
  "./da-x-k12/remove_pace_warning_modal.json": [
    "443496",
    [
      942908
    ]
  ],
  "./hi/content_shares.json": [
    "822973",
    [
      993611
    ]
  ],
  "./ar/account_notification_settings.json": [
    "628608",
    [
      106820
    ]
  ],
  "./es-ES/announcements_on_home_page.json": [
    "514125",
    [
      856203
    ]
  ],
  "./ca/assignments_2_text_entry.json": [
    "614302",
    [
      410366
    ]
  ],
  "./hi/sharedSetDefaultGradeDialog.json": [
    "666498",
    [
      461282
    ]
  ],
  "./ht/roster_section_input.json": [
    "383906",
    [
      67222
    ]
  ],
  "./ga/account_calendar_settings_account_calendar_item_dropdown.json": [
    "404657",
    [
      21463
    ]
  ],
  "./ga/assignments_2_media_attempt.json": [
    "696672",
    [
      537640
    ]
  ],
  "./ru/user_date_range_search.json": [
    "971606",
    [
      402126
    ]
  ],
  "./el/course_paces_header.json": [
    "886041",
    [
      555187
    ]
  ],
  "./da-x-k12/direct_share_course_import_panel.json": [
    "452613",
    [
      376743
    ]
  ],
  "./nl/announcements_v2.json": [
    "204153",
    [
      133515
    ]
  ],
  "./sv/gradinggradingPeriodCollection.json": [
    "2036",
    [
      114904
    ]
  ],
  "./tr/user_name.json": [
    "613171",
    [
      838957
    ]
  ],
  "./en-GB-x-lbs/filter_calendars_modal.json": [
    "267440",
    [
      446904
    ]
  ],
  "./ht/gradebook_history.json": [
    "169311",
    [
      997041
    ]
  ],
  "./mi/accessibility_checker.json": [
    "450792",
    [
      392248
    ]
  ],
  "./cy/dashboard_grades_page.json": [
    "501215",
    [
      410109
    ]
  ],
  "./is/account_calendar_settings_account_group.json": [
    "427820",
    [
      849548
    ]
  ],
  "./en-GB-x-lbs/react_scheduler.json": [
    "364529",
    [
      292999
    ]
  ],
  "./ga/course_paces_pace_picker.json": [
    "908553",
    [
      570255
    ]
  ],
  "./pt-BR/calendar_custom_recurring_event_natural_language.json": [
    "306181",
    [
      626132
    ]
  ],
  "./zh-Hant/grade_summary.json": [
    "293580",
    [
      273360
    ]
  ],
  "./nl/k5_dashboard_card.json": [
    "885066",
    [
      200166
    ]
  ],
  "./hu/users.json": [
    "322781",
    [
      970611
    ]
  ],
  "./ga/eportfolio.json": [
    "914119",
    [
      591965
    ]
  ],
  "./ja/learning_mastery_gradebook.json": [
    "592052",
    [
      137265
    ]
  ],
  "./de/assignments_2_text_entry.json": [
    "553063",
    [
      439266
    ]
  ],
  "./fa/grades_summary.json": [
    "137606",
    [
      336542
    ]
  ],
  "./ja/react_scheduler.json": [
    "581078",
    [
      80407
    ]
  ],
  "./pt/HelpTray.json": [
    "407785",
    [
      774923
    ]
  ],
  "./sl/unpublished_changes_tray_contents.json": [
    "905012",
    [
      642272
    ]
  ],
  "./ms/sections_tooltip.json": [
    "107986",
    [
      253290
    ]
  ],
  "./he/MasteryScale.json": [
    "658078",
    [
      907982
    ]
  ],
  "./nl/course_paces_pace_picker.json": [
    "987363",
    [
      268085
    ]
  ],
  "./uk/peer-review-assignment-widget.json": [
    "724332",
    [
      326884
    ]
  ],
  "./nb-x-k12/new_nav.json": [
    "746856",
    [
      340496
    ]
  ],
  "./fr/plugins.json": [
    "842382",
    [
      266915
    ]
  ],
  "./cy/user_grades.json": [
    "128858",
    [
      784322
    ]
  ],
  "./ht/LearningMasteryGradebook.json": [
    "991033",
    [
      394235
    ]
  ],
  "./ms/content_migrations_redesign.json": [
    "234169",
    [
      990599
    ]
  ],
  "./vi/assignments_2_file_upload.json": [
    "285385",
    [
      395631
    ]
  ],
  "./en-AU-x-unimelb/assignments_2_login_action_prompt.json": [
    "620905",
    [
      426403
    ]
  ],
  "./hy/courses_show.json": [
    "748681",
    [
      433087
    ]
  ],
  "./sl/grades_empty_page.json": [
    "772753",
    [
      273595
    ]
  ],
  "./zh-Hans/progress_pill.json": [
    "821078",
    [
      702846
    ]
  ],
  "./sv-x-k12/peer_review_allocation_rules_tray.json": [
    "478596",
    [
      908260
    ]
  ],
  "./es/course_paces_blackout_dates_modal.json": [
    "656152",
    [
      9005
    ]
  ],
  "./en-AU-x-unimelb/discussion_row.json": [
    "1081",
    [
      523843
    ]
  ],
  "./it/blueprint_settingsUnsyncedChanges.json": [
    "225462",
    [
      256298
    ]
  ],
  "./is/auth_logging.json": [
    "483910",
    [
      263678
    ]
  ],
  "./sl/bulk_edit_students.json": [
    "838889",
    [
      949491
    ]
  ],
  "./da/account_notification_settings.json": [
    "97620",
    [
      85340
    ]
  ],
  "./ms/student_annotation_preview.json": [
    "125472",
    [
      353664
    ]
  ],
  "./uk/user_date_range_search.json": [
    "279601",
    [
      48831
    ]
  ],
  "./zh-Hans/assignments_2_url_entry.json": [
    "311975",
    [
      789677
    ]
  ],
  "./cy/assignment_2_assignment_toggle_details.json": [
    "796126",
    [
      567502
    ]
  ],
  "./el/comm_messages.json": [
    "989670",
    [
      426122
    ]
  ],
  "./zh-Hans/assignments_2_student_header_date_title.json": [
    "300354",
    [
      53186
    ]
  ],
  "./el/edit_section_end_date.json": [
    "24452",
    [
      778736
    ]
  ],
  "./ru/accessibility_course_statistics.json": [
    "92421",
    [
      838051
    ]
  ],
  "./sv/eportfolio.json": [
    "961980",
    [
      607112
    ]
  ],
  "./is/enhanced_individual_gradebook_submit_score.json": [
    "291241",
    [
      269455
    ]
  ],
  "./da/course_paces_change_tracking.json": [
    "249078",
    [
      921670
    ]
  ],
  "./es-ES/quiz_migration_notifications.json": [
    "388468",
    [
      233236
    ]
  ],
  "./fr/peer_review_student_select.json": [
    "548116",
    [
      241237
    ]
  ],
  "./he/assignmentsIndexView.json": [
    "725516",
    [
      224852
    ]
  ],
  "./pt/canvas_file_upload.json": [
    "74675",
    [
      740541
    ]
  ],
  "./nb-x-k12/SpeedGraderCheckpoints.json": [
    "520367",
    [
      995829
    ]
  ],
  "./ga/quiz_statistics.json": [
    "756711",
    [
      146733
    ]
  ],
  "./it/editAssignmentGroupWeights.json": [
    "416608",
    [
      146324
    ]
  ],
  "./nn/notebook_index.json": [
    "932340",
    [
      257056
    ]
  ],
  "./nb/bulk_edit_students.json": [
    "269616",
    [
      361668
    ]
  ],
  "./sv-x-k12/file_not_found.json": [
    "873044",
    [
      820948
    ]
  ],
  "./da-x-k12/ldap_cert_upload.json": [
    "83553",
    [
      166403
    ]
  ],
  "./it/sections_tooltip.json": [
    "14993",
    [
      962275
    ]
  ],
  "./ru/assignments_2_login_action_prompt.json": [
    "130812",
    [
      773740
    ]
  ],
  "./th/link_to_students.json": [
    "341695",
    [
      391625
    ]
  ],
  "./ht/assignments_2_media_attempt.json": [
    "142444",
    [
      558864
    ]
  ],
  "./en-AU/enhanced_individual_gradebook_submit_score.json": [
    "629047",
    [
      954906
    ]
  ],
  "./en-AU/quiz_show.json": [
    "408939",
    [
      474118
    ]
  ],
  "./id/account_calendar_settings_footer.json": [
    "164833",
    [
      613547
    ]
  ],
  "./nb-x-k12/choose_mastery_path.json": [
    "523119",
    [
      678101
    ]
  ],
  "./da.json": [
    "833602",
    [
      231732
    ]
  ],
  "./hu/dashboard_grades_page.json": [
    "359080",
    [
      603352
    ]
  ],
  "./fr/course_restore.json": [
    "273022",
    [
      365403
    ]
  ],
  "./pt/confirmMasteryModal.json": [
    "416148",
    [
      708344
    ]
  ],
  "./zh-Hant/roster_section_selector.json": [
    "887777",
    [
      488099
    ]
  ],
  "./nb-x-k12/ignite_agent.json": [
    "916024",
    [
      399696
    ]
  ],
  "./fa/quizzes.take_quiz.json": [
    "118469",
    [
      790930
    ]
  ],
  "./zh-Hans/manage_avatars.json": [
    "177313",
    [
      715799
    ]
  ],
  "./mi/react_files.json": [
    "66371",
    [
      614745
    ]
  ],
  "./hu/gradebook_default_gradebook_components_content_filters_module_filter.json": [
    "827167",
    [
      282205
    ]
  ],
  "./ar/external_content_cancel.json": [
    "946553",
    [
      2555
    ]
  ],
  "./en-AU-x-unimelb/MobileGlobalMenu.json": [
    "841212",
    [
      541624
    ]
  ],
  "./es-ES/webzip_export.json": [
    "302819",
    [
      130241
    ]
  ],
  "./ms/assignments_2_url_entry.json": [
    "900608",
    [
      978656
    ]
  ],
  "./de/conferences.json": [
    "947522",
    [
      54467
    ]
  ],
  "./en-GB-x-ukhe/OutcomeMoveModal.json": [
    "933774",
    [
      11766
    ]
  ],
  "./fr-CA/youtube_migration.json": [
    "953085",
    [
      907679
    ]
  ],
  "./ar/account_course_user_search.json": [
    "407969",
    [
      513043
    ]
  ],
  "./ht/permissions.json": [
    "125166",
    [
      899298
    ]
  ],
  "./hu/jobs.json": [
    "485275",
    [
      688929
    ]
  ],
  "./es/outcome_management.json": [
    "351512",
    [
      470061
    ]
  ],
  "./sv/grade_change_logging_content.json": [
    "619337",
    [
      692683
    ]
  ],
  "./nn/epub_exports.json": [
    "237544",
    [
      363756
    ]
  ],
  "./ja/outcome_detail.json": [
    "557197",
    [
      724132
    ]
  ],
  "./ja/theme_collection_view.json": [
    "772617",
    [
      910664
    ]
  ],
  "./mi/empty_course.json": [
    "66219",
    [
      169649
    ]
  ],
  "./nb/theme_editor.json": [
    "96881",
    [
      933507
    ]
  ],
  "./hi/course_link_validator.json": [
    "114902",
    [
      617454
    ]
  ],
  "./hy/admin_split.json": [
    "805501",
    [
      142859
    ]
  ],
  "./id/bulk_edit_students_actions.json": [
    "250491",
    [
      774797
    ]
  ],
  "./he/modules_home_page.json": [
    "328428",
    [
      787668
    ]
  ],
  "./en-AU/calendar_sidebar.json": [
    "449925",
    [
      226012
    ]
  ],
  "./nn/terms_index.json": [
    "243854",
    [
      66146
    ]
  ],
  "./nb-x-k12/eportfolio.json": [
    "532045",
    [
      551915
    ]
  ],
  "./sv-x-k12/discussion_insights.json": [
    "484757",
    [
      76675
    ]
  ],
  "./ko/k5_course.json": [
    "855484",
    [
      585364
    ]
  ],
  "./da-x-k12/quizzes_quiz_submission.json": [
    "667743",
    [
      720289
    ]
  ],
  "./mi/user_lists.json": [
    "358277",
    [
      912587
    ]
  ],
  "./en-GB-x-ukhe/bulk_edit_students.json": [
    "144062",
    [
      779078
    ]
  ],
  "./ko/AlignmentSummary.json": [
    "388035",
    [
      816169
    ]
  ],
  "./ht/course_paces_assignment_row.json": [
    "658783",
    [
      17801
    ]
  ],
  "./mi/sharedSetDefaultGradeDialog.json": [
    "379651",
    [
      514681
    ]
  ],
  "./hi/remove_pace_warning_modal.json": [
    "284474",
    [
      958250
    ]
  ],
  "./tr/video_conference.json": [
    "797834",
    [
      637214
    ]
  ],
  "./pt-BR/change_password.json": [
    "514691",
    [
      607942
    ]
  ],
  "./zh-Hant/AddGroup.json": [
    "417786",
    [
      371542
    ]
  ],
  "./zh-Hans/discussion_insights.json": [
    "788797",
    [
      484155
    ]
  ],
  "./de/important_dates_empty.json": [
    "680619",
    [
      9870
    ]
  ],
  "./hu/peer_review_configuration_tray.json": [
    "32146",
    [
      605738
    ]
  ],
  "./is/course_paces_blackout_dates_modal.json": [
    "426132",
    [
      318820
    ]
  ],
  "./ru/account_calendars_modal.json": [
    "516018",
    [
      37458
    ]
  ],
  "./cy/users.json": [
    "755470",
    [
      626910
    ]
  ],
  "./da/IndividualStudentMasteryOutcome.json": [
    "928160",
    [
      363920
    ]
  ],
  "./fr/discussion_insights.json": [
    "943846",
    [
      446699
    ]
  ],
  "./en-GB/bulk_edit_students.json": [
    "694659",
    [
      444386
    ]
  ],
  "./es-ES/editGroup.json": [
    "142584",
    [
      3200
    ]
  ],
  "./mi/HelpTray.json": [
    "701395",
    [
      3785
    ]
  ],
  "./fr-CA/blueprint_settingsCoursePickerTable.json": [
    "738129",
    [
      543171
    ]
  ],
  "./nb/gradebook_uploads.json": [
    "220817",
    [
      803187
    ]
  ],
  "./nl/account_calendar_settings_account_tree.json": [
    "309799",
    [
      369545
    ]
  ],
  "./pl/accessibility_course_statistics.json": [
    "152324",
    [
      554248
    ]
  ],
  "./ga/grades_summary.json": [
    "488441",
    [
      525439
    ]
  ],
  "./ar/error_form.json": [
    "559674",
    [
      575982
    ]
  ],
  "./sl/conferences_alternatives.json": [
    "87663",
    [
      119721
    ]
  ],
  "./sv-x-k12/available_pronouns_list.json": [
    "626056",
    [
      996096
    ]
  ],
  "./pt/ai_experiences_ai_conversations.json": [
    "100718",
    [
      923738
    ]
  ],
  "./ar/pairing_code_user_observees.json": [
    "95388",
    [
      567136
    ]
  ],
  "./en-GB/blueprint_settingsMigrationSync.json": [
    "637019",
    [
      906914
    ]
  ],
  "./da/ai_experiences_edit.json": [
    "367476",
    [
      872956
    ]
  ],
  "./ca/sidenav.json": [
    "78610",
    [
      288954
    ]
  ],
  "./fr/assignments_peer_reviews.json": [
    "3199",
    [
      966606
    ]
  ],
  "./hy/MobileGlobalMenu.json": [
    "947073",
    [
      598935
    ]
  ],
  "./fr/remove_pace_warning_modal.json": [
    "976953",
    [
      874068
    ]
  ],
  "./da-x-k12/course_statistics.json": [
    "801506",
    [
      333694
    ]
  ],
  "./he/horizon_toggle.json": [
    "232703",
    [
      506749
    ]
  ],
  "./ja/top_navigation_tools.json": [
    "587631",
    [
      985970
    ]
  ],
  "./ga/courses_show.json": [
    "455100",
    [
      354940
    ]
  ],
  "./th/course_paces_module.json": [
    "946765",
    [
      876839
    ]
  ],
  "./nb/error_form.json": [
    "850363",
    [
      741581
    ]
  ],
  "./ru/grades_summary.json": [
    "492142",
    [
      267206
    ]
  ],
  "./ht/last_attended.json": [
    "524982",
    [
      762170
    ]
  ],
  "./cy/submit_online_url_assignment.json": [
    "930182",
    [
      675174
    ]
  ],
  "./ko/paginated_list.json": [
    "424416",
    [
      566160
    ]
  ],
  "./da/suppress_notifications.json": [
    "194251",
    [
      742625
    ]
  ],
  "./id/content_copy_redesign.json": [
    "71700",
    [
      714504
    ]
  ],
  "./ms/use_switch_experience.json": [
    "466035",
    [
      732137
    ]
  ],
  "./ko/account_calendar_settings.json": [
    "272098",
    [
      38890
    ]
  ],
  "./fr-CA/quizzes_quiz_submission.json": [
    "375671",
    [
      191617
    ]
  ],
  "./nl/direct_share_course_import_panel.json": [
    "584012",
    [
      705856
    ]
  ],
  "./nb-x-k12/homeroom_page.json": [
    "359630",
    [
      224694
    ]
  ],
  "./de/account_calendar_settings_account_calendar_item.json": [
    "867520",
    [
      733885
    ]
  ],
  "./fr-CA/user.json": [
    "591298",
    [
      199478
    ]
  ],
  "./cy/reset_pace_warning_modal.json": [
    "310084",
    [
      873820
    ]
  ],
  "./ca/account_calendar_settings_account_tree.json": [
    "266141",
    [
      877859
    ]
  ],
  "./en-GB-x-lbs/jobs_v2.json": [
    "824205",
    [
      299163
    ]
  ],
  "./pl/course_paces_change_tracking.json": [
    "572711",
    [
      117529
    ]
  ],
  "./zh-Hans/user_date_range_search.json": [
    "127920",
    [
      77672
    ]
  ],
  "./pt/learning_mastery_gradebook.json": [
    "618551",
    [
      339113
    ]
  ],
  "./sv/roster_section_input.json": [
    "923965",
    [
      875247
    ]
  ],
  "./zh-Hans/error_form.json": [
    "722578",
    [
      600082
    ]
  ],
  "./da/content_shares.json": [
    "73145",
    [
      219863
    ]
  ],
  "./it/course_paces_projected_dates.json": [
    "523930",
    [
      675582
    ]
  ],
  "./cy/question_banks.json": [
    "458678",
    [
      357046
    ]
  ],
  "./pt-BR/discussion_topics_edit.json": [
    "951939",
    [
      125094
    ]
  ],
  "./hi/permissions.json": [
    "394621",
    [
      727259
    ]
  ],
  "./ja/GroupDetailView.json": [
    "427932",
    [
      539929
    ]
  ],
  "./vi/k5_dashboard_card.json": [
    "926673",
    [
      601671
    ]
  ],
  "./pt-BR/SpeedGraderCheckpoints.json": [
    "401206",
    [
      646687
    ]
  ],
  "./ca/roster_section_input.json": [
    "701002",
    [
      558210
    ]
  ],
  "./fr/assignments_2_peer_review.json": [
    "768847",
    [
      603550
    ]
  ],
  "./sv/user_lists.json": [
    "861848",
    [
      225836
    ]
  ],
  "./nb/edit_section_view.json": [
    "586658",
    [
      176222
    ]
  ],
  "./en-AU/assignment_show.json": [
    "633171",
    [
      385870
    ]
  ],
  "./fa/moderate_quiz.json": [
    "748508",
    [
      222076
    ]
  ],
  "./da-x-k12/question_bank.json": [
    "894028",
    [
      133224
    ]
  ],
  "./da-x-k12/blueprint_settingsUnsyncedChanges.json": [
    "959922",
    [
      649118
    ]
  ],
  "./hi/empty_course.json": [
    "268716",
    [
      245756
    ]
  ],
  "./tr/course_pace_date_input.json": [
    "927017",
    [
      110459
    ]
  ],
  "./zh-Hans/blueprint_settingsCoursePicker.json": [
    "816473",
    [
      631999
    ]
  ],
  "./da-x-k12/add_edit_pseudonym.json": [
    "827988",
    [
      390968
    ]
  ],
  "./en-GB-x-ukhe/LogoutButton.json": [
    "919730",
    [
      207410
    ]
  ],
  "./en-GB-x-ukhe/gradingGradeSummary.json": [
    "799506",
    [
      121603
    ]
  ],
  "./nb-x-k12/MobileGlobalMenu.json": [
    "544978",
    [
      890162
    ]
  ],
  "./ms/courses.show.json": [
    "208715",
    [
      652298
    ]
  ],
  "./vi/assignment_show.json": [
    "117348",
    [
      93108
    ]
  ],
  "./ht/self_unenrollment_modal.json": [
    "501812",
    [
      782112
    ]
  ],
  "./ga/assignments_2_student_header.json": [
    "757799",
    [
      718525
    ]
  ],
  "./sv-x-k12/SpeedGraderSettingsMenu.json": [
    "90535",
    [
      885261
    ]
  ],
  "./ca/AccountsTray.json": [
    "603538",
    [
      524410
    ]
  ],
  "./ja/account_notification_settings.json": [
    "701642",
    [
      666867
    ]
  ],
  "./ht/filter_calendars_modal.json": [
    "960402",
    [
      787062
    ]
  ],
  "./nl/add_edit_pseudonym.json": [
    "223669",
    [
      693479
    ]
  ],
  "./sv-x-k12/discussion_topics.json": [
    "557728",
    [
      959304
    ]
  ],
  "./th/question_bank.json": [
    "220961",
    [
      510491
    ]
  ],
  "./en-AU/user.json": [
    "729575",
    [
      168586
    ]
  ],
  "./nl/content_copy_redesign.json": [
    "693695",
    [
      799129
    ]
  ],
  "./tr/media_immersive_view.json": [
    "589560",
    [
      903468
    ]
  ],
  "./zh-Hant/unpublished_changes_tray_contents.json": [
    "361529",
    [
      904483
    ]
  ],
  "./id/mutationActivity.json": [
    "546631",
    [
      992817
    ]
  ],
  "./ga/discussion_pinned_post.json": [
    "755072",
    [
      606872
    ]
  ],
  "./ru/course_paces_no_results.json": [
    "750814",
    [
      325238
    ]
  ],
  "./en-GB-x-lbs/user_name.json": [
    "346015",
    [
      352661
    ]
  ],
  "./el/copy_course.json": [
    "202912",
    [
      367484
    ]
  ],
  "./hi/course_paces_actions.json": [
    "387997",
    [
      380379
    ]
  ],
  "./zh-Hant/outcome_detail.json": [
    "517516",
    [
      819912
    ]
  ],
  "./ko/epub_exports.json": [
    "140826",
    [
      880754
    ]
  ],
  "./ca/quiz_show.json": [
    "11461",
    [
      156027
    ]
  ],
  "./nb-x-k12/blueprint_settingsCoursePickerTable.json": [
    "426594",
    [
      386178
    ]
  ],
  "./nb/change_password.json": [
    "57838",
    [
      91098
    ]
  ],
  "./he/video_conference.json": [
    "155153",
    [
      167599
    ]
  ],
  "./ko/assignments.no_assignments_search.json": [
    "41331",
    [
      693080
    ]
  ],
  "./pt/content_copy_redesign.json": [
    "365950",
    [
      173939
    ]
  ],
  "./hy/permissions_v2.json": [
    "99014",
    [
      819886
    ]
  ],
  "./is/video_conference.json": [
    "222888",
    [
      483472
    ]
  ],
  "./fr/change_password.json": [
    "18326",
    [
      843363
    ]
  ],
  "./nb-x-k12/account_calendar_settings_account_tree.json": [
    "205979",
    [
      582649
    ]
  ],
  "./nn/OutcomeDescriptionModal.json": [
    "75209",
    [
      350283
    ]
  ],
  "./nn/gradinggradingPeriodCollection.json": [
    "287039",
    [
      513521
    ]
  ],
  "./tr/NewTabIndicator.json": [
    "181166",
    [
      865586
    ]
  ],
  "./zh-Hant/discovery_page.json": [
    "256896",
    [
      576548
    ]
  ],
  "./fr-CA/sharedCurveGradesDialog.json": [
    "93883",
    [
      765461
    ]
  ],
  "./en-GB-x-ukhe/modules_home_page.json": [
    "478841",
    [
      316303
    ]
  ],
  "./ga/self_unenrollment_modal.json": [
    "468912",
    [
      227528
    ]
  ],
  "./en-GB-x-lbs/peer_review_allocation_rules_tray.json": [
    "932941",
    [
      314395
    ]
  ],
  "./pl/outcome_reporting.json": [
    "970099",
    [
      499997
    ]
  ],
  "./da/calendar_appointment_group_edit.json": [
    "721280",
    [
      340784
    ]
  ],
  "./pt-BR/assignments_2_MoreOptions.json": [
    "540458",
    [
      745947
    ]
  ],
  "./da/course_paces_search.json": [
    "93026",
    [
      932842
    ]
  ],
  "./hy/assignments_2_submission_histories_query.json": [
    "465335",
    [
      241997
    ]
  ],
  "./en-GB-x-ukhe/widget_dashboard.json": [
    "166471",
    [
      560333
    ]
  ],
  "./he/course_template_details.json": [
    "895912",
    [
      441464
    ]
  ],
  "./th/collaborations.json": [
    "294324",
    [
      243520
    ]
  ],
  "./ar/blueprint_settingsMigrationSync.json": [
    "910693",
    [
      744343
    ]
  ],
  "./tr/discussion_insights.json": [
    "178060",
    [
      751128
    ]
  ],
  "./zh-Hans/discussion_posts.json": [
    "710039",
    [
      397293
    ]
  ],
  "./ar/grade_change_logging_content.json": [
    "733023",
    [
      205505
    ]
  ],
  "./en-GB-x-lbs/lti_registrations.json": [
    "124590",
    [
      973558
    ]
  ],
  "./zh-Hant/course_paces_time_selection.json": [
    "101815",
    [
      106873
    ]
  ],
  "./th/gradebook_uploads.json": [
    "445433",
    [
      200731
    ]
  ],
  "./ca/copy_warnings_modal.json": [
    "923479",
    [
      384021
    ]
  ],
  "./da/assignments_2_student_points_display.json": [
    "292265",
    [
      178695
    ]
  ],
  "./en-CA/dashboard.json": [
    "536862",
    [
      855625
    ]
  ],
  "./en-GB/media_player_iframe_content.json": [
    "222972",
    [
      950133
    ]
  ],
  "./he/gradebook_default_gradebook_components_content_filters_module_filter.json": [
    "462287",
    [
      202573
    ]
  ],
  "./nl/content_share_preview_overlay.json": [
    "114209",
    [
      858011
    ]
  ],
  "./nb/course_paces_no_results.json": [
    "755235",
    [
      444629
    ]
  ],
  "./de/assignmentsIndexView.json": [
    "195688",
    [
      520421
    ]
  ],
  "./pl/discussion_insights.json": [
    "780638",
    [
      373362
    ]
  ],
  "./es-ES/user_profile.json": [
    "159416",
    [
      332624
    ]
  ],
  "./sv/jobs_v2.json": [
    "83726",
    [
      216138
    ]
  ],
  "./th/appointment_groups.json": [
    "366488",
    [
      74556
    ]
  ],
  "./en/assignments_2_student_header_date_title.json": [
    "9706",
    [
      740086
    ]
  ],
  "./is/blueprint_coursesExpandableLockOptions.json": [
    "76255",
    [
      391013
    ]
  ],
  "./cy/courses.show.json": [
    "195779",
    [
      324690
    ]
  ],
  "./ca/custom_emoji_deny_list.json": [
    "437380",
    [
      493484
    ]
  ],
  "./en-AU-x-unimelb/blueprint_course_sidebar.json": [
    "759288",
    [
      622172
    ]
  ],
  "./en-AU/quiz_log_auditing.json": [
    "434620",
    [
      104665
    ]
  ],
  "./is/quizzes_index.json": [
    "273168",
    [
      230344
    ]
  ],
  "./it/NewTabIndicator.json": [
    "15901",
    [
      248463
    ]
  ],
  "./sl/file_not_found.json": [
    "344140",
    [
      32064
    ]
  ],
  "./es-ES/ai_experiences.json": [
    "539777",
    [
      259671
    ]
  ],
  "./en-GB-x-ukhe/discussion_posts.json": [
    "113692",
    [
      557852
    ]
  ],
  "./ar/quizzes_index.json": [
    "780663",
    [
      90553
    ]
  ],
  "./da/comm_messages.json": [
    "153740",
    [
      909860
    ]
  ],
  "./sv-x-k12/blueprint_settingsUnsyncedChanges.json": [
    "757824",
    [
      722984
    ]
  ],
  "./is/assignmentsIndexView.json": [
    "312769",
    [
      238551
    ]
  ],
  "./ga/not_found_page_slide_puzzle.json": [
    "562589",
    [
      588971
    ]
  ],
  "./nn/assignments_2_attempt_tab.json": [
    "581371",
    [
      849333
    ]
  ],
  "./da/AssignmentGroupListItemView.json": [
    "316083",
    [
      80793
    ]
  ],
  "./ko/assignments_peer_reviews.json": [
    "518357",
    [
      105387
    ]
  ],
  "./en-GB-x-lbs/theme_editor.json": [
    "962623",
    [
      576965
    ]
  ],
  "./en-GB-x-ukhe/calendar_custom_recurring_event_natural_language.json": [
    "173016",
    [
      259808
    ]
  ],
  "./hi/job_stats.json": [
    "776242",
    [
      30834
    ]
  ],
  "./ar/submit_assignment.json": [
    "835909",
    [
      875023
    ]
  ],
  "./is/account_calendars_modal.json": [
    "64687",
    [
      187493
    ]
  ],
  "./nn/CreateEditAssignmentModal.json": [
    "941876",
    [
      333928
    ]
  ],
  "./es/blueprint_course_child.json": [
    "800598",
    [
      180071
    ]
  ],
  "./es-ES/account_calendars.json": [
    "598216",
    [
      535872
    ]
  ],
  "./sv-x-k12/remove_pace_warning_modal.json": [
    "177242",
    [
      732010
    ]
  ],
  "./it/assignments_2_submission_helpers.json": [
    "10231",
    [
      554345
    ]
  ],
  "./ar/folder_tree.json": [
    "86028",
    [
      454624
    ]
  ],
  "./da-x-k12/account_notification_settings.json": [
    "214930",
    [
      867750
    ]
  ],
  "./ja/outcome_management.json": [
    "694547",
    [
      468910
    ]
  ],
  "./tr/edit_section_start_date.json": [
    "791296",
    [
      105548
    ]
  ],
  "./en-AU-x-unimelb/submit_assignment.json": [
    "421602",
    [
      709062
    ]
  ],
  "./fr-CA/grade_details.json": [
    "129513",
    [
      988395
    ]
  ],
  "./ko/assignments_2_media_attempt.json": [
    "962298",
    [
      555858
    ]
  ],
  "./ms/AlignmentSummary.json": [
    "82890",
    [
      775635
    ]
  ],
  "./fr-CA/unpublished_changes_tray_contents.json": [
    "174",
    [
      869194
    ]
  ],
  "./ms/empty_modules.json": [
    "688637",
    [
      740787
    ]
  ],
  "./nb/content_shares.json": [
    "924772",
    [
      196632
    ]
  ],
  "./nb/assignment_index_menu.json": [
    "200922",
    [
      948638
    ]
  ],
  "./th/bulk_edit_students.json": [
    "936744",
    [
      81340
    ]
  ],
  "./fi/accessibility_scan.json": [
    "329949",
    [
      777979
    ]
  ],
  "./is/manage_avatars.json": [
    "889028",
    [
      331332
    ]
  ],
  "./ko/peer_review_configuration_tray.json": [
    "969069",
    [
      306387
    ]
  ],
  "./fr-CA/calendar_sidebar.json": [
    "554856",
    [
      698748
    ]
  ],
  "./el/todo.json": [
    "614405",
    [
      334743
    ]
  ],
  "./ko/self_unenrollment_modal.json": [
    "784506",
    [
      749906
    ]
  ],
  "./th/confirmMasteryModal.json": [
    "151956",
    [
      837224
    ]
  ],
  "./fr/a2LatePolicyToolTipContent.json": [
    "877903",
    [
      429310
    ]
  ],
  "./es-ES/permissions_v2.json": [
    "281100",
    [
      516476
    ]
  ],
  "./nb/discussionTopicKeyboradShortcutModal.json": [
    "517385",
    [
      911048
    ]
  ],
  "./sl/upload_button.json": [
    "156407",
    [
      619777
    ]
  ],
  "./sv/course_paces_blackout_dates_modal.json": [
    "627441",
    [
      409195
    ]
  ],
  "./uk/announcements_on_home_page.json": [
    "614210",
    [
      555242
    ]
  ],
  "./nb-x-k12/edit_section_start_date.json": [
    "515592",
    [
      819920
    ]
  ],
  "./pl/ai_experiences_show.json": [
    "708186",
    [
      72558
    ]
  ],
  "./sv/AddGroup.json": [
    "177835",
    [
      486517
    ]
  ],
  "./uk/mutationActivity.json": [
    "664464",
    [
      720224
    ]
  ],
  "./zh-Hant/course_paces_actions.json": [
    "214142",
    [
      521170
    ]
  ],
  "./en-GB-x-lbs/restore_content_pane.json": [
    "596947",
    [
      484017
    ]
  ],
  "./zh-Hant/permissions_v2.json": [
    "810261",
    [
      346711
    ]
  ],
  "./da/course_paces_header.json": [
    "818063",
    [
      61501
    ]
  ],
  "./es-ES/appointment_groups.json": [
    "125367",
    [
      300989
    ]
  ],
  "./fr/link_validator.json": [
    "242459",
    [
      56850
    ]
  ],
  "./sl/last_attended.json": [
    "662925",
    [
      792799
    ]
  ],
  "./cy/student_entries.json": [
    "591574",
    [
      737526
    ]
  ],
  "./hi/permissions_v2.json": [
    "252790",
    [
      572190
    ]
  ],
  "./sv/account_calendar_settings_account_calendar_item.json": [
    "451742",
    [
      9338
    ]
  ],
  "./hu/folder_tree.json": [
    "211272",
    [
      984280
    ]
  ],
  "./en-GB-x-lbs/quizzes_openModerateStudentDialog.json": [
    "111962",
    [
      52842
    ]
  ],
  "./is/editGroup.json": [
    "670817",
    [
      318471
    ]
  ],
  "./tr/accessibility_scan.json": [
    "310860",
    [
      304216
    ]
  ],
  "./fa/terms_index.json": [
    "617239",
    [
      700765
    ]
  ],
  "./es/assignments_2_student_header_date_title.json": [
    "51269",
    [
      936396
    ]
  ],
  "./he/content_migrations.json": [
    "335900",
    [
      811780
    ]
  ],
  "./ar/course_paces_module.json": [
    "505066",
    [
      577654
    ]
  ],
  "./hy/ai_experiences_ai_conversations.json": [
    "336557",
    [
      418155
    ]
  ],
  "./tr/empty_modules.json": [
    "404643",
    [
      314509
    ]
  ],
  "./fr-CA/assignments_2_media_attempt.json": [
    "112797",
    [
      655839
    ]
  ],
  "./sv-x-k12/link_to_students.json": [
    "816422",
    [
      637505
    ]
  ],
  "./id/blueprint_course_sidebar.json": [
    "245391",
    [
      506417
    ]
  ],
  "./ca/add_edit_pseudonym.json": [
    "776743",
    [
      805029
    ]
  ],
  "./de/speed_grader_helpers.json": [
    "824710",
    [
      125631
    ]
  ],
  "./pt-BR/gradinggradingPeriodCollection.json": [
    "874096",
    [
      283629
    ]
  ],
  "./ja/video_conference.json": [
    "522275",
    [
      816830
    ]
  ],
  "./uk/comm_messages.json": [
    "483847",
    [
      126021
    ]
  ],
  "./fi/react_developer_keys.json": [
    "967418",
    [
      895962
    ]
  ],
  "./nb-x-k12/assignments.never_drop.json": [
    "245238",
    [
      248685
    ]
  ],
  "./hy/peer_review_allocation_rule_card.json": [
    "894037",
    [
      696547
    ]
  ],
  "./pt-BR/registration.json": [
    "382435",
    [
      767821
    ]
  ],
  "./ht/speed_grader_helpers.json": [
    "99231",
    [
      16129
    ]
  ],
  "./zh-Hant/course_paces_module.json": [
    "660611",
    [
      851421
    ]
  ],
  "./zh-Hant/unpublished_changes_button_props.json": [
    "457371",
    [
      985981
    ]
  ],
  "./ga/use_switch_experience.json": [
    "219375",
    [
      502002
    ]
  ],
  "./es/rubrics-export.json": [
    "41449",
    [
      309912
    ]
  ],
  "./ca/assignment_index.json": [
    "493436",
    [
      584884
    ]
  ],
  "./fa/dashboard_grades_page.json": [
    "78994",
    [
      301874
    ]
  ],
  "./uk/course_paces_modal.json": [
    "309918",
    [
      880446
    ]
  ],
  "./hu/context_prior_users.json": [
    "795230",
    [
      647182
    ]
  ],
  "./en-GB-x-ukhe/MobileGlobalMenu.json": [
    "932822",
    [
      487710
    ]
  ],
  "./nb/grade_change_logging_content.json": [
    "455494",
    [
      700202
    ]
  ],
  "./pt-BR/assignment_2_assignment_toggle_details.json": [
    "486513",
    [
      183848
    ]
  ],
  "./zh-Hant/peer_review_configuration_tray.json": [
    "580857",
    [
      812307
    ]
  ],
  "./ru/registration.json": [
    "291840",
    [
      241864
    ]
  ],
  "./en-AU-x-unimelb/grade_summary.json": [
    "556982",
    [
      648858
    ]
  ],
  "./nl/student_groups.json": [
    "809380",
    [
      446608
    ]
  ],
  "./ko.json": [
    "767367",
    [
      660439
    ]
  ],
  "./fr/outcome_management.json": [
    "463680",
    [
      928009
    ]
  ],
  "./pt-BR/submit_assignment.json": [
    "649723",
    [
      530350
    ]
  ],
  "./tr/SpeedGraderCheckpoints.json": [
    "491255",
    [
      562993
    ]
  ],
  "./el/entity_search_form.json": [
    "753198",
    [
      68618
    ]
  ],
  "./hi/context_prior_users.json": [
    "816522",
    [
      225114
    ]
  ],
  "./da/account_calendars_modal.json": [
    "44092",
    [
      378452
    ]
  ],
  "./nl/assignments_2_attempt_tab.json": [
    "857777",
    [
      940947
    ]
  ],
  "./ru/widget_dashboard.json": [
    "673466",
    [
      754762
    ]
  ],
  "./nb/calendar_appointment_group_edit.json": [
    "863587",
    [
      736909
    ]
  ],
  "./id/blueprint_settingsUnsyncedChanges.json": [
    "854534",
    [
      621562
    ]
  ],
  "./nl/AccountsTray.json": [
    "238628",
    [
      657272
    ]
  ],
  "./cy/eportfolio.json": [
    "298603",
    [
      396369
    ]
  ],
  "./el.json": [
    "944884",
    [
      340878
    ]
  ],
  "./id/student_entries.json": [
    "240515",
    [
      1197
    ]
  ],
  "./sv/assignments_2_student_annotation.json": [
    "47284",
    [
      661800
    ]
  ],
  "./pl/student_groups.json": [
    "41182",
    [
      583146
    ]
  ],
  "./it/discussion_settings.json": [
    "187559",
    [
      168673
    ]
  ],
  "./en-CA/sharedSetDefaultGradeDialog.json": [
    "281121",
    [
      25495
    ]
  ],
  "./es-ES/blueprint_settingsMigrationSync.json": [
    "699511",
    [
      164013
    ]
  ],
  "./ca/SpeedGraderPostGradesMenu.json": [
    "505615",
    [
      959453
    ]
  ],
  "./fr-CA/assignmentsIndexView.json": [
    "871114",
    [
      294990
    ]
  ],
  "./sv-x-k12/quizzes_public.json": [
    "230652",
    [
      798700
    ]
  ],
  "./ko/course_link_validator.json": [
    "546799",
    [
      787037
    ]
  ],
  "./en-AU-x-unimelb/content_copy_redesign.json": [
    "65985",
    [
      514651
    ]
  ],
  "./da/restore_content_pane.json": [
    "209860",
    [
      386444
    ]
  ],
  "./it/security_panel.json": [
    "45182",
    [
      789786
    ]
  ],
  "./zh-Hant/context_modules_v2.json": [
    "454654",
    [
      124314
    ]
  ],
  "./id/conferences.json": [
    "696680",
    [
      127036
    ]
  ],
  "./en-GB-x-ukhe/external_content_cancel.json": [
    "563540",
    [
      418356
    ]
  ],
  "./en-GB-x-lbs/quiz_log_auditing.json": [
    "994744",
    [
      704256
    ]
  ],
  "./fa/assignment_show.json": [
    "479500",
    [
      755564
    ]
  ],
  "./zh-Hant/file_not_found.json": [
    "270271",
    [
      122977
    ]
  ],
  "./zh-Hant/copy_course.json": [
    "476583",
    [
      538609
    ]
  ],
  "./el/editGroup.json": [
    "510676",
    [
      293648
    ]
  ],
  "./cy/nav_tourpoints.json": [
    "554045",
    [
      743251
    ]
  ],
  "./en-GB-x-lbs/gradingPeriodTemplate.json": [
    "442687",
    [
      175653
    ]
  ],
  "./th/gradebook.json": [
    "631920",
    [
      412460
    ]
  ],
  "./da/student_groups.json": [
    "741991",
    [
      241029
    ]
  ],
  "./en-CA/course_link_validator.json": [
    "652173",
    [
      891851
    ]
  ],
  "./sv/assignmentsIndexView.json": [
    "909946",
    [
      281662
    ]
  ],
  "./sv-x-k12/course_paces_actions.json": [
    "490493",
    [
      461979
    ]
  ],
  "./ca/student_groups.json": [
    "36166",
    [
      449654
    ]
  ],
  "./fr/course_paces_app.json": [
    "807896",
    [
      467465
    ]
  ],
  "./zh-Hant/blueprint_course_child.json": [
    "301780",
    [
      712376
    ]
  ],
  "./he/quizzes_quiz_submission.json": [
    "31305",
    [
      259095
    ]
  ],
  "./en-GB/files_v2.json": [
    "921593",
    [
      806508
    ]
  ],
  "./ar/knowledge_check_not_ready.json": [
    "321240",
    [
      491764
    ]
  ],
  "./vi/assignments.no_assignments_search.json": [
    "51044",
    [
      92949
    ]
  ],
  "./zh-Hant/assignments_2_student_points_display.json": [
    "894070",
    [
      581274
    ]
  ],
  "./pl/assignments_2_attempt_tab.json": [
    "192823",
    [
      136833
    ]
  ],
  "./da-x-k12/lti_registrations.json": [
    "455885",
    [
      461719
    ]
  ],
  "./fr/LearningMasteryGradebook.json": [
    "400097",
    [
      488900
    ]
  ],
  "./vi/calendar_custom_recurring_event_repeat_picker.json": [
    "658077",
    [
      810043
    ]
  ],
  "./el/gradingPeriodTemplate.json": [
    "867124",
    [
      71624
    ]
  ],
  "./da/assignment_index.json": [
    "232873",
    [
      371975
    ]
  ],
  "./es-ES/account_calendars_modal.json": [
    "560162",
    [
      360706
    ]
  ],
  "./pt/calendar.header.json": [
    "535703",
    [
      94194
    ]
  ],
  "./fr/user.json": [
    "785881",
    [
      313252
    ]
  ],
  "./ko/react_scheduler.json": [
    "387937",
    [
      598671
    ]
  ],
  "./nn/assignments.no_assignments_search.json": [
    "46617",
    [
      64302
    ]
  ],
  "./en-GB-x-ukhe/calculator_command.json": [
    "534558",
    [
      979302
    ]
  ],
  "./fr-CA/student_groups.json": [
    "114573",
    [
      9679
    ]
  ],
  "./he/nav_tourpoints.json": [
    "437940",
    [
      476876
    ]
  ],
  "./ht/accessibility_checker.json": [
    "251318",
    [
      531386
    ]
  ],
  "./de/account_calendar_settings_account_calendar_item_dropdown.json": [
    "197152",
    [
      499149
    ]
  ],
  "./es-ES/bulk_edit_students_table.json": [
    "230140",
    [
      553292
    ]
  ],
  "./pt-BR/assignments.never_drop.json": [
    "375879",
    [
      775106
    ]
  ],
  "./fi/course_restore.json": [
    "721437",
    [
      127803
    ]
  ],
  "./sv-x-k12/ProfileTray.json": [
    "588144",
    [
      97608
    ]
  ],
  "./ga/peer_review_allocation_rule_card.json": [
    "725296",
    [
      674472
    ]
  ],
  "./es/modelsQuiz.json": [
    "145625",
    [
      571336
    ]
  ],
  "./ms/MobileGlobalMenu.json": [
    "564444",
    [
      154052
    ]
  ],
  "./fr/default_account_quotas.json": [
    "546101",
    [
      861744
    ]
  ],
  "./sv/peer_reviews_student.json": [
    "427003",
    [
      849821
    ]
  ],
  "./nl/nav_tourpoints.json": [
    "883247",
    [
      513369
    ]
  ],
  "./zh-Hant/dashboard.json": [
    "998696",
    [
      114340
    ]
  ],
  "./pt-BR/discussion_posts.json": [
    "402009",
    [
      955824
    ]
  ],
  "./nn/terms_of_use.json": [
    "37875",
    [
      963333
    ]
  ],
  "./fa/last_attended.json": [
    "621551",
    [
      5605
    ]
  ],
  "./da/roster_section_selector.json": [
    "344768",
    [
      314352
    ]
  ],
  "./sl/HelpTray.json": [
    "483372",
    [
      729472
    ]
  ],
  "./uk/calendar_sidebar.json": [
    "360059",
    [
      580209
    ]
  ],
  "./sv/quantitative_data_options.json": [
    "113582",
    [
      974362
    ]
  ],
  "./hu/question_bank.json": [
    "832714",
    [
      503090
    ]
  ],
  "./vi/last_attended.json": [
    "207431",
    [
      953357
    ]
  ],
  "./ko/assignments_2_file_upload.json": [
    "957414",
    [
      695926
    ]
  ],
  "./fr/assignments_2_url_entry.json": [
    "647408",
    [
      288457
    ]
  ],
  "./pt/quizzes_openModerateStudentDialog.json": [
    "394844",
    [
      470392
    ]
  ],
  "./th/ai_experiences_edit.json": [
    "156879",
    [
      732577
    ]
  ],
  "./el/quizzes_regrade_modal.json": [
    "57543",
    [
      500281
    ]
  ],
  "./nl/grades_empty_page.json": [
    "168972",
    [
      176000
    ]
  ],
  "./pl/assignments_2_student_content.json": [
    "531843",
    [
      870197
    ]
  ],
  "./id/react_scheduler.json": [
    "409258",
    [
      68574
    ]
  ],
  "./ko/blueprint_settingsMigrationOptions.json": [
    "227491",
    [
      183625
    ]
  ],
  "./sv/comm_messages.json": [
    "817430",
    [
      233018
    ]
  ],
  "./fr/course_paces_search.json": [
    "466065",
    [
      631836
    ]
  ],
  "./mi/LogoutButton.json": [
    "156270",
    [
      548574
    ]
  ],
  "./hi/bulk_edit_students.json": [
    "654833",
    [
      936663
    ]
  ],
  "./fr-CA/course_link_validator.json": [
    "212631",
    [
      583008
    ]
  ],
  "./hy/NewTabIndicator.json": [
    "928467",
    [
      981809
    ]
  ],
  "./de/gradebookActionMenu.json": [
    "174966",
    [
      932191
    ]
  ],
  "./en-AU-x-unimelb/sis_import.json": [
    "643993",
    [
      158475
    ]
  ],
  "./en-GB/Navigation.json": [
    "794031",
    [
      574366
    ]
  ],
  "./fi/permissions_role_tray_table_row.json": [
    "974381",
    [
      916747
    ]
  ],
  "./ms/quiz_statistics.json": [
    "511211",
    [
      892561
    ]
  ],
  "./en-GB/calculator.json": [
    "766357",
    [
      711888
    ]
  ],
  "./ru/jobs.json": [
    "115449",
    [
      673135
    ]
  ],
  "./sv-x-k12/auth_logging.json": [
    "749155",
    [
      777217
    ]
  ],
  "./ga/job_stats.json": [
    "788309",
    [
      322803
    ]
  ],
  "./ga/question_banks.json": [
    "458386",
    [
      951810
    ]
  ],
  "./mi/confirmMasteryModal.json": [
    "956270",
    [
      529534
    ]
  ],
  "./pl/discussion_posts.json": [
    "556554",
    [
      825206
    ]
  ],
  "./vi/courses_show.json": [
    "946015",
    [
      899906
    ]
  ],
  "./vi/ldap_cert_upload.json": [
    "655221",
    [
      146499
    ]
  ],
  "./zh-Hans/course_paces_blueprint_lock.json": [
    "663525",
    [
      963843
    ]
  ],
  "./cy/course_paces_blackout_dates_modal.json": [
    "937288",
    [
      83288
    ]
  ],
  "./sv/self_unenrollment_modal.json": [
    "977597",
    [
      858343
    ]
  ],
  "./ga/account_calendar_settings_confirmation_modal.json": [
    "206122",
    [
      604202
    ]
  ],
  "./ko/k5_dashboard.json": [
    "236639",
    [
      298317
    ]
  ],
  "./pt/discussion_topics_edit.json": [
    "750224",
    [
      298436
    ]
  ],
  "./zh-Hans/restore_content_pane.json": [
    "233536",
    [
      404824
    ]
  ],
  "./cy/course_paces_projected_dates.json": [
    "981357",
    [
      446883
    ]
  ],
  "./en-AU/terms_of_use.json": [
    "432497",
    [
      85520
    ]
  ],
  "./nn/learning_mastery_gradebook.json": [
    "30811",
    [
      113197
    ]
  ],
  "./mi/account_calendar_settings_account_list.json": [
    "803015",
    [
      843285
    ]
  ],
  "./sv/course_paces_flaggable_number_input.json": [
    "228998",
    [
      58402
    ]
  ],
  "./cy/todo.json": [
    "787494",
    [
      4678
    ]
  ],
  "./ar/login.json": [
    "508268",
    [
      219640
    ]
  ],
  "./es-ES/edit_section_start_date.json": [
    "731063",
    [
      190861
    ]
  ],
  "./mi/editAssignmentGroupWeights.json": [
    "196989",
    [
      488819
    ]
  ],
  "./sv-x-k12/unpublished_changes_button_props.json": [
    "966360",
    [
      483792
    ]
  ],
  "./id/course_paces_empty_state.json": [
    "216011",
    [
      449037
    ]
  ],
  "./hy/assignments.no_assignments_search.json": [
    "505886",
    [
      600939
    ]
  ],
  "./el/pairing_code_user_observees.json": [
    "246950",
    [
      212178
    ]
  ],
  "./mi/discussion_topics_edit.json": [
    "7818",
    [
      856242
    ]
  ],
  "./fa/login.json": [
    "890398",
    [
      841846
    ]
  ],
  "./ru/GroupDetailView.json": [
    "659312",
    [
      826696
    ]
  ],
  "./fr-CA/submissions_show_preview.json": [
    "840805",
    [
      582455
    ]
  ],
  "./hu/account_calendars_results_area.json": [
    "656977",
    [
      442159
    ]
  ],
  "./pt/k5_dashboard_card.json": [
    "946976",
    [
      966188
    ]
  ],
  "./ga/youtube_migration.json": [
    "106872",
    [
      840560
    ]
  ],
  "./ru/discussion_settings.json": [
    "372679",
    [
      864733
    ]
  ],
  "./ko/account_calendar_settings_confirmation_modal.json": [
    "854148",
    [
      393868
    ]
  ],
  "./en-GB-x-ukhe/blueprint_settingsUnsyncedChanges.json": [
    "713393",
    [
      939527
    ]
  ],
  "./zh-Hans/calendar_edit.json": [
    "289510",
    [
      192990
    ]
  ],
  "./ja/assignments_peer_reviews.json": [
    "992552",
    [
      373133
    ]
  ],
  "./en-AU/assignments_2_student_points_display.json": [
    "934542",
    [
      88399
    ]
  ],
  "./hi/grade_details.json": [
    "214591",
    [
      523653
    ]
  ],
  "./pt/empty_modules.json": [
    "509549",
    [
      788116
    ]
  ],
  "./zh-Hant/course_paces_footer.json": [
    "227684",
    [
      467976
    ]
  ],
  "./mi/calendar.header.json": [
    "373013",
    [
      848728
    ]
  ],
  "./zh-Hant/react_files.json": [
    "132467",
    [
      185037
    ]
  ],
  "./zh-Hant/paginated_list.json": [
    "345084",
    [
      381520
    ]
  ],
  "./el/ai_experiences_ai_conversations.json": [
    "770471",
    [
      436369
    ]
  ],
  "./ru/context_modules_v2.json": [
    "983071",
    [
      572101
    ]
  ],
  "./is/error_form.json": [
    "624791",
    [
      222397
    ]
  ],
  "./nl/collaborations.json": [
    "973934",
    [
      434234
    ]
  ],
  "./he/content_migrations_redesign.json": [
    "288598",
    [
      807286
    ]
  ],
  "./ru/users.json": [
    "689283",
    [
      121809
    ]
  ],
  "./da-x-k12/theme_editor.json": [
    "912277",
    [
      533782
    ]
  ],
  "./fa/roster_section_selector.json": [
    "535298",
    [
      202690
    ]
  ],
  "./mi/quantitative_data_options.json": [
    "543725",
    [
      991619
    ]
  ],
  "./en-GB-x-ukhe/course_color_selector.json": [
    "81183",
    [
      315429
    ]
  ],
  "./ko/gradebookOutcomeGradebookView.json": [
    "851537",
    [
      782911
    ]
  ],
  "./fi/account_calendar_settings_account_group.json": [
    "621005",
    [
      776283
    ]
  ],
  "./tr/MobileNavigation.json": [
    "127212",
    [
      600256
    ]
  ],
  "./pt/unpublished_changes_tray_contents.json": [
    "383535",
    [
      293401
    ]
  ],
  "./da/content_migrations_redesign.json": [
    "754166",
    [
      985670
    ]
  ],
  "./da/context_roster_user_services.json": [
    "915519",
    [
      732589
    ]
  ],
  "./pt-BR/course_paces_change_tracking.json": [
    "741320",
    [
      283381
    ]
  ],
  "./cy/widget_dashboard.json": [
    "807601",
    [
      471535
    ]
  ],
  "./hu/roster_section_input.json": [
    "717143",
    [
      150629
    ]
  ],
  "./ga/peer_review_configuration_tray.json": [
    "656815",
    [
      959285
    ]
  ],
  "./fr-CA/ProfileTray.json": [
    "203250",
    [
      930054
    ]
  ],
  "./nb/lti_registrations.json": [
    "572776",
    [
      257108
    ]
  ],
  "./ar/content_exports.json": [
    "990944",
    [
      424852
    ]
  ],
  "./hu/section.json": [
    "582914",
    [
      477626
    ]
  ],
  "./hy/gradebook.json": [
    "33279",
    [
      116805
    ]
  ],
  "./zh-Hant/gradinggradingPeriodCollection.json": [
    "457741",
    [
      550095
    ]
  ],
  "./id/MobileGlobalMenu.json": [
    "256699",
    [
      803541
    ]
  ],
  "./vi/course_paces_blueprint_lock.json": [
    "658551",
    [
      582445
    ]
  ],
  "./ja/AddGroup.json": [
    "695275",
    [
      562918
    ]
  ],
  "./en-GB-x-lbs/course_link_validator.json": [
    "103999",
    [
      174373
    ]
  ],
  "./uk/MasteryScale.json": [
    "338771",
    [
      726233
    ]
  ],
  "./ca/submissions_show_preview.json": [
    "962890",
    [
      987202
    ]
  ],
  "./he/blueprint_coursesExpandableLockOptions.json": [
    "47622",
    [
      317798
    ]
  ],
  "./hy/user_grades.json": [
    "388581",
    [
      252627
    ]
  ],
  "./sl/course_paces_blackout_dates_modal.json": [
    "296671",
    [
      919281
    ]
  ],
  "./cy/assignments.json": [
    "521124",
    [
      443279
    ]
  ],
  "./he/student_groups.json": [
    "696583",
    [
      518165
    ]
  ],
  "./sl/SpeedGraderSettingsMenu.json": [
    "91247",
    [
      70897
    ]
  ],
  "./da-x-k12/quizzes_public.json": [
    "186322",
    [
      161590
    ]
  ],
  "./sl/todos_page.json": [
    "69390",
    [
      850826
    ]
  ],
  "./ar/assignments_2_url_entry.json": [
    "741887",
    [
      975777
    ]
  ],
  "./is/student_entries.json": [
    "620706",
    [
      498914
    ]
  ],
  "./sv/entity_search_form.json": [
    "139454",
    [
      97754
    ]
  ],
  "./pt-BR/GroupDetailView.json": [
    "445568",
    [
      459277
    ]
  ],
  "./en-GB-x-ukhe/quizzes.take_quiz.json": [
    "460366",
    [
      71751
    ]
  ],
  "./en-GB/progress_pill.json": [
    "833260",
    [
      20989
    ]
  ],
  "./id/student_groups.json": [
    "17081",
    [
      76075
    ]
  ],
  "./hi/rate_limiting_settings.json": [
    "20821",
    [
      447907
    ]
  ],
  "./pl/user_search_results.json": [
    "88779",
    [
      731853
    ]
  ],
  "./de/editAssignmentGroupWeights.json": [
    "191010",
    [
      633827
    ]
  ],
  "./fa/submit_assignment.json": [
    "856771",
    [
      748017
    ]
  ],
  "./hi/AlignmentSummary.json": [
    "377032",
    [
      34112
    ]
  ],
  "./zh-Hans/assignments_peer_reviews_student.json": [
    "215626",
    [
      803530
    ]
  ],
  "./en-GB/account_notification_settings.json": [
    "123418",
    [
      106375
    ]
  ],
  "./id/course_link_validator.json": [
    "328040",
    [
      999012
    ]
  ],
  "./sv/account_settings_jsx_bundle.json": [
    "163755",
    [
      805725
    ]
  ],
  "./hy/DueDateOverrideView.json": [
    "144670",
    [
      879830
    ]
  ],
  "./uk/calendar.header.json": [
    "81191",
    [
      537662
    ]
  ],
  "./uk/LearningMasteryGradebook.json": [
    "328369",
    [
      40127
    ]
  ],
  "./hu/empty_course.json": [
    "309120",
    [
      353760
    ]
  ],
  "./da/permissions_role_tray.json": [
    "681855",
    [
      701933
    ]
  ],
  "./ht/account_calendar_settings_account_list.json": [
    "721881",
    [
      123771
    ]
  ],
  "./tr/edit_section_view.json": [
    "745644",
    [
      435243
    ]
  ],
  "./hu/course_paces_no_results.json": [
    "75316",
    [
      613900
    ]
  ],
  "./en-GB-x-lbs/course_paces_module.json": [
    "202367",
    [
      752101
    ]
  ],
  "./mi/course_template_details.json": [
    "860037",
    [
      515787
    ]
  ],
  "./ms/blueprint_settingsCourseFilter.json": [
    "711008",
    [
      966592
    ]
  ],
  "./th/user_search_results.json": [
    "705360",
    [
      47429
    ]
  ],
  "./en/a2_AccessibleTipContent.json": [
    "977313",
    [
      364259
    ]
  ],
  "./is/overview_page.json": [
    "630241",
    [
      350967
    ]
  ],
  "./pt/peer_review_student_select.json": [
    "745012",
    [
      859136
    ]
  ],
  "./es-ES/assignments_2_MoreOptions.json": [
    "823690",
    [
      232970
    ]
  ],
  "./nb/eportfolio.json": [
    "55723",
    [
      2149
    ]
  ],
  "./cy/error_form.json": [
    "205563",
    [
      971425
    ]
  ],
  "./pt-BR/assignments_bulk_edit.json": [
    "433623",
    [
      573554
    ]
  ],
  "./el/top_navigation_tools.json": [
    "141407",
    [
      155081
    ]
  ],
  "./ko/terms_of_use.json": [
    "652853",
    [
      936395
    ]
  ],
  "./ko/DueDateOverrideView.json": [
    "531599",
    [
      668349
    ]
  ],
  "./en-AU-x-unimelb/blueprint_settingsAssociationsTable.json": [
    "237901",
    [
      953151
    ]
  ],
  "./nn/user_lists.json": [
    "869679",
    [
      646377
    ]
  ],
  "./sv/assignments_2_url_entry.json": [
    "398717",
    [
      977303
    ]
  ],
  "./fa/editGroup.json": [
    "25712",
    [
      755608
    ]
  ],
  "./en-GB-x-lbs/CoursesTray.json": [
    "858306",
    [
      400578
    ]
  ],
  "./en-GB/pairing_code_user_observees.json": [
    "232550",
    [
      128819
    ]
  ],
  "./pt/assignment_index_deep_linking_handlers.json": [
    "417188",
    [
      771720
    ]
  ],
  "./th/mutationActivity.json": [
    "227200",
    [
      461476
    ]
  ],
  "./nb-x-k12/edit_section_end_date.json": [
    "328199",
    [
      975293
    ]
  ],
  "./en-GB-x-lbs/permissions_v2_add_tray.json": [
    "191318",
    [
      927758
    ]
  ],
  "./ja/k5_dashboard_card.json": [
    "19557",
    [
      430876
    ]
  ],
  "./ko/AccountsTray.json": [
    "858308",
    [
      568268
    ]
  ],
  "./pt/terms_index.json": [
    "417458",
    [
      816822
    ]
  ],
  "./ko/confirmMasteryModal.json": [
    "514354",
    [
      834298
    ]
  ],
  "./nl/self_unenrollment_modal.json": [
    "10650",
    [
      956430
    ]
  ],
  "./vi/enhanced_individual_gradebook_submit_score.json": [
    "829586",
    [
      594594
    ]
  ],
  "./nl/edit_section_start_date.json": [
    "173652",
    [
      638976
    ]
  ],
  "./en/sharedSetDefaultGradeDialog.json": [
    "943890",
    [
      962990
    ]
  ],
  "./sv-x-k12/bounced_emails.json": [
    "751295",
    [
      909829
    ]
  ],
  "./ms/ProfileTray.json": [
    "962539",
    [
      801905
    ]
  ],
  "./es/add_edit_pseudonym.json": [
    "140031",
    [
      440914
    ]
  ],
  "./es/submit_online_url_assignment.json": [
    "982582",
    [
      631943
    ]
  ],
  "./pt-BR/horizon_toggle.json": [
    "751977",
    [
      408400
    ]
  ],
  "./vi/assignments_bulk_edit.json": [
    "421047",
    [
      455229
    ]
  ],
  "./nn/collaborations.json": [
    "205336",
    [
      588180
    ]
  ],
  "./ko/authentication_providers.json": [
    "580285",
    [
      96867
    ]
  ],
  "./ja/outcome_alignment_v2.json": [
    "813210",
    [
      662787
    ]
  ],
  "./zh-Hans/discussion_create.json": [
    "358968",
    [
      19696
    ]
  ],
  "./nn/admin_split.json": [
    "565490",
    [
      955062
    ]
  ],
  "./ca/self_enrollment.json": [
    "766845",
    [
      839619
    ]
  ],
  "./nn/quizzes_index.json": [
    "788056",
    [
      85812
    ]
  ],
  "./da-x-k12/files_v2.json": [
    "480545",
    [
      343995
    ]
  ],
  "./nb/discussion_posts.json": [
    "170362",
    [
      16870
    ]
  ],
  "./hu/assignments.json": [
    "86843",
    [
      584513
    ]
  ],
  "./ar/reset_pace_warning_modal.json": [
    "986793",
    [
      656123
    ]
  ],
  "./da/self_enrollment.json": [
    "830290",
    [
      62874
    ]
  ],
  "./ms/modelsQuiz.json": [
    "93345",
    [
      726911
    ]
  ],
  "./id/bulk_edit_students_table.json": [
    "224540",
    [
      477760
    ]
  ],
  "./pt-BR/AssignmentGroupListItemView.json": [
    "540777",
    [
      197168
    ]
  ],
  "./cy/course_paces_app.json": [
    "271984",
    [
      603888
    ]
  ],
  "./pt-BR/calendar_sidebar.json": [
    "808796",
    [
      472817
    ]
  ],
  "./sl/k5_dashboard_card.json": [
    "128703",
    [
      423761
    ]
  ],
  "./mi/ai_experiences_ai_conversations.json": [
    "805656",
    [
      892520
    ]
  ],
  "./hy/plugins.json": [
    "522801",
    [
      75639
    ]
  ],
  "./he/peer_review_configuration_tray.json": [
    "176642",
    [
      197338
    ]
  ],
  "./mi/lti_registrations.json": [
    "996330",
    [
      99826
    ]
  ],
  "./pl/context_modules_v2.json": [
    "687284",
    [
      966456
    ]
  ],
  "./fa/sharedSetDefaultGradeDialog.json": [
    "231200",
    [
      603992
    ]
  ],
  "./is/course_stats.json": [
    "925567",
    [
      234325
    ]
  ],
  "./ms/webcam_modal.json": [
    "532009",
    [
      690167
    ]
  ],
  "./nb/custom_emoji_deny_list.json": [
    "104396",
    [
      748504
    ]
  ],
  "./ko/plugins.json": [
    "931928",
    [
      27384
    ]
  ],
  "./pl/blueprint_settingsMigrationSync.json": [
    "140326",
    [
      954354
    ]
  ],
  "./zh-Hans/course_paces_blackout_dates_modal.json": [
    "482927",
    [
      937269
    ]
  ],
  "./en-GB/course_paces_header.json": [
    "329305",
    [
      821556
    ]
  ],
  "./da-x-k12/MobileGlobalMenu.json": [
    "369847",
    [
      530729
    ]
  ],
  "./fa/conversations_2.json": [
    "897018",
    [
      99434
    ]
  ],
  "./pl/rootFoldersFinder.json": [
    "833403",
    [
      350357
    ]
  ],
  "./es/blueprint_course_sidebar.json": [
    "375984",
    [
      883077
    ]
  ],
  "./da/dashboard_grading_period_select.json": [
    "28603",
    [
      858961
    ]
  ],
  "./en-AU/gradebook.json": [
    "78410",
    [
      845843
    ]
  ],
  "./nl/quizzes_public.json": [
    "725020",
    [
      282409
    ]
  ],
  "./ru/password_complexity_configuration.json": [
    "295328",
    [
      359880
    ]
  ],
  "./vi/login.json": [
    "973094",
    [
      412526
    ]
  ],
  "./ca/peer_review_student_select.json": [
    "390564",
    [
      815308
    ]
  ],
  "./ru/roster_section_input.json": [
    "266825",
    [
      1791
    ]
  ],
  "./pt-BR/edit_section_dates.json": [
    "60051",
    [
      957574
    ]
  ],
  "./en-GB/rate_limiting_settings.json": [
    "727519",
    [
      630782
    ]
  ],
  "./en-GB-x-lbs/link_to_students.json": [
    "300889",
    [
      659180
    ]
  ],
  "./uk/rubrics-export.json": [
    "702785",
    [
      347279
    ]
  ],
  "./es-ES/paginated_list.json": [
    "110997",
    [
      993555
    ]
  ],
  "./nl/peer_review_allocation_rules_tray.json": [
    "788829",
    [
      610575
    ]
  ],
  "./hi/blueprint_settingsCoursePickerTable.json": [
    "114407",
    [
      396973
    ]
  ],
  "./fa/eportfolio.json": [
    "503176",
    [
      347360
    ]
  ],
  "./hy/gradingPeriodTemplate.json": [
    "933562",
    [
      608346
    ]
  ],
  "./nb/modules_home_page.json": [
    "82971",
    [
      364285
    ]
  ],
  "./nb-x-k12/course_paces_actions.json": [
    "164838",
    [
      509694
    ]
  ],
  "./ja/important_dates.json": [
    "221031",
    [
      479274
    ]
  ],
  "./mi/course_paces_blackout_dates_modal.json": [
    "231946",
    [
      465778
    ]
  ],
  "./nb/course_navigation_settings.json": [
    "230750",
    [
      544954
    ]
  ],
  "./en-CA/assignments_2_file_upload.json": [
    "452200",
    [
      329776
    ]
  ],
  "./es/ignite_agent.json": [
    "721030",
    [
      542039
    ]
  ],
  "./ko/conferences.json": [
    "502639",
    [
      707997
    ]
  ],
  "./en-GB-x-ukhe/AlignmentSummary.json": [
    "595563",
    [
      460489
    ]
  ],
  "./es-ES/eportfolio.json": [
    "954608",
    [
      531528
    ]
  ],
  "./ca/k5_dashboard.json": [
    "594557",
    [
      220995
    ]
  ],
  "./cy/MasteryScale.json": [
    "74107",
    [
      243105
    ]
  ],
  "./da/course_link_validator.json": [
    "982298",
    [
      506482
    ]
  ],
  "./da/account_calendar_settings_account_calendar_item.json": [
    "226884",
    [
      70028
    ]
  ],
  "./ht/use_switch_experience.json": [
    "410027",
    [
      748253
    ]
  ],
  "./es-ES/folder_tree.json": [
    "729046",
    [
      88478
    ]
  ],
  "./en-GB-x-ukhe/CourseAvailabilityOptions.json": [
    "957088",
    [
      417336
    ]
  ],
  "./hu/quizzes_openModerateStudentDialog.json": [
    "893243",
    [
      146017
    ]
  ],
  "./sv/progressbar_view.json": [
    "876833",
    [
      190243
    ]
  ],
  "./hu/direct_share_course_import_panel.json": [
    "726004",
    [
      164629
    ]
  ],
  "./en-GB-x-lbs/section.json": [
    "963319",
    [
      133885
    ]
  ],
  "./fi/epub_exports.json": [
    "132791",
    [
      466829
    ]
  ],
  "./ms/todos_page.json": [
    "829975",
    [
      867749
    ]
  ],
  "./da/copy_warnings_modal.json": [
    "883876",
    [
      301036
    ]
  ],
  "./pt-BR/module_sequence_footer.json": [
    "644099",
    [
      168342
    ]
  ],
  "./he/submit_assignment.json": [
    "685449",
    [
      719543
    ]
  ],
  "./en-AU-x-unimelb/assignments.json": [
    "373788",
    [
      960208
    ]
  ],
  "./vi/canvascareer.json": [
    "668807",
    [
      322621
    ]
  ],
  "./fr/course_paces_time_selection.json": [
    "677729",
    [
      632788
    ]
  ],
  "./is/self_unenrollment_modal.json": [
    "215048",
    [
      866576
    ]
  ],
  "./ms/conferences_alternatives.json": [
    "324178",
    [
      782410
    ]
  ],
  "./en-GB-x-ukhe/account_course_user_search.json": [
    "550550",
    [
      910750
    ]
  ],
  "./fr/course_paces_assignment_row.json": [
    "464791",
    [
      113814
    ]
  ],
  "./en-AU/course_link_validator.json": [
    "28395",
    [
      709894
    ]
  ],
  "./is/not_found_page_slide_puzzle.json": [
    "122421",
    [
      982899
    ]
  ],
  "./ko/permissions_v2_add_tray.json": [
    "442982",
    [
      50422
    ]
  ],
  "./cy/use_switch_experience.json": [
    "484619",
    [
      475953
    ]
  ],
  "./pt/permissions_role_tray.json": [
    "658076",
    [
      72936
    ]
  ],
  "./vi/assignments_2_url_entry.json": [
    "506657",
    [
      674599
    ]
  ],
  "./fr-CA/accessibility_checker.json": [
    "369827",
    [
      571725
    ]
  ],
  "./en-GB-x-lbs/course_paces_time_selection.json": [
    "363779",
    [
      614305
    ]
  ],
  "./sv-x-k12/assignments_2_initial_query.json": [
    "102410",
    [
      762074
    ]
  ],
  "./en-GB-x-lbs/peer_review_allocation_rule_card.json": [
    "12298",
    [
      147914
    ]
  ],
  "./hu/choose_mastery_path.json": [
    "735426",
    [
      87322
    ]
  ],
  "./hi/registration.json": [
    "298390",
    [
      595966
    ]
  ],
  "./ja/assignments_2_student_header.json": [
    "872780",
    [
      628553
    ]
  ],
  "./nl/appointment_groups.json": [
    "525346",
    [
      165926
    ]
  ],
  "./th/grade_summary.json": [
    "94534",
    [
      390450
    ]
  ],
  "./es/OutcomeDescriptionModal.json": [
    "542517",
    [
      894460
    ]
  ],
  "./he/assignment_index_menu.json": [
    "40749",
    [
      660323
    ]
  ],
  "./nb-x-k12/pseudonyms_mobile_login.json": [
    "293284",
    [
      165892
    ]
  ],
  "./pt-BR/empty_modules.json": [
    "221372",
    [
      493953
    ]
  ],
  "./en-GB-x-lbs/assignmentsIndexView.json": [
    "749675",
    [
      909865
    ]
  ],
  "./ko/assignment_index.json": [
    "122946",
    [
      169034
    ]
  ],
  "./en-AU/account_notification_settings.json": [
    "190893",
    [
      291876
    ]
  ],
  "./en-GB-x-lbs/license_help.json": [
    "200247",
    [
      903133
    ]
  ],
  "./nl/link_validator.json": [
    "580253",
    [
      898247
    ]
  ],
  "./en-AU/discussion_pinned_post.json": [
    "588426",
    [
      159251
    ]
  ],
  "./he/CreateEditAssignmentModal.json": [
    "165247",
    [
      739805
    ]
  ],
  "./es/a2LatePolicyToolTipContent.json": [
    "363431",
    [
      898362
    ]
  ],
  "./da/moderate_quiz.json": [
    "941562",
    [
      81362
    ]
  ],
  "./hu/admin_split.json": [
    "550497",
    [
      696639
    ]
  ],
  "./it/bulk_edit_students.json": [
    "333255",
    [
      494177
    ]
  ],
  "./ms/assignments_2_student_header.json": [
    "821371",
    [
      523809
    ]
  ],
  "./en-GB-x-lbs.json": [
    "625367",
    [
      120719
    ]
  ],
  "./fr/account_calendar_settings_account_calendar_item_dropdown.json": [
    "181157",
    [
      236216
    ]
  ],
  "./da/sections_tooltip.json": [
    "16099",
    [
      87049
    ]
  ],
  "./da/media_immersive_view.json": [
    "662635",
    [
      795521
    ]
  ],
  "./en-AU-x-unimelb/unpublished_warning_modal.json": [
    "465720",
    [
      758724
    ]
  ],
  "./pt/collaborations.json": [
    "604020",
    [
      341040
    ]
  ],
  "./zh-Hant/assignment_grade_summary.json": [
    "358506",
    [
      620606
    ]
  ],
  "./tr/AlignmentSummary.json": [
    "413727",
    [
      28825
    ]
  ],
  "./ms/confirmMasteryModal.json": [
    "540612",
    [
      979708
    ]
  ],
  "./zh-Hans/course_paces_errors.json": [
    "929289",
    [
      628751
    ]
  ],
  "./mi/terms_index.json": [
    "103084",
    [
      358356
    ]
  ],
  "./ht/authentication_providers.json": [
    "752115",
    [
      865501
    ]
  ],
  "./pl/confirmMasteryModal.json": [
    "650412",
    [
      36128
    ]
  ],
  "./uk/gradebookOutcomeGradebookView.json": [
    "459567",
    [
      238013
    ]
  ],
  "./he/appointment_groups.json": [
    "298185",
    [
      214295
    ]
  ],
  "./fi/k5_dashboard.json": [
    "269138",
    [
      603650
    ]
  ],
  "./nb/webcam_modal.json": [
    "388145",
    [
      691483
    ]
  ],
  "./fr/edit_section_dates.json": [
    "30596",
    [
      236109
    ]
  ],
  "./hi/peer_review_student_select.json": [
    "884173",
    [
      823915
    ]
  ],
  "./th/blueprint_settingsCoursePickerTable.json": [
    "184136",
    [
      197196
    ]
  ],
  "./tr/course_paces_blueprint_lock.json": [
    "559248",
    [
      527492
    ]
  ],
  "./zh-Hant/MobileGlobalMenu.json": [
    "873261",
    [
      959678
    ]
  ],
  "./sl/peer_review_student_select.json": [
    "297573",
    [
      87223
    ]
  ],
  "./da/OutcomeMoveModal.json": [
    "258389",
    [
      591979
    ]
  ],
  "./he/react_developer_keys.json": [
    "719416",
    [
      405128
    ]
  ],
  "./es/grade_change_logging_content.json": [
    "101910",
    [
      872583
    ]
  ],
  "./ko/account_calendar_settings_filter_controls.json": [
    "915608",
    [
      442424
    ]
  ],
  "./es-ES/NewTabIndicator.json": [
    "826221",
    [
      611787
    ]
  ],
  "./da-x-k12/course_navigation_settings.json": [
    "867057",
    [
      692739
    ]
  ],
  "./en-GB-x-ukhe/sis_import.json": [
    "768463",
    [
      923477
    ]
  ],
  "./mi/progress_pill.json": [
    "628627",
    [
      325577
    ]
  ],
  "./ar/quizzes_regrade_modal.json": [
    "672849",
    [
      517155
    ]
  ],
  "./fr-CA/nav_tourpoints.json": [
    "589694",
    [
      664514
    ]
  ],
  "./ar/account_calendars_modal.json": [
    "801832",
    [
      424028
    ]
  ],
  "./id/authentication_providers.json": [
    "102388",
    [
      939064
    ]
  ],
  "./he/manage_avatars.json": [
    "307853",
    [
      63715
    ]
  ],
  "./sv-x-k12/context_roster_user_services.json": [
    "866035",
    [
      446129
    ]
  ],
  "./th/lti_registrations.json": [
    "907168",
    [
      342220
    ]
  ],
  "./pt/course_paces_no_results.json": [
    "922875",
    [
      892061
    ]
  ],
  "./ar/empty_course.json": [
    "522972",
    [
      287848
    ]
  ],
  "./it/rootFoldersFinder.json": [
    "232218",
    [
      774542
    ]
  ],
  "./en-GB/quiz_log_auditing.json": [
    "434467",
    [
      148858
    ]
  ],
  "./pt/quizzes_regrade_modal.json": [
    "678010",
    [
      134822
    ]
  ],
  "./cy/CreateEditAssignmentModal.json": [
    "669144",
    [
      466824
    ]
  ],
  "./en-GB-x-lbs/discussion_settings.json": [
    "266344",
    [
      243600
    ]
  ],
  "./zh-Hans/quizzes_regrade_modal.json": [
    "250265",
    [
      366079
    ]
  ],
  "./nb/k5_dashboard.json": [
    "488565",
    [
      524671
    ]
  ],
  "./th/dashboard_grades_page.json": [
    "635559",
    [
      400633
    ]
  ],
  "./en-GB-x-lbs/announcements_on_home_page.json": [
    "687812",
    [
      717492
    ]
  ],
  "./fr-CA/theme_collection_view.json": [
    "3801",
    [
      290315
    ]
  ],
  "./ht/student_groups.json": [
    "399662",
    [
      459418
    ]
  ],
  "./sv/course_paces_app.json": [
    "147123",
    [
      75477
    ]
  ],
  "./fi/course_color_selector.json": [
    "417660",
    [
      357516
    ]
  ],
  "./en-GB-x-ukhe/lti_registration.wizard.json": [
    "142554",
    [
      372405
    ]
  ],
  "./es-ES/assignments_2_peer_review.json": [
    "833486",
    [
      825814
    ]
  ],
  "./ru/content_exports.json": [
    "494726",
    [
      973246
    ]
  ],
  "./vi/lti_registrations.json": [
    "473697",
    [
      438551
    ]
  ],
  "./ca/course_paces_blueprint_lock.json": [
    "33026",
    [
      869418
    ]
  ],
  "./ca/bulk_edit_students_table.json": [
    "666359",
    [
      401141
    ]
  ],
  "./en-GB-x-lbs/SpeedGraderCheckpoints.json": [
    "732795",
    [
      953417
    ]
  ],
  "./hu/eportfolio.json": [
    "10974",
    [
      996302
    ]
  ],
  "./zh-Hant/ignite_agent.json": [
    "383008",
    [
      848084
    ]
  ],
  "./fi/outcome_reporting.json": [
    "217662",
    [
      549126
    ]
  ],
  "./el/ai_experiences.json": [
    "12549",
    [
      384231
    ]
  ],
  "./de/course_paces_time_selection.json": [
    "434038",
    [
      107455
    ]
  ],
  "./da-x-k12/custom_emoji_deny_list.json": [
    "728307",
    [
      219845
    ]
  ],
  "./cy/k5_dashboard_card.json": [
    "567336",
    [
      455000
    ]
  ],
  "./is.eager.json": [
    "396007",
    [
      772234
    ]
  ],
  "./es/editGroup.json": [
    "831549",
    [
      456868
    ]
  ],
  "./tr/calendar_edit.json": [
    "647483",
    [
      532949
    ]
  ],
  "./tr/theme_collection_view.json": [
    "510006",
    [
      622634
    ]
  ],
  "./it/grade_change_logging_content.json": [
    "926973",
    [
      663215
    ]
  ],
  "./hi/roster_section_input.json": [
    "961867",
    [
      147833
    ]
  ],
  "./it/content_share_preview_overlay.json": [
    "43682",
    [
      406790
    ]
  ],
  "./ca/account_course_user_search.json": [
    "814420",
    [
      669756
    ]
  ],
  "./is/content_migrations_redesign.json": [
    "905237",
    [
      560931
    ]
  ],
  "./pt/dashboard_grades_page.json": [
    "915879",
    [
      232585
    ]
  ],
  "./he/gradingPeriodTemplate.json": [
    "615094",
    [
      77622
    ]
  ],
  "./pt/courses.json": [
    "792468",
    [
      280392
    ]
  ],
  "./sl/reset_pace_warning_modal.json": [
    "707905",
    [
      426619
    ]
  ],
  "./cy/job_stats.json": [
    "210681",
    [
      331399
    ]
  ],
  "./nb-x-k12/user_name.json": [
    "570171",
    [
      330745
    ]
  ],
  "./da-x-k12/todos_page.json": [
    "54720",
    [
      589692
    ]
  ],
  "./fi/roster_publicjs.json": [
    "466245",
    [
      298339
    ]
  ],
  "./pt-BR/edit_section_start_date.json": [
    "283927",
    [
      439058
    ]
  ],
  "./fr-CA/important_dates_empty.json": [
    "42837",
    [
      203351
    ]
  ],
  "./hy/question_bank.json": [
    "219150",
    [
      521910
    ]
  ],
  "./el/discussion_create.json": [
    "30678",
    [
      2506
    ]
  ],
  "./vi/ignite_agent.json": [
    "335861",
    [
      220643
    ]
  ],
  "./id/permissions_v2.json": [
    "635180",
    [
      450424
    ]
  ],
  "./es/courses.show.json": [
    "867347",
    [
      327838
    ]
  ],
  "./nn/security_panel.json": [
    "271265",
    [
      243499
    ]
  ],
  "./zh-Hans/submit_online_url_assignment.json": [
    "778627",
    [
      980305
    ]
  ],
  "./it/folder_tree.json": [
    "97670",
    [
      108970
    ]
  ],
  "./da/course_restore.json": [
    "223795",
    [
      135065
    ]
  ],
  "./fa/assignments_2_media_attempt.json": [
    "526337",
    [
      646375
    ]
  ],
  "./pt-BR/content_copy_redesign.json": [
    "654804",
    [
      760969
    ]
  ],
  "./pt-BR/entity_search_form.json": [
    "98442",
    [
      706219
    ]
  ],
  "./sv/grades_empty_page.json": [
    "631795",
    [
      275149
    ]
  ],
  "./ar/speed_grader_helpers.json": [
    "658702",
    [
      744290
    ]
  ],
  "./zh-Hans/calendar_appointment_group_edit.json": [
    "527748",
    [
      100052
    ]
  ],
  "./zh-Hant/module_sequence_footer.json": [
    "568274",
    [
      860710
    ]
  ],
  "./ru/MobileGlobalMenu.json": [
    "207275",
    [
      575433
    ]
  ],
  "./ru/context_prior_users.json": [
    "796812",
    [
      321852
    ]
  ],
  "./ja/react_developer_keys.json": [
    "743598",
    [
      423823
    ]
  ],
  "./fr/bulk_edit_students_actions.json": [
    "376844",
    [
      247853
    ]
  ],
  "./pt/todo.json": [
    "574782",
    [
      768810
    ]
  ],
  "./ar/course_search_results.json": [
    "414762",
    [
      522998
    ]
  ],
  "./fr-CA/assignmentsToggleShowByView.json": [
    "22556",
    [
      435424
    ]
  ],
  "./ga/dashboard.json": [
    "145722",
    [
      257098
    ]
  ],
  "./id/question_banks.json": [
    "798629",
    [
      606791
    ]
  ],
  "./en-AU-x-unimelb/ProfileTray.json": [
    "800075",
    [
      841685
    ]
  ],
  "./ko/youtube_migration.json": [
    "809534",
    [
      999678
    ]
  ],
  "./da/quizzes_index.json": [
    "176923",
    [
      199281
    ]
  ],
  "./vi/discussion_row.json": [
    "879842",
    [
      870226
    ]
  ],
  "./en-GB-x-lbs/account_notification_settings.json": [
    "861377",
    [
      785079
    ]
  ],
  "./ar/custom_emoji_deny_list.json": [
    "780397",
    [
      329191
    ]
  ],
  "./cy/pseudonyms_mobile_login.json": [
    "859806",
    [
      670990
    ]
  ],
  "./da/last_attended.json": [
    "524601",
    [
      289943
    ]
  ],
  "./de/bulk_edit_students.json": [
    "627897",
    [
      802864
    ]
  ],
  "./is/unpublished_changes_button_props.json": [
    "780377",
    [
      881151
    ]
  ],
  "./ca/OutcomeMoveModal.json": [
    "658484",
    [
      350236
    ]
  ],
  "./th/account_calendars_results_area.json": [
    "363036",
    [
      166960
    ]
  ],
  "./zh-Hant/calendar_sidebar.json": [
    "948221",
    [
      391159
    ]
  ],
  "./ca/group_submission_reminder.json": [
    "391473",
    [
      654271
    ]
  ],
  "./pt/course_paces_projected_dates.json": [
    "296069",
    [
      409839
    ]
  ],
  "./pl/user_profile.json": [
    "389179",
    [
      635413
    ]
  ],
  "./ko/discussion_insights.json": [
    "723592",
    [
      800488
    ]
  ],
  "./da-x-k12/authentication_providers.json": [
    "778008",
    [
      767412
    ]
  ],
  "./en-GB-x-ukhe/rubrics-export.json": [
    "484567",
    [
      549821
    ]
  ],
  "./fr/job_stats.json": [
    "775217",
    [
      145124
    ]
  ],
  "./da-x-k12/edit_section_dates.json": [
    "209039",
    [
      419201
    ]
  ],
  "./he/link_validator.json": [
    "857610",
    [
      323506
    ]
  ],
  "./nl/suppress_notifications.json": [
    "59816",
    [
      486796
    ]
  ],
  "./zh-Hant/assignments_2_text_entry.json": [
    "607652",
    [
      503264
    ]
  ],
  "./ht/calendar_custom_recurring_event_repeat_picker.json": [
    "264308",
    [
      501104
    ]
  ],
  "./en-AU/Navigation.json": [
    "886074",
    [
      143299
    ]
  ],
  "./fr-CA/permissions_role_tray.json": [
    "204121",
    [
      56267
    ]
  ],
  "./cy/keyboardShortcutModal.json": [
    "375242",
    [
      39186
    ]
  ],
  "./is/AlignmentSummary.json": [
    "398065",
    [
      190087
    ]
  ],
  "./ar/canvas_file_upload.json": [
    "682678",
    [
      941994
    ]
  ],
  "./vi/gradingPeriodTemplate.json": [
    "516032",
    [
      816552
    ]
  ],
  "./ca/modules_home_page.json": [
    "221683",
    [
      531449
    ]
  ],
  "./cy/assignment_index_menu.json": [
    "216666",
    [
      165794
    ]
  ],
  "./ja/assignment_index.json": [
    "148191",
    [
      432994
    ]
  ],
  "./nl/copy_course.json": [
    "697275",
    [
      57557
    ]
  ],
  "./zh-Hant/keyboardShortcutModal.json": [
    "118560",
    [
      273260
    ]
  ],
  "./nl/bulk_edit_students.json": [
    "368502",
    [
      869906
    ]
  ],
  "./da/gradebook_default_gradebook_components_content_filters_module_filter.json": [
    "277743",
    [
      531421
    ]
  ],
  "./el/discussion_insights.json": [
    "749083",
    [
      480325
    ]
  ],
  "./es-ES/learning_mastery_gradebook.json": [
    "48840",
    [
      686256
    ]
  ],
  "./hi/notebook_index.json": [
    "273257",
    [
      388047
    ]
  ],
  "./th/content_migrations_redesign.json": [
    "628489",
    [
      169851
    ]
  ],
  "./uk/context_modules_v2.json": [
    "410988",
    [
      879652
    ]
  ],
  "./vi/assignments_2_media_attempt.json": [
    "611657",
    [
      788031
    ]
  ],
  "./th/overview_page.json": [
    "467293",
    [
      680575
    ]
  ],
  "./tr/OutcomeMoveModal.json": [
    "605986",
    [
      993670
    ]
  ],
  "./sl/submit_assignment.json": [
    "561421",
    [
      743439
    ]
  ],
  "./en-GB-x-ukhe/discussionTopicKeyboradShortcutModal.json": [
    "127991",
    [
      940605
    ]
  ],
  "./en-GB-x-lbs/peer_reviews_student.json": [
    "384386",
    [
      308306
    ]
  ],
  "./is/sharedCurveGradesDialog.json": [
    "980438",
    [
      627870
    ]
  ],
  "./ca/epub_exports.json": [
    "971628",
    [
      917796
    ]
  ],
  "./pt-BR/CreateEditAssignmentModalAdapter.json": [
    "39612",
    [
      285425
    ]
  ],
  "./pt/CreateEditAssignmentModal.json": [
    "388256",
    [
      187092
    ]
  ],
  "./ca/course_paces_blackout_date_row.json": [
    "279486",
    [
      950046
    ]
  ],
  "./nn/filter_calendars_modal.json": [
    "67622",
    [
      639818
    ]
  ],
  "./fr/calculator_command.json": [
    "98324",
    [
      585813
    ]
  ],
  "./ja/course_default_due_time.json": [
    "141481",
    [
      721832
    ]
  ],
  "./hi/user_profile.json": [
    "984206",
    [
      778310
    ]
  ],
  "./ja/assignments_2_external_tool.json": [
    "655041",
    [
      828288
    ]
  ],
  "./da-x-k12/user_restore.json": [
    "707851",
    [
      817997
    ]
  ],
  "./fi/student_entries.json": [
    "767475",
    [
      56305
    ]
  ],
  "./mi/course_search_results.json": [
    "166359",
    [
      268069
    ]
  ],
  "./ms/keyboardShortcutModal.json": [
    "694434",
    [
      733850
    ]
  ],
  "./pt/account_calendars_results_area.json": [
    "638748",
    [
      404256
    ]
  ],
  "./ru/remove_pace_warning_modal.json": [
    "893644",
    [
      557660
    ]
  ],
  "./fr-CA/course_paces_projected_dates.json": [
    "404982",
    [
      316234
    ]
  ],
  "./es/course_link_validator.json": [
    "624101",
    [
      625964
    ]
  ],
  "./cy/quiz_statistics.json": [
    "351235",
    [
      315257
    ]
  ],
  "./id/assignments_2_shared_Steps.json": [
    "761216",
    [
      31468
    ]
  ],
  "./ar/account_calendar_settings.json": [
    "396155",
    [
      313261
    ]
  ],
  "./da-x-k12/folder_tree.json": [
    "865618",
    [
      861390
    ]
  ],
  "./nb-x-k12/sidenav.json": [
    "973136",
    [
      929592
    ]
  ],
  "./ar/react_collaborations.json": [
    "224157",
    [
      463839
    ]
  ],
  "./da-x-k12/accessibility_scan.json": [
    "6017",
    [
      642923
    ]
  ],
  "./hu/assignmentsIndexView.json": [
    "754748",
    [
      694724
    ]
  ],
  "./ga/remove_pace_warning_modal.json": [
    "667653",
    [
      453283
    ]
  ],
  "./sl/content_shares.json": [
    "272965",
    [
      491836
    ]
  ],
  "./id/blueprint_settingsSyncHistory.json": [
    "255409",
    [
      39003
    ]
  ],
  "./id/outcomes_user_outcome_results.json": [
    "644476",
    [
      772488
    ]
  ],
  "./pt-BR/assignments_2_student_content.json": [
    "751902",
    [
      167063
    ]
  ],
  "./is/course_link_validator.json": [
    "665705",
    [
      797503
    ]
  ],
  "./zh-Hans/editAssignmentGroupWeights.json": [
    "53698",
    [
      814754
    ]
  ],
  "./es-ES/course_paces_module.json": [
    "986460",
    [
      242204
    ]
  ],
  "./ja/user_logins.json": [
    "720533",
    [
      515788
    ]
  ],
  "./cy/quiz_log_auditing.json": [
    "289534",
    [
      859374
    ]
  ],
  "./zh-Hant/canvascareer.json": [
    "761198",
    [
      219930
    ]
  ],
  "./hi/homeroom_page.json": [
    "755379",
    [
      428209
    ]
  ],
  "./tr/peer_review_allocation_rule_card.json": [
    "671894",
    [
      243970
    ]
  ],
  "./zh-Hans/bounced_emails.json": [
    "504007",
    [
      235197
    ]
  ],
  "./zh-Hans/account_calendar_settings_account_calendar_item.json": [
    "308832",
    [
      546600
    ]
  ],
  "./hi/assignments.no_assignments_search.json": [
    "289390",
    [
      179515
    ]
  ],
  "./id/edit_section_start_date.json": [
    "305943",
    [
      644921
    ]
  ],
  "./en-GB-x-lbs/user_date_range_search.json": [
    "939751",
    [
      210621
    ]
  ],
  "./en-AU/AlignmentSummary.json": [
    "462951",
    [
      203914
    ]
  ],
  "./cy/blueprint_settingsMigrationSync.json": [
    "819190",
    [
      181046
    ]
  ],
  "./nl/admin_split.json": [
    "733184",
    [
      913132
    ]
  ],
  "./nn/quizzes.take_quiz.json": [
    "7576",
    [
      464729
    ]
  ],
  "./sl/peer_review_allocation_rules_tray.json": [
    "255996",
    [
      3456
    ]
  ],
  "./en-GB-x-ukhe/file_not_found.json": [
    "287251",
    [
      713153
    ]
  ],
  "./da/assignments_2_student_content.json": [
    "404364",
    [
      935908
    ]
  ],
  "./hu/react_collaborations.json": [
    "25097",
    [
      485367
    ]
  ],
  "./ca/user.json": [
    "158345",
    [
      41095
    ]
  ],
  "./ko/course_paces_app.json": [
    "243474",
    [
      317466
    ]
  ],
  "./he/a2LatePolicyStatusDisplay.json": [
    "676190",
    [
      101710
    ]
  ],
  "./es/permissions_v2_add_tray.json": [
    "400840",
    [
      717853
    ]
  ],
  "./id/knowledge_check_not_ready.json": [
    "124782",
    [
      202946
    ]
  ],
  "./it/assignments_2_file_upload.json": [
    "398969",
    [
      932339
    ]
  ],
  "./nb/course_paces_flaggable_number_input.json": [
    "160671",
    [
      739977
    ]
  ],
  "./sl/self_unenrollment_modal.json": [
    "892195",
    [
      480549
    ]
  ],
  "./hi/module_sequence_footer.json": [
    "173409",
    [
      796967
    ]
  ],
  "./sv/NewTabIndicator.json": [
    "884681",
    [
      422667
    ]
  ],
  "./nb-x-k12/assignments.json": [
    "896734",
    [
      941174
    ]
  ],
  "./zh-Hans/account_calendar_settings_confirmation_modal.json": [
    "979419",
    [
      194249
    ]
  ],
  "./en-AU-x-unimelb/nav_tourpoints.json": [
    "466053",
    [
      859991
    ]
  ],
  "./sv/react_files.json": [
    "454648",
    [
      296300
    ]
  ],
  "./mi/assignments_bulk_edit.json": [
    "402188",
    [
      978068
    ]
  ],
  "./nb/progressbar_view.json": [
    "226910",
    [
      693762
    ]
  ],
  "./es-ES/course_link_validator.json": [
    "783240",
    [
      8272
    ]
  ],
  "./zh-Hant/discussion_row.json": [
    "730604",
    [
      22097
    ]
  ],
  "./ca/editAssignmentGroupWeights.json": [
    "456163",
    [
      914793
    ]
  ],
  "./pl/ignite_agent.json": [
    "98470",
    [
      446186
    ]
  ],
  "./cy/discussion_row.json": [
    "143089",
    [
      730287
    ]
  ],
  "./ga/discussion_topics.json": [
    "747943",
    [
      875629
    ]
  ],
  "./sv-x-k12/rubrics-export.json": [
    "151884",
    [
      772572
    ]
  ],
  "./ca/react_developer_keys.json": [
    "105313",
    [
      904879
    ]
  ],
  "./zh-Hant/editGroup.json": [
    "463707",
    [
      950293
    ]
  ],
  "./nb-x-k12/FindOutcomesModal.json": [
    "63803",
    [
      879497
    ]
  ],
  "./de/mutationActivity.json": [
    "135021",
    [
      996940
    ]
  ],
  "./is/grade_summaryGroupView.json": [
    "521148",
    [
      984028
    ]
  ],
  "./mi.json": [
    "699587",
    [
      483227
    ]
  ],
  "./ja/assignments_2_student_header_date_title.json": [
    "948112",
    [
      459477
    ]
  ],
  "./ko/assignments_2_peer_review.json": [
    "817973",
    [
      858507
    ]
  ],
  "./ja/assignments_2_student_points_display.json": [
    "502807",
    [
      99354
    ]
  ],
  "./ru/a2LatePolicyToolTipContent.json": [
    "781124",
    [
      917444
    ]
  ],
  "./nb/gradebook_history.json": [
    "973823",
    [
      442225
    ]
  ],
  "./nn/lti_registration.wizard.json": [
    "319284",
    [
      431503
    ]
  ],
  "./sv/ImportConfirmBox.json": [
    "880381",
    [
      391695
    ]
  ],
  "./tr/user_search_results.json": [
    "529821",
    [
      322255
    ]
  ],
  "./hy/dashboard_grading_period_select.json": [
    "302447",
    [
      669061
    ]
  ],
  "./hi/assignment_index.json": [
    "171405",
    [
      118667
    ]
  ],
  "./hu/terms_of_use.json": [
    "326790",
    [
      11142
    ]
  ],
  "./nn/notebook.json": [
    "447847",
    [
      387177
    ]
  ],
  "./da/calculator.json": [
    "779979",
    [
      350881
    ]
  ],
  "./hi/rubrics-export.json": [
    "164716",
    [
      896540
    ]
  ],
  "./id/license_help.json": [
    "676226",
    [
      466310
    ]
  ],
  "./da-x-k12/gradinggradingPeriodCollection.json": [
    "928572",
    [
      120840
    ]
  ],
  "./en-AU-x-unimelb/ai_experiences_ai_conversations.json": [
    "826462",
    [
      314754
    ]
  ],
  "./fi/course_paces_errors.json": [
    "546075",
    [
      267561
    ]
  ],
  "./sl/course_default_due_time.json": [
    "684839",
    [
      298673
    ]
  ],
  "./ar/conferences.json": [
    "974474",
    [
      722910
    ]
  ],
  "./sv-x-k12/course_paces_blackout_dates_table.json": [
    "898158",
    [
      280198
    ]
  ],
  "./en-GB/IndividualStudentMasteryOutcome.json": [
    "957618",
    [
      34183
    ]
  ],
  "./ru/course_logging_details.json": [
    "537731",
    [
      817297
    ]
  ],
  "./zh-Hant/course_paces_app.json": [
    "534990",
    [
      301594
    ]
  ],
  "./da/SpeedGraderCheckpoints.json": [
    "329464",
    [
      770328
    ]
  ],
  "./zh-Hans/ai_experiences_edit.json": [
    "492424",
    [
      97299
    ]
  ],
  "./ar/assignment_grade_summary.json": [
    "357065",
    [
      188003
    ]
  ],
  "./en-GB-x-ukhe/MoveOutcomesModal.json": [
    "577125",
    [
      973395
    ]
  ],
  "./es-ES/account_notification_settings.json": [
    "286142",
    [
      235190
    ]
  ],
  "./id/canvascareer.json": [
    "467623",
    [
      855929
    ]
  ],
  "./hu/SpeedGraderSettingsMenu.json": [
    "678659",
    [
      425017
    ]
  ],
  "./es-ES/module_sequence_footer.json": [
    "84835",
    [
      525185
    ]
  ],
  "./hy/user.json": [
    "682812",
    [
      511020
    ]
  ],
  "./en-GB-x-lbs/Navigation.json": [
    "43718",
    [
      982798
    ]
  ],
  "./pt-BR/ai_experiences_ai_conversations.json": [
    "613187",
    [
      615094
    ]
  ],
  "./en-GB-x-lbs/last_attended.json": [
    "285552",
    [
      407528
    ]
  ],
  "./es-ES/error_form.json": [
    "520780",
    [
      580092
    ]
  ],
  "./ms/MasteryScale.json": [
    "184915",
    [
      361097
    ]
  ],
  "./pt/assignments_2_student_content.json": [
    "325195",
    [
      177165
    ]
  ],
  "./tr/context_prior_users.json": [
    "738455",
    [
      199433
    ]
  ],
  "./en-GB-x-ukhe/suppress_notifications.json": [
    "245904",
    [
      977544
    ]
  ],
  "./uk/job_stats.json": [
    "329134",
    [
      50831
    ]
  ],
  "./ar/quiz_show.json": [
    "272142",
    [
      461474
    ]
  ],
  "./sl/overview_page.json": [
    "792354",
    [
      484334
    ]
  ],
  "./de/modelsQuiz.json": [
    "546548",
    [
      221017
    ]
  ],
  "./fi/moderate_quiz.json": [
    "924036",
    [
      481140
    ]
  ],
  "./en-AU/empty_course.json": [
    "412675",
    [
      860158
    ]
  ],
  "./sv/notebook.json": [
    "730748",
    [
      748064
    ]
  ],
  "./it/MobileNavigation.json": [
    "821477",
    [
      163023
    ]
  ],
  "./fr-CA/module_student_view_peer_reviews.json": [
    "218642",
    [
      49390
    ]
  ],
  "./hy/assignments.never_drop.json": [
    "489081",
    [
      420932
    ]
  ],
  "./nb/unpublished_changes_button_props.json": [
    "829",
    [
      940943
    ]
  ],
  "./tr/empty_course.json": [
    "46075",
    [
      215797
    ]
  ],
  "./pt-BR/discussion_pinned_post.json": [
    "481851",
    [
      517294
    ]
  ],
  "./da/knowledge_check_not_ready.json": [
    "399924",
    [
      530876
    ]
  ],
  "./nl/blueprint_settingsMigrationOptions.json": [
    "887427",
    [
      43565
    ]
  ],
  "./fi/empty_modules.json": [
    "634284",
    [
      482588
    ]
  ],
  "./pl/module_student_view_peer_reviews.json": [
    "49953",
    [
      213251
    ]
  ],
  "./nn/courses_show.json": [
    "615868",
    [
      139624
    ]
  ],
  "./id/course_pace_date_input.json": [
    "95680",
    [
      948444
    ]
  ],
  "./pt/canvascareer.json": [
    "466028",
    [
      733907
    ]
  ],
  "./mi/ignite_agent.json": [
    "719984",
    [
      466576
    ]
  ],
  "./nl/last_attended.json": [
    "612256",
    [
      692636
    ]
  ],
  "./hi/self_enrollment.json": [
    "68790",
    [
      16878
    ]
  ],
  "./pt/editGroup.json": [
    "20885",
    [
      461551
    ]
  ],
  "./nb/media_immersive_view.json": [
    "988814",
    [
      889202
    ]
  ],
  "./fa/section.json": [
    "667388",
    [
      136828
    ]
  ],
  "./en/suppress_notifications.json": [
    "126735",
    [
      487809
    ]
  ],
  "./es-ES.json": [
    "247776",
    [
      992318
    ]
  ],
  "./it/unpublished_warning_modal.json": [
    "734893",
    [
      918479
    ]
  ],
  "./sl/user.json": [
    "39524",
    [
      580832
    ]
  ],
  "./ko/course_paces_empty_state.json": [
    "168658",
    [
      91930
    ]
  ],
  "./ja/AlignmentSummary.json": [
    "108666",
    [
      919203
    ]
  ],
  "./fi/permissions_role_tray.json": [
    "217053",
    [
      845179
    ]
  ],
  "./ms/CourseAvailabilityOptions.json": [
    "406818",
    [
      154522
    ]
  ],
  "./vi/jobs_v2.json": [
    "311354",
    [
      290106
    ]
  ],
  "./hi/context_modules_v2.json": [
    "902465",
    [
      313703
    ]
  ],
  "./fr-CA/sharedSetDefaultGradeDialog.json": [
    "135708",
    [
      481632
    ]
  ],
  "./id/calendar_custom_recurring_event_natural_language.json": [
    "166661",
    [
      190255
    ]
  ],
  "./sv-x-k12/SpeedGraderPostGradesMenu.json": [
    "703324",
    [
      79628
    ]
  ],
  "./uk/link_to_students.json": [
    "289455",
    [
      769149
    ]
  ],
  "./th/progress_pill.json": [
    "130645",
    [
      305903
    ]
  ],
  "./it/suppress_notifications.json": [
    "987078",
    [
      395
    ]
  ],
  "./sv/grade_summary.json": [
    "676083",
    [
      665477
    ]
  ],
  "./ga/epub_exports.json": [
    "76776",
    [
      756256
    ]
  ],
  "./vi/assignmentsIndexView.json": [
    "283606",
    [
      522670
    ]
  ],
  "./mi/AccountsTray.json": [
    "39320",
    [
      290504
    ]
  ],
  "./sv/course_paces_time_selection.json": [
    "449516",
    [
      37960
    ]
  ],
  "./en-AU-x-unimelb/grade_change_logging_content.json": [
    "426830",
    [
      849786
    ]
  ],
  "./en-GB-x-lbs/gradebook_history.json": [
    "366021",
    [
      129875
    ]
  ],
  "./sv-x-k12/NewTabIndicator.json": [
    "805507",
    [
      119041
    ]
  ],
  "./nb-x-k12/change_password.json": [
    "399276",
    [
      722492
    ]
  ],
  "./hu/peer_reviews_student.json": [
    "296709",
    [
      988971
    ]
  ],
  "./fi/wiki_page_index.json": [
    "500890",
    [
      545258
    ]
  ],
  "./zh-Hans/CreateEditAssignmentModalAdapter.json": [
    "753230",
    [
      574054
    ]
  ],
  "./fr/file_not_found.json": [
    "638937",
    [
      923052
    ]
  ],
  "./ja/assignmentsToggleShowByView.json": [
    "565836",
    [
      708233
    ]
  ],
  "./en-AU-x-unimelb/conversations_2.json": [
    "134299",
    [
      933485
    ]
  ],
  "./ru/internal-settings.json": [
    "430182",
    [
      288014
    ]
  ],
  "./en-GB/discussion_pinned_post.json": [
    "575759",
    [
      950942
    ]
  ],
  "./en-GB/keyboardShortcutModal.json": [
    "720827",
    [
      720578
    ]
  ],
  "./zh-Hans/context_roster_user_services.json": [
    "247547",
    [
      503593
    ]
  ],
  "./fr/registration.json": [
    "211811",
    [
      256154
    ]
  ],
  "./en/eportfolio.json": [
    "607338",
    [
      416110
    ]
  ],
  "./id/empty_course.json": [
    "482530",
    [
      116214
    ]
  ],
  "./de/permissions.json": [
    "112069",
    [
      196116
    ]
  ],
  "./zh-Hans/FindOutcomesModal.json": [
    "259294",
    [
      712486
    ]
  ],
  "./en-GB/course_paces_change_tracking.json": [
    "64900",
    [
      90789
    ]
  ],
  "./cy/k5_dashboard.json": [
    "402421",
    [
      135675
    ]
  ],
  "./en-AU/CourseAvailabilityOptions.json": [
    "236092",
    [
      298905
    ]
  ],
  "./id/assignment_show.json": [
    "810884",
    [
      739328
    ]
  ],
  "./pt/a2LatePolicyStatusDisplay.json": [
    "92949",
    [
      396287
    ]
  ],
  "./en-AU-x-unimelb/LearningMasteryGradebook.json": [
    "320977",
    [
      497867
    ]
  ],
  "./ht/youtube_migration.json": [
    "705812",
    [
      588888
    ]
  ],
  "./is/assignments_2_MoreOptions_CanvasFiles.json": [
    "139351",
    [
      925805
    ]
  ],
  "./zh-Hans/modelsQuiz.json": [
    "526164",
    [
      520196
    ]
  ],
  "./cy/discussion_pinned_post.json": [
    "971132",
    [
      118212
    ]
  ],
  "./fa/dashboard_grading_period_select.json": [
    "209065",
    [
      335999
    ]
  ],
  "./hy/bulk_edit_students.json": [
    "398817",
    [
      663687
    ]
  ],
  "./ca/lti_registration.wizard.json": [
    "721408",
    [
      774119
    ]
  ],
  "./ar/assignment_index_menu.json": [
    "553009",
    [
      853051
    ]
  ],
  "./es-ES/quizzes_regrade_modal.json": [
    "877291",
    [
      957961
    ]
  ],
  "./uk/peer_review_student_select.json": [
    "668772",
    [
      377356
    ]
  ],
  "./is/nav_tourpoints.json": [
    "422433",
    [
      783063
    ]
  ],
  "./uk/assignments.never_drop.json": [
    "951980",
    [
      317327
    ]
  ],
  "./nl/assignment_show.json": [
    "827455",
    [
      284881
    ]
  ],
  "./ht/course_search_results.json": [
    "858925",
    [
      720471
    ]
  ],
  "./nb/paginated_list.json": [
    "883278",
    [
      301322
    ]
  ],
  "./th/remove_pace_warning_modal.json": [
    "740569",
    [
      123827
    ]
  ],
  "./tr/CreateEditAssignmentModalAdapter.json": [
    "194665",
    [
      962811
    ]
  ],
  "./ht/password_complexity_configuration.json": [
    "890885",
    [
      657263
    ]
  ],
  "./tr/content_shares.json": [
    "392626",
    [
      124726
    ]
  ],
  "./nl/ignite_agent.json": [
    "130396",
    [
      329440
    ]
  ],
  "./vi/calendar_custom_recurring_event_natural_language.json": [
    "477477",
    [
      104451
    ]
  ],
  "./pt/assignments_2_submission_histories_query.json": [
    "629954",
    [
      61662
    ]
  ],
  "./de/manage_avatars.json": [
    "187649",
    [
      538056
    ]
  ],
  "./hu/quizzes.take_quiz.json": [
    "392967",
    [
      612984
    ]
  ],
  "./ar/permissions_role_tray_table_row.json": [
    "804699",
    [
      973597
    ]
  ],
  "./es/student_study_drawer.json": [
    "232345",
    [
      264168
    ]
  ],
  "./fr-CA/calculator.json": [
    "304021",
    [
      697647
    ]
  ],
  "./ga/k5_course.json": [
    "378738",
    [
      868354
    ]
  ],
  "./he/assignments_2_MoreOptions.json": [
    "372692",
    [
      974828
    ]
  ],
  "./fi/terms_of_use.json": [
    "271216",
    [
      312584
    ]
  ],
  "./hi/new_user_tutorial.json": [
    "483802",
    [
      379706
    ]
  ],
  "./th/k5_course.json": [
    "349590",
    [
      211890
    ]
  ],
  "./es/ImportConfirmBox.json": [
    "996274",
    [
      49259
    ]
  ],
  "./ga/section.json": [
    "382093",
    [
      482203
    ]
  ],
  "./es/module_sequence_footer.json": [
    "799004",
    [
      59913
    ]
  ],
  "./cy/discussion_insights.json": [
    "362958",
    [
      706782
    ]
  ],
  "./ko/conferences_alternatives.json": [
    "279072",
    [
      409232
    ]
  ],
  "./da-x-k12/auth_logging.json": [
    "798113",
    [
      680763
    ]
  ],
  "./hi/reset_pace_warning_modal.json": [
    "449657",
    [
      858751
    ]
  ],
  "./nb-x-k12/sharedCurveGradesDialog.json": [
    "335220",
    [
      639636
    ]
  ],
  "./ms/canvascareer.json": [
    "110428",
    [
      99236
    ]
  ],
  "./ja/discussion_settings.json": [
    "242835",
    [
      736878
    ]
  ],
  "./it/assignments_bulk_edit.json": [
    "467303",
    [
      769321
    ]
  ],
  "./mi/choose_mastery_path.json": [
    "536743",
    [
      380053
    ]
  ],
  "./sv-x-k12/quiz_log_auditing.json": [
    "442525",
    [
      652187
    ]
  ],
  "./da-x-k12/course_paces_modal.json": [
    "32157",
    [
      809303
    ]
  ],
  "./vi/eportfolio.json": [
    "957808",
    [
      817400
    ]
  ],
  "./en-GB-x-ukhe/nav_tourpoints.json": [
    "963223",
    [
      838429
    ]
  ],
  "./ja/submit_assignment.json": [
    "306999",
    [
      912826
    ]
  ],
  "./en-GB/accessibility_scan.json": [
    "691353",
    [
      365084
    ]
  ],
  "./nb-x-k12/canvas_file_upload.json": [
    "782409",
    [
      530687
    ]
  ],
  "./en-AU-x-unimelb/users.json": [
    "199430",
    [
      178
    ]
  ],
  "./ar/entity_search_form.json": [
    "479796",
    [
      980200
    ]
  ],
  "./en-AU-x-unimelb/suppress_notifications.json": [
    "968414",
    [
      122130
    ]
  ],
  "./en-GB-x-lbs/roster_publicjs.json": [
    "920150",
    [
      440654
    ]
  ],
  "./nb/account_calendar_settings_account_calendar_item_dropdown.json": [
    "893437",
    [
      582623
    ]
  ],
  "./en-GB-x-ukhe/blueprint_settingsAssociationsTable.json": [
    "633923",
    [
      639425
    ]
  ],
  "./en-GB/theme_collection_view.json": [
    "587289",
    [
      47548
    ]
  ],
  "./pl/course_paces_blueprint_lock.json": [
    "224154",
    [
      309158
    ]
  ],
  "./ga/manage_avatars.json": [
    "45884",
    [
      603052
    ]
  ],
  "./zh-Hant/calendar.header.json": [
    "712133",
    [
      243180
    ]
  ],
  "./en-GB-x-lbs/a2_AccessibleTipContent.json": [
    "731508",
    [
      488004
    ]
  ],
  "./id/announcements_on_home_page.json": [
    "897709",
    [
      99607
    ]
  ],
  "./es-ES/peer-review-assignment-widget.json": [
    "56549",
    [
      775443
    ]
  ],
  "./nb/assignments_2_MoreOptions.json": [
    "169063",
    [
      596833
    ]
  ],
  "./nb/content_migrations_redesign.json": [
    "984641",
    [
      988627
    ]
  ],
  "./nl/CreateEditAssignmentModal.json": [
    "739798",
    [
      518354
    ]
  ],
  "./nl/course_color_selector.json": [
    "483975",
    [
      774249
    ]
  ],
  "./cy/folder_tree.json": [
    "528419",
    [
      868953
    ]
  ],
  "./he/account_course_user_search.json": [
    "385253",
    [
      538923
    ]
  ],
  "./nn/edit_section_dates.json": [
    "504304",
    [
      265236
    ]
  ],
  "./pt-BR/courses.json": [
    "778669",
    [
      485820
    ]
  ],
  "./pt-BR/account_course_user_search.json": [
    "448075",
    [
      360398
    ]
  ],
  "./ru/quiz_show.json": [
    "391048",
    [
      437856
    ]
  ],
  "./es/gradebook_history.json": [
    "253551",
    [
      862594
    ]
  ],
  "./he/assignments_2_submission_helpers.json": [
    "414721",
    [
      991327
    ]
  ],
  "./es-ES/overview_page.json": [
    "27044",
    [
      844100
    ]
  ],
  "./it/progression_module_header.json": [
    "502079",
    [
      631273
    ]
  ],
  "./nb/content_share_preview_overlay.json": [
    "570207",
    [
      705617
    ]
  ],
  "./mi/wiki_page_index.json": [
    "275101",
    [
      670739
    ]
  ],
  "./tr/self_unenrollment_modal.json": [
    "326686",
    [
      823298
    ]
  ],
  "./sv/filter_calendars_modal.json": [
    "877985",
    [
      758427
    ]
  ],
  "./es-ES/sis_import.json": [
    "5630",
    [
      92294
    ]
  ],
  "./sv-x-k12/edit_section_view.json": [
    "110521",
    [
      4399
    ]
  ],
  "./pt/peer_review_configuration_tray.json": [
    "890435",
    [
      466165
    ]
  ],
  "./cy/account_calendar_settings_filter_controls.json": [
    "841862",
    [
      91558
    ]
  ],
  "./id/account_calendar_settings_account_list.json": [
    "820406",
    [
      742290
    ]
  ],
  "./nb/permissions_role_tray_table_row.json": [
    "896056",
    [
      494628
    ]
  ],
  "./tr/blueprint_settingsSyncHistory.json": [
    "168878",
    [
      566658
    ]
  ],
  "./sv/user.json": [
    "47282",
    [
      168358
    ]
  ],
  "./fi/account_calendar_settings_utils.json": [
    "319999",
    [
      226741
    ]
  ],
  "./fi/discussion_pinned_post.json": [
    "765835",
    [
      871465
    ]
  ],
  "./ar/rootFoldersFinder.json": [
    "433084",
    [
      895560
    ]
  ],
  "./nn/accessibility_course_statistics.json": [
    "542072",
    [
      252396
    ]
  ],
  "./en/modelsQuiz.json": [
    "26284",
    [
      82344
    ]
  ],
  "./uk/users.json": [
    "948454",
    [
      89238
    ]
  ],
  "./nl/sidenav.json": [
    "563604",
    [
      518920
    ]
  ],
  "./zh-Hant/assignments_2_peer_review.json": [
    "563537",
    [
      637515
    ]
  ],
  "./el/appointment_groups.json": [
    "373315",
    [
      158541
    ]
  ],
  "./zh-Hant/account_settings_jsx_bundle.json": [
    "707932",
    [
      926560
    ]
  ],
  "./th/assignments_bulk_edit.json": [
    "310642",
    [
      941046
    ]
  ],
  "./it/modules_page_icon_legend.json": [
    "582296",
    [
      663844
    ]
  ],
  "./nb/react_files.json": [
    "256085",
    [
      820431
    ]
  ],
  "./ca/MoveOutcomesModal.json": [
    "500299",
    [
      137793
    ]
  ],
  "./en-GB/suppress_notifications.json": [
    "638125",
    [
      122320
    ]
  ],
  "./en/assignments.json": [
    "457095",
    [
      61985
    ]
  ],
  "./pl/edit_section_dates.json": [
    "434140",
    [
      658992
    ]
  ],
  "./sl/permissions_role_tray_table_row.json": [
    "729427",
    [
      884189
    ]
  ],
  "./zh-Hant/pairing_code_user_observees.json": [
    "606965",
    [
      919335
    ]
  ],
  "./es-ES/todos_page.json": [
    "336076",
    [
      681772
    ]
  ],
  "./cy/LogoutButton.json": [
    "882112",
    [
      963136
    ]
  ],
  "./th/new_user_tutorial.json": [
    "551305",
    [
      303067
    ]
  ],
  "./mi/calculator.json": [
    "760364",
    [
      620084
    ]
  ],
  "./sl/course_paces_flaggable_number_input.json": [
    "317972",
    [
      25280
    ]
  ],
  "./sl/quizzes_openModerateStudentDialog.json": [
    "362191",
    [
      915193
    ]
  ],
  "./nl/discussion_pinned_post.json": [
    "742582",
    [
      433978
    ]
  ],
  "./he/accessibility_course_statistics.json": [
    "335495",
    [
      314805
    ]
  ],
  "./sv-x-k12/assignments_2_url_entry.json": [
    "626767",
    [
      118373
    ]
  ],
  "./vi/permissions_role_tray.json": [
    "695213",
    [
      519467
    ]
  ],
  "./en-GB-x-ukhe/course_logging_details.json": [
    "747210",
    [
      786778
    ]
  ],
  "./zh-Hans/permissions_role_tray.json": [
    "846627",
    [
      267089
    ]
  ],
  "./en-GB/sections_tooltip.json": [
    "803637",
    [
      942024
    ]
  ],
  "./hy/todo.json": [
    "317727",
    [
      511397
    ]
  ],
  "./it/gradebook.json": [
    "885877",
    [
      844079
    ]
  ],
  "./hi/user_restore.json": [
    "671097",
    [
      174031
    ]
  ],
  "./pt/gradebookActionMenu.json": [
    "578545",
    [
      574915
    ]
  ],
  "./sv-x-k12/AddGroup.json": [
    "391577",
    [
      536767
    ]
  ],
  "./fi/course_default_due_time.json": [
    "413469",
    [
      641707
    ]
  ],
  "./tr/modelsQuiz.json": [
    "47011",
    [
      523525
    ]
  ],
  "./es/SpeedGraderDiscussionsNavigation.json": [
    "719257",
    [
      635176
    ]
  ],
  "./ht/grade_change_logging_content.json": [
    "299686",
    [
      868970
    ]
  ],
  "./pl/security_panel.json": [
    "288629",
    [
      946911
    ]
  ],
  "./ht/terms_of_use.json": [
    "548439",
    [
      519833
    ]
  ],
  "./da/license_help.json": [
    "504812",
    [
      396100
    ]
  ],
  "./en/quiz_log_auditing.json": [
    "156877",
    [
      761399
    ]
  ],
  "./es/accessibility_course_statistics.json": [
    "209636",
    [
      870161
    ]
  ],
  "./ja/quiz_show.json": [
    "812756",
    [
      105745
    ]
  ],
  "./th/user_lists.json": [
    "805883",
    [
      940613
    ]
  ],
  "./pt/account_calendar_settings_utils.json": [
    "703618",
    [
      972358
    ]
  ],
  "./nl/outcome_management.json": [
    "411902",
    [
      1162
    ]
  ],
  "./en-AU/course_paces_assignment_row.json": [
    "958525",
    [
      904052
    ]
  ],
  "./en-GB-x-ukhe/course_paces_projected_dates.json": [
    "86079",
    [
      681269
    ]
  ],
  "./ru/MobileNavigation.json": [
    "549125",
    [
      12067
    ]
  ],
  "./ca/media_immersive_view.json": [
    "179142",
    [
      295606
    ]
  ],
  "./da-x-k12/course_stats.json": [
    "902184",
    [
      9804
    ]
  ],
  "./ms/bulk_edit_students.json": [
    "833208",
    [
      200680
    ]
  ],
  "./nb/bulk_edit_students_table.json": [
    "125551",
    [
      479953
    ]
  ],
  "./da-x-k12/content_share_preview_overlay.json": [
    "688742",
    [
      88450
    ]
  ],
  "./ms/calendar.header.json": [
    "290855",
    [
      850414
    ]
  ],
  "./ja/CourseAvailabilityOptions.json": [
    "775843",
    [
      980158
    ]
  ],
  "./vi/student_entries.json": [
    "637155",
    [
      954369
    ]
  ],
  "./sv/security_panel.json": [
    "252394",
    [
      355158
    ]
  ],
  "./ru/sidenav.json": [
    "813895",
    [
      655693
    ]
  ],
  "./pt-BR/react_files.json": [
    "927612",
    [
      129329
    ]
  ],
  "./sl/assignments_2_login_action_prompt.json": [
    "846586",
    [
      256830
    ]
  ],
  "./ga/discovery_page.json": [
    "313242",
    [
      560506
    ]
  ],
  "./nl/assignments.never_drop.json": [
    "578482",
    [
      422205
    ]
  ],
  "./nl/react_scheduler.json": [
    "376705",
    [
      769851
    ]
  ],
  "./pl/calendar.header.json": [
    "969983",
    [
      148426
    ]
  ],
  "./de/account_settings_jsx_bundle.json": [
    "608533",
    [
      934692
    ]
  ],
  "./vi/content_migrations.json": [
    "582450",
    [
      776370
    ]
  ],
  "./en-GB/quizzes.take_quiz.json": [
    "677137",
    [
      887932
    ]
  ],
  "./da-x-k12/edit_section_end_date.json": [
    "761164",
    [
      634192
    ]
  ],
  "./da/discussion_create.json": [
    "896036",
    [
      596460
    ]
  ],
  "./es-ES/course_statistics.json": [
    "375510",
    [
      269838
    ]
  ],
  "./cy/a2LatePolicyToolTipContent.json": [
    "776311",
    [
      850405
    ]
  ],
  "./ja/users.json": [
    "617071",
    [
      745586
    ]
  ],
  "./ms/course_paces_blackout_dates_modal.json": [
    "322352",
    [
      350819
    ]
  ],
  "./nb/section.json": [
    "315377",
    [
      773811
    ]
  ],
  "./tr/quantitative_data_options.json": [
    "450557",
    [
      173743
    ]
  ],
  "./pl/login.json": [
    "546807",
    [
      427369
    ]
  ],
  "./he/gradebookActionMenu.json": [
    "708402",
    [
      977610
    ]
  ],
  "./ko/user.json": [
    "5216",
    [
      721177
    ]
  ],
  "./pl/course_paces_module.json": [
    "83381",
    [
      364719
    ]
  ],
  "./vi/blueprint_settingsCourseFilter.json": [
    "594295",
    [
      26061
    ]
  ],
  "./da/gradingPeriodTemplate.json": [
    "235158",
    [
      786022
    ]
  ],
  "./zh-Hans/gradingPeriodTemplate.json": [
    "105794",
    [
      901842
    ]
  ],
  "./tr/calendar_custom_recurring_event_repeat_picker.json": [
    "654610",
    [
      323774
    ]
  ],
  "./th/filter_calendars_modal.json": [
    "968442",
    [
      73310
    ]
  ],
  "./zh-Hans/assignments_2_submission_helpers.json": [
    "469197",
    [
      20459
    ]
  ],
  "./vi/announcements_v2.json": [
    "947812",
    [
      194148
    ]
  ],
  "./hu/course_statistics.json": [
    "655720",
    [
      218360
    ]
  ],
  "./ar/ai_experiences_ai_conversations.json": [
    "670125",
    [
      804623
    ]
  ],
  "./it/account_calendar_settings_account_tree.json": [
    "201862",
    [
      384010
    ]
  ],
  "./it/course_paces_time_selection.json": [
    "16320",
    [
      275708
    ]
  ],
  "./it/sis_import.json": [
    "231310",
    [
      585826
    ]
  ],
  "./nb-x-k12/terms_index.json": [
    "279652",
    [
      361556
    ]
  ],
  "./da/a2_AccessibleTipContent.json": [
    "103005",
    [
      991811
    ]
  ],
  "./sv/assignments_2_login_action_prompt.json": [
    "116760",
    [
      170908
    ]
  ],
  "./fa/external_content_cancel.json": [
    "788163",
    [
      113697
    ]
  ],
  "./ms/context_roster_user_services.json": [
    "915662",
    [
      157214
    ]
  ],
  "./ar/dashboard_grading_period_select.json": [
    "636015",
    [
      954473
    ]
  ],
  "./sl/outcome_management.json": [
    "942937",
    [
      120115
    ]
  ],
  "./da/assignment_show.json": [
    "691070",
    [
      925374
    ]
  ],
  "./pt/course_default_due_time.json": [
    "428136",
    [
      464780
    ]
  ],
  "./mi/external_content_cancel.json": [
    "616400",
    [
      339472
    ]
  ],
  "./nl/react_files.json": [
    "423807",
    [
      418793
    ]
  ],
  "./nb-x-k12/content_shares.json": [
    "960650",
    [
      838042
    ]
  ],
  "./ar/direct_share_course_import_panel.json": [
    "847123",
    [
      109533
    ]
  ],
  "./fi/use_switch_experience.json": [
    "277378",
    [
      923026
    ]
  ],
  "./fr/edit_section_start_date.json": [
    "267098",
    [
      408895
    ]
  ],
  "./pl/grade_change_logging_content.json": [
    "924662",
    [
      146330
    ]
  ],
  "./fr/gradebook_uploads.json": [
    "293337",
    [
      181004
    ]
  ],
  "./ms/discovery_page.json": [
    "226662",
    [
      700006
    ]
  ],
  "./id/discovery_page.json": [
    "16817",
    [
      375515
    ]
  ],
  "./hu/quantitative_data_options.json": [
    "783976",
    [
      735480
    ]
  ],
  "./ja/assignment_index_deep_linking_handlers.json": [
    "60683",
    [
      967366
    ]
  ],
  "./fr-CA/bulk_edit_students.json": [
    "946179",
    [
      503997
    ]
  ],
  "./ht/moderate_quiz.json": [
    "81897",
    [
      942971
    ]
  ],
  "./ca/account_calendars_modal.json": [
    "93027",
    [
      744425
    ]
  ],
  "./nb/course_paces_module.json": [
    "353189",
    [
      169439
    ]
  ],
  "./hu/account_calendar_settings_account_calendar_item.json": [
    "385364",
    [
      509260
    ]
  ],
  "./sl/files_v2.json": [
    "161119",
    [
      158489
    ]
  ],
  "./sv-x-k12/section.json": [
    "840654",
    [
      16006
    ]
  ],
  "./uk/assignments_2_student_points_display.json": [
    "25916",
    [
      6708
    ]
  ],
  "./hu/user_restore.json": [
    "758685",
    [
      462867
    ]
  ],
  "./fr-CA/rubrics-export.json": [
    "630342",
    [
      650538
    ]
  ],
  "./sl/account_notification_settings.json": [
    "821032",
    [
      883972
    ]
  ],
  "./th/quiz_migration_notifications.json": [
    "184515",
    [
      200381
    ]
  ],
  "./es/top_navigation_tools.json": [
    "928848",
    [
      219461
    ]
  ],
  "./fa/k5_course.json": [
    "416123",
    [
      637081
    ]
  ],
  "./nb-x-k12/conferences_alternatives.json": [
    "158940",
    [
      940524
    ]
  ],
  "./sl/sections_tooltip.json": [
    "38351",
    [
      186257
    ]
  ],
  "./cy/blueprint_course_sidebar.json": [
    "228544",
    [
      423872
    ]
  ],
  "./da-x-k12/calendar.header.json": [
    "22474",
    [
      850421
    ]
  ],
  "./is/content_share_preview_overlay.json": [
    "740819",
    [
      892481
    ]
  ],
  "./it/assignments_peer_reviews_student.json": [
    "199628",
    [
      449296
    ]
  ],
  "./hy/gradinggradingPeriodCollection.json": [
    "23770",
    [
      626602
    ]
  ],
  "./pl/assignments_2_login_action_prompt.json": [
    "408497",
    [
      982595
    ]
  ],
  "./fr/quiz_log_auditing.json": [
    "836822",
    [
      36963
    ]
  ],
  "./ga/course_paces_search.json": [
    "888797",
    [
      215419
    ]
  ],
  "./is/CommentLibrary.json": [
    "384690",
    [
      420498
    ]
  ],
  "./mi/course_paces_settings.json": [
    "334166",
    [
      298358
    ]
  ],
  "./ga/calculator_command.json": [
    "457080",
    [
      4480
    ]
  ],
  "./ms/overview_page.json": [
    "546669",
    [
      234467
    ]
  ],
  "./sv-x-k12/assignments_2_submission_helpers.json": [
    "436805",
    [
      377235
    ]
  ],
  "./fi/course_paces_app.json": [
    "955407",
    [
      994485
    ]
  ],
  "./ko/course_search_results.json": [
    "216563",
    [
      835673
    ]
  ],
  "./is/assignment_2_assignment_toggle_details.json": [
    "838218",
    [
      132509
    ]
  ],
  "./nl/calculator_command.json": [
    "309526",
    [
      299986
    ]
  ],
  "./fi/quantitative_data_options.json": [
    "328410",
    [
      346042
    ]
  ],
  "./it/ignite_agent.json": [
    "175205",
    [
      217815
    ]
  ],
  "./zh-Hans/important_dates_empty.json": [
    "453643",
    [
      852969
    ]
  ],
  "./fr-CA/epub_exports.json": [
    "497595",
    [
      170333
    ]
  ],
  "./ca/quizzes.take_quiz.json": [
    "830540",
    [
      522897
    ]
  ],
  "./ru/peer_review_allocation_rule_card.json": [
    "690531",
    [
      631681
    ]
  ],
  "./sv/wiki_page_index.json": [
    "817686",
    [
      706698
    ]
  ],
  "./es/gradingPeriodTemplate.json": [
    "23153",
    [
      242624
    ]
  ],
  "./es/k5_course.json": [
    "111534",
    [
      838655
    ]
  ],
  "./es/permissions_role_tray_table_row.json": [
    "546344",
    [
      66909
    ]
  ],
  "./id/gradebookActionMenu.json": [
    "55364",
    [
      247224
    ]
  ],
  "./pt/login.json": [
    "90351",
    [
      358737
    ]
  ],
  "./ko/progression_module_header.json": [
    "114208",
    [
      351440
    ]
  ],
  "./vi/course_paces_blackout_dates_modal.json": [
    "858541",
    [
      91643
    ]
  ],
  "./is/account_calendar_settings_confirmation_modal.json": [
    "143810",
    [
      530226
    ]
  ],
  "./es-ES/assignments_2_student_content_rubric_self_assessment.json": [
    "501252",
    [
      222884
    ]
  ],
  "./uk/canvas_file_upload.json": [
    "985187",
    [
      707753
    ]
  ],
  "./el/gradebookOutcomeGradebookView.json": [
    "870474",
    [
      406558
    ]
  ],
  "./ht/k5_course.json": [
    "941758",
    [
      433594
    ]
  ],
  "./is/group_submission_reminder.json": [
    "311549",
    [
      341880
    ]
  ],
  "./en-AU-x-unimelb/sharedSetDefaultGradeDialog.json": [
    "863073",
    [
      870867
    ]
  ],
  "./en-AU-x-unimelb/blueprint_settingsMigrationOptions.json": [
    "437425",
    [
      862979
    ]
  ],
  "./vi/course_default_due_time.json": [
    "287565",
    [
      444859
    ]
  ],
  "./mi/custom_help_link.json": [
    "504108",
    [
      825172
    ]
  ],
  "./sv-x-k12/peer_reviews_student.json": [
    "958905",
    [
      286895
    ]
  ],
  "./ht/course_link_validator.json": [
    "889685",
    [
      530767
    ]
  ],
  "./da-x-k12/announcements_on_home_page.json": [
    "18489",
    [
      539963
    ]
  ],
  "./zh-Hans/pseudonyms_mobile_login.json": [
    "915601",
    [
      171719
    ]
  ],
  "./sl/k5_course.json": [
    "575725",
    [
      589959
    ]
  ],
  "./el/peer_review_student_select.json": [
    "976311",
    [
      720809
    ]
  ],
  "./en-GB/account_course_user_search.json": [
    "309479",
    [
      134750
    ]
  ],
  "./fa/terms_of_service_modal.json": [
    "148786",
    [
      40882
    ]
  ],
  "./ms/user_logins.json": [
    "432064",
    [
      138784
    ]
  ],
  "./ar/student_entries.json": [
    "332213",
    [
      763783
    ]
  ],
  "./sl/external_content_cancel.json": [
    "320081",
    [
      534587
    ]
  ],
  "./sv-x-k12/speed_grader_helpers.json": [
    "322430",
    [
      780950
    ]
  ],
  "./cy/content_migrations_redesign.json": [
    "723841",
    [
      911647
    ]
  ],
  "./nn/sharedCurveGradesDialog.json": [
    "511438",
    [
      219914
    ]
  ],
  "./fr-CA/Navigation.json": [
    "331695",
    [
      6009
    ]
  ],
  "./ar/mutationActivity.json": [
    "855557",
    [
      277103
    ]
  ],
  "./pt-BR/gradebookOutcomeGradebookView.json": [
    "710806",
    [
      416831
    ]
  ],
  "./ru/bulk_edit_students_actions.json": [
    "780491",
    [
      276121
    ]
  ],
  "./en-AU-x-unimelb/edit_section_view.json": [
    "241226",
    [
      681518
    ]
  ],
  "./en-GB/sis_import.json": [
    "798418",
    [
      409431
    ]
  ],
  "./fa/admin_split.json": [
    "972055",
    [
      392717
    ]
  ],
  "./sv-x-k12/assignments.never_drop.json": [
    "557097",
    [
      479636
    ]
  ],
  "./hy/confirmMasteryModal.json": [
    "433555",
    [
      94833
    ]
  ],
  "./ar/choose_mastery_path.json": [
    "668486",
    [
      907122
    ]
  ],
  "./es-ES/react_developer_keys.json": [
    "583530",
    [
      832570
    ]
  ],
  "./es/assignments_2_login_action_prompt.json": [
    "377553",
    [
      185376
    ]
  ],
  "./ru/grade_summary.json": [
    "971295",
    [
      414229
    ]
  ],
  "./pt-BR/copy_course.json": [
    "416748",
    [
      452465
    ]
  ],
  "./tr/account_calendar_settings_confirmation_modal.json": [
    "535792",
    [
      604476
    ]
  ],
  "./en-AU-x-unimelb/wiki_page_index.json": [
    "360947",
    [
      195557
    ]
  ],
  "./ko/course_paces_flaggable_number_input.json": [
    "68701",
    [
      429635
    ]
  ],
  "./nl/grade_summaryGroupView.json": [
    "479594",
    [
      282382
    ]
  ],
  "./es/important_dates.json": [
    "116554",
    [
      593571
    ]
  ],
  "./he/course_paces_errors.json": [
    "293317",
    [
      410859
    ]
  ],
  "./nl/media_immersive_view.json": [
    "587348",
    [
      122568
    ]
  ],
  "./uk/widget_dashboard.json": [
    "464377",
    [
      539255
    ]
  ],
  "./ar/conferences_alternatives.json": [
    "280983",
    [
      349225
    ]
  ],
  "./es-ES/direct_share_course_import_panel.json": [
    "928241",
    [
      270583
    ]
  ],
  "./hy/course_paces_no_results.json": [
    "814632",
    [
      158720
    ]
  ],
  "./sl/discussion_settings.json": [
    "701845",
    [
      899687
    ]
  ],
  "./ar/bounced_emails.json": [
    "912911",
    [
      68081
    ]
  ],
  "./he/quantitative_data_options.json": [
    "167864",
    [
      649160
    ]
  ],
  "./ms/course_paces_errors.json": [
    "813910",
    [
      136790
    ]
  ],
  "./ga/overview_page.json": [
    "434025",
    [
      207535
    ]
  ],
  "./mi/permissions_role_tray.json": [
    "442277",
    [
      15018
    ]
  ],
  "./it/assignments_2_MoreOptions.json": [
    "147738",
    [
      134422
    ]
  ],
  "./nb-x-k12/course_paces_app.json": [
    "956102",
    [
      425230
    ]
  ],
  "./fa/direct_share_course_import_panel.json": [
    "592633",
    [
      638623
    ]
  ],
  "./vi/widget_dashboard.json": [
    "549226",
    [
      483178
    ]
  ],
  "./zh-Hant/gradebook_default_gradebook_components_content_filters_module_filter.json": [
    "747284",
    [
      793336
    ]
  ],
  "./hu/account_course_user_search.json": [
    "397013",
    [
      59611
    ]
  ],
  "./ru/sharedSetDefaultGradeDialog.json": [
    "732392",
    [
      925152
    ]
  ],
  "./tr/grades_summary.json": [
    "75659",
    [
      91173
    ]
  ],
  "./ga/assignments_2_student_header_date_title.json": [
    "882649",
    [
      894303
    ]
  ],
  "./hi/assignments_2_login_action_prompt.json": [
    "751394",
    [
      328546
    ]
  ],
  "./ht/assignmentsIndexView.json": [
    "45717",
    [
      636903
    ]
  ],
  "./ms/assignments_2_MoreOptions.json": [
    "703487",
    [
      206493
    ]
  ],
  "./nb-x-k12/security_panel.json": [
    "263223",
    [
      279693
    ]
  ],
  "./en-GB-x-ukhe/course_template_details.json": [
    "90817",
    [
      635031
    ]
  ],
  "./pt-BR/unpublished_changes_button_props.json": [
    "871546",
    [
      32507
    ]
  ],
  "./sv-x-k12/a2LatePolicyToolTipContent.json": [
    "520830",
    [
      426678
    ]
  ],
  "./ca/SpeedGraderDiscussionsNavigation.json": [
    "75553",
    [
      567151
    ]
  ],
  "./vi/course_template_details.json": [
    "753878",
    [
      711630
    ]
  ],
  "./pt-BR/external_content_cancel.json": [
    "573483",
    [
      308846
    ]
  ],
  "./sl/discussion_topics.json": [
    "79448",
    [
      297852
    ]
  ],
  "./de/appt_calendar_event_dialog.json": [
    "373275",
    [
      589118
    ]
  ],
  "./uk/discussionTopicKeyboradShortcutModal.json": [
    "209713",
    [
      850495
    ]
  ],
  "./fi/gradinggradingPeriodCollection.json": [
    "796576",
    [
      410360
    ]
  ],
  "./nb-x-k12/not_found_page_slide_puzzle.json": [
    "909191",
    [
      559245
    ]
  ],
  "./de/ImportConfirmBox.json": [
    "51675",
    [
      706302
    ]
  ],
  "./da-x-k12/EditMasteryScaleLink.json": [
    "725012",
    [
      518736
    ]
  ],
  "./en/discussion_insights.json": [
    "41765",
    [
      855591
    ]
  ],
  "./fr/react_scheduler.json": [
    "411859",
    [
      44562
    ]
  ],
  "./sl/CourseAvailabilityOptions.json": [
    "867721",
    [
      90811
    ]
  ],
  "./de/ai_experiences_ai_conversations.json": [
    "994981",
    [
      837588
    ]
  ],
  "./ko/Navigation.json": [
    "283862",
    [
      304550
    ]
  ],
  "./he/roster_publicjs.json": [
    "795767",
    [
      173381
    ]
  ],
  "./nb-x-k12/quizzes_index.json": [
    "99954",
    [
      461314
    ]
  ],
  "./ht/MobileNavigation.json": [
    "784562",
    [
      520806
    ]
  ],
  "./vi/paginated_list.json": [
    "264981",
    [
      276163
    ]
  ],
  "./en/discussion_row.json": [
    "772608",
    [
      994716
    ]
  ],
  "./id/ai_experiences.json": [
    "230817",
    [
      28851
    ]
  ],
  "./th/assignments_2_MoreOptions_CanvasFiles.json": [
    "933843",
    [
      875141
    ]
  ],
  "./en-GB-x-ukhe/sidenav.json": [
    "342828",
    [
      599196
    ]
  ],
  "./ko/appointment_groups.json": [
    "206402",
    [
      96330
    ]
  ],
  "./pl/account_calendar_settings_account_calendar_item_dropdown.json": [
    "833325",
    [
      68047
    ]
  ],
  "./es/peer_reviews_student.json": [
    "367532",
    [
      757017
    ]
  ],
  "./is.json": [
    "48889",
    [
      355021
    ]
  ],
  "./ga/sidenav.json": [
    "721446",
    [
      785966
    ]
  ],
  "./uk/discussion_create.json": [
    "255567",
    [
      451485
    ]
  ],
  "./el/conferences_alternatives.json": [
    "284521",
    [
      682891
    ]
  ],
  "./is/paginated_list.json": [
    "462730",
    [
      507642
    ]
  ],
  "./sl/empty_course.json": [
    "113828",
    [
      49704
    ]
  ],
  "./ar/rate_limiting_settings.json": [
    "565829",
    [
      920503
    ]
  ],
  "./es/user_grades.json": [
    "884554",
    [
      553539
    ]
  ],
  "./en-GB-x-ukhe/calendar_sidebar.json": [
    "90561",
    [
      215575
    ]
  ],
  "./cy/not_found_page_slide_puzzle.json": [
    "458721",
    [
      40863
    ]
  ],
  "./is/IndividualStudentMasteryOutcome.json": [
    "940903",
    [
      975277
    ]
  ],
  "./es-ES/gradebookActionMenu.json": [
    "50084",
    [
      784020
    ]
  ],
  "./da-x-k12/outcome_reporting.json": [
    "351474",
    [
      298166
    ]
  ],
  "./ga/user_lists.json": [
    "935279",
    [
      802549
    ]
  ],
  "./es/NewTabIndicator.json": [
    "915960",
    [
      265197
    ]
  ],
  "./nn/blueprint_settingsCourseFilter.json": [
    "899420",
    [
      932600
    ]
  ],
  "./sv/grades_summary.json": [
    "527658",
    [
      48630
    ]
  ],
  "./ca/calculator.json": [
    "918206",
    [
      794462
    ]
  ],
  "./da-x-k12/new_user_tutorial.json": [
    "248100",
    [
      466120
    ]
  ],
  "./fi/assignments_2_media_attempt.json": [
    "770009",
    [
      704303
    ]
  ],
  "./da-x-k12/progression_module_header.json": [
    "622867",
    [
      876821
    ]
  ],
  "./sl/theme_collection_view.json": [
    "636960",
    [
      80597
    ]
  ],
  "./ar/sis_import.json": [
    "30696",
    [
      30644
    ]
  ],
  "./fa/discussion_pinned_post.json": [
    "662403",
    [
      31857
    ]
  ],
  "./fr-CA/upload_button.json": [
    "809205",
    [
      94095
    ]
  ],
  "./hi/sharedCurveGradesDialog.json": [
    "851217",
    [
      685063
    ]
  ],
  "./ar/quizzes_quiz_submission.json": [
    "175565",
    [
      617695
    ]
  ],
  "./ko/unpublished_changes_tray_contents.json": [
    "754237",
    [
      185123
    ]
  ],
  "./ga/syllabus_revisions.json": [
    "628932",
    [
      142548
    ]
  ],
  "./id/ImportConfirmBox.json": [
    "385257",
    [
      879339
    ]
  ],
  "./ar/course_paces_modal.json": [
    "335747",
    [
      599349
    ]
  ],
  "./da-x-k12/use_switch_experience.json": [
    "334142",
    [
      249826
    ]
  ],
  "./he/remove_pace_warning_modal.json": [
    "450630",
    [
      37446
    ]
  ],
  "./en-GB-x-ukhe/blueprint_course_child.json": [
    "378320",
    [
      685656
    ]
  ],
  "./pl/add_edit_pseudonym.json": [
    "994655",
    [
      641825
    ]
  ],
  "./uk.json": [
    "319205",
    [
      463449
    ]
  ],
  "./is/assignments_peer_reviews_student.json": [
    "262383",
    [
      26005
    ]
  ],
  "./he/permissions_v2_add_tray.json": [
    "16711",
    [
      702773
    ]
  ],
  "./fa/collaborations.json": [
    "826575",
    [
      355541
    ]
  ],
  "./pt-BR/user_search_results.json": [
    "181562",
    [
      981707
    ]
  ],
  "./sv-x-k12/ai_experiences_ai_conversations.json": [
    "2525",
    [
      645755
    ]
  ],
  "./nb-x-k12/quizzes_openModerateStudentDialog.json": [
    "387641",
    [
      710926
    ]
  ],
  "./en-GB-x-ukhe/assignments_peer_reviews_student.json": [
    "212621",
    [
      497259
    ]
  ],
  "./nl/user_lists.json": [
    "530049",
    [
      975963
    ]
  ],
  "./pt/assignmentsIndexView.json": [
    "882349",
    [
      387855
    ]
  ],
  "./cy/empty_course.json": [
    "547313",
    [
      450991
    ]
  ],
  "./nb-x-k12/permissions_v2_add_tray.json": [
    "416314",
    [
      241402
    ]
  ],
  "./cy/learning_mastery_gradebook.json": [
    "806575",
    [
      870477
    ]
  ],
  "./de/enhanced_individual_gradebook_submit_score.json": [
    "727476",
    [
      895369
    ]
  ],
  "./en-AU/sharedCurveGradesDialog.json": [
    "325300",
    [
      495505
    ]
  ],
  "./ca/grade_summaryGroupView.json": [
    "604816",
    [
      321696
    ]
  ],
  "./en-AU-x-unimelb/webcam_modal.json": [
    "334665",
    [
      847019
    ]
  ],
  "./ms/course_paces_pace_picker.json": [
    "45733",
    [
      748299
    ]
  ],
  "./pt/calendar_appointment_group_edit.json": [
    "257419",
    [
      133477
    ]
  ],
  "./ru/dashboard.json": [
    "876944",
    [
      629649
    ]
  ],
  "./th/course_stats.json": [
    "434411",
    [
      716349
    ]
  ],
  "./zh-Hans/ProfileTray.json": [
    "494152",
    [
      583504
    ]
  ],
  "./sv/quizzes_index.json": [
    "780429",
    [
      860295
    ]
  ],
  "./ar/user_search_results.json": [
    "187564",
    [
      5472
    ]
  ],
  "./es-ES/MasteryScale.json": [
    "243284",
    [
      704452
    ]
  ],
  "./hy/question_banks.json": [
    "269587",
    [
      958673
    ]
  ],
  "./fa/gradinggradingPeriodCollection.json": [
    "375704",
    [
      278976
    ]
  ],
  "./ga/custom_help_link.json": [
    "374406",
    [
      632926
    ]
  ],
  "./de/edit_section_end_date.json": [
    "612986",
    [
      711115
    ]
  ],
  "./zh-Hant/course_template_details.json": [
    "874997",
    [
      314935
    ]
  ],
  "./ga/group_submission_reminder.json": [
    "900325",
    [
      195075
    ]
  ],
  "./en-AU-x-unimelb/restore_content_pane.json": [
    "694901",
    [
      856239
    ]
  ],
  "./ar/assignments.never_drop.json": [
    "651321",
    [
      620824
    ]
  ],
  "./cy/accessibility_scan.json": [
    "374522",
    [
      45058
    ]
  ],
  "./th/theme_collection_view.json": [
    "697416",
    [
      277836
    ]
  ],
  "./tr/mutationActivity.json": [
    "573982",
    [
      681666
    ]
  ],
  "./ca/assignments_2_submission_histories_query.json": [
    "345874",
    [
      917626
    ]
  ],
  "./pt/calculator.json": [
    "619502",
    [
      648082
    ]
  ],
  "./it/calendar_sidebar.json": [
    "110348",
    [
      100256
    ]
  ],
  "./fr/unpublished_changes_button_props.json": [
    "280437",
    [
      600824
    ]
  ],
  "./en-GB-x-lbs/MasteryScale.json": [
    "504549",
    [
      106451
    ]
  ],
  "./uk/account_settings.json": [
    "334779",
    [
      881201
    ]
  ],
  "./zh-Hans/gradebookOutcomeGradebookView.json": [
    "465884",
    [
      460540
    ]
  ],
  "./ar/epub_exports.json": [
    "117905",
    [
      675131
    ]
  ],
  "./zh-Hans/account_calendar_settings_filter_controls.json": [
    "16289",
    [
      473783
    ]
  ],
  "./fr/LogoutButton.json": [
    "872552",
    [
      946225
    ]
  ],
  "./en/quizzes_public.json": [
    "414380",
    [
      305056
    ]
  ],
  "./fa/grades_empty_page.json": [
    "762303",
    [
      624709
    ]
  ],
  "./tr/notebook.json": [
    "960289",
    [
      278091
    ]
  ],
  "./de/registration.json": [
    "110910",
    [
      183255
    ]
  ],
  "./ga/course_paces_settings.json": [
    "803352",
    [
      153056
    ]
  ],
  "./mi/assignments_2_url_entry.json": [
    "961846",
    [
      982742
    ]
  ],
  "./en-GB-x-ukhe/assignments.json": [
    "399210",
    [
      768922
    ]
  ],
  "./cy/account_calendar_settings.json": [
    "759512",
    [
      635240
    ]
  ],
  "./da/course_navigation_settings.json": [
    "128411",
    [
      486449
    ]
  ],
  "./ht/submit_online_url_assignment.json": [
    "199462",
    [
      874154
    ]
  ],
  "./el/question_bank.json": [
    "820068",
    [
      694920
    ]
  ],
  "./pt/blueprint_settingsUnsyncedChanges.json": [
    "356467",
    [
      261717
    ]
  ],
  "./ar/MoveOutcomesModal.json": [
    "395404",
    [
      719800
    ]
  ],
  "./hu/quizzes_public.json": [
    "601600",
    [
      501184
    ]
  ],
  "./hy/discovery_page.json": [
    "162523",
    [
      198665
    ]
  ],
  "./fa/course_paces_empty_state.json": [
    "383859",
    [
      834945
    ]
  ],
  "./es-ES/course_paces_blackout_dates_table.json": [
    "349076",
    [
      415156
    ]
  ],
  "./en-AU-x-unimelb/account_notification_settings.json": [
    "477779",
    [
      879189
    ]
  ],
  "./ht/blueprint_settingsSyncHistory.json": [
    "210108",
    [
      128120
    ]
  ],
  "./ko/knowledge_check_not_ready.json": [
    "946201",
    [
      828727
    ]
  ],
  "./ja/assignments_2_student_content_rubric_self_assessment.json": [
    "90944",
    [
      52357
    ]
  ],
  "./vi/error_form.json": [
    "84684",
    [
      749676
    ]
  ],
  "./ar/HelpTray.json": [
    "599412",
    [
      256768
    ]
  ],
  "./id/assignments_bulk_edit_use_save_assignment.json": [
    "857559",
    [
      173665
    ]
  ],
  "./it/sharedSetDefaultGradeDialog.json": [
    "824456",
    [
      122924
    ]
  ],
  "./mi/quizzes_quiz_submission.json": [
    "343476",
    [
      498668
    ]
  ],
  "./da-x-k12/rootFoldersFinder.json": [
    "638878",
    [
      561178
    ]
  ],
  "./ms/k5_course.json": [
    "466182",
    [
      308422
    ]
  ],
  "./sv/discussion_pinned_post.json": [
    "275551",
    [
      336393
    ]
  ],
  "./uk/sharedCurveGradesDialog.json": [
    "95882",
    [
      697026
    ]
  ],
  "./vi/courses.show.json": [
    "309124",
    [
      153607
    ]
  ],
  "./fa/discussion_topics.json": [
    "692542",
    [
      911590
    ]
  ],
  "./es-ES/security_panel.json": [
    "387982",
    [
      49558
    ]
  ],
  "./en-GB-x-lbs/discussion_topics.json": [
    "20953",
    [
      688735
    ]
  ],
  "./es/assignment_index_deep_linking_handlers.json": [
    "549308",
    [
      216713
    ]
  ],
  "./ko/course_pace_date_input.json": [
    "318453",
    [
      394763
    ]
  ],
  "./fa/course_statistics.json": [
    "566446",
    [
      214822
    ]
  ],
  "./ms/conversations_2.json": [
    "56187",
    [
      326465
    ]
  ],
  "./nb-x-k12/MobileNavigation.json": [
    "789604",
    [
      799332
    ]
  ],
  "./nb/reset_pace_warning_modal.json": [
    "830084",
    [
      59408
    ]
  ],
  "./ms/account_calendar_settings_account_list.json": [
    "142081",
    [
      547839
    ]
  ],
  "./zh-Hans/quizzes.take_quiz.json": [
    "84163",
    [
      767268
    ]
  ],
  "./cy/content_exports.json": [
    "970355",
    [
      399145
    ]
  ],
  "./pt/permissions_v2_add_tray.json": [
    "10000",
    [
      961036
    ]
  ],
  "./ms/discussion_settings.json": [
    "142774",
    [
      756406
    ]
  ],
  "./th/assignments_2_media_attempt.json": [
    "22580",
    [
      18552
    ]
  ],
  "./ja/SpeedGraderDiscussionsNavigation.json": [
    "384322",
    [
      959787
    ]
  ],
  "./vi/todos_page.json": [
    "883852",
    [
      338876
    ]
  ],
  "./ar/account_calendar_settings_footer.json": [
    "96743",
    [
      991993
    ]
  ],
  "./zh-Hant/entity_search_form.json": [
    "839267",
    [
      33989
    ]
  ],
  "./fr/course_paces_projected_dates.json": [
    "943141",
    [
      846208
    ]
  ],
  "./nb-x-k12/ldap_cert_upload.json": [
    "699828",
    [
      34900
    ]
  ],
  "./pt-BR/modelsQuiz.json": [
    "81450",
    [
      221627
    ]
  ],
  "./th/FindOutcomesModal.json": [
    "992789",
    [
      17463
    ]
  ],
  "./fr/knowledge_check_not_ready.json": [
    "703179",
    [
      749346
    ]
  ],
  "./tr/grades_empty_page.json": [
    "767328",
    [
      988980
    ]
  ],
  "./ko/content_shares.json": [
    "721174",
    [
      586726
    ]
  ],
  "./pl/appointment_groups.json": [
    "499552",
    [
      796964
    ]
  ],
  "./hi/widget_dashboard.json": [
    "787188",
    [
      666452
    ]
  ],
  "./nb-x-k12/calendar_edit.json": [
    "965971",
    [
      394206
    ]
  ],
  "./zh-Hant/account_calendar_settings_account_calendar_item_dropdown.json": [
    "767591",
    [
      522961
    ]
  ],
  "./it/assignmentsIndexView.json": [
    "393926",
    [
      881306
    ]
  ],
  "./es/student_entries.json": [
    "650566",
    [
      583703
    ]
  ],
  "./ko/GroupDetailView.json": [
    "630851",
    [
      361001
    ]
  ],
  "./sv-x-k12/jobs_v2.json": [
    "452664",
    [
      387984
    ]
  ],
  "./de/content_migrations.json": [
    "701704",
    [
      60245
    ]
  ],
  "./da-x-k12/peer_review_student_select.json": [
    "297423",
    [
      279241
    ]
  ],
  "./ms/assignments_2_shared_Steps.json": [
    "132667",
    [
      600065
    ]
  ],
  "./en-GB/modules_home_page.json": [
    "219474",
    [
      129095
    ]
  ],
  "./ht/outcomes_user_outcome_results.json": [
    "581897",
    [
      368771
    ]
  ],
  "./da/error_form.json": [
    "403574",
    [
      684678
    ]
  ],
  "./en-GB/roster_publicjs.json": [
    "22961",
    [
      322772
    ]
  ],
  "./id/assignments_peer_reviews.json": [
    "608436",
    [
      197584
    ]
  ],
  "./da/modules_home_page.json": [
    "58764",
    [
      982884
    ]
  ],
  "./nb-x-k12/a2_AccessibleTipContent.json": [
    "850280",
    [
      782096
    ]
  ],
  "./ru/blueprint_settingsCourseFilter.json": [
    "775719",
    [
      836589
    ]
  ],
  "./ca/blueprint_settingsSyncChange.json": [
    "652052",
    [
      45820
    ]
  ],
  "./ht/content_copy_redesign.json": [
    "384953",
    [
      572395
    ]
  ],
  "./nb-x-k12/grades_empty_page.json": [
    "432600",
    [
      990640
    ]
  ],
  "./da/mutationActivity.json": [
    "491961",
    [
      654039
    ]
  ],
  "./ms/assignment_show.json": [
    "101045",
    [
      874203
    ]
  ],
  "./vi/default_account_quotas.json": [
    "807762",
    [
      837634
    ]
  ],
  "./zh-Hans/module_sequence_footer.json": [
    "437033",
    [
      704607
    ]
  ],
  "./es/wiki_page_index.json": [
    "315147",
    [
      351990
    ]
  ],
  "./zh-Hant/submissions_show_preview.json": [
    "536703",
    [
      31728
    ]
  ],
  "./is/course_paces_footer.json": [
    "523550",
    [
      812038
    ]
  ],
  "./sv-x-k12/course_stats.json": [
    "158254",
    [
      102022
    ]
  ],
  "./en-GB-x-lbs/course_navigation_settings.json": [
    "941748",
    [
      771748
    ]
  ],
  "./es.json": [
    "480141",
    [
      94113
    ]
  ],
  "./ms/SpeedGraderDiscussionsNavigation.json": [
    "895265",
    [
      632671
    ]
  ],
  "./en-GB-x-ukhe/self_unenrollment_modal.json": [
    "73538",
    [
      336050
    ]
  ],
  "./hy/external_content_cancel.json": [
    "171385",
    [
      408703
    ]
  ],
  "./is/bulk_edit_students.json": [
    "738436",
    [
      114100
    ]
  ],
  "./hu/permissions_v2_add_tray.json": [
    "168855",
    [
      290098
    ]
  ],
  "./da/quizzes_openModerateStudentDialog.json": [
    "38923",
    [
      771489
    ]
  ],
  "./ga/discussion_row.json": [
    "713325",
    [
      972923
    ]
  ],
  "./it/quizzes_openModerateStudentDialog.json": [
    "76061",
    [
      837503
    ]
  ],
  "./tr/custom_emoji_deny_list.json": [
    "550690",
    [
      253566
    ]
  ],
  "./mi/rootFoldersFinder.json": [
    "575949",
    [
      400451
    ]
  ],
  "./uk/outcomes_user_outcome_results.json": [
    "657217",
    [
      938767
    ]
  ],
  "./hy/react_developer_keys.json": [
    "125452",
    [
      267292
    ]
  ],
  "./uk/dashboard.json": [
    "326993",
    [
      756382
    ]
  ],
  "./da/content_share_preview_overlay.json": [
    "299244",
    [
      738116
    ]
  ],
  "./nb-x-k12/media_player_iframe_content.json": [
    "508979",
    [
      741809
    ]
  ],
  "./is/roster_publicjs.json": [
    "233000",
    [
      902128
    ]
  ],
  "./ht/enhanced_individual_gradebook_submit_score.json": [
    "36197",
    [
      267903
    ]
  ],
  "./mi/eportfolio.json": [
    "526629",
    [
      300971
    ]
  ],
  "./cy/student_study_drawer.json": [
    "183209",
    [
      791703
    ]
  ],
  "./el/course_paces_change_tracking.json": [
    "228100",
    [
      554848
    ]
  ],
  "./de/SpeedGraderPostGradesMenu.json": [
    "986884",
    [
      763321
    ]
  ],
  "./fi/submit_online_url_assignment.json": [
    "356333",
    [
      306539
    ]
  ],
  "./is/react_scheduler.json": [
    "282735",
    [
      585317
    ]
  ],
  "./nb-x-k12.json": [
    "924187",
    [
      31643
    ]
  ],
  "./nn/CommentLibrary.json": [
    "915626",
    [
      651985
    ]
  ],
  "./en-GB-x-lbs/course_paces_app.json": [
    "431586",
    [
      553506
    ]
  ],
  "./ms/assignments_2_file_upload.json": [
    "60168",
    [
      935672
    ]
  ],
  "./sl/assignments_2_initial_query.json": [
    "671266",
    [
      885606
    ]
  ],
  "./zh-Hans/calendar_sidebar.json": [
    "325462",
    [
      53310
    ]
  ],
  "./en-GB/course_paces_blackout_dates_table.json": [
    "322720",
    [
      204409
    ]
  ],
  "./hu/assignments_2_student_header_date_title.json": [
    "769750",
    [
      623702
    ]
  ],
  "./pl/course_paces_app.json": [
    "26752",
    [
      814204
    ]
  ],
  "./ru/editGroup.json": [
    "561288",
    [
      473488
    ]
  ],
  "./sv/peer_review_configuration_tray.json": [
    "235572",
    [
      876760
    ]
  ],
  "./en-GB-x-ukhe/courses.json": [
    "247950",
    [
      824470
    ]
  ],
  "./es/assignments_2_student_content.json": [
    "654563",
    [
      276942
    ]
  ],
  "./fr-CA/account_calendar_settings_utils.json": [
    "798387",
    [
      276933
    ]
  ],
  "./en-AU-x-unimelb/video_conference.json": [
    "913332",
    [
      64080
    ]
  ],
  "./fr/reset_pace_warning_modal.json": [
    "423660",
    [
      613101
    ]
  ],
  "./is/direct_share_course_import_panel.json": [
    "134338",
    [
      596562
    ]
  ],
  "./vi/content_copy_redesign.json": [
    "99764",
    [
      227479
    ]
  ],
  "./hy/assignments_2_student_content.json": [
    "14800",
    [
      402360
    ]
  ],
  "./fr/webzip_export.json": [
    "527518",
    [
      616099
    ]
  ],
  "./de/blueprint_settingsAssociationsTable.json": [
    "367578",
    [
      803243
    ]
  ],
  "./da/section.json": [
    "396210",
    [
      140090
    ]
  ],
  "./ms/gradebookActionMenu.json": [
    "801633",
    [
      629759
    ]
  ],
  "./th/k5_dashboard.json": [
    "743181",
    [
      288375
    ]
  ],
  "./hu/user_profile.json": [
    "437122",
    [
      85594
    ]
  ],
  "./it/ai_experiences.json": [
    "489905",
    [
      140867
    ]
  ],
  "./ja/bulk_edit_students.json": [
    "909427",
    [
      940238
    ]
  ],
  "./fa/ai_experiences.json": [
    "470361",
    [
      482543
    ]
  ],
  "./cy/account_notification_settings.json": [
    "875371",
    [
      6801
    ]
  ],
  "./en-GB-x-lbs/canvas_file_upload.json": [
    "864717",
    [
      616843
    ]
  ],
  "./id/SpeedGraderPostGradesMenu.json": [
    "340626",
    [
      236910
    ]
  ],
  "./ga/NewTabIndicator.json": [
    "323204",
    [
      280180
    ]
  ],
  "./fr/user_date_range_search.json": [
    "736993",
    [
      304172
    ]
  ],
  "./pt-BR/course_paces_header.json": [
    "360453",
    [
      461348
    ]
  ],
  "./zh-Hant/IndividualStudentMasteryOutcome.json": [
    "337953",
    [
      790171
    ]
  ],
  "./zh-Hant/collaborations.json": [
    "1762",
    [
      330446
    ]
  ],
  "./sv/peer_review_allocation_rules_tray.json": [
    "287130",
    [
      714134
    ]
  ],
  "./fr/horizon_toggle.json": [
    "605578",
    [
      8031
    ]
  ],
  "./pt-BR/job_stats.json": [
    "736136",
    [
      310021
    ]
  ],
  "./vi/discussion_settings.json": [
    "376151",
    [
      710333
    ]
  ],
  "./ca/assignment_grade_summary.json": [
    "294632",
    [
      178152
    ]
  ],
  "./ca/module_sequence_footer.json": [
    "368084",
    [
      499388
    ]
  ],
  "./ko/password_complexity_configuration.json": [
    "511183",
    [
      938493
    ]
  ],
  "./pl/plugins.json": [
    "819270",
    [
      77402
    ]
  ],
  "./pt-BR/epub_exports.json": [
    "722023",
    [
      192242
    ]
  ],
  "./ar/blueprint_settingsCourseFilter.json": [
    "920421",
    [
      243879
    ]
  ],
  "./ar/course_paces_footer.json": [
    "777865",
    [
      663411
    ]
  ],
  "./he/theme_collection_view.json": [
    "783775",
    [
      36669
    ]
  ],
  "./it/course_paces_assignment_row.json": [
    "959934",
    [
      720770
    ]
  ],
  "./hu/grade_summary.json": [
    "918593",
    [
      928031
    ]
  ],
  "./vi/wiki_page_index.json": [
    "203946",
    [
      932698
    ]
  ],
  "./ko/ai_experiences_ai_conversations.json": [
    "743004",
    [
      472180
    ]
  ],
  "./ar/discussion_posts.json": [
    "286783",
    [
      416593
    ]
  ],
  "./en-AU-x-unimelb/course_navigation_settings.json": [
    "843590",
    [
      18410
    ]
  ],
  "./zh-Hant/FindOutcomesModal.json": [
    "365731",
    [
      116021
    ]
  ],
  "./cy/media_player_iframe_content.json": [
    "446729",
    [
      308567
    ]
  ],
  "./es/grade_details.json": [
    "68612",
    [
      532049
    ]
  ],
  "./en-AU-x-unimelb/question_bank.json": [
    "926833",
    [
      391331
    ]
  ],
  "./pl/account_calendars_results_area.json": [
    "790132",
    [
      16392
    ]
  ],
  "./es-ES/account_settings.json": [
    "542964",
    [
      263140
    ]
  ],
  "./ja/assignments_2_MoreOptions.json": [
    "318430",
    [
      251839
    ]
  ],
  "./tr/gradebook.json": [
    "225474",
    [
      879510
    ]
  ],
  "./ms/files_v2.json": [
    "973738",
    [
      407346
    ]
  ],
  "./ru/choose_mastery_path.json": [
    "551612",
    [
      593148
    ]
  ],
  "./ht/user_lists.json": [
    "207731",
    [
      989789
    ]
  ],
  "./sl/assignments_2_student_points_display.json": [
    "983837",
    [
      47231
    ]
  ],
  "./nb/permissions.json": [
    "257486",
    [
      550626
    ]
  ],
  "./en-CA/course_paces_search.json": [
    "297729",
    [
      83335
    ]
  ],
  "./is/new_user_tutorial.json": [
    "513365",
    [
      930147
    ]
  ],
  "./uk/quantitative_data_options.json": [
    "789403",
    [
      968529
    ]
  ],
  "./nb/blueprint_settingsMigrationOptions.json": [
    "136089",
    [
      953203
    ]
  ],
  "./ru/assignments_2_MoreOptions_CanvasFiles.json": [
    "830210",
    [
      605010
    ]
  ],
  "./ru/assignments_2_student_content.json": [
    "177102",
    [
      221414
    ]
  ],
  "./ko/quizzes_openModerateStudentDialog.json": [
    "798954",
    [
      282562
    ]
  ],
  "./ms/blueprint_settingsAssociationsTable.json": [
    "946605",
    [
      123811
    ]
  ],
  "./nb-x-k12/account_calendar_settings_account_calendar_item_dropdown.json": [
    "615615",
    [
      376325
    ]
  ],
  "./tr/account_course_user_search.json": [
    "969778",
    [
      853102
    ]
  ],
  "./fi/custom_emoji_deny_list.json": [
    "382959",
    [
      768565
    ]
  ],
  "./sv-x-k12/user_restore.json": [
    "93977",
    [
      776591
    ]
  ],
  "./fi/gradebook_default_gradebook_components_content_filters_module_filter.json": [
    "444997",
    [
      729555
    ]
  ],
  "./cy/new_nav.json": [
    "796162",
    [
      809466
    ]
  ],
  "./de/AssignmentListItemView.json": [
    "101804",
    [
      802641
    ]
  ],
  "./en-AU-x-unimelb/FindOutcomesModal.json": [
    "901733",
    [
      670655
    ]
  ],
  "./ga/CourseAvailabilityOptions.json": [
    "915198",
    [
      986566
    ]
  ],
  "./vi/course_paces_blackout_dates_table.json": [
    "630036",
    [
      578980
    ]
  ],
  "./da-x-k12/account_calendars_results_area.json": [
    "481879",
    [
      796105
    ]
  ],
  "./en-GB-x-lbs/todo.json": [
    "76760",
    [
      728064
    ]
  ],
  "./nn/custom_help_link.json": [
    "464134",
    [
      825514
    ]
  ],
  "./fr-CA/MobileGlobalMenu.json": [
    "371503",
    [
      916873
    ]
  ],
  "./nb/dashboard_grading_period_select.json": [
    "623648",
    [
      810412
    ]
  ],
  "./pt-BR/sections_tooltip.json": [
    "423233",
    [
      510136
    ]
  ],
  "./zh-Hans/GroupsTray.json": [
    "300355",
    [
      693089
    ]
  ],
  "./pl/course_paces_blackout_date_row.json": [
    "84086",
    [
      567450
    ]
  ],
  "./is/assignments_bulk_edit_use_save_assignment.json": [
    "95078",
    [
      897614
    ]
  ],
  "./en-AU-x-unimelb/filter_calendars_modal.json": [
    "969738",
    [
      660806
    ]
  ],
  "./nb-x-k12/blueprint_settingsMigrationOptions.json": [
    "2439",
    [
      991741
    ]
  ],
  "./pl/peer-review-assignment-widget.json": [
    "477012",
    [
      525104
    ]
  ],
  "./de/calculator_command.json": [
    "115445",
    [
      25572
    ]
  ],
  "./vi/progress_pill.json": [
    "629360",
    [
      503016
    ]
  ],
  "./ko/account_settings_jsx_bundle.json": [
    "229936",
    [
      529440
    ]
  ],
  "./nb/assignments_peer_reviews_student.json": [
    "63595",
    [
      594661
    ]
  ],
  "./da/course_paces_app.json": [
    "369609",
    [
      148775
    ]
  ],
  "./it/HelpTray.json": [
    "239650",
    [
      765206
    ]
  ],
  "./nn/appointment_groups.json": [
    "950524",
    [
      431344
    ]
  ],
  "./en-GB-x-ukhe/account_calendar_settings_footer.json": [
    "516784",
    [
      611160
    ]
  ],
  "./id/permissions_role_tray_table_row.json": [
    "60861",
    [
      979719
    ]
  ],
  "./sv/assignments.json": [
    "434089",
    [
      892379
    ]
  ],
  "./es-ES/assignments_2_initial_query.json": [
    "268200",
    [
      956288
    ]
  ],
  "./fr-CA/edit_section_end_date.json": [
    "594564",
    [
      925296
    ]
  ],
  "./ca/grade_details.json": [
    "999164",
    [
      230132
    ]
  ],
  "./sl/ProfileTray.json": [
    "816184",
    [
      946204
    ]
  ],
  "./sl/course_paces_blackout_dates_table.json": [
    "575462",
    [
      847026
    ]
  ],
  "./fa/SpeedGraderPostGradesMenu.json": [
    "752250",
    [
      11578
    ]
  ],
  "./es-ES/account_calendar_settings_utils.json": [
    "211727",
    [
      107925
    ]
  ],
  "./hu/courses.json": [
    "592591",
    [
      786733
    ]
  ],
  "./sv-x-k12/default_account_quotas.json": [
    "53244",
    [
      395852
    ]
  ],
  "./tr/assignments_2_url_entry.json": [
    "608038",
    [
      665242
    ]
  ],
  "./th/default_account_quotas.json": [
    "68693",
    [
      253263
    ]
  ],
  "./en-CA/roster_section_input.json": [
    "245290",
    [
      544394
    ]
  ],
  "./da-x-k12/ProfileTray.json": [
    "323098",
    [
      276582
    ]
  ],
  "./fa/unpublished_warning_modal.json": [
    "348949",
    [
      71523
    ]
  ],
  "./pt/assignments_2_peer_review.json": [
    "935663",
    [
      402985
    ]
  ],
  "./hy/grade_summaryGroupView.json": [
    "4437",
    [
      583875
    ]
  ],
  "./vi/permissions_v2_add_tray.json": [
    "627657",
    [
      506767
    ]
  ],
  "./tr/question_banks.json": [
    "274076",
    [
      639160
    ]
  ],
  "./fr/blueprint_course_sidebar.json": [
    "808872",
    [
      763177
    ]
  ],
  "./fr-CA/ai_experiences_edit.json": [
    "812746",
    [
      128854
    ]
  ],
  "./en-GB-x-ukhe/course_paces_empty_state.json": [
    "193338",
    [
      503034
    ]
  ],
  "./en-GB-x-ukhe/security_panel.json": [
    "731123",
    [
      683121
    ]
  ],
  "./es-ES/LearningMasteryGradebook.json": [
    "969750",
    [
      348750
    ]
  ],
  "./es-ES/custom_help_link.json": [
    "320781",
    [
      383819
    ]
  ],
  "./fr/accessibility_course_statistics.json": [
    "79836",
    [
      984069
    ]
  ],
  "./he/quiz_show.json": [
    "764594",
    [
      978602
    ]
  ],
  "./nb/assignment_show.json": [
    "106797",
    [
      261567
    ]
  ],
  "./sv/last_attended.json": [
    "389043",
    [
      116605
    ]
  ],
  "./fr-CA/canvascareer.json": [
    "909099",
    [
      165661
    ]
  ],
  "./he/peer_review_student_select.json": [
    "691489",
    [
      625695
    ]
  ],
  "./nl/keyboardShortcutModal.json": [
    "181124",
    [
      393664
    ]
  ],
  "./id/video_conference.json": [
    "114223",
    [
      642721
    ]
  ],
  "./ms/DueDateOverrideView.json": [
    "499793",
    [
      246575
    ]
  ],
  "./pt-BR/self_unenrollment_modal.json": [
    "562305",
    [
      741400
    ]
  ],
  "./uk/sis_import.json": [
    "162745",
    [
      331575
    ]
  ],
  "./da-x-k12/unpublished_changes_button_props.json": [
    "363382",
    [
      99514
    ]
  ],
  "./tr/progress_pill.json": [
    "980803",
    [
      183245
    ]
  ],
  "./handlebars-namespaces.json": [
    "737876",
    []
  ],
  "./el/horizon_toggle.json": [
    "985389",
    [
      868415
    ]
  ],
  "./nb/mutationActivity.json": [
    "670072",
    [
      384060
    ]
  ],
  "./fa/assignments_2_MoreOptions.json": [
    "213922",
    [
      71906
    ]
  ],
  "./fr-CA/permissions.json": [
    "709135",
    [
      335473
    ]
  ],
  "./es-ES/jobs.json": [
    "71017",
    [
      334303
    ]
  ],
  "./it/blueprint_settingsSyncHistory.json": [
    "683041",
    [
      266123
    ]
  ],
  "./ja/mutationActivity.json": [
    "720707",
    [
      803358
    ]
  ],
  "./zh-Hans/canvas_file_upload.json": [
    "558846",
    [
      292038
    ]
  ],
  "./ar/k5_course.json": [
    "709125",
    [
      942407
    ]
  ],
  "./th/enhanced_individual_gradebook_submit_score.json": [
    "700797",
    [
      84311
    ]
  ],
  "./en-GB-x-ukhe/content_migrations.json": [
    "76791",
    [
      36685
    ]
  ],
  "./en/sidenav.json": [
    "63349",
    [
      67479
    ]
  ],
  "./da/peer_review_allocation_rule_card.json": [
    "267953",
    [
      722271
    ]
  ],
  "./cy/course_paces_module.json": [
    "546469",
    [
      718603
    ]
  ],
  "./he/quizzes_regrade_modal.json": [
    "352373",
    [
      529563
    ]
  ],
  "./nn/account_calendar_settings_confirmation_modal.json": [
    "735658",
    [
      407606
    ]
  ],
  "./nl/course_paces_projected_dates.json": [
    "251287",
    [
      289617
    ]
  ],
  "./it/roster_publicjs.json": [
    "883237",
    [
      458039
    ]
  ],
  "./vi/course_link_validator.json": [
    "40008",
    [
      955968
    ]
  ],
  "./uk/accessibility_checker.json": [
    "817518",
    [
      283918
    ]
  ],
  "./mi/discussion_row.json": [
    "584591",
    [
      224877
    ]
  ],
  "./ar/user_grades.json": [
    "378149",
    [
      153135
    ]
  ],
  "./fr-CA/course_paces_blackout_date_row.json": [
    "655193",
    [
      79291
    ]
  ],
  "./uk/custom_help_link.json": [
    "138842",
    [
      896466
    ]
  ],
  "./hy/AccountsTray.json": [
    "877039",
    [
      637733
    ]
  ],
  "./en-AU-x-unimelb/link_validator.json": [
    "241483",
    [
      262661
    ]
  ],
  "./sv/course_paces_empty_state.json": [
    "146775",
    [
      753529
    ]
  ],
  "./el/peer_reviews_student.json": [
    "405355",
    [
      452877
    ]
  ],
  "./sl/confirmMasteryModal.json": [
    "583515",
    [
      723957
    ]
  ],
  "./nb/appointment_groups.json": [
    "519440",
    [
      976276
    ]
  ],
  "./it/pairing_code_user_observees.json": [
    "84066",
    [
      414046
    ]
  ],
  "./it/peer_reviews_student.json": [
    "161111",
    [
      310169
    ]
  ],
  "./pt-BR/users.json": [
    "441939",
    [
      821366
    ]
  ],
  "./ga/roster_section_input.json": [
    "149894",
    [
      29982
    ]
  ],
  "./ca/canvas_file_upload.json": [
    "337251",
    [
      777577
    ]
  ],
  "./ca/collaborations.json": [
    "422148",
    [
      910636
    ]
  ],
  "./ht/course_statistics.json": [
    "791451",
    [
      167709
    ]
  ],
  "./sv-x-k12/peer_review_allocation_rule_card.json": [
    "191237",
    [
      410099
    ]
  ],
  "./da-x-k12/gradebook_history.json": [
    "188586",
    [
      435182
    ]
  ],
  "./el/react_developer_keys.json": [
    "426110",
    [
      690314
    ]
  ],
  "./ms/quizzes_public.json": [
    "439285",
    [
      539195
    ]
  ],
  "./ms/calendar_custom_recurring_event_natural_language.json": [
    "705206",
    [
      769366
    ]
  ],
  "./es/gradebook_uploads.json": [
    "179937",
    [
      756304
    ]
  ],
  "./en-GB-x-ukhe/content_shares.json": [
    "757326",
    [
      378118
    ]
  ],
  "./sv-x-k12/top_navigation_tools.json": [
    "440877",
    [
      969979
    ]
  ],
  "./en-AU-x-unimelb/student_groups.json": [
    "957542",
    [
      884618
    ]
  ],
  "./de/assignmentsToggleShowByView.json": [
    "8958",
    [
      65095
    ]
  ],
  "./da/CoursesTray.json": [
    "951571",
    [
      287865
    ]
  ],
  "./is/outcome_detail.json": [
    "811050",
    [
      748938
    ]
  ],
  "./nl/EditMasteryScaleLink.json": [
    "881197",
    [
      903303
    ]
  ],
  "./fr/collaborations.json": [
    "237204",
    [
      18437
    ]
  ],
  "./en-GB/paginated_list.json": [
    "872521",
    [
      876644
    ]
  ],
  "./da/learning_mastery_gradebook.json": [
    "580154",
    [
      319250
    ]
  ],
  "./es/permissions_v2.json": [
    "696883",
    [
      312126
    ]
  ],
  "./is/syllabus_revisions.json": [
    "258908",
    [
      6396
    ]
  ],
  "./ht/blueprint_course_sidebar.json": [
    "791776",
    [
      793772
    ]
  ],
  "./en/context_modules_v2.json": [
    "63601",
    [
      48547
    ]
  ],
  "./hu/IndividualStudentMasteryOutcome.json": [
    "147952",
    [
      358608
    ]
  ],
  "./de/discussion_insights.json": [
    "292189",
    [
      399276
    ]
  ],
  "./de/assignments_2_external_tool.json": [
    "359111",
    [
      69058
    ]
  ],
  "./ja/discussion_insights.json": [
    "55563",
    [
      544646
    ]
  ],
  "./it/student_annotation_preview.json": [
    "944391",
    [
      144801
    ]
  ],
  "./sv/outcomes_user_outcome_results.json": [
    "220560",
    [
      591132
    ]
  ],
  "./ko/last_attended.json": [
    "337600",
    [
      629680
    ]
  ],
  "./zh-Hans/submissions_show_preview.json": [
    "588827",
    [
      516393
    ]
  ],
  "./id/security_panel.json": [
    "870638",
    [
      570250
    ]
  ],
  "./pt/dashboard_grading_period_select.json": [
    "485512",
    [
      243268
    ]
  ],
  "./fi/grade_details.json": [
    "275629",
    [
      36667
    ]
  ],
  "./de/submissions_show_preview.json": [
    "199355",
    [
      609710
    ]
  ],
  "./uk/appt_calendar_event_dialog.json": [
    "12518",
    [
      421078
    ]
  ],
  "./sl/use_switch_experience.json": [
    "17248",
    [
      396276
    ]
  ],
  "./ja/course_paces_time_selection.json": [
    "520044",
    [
      698025
    ]
  ],
  "./ht/sharedSetDefaultGradeDialog.json": [
    "564697",
    [
      570755
    ]
  ],
  "./sv/blueprint_settingsUnsyncedChanges.json": [
    "266986",
    [
      773262
    ]
  ],
  "./es/blueprint_settingsSyncChange.json": [
    "661724",
    [
      259177
    ]
  ],
  "./sv/edit_section_view.json": [
    "142931",
    [
      213181
    ]
  ],
  "./ja/account_calendar_settings.json": [
    "658729",
    [
      41448
    ]
  ],
  "./en-GB-x-ukhe/gradebook.json": [
    "167262",
    [
      915622
    ]
  ],
  "./zh-Hans/announcements_on_home_page.json": [
    "647699",
    [
      860561
    ]
  ],
  "./is/user_search_results.json": [
    "967799",
    [
      662829
    ]
  ],
  "./en-GB/gradinggradingPeriodCollection.json": [
    "116548",
    [
      110525
    ]
  ],
  "./hy/blueprint_coursesExpandableLockOptions.json": [
    "751706",
    [
      716154
    ]
  ],
  "./hy/upload_button.json": [
    "43087",
    [
      551189
    ]
  ],
  "./uk/blueprint_settingsSyncHistory.json": [
    "75604",
    [
      453820
    ]
  ],
  "./hu/assignments_2_student_header.json": [
    "9926",
    [
      729030
    ]
  ],
  "./vi/EditMasteryScaleLink.json": [
    "985928",
    [
      41040
    ]
  ],
  "./sv/course_paces_assignment_row.json": [
    "101682",
    [
      36934
    ]
  ],
  "./uk/epub_exports.json": [
    "293164",
    [
      196004
    ]
  ],
  "./el/a2LatePolicyStatusDisplay.json": [
    "513100",
    [
      668232
    ]
  ],
  "./nn/ldap_cert_upload.json": [
    "302782",
    [
      742978
    ]
  ],
  "./en-GB/copy_course.json": [
    "380576",
    [
      626625
    ]
  ],
  "./cy/edit_section_dates.json": [
    "682316",
    [
      704628
    ]
  ],
  "./fr/conferences.json": [
    "705817",
    [
      585940
    ]
  ],
  "./id/discussion_create.json": [
    "681802",
    [
      634766
    ]
  ],
  "./nl/MoveOutcomesModal.json": [
    "498093",
    [
      618671
    ]
  ],
  "./ht/calculator_command.json": [
    "582300",
    [
      700376
    ]
  ],
  "./it/account_calendars_modal.json": [
    "329938",
    [
      745030
    ]
  ],
  "./ru/quiz_statistics.json": [
    "503074",
    [
      531362
    ]
  ],
  "./he/Navigation.json": [
    "225785",
    [
      928935
    ]
  ],
  "./ga/assignment_index.json": [
    "985592",
    [
      801824
    ]
  ],
  "./en-GB-x-ukhe/appointment_groups.json": [
    "479258",
    [
      841386
    ]
  ],
  "./ru/horizon_toggle.json": [
    "419385",
    [
      910271
    ]
  ],
  "./en-GB-x-ukhe/modelsQuiz.json": [
    "533967",
    [
      720661
    ]
  ],
  "./es-ES/account_calendar_settings_filter_controls.json": [
    "237443",
    [
      64433
    ]
  ],
  "./es/eportfolio.json": [
    "854555",
    [
      37478
    ]
  ],
  "./hy/rubrics-export.json": [
    "819900",
    [
      592172
    ]
  ],
  "./sl/context_roster_user_services.json": [
    "243723",
    [
      71637
    ]
  ],
  "./zh-Hant/submit_online_url_assignment.json": [
    "544476",
    [
      340344
    ]
  ],
  "./ht/course_logging_details.json": [
    "90200",
    [
      490044
    ]
  ],
  "./nn/account_settings_jsx_bundle.json": [
    "931186",
    [
      192414
    ]
  ],
  "./ca/assignments.never_drop.json": [
    "276460",
    [
      283343
    ]
  ],
  "./en-GB/video_conference.json": [
    "722227",
    [
      941946
    ]
  ],
  "./th/direct_share_course_import_panel.json": [
    "529062",
    [
      883450
    ]
  ],
  "./it/edit_section_view.json": [
    "270903",
    [
      126337
    ]
  ],
  "./fi/calculator.json": [
    "105225",
    [
      817983
    ]
  ],
  "./ja/knowledge_check_not_ready.json": [
    "574418",
    [
      743803
    ]
  ],
  "./sv/quizzes.take_quiz.json": [
    "214081",
    [
      333370
    ]
  ],
  "./th/course_paces_search.json": [
    "285489",
    [
      648555
    ]
  ],
  "./hi/admin_split.json": [
    "176781",
    [
      816539
    ]
  ],
  "./hi/entity_search_form.json": [
    "118436",
    [
      998148
    ]
  ],
  "./nb/grade_summaryGroupView.json": [
    "163880",
    [
      206956
    ]
  ],
  "./da-x-k12/last_attended.json": [
    "279387",
    [
      967053
    ]
  ],
  "./sv-x-k12/account_settings.json": [
    "805662",
    [
      844614
    ]
  ],
  "./th/moderate_quiz.json": [
    "233889",
    [
      230963
    ]
  ],
  "./nn/ai_experiences_show.json": [
    "195038",
    [
      420626
    ]
  ],
  "./fi/course_statistics.json": [
    "928550",
    [
      70190
    ]
  ],
  "./th/terms_index.json": [
    "58994",
    [
      779686
    ]
  ],
  "./fi/quiz_migration_notifications.json": [
    "230052",
    [
      816500
    ]
  ],
  "./da/CreateEditAssignmentModalAdapter.json": [
    "538042",
    [
      858706
    ]
  ],
  "./pt/progressbar_view.json": [
    "220230",
    [
      414234
    ]
  ],
  "./sv-x-k12/ai_experiences_edit.json": [
    "628192",
    [
      558408
    ]
  ],
  "./th/content_shares.json": [
    "455468",
    [
      455744
    ]
  ],
  "./tr/assignments_2_login_action_prompt.json": [
    "10207",
    [
      572593
    ]
  ],
  "./es-ES/suppress_notifications.json": [
    "678313",
    [
      731679
    ]
  ],
  "./es/account_calendar_settings_confirmation_modal.json": [
    "457190",
    [
      743927
    ]
  ],
  "./ar/assignment_index.json": [
    "613693",
    [
      556431
    ]
  ],
  "./ca/learning_mastery_gradebook.json": [
    "688615",
    [
      549413
    ]
  ],
  "./fa/video_conference.json": [
    "227511",
    [
      301693
    ]
  ],
  "./hy/submissions_show_preview.json": [
    "25667",
    [
      761729
    ]
  ],
  "./sv/quizzes_quiz_submission.json": [
    "289447",
    [
      973745
    ]
  ],
  "./fr-CA/account_settings_jsx_bundle.json": [
    "371963",
    [
      421677
    ]
  ],
  "./fi/bulk_edit_students_table.json": [
    "898124",
    [
      312556
    ]
  ],
  "./zh-Hant/accessibility_course_statistics.json": [
    "149970",
    [
      100710
    ]
  ],
  "./th/IndividualStudentMasteryOutcome.json": [
    "266755",
    [
      627381
    ]
  ],
  "./ko/login.json": [
    "813249",
    [
      768047
    ]
  ],
  "./he/new_user_tutorial.json": [
    "204990",
    [
      833838
    ]
  ],
  "./en-AU/conversations_2.json": [
    "943129",
    [
      511416
    ]
  ],
  "./fi/course_navigation_settings.json": [
    "307253",
    [
      870707
    ]
  ],
  "./ko/blueprint_settingsAssociationsTable.json": [
    "153739",
    [
      916769
    ]
  ],
  "./hy/sidenav.json": [
    "160757",
    [
      627539
    ]
  ],
  "./zh-Hant/lti_registration.wizard.json": [
    "620390",
    [
      101013
    ]
  ],
  "./ar/auth_logging.json": [
    "240435",
    [
      887789
    ]
  ],
  "./pt-BR/a2LatePolicyToolTipContent.json": [
    "232788",
    [
      958742
    ]
  ],
  "./zh-Hans/rate_limiting_settings.json": [
    "780573",
    [
      354459
    ]
  ],
  "./en-GB-x-lbs/react_collaborations.json": [
    "437718",
    [
      204206
    ]
  ],
  "./ru/AlignmentSummary.json": [
    "584070",
    [
      735406
    ]
  ],
  "./ar/theme_collection_view.json": [
    "377131",
    [
      756117
    ]
  ],
  "./th/content_exports.json": [
    "62811",
    [
      698661
    ]
  ],
  "./ca/course_search_results.json": [
    "121557",
    [
      355083
    ]
  ],
  "./hu/quiz_log_auditing.json": [
    "109865",
    [
      655895
    ]
  ],
  "./vi/calendar.header.json": [
    "261062",
    [
      576949
    ]
  ],
  "./id/quizzes_index.json": [
    "255201",
    [
      490635
    ]
  ],
  "./en-CA/announcements_v2.json": [
    "625031",
    [
      123709
    ]
  ],
  "./hu/paginated_list.json": [
    "537167",
    [
      333869
    ]
  ],
  "./ru/course_paces_search.json": [
    "834616",
    [
      257312
    ]
  ],
  "./hy/submit_online_url_assignment.json": [
    "520763",
    [
      58041
    ]
  ],
  "./sl/quantitative_data_options.json": [
    "336932",
    [
      8800
    ]
  ],
  "./tr/grade_summaryGroupView.json": [
    "761950",
    [
      890642
    ]
  ],
  "./en-AU-x-unimelb/custom_help_link.json": [
    "865402",
    [
      853222
    ]
  ],
  "./ru/permissions_v2.json": [
    "350716",
    [
      156524
    ]
  ],
  "./nl/assignments_2_login_action_prompt.json": [
    "140107",
    [
      819197
    ]
  ],
  "./uk/grade_details.json": [
    "237308",
    [
      626612
    ]
  ],
  "./en-CA.json": [
    "174917",
    [
      194689
    ]
  ],
  "./id/blueprint_settingsAssociationsTable.json": [
    "14376",
    [
      59108
    ]
  ],
  "./he/ai_experiences_edit.json": [
    "836372",
    [
      391404
    ]
  ],
  "./nl/gradebookOutcomeGradebookView.json": [
    "122865",
    [
      918643
    ]
  ],
  "./uk/blueprint_settingsUnsyncedChanges.json": [
    "893091",
    [
      91049
    ]
  ],
  "./pl/assignmentsIndexView.json": [
    "276037",
    [
      44599
    ]
  ],
  "./ht/assignments_2_student_content_rubric_self_assessment.json": [
    "362175",
    [
      286449
    ]
  ],
  "./pt/account_calendar_settings_footer.json": [
    "291606",
    [
      547802
    ]
  ],
  "./mi/user_search_results.json": [
    "553165",
    [
      688739
    ]
  ],
  "./zh-Hant/enhanced_individual_gradebook_submit_score.json": [
    "604847",
    [
      601441
    ]
  ],
  "./is/account_calendar_settings_account_list.json": [
    "353725",
    [
      586091
    ]
  ],
  "./it/course_search_results.json": [
    "319960",
    [
      94564
    ]
  ],
  "./ar/manage_avatars.json": [
    "757945",
    [
      50955
    ]
  ],
  "./ms/gradebook_default_gradebook_components_content_filters_module_filter.json": [
    "151230",
    [
      894574
    ]
  ],
  "./ms/ignite_agent.json": [
    "927694",
    [
      614366
    ]
  ],
  "./sv-x-k12/discussion_pinned_post.json": [
    "661921",
    [
      701287
    ]
  ],
  "./id/notebook_index.json": [
    "295099",
    [
      314469
    ]
  ],
  "./ko/video_conference.json": [
    "598958",
    [
      336622
    ]
  ],
  "./hi/assignments_2_attempt_tab.json": [
    "495468",
    [
      78655
    ]
  ],
  "./th/assignment_index_menu.json": [
    "886258",
    [
      519222
    ]
  ],
  "./pl/student_entries.json": [
    "15654",
    [
      553410
    ]
  ],
  "./vi/reset_pace_warning_modal.json": [
    "588179",
    [
      539665
    ]
  ],
  "./ga/EditMasteryScaleLink.json": [
    "878031",
    [
      77765
    ]
  ],
  "./ms/epub_exports.json": [
    "622956",
    [
      728564
    ]
  ],
  "./pt/peer_reviews_student.json": [
    "815860",
    [
      866200
    ]
  ],
  "./nl/react_developer_keys.json": [
    "25135",
    [
      532273
    ]
  ],
  "./ht.eager.json": [
    "779547",
    [
      502778
    ]
  ],
  "./pl/assignments_bulk_edit.json": [
    "162666",
    [
      500942
    ]
  ],
  "./zh-Hant/grade_details.json": [
    "140454",
    [
      24890
    ]
  ],
  "./ht/link_validator.json": [
    "228195",
    [
      15797
    ]
  ],
  "./pl/conferences_alternatives.json": [
    "953034",
    [
      124022
    ]
  ],
  "./ru/course_pace_date_input.json": [
    "953648",
    [
      572408
    ]
  ],
  "./de/k5_course.json": [
    "413725",
    [
      784236
    ]
  ],
  "./fr/theme_collection_view.json": [
    "768744",
    [
      594353
    ]
  ],
  "./id/outcome_management.json": [
    "627799",
    [
      109233
    ]
  ],
  "./sv-x-k12/course_default_due_time.json": [
    "99279",
    [
      876501
    ]
  ],
  "./uk/question_bank.json": [
    "637393",
    [
      497247
    ]
  ],
  "./nl/assignment_2_assignment_toggle_details.json": [
    "817980",
    [
      344216
    ]
  ],
  "./en-AU/users.json": [
    "11140",
    [
      28001
    ]
  ],
  "./nb/assignments_2_text_entry.json": [
    "688150",
    [
      788250
    ]
  ],
  "./nl/comm_messages.json": [
    "471617",
    [
      810107
    ]
  ],
  "./da-x-k12/account_calendars.json": [
    "849012",
    [
      283472
    ]
  ],
  "./en-GB-x-ukhe/ai_experiences.json": [
    "453832",
    [
      207360
    ]
  ],
  "./it/Navigation.json": [
    "508539",
    [
      961381
    ]
  ],
  "./nn/dashboard.json": [
    "425722",
    [
      601446
    ]
  ],
  "./pl/content_migrations.json": [
    "931821",
    [
      33135
    ]
  ],
  "./sv/blueprint_course_sidebar.json": [
    "16067",
    [
      491525
    ]
  ],
  "./da/roster_publicjs.json": [
    "900503",
    [
      471285
    ]
  ],
  "./ar/enhanced_individual_gradebook_submit_score.json": [
    "221852",
    [
      768552
    ]
  ],
  "./sv-x-k12/courses_show.json": [
    "734073",
    [
      201551
    ]
  ],
  "./sv-x-k12/module_student_view_peer_reviews.json": [
    "735276",
    [
      751772
    ]
  ],
  "./nb-x-k12/NewTabIndicator.json": [
    "996502",
    [
      568462
    ]
  ],
  "./sv-x-k12/collaborations.json": [
    "460957",
    [
      331307
    ]
  ],
  "./is/grade_summary.json": [
    "677866",
    [
      321690
    ]
  ],
  "./pt-BR/assignments_2_submission_helpers.json": [
    "863143",
    [
      210434
    ]
  ],
  "./mi/calendar_custom_recurring_event_repeat_picker.json": [
    "854786",
    [
      612410
    ]
  ],
  "./tr/student_groups.json": [
    "601795",
    [
      970556
    ]
  ],
  "./en-GB-x-ukhe.eager.json": [
    "667809",
    [
      67151
    ]
  ],
  "./el/course_paces_blackout_dates_modal.json": [
    "403297",
    [
      911963
    ]
  ],
  "./pl/IndividualStudentMasteryOutcome.json": [
    "713595",
    [
      4685
    ]
  ],
  "./fa/progress_pill.json": [
    "564952",
    [
      599072
    ]
  ],
  "./uk/accessibility_scan.json": [
    "876466",
    [
      158874
    ]
  ],
  "./ar/accessibility_scan.json": [
    "28327",
    [
      915065
    ]
  ],
  "./is/permissions_role_tray_table_row.json": [
    "330900",
    [
      140500
    ]
  ],
  "./en-GB-x-ukhe/roster_section_selector.json": [
    "263477",
    [
      375747
    ]
  ],
  "./zh-Hans/assignment_2_assignment_toggle_details.json": [
    "78539",
    [
      164633
    ]
  ],
  "./ca/user_restore.json": [
    "449332",
    [
      604636
    ]
  ],
  "./es/MobileNavigation.json": [
    "802338",
    [
      210427
    ]
  ],
  "./ht/conferences.json": [
    "96769",
    [
      298939
    ]
  ],
  "./ar/course_link_validator.json": [
    "921222",
    [
      861834
    ]
  ],
  "./pt/progress_pill.json": [
    "988437",
    [
      776959
    ]
  ],
  "./fi/content_migrations.json": [
    "236450",
    [
      568578
    ]
  ],
  "./pt/overview_page.json": [
    "583389",
    [
      230191
    ]
  ],
  "./fr-CA/module_sequence_footer.json": [
    "477575",
    [
      132785
    ]
  ],
  "./id/keyboardShortcutModal.json": [
    "773415",
    [
      988489
    ]
  ],
  "./sl/gradinggradingPeriodCollection.json": [
    "904226",
    [
      355822
    ]
  ],
  "./tr/SpeedGraderSettingsMenu.json": [
    "815198",
    [
      506746
    ]
  ],
  "./pl/suppress_notifications.json": [
    "870694",
    [
      703602
    ]
  ],
  "./zh-Hant/login.json": [
    "93317",
    [
      146543
    ]
  ],
  "./pl/assignment_grade_summary.json": [
    "173984",
    [
      506012
    ]
  ],
  "./pt/roster_section_selector.json": [
    "831359",
    [
      759473
    ]
  ],
  "./ko/assignments_2_text_entry.json": [
    "573104",
    [
      194848
    ]
  ],
  "./sv-x-k12/edit_section_start_date.json": [
    "809605",
    [
      533875
    ]
  ],
  "./ht/sections_tooltip.json": [
    "381066",
    [
      118158
    ]
  ],
  "./pt/k5_dashboard.json": [
    "965389",
    [
      984071
    ]
  ],
  "./ru/empty_course.json": [
    "306066",
    [
      732530
    ]
  ],
  "./zh-Hans/login.json": [
    "25044",
    [
      704772
    ]
  ],
  "./da-x-k12/modules_home_page.json": [
    "180474",
    [
      461190
    ]
  ],
  "./nn/theme_editor.json": [
    "438109",
    [
      424815
    ]
  ],
  "./de/jobs_v2.json": [
    "995680",
    [
      669053
    ]
  ],
  "./nb/AccountsTray.json": [
    "237658",
    [
      426902
    ]
  ],
  "./tr/gradebook_uploads.json": [
    "419671",
    [
      779385
    ]
  ],
  "./fr-CA/grade_change_logging_content.json": [
    "261817",
    [
      263227
    ]
  ],
  "./fr/assignments.never_drop.json": [
    "952444",
    [
      55205
    ]
  ],
  "./ms/progression_module_header.json": [
    "650562",
    [
      416058
    ]
  ],
  "./fi/error_form.json": [
    "863068",
    [
      63772
    ]
  ],
  "./is/course_paces_no_results.json": [
    "233999",
    [
      934757
    ]
  ],
  "./el/unpublished_changes_tray_contents.json": [
    "451054",
    [
      736650
    ]
  ],
  "./en-AU-x-unimelb/course_paces_app.json": [
    "94568",
    [
      110748
    ]
  ],
  "./es-ES/course_paces_time_selection.json": [
    "271088",
    [
      50568
    ]
  ],
  "./he/grade_summary.json": [
    "111633",
    [
      874287
    ]
  ],
  "./it/not_found_page_slide_puzzle.json": [
    "36396",
    [
      887568
    ]
  ],
  "./de/course_paces_actions.json": [
    "379397",
    [
      353460
    ]
  ],
  "./da-x-k12/account_calendar_settings_account_tree.json": [
    "243506",
    [
      991246
    ]
  ],
  "./fr-CA/available_pronouns_list.json": [
    "208478",
    [
      861802
    ]
  ],
  "./it/mutationActivity.json": [
    "507031",
    [
      978305
    ]
  ],
  "./fa.json": [
    "618792",
    [
      630918
    ]
  ],
  "./fi/account_settings_jsx_bundle.json": [
    "155895",
    [
      749309
    ]
  ],
  "./sv-x-k12/direct_share_course_import_panel.json": [
    "896387",
    [
      35969
    ]
  ],
  "./nl/job_stats.json": [
    "717839",
    [
      177801
    ]
  ],
  "./uk/jobs.json": [
    "381846",
    [
      689798
    ]
  ],
  "./en/filter_calendars_modal.json": [
    "624063",
    [
      828513
    ]
  ],
  "./en-AU/blueprint_settingsCoursePickerTable.json": [
    "247778",
    [
      617643
    ]
  ],
  "./ja/AssignmentListItemView.json": [
    "197474",
    [
      262731
    ]
  ],
  "./ht/terms_of_service_modal.json": [
    "934165",
    [
      3007
    ]
  ],
  "./hi/peer_reviews_student.json": [
    "286745",
    [
      205295
    ]
  ],
  "./zh-Hant/course_paces_modal.json": [
    "326568",
    [
      205828
    ]
  ],
  "./ar/unpublished_changes_tray_contents.json": [
    "315532",
    [
      29792
    ]
  ],
  "./ca/a2_AccessibleTipContent.json": [
    "348290",
    [
      363178
    ]
  ],
  "./ja/course_stats.json": [
    "571584",
    [
      194245
    ]
  ],
  "./es-ES/course_paces_footer.json": [
    "647383",
    [
      111117
    ]
  ],
  "./tr/editGroup.json": [
    "990971",
    [
      564741
    ]
  ],
  "./nn/assignments_2_student_header_date_title.json": [
    "234521",
    [
      279259
    ]
  ],
  "./ar/a2LatePolicyStatusDisplay.json": [
    "388618",
    [
      138390
    ]
  ],
  "./fi/security_panel.json": [
    "408414",
    [
      816886
    ]
  ],
  "./es/edit_section_dates.json": [
    "878652",
    [
      40649
    ]
  ],
  "./fi/calendar.header.json": [
    "607126",
    [
      857637
    ]
  ],
  "./ht/react_files.json": [
    "596085",
    [
      169103
    ]
  ],
  "./sv/gradingPeriodTemplate.json": [
    "298596",
    [
      210808
    ]
  ],
  "./ht/assignments_2_attempt_tab.json": [
    "820519",
    [
      24145
    ]
  ],
  "./id/file_not_found.json": [
    "736462",
    [
      955450
    ]
  ],
  "./da/assignments_2_file_upload.json": [
    "404535",
    [
      189333
    ]
  ],
  "./ga/blueprint_course_sidebar.json": [
    "520804",
    [
      831876
    ]
  ],
  "./ru/permissions_role_tray.json": [
    "376861",
    [
      944715
    ]
  ],
  "./da-x-k12/gradingGradeSummary.json": [
    "551246",
    [
      238810
    ]
  ],
  "./nb/k5_dashboard_card.json": [
    "660968",
    [
      789124
    ]
  ],
  "./nb/notebook_index.json": [
    "835584",
    [
      238460
    ]
  ],
  "./fa/permissions_role_tray_table_row.json": [
    "587509",
    [
      474883
    ]
  ],
  "./nb-x-k12/user_lists.json": [
    "152621",
    [
      105931
    ]
  ],
  "./nn/top_navigation_tools.json": [
    "623700",
    [
      926464
    ]
  ],
  "./ja/sharedCurveGradesDialog.json": [
    "669707",
    [
      148934
    ]
  ],
  "./es-ES/blueprint_coursesExpandableLockOptions.json": [
    "919924",
    [
      997476
    ]
  ],
  "./el/bulk_edit_students_actions.json": [
    "637383",
    [
      207577
    ]
  ],
  "./cy/roster_section_input.json": [
    "630274",
    [
      967642
    ]
  ],
  "./he/rootFoldersFinder.json": [
    "331040",
    [
      532960
    ]
  ],
  "./fr/module_sequence_footer.json": [
    "656900",
    [
      954093
    ]
  ],
  "./ko/quizzes_quiz_submission.json": [
    "369016",
    [
      235480
    ]
  ],
  "./nl/blueprint_settingsCoursePicker.json": [
    "970682",
    [
      670145
    ]
  ],
  "./it/IndividualStudentMasteryOutcome.json": [
    "918606",
    [
      532754
    ]
  ],
  "./sl/restore_content_pane.json": [
    "597712",
    [
      565444
    ]
  ],
  "./fr-CA/k5_course.json": [
    "49127",
    [
      175073
    ]
  ],
  "./sl/assignments_2_url_entry.json": [
    "904215",
    [
      507809
    ]
  ],
  "./tr/login.json": [
    "383397",
    [
      262111
    ]
  ],
  "./is/outcome_alignment_v2.json": [
    "950381",
    [
      470811
    ]
  ],
  "./ga/authentication_providers.json": [
    "172335",
    [
      37173
    ]
  ],
  "./it/assignment_show.json": [
    "468884",
    [
      550864
    ]
  ],
  "./pt/youtube_migration.json": [
    "214524",
    [
      11504
    ]
  ]
};
function __rspack_async_context(req) {
  if(!__webpack_require__.o(map, req)) {
    return Promise.resolve().then(() => {
var e = new Error("Cannot find module '" + req + "'");
e.code = 'MODULE_NOT_FOUND';
throw e;
});
  }

  var ids = map[req], id = ids[0];
  return Promise.all(ids[1].map(__webpack_require__.e)).then(() => (__webpack_require__.t(id, 3 | 16)));
}

__rspack_async_context.keys = () => (Object.keys(map));
__rspack_async_context.id = 289683;
module.exports = __rspack_async_context;
